var _b, _c, _d, _e;
import * as React$7 from "react";
import React__default, { useRef, useState, useEffect, useLayoutEffect, useMemo, useCallback, useImperativeHandle, useContext, forwardRef, Fragment, createRef } from "react";
import { connect, useSelector, useDispatch, Provider } from "react-redux";
import { useTheme as useTheme$1, createUseStyles, ThemeProvider } from "react-jss";
import { TabBar as TabBar$2, Spacer, Box, Divider, ValueField as ValueField$2, Popover as Popover$3, Button, TextField as TextField$2, Spinner, Checkbox, MultiSelectDropdown, Dropdown as Dropdown$2, Toggle, SegmentedControl, Skeleton as Skeleton$1, FileUpload, Tooltip, ColorPicker, TextArea, ListPopover, Modal, Accordion, RadioButtonGroup, ObeeDatePicker, Table, InlineTextArea, Canvas, ToggleGroup as ToggleGroup$2, Pill } from "@eatclub-apps/ec-component-library";
import moment$2 from "moment";
import { useLocation, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import momentPropTypes from "react-moment-proptypes";
import { bindActionCreators, combineReducers } from "@reduxjs/toolkit";
import { API } from "aws-amplify";
import { ThemeContext } from "@emotion/react";
import { Popover as Popover$2, useMediaQuery as useMediaQuery$1, LinearProgress, Grid as Grid$1, CircularProgress, Box as Box$1, TextField as TextField$3, Skeleton as Skeleton$2, AppBar } from "@mui/material";
import require$$2, { unstable_batchedUpdates } from "react-dom";
import { DragDropContext, Droppable, Draggable as Draggable$2 } from "react-beautiful-dnd";
import { Grid } from "react-virtualized";
import { loadStripe } from "@stripe/stripe-js";
import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement, Elements } from "@stripe/react-stripe-js";
import moment$3 from "moment-timezone";
const underlinedTabBarStyles = (theme2, style) => ({
  fontWeight: theme2.fontWeights.medium,
  // marginLeft: '-9px', // To offset internal padding
  containerInner: {
    gap: "20px",
    flexWrap: "wrap",
    ...style == null ? void 0 : style.containerInner
  },
  tabContainer: {
    position: "relative",
    ...style == null ? void 0 : style.tabContainer
  },
  tab: {
    // marginLeft: '-10px',
    gap: "10px",
    padding: "10px 8px",
    paddingBottom: "10px",
    fontSize: "24px",
    lineHeight: "normal",
    transition: "background-color 0.1s",
    whiteSpace: "nowrap",
    display: "flex",
    justifyContent: "flex-start",
    color: theme2.colors.nimbus,
    fontWeight: theme2.fontWeights.medium,
    ...style == null ? void 0 : style.tab
  },
  tabActive: {
    paddingBottom: "10px",
    color: theme2.colors.black,
    borderBottom: "none",
    background: `radial-gradient(farthest-side,${theme2.colors.tabUnderline} 98%,#0000) bottom left, linear-gradient(${theme2.colors.tabUnderline} 0 0) bottom, radial-gradient(farthest-side,${theme2.colors.tabUnderline} 98%,#0000) bottom right`,
    backgroundSize: "18px 18px,calc(100% - 18px) 18px",
    backgroundRepeat: "no-repeat",
    backgroundPositionY: "80%",
    fontWeight: theme2.fontWeights.medium,
    ...style == null ? void 0 : style.tabActive
  },
  tabHover: {
    color: theme2.colors.textGray,
    filter: "none",
    ...style == null ? void 0 : style.tabHover
  }
});
const UnderlinedTabBar = ({ style, ...props }) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(TabBar$2, { style: underlinedTabBarStyles(theme2, style), ...props });
};
UnderlinedTabBar.defaultProps = {
  tabs: [],
  activeTab: null,
  setActiveTab: (e) => e,
  style: {}
};
UnderlinedTabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number, PropTypes.shape({})])
  ),
  style: PropTypes.shape({}),
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func
};
const mapStateToProps$3v = () => ({});
const mapDispatchToProps$3u = (dispatch) => bindActionCreators({}, dispatch);
const UnderlinedTabBar$1 = connect(mapStateToProps$3v, mapDispatchToProps$3u)(UnderlinedTabBar);
const useStyles$1Y = createUseStyles(
  (theme2) => ({
    notificationCount: {
      border: `1px solid ${theme2.colors.charcoal}`,
      borderRadius: "40px",
      padding: "2px 8px",
      height: "20px",
      minWidth: "24px",
      fontSize: "12px",
      color: theme2.colors.smoke,
      position: "absolute",
      top: "-10px",
      left: "100%"
    }
  }),
  { name: "BookingsTabBar" }
);
const WaitlistLabel = ({ waitingBookings }) => {
  const classes = useStyles$1Y();
  const waitlistCount = waitingBookings == null ? void 0 : waitingBookings.length;
  if (waitlistCount > 0) {
    return /* @__PURE__ */ React__default.createElement(Spacer, { style: { position: "relative" }, gap: 0 }, "Waitlist", /* @__PURE__ */ React__default.createElement(Box, { className: classes.notificationCount }, waitlistCount));
  }
  return "Waitlist";
};
WaitlistLabel.defaultProps = {
  waitingBookings: []
};
WaitlistLabel.propTypes = {
  waitingBookings: PropTypes.arrayOf(PropTypes.shape({}))
};
const mapStateToProps$3u = () => ({});
const mapDispatchToProps$3t = (dispatch) => bindActionCreators({}, dispatch);
const WaitlistLabel$1 = connect(mapStateToProps$3u, mapDispatchToProps$3t)(WaitlistLabel);
const BookingsTabBar = ({ showWaitlist, waitingBookings, activeTab, setActiveTab, style }) => {
  return /* @__PURE__ */ React__default.createElement(
    UnderlinedTabBar$1,
    {
      tabs: [
        { label: "Bookings", value: "bookings" },
        ...showWaitlist ? [
          {
            label: /* @__PURE__ */ React__default.createElement(WaitlistLabel$1, { waitingBookings }),
            value: "waitlist"
          }
        ] : []
      ],
      value: activeTab,
      onSelect: setActiveTab,
      style: {
        ...style == null ? void 0 : style.containerInner,
        containerInner: {
          marginLeft: "-10px",
          gap: "10px",
          ...style == null ? void 0 : style.containerInner
        }
      }
    }
  );
};
BookingsTabBar.defaultProps = {
  activeTab: null,
  setActiveTab: (e) => e,
  showWaitlist: false,
  waitingBookings: [],
  style: {}
};
BookingsTabBar.propTypes = {
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  showWaitlist: PropTypes.bool,
  style: PropTypes.shape({}),
  waitingBookings: PropTypes.arrayOf(PropTypes.shape({}))
};
const mapStateToProps$3t = () => ({});
const mapDispatchToProps$3s = (dispatch) => bindActionCreators({}, dispatch);
const BookingsTabBar$1 = connect(mapStateToProps$3t, mapDispatchToProps$3s)(BookingsTabBar);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var moment$1 = { exports: {} };
(function(module2, exports) {
  (function(global2, factory2) {
    module2.exports = factory2();
  })(commonjsGlobal, function() {
    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject2(input) {
      return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty2(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber2(input) {
      return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
      var res = [], i, arrLen = arr.length;
      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, "toString")) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, "valueOf")) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format2, locale2, strict) {
      return createLocalOrUTC(input, format2, locale2, strict, true).utc();
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
      if (isNowValid) {
        flags = getParsingFlags(m);
        parsedParts = some.call(flags.parsedDateParts, function(i) {
          return i != null;
        });
        isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
        }
      }
      if (Object.isFrozen == null || !Object.isFrozen(m)) {
        m._isValid = isNowValid;
      } else {
        return isNowValid;
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to2, from2) {
      var i, prop, val, momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from2._isAMomentObject)) {
        to2._isAMomentObject = from2._isAMomentObject;
      }
      if (!isUndefined(from2._i)) {
        to2._i = from2._i;
      }
      if (!isUndefined(from2._f)) {
        to2._f = from2._f;
      }
      if (!isUndefined(from2._l)) {
        to2._l = from2._l;
      }
      if (!isUndefined(from2._strict)) {
        to2._strict = from2._strict;
      }
      if (!isUndefined(from2._tzm)) {
        to2._tzm = from2._tzm;
      }
      if (!isUndefined(from2._isUTC)) {
        to2._isUTC = from2._isUTC;
      }
      if (!isUndefined(from2._offset)) {
        to2._offset = from2._offset;
      }
      if (!isUndefined(from2._pf)) {
        to2._pf = getParsingFlags(from2);
      }
      if (!isUndefined(from2._locale)) {
        to2._locale = from2._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from2[prop];
          if (!isUndefined(val)) {
            to2[prop] = val;
          }
        }
      }
      return to2;
    }
    function Moment(config2) {
      copyConfig(this, config2);
      this._d = new Date(config2._d != null ? config2._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = /* @__PURE__ */ new Date(NaN);
      }
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
        console.warn("Deprecation warning: " + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function() {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [], arg, i, key, argLen = arguments.length;
          for (i = 0; i < argLen; i++) {
            arg = "";
            if (typeof arguments[i] === "object") {
              arg += "\n[" + i + "] ";
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ": " + arguments[0][key] + ", ";
                }
              }
              arg = arg.slice(0, -2);
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(
            msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
          );
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name2, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name2, msg);
      }
      if (!deprecations[name2]) {
        warn(msg);
        deprecations[name2] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction2(input) {
      return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config2) {
      var prop, i;
      for (i in config2) {
        if (hasOwnProp(config2, i)) {
          prop = config2[i];
          if (isFunction2(prop)) {
            this[i] = prop;
          } else {
            this["_" + i] = prop;
          }
        }
      }
      this._config = config2;
      this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
      );
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig), prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject2(parentConfig[prop]) && isObject2(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject2(parentConfig[prop])) {
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config2) {
      if (config2 != null) {
        this.set(config2);
      }
    }
    var keys2;
    if (Object.keys) {
      keys2 = Object.keys;
    } else {
      keys2 = function(obj) {
        var i, res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    };
    function calendar(key, mom, now22) {
      var output = this._calendar[key] || this._calendar["sameElse"];
      return isFunction2(output) ? output.call(mom, now22) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign2 = number >= 0;
      return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    function addFormatToken(token2, padded, ordinal22, callback) {
      var func = callback;
      if (typeof callback === "string") {
        func = function() {
          return this[callback]();
        };
      }
      if (token2) {
        formatTokenFunctions[token2] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function() {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal22) {
        formatTokenFunctions[ordinal22] = function() {
          return this.localeData().ordinal(
            func.apply(this, arguments),
            token2
          );
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, "");
      }
      return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format2) {
      var array = format2.match(formattingTokens), i, length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function(mom) {
        var output = "", i2;
        for (i2 = 0; i2 < length; i2++) {
          output += isFunction2(array[i2]) ? array[i2].call(mom, format2) : array[i2];
        }
        return output;
      };
    }
    function formatMoment(m, format2) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format2 = expandFormat(format2, m.localeData());
      formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
      return formatFunctions[format2](m);
    }
    function expandFormat(format2, locale2) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale2.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format2)) {
        format2 = format2.replace(
          localFormattingTokens,
          replaceLongDateFormatTokens
        );
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format2;
    }
    var defaultLongDateFormat = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
      var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format2 || !formatUpper) {
        return format2;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
        if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
          return tok.slice(1);
        }
        return tok;
      }).join("");
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal2(number) {
      return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      w: "a week",
      ww: "%d weeks",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction2(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff2, output) {
      var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
      return isFunction2(format2) ? format2(output) : format2.replace(/%s/i, output);
    }
    var aliases = {
      D: "date",
      dates: "date",
      date: "date",
      d: "day",
      days: "day",
      day: "day",
      e: "weekday",
      weekdays: "weekday",
      weekday: "weekday",
      E: "isoWeekday",
      isoweekdays: "isoWeekday",
      isoweekday: "isoWeekday",
      DDD: "dayOfYear",
      dayofyears: "dayOfYear",
      dayofyear: "dayOfYear",
      h: "hour",
      hours: "hour",
      hour: "hour",
      ms: "millisecond",
      milliseconds: "millisecond",
      millisecond: "millisecond",
      m: "minute",
      minutes: "minute",
      minute: "minute",
      M: "month",
      months: "month",
      month: "month",
      Q: "quarter",
      quarters: "quarter",
      quarter: "quarter",
      s: "second",
      seconds: "second",
      second: "second",
      gg: "weekYear",
      weekyears: "weekYear",
      weekyear: "weekYear",
      GG: "isoWeekYear",
      isoweekyears: "isoWeekYear",
      isoweekyear: "isoWeekYear",
      w: "week",
      weeks: "week",
      week: "week",
      W: "isoWeek",
      isoweeks: "isoWeek",
      isoweek: "isoWeek",
      y: "year",
      years: "year",
      year: "year"
    };
    function normalizeUnits(units) {
      return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {}, normalizedProp, prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {
      date: 9,
      day: 11,
      weekday: 11,
      isoWeekday: 11,
      dayOfYear: 4,
      hour: 13,
      millisecond: 16,
      minute: 14,
      month: 8,
      quarter: 7,
      second: 15,
      weekYear: 1,
      isoWeekYear: 1,
      week: 5,
      isoWeek: 5,
      year: 1
    };
    function getPrioritizedUnits(unitsObj) {
      var units = [], u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({ unit: u, priority: priorities[u] });
        }
      }
      units.sort(function(a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token2, regex, strictRegex) {
      regexes[token2] = isFunction2(regex) ? regex : function(isStrict, localeData2) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token2, config2) {
      if (!hasOwnProp(regexes, token2)) {
        return new RegExp(unescapeFormat(token2));
      }
      return regexes[token2](config2._strict, config2._locale);
    }
    function unescapeFormat(s) {
      return regexEscape(
        s.replace("\\", "").replace(
          /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
          function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
          }
        )
      );
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion, value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    var tokens = {};
    function addParseToken(token2, callback) {
      var i, func = callback, tokenLen;
      if (typeof token2 === "string") {
        token2 = [token2];
      }
      if (isNumber2(callback)) {
        func = function(input, array) {
          array[callback] = toInt(input);
        };
      }
      tokenLen = token2.length;
      for (i = 0; i < tokenLen; i++) {
        tokens[token2[i]] = func;
      }
    }
    function addWeekParseToken(token2, callback) {
      addParseToken(token2, function(input, array, config2, token3) {
        config2._w = config2._w || {};
        callback(input, config2._w, config2, token3);
      });
    }
    function addTimeToArrayFromToken(token2, input, config2) {
      if (input != null && hasOwnProp(tokens, token2)) {
        tokens[token2](input, config2._a, config2, token2);
      }
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    addFormatToken("Y", 0, 0, function() {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, ["YY", 2], 0, function() {
      return this.year() % 100;
    });
    addFormatToken(0, ["YYYY", 4], 0, "year");
    addFormatToken(0, ["YYYYY", 5], 0, "year");
    addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken(["YYYYY", "YYYYYY"], YEAR);
    addParseToken("YYYY", function(input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
      array[YEAR] = parseInt(input, 10);
    });
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }
    hooks.parseTwoDigitYear = function(input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
    };
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
      return function(value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get2(this, unit);
        }
      };
    }
    function get2(mom, unit) {
      if (!mom.isValid()) {
        return NaN;
      }
      var d = mom._d, isUTC = mom._isUTC;
      switch (unit) {
        case "Milliseconds":
          return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
        case "Seconds":
          return isUTC ? d.getUTCSeconds() : d.getSeconds();
        case "Minutes":
          return isUTC ? d.getUTCMinutes() : d.getMinutes();
        case "Hours":
          return isUTC ? d.getUTCHours() : d.getHours();
        case "Date":
          return isUTC ? d.getUTCDate() : d.getDate();
        case "Day":
          return isUTC ? d.getUTCDay() : d.getDay();
        case "Month":
          return isUTC ? d.getUTCMonth() : d.getMonth();
        case "FullYear":
          return isUTC ? d.getUTCFullYear() : d.getFullYear();
        default:
          return NaN;
      }
    }
    function set$1(mom, unit, value) {
      var d, isUTC, year, month, date;
      if (!mom.isValid() || isNaN(value)) {
        return;
      }
      d = mom._d;
      isUTC = mom._isUTC;
      switch (unit) {
        case "Milliseconds":
          return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
        case "Seconds":
          return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
        case "Minutes":
          return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
        case "Hours":
          return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
        case "Date":
          return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
        case "FullYear":
          break;
        default:
          return;
      }
      year = value;
      month = mom.month();
      date = mom.date();
      date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
      void (isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date));
    }
    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction2(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === "object") {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction2(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    function mod2(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function(o) {
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod2(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    addFormatToken("M", ["MM", 2], "Mo", function() {
      return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format2) {
      return this.localeData().monthsShort(this, format2);
    });
    addFormatToken("MMMM", 0, 0, function(format2) {
      return this.localeData().months(this, format2);
    });
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale2) {
      return locale2.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale2) {
      return locale2.monthsRegex(isStrict);
    });
    addParseToken(["M", "MM"], function(input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(["MMM", "MMMM"], function(input, array, config2, token2) {
      var month = config2._locale.monthsParse(input, token2, config2._strict);
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config2).invalidMonth = input;
      }
    });
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format2) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months["standalone"];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format2) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format2, strict) {
      var i, ii, mom, llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2e3, i]);
          this._shortMonthsParse[i] = this.monthsShort(
            mom,
            ""
          ).toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format2 === "MMM") {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format2 === "MMM") {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format2, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format2, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2e3, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp(
            "^" + this.months(mom, "").replace(".", "") + "$",
            "i"
          );
          this._shortMonthsParse[i] = new RegExp(
            "^" + this.monthsShort(mom, "").replace(".", "") + "$",
            "i"
          );
        }
        if (!strict && !this._monthsParse[i]) {
          regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
          this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
        }
        if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }
    function setMonth(mom, value) {
      if (!mom.isValid()) {
        return mom;
      }
      if (typeof value === "string") {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          if (!isNumber2(value)) {
            return mom;
          }
        }
      }
      var month = value, date = mom.date();
      date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
      void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get2(this, "Month");
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, "_monthsShortRegex")) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, "_monthsRegex")) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
      for (i = 0; i < 12; i++) {
        mom = createUTC([2e3, i]);
        shortP = regexEscape(this.monthsShort(mom, ""));
        longP = regexEscape(this.months(mom, ""));
        shortPieces.push(shortP);
        longPieces.push(longP);
        mixedPieces.push(longP);
        mixedPieces.push(shortP);
      }
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp(
        "^(" + longPieces.join("|") + ")",
        "i"
      );
      this._monthsShortStrictRegex = new RegExp(
        "^(" + shortPieces.join("|") + ")",
        "i"
      );
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date;
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    addFormatToken("w", ["ww", 2], "wo", "week");
    addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken(
      ["w", "ww", "W", "WW"],
      function(input, week, config2, token2) {
        week[token2.substr(0, 1)] = toInt(input);
      }
    );
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, "d");
    }
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format2) {
      return this.localeData().weekdaysMin(this, format2);
    });
    addFormatToken("ddd", 0, 0, function(format2) {
      return this.localeData().weekdaysShort(this, format2);
    });
    addFormatToken("dddd", 0, 0, function(format2) {
      return this.localeData().weekdays(this, format2);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale2) {
      return locale2.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale2) {
      return locale2.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale2) {
      return locale2.weekdaysRegex(isStrict);
    });
    addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config2, token2) {
      var weekday = config2._locale.weekdaysParse(input, token2, config2._strict);
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config2).invalidWeekday = input;
      }
    });
    addWeekParseToken(["d", "e", "E"], function(input, week, config2, token2) {
      week[token2] = toInt(input);
    });
    function parseWeekday(input, locale2) {
      if (typeof input !== "string") {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale2.weekdaysParse(input);
      if (typeof input === "number") {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale2) {
      if (typeof input === "string") {
        return locale2.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format2) {
      var weekdays2 = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
      return m === true ? shiftWeekdays(weekdays2, this._week.dow) : m ? weekdays2[m.day()] : weekdays2;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format2, strict) {
      var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2e3, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(
            mom,
            ""
          ).toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(
            mom,
            ""
          ).toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format2 === "dddd") {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format2 === "ddd") {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format2 === "dddd") {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format2 === "ddd") {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format2, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format2, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2e3, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp(
            "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
          this._shortWeekdaysParse[i] = new RegExp(
            "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
          this._minWeekdaysParse[i] = new RegExp(
            "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
            "i"
          );
        }
        if (!this._weekdaysParse[i]) {
          regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
          this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
        }
        if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = get2(this, "Day");
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, "d");
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysShortRegex")) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysMinRegex")) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
      for (i = 0; i < 7; i++) {
        mom = createUTC([2e3, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ""));
        shortp = regexEscape(this.weekdaysShort(mom, ""));
        longp = regexEscape(this.weekdays(mom, ""));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp(
        "^(" + longPieces.join("|") + ")",
        "i"
      );
      this._weekdaysShortStrictRegex = new RegExp(
        "^(" + shortPieces.join("|") + ")",
        "i"
      );
      this._weekdaysMinStrictRegex = new RegExp(
        "^(" + minPieces.join("|") + ")",
        "i"
      );
    }
    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken("H", ["HH", 2], 0, "hour");
    addFormatToken("h", ["hh", 2], 0, hFormat);
    addFormatToken("k", ["kk", 2], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
      return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
      return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
      return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
      return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token2, lowercase) {
      addFormatToken(token2, 0, 0, function() {
        return this.localeData().meridiem(
          this.hours(),
          this.minutes(),
          lowercase
        );
      });
    }
    meridiem("a", true);
    meridiem("A", false);
    function matchMeridiem(isStrict, locale2) {
      return locale2._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken(["H", "HH"], HOUR);
    addParseToken(["k", "kk"], function(input, array, config2) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(["a", "A"], function(input, array, config2) {
      config2._isPm = config2._locale.isPM(input);
      config2._meridiem = input;
    });
    addParseToken(["h", "hh"], function(input, array, config2) {
      array[HOUR] = toInt(input);
      getParsingFlags(config2).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config2) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config2).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config2) {
      var pos1 = input.length - 4, pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config2).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config2) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config2) {
      var pos1 = input.length - 4, pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });
    function localeIsPM(input) {
      return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours2, minutes2, isLower) {
      if (hours2 > 11) {
        return isLower ? "pm" : "PM";
      } else {
        return isLower ? "am" : "AM";
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
      var i, minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace("_", "-") : key;
    }
    function chooseLocale(names) {
      var i = 0, j, next, locale2, split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split("-");
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split("-") : null;
        while (j > 0) {
          locale2 = loadLocale(split.slice(0, j).join("-"));
          if (locale2) {
            return locale2;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name2) {
      return !!(name2 && name2.match("^[^/\\\\]*$"));
    }
    function loadLocale(name2) {
      var oldLocale = null, aliasedRequire;
      if (locales[name2] === void 0 && true && module2 && module2.exports && isLocaleNameSane(name2)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire;
          aliasedRequire("./locale/" + name2);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          locales[name2] = null;
        }
      }
      return locales[name2];
    }
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          globalLocale = data;
        } else {
          if (typeof console !== "undefined" && console.warn) {
            console.warn(
              "Locale " + key + " not found. Did you forget to load it?"
            );
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name2, config2) {
      if (config2 !== null) {
        var locale2, parentConfig = baseConfig;
        config2.abbr = name2;
        if (locales[name2] != null) {
          deprecateSimple(
            "defineLocaleOverride",
            "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
          );
          parentConfig = locales[name2]._config;
        } else if (config2.parentLocale != null) {
          if (locales[config2.parentLocale] != null) {
            parentConfig = locales[config2.parentLocale]._config;
          } else {
            locale2 = loadLocale(config2.parentLocale);
            if (locale2 != null) {
              parentConfig = locale2._config;
            } else {
              if (!localeFamilies[config2.parentLocale]) {
                localeFamilies[config2.parentLocale] = [];
              }
              localeFamilies[config2.parentLocale].push({
                name: name2,
                config: config2
              });
              return null;
            }
          }
        }
        locales[name2] = new Locale(mergeConfigs(parentConfig, config2));
        if (localeFamilies[name2]) {
          localeFamilies[name2].forEach(function(x) {
            defineLocale(x.name, x.config);
          });
        }
        getSetGlobalLocale(name2);
        return locales[name2];
      } else {
        delete locales[name2];
        return null;
      }
    }
    function updateLocale(name2, config2) {
      if (config2 != null) {
        var locale2, tmpLocale, parentConfig = baseConfig;
        if (locales[name2] != null && locales[name2].parentLocale != null) {
          locales[name2].set(mergeConfigs(locales[name2]._config, config2));
        } else {
          tmpLocale = loadLocale(name2);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config2 = mergeConfigs(parentConfig, config2);
          if (tmpLocale == null) {
            config2.abbr = name2;
          }
          locale2 = new Locale(config2);
          locale2.parentLocale = locales[name2];
          locales[name2] = locale2;
        }
        getSetGlobalLocale(name2);
      } else {
        if (locales[name2] != null) {
          if (locales[name2].parentLocale != null) {
            locales[name2] = locales[name2].parentLocale;
            if (name2 === getSetGlobalLocale()) {
              getSetGlobalLocale(name2);
            }
          } else if (locales[name2] != null) {
            delete locales[name2];
          }
        }
      }
      return locales[name2];
    }
    function getLocale(key) {
      var locale2;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        locale2 = loadLocale(key);
        if (locale2) {
          return locale2;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys2(locales);
    }
    function checkOverflow(m) {
      var overflow, a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
      ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
      ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
      ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
      ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
      ["YYYY-DDD", /\d{4}-\d{3}/],
      ["YYYY-MM", /\d{4}-\d\d/, false],
      ["YYYYYYMMDD", /[+-]\d{10}/],
      ["YYYYMMDD", /\d{8}/],
      ["GGGG[W]WWE", /\d{4}W\d{3}/],
      ["GGGG[W]WW", /\d{4}W\d{2}/, false],
      ["YYYYDDD", /\d{7}/],
      ["YYYYMM", /\d{6}/, false],
      ["YYYY", /\d{4}/, false]
    ], isoTimes = [
      ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
      ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
      ["HH:mm:ss", /\d\d:\d\d:\d\d/],
      ["HH:mm", /\d\d:\d\d/],
      ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
      ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
      ["HHmmss", /\d\d\d\d\d\d/],
      ["HHmm", /\d\d\d\d/],
      ["HH", /\d\d/]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };
    function configFromISO(config2) {
      var i, l, string = config2._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
      if (match) {
        getParsingFlags(config2).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config2._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || " ") + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config2._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config2._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = "Z";
          } else {
            config2._isValid = false;
            return;
          }
        }
        config2._f = dateFormat + (timeFormat || "") + (tzFormat || "");
        configFromStringAndFormat(config2);
      } else {
        config2._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
      ];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2e3 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config2) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
          parsedInput[0],
          parsedInput[1],
          parsedInput[2]
        ).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config2).weekdayMismatch = true;
          config2._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        return 0;
      } else {
        var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
      }
    }
    function configFromRFC2822(config2) {
      var match = rfc2822.exec(preprocessRFC2822(config2._i)), parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(
          match[4],
          match[3],
          match[2],
          match[5],
          match[6],
          match[7]
        );
        if (!checkWeekday(match[1], parsedArray, config2)) {
          return;
        }
        config2._a = parsedArray;
        config2._tzm = calculateOffset(match[8], match[9], match[10]);
        config2._d = createUTCDate.apply(null, config2._a);
        config2._d.setUTCMinutes(config2._d.getUTCMinutes() - config2._tzm);
        getParsingFlags(config2).rfc2822 = true;
      } else {
        config2._isValid = false;
      }
    }
    function configFromString(config2) {
      var matched = aspNetJsonRegex.exec(config2._i);
      if (matched !== null) {
        config2._d = /* @__PURE__ */ new Date(+matched[1]);
        return;
      }
      configFromISO(config2);
      if (config2._isValid === false) {
        delete config2._isValid;
      } else {
        return;
      }
      configFromRFC2822(config2);
      if (config2._isValid === false) {
        delete config2._isValid;
      } else {
        return;
      }
      if (config2._strict) {
        config2._isValid = false;
      } else {
        hooks.createFromInputFallback(config2);
      }
    }
    hooks.createFromInputFallback = deprecate(
      "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
      function(config2) {
        config2._d = /* @__PURE__ */ new Date(config2._i + (config2._useUTC ? " UTC" : ""));
      }
    );
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config2) {
      var nowValue = new Date(hooks.now());
      if (config2._useUTC) {
        return [
          nowValue.getUTCFullYear(),
          nowValue.getUTCMonth(),
          nowValue.getUTCDate()
        ];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }
    function configFromArray(config2) {
      var i, date, input = [], currentDate, expectedWeekday, yearToUse;
      if (config2._d) {
        return;
      }
      currentDate = currentDateArray(config2);
      if (config2._w && config2._a[DATE] == null && config2._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config2);
      }
      if (config2._dayOfYear != null) {
        yearToUse = defaults(config2._a[YEAR], currentDate[YEAR]);
        if (config2._dayOfYear > daysInYear(yearToUse) || config2._dayOfYear === 0) {
          getParsingFlags(config2)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config2._dayOfYear);
        config2._a[MONTH] = date.getUTCMonth();
        config2._a[DATE] = date.getUTCDate();
      }
      for (i = 0; i < 3 && config2._a[i] == null; ++i) {
        config2._a[i] = input[i] = currentDate[i];
      }
      for (; i < 7; i++) {
        config2._a[i] = input[i] = config2._a[i] == null ? i === 2 ? 1 : 0 : config2._a[i];
      }
      if (config2._a[HOUR] === 24 && config2._a[MINUTE] === 0 && config2._a[SECOND] === 0 && config2._a[MILLISECOND] === 0) {
        config2._nextDay = true;
        config2._a[HOUR] = 0;
      }
      config2._d = (config2._useUTC ? createUTCDate : createDate).apply(
        null,
        input
      );
      expectedWeekday = config2._useUTC ? config2._d.getUTCDay() : config2._d.getDay();
      if (config2._tzm != null) {
        config2._d.setUTCMinutes(config2._d.getUTCMinutes() - config2._tzm);
      }
      if (config2._nextDay) {
        config2._a[HOUR] = 24;
      }
      if (config2._w && typeof config2._w.d !== "undefined" && config2._w.d !== expectedWeekday) {
        getParsingFlags(config2).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config2) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config2._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        weekYear = defaults(
          w.GG,
          config2._a[YEAR],
          weekOfYear(createLocal2(), 1, 4).year
        );
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config2._locale._week.dow;
        doy = config2._locale._week.doy;
        curWeek = weekOfYear(createLocal2(), dow, doy);
        weekYear = defaults(w.gg, config2._a[YEAR], curWeek.year);
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config2)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config2)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config2._a[YEAR] = temp.year;
        config2._dayOfYear = temp.dayOfYear;
      }
    }
    hooks.ISO_8601 = function() {
    };
    hooks.RFC_2822 = function() {
    };
    function configFromStringAndFormat(config2) {
      if (config2._f === hooks.ISO_8601) {
        configFromISO(config2);
        return;
      }
      if (config2._f === hooks.RFC_2822) {
        configFromRFC2822(config2);
        return;
      }
      config2._a = [];
      getParsingFlags(config2).empty = true;
      var string = "" + config2._i, i, parsedInput, tokens2, token2, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
      tokens2 = expandFormat(config2._f, config2._locale).match(formattingTokens) || [];
      tokenLen = tokens2.length;
      for (i = 0; i < tokenLen; i++) {
        token2 = tokens2[i];
        parsedInput = (string.match(getParseRegexForToken(token2, config2)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config2).unusedInput.push(skipped);
          }
          string = string.slice(
            string.indexOf(parsedInput) + parsedInput.length
          );
          totalParsedInputLength += parsedInput.length;
        }
        if (formatTokenFunctions[token2]) {
          if (parsedInput) {
            getParsingFlags(config2).empty = false;
          } else {
            getParsingFlags(config2).unusedTokens.push(token2);
          }
          addTimeToArrayFromToken(token2, parsedInput, config2);
        } else if (config2._strict && !parsedInput) {
          getParsingFlags(config2).unusedTokens.push(token2);
        }
      }
      getParsingFlags(config2).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config2).unusedInput.push(string);
      }
      if (config2._a[HOUR] <= 12 && getParsingFlags(config2).bigHour === true && config2._a[HOUR] > 0) {
        getParsingFlags(config2).bigHour = void 0;
      }
      getParsingFlags(config2).parsedDateParts = config2._a.slice(0);
      getParsingFlags(config2).meridiem = config2._meridiem;
      config2._a[HOUR] = meridiemFixWrap(
        config2._locale,
        config2._a[HOUR],
        config2._meridiem
      );
      era = getParsingFlags(config2).era;
      if (era !== null) {
        config2._a[YEAR] = config2._locale.erasConvertYear(era, config2._a[YEAR]);
      }
      configFromArray(config2);
      checkOverflow(config2);
    }
    function meridiemFixWrap(locale2, hour, meridiem2) {
      var isPm;
      if (meridiem2 == null) {
        return hour;
      }
      if (locale2.meridiemHour != null) {
        return locale2.meridiemHour(hour, meridiem2);
      } else if (locale2.isPM != null) {
        isPm = locale2.isPM(meridiem2);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        return hour;
      }
    }
    function configFromStringAndArray(config2) {
      var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config2._f.length;
      if (configfLen === 0) {
        getParsingFlags(config2).invalidFormat = true;
        config2._d = /* @__PURE__ */ new Date(NaN);
        return;
      }
      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config2);
        if (config2._useUTC != null) {
          tempConfig._useUTC = config2._useUTC;
        }
        tempConfig._f = config2._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config2, bestMoment || tempConfig);
    }
    function configFromObject(config2) {
      if (config2._d) {
        return;
      }
      var i = normalizeObjectUnits(config2._i), dayOrDate = i.day === void 0 ? i.date : i.day;
      config2._a = map(
        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
        function(obj) {
          return obj && parseInt(obj, 10);
        }
      );
      configFromArray(config2);
    }
    function createFromConfig(config2) {
      var res = new Moment(checkOverflow(prepareConfig(config2)));
      if (res._nextDay) {
        res.add(1, "d");
        res._nextDay = void 0;
      }
      return res;
    }
    function prepareConfig(config2) {
      var input = config2._i, format2 = config2._f;
      config2._locale = config2._locale || getLocale(config2._l);
      if (input === null || format2 === void 0 && input === "") {
        return createInvalid({ nullInput: true });
      }
      if (typeof input === "string") {
        config2._i = input = config2._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config2._d = input;
      } else if (isArray(format2)) {
        configFromStringAndArray(config2);
      } else if (format2) {
        configFromStringAndFormat(config2);
      } else {
        configFromInput(config2);
      }
      if (!isValid(config2)) {
        config2._d = null;
      }
      return config2;
    }
    function configFromInput(config2) {
      var input = config2._i;
      if (isUndefined(input)) {
        config2._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config2._d = new Date(input.valueOf());
      } else if (typeof input === "string") {
        configFromString(config2);
      } else if (isArray(input)) {
        config2._a = map(input.slice(0), function(obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config2);
      } else if (isObject2(input)) {
        configFromObject(config2);
      } else if (isNumber2(input)) {
        config2._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config2);
      }
    }
    function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
      var c = {};
      if (format2 === true || format2 === false) {
        strict = format2;
        format2 = void 0;
      }
      if (locale2 === true || locale2 === false) {
        strict = locale2;
        locale2 = void 0;
      }
      if (isObject2(input) && isObjectEmpty2(input) || isArray(input) && input.length === 0) {
        input = void 0;
      }
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale2;
      c._i = input;
      c._f = format2;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal2(input, format2, locale2, strict) {
      return createLocalOrUTC(input, format2, locale2, strict, false);
    }
    var prototypeMin = deprecate(
      "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var other = createLocal2.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }
    ), prototypeMax = deprecate(
      "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var other = createLocal2.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      }
    );
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal2();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy("isBefore", args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy("isAfter", args);
    }
    var now2 = function() {
      return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
    };
    var ordering = [
      "year",
      "quarter",
      "month",
      "week",
      "day",
      "hour",
      "minute",
      "second",
      "millisecond"
    ];
    function isDurationValid(m) {
      var key, unitHasDecimal = false, i, orderLen = ordering.length;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false;
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months22 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);
      this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
      minutes2 * 6e4 + // 1000 * 60
      hours2 * 1e3 * 60 * 60;
      this._days = +days2 + weeks2 * 7;
      this._months = +months22 + quarters * 3 + years2 * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }
    function offset(token2, separator) {
      addFormatToken(token2, 0, 0, function() {
        var offset2 = this.utcOffset(), sign2 = "+";
        if (offset2 < 0) {
          offset2 = -offset2;
          sign2 = "-";
        }
        return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
      });
    }
    offset("Z", ":");
    offset("ZZ", "");
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken(["Z", "ZZ"], function(input, array, config2) {
      config2._useUTC = true;
      config2._tzm = offsetFromString(matchShortOffset, input);
    });
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || "").match(matcher), chunk, parts, minutes2;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
      minutes2 = +(parts[1] * 60) + toInt(parts[2]);
      return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
    }
    function cloneWithOffset(input, model) {
      var res, diff2;
      if (model._isUTC) {
        res = model.clone();
        diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal2(input).valueOf()) - res.valueOf();
        res._d.setTime(res._d.valueOf() + diff2);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal2(input).local();
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset());
    }
    hooks.updateOffset = function() {
    };
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset2 = this._offset || 0, localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === "string") {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, "m");
        }
        if (offset2 !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(
              this,
              createDuration(input - offset2, "m"),
              1,
              false
            );
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset2 : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== "string") {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), "m");
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === "string") {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal2(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {}, other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal2(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input, match = null, sign2, ret, diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber2(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign2 = match[1] === "-" ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign2,
          h: toInt(match[HOUR]) * sign2,
          m: toInt(match[MINUTE]) * sign2,
          s: toInt(match[SECOND]) * sign2,
          ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign2
          // the millisecond decimal point is included in the match
        };
      } else if (match = isoRegex.exec(input)) {
        sign2 = match[1] === "-" ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign2),
          M: parseIso(match[3], sign2),
          w: parseIso(match[4], sign2),
          d: parseIso(match[5], sign2),
          h: parseIso(match[6], sign2),
          m: parseIso(match[7], sign2),
          s: parseIso(match[8], sign2)
        };
      } else if (duration == null) {
        duration = {};
      } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
        diffRes = momentsDifference(
          createLocal2(duration.from),
          createLocal2(duration.to)
        );
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, "_locale")) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, "_isValid")) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign2) {
      var res = inp && parseFloat(inp.replace(",", "."));
      return (isNaN(res) ? 0 : res) * sign2;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, "M").isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, "M");
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return { milliseconds: 0, months: 0 };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }
    function createAdder(direction, name2) {
      return function(val, period) {
        var dur, tmp;
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(
            name2,
            "moment()." + name2 + "(period, number) is deprecated. Please use moment()." + name2 + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
          );
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months22 = absRound(duration._months);
      if (!mom.isValid()) {
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months22) {
        setMonth(mom, get2(mom, "Month") + months22 * isAdding);
      }
      if (days2) {
        set$1(mom, "Date", get2(mom, "Date") + days2 * isAdding);
      }
      if (milliseconds2) {
        mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days2 || months22);
      }
    }
    var add3 = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
      return typeof input === "string" || input instanceof String;
    }
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber2(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject2(input) && !isObjectEmpty2(input), propertyTest = false, properties = [
        "years",
        "year",
        "y",
        "months",
        "month",
        "M",
        "days",
        "day",
        "d",
        "dates",
        "date",
        "D",
        "hours",
        "hour",
        "h",
        "minutes",
        "minute",
        "m",
        "seconds",
        "second",
        "s",
        "milliseconds",
        "millisecond",
        "ms"
      ], i, property, propertyLen = properties.length;
      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input), dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function(item) {
          return !isNumber2(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject2(input) && !isObjectEmpty2(input), propertyTest = false, properties = [
        "sameDay",
        "nextDay",
        "lastDay",
        "nextWeek",
        "lastWeek",
        "sameElse"
      ], i, property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now22) {
      var diff2 = myMoment.diff(now22, "days", true);
      return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = void 0;
          formats = void 0;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = void 0;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = void 0;
        }
      }
      var now22 = time || createLocal2(), sod = cloneWithOffset(now22, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction2(formats[format2]) ? formats[format2].call(this, now22) : formats[format2]);
      return this.format(
        output || this.localeData().calendar(format2, this, createLocal2(now22))
      );
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal2(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal2(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween2(from2, to2, units, inclusivity) {
      var localFrom = isMoment(from2) ? from2 : createLocal2(from2), localTo = isMoment(to2) ? to2 : createLocal2(to2);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || "()";
      return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal2(input), inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || "millisecond";
      if (units === "millisecond") {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case "year":
          output = monthDiff(this, that) / 12;
          break;
        case "month":
          output = monthDiff(this, that);
          break;
        case "quarter":
          output = monthDiff(this, that) / 3;
          break;
        case "second":
          output = (this - that) / 1e3;
          break;
        case "minute":
          output = (this - that) / 6e4;
          break;
        case "hour":
          output = (this - that) / 36e5;
          break;
        case "day":
          output = (this - that - zoneDelta) / 864e5;
          break;
        case "week":
          output = (this - that - zoneDelta) / 6048e5;
          break;
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a);
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
        adjust = (b - anchor) / (anchor2 - anchor);
      }
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
      return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(
          m,
          utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
        );
      }
      if (isFunction2(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
        }
      }
      return formatMoment(
        m,
        utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
      );
    }
    function inspect() {
      if (!this.isValid()) {
        return "moment.invalid(/* " + this._i + " */)";
      }
      var func = "moment", zone = "", prefix, year, datetime, suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
        zone = "Z";
      }
      prefix = "[" + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
      datetime = "-MM-DD[T]HH:mm:ss.SSS";
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal2(time).isValid())) {
        return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal2(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal2(time).isValid())) {
        return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal2(), withoutSuffix);
    }
    function locale(key) {
      var newLocaleData;
      if (key === void 0) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate(
      "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
      function(key) {
        if (key === void 0) {
          return this.localeData();
        } else {
          return this.locale(key);
        }
      }
    );
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === void 0 || units === "millisecond" || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case "year":
          time = startOfDate(this.year(), 0, 1);
          break;
        case "quarter":
          time = startOfDate(
            this.year(),
            this.month() - this.month() % 3,
            1
          );
          break;
        case "month":
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case "week":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - this.weekday()
          );
          break;
        case "isoWeek":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1)
          );
          break;
        case "day":
        case "date":
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case "hour":
          time = this._d.valueOf();
          time -= mod$1(
            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
            MS_PER_HOUR
          );
          break;
        case "minute":
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case "second":
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === void 0 || units === "millisecond" || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case "year":
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case "quarter":
          time = startOfDate(
            this.year(),
            this.month() - this.month() % 3 + 3,
            1
          ) - 1;
          break;
        case "month":
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case "week":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - this.weekday() + 7
          ) - 1;
          break;
        case "isoWeek":
          time = startOfDate(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1) + 7
          ) - 1;
          break;
        case "day":
        case "date":
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case "hour":
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(
            time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
            MS_PER_HOUR
          ) - 1;
          break;
        case "minute":
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case "second":
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 6e4;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1e3);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray2() {
      var m = this;
      return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond()
      ];
    }
    function toObject2() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", ["y", 1], "yo", "eraYear");
    addFormatToken("y", ["yy", 2], 0, "eraYear");
    addFormatToken("y", ["yyy", 3], 0, "eraYear");
    addFormatToken("y", ["yyyy", 4], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken(
      ["N", "NN", "NNN", "NNNN", "NNNNN"],
      function(input, array, config2, token2) {
        var era = config2._locale.erasParse(input, token2, config2._strict);
        if (era) {
          getParsingFlags(config2).era = era;
        } else {
          getParsingFlags(config2).invalidEra = input;
        }
      }
    );
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
    addParseToken(["yo"], function(input, array, config2, token2) {
      var match;
      if (config2._locale._eraYearOrdinalRegex) {
        match = input.match(config2._locale._eraYearOrdinalRegex);
      }
      if (config2._locale.eraYearOrdinalParse) {
        array[YEAR] = config2._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format2) {
      var i, l, date, eras = this._eras || getLocale("en")._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case "string":
            date = hooks(eras[i].since).startOf("day");
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case "undefined":
            eras[i].until = Infinity;
            break;
          case "string":
            date = hooks(eras[i].until).startOf("day").valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format2, strict) {
      var i, l, eras = this.eras(), name2, abbr, narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name2 = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format2) {
            case "N":
            case "NN":
            case "NNN":
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case "NNNN":
              if (name2 === eraName) {
                return eras[i];
              }
              break;
            case "NNNNN":
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name2, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? 1 : -1;
      if (year === void 0) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i, l, val, eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return "";
    }
    function getEraNarrow() {
      var i, l, val, eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return "";
    }
    function getEraAbbr() {
      var i, l, val, eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return "";
    }
    function getEraYear() {
      var i, l, dir, val, eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? 1 : -1;
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, "_erasNameRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, "_erasAbbrRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, "_erasNarrowRegex")) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale2) {
      return locale2.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale2) {
      return locale2.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale2) {
      return locale2.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale2) {
      return locale2._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        erasName = regexEscape(eras[i].name);
        erasAbbr = regexEscape(eras[i].abbr);
        erasNarrow = regexEscape(eras[i].narrow);
        namePieces.push(erasName);
        abbrPieces.push(erasAbbr);
        narrowPieces.push(erasNarrow);
        mixedPieces.push(erasName);
        mixedPieces.push(erasAbbr);
        mixedPieces.push(erasNarrow);
      }
      this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
      this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
      this._erasNarrowRegex = new RegExp(
        "^(" + narrowPieces.join("|") + ")",
        "i"
      );
    }
    addFormatToken(0, ["gg", 2], 0, function() {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ["GG", 2], 0, function() {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token2, getter) {
      addFormatToken(0, [token2, token2.length], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken(
      ["gggg", "ggggg", "GGGG", "GGGGG"],
      function(input, week, config2, token2) {
        week[token2.substr(0, 2)] = toInt(input);
      }
    );
    addWeekParseToken(["gg", "GG"], function(input, week, config2, token2) {
      week[token2] = hooks.parseTwoDigitYear(input);
    });
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday() + this.localeData()._week.dow,
        this.localeData()._week.dow,
        this.localeData()._week.doy
      );
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
      );
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }
    addFormatToken("Q", 0, "Qo", "quarter");
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });
    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    addFormatToken("D", ["DD", 2], "Do", "date");
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale2) {
      return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(["D", "DD"], DATE);
    addParseToken("Do", function(input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });
    var getSetDayOfMonth = makeGetSet("Date", true);
    addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken(["DDD", "DDDD"], function(input, array, config2) {
      config2._dayOfYear = toInt(input);
    });
    function getSetDayOfYear(input) {
      var dayOfYear = Math.round(
        (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
      ) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    addFormatToken("m", ["mm", 2], 0, "minute");
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken(["m", "mm"], MINUTE);
    var getSetMinute = makeGetSet("Minutes", false);
    addFormatToken("s", ["ss", 2], 0, "second");
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken(["s", "ss"], SECOND);
    var getSetSecond = makeGetSet("Seconds", false);
    addFormatToken("S", 0, 0, function() {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ["SS", 2], 0, function() {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ["SSS", 3], 0, "millisecond");
    addFormatToken(0, ["SSSS", 4], 0, function() {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ["SSSSS", 5], 0, function() {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ["SSSSSS", 6], 0, function() {
      return this.millisecond() * 1e3;
    });
    addFormatToken(0, ["SSSSSSS", 7], 0, function() {
      return this.millisecond() * 1e4;
    });
    addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
      return this.millisecond() * 1e5;
    });
    addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
      return this.millisecond() * 1e6;
    });
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for (token = "SSSS"; token.length <= 9; token += "S") {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(("0." + input) * 1e3);
    }
    for (token = "S"; token.length <= 9; token += "S") {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet("Milliseconds", false);
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    function getZoneAbbr() {
      return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
      return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add3;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween2;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray2;
    proto.toObject = toObject2;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) {
      proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
      "dates accessor is deprecated. Use date instead.",
      getSetDayOfMonth
    );
    proto.months = deprecate(
      "months accessor is deprecated. Use month instead",
      getSetMonth
    );
    proto.years = deprecate(
      "years accessor is deprecated. Use year instead",
      getSetYear
    );
    proto.zone = deprecate(
      "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
      getSetZone
    );
    proto.isDSTShifted = deprecate(
      "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
      isDaylightSavingTimeShifted
    );
    function createUnix(input) {
      return createLocal2(input * 1e3);
    }
    function createInZone() {
      return createLocal2.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal2;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format2, index, field, setter) {
      var locale2 = getLocale(), utc = createUTC().set(setter, index);
      return locale2[field](utc, format2);
    }
    function listMonthsImpl(format2, index, field) {
      if (isNumber2(format2)) {
        index = format2;
        format2 = void 0;
      }
      format2 = format2 || "";
      if (index != null) {
        return get$1(format2, index, field, "month");
      }
      var i, out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format2, i, field, "month");
      }
      return out;
    }
    function listWeekdaysImpl(localeSorted, format2, index, field) {
      if (typeof localeSorted === "boolean") {
        if (isNumber2(format2)) {
          index = format2;
          format2 = void 0;
        }
        format2 = format2 || "";
      } else {
        format2 = localeSorted;
        index = format2;
        localeSorted = false;
        if (isNumber2(format2)) {
          index = format2;
          format2 = void 0;
        }
        format2 = format2 || "";
      }
      var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
      if (index != null) {
        return get$1(format2, (index + shift) % 7, field, "day");
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format2, (i + shift) % 7, field, "day");
      }
      return out;
    }
    function listMonths(format2, index) {
      return listMonthsImpl(format2, index, "months");
    }
    function listMonthsShort(format2, index) {
      return listMonthsImpl(format2, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format2, index) {
      return listWeekdaysImpl(localeSorted, format2, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format2, index) {
      return listWeekdaysImpl(localeSorted, format2, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format2, index) {
      return listWeekdaysImpl(localeSorted, format2, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
      eras: [
        {
          since: "0001-01-01",
          until: Infinity,
          offset: 1,
          name: "Anno Domini",
          narrow: "AD",
          abbr: "AD"
        },
        {
          since: "0000-12-31",
          until: -Infinity,
          offset: 1,
          name: "Before Christ",
          narrow: "BC",
          abbr: "BC"
        }
      ],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function(number) {
        var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        return number + output;
      }
    });
    hooks.lang = deprecate(
      "moment.lang is deprecated. Use moment.locale instead.",
      getSetGlobalLocale
    );
    hooks.langData = deprecate(
      "moment.langData is deprecated. Use moment.localeData instead.",
      getLocale
    );
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds2 = this._milliseconds, days2 = this._days, months22 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
      if (!(milliseconds2 >= 0 && days2 >= 0 && months22 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months22 <= 0)) {
        milliseconds2 += absCeil(monthsToDays(months22) + days2) * 864e5;
        days2 = 0;
        months22 = 0;
      }
      data.milliseconds = milliseconds2 % 1e3;
      seconds2 = absFloor(milliseconds2 / 1e3);
      data.seconds = seconds2 % 60;
      minutes2 = absFloor(seconds2 / 60);
      data.minutes = minutes2 % 60;
      hours2 = absFloor(minutes2 / 60);
      data.hours = hours2 % 24;
      days2 += absFloor(hours2 / 24);
      monthsFromDays = absFloor(daysToMonths(days2));
      months22 += monthsFromDays;
      days2 -= absCeil(monthsToDays(monthsFromDays));
      years2 = absFloor(months22 / 12);
      months22 %= 12;
      data.days = days2;
      data.months = months22;
      data.years = years2;
      return this;
    }
    function daysToMonths(days2) {
      return days2 * 4800 / 146097;
    }
    function monthsToDays(months22) {
      return months22 * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days2, months22, milliseconds2 = this._milliseconds;
      units = normalizeUnits(units);
      if (units === "month" || units === "quarter" || units === "year") {
        days2 = this._days + milliseconds2 / 864e5;
        months22 = this._months + daysToMonths(days2);
        switch (units) {
          case "month":
            return months22;
          case "quarter":
            return months22 / 3;
          case "year":
            return months22 / 12;
        }
      } else {
        days2 = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case "week":
            return days2 / 7 + milliseconds2 / 6048e5;
          case "day":
            return days2 + milliseconds2 / 864e5;
          case "hour":
            return days2 * 24 + milliseconds2 / 36e5;
          case "minute":
            return days2 * 1440 + milliseconds2 / 6e4;
          case "second":
            return days2 * 86400 + milliseconds2 / 1e3;
          case "millisecond":
            return Math.floor(days2 * 864e5) + milliseconds2;
          default:
            throw new Error("Unknown unit " + units);
        }
      }
    }
    function makeAs(alias) {
      return function() {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name2) {
      return function() {
        return this.isValid() ? this._data[name2] : NaN;
      };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months2 = makeGetter("months"), years = makeGetter("years");
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month/week
      w: null,
      // weeks to month
      M: 11
      // months to year
    };
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale2) {
      return locale2.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
      var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months22 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
      if (thresholds2.w != null) {
        a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
      }
      a = a || months22 <= 1 && ["M"] || months22 < thresholds2.M && ["MM", months22] || years2 <= 1 && ["y"] || ["yy", years2];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale2;
      return substituteTimeAgo.apply(null, a);
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === void 0) {
        return round;
      }
      if (typeof roundingFunction === "function") {
        round = roundingFunction;
        return true;
      }
      return false;
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === void 0) {
        return false;
      }
      if (limit === void 0) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === "s") {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false, th = thresholds, locale2, output;
      if (typeof argWithSuffix === "object") {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === "boolean") {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === "object") {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale2 = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale2);
      if (withSuffix) {
        output = locale2.pastFuture(+this, output);
      }
      return locale2.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months22 = abs$1(this._months), minutes2, hours2, years2, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
      if (!total) {
        return "P0D";
      }
      minutes2 = absFloor(seconds2 / 60);
      hours2 = absFloor(minutes2 / 60);
      seconds2 %= 60;
      minutes2 %= 60;
      years2 = absFloor(months22 / 12);
      months22 %= 12;
      s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
      totalSign = total < 0 ? "-" : "";
      ymSign = sign(this._months) !== sign(total) ? "-" : "";
      daysSign = sign(this._days) !== sign(total) ? "-" : "";
      hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
      return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months22 ? ymSign + months22 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months2;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate(
      "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
      toISOString$1
    );
    proto$2.lang = lang;
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config2) {
      config2._d = new Date(parseFloat(input) * 1e3);
    });
    addParseToken("x", function(input, array, config2) {
      config2._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal2);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now2;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
      // <input type="datetime-local" step="0.001" />
      DATE: "YYYY-MM-DD",
      // <input type="date" />
      TIME: "HH:mm",
      // <input type="time" />
      TIME_SECONDS: "HH:mm:ss",
      // <input type="time" step="1" />
      TIME_MS: "HH:mm:ss.SSS",
      // <input type="time" step="0.001" />
      WEEK: "GGGG-[W]WW",
      // <input type="week" />
      MONTH: "YYYY-MM"
      // <input type="month" />
    };
    return hooks;
  });
})(moment$1);
var momentExports = moment$1.exports;
const moment = /* @__PURE__ */ getDefaultExportFromCjs(momentExports);
const getColor = (context) => {
  switch (context) {
    case "success":
      return "lawngreen";
    case "error":
      return "hotpink";
    case "info":
      return "dodgerblue";
    default:
      return "white";
  }
};
const devLog = (context = "success", name2, ...msg) => {
  var _a, _b2;
  if (!((_a = window.bookingsConfig) == null ? void 0 : _a.mode) || ((_b2 = window.bookingsConfig) == null ? void 0 : _b2.mode) === "development") {
    console.log(`%c${context.toUpperCase()}: ${name2} `, `color: ${getColor(context)}`, ...msg);
  }
};
const useEnhancedEffect = typeof window !== "undefined" ? React$7.useLayoutEffect : React$7.useEffect;
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function resolveProps(defaultProps, props) {
  const output = _extends$3({}, props);
  Object.keys(defaultProps).forEach((propName) => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = _extends$3({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        output[propName] = slotProps;
      } else {
        output[propName] = _extends$3({}, slotProps);
        Object.keys(defaultSlotProps).forEach((slotPropName) => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === void 0) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}
function getThemeProps(params) {
  const {
    theme: theme2,
    name: name2,
    props
  } = params;
  if (!theme2 || !theme2.components || !theme2.components[name2] || !theme2.components[name2].defaultProps) {
    return props;
  }
  return resolveProps(theme2.components[name2].defaultProps, props);
}
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = React$7.useContext(ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match, setMatch] = React$7.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }
    return defaultMatches;
  });
  useEnhancedEffect(() => {
    let active = true;
    if (!matchMedia) {
      return void 0;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}
const maybeReactUseSyncExternalStore = React$7["useSyncExternalStore"];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = React$7.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = React$7.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = React$7.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {
      }];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, (notify) => {
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery(queryInput, options = {}) {
  const theme2 = useTheme();
  const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr = false
  } = getThemeProps({
    name: "MuiUseMediaQuery",
    props: options,
    theme: theme2
  });
  if (process.env.NODE_ENV !== "production") {
    if (typeof queryInput === "function" && theme2 === null) {
      console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join("\n"));
    }
  }
  let query = typeof queryInput === "function" ? queryInput(theme2) : queryInput;
  query = query.replace(/^@media( ?)/m, "");
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== void 0 ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (process.env.NODE_ENV !== "production") {
    React$7.useDebugValue({
      query,
      match
    });
  }
  return match;
}
const name$4 = "@eatclub-apps/ec-bookings-library";
const version = "1.16.15-ec.1";
const description = "Components used in EC Bookings and Obee FOH apps";
const publishConfig = {
  registry: "https://npm.pkg.github.com"
};
const license = "UNLICENSED";
const repository = {
  type: "git",
  url: "git+https://github.com/eatclub-apps/ec-bookings-library.git"
};
const type = "module";
const main = "./build/ec-bookings-library.umd.cjs";
const module = "./build/ec-bookings-library.js";
const files = [
  "build"
];
const sideEffects = false;
const dependencies = {
  "@babel/runtime": "^7.22.15",
  "@camdarragh/react-draggable": "^4.5.0",
  "@date-io/moment": "^1.3.13",
  "@eatclub-apps/ec-component-library": "3.1.6",
  "@mui/material": "^5.11.10",
  "@mui/styles": "^5.11.9",
  "@rollbar/react": "^0.11.0",
  "@stripe/react-stripe-js": "^1.8.1",
  "@stripe/stripe-js": "^1.31.0",
  "draft-js": "^0.11.7",
  "env-cmd": "^10.0.1",
  "lodash.debounce": "^4.0.8",
  "lodash.range": "^3.2.0",
  "prop-types": "^15.7.2",
  "react-beautiful-dnd": "^13.1.0",
  "react-ga4": "^2.1.0",
  "react-infinite-scroll-hook": "^4.1.1",
  "react-jss": "^10.10.0",
  "react-moment-proptypes": "^1.8.1",
  "react-zoom-pan-pinch": "^3.3.0",
  validator: "^13.7.0",
  webfontloader: "^1.6.28",
  wretch: "^2.0.2"
};
const devDependencies = {
  "@analytics/google-analytics": "^0.5.3",
  "@babel/core": "^7.13.10",
  "@babel/plugin-proposal-private-property-in-object": "^7.21.0",
  "@babel/plugin-syntax-jsx": "^7.12.13",
  "@babel/plugin-transform-react-jsx": "^7.14.3",
  "@babel/plugin-transform-runtime": "^7.22.15",
  "@babel/preset-env": "^7.18.10",
  "@babel/preset-react": "^7.18.6",
  "@babel/preset-typescript": "^7.18.6",
  "@emotion/react": "^11.10.4",
  "@emotion/styled": "^11.10.4",
  "@redux-devtools/extension": "^3.2.3",
  "@reduxjs/toolkit": "^1.8.5",
  "@rollup/plugin-alias": "^3.1.9",
  "@rollup/plugin-babel": "^5.3.0",
  "@rollup/plugin-commonjs": "^19.0.0",
  "@rollup/plugin-json": "^4.1.0",
  "@rollup/plugin-multi-entry": "^4.0.0",
  "@rollup/plugin-node-resolve": "^13.0.0",
  "@rollup/plugin-terser": "^0.4.1",
  "@rollup/plugin-url": "^7.0.0",
  "@svgr/rollup": "^6.2.1",
  "@types/jest": "^26.0.23",
  "@types/react": "^18.0.28",
  "@types/react-dom": "^18.0.11",
  "@vitejs/plugin-react": "^4.1.0",
  "aws-amplify": "^4.3.46",
  "babel-loader": "^8.2.2",
  dotenv: "^16.0.1",
  "dotenv-cli": "^6.0.0",
  eslint: "^8.34.0",
  "eslint-config-airbnb": "^19.0.4",
  "eslint-config-prettier": "^9.1.0",
  "eslint-import-resolver-typescript": "^3.5.3",
  "eslint-plugin-import": "^2.27.5",
  "eslint-plugin-jsx-a11y": "^6.7.1",
  "eslint-plugin-prettier": "^5.1.3",
  "eslint-plugin-react": "^7.27.1",
  "eslint-plugin-react-hooks": "^4.6.0",
  history: "^5.3.0",
  husky: "^8.0.1",
  "identity-obj-proxy": "^3.0.0",
  jest: "^26.6.3",
  "lint-staged": "^13.0.3",
  moment: "^2.24.0",
  "moment-timezone": "^0.5.31",
  postcss: "^8.3.0",
  prettier: "^3.2.4",
  react: "^18.2.0",
  "react-dom": "^18.2.0",
  "react-redux": "^7.1.3",
  "react-router-dom": "^5.1.2",
  "react-virtualized": "^9.22.3",
  rollbar: "^2.24.1",
  "ts-jest": "^26.5.6",
  typescript: "^4.9.5",
  vite: "^5.2.8",
  "vite-plugin-dts": "^3.8.1",
  "vite-plugin-env-compatible": "^2.0.1",
  "vite-plugin-svgr": "^4.2.0",
  "vite-tsconfig-paths": "^4.3.2"
};
const peerDependencies = {
  "@analytics/google-analytics": "^0.5.3",
  "@babel/runtime": "^7.22.15",
  "@date-io/moment": "^1.3.13",
  "@eatclub-apps/ec-component-library": "3.1.6",
  "@emotion/react": "^11.10.4",
  "@emotion/styled": "^11.10.4",
  "@mui/material": "^5.11.10",
  "@mui/styles": "^5.11.9",
  "@redux-devtools/extension": "^3.2.3",
  "@reduxjs/toolkit": "^1.8.5",
  "@rollbar/react": "^0.11.0",
  "@stripe/react-stripe-js": "^1.8.1",
  "@stripe/stripe-js": "^1.31.0",
  "aws-amplify": "^4.3.46",
  "env-cmd": "^10.0.1",
  history: "^5.3.0",
  moment: "^2.24.0",
  "moment-timezone": "^0.5.31",
  "prop-types": "^15.7.2",
  react: "^18.2.0",
  "react-beautiful-dnd": "^13.1.0",
  "react-device-detect": "^2.2.2",
  "react-dom": "^18.2.0",
  "react-jss": "^10.10.0",
  "react-moment-proptypes": "^1.8.1",
  "react-redux": "^7.1.3",
  "react-router-dom": "^5.1.2",
  "react-virtualized": "^9.22.3",
  rollbar: "^2.24.1"
};
const babel = {
  presets: [
    "@babel/preset-react",
    "@babel/preset-env"
  ],
  plugins: [
    "@babel/plugin-syntax-jsx"
  ]
};
const scripts = {
  "build:prod": "NODE_ENV=production rm -rf build && vite build",
  "build:staging": "NODE_ENV=development rm -rf build && vite build",
  "build-dev": "NODE_ENV=development yarn publish-local",
  "build:dev": "yarn run build-dev",
  "build-watch": "yarn run build-dev && fswatch -o -r ./src | xargs -n1 -I{} yarn run build-dev",
  lint: "eslint --ext .js,.jsx,ts,tsx ./src",
  "lint:fix": "npx eslint --fix --ext js,jsx,ts,tsx,json ./src",
  test: "jest",
  "test:watch": "jest --watch",
  prepublishOnly: "vite build",
  prepare: "husky install",
  "link:components": "yalc link @eatclub-apps/ec-component-library",
  "unlink:components": "yalc remove @eatclub-apps/ec-component-library",
  "publish-local": "yalc push --replace --private --scripts",
  wipe: "rm -rf .yalc && rm -rf node_modules && rm -rf build && yarn install"
};
const browserslist = {
  production: [
    ">0.2%",
    "not dead",
    "not op_mini all"
  ],
  development: [
    "last 1 chrome version",
    "last 1 firefox version",
    "last 1 safari version"
  ]
};
const packageInfo = {
  name: name$4,
  version,
  description,
  publishConfig,
  license,
  repository,
  type,
  main,
  module,
  files,
  sideEffects,
  dependencies,
  devDependencies,
  peerDependencies,
  babel,
  scripts,
  "lint-staged": {
    "**/*.{js,jsx,ts,tsx}": [
      "prettier --write"
    ]
  },
  browserslist
};
const isVoid = (item) => item === null || item === void 0;
const isSet = (value) => value !== null && value !== void 0;
const isEmpty = (item) => {
  if (item === null || item === void 0) {
    return true;
  }
  if (Object.getPrototypeOf(item) === Object.prototype) {
    return item && Object.keys(item).length === 0;
  }
  if (item.constructor === Array) {
    return (item == null ? void 0 : item.length) === 0;
  }
  return item === "";
};
const formatCurrency = (value, useDecimals = true, invalidValue = "$0", isInCents = false) => {
  if (value === null || Number.isNaN(value)) {
    return invalidValue;
  }
  let newValue = `${isInCents ? value / 100 : value}`;
  if (newValue.includes("$")) {
    newValue = newValue.replace("$", "");
  }
  const parsedValue = parseFloat(newValue);
  if (Number.isNaN(parsedValue)) {
    return invalidValue;
  }
  const formatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: useDecimals ? 2 : 0,
    maximumFractionDigits: useDecimals ? 2 : 0
  });
  return formatter.format(parsedValue).toLocaleString();
};
const isNumeric = (value) => {
  return /^\d+$/.test(value);
};
const minutesToTimeString = (minutes, format = "h:mma") => {
  let timeAsInt = minutes;
  if (typeof minutes === "string") {
    timeAsInt = parseInt(minutes, 10);
  }
  const hours = Math.floor(timeAsInt / 60);
  const mins = timeAsInt % 60;
  const bookingMoment = moment$2(`${hours}:${mins}`, "hh:mm").format(format);
  return bookingMoment;
};
const formatTimeFromInt = (time, overrideFormat = null, suffix = "a") => {
  if (isVoid(time)) {
    return time;
  }
  if (!isNumeric(time)) {
    devLog("info", "time formatted was not an int");
    return time;
  }
  const format = overrideFormat || (time % 60 === 0 ? `h${suffix}` : `h:mm${suffix}`);
  return minutesToTimeString(time, format);
};
const momentFromInt = (time, date = null) => {
  const momentDate = date === null ? moment$2().format("YYYY-MM-DD") : moment$2(date).format("YYYY-MM-DD");
  const minutes = minutesToTimeString(time);
  return moment$2(`${momentDate} ${minutes}`, "YYYY-MM-DD h:mma");
};
const formatIntFromTime = (time) => {
  if (isVoid(time)) {
    return time;
  }
  if (isNumeric(time)) {
    devLog("info", "time formatted was an int");
    return time;
  }
  if (isEmpty(time)) {
    return null;
  }
  const hours = parseInt(time.format("H"), 10);
  const minutes = parseInt(time.format("m"), 10);
  return hours * 60 + minutes;
};
const formatTime = (time, format = "h:mma", emptyValue = "") => {
  if (isEmpty(time)) {
    return emptyValue;
  }
  const timeAsMoment = moment$2(time);
  return timeAsMoment.format(format);
};
const formatNumber = (value, fallback = null) => {
  if (Number.isNaN(value) && Number.isNaN(parseFloat(value))) {
    console.error("A non-numeric value was attempted to be formatted: ", value);
    if (!isVoid(fallback)) {
      return fallback;
    }
    return value;
  }
  return parseFloat(value).toString();
};
const pluralise = (string, number, pluralString) => {
  if (number === 1) {
    return string;
  }
  if (pluralString) {
    return pluralString;
  }
  return `${string}s`;
};
const getLabelForValue = (value, items, valueIfNotFound = true) => {
  var _a, _b2;
  if (!valueIfNotFound) {
    return (_a = items == null ? void 0 : items.find((item) => (item == null ? void 0 : item.value) === value)) == null ? void 0 : _a.label;
  }
  const matchingItems = items == null ? void 0 : items.filter((item) => (item == null ? void 0 : item.value) === value);
  if (isEmpty(matchingItems)) {
    return value;
  }
  return (_b2 = matchingItems[0]) == null ? void 0 : _b2.label;
};
const capitaliseFirstLetter = (string) => {
  if (typeof string !== "string") {
    return string;
  }
  if (isEmpty(string)) {
    return "";
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const roundToNearest = (value, roundTo = 0, type2 = "round") => {
  if (roundTo === 0) {
    switch (type2) {
      case "floor":
        return Math.floor(value);
      case "ceil":
        return Math.ceil(value);
      case "round":
      default:
        return Math.round(value);
    }
  }
  switch (type2) {
    case "floor":
      return Math.floor(value / roundTo) * roundTo;
    case "ceil":
      return Math.ceil(value / roundTo) * roundTo;
    case "round":
    default:
      return Math.round(value / roundTo) * roundTo;
  }
};
const roundToDecimals = (value, decimals = 2) => {
  return parseFloat(parseFloat(value).toFixed(decimals));
};
const groupObjects = (objects, groupBy, allowMultiple = true) => objects == null ? void 0 : objects.reduce((accum, object) => {
  const updated = { ...accum };
  if (allowMultiple) {
    if (Object.hasOwnProperty.call(updated, object[groupBy])) {
      updated[object[groupBy]].push(object);
    } else {
      updated[object[groupBy]] = [object];
    }
  } else {
    updated[object[groupBy]] = object;
  }
  return updated;
}, {});
const findObjectIndexByProperty = (objects, id, property = "objectId") => objects == null ? void 0 : objects.findIndex((obj) => (obj == null ? void 0 : obj[property]) === id);
const findObjectByProperty = (objects, id, property = "objectId", fallbackObject = null) => {
  if (isEmpty(id) || !Array.isArray(objects)) {
    return fallbackObject;
  }
  return (objects == null ? void 0 : objects.find((obj) => (obj == null ? void 0 : obj[property]) === id)) || fallbackObject;
};
const emptyObject = (value) => value && Object.keys(value).length === 0 && Object.getPrototypeOf(value) === Object.prototype;
const safeDivision = (numerator, denominator) => {
  if (!numerator) {
    return 0;
  }
  if (!denominator) {
    return numerator;
  }
  return numerator / denominator;
};
const updateObjectByProperty = (objects, updatedObject, property = "objectId", merge2 = false) => objects == null ? void 0 : objects.map((obj) => {
  if (!isVoid(updatedObject == null ? void 0 : updatedObject[property]) && (obj == null ? void 0 : obj[property]) === (updatedObject == null ? void 0 : updatedObject[property])) {
    if (merge2) {
      return { ...obj, ...updatedObject };
    }
    return updatedObject;
  }
  return obj;
});
const updateObjectsByProperty = (objects, updatedObjects, property = "objectId", merge2 = false) => {
  if (!Array.isArray(objects)) {
    return [];
  }
  return objects == null ? void 0 : objects.map((obj) => {
    if (isVoid(obj == null ? void 0 : obj[property])) {
      return obj;
    }
    const objectToReplaceWith = findObjectByProperty(updatedObjects, obj == null ? void 0 : obj[property], property);
    if (isVoid(objectToReplaceWith)) {
      return obj;
    }
    if (merge2) {
      return { ...obj, ...objectToReplaceWith };
    }
    return objectToReplaceWith;
  });
};
const replaceObject = (objects, newObject, id, property = "objectId", createIfNotFound = false) => {
  if (!Array.isArray(objects)) {
    return [];
  }
  let found = false;
  const updatedObjects = objects == null ? void 0 : objects.map((obj) => {
    if (!found && !isVoid(obj == null ? void 0 : obj[property]) && id === (obj == null ? void 0 : obj[property])) {
      found = true;
      return newObject;
    }
    return obj;
  });
  if (createIfNotFound && !found) {
    return [...updatedObjects, newObject];
  }
  return updatedObjects;
};
const sortValues = (a, b, descending = false) => {
  if (a === b) {
    return 0;
  }
  const descendingModifier = descending ? -1 : 1;
  if (!isVoid(a) && isVoid(b)) {
    return 1 * descendingModifier;
  }
  if (isVoid(a) && !isVoid(b)) {
    return -1 * descendingModifier;
  }
  if (a > b) {
    return 1 * descendingModifier;
  }
  return -1 * descendingModifier;
};
const immutableSort = (items, callback = null) => {
  if (isEmpty(items)) {
    return [];
  }
  if (callback === null) {
    const newItems2 = [...items];
    return newItems2.sort(sortValues);
  }
  const newItems = [...items];
  return newItems.sort(callback);
};
const sortMultiple = (items, callbacks = []) => {
  return callbacks.reduce((accum, callback) => immutableSort(accum, callback), items);
};
const sortByProperty = (a, b, property, descending = false) => ((a == null ? void 0 : a[property]) >= (b == null ? void 0 : b[property]) ? 1 : -1) * descending ? -1 : 1;
const sortListByProperty = (list, property, descending = false) => {
  if (isEmpty(list)) {
    return [];
  }
  const newList = [...list];
  return newList.sort((a, b) => sortValues(a == null ? void 0 : a[property], b == null ? void 0 : b[property], descending));
};
const convertDateFormat = (dateString, oldFormat, newFormat, invalidValue = null) => {
  const momentDate = moment$2(dateString, oldFormat);
  if (!momentDate.isValid()) {
    return invalidValue;
  }
  return momentDate.format(newFormat);
};
const formatDate = (date, format = "Do", invalidValue = "Invalid date") => {
  const formattedDate = `${moment$2(date).format(format)}`;
  if (formattedDate === "Invalid date") {
    return invalidValue;
  }
  return formattedDate;
};
const filterByProperty = (array, value, property = "objectId", invert = false) => {
  if (isEmpty(array)) {
    return [];
  }
  if (Array.isArray(value)) {
    return array == null ? void 0 : array.filter(
      (item) => !invert ? value.includes(item == null ? void 0 : item[property]) : !value.includes(item == null ? void 0 : item[property])
    );
  }
  return array == null ? void 0 : array.filter(
    (item) => !invert ? (item == null ? void 0 : item[property]) === value : (item == null ? void 0 : item[property]) !== value
  );
};
const filter = (array, value, invert = false) => {
  if (isEmpty(array)) {
    return [];
  }
  if (Array.isArray(value)) {
    return array == null ? void 0 : array.filter((item) => !invert ? value.includes(item) : !value.includes(item));
  }
  return array == null ? void 0 : array.filter((item) => !invert ? item === value : item !== value);
};
const groupByProperty = (arr, property, propertyName = "name") => {
  let groupedObjects = [];
  arr == null ? void 0 : arr.forEach((item) => {
    var _a;
    const index = findObjectIndexByProperty(groupedObjects, item == null ? void 0 : item[property], propertyName);
    if (index < 0) {
      const newItem = { [propertyName]: item == null ? void 0 : item[property], items: [item] };
      groupedObjects = [...groupedObjects, newItem];
    } else {
      const newItems = [...(_a = groupedObjects == null ? void 0 : groupedObjects[index]) == null ? void 0 : _a.items, item];
      groupedObjects[index] = { ...groupedObjects == null ? void 0 : groupedObjects[index], items: newItems };
    }
  });
  return groupedObjects;
};
const groupAsObjectByProperty = (arr, property) => {
  const newObject = {};
  arr.forEach((item) => {
    newObject[item[property]] = item;
  });
  return newObject;
};
const safeSplit = (str, delimiter = ",") => {
  if (typeof str !== "string") {
    return [];
  }
  return str.split(delimiter);
};
const generateRandomString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
const dotProduct = (a, b) => {
  return a.map((x, i) => a[i] * b[i]).reduce((m, n) => m + n);
};
const squareNumbers = (a, b) => {
  return a * a + b * b;
};
const lengthSquared = (a, b) => {
  const width = a.x - b.x;
  const height = a.y - b.y;
  return squareNumbers(width, height);
};
const distanceBetween = (a, b) => {
  return Math.sqrt(lengthSquared(a, b));
};
const insert = (array, index, newItem) => [
  ...array.slice(0, index),
  newItem,
  ...array.slice(index)
];
const nullToEmpty = (value) => {
  if (isVoid(value)) {
    return "";
  }
  return value;
};
const angleBetweenPoints = (point1, point2) => {
  return Math.atan2(point2.y - point1.y, point2.x - point1.x) * 180 / Math.PI;
};
const numberRange = (start, end, interval = 1, inclusive = false) => {
  if (isEmpty(start) || isEmpty(end)) {
    return [];
  }
  if (start === end) {
    return [start];
  }
  const amountInRange = Math.ceil(safeDivision(end - start, interval)) + (inclusive ? 1 : 0);
  if (amountInRange <= 0) {
    return [];
  }
  return Array.from(Array(amountInRange).keys()).map((num) => num * interval + start);
};
const only = (object, keys2) => {
  if (Array.isArray(object)) {
    return object.map((item) => only(item, keys2));
  }
  const newObject = {};
  if (isEmpty(keys2)) {
    return {};
  }
  keys2 == null ? void 0 : keys2.forEach((key) => {
    newObject[key] = object == null ? void 0 : object[key];
  });
  return newObject;
};
const flatten = (arr, key = "id") => {
  if (!(arr == null ? void 0 : arr.length)) {
    return [];
  }
  return arr == null ? void 0 : arr.map((item) => item == null ? void 0 : item[key]);
};
const flattenArrayValues = (arr, key = "id") => {
  if (!(arr == null ? void 0 : arr.length)) {
    return [];
  }
  let newList = [];
  arr == null ? void 0 : arr.forEach((item) => {
    if (Array.isArray(item == null ? void 0 : item[key])) {
      newList = [...newList, ...item == null ? void 0 : item[key]];
    }
  });
  return newList;
};
const copyObjects = (arr) => {
  return arr.map((obj) => ({
    ...obj
  }));
};
const stripSpaces = (text) => {
  return text.replace(/\s/g, "");
};
const separateFuzzySearchText = (text, searchString) => {
  if (!searchString) {
    return false;
  }
  const textLetters = text.split("");
  const searchStringLetters = stripSpaces(searchString).toLowerCase().split("");
  let searchIndex = 0;
  let currentString = "";
  let stringList = [];
  let currentIsMatch = false;
  let foundMatch = false;
  textLetters.forEach((letter) => {
    if (foundMatch) {
      currentString += letter;
      return;
    }
    if (letter.toLowerCase() === searchStringLetters[searchIndex].toLowerCase()) {
      if (!currentIsMatch) {
        stringList = [...stringList, { string: currentString, isMatch: false }];
        currentString = "";
        currentIsMatch = true;
      }
      currentString += letter;
      if (searchIndex + 1 >= (searchStringLetters == null ? void 0 : searchStringLetters.length)) {
        stringList = [...stringList, { string: currentString, isMatch: true }];
        currentString = "";
        currentIsMatch = false;
        foundMatch = true;
      }
      searchIndex += 1;
    } else {
      if (currentIsMatch) {
        stringList = [...stringList, { string: currentString, isMatch: true }];
        currentString = "";
        currentIsMatch = false;
      }
      currentString += letter;
    }
  });
  stringList = [...stringList, { string: currentString, isMatch: currentIsMatch }];
  return stringList;
};
const combineNames = (names) => {
  return nullToEmpty(
    names.filter((name2) => typeof name2 === "string").map((name2) => name2.trim()).join(" ")
  );
};
const joinList = (arr, delimiter = ", ", finalDelimiter = " & ") => {
  if (!Array.isArray(arr) || isEmpty(arr)) {
    return [];
  }
  const stringItems = arr == null ? void 0 : arr.map((item) => `${item}`.trim());
  if (!isEmpty(finalDelimiter) && stringItems.length > 1) {
    const allButLast = arr.slice(0, arr.length - 1);
    const last = arr[arr.length - 1];
    return allButLast.join(delimiter) + finalDelimiter + last;
  }
  return stringItems.join(delimiter);
};
const fuzzySearch = (text, searchString) => {
  if (!searchString) {
    return false;
  }
  const textLetters = text.split("");
  const searchStringLetters = stripSpaces(searchString).toLowerCase().split("");
  let searchIndex = 0;
  let foundMatch = false;
  textLetters.forEach((letter) => {
    if (foundMatch) {
      return;
    }
    if (letter.toLowerCase() === searchStringLetters[searchIndex].toLowerCase()) {
      searchIndex += 1;
      if (searchIndex >= searchStringLetters.length) {
        foundMatch = true;
      }
    }
  });
  return foundMatch;
};
const revertObscureString = (string) => {
  if (!string || typeof string !== "string") {
    return "";
  }
  try {
    let s = atob(string);
    s = atob(s);
    s = s.slice(-3, s.length) + s.slice(0, -3);
    s = atob(s);
    s = s.slice(2, -6);
    s = atob(s);
    return s;
  } catch (e) {
    devLog("error", "string", "Error decoding", e);
    return "";
  }
};
const nullIfNegative = (value) => value < 0 ? null : value;
const getAppVersion = () => {
  let version2;
  if (packageInfo.version.includes("-")) {
    version2 = packageInfo.version.substring(0, packageInfo.version.lastIndexOf("-"));
    version2 = `web_${version2.substring(0, packageInfo.version.lastIndexOf("."))}`;
  } else {
    version2 = `web_${packageInfo.version.substring(0, packageInfo.version.lastIndexOf("."))}`;
  }
  return version2;
};
const arraysMatch = (arr1, arr2) => {
  if (isEmpty(arr1) && isEmpty(arr2)) {
    return true;
  }
  if (isEmpty(arr1) || isEmpty(arr2)) {
    return false;
  }
  if ((arr1 == null ? void 0 : arr1.length) !== (arr2 == null ? void 0 : arr2.length)) {
    return false;
  }
  return [...arr1].sort().join(",") === [...arr2].sort().join(",");
};
const isObject$1 = (obj) => {
  return typeof obj === "object" && obj !== null;
};
const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  return keys1.every((key) => {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject$1(val1) && isObject$1(val2);
    if (areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2) {
      return false;
    }
    return true;
  });
};
const removeNullFields = (object) => {
  if (Array.isArray(object)) {
    return object.map((item) => removeNullFields(item));
  }
  const newObject = {};
  Object.keys(object).forEach((key) => {
    if (typeof object[key] !== "string" && isObject$1(object[key])) {
      newObject[key] = removeNullFields(object[key]);
    } else if (!isVoid(object[key])) {
      newObject[key] = object[key];
    }
  });
  return newObject;
};
const nextNearestMinutes = (time, interval) => {
  const next = time.clone().add(interval, "minutes");
  return next.minutes(Math.floor(safeDivision(next.minutes(), interval)) * interval);
};
const pastNearestMinutes = (time, interval) => {
  const past = time.clone();
  return past.minutes(Math.floor(safeDivision(past.minutes(), interval)) * interval);
};
const removeDuplicates = (array) => {
  return [...new Set(array)];
};
const alphaNumeric = (str) => {
  if (typeof str !== "string") {
    return str;
  }
  return str.replace(/[^a-z0-9]/gi, "");
};
const onlyCharacters = (str, characterRegex) => {
  if (typeof str !== "string") {
    return str;
  }
  const regex = new RegExp(`/[^${characterRegex}]/gi`);
  return str.replace(regex, "");
};
const getAsArray = (item) => {
  if (!Array.isArray(item)) {
    return [item];
  }
  return item;
};
const removeFromArray = (arr, item) => {
  const itemList = getAsArray(item);
  const newItems = [...arr];
  itemList.forEach((itemToCheck) => {
    const index = newItems.indexOf(itemToCheck);
    newItems.splice(index, 1);
  });
  return newItems;
};
const addAlphaToHex = (colorHex, alpha = 1) => {
  const alphaHex = Math.round(alpha * 255).toString(16);
  return `${colorHex}${alphaHex.length === 1 ? `0${alphaHex}` : alphaHex}`;
};
const sortAlphaNumeric = (a, b, descending = false) => {
  const descendingModifier = descending ? -1 : 1;
  if (isVoid(a)) {
    return 1 * descendingModifier;
  }
  if (isVoid(b)) {
    return -1 * descendingModifier;
  }
  const alphabetRegex = /[^a-zA-Z]/g;
  const numericRegex2 = /[^0-9]/g;
  const aAlpha = a.replace(alphabetRegex, "");
  const bAlpha = b.replace(alphabetRegex, "");
  if (aAlpha === bAlpha) {
    const aNumeric = parseInt(a.replace(numericRegex2, ""), 10);
    const bNumeric = parseInt(b.replace(numericRegex2, ""), 10);
    return aNumeric === bNumeric ? 0 : (aNumeric > bNumeric ? 1 : -1) * descendingModifier;
  }
  return (aAlpha > bAlpha ? 1 : -1) * descendingModifier;
};
const sortAlphaNumericByProperty = (a, b, property, descending = false) => {
  return sortAlphaNumeric((a == null ? void 0 : a[property]) || "", (b == null ? void 0 : b[property]) || "", descending);
};
const sortListNaturalByProperty = (list, property, descending) => {
  var _a;
  return (_a = [...list]) == null ? void 0 : _a.sort((a, b) => sortAlphaNumericByProperty(a, b, property, descending));
};
const sortRunSheetListByProperty = (list, property, descending = false) => {
  var _a;
  return property === "tableNumber" ? (_a = [...list]) == null ? void 0 : _a.sort((a, b) => sortAlphaNumericByProperty(a, b, property, descending)) : sortListByProperty(list, property, descending);
};
const sortBoolToStart = (a, b, property, descending = false) => {
  if ((a == null ? void 0 : a[property]) && !(b == null ? void 0 : b[property])) {
    return descending ? 1 : -1;
  }
  if ((b == null ? void 0 : b[property]) && !(a == null ? void 0 : a[property])) {
    return descending ? -1 : 1;
  }
  return 0;
};
const sortMomentByProperty = (a, b, property, format = "h:mm a") => {
  return moment$2(a == null ? void 0 : a[property], format).diff(moment$2(b == null ? void 0 : b[property], format));
};
const isCurrentDate = (date) => {
  if (isEmpty(date)) {
    return false;
  }
  return moment$2().startOf("day").diff(date == null ? void 0 : date.startOf("day"), "hour") === 0;
};
const getAllTimes = (start, end, interval = 15, format = "h:mm a") => numberRange(start, end, interval, true).map((time) => ({
  label: formatTimeFromInt(time, format),
  value: time
}));
const getDayRange = (days) => {
  if (isEmpty(days)) {
    return null;
  }
  if (days.length === 1) {
    return capitaliseFirstLetter(days[0]);
  }
  const weekdaysShort = ["mon", "tue", "wed", "thu", "fri"];
  const weekendDaysShort = ["sat", "sun"];
  const allDaysShort = [...weekdaysShort, ...weekendDaysShort];
  if (arraysMatch(days, allDaysShort)) {
    return "Every day";
  }
  if (arraysMatch(days, weekdaysShort)) {
    return "Weekdays";
  }
  if (arraysMatch(days, weekendDaysShort)) {
    return "Weekends";
  }
  const daysFounds = filter(allDaysShort, days);
  return daysFounds.map(capitaliseFirstLetter).join(", ");
};
const valueIfValue = (value, check, valueOnMatch) => {
  return value === check ? valueOnMatch : value;
};
const daysShort = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const sortByDay = (a, b) => {
  const aIndex = daysShort.findIndex((day) => day === a);
  const bIndex = daysShort.findIndex((day) => day === b);
  if (aIndex < 0) {
    return 1;
  }
  if (bIndex < 0) {
    return -1;
  }
  return aIndex - bIndex;
};
const safeParse = (json, fallback = {}) => {
  let parsed;
  try {
    parsed = JSON.parse(json);
  } catch {
    return json || fallback;
  }
  return parsed;
};
const filterUnique = (value, index, self2) => {
  return self2.indexOf(value) === index;
};
const unique = (arr) => {
  return arr.filter(filterUnique);
};
const diffObjects = (object1, object2) => {
  const diff = {};
  Object.keys(object1).forEach((key) => {
    if (object1[key] !== object2[key]) {
      diff[key] = object1[key];
    }
  });
  return diff;
};
const diffObjectLists = (list1, list2, key = "id", propertiesToKeep = []) => {
  var _a;
  if (isEmpty(list1)) {
    return [];
  }
  const list2ById = groupObjects(list2, key, false);
  const changes = (_a = list1.map((item1) => {
    const item2 = list2ById == null ? void 0 : list2ById[item1 == null ? void 0 : item1[key]];
    if (isEmpty(item1) || isEmpty(item2)) {
      return null;
    }
    const diff = diffObjects(item1, item2);
    if (isEmpty(diff)) {
      return null;
    }
    const keptProperties = only(item1, propertiesToKeep);
    return { ...diff, ...keptProperties };
  })) == null ? void 0 : _a.filter((item) => !isEmpty(item));
  return changes;
};
const arrayWrap = (item) => {
  if (Array.isArray(item)) {
    return item;
  }
  return [item];
};
const removeKeyFromObject = (object, keys2) => {
  const newObject = { ...object };
  const keysList = arrayWrap(keys2);
  if (isEmpty(keysList)) {
    return newObject;
  }
  keysList == null ? void 0 : keysList.forEach((key) => {
    newObject == null ? true : delete newObject[key];
  });
  return newObject;
};
const removeKeyFromObjects = (objects, keys2) => {
  return objects.map((item) => removeKeyFromObject(item, keys2));
};
const parseRichText = (richText) => {
  var _a;
  if (isEmpty(richText)) {
    return "";
  }
  const parsedText = typeof richText === "string" ? JSON.parse(richText) : richText;
  const text = (_a = (parsedText == null ? void 0 : parsedText.blocks) || []) == null ? void 0 : _a.map((block) => block.text).join("\n");
  return text;
};
const arraysEqual = (a, b) => {
  if (a === b) {
    return true;
  }
  if (a == null || b == null) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  const sortedA = immutableSort(a);
  const sortedB = immutableSort(b);
  for (let i = 0; i < sortedA.length; i += 1) {
    if (sortedA[i] !== sortedB[i]) {
      return false;
    }
  }
  return true;
};
const mergeDeep$1 = (target, source, depth = 0, maxDepth = 20) => {
  const output = { ...target };
  if (depth < maxDepth && isObject$1(target) && isObject$1(source)) {
    const newDepth = depth + 1;
    Object.keys(source).forEach((key) => {
      if (isObject$1(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = mergeDeep$1(target[key], source[key], newDepth, maxDepth);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
};
const noop = () => {
};
const mod = (n, m) => {
  return (n % m + m) % m;
};
const isObee = () => {
  var _a;
  return ((_a = window.bookingsConfig) == null ? void 0 : _a.bookingsBranding) === "obee";
};
const toggleListItem = (list, item) => {
  if (list.includes(item)) {
    const index = list.indexOf(item);
    const newList = [...list];
    newList.splice(index, 1);
    return newList;
  }
  return [...list, item];
};
const isIsoDate = (str) => {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str))
    return false;
  const d = new Date(str);
  return d instanceof Date && !Number.isNaN(d) && d.toISOString() === str;
};
const loadItem = (name2) => {
  try {
    const serialState = localStorage.getItem(name2);
    if (serialState === null) {
      return void 0;
    }
    return JSON.parse(serialState);
  } catch (err) {
    devLog("error", "loadState", err);
    return void 0;
  }
};
const saveItem = (name2, state) => {
  try {
    const serialState = JSON.stringify(state);
    localStorage.setItem(name2, serialState);
  } catch (err) {
    devLog("error", "saveState", err);
  }
};
const isBetween = (value, start, end, inclusion = "[]") => {
  switch (inclusion) {
    case "()": {
      return value > start && value < end;
    }
    case "[)": {
      return value >= start && value < end;
    }
    case "(]": {
      return value > start && value <= end;
    }
    case "[]":
    default: {
      return value >= start && value <= end;
    }
  }
};
const getDateTimeNow = () => {
  return isObee() ? moment$2().format("YYYY-MM-DD HH:mm:ss") : (/* @__PURE__ */ new Date()).toISOString();
};
const debounce$2 = (func, wait = 300) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
const trim = (str) => {
  if (typeof str !== "string") {
    return str;
  }
  return str.trim();
};
const getRelativeDate = (momentDate) => {
  const dateFromNow = momentDate.fromNow();
  let relativeDate = `${dateFromNow},`;
  if (dateFromNow === "a day ago") {
    relativeDate = "Yesterday,";
  }
  const currentDateTime = moment$2();
  if (currentDateTime.diff(momentDate, "days") >= 30) {
    relativeDate = "";
  }
  return `${capitaliseFirstLetter(relativeDate)} ${momentDate.format("ddd Do MMM YYYY")}`;
};
const getRelativeTime = (momentDate) => {
  const dateFromNow = momentDate.fromNow();
  let relativeDate = `${dateFromNow}`;
  if (dateFromNow === "a day ago") {
    relativeDate = "Yesterday";
  }
  const currentDateTime = moment$2();
  if (currentDateTime.diff(momentDate, "days") >= 30) {
    return "";
  }
  return relativeDate;
};
const fixedDigits = (number, digits = 2) => number == null ? void 0 : number.toLocaleString("en-US", { minimumIntegerDigits: digits, useGrouping: false });
const stringifyObject = (obj) => {
  const newObject = { ...obj };
  if (Object.getPrototypeOf(obj) === Object.prototype) {
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === "boolean") {
        newObject[key] = `${obj[key]}`;
      } else {
        newObject[key] = obj[key];
      }
    });
  }
  return JSON.stringify(newObject);
};
const stringifyArray = (arr) => {
  let newArray = [...arr];
  if (Array.isArray(newArray)) {
    newArray = newArray.map((item) => {
      if (typeof item === "boolean") {
        return `${item}`;
      }
      return item;
    });
  }
  return JSON.stringify(newArray);
};
const fitIntoRows = (objects, startProperty, endProperty) => {
  const groupedRows = [];
  const rowEnds = [];
  groupedRows[0] = [];
  rowEnds[0] = 0;
  if (!isEmpty(objects)) {
    sortListByProperty(objects, startProperty).forEach((object) => {
      for (let i = 0; i < groupedRows.length; i += 1) {
        if ((object == null ? void 0 : object[startProperty]) >= rowEnds[i]) {
          groupedRows[i] = [...groupedRows[i], object];
          rowEnds[i] = object == null ? void 0 : object[endProperty];
          return;
        }
      }
      groupedRows[groupedRows.length] = [object];
      rowEnds[rowEnds.length] = object == null ? void 0 : object[endProperty];
    });
  }
  return groupedRows;
};
const uniqueObjects = (objects) => {
  const uniqueArray = objects.filter((object, index) => {
    const stringifiedObject = JSON.stringify(object);
    return index === objects.findIndex((obj) => {
      return JSON.stringify(obj) === stringifiedObject;
    });
  });
  return uniqueArray;
};
const getEverySideBySideCombination = (objects, minLength = 1) => {
  const allCombinations = [];
  for (let start = 0; start < objects.length; start += 1) {
    for (let end = start; end <= objects.length; end += 1) {
      allCombinations.push(objects.slice(start, end));
    }
  }
  return allCombinations.filter((combination) => combination.length >= minLength);
};
const generateAddressString = (addressLine1, addressLine2, city, state) => {
  return [addressLine1, addressLine2, city, state].filter((item) => item).join(", ");
};
const arrayMove = (arr, fromIndex, toIndex) => {
  const newArray = [...arr];
  const element = newArray[fromIndex];
  newArray.splice(fromIndex, 1);
  newArray.splice(toIndex, 0, element);
  return newArray;
};
const areEqual$2 = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
};
const convertArrayToObjectWithDefaultValues = (keys2, value) => {
  const initialValue = {};
  return keys2.reduce((obj, key) => {
    return {
      ...obj,
      [key]: value
    };
  }, initialValue);
};
const floatsEqual = (a, b) => {
  const difference1 = Math.abs(a - b);
  return difference1 >= 0 && difference1 <= 0.01;
};
const hasBirthdayCheck = (date, birthday) => {
  const parsedDate = moment$2(date);
  const parsedBirthday = moment$2(birthday);
  return parsedDate.month() === parsedBirthday.month() && parsedDate.date() === parsedBirthday.date();
};
const ordinal = (num) => {
  const numAsInt = parseInt(num, 10);
  const ones = numAsInt % 10;
  const tens = numAsInt % 100;
  if (ones === 1 && tens !== 11) {
    return `${numAsInt}st`;
  }
  if (ones === 2 && tens !== 12) {
    return `${numAsInt}nd`;
  }
  if (ones === 3 && tens !== 13) {
    return `${numAsInt}rd`;
  }
  return `${numAsInt}th`;
};
const getMinInArrayOfObjects = (array, property) => {
  const min = array.reduce((prev, current) => {
    return prev[property] < current[property] ? prev : current;
  })[property];
  return min;
};
const getMaxInArrayOfObjects = (array, property) => {
  const max = array.reduce((prev, current) => {
    return prev[property] > current[property] ? prev : current;
  })[property];
  return max;
};
const getMinMaxInArrayOfObjects = (array, minProperty, maxProperty) => {
  const min = getMinInArrayOfObjects(array, minProperty);
  const max = getMaxInArrayOfObjects(array, maxProperty);
  return { min, max };
};
const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
};
const useInterval = (callback, delay) => {
  const savedCallback = useRef();
  useLayoutEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
const useHoldCounter = (callback, delay = 500) => {
  const savedCallback = useRef();
  const [counter, setCounter] = useState(0);
  const timer = useRef(null);
  useEffect(() => {
    savedCallback.current = callback;
    timer.current = null;
  }, []);
  const countInterval = 50;
  const startCounter = () => {
    devLog("info", "starting counter");
    if (timer.current) {
      devLog("info", "nevermind, theres already a timer");
      return;
    }
    timer.current = setInterval(() => {
      setCounter((previousCount) => {
        return previousCount + countInterval;
      });
    }, countInterval);
  };
  const stopCounter = () => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
      setCounter(0);
    }
  };
  useEffect(() => {
    if (counter > 0 && counter >= delay) {
      stopCounter();
      savedCallback.current();
    }
  }, [counter]);
  useEffect(() => {
    return () => {
      stopCounter();
      savedCallback.current = () => {
      };
    };
  }, []);
  return [startCounter, stopCounter];
};
const useFetchOnFirstRender = (fetches, data, prerequisites = [], skipLoading = false, abortIfFetched = false, additionalData = []) => {
  const firstRender = useRef(true);
  let dataArray = data;
  if (!Array.isArray(data) || (fetches == null ? void 0 : fetches.length) !== (data == null ? void 0 : data.length)) {
    console.error(
      "Data passed into useFetchOnFirstRender must be an array of entities that matches the length of fetches. Data given:",
      data
    );
    dataArray = [];
  }
  const hasFinishedLoading = (newData, isFirstRender) => {
    let finishedLoading;
    const hasMissingData = !isEmpty(
      newData.filter((item) => !(item == null ? void 0 : item.hasFetched) && isEmpty(item == null ? void 0 : item.apiData))
    );
    if (isFirstRender) {
      finishedLoading = !hasMissingData;
    } else {
      const hasPendingRequests = !isEmpty(newData.filter((item) => item == null ? void 0 : item.pending));
      finishedLoading = !hasPendingRequests;
    }
    return finishedLoading;
  };
  const [hasLoaded, setHasLoaded] = useState(
    skipLoading ? true : hasFinishedLoading(dataArray, firstRender.current)
  );
  const dataPending = dataArray.map((item) => item == null ? void 0 : item.pending);
  useEffect(() => {
    if (!skipLoading && hasFinishedLoading(dataArray, firstRender.current)) {
      setHasLoaded(true);
    }
  }, dataPending);
  const prerequisitesComplete = isEmpty(prerequisites.filter((prereq) => isVoid(prereq)));
  useEffect(() => {
    if (!skipLoading && !hasLoaded && prerequisitesComplete) {
      fetches.forEach((fetch2, index) => {
        var _a, _b2, _c2;
        if (!((_a = dataArray == null ? void 0 : dataArray[index]) == null ? void 0 : _a.pending) && isEmpty((_b2 = dataArray == null ? void 0 : dataArray[index]) == null ? void 0 : _b2.apiData) && !(abortIfFetched && ((_c2 = dataArray == null ? void 0 : dataArray[index]) == null ? void 0 : _c2.hasFetched))) {
          if (!isEmpty(additionalData)) {
            fetch2(...additionalData);
          } else {
            fetch2();
          }
        }
      });
    }
    firstRender.current = false;
  }, [prerequisitesComplete]);
  return skipLoading || !hasLoaded;
};
const useStartAndEndTimes = (interval, restaurantOpen, restaurantClose, defaultStartTime = "allDay", defaultEndTime = "allDay") => {
  const [startTime, setStartTime] = useState(defaultStartTime);
  const [endTime, setEndTime] = useState(defaultEndTime);
  let updatedStartTime = startTime;
  const changeStartTime = (newTime) => {
    if (newTime === "allDay") {
      setStartTime(newTime);
      updatedStartTime = newTime;
      setEndTime(newTime);
      return;
    }
    if (endTime === "allDay") {
      setEndTime(restaurantClose);
    }
    if (isEmpty(newTime)) {
      updatedStartTime = newTime;
      setStartTime(newTime);
      return;
    }
    const maxStartTime = restaurantClose - interval;
    const updatedTime = Math.min(maxStartTime, newTime);
    updatedStartTime = newTime;
    setStartTime(updatedTime);
    if (updatedTime >= endTime) {
      setEndTime(updatedTime + interval);
    }
  };
  const changeEndTime = (newTime) => {
    if (newTime === "allDay") {
      setStartTime(newTime);
      setEndTime(newTime);
      return;
    }
    if (updatedStartTime === "allDay") {
      setStartTime(restaurantOpen);
    }
    if (isEmpty(newTime)) {
      setEndTime(newTime);
      return;
    }
    const minEndTime = restaurantOpen + interval;
    const updatedTime = Math.max(minEndTime, newTime);
    setEndTime(updatedTime);
    if (updatedTime <= startTime) {
      setStartTime(restaurantOpen);
    }
  };
  const startTimes = useMemo(() => {
    const restaurantOpenFormatted = formatTimeFromInt(restaurantOpen, "h:mma");
    const restaurantCloseFormatted = formatTimeFromInt(restaurantClose, "h:mma");
    return [
      { label: "-", value: null },
      {
        label: `All day (${restaurantOpenFormatted}-${restaurantCloseFormatted})`,
        value: "allDay"
      },
      ...getAllTimes(restaurantOpen, restaurantClose, interval)
    ];
  }, [interval, restaurantOpen, restaurantClose]);
  const endTimes = useMemo(() => {
    const restaurantOpenFormatted = formatTimeFromInt(restaurantOpen, "h:mma");
    const restaurantCloseFormatted = formatTimeFromInt(restaurantClose, "h:mma");
    const allDayLabel = `All day (${restaurantOpenFormatted}-${restaurantCloseFormatted})`;
    if (startTime === "allDay") {
      return [
        { label: "-", value: null },
        {
          label: allDayLabel,
          value: "allDay"
        },
        ...getAllTimes(restaurantOpen + interval, restaurantClose, interval)
      ];
    }
    return [
      { label: "-", value: null },
      { label: allDayLabel, value: "allDay" },
      ...getAllTimes(startTime, restaurantClose, interval)
    ];
  }, [startTime, interval, restaurantOpen, restaurantClose]);
  return [startTimes, endTimes, startTime, endTime, changeStartTime, changeEndTime];
};
const useHasMobile = () => {
  const theme2 = useTheme$1();
  return useMediaQuery(theme2.breakpoints.down("md"));
};
const useBreakpointDown = (breakpoint) => {
  const theme2 = useTheme$1();
  return useMediaQuery(theme2.breakpoints.down(breakpoint));
};
const useErrorListener = (value, checkIsError, setError, errorMessage) => useEffect(() => {
  if (checkIsError(value)) {
    setError(errorMessage);
  } else {
    setError(null);
  }
  return () => setError(null);
}, [value]);
const useEffectAfterFirstRender = (callback, deps = []) => {
  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      callback();
    }
  }, deps);
  useEffect(
    () => () => {
      firstRender.current = true;
    },
    []
  );
};
const useKeyboardListener = (elementRef, onBlur2, keyActions, allowedElements = []) => {
  const handleKeyPress = (event) => {
    if (document.activeElement !== elementRef.current && !allowedElements.includes(document.activeElement)) {
      return;
    }
    if (event.key === "Escape") {
      document.activeElement.blur();
      onBlur2();
    }
    keyActions.forEach((keyAction) => {
      if (event.key === (keyAction == null ? void 0 : keyAction.key)) {
        keyAction == null ? void 0 : keyAction.action(event);
      }
    });
  };
  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  });
  return handleKeyPress;
};
const sortByDate = (date1, date2, format = ((_a) => (_a = window.bookingsConfig) == null ? void 0 : _a.dateFormat)(), descending = false) => {
  const momentDate1 = moment$2(date1, format);
  const momentDate2 = moment$2(date2, format);
  if (momentDate1.isBefore(momentDate2)) {
    return descending ? 1 : -1;
  }
  if (momentDate1.isAfter(momentDate2)) {
    return descending ? -1 : 1;
  }
  return 0;
};
const useQuery = () => new URLSearchParams(useLocation().search);
const useHashQuery = () => {
  const getParams = () => {
    let query = window.location.hash.substring(1);
    query = query.split("&").reduce((previous, current) => {
      const pair = current.split("=");
      const updated = { ...previous };
      updated[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
      return updated;
    }, {});
    return query;
  };
  const [params] = useState(getParams());
  return params;
};
const dailyNotePropTypes = PropTypes.shape({
  id: PropTypes.number,
  // int in obee
  date: PropTypes.string,
  // Date that note applies to
  title: PropTypes.string,
  note: PropTypes.string,
  insertedBy: PropTypes.string,
  category: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // category ID
  // category: PropTypes.shape({
  //   id: PropTypes.number,
  //   category: PropTypes.string,
  //   colour: PropTypes.string,
  // }),
  pinned: PropTypes.bool,
  createdDate: PropTypes.string
  // Needed for sorting most recent at top
});
const dailyNotesPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(dailyNotePropTypes),
  apiData: PropTypes.arrayOf(dailyNotePropTypes),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const getData$j = (dailyNote) => {
  var _a;
  devLog("info", "getting data for dailyNotes", dailyNote);
  return {
    ...dailyNote,
    date: moment(dailyNote == null ? void 0 : dailyNote.date).format("YYYY-MM-DD"),
    // Obee's api returns the time as well
    category: (_a = dailyNote == null ? void 0 : dailyNote.category) == null ? void 0 : _a.id,
    unread: true,
    readableDate: moment(dailyNote.date).format("DD/MM")
  };
};
const getDailyNoteColor = (category, theme2) => {
  var _a, _b2;
  const colorMap = {
    staff: theme2.colors.dailyNoteCategory1,
    general: theme2.colors.dailyNoteCategory2,
    menu: theme2.colors.dailyNoteCategory3,
    booking: theme2.colors.dailyNoteCategory4,
    events: theme2.colors.dailyNoteCategory5,
    other: theme2.colors.dailyNoteCategoryOther
  };
  if (colorMap == null ? void 0 : colorMap[(_a = category == null ? void 0 : category.category) == null ? void 0 : _a.toLowerCase()]) {
    return colorMap == null ? void 0 : colorMap[(_b2 = category == null ? void 0 : category.category) == null ? void 0 : _b2.toLowerCase()];
  }
  if (category == null ? void 0 : category.colour) {
    return category.colour;
  }
  return theme2.colors.dailyNoteCategoryOther;
};
const keys = ["xs", "sm", "md", "lg", "xl"];
const runsheetIpadViewBreakpoint = 1025;
function createBreakpoints(breakpoints2) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm[.
    values = {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    },
    unit = "px",
    step = 5,
    ...other
  } = breakpoints2;
  function up(key) {
    const value = typeof values[key] === "number" ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const endIndex = keys.indexOf(key) + 1;
    const upperbound = values[keys[endIndex]];
    if (endIndex === keys.length) {
      return up("xs");
    }
    const value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    if (endIndex === keys.length - 1) {
      return up(start);
    }
    return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and (max-width:${(endIndex !== -1 && typeof values[keys[endIndex + 1]] === "number" ? values[keys[endIndex + 1]] : end) - step / 100}${unit})`;
  }
  function only2(key) {
    return between(key, key);
  }
  function width(key) {
    return values[key];
  }
  return {
    keys,
    values,
    up,
    down,
    between,
    only: only2,
    width,
    ...other
  };
}
const mergeDeep = (source, target, depth = 0, maxDepth = 20) => {
  const output = { ...source };
  if (depth >= maxDepth) {
    devLog(
      "error",
      "merge deep",
      "merge deep has hit too many nested objects. Further objects wont be merged"
    );
  }
  if (depth < maxDepth && isObject$1(source) && isObject$1(target)) {
    const newDepth = depth + 1;
    Object.keys(target).forEach((key) => {
      if (isObject$1(target[key])) {
        if (!(key in source)) {
          Object.assign(output, { [key]: target[key] });
        } else {
          output[key] = mergeDeep(source[key], target[key], newDepth, maxDepth);
        }
      } else {
        Object.assign(output, { [key]: target[key] });
      }
    });
  }
  return output;
};
const breakpoints = createBreakpoints({
  xs: 0,
  sm: 600,
  // Mobile - not supported
  md: 1025,
  // Smallest tablet
  lg: 1280,
  // Normal laptop size
  xl: 1920
  // Full width
});
const overlay = "auto";
const lineHeights = {
  xs: "10px",
  s: "14px",
  m: "16px",
  l: "20px",
  l2: "22px",
  // Since there's no consistency yet
  l3: "24px",
  // Since there's no consistency yet
  xl: "28px",
  xxl: "32px",
  "3xl": "34px",
  "4xl": "40px"
};
const appColors = {
  black: "#000000",
  red: "#EB5757",
  charcoal: "#313131",
  cloud: "#F0F0F0",
  dune: "#F2EFEE",
  fern: "#6EA76D",
  honeydew: "#F9FBF9",
  lightCloud: "#F7F7F7",
  linen: "#F5F2ED",
  nimbus: "#AEAEAE",
  jet: "#1A1919",
  olive2: "#386D64",
  olive3: "#5A9488",
  olive4: "#86AEA6",
  olive5: "#E1EAE8",
  orange: "#FBD283",
  shark: "#DCDCDB",
  white: "#FFFFFF",
  whiteSmoke: "#F4F4F4",
  smoke: "#6E6E6D",
  gray3: "#969696",
  gray4: "#C4C4C4",
  gray5: "#D5D5D5",
  gray6: "#F7F6F5",
  gray7: "#E7E7E7",
  gray8: "#DCDCDC",
  gray9: "#CACACA",
  yetAnotherGray: "#F1F1F1",
  yetAnotherGray2: "#EEEEEE",
  yetAnotherGray3: "#E0E0E0",
  yetAnotherGray4: "#F8F8F8",
  yetAnotherGray5: "#828282",
  yetAnotherGray6: "#979797",
  yetAnotherGray7: "#8F8F8F",
  yetAnotherGray8: "#D2D2D2",
  yetAnotherGray9: "#F2F2F2",
  yetAnotherGray10: "#575757",
  yetAnotherGray11: "#E4E4E4",
  yetAnotherGray12: "#f5f5f5",
  // TODO use whitesmoke instead
  yetAnotherGray13: "#EDEDED",
  yetAnotherGray14: "#A1A1A1",
  yetAnotherGray15: "#D9D9D9",
  yetAnotherGray16: "#757575",
  // TODO use grayLight
  yetAnotherGray17: "#EBF2EB",
  yetAnotherGray18: "#D3CCC9",
  // YET_ANOTHER_GRAY_12 in old version
  yetAnotherGray19: "#F9F8F8",
  // YET_ANOTHER_GRAY_13 in old version
  yetAnotherGray20: "#B3B3B3",
  // YET_ANOTHER_GRAY_14 in old version
  yetAnotherGray21: "#DCDBDB",
  yetAnotherGray22: "#E5E5E5",
  yetAnotherGray23: "#6A6A6A",
  yetAnotherGray24: "#ECECEC",
  // Formerly #EBEBEB
  yetAnotherGray25: "#939393",
  yetAnotherGray27: "#DEDEDE",
  lightShade: "#F9F9F9",
  notificationBackgroundGray: "#F4F4F4",
  backgroundLight: "#EFEFEF",
  grayBorder: "#DCDCDB",
  grayLight: "#7E7E7E",
  grayBackground: "#E5DED3",
  linkIconBackground: "#ECECEC",
  timelineGray: "#DDEAE7",
  burntOrange: "#E07D5C",
  mandarin: "#E7B78B",
  turmeric: "#EAD16A",
  turmericDarker: "#E4C43F",
  turmericLight: "#FBF8EA",
  cancelledPink: "#EEC7BB",
  finishedGreen: "#1F4C46",
  finishedGreenDarker: "#173531",
  alabaster: "#EFEBE4",
  rose: "#EEC1BB",
  cakeBackground: "#F2CFCA",
  roquetteLight: "#ECF4EC",
  whiteRock: "#ECE6DC",
  noShowOutline: "#E08A7E",
  greenShadeHighlight: "#E6EDEC",
  anotherOrange: "#E8A263",
  breakfastTime: "#F7EAB6",
  peach: "#F9E7D6",
  greenBackground: "#E3ECE3",
  darkerSunnyGreen: "#619260",
  informationBlue: "#0E3AB9",
  roquette: "#5D995C",
  // sic
  olive: "#28524B",
  oliveText: "#42756C",
  floorplanTableFill: "#F5F8F5",
  floorplanTableOutline: "#558C54",
  bannerBackground: "#F1F5ED",
  // Note: was F5F2ED in develop
  timelineGreen: "#28665B",
  textGray: "#A1A1A1",
  listItemSelected: "#EEF2F1",
  linenLight: "#EFEDED",
  // used for loading shimmer
  linenLight2: "#F7F5F3",
  // Used for canvas background
  warningOrange: "#DE8E50",
  errorRed: "#DA5A5A",
  bannerBlue: "#F2F6FA",
  linenDark: "#DFD7C8",
  linenButton: "#EAE4DB",
  linenButtonOutline: "#E7E1D7",
  staffBlue: "#C4D8F3",
  warningIcon: "#E09A63",
  apricot: "#DE9863",
  apricotLight: "#F7E6D9",
  // NOTE: Should these light/dark colors be calculated programmatically if its just an alpha shift?
  blue: "#96B1D5",
  selectedListItem: "#F0EBE4",
  successGreenLight: "#E3ECE2",
  errorRedLight: "#F9E6E6",
  infoBlue: "#2A476A",
  infoBlueLight: "#E5ECF5",
  warningBlue: "#4C7DB8",
  // Used in warning icons
  bookedBookingPill: "#EAE4DB",
  // TODO find what this should actually be
  arrivedYellow: "#EDCC3E",
  finishedBlack: "#201F1E",
  vipYellow: "#EEEA7D",
  blacklistBlack: "#141412",
  darkYellowBrown: "#433F1F",
  birthdayPurple: "#C7C1E3",
  favouriteBrown: "#E9D6B3",
  // Calendar
  // calendarTotalBackground: '#1E1E1A',
  calendarTotalBackground: "#FFFFFF",
  calendarStatsBorder: "#E6E6E6",
  calendarStatsTotalBackground: "#FFFFFF",
  calendarStatsTotalOutline: "#000000",
  totalUnderlineColor: "#F0EDE7",
  calendarStats1: "#F8EAAD",
  calendarStats2: "#ECEEB4",
  calendarStats3: "#EDE4CD",
  calendarStats4: "#F7DFC9",
  calendarStats5: "#E9E7F7",
  calendarStatsBackground1: "#EDCC3E",
  calendarStatsBackground2: "#E3E596",
  calendarStatsBackground3: "#CEC7B6",
  calendarStatsBackground4: "#E8A263",
  calendarStatsBackground5: "#C7C1E3",
  // Daily notes
  dailyNoteCategory1: "#E3E596",
  dailyNoteCategory2: "#C7C1E3",
  dailyNoteCategory3: "#EF8453",
  dailyNoteCategory4: "#FAD14C",
  dailyNoteCategory5: "#78734D",
  dailyNoteCategoryOther: "#e9e9e9",
  // More stuff
  headerBorder: "#EEE9E1",
  headerButtonOutline: "#C0B096",
  // Used on single/multi buttons
  pillAvailable: "#86B186",
  availableBackground: "#EBF2EB",
  unavailableBackground: "#FAE1DF",
  // Guest book and vouchers
  unicornSilver: "#E9E8E8",
  lightRed: "#F9DAD8",
  darkRed: "#E54439",
  // Integrations
  facebookBlue: "#1877F2"
};
const baseStyles = {
  breakpoints,
  // TODO give the colours more meaningful names. e.g. "headerBackground" rather than just the colour
  // Some colours may refer to the same base colour. This is fine, as a colour can be reused in multiple contexts
  colors: {
    black: appColors.black,
    brandPrimary: appColors.fern,
    // Here's an example of using a more literal name
    red: appColors.red,
    charcoal: appColors.charcoal,
    // This should be broken out into things like text colour
    cloud: appColors.cloud,
    borderLight: appColors.cloud,
    dune: appColors.dune,
    fern: appColors.fern,
    honeydew: appColors.honeydew,
    lightCloud: appColors.lightCloud,
    linen: appColors.linen,
    nimbus: appColors.nimbus,
    jet: appColors.jet,
    olive2: appColors.olive2,
    olive3: appColors.olive3,
    olive4: appColors.olive4,
    olive5: appColors.olive5,
    orange: appColors.orange,
    shark: appColors.shark,
    white: appColors.white,
    whiteSmoke: appColors.whiteSmoke,
    smoke: appColors.smoke,
    gray3: appColors.gray3,
    gray4: appColors.gray4,
    gray5: appColors.gray5,
    gray6: appColors.gray6,
    gray7: appColors.gray7,
    gray8: appColors.gray8,
    yetAnotherGray: appColors.yetAnotherGray,
    yetAnotherGray2: appColors.yetAnotherGray2,
    yetAnotherGray3: appColors.yetAnotherGray3,
    yetAnotherGray4: appColors.yetAnotherGray4,
    yetAnotherGray5: appColors.yetAnotherGray5,
    yetAnotherGray6: appColors.yetAnotherGray6,
    yetAnotherGray7: appColors.yetAnotherGray7,
    yetAnotherGray8: appColors.yetAnotherGray8,
    yetAnotherGray9: appColors.yetAnotherGray9,
    yetAnotherGray10: appColors.yetAnotherGray10,
    yetAnotherGray11: appColors.yetAnotherGray11,
    yetAnotherGray12: appColors.yetAnotherGray12,
    yetAnotherGray13: appColors.yetAnotherGray13,
    floorplanAreaIcon: appColors.yetAnotherGray14,
    yetAnotherGray15: appColors.yetAnotherGray15,
    yetAnotherGray16: appColors.yetAnotherGray16,
    yetAnotherGray17: appColors.yetAnotherGray17,
    yetAnotherGray18: appColors.yetAnotherGray18,
    yetAnotherGray19: appColors.yetAnotherGray19,
    yetAnotherGray20: appColors.yetAnotherGray20,
    yetAnotherGray21: appColors.yetAnotherGray21,
    yetAnotherGray22: appColors.yetAnotherGray22,
    yetAnotherGray23: appColors.yetAnotherGray23,
    yetAnotherGray24: appColors.yetAnotherGray24,
    yetAnotherGray25: appColors.yetAnotherGray25,
    yetAnotherGray27: appColors.yetAnotherGray27,
    notificationBackgroundGray: appColors.notificationBackgroundGray,
    statusBackground: appColors.notificationBackgroundGray,
    backgroundLight: appColors.backgroundLight,
    grayBorder: appColors.grayBorder,
    borderGray: appColors.gray7,
    grayLight: appColors.grayLight,
    grayBackground: appColors.grayBackground,
    linkIconBackground: appColors.linkIconBackground,
    burntOrange: appColors.burntOrange,
    mandarin: appColors.mandarin,
    turmeric: appColors.turmeric,
    turmericDarker: appColors.turmericDarker,
    turmericLight: appColors.turmericLight,
    cancelledPink: appColors.cancelledPink,
    finishedGreen: appColors.finishedGreen,
    finishedGreenDarker: appColors.finishedGreenDarker,
    alabaster: appColors.alabaster,
    rose: appColors.rose,
    cakeBackground: appColors.cakeBackground,
    roquetteLight: appColors.roquetteLight,
    bookedBookingPill: appColors.bookedBookingPill,
    noShowOutline: appColors.noShowOutline,
    greenShadeHighlight: appColors.greenShadeHighlight,
    anotherOrange: appColors.anotherOrange,
    breakfastTime: appColors.breakfastTime,
    peach: appColors.peach,
    greenBackground: appColors.greenBackground,
    darkerSunnyGreen: appColors.darkerSunnyGreen,
    informationBlue: appColors.informationBlue,
    roquette: appColors.roquette,
    // sic
    olive: appColors.olive,
    oliveText: appColors.oliveText,
    floorplanTableFill: appColors.floorplanTableFill,
    floorplanTableOutline: appColors.floorplanTableOutline,
    bannerBackground: appColors.bannerBackground,
    dateSelectBackground: appColors.yetAnotherGray12,
    timelineGreen: appColors.timelineGreen,
    timelineHighlight: appColors.timelineGreen,
    labelBackground: appColors.timelineGray,
    cardOutline: appColors.gray7,
    pillAvailable: appColors.pillAvailable,
    availableBackground: appColors.availableBackground,
    unavailableBackground: appColors.unavailableBackground,
    menuText: appColors.textGray,
    textGray: appColors.textGray,
    lightShade: appColors.lightShade,
    listItemSelected: appColors.listItemSelected,
    warningOrange: appColors.warningOrange,
    warning: appColors.warningOrange,
    errorRed: appColors.errorRed,
    bannerBlue: appColors.bannerBlue,
    linenDark: appColors.linenDark,
    linenButton: appColors.linenButton,
    linenButtonOutline: appColors.linenButtonOutline,
    staffBlue: appColors.staffBlue,
    warningIcon: appColors.warningIcon,
    apricot: appColors.apricot,
    apricotLight: appColors.apricotLight,
    blue: appColors.blue,
    selectedListItem: appColors.selectedListItem,
    successGreenLight: appColors.successGreenLight,
    errorRedLight: appColors.errorRedLight,
    infoBlue: appColors.infoBlue,
    infoBlueLight: appColors.infoBlueLight,
    unicornSilver: appColors.unicornSilver,
    lightRed: appColors.lightRed,
    darkRed: appColors.darkRed,
    submitButton: appColors.charcoal,
    facebookBlue: appColors.facebookBlue,
    darkYellowBrown: appColors.darkYellowBrown,
    birthdayPurple: appColors.birthdayPurple,
    favouriteBrown: appColors.favouriteBrown,
    // THEMING
    buttonText: appColors.charcoal,
    // Buttons with coloured background. e.g. select toggle
    labelText: appColors.charcoal,
    sidebarBackground: appColors.linen,
    sidebarSelected: appColors.white,
    sidebarItemHovered: appColors.gray6,
    pageBackground: appColors.linen,
    // Background of floorplan page
    canvasBackground: appColors.linenLight2,
    canvasBorder: appColors.yetAnotherGray15,
    headerBorder: appColors.linen,
    headerButtonOutline: appColors.linenButtonOutline,
    headerIcon: appColors.headerButtonOutline,
    // The colours inside the single/multi icon // or beaf98
    menuHighlightBackground: appColors.dune,
    // quick actions menu, calendar header, etc.
    timelineEmptyRow: appColors.dune,
    // Shown on rows for areas on timeline
    timelineClosed: appColors.lightShade,
    // Shown on closed cells on timeline
    tableMenuBackground: appColors.linen,
    // Sidebar on edit floorplan
    floorplanElementColour: appColors.linen,
    // Fill in tables and elements on edit floorplan
    outdoorAreaLine: appColors.charcoal,
    outdoorAreaBackground: appColors.dune,
    loadingShimmer: appColors.linenLight,
    // Used on skeletons
    bodyText: appColors.charcoal,
    modalHighlight: appColors.linen,
    // Used on the horizontal bar for modal headers
    notification: appColors.turmeric,
    // Used on notification bell
    notificationBellBackgroundColor: appColors.linenButton,
    // Used on notification bell background color
    // Tabs
    tabUnderline: appColors.grayBackground,
    // status pills
    bookedStatusText: appColors.charcoal,
    bookedStatusOutline: appColors.charcoal,
    bookedStatusBackground: appColors.linen,
    confirmedStatusText: appColors.charcoal,
    confirmedStatusOutline: appColors.charcoal,
    confirmedStatusBackground: appColors.linen,
    arrivedStatusText: appColors.charcoal,
    arrivedStatusOutline: appColors.turmeric,
    arrivedStatusBackground: appColors.arrivedYellow,
    finishedStatusText: appColors.olive5,
    finishedStatusRunSheetText: appColors.nimbus,
    finishedStatusOutline: appColors.shark,
    finishedStatusBackground: appColors.finishedBlack,
    noShowStatusText: appColors.charcoal,
    noShowStatusOutline: appColors.anotherOrange,
    noShowStatusBackground: appColors.anotherOrange,
    cancelledStatusText: appColors.charcoal,
    cancelledStatusOutline: appColors.cancelledPink,
    cancelledStatusBackground: appColors.cancelledPink,
    waitingStatusText: appColors.charcoal,
    waitingStatusOutline: appColors.blue,
    waitingStatusBackground: appColors.blue,
    unconfirmedStatusText: appColors.charcoal,
    unconfirmedStatusOutline: appColors.cancelledPink,
    unconfirmedStatusBackground: appColors.cancelledPink,
    // Floorplan tables
    defaultTableOutline: appColors.charcoal,
    defaultTableFill: appColors.roquetteLight,
    bookedTableFill: appColors.linen,
    bookedTableOutline: appColors.charcoal,
    confirmedTableFill: appColors.linen,
    confirmedTableOutline: appColors.charcoal,
    availableTableFill: appColors.roquetteLight,
    availableTableOutline: appColors.roquette,
    unavailableTableFill: appColors.shark,
    unavailableTableOutline: appColors.charcoal,
    seatedTableFill: appColors.turmericLight,
    seatedTableOutline: appColors.turmeric,
    finishedTableFill: appColors.roquetteLight,
    finishedTableOutline: appColors.roquette,
    blockedTableFill: appColors.shark,
    blockedTableOutline: appColors.smoke,
    fullyBookedTableFill: appColors.shark,
    fullyBookedTableOutline: appColors.smoke,
    lateTableFill: appColors.linen,
    lateTableOutline: appColors.noShowOutline,
    noShowTableFill: appColors.linen,
    noShowTableOutline: appColors.noShowOutline,
    cancelledTableFill: appColors.linen,
    cancelledTableOutline: appColors.cancelledPink,
    multiTableFill: appColors.white,
    multiTableOutline: appColors.white,
    availableLabelBackground: appColors.roquetteLight,
    availableLabelText: appColors.roquette,
    // Timeline blocks
    // booked
    bookedBookingBarOutline: appColors.charcoal,
    bookedBookingBarFill: appColors.linen,
    bookedBookingBarHighlight: appColors.charcoal,
    bookedBookingBarDetails: appColors.smoke,
    bookedBookingBarIconOutline: appColors.shark,
    bookedBookingBarJointPill: appColors.bookedBookingPill,
    bookedBookingBarJointText: appColors.charcoal,
    // confirmed
    confirmedBookingBarOutline: appColors.charcoal,
    confirmedBookingBarFill: appColors.linen,
    confirmedBookingBarHighlight: appColors.charcoal,
    confirmedBookingBarDetails: appColors.smoke,
    confirmedBookingBarIconOutline: appColors.shark,
    confirmedBookingBarJointPill: appColors.bookedBookingPill,
    confirmedBookingBarJointText: appColors.charcoal,
    // arrived
    arrivedBookingBarOutline: appColors.turmeric,
    arrivedBookingBarFill: appColors.turmeric,
    arrivedBookingBarHighlight: appColors.turmericDarker,
    arrivedBookingBarDetails: appColors.smoke,
    arrivedBookingBarIconOutline: appColors.turmericDarker,
    arrivedBookingBarJointPill: appColors.turmericDarker,
    arrivedBookingBarJointText: appColors.charcoal,
    // finished
    finishedBookingBarOutline: appColors.finishedGreen,
    finishedBookingBarFill: appColors.finishedGreen,
    finishedBookingBarHighlight: appColors.finishedGreenDarker,
    finishedBookingBarDetails: appColors.olive5,
    finishedBookingBarIconOutline: appColors.olive5,
    finishedBookingBarJointPill: appColors.finishedGreenDarker,
    finishedBookingBarJointText: appColors.olive5,
    // Other statuses don't show?
    // Guestbook
    activeGuestRowBackground: appColors.white,
    activeGuestRowBorder: appColors.charcoal,
    dividerLineGray: appColors.charcoal,
    summaryPanelBackground: appColors.white,
    // Voucher
    activeVoucher: appColors.greenBackground,
    // Text fields
    textAreaBackground: appColors.lightShade,
    // f9f9f9
    editableTextPlaceholder: appColors.yetAnotherGray20,
    // B5B5B5 in figma
    // Toggle
    toggleBackground: appColors.turmeric,
    // Runsheet
    vipYellow: appColors.vipYellow,
    blacklistBlack: appColors.blacklistBlack,
    // Calendar
    calendarTotalBackground: appColors.calendarTotalBackground,
    calendarStatsBorder: appColors.calendarStatsBorder,
    calendarStats1: appColors.calendarStats1,
    calendarStats2: appColors.calendarStats2,
    calendarStats3: appColors.calendarStats3,
    calendarStats4: appColors.calendarStats4,
    calendarStats5: appColors.calendarStats5,
    calendarStatsBackground1: appColors.calendarStatsBackground1,
    calendarStatsBackground2: appColors.calendarStatsBackground2,
    calendarStatsBackground3: appColors.calendarStatsBackground3,
    calendarStatsBackground4: appColors.calendarStatsBackground4,
    calendarStatsBackground5: appColors.calendarStatsBackground5,
    calendarStatsTotalBackground: appColors.calendarStatsTotalBackground,
    // Daily notes
    dailyNoteCategory1: appColors.dailyNoteCategory1,
    dailyNoteCategory2: appColors.dailyNoteCategory2,
    dailyNoteCategory3: appColors.dailyNoteCategory3,
    dailyNoteCategory4: appColors.dailyNoteCategory4,
    dailyNoteCategory5: appColors.dailyNoteCategory5,
    dailyNoteCategoryOther: appColors.dailyNoteCategoryOther
  },
  fontSizes: {
    hxl: "56px",
    h1: "40px",
    h2: "32px",
    h3: "24px",
    h4: "18px",
    h5: "14px",
    subhead: "14px",
    hm: "28px",
    // used on sms confirmation
    // Everything below this is old and should be replaced with new names
    xs: "12px",
    s: "14px",
    m2: "15px",
    m: "16px",
    // TODO replace 'm' with 15px. Need to cross-check every usage of m to see if it should be changed to 15
    l: "18px",
    xl: "20px",
    xl2: "22px",
    xxl: "24px",
    xxl2: "28px",
    "3xl": "32px",
    "4xl": "40px"
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    bold: 700,
    black: 900
  },
  borderRadius: {
    s: "4px",
    m: "6px",
    l: "8px",
    xl: "12px",
    xxl: "24px",
    xxxl: "100px"
  },
  // TODO this needs its names cleaned up
  spacing: {
    xxl: "28px",
    xl: "24px",
    pxl: "22px",
    l: "20px",
    pl: "18px",
    p: "16px",
    ps: "14px",
    s: "10px",
    xs: "8px",
    xxs: "6px"
  }
};
const baseTheme = {
  ...baseStyles,
  overlay,
  typography: {
    // body1: {
    //   color: 'red',
    //   fontSize: '0.938rem', // 15px
    //   letterSpacing: 'normal',
    //   lineHeight: 1.5,
    //   fontWeight: 400,
    // },
    heading: {
      // TODO clean up all capitalised style names
      HXL: {
        fontSize: "56px",
        fontWeight: baseStyles.fontWeights.black,
        lineHeight: "normal",
        [baseStyles.breakpoints.down("sm")]: {
          fontSize: "40px"
        }
      },
      H1: {
        fontSize: "40px",
        fontWeight: baseStyles.fontWeights.bold,
        lineHeight: "normal",
        [baseStyles.breakpoints.down("sm")]: {
          fontSize: "32px"
        }
      },
      H2: {
        fontSize: "32px",
        fontWeight: baseStyles.fontWeights.bold,
        lineHeight: "normal",
        [baseStyles.breakpoints.down("sm")]: {
          fontSize: "28px"
        }
      },
      H3: {
        fontWeight: baseStyles.fontWeights.medium,
        fontSize: "24px"
      },
      H4: {
        fontWeight: baseStyles.fontWeights.bold,
        fontSize: "18px",
        lineHeight: "normal"
      },
      H5: {
        fontWeight: baseStyles.fontWeights.regular,
        fontSize: "14px",
        lineHeight: "normal"
      },
      SUBHEAD: {
        fontWeight: baseStyles.fontWeights.regular,
        fontSize: "12px",
        lineHeight: "normal"
      },
      smallHeading: {
        fontSize: baseStyles.fontSizes.l,
        fontWeight: baseStyles.fontWeights.bold
        // lineHeight: lineHeights.l,
      },
      sectionHeading: {
        fontSize: baseStyles.fontSizes.m2,
        fontWeight: baseStyles.fontWeights.medium,
        color: baseStyles.colors.jet
      }
    },
    body: {
      PXL: {
        fontSize: "22px",
        lineHeight: "26px",
        [baseStyles.breakpoints.down("xs")]: {
          fontSize: "18px",
          lineHeight: "26px"
        }
      },
      PL: {
        fontSize: "18px"
      },
      P: {
        fontSize: "16px",
        lineHeight: "16px"
      },
      PS: {
        fontSize: "14px",
        lineHeight: "14px"
      },
      PXS: {
        // NOTE: I added this one for the existing tiny text
        fontSize: "12px"
      },
      bodyText2: {
        fontSize: baseStyles.fontSizes.m2,
        fontWeight: baseStyles.fontWeights.regular,
        lineHeight: lineHeights.xl
      },
      // body styles below are all probably deprecated
      bodyText: {
        fontSize: baseStyles.fontSizes.m,
        fontWeight: baseStyles.fontWeights.regular,
        lineHeight: lineHeights.l
      },
      textMedium: {
        fontSize: baseStyles.fontSizes.l,
        fontWeight: baseStyles.fontWeights.medium,
        lineHeight: lineHeights.xl
      },
      heading: {
        fontSize: baseStyles.fontSizes.xl2,
        fontWeight: baseStyles.fontWeights.bold,
        lineHeight: lineHeights.xxl
      },
      headingLarge: {
        fontSize: baseStyles.fontSizes["3xl"],
        fontWeight: baseStyles.fontWeights.black,
        lineHeight: lineHeights["3xl"]
      },
      subheading: {
        fontSize: baseStyles.fontSizes.l,
        fontWeight: baseStyles.fontWeights.bold,
        lineHeight: lineHeights.l2
      },
      small: {
        fontWeight: baseStyles.fontWeights.regular,
        fontSize: baseStyles.fontSizes.s,
        lineHeight: lineHeights.xl,
        color: baseStyles.colors.charcoal,
        verticalAlign: "baseline"
      },
      smallBold: {
        fontWeight: baseStyles.fontWeights.bold,
        fontSize: baseStyles.fontSizes.s,
        lineHeight: lineHeights.xl
      },
      labelText: {
        fontSize: baseStyles.fontSizes.xs,
        fontWeight: baseStyles.fontWeights.regular,
        textTransform: "uppercase",
        letterSpacing: "0.13em",
        width: "fit-content"
      },
      textLarge: {
        fontSize: baseStyles.fontSizes.l,
        fontWeight: baseStyles.fontWeights.regular,
        // lineHeight: lineHeights.L2,
        lineHeight: "1.75"
      },
      textExtraLarge: {
        fontSize: baseStyles.fontSizes.xl2,
        fontWeight: baseStyles.fontWeights.regular,
        lineHeight: lineHeights.xxl
      },
      textModalHeading: {
        fontSize: baseStyles.fontSizes.xxl2,
        fontWeight: baseStyles.fontWeights.black,
        lineHeight: lineHeights.xxl
      },
      textPageHeading: {
        fontSize: baseStyles.fontSizes["4xl"],
        fontWeight: baseStyles.fontWeights.black,
        lineHeight: lineHeights["4xl"]
      }
    },
    guestBookHeading: {
      fontWeight: baseStyles.fontWeights.black,
      fontSize: baseStyles.fontSizes.l,
      lineHeight: "auto"
    },
    buttonText: {
      fontWeight: baseStyles.fontWeights.medium,
      fontSize: "15px",
      lineHeight: "auto"
    }
    // body1: {
    //   fontFamily: "Gordita, 'Open Sans', 'Helvetica', 'sans-serif' !important",
    //   // fontSize: '22px',
    // },
  },
  utilities: {
    noPrint: {
      "@media print": {
        display: "none",
        height: 0,
        width: 0,
        overflow: "hidden"
      }
    }
  },
  // Component-specific theming, that can be passed into ec-component-library components
  components: {
    floorplan: {
      sidebarWidth: 315
      // must be a number, not a string TODO this value is different in multiple places :|
    },
    timeline: {
      sidebarWidth: 150
      // used for some magic css calculations for floating labels
    },
    scrollbarWide: {
      overflowY: overlay,
      "&::WebkitScrollbar": {
        paddingLeft: "1px",
        width: "100px",
        borderRadius: "100px"
      },
      "&::WebkitScrollbarTrackPiece": {
        background: baseStyles.colors.yetAnotherGray9,
        borderRadius: "100px"
      },
      "&::WebkitScrollbarThumb": {
        "&:hover": {
          background: baseStyles.colors.charcoal
        },
        background: baseStyles.colors.yetAnotherGray10,
        borderRadius: "100px"
      },
      "&::WebkitScrollbarButton:end:increment": {
        display: "block",
        background: "transparent"
      }
    },
    scrollbar: {
      overflowY: overlay,
      "&::WebkitScrollbar": {
        paddingLeft: "1px",
        width: "6px",
        borderRadius: "100px"
      },
      "&::WebkitScrollbarTrackPiece": {
        background: baseStyles.colors.yetAnotherGray9,
        borderRadius: "100px"
      },
      "&::WebkitScrollbarThumb": {
        "&:hover": {
          background: baseStyles.colors.charcoal
        },
        background: baseStyles.colors.yetAnotherGray10,
        borderRadius: "100px"
      },
      "&::WebkitScrollbarButton:end:increment": {
        display: "block",
        background: "transparent"
      }
    }
    // MuiPaper: {
    //   styleOverrides: { root: { backgroundImage: 'unset' } },
    // },
  },
  // TODO overrides might not work on mui from jss. Need to test
  overrides: {
    MuiTooltip: {
      styleOverrides: {
        root: {
          tooltip: {
            fontSize: ".875em"
          }
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          button: {
            "&.Mui-selected": {
              backgroundColor: "#F5F2ED"
            }
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#313131"
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused fieldset": {
            borderColor: "#313131 !important"
          }
        }
      }
    }
  }
};
const fontFamily$2 = "Gordita, 'Helvetica', 'sans-serif'";
const FONT_SIZES = {
  // New styles for 2023
  DEFAULT: "15px",
  H1_NEW: "32px",
  H2_NEW: "28px",
  // Old styles that need refactoring
  // TODO should just be able to replace these in the theme
  HXL: "56px",
  H1: "40px",
  H2: "32px",
  H3: "24px",
  H4: "18px",
  H5: "14px",
  SUBHEAD: "14px",
  // Everything below this is old and should be replaced with new names
  XS: "12px",
  S: "14px",
  M2: "12px",
  M: "16px",
  L: "18px",
  XL: "20px",
  XL2: "22px",
  XXL: "24px",
  XXL2: "28px",
  "3XL": "32px",
  "4XL": "40px"
};
const FONT_WEIGHTS = {
  REGULAR: 400,
  MEDIUM: 500,
  BOLD: 700,
  BLACK: 900
};
const EatClubTheme = {
  colors: {
    brandPrimary: "#E54439",
    submitButton: "#E54439"
  },
  typography: {
    // New styles, 2023
    default: {
      fontSize: FONT_SIZES.DEFAULT,
      fontWeight: FONT_WEIGHTS.REGULAR
    },
    h2: {
      fontSize: FONT_SIZES.H2_NEW,
      fontWeight: FONT_WEIGHTS.BLACK,
      lineHeight: "normal"
    },
    paragraph: {
      fontSize: FONT_SIZES.DEFAULT,
      fontWeight: FONT_WEIGHTS.REGULAR,
      lineHeight: "1.7"
    },
    paragraphLarge: {
      fontSize: FONT_SIZES.L,
      fontWeight: FONT_WEIGHTS.REGULAR,
      lineHeight: "1.7"
    }
  }
};
const fontFamily$1 = "Inter, 'Helvetica', 'sans-serif'";
const fontWeights = {
  regular: 400,
  medium: 500,
  bold: 700,
  black: 900
};
const obeeColors = {
  brandPrimary: "#00AA81",
  obeeGreen: "#78BEA1",
  // shades of gray
  greenBlack: "#15221C",
  jet: "#1A1919",
  charcoal: "#313131",
  smoke: "#6E6E6D",
  nimbus: "#AEAEAE",
  shark: "#DCDCDB",
  cloud: "#F0F0F0",
  lightShade: "#F5F5F5",
  grayGreen: "#E0E3DE",
  // Secondary colours
  sourApple: "#C8F2A8",
  lemonDrop: "#F1ED89",
  grapeSoda: "#C7C1E3",
  cloudNine: "#AFC7EC",
  // Backgrounds and accents
  dreamySage: "#D8DDD3",
  paleMint: "#F1F3F1",
  calmingFog: "#F7F8F7",
  // Calendar styles
  calendarStats1: "#E9F4FA",
  calendarStats2: "#E5F2EC",
  calendarStats3: "#F1F7CC",
  calendarStats4: "#EFEEFD",
  calendarStats5: "#E8EBDE",
  calendarStatsBackground1: "#AED7EE",
  calendarStatsBackground2: "#8CC9B0",
  calendarStatsBackground3: "#DFE870",
  calendarStatsBackground4: "#C6C2F7",
  calendarStatsBackground5: "#D4DAC1",
  // Daily notes
  dailyNoteCategory1: "#C1F191",
  dailyNoteCategory2: "#C6C2F7",
  dailyNoteCategory3: "#7B72E8",
  dailyNoteCategory4: "#75CFAA",
  dailyNoteCategory5: "#A2DEFB",
  dailyNoteCategoryOther: "#e9e9e9",
  // Others with no definition
  mint: "#E6EBE6",
  mintDark: "#DCE0DC",
  // Outline on select toggle
  mintBackground: "#DDE2DD",
  // Background on tabs
  headerOutline: "#C3C3C3",
  // Outline on header buttons
  multiTableOutline: "#BCBCBC",
  multiTableFill: "#F0F2F0",
  availableTableBackground: "#FBFAE5",
  availableTableText: "#867F13",
  availableTableOutline: "#DBCF1E",
  arriveBookingHighlight: "#346550",
  mutedObeeGreen: "#C9E5D9"
};
const ObeeTheme = {
  colors: {
    brandPrimary: obeeColors.brandPrimary,
    submitButton: obeeColors.greenBlack,
    linen: obeeColors.paleMint,
    // To replace header colour TODO have specific name to not override linen
    lightShade: obeeColors.mint,
    // For select toggle
    lightButtonHover: obeeColors.lightShade,
    // For select toggle hover
    alabaster: obeeColors.mint,
    // For select toggle TODO  have specific name
    linenDark: obeeColors.mintDark,
    // For select toggle (hovered) TODO have specific name
    buttonText: obeeColors.greenBlack,
    // Buttons with coloured background. e.g. select toggle
    labelText: obeeColors.greenBlack,
    // Labels that are normally charcoal. e.g. on reservation card
    // TODO dune needs replacing in quick actions menu
    sidebarBackground: obeeColors.paleMint,
    sidebarItemHovered: appColors.white,
    pageBackground: obeeColors.paleMint,
    // In top row above floorplan
    canvasBackground: appColors.lightCloud,
    // view floorplan canvas
    canvasBorder: appColors.shark,
    // view floorplan canvas border
    headerBorder: obeeColors.paleMint,
    // Bottom border of header
    menuHighlightBackground: appColors.lightCloud,
    // Bottom border of header
    timelineEmptyRow: obeeColors.calmingFog,
    // Shown on rows for areas on timeline
    timelineClosed: obeeColors.calmingFog,
    // Shown on rows for areas on timeline
    tableMenuBackground: obeeColors.paleMint,
    floorplanElementColour: obeeColors.calmingFog,
    outdoorAreaLine: appColors.yetAnotherGray2,
    // Grid lines inside outdoor area
    outdoorAreaBackground: appColors.lightCloud,
    // background color of outdoor area
    modalHighlight: obeeColors.paleMint,
    // highlight in modal header
    warning: appColors.warningBlue,
    // Warning icon in comms modal
    notification: obeeColors.obeeGreen,
    // Used on notification bell
    // status pills
    bookedStatusText: obeeColors.greenBlack,
    bookedStatusOutline: obeeColors.greenBlack,
    bookedStatusIconOutline: obeeColors.paleMint,
    bookedStatusBackground: obeeColors.paleMint,
    confirmedStatusText: obeeColors.greenBlack,
    confirmedStatusOutline: obeeColors.greenBlack,
    confirmedStatusBackground: obeeColors.paleMint,
    arrivedStatusText: obeeColors.greenBlack,
    arrivedStatusOutline: obeeColors.obeeGreen,
    arrivedStatusBackground: obeeColors.obeeGreen,
    finishedStatusText: appColors.olive5,
    finishedStatusRunSheetText: appColors.nimbus,
    finishedStatusOutline: appColors.shark,
    // finishedStatusBackground: appColors.finishedGreen,
    finishedStatusBackground: obeeColors.greenBlack,
    noShowStatusText: obeeColors.greenBlack,
    noShowStatusOutline: obeeColors.sourApple,
    noShowStatusBackground: obeeColors.sourApple,
    cancelledStatusText: obeeColors.greenBlack,
    cancelledStatusOutline: appColors.shark,
    cancelledStatusBackground: appColors.shark,
    waitingStatusText: obeeColors.greenBlack,
    waitingStatusOutline: obeeColors.cloudNine,
    waitingStatusBackground: obeeColors.cloudNine,
    unconfirmedStatusText: obeeColors.greenBlack,
    unconfirmedStatusOutline: appColors.cancelledPink,
    unconfirmedStatusBackground: appColors.cancelledPink,
    // Floorplan tables
    defaultTableOutline: obeeColors.greenBlack,
    defaultTableFill: obeeColors.calmingFog,
    bookedTableFill: obeeColors.calmingFog,
    bookedTableOutline: obeeColors.greenBlack,
    confirmedTableFill: obeeColors.calmingFog,
    confirmedTableOutline: obeeColors.greenBlack,
    availableTableFill: obeeColors.availableTableBackground,
    availableTableOutline: obeeColors.availableTableOutline,
    unavailableTableFill: obeeColors.shark,
    unavailableTableOutline: obeeColors.smoke,
    seatedTableFill: obeeColors.calmingFog,
    seatedTableOutline: obeeColors.obeeGreen,
    finishedTableFill: obeeColors.calmingFog,
    finishedTableOutline: obeeColors.greenBlack,
    blockedTableFill: appColors.shark,
    blockedTableOutline: appColors.smoke,
    fullyBookedTableFill: obeeColors.shark,
    fullyBookedTableOutline: appColors.smoke,
    lateTableFill: obeeColors.calmingFog,
    lateTableOutline: obeeColors.greenBlack,
    noShowTableFill: obeeColors.calmingFog,
    noShowTableOutline: obeeColors.greenBlack,
    cancelledTableFill: obeeColors.calmingFog,
    cancelledTableOutline: obeeColors.greenBlack,
    multiTableFill: obeeColors.multiTableFill,
    multiTableOutline: obeeColors.multiTableOutline,
    availableLabelBackground: obeeColors.availableTableBackground,
    availableLabelText: obeeColors.availableTableText,
    loadingShimmer: obeeColors.mint,
    // Used on skeletons
    // Timeline blocks
    // booked
    bookedBookingBarOutline: obeeColors.greenBlack,
    bookedBookingBarFill: obeeColors.calmingFog,
    bookedBookingBarHighlight: obeeColors.greenBlack,
    bookedBookingBarDetails: appColors.smoke,
    bookedBookingBarIconOutline: obeeColors.shark,
    bookedBookingBarJointPill: appColors.bookedBookingPill,
    bookedBookingBarJointText: obeeColors.greenBlack,
    // confirmed
    confirmedBookingBarOutline: obeeColors.greenBlack,
    confirmedBookingBarFill: obeeColors.calmingFog,
    confirmedBookingBarHighlight: obeeColors.greenBlack,
    confirmedBookingBarDetails: obeeColors.smoke,
    confirmedBookingBarIconOutline: obeeColors.shark,
    confirmedBookingBarJointPill: appColors.bookedBookingPill,
    confirmedBookingBarJointText: obeeColors.greenBlack,
    // arrived
    arrivedBookingBarOutline: obeeColors.obeeGreen,
    arrivedBookingBarFill: obeeColors.obeeGreen,
    arrivedBookingBarHighlight: obeeColors.arriveBookingHighlight,
    arrivedBookingBarDetails: obeeColors.greenBlack,
    arrivedBookingBarIconOutline: obeeColors.greenBlack,
    arrivedBookingBarJointPill: obeeColors.arriveBookingHighlight,
    arrivedBookingBarJointText: appColors.olive5,
    // finished
    finishedBookingBarOutline: obeeColors.greenBlack,
    finishedBookingBarFill: obeeColors.greenBlack,
    finishedBookingBarHighlight: appColors.olive2,
    finishedBookingBarDetails: appColors.olive5,
    finishedBookingBarIconOutline: appColors.olive5,
    finishedBookingBarJointPill: appColors.olive2,
    finishedBookingBarJointText: appColors.olive5,
    // headerButtonOutline: obeeColors.headerOutline, // Used on single/multi buttons
    headerButtonOutline: obeeColors.mintDark,
    // Used on the outline for the header buttons
    headerIcon: obeeColors.headerOutline,
    // Used on single/multi buttons
    // Guestbook
    // notificationBackgroundGray: appColors.white, // Why was this changed?
    activeGuestRowBackground: appColors.white,
    activeGuestRowBorder: obeeColors.greenBlack,
    dividerLineGray: obeeColors.grayGreen,
    summaryPanelBackground: appColors.white,
    // Voucher
    activeVoucher: obeeColors.obeeGreen,
    // Tabs
    tabUnderline: obeeColors.mintDark,
    // Text fields
    textAreaBackground: appColors.lightShade,
    // f9f9f9
    // Toggle
    toggleBackground: obeeColors.obeeGreen,
    // When hovering over a large touchable section
    touchSectionHover: appColors.lightShade,
    // Calendar
    calendarStats1: obeeColors.calendarStats1,
    calendarStats2: obeeColors.calendarStats2,
    calendarStats3: obeeColors.calendarStats3,
    calendarStats4: obeeColors.calendarStats4,
    calendarStats5: obeeColors.calendarStats5,
    calendarStatsBackground1: obeeColors.calendarStatsBackground1,
    calendarStatsBackground2: obeeColors.calendarStatsBackground2,
    calendarStatsBackground3: obeeColors.calendarStatsBackground3,
    calendarStatsBackground4: obeeColors.calendarStatsBackground4,
    calendarStatsBackground5: obeeColors.calendarStatsBackground5,
    totalUnderlineColor: obeeColors.paleMint,
    // Daily notes
    dailyNoteCategory1: obeeColors.dailyNoteCategory1,
    dailyNoteCategory2: obeeColors.dailyNoteCategory2,
    dailyNoteCategory3: obeeColors.dailyNoteCategory3,
    dailyNoteCategory4: obeeColors.dailyNoteCategory4,
    dailyNoteCategory5: obeeColors.dailyNoteCategory5,
    dailyNoteCategoryOther: obeeColors.dailyNoteCategoryOther
  },
  components: {
    // sort of an mui style component styling. Passed in to actual component's styles
    ReservationStatusPill: {
      container: {
        borderRadius: "7px",
        fontWeight: fontWeights.medium
      }
    },
    SearchBar: {
      input: {
        borderRadius: "12px"
      }
    },
    // Used on save button
    Button: {
      button: {
        borderRadius: "12px"
      }
    }
  },
  palette: {
    primary: {
      main: obeeColors.brandPrimary,
      dark: "#235c4e"
    },
    error: {
      main: obeeColors.brandPrimary,
      dark: "#235c4e"
    }
  }
};
const obee = isObee();
const companyTheme = obee ? ObeeTheme : EatClubTheme;
const fontFamily = obee ? fontFamily$1 : fontFamily$2;
const theme = mergeDeep(baseTheme, companyTheme);
const theme$1 = theme;
const obeeGuestPropTypes = PropTypes.shape({
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  mobile: PropTypes.string,
  landline: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  notes: PropTypes.string,
  allergies: PropTypes.string,
  birthday: PropTypes.string,
  vip: PropTypes.bool,
  jobCompany: PropTypes.string,
  interests: PropTypes.string,
  secretary: PropTypes.string,
  address: PropTypes.string,
  postcode: PropTypes.string,
  website: PropTypes.string,
  blog: PropTypes.string,
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  instagram: PropTypes.string,
  pinterest: PropTypes.string,
  linkedIn: PropTypes.string,
  blacklisted: PropTypes.bool,
  favouriteMeals: PropTypes.string,
  favouriteDrinks: PropTypes.string,
  preferredTableArea: PropTypes.string,
  marketingPreferences: PropTypes.arrayOf(PropTypes.string)
});
const obeeGuestsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(obeeGuestPropTypes),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const convertDataForAPI = (guest) => {
  var _a, _b2;
  const data = { ...guest };
  if ("birthday" in guest) {
    data.birthday = convertDateFormat(guest == null ? void 0 : guest.birthday, "DD/MM/YYYY", "YYYY-MM-DD");
  }
  if ("marketingPreferences" in guest) {
    data.smsPromo = (_a = guest == null ? void 0 : guest.marketingPreferences) == null ? void 0 : _a.includes("smsPromo");
    data.emailPromo = (_b2 = guest == null ? void 0 : guest.marketingPreferences) == null ? void 0 : _b2.includes("emailPromo");
  }
  return data;
};
const convertGuestApiData = (guest) => {
  const firstName = (guest == null ? void 0 : guest.first_name) || (guest == null ? void 0 : guest.firstName);
  const lastName = (guest == null ? void 0 : guest.last_name) || (guest == null ? void 0 : guest.lastName);
  const getMarketingPreferences = () => {
    const preferences = [];
    if (guest == null ? void 0 : guest.smsPromo) {
      preferences.push("smsPromo");
    }
    if (guest == null ? void 0 : guest.emailPromo) {
      preferences.push("emailPromo");
    }
    return preferences;
  };
  const data = {
    ...guest,
    firstName,
    lastName,
    birthday: convertDateFormat(guest == null ? void 0 : guest.birthday, "YYYY-MM-DD", "DD/MM/YYYY"),
    marketingPreferences: getMarketingPreferences()
  };
  return data;
};
const getAllData$1 = (guests) => guests.map((guest) => convertGuestApiData(guest));
const getVIPstatus = (booking) => {
  var _a, _b2;
  return ((_b2 = (_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a.at(0)) == null ? void 0 : _b2.vip) ?? false;
};
const getBlacklistStatus = (booking) => {
  var _a, _b2;
  return ((_b2 = (_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a.at(0)) == null ? void 0 : _b2.blacklisted) ?? false;
};
const obeeBookingPropTypesObject = {
  id: PropTypes.number.isRequired,
  firstName: PropTypes.string,
  // TODO add this to backend
  lastName: PropTypes.string,
  // TODO add this to backend
  email: PropTypes.string,
  // TODO add this to backend
  phone: PropTypes.string,
  // TODO add this to backend
  date: PropTypes.string,
  tableId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tableNumber: PropTypes.string,
  // TODO this or tableId?
  status: PropTypes.string.isRequired,
  // TODO add this to backend
  size: PropTypes.number.isRequired,
  startTime: PropTypes.number.isRequired,
  // TODO add this to backend
  endTime: PropTypes.number.isRequired,
  // TODO add this to backend
  isBirthday: PropTypes.bool,
  // TODO add this to backend
  isAnniversary: PropTypes.bool,
  // TODO add this to backend
  isCelebration: PropTypes.bool,
  // TODO add this to backend
  hasDietaries: PropTypes.bool,
  // TODO add this to backend
  hasFavourites: PropTypes.bool,
  // TODO add this to backend
  createdAt: PropTypes.string,
  areaId: PropTypes.number,
  time: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  code: PropTypes.string,
  // Some sort of unique id generated by obee
  restaurantComments: PropTypes.string,
  // restaurant comments, such as table
  customerComments: PropTypes.string,
  // customer comments, such as allergies
  source: PropTypes.string.isRequired,
  // Where the booking came from
  duration: PropTypes.number,
  labels: PropTypes.string,
  kids: PropTypes.number,
  highchairs: PropTypes.number,
  vaccinated: PropTypes.bool,
  staff: PropTypes.string,
  // TODO what is this?
  history: PropTypes.string,
  // TODO what is this?
  guests: PropTypes.arrayOf(obeeGuestPropTypes),
  isJoin: PropTypes.bool,
  // Whether this booking is on a joined table
  tableNumbers: PropTypes.arrayOf(PropTypes.string),
  // List of table numbers for this booking
  ccNoShowFee: PropTypes.number,
  ccNoShowChargeType: PropTypes.string,
  ccNoShowChargeStatus: PropTypes.string,
  ccNoShowChargeTime: PropTypes.string,
  ccNoShowPaymentIntentId: PropTypes.string,
  waitlistSMS: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dateTimeSent: PropTypes.string,
    responseMessage: PropTypes.string
  }),
  commsHistory: PropTypes.string,
  emailHistory: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.oneOf([
        "confirmation",
        "waiting_list",
        "reminder",
        "cancellation",
        "followup"
      ]),
      dateTimeSent: PropTypes.string
    })
  ),
  smsHistory: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      message: PropTypes.string,
      dateTimeSent: PropTypes.string,
      response: PropTypes.string
    })
  ),
  lastEditedByGuest: PropTypes.string
};
const obeeBookingPropTypes = PropTypes.shape(obeeBookingPropTypesObject);
const runSheetBookingPropTypes = PropTypes.shape({
  ...obeeBookingPropTypesObject,
  areaName: PropTypes.string,
  fullComments: PropTypes.string
});
PropTypes.shape({
  data: PropTypes.arrayOf(runSheetBookingPropTypes),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const obeeBookingsPropTypes = PropTypes.shape({
  data: PropTypes.oneOfType([
    PropTypes.shape({}),
    // BookingsForUser is keyed by user ID
    PropTypes.arrayOf(obeeBookingPropTypes)
  ]),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const obeeChargeNoShowPropTypes = PropTypes.shape({
  data: PropTypes.shape({}),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const STATUS_TYPES = {
  BOOKED: "booked",
  CONFIRMED: "confirmed",
  ARRIVED: "arrived",
  FINISHED: "finished",
  NO_SHOW: "noshow",
  CANCELLED: "cancelled",
  WAITING: "waitlist",
  UNCONFIRMED: "unconfirmed"
  // A waitlist booking that has been cancelled
};
const DIETARY_KEYWORDS = [
  "allergy",
  "allergic",
  "allergies",
  "dietary",
  "gluten",
  "wheat",
  "vegan",
  "vegetarian",
  "vego",
  "veggo",
  "veg",
  "lactose",
  "pregnant",
  "requirement",
  "sensitivity",
  "sensitive",
  "pesca",
  "pesco",
  "pesci",
  "seafood",
  "shellfish",
  "fish",
  " nuts",
  // I used a space here to hopefully prevent false flags from other words like "donuts"
  "peanuts",
  "eggs",
  "soy"
];
const statuses = [
  {
    id: STATUS_TYPES.BOOKED,
    label: "Booked",
    backgroundColor: theme$1.colors.bookedStatusBackground,
    outline: theme$1.colors.bookedStatusOutline,
    iconOutline: theme$1.colors.bookedStatusIconOutline,
    color: theme$1.colors.bookedStatusText,
    tableOutline: theme$1.colors.bookedTableOutline,
    tableFill: theme$1.colors.bookedTableFill,
    bookingBarOutline: theme$1.colors.bookedBookingBarOutline,
    bookingBarFill: theme$1.colors.bookedBookingBarFill,
    bookingBarHighlight: theme$1.colors.bookedBookingBarHighlight,
    bookingBarDetails: theme$1.colors.bookedBookingBarDetails,
    bookingBarIconOutline: theme$1.colors.bookedBookingBarIconOutline,
    bookingBarJointPill: theme$1.colors.bookedBookingBarJointPill,
    bookingBarJointText: theme$1.colors.bookedBookingBarJointText,
    nextStatus: STATUS_TYPES.ARRIVED,
    nextStatusLabel: "Seat"
  },
  {
    id: STATUS_TYPES.CONFIRMED,
    label: "Confirmed",
    backgroundColor: theme$1.colors.confirmedStatusBackground,
    outline: theme$1.colors.confirmedStatusOutline,
    color: theme$1.colors.confirmedStatusText,
    tableOutline: theme$1.colors.confirmedTableOutline,
    tableFill: theme$1.colors.confirmedTableFill,
    bookingBarOutline: theme$1.colors.confirmedBookingBarOutline,
    bookingBarFill: theme$1.colors.confirmedBookingBarFill,
    bookingBarHighlight: theme$1.colors.confirmedBookingBarHighlight,
    bookingBarDetails: theme$1.colors.confirmedBookingBarDetails,
    bookingBarIconOutline: theme$1.colors.confirmedBookingBarIconOutline,
    bookingBarJointPill: theme$1.colors.confirmedBookingBarJointPill,
    bookingBarJointText: theme$1.colors.confirmedBookingBarJointText,
    nextStatus: STATUS_TYPES.ARRIVED,
    nextStatusLabel: "Seat"
  },
  {
    id: STATUS_TYPES.ARRIVED,
    label: "Seated",
    backgroundColor: theme$1.colors.arrivedStatusBackground,
    outline: theme$1.colors.arrivedStatusOutline,
    color: theme$1.colors.arrivedStatusText,
    tableOutline: theme$1.colors.seatedTableOutline,
    tableFill: theme$1.colors.seatedTableFill,
    bookingBarOutline: theme$1.colors.arrivedBookingBarOutline,
    bookingBarFill: theme$1.colors.arrivedBookingBarFill,
    bookingBarHighlight: theme$1.colors.arrivedBookingBarHighlight,
    bookingBarDetails: theme$1.colors.arrivedBookingBarDetails,
    bookingBarIconOutline: theme$1.colors.arrivedBookingBarIconOutline,
    bookingBarJointPill: theme$1.colors.arrivedBookingBarJointPill,
    bookingBarJointText: theme$1.colors.arrivedBookingBarJointText,
    nextStatus: STATUS_TYPES.FINISHED,
    nextStatusLabel: "Finish"
  },
  {
    id: STATUS_TYPES.FINISHED,
    label: "Finished",
    backgroundColor: theme$1.colors.finishedStatusBackground,
    outline: theme$1.colors.finishedStatusOutline,
    color: theme$1.colors.finishedStatusText,
    runsheetText: theme$1.colors.finishedStatusRunSheetText,
    runsheetTextDecoration: "line-through",
    tableOutline: theme$1.colors.finishedTableOutline,
    tableFill: theme$1.colors.finishedTableFill,
    bookingBarOutline: theme$1.colors.finishedBookingBarOutline,
    bookingBarFill: theme$1.colors.finishedBookingBarFill,
    bookingBarHighlight: theme$1.colors.finishedBookingBarHighlight,
    bookingBarDetails: theme$1.colors.finishedBookingBarDetails,
    bookingBarIconOutline: theme$1.colors.finishedBookingBarIconOutline,
    bookingBarJointPill: theme$1.colors.finishedBookingBarJointPill,
    bookingBarJointText: theme$1.colors.finishedBookingBarJointText
  },
  {
    id: STATUS_TYPES.NO_SHOW,
    label: "No show",
    backgroundColor: theme$1.colors.noShowStatusBackground,
    outline: theme$1.colors.noShowStatusOutline,
    color: theme$1.colors.noShowStatusText,
    tableOutline: theme$1.colors.noShowTableOutline,
    tableFill: theme$1.colors.noShowTableFill
  },
  {
    id: STATUS_TYPES.CANCELLED,
    label: "Cancelled",
    backgroundColor: theme$1.colors.cancelledStatusBackground,
    outline: theme$1.colors.cancelledStatusOutline,
    color: theme$1.colors.cancelledStatusText,
    tableOutline: theme$1.colors.cancelledTableOutline,
    tableFill: theme$1.colors.cancelledTableFill
  },
  {
    id: STATUS_TYPES.WAITING,
    label: "Waitlist",
    backgroundColor: theme$1.colors.blue,
    outline: theme$1.colors.blue,
    color: theme$1.colors.charcoal,
    tableOutline: theme$1.colors.charcoal,
    // Note: Waitlist bookings don't show on the floorplan
    tableFill: theme$1.colors.linen
  },
  {
    id: STATUS_TYPES.UNCONFIRMED,
    label: "Unconfirmed",
    backgroundColor: theme$1.colors.cancelledPink,
    outline: theme$1.colors.cancelledPink,
    color: theme$1.colors.charcoal,
    tableOutline: theme$1.colors.smoke,
    tableFill: theme$1.colors.shark
  }
];
const getStatuses = () => statuses;
const NO_STATUS = {
  label: "No status",
  backgroundColor: theme$1.colors.linen,
  outline: theme$1.colors.charcoal,
  color: theme$1.colors.charcoal,
  tableOutline: theme$1.colors.charcoal,
  tableFill: theme$1.colors.linen,
  bookingBarOutline: theme$1.colors.charcoal,
  bookingBarFill: theme$1.colors.linen,
  bookingBarHighlight: theme$1.colors.charcoal,
  bookingBarDetails: theme$1.colors.smoke,
  bookingBarIconOutline: theme$1.colors.shark
};
const getStatus = (obeeBooking) => {
  if (!obeeBooking) {
    return null;
  }
  return findObjectByProperty(
    getStatuses(),
    (obeeBooking == null ? void 0 : obeeBooking.status) || STATUS_TYPES.BOOKED,
    "id",
    NO_STATUS
  );
};
const getStatusDetails = (status) => (
  // Fallback to "No status" if the status id does not exist in getStatuses()
  findObjectByProperty(getStatuses(), status, "id", NO_STATUS)
);
const getStatusLabel = (obeeBooking) => {
  var _a;
  return (_a = getStatus(obeeBooking)) == null ? void 0 : _a.label;
};
const getHiddenTimelineStatuses = () => [
  STATUS_TYPES.NO_SHOW,
  STATUS_TYPES.CANCELLED,
  STATUS_TYPES.WAITING
];
const getSeatableStatuses = () => {
  return [STATUS_TYPES.BOOKED, STATUS_TYPES.CONFIRMED, STATUS_TYPES.ARRIVED];
};
const getVisitedStatuses = () => {
  return [STATUS_TYPES.ARRIVED, STATUS_TYPES.FINISHED];
};
const isLate = (booking) => {
  if (isEmpty(booking)) {
    return false;
  }
  const currentTime = moment$2();
  const currentTimeAsInt = formatIntFromTime(currentTime);
  const latenessAmount = 15;
  return (booking == null ? void 0 : booking.startTime) + latenessAmount < currentTimeAsInt && (booking.status === STATUS_TYPES.BOOKED || booking.status === STATUS_TYPES.CONFIRMED);
};
const showInFloorplan = (booking) => {
  return (booking == null ? void 0 : booking.status) !== STATUS_TYPES.FINISHED && (booking == null ? void 0 : booking.status) !== STATUS_TYPES.CANCELLED && (booking == null ? void 0 : booking.status) !== STATUS_TYPES.NO_SHOW && (booking == null ? void 0 : booking.status) !== STATUS_TYPES.WAITING;
};
const isBooked = (booking) => {
  return (booking == null ? void 0 : booking.status) === STATUS_TYPES.BOOKED || (booking == null ? void 0 : booking.status) === STATUS_TYPES.CONFIRMED;
};
const isFutureDate = (booking) => {
  return moment$2(booking == null ? void 0 : booking.date).isAfter(moment$2(), "day");
};
const resolveSource = (sourceType) => {
  switch (sourceType) {
    case "walkin":
      return "Walk-In";
    case "google":
      return "Google";
    case "facebook":
      return "Facebook";
    default:
      return capitaliseFirstLetter(sourceType);
  }
};
const SECONDARYTAGS = ["Promo", "Options", "Payment history", "Booked on", "Taken by", "Voucher"];
const getSecondaryTags = () => {
  return SECONDARYTAGS;
};
const getShowSecondaryTag = (booking, tag) => {
  var _a, _b2;
  switch (tag) {
    case "Promo":
      return (booking == null ? void 0 : booking.promoCode) ?? "";
    case "Options":
      return ((_a = booking == null ? void 0 : booking.guests[0]) == null ? void 0 : _a.options) ?? "";
    case "Payment history":
      if (!isVoid(booking == null ? void 0 : booking.payments)) {
        const payments = safeParse(booking.payments);
        const deposit = (_b2 = payments == null ? void 0 : payments.data) == null ? void 0 : _b2.find((payment) => (payment == null ? void 0 : payment.type) === "charges");
        return formatCurrency(deposit == null ? void 0 : deposit.amount_cents, true, "", true);
      }
      return "";
    case "Booked on":
      return formatTime(booking == null ? void 0 : booking.createdAt, "DD/MM/YY");
    case "Taken by":
      return (booking == null ? void 0 : booking.staff) ?? "";
    case "Voucher":
      return (booking == null ? void 0 : booking.voucher) ?? "";
    default:
      return "";
  }
};
const getFullComments = (booking) => {
  return [booking == null ? void 0 : booking.restaurantComments, booking == null ? void 0 : booking.customerComments].filter((item) => !isEmpty(item)).join(" | ");
};
const hasDietaries = (comments) => {
  return !isEmpty(comments) ? DIETARY_KEYWORDS.some((word) => comments.toLowerCase().includes(word)) : false;
};
const getData$i = (item) => {
  var _a, _b2;
  const tableNumbers = safeSplit(item == null ? void 0 : item.tableNumber).sort(sortAlphaNumeric);
  const waitlistSMSUnprocessed = safeParse(item == null ? void 0 : item.waitlistSMS);
  const waitlistSMSProperties = {
    dateTimeSent: waitlistSMSUnprocessed == null ? void 0 : waitlistSMSUnprocessed.date_time_sent,
    // TODO get backend to clean this up
    msg: waitlistSMSUnprocessed == null ? void 0 : waitlistSMSUnprocessed.msg,
    // TODO get backend to clean this up
    responseMessage: waitlistSMSUnprocessed == null ? void 0 : waitlistSMSUnprocessed.response_message
    // TODO get backend to clean this up
  };
  const commsHistory = safeParse(item == null ? void 0 : item.commsHistory);
  const comments = getFullComments(item).toLowerCase();
  const guestsData = ((_a = item == null ? void 0 : item.guests) == null ? void 0 : _a.data) || (item == null ? void 0 : item.guests) || [];
  const birthdayCheck = comments.includes("birthday") || comments.includes("bday") || guestsData.some((guest) => hasBirthdayCheck(item == null ? void 0 : item.date, guest == null ? void 0 : guest.birthday));
  const dietaryCheck = hasDietaries(comments) || guestsData.some((guest) => !isEmpty(guest == null ? void 0 : guest.allergies));
  const favouritesCheck = guestsData.some(
    (guest) => !isEmpty(guest == null ? void 0 : guest.favouriteMeals) || !isEmpty(guest == null ? void 0 : guest.favouriteDrinks)
  );
  const bookingData = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    status: "",
    ...item,
    isBirthday: birthdayCheck,
    isAnniversary: comments.includes("anniversary"),
    isCelebration: comments.includes("celebration"),
    hasDietaries: dietaryCheck,
    hasFavourites: favouritesCheck,
    highchairs: nullIfNegative(item == null ? void 0 : item.highchairs) || 0,
    kids: nullIfNegative(item == null ? void 0 : item.kids) || 0,
    duration: nullIfNegative(item == null ? void 0 : item.duration) || 60,
    // Fallback to 60 mins. Really this should always be set,
    startTime: item == null ? void 0 : item.time,
    name: (item == null ? void 0 : item.name) || "",
    // startTime: formatIntFromTime(moment(item?.time, 'hh:mm:ss')),
    momentStartTime: momentFromInt(item.time, item == null ? void 0 : item.date),
    formattedStartTime: formatTimeFromInt(item.time),
    isJoin: tableNumbers.length > 1,
    // IMPORTANT: We don't sort the actual table number since it's a unique identifier for the table. If the order of the numbers is different, Obee considers it a different table
    tableNumberDisplay: (_b2 = tableNumbers == null ? void 0 : tableNumbers.sort(sortAlphaNumeric)) == null ? void 0 : _b2.join(","),
    tableNumbers,
    sourceLabel: resolveSource(item.source),
    guests: getAllData$1(guestsData),
    // TODO each API returns guests slightly differently
    ccNoShowChargeDisplayNumber: (item == null ? void 0 : item.ccNoShowChargeDisplayNumber) ? `**** ${item == null ? void 0 : item.ccNoShowChargeDisplayNumber}` : null,
    waitlistSMS: waitlistSMSProperties,
    quotedMins: (item == null ? void 0 : item.quotedMins) > 0 ? item == null ? void 0 : item.quotedMins : null,
    // backend sends -1 as an indicator that its not set
    emailHistory: (commsHistory == null ? void 0 : commsHistory.emailHistory) ?? [],
    smsHistory: (commsHistory == null ? void 0 : commsHistory.smsHistory) ?? []
  };
  const newData = {
    ...bookingData,
    isLate: isLate(bookingData),
    endTime: bookingData.time + bookingData.duration
  };
  return newData;
};
const getObeeData = (item) => {
  const bookingData = {
    ...getData$i(item),
    noShowDetails: item == null ? void 0 : item.no_show_details,
    restaurantComments: (item == null ? void 0 : item.restaurant_comments) || "",
    customerComments: (item == null ? void 0 : item.customer_comments) || "",
    userId: item == null ? void 0 : item.user_id,
    timeArrived: item == null ? void 0 : item.time_arrived,
    timeFinished: item == null ? void 0 : item.time_finished
  };
  return bookingData;
};
const obeeUpdateCheckPropTypes = PropTypes.shape({
  data: PropTypes.shape({
    available: PropTypes.bool
  }),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const getBookingName = (booking) => (booking == null ? void 0 : booking.name) || "[Missing name]";
const getNoShowFee = (booking) => {
  if (!booking) {
    return null;
  }
  if (booking.ccNoShowChargeType === "guest") {
    return booking.ccNoShowFee * booking.size;
  }
  return booking.ccNoShowFee;
};
const extractSmsMessage = (booking, smsBody) => {
  var _a, _b2, _c2, _d2;
  const messageBody = (smsBody || "").replace("[fname]", (_b2 = (_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a[0]) == null ? void 0 : _b2.firstName).replace("[size]", booking == null ? void 0 : booking.size);
  const messageBodySplit = messageBody.split("[x]");
  return (_d2 = (_c2 = booking.waitlistSMS) == null ? void 0 : _c2.msg) == null ? void 0 : _d2.replace(messageBodySplit[0], "").replace(messageBodySplit[1], "");
};
const getWaitlistOverdueInMinutes = (booking) => {
  if (booking.status !== STATUS_TYPES.WAITING) {
    return 0;
  }
  if ((booking == null ? void 0 : booking.quotedMins) > 0) {
    return moment$2().diff(moment$2(booking.createdAt).add(booking.quotedMins, "m"), "m");
  }
  return 0;
};
const monthlyViewDayPropTypes = PropTypes.shape({
  day: PropTypes.string,
  date: PropTypes.string,
  note: PropTypes.string,
  past: PropTypes.bool,
  dateNo: PropTypes.string,
  // ?
  totalBookings: PropTypes.number,
  totalCovers: PropTypes.number,
  waitlistBookings: PropTypes.number,
  waitlistCovers: PropTypes.number,
  sessionGroups: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({})]),
  currentMonth: PropTypes.bool,
  // Whether this data is for the month that the venue is experiencing
  hasNotes: PropTypes.bool
  // Whether there is a note for this day
});
const monthlyViewPropTypes = PropTypes.shape({
  data: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({
      totals: PropTypes.shape({
        totalBookings: PropTypes.number,
        totalCovers: PropTypes.number,
        totalWaitlistBookings: PropTypes.number,
        totalWaitlistCovers: PropTypes.number
      }),
      monthlyViewData: PropTypes.arrayOf(monthlyViewDayPropTypes)
    })
  ]),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const getData$h = (item) => {
  const monthlyViewData = {
    ...item,
    day: item == null ? void 0 : item.day,
    date: item == null ? void 0 : item.date,
    note: item == null ? void 0 : item.note,
    past: item == null ? void 0 : item.past,
    dateNo: item == null ? void 0 : item.dateNo,
    totalBookings: (item == null ? void 0 : item.totalBookings) || 0,
    totalCovers: (item == null ? void 0 : item.totalCovers) || 0,
    waitlistBookings: (item == null ? void 0 : item.wlBookings) || 0,
    waitlistCovers: (item == null ? void 0 : item.wlCovers) || 0,
    sessionGroups: item == null ? void 0 : item.sessionGroups,
    currentMonth: item == null ? void 0 : item.currMonth,
    hasNotes: !isEmpty(item == null ? void 0 : item.note)
  };
  return monthlyViewData;
};
const getMonthlyData = (apiData) => {
  var _a, _b2, _c2, _d2, _e2;
  const monthlyData = safeParse(apiData, {});
  return {
    totals: {
      totalBookings: ((_a = monthlyData == null ? void 0 : monthlyData.totals) == null ? void 0 : _a.totalBookings) || 0,
      totalCovers: ((_b2 = monthlyData == null ? void 0 : monthlyData.totals) == null ? void 0 : _b2.totalCovers) || 0,
      totalWaitlistBookings: ((_c2 = monthlyData == null ? void 0 : monthlyData.totals) == null ? void 0 : _c2.totalWaitlistBookings) || 0,
      totalWaitlistCovers: ((_d2 = monthlyData == null ? void 0 : monthlyData.totals) == null ? void 0 : _d2.totalWaitlistCovers) || 0
    },
    monthlyViewData: (_e2 = monthlyData == null ? void 0 : monthlyData.monthlyViewData) == null ? void 0 : _e2.map((item) => getData$h(item))
  };
};
const calendarSessionColors = [
  theme$1.colors.calendarStats1,
  theme$1.colors.calendarStats2,
  theme$1.colors.calendarStats3,
  theme$1.colors.calendarStats4,
  theme$1.colors.calendarStats5
];
const calendarSessionBackgroundColors = [
  theme$1.colors.calendarStatsBackground1,
  theme$1.colors.calendarStatsBackground2,
  theme$1.colors.calendarStatsBackground3,
  theme$1.colors.calendarStatsBackground4,
  theme$1.colors.calendarStatsBackground5
];
const getSessionColorForIndex = (index = null) => {
  if (isVoid(index)) {
    return {
      backgroundColor: "white",
      numberBackgroundColor: "white",
      numberOutlineColor: "black"
    };
  }
  return {
    backgroundColor: calendarSessionColors[index % calendarSessionColors.length],
    numberBackgroundColor: calendarSessionBackgroundColors[index % calendarSessionBackgroundColors.length],
    numberOutlineColor: calendarSessionBackgroundColors[index % calendarSessionBackgroundColors.length]
  };
};
const sessionPropTypes = PropTypes.shape({
  id: PropTypes.number,
  areaId: PropTypes.number,
  label: PropTypes.string,
  startTime: PropTypes.number,
  endTime: PropTypes.number,
  isPublic: PropTypes.bool,
  day: PropTypes.string,
  date: PropTypes.string,
  sittingTimes: PropTypes.arrayOf(PropTypes.string)
});
const sessionsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(sessionPropTypes),
  apiData: PropTypes.arrayOf(sessionPropTypes),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const sessionInputKeys = () => [
  "areaId",
  "label",
  "startTime",
  "endTime",
  "isPublic",
  "days",
  "sittingTimes"
];
const sessionUpdateInputKeys = () => [
  "areaId",
  "label",
  "startTime",
  "endTime",
  "isPublic",
  "day",
  "date",
  "sittingTimes"
];
const globalSessionPropTypes = PropTypes.shape({
  objectId: PropTypes.string,
  label: PropTypes.string,
  startTime: PropTypes.number,
  endTime: PropTypes.number,
  isPublic: PropTypes.bool,
  day: PropTypes.string,
  date: PropTypes.string,
  sittingTimes: PropTypes.arrayOf(PropTypes.string)
});
const globalSessionsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(globalSessionPropTypes),
  apiData: PropTypes.arrayOf(globalSessionPropTypes),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const globalSessionInputKeys = () => [
  "label",
  "startTime",
  "endTime",
  "isPublic",
  "days",
  "dates",
  "sittingTimes"
];
const globalSessionUpdateInputKeys = () => [
  "label",
  "startTime",
  "endTime",
  "isPublic",
  "day",
  "date",
  "sittingTimes"
];
const eventSessionsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(globalSessionPropTypes),
  apiData: PropTypes.arrayOf(globalSessionPropTypes),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const eventSessionInputKeys = () => [
  "date",
  "label",
  "startTime",
  "endTime",
  "isPublic",
  "sittingTimes"
];
const eventSessionUpdateInputKeys = () => [
  "date",
  "label",
  "startTime",
  "endTime",
  "isPublic",
  "sittingTimes"
];
const getData$g = (session) => {
  var _a;
  return {
    ...session,
    label: (session == null ? void 0 : session.label) || "All day",
    sittingTimes: (_a = safeParse(session == null ? void 0 : session.sittingTimes)) == null ? void 0 : _a.times,
    isClosed: (session == null ? void 0 : session.startTime) === 0 && (session == null ? void 0 : session.endTime) === 0
  };
};
const getSessionColors = (sessionId, theme2) => {
  if (isEmpty(theme2)) {
    devLog("warning", "THEME IS EMPTY", theme2);
    return {
      color: "#FFFFFF",
      backgroundColor: "#FFFFFF"
    };
  }
  switch (sessionId) {
    case "morning":
      return {
        color: theme2.colors.turmeric,
        backgroundColor: theme2.colors.breakfastTime
      };
    case "lunch":
      return {
        color: theme2.colors.anotherOrange,
        backgroundColor: theme2.colors.peach
      };
    case "dinner":
      return {
        color: theme2.colors.darkerSunnyGreen,
        backgroundColor: theme2.colors.greenBackground
      };
    case "all_day":
    default:
      return {
        color: theme2.colors.rose,
        backgroundColor: theme2.colors.cakeBackground
      };
  }
};
const getSessionColorMap = (obeeSessions2) => {
  const colorMap = {};
  if (isEmpty(obeeSessions2)) {
    return {};
  }
  const sortedSessions = sortListByProperty(obeeSessions2, "startTime").map((session) => session.label.toLowerCase()).filter(filterUnique);
  sortedSessions.forEach((label, index) => {
    colorMap[label] = getSessionColorForIndex(index);
  });
  return colorMap;
};
const getColorForSession = (session, sessionColors) => {
  return sessionColors == null ? void 0 : sessionColors[session.label.toLowerCase()];
};
const getSessionLabel = (sessionLabelId = "") => {
  const labelMap = {
    morning: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    all_day: "All Day"
  };
  return (labelMap == null ? void 0 : labelMap[sessionLabelId]) || sessionLabelId;
};
const getListLabel = (sessionLabelId, theme2) => /* @__PURE__ */ React__default.createElement("div", { style: { display: "flex", gap: "10px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(
  "div",
  {
    style: {
      width: "9px",
      height: "9px",
      borderRadius: "9px",
      backgroundColor: getSessionColors(sessionLabelId, theme2).color
    }
  }
), /* @__PURE__ */ React__default.createElement("div", null, getSessionLabel(sessionLabelId)));
const sessionLabels = (theme2) => [
  {
    value: "morning",
    label: getListLabel("morning", theme2)
  },
  {
    value: "lunch",
    label: getListLabel("lunch", theme2)
  },
  {
    value: "dinner",
    label: getListLabel("dinner", theme2)
  },
  {
    value: "all_day",
    label: getListLabel("all_day", theme2)
  }
];
const getSessionList = () => [
  {
    value: "morning",
    label: getSessionLabel("morning")
  },
  {
    value: "lunch",
    label: getSessionLabel("lunch")
  },
  {
    value: "dinner",
    label: getSessionLabel("dinner")
  },
  {
    value: "all_day",
    label: getSessionLabel("all_day")
  }
];
const sortSessions = (a, b) => {
  const order = {
    morning: 0,
    lunch: 1,
    dinner: 2,
    all_day: 3,
    "all day": 4
    // Old obee naming
  };
  if (isEmpty(a)) {
    return -1;
  }
  if (isEmpty(b)) {
    return 1;
  }
  return (order == null ? void 0 : order[a.toLowerCase()]) - (order == null ? void 0 : order[b.toLowerCase()]);
};
const getTypeLabel = (typeLabelId) => {
  const labelMap = {
    differentHours: "Different Hours",
    closed: "Closed"
  };
  return (labelMap == null ? void 0 : labelMap[typeLabelId]) || typeLabelId;
};
const typeItems = [
  { label: getTypeLabel("differentHours"), value: "differentHours" },
  { label: getTypeLabel("closed"), value: "closed" }
];
const BOOKING_CONFLICT_TYPE = {
  SESSION: "session",
  BLOCK: "block",
  BOOKING: "booking"
};
const BOOKING_AVAILABILITY_STATE = {
  AVAILABLE: "available",
  CONFLICTED: "conflicted",
  UNAVAILABLE: "unavailable"
};
const SvgGlobe = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 36, height: 33, viewBox: "0 0 36 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.355713, y: 0.465576, width: 35.1274, height: 32, rx: 10, fill: "#F4F4F4" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 17.4718, cy: 16.2379, r: 8.99988, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 17.5195, y1: 6.73804, x2: 17.5195, y2: 25.6835, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.11502 16.2378H26.2421", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M22.0839 16.2823C22.0839 18.796 21.513 21.0471 20.6155 22.6521C19.7088 24.2734 18.5353 25.1357 17.3533 25.1357C16.1712 25.1357 14.9977 24.2734 14.0911 22.6521C13.1935 21.0471 12.6227 18.796 12.6227 16.2823C12.6227 13.7685 13.1935 11.5174 14.0911 9.91243C14.9977 8.29115 16.1712 7.42883 17.3533 7.42883C18.5353 7.42883 19.7088 8.29115 20.6155 9.91243C21.513 11.5174 22.0839 13.7685 22.0839 16.2823Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.5873 10.0602C11.4119 10.6021 14.3997 11.6859 17.5098 11.6859C20.6198 11.6859 23.0569 10.6021 23.9993 10.0602", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.5873 21.5109C11.4119 20.969 14.352 19.8852 17.462 19.8852C20.5721 19.8852 23.3432 21.3243 24.2856 21.8662", stroke: "currentColor" }));
const InternetIconSVG = SvgGlobe;
const SvgPhone = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 35, height: 33, viewBox: "0 0 35 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.612793, y: 0.594971, width: 34.2861, height: 32, rx: 10, fill: "#F4F4F4" }), /* @__PURE__ */ React$7.createElement("path", { d: "M15.567 11.1635L13.8759 7.56864C13.7037 7.20245 13.2851 7.02257 12.9009 7.14963L11.7762 7.52153C11.6475 7.56408 11.5312 7.63693 11.4447 7.74126C10.23 9.20656 8.58673 13.2212 12.1737 18.3046C16.8265 24.8986 22.2151 24.7308 22.8798 24.4011C23.2928 24.1963 23.9998 23.3152 24.5026 22.623C24.7244 22.3176 24.6864 21.8993 24.4241 21.628L21.7309 18.8427C21.4381 18.5399 20.9716 18.531 20.6183 18.7603C20.3134 18.9583 19.8721 19.1984 19.224 19.4556C17.5623 20.115 15.5682 19.1259 14.2388 17.1477C12.9094 15.1695 13.2418 13.1913 13.9064 12.8616L15.1987 12.2206C15.5887 12.0272 15.7523 11.5574 15.567 11.1635Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M14.1273 12.7885C14.1273 12.7885 13.9774 12.5096 13.9226 12.3464C13.841 12.1031 13.5926 11.4911 13.5146 11.247C13.4526 11.0529 13.3742 10.8943 13.289 10.6714C13.0767 10.1159 12.315 8.47984 12.1736 7.90417", stroke: "currentColor", strokeWidth: 0.5, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M23.8959 23.5343C23.8959 23.5343 23.5959 23.3112 23.4865 23.1806C23.3232 22.986 22.8264 22.4964 22.6704 22.3011C22.5464 22.1458 22.3897 22.019 22.2193 21.8406C21.7946 21.3962 20.2713 20.0874 19.9884 19.6268", stroke: "currentColor", strokeWidth: 0.5, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M22.6801 24.5975C21.9224 24.9114 21.1367 25.1104 20.3628 25.3683C19.6503 25.6058 18.8578 25.5851 18.1197 25.6522C17.0937 25.7455 15.9952 25.7335 14.9919 25.4888C14.7423 25.4279 14.2989 25.1913 14.444 24.8649C14.5222 24.6888 14.7475 24.6461 14.9375 24.6883C14.9881 24.6996 15.1388 24.8032 15.1785 24.8517C15.2643 24.9566 15.2563 25.0174 15.2973 25.1323C15.3941 25.4033 15.1024 25.7104 14.883 25.8156C14.561 25.97 14.1745 26.0006 13.8267 26.0533C13.3746 26.1218 12.9117 26.1835 12.4534 26.1655C11.949 26.1458 11.4469 26.0692 10.9448 26.0236", stroke: "currentColor", strokeWidth: 0.6, strokeLinecap: "round" }));
const PhoneIconSVG = SvgPhone;
const SvgGoogle = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 36, height: 33, viewBox: "0 0 36 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.900513, y: 0.875, width: 34.2861, height: 32, rx: 10, fill: "#F4F4F4" }), /* @__PURE__ */ React$7.createElement("path", { d: "M22.6193 18.9425H17.7948V16.111H26.1867C26.2559 16.6027 26.2926 17.1106 26.2926 17.6346C26.2926 20.5141 25.2676 22.9038 23.5238 24.5246L23.0603 24.8644L21.7762 23.798L21.7635 23.7874L21.75 23.7777L20.703 23.0195L20.9359 22.8175C22.0825 22.0433 22.8531 20.8924 23.1106 19.5357L23.2232 18.9425H22.6193Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M20.6005 23.0286L23.0513 24.9302C21.5623 26.1133 19.6095 26.8033 17.2942 26.8033C13.6309 26.8033 10.4676 24.7038 8.91755 21.6458L8.38058 20.3199L8.28933 19.7985H11.4046C12.3414 22.1514 14.6178 23.8728 17.2942 23.8728C18.57 23.8728 19.6848 23.5631 20.6005 23.0286Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.19407 19.7265C8.00341 18.987 7.90125 18.2115 7.90125 17.4097C7.90125 15.9041 8.26149 14.4911 8.89146 13.2355L9.06886 12.9884L10.2118 13.8579L10.2117 13.858L10.219 13.8633L11.4562 14.7697L11.2771 15.3806C11.0661 16.0164 10.9396 16.6965 10.9396 17.4097C10.9396 18.0746 11.0496 18.7107 11.2355 19.309L11.135 19.7265H8.57134H8.19407Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M21.0572 12.2479C19.9931 11.3954 18.7087 10.9557 17.295 10.9557C14.735 10.9557 12.5409 12.5307 11.5351 14.7268L9.1014 12.8384C10.7088 9.95968 13.7705 8.01624 17.295 8.01624C19.637 8.01624 21.6138 8.80614 23.1851 10.12L21.0572 12.2479Z", stroke: "currentColor" }));
const GoogleIconSVG = SvgGoogle;
const SvgWalkIn = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 35, height: 33, viewBox: "0 0 35 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.116699, y: 0.869873, width: 34.2861, height: 32, rx: 10, fill: "#F4F4F4" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 16.4193, cy: 8.1904, r: 1.95322, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.1172 18.1863L11.231 17.6978C11.7577 15.4359 11.6746 11.7333 13.9971 11.7333V11.7333C14.6904 11.7333 17.7978 11.8113 18.4911 12.9846C19.1844 14.1578 18.8502 15.6264 19.1702 15.9997C19.4261 16.2984 21.3034 17.5819 22.21 18.1863", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.3341 17.349L13.8275 16.8226C13.7386 17.5159 14.1155 19.1479 16.3341 20.1291C18.5526 21.1104 20.7072 25.8711 21.5072 28.1288", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.6028 27.3047C11.501 27.5614 11.6266 27.852 11.8833 27.9538C12.14 28.0556 12.4306 27.93 12.5324 27.6733L11.6028 27.3047ZM14.1009 21.0054L11.6028 27.3047L12.5324 27.6733L15.0305 21.374L14.1009 21.0054Z", fill: "currentColor" }));
const WalkinIconSVG = SvgWalkIn;
const SvgEmail = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 35, height: 33, viewBox: "0 0 35 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { y: 0.875, width: 34.2861, height: 32, rx: 10, fill: "#F4F4F4" }), /* @__PURE__ */ React$7.createElement("rect", { x: 8.5, y: 10.5, width: 16.5882, height: 12, rx: 1.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.76465 10.7647L16.7941 16.8823L24.8235 10.3823", stroke: "currentColor" }));
const EmailIconSVG = SvgEmail;
const getJoinedTables = (booking, tableNumber, tables) => {
  const joinedTableNumbers = (booking == null ? void 0 : booking.tableNumbers) || [tableNumber];
  return filterByProperty(tables.data, joinedTableNumbers, "tableNumber");
};
const hasBookingsPremium = (restaurant) => {
  if (isObee()) {
    return true;
  }
  return (restaurant == null ? void 0 : restaurant.obeeEnabled) && (restaurant == null ? void 0 : restaurant.premium);
};
const hasBrandingSettings = (restaurant) => {
  if (isObee()) {
    return (restaurant == null ? void 0 : restaurant.obeePlan) !== "standard";
  }
  return (restaurant == null ? void 0 : restaurant.obeeEnabled) && (restaurant == null ? void 0 : restaurant.premium);
};
const getRestaurantHoursFromSessions = (sessions) => {
  if (isEmpty(sessions.length)) {
    return {
      open: 0,
      close: 0
    };
  }
  let earliestTime = 1440;
  let latestTime = 0;
  sessions.filter((session) => session.endTime - session.startTime > 0).forEach((session) => {
    if (session.startTime < earliestTime) {
      earliestTime = session.startTime;
    }
    if (session.endTime > latestTime) {
      latestTime = session.endTime;
    }
  });
  return {
    open: roundToNearest(earliestTime, 15, "floor"),
    close: roundToNearest(latestTime, 15, "ceil")
  };
};
const getDefaultTermsAndConditions = () => {
  return '{"blocks":[{"key":"1i90q","text":"Minimum spend - We have a minimum spend of [$XX] per booking.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":15,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"fgm7d","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"d9fq3","text":"Booking duration - We offer a [X hrs] dining duration for bookings. Your table will only be held for [XX minutes] after your booking time. Please advise us if you will be late as soon as possible. We require credit card details to secure all bookings. There is [$$] to secure this booking.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":18,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"4urqm","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5000b","text":"Surcharge - A [XX%] surcharge is applied to food and beverage on public holidays.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":11,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"569lf","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"2rjg3","text":"Contact - If you have any questions about your booking, please contact us on [Phone number].","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":9,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"4ttnv","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"e8835","text":"We look forward to seeing you.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":30,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}';
};
const isTableInUse = (bookingToCheck, tableBookings, time, includeStart = false) => {
  const seatableStatuses = getSeatableStatuses();
  const doubleBooking = tableBookings == null ? void 0 : tableBookings.find(
    (booking) => (includeStart ? time >= booking.time : time > booking.time) && time < booking.endTime && seatableStatuses.includes(booking.status) && booking.id !== bookingToCheck.id
  );
  return doubleBooking;
};
const getSwapConflict = (bookingToCheck, bookingToSwap, obeeTables2, bookings) => {
  var _a;
  const tableToCheck = (_a = obeeTables2.data) == null ? void 0 : _a.find(
    (table) => table.tableNumber === bookingToSwap.tableNumber
  );
  if (tableToCheck && bookingToCheck.size > tableToCheck.maxSeats || bookingToCheck.size < tableToCheck.minSeats) {
    return true;
  }
  const tableBookings = bookings == null ? void 0 : bookings.filter((booking) => getSeatableStatuses().includes(booking.status)).filter(
    (booking) => booking.tableNumber === bookingToSwap.tableNumber && booking.id !== bookingToSwap.id
  );
  const bookingToCheckNewStartTime = bookingToSwap.time;
  const bookingToCheckNewEndTime = bookingToCheckNewStartTime + bookingToCheck.duration;
  return tableBookings == null ? void 0 : tableBookings.find(
    (booking) => booking.time > bookingToCheckNewStartTime && booking.time < bookingToCheckNewEndTime
  );
};
const getShortBookingConflict = (bookingToCheck, tableBookings, table, newStartTime) => {
  var _a;
  const bookingConflict = tableBookings == null ? void 0 : tableBookings.filter((booking) => getSeatableStatuses().includes(booking.status)).find((booking) => {
    return newStartTime < booking.time && newStartTime + bookingToCheck.duration > booking.time && booking.id !== bookingToCheck.id;
  });
  if (bookingConflict) {
    return { ...bookingConflict, type: BOOKING_CONFLICT_TYPE.BOOKING };
  }
  const blockConflict = (_a = table.blocks) == null ? void 0 : _a.find(
    (block) => newStartTime < block.startTime && newStartTime + bookingToCheck.duration > block.startTime
  );
  if (blockConflict) {
    return { ...blockConflict, type: BOOKING_CONFLICT_TYPE.BLOCK };
  }
  return null;
};
const exceedsTableCapacity = (bookingToCheck, table) => {
  return bookingToCheck.size > table.maxSeats || bookingToCheck.size < table.minSeats;
};
const exceedsAreaCapacity = (bookingToCheck, area) => {
  return bookingToCheck.size > area.capacity;
};
const getTodaySessions = (date, obeeSessions2, filteredSession = "all_sessions", areaId = "all") => {
  var _a, _b2;
  if (isEmpty(obeeSessions2 == null ? void 0 : obeeSessions2.data)) {
    return [];
  }
  const areaFilter = isEmpty(areaId) ? "all" : areaId;
  const formattedDate = formatDate(date, "YYYY-MM-DD");
  const areaSpecificEvents = (_a = obeeSessions2 == null ? void 0 : obeeSessions2.data) == null ? void 0 : _a.filter(
    (session) => session.date === formattedDate && (filteredSession === "all_sessions" || session.label === filteredSession)
  );
  const areasWithEvents = areaSpecificEvents == null ? void 0 : areaSpecificEvents.map((session) => session == null ? void 0 : session.areaId);
  const currentDay = moment(date).format("ddd").toLowerCase();
  let todaySessions = sortListByProperty(
    [
      ...areaSpecificEvents.filter((session) => !session.isClosed),
      ...(_b2 = obeeSessions2 == null ? void 0 : obeeSessions2.data) == null ? void 0 : _b2.filter(
        (session) => !areasWithEvents.includes(session == null ? void 0 : session.areaId) && (session == null ? void 0 : session.areaId) !== 0 && session.day === currentDay
      )
    ],
    "startTime"
  );
  if (areaFilter !== "all") {
    todaySessions = todaySessions.filter((session) => (session == null ? void 0 : session.areaId) === areaFilter);
  }
  if (filteredSession !== "all_sessions" && !isEmpty(filteredSession)) {
    return todaySessions.filter((session) => session.label === filteredSession);
  }
  return todaySessions;
};
const getMonthSessions = (currentMonth, obeeSessions2, filteredSession = "all_sessions") => {
  if (isEmpty(obeeSessions2)) {
    return [];
  }
  const realSessions = obeeSessions2 == null ? void 0 : obeeSessions2.filter(
    (session) => session.areaId !== 0 || !isEmpty(session.date) || session.startTime !== 0 || session.endTime !== 0 || !isEmpty(session.day)
  );
  const eventSessions = realSessions == null ? void 0 : realSessions.filter((session) => !isEmpty(session.date));
  const normalSessions = realSessions == null ? void 0 : realSessions.filter((session) => isEmpty(session.date));
  const areaSpecificEvents = eventSessions == null ? void 0 : eventSessions.filter(
    (session) => (isVoid(currentMonth) || formatDate(session.date, "MMMM YYYY") === currentMonth) && !session.isClosed && (filteredSession === "all_sessions" || session.label === filteredSession)
  );
  const allSessions = sortListByProperty([...areaSpecificEvents, ...normalSessions], "startTime");
  if (filteredSession !== "all_sessions" && !isEmpty(filteredSession)) {
    return allSessions.filter((session) => session.label === filteredSession);
  }
  return sortListByProperty(allSessions, "startTime");
};
const getTimeDropdownList = (sessionsForDay, onClick, bookingInterval = 15) => {
  const sessionsByLabel = groupByProperty(sessionsForDay, "label");
  return sessionsByLabel == null ? void 0 : sessionsByLabel.map((sessionGroup) => {
    const sessionTimes = [];
    sessionGroup.items.forEach((session) => {
      for (let i = session.startTime; i < session.endTime; i += bookingInterval) {
        sessionTimes.push(i);
      }
    });
    const cleanSessionTimes = unique(sessionTimes).sort(sortValues);
    return {
      label: getSessionLabel(sessionGroup == null ? void 0 : sessionGroup.name),
      items: cleanSessionTimes == null ? void 0 : cleanSessionTimes.map((sessionTime) => ({
        label: formatTimeFromInt(sessionTime, "h:mma"),
        value: sessionTime,
        onClick: () => onClick(sessionTime, sessionGroup)
      }))
    };
  });
};
const bookingStartsInSession = (booking, session) => {
  return ((booking == null ? void 0 : booking.areaId) === (session == null ? void 0 : session.areaId) || isVoid(session == null ? void 0 : session.areaId) || (booking == null ? void 0 : booking.areaId) === "all") && // global sessions don't have an areaId
  booking.startTime < session.endTime && booking.startTime >= session.startTime;
};
const bookingIsInSession = (booking, session) => {
  return ((booking == null ? void 0 : booking.areaId) === (session == null ? void 0 : session.areaId) || isVoid(session == null ? void 0 : session.areaId) || (booking == null ? void 0 : booking.areaId) === "all") && // global sessions don't have an areaId
  booking.startTime < session.endTime && booking.endTime > session.startTime;
};
const getSessionForBooking = (booking, sessions, startOnly = true) => {
  if (startOnly) {
    return sessions.find((session) => bookingStartsInSession(booking, session));
  }
  return sessions.find((session) => bookingIsInSession(booking, session));
};
const getBookingsForSessions = (bookings, sessions, startOnly = true, showAll = false) => {
  if (showAll) {
    return bookings;
  }
  return bookings.filter((booking) => {
    return (booking == null ? void 0 : booking.status) === "waitlist" || !isEmpty(getSessionForBooking(booking, sessions, startOnly));
  });
};
const groupBookingsBySessionLabel = (bookings, sessions) => {
  const newSessions = {};
  bookings.forEach((booking) => {
    var _a;
    const sessionLabel = ((_a = getSessionForBooking(booking, sessions)) == null ? void 0 : _a.label) || "No session";
    if (isEmpty(newSessions == null ? void 0 : newSessions[sessionLabel])) {
      newSessions[sessionLabel] = [];
    }
    newSessions[sessionLabel].push(booking);
  });
  return newSessions;
};
const getNextTime = (times) => {
  var _a, _b2;
  const flatTimes = flattenArrayValues(times, "items");
  if (isEmpty(flatTimes)) {
    return 0;
  }
  const bookingInterval = 15;
  const nextIntervalTime = nextNearestMinutes(moment(), bookingInterval);
  const nextSitting = (_a = flatTimes.filter(
    (time) => time.value >= formatIntFromTime(nextIntervalTime)
  )) == null ? void 0 : _a[0];
  return !isEmpty(nextSitting == null ? void 0 : nextSitting.value) ? nextSitting == null ? void 0 : nextSitting.value : (_b2 = flatTimes == null ? void 0 : flatTimes[flatTimes.length - 1]) == null ? void 0 : _b2.value;
};
const getLastSession = (sessions) => {
  var _a;
  return (_a = sortListByProperty(sessions, "endTime", true)) == null ? void 0 : _a[0];
};
const getNumberVisits = (booking) => {
  var _a, _b2, _c2, _d2;
  return ((_b2 = (_a = booking.guests) == null ? void 0 : _a[0]) == null ? void 0 : _b2.numVisits) > 1 ? `${ordinal((_d2 = (_c2 = booking.guests) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.numVisits)} visit` : "New";
};
const getKidsText = (booking) => {
  const inclusions = [];
  if ((booking == null ? void 0 : booking.kids) > 0) {
    inclusions.push(`${booking.kids} ${pluralise("kid", booking.kids)}`);
  }
  if ((booking == null ? void 0 : booking.highchairs) > 0) {
    inclusions.push(`
\r${booking.highchairs} ${pluralise("highchair", booking.highchairs)}`);
  }
  return joinList(inclusions);
};
const getSourceIcon = (booking) => {
  if ((booking == null ? void 0 : booking.source) === "phone") {
    return /* @__PURE__ */ React__default.createElement(PhoneIconSVG, null);
  }
  if ((booking == null ? void 0 : booking.source) === "google") {
    return /* @__PURE__ */ React__default.createElement(GoogleIconSVG, null);
  }
  if ((booking == null ? void 0 : booking.source) === "walkin") {
    return /* @__PURE__ */ React__default.createElement(WalkinIconSVG, null);
  }
  if ((booking == null ? void 0 : booking.source) === "email") {
    return /* @__PURE__ */ React__default.createElement(EmailIconSVG, null);
  }
  return /* @__PURE__ */ React__default.createElement(InternetIconSVG, null);
};
const getTableForBooking = (booking, tables, areas) => {
  if (isEmpty(tables) || isEmpty(booking)) {
    return null;
  }
  const bookingArea = findObjectByProperty(areas, booking == null ? void 0 : booking.areaId, "id");
  const tablesForArea = tables.filter((table) => (table == null ? void 0 : table.areaId) === (bookingArea == null ? void 0 : bookingArea.id));
  if (isEmpty(tablesForArea)) {
    return null;
  }
  return findObjectByProperty(tables, booking == null ? void 0 : booking.tableNumber, "tableNumber");
};
const isTableForBooking = (table, booking) => {
  if (isEmpty(booking) || isEmpty(table)) {
    return false;
  }
  return (booking == null ? void 0 : booking.tableNumbers.includes(table == null ? void 0 : table.tableNumber)) && table.areaId === (booking == null ? void 0 : booking.areaId);
};
const bookingsOnSameTable = (bookingA, bookingB) => {
  if (isEmpty(bookingA) || isEmpty(bookingB) || (bookingA == null ? void 0 : bookingA.id) === (bookingB == null ? void 0 : bookingB.id)) {
    return false;
  }
  return (bookingA == null ? void 0 : bookingA.tableNumbers.some((tableNumber) => {
    var _a;
    return (_a = bookingB == null ? void 0 : bookingB.tableNumbers) == null ? void 0 : _a.includes(tableNumber);
  })) && bookingA.areaId === (bookingB == null ? void 0 : bookingB.areaId);
};
const getBookingsForTable = (table, bookings) => {
  return bookings.filter((booking) => {
    return isTableForBooking(table, booking);
  });
};
const getAreaById = (areas, areaId) => {
  return findObjectByProperty(areas, areaId, "id");
};
const getDisplayTableNumberForBooking = (areas, tables, booking) => {
  const areaForBooking = getAreaById(areas, booking == null ? void 0 : booking.areaId);
  if (isEmpty(booking == null ? void 0 : booking.areaId) || isEmpty(areaForBooking)) {
    return null;
  }
  const table = getTableForBooking(booking, tables, areas);
  if (isEmpty(table)) {
    return `${(booking == null ? void 0 : booking.tableNumberDisplay) ?? ""} ${(areaForBooking == null ? void 0 : areaForBooking.name) ?? ""}`;
  }
  if (booking == null ? void 0 : booking.tableNumberDisplay) {
    return booking.tableNumberDisplay;
  }
  const areaForTable = findObjectByProperty(areas, booking == null ? void 0 : booking.areaId, "id");
  return areaForTable == null ? void 0 : areaForTable.name;
};
const getConflicts = (booking, tables, restaurantOpen, restaurantClose, sessions, areas) => {
  const bookingArea = findObjectByProperty(areas, booking == null ? void 0 : booking.areaId, "id");
  const tablesForArea = tables.filter((table) => (table == null ? void 0 : table.areaId) === (bookingArea == null ? void 0 : bookingArea.id));
  if (!isEmpty(tablesForArea) && !isEmpty(booking == null ? void 0 : booking.tableNumber) && booking.tableNumbers.some(
    // Might be a manual join, check all the tables exist individually since the joint table will not exist in the system
    (tableNumber) => !findObjectByProperty(tables, tableNumber, "tableNumber")
  )) {
    devLog("warning", "missing table", tables, booking);
    return "The table for this booking does not exist";
  }
  if (!isEmpty(restaurantOpen) && (booking == null ? void 0 : booking.startTime) < restaurantOpen) {
    return "Booking start time is before opening time";
  }
  if ((booking == null ? void 0 : booking.status) !== "waitlist" && isEmpty(getSessionForBooking(booking, sessions))) {
    return "Booking does not belong to any session";
  }
  const bookingTable = getTableForBooking(booking, tables, areas);
  if (bookingTable && (booking == null ? void 0 : booking.areaId) && (bookingTable == null ? void 0 : bookingTable.areaId) !== (booking == null ? void 0 : booking.areaId)) {
    const newBookingArea = findObjectByProperty(areas, booking == null ? void 0 : booking.areaId, "id");
    const tableArea = findObjectByProperty(areas, bookingTable == null ? void 0 : bookingTable.areaId, "id");
    return `Booking is for area "${newBookingArea == null ? void 0 : newBookingArea.name}" but table ${bookingTable == null ? void 0 : bookingTable.tableNumberDisplay} is in area "${tableArea == null ? void 0 : tableArea.name}"`;
  }
  return false;
};
const JSON_MIME = "application/json";
const CONTENT_TYPE_HEADER = "Content-Type";
const FETCH_ERROR = Symbol();
const CATCHER_FALLBACK = Symbol();
function extractContentType(headers = {}) {
  var _a;
  return (_a = Object.entries(headers).find(([k]) => k.toLowerCase() === CONTENT_TYPE_HEADER.toLowerCase())) === null || _a === void 0 ? void 0 : _a[1];
}
function isLikelyJsonMime(value) {
  return /^application\/.*json.*/.test(value);
}
const mix = function(one, two, mergeArrays = false) {
  return Object.entries(two).reduce((acc, [key, newValue]) => {
    const value = one[key];
    if (Array.isArray(value) && Array.isArray(newValue)) {
      acc[key] = mergeArrays ? [...value, ...newValue] : newValue;
    } else if (typeof value === "object" && typeof newValue === "object") {
      acc[key] = mix(value, newValue, mergeArrays);
    } else {
      acc[key] = newValue;
    }
    return acc;
  }, { ...one });
};
const config = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null
  },
  polyfill(p, doThrow = true, instance = false, ...args) {
    const res = this.polyfills[p] || (typeof self !== "undefined" ? self[p] : null) || (typeof global !== "undefined" ? global[p] : null);
    if (doThrow && !res)
      throw new Error(p + " is not defined");
    return instance && res ? new res(...args) : res;
  }
};
function setOptions(options, replace2 = false) {
  config.options = replace2 ? options : mix(config.options, options);
}
function setPolyfills(polyfills, replace2 = false) {
  config.polyfills = replace2 ? polyfills : mix(config.polyfills, polyfills);
}
function setErrorType(errorType) {
  config.errorType = errorType;
}
const middlewareHelper = (middlewares) => (fetchFunction) => {
  return middlewares.reduceRight((acc, curr) => curr(acc), fetchFunction) || fetchFunction;
};
class WretchError extends Error {
}
const resolver = (wretch) => {
  const sharedState = /* @__PURE__ */ Object.create(null);
  wretch = wretch._addons.reduce((w, addon) => addon.beforeRequest && addon.beforeRequest(w, wretch._options, sharedState) || w, wretch);
  const { _url: url, _options: opts, _config: config2, _catchers, _resolvers: resolvers, _middlewares: middlewares, _addons: addons } = wretch;
  const catchers = new Map(_catchers);
  const finalOptions = mix(config2.options, opts);
  let finalUrl = url;
  const _fetchReq = middlewareHelper(middlewares)((url2, options) => {
    finalUrl = url2;
    return config2.polyfill("fetch")(url2, options);
  })(url, finalOptions);
  const referenceError = new Error();
  const throwingPromise = _fetchReq.catch((error) => {
    throw { [FETCH_ERROR]: error };
  }).then((response) => {
    if (!response.ok) {
      const err = new WretchError();
      err["cause"] = referenceError;
      err.stack = err.stack + "\nCAUSE: " + referenceError.stack;
      err.response = response;
      err.url = finalUrl;
      if (response.type === "opaque") {
        throw err;
      }
      return response.text().then((body) => {
        var _a;
        err.message = body;
        if (config2.errorType === "json" || ((_a = response.headers.get("Content-Type")) === null || _a === void 0 ? void 0 : _a.split(";")[0]) === "application/json") {
          try {
            err.json = JSON.parse(body);
          } catch (e) {
          }
        }
        err.text = body;
        err["status"] = response.status;
        throw err;
      });
    }
    return response;
  });
  const catchersWrapper = (promise) => {
    return promise.catch((err) => {
      const fetchErrorFlag = err.hasOwnProperty(FETCH_ERROR);
      const error = fetchErrorFlag ? err[FETCH_ERROR] : err;
      const catcher = (error === null || error === void 0 ? void 0 : error.status) && catchers.get(error.status) || catchers.get(error === null || error === void 0 ? void 0 : error.name) || fetchErrorFlag && catchers.has(FETCH_ERROR) && catchers.get(FETCH_ERROR);
      if (catcher)
        return catcher(error, wretch);
      const catcherFallback = catchers.get(CATCHER_FALLBACK);
      if (catcherFallback)
        return catcherFallback(error, wretch);
      throw error;
    });
  };
  const bodyParser = (funName) => (cb) => funName ? (
    // If a callback is provided, then callback with the body result otherwise return the parsed body itself.
    catchersWrapper(throwingPromise.then((_) => _ && _[funName]()).then((_) => cb ? cb(_) : _))
  ) : (
    // No body parsing method - return the response
    catchersWrapper(throwingPromise.then((_) => cb ? cb(_) : _))
  );
  const responseChain = {
    _wretchReq: wretch,
    _fetchReq,
    _sharedState: sharedState,
    res: bodyParser(null),
    json: bodyParser("json"),
    blob: bodyParser("blob"),
    formData: bodyParser("formData"),
    arrayBuffer: bodyParser("arrayBuffer"),
    text: bodyParser("text"),
    error(errorId, cb) {
      catchers.set(errorId, cb);
      return this;
    },
    badRequest(cb) {
      return this.error(400, cb);
    },
    unauthorized(cb) {
      return this.error(401, cb);
    },
    forbidden(cb) {
      return this.error(403, cb);
    },
    notFound(cb) {
      return this.error(404, cb);
    },
    timeout(cb) {
      return this.error(408, cb);
    },
    internalError(cb) {
      return this.error(500, cb);
    },
    fetchError(cb) {
      return this.error(FETCH_ERROR, cb);
    }
  };
  const enhancedResponseChain = addons.reduce((chain, addon) => ({
    ...chain,
    ...typeof addon.resolver === "function" ? addon.resolver(chain) : addon.resolver
  }), responseChain);
  return resolvers.reduce((chain, r2) => r2(chain, wretch), enhancedResponseChain);
};
const core = {
  _url: "",
  _options: {},
  _config: config,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(addon) {
    return { ...this, _addons: [...this._addons, addon], ...addon.wretch };
  },
  errorType(errorType) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType
      }
    };
  },
  polyfills(polyfills, replace2 = false) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: replace2 ? polyfills : mix(this._config.polyfills, polyfills)
      }
    };
  },
  url(_url, replace2 = false) {
    if (replace2)
      return { ...this, _url };
    const split = this._url.split("?");
    return {
      ...this,
      _url: split.length > 1 ? split[0] + _url + "?" + split[1] : this._url + _url
    };
  },
  options(options, replace2 = false) {
    return { ...this, _options: replace2 ? options : mix(this._options, options) };
  },
  headers(headerValues) {
    const headers = !headerValues ? {} : Array.isArray(headerValues) ? Object.fromEntries(headerValues) : "entries" in headerValues ? Object.fromEntries(headerValues.entries()) : headerValues;
    return { ...this, _options: mix(this._options, { headers }) };
  },
  accept(headerValue) {
    return this.headers({ Accept: headerValue });
  },
  content(headerValue) {
    return this.headers({ [CONTENT_TYPE_HEADER]: headerValue });
  },
  auth(headerValue) {
    return this.headers({ Authorization: headerValue });
  },
  catcher(errorId, catcher) {
    const newMap = new Map(this._catchers);
    newMap.set(errorId, catcher);
    return { ...this, _catchers: newMap };
  },
  catcherFallback(catcher) {
    return this.catcher(CATCHER_FALLBACK, catcher);
  },
  resolve(resolver2, clear2 = false) {
    return { ...this, _resolvers: clear2 ? [resolver2] : [...this._resolvers, resolver2] };
  },
  defer(callback, clear2 = false) {
    return {
      ...this,
      _deferred: clear2 ? [callback] : [...this._deferred, callback]
    };
  },
  middlewares(middlewares, clear2 = false) {
    return {
      ...this,
      _middlewares: clear2 ? middlewares : [...this._middlewares, ...middlewares]
    };
  },
  fetch(method = this._options.method, url = "", body = null) {
    let base = this.url(url).options({ method });
    const contentType = extractContentType(base._options.headers);
    const jsonify = typeof body === "object" && (!base._options.headers || !contentType || isLikelyJsonMime(contentType));
    base = !body ? base : jsonify ? base.json(body, contentType) : base.body(body);
    return resolver(base._deferred.reduce((acc, curr) => curr(acc, acc._url, acc._options), base));
  },
  get(url = "") {
    return this.fetch("GET", url);
  },
  delete(url = "") {
    return this.fetch("DELETE", url);
  },
  put(body, url = "") {
    return this.fetch("PUT", url, body);
  },
  post(body, url = "") {
    return this.fetch("POST", url, body);
  },
  patch(body, url = "") {
    return this.fetch("PATCH", url, body);
  },
  head(url = "") {
    return this.fetch("HEAD", url);
  },
  opts(url = "") {
    return this.fetch("OPTIONS", url);
  },
  body(contents) {
    return { ...this, _options: { ...this._options, body: contents } };
  },
  json(jsObject, contentType) {
    const currentContentType = extractContentType(this._options.headers);
    return this.content(contentType || isLikelyJsonMime(currentContentType) && currentContentType || JSON_MIME).body(JSON.stringify(jsObject));
  }
};
function factory(_url = "", _options = {}) {
  return { ...core, _url, _options };
}
factory["default"] = factory;
factory.options = setOptions;
factory.errorType = setErrorType;
factory.polyfills = setPolyfills;
factory.WretchError = WretchError;
const defaultSkip$1 = (_, opts) => opts.skipDedupe || opts.method !== "GET";
const defaultKey$1 = (url, opts) => opts.method + "@" + url;
const defaultResolver = (response) => response.clone();
const dedupe = ({ skip = defaultSkip$1, key = defaultKey$1, resolver: resolver2 = defaultResolver } = {}) => {
  const inflight = /* @__PURE__ */ new Map();
  return (next) => (url, opts) => {
    if (skip(url, opts)) {
      return next(url, opts);
    }
    const _key = key(url, opts);
    if (!inflight.has(_key)) {
      inflight.set(_key, []);
    } else {
      return new Promise((resolve, reject) => {
        inflight.get(_key).push([resolve, reject]);
      });
    }
    try {
      return next(url, opts).then((response) => {
        inflight.get(_key).forEach(([resolve]) => resolve(resolver2(response)));
        inflight.delete(_key);
        return response;
      }).catch((error) => {
        inflight.get(_key).forEach(([resolve, reject]) => reject(error));
        inflight.delete(_key);
        throw error;
      });
    } catch (error) {
      inflight.delete(_key);
      return Promise.reject(error);
    }
  };
};
const defaultSkip = (url, opts) => opts.skipCache || opts.method !== "GET";
const defaultKey = (url, opts) => opts.method + "@" + url;
const defaultClear = (url, opts) => false;
const defaultInvalidate = (url, opts) => null;
const defaultCondition = (response) => response.ok;
const throttlingCache = ({ throttle = 1e3, skip = defaultSkip, key = defaultKey, clear: clear2 = defaultClear, invalidate = defaultInvalidate, condition = defaultCondition, flagResponseOnCacheHit = "__cached" } = {}) => {
  const cache = /* @__PURE__ */ new Map();
  const inflight = /* @__PURE__ */ new Map();
  const throttling = /* @__PURE__ */ new Set();
  const throttleRequest = (_key) => {
    if (throttle && !throttling.has(_key)) {
      throttling.add(_key);
      setTimeout(() => {
        throttling.delete(_key);
      }, throttle);
    }
  };
  const middleware = (next) => (url, opts) => {
    const _key = key(url, opts);
    let invalidatePatterns = invalidate(url, opts);
    if (invalidatePatterns) {
      if (!(invalidatePatterns instanceof Array)) {
        invalidatePatterns = [invalidatePatterns];
      }
      invalidatePatterns.forEach((pattern) => {
        if (typeof pattern === "string") {
          cache.delete(pattern);
        } else if (pattern instanceof RegExp) {
          cache.forEach((_, key2) => {
            if (pattern.test(key2)) {
              cache.delete(key2);
            }
          });
        }
      });
    }
    if (clear2(url, opts)) {
      cache.clear();
    }
    if (skip(url, opts)) {
      return next(url, opts);
    }
    if (throttling.has(_key)) {
      if (cache.has(_key)) {
        const cachedClone = cache.get(_key).clone();
        if (flagResponseOnCacheHit) {
          Object.defineProperty(cachedClone, flagResponseOnCacheHit, {
            value: _key,
            enumerable: false
          });
        }
        return Promise.resolve(cachedClone);
      } else if (inflight.has(_key)) {
        return new Promise((resolve, reject) => {
          inflight.get(_key).push([resolve, reject]);
        });
      }
    }
    if (!inflight.has(_key))
      inflight.set(_key, []);
    throttleRequest(_key);
    return next(url, opts).then((response) => {
      if (condition(response.clone())) {
        cache.set(_key, response.clone());
      }
      inflight.get(_key).forEach(([resolve]) => resolve(response.clone()));
      inflight.delete(_key);
      return response;
    }).catch((error) => {
      inflight.get(_key).forEach(([resolve, reject]) => reject(error));
      inflight.delete(_key);
      throw error;
    });
  };
  middleware.cacheResponse = function(key2, response) {
    throttleRequest(key2);
    cache.set(key2, response);
  };
  middleware.cache = cache;
  middleware.inflight = inflight;
  middleware.throttling = throttling;
  return middleware;
};
const SET_ID_APP_LOADING = "SET_ID_APP_LOADING";
const REMOVE_ID_APP_LOADING = "REMOVE_ID_APP_LOADING";
const ADD_MESSAGE = "ADD_MESSAGE";
const ADD_API_REQUEST = "ADD_API_REQUEST";
const REMOVE_API_REQUEST = "REMOVE_API_REQUEST";
const FETCH_OBEE_SETTINGS_PENDING = "FETCH_OBEE_SETTINGS_PENDING";
const FETCH_OBEE_SETTINGS_SUCCESS = "FETCH_OBEE_SETTINGS_SUCCESS";
const FETCH_OBEE_SETTINGS_FAILURE = "FETCH_OBEE_SETTINGS_FAILURE";
const UPDATE_OBEE_SETTING_PENDING = "UPDATE_OBEE_SETTING_PENDING";
const UPDATE_OBEE_SETTING_SUCCESS = "UPDATE_OBEE_SETTING_SUCCESS";
const UPDATE_OBEE_SETTING_FAILURE = "UPDATE_OBEE_SETTING_FAILURE";
const FETCH_WIDGET_SETTINGS_PENDING = "FETCH_WIDGET_SETTINGS_PENDING";
const FETCH_WIDGET_SETTINGS_SUCCESS = "FETCH_WIDGET_SETTINGS_SUCCESS";
const FETCH_WIDGET_SETTINGS_FAILURE = "FETCH_WIDGET_SETTINGS_FAILURE";
const UPDATE_WIDGET_SETTING_PENDING = "UPDATE_WIDGET_SETTING_PENDING";
const UPDATE_WIDGET_SETTING_SUCCESS = "UPDATE_WIDGET_SETTING_SUCCESS";
const UPDATE_WIDGET_SETTING_FAILURE = "UPDATE_WIDGET_SETTING_FAILURE";
const FETCH_PAYMENT_SETTINGS_PENDING = "FETCH_PAYMENT_SETTINGS_PENDING";
const FETCH_PAYMENT_SETTINGS_SUCCESS = "FETCH_PAYMENT_SETTINGS_SUCCESS";
const FETCH_PAYMENT_SETTINGS_FAILURE = "FETCH_PAYMENT_SETTINGS_FAILURE";
const FETCH_MESSAGES_SETTINGS_PENDING = "FETCH_MESSAGES_SETTINGS_PENDING";
const FETCH_MESSAGES_SETTINGS_SUCCESS = "FETCH_MESSAGES_SETTINGS_SUCCESS";
const FETCH_MESSAGES_SETTINGS_FAILURE = "FETCH_MESSAGES_SETTINGS_FAILURE";
const UPDATE_MESSAGES_SETTING_PENDING = "UPDATE_MESSAGES_SETTING_PENDING";
const UPDATE_MESSAGES_SETTING_SUCCESS = "UPDATE_MESSAGES_SETTING_SUCCESS";
const UPDATE_MESSAGES_SETTING_FAILURE = "UPDATE_MESSAGES_SETTING_FAILURE";
const FETCH_BRANDED_EMAIL_SETTINGS_PENDING = "FETCH_BRANDED_EMAIL_SETTINGS_PENDING";
const FETCH_BRANDED_EMAIL_SETTINGS_SUCCESS = "FETCH_BRANDED_EMAIL_SETTINGS_SUCCESS";
const FETCH_BRANDED_EMAIL_SETTINGS_FAILURE = "FETCH_BRANDED_EMAIL_SETTINGS_FAILURE";
const UPDATE_BRANDED_EMAIL_SETTING_PENDING = "UPDATE_BRANDED_EMAIL_SETTING_PENDING";
const UPDATE_BRANDED_EMAIL_SETTING_SUCCESS = "UPDATE_BRANDED_EMAIL_SETTING_SUCCESS";
const UPDATE_BRANDED_EMAIL_SETTING_FAILURE = "UPDATE_BRANDED_EMAIL_SETTING_FAILURE";
const FETCH_OBEE_BOOKINGS_PENDING = "FETCH_OBEE_BOOKINGS_PENDING";
const FETCH_OBEE_BOOKINGS_SUCCESS = "FETCH_OBEE_BOOKINGS_SUCCESS";
const FETCH_OBEE_BOOKINGS_FAILURE = "FETCH_OBEE_BOOKINGS_FAILURE";
const CREATE_OBEE_BOOKING_PENDING = "CREATE_OBEE_BOOKING_PENDING";
const CREATE_OBEE_BOOKING_SUCCESS = "CREATE_OBEE_BOOKING_SUCCESS";
const CREATE_OBEE_BOOKING_FAILURE = "CREATE_OBEE_BOOKING_FAILURE";
const UPDATE_OBEE_BOOKING_PENDING = "UPDATE_OBEE_BOOKING_PENDING";
const UPDATE_OBEE_BOOKING_SUCCESS = "UPDATE_OBEE_BOOKING_SUCCESS";
const UPDATE_OBEE_BOOKING_FAILURE = "UPDATE_OBEE_BOOKING_FAILURE";
const CONFIRM_WAITLIST_SUCCESS = "CONFIRM_WAITLIST_SUCCESS";
const CONFIRM_WAITLIST_PENDING = "CONFIRM_WAITLIST_PENDING";
const CONFIRM_WAITLIST_FAILURE = "CONFIRM_WAITLIST_FAILURE";
const CONFIRM_WAITLIST_AS_BOOKED_SUCCESS = "CONFIRM_WAITLIST_AS_BOOKED_SUCCESS";
const CONFIRM_WAITLIST_AS_BOOKED_PENDING = "CONFIRM_WAITLIST_AS_BOOKED_PENDING";
const CONFIRM_WAITLIST_AS_BOOKED_FAILURE = "CONFIRM_WAITLIST_AS_BOOKED_FAILURE";
const RESUBMIT_OBEE_BOOKING_PENDING = "CREATE_OBEE_BOOKING_PENDING";
const RESUBMIT_OBEE_BOOKING_SUCCESS = "CREATE_OBEE_BOOKING_SUCCESS";
const RESUBMIT_OBEE_BOOKING_FAILURE = "CREATE_OBEE_BOOKING_FAILURE";
const CLEAR_OBEE_BOOKINGS = "CLEAR_OBEE_BOOKINGS";
const DELETE_LOCAL_OBEE_AREAS = "DELETE_LOCAL_OBEE_AREAS";
const CREATE_OBEE_SESSION_PENDING = "CREATE_OBEE_SESSION_PENDING";
const CREATE_OBEE_SESSION_SUCCESS = "CREATE_OBEE_SESSION_SUCCESS";
const CREATE_OBEE_SESSION_FAILURE = "CREATE_OBEE_SESSION_FAILURE";
const UPDATE_OBEE_SESSION_PENDING = "UPDATE_OBEE_SESSION_PENDING";
const UPDATE_OBEE_SESSION_SUCCESS = "UPDATE_OBEE_SESSION_SUCCESS";
const UPDATE_OBEE_SESSION_FAILURE = "UPDATE_OBEE_SESSION_FAILURE";
const FETCH_OBEE_SESSIONS_PENDING = "FETCH_OBEE_SESSIONS_PENDING";
const FETCH_OBEE_SESSIONS_SUCCESS = "FETCH_OBEE_SESSIONS_SUCCESS";
const FETCH_OBEE_SESSIONS_FAILURE = "FETCH_OBEE_SESSIONS_FAILURE";
const DELETE_OBEE_SESSION_PENDING = "DELETE_OBEE_SESSION_PENDING";
const DELETE_OBEE_SESSION_SUCCESS = "DELETE_OBEE_SESSION_SUCCESS";
const DELETE_OBEE_SESSION_FAILURE = "DELETE_OBEE_SESSION_FAILURE";
const CHECK_OBEE_AVAILABILITY_PENDING = "CHECK_OBEE_AVAILABILITY_PENDING";
const CHECK_OBEE_AVAILABILITY_SUCCESS = "CHECK_OBEE_AVAILABILITY_SUCCESS";
const CHECK_OBEE_AVAILABILITY_FAILURE = "CHECK_OBEE_AVAILABILITY_FAILURE";
const CLEAR_OBEE_AVAILABILITY = "CLEAR_OBEE_AVAILABILITY";
const GET_OBEE_AVAILABILITY_SUGGESTIONS_PENDING = "GET_OBEE_AVAILABILITY_SUGGESTIONS_PENDING";
const GET_OBEE_AVAILABILITY_SUGGESTIONS_SUCCESS = "GET_OBEE_AVAILABILITY_SUGGESTIONS_SUCCESS";
const GET_OBEE_AVAILABILITY_SUGGESTIONS_FAILURE = "GET_OBEE_AVAILABILITY_SUGGESTIONS_FAILURE";
const CLEAR_GET_OBEE_AVAILABILITY_SUGGESTIONS = "CLEAR_GET_OBEE_AVAILABILITY_SUGGESTIONS";
const UPDATE_OBEE_FLOORPLAN_PENDING = "UPDATE_OBEE_FLOORPLAN_PENDING";
const UPDATE_OBEE_FLOORPLAN_SUCCESS = "UPDATE_OBEE_FLOORPLAN_SUCCESS";
const UPDATE_OBEE_FLOORPLAN_FAILURE = "UPDATE_OBEE_FLOORPLAN_FAILURE";
const SAVE_FLOORPLAN_PENDING = "SAVE_FLOORPLAN_PENDING";
const FETCH_OBEE_FLOORPLAN_PENDING = "FETCH_OBEE_FLOORPLAN_PENDING";
const FETCH_OBEE_FLOORPLAN_SUCCESS = "FETCH_OBEE_FLOORPLAN_SUCCESS";
const FETCH_OBEE_FLOORPLAN_FAILURE = "FETCH_OBEE_FLOORPLAN_FAILURE";
const UPDATE_OBEE_FLOORPLAN_LOCAL = "UPDATE_OBEE_FLOORPLAN_LOCAL";
const RESET_OBEE_FLOORPLAN = "RESET_OBEE_FLOORPLAN";
const UNDO_UPDATE_OBEE_FLOORPLAN_LOCAL = "UNDO_UPDATE_OBEE_FLOORPLAN_LOCAL";
const REDO_UPDATE_OBEE_FLOORPLAN_LOCAL = "REDO_UPDATE_OBEE_FLOORPLAN_LOCAL";
const SET_OBEE_DATE = "SET_OBEE_DATE";
const SET_CALENDAR_MONTH = "SET_CALENDAR_MONTH";
const SET_SESSION_FILTER = "SET_SESSION_FILTER";
const SET_FLOORPLAN_VIEW = "SET_FLOORPLAN_VIEW";
const SET_OBEE_SHOW_ADD_BOOKING_MODAL = "SET_OBEE_SHOW_ADD_BOOKING_MODAL";
const SET_OBEE_BOOKING_DETAILS_MODAL = "SET_OBEE_BOOKING_DETAILS_MODAL";
const SET_SHOW_DAILY_NOTES_MODAL = "SET_SHOW_DAILY_NOTES_MODAL";
const UPDATE_CHECK_PENDING = "UPDATE_CHECK_PENDING";
const UPDATE_CHECK_SUCCESS = "UPDATE_CHECK_SUCCESS";
const UPDATE_CHECK_FAILURE = "UPDATE_CHECK_FAILURE";
const CLEAR_UPDATE_CHECK = "CLEAR_UPDATE_CHECK";
const FETCH_OBEE_BOOKINGS_FOR_USER_PENDING = "FETCH_OBEE_BOOKINGS_FOR_USER_PENDING";
const FETCH_OBEE_BOOKINGS_FOR_USER_SUCCESS = "FETCH_OBEE_BOOKINGS_FOR_USER_SUCCESS";
const FETCH_OBEE_BOOKINGS_FOR_USER_FAILURE = "FETCH_OBEE_BOOKINGS_FOR_USER_FAILURE";
const CLEAR_OBEE_BOOKINGS_FOR_USER = "CLEAR_OBEE_BOOKINGS_FOR_USER";
const CHARGE_NO_SHOW_PENDING = "CHARGE_NO_SHOW_PENDING";
const CHARGE_NO_SHOW_SUCCESS = "CHARGE_NO_SHOW_SUCCESS";
const CHARGE_NO_SHOW_FAILURE = "CHARGE_NO_SHOW_FAILURE";
const CLEAR_CHARGE_NO_SHOW = "CLEAR_CHARGE_NO_SHOW";
const FETCH_OBEE_STAFF_PENDING = "FETCH_OBEE_STAFF_PENDING";
const FETCH_OBEE_STAFF_SUCCESS = "FETCH_OBEE_STAFF_SUCCESS";
const FETCH_OBEE_STAFF_FAILURE = "FETCH_OBEE_STAFF_FAILURE";
const UPDATE_OBEE_STAFF_PENDING = "UPDATE_OBEE_STAFF_PENDING";
const UPDATE_OBEE_STAFF_SUCCESS = "UPDATE_OBEE_STAFF_SUCCESS";
const UPDATE_OBEE_STAFF_FAILURE = "UPDATE_OBEE_STAFF_FAILURE";
const DELETE_OBEE_STAFF_PENDING = "DELETE_OBEE_STAFF_PENDING";
const DELETE_OBEE_STAFF_SUCCESS = "DELETE_OBEE_STAFF_SUCCESS";
const DELETE_OBEE_STAFF_FAILURE = "DELETE_OBEE_STAFF_FAILURE";
const CREATE_OBEE_STAFF_PENDING = "CREATE_OBEE_STAFF_PENDING";
const CREATE_OBEE_STAFF_SUCCESS = "CREATE_OBEE_STAFF_SUCCESS";
const CREATE_OBEE_STAFF_FAILURE = "CREATE_OBEE_STAFF_FAILURE";
const CREATE_OBEE_GLOBAL_SESSION_PENDING = "CREATE_OBEE_GLOBAL_SESSION_PENDING";
const CREATE_OBEE_GLOBAL_SESSION_SUCCESS = "CREATE_OBEE_GLOBAL_SESSION_SUCCESS";
const CREATE_OBEE_GLOBAL_SESSION_FAILURE = "CREATE_OBEE_GLOBAL_SESSION_FAILURE";
const UPDATE_OBEE_GLOBAL_SESSION_PENDING = "UPDATE_OBEE_GLOBAL_SESSION_PENDING";
const UPDATE_OBEE_GLOBAL_SESSION_SUCCESS = "UPDATE_OBEE_GLOBAL_SESSION_SUCCESS";
const UPDATE_OBEE_GLOBAL_SESSION_FAILURE = "UPDATE_OBEE_GLOBAL_SESSION_FAILURE";
const FETCH_OBEE_GLOBAL_SESSIONS_PENDING = "FETCH_OBEE_GLOBAL_SESSIONS_PENDING";
const FETCH_OBEE_GLOBAL_SESSIONS_SUCCESS = "FETCH_OBEE_GLOBAL_SESSIONS_SUCCESS";
const FETCH_OBEE_GLOBAL_SESSIONS_FAILURE = "FETCH_OBEE_GLOBAL_SESSIONS_FAILURE";
const DELETE_OBEE_GLOBAL_SESSION_PENDING = "DELETE_OBEE_GLOBAL_SESSION_PENDING";
const DELETE_OBEE_GLOBAL_SESSION_SUCCESS = "DELETE_OBEE_GLOBAL_SESSION_SUCCESS";
const DELETE_OBEE_GLOBAL_SESSION_FAILURE = "DELETE_OBEE_GLOBAL_SESSION_FAILURE";
const CREATE_OBEE_EVENT_SESSION_PENDING = "CREATE_OBEE_EVENT_SESSION_PENDING";
const CREATE_OBEE_EVENT_SESSION_SUCCESS = "CREATE_OBEE_EVENT_SESSION_SUCCESS";
const CREATE_OBEE_EVENT_SESSION_FAILURE = "CREATE_OBEE_EVENT_SESSION_FAILURE";
const UPDATE_OBEE_EVENT_SESSION_PENDING = "UPDATE_OBEE_EVENT_SESSION_PENDING";
const UPDATE_OBEE_EVENT_SESSION_SUCCESS = "UPDATE_OBEE_EVENT_SESSION_SUCCESS";
const UPDATE_OBEE_EVENT_SESSION_FAILURE = "UPDATE_OBEE_EVENT_SESSION_FAILURE";
const FETCH_OBEE_EVENT_SESSIONS_PENDING = "FETCH_OBEE_EVENT_SESSIONS_PENDING";
const FETCH_OBEE_EVENT_SESSIONS_SUCCESS = "FETCH_OBEE_EVENT_SESSIONS_SUCCESS";
const FETCH_OBEE_EVENT_SESSIONS_FAILURE = "FETCH_OBEE_EVENT_SESSIONS_FAILURE";
const DELETE_OBEE_EVENT_SESSION_PENDING = "DELETE_OBEE_EVENT_SESSION_PENDING";
const DELETE_OBEE_EVENT_SESSION_SUCCESS = "DELETE_OBEE_EVENT_SESSION_SUCCESS";
const DELETE_OBEE_EVENT_SESSION_FAILURE = "DELETE_OBEE_EVENT_SESSION_FAILURE";
const CLOSE_RESTAURANT_PENDING = "CLOSE_RESTAURANT_PENDING";
const CLOSE_RESTAURANT_SUCCESS = "CLOSE_RESTAURANT_SUCCESS";
const CLOSE_RESTAURANT_FAILURE = "CLOSE_RESTAURANT_FAILURE";
const REOPEN_RESTAURANT_PENDING = "REOPEN_RESTAURANT_PENDING";
const REOPEN_RESTAURANT_SUCCESS = "REOPEN_RESTAURANT_SUCCESS";
const REOPEN_RESTAURANT_FAILURE = "REOPEN_RESTAURANT_FAILURE";
const BLOCK_OBEE_TABLE_SUCCESS = "BLOCK_OBEE_TABLE_SUCCESS";
const UNBLOCK_OBEE_TABLE_SUCCESS = "UNBLOCK_OBEE_TABLE_SUCCESS";
const EDIT_BLOCK_OBEE_TABLE_SUCCESS = "EDIT_BLOCK_OBEE_TABLE_SUCCESS";
const FETCH_OBEE_GUESTS_PENDING = "FETCH_OBEE_GUESTS_PENDING";
const FETCH_OBEE_GUESTS_SUCCESS = "FETCH_OBEE_GUESTS_SUCCESS";
const FETCH_OBEE_GUESTS_FAILURE = "FETCH_OBEE_GUESTS_FAILURE";
const UPDATE_OBEE_GUEST_PENDING = "UPDATE_OBEE_GUEST_PENDING";
const UPDATE_OBEE_GUEST_SUCCESS = "UPDATE_OBEE_GUEST_SUCCESS";
const UPDATE_OBEE_GUEST_FAILURE = "UPDATE_OBEE_GUEST_FAILURE";
const CLEAR_OBEE_GUESTS = "CLEAR_OBEE_GUESTS";
const FETCH_OBEE_INTEGRATIONS_PENDING = "FETCH_OBEE_INTEGRATIONS_PENDING";
const FETCH_OBEE_INTEGRATIONS_SUCCESS = "FETCH_OBEE_INTEGRATIONS_SUCCESS";
const FETCH_OBEE_INTEGRATIONS_FAILURE = "FETCH_OBEE_INTEGRATIONS_FAILURE";
const ENABLE_RESERVE_WITH_GOOGLE_PENDING = "ENABLE_RESERVE_WITH_GOOGLE_PENDING";
const ENABLE_RESERVE_WITH_GOOGLE_SUCCESS = "ENABLE_RESERVE_WITH_GOOGLE_SUCCESS";
const ENABLE_RESERVE_WITH_GOOGLE_FAILURE = "ENABLE_RESERVE_WITH_GOOGLE_FAILURE";
const DISABLE_RESERVE_WITH_GOOGLE_PENDING = "DISABLE_RESERVE_WITH_GOOGLE_PENDING";
const DISABLE_RESERVE_WITH_GOOGLE_SUCCESS = "DISABLE_RESERVE_WITH_GOOGLE_SUCCESS";
const DISABLE_RESERVE_WITH_GOOGLE_FAILURE = "DISABLE_RESERVE_WITH_GOOGLE_FAILURE";
const GENERATE_FB_LOGIN_BUTTON_PENDING = "GENERATE_FB_LOGIN_BUTTON_PENDING";
const GENERATE_FB_LOGIN_BUTTON_SUCCESS = "GENERATE_FB_LOGIN_BUTTON_SUCCESS";
const GENERATE_FB_LOGIN_BUTTON_FAILURE = "GENERATE_FB_LOGIN_BUTTON_FAILURE";
const COMPLETE_META_CALLBACK_PENDING = "COMPLETE_META_CALLBACK_PENDING";
const COMPLETE_META_CALLBACK_SUCCESS = "COMPLETE_META_CALLBACK_SUCCESS";
const COMPLETE_META_CALLBACK_FAILURE = "COMPLETE_META_CALLBACK_FAILURE";
const DISABLE_META_INTEGRATION_PENDING = "DISABLE_META_INTEGRATION_PENDING";
const DISABLE_META_INTEGRATION_SUCCESS = "DISABLE_META_INTEGRATION_SUCCESS";
const DISABLE_META_INTEGRATION_FAILURE = "DISABLE_META_INTEGRATION_FAILURE";
const GET_FACEBOOK_REDIRECT_URL_PENDING = "GET_FACEBOOK_REDIRECT_URL_PENDING";
const GET_FACEBOOK_REDIRECT_URL_SUCCESS = "GET_FACEBOOK_REDIRECT_URL_SUCCESS";
const GET_FACEBOOK_REDIRECT_URL_FAILURE = "GET_FACEBOOK_REDIRECT_URL_FAILURE";
const FETCH_OBEE_VOUCHER_REDEMPTION_LIST_PENDING = "FETCH_OBEE_VOUCHER_REDEMPTION_LIST_PENDING";
const FETCH_OBEE_VOUCHER_REDEMPTION_LIST_SUCCESS = "FETCH_OBEE_VOUCHER_REDEMPTION_LIST_SUCCESS";
const FETCH_OBEE_VOUCHER_REDEMPTION_LIST_FAILURE = "FETCH_OBEE_VOUCHER_REDEMPTION_LIST_FAILURE";
const CREATE_OBEE_VOUCHER_REDEMPTION_PENDING = "CREATE_OBEE_VOUCHER_REDEMPTION_PENDING";
const CREATE_OBEE_VOUCHER_REDEMPTION_SUCCESS = "CREATE_OBEE_VOUCHER_REDEMPTION_SUCCESS";
const CREATE_OBEE_VOUCHER_REDEMPTION_FAILURE = "CREATE_OBEE_VOUCHER_REDEMPTION_FAILURE";
const RESTORE_NOTIFICATIONS = "RESTORE_NOTIFICATIONS";
const FETCH_NOTIFICATIONS_PENDING = "FETCH_NOTIFICATIONS_PENDING";
const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";
const MARK_ALL_NOTIFICATIONS_AS_READ = "MARK_ALL_NOTIFICATIONS_AS_READ";
const FETCH_NOTIFICATIONS_COUNT_SUCCESS = "FETCH_NOTIFICATIONS_COUNT_SUCCESS";
const SUBSCRIBE_TO_NOTIFICATION_EVENTS_PENDING = "SUBSCRIBE_TO_NOTIFICATION_EVENTS_PENDING";
const SUBSCRIBE_TO_NOTIFICATION_EVENTS_SUCCESS = "SUBSCRIBE_TO_NOTIFICATION_EVENTS_SUCCESS";
const SUBSCRIBE_TO_NOTIFICATION_EVENTS_FAILURE = "SUBSCRIBE_TO_NOTIFICATION_EVENTS_FAILURE";
const FETCH_FULLY_BOOKED_SESSIONS_PENDING = "FETCH_FULLY_BOOKED_SESSIONS_PENDING";
const FETCH_FULLY_BOOKED_SESSIONS_SUCCESS = "FETCH_FULLY_BOOKED_SESSIONS_SUCCESS";
const FETCH_FULLY_BOOKED_SESSIONS_FAILURE = "FETCH_FULLY_BOOKED_SESSIONS_FAILURE";
const BULK_UPDATE_FULLY_BOOKED_SESSIONS_PENDING = "BULK_UPDATE_FULLY_BOOKED_SESSIONS_PENDING";
const BULK_UPDATE_FULLY_BOOKED_SESSIONS_SUCCESS = "BULK_UPDATE_FULLY_BOOKED_SESSIONS_SUCCESS";
const BULK_UPDATE_FULLY_BOOKED_SESSIONS_FAILURE = "BULK_UPDATE_FULLY_BOOKED_SESSIONS_FAILURE";
const CLEAR_FULLY_BOOKED_SESSIONS = "CLEAR_FULLY_BOOKED_SESSIONS";
const SET_FORM_EDITING = "SET_FORM_EDITING";
const CLEAR_FORM_EDITING = "CLEAR_FORM_EDITING";
const SET_HAS_UNSAVED_CHANGES = "SET_HAS_UNSAVED_CHANGES";
const SEND_WAITLIST_SMS_SUCCESS = "SEND_WAITLIST_SMS_SUCCESS";
const SEND_GUEST_EMAIL_SUCCESS = "SEND_GUEST_EMAIL_SUCCESS";
const SEND_GUEST_SMS_SUCCESS = "SEND_GUEST_SMS_SUCCESS";
const SET_RUNSHEET_DISPLAY_MODE = "SET_RUNSHEET_DISPLAY_MODE";
const SET_RUNSHEET_DISPLAY_OVERVIEW = "SET_RUNSHEET_DISPLAY_OVERVIEW";
const SET_RUNSHEET_TIME_SEPARATOR = "SET_RUNSHEET_TIME_SEPARATOR";
const SET_RUNSHEET_TIME_SEPARATOR_INTERVAL = "SET_RUNSHEET_TIME_SEPARATOR_INTERVAL";
const FETCH_OBEE_MONTHLY_VIEW_PENDING = "FETCH_OBEE_MONTHLY_VIEW_PENDING";
const FETCH_OBEE_MONTHLY_VIEW_SUCCESS = "FETCH_OBEE_MONTHLY_VIEW_SUCCESS";
const FETCH_OBEE_MONTHLY_VIEW_FAILURE = "FETCH_OBEE_MONTHLY_VIEW_FAILURE";
const CLEAR_OBEE_MONTHLY_VIEW = "CLEAR_OBEE_MONTHLY_VIEW";
const areaPropTypes = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  capacity: PropTypes.number,
  minGroup: PropTypes.number,
  maxGroup: PropTypes.number,
  areaType: PropTypes.string
  // table or capacity based. Only used on frontend
  // public: PropTypes.bool,
});
const areasPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(areaPropTypes),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const areaTypes = [
  { label: "Indoor", value: "indoor" },
  { label: "Outdoor", value: "outdoor" }
];
const getData$f = (area) => area;
const convertDataForApi$5 = (updatedArea) => {
  const data = {
    // id: updatedArea?.id,
    name: updatedArea == null ? void 0 : updatedArea.name,
    duration: updatedArea == null ? void 0 : updatedArea.duration,
    capacity: (updatedArea == null ? void 0 : updatedArea.capacity) || 0,
    // Turn null into 0
    priority: updatedArea == null ? void 0 : updatedArea.priority,
    minGroup: updatedArea == null ? void 0 : updatedArea.minGroup,
    maxGroup: updatedArea == null ? void 0 : updatedArea.maxGroup
    // cutoffMode: '',
    // cutoffValue: '',
  };
  return data;
};
const getDefaultValues$1 = (defaultDuration) => ({
  // id: areaId,
  name: `New area`,
  duration: defaultDuration,
  // TODO get default restaurant duration from settings
  capacity: 50,
  priority: 50,
  // Low priority by default
  minGroup: 1,
  maxGroup: 8,
  areaType: "table"
  // cutoffMode: '', // TODO figure this out
  // cutoffValue: '', // TODO figure this out
});
const isAreaCapacityBased = (area, tables) => {
  if (isEmpty(area)) {
    return false;
  }
  return !tables.some((table) => (table == null ? void 0 : table.areaId) === (area == null ? void 0 : area.id));
};
const getAllAreaBookings = (area, bookings) => {
  return bookings.filter((booking) => booking.areaId === area.id);
};
const isAreaBookedAtTime = (area, areaBookings, time, bookingId = null) => {
  const seatableStatuses = getSeatableStatuses();
  const bookingCapacityTotal = areaBookings.reduce((accum, booking) => {
    if (time >= booking.time && time < booking.endTime && booking.id !== bookingId && seatableStatuses.includes(booking.status)) {
      return accum + booking.size;
    }
    return accum;
  }, 0);
  return bookingCapacityTotal >= (area == null ? void 0 : area.capacity);
};
const getMinMaxGroupSize = (areas, areaId) => {
  if (areaId === -1 || areaId === "all") {
    const { min, max } = getMinMaxInArrayOfObjects(areas, "minGroup", "maxGroup");
    return { minGroup: min, maxGroup: max };
  }
  const { minGroup, maxGroup } = areas.find((area) => area.id === areaId) ?? {
    minGroup: 1,
    maxGroup: 20
    // TODO should venue-wide max group size be in a setting?
  };
  return { minGroup, maxGroup };
};
const setDataSuccess = (updatedData, state) => ({
  ...state,
  data: updatedData || [],
  apiData: updatedData || [],
  hasChanges: false,
  pending: false,
  success: true,
  error: "",
  errorData: {}
});
const updateItemSuccess$1 = (updatedItem, state, idFieldName = "id") => {
  const newItems = updateObjectByProperty(state.data, updatedItem, idFieldName);
  return setDataSuccess(newItems, state);
};
const bulkUpdate = (newItems, data, key = "id") => data.map((item) => {
  const updatedItem = findObjectByProperty(newItems, item[key], key);
  return updatedItem || item || null;
});
const isSameItem = (item1, item2, idProperty = "id") => !isEmpty(item1 == null ? void 0 : item1[idProperty]) && (item2 == null ? void 0 : item2[idProperty]) === (item1 == null ? void 0 : item1[idProperty]) || !isEmpty(item1 == null ? void 0 : item1._tempId) && (item2 == null ? void 0 : item2._tempId) === (item1 == null ? void 0 : item1._tempId);
const getOtherLocalItems = (localItem, list, idProperty = "id") => {
  return list.filter((listItem) => !isSameItem(localItem, listItem, idProperty));
};
const getRefreshedTablePriorities = (tables, tableState) => {
  const newTables = tables.map((table, index) => {
    const tableApiData = findObjectByProperty(tableState.apiData, table.id, "id");
    return {
      ...table,
      priority: index + 1,
      priorityChanged: (table == null ? void 0 : table.priorityChanged) || index + 1 !== (tableApiData == null ? void 0 : tableApiData.priority)
    };
  });
  return newTables;
};
const updateItemInArray = (array, arrayKey, itemKey, updateItemCallback) => array.map((item) => {
  if (item[arrayKey] !== itemKey) {
    return item;
  }
  return updateItemCallback(item);
});
const setPending = (state) => ({
  ...state,
  pending: true,
  success: false,
  error: "",
  errorData: {}
});
const setFailed = (state, error = "", errorData = {}) => ({
  ...state,
  pending: false,
  success: false,
  error,
  errorData
});
const setSuccess = (state) => ({
  ...state,
  apiData: state.data,
  pending: false,
  success: true,
  hasChanges: false,
  error: "",
  errorData: {}
});
const clear$1 = (state, initialData = []) => {
  return {
    ...state,
    data: initialData,
    apiData: initialData,
    pending: false,
    error: "",
    errorData: {},
    success: false
  };
};
const setDataPending = (updatedData, state) => ({
  ...state,
  data: updatedData,
  pending: true,
  success: false,
  error: "",
  errorData: {}
});
const setFetchPending = (state) => {
  return {
    ...setPending(state),
    hasFetched: true
    // Set true on pending to prevent other components from fetching
  };
};
const setFetchSuccess = (apiData, state) => {
  return {
    ...setDataSuccess(apiData, state),
    hasFetched: true
  };
};
const updateItemPending = (updatedItem, state, idFieldName = "id", merge2 = false) => {
  const newItems = updateObjectByProperty(state.data, updatedItem, idFieldName, merge2);
  return setDataPending(newItems, state);
};
const bulkUpdatePending = (items, state, key) => setDataPending(bulkUpdate(items, state.data, key), state);
const bulkUpdateSuccess = (items, state, key) => {
  devLog("info", "BULK UPDATE DEBUG", { items, state, key });
  return setDataSuccess(bulkUpdate(items, state.data, key), state);
};
const updateItemFailure = (state, error = "", errorData = {}) => ({
  ...state,
  data: state.apiData,
  pending: false,
  success: false,
  error,
  errorData
});
const resetToApiData$1 = (state) => ({
  ...state,
  data: state.apiData,
  hasChanges: false
});
const createItemPending = (createdItem, state, createWhilePending = false) => {
  const getNewItems = () => {
    if (createWhilePending) {
      return [...state.data, createdItem];
    }
    return [...state.data];
  };
  return setDataPending(getNewItems(), state);
};
const createItemSuccess$1 = (createdItem, state) => {
  const newItems = [...state.data, createdItem];
  return setDataSuccess(newItems, state);
};
const createItemSuccessOrUpdate = (newItem, state, idField = "id") => {
  const id = newItem == null ? void 0 : newItem[idField];
  const newItems = replaceObject(state.data, newItem, id, idField, true);
  return setDataSuccess(newItems, state);
};
const createItemFailure = (state, error = "", errorData = {}) => ({
  ...state,
  pending: false,
  error,
  errorData
});
const deleteItemPending = (itemId, state, property = "id", updateWhilePending = true) => {
  if (!updateWhilePending) {
    return setPending(state);
  }
  const newItems = filterByProperty(state.data, itemId, property, true);
  return setDataPending(newItems, state);
};
const deleteItemSuccess$1 = (itemId, state, property = "id") => {
  const newItems = filterByProperty(state.data, itemId, property, true);
  return setDataSuccess(newItems, state);
};
const deleteItemFailure = (state, error = "") => (
  // TODO revert failed update back to apiData's version
  {
    ...state,
    pending: false,
    error
  }
);
const setFetchPaginatedDataSuccess = (action, getData2, state) => {
  var _a, _b2, _c2;
  const pagination = (_a = action.payload) == null ? void 0 : _a.pagination;
  let newData = (_b2 = action.payload.data) == null ? void 0 : _b2.map(getData2);
  if ((pagination == null ? void 0 : pagination.currentPage) > 1) {
    newData = [...state.apiData, ...newData];
  }
  return setDataSuccess(newData, {
    ...state,
    pagination: {
      ...(_c2 = action.payload) == null ? void 0 : _c2.pagination
    }
  });
};
const getInitialApiItemState = (initData = []) => ({
  data: initData,
  // The copy of the data that will be modified locally
  apiData: initData,
  // The copy of the data that is up-to-date with the api
  deleted: [],
  // IDs of locally deleted items that need to be saved
  created: [],
  // IDs of locally created items that need to be saved
  updated: [],
  // IDs of locally updated items that need to be saved
  hasChanges: false,
  // Whether the data has differed from the API data
  error: "",
  pending: false,
  success: false,
  hasFetched: false
});
const clear = (state, initData = []) => ({
  ...state,
  data: initData,
  apiData: initData,
  created: [],
  updated: [],
  deleted: [],
  pending: false,
  error: "",
  success: false
});
const createItemSuccess = (newItem, state, tempId, updateWhilePending) => {
  const newItems = updateWhilePending ? replaceObject(state.data, newItem, tempId, "_tempId") : [...state.data, newItem];
  return setDataSuccess(newItems, state);
};
const updateItemSuccess = (updatedItem, state, idFieldName = "id") => {
  const newItems = updateObjectByProperty(state.data, updatedItem, idFieldName);
  return {
    ...setDataSuccess(newItems, state),
    updated: filterByProperty(state.updated, updatedItem == null ? void 0 : updatedItem[idFieldName], idFieldName, true)
  };
};
const setLocalData = (data, state) => ({
  ...state,
  data,
  hasChanges: true
});
const setLocalDataWithHistory = (data, state) => {
  return {
    ...state,
    data,
    history: { undo: [...state.history.undo, state.data], redo: [] },
    hasChanges: true
  };
};
const undo = (state) => {
  const history = [...state.history.undo];
  if (history.length === 0) {
    return state;
  }
  const previousData = history.pop();
  return {
    ...state,
    data: previousData,
    history: { undo: history, redo: [...state.history.redo, state.data] },
    hasChanges: true
  };
};
const redo = (state) => {
  const redos = [...state.history.redo];
  if (redos.length === 0) {
    return state;
  }
  const nextData = redos.pop();
  return {
    ...state,
    data: nextData,
    history: { undo: [...state.history.undo, state.data], redo: redos },
    hasChanges: true
  };
};
const createLocal = (createdItem, state) => {
  const newItems = [...state.data, createdItem];
  return {
    ...setLocalData(newItems, state),
    created: removeDuplicates([...state.created, createdItem == null ? void 0 : createdItem._tempId])
  };
};
const createLocalItems$1 = (createdItems, state) => {
  const newItems = [...state.data, ...createdItems];
  return {
    ...setLocalData(newItems, state),
    created: removeDuplicates([
      ...state.created,
      ...createdItems.map((createdItem) => createdItem == null ? void 0 : createdItem._tempId)
    ])
  };
};
const getLocalItem = (updatedItem, state, idProperty) => {
  if (updatedItem == null ? void 0 : updatedItem._isNew) {
    return findObjectByProperty(state.data, updatedItem == null ? void 0 : updatedItem._tempId, "_tempId");
  }
  return findObjectByProperty(state.data, updatedItem == null ? void 0 : updatedItem[idProperty], idProperty);
};
const updateLocal = (updatedItem, state, idProperty = "objectId") => {
  let updatedItems;
  if (updatedItem == null ? void 0 : updatedItem._isNew) {
    updatedItems = updateObjectByProperty(state.data, updatedItem, "_tempId");
    return {
      ...setLocalData(updatedItems, state)
    };
  }
  updatedItems = updateObjectByProperty(state.data, updatedItem, idProperty);
  return {
    ...setLocalData(updatedItems, state),
    updated: removeDuplicates([...state.updated, updatedItem == null ? void 0 : updatedItem[idProperty]]),
    hasChanges: true
  };
};
const bulkUpdateLocal = (updatedItems, state, idProperty = "objectId") => {
  let newData = state.data;
  let newUpdatesList = [...state.updated];
  updatedItems == null ? void 0 : updatedItems.forEach((updatedItem) => {
    if (updatedItem == null ? void 0 : updatedItem._isNew) {
      newData = updateObjectByProperty(newData, updatedItem, "_tempId");
      return;
    }
    newData = updateObjectByProperty(newData, updatedItem, idProperty);
    newUpdatesList = [...newUpdatesList, updatedItem == null ? void 0 : updatedItem[idProperty]];
  });
  return {
    ...setLocalData(newData, state),
    updated: removeDuplicates(newUpdatesList),
    hasChanges: true
  };
};
const deleteLocal = (id, state, idProperty = "objectId") => {
  const newItems = filterByProperty(state.data, id, idProperty, true);
  const idList = getAsArray(id);
  let newCreatedItems = state.created;
  let newUpdatedItems = state.updated;
  let idsToDelete = [];
  idList.forEach((idToCheck) => {
    if (newCreatedItems.includes(idToCheck)) {
      newCreatedItems = removeFromArray(newCreatedItems, idToCheck);
    } else {
      idsToDelete = [...idsToDelete, idToCheck];
    }
    if (newUpdatedItems.includes(idToCheck)) {
      newUpdatedItems = removeFromArray(newUpdatedItems, idToCheck);
    }
  });
  return {
    ...setLocalData(newItems, state),
    created: newCreatedItems,
    updated: newUpdatedItems,
    deleted: removeDuplicates([...state.deleted, ...idsToDelete])
  };
};
const resetToApiData = (state) => ({
  ...state,
  data: state.apiData,
  created: [],
  updated: [],
  deleted: [],
  hasChanges: false
});
const deleteItemSuccess = (itemId, state, idProperty = "objectId") => {
  const newItems = filterByProperty(state.data, itemId, idProperty, true);
  return {
    ...setDataSuccess(newItems, state),
    deleted: filterByProperty(state.deleted, itemId, idProperty, true)
  };
};
const finishSaveLocal = (state, responseData, getData2, property = "objectId") => {
  const createdIds = flatten(responseData.created, "_tempId");
  const updatedIds = flatten(responseData.updated, property);
  const newCreated = removeFromArray(state.created, flatten(responseData.created, property));
  const newUpdated = removeFromArray(state.updated, flatten(responseData.updated, property));
  const newDeleted = removeFromArray(state.deleted, flatten(responseData.deleted, property));
  const newData = state.data.map((item) => {
    var _a, _b2;
    if (createdIds.includes(item == null ? void 0 : item._tempId)) {
      return {
        ...getData2((_a = findObjectByProperty(responseData.created, item == null ? void 0 : item._tempId, "_tempId")) == null ? void 0 : _a.data),
        _isNew: false
      };
    }
    if (updatedIds.includes(item == null ? void 0 : item.id)) {
      return {
        ...getData2((_b2 = findObjectByProperty(responseData.updated, item == null ? void 0 : item.id, property)) == null ? void 0 : _b2.data),
        _isNew: false
      };
    }
    return item;
  });
  return {
    ...state,
    data: newData,
    created: newCreated,
    updated: newUpdated,
    deleted: newDeleted
  };
};
const updateApiState = (name2, state, action, transformData = (item) => item, overrides = {}, idProperty = "id", updateWhilePending = false, customPluralName = null) => {
  const pluralName = customPluralName ?? `${name2}S`;
  const mappedActions = {
    // Fetch
    [`FETCH_${pluralName}_PENDING`]: () => setPending(state),
    [`FETCH_${pluralName}_SUCCESS`]: () => {
      var _a;
      if (isEmpty((_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.data)) {
        return setDataSuccess([], state);
      }
      const data = action.payload.data.map((item) => transformData(item));
      return setDataSuccess(data, state);
    },
    [`FETCH_${pluralName}_FAILURE`]: () => setFailed(state, action.payload.error),
    // Create
    [`CREATE_${name2}_PENDING`]: () => {
      var _a;
      return createItemPending(
        action.payload.data,
        state,
        !((_a = action.payload) == null ? void 0 : _a.fromLocal) && updateWhilePending
      );
    },
    [`CREATE_${name2}_SUCCESS`]: () => {
      var _a;
      return createItemSuccess(
        transformData(action.payload.data),
        state,
        (_a = action.payload) == null ? void 0 : _a.tempId,
        updateWhilePending
      );
    },
    [`CREATE_${name2}_FAILURE`]: () => createItemFailure(state, action.payload.error),
    // Update
    [`UPDATE_${name2}_PENDING`]: () => {
      const updatedItem = transformData(action.payload.data);
      return updateItemPending(updatedItem, state, idProperty);
    },
    [`UPDATE_${name2}_SUCCESS`]: () => {
      const updatedItemSuccess = transformData(action.payload.data);
      return updateItemSuccess(updatedItemSuccess, state, idProperty);
    },
    [`UPDATE_${name2}_FAILURE`]: () => updateItemFailure(state, action.payload.error),
    // Delete
    [`DELETE_${name2}_PENDING`]: () => deleteItemPending(action.payload, state, idProperty, updateWhilePending),
    [`DELETE_${name2}_SUCCESS`]: () => {
      var _a;
      return deleteItemSuccess((_a = action.payload) == null ? void 0 : _a.id, state, idProperty);
    },
    [`DELETE_${name2}_FAILURE`]: () => deleteItemFailure(state, action.payload.error),
    // Bulk update
    [`UPDATE_${pluralName}_PENDING`]: () => bulkUpdatePending(action.payload.data, state),
    [`UPDATE_${pluralName}_SUCCESS`]: () => (
      // TODO this might not work
      bulkUpdateSuccess(action.payload, state)
    ),
    [`UPDATE_${pluralName}_FAILURE`]: () => updateItemFailure(state, action.payload.error),
    // Bulk delete
    [`DELETE_${pluralName}_PENDING`]: () => {
      const itemsToKeep = state.data.filter((item) => !action.payload.includes(item == null ? void 0 : item[idProperty]));
      return {
        ...state,
        data: itemsToKeep,
        pending: true,
        error: ""
      };
    },
    [`DELETE_${pluralName}_SUCCESS`]: () => deleteItemSuccess(action.payload, state, idProperty),
    [`DELETE_${pluralName}_FAILURE`]: () => deleteItemFailure(state, action.payload.error),
    // Local functions. When making lots of local changes and saving in bulk
    [`CREATE_LOCAL_${name2}`]: () => {
      const newItem = {
        ...transformData(action.payload),
        _isNew: true
      };
      return createLocal(newItem, state);
    },
    [`CREATE_LOCAL_${pluralName}`]: () => {
      const newItems = action.payload.map((item) => ({
        ...transformData(item),
        _isNew: true
      }));
      return createLocalItems$1(newItems, state);
    },
    [`UPDATE_LOCAL_${name2}`]: () => updateLocal(action.payload, state, idProperty),
    [`DELETE_LOCAL_${pluralName}`]: () => deleteLocal(action.payload, state, idProperty),
    [`UPDATE_LOCAL_${pluralName}`]: () => {
      return bulkUpdateLocal(action.payload, state, "id");
    },
    [`CLEAR_${pluralName}`]: () => clear(state),
    [`RESET_${pluralName}`]: () => resetToApiData(state),
    // Any of the above can be overridden if the reducer wants to do something different
    ...overrides
  };
  if (Object.keys(mappedActions).includes(action.type)) {
    return mappedActions[action.type]();
  }
  return state;
};
const initialState$C = {
  ...getInitialApiItemState()
};
const name$3 = "OBEE_AREA";
const handleAdditionalState$1 = (state, action) => {
  switch (action.type) {
    case UPDATE_OBEE_FLOORPLAN_SUCCESS:
      return finishSaveLocal(state, action.payload.areas, getData$f);
    default:
      return state;
  }
};
const areasReducer = (state = initialState$C, action) => {
  const overrides = {};
  const newState = updateApiState(name$3, state, action, getData$f, overrides, "id");
  return handleAdditionalState$1(newState, action);
};
const dailyNoteCategoryPropTypes = PropTypes.shape({
  id: PropTypes.number,
  category: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colour: PropTypes.string
});
const dailyNoteCategoriesPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(dailyNoteCategoryPropTypes),
  apiData: PropTypes.arrayOf(dailyNoteCategoryPropTypes),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const getData$e = (dailyNoteCategory) => {
  return {
    ...dailyNoteCategory
  };
};
const initialState$B = {
  ...getInitialApiItemState([])
};
const dailyNoteCategoriesReducer = (state = initialState$B, action) => {
  const overrides = {};
  return updateApiState(
    "DAILY_NOTE_CATEGORY",
    state,
    action,
    getData$e,
    overrides,
    "id",
    false,
    "DAILY_NOTE_CATEGORIES"
  );
};
const floorplanTablePropTypes = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string,
  rotation: PropTypes.number,
  scale: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  originalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
const floorplanAreaPropTypes = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
  levelId: PropTypes.number,
  isRectangle: PropTypes.bool,
  points: PropTypes.arrayOf(
    PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    })
  ),
  originalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
const floorplanDataPropTypes = PropTypes.shape({
  id: PropTypes.number,
  width: PropTypes.number,
  // calculated when fetched
  height: PropTypes.number,
  levels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      priority: PropTypes.number
    })
  ),
  areas: PropTypes.arrayOf(floorplanAreaPropTypes),
  tables: PropTypes.arrayOf(floorplanTablePropTypes),
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      areaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      type: PropTypes.string,
      rotation: PropTypes.number,
      x: PropTypes.number,
      y: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number,
      points: PropTypes.arrayOf(
        // Only used for line
        PropTypes.shape({
          x: PropTypes.number,
          y: PropTypes.number
        })
      ),
      text: PropTypes.string
      // Only used for textbox
    })
  )
});
const floorplanPropTypes = PropTypes.shape({
  data: floorplanDataPropTypes,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const areaIsRectangular = (points) => {
  const isOrthogonal = (a2, b2, c2) => {
    return (b2.x - a2.x) * (b2.x - c2.x) + (b2.y - a2.y) * (b2.y - c2.y) === 0;
  };
  if ((points == null ? void 0 : points.length) !== 4) {
    return false;
  }
  const a = points[0];
  const b = points[1];
  const c = points[2];
  const d = points[3];
  return isOrthogonal(a, b, c) && isOrthogonal(b, c, d) && isOrthogonal(c, d, a);
};
const areaIsBigEnough = (area) => {
  if (isEmpty(area == null ? void 0 : area.points)) {
    return false;
  }
  const minX = ((area == null ? void 0 : area.points) || []).reduce((accum, point) => Math.min(point.x, accum), 9999);
  const minY = ((area == null ? void 0 : area.points) || []).reduce((accum, point) => Math.min(point.y, accum), 9999);
  const maxX = ((area == null ? void 0 : area.points) || []).reduce((accum, point) => Math.max(point.x, accum), 0);
  const maxY = ((area == null ? void 0 : area.points) || []).reduce((accum, point) => Math.max(point.y, accum), 0);
  const tooSmallLength = 20;
  return Math.abs(maxX - minX) > tooSmallLength && Math.abs(maxY - minY) > tooSmallLength;
};
const getAreaData = (area, width = 1e3, height = 200) => {
  const points = areaIsBigEnough(area) ? area == null ? void 0 : area.points : [
    { x: 0, y: 0 },
    { x: 0, y: height },
    { x: width, y: height },
    { x: width, y: 0 }
  ];
  return {
    ...area,
    isRectangle: areaIsRectangular(points),
    type: (area == null ? void 0 : area.type) || "indoor",
    x: (area == null ? void 0 : area.x) || 5,
    y: (area == null ? void 0 : area.y) || 5,
    levelId: parseInt(area == null ? void 0 : area.levelId, 10) || null,
    points
  };
};
const getData$d = (floorplanString) => {
  const floorplanData = JSON.parse(floorplanString);
  const areas = (floorplanData == null ? void 0 : floorplanData.areas) || [];
  const areasData = areas == null ? void 0 : areas.map((area) => getAreaData(area));
  let width = 500;
  let height = 500;
  areasData == null ? void 0 : areasData.forEach((floorplanArea) => {
    var _a;
    (_a = floorplanArea == null ? void 0 : floorplanArea.points) == null ? void 0 : _a.forEach((point) => {
      if (point.x + floorplanArea.x > width) {
        width = point.x + floorplanArea.x;
      }
      if (point.y + floorplanArea.y > height) {
        height = point.y + floorplanArea.y;
      }
    });
  });
  const elementsData = ((floorplanData == null ? void 0 : floorplanData.elements) || []).filter((element) => element == null ? void 0 : element.id);
  return {
    width,
    height,
    areas: areasData,
    tables: (floorplanData == null ? void 0 : floorplanData.tables) || [],
    elements: elementsData,
    levels: (floorplanData == null ? void 0 : floorplanData.levels) || []
  };
};
const tableTypes = [
  { label: "Round", value: "round" },
  { label: "Rectangle", value: "rectangle" },
  { label: "Square", value: "square" },
  { label: "Long", value: "long" },
  { label: "Bar seats", value: "bar" }
];
const getDefaultSeatsForType = (type2) => {
  if (type2 === "bar") {
    return 1;
  }
  if (type2 === "long") {
    return 6;
  }
  return 4;
};
const getDefaultAreaValues = (yOffset = 0) => ({
  type: "indoor",
  x: 5,
  y: 5 + yOffset,
  levelId: 0,
  isRectangle: true,
  points: [
    { x: 0, y: 0 },
    { x: 0, y: 400 },
    { x: 1e3, y: 400 },
    { x: 1e3, y: 0 }
  ]
});
const initialState$A = {
  data: {},
  // The copy of the data that will be modified locally
  apiData: {},
  // The copy of the data that is up-to-date with the api
  hasChanges: false,
  // Whether the data has differed from the API data
  history: {
    undo: [],
    redo: []
  },
  // List of changes that can be undone
  error: "",
  pending: false,
  success: false
};
const floorplanReducer = (state = initialState$A, action) => {
  var _a;
  switch (action.type) {
    case FETCH_OBEE_FLOORPLAN_PENDING:
      return setPending(state);
    case FETCH_OBEE_FLOORPLAN_SUCCESS:
      return setDataSuccess(getData$d(action.payload.data), state);
    case FETCH_OBEE_FLOORPLAN_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_OBEE_FLOORPLAN_PENDING:
      const updatedFloorplanPending = getData$d(action.payload.data);
      return setDataPending(updatedFloorplanPending, state);
    case UPDATE_OBEE_FLOORPLAN_SUCCESS:
      return { ...setSuccess(state), history: { undo: [], redo: [] } };
    case UPDATE_OBEE_FLOORPLAN_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case UPDATE_OBEE_FLOORPLAN_LOCAL:
      return setLocalDataWithHistory(getData$d((_a = action.payload) == null ? void 0 : _a.data), state);
    case UNDO_UPDATE_OBEE_FLOORPLAN_LOCAL:
      return undo(state);
    case REDO_UPDATE_OBEE_FLOORPLAN_LOCAL:
      return redo(state);
    case RESET_OBEE_FLOORPLAN:
      return resetToApiData$1(state);
    case SAVE_FLOORPLAN_PENDING:
      return setPending(state);
    default:
      return state;
  }
};
const initialState$z = {
  formEditingId: null,
  hasUnsavedChanges: false
};
const formReducer = (state = initialState$z, action) => {
  var _a, _b2, _c2;
  switch (action.type) {
    case SET_FORM_EDITING:
      return {
        ...state,
        formEditingId: (_a = action.payload) == null ? void 0 : _a.formId,
        hasUnsavedChanges: (_b2 = action.payload) == null ? void 0 : _b2.hasUnsavedChanges
      };
    case CLEAR_FORM_EDITING:
      return initialState$z;
    case SET_HAS_UNSAVED_CHANGES:
      return {
        ...state,
        hasUnsavedChanges: (_c2 = action.payload) == null ? void 0 : _c2.hasUnsavedChanges
      };
    default:
      return state;
  }
};
const initialState$y = {
  data: {},
  // The copy of the data that will be modified locally
  apiData: {},
  // The copy of the data that is up-to-date with the api
  error: "",
  pending: false,
  success: false
};
const facebookRedirectUrlReducer = (state = initialState$y, action) => {
  switch (action.type) {
    case GET_FACEBOOK_REDIRECT_URL_PENDING:
      return setPending(state);
    case GET_FACEBOOK_REDIRECT_URL_SUCCESS:
      devLog("info", "callback success", action);
      return setFetchSuccess(JSON.parse(action.payload.data), state);
    case GET_FACEBOOK_REDIRECT_URL_FAILURE:
      devLog("error", "callback fail", action);
      return setFailed(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$x = {
  data: {},
  // The copy of the data that will be modified locally
  apiData: {},
  // The copy of the data that is up-to-date with the api
  error: "",
  pending: false,
  success: false
};
const metaCallbackReducer = (state = initialState$x, action) => {
  switch (action.type) {
    case COMPLETE_META_CALLBACK_PENDING:
      return setPending(state);
    case COMPLETE_META_CALLBACK_SUCCESS:
      devLog("info", "callback success", action);
      return setFetchSuccess(action.payload.data, state);
    case COMPLETE_META_CALLBACK_FAILURE:
      devLog("info", "callback fail", action);
      return setFailed(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$w = {
  error: "",
  pending: false,
  success: false
};
const metaIntegrationReducer = (state = initialState$w, action) => {
  switch (action.type) {
    case DISABLE_META_INTEGRATION_PENDING:
      devLog("info", "meta", "disable meta pending");
      return setPending(state);
    case DISABLE_META_INTEGRATION_SUCCESS:
      return setSuccess(state);
    case DISABLE_META_INTEGRATION_FAILURE:
      return setFailed(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$v = {
  data: "",
  apiData: "",
  error: "",
  pending: false,
  success: false
};
const metaLoginButtonReducer = (state = initialState$v, action) => {
  var _a, _b2;
  switch (action.type) {
    case GENERATE_FB_LOGIN_BUTTON_PENDING:
      return setPending(state);
    case GENERATE_FB_LOGIN_BUTTON_SUCCESS:
      const buttonUrl = (_b2 = safeParse((_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.data)) == null ? void 0 : _b2.fbeButtonUrl;
      return setDataSuccess(buttonUrl, state);
    case GENERATE_FB_LOGIN_BUTTON_FAILURE:
      return setFailed(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$u = {
  error: "",
  pending: false,
  success: false
};
const reserveWithGoogleReducer = (state = initialState$u, action) => {
  switch (action.type) {
    case ENABLE_RESERVE_WITH_GOOGLE_PENDING:
      return setPending(state);
    case ENABLE_RESERVE_WITH_GOOGLE_SUCCESS:
      return setSuccess(state);
    case ENABLE_RESERVE_WITH_GOOGLE_FAILURE:
      return setFailed(state, action.payload.error);
    case DISABLE_RESERVE_WITH_GOOGLE_PENDING:
      return setPending(state);
    case DISABLE_RESERVE_WITH_GOOGLE_SUCCESS:
      return setSuccess(state);
    case DISABLE_RESERVE_WITH_GOOGLE_FAILURE:
      return setFailed(state, action.payload.error);
    default:
      return state;
  }
};
const messagesSettingPropTypes = PropTypes.shape({
  confirmationEmail: PropTypes.bool,
  confirmationSMS: PropTypes.bool,
  reminderEmail: PropTypes.bool,
  reminderSMS: PropTypes.bool,
  thankYouEmail: PropTypes.bool,
  cancellationEmail: PropTypes.bool,
  waitlistEmail: PropTypes.bool
});
const messagesSettingsPropTypes = PropTypes.shape({
  apiData: messagesSettingPropTypes,
  data: messagesSettingPropTypes,
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const getData$c = (settings) => {
  const settingsData = {
    ...settings,
    confirmationEmail: (settings == null ? void 0 : settings.confirmationEmail) || false,
    confirmationSMS: (settings == null ? void 0 : settings.confirmationSMS) || false,
    reminderEmail: (settings == null ? void 0 : settings.reminderEmail) || false,
    reminderSMS: (settings == null ? void 0 : settings.reminderSMS) || false,
    thankYouEmail: (settings == null ? void 0 : settings.thankYouEmail) || false,
    cancellationEmail: (settings == null ? void 0 : settings.cancellationEmail) || false,
    waitlistEmail: (settings == null ? void 0 : settings.waitlistEmail) || false
  };
  return settingsData;
};
const MessagesSettingsInputKeys = () => [
  "confirmationEmail",
  "confirmationSMS",
  "reminderEmail",
  "reminderSMS",
  "thankYouEmail",
  "cancellationEmail",
  "waitlistEmail"
];
const initialState$t = {
  apiData: {},
  data: {},
  error: "",
  pending: false,
  success: false
};
const messagesSettingsReducer = (state = initialState$t, action) => {
  switch (action.type) {
    case FETCH_MESSAGES_SETTINGS_PENDING:
      return setPending(state);
    case FETCH_MESSAGES_SETTINGS_SUCCESS:
      return setDataSuccess(getData$c(action.payload.data), state);
    case FETCH_MESSAGES_SETTINGS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_MESSAGES_SETTING_PENDING:
      return {
        ...state,
        data: { ...state.data, ...action.payload.data },
        pending: true,
        success: false,
        error: ""
      };
    case UPDATE_MESSAGES_SETTING_SUCCESS:
      const newItems = { ...state.data, ...getData$c(action.payload.data) };
      return {
        ...state,
        apiData: newItems,
        data: newItems,
        pending: false,
        success: true,
        error: ""
      };
    case UPDATE_MESSAGES_SETTING_FAILURE:
      return { ...state, data: state.apiData, pending: false, error: action.payload.error };
    default:
      return state;
  }
};
const obeeAvailabilityPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(PropTypes.shape({})),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
PropTypes.shape({
  data: PropTypes.arrayOf(PropTypes.shape({})),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const tableIsJoin$1 = (tableNumber) => tableNumber == null ? void 0 : tableNumber.includes(",");
const getData$b = (table) => {
  const tableNumbers = safeSplit(table == null ? void 0 : table.tableNumber).sort(sortAlphaNumeric);
  return {
    ...table,
    minSeats: table == null ? void 0 : table.min,
    // todo this is actually redundant, but a better name
    maxSeats: table == null ? void 0 : table.max,
    isPublic: (table == null ? void 0 : table.isPublic) !== false,
    isJoin: tableIsJoin$1(table.tableNumber),
    blocks: (table == null ? void 0 : table.blocks) || [],
    // Default to empty array
    duration: table == null ? void 0 : table.duration,
    tableNumbers
  };
};
const initialState$s = {
  data: [],
  error: "",
  pending: false,
  success: false
};
const obeeAvailabilityReducer = (state = initialState$s, action) => {
  var _a;
  switch (action.type) {
    case CHECK_OBEE_AVAILABILITY_PENDING:
      return setPending(state);
    case CHECK_OBEE_AVAILABILITY_SUCCESS:
      return setDataSuccess(
        (_a = action.payload.data) == null ? void 0 : _a.map((table) => getData$b(table)),
        // get `isJoin` and additional table information
        state
      );
    case CHECK_OBEE_AVAILABILITY_FAILURE:
      return setFailed(state, action.payload.error);
    case CLEAR_OBEE_AVAILABILITY:
      return clear$1(state);
    default:
      return state;
  }
};
const initialState$r = {
  data: [],
  error: "",
  pending: false,
  success: false
};
const obeeAvailabilitySuggestionsReducer = (state = initialState$r, action) => {
  switch (action.type) {
    case GET_OBEE_AVAILABILITY_SUGGESTIONS_PENDING:
      return setPending(state);
    case GET_OBEE_AVAILABILITY_SUGGESTIONS_SUCCESS:
      const tablesForArea = action.payload.data;
      const { areaId } = action.payload;
      const newData = {
        ...state.data,
        [areaId]: tablesForArea
      };
      return setDataSuccess(newData, state);
    case GET_OBEE_AVAILABILITY_SUGGESTIONS_FAILURE:
      return setFailed(state, action.payload.error);
    case CLEAR_GET_OBEE_AVAILABILITY_SUGGESTIONS:
      return clear$1(state);
    default:
      return state;
  }
};
const initialState$q = {
  apiData: [],
  data: [],
  error: "",
  errorData: { errors: {}, extras: {} },
  pending: false,
  success: false
};
const obeeBookingsReducer = (state = initialState$q, action) => {
  var _a, _b2, _c2;
  switch (action.type) {
    case FETCH_OBEE_BOOKINGS_PENDING:
      return setPending(state);
    case FETCH_OBEE_BOOKINGS_SUCCESS:
      const convertedItems = action.payload.data.map(getData$i);
      return setFetchSuccess(convertedItems, state);
    case FETCH_OBEE_BOOKINGS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_OBEE_BOOKING_PENDING:
      return updateItemPending(getData$i(action.payload.data), state);
    case UPDATE_OBEE_BOOKING_SUCCESS:
      return updateItemSuccess$1(getData$i(action.payload.data), state);
    case UPDATE_OBEE_BOOKING_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case CONFIRM_WAITLIST_SUCCESS:
      return updateItemSuccess$1(getData$i(action.payload.data), state);
    case CONFIRM_WAITLIST_PENDING:
      return updateItemPending(getData$i(action.payload.data), state);
    case CONFIRM_WAITLIST_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case CONFIRM_WAITLIST_AS_BOOKED_SUCCESS:
      return updateItemSuccess$1(getData$i(action.payload.data), state);
    case CONFIRM_WAITLIST_AS_BOOKED_PENDING:
      return updateItemPending(getData$i(action.payload.data), state);
    case CONFIRM_WAITLIST_AS_BOOKED_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case CREATE_OBEE_BOOKING_PENDING:
      return createItemPending(action.payload.data, state);
    case CREATE_OBEE_BOOKING_SUCCESS:
      const newItemData = getData$i(action.payload.data);
      return createItemSuccess$1(newItemData, state);
    case CREATE_OBEE_BOOKING_FAILURE:
      const errorMessage = (_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.error;
      return createItemFailure(state, errorMessage, (_b2 = action == null ? void 0 : action.payload) == null ? void 0 : _b2.errorData);
    case RESUBMIT_OBEE_BOOKING_PENDING:
      return updateItemPending(getData$i(action.payload.data), state);
    case RESUBMIT_OBEE_BOOKING_SUCCESS:
      return updateItemSuccess$1(getData$i(action.payload.data), state);
    case RESUBMIT_OBEE_BOOKING_FAILURE:
      return updateItemFailure(state, action.payload.error, (_c2 = action.payload) == null ? void 0 : _c2.errorData);
    case UPDATE_OBEE_GUEST_SUCCESS:
      const updatedGuest = action.payload.data;
      const updatedBookings = state.data.map((booking) => {
        var _a2;
        if (((_a2 = booking.guests) == null ? void 0 : _a2.length) > 0) {
          const updatedGuests = updateObjectByProperty(
            booking.guests,
            convertGuestApiData(updatedGuest),
            "id"
          );
          return { ...booking, guests: updatedGuests };
        }
        return booking;
      });
      return { ...state, data: updatedBookings, apiData: updatedBookings };
    case CHARGE_NO_SHOW_SUCCESS:
      const {
        ccNoShowChargeStatus,
        ccNoShowFee,
        ccNoShowChargeType,
        ccNoShowChargeTime,
        ccNoShowPaymentIntentId
      } = safeParse(action.payload.data);
      const newBookings = state.data.map((booking) => {
        var _a2;
        if (booking.id === ((_a2 = action.payload) == null ? void 0 : _a2.obBookingId)) {
          return {
            ...booking,
            ccNoShowChargeStatus,
            ccNoShowFee,
            ccNoShowChargeType,
            ccNoShowChargeTime,
            ccNoShowPaymentIntentId
          };
        }
        return booking;
      });
      return setDataSuccess(newBookings, state);
    case SEND_WAITLIST_SMS_SUCCESS:
      const newBookingsWithSms = state.data.map((booking) => {
        var _a2;
        if (booking.id === ((_a2 = action.payload) == null ? void 0 : _a2.bookingId)) {
          const waitlistSMS = {
            responseMessage: "",
            dateTimeSent: moment().format("YYYY-MM-DD HH:mm:ss")
          };
          return {
            ...booking,
            waitlistSMS
          };
        }
        return booking;
      });
      return setDataSuccess(newBookingsWithSms, state);
    case SEND_GUEST_EMAIL_SUCCESS: {
      const newBookingsWithEmailHistory = state.data.map((booking) => {
        var _a2, _b3;
        if (booking.id === ((_a2 = action.payload) == null ? void 0 : _a2.bookingId)) {
          const emailHistory = [
            {
              emailType: (_b3 = action.payload) == null ? void 0 : _b3.emailType,
              dateTimeSent: moment().format("YYYY-MM-DD HH:mm:ss")
            },
            ...booking.emailHistory
          ];
          return {
            ...booking,
            commsHistory: JSON.stringify({
              emailHistory,
              smsHistory: booking.smsHistory
            }),
            emailHistory
          };
        }
        return booking;
      });
      return setDataSuccess(newBookingsWithEmailHistory, state);
    }
    case SEND_GUEST_SMS_SUCCESS: {
      const newBookingsWithSmsHistory = state.data.map((booking) => {
        var _a2, _b3;
        if (booking.id === ((_a2 = action.payload) == null ? void 0 : _a2.bookingId)) {
          const smsHistory = [
            {
              smsType: (_b3 = action.payload) == null ? void 0 : _b3.smsType,
              dateTimeSent: moment().format("YYYY-MM-DD HH:mm:ss")
            },
            ...booking.smsHistory
          ];
          return {
            ...booking,
            commsHistory: JSON.stringify({
              emailHistory: booking.emailHistory,
              smsHistory
            }),
            smsHistory
          };
        }
        return booking;
      });
      return setDataSuccess(newBookingsWithSmsHistory, state);
    }
    case CLEAR_OBEE_BOOKINGS:
      return clear$1(state);
    default:
      return state;
  }
};
const obeeSettingPropTypes = PropTypes.shape({
  daysInAdvance: PropTypes.number,
  systemTimeInterval: PropTypes.number,
  bookingsDuration: PropTypes.number,
  waitlist: PropTypes.bool,
  abHighchairs: PropTypes.bool,
  abVaccination: PropTypes.bool,
  // depreciated
  abTakenBy: PropTypes.string,
  abConfirmation: PropTypes.bool,
  // depreciated
  ccCapture: PropTypes.bool,
  ccNoShowFee: PropTypes.number,
  ccNoShowChargeType: PropTypes.oneOf(["guest", "group"]),
  ccPaymentPolicy: PropTypes.string,
  ccWaitlistShow: PropTypes.string,
  ccWaitlistPolicy: PropTypes.string,
  ccAddBookings: PropTypes.string,
  terms: PropTypes.string,
  logo: PropTypes.string,
  heroImage: PropTypes.string,
  favicon: PropTypes.string,
  stepperColor: PropTypes.string,
  iconBgColor: PropTypes.string,
  datePickerColor: PropTypes.string,
  linkColor: PropTypes.string,
  availableTimesColor: PropTypes.string,
  formBgColor: PropTypes.string,
  venueMessage: PropTypes.string,
  disabledAccess: PropTypes.string,
  dressCode: PropTypes.string,
  kidFriendly: PropTypes.string,
  kidsPlayArea: PropTypes.string,
  byo: PropTypes.string,
  corkage: PropTypes.string,
  cakeage: PropTypes.string,
  showHighchairs: PropTypes.bool,
  groupSizeLimit: PropTypes.number,
  groupSizeMessage: PropTypes.string,
  areaPhotos: PropTypes.arrayOf(PropTypes.string),
  slug: PropTypes.string,
  openingHoursStyle: PropTypes.string,
  cutoffMode: PropTypes.string,
  cutoffValue: PropTypes.string,
  hasCustomDuration: PropTypes.bool,
  // Optimisation to prevent an extra check if not using custom durations
  hasVoucherRedeem: PropTypes.bool,
  customOverrides: PropTypes.shape({}),
  hasPaymentSettings: PropTypes.bool,
  messaging: PropTypes.shape({
    waitlistSmsSettings: PropTypes.shape({
      enabled: PropTypes.bool,
      // true,
      smsBody: PropTypes.string,
      // "Hi [fname], your table for [size] people is [x]. Reply 'y' to confirm. Cheers Demo Simone V3",
      allowResponse: PropTypes.bool,
      // true,
      quickOption1: PropTypes.string,
      // 'now ready',
      quickOption2: PropTypes.string,
      // 'ready in 5 mins',
      quickOption3: PropTypes.string,
      // '',
      showWaitlistCounter: PropTypes.bool,
      // false,
      showBuzzerNumber: PropTypes.bool,
      // false,
      showQuotedTime: PropTypes.bool,
      // false,
      showTableNumberField: PropTypes.bool
      // false,
    })
  }),
  addBookingSettings: PropTypes.shape({}),
  showSMSConfirmation: PropTypes.bool,
  showSMSConfirmationDefaultChecked: PropTypes.bool,
  showEmailConfirmation: PropTypes.bool,
  showEmailConfirmationDefaultChecked: PropTypes.bool,
  runsheetSettings: PropTypes.shape({}),
  defaultLandingPage: PropTypes.string
});
const obeeSettingsPropTypes = PropTypes.shape({
  apiData: obeeSettingPropTypes,
  data: obeeSettingPropTypes,
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const ccAddBookingsValues = {
  off: "off",
  optional: "optional",
  mandatory: "mandatory"
};
const RUNSHEET_DISPLAYMODE_OVERVIEW_OPTIONS = {
  "Finished bookings": true,
  Cancellations: true,
  "Payment history": true,
  "Booked on": false,
  "Taken by": true,
  Source: true
};
const getData$a = (settings) => {
  var _a, _b2;
  const addBookingSettings = safeParse(settings == null ? void 0 : settings.addBookingSettings);
  const runsheetSettings = safeParse(settings == null ? void 0 : settings.runsheetSettings);
  const localRunSheetTimeSeparator = loadItem("runsheetTimeSeparator");
  if (localRunSheetTimeSeparator === void 0) {
    saveItem("runsheetTimeSeparator", (runsheetSettings == null ? void 0 : runsheetSettings.runsheetSeparatorSeconds) > 0);
    saveItem("runsheetTimeSeparatorInterval", (runsheetSettings == null ? void 0 : runsheetSettings.runsheetSeparatorSeconds) ?? 3600);
  }
  const localRunSheetDisplayModeOverview = loadItem("runsheetDisplayModeOverview");
  if (localRunSheetDisplayModeOverview === void 0) {
    saveItem("runsheetDisplayModeOverview", {
      ...RUNSHEET_DISPLAYMODE_OVERVIEW_OPTIONS,
      Cancellations: ((_a = runsheetSettings == null ? void 0 : runsheetSettings.dailyViewOptions) == null ? void 0 : _a.showCancelled) === 1,
      "Payment history": ((_b2 = runsheetSettings == null ? void 0 : runsheetSettings.dailyViewOptions) == null ? void 0 : _b2.showPaymentsHistory) === 1
    });
  }
  const requireTakenBy = () => {
    var _a2;
    if (!isObee()) {
      return (settings == null ? void 0 : settings.abTakenBy) || "off";
    }
    if ((addBookingSettings == null ? void 0 : addBookingSettings.showRequireTakenBy) === true) {
      if ((_a2 = addBookingSettings == null ? void 0 : addBookingSettings.takenBySettings) == null ? void 0 : _a2.compulsoryOnAllBookings) {
        return "mandatory";
      }
      return "optional";
    }
    return "off";
  };
  const settingsData = {
    ...settings,
    daysInAdvance: nullIfNegative(settings.daysInAdvance) || 60,
    // The maximum amount of days that can be booked in advance. Fallback to 60 days.
    bookingsDuration: nullIfNegative(settings.bookingsDuration) || 60,
    // Fallback to 60 mins.
    systemTimeInterval: nullIfNegative(settings.systemTimeInterval) || 15,
    // Fallback to 15 mins.
    abHighchairs: settings.abHighchairs || false,
    // Fallback to false.
    abTakenBy: requireTakenBy(),
    ccCapture: settings.ccCapture || false,
    // Fallback to false. Obee will always try to get cc payment info separately
    ccNoShowFee: nullIfNegative(settings.ccNoShowFee) || 0,
    // Fallback to ($)0.
    ccNoShowChargeType: (settings == null ? void 0 : settings.ccNoShowChargeType) || "guest",
    // guest is the default
    ccPaymentPolicy: (settings == null ? void 0 : settings.ccPaymentPolicy) || "",
    // Fallback to empty.
    ccWaitlistShow: (settings == null ? void 0 : settings.ccWaitlistShow) || "off",
    // Fallback to off.
    ccWaitlistPolicy: (settings == null ? void 0 : settings.ccWaitlistPolicy) || "",
    // Fallback to empty.
    ccAddBookings: (settings == null ? void 0 : settings.ccAddBookings) || "off",
    // Fallback to off.
    terms: settings.terms || "",
    // Fallback to empty.
    cutoffMode: settings.cutoffMode || "off",
    hasCustomDuration: settings.hasCustomDuration || false,
    customOverrides: safeParse(settings.customOverrides) || {},
    hasPaymentSettings: (settings == null ? void 0 : settings.hasPaymentSettings) || false,
    hasVoucherRedeem: (settings == null ? void 0 : settings.hasVoucherRedeem) || false,
    messaging: safeParse(settings == null ? void 0 : settings.messaging) || {},
    showSMSConfirmation: addBookingSettings == null ? void 0 : addBookingSettings.showConfirmationSmsOption,
    showSMSConfirmationDefaultChecked: addBookingSettings == null ? void 0 : addBookingSettings.showConfirmationSmsOptionDefault,
    showEmailConfirmation: addBookingSettings == null ? void 0 : addBookingSettings.showConfirmationEmailOption,
    showEmailConfirmationDefaultChecked: addBookingSettings == null ? void 0 : addBookingSettings.showConfirmationEmailOptionDefault,
    addBookingSettings,
    runsheetSettings,
    defaultLandingPage: (settings == null ? void 0 : settings.defaultLandingPage) || "runsheet"
  };
  return settingsData;
};
const showField = (settingValue) => ["optional", "mandatory"].includes(settingValue);
const OBSettingsInputKeys = () => [
  "daysInAdvance",
  "systemTimeInterval",
  "bookingsDuration",
  "waitlist",
  "abHighchairs",
  "abVaccination",
  "abTakenBy",
  "abConfirmation",
  "ccCapture",
  "ccNoShowFee",
  "ccNoShowChargeType",
  "ccPaymentPolicy",
  "ccWaitlistShow",
  "ccWaitlistPolicy",
  "ccAddBookings",
  "terms",
  "logo",
  "heroImage",
  "favicon",
  "stepperColor",
  "iconBgColor",
  "datePickerColor",
  "linkColor",
  "availableTimesColor",
  "formBgColor",
  "venueMessage",
  "disabledAccess",
  "dressCode",
  "kidFriendly",
  "kidsPlayArea",
  "byo",
  "corkage",
  "cakeage",
  "showHighchairs",
  "groupSizeLimit",
  "groupSizeMessage",
  "areaPhotos",
  "openingHoursStyle",
  "cutoffMode",
  "cutoffValue",
  "showSMSConfirmation",
  "showSMSConfirmationDefaultChecked",
  "showEmailConfirmation",
  "showEmailConfirmationDefaultChecked"
];
const getCutoffModeLabel = (cutoffMode) => {
  switch (cutoffMode) {
    case "set_time":
      return "Fixed cut-off";
    case "hours_before":
      return "Sessional cut-off";
    case "rolling":
      return "Rolling cut-off";
    default:
      return "";
  }
};
const RUNSHEET_DISPLAYMODE = {
  ALL: "all",
  FILTERED: "filtered"
};
const RUNSHEET_SORTABLE_HEADERS = {
  arrival: {
    label: "Arrival",
    sortKey: "startTime"
  },
  area: {
    label: "Area",
    sortKey: "areaName"
  },
  table: {
    label: "Table",
    sortKey: "tableNumber"
  },
  guest: {
    label: "Guest",
    sortKey: "name"
  },
  party: {
    label: "Party",
    sortKey: "size"
  },
  comments: {
    label: "Comments",
    sortKey: "fullComments"
  },
  source: {
    label: "Source",
    sortKey: "source"
  }
};
const DEFAULT_SORTABLE = {
  column: RUNSHEET_SORTABLE_HEADERS.arrival,
  direction: "asc"
};
const wasDateChangedToday = sessionStorage.getItem("dateSetOn") === moment$2().format("YYYY-MM-DD") && sessionStorage.getItem("date");
const getInitialInterval = () => {
  const initialInterval = parseInt(safeParse(localStorage.getItem("runsheetTimeSeparatorInterval")), 10) ?? 3600;
  if (Number.isNaN(initialInterval) || isVoid(initialInterval)) {
    return 3600;
  }
  return initialInterval;
};
const initialState$p = {
  date: wasDateChangedToday ? moment$2(sessionStorage.getItem("date"), "YYYY-MM-DD") : moment$2(),
  // Not sure if this is a good idea. Might be fine because it's initial state?
  calendarMonth: moment$2().format("MMMM YYYY"),
  sessionFilter: "all_sessions",
  // all_sessions, morning, lunch, dinner, all_day
  addBookingModal: {
    show: false,
    quickBooking: null,
    preventChanges: false,
    defaultDate: null
  },
  bookingDetailsModal: {
    bookingId: null,
    defaultTab: "booking",
    newBookingsStatus: null
  },
  showDailyNotesModal: false,
  floorplanView: localStorage.getItem("floorplanView") || "single",
  // TODO separate below into runsheet reducer
  runsheetDisplayMode: localStorage.getItem("runsheetDisplayMode") || "filtered",
  runsheetDisplayModeOverview: safeParse(localStorage.getItem("runsheetDisplayModeOverview"), false) || RUNSHEET_DISPLAYMODE_OVERVIEW_OPTIONS,
  runsheetTimeSeparator: safeParse(localStorage.getItem("runsheetTimeSeparator")) !== false,
  runsheetTimeSeparatorInterval: getInitialInterval()
};
const obeeScreenReducer = (state = initialState$p, action) => {
  switch (action.type) {
    case SET_OBEE_DATE:
      return {
        ...state,
        date: action.payload !== "Invalid date" ? action.payload : null
        // Prevent "invalid date" getting through
      };
    case SET_CALENDAR_MONTH:
      return {
        ...state,
        calendarMonth: action.payload !== "Invalid date" ? action.payload : null
        // Prevent "invalid date" getting through
      };
    case SET_SESSION_FILTER:
      return {
        ...state,
        sessionFilter: action.payload
      };
    case SET_FLOORPLAN_VIEW:
      localStorage.setItem("floorplanView", action.payload);
      return {
        ...state,
        floorplanView: action.payload
      };
    case SET_OBEE_SHOW_ADD_BOOKING_MODAL:
      return {
        ...state,
        addBookingModal: action.payload,
        // close bookings details modal
        bookingDetailsModal: {
          bookingId: null,
          defaultTab: "booking",
          newBookingsStatus: null
        }
      };
    case SET_OBEE_BOOKING_DETAILS_MODAL:
      return {
        ...state,
        // close add booking modal
        addBookingModal: {
          show: false,
          quickBooking: null,
          preventChanges: false,
          defaultDate: null
        },
        bookingDetailsModal: action.payload
      };
    case SET_SHOW_DAILY_NOTES_MODAL:
      return {
        ...state,
        showDailyNotesModal: action.payload
      };
    case SET_RUNSHEET_DISPLAY_MODE:
      localStorage.setItem("runsheetDisplayMode", action.payload);
      return {
        ...state,
        runsheetDisplayMode: action.payload
      };
    case SET_RUNSHEET_DISPLAY_OVERVIEW:
      localStorage.setItem("runsheetDisplayModeOverview", JSON.stringify(action.payload));
      return {
        ...state,
        runsheetDisplayModeOverview: action.payload
      };
    case SET_RUNSHEET_TIME_SEPARATOR:
      saveItem("runsheetTimeSeparator", !!action.payload);
      return {
        ...state,
        runsheetTimeSeparator: action.payload
      };
    case SET_RUNSHEET_TIME_SEPARATOR_INTERVAL:
      saveItem("runsheetTimeSeparatorInterval", action.payload || 0);
      return {
        ...state,
        runsheetTimeSeparatorInterval: action.payload
      };
    default:
      return state;
  }
};
const paymentSettingPropTypes = PropTypes.shape({
  id: PropTypes.number,
  areaId: PropTypes.number,
  date: PropTypes.string,
  dateMax: PropTypes.string,
  day: PropTypes.string,
  timeOption: PropTypes.string,
  time: PropTypes.string,
  timeMax: PropTypes.string,
  sizeOption: PropTypes.string,
  size: PropTypes.number,
  sizeMax: PropTypes.number,
  source: PropTypes.string,
  mode: PropTypes.string,
  noShowAmount: PropTypes.number,
  noShowOption: PropTypes.string,
  depositAmount: PropTypes.number,
  depositOption: PropTypes.string,
  fullAmount: PropTypes.number,
  fullOption: PropTypes.string,
  currency: PropTypes.string,
  incGst: PropTypes.bool,
  title: PropTypes.string,
  shortDesc: PropTypes.string,
  policyUrl: PropTypes.string,
  policyText: PropTypes.string,
  staffPayRequired: PropTypes.bool,
  usedBy: PropTypes.string,
  priority: PropTypes.number,
  deleted: PropTypes.bool,
  amount: PropTypes.number,
  // Amount for the selected mode in dollars
  publishableKey: PropTypes.string,
  pinMode: PropTypes.string
});
const paymentSettingsPropTypes = PropTypes.shape({
  apiData: paymentSettingPropTypes,
  data: paymentSettingPropTypes,
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const getData$9 = (settings) => {
  const getAmountForMode = () => {
    switch (settings == null ? void 0 : settings.mode) {
      case "deposit":
        return settings == null ? void 0 : settings.depositAmount;
      case "full":
        return settings == null ? void 0 : settings.fullAmount;
      case "cc-store":
        return settings == null ? void 0 : settings.noShowAmount;
      default:
        return null;
    }
  };
  const settingsData = {
    ...settings,
    amount: getAmountForMode()
  };
  return settingsData;
};
const initialState$o = {
  apiData: {},
  data: {},
  error: "",
  pending: false,
  success: false
};
const paymentSettingsReducer = (state = initialState$o, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_SETTINGS_PENDING:
      return setPending(state);
    case FETCH_PAYMENT_SETTINGS_SUCCESS:
      return setDataSuccess(getData$9(action.payload.data), state);
    case FETCH_PAYMENT_SETTINGS_FAILURE:
      return setFailed(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$n = {
  ...getInitialApiItemState()
};
const sessionsReducer = (state = initialState$n, action) => {
  switch (action.type) {
    case FETCH_OBEE_SESSIONS_PENDING:
      return setFetchPending(state);
    case FETCH_OBEE_SESSIONS_SUCCESS:
      const data = action.payload.data.map((item) => getData$g(item));
      return setDataSuccess(data, state);
    case FETCH_OBEE_SESSIONS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_OBEE_SESSION_PENDING:
      const updatedSession = getData$g(action.payload.data);
      return updateItemPending(updatedSession, state);
    case UPDATE_OBEE_SESSION_SUCCESS:
      const updatedSessionSuccess = getData$g(action.payload.data);
      return updateItemSuccess$1(updatedSessionSuccess, state);
    case UPDATE_OBEE_SESSION_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case DELETE_OBEE_SESSION_PENDING:
      return deleteItemPending(action.payload.data.id, state);
    case DELETE_OBEE_SESSION_SUCCESS:
      return deleteItemSuccess$1(action.payload.id, state);
    case DELETE_OBEE_SESSION_FAILURE:
      return deleteItemFailure(state, action.payload.error);
    case CREATE_OBEE_SESSION_PENDING:
      return createItemPending(getData$g(action.payload.data), state, true);
    case CREATE_OBEE_SESSION_SUCCESS:
      return setDataSuccess([...state.data, ...action.payload.data], state);
    case CREATE_OBEE_SESSION_FAILURE:
      return createItemFailure(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$m = {
  apiData: {},
  data: {
    systemTimeInterval: 15,
    // Default so can never be undefined
    bookingsDuration: 60
    // Default
  },
  error: "",
  pending: false,
  success: false
};
const settingsReducer = (state = initialState$m, action) => {
  switch (action.type) {
    case FETCH_OBEE_SETTINGS_PENDING:
      return setPending(state);
    case FETCH_OBEE_SETTINGS_SUCCESS:
      return setDataSuccess(getData$a(action.payload.data), state);
    case FETCH_OBEE_SETTINGS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_OBEE_SETTING_PENDING:
      return {
        ...state,
        data: { ...state.data, ...action.payload.data },
        pending: true,
        success: false,
        error: ""
      };
    case UPDATE_OBEE_SETTING_SUCCESS:
      const newItems = { ...state.data, ...getData$a(action.payload.data) };
      return {
        ...state,
        apiData: newItems,
        data: newItems,
        pending: false,
        success: true,
        error: ""
      };
    case UPDATE_OBEE_SETTING_FAILURE:
      return { ...state, data: state.apiData, pending: false, error: action.payload.error };
    default:
      return state;
  }
};
const tableBlockPropTypes = PropTypes.shape({
  id: PropTypes.number,
  tableId: PropTypes.number,
  date: PropTypes.string,
  endTime: PropTypes.number,
  startTime: PropTypes.number,
  updateFlag: PropTypes.bool,
  removeFlag: PropTypes.bool,
  singleBlockId: PropTypes.number
});
const tablePropTypes = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // Temp IDs can be strings
  notes: PropTypes.string,
  tableNumber: PropTypes.string,
  // What is shown on floorplan and stuff. Can have letters
  areaId: PropTypes.number,
  minSeats: PropTypes.number,
  maxSeats: PropTypes.number,
  isPublic: PropTypes.bool,
  priority: PropTypes.number,
  isJoin: PropTypes.bool,
  blocks: PropTypes.arrayOf(tableBlockPropTypes),
  customDuration: PropTypes.number,
  // for the availability checks, this will be `-1` if the table has no custom duration
  tableNumbers: PropTypes.arrayOf(PropTypes.string)
});
const tablesPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(tablePropTypes),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const publicTypes = [
  { label: "Public", value: "public" },
  { label: "Private", value: "private" }
];
const tableIsJoin = (tableNumber) => tableNumber == null ? void 0 : tableNumber.includes(",");
const getData$8 = (table) => {
  const tableNumber = (table == null ? void 0 : table.tableNumber) === "null" || (table == null ? void 0 : table.tableNumber) === "" ? null : table == null ? void 0 : table.tableNumber;
  const tableNumbers = safeSplit(tableNumber).sort(sortAlphaNumeric);
  return {
    ...table,
    minSeats: (table == null ? void 0 : table.min) || (table == null ? void 0 : table.minSeats),
    // todo this is actually redundant, but a better name
    maxSeats: (table == null ? void 0 : table.max) || (table == null ? void 0 : table.maxSeats),
    isPublic: (table == null ? void 0 : table.isPublic) !== false,
    isJoin: tableIsJoin(table.tableNumber),
    blocks: (table == null ? void 0 : table.blocks) || [],
    // Default to empty array
    tableNumber,
    tableNumbers
  };
};
const convertDataForApi$4 = (updatedTable) => ({
  areaId: updatedTable == null ? void 0 : updatedTable.areaId,
  tableNumber: onlyCharacters(updatedTable == null ? void 0 : updatedTable.tableNumber, "a-z0-9,"),
  // API breaks if there are spaces
  notes: updatedTable == null ? void 0 : updatedTable.notes,
  tableName: updatedTable == null ? void 0 : updatedTable.tableName,
  min: updatedTable == null ? void 0 : updatedTable.minSeats,
  max: updatedTable == null ? void 0 : updatedTable.maxSeats,
  // priority: updatedTable?.priority, // Priority is no longer sent, is handled separately
  isPublic: updatedTable == null ? void 0 : updatedTable.isPublic
});
const getDefaultValues = (tableNumber = "") => {
  return {
    priority: 50,
    isJoin: tableIsJoin(tableNumber),
    isPublic: true,
    blocks: []
  };
};
const getTableBlockForTime = (table, time) => {
  var _a;
  return (_a = table == null ? void 0 : table.blocks) == null ? void 0 : _a.find(
    (blockToCheck) => blockToCheck.startTime <= time && blockToCheck.endTime > time
  );
};
const getTablesBlockForTime = (tables, time) => {
  var _a;
  const blocks = tables.map(
    (table) => {
      var _a2;
      return (_a2 = table == null ? void 0 : table.blocks) == null ? void 0 : _a2.find(
        (blockToCheck) => blockToCheck.startTime <= time && blockToCheck.endTime > time
      );
    }
  );
  return (_a = sortListByProperty(blocks, "startTime")) == null ? void 0 : _a[0];
};
const getBlockForTable = (booking, tableNumber, tables, time) => {
  const joinedTables = getJoinedTables(booking, tableNumber, tables);
  const block = getTablesBlockForTime(joinedTables, time);
  return block;
};
const getBlockEndTime = (block, closingTime, endOfDayString = "EOD") => {
  if ((block == null ? void 0 : block.endTime) >= closingTime) {
    return endOfDayString;
  }
  return formatTimeFromInt((block == null ? void 0 : block.endTime) || 1439, "h:mma");
};
const getAllJoinsForTable = (table, tables) => {
  var _a, _b2;
  if (isEmpty(table)) {
    return [];
  }
  return (_b2 = (_a = tables == null ? void 0 : tables.filter((joinTable) => joinTable.isJoin)) == null ? void 0 : _a.map((joinTable) => {
    const tableNumbers = joinTable.tableNumber.split(",");
    return {
      ...joinTable,
      otherTables: tableNumbers.filter((tableNumber) => tableNumber !== table.tableNumber).sort(sortAlphaNumeric)
    };
  })) == null ? void 0 : _b2.filter((joinTable) => {
    const tablesJoined = joinTable.tableNumber.split(",");
    return tablesJoined.includes(table.tableNumber);
  });
};
const getNewPriorityIndex = (oldIndex, newIndex, tables, ignoredTables, descending = false) => {
  if (newIndex === oldIndex) {
    return null;
  }
  const rowsWithoutResult = [...tables];
  rowsWithoutResult.splice(oldIndex, 1);
  const sortModifier = descending ? -0.5 : 0.5;
  let previousTableInList = null;
  for (let i = newIndex; i >= 1; i -= 1) {
    const prevTable = rowsWithoutResult[i - 1];
    if (!ignoredTables.includes(prevTable == null ? void 0 : prevTable.id)) {
      previousTableInList = prevTable;
      break;
    }
  }
  if (!previousTableInList) {
    return -1;
  }
  const listWithNoSelections = tables.filter((table) => !ignoredTables.includes(table == null ? void 0 : table.id));
  const previousTableIndex = findObjectIndexByProperty(
    listWithNoSelections,
    previousTableInList.id,
    "id"
  );
  return previousTableIndex + sortModifier;
};
const getNewTablePriorities = (oldIndex, newIndex, tables, tableToUpdate, descending = false) => {
  if (newIndex === oldIndex) {
    return null;
  }
  const rowsWithoutResult = [...tables];
  rowsWithoutResult.splice(oldIndex, 1);
  const sortModifier = descending ? -0.5 : 0.5;
  const newPriority = (() => {
    const prev = newIndex - 1;
    const next = newIndex;
    if (prev === -1) {
      return rowsWithoutResult[next].priority + sortModifier * -1;
    }
    const prevPriority = rowsWithoutResult[prev].priority;
    return prevPriority + sortModifier;
  })();
  const rowsWithResult = [...rowsWithoutResult, { ...tableToUpdate, priority: newPriority }];
  const newTables = sortListByProperty(rowsWithResult, "priority");
  const tablesWithNewPriority = newTables.map((table, index) => ({
    ...table,
    priority: index + 1,
    priorityChanged: (table == null ? void 0 : table.priorityChanged) || index + 1 !== (table == null ? void 0 : table.priority)
  }));
  return tablesWithNewPriority;
};
const getTableBlocksForDate = (table, date) => {
  var _a;
  return (_a = table == null ? void 0 : table.blocks) == null ? void 0 : _a.filter((blockToCheck) => {
    if ((blockToCheck == null ? void 0 : blockToCheck.date) === date) {
      return blockToCheck;
    }
    return false;
  });
};
const getAllTableBookings = (table, bookings) => {
  const tableBookings = bookings.filter((booking) => isTableForBooking(table, booking));
  return tableBookings;
};
const getTableBookingAhead = (tableBookings, startTime, endTime) => {
  const conflictedStatuses = getSeatableStatuses();
  const bookingAhead = tableBookings.sort((a, b) => sortByProperty(a, b, "startTime")).find(
    (tableBooking) => tableBooking.startTime > startTime && endTime > tableBooking.startTime && conflictedStatuses.includes(tableBooking.status)
  );
  return bookingAhead;
};
const getTableBlockAhead = (tableBlocks, startTime, endTime) => {
  const blockAhead = tableBlocks.find(
    (block) => startTime >= block.startTime && startTime < block.endTime || endTime > block.startTime && startTime < block.endTime
  );
  return blockAhead;
};
const initialState$l = {
  ...getInitialApiItemState()
};
const name$2 = "OBEE_TABLE";
const getNewPriorityForTable = (updatingTable, tables) => {
  if (isEmpty(tables)) {
    return 1;
  }
  const tablesByPriority = sortListByProperty(tables, "priority");
  const tablesByMinSeats = sortListByProperty(tablesByPriority, "minSeats", true);
  const sortedTables = sortListByProperty(tablesByMinSeats, "maxSeats");
  for (let i = sortedTables.length - 1; i >= 0; i -= 1) {
    const tableChecking = sortedTables[i];
    const isSameTable = isSameItem(updatingTable, tableChecking);
    if (!isSameTable && (tableChecking.maxSeats < updatingTable.maxSeats || tableChecking.maxSeats === updatingTable.maxSeats && tableChecking.minSeats >= updatingTable.minSeats)) {
      return tableChecking.priority + 1;
    }
  }
  return 1;
};
const insertPriority = (newTable, newPriority, state) => {
  const tables = sortListByProperty([...state.data], "priority");
  const newTables = getOtherLocalItems(newTable, tables);
  const insertIndex = Math.max(
    newTables.findIndex((table) => table.priority >= newPriority),
    0
  );
  newTables.splice(insertIndex, 0, { ...newTable, priority: newPriority });
  return getRefreshedTablePriorities(newTables, state);
};
const changePriority = (updatedTable, tables, state) => {
  const newTables = tables.map((table) => {
    if (isSameItem(updatedTable, table)) {
      return {
        ...updatedTable,
        priority: updatedTable.priority - 0.5
        // So it is above the other table with the same priority
      };
    }
    return table;
  });
  return getRefreshedTablePriorities(sortListByProperty(newTables, "priority"), state);
};
const handleAdditionalState = (state, action) => {
  var _a;
  switch (action.type) {
    case DELETE_LOCAL_OBEE_AREAS:
      const areaIds = getAsArray(action.payload);
      const tablesToDelete = flatten(state.data.filter((table) => areaIds.includes(table == null ? void 0 : table.areaId)));
      return deleteLocal(tablesToDelete, state, "id");
    case UPDATE_OBEE_FLOORPLAN_SUCCESS:
      return finishSaveLocal(state, action.payload.tables, getData$8, "id");
    case BLOCK_OBEE_TABLE_SUCCESS:
      const tableToBlock = state.data.find((table) => table.id === action.payload.data.tableId);
      const updatedTableToBlock = {
        ...tableToBlock,
        blocks: tableToBlock.blocks ? [...tableToBlock.blocks, action.payload.data] : [action.payload.data]
      };
      return updateItemSuccess(updatedTableToBlock, state);
    case UNBLOCK_OBEE_TABLE_SUCCESS:
      const tableToUnblock = state.data.find((table) => table.id === action.payload.tableId);
      const updatedTableToUnblock = {
        ...tableToUnblock,
        blocks: (_a = tableToUnblock.blocks) == null ? void 0 : _a.filter((block) => block.id !== action.payload.tableBlockId)
      };
      return updateItemSuccess(updatedTableToUnblock, state);
    case EDIT_BLOCK_OBEE_TABLE_SUCCESS:
      const tableToUpdate = state.data.find((table) => table.id === action.payload.tableId);
      const updatedTableToUpdate = {
        ...tableToUpdate,
        blocks: updateItemInArray(
          tableToUpdate.blocks,
          "id",
          action.payload.tableBlockId,
          (item) => ({ ...item, ...action.payload.data })
        )
      };
      return updateItemSuccess(updatedTableToUpdate, state);
    default:
      return state;
  }
};
const tablesReducer = (state = initialState$l, action) => {
  const overrides = {
    CREATE_LOCAL_OBEE_TABLE: () => {
      var _a;
      const newItem = {
        ...action.payload,
        _isNew: true
      };
      const newState2 = createLocal(newItem, state);
      const newTable = newItem;
      const tables = newState2.data;
      const newPriority = getNewPriorityForTable(newTable, tables);
      const newTableWithPriority = { ...newTable, priority: newPriority, priorityChanged: true };
      const newList = (_a = insertPriority(newTableWithPriority, newPriority, state)) == null ? void 0 : _a.filter(
        (table) => (table == null ? void 0 : table.priorityChanged) === true || (table == null ? void 0 : table._isNew)
      );
      return bulkUpdateLocal(newList, newState2, "id");
    },
    // Update the table, but also run updates against other tables if priority changed
    UPDATE_LOCAL_OBEE_TABLE: () => {
      var _a;
      const updatedTable = action.payload;
      const dataTable = getLocalItem(updatedTable, state, "id");
      if (dataTable.priority !== (updatedTable == null ? void 0 : updatedTable.priority)) {
        dataTable.manuallyChangedPriority = true;
      }
      if ((updatedTable == null ? void 0 : updatedTable._isNew) && !dataTable.manuallyChangedPriority) {
        const tables = state.data;
        if (dataTable.priority !== (updatedTable == null ? void 0 : updatedTable.priority)) {
          const updatedPriorities = changePriority(updatedTable, state.data, state);
          return bulkUpdateLocal(updatedPriorities, state, "id");
        }
        const newPriority = getNewPriorityForTable(updatedTable, tables);
        const newTableWithPriority = {
          ...updatedTable,
          priority: newPriority,
          priorityChanged: true
        };
        const newList = (_a = insertPriority(newTableWithPriority, newPriority, state)) == null ? void 0 : _a.filter(
          (table) => (table == null ? void 0 : table.priorityChanged) === true || (table == null ? void 0 : table._isNew)
        );
        return bulkUpdateLocal(newList, state, "id");
      }
      return updateLocal(action.payload, state, "id");
    }
  };
  const newState = updateApiState(name$2, state, action, getData$8, overrides, "id");
  return handleAdditionalState(newState, action);
};
const rulePropTypes = PropTypes.shape({
  objectId: PropTypes.string,
  startTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  endTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  limitType: PropTypes.string,
  ruleOptionValue: PropTypes.number,
  timeInterval: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  source: PropTypes.string,
  groupSize: PropTypes.shape({
    option: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    exact: PropTypes.number
  })
});
const sources = [
  { label: "All", value: "all" },
  { label: "Phone", value: "phone" },
  { label: "Internet", value: "internet" }
];
const dayOptions = [
  { value: "all", label: "Every day" },
  { value: "weekdays", label: "Days" },
  { value: "date", label: "Specific date" },
  { value: "dateRange", label: "Date range" }
];
const limitTypeOptions = [
  { label: "Max guests", value: "maxGuests" },
  { label: "Max groups", value: "maxGroups" },
  { label: "Don't allow any bookings", value: "noBookings" }
];
const timeIntervals = [
  { label: "No time interval", value: null },
  { label: "15 mins", value: 15 },
  { label: "30 mins", value: 30 },
  { label: "45 mins", value: 45 },
  { label: "1 hour", value: 60 },
  { label: "1 hour, 15 mins", value: 75 },
  { label: "1 hour, 30 mins", value: 90 },
  { label: "1 hour, 45 mins", value: 105 },
  { label: "2 hours", value: 120 }
];
const LIMIT_TYPES = {
  MAX_GUESTS: "maxGuests",
  MAX_GROUPS: "maxGroups",
  NO_BOOKINGS: "noBookings"
};
const getData$7 = (rule) => {
  devLog("info", "getting data for rule", rule);
  const isAllDay = (rule == null ? void 0 : rule.startTime) === 0 && (rule == null ? void 0 : rule.endTime) === 1439;
  const startTime = isAllDay ? "allDay" : rule == null ? void 0 : rule.startTime;
  const endTime = isAllDay ? "allDay" : rule == null ? void 0 : rule.endTime;
  const limitsMap = {
    guests: "maxGuests",
    groups: "maxGroups",
    dont_allow: "noBookings"
  };
  const sizeOptionMap = {
    more_than: "more",
    less_than: "less",
    exactly: "exactly",
    between: "between"
  };
  const ruleData = {
    objectId: rule == null ? void 0 : rule.objectId,
    timeInterval: (rule == null ? void 0 : rule.timeInterval) === -1 ? null : rule == null ? void 0 : rule.timeInterval,
    startTime,
    endTime,
    limitType: limitsMap == null ? void 0 : limitsMap[rule.limitType],
    limitAmount: rule == null ? void 0 : rule.limitValue,
    source: (rule == null ? void 0 : rule.source) || "all",
    groupSize: {
      option: (sizeOptionMap == null ? void 0 : sizeOptionMap[rule == null ? void 0 : rule.groupSizeOption]) || "more",
      min: rule == null ? void 0 : rule.groupSizeMin,
      max: rule == null ? void 0 : rule.groupSizeMax,
      exact: rule == null ? void 0 : rule.groupSizeMin
    }
  };
  return ruleData;
};
const convertDataForApi$3 = (rule) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h;
  devLog("info", "converting rule data for api", rule);
  if (isEmpty(rule)) {
    return {};
  }
  const limitsMap = {
    maxGuests: "guests",
    maxGroups: "groups",
    noBookings: "dont_allow"
  };
  const limitType = limitsMap == null ? void 0 : limitsMap[rule == null ? void 0 : rule.limitType];
  const data = {
    startTime: valueIfValue(rule == null ? void 0 : rule.startTime, "allDay", 0),
    endTime: valueIfValue(rule == null ? void 0 : rule.endTime, "allDay", 1439),
    limitType,
    limitValue: parseInt(rule == null ? void 0 : rule.limitAmount, 10),
    // Max amount of group/guest
    source: valueIfValue(rule == null ? void 0 : rule.source, "all", null),
    timeInterval: rule == null ? void 0 : rule.timeInterval,
    groupSizeOption: null,
    groupSizeMin: null,
    groupSizeMax: null
  };
  const sizeOptionMap = {
    more: "more_than",
    less: "less_than",
    exactly: "exactly",
    between: "between"
  };
  if ((rule == null ? void 0 : rule.limitType) === LIMIT_TYPES.MAX_GROUPS) {
    data.groupSizeOption = sizeOptionMap == null ? void 0 : sizeOptionMap[(_a = rule == null ? void 0 : rule.groupSize) == null ? void 0 : _a.option];
    switch ((_b2 = rule == null ? void 0 : rule.groupSize) == null ? void 0 : _b2.option) {
      case "more":
        data.groupSizeMin = (_c2 = rule == null ? void 0 : rule.groupSize) == null ? void 0 : _c2.min;
        break;
      case "less":
        data.groupSizeMax = (_d2 = rule == null ? void 0 : rule.groupSize) == null ? void 0 : _d2.max;
        break;
      case "exactly":
        data.groupSizeMin = (_e2 = rule == null ? void 0 : rule.groupSize) == null ? void 0 : _e2.exact;
        data.groupSizeMax = (_f = rule == null ? void 0 : rule.groupSize) == null ? void 0 : _f.exact;
        break;
      case "between":
        data.groupSizeMin = (_g = rule == null ? void 0 : rule.groupSize) == null ? void 0 : _g.min;
        data.groupSizeMax = (_h = rule == null ? void 0 : rule.groupSize) == null ? void 0 : _h.max;
        break;
    }
  }
  return data;
};
const getEntityPropTypes = (entityData) => PropTypes.shape({
  data: PropTypes.arrayOf(entityData),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool,
  apiData: PropTypes.arrayOf(entityData),
  // The copy of the data that is up-to-date with the api
  deleted: PropTypes.arrayOf(PropTypes.string),
  // IDs of locally deleted items that need to be saved
  created: PropTypes.arrayOf(PropTypes.string),
  // IDs of locally created items that need to be saved
  updated: PropTypes.arrayOf(PropTypes.string),
  // IDs of locally updated items that need to be saved
  hasChanges: PropTypes.bool
  // Whether the data has differed from the API data
});
const bookingLimitPropTypes = PropTypes.shape({
  objectId: PropTypes.string,
  areaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  days: PropTypes.arrayOf(PropTypes.string),
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  dayType: PropTypes.string,
  limits: PropTypes.arrayOf(rulePropTypes)
});
const bookingLimitsPropTypes = getEntityPropTypes(bookingLimitPropTypes);
const getLimitSize = (rule) => {
  if ((rule == null ? void 0 : rule.limitType) === "noBookings") {
    return "No bookings";
  }
  return `Max ${rule == null ? void 0 : rule.limitAmount} ${(rule == null ? void 0 : rule.limitType) === "maxGuests" ? pluralise("guest", rule == null ? void 0 : rule.limitAmount) : pluralise("group", rule == null ? void 0 : rule.limitAmount)}`;
};
const getTimeInterval = (rule) => {
  if ((rule == null ? void 0 : rule.timeInterval) === null) {
    return "";
  }
  return `every ${rule == null ? void 0 : rule.timeInterval} minutes`;
};
const getFriendlyGroupSizeText = (groupSize) => {
  switch (groupSize == null ? void 0 : groupSize.option) {
    case "exactly":
      return `Exactly ${groupSize == null ? void 0 : groupSize.exact}`;
    case "more":
      return `${groupSize == null ? void 0 : groupSize.min} or more`;
    case "less":
      return `${groupSize == null ? void 0 : groupSize.max} or less`;
    case "between":
      return `${groupSize == null ? void 0 : groupSize.min} - ${groupSize == null ? void 0 : groupSize.max}`;
    case "any":
    default:
      return "Any size";
  }
};
const getGroupSize = (rule) => {
  if (rule.limitType !== "maxGroups") {
    return null;
  }
  return getFriendlyGroupSizeText(rule.groupSize);
};
const getTimeRange = (rule) => {
  if (rule.startTime === "allDay" || rule.endTime === "allDay") {
    return "All day";
  }
  return `${formatTimeFromInt(rule == null ? void 0 : rule.startTime, "h:mma")}-
      ${formatTimeFromInt(rule == null ? void 0 : rule.endTime, "h:mma")}`;
};
const getData$6 = (bookingLimit) => {
  var _a;
  devLog("info", "getting data for booking limit", bookingLimit);
  const getDayType = () => {
    if (!isEmpty(bookingLimit == null ? void 0 : bookingLimit.startDate)) {
      if ((bookingLimit == null ? void 0 : bookingLimit.startDate) !== (bookingLimit == null ? void 0 : bookingLimit.endDate)) {
        return "dateRange";
      }
      return "date";
    }
    if (!isEmpty(bookingLimit == null ? void 0 : bookingLimit.days)) {
      return "weekdays";
    }
    return "all";
  };
  return {
    // ...bookingLimit,
    objectId: bookingLimit == null ? void 0 : bookingLimit.objectId,
    areaId: (bookingLimit == null ? void 0 : bookingLimit.areaId) === -1 ? "all" : bookingLimit == null ? void 0 : bookingLimit.areaId,
    days: (bookingLimit == null ? void 0 : bookingLimit.days) || [],
    startDate: (bookingLimit == null ? void 0 : bookingLimit.startDate) || null,
    endDate: (bookingLimit == null ? void 0 : bookingLimit.endDate) || null,
    rules: (_a = (bookingLimit == null ? void 0 : bookingLimit.limits) || []) == null ? void 0 : _a.map(getData$7),
    dayType: getDayType()
  };
};
const getDayValuesForApi = (updatedBookingLimit) => {
  var _a;
  switch (updatedBookingLimit == null ? void 0 : updatedBookingLimit.dayType) {
    case "all":
      return {
        days: null
      };
    case "weekdays":
      if (((_a = updatedBookingLimit == null ? void 0 : updatedBookingLimit.conditionDays) == null ? void 0 : _a.length) === 7) {
        return {
          days: null
        };
      }
      return {
        days: updatedBookingLimit == null ? void 0 : updatedBookingLimit.conditionDays
      };
    case "date":
      return {
        startDate: formatDate(updatedBookingLimit == null ? void 0 : updatedBookingLimit.date, "YYYY-MM-DD", null),
        endDate: formatDate(updatedBookingLimit == null ? void 0 : updatedBookingLimit.date, "YYYY-MM-DD", null)
      };
    case "dateRange":
      return {
        startDate: formatDate(updatedBookingLimit == null ? void 0 : updatedBookingLimit.startDate, "YYYY-MM-DD", null),
        endDate: formatDate(updatedBookingLimit == null ? void 0 : updatedBookingLimit.endDate, "YYYY-MM-DD", null)
      };
    default:
      return {};
  }
};
const convertDataForApi$2 = (updatedBookingLimit) => {
  devLog("info", "converting booking limit data for api", updatedBookingLimit);
  const rule = convertDataForApi$3(updatedBookingLimit);
  const data = {
    ...rule,
    areaId: ["all", -1].includes(updatedBookingLimit == null ? void 0 : updatedBookingLimit.selectedArea) ? null : updatedBookingLimit == null ? void 0 : updatedBookingLimit.selectedArea,
    ...getDayValuesForApi(updatedBookingLimit)
  };
  return data;
};
const initialState$k = {
  ...getInitialApiItemState()
};
const name$1 = "OBEE_BOOKING_LIMIT";
const bookingLimitsReducer = (state = initialState$k, action) => {
  const overrides = {
    [`CREATE_${name$1}_PENDING`]: () => {
      var _a;
      const bookingLimit = action.payload.data;
      const freshItem = {
        _tempId: (_a = action.payload) == null ? void 0 : _a.tempId,
        ...getData$6({
          ...bookingLimit,
          days: bookingLimit == null ? void 0 : bookingLimit.days,
          rules: [
            {
              source: bookingLimit == null ? void 0 : bookingLimit.source,
              startTime: bookingLimit == null ? void 0 : bookingLimit.startTime,
              endTime: bookingLimit == null ? void 0 : bookingLimit.endTime,
              groupSizeMin: bookingLimit == null ? void 0 : bookingLimit.groupSizeMin,
              groupSizeMax: bookingLimit == null ? void 0 : bookingLimit.groupSizeMax,
              groupSizeOption: bookingLimit == null ? void 0 : bookingLimit.groupSizeOption,
              limitType: bookingLimit == null ? void 0 : bookingLimit.limitType,
              limitValue: bookingLimit == null ? void 0 : bookingLimit.limitValue,
              timeInterval: bookingLimit == null ? void 0 : bookingLimit.timeInterval
            }
          ]
        })
      };
      return createItemPending(freshItem, state, true);
    },
    // If a rule is created along with a condition
    [`CREATE_OBEE_BOOKING_LIMIT_SUCCESS`]: () => {
      var _a, _b2, _c2;
      const pendingCondition = findObjectByProperty(state.data, action.payload.tempId, "_tempId");
      const newItem = {
        ...pendingCondition,
        ...action.payload.data,
        rules: (_c2 = (_b2 = (_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.data) == null ? void 0 : _b2.limits) == null ? void 0 : _c2.map(getData$7)
      };
      return createItemSuccessOrUpdate(newItem, state, "_tempId");
    },
    // If a rule is created or updated, it updates here too
    [`CREATE_OBEE_BOOKING_LIMIT_RULE_SUCCESS`]: () => {
      const newRule = action.payload.data;
      const condition = findObjectByProperty(state.data, action.payload.conditionId, "objectId");
      const freshItem = {
        ...condition,
        rules: [...condition == null ? void 0 : condition.rules, getData$7(newRule)]
      };
      return updateItemSuccess$1(freshItem, state, "objectId");
    },
    [`UPDATE_OBEE_BOOKING_LIMIT_RULE_SUCCESS`]: () => {
      const updatedRule = getData$7(action.payload.data);
      const condition = findObjectByProperty(state.data, action.payload.conditionId, "objectId");
      const newRules = updateObjectByProperty(condition == null ? void 0 : condition.rules, updatedRule, "objectId");
      const freshItem = {
        ...condition,
        rules: newRules
      };
      return updateItemPending(freshItem, state, "objectId");
    },
    [`DELETE_OBEE_BOOKING_LIMIT_RULE_SUCCESS`]: () => {
      var _a;
      const condition = findObjectByProperty(state.data, action.payload.conditionId, "objectId");
      const newRules = filterByProperty(
        condition == null ? void 0 : condition.rules,
        (_a = action.payload) == null ? void 0 : _a.limitId,
        "objectId",
        true
      );
      const freshItem = {
        ...condition,
        rules: newRules
      };
      return updateItemPending(freshItem, state, "objectId");
    }
  };
  return updateApiState(name$1, state, action, getData$6, overrides, "objectId", true);
};
const initialState$j = {
  ...getInitialApiItemState([])
};
const dailyNotesReducer = (state = initialState$j, action) => {
  const overrides = {};
  return updateApiState("DAILY_NOTE", state, action, getData$j, overrides, "id");
};
const integrationPropTypes = PropTypes.shape({
  id: PropTypes.string,
  data: PropTypes.shape({}),
  active: PropTypes.bool
});
const integrationsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(integrationPropTypes),
  error: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const getData$5 = (integration) => {
  devLog("info", "getting data for integration", integration);
  const data = {
    id: integration == null ? void 0 : integration.id,
    active: integration == null ? void 0 : integration.active,
    data: safeParse(integration == null ? void 0 : integration.data)
  };
  return data;
};
const initialState$i = {
  data: [],
  // The copy of the data that will be modified locally
  apiData: [],
  // The copy of the data that is up-to-date with the api
  error: "",
  pending: false,
  success: false,
  hasFetched: false
};
const integrationsReducer = (state = initialState$i, action) => {
  var _a;
  switch (action.type) {
    case FETCH_OBEE_INTEGRATIONS_PENDING:
      return setPending(state);
    case FETCH_OBEE_INTEGRATIONS_SUCCESS:
      devLog("info", "fetch success...", action.payload, state);
      return setFetchSuccess((_a = action.payload.data) == null ? void 0 : _a.map(getData$5), state);
    case FETCH_OBEE_INTEGRATIONS_FAILURE:
      return setFailed(state, action.payload.error);
    case ENABLE_RESERVE_WITH_GOOGLE_SUCCESS:
      devLog("info", "enable success...", action.payload, state);
      return createItemSuccessOrUpdate(getData$5(action.payload.data), state);
    case DISABLE_RESERVE_WITH_GOOGLE_SUCCESS:
      devLog("info", "disable RWG success...", action.payload, state);
      return updateItemSuccess$1(getData$5(action.payload.data), state, "id");
    case DISABLE_META_INTEGRATION_SUCCESS:
      devLog("info", "disable meta success...", action.payload, state);
      return updateItemSuccess$1({ id: "Meta", active: false, data: {} }, state, "id");
    default:
      return state;
  }
};
const initialState$h = {
  apiData: [],
  data: [],
  error: "",
  pending: false,
  success: false
};
const obeeStaffReducer = (state = initialState$h, action) => {
  switch (action.type) {
    case FETCH_OBEE_STAFF_PENDING:
      return setPending(state);
    case FETCH_OBEE_STAFF_SUCCESS:
      return setDataSuccess(action.payload.data, state);
    case FETCH_OBEE_STAFF_FAILURE:
      return setFailed(state, action.payload.error);
    case CREATE_OBEE_STAFF_PENDING:
      return createItemPending(action.payload.data, state);
    case CREATE_OBEE_STAFF_SUCCESS:
      const newItemData = action.payload.data;
      return createItemSuccess$1(newItemData, state);
    case CREATE_OBEE_STAFF_FAILURE:
      return createItemFailure(state, action.payload.error);
    case UPDATE_OBEE_STAFF_PENDING:
      return updateItemPending(action.payload.data, state, "objectId");
    case UPDATE_OBEE_STAFF_SUCCESS:
      return updateItemSuccess$1(action.payload.data, state, "objectId");
    case UPDATE_OBEE_STAFF_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case DELETE_OBEE_STAFF_PENDING:
      return deleteItemPending(action.payload.data.staffId, state, "objectId");
    case DELETE_OBEE_STAFF_SUCCESS:
      return deleteItemSuccess$1(action.payload.staffId, state, "objectId");
    case DELETE_OBEE_STAFF_FAILURE:
      return deleteItemFailure(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$g = {
  ...getInitialApiItemState()
};
const globalSessionsReducer = (state = initialState$g, action) => {
  switch (action.type) {
    case FETCH_OBEE_GLOBAL_SESSIONS_PENDING:
      return setFetchPending(state);
    case FETCH_OBEE_GLOBAL_SESSIONS_SUCCESS:
      const data = action.payload.data.map((item) => getData$g(item));
      return setFetchSuccess(data, state);
    case FETCH_OBEE_GLOBAL_SESSIONS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_OBEE_GLOBAL_SESSION_PENDING:
      const updatedSession = getData$g(action.payload.data);
      return updateItemPending(updatedSession, state, "objectId");
    case UPDATE_OBEE_GLOBAL_SESSION_SUCCESS:
      const updatedSessionSuccess = getData$g(action.payload.data);
      return updateItemSuccess$1(updatedSessionSuccess, state, "objectId");
    case UPDATE_OBEE_GLOBAL_SESSION_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case DELETE_OBEE_GLOBAL_SESSION_PENDING:
      return deleteItemPending(action.payload.data.objectId, state, "objectId");
    case DELETE_OBEE_GLOBAL_SESSION_SUCCESS:
      return deleteItemSuccess$1(action.payload.objectId, state, "objectId");
    case DELETE_OBEE_GLOBAL_SESSION_FAILURE:
      return deleteItemFailure(state, action.payload.error);
    case CREATE_OBEE_GLOBAL_SESSION_PENDING:
      return createItemPending(getData$g(action.payload.data), state);
    case CREATE_OBEE_GLOBAL_SESSION_SUCCESS:
      return setDataSuccess([...state.data, ...action.payload.data], state);
    case CREATE_OBEE_GLOBAL_SESSION_FAILURE:
      return createItemFailure(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$f = {
  ...getInitialApiItemState()
};
const eventSessionsReducer = (state = initialState$f, action) => {
  switch (action.type) {
    case FETCH_OBEE_EVENT_SESSIONS_PENDING:
      return setFetchPending(state);
    case FETCH_OBEE_EVENT_SESSIONS_SUCCESS:
      const data = action.payload.data.map((item) => getData$g(item));
      return setDataSuccess(data, state);
    case FETCH_OBEE_EVENT_SESSIONS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_OBEE_EVENT_SESSION_PENDING:
      const updatedSession = getData$g(action.payload.data);
      return updateItemPending(updatedSession, state, "objectId");
    case UPDATE_OBEE_EVENT_SESSION_SUCCESS:
      const updatedSessionSuccess = getData$g(action.payload.data);
      return updateItemSuccess$1(updatedSessionSuccess, state, "objectId");
    case UPDATE_OBEE_EVENT_SESSION_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case DELETE_OBEE_EVENT_SESSION_PENDING:
      return deleteItemPending(action.payload.data.objectId, state, "objectId");
    case DELETE_OBEE_EVENT_SESSION_SUCCESS:
      return deleteItemSuccess$1(action.payload.objectId, state, "objectId");
    case DELETE_OBEE_EVENT_SESSION_FAILURE:
      return deleteItemFailure(state, action.payload.error);
    case CREATE_OBEE_EVENT_SESSION_PENDING:
      return createItemPending(getData$g(action.payload.data), state);
    case CREATE_OBEE_EVENT_SESSION_SUCCESS:
      return createItemSuccess$1(getData$g(action.payload.data), state);
    case CREATE_OBEE_EVENT_SESSION_FAILURE:
      return createItemFailure(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$e = {
  data: {},
  error: "",
  pending: false,
  success: false
};
const obeeUpdateCheckReducer = (state = initialState$e, action) => {
  switch (action.type) {
    case UPDATE_CHECK_PENDING:
      return setPending(state);
    case UPDATE_CHECK_SUCCESS:
      return setDataSuccess(safeParse(action.payload.data), state);
    case UPDATE_CHECK_FAILURE:
      return setFailed(state, action.payload.error);
    case CLEAR_UPDATE_CHECK:
      return clear$1(state, {});
    default:
      return state;
  }
};
const initialState$d = {
  apiData: [],
  data: [],
  error: "",
  pending: false,
  success: false,
  pagination: {}
};
const obeeGuestsReducer = (state = initialState$d, action) => {
  switch (action.type) {
    case FETCH_OBEE_GUESTS_PENDING:
      return setPending(state);
    case FETCH_OBEE_GUESTS_SUCCESS:
      return setFetchPaginatedDataSuccess(action, convertGuestApiData, state);
    case FETCH_OBEE_GUESTS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_OBEE_GUEST_PENDING:
      return updateItemPending(action.payload.data, state, "id", true);
    case UPDATE_OBEE_GUEST_SUCCESS:
      return updateItemSuccess$1(convertGuestApiData(action.payload.data), state);
    case UPDATE_OBEE_GUEST_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case CLEAR_OBEE_GUESTS:
      return clear$1(state);
    default:
      return state;
  }
};
const initialState$c = {
  data: {},
  // Key by user ID
  error: "",
  pending: false,
  success: false
};
const bookingsForUserReducer = (state = initialState$c, action) => {
  var _a;
  switch (action.type) {
    case FETCH_OBEE_BOOKINGS_FOR_USER_PENDING:
      return setPending(state);
    case FETCH_OBEE_BOOKINGS_FOR_USER_SUCCESS:
      const bookingsForUser = (action.payload.data || []).map(getObeeData);
      const updatedData = { ...state.data, [(_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.userId]: bookingsForUser };
      return {
        data: updatedData,
        pending: false,
        success: true,
        error: ""
      };
    case FETCH_OBEE_BOOKINGS_FOR_USER_FAILURE:
      return setFailed(state, action.payload.error);
    case CLEAR_OBEE_BOOKINGS_FOR_USER:
      return clear$1(state);
    default:
      return state;
  }
};
const initialState$b = {
  data: "",
  // note: just an artifact thats not needed in this reducer
  error: "",
  pending: false,
  success: false
};
const chargeNoShowReducer = (state = initialState$b, action) => {
  switch (action.type) {
    case CHARGE_NO_SHOW_PENDING:
      return setPending(state);
    case CHARGE_NO_SHOW_SUCCESS:
      return setDataSuccess(action.payload.data, state);
    case CHARGE_NO_SHOW_FAILURE:
      return setFailed(state, action.payload.error);
    case CLEAR_CHARGE_NO_SHOW:
      return clear$1(state, "");
    default:
      return state;
  }
};
const initialState$a = {
  data: null,
  error: "",
  pending: false,
  success: false
};
const closeEarlyReducer = (state = initialState$a, action) => {
  switch (action.type) {
    case CLOSE_RESTAURANT_PENDING:
    case REOPEN_RESTAURANT_PENDING:
      return setPending(state);
    case CLOSE_RESTAURANT_SUCCESS:
    case REOPEN_RESTAURANT_SUCCESS:
      return setSuccess(state);
    case CLOSE_RESTAURANT_FAILURE:
    case REOPEN_RESTAURANT_FAILURE:
      return setFailed(state, action.payload.error);
    default:
      return state;
  }
};
const initialState$9 = [];
const apiRequestsReducer = (state = initialState$9, action) => {
  switch (action.type) {
    case ADD_API_REQUEST: {
      return [...state, action.payload];
    }
    case REMOVE_API_REQUEST: {
      return [...state.filter((request) => request.id !== action.payload)];
    }
    default:
      return state;
  }
};
const voucherRedemptionPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  voucherRef: PropTypes.string,
  voucherNumber: PropTypes.number,
  issueDate: PropTypes.string,
  expiryDate: PropTypes.string,
  originalValue: PropTypes.string,
  purchaserFirstName: PropTypes.string,
  purchaserLastName: PropTypes.string,
  recipientName: PropTypes.string,
  voucherStatus: PropTypes.string,
  voucherType: PropTypes.string,
  menu: PropTypes.string,
  notes: PropTypes.string,
  balance: PropTypes.number
});
const voucherRedemptionsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(voucherRedemptionPropTypes),
  error: PropTypes.string,
  status: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const getData$4 = (item) => {
  return {
    id: item.id,
    voucherRef: item.voucherRef,
    voucherNumber: item.voucherNumber,
    issueDate: item.issueDate,
    expiryDate: item.expiryDate,
    originalValue: item.originalValue,
    purchaserFirstName: item.purchaserFirstName,
    purchaserLastName: item.purchaserLastName,
    recipientName: item.recipientName,
    voucherStatus: item.voucherStatus,
    voucherType: item.voucherType,
    balance: item.balance,
    menu: item.menu,
    notes: item.notes
  };
};
const initialState$8 = {
  data: [],
  error: "",
  pending: false,
  success: false,
  searchValue: "",
  noResults: false,
  totalResults: null,
  currentPage: null,
  totalPages: null
};
const voucherRedemptionReducer = (state = initialState$8, action) => {
  switch (action.type) {
    case FETCH_OBEE_VOUCHER_REDEMPTION_LIST_PENDING:
      return setPending(state);
    case FETCH_OBEE_VOUCHER_REDEMPTION_LIST_SUCCESS:
      return setFetchPaginatedDataSuccess(action, getData$4, state);
    case FETCH_OBEE_VOUCHER_REDEMPTION_LIST_FAILURE:
      return setFailed(state, action.payload.error);
    case CREATE_OBEE_VOUCHER_REDEMPTION_PENDING:
      return setPending(state);
    case CREATE_OBEE_VOUCHER_REDEMPTION_SUCCESS:
      return setSuccess(state);
    case CREATE_OBEE_VOUCHER_REDEMPTION_FAILURE:
      return setFailed(state, action.payload.error);
    default:
      return state;
  }
};
const notificationPropTypes = PropTypes.shape({
  id: PropTypes.string,
  // the booking id, not to be confused with being a notification id
  date: PropTypes.string,
  time: PropTypes.string,
  bSize: PropTypes.number,
  bName: PropTypes.string,
  bMade: PropTypes.string,
  bType: PropTypes.string,
  status: PropTypes.string,
  orderByDate: PropTypes.string,
  // date time the notification was received
  tableNumber: PropTypes.string,
  customerComments: PropTypes.string,
  readableDate: PropTypes.string,
  readableTime: PropTypes.string,
  readableReceived: PropTypes.string,
  whichNotification: PropTypes.oneOf(["new", "update", "waitlist", "cancelled"])
});
const notificationsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(notificationPropTypes),
  apiData: PropTypes.arrayOf(notificationPropTypes),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool,
  lastCheckedAt: PropTypes.string,
  unreadNotifications: PropTypes.bool,
  restored: PropTypes.bool
});
const getData$3 = (notification) => {
  devLog("info", "getting data for notifications", notification);
  return {
    ...notification,
    unread: true,
    readableDate: moment$2(notification.date).format("DD/MM"),
    readableTime: moment$2(notification.time, "HH:mm:ss").format("h:mma"),
    readableReceived: moment$2(notification.orderByDate).format("DD/MM/YY [at] h:mma")
  };
};
const getAllData = (notifications) => notifications.map((notification) => getData$3(notification));
const getNotificationTypeLabel = (type2) => {
  switch (type2) {
    case "new":
      return "New booking";
    case "update":
      return "Updates";
    case "waitlist":
      return "Waitlist";
    case "cancelled":
      return "Cancellation";
    default:
      return type2;
  }
};
const getNotificationSource = (notification) => {
  if (notification.bType === "walkin") {
    return "Walk-In";
  }
  return capitaliseFirstLetter(notification.bType);
};
const filterOptions = [
  {
    label: "New bookings",
    value: "new"
  },
  {
    label: "Updates",
    value: "update"
  },
  {
    label: "Waiting list",
    value: "waitlist"
  },
  {
    label: "Cancellations",
    value: "cancelled"
  }
];
const initialState$7 = {
  ...getInitialApiItemState([]),
  lastCheckedAt: "",
  unreadNotifications: false,
  restored: false
};
const notificationsReducer = (state = initialState$7, action) => {
  switch (action.type) {
    case RESTORE_NOTIFICATIONS: {
      const notifications = loadItem(`notifications:${action.payload.restId}`);
      let data = notifications == null ? void 0 : notifications.data;
      let lastCheckedAt = notifications == null ? void 0 : notifications.lastCheckedAt;
      if (!Array.isArray(data)) {
        data = [];
      }
      if (isObee() && !moment$2(lastCheckedAt, "YYYY-MM-DD HH:mm:ss", true).isValid() || !isObee() && !isIsoDate(lastCheckedAt)) {
        lastCheckedAt = getDateTimeNow();
      }
      saveItem(`notifications:${action.payload.restId}`, { data, lastCheckedAt });
      return {
        ...state,
        data,
        apiData: data,
        lastCheckedAt,
        unreadNotifications: data.some((notification) => notification.unread),
        restored: true
      };
    }
    case FETCH_NOTIFICATIONS_PENDING: {
      return setPending(state);
    }
    case FETCH_NOTIFICATIONS_SUCCESS: {
      const updatedData = [...state.data, ...getAllData(action.payload.data)];
      const uniqueNotifications = uniqueObjects(updatedData);
      saveItem(`notifications:${action.payload.variables.restId}`, {
        data: uniqueNotifications,
        lastCheckedAt: action.payload.lastCheckedAt
      });
      return {
        ...setDataSuccess(uniqueNotifications, state),
        lastCheckedAt: action.payload.lastCheckedAt,
        // note: set the last checked on success in case it fails
        unreadNotifications: uniqueNotifications.some((notification) => notification.unread)
      };
    }
    case FETCH_NOTIFICATIONS_FAILURE: {
      return setFailed(state, action.payload.error);
    }
    case MARK_ALL_NOTIFICATIONS_AS_READ: {
      const updatedData = state.data.map((notification) => ({
        ...notification,
        unread: false
      }));
      const notifications = loadItem(`notifications:${action.payload.restId}`);
      saveItem(`notifications:${action.payload.restId}`, {
        ...isObject$1(notifications) ? notifications : {},
        // failsafe check
        data: updatedData
      });
      return {
        ...setDataSuccess(updatedData, state),
        unreadNotifications: false
      };
    }
    case FETCH_NOTIFICATIONS_COUNT_SUCCESS: {
      const parsedData = safeParse(action.payload.data);
      const count = parseInt(parsedData ? parsedData.updates : "0", 10);
      return {
        ...state,
        unreadNotifications: state.unreadNotifications || count > 0
      };
    }
    default:
      return state;
  }
};
const initialState$6 = {
  pending: false,
  error: "",
  success: false
};
const notificationEventsReducer = (state = initialState$6, action) => {
  switch (action.type) {
    case SUBSCRIBE_TO_NOTIFICATION_EVENTS_PENDING: {
      return {
        ...state,
        pending: true,
        error: ""
      };
    }
    case SUBSCRIBE_TO_NOTIFICATION_EVENTS_SUCCESS: {
      return {
        ...state,
        pending: false,
        success: true
      };
    }
    case SUBSCRIBE_TO_NOTIFICATION_EVENTS_FAILURE: {
      return {
        ...state,
        pending: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
};
const bookingDurationPropTypes = PropTypes.shape({
  objectId: PropTypes.string,
  areaIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  duration: PropTypes.number,
  groupSize: PropTypes.shape({
    option: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    exact: PropTypes.number
  })
});
const bookingDurationsPropTypes = getEntityPropTypes(bookingDurationPropTypes);
const bookingDurationAmounts = [
  { label: "15 minutes", value: 15 },
  { label: "30 minutes", value: 30 },
  { label: "45 minutes", value: 45 },
  { label: "1 hour", value: 60 },
  { label: "75 minutes", value: 75 },
  { label: "90 minutes", value: 90 },
  { label: "1 hour 45 minutes", value: 105 },
  { label: "2 hours", value: 120 },
  { label: "2 hours 15 minutes", value: 135 },
  { label: "2 hours 30 minutes", value: 150 },
  { label: "2 hours 45 minutes", value: 165 },
  { label: "3 hours", value: 180 }
];
const getData$2 = (bookingDuration) => {
  devLog("info", "getting data for bookingDuration", bookingDuration);
  const getGroupSize2 = () => {
    devLog("info", "getting group size for", bookingDuration);
    const sizeOption = (bookingDuration == null ? void 0 : bookingDuration.sizeOption) || "more";
    switch (sizeOption) {
      case "more":
        return {
          option: sizeOption,
          min: bookingDuration == null ? void 0 : bookingDuration.size,
          max: bookingDuration == null ? void 0 : bookingDuration.sizeMax,
          exact: bookingDuration == null ? void 0 : bookingDuration.size
        };
      case "less":
        return {
          option: sizeOption,
          min: 1,
          max: bookingDuration == null ? void 0 : bookingDuration.size,
          exact: bookingDuration == null ? void 0 : bookingDuration.size
        };
      case "exactly":
        return {
          option: sizeOption,
          min: bookingDuration == null ? void 0 : bookingDuration.size,
          max: bookingDuration == null ? void 0 : bookingDuration.size,
          exact: bookingDuration == null ? void 0 : bookingDuration.size
        };
      case "between":
        return {
          option: sizeOption,
          min: bookingDuration == null ? void 0 : bookingDuration.size,
          max: bookingDuration == null ? void 0 : bookingDuration.sizeMax,
          exact: bookingDuration == null ? void 0 : bookingDuration.size
        };
      default:
        return {
          option: sizeOption,
          min: bookingDuration == null ? void 0 : bookingDuration.size,
          max: bookingDuration == null ? void 0 : bookingDuration.sizeMax,
          exact: bookingDuration == null ? void 0 : bookingDuration.size
        };
    }
  };
  return {
    objectId: bookingDuration.objectId,
    areaIds: bookingDuration.areaIds,
    duration: bookingDuration.duration,
    groupSize: getGroupSize2()
  };
};
const convertDataForApi$1 = (updatedBookingDuration, isAllAreas = false) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h;
  devLog("info", "converting bookingDuration data for api", updatedBookingDuration);
  const sizeOptionMap = {
    more: "more",
    less: "less",
    exactly: "exactly",
    between: "between",
    any: "any"
  };
  const sizeOption = sizeOptionMap == null ? void 0 : sizeOptionMap[(_a = updatedBookingDuration == null ? void 0 : updatedBookingDuration.groupSize) == null ? void 0 : _a.option];
  const data = {
    areaIds: isAllAreas ? null : (_b2 = updatedBookingDuration == null ? void 0 : updatedBookingDuration.areaIds) == null ? void 0 : _b2.map((id) => `${id}`),
    duration: updatedBookingDuration == null ? void 0 : updatedBookingDuration.duration,
    sizeOption
  };
  switch ((_c2 = updatedBookingDuration == null ? void 0 : updatedBookingDuration.groupSize) == null ? void 0 : _c2.option) {
    case "more":
      data.size = (_d2 = updatedBookingDuration == null ? void 0 : updatedBookingDuration.groupSize) == null ? void 0 : _d2.min;
      data.sizeMax = null;
      break;
    case "less":
      data.size = (_e2 = updatedBookingDuration == null ? void 0 : updatedBookingDuration.groupSize) == null ? void 0 : _e2.max;
      data.sizeMax = null;
      break;
    case "exactly":
      data.size = (_f = updatedBookingDuration == null ? void 0 : updatedBookingDuration.groupSize) == null ? void 0 : _f.exact;
      data.sizeMax = null;
      break;
    case "between":
      data.size = (_g = updatedBookingDuration == null ? void 0 : updatedBookingDuration.groupSize) == null ? void 0 : _g.min;
      data.sizeMax = (_h = updatedBookingDuration == null ? void 0 : updatedBookingDuration.groupSize) == null ? void 0 : _h.max;
      break;
    case "any":
    default:
      data.size = 1;
      data.sizeMax = -1;
      data.sizeOption = "more";
      break;
  }
  return data;
};
const getAreaNameList = (areasList, areasSelected) => {
  if (areasSelected === null || areasSelected.length === areasList.length) {
    return "All areas";
  }
  return areasSelected.map((area) => getLabelForValue(area, areasList)).join(", ");
};
const initialState$5 = getInitialApiItemState();
const name = "BOOKING_DURATION";
const bookingDurationsReducer = (state = initialState$5, action) => {
  const overrides = {};
  return updateApiState(name, state, action, getData$2, overrides, "objectId", false);
};
const initialState$4 = {
  ...getInitialApiItemState([])
};
const fullyBookedSessionsReducer = (state = initialState$4, action) => {
  switch (action.type) {
    case FETCH_FULLY_BOOKED_SESSIONS_PENDING:
      return setFetchPending(state);
    case FETCH_FULLY_BOOKED_SESSIONS_SUCCESS:
      return setDataSuccess(action.payload.data, state);
    case FETCH_FULLY_BOOKED_SESSIONS_FAILURE:
      return setFailed(state, action.payload.error);
    case BULK_UPDATE_FULLY_BOOKED_SESSIONS_PENDING:
      return setPending(state);
    case BULK_UPDATE_FULLY_BOOKED_SESSIONS_SUCCESS:
      return setDataSuccess(action.payload.data, state);
    case BULK_UPDATE_FULLY_BOOKED_SESSIONS_FAILURE:
      return updateItemFailure(state, action.payload.error);
    case CLEAR_FULLY_BOOKED_SESSIONS:
      return clear$1(state);
    default:
      return state;
  }
};
const widgetSettingKeys = [
  "navigationLogoUrl",
  "navigationLogoAlignment",
  "navigationBgColour",
  "navigationBgColourTransparency",
  "navigationUnderlineColour",
  "navigationShowVenueName",
  "navigationVenueNameTextColour",
  "navigationShowNeedHelp",
  "navigationNeedHelpButtonBorderColour",
  "navigationNeedHelpButtonTextColour",
  "backgroundType",
  "backgroundValue",
  "backgroundImageUrl",
  "providerLogoStyle",
  "availabilityMainButtonBgColour",
  "availabilityMainButtonTextColour",
  "availabilityMainButtonCornerRadius",
  "availabilityFieldsActiveStateColour",
  "availabilityFieldsColourOpacity",
  "availabilityBackgroundBoxBgColour",
  "availabilityBackgroundBoxBorderColour",
  "availabilityBackgroundBoxBorderWeight",
  "navigationShowHeaderText",
  "navigationHeaderTextColour",
  "availabilityFontFamilies",
  "generalFontFamilies",
  "dateSelectorType",
  "navigationHeaderText",
  "darkTheme",
  "mainTextColour",
  "secondaryTextColour",
  "secondaryTextOpacity",
  "outlineColour",
  "outlineOpacity",
  "activeOutlineColour",
  "faviconUrl",
  "bodyTextColour",
  "bodyButtonTextColour",
  "bodyButtonBorderColour",
  "showAreaImages",
  "areas",
  "showChildren",
  "showHighChairs",
  "showMarketingOptIn",
  "marketingOptInMessage",
  "displayHelpfulInfo",
  "hasDisabledAccess",
  "hasDressCode",
  "hasKidsMenu",
  "hasPlayArea",
  "hasBYO",
  "hasCorkage",
  "hasCakes",
  "disabledOption",
  "dressCodeOption",
  "kidsMenuOption",
  "playAreaOption",
  "byoOption",
  "corkageOption",
  "corkageFee",
  "corkagePer",
  "cakesOption",
  "suggestAvailability",
  "linkedVenues",
  "venueMessage",
  "showCustomMessages",
  "showVenueClosedMessage",
  "showNoAvailabilityDayMessage",
  "showNoAvailabilityTimeMessage",
  "showCutoffMessage",
  "venueClosedMessage",
  "noAvailabilityDayMessage",
  "noAvailabilityTimeMessage",
  "cutoffMessage",
  "navigationShowHeaderForEmbed",
  "navigationShowUnderline",
  "navigationUnderlineHeight",
  "providerLogoAlignment",
  "showProviderLogo",
  "venueDescription",
  "showMaxGroupMessage",
  "maxGroupMessage",
  "showVenueInfoOnCutoff",
  "cutoffContactType"
];
const widgetSettingPropTypes = PropTypes.shape({
  // Settings that we use
  navigationLogoUrl: PropTypes.string,
  navigationLogoAlignment: PropTypes.string,
  navigationBgColour: PropTypes.string,
  navigationBgColourTransparency: PropTypes.number,
  navigationUnderlineColour: PropTypes.string,
  navigationShowVenueName: PropTypes.bool,
  navigationVenueNameTextColour: PropTypes.string,
  navigationShowNeedHelp: PropTypes.bool,
  navigationNeedHelpButtonBorderColour: PropTypes.string,
  navigationNeedHelpButtonTextColour: PropTypes.string,
  backgroundType: PropTypes.string,
  backgroundValue: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  providerLogoStyle: PropTypes.string,
  // obee/eatclub logo
  availabilityMainButtonBgColour: PropTypes.string,
  // Next button background
  availabilityMainButtonTextColour: PropTypes.string,
  // Next button text
  availabilityMainButtonCornerRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // Note: need to have the px removed
  availabilityFieldsActiveStateColour: PropTypes.string,
  // The time option when clicked
  availabilityFieldsColourOpacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // ?
  availabilityBackgroundBoxBgColour: PropTypes.string,
  // The background of the actual content
  availabilityBackgroundBoxBorderColour: PropTypes.string,
  // Optional border around that box. How to disable?
  availabilityBackgroundBoxBorderWeight: PropTypes.number,
  // The weight of that border
  navigationShowHeaderText: PropTypes.bool,
  // Whether to show the reservations text
  navigationHeaderTextColour: PropTypes.string,
  // Colour of reservations text
  availabilityFontFamilies: PropTypes.string,
  // Half of the text
  generalFontFamilies: PropTypes.string,
  // The other half of the text. Set these together
  dateSelectorType: PropTypes.string,
  // What type of date selector/calendar to show
  navigationHeaderText: PropTypes.string,
  // Reservations text
  darkTheme: PropTypes.bool,
  mainTextColour: PropTypes.string,
  secondaryTextColour: PropTypes.string,
  secondaryTextOpacity: PropTypes.number,
  outlineColour: PropTypes.string,
  outlineOpacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // Might come back as string instead of int
  activeOutlineColour: PropTypes.string,
  faviconUrl: PropTypes.string,
  // Custom favicon
  // Settings that are used here but maybe not in widget:
  bodyTextColour: PropTypes.string,
  bodyButtonTextColour: PropTypes.string,
  bodyButtonBorderColour: PropTypes.string,
  showAreaImages: PropTypes.bool,
  areas: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  showChildren: PropTypes.bool,
  showHighChairs: PropTypes.bool,
  showMarketingOptIn: PropTypes.bool,
  marketingOptInMessage: PropTypes.string,
  displayHelpfulInfo: PropTypes.bool,
  hasDisabledAccess: PropTypes.bool,
  hasDressCode: PropTypes.bool,
  hasKidsMenu: PropTypes.bool,
  hasPlayArea: PropTypes.bool,
  hasBYO: PropTypes.bool,
  hasCorkage: PropTypes.bool,
  hasCakes: PropTypes.bool,
  // Options after each section is selected
  disabledOption: PropTypes.string,
  dressCodeOption: PropTypes.string,
  kidsMenuOption: PropTypes.string,
  playAreaOption: PropTypes.string,
  byoOption: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  corkageOption: PropTypes.string,
  corkageFee: PropTypes.string,
  corkagePer: PropTypes.string,
  cakesOption: PropTypes.string,
  // Multiple venues
  suggestAvailability: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  linkedVenues: PropTypes.arrayOf(PropTypes.string),
  venueDescription: PropTypes.string,
  // Unavailability and messaging
  venueMessage: PropTypes.string,
  showCustomMessages: PropTypes.bool,
  showVenueClosedMessage: PropTypes.bool,
  showNoAvailabilityDayMessage: PropTypes.bool,
  showNoAvailabilityTimeMessage: PropTypes.bool,
  showCutoffMessage: PropTypes.bool,
  venueClosedMessage: PropTypes.string,
  noAvailabilityDayMessage: PropTypes.string,
  noAvailabilityTimeMessage: PropTypes.string,
  cutoffMessage: PropTypes.string,
  showMaxGroupMessage: PropTypes.string,
  maxGroupMessage: PropTypes.string,
  showVenueInfoOnCutoff: PropTypes.bool,
  cutoffContactType: PropTypes.string,
  // Other types that might not be part of this:
  // area image
  // area description
  // Settings not used here: TODO find out what these do
  navigationShowHeaderForEmbed: PropTypes.bool,
  // deprecated as query param is used instead
  navigationShowUnderline: PropTypes.bool,
  navigationUnderlineHeight: PropTypes.number,
  providerLogoAlignment: PropTypes.string,
  showProviderLogo: PropTypes.bool
});
const widgetSettingsPropTypes = PropTypes.shape({
  apiData: widgetSettingPropTypes,
  data: widgetSettingPropTypes,
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const extractInt = (value, defaultValue = 0) => {
  if (value === false) {
    return 0;
  }
  if (value === true) {
    return 1;
  }
  if (isVoid(value)) {
    return defaultValue;
  }
  return parseInt(value, 10) || 0;
};
const getValueAsNumber = (value, suffixToRemove = "%", defaultValue = 0) => {
  return parseInt(`${extractInt(value, defaultValue)}`.replace(suffixToRemove, ""), 10);
};
const getData$1 = (widgetSettings2) => {
  const defaultFont = isObee() ? "Inter" : "Gordita";
  const byoOption = safeParse(widgetSettings2 == null ? void 0 : widgetSettings2.byoOption);
  const widgetSettingsData = {
    ...widgetSettings2,
    showAreaImages: widgetSettings2.showAreaImages,
    availabilityMainButtonCornerRadius: getValueAsNumber(
      widgetSettings2.availabilityMainButtonCornerRadius,
      "px"
    ),
    availabilityBackgroundBoxBorderWeight: getValueAsNumber(
      widgetSettings2.availabilityBackgroundBoxBorderWeight,
      "px"
    ),
    availabilityFieldsColourOpacity: getValueAsNumber(
      widgetSettings2.availabilityFieldsColourOpacity,
      "%",
      100
    ),
    secondaryTextOpacity: getValueAsNumber(widgetSettings2.secondaryTextOpacity, "%", 100),
    outlineOpacity: getValueAsNumber(widgetSettings2.outlineOpacity, "%", 100),
    navigationBgColourTransparency: getValueAsNumber(
      widgetSettings2.navigationBgColourTransparency,
      "%",
      100
    ),
    navigationUnderlineHeight: getValueAsNumber(widgetSettings2.navigationUnderlineHeight, "px", 1),
    availabilityFontFamilies: (widgetSettings2 == null ? void 0 : widgetSettings2.availabilityFontFamilies) || defaultFont,
    generalFontFamilies: (widgetSettings2 == null ? void 0 : widgetSettings2.generalFontFamilies) || defaultFont,
    byoOption: typeof byoOption === "string" ? byoOption : Object.values(byoOption) || [],
    linkedVenues: Object.values(safeParse(widgetSettings2 == null ? void 0 : widgetSettings2.linkedVenues)) || [],
    showMarketingOptIn: !!(widgetSettings2 == null ? void 0 : widgetSettings2.showMarketingOptIn)
  };
  return widgetSettingsData;
};
const convertFieldsToString = (data, fields) => {
  const newData = { ...data };
  fields.forEach((field) => {
    if (isSet(newData == null ? void 0 : newData[field])) {
      if (Array.isArray(newData[field])) {
        newData[field] = stringifyArray(newData[field]);
      } else {
        newData[field] = `${newData[field]}`;
      }
    }
  });
  return newData;
};
const themeSettings = [
  "navigationLogoUrl",
  "navigationLogoAlignment",
  "navigationBgColour",
  "navigationBgColourTransparency",
  "navigationUnderlineColour",
  "navigationShowVenueName",
  "navigationVenueNameTextColour",
  "navigationShowNeedHelp",
  "navigationNeedHelpButtonBorderColour",
  "navigationNeedHelpButtonTextColour",
  "backgroundType",
  "backgroundValue",
  "backgroundImageUrl",
  "providerLogoStyle",
  "availabilityMainButtonBgColour",
  "availabilityMainButtonTextColour",
  "availabilityMainButtonCornerRadius",
  "availabilityFieldsActiveStateColour",
  "availabilityFieldsColourOpacity",
  "availabilityBackgroundBoxBgColour",
  "availabilityBackgroundBoxBorderColour",
  "availabilityBackgroundBoxBorderWeight",
  "navigationShowHeaderText",
  "navigationHeaderTextColour",
  "availabilityFontFamilies",
  "generalFontFamilies",
  "dateSelectorType",
  "navigationHeaderText",
  "bodyTextColour",
  "bodyButtonTextColour",
  "bodyButtonBorderColour",
  "navigationShowHeaderForEmbed",
  "navigationShowUnderline",
  "navigationUnderlineHeight",
  "providerLogoAlignment",
  "showProviderLogo",
  "darkTheme",
  "mainTextColour",
  "secondaryTextColour",
  "secondaryTextOpacity",
  "outlineColour",
  "outlineOpacity",
  "activeOutlineColour",
  "faviconUrl"
];
const widgetSettings = [
  "showAreaImages",
  "areas",
  "showChildren",
  "showHighChairs",
  "showMarketingOptIn",
  "marketingOptInMessage",
  "displayHelpfulInfo",
  "hasDisabledAccess",
  "hasDressCode",
  "hasKidsMenu",
  "hasPlayArea",
  "hasBYO",
  "hasCorkage",
  "hasCakes",
  "disabledOption",
  "dressCodeOption",
  "kidsMenuOption",
  "playAreaOption",
  "byoOption",
  "corkageOption",
  "corkageFee",
  "corkagePer",
  "cakesOption",
  "suggestAvailability",
  "linkedVenues",
  "venueMessage",
  "showCustomMessages",
  "showVenueClosedMessage",
  "showNoAvailabilityDayMessage",
  "showNoAvailabilityTimeMessage",
  "showCutoffMessage",
  "showMaxGroupMessage",
  "maxGroupMessage",
  "showCreateCutoffMessage",
  "showVenueInfoOnCutoff",
  "cutoffContactType",
  "venueClosedMessage",
  "noAvailabilityDayMessage",
  "noAvailabilityTimeMessage",
  "venueDescription"
];
const convertDataForApi = (settingsToSave) => {
  let data = {
    ...settingsToSave
  };
  data = convertFieldsToString(data, [
    "availabilityMainButtonCornerRadius",
    "availabilityBackgroundBoxBorderWeight",
    "navigationBgColourTransparency"
  ]);
  return {
    theme: stringifyObject(only(data, themeSettings)),
    settings: stringifyObject(only(data, widgetSettings))
  };
};
const initialState$3 = {
  apiData: {},
  data: {},
  error: "",
  pending: false,
  success: false
};
const widgetSettingsReducer = (state = initialState$3, action) => {
  switch (action.type) {
    case FETCH_WIDGET_SETTINGS_PENDING:
      return setPending(state);
    case FETCH_WIDGET_SETTINGS_SUCCESS:
      return setDataSuccess(getData$1(action.payload.data), state);
    case FETCH_WIDGET_SETTINGS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_WIDGET_SETTING_PENDING:
      return {
        ...state,
        data: getData$1({ ...state.data, ...action.payload.data }),
        pending: true,
        success: false,
        error: ""
      };
    case UPDATE_WIDGET_SETTING_SUCCESS:
      return setSuccess(state);
    case UPDATE_WIDGET_SETTING_FAILURE:
      return { ...state, data: state.apiData, pending: false, error: action.payload };
    default:
      return state;
  }
};
const brandedEmailSettingPropTypes = PropTypes.shape({
  // Messaging
  confirmationMessage: PropTypes.string,
  reminderMessage: PropTypes.string,
  followupMessage: PropTypes.string,
  cancellationMessage: PropTypes.string,
  waitlistMessage: PropTypes.string,
  // Navigation
  logoUrl: PropTypes.string,
  navigationBackgroundColor: PropTypes.string,
  // Main content
  featureImageUrl: PropTypes.string,
  bodyBackgroundColor: PropTypes.string,
  emailBackgroundColor: PropTypes.string,
  emailBorderColor: PropTypes.string,
  fontColor: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonTextColor: PropTypes.string,
  bookingLabelColor: PropTypes.string,
  textLinkColor: PropTypes.string,
  // Footer
  showProviderLogo: PropTypes.bool
});
const brandedEmailSettingsPropTypes = PropTypes.shape({
  apiData: brandedEmailSettingPropTypes,
  data: brandedEmailSettingPropTypes,
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const getData = (data) => {
  var _a;
  return ((_a = safeParse(data)) == null ? void 0 : _a.themeDetails) || {};
};
const initialState$2 = {
  apiData: {},
  data: {},
  error: "",
  pending: false,
  success: false
};
const brandedEmailSettingsReducer = (state = initialState$2, action) => {
  switch (action.type) {
    case FETCH_BRANDED_EMAIL_SETTINGS_PENDING:
      return setPending(state);
    case FETCH_BRANDED_EMAIL_SETTINGS_SUCCESS:
      return setDataSuccess(getData(action.payload.data), state);
    case FETCH_BRANDED_EMAIL_SETTINGS_FAILURE:
      return setFailed(state, action.payload.error);
    case UPDATE_BRANDED_EMAIL_SETTING_PENDING:
      return {
        ...state,
        data: { ...state.data, ...action.payload.data },
        pending: true,
        success: false,
        error: ""
      };
    case UPDATE_BRANDED_EMAIL_SETTING_SUCCESS:
      return setSuccess(state);
    case UPDATE_BRANDED_EMAIL_SETTING_FAILURE:
      return { ...state, pending: false, error: action.payload };
    default:
      return state;
  }
};
const initialState$1 = {
  apiData: {},
  data: {},
  error: "",
  pending: false,
  success: false,
  pagination: {},
  name: "monthlyView"
};
const monthlyViewReducer = (state = initialState$1, action) => {
  switch (action.type) {
    case FETCH_OBEE_MONTHLY_VIEW_PENDING:
      return setPending(state);
    case FETCH_OBEE_MONTHLY_VIEW_SUCCESS:
      return setDataSuccess(getMonthlyData(action.payload.data), state);
    case FETCH_OBEE_MONTHLY_VIEW_FAILURE:
      return setFailed(state, action.payload.error);
    case CLEAR_OBEE_MONTHLY_VIEW:
      return clear$1(state);
    default:
      return state;
  }
};
const reducers = {
  // restaurant: restaurantReducer,
  // restaurantActive: restaurantActiveReducer,
  // restaurants: restaurantsReducer,
  apiRequests: apiRequestsReducer,
  areas: areasReducer,
  bookingDurations: bookingDurationsReducer,
  bookingLimits: bookingLimitsReducer,
  brandedEmailSettings: brandedEmailSettingsReducer,
  chargeNoShow: chargeNoShowReducer,
  closeEarly: closeEarlyReducer,
  dailyNotes: dailyNotesReducer,
  dailyNoteCategories: dailyNoteCategoriesReducer,
  facebookRedirectUrl: facebookRedirectUrlReducer,
  floorplan: floorplanReducer,
  form: formReducer,
  fullyBookedSessions: fullyBookedSessionsReducer,
  messagesSettings: messagesSettingsReducer,
  metaCallback: metaCallbackReducer,
  metaIntegration: metaIntegrationReducer,
  metaLoginButton: metaLoginButtonReducer,
  notificationEvents: notificationEventsReducer,
  notifications: notificationsReducer,
  obeeAvailability: obeeAvailabilityReducer,
  obeeAvailabilitySuggestions: obeeAvailabilitySuggestionsReducer,
  obeeBookings: obeeBookingsReducer,
  obeeBookingsForUser: bookingsForUserReducer,
  obeeEventSessions: eventSessionsReducer,
  obeeGlobalSessions: globalSessionsReducer,
  obeeGuests: obeeGuestsReducer,
  obeeIntegrations: integrationsReducer,
  obeeScreen: obeeScreenReducer,
  obeeSessions: sessionsReducer,
  obeeSettings: settingsReducer,
  widgetSettings: widgetSettingsReducer,
  obeeStaff: obeeStaffReducer,
  obeeUpdateCheck: obeeUpdateCheckReducer,
  paymentSettings: paymentSettingsReducer,
  reserveWithGoogle: reserveWithGoogleReducer,
  tables: tablesReducer,
  voucherRedemptions: voucherRedemptionReducer,
  monthlyView: monthlyViewReducer
};
combineReducers(reducers);
const store = window.getStore();
for (const key in reducers) {
  if (Object.prototype.hasOwnProperty.call(reducers, key)) {
    store.reducerManager.add(key, reducers[key]);
  }
}
const store$1 = store;
const OBSettings$1 = `
	daysInAdvance
	systemTimeInterval
	bookingsDuration
	waitlist
	abHighchairs
	abVaccination
	abTakenBy
	abConfirmation
	ccCapture
	ccNoShowFee
	ccPaymentPolicy
	ccWaitlistShow
	ccWaitlistPolicy
	ccAddBookings
	terms
	logo
	heroImage
	favicon
	stepperColor
	iconBgColor
	datePickerColor
	linkColor
	availableTimesColor
	formBgColor
	venueMessage
	disabledAccess
	dressCode
	kidFriendly
	kidsPlayArea
	byo
	corkage
	cakeage
	showHighchairs
	groupSizeLimit
	groupSizeMessage
	areaPhotos
	slug
	openingHoursStyle
	operationsEmail
	cutoffMode
	cutoffValue
	hasCustomDuration
	hasVoucherRedeem
	customOverrides
	hasPaymentSettings
	messaging
	addBookingSettings
	runsheetSettings
	defaultLandingPage
`;
const Restaurant$1 = `
	objectId
	name
	region
	address1
	address2
	city
	state
	postcode
	phone
	website
	instagramLink
	facebookLink
	twitterLink
	obeeEnabled
	obeeGoLiveDate
	obeeToken
	premium
	slug
	closedEarly
`;
const RestaurantTheme$1 = `
  theme
  bookingWidgetSettings
`;
const OBTableBlock$1 = `
	id
	tableId
	date
	startTime
	endTime
`;
const OBTable$1 = `
	id
	areaId
	tableNumber
	notes
	min
	max
	priority
	isPublic
	blocks {
		${OBTableBlock$1}
	}
	customDuration
`;
const OBArea$1 = `
	id
	name
	duration
	capacity
	priority
	minGroup
	maxGroup
	cutoffMode
	cutoffValue
`;
const OBSession$1 = `
	id
	areaId
	label
	startTime
	endTime
	isPublic
	day
	date
	sittingTimes
`;
const OBGuest$1 = `
	id
	firstName
	lastName
	email
	mobile
	landline
	title
	description
	notes
	allergies
	birthday
	vip
	jobCompany
	interests
	secretary
	address
	postcode
	website
	blog
	facebook
	twitter
	instagram
	pinterest
	linkedIn
	blacklisted
	favouriteMeals
	favouriteDrinks
	preferredTableArea
	smsPromo
	emailPromo
	numVisits
`;
const OBGuestFilter = `
	guests {
		${OBGuest$1}
	}
	currentPage
	totalPages
	totalResults
	pageSize
`;
const OBBooking$1 = `
	createdAt
	id
	areaId
	date
	time
	size
	name
	code
	restaurantComments
	customerComments
	source
	status
	tableNumber
	tableId
	duration
	labels
	kids
	highchairs
	vaccinated
	quotedMins
	staff
	history
	paymentCustomerId
	paymentMethodId
	paymentMethodName
	guests {
		${OBGuest$1}
	}
	ccNoShowFee
	ccNoShowChargeType
	ccNoShowChargeStatus
	ccNoShowChargeTime
	ccNoShowPaymentIntentId
	ccNoShowChargeDisplayNumber
	payments
	waitlistSMS
	commsHistory
	lastEditedByGuest
`;
const OBAvailabilitySuggestion$1 = `
  time
  table {
    ${OBTable$1}
  }
`;
const OBTimeslotLimit$1 = `
	objectId
	restId
	conditionId
	startTime
	endTime
	limitType
	limitValue
	groupSizeOption
	groupSizeMin
	groupSizeMax
	timeInterval
	source
`;
const OBTimeslotCondition$1 = `
	objectId
	areaId
	days
	startDate
	endDate
	limits {
	 ${OBTimeslotLimit$1}
 }
`;
const Integration$1 = `
	id
	data
	active
`;
const Notification$1 = `
	id
	date
	time
	bSize
	bName
	bMade
	bType
	status
	orderByDate
	tableNumber
	customerComments
	whichNotification
`;
const ObeePubSubEvent$1 = `
	restId
	type
`;
const OBBookingDuration$1 = `
	objectId
	areaIds
	duration
	size
	sizeMax
	sizeOption
`;
const OBFullyBooked$1 = `
	areaId
	name
	capacity
	sessionId
	label
	openingTime
	closingTime
	fullyBooked
	fullyBookedBId
`;
const MessagesSettings$3 = `
	confirmationEmail
	confirmationSMS
	reminderEmail
	reminderSMS
	thankYouEmail
	cancellationEmail
	waitlistEmail
`;
const PaymentSettings$2 = `
  id
  areaId
  date
  dateMax
  day
  timeOption
  time
  timeMax
  sizeOption
  size
  sizeMax
  source
  mode
  noShowAmount
  noShowOption
  depositAmount
  depositOption
  fullAmount
  fullOption
  currency
  includeGST
  title
  shortDescription
  policyUrl
  policyText
  staffPayRequired
  usedBy
  priority
  deleted
  publishableKey
  pinMode
`;
const OBDailyNoteCategory$1 = `
  id
  category
  colour
`;
const OBDailyNote$1 = `
  id
  date
  title
  note
	category {
		${OBDailyNoteCategory$1}
	}
  insertedBy
  pinned
  createdDate
`;
const OBBookingInputKeys$1 = [
  "areaId",
  "date",
  "time",
  "size",
  "guests",
  "name",
  "restaurantComments",
  "customerComments",
  "source",
  "status",
  "tableNumber",
  "tableId",
  "duration",
  "labels",
  "kids",
  "highchairs",
  "vaccinated",
  "quotedMins",
  "staff",
  // 'emailConfirmation',
  // 'paymentMethodId', // Not used in obee
  // 'paymentMethodName',
  // 'setupIntentId',
  "cardToken",
  "amount",
  "paymentSettingId",
  "ccMode",
  "sendConfirmationEmail",
  "sendConfirmationSMS"
];
const OBBookingPaymentInputKeys = [
  "guests",
  "cardToken",
  "amount",
  "paymentSettingId",
  "ccMode"
];
const OBGuestInputKeys$1 = [
  "firstName",
  "lastName",
  "email",
  "mobile",
  // 'landline',
  "title",
  "description",
  "notes",
  "allergies",
  "birthday",
  "vip",
  "jobCompany",
  "interests",
  "secretary",
  "address",
  "postcode",
  "website",
  "blog",
  "facebook",
  "twitter",
  "instagram",
  "pinterest",
  "linkedIn",
  "blacklisted",
  "favouriteMeals",
  "favouriteDrinks",
  "preferredTableArea",
  "emailPromo",
  "smsPromo"
];
const OBGuestUpdateInput = [
  "firstName",
  "lastName",
  "email",
  "mobile",
  "landline",
  "title",
  "description",
  "notes",
  "allergies",
  "birthday",
  "vip",
  "jobCompany",
  "interests",
  "secretary",
  "address",
  "postcode",
  "website",
  "blog",
  "facebook",
  "twitter",
  "instagram",
  "pinterest",
  "linkedIn",
  "blacklisted",
  "favouriteMeals",
  "favouriteDrinks",
  "preferredTableArea",
  "smsPromo",
  "emailPromo"
];
const createArea$1 = (
  /* GraphQL */
  `
  mutation CreateArea($restId: String!, $area: OBAreaInput!) {
    createArea(restId: $restId, area: $area) {
      ${OBArea$1}
    }
  }
`
);
const createSession$1 = (
  /* GraphQL */
  `
  mutation CreateSession($restId: String!, $session: OBSessionInput!) {
    createSession(restId: $restId, session: $session){
      ${OBSession$1}
    }
  }
`
);
const createTable$1 = (
  /* GraphQL */
  `
  mutation CreateTable($restId: String!, $table: OBTableInput!) {
    createTable(restId: $restId, table: $table) {
      ${OBTable$1}
    }
  }
`
);
const createObeeBooking$2 = (
  /* GraphQL */
  `
  mutation CreateObeeBooking($restId: String!, $booking: OBBookingInput!) {
    createObeeBooking(restId: $restId, booking: $booking) {
      ${OBBooking$1}
    }
  }
`
);
const updateObeeBooking$2 = (
  /* GraphQL */
  `
  mutation UpdateObeeBooking($restId: String!, $bookingId: String!, $booking: OBBookingInput!) {
    updateObeeBooking(restId: $restId, bookingId: $bookingId, booking: $booking) {
      ${OBBooking$1}
    }
  }
`
);
const resubmitBookingPayment = (
  /* GraphQL */
  `
  mutation ResubmitBookingPayment($restId: String!, $bookingId: String!, $bookingPayment: OBBookingPaymentInput!) {
    resubmitBookingPayment(restId: $restId, bookingId: $bookingId, bookingPayment: $bookingPayment) {
      ${OBBooking$1}
    }
  }
`
);
const confirmWaitlist$2 = (
  /* GraphQL */
  `
  mutation ConfirmWaitlist($restId: String!, $bookingId: Int!, $areaId: Int, $tableId: Int, $staff: String) {
    confirmWaitlist(restId: $restId, bookingId: $bookingId, areaId: $areaId, tableId: $tableId, staff: $staff) {
      ${OBBooking$1}
    }
  }
`
);
const confirmWaitlistAsBooked$2 = (
  /* GraphQL */
  `
  mutation ConfirmWaitlistAsBooked($restId: String!, $bookingId: Int!, $areaId: Int, $tableId: Int, $staff: String) {
    confirmWaitlistAsBooked(restId: $restId, bookingId: $bookingId, areaId: $areaId, tableId: $tableId, staff: $staff) {
      ${OBBooking$1}
    }
  }
`
);
const sendWaitlistSMS$2 = (
  /* GraphQL */
  `
  mutation SendWaitlistSMS($restId: String!, $bookingId: String!, $inHowLong: String!) {
    sendWaitlistSMS(restId: $restId, bookingId: $bookingId, inHowLong: $inHowLong)
  }
`
);
const sendGuestEmail$2 = (
  /* GraphQL */
  `
  mutation SendGuestEmail($restId: String!, $bookingId: String!, $emailType: String!) {
    sendGuestEmail(restId: $restId, bookingId: $bookingId, emailType: $emailType)
  }
`
);
const sendGuestSMS$2 = (
  /* GraphQL */
  `
  mutation SendGuestSMS($restId: String!, $bookingId: String!, $smsType: String!) {
    sendGuestSMS(restId: $restId, bookingId: $bookingId, smsType: $smsType)
  }
`
);
const updateArea$1 = (
  /* GraphQL */
  `
  mutation UpdateArea($restId: String!, $areaId: Int!, $area: OBAreaInput!) {
    updateArea(restId: $restId, areaId: $areaId, area: $area) {
      ${OBArea$1}
    }
  }
`
);
const updateTable$1 = (
  /* GraphQL */
  `
  mutation UpdateTable($restId: String!, $tableId: Int!, $table: OBTableInput!) {
    updateTable(restId: $restId, tableId: $tableId, table: $table) {
      ${OBTable$1}
    }
  }
`
);
const deleteArea$1 = (
  /* GraphQL */
  `
  mutation DeleteArea($restId: String!, $areaId: Int!) {
    deleteArea(restId: $restId, areaId: $areaId)
  }
`
);
const deleteSession$1 = (
  /* GraphQL */
  `
  mutation DeleteSession($restId: String!, $sessionId: Int!) {
    deleteSession(restId: $restId, sessionId: $sessionId)
  }
`
);
const deleteTable$1 = (
  /* GraphQL */
  `
  mutation DeleteTable($restId: String!, $tableId: Int!) {
    deleteTable(restId: $restId, tableId: $tableId)
  }
`
);
const saveFloorPlan$1 = (
  /* GraphQL */
  `
  mutation SaveFloorPlan($restId: String!, $data: String!) {
    saveFloorPlan(restId: $restId, data: $data)
  }
`
);
const saveObeeSettings$1 = (
  /* GraphQL */
  `
  mutation SaveObeeSettings($restId: String!, $settings: OBSettingsInput!) {
    saveObeeSettings(restId: $restId, settings: $settings){
      ${OBSettings$1}
    }
  }
`
);
const saveRestaurant$1 = (
  /* GraphQL */
  `
  mutation SaveRestaurant($restId: String!, $restaurant: RestaurantInput!) {
    saveRestaurant(restId: $restId, restaurant: $restaurant){
      ${Restaurant$1}
    }
  }
`
);
const blockTable$2 = (
  /* GraphQL */
  `
  mutation BlockTable(
    $restId: String!
    $tableId: Int!
    $date: String!
    $startTime: Int
    $endTime: Int!
  ) {
    blockTable(
      restId: $restId
      tableId: $tableId
      date: $date
      startTime: $startTime
      endTime: $endTime
    ) {
      ${OBTableBlock$1}
    }
  }
`
);
const unblockTable$2 = (
  /* GraphQL */
  `
  mutation UnblockTable($restId: String!, $tableBlockId: Int!) {
    unblockTable(restId: $restId, tableBlockId: $tableBlockId)
  }
`
);
const editTableBlock$1 = (
  /* GraphQL */
  `
  mutation EditTableBlock(
    $restId: String!
    $tableBlockId: Int!
    $startTime: Int
    $endTime: Int
  ) {
    editTableBlock(
      restId: $restId
      tableBlockId: $tableBlockId
      startTime: $startTime
      endTime: $endTime
    ) {
      ${OBTableBlock$1}
    }
  }
`
);
const createTimeslotCondition$2 = (
  /* GraphQL */
  `
  mutation CreateTimeslotCondition($restId: String!, $condition: OBTimeslotConditionInput!) {
    createTimeslotCondition(restId: $restId, condition: $condition) {
      ${OBTimeslotCondition$1}
    }
  }
`
);
const deleteTimeslotCondition$2 = (
  /* GraphQL */
  `
  mutation DeleteTimeslotCondition($restId: String!, $conditionId: String!) {
    deleteTimeslotCondition(restId: $restId, conditionId: $conditionId)
  }
`
);
const createTimeslotLimit$2 = (
  /* GraphQL */
  `
  mutation CreateTimeslotLimit($restId: String!, $conditionId: String!, $limit: OBTimeslotLimitInput!) {
    createTimeslotLimit(restId: $restId, conditionId: $conditionId, limit: $limit) {
      ${OBTimeslotLimit$1}
    }
  }
`
);
const updateTimeslotLimit$2 = (
  /* GraphQL */
  `
  mutation UpdateTimeslotLimit($restId: String!, $limitId: String!, $limit: OBTimeslotLimitInput!) {
    updateTimeslotLimit(restId: $restId, limitId: $limitId, limit: $limit) {
      ${OBTimeslotLimit$1}
    }
  }
`
);
const deleteTimeslotLimit$2 = (
  /* GraphQL */
  `
  mutation DeleteTimeslotLimit($restId: String!, $limitId: String!) {
    deleteTimeslotLimit(restId: $restId, limitId: $limitId)
  }
`
);
const updateGuest$2 = (
  /* GraphQL */
  `
  mutation UpdateGuest($restId: String!, $guestId: Int!, $guest: OBGuestUpdateInput!) {
    updateGuest(restId: $restId, guestId: $guestId, guest: $guest) {
      ${OBGuest$1}
    }
  }
`
);
const saveTablePriorities$1 = (
  /* GraphQL */
  `
  mutation SaveTablePriorities($restId: String!, $tablePriorities: [OBTablePriorityInput]!) {
    saveTablePriorities(restId: $restId, tablePriorities: $tablePriorities) {
      ${OBTable$1}
    }
  }
`
);
const closeEarly$2 = (
  /* GraphQL */
  `
  mutation CloseEarly($restId: String!) {
    closeEarly(restId: $restId) {
      ${Restaurant$1}
    }
  }
`
);
const reopen$2 = (
  /* GraphQL */
  `
  mutation Reopen($restId: String!) {
    reopen(restId: $restId) {
      ${Restaurant$1}
    }
  }
`
);
const createPaymentSetupIntent$2 = (
  /* GraphQL */
  `
  mutation CreatePaymentSetupIntent(
    $name: String!
    $phone: String!
    $email: String
    $userId: String
    $stripeId: String
  ) {
    createPaymentSetupIntent(
      name: $name
      phone: $phone
      email: $email
      userId: $userId
      stripeId: $stripeId
    )
  }
`
);
const enableReserveWithGoogle$2 = (
  /* GraphQL */
  `
  mutation EnableReserveWithGoogle($restId: String!, $merchantTerms: String) {
    enableReserveWithGoogle(restId: $restId, merchantTerms: $merchantTerms) {
      ${Integration$1}
    }
  }
`
);
const disableReserveWithGoogle$2 = (
  /* GraphQL */
  `
  mutation DisableReserveWithGoogle($restId: String!) {
    disableReserveWithGoogle(restId: $restId) {
      ${Integration$1}
    }
  }
`
);
const chargeNoShow$2 = (
  /* GraphQL */
  `
  mutation ChargeNoShow($restId: String!, $obBookingId: String!, $charge: OBChargeNoShowInput!) {
    chargeNoShow(restId: $restId, obBookingId: $obBookingId, charge: $charge)
  }
`
);
const createBookingDuration$2 = (
  /* GraphQL */
  `
  mutation CreateBookingDuration($restId: String!, $duration: OBBookingDurationInput!) {
    createBookingDuration(restId: $restId, duration: $duration) {
      ${OBBookingDuration$1}
    }
  }
`
);
const updateBookingDuration$2 = (
  /* GraphQL */
  `
  mutation UpdateBookingDuration($restId: String!, $bookingDurationId: String!, $duration: OBBookingDurationInput!) {
    updateBookingDuration(restId: $restId, bookingDurationId: $bookingDurationId, duration: $duration) {
      ${OBBookingDuration$1}
    }
  }
`
);
const deleteBookingDuration$2 = (
  /* GraphQL */
  `
  mutation DeleteBookingDuration($restId: String!, $bookingDurationId: String!) {
    deleteBookingDuration(restId: $restId, bookingDurationId: $bookingDurationId)
  }
`
);
const createFullyBookedSessions$2 = (
  /* GraphQL */
  `
  mutation createFullyBookedSessions($restId: String!, $date: AWSDate!, $sessions: [OBFullyBookedCreateInput]!) {
    createFullyBookedSessions(restId: $restId, date: $date, sessions: $sessions) {
      ${OBFullyBooked$1}
    }
  }
`
);
const deleteFullyBookedSessions$2 = (
  /* GraphQL */
  `
  mutation deleteFullyBookedSessions($restId: String!, $date: AWSDate!, $sessions: [OBFullyBookedDeleteInput]!) {
    deleteFullyBookedSessions(restId: $restId, date: $date, sessions: $sessions) {
      ${OBFullyBooked$1}
    }
  }
`
);
const updateAreaCapacity$2 = (
  /* GraphQL */
  `
  mutation UpdateAreaCapacity($restId: String!) {
    updateAreaCapacity(restId: $restId)
  }
`
);
const generateFBLoginButton$1 = (
  /* GraphQL */
  `
  mutation GenerateFBLoginButton($restId: String!, $buttonText: String) {
    generateFBLoginButton(restId: $restId, buttonText: $buttonText)
  }
`
);
const disconnectMetaConnection$1 = (
  /* GraphQL */
  `
  mutation DisconnectMetaConnection($restId: String!, $companyId: String) {
    disconnectMetaConnection(restId: $restId, companyId: $companyId)
  }
`
);
const metaCallback$1 = (
  /* GraphQL */
  `
  mutation MetaCallback($restId: String!, $state: String!, $accessToken: String!) {
    metaCallback(restId: $restId, state: $state, accessToken: $accessToken)
  }
`
);
const getFBRedirectUrl$1 = (
  /* GraphQL */
  `
  mutation GetFBRedirectUrl($restId: String!, $queryString: String!) {
    getFBRedirectUrl(restId: $restId, queryString: $queryString)
  }
`
);
const saveMessagesSettings$1 = (
  /* GraphQL */
  `
  mutation SaveMessagesSettings($restId: String!, $settings: MessagesSettingsInput!) {
    saveMessagesSettings(restId: $restId, settings: $settings) {
      ${MessagesSettings$3}
    }
  }
`
);
const updateThemeSettings$1 = (
  /* GraphQL */
  `
  mutation UpdateThemeSettings($restId: String!, $settings: AWSJSON!) {
    updateThemeSettings(restId: $restId, settings: $settings)
  }
`
);
const updateBookingWidgetSettings$2 = (
  /* GraphQL */
  `
  mutation UpdateBookingWidgetSettings($restId: String!, $settings: AWSJSON!) {
    updateBookingWidgetSettings(restId: $restId, settings: $settings)
  }
`
);
const updateBrandedEmailSettings$2 = (
  /* GraphQL */
  `
  mutation UpdateBrandedEmailSettings($restId: String!, $settings: AWSJSON!) {
    updateBrandedEmailSettings(restId: $restId, settings: $settings)
  }
`
);
const createDailyNote$2 = (
  /* GraphQL */
  `
  mutation CreateDailyNote($restId: String!, $dailyNote: OBDailyNoteInput!) {
    createDailyNote(restId: $restId, dailyNote: $dailyNote){
      ${OBDailyNote$1}
    }
  }
`
);
const updateDailyNote$2 = (
  /* GraphQL */
  `
  mutation UpdateDailyNote($restId: String!, $id: String!, $dailyNote: OBDailyNoteUpdateInput!) {
    updateDailyNote(restId: $restId, id: $id, dailyNote: $dailyNote){
      ${OBDailyNote$1}
    }
  }
`
);
const deleteDailyNote$2 = (
  /* GraphQL */
  `
  mutation DeleteDailyNote($restId: String!, $id: String!) {
    deleteDailyNote(restId: $restId, id: $id)
  }
`
);
const restaurantById$1 = (
  /* GraphQL */
  `
  query RestaurantById($restId: String!) {
    restaurantById(restId: $restId) {
      ${Restaurant$1}
    }
  }
`
);
const restaurantBySlug = (
  /* GraphQL */
  `
  query RestaurantBySlug($slug: String!) {
    restaurantBySlug(slug: $slug) {
      ${Restaurant$1}
    }
  }
`
);
const restaurantSearchByName$1 = (
  /* GraphQL */
  `
  query RestaurantSearchByName($name: String!) {
    restaurantSearchByName(name: $name) {
      ${Restaurant$1}
    }
  }
`
);
const widgetTheme$1 = (
  /* GraphQL */
  `
  query WidgetTheme($restId: String!) {
    restaurantById(restId: $restId) {
      ${RestaurantTheme$1}
    }
  }
`
);
const obeeBookings$1 = (
  /* GraphQL */
  `
  query ObeeBookings($restId: String!, $date: AWSDate!) {
    obeeBookings(restId: $restId, date: $date) {
      ${OBBooking$1}
    }
  }
`
);
const obeeBookingsForUser$1 = (
  /* GraphQL */
  `
  query ObeeBookingsForUser($restId: String!, $userId: Int!) {
    obeeBookingsForUser(restId: $restId, userId: $userId) {
      ${OBBooking$1}
    }
  }
`
);
const obeeAvailabilityCheck$1 = (
  /* GraphQL */
  `
  query ObeeAvailabilityCheck(
    $restId: String!
    $areaId: Int!
    $date: AWSDate!
    $time: Int!
    $size: Int!
    $public: Boolean
    $returnAll: Boolean
    $excludeBookingId: Int
    $fromForceBooking: Boolean
  ) {
    obeeAvailabilityCheck(restId: $restId, areaId: $areaId, date: $date, time: $time, size: $size, public: $public, returnAll: $returnAll, excludeBookingId: $excludeBookingId, fromForceBooking: $fromForceBooking) {
      ${OBTable$1}
    }
  }
`
);
const obeeAvailabilityCheckAllAreas$1 = (
  /* GraphQL */
  `
  query ObeeAvailabilityCheckAllAreas(
    $restId: String!
    $date: AWSDate!
    $time: Int!
    $size: Int!
    $public: Boolean
    $returnAll: Boolean
    $excludeBookingId: Int
    $fromForceBooking: Boolean
  ) {
    obeeAvailabilityCheckAllAreas(restId: $restId, date: $date, time: $time, size: $size, public: $public, returnAll: $returnAll, excludeBookingId: $excludeBookingId, fromForceBooking: $fromForceBooking) {
      ${OBTable$1}
    }
  }
`
);
const obeeAvailabilitySuggestions$1 = (
  /* GraphQL */
  `
  query ObeeAvailabilitySuggestions(
    $restId: String!
    $areaId: Int!
    $date: AWSDate!
    $time: Int!
    $size: Int!
    $length: Int
    $public: Boolean
    $excludeBookingId: Int
  ) {
    obeeAvailabilitySuggestions(
      areaId: $areaId
      restId: $restId
      date: $date
      time: $time
      size: $size
      length: $length
      public: $public
      excludeBookingId: $excludeBookingId
    ) {
      ${OBAvailabilitySuggestion$1}
    }
  }
`
);
const obeeAreas$1 = (
  /* GraphQL */
  `
  query ObeeAreas($restId: String!) {
    obeeAreas(restId: $restId) {
      ${OBArea$1}
    }
  }
`
);
const obeeTables$1 = (
  /* GraphQL */
  `
  query ObeeTables($restId: String!, $date: String) {
    obeeTables(restId: $restId, date: $date) {
      ${OBTable$1}
    }
  }
`
);
const obeeFloorPlan$1 = (
  /* GraphQL */
  `
  query ObeeFloorPlan($restId: String!) {
    obeeFloorPlan(restId: $restId)
  }
`
);
const obeeSessions$1 = (
  /* GraphQL */
  `
  query ObeeSessions($restId: String!) {
    obeeSessions(restId: $restId) {
      ${OBSession$1}
    }
  }
`
);
const obeeSettings$1 = (
  /* GraphQL */
  `
  query ObeeSettings($restId: String!) {
    obeeSettings(restId: $restId) {
      ${OBSettings$1}
    }
  }
`
);
const obeeTimeslotConditions$1 = (
  /* GraphQL */
  `
  query ObeeTimeslotConditions($restId: String!) {
    obeeTimeslotConditions(restId: $restId) {
      ${OBTimeslotCondition$1}
    }
  }
`
);
const obeeBookingUpdateCheck$1 = (
  /* GraphQL */
  `
  query ObeeBookingUpdateCheck(
    $restId: String!
    $bookingId: Int!
    $areaId: Int
    $date: String
    $time: Int
    $size: Int
    $tableNumber: String
    $duration: Int
    $public: Boolean
  ) {
    obeeBookingUpdateCheck(
      restId: $restId
      bookingId: $bookingId
      areaId: $areaId
      date: $date
      time: $time
      size: $size
      tableNumber: $tableNumber
      duration: $duration
      public: $public
    )
  }
`
);
const obeeGuestsFilter = (
  /* GraphQL */
  `
  query ObeeGuestsFilter($restId: String!, $search: String, $searchType: String, $pageSize: String!, $page: String!) {
    obeeGuestsFilter(restId: $restId, search: $search, searchType: $searchType, pageSize: $pageSize, page: $page) {
      ${OBGuestFilter}
    }
  }
`
);
const lookupPaymentMethodName$2 = (
  /* GraphQL */
  `
  query LookupPaymentMethodName($paymentMethodId: String!) {
    lookupPaymentMethodName(paymentMethodId: $paymentMethodId)
  }
`
);
const obeeImageUploadUrl$1 = (
  /* GraphQL */
  `
  query ObeeImageUploadUrl($restId: String!, $slug: String!, $fileName: String!) {
    obeeImageUploadUrl(restId: $restId, slug: $slug, fileName: $fileName)
  }
`
);
const obeeIntegrations$1 = (
  /* GraphQL */
  `
  query ObeeIntegrations($restId: String!) {
    obeeIntegrations(restId: $restId) {
      ${Integration$1}
    }
  }
`
);
const obeeNotificationCount$1 = (
  /* GraphQL */
  `
  query ObeeNotificationCount($restId: String!, $lastChecked: String!) {
    obeeNotificationCount(restId: $restId, lastChecked: $lastChecked)
  }
`
);
const obeeNotifications$1 = (
  /* GraphQL */
  `
  query ObeeNotifications($restId: String!, $lastChecked: String!) {
    obeeNotifications(restId: $restId, lastChecked: $lastChecked) {
      ${Notification$1}
    }
  }
`
);
const obeeDailyNotes$1 = (
  /* GraphQL */
  `
  query ObeeDailyNotes($restId: String!, $date: String!) {
    obeeDailyNotes(restId: $restId, date: $date) {
      ${OBDailyNote$1}
    }
  }
`
);
const obeeDailyNoteCategories$1 = (
  /* GraphQL */
  `
  query ObeeDailyNoteCategories($restId: String!) {
    obeeDailyNoteCategories(restId: $restId) {
      ${OBDailyNoteCategory$1}
    }
  }
`
);
const obeeBookingDurations$1 = (
  /* GraphQL */
  `
  query ObeeBookingDurations($restId: String!) {
    obeeBookingDurations(restId: $restId) {
      ${OBBookingDuration$1}
    }
  }
`
);
const obeeFullyBookedSessions$1 = (
  /* GraphQL */
  `
  query ObeeFullyBookedSessions($restId: String!, $date: AWSDate!) {
    obeeFullyBookedSessions(restId: $restId, date: $date) {
      ${OBFullyBooked$1}
    }
  }
`
);
const messagesSettingsByRestId$1 = (
  /* GraphQL */
  `
  query MessagesSettingsByRestId($restId: String!) {
    messagesSettingsByRestId(restId: $restId) {
      ${MessagesSettings$3}
    }
  }
`
);
const obeePaymentSettingsByCriteria = (
  /* GraphQL */
  `
  query ObeePaymentSettingsByCriteria($restId: String!, $paymentSettings: OBPaymentSettingsInput!) {
    obeePaymentSettingsByCriteria(restId: $restId, paymentSettings: $paymentSettings) {
      ${PaymentSettings$2}
    }
  }
`
);
const obeeBrandedEmailSettings$1 = (
  /* GraphQL */
  `
  query ObeeBrandedEmailSettings($restId: String!) {
    obeeBrandedEmailSettings(restId: $restId)
  }
`
);
const obeeExportGuestBook$1 = (
  /* GraphQL */
  `
  query ObeeExportGuestBook($restId: String!) {
    obeeExportGuestBook(restId: $restId)
  }
`
);
const obeeMonthlyViewByDate$1 = (
  /* GraphQL */
  `
  query ObeeMonthlyViewByDate($restId: String!, $date: String!, $dateTo: String) {
    obeeMonthlyViewByDate(restId: $restId, date: $date, dateTo: $dateTo)
  }
`
);
const subscribeToObeePubSubEvents$1 = (
  /* GraphQL */
  `
  subscription SubscribeToObeePubSubEvents($restId: String!) {
    subscribeToObeePubSubEvents(restId: $restId) {
      ${ObeePubSubEvent$1}
    }
  }
`
);
const endpointPrefix = (_b = window.bookingsConfig) == null ? void 0 : _b.obeeApiPrefix;
const ObeeApiClient = () => {
  const makeExternalAPICall = () => {
    var _a, _b2;
    const state = store$1 == null ? void 0 : store$1.getState();
    const obeeToken = revertObscureString((_a = state.restaurantActive.restaurant) == null ? void 0 : _a.obeeToken);
    return factory(`${(_b2 = window.bookingsConfig) == null ? void 0 : _b2.obeeApiUrl}`).middlewares([
      throttlingCache({
        // Cache requests for 1 minute
        throttle: 6e4
      }),
      // Prevents having multiple identical requests on the fly at the same time
      dedupe()
    ]).auth(`Bearer ${obeeToken}`).resolve((response) => response.json());
  };
  const post = (uri, params) => {
    return makeExternalAPICall().url(`${endpointPrefix}${uri}`).post(params);
  };
  const put = (uri, params) => {
    return makeExternalAPICall().url(`${endpointPrefix}${uri}`).put(params);
  };
  const get2 = (uri) => {
    return makeExternalAPICall().url(`${endpointPrefix}${uri}`).get();
  };
  const obeeAPIProvider = (method, uri, params = []) => {
    try {
      switch (method) {
        case "get":
          return get2(!isEmpty(params) ? `${uri}?${new URLSearchParams(params).toString()}` : uri);
        case "post":
          return post(uri, params);
        case "put":
          return put(uri, params);
        default:
          return get2(uri);
      }
    } catch (error) {
      return {
        data: null,
        error: (error == null ? void 0 : error.message) || error,
        status: "error"
      };
    }
  };
  const graphqlApiCall = async (query, variables = {}, addRestId = true, graphqlCallback = (graphql) => graphql) => {
    var _a, _b2, _c2, _d2, _e2, _f, _g;
    const state = store$1 == null ? void 0 : store$1.getState();
    const restId = (_b2 = (_a = state == null ? void 0 : state.restaurantActive) == null ? void 0 : _a.restaurant) == null ? void 0 : _b2.objectId;
    const userId = state.user.userInfo.objectId;
    const { userType } = state.user.userInfo;
    const variablesWithExtra = {
      ...variables,
      ...addRestId ? { restId } : {}
    };
    const response = {
      response: null,
      status: null,
      error: null
    };
    try {
      const apiResponse = await graphqlCallback(
        API.graphql(
          {
            query,
            variables: variablesWithExtra,
            authMode: "AMAZON_COGNITO_USER_POOLS"
          },
          {
            "user-id": userId,
            "user-type": userType,
            "rest-id": restId,
            "app-version": getAppVersion()
          }
        )
      );
      response.response = apiResponse;
      response.status = "success";
    } catch (e) {
      devLog("info", "there was an error", e);
      const errorData = safeParse(((_d2 = (_c2 = e == null ? void 0 : e.errors) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.message) || ((_e2 = e == null ? void 0 : e.error) == null ? void 0 : _e2.message) || e);
      response.status = "error";
      response.error = {
        message: `${(errorData == null ? void 0 : errorData.message) || errorData}`,
        data: errorData || {}
      };
      if ((_f = response.error.message) == null ? void 0 : _f.includes("No current user")) {
        devLog("info", "no user, logging out");
        window.location = "/logout";
      }
    }
    const preventLoggingResponse = response.status === "success" && !((_g = window.bookingsConfig) == null ? void 0 : _g.logApiSuccesses);
    if (!preventLoggingResponse) {
      devLog(response.status, "GraphQL API response", response);
    }
    return response;
  };
  const cancelRequests2 = (model, now2) => {
    const state = store$1 == null ? void 0 : store$1.getState();
    const { apiRequests } = state;
    apiRequests.forEach((apiRequest) => {
      if (apiRequest.model === model && now2 > apiRequest.timestamp) {
        devLog("info", "cancelling api request", apiRequest);
        API.cancel(apiRequest.request);
      }
    });
  };
  const isCancel2 = (error) => {
    return API.isCancel(error);
  };
  const fetchBookings = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBookings$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBookings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const checkBookingUpdate2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBookingUpdateCheck$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBookingUpdateCheck,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createBooking = async (data) => {
    var _a, _b2, _c2;
    const bookingData = data.booking;
    const guestsInput = (_a = bookingData.guests) == null ? void 0 : _a.map((guest) => only(guest, OBGuestInputKeys$1));
    const bookingInputData = removeNullFields(
      only(
        {
          ...bookingData,
          ccMode: bookingData == null ? void 0 : bookingData.ccMode,
          guests: guestsInput
        },
        OBBookingInputKeys$1
      )
    );
    const inputData = {
      ...data,
      booking: bookingInputData
    };
    const response = await graphqlApiCall(createObeeBooking$2, inputData);
    return {
      data: (_c2 = (_b2 = response == null ? void 0 : response.response) == null ? void 0 : _b2.data) == null ? void 0 : _c2.createObeeBooking,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const resubmitBooking2 = async (data) => {
    var _a, _b2, _c2;
    const bookingPaymentData = data.bookingPayment;
    const guestsInput = (_a = bookingPaymentData.guests) == null ? void 0 : _a.map((guest) => only(guest, OBGuestInputKeys$1));
    const bookingPaymentInputData = removeNullFields(
      only(
        {
          ...bookingPaymentData,
          ccMode: bookingPaymentData == null ? void 0 : bookingPaymentData.ccMode,
          guests: guestsInput
        },
        OBBookingPaymentInputKeys
      )
    );
    const inputData = {
      ...data,
      bookingPayment: bookingPaymentInputData,
      bookingId: data == null ? void 0 : data.bookingId
    };
    const response = await graphqlApiCall(resubmitBookingPayment, inputData);
    return {
      data: (_c2 = (_b2 = response == null ? void 0 : response.response) == null ? void 0 : _b2.data) == null ? void 0 : _c2.resubmitBookingPayment,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateBooking = async (data) => {
    var _a, _b2, _c2, _d2, _e2, _f, _g;
    const guestsInput = (_a = data.booking.guests) == null ? void 0 : _a.map((guest) => only(guest, OBGuestInputKeys$1));
    const inputBookingData = only(
      {
        ...data.booking,
        cardToken: (_b2 = data.booking) == null ? void 0 : _b2.cardToken,
        amount: (_c2 = data.booking) == null ? void 0 : _c2.amount,
        paymentSettingId: (_d2 = data.booking) == null ? void 0 : _d2.paymentSettingId,
        ccMode: (_e2 = data.booking) == null ? void 0 : _e2.ccMode,
        guests: guestsInput
      },
      OBBookingInputKeys$1
    );
    const inputData = {
      ...data,
      booking: inputBookingData
    };
    const response = await graphqlApiCall(updateObeeBooking$2, inputData);
    return {
      data: (_g = (_f = response == null ? void 0 : response.response) == null ? void 0 : _f.data) == null ? void 0 : _g.updateObeeBooking,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const confirmWaitlistBooking = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(confirmWaitlist$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.confirmWaitlist,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const confirmWaitlistAsBooked2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(confirmWaitlistAsBooked$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.confirmWaitlistAsBooked,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const sendWaitlistSMS2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(sendWaitlistSMS$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.sendWaitlistSMSQuery,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const sendGuestEmail2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(sendGuestEmail$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.sendGuestEmail,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const sendGuestSMS2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(sendGuestSMS$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.sendGuestSMS,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchTables = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeTables$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeTables,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createTable2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createTable$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createTable,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateTable2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateTable$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateTable,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteTable2 = async (data) => {
    const response = await graphqlApiCall(deleteTable$1, data);
    return response;
  };
  const updateTablePriorities2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveTablePriorities$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.saveTablePriorities,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchSettings = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeSettings$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateSettings = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveObeeSettings$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.saveObeeSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchWidgetSettings2 = async (data) => {
    var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j;
    const response = await graphqlApiCall(widgetTheme$1, data);
    const combinedThemeData = {
      ...((_e2 = (_d2 = safeParse((_c2 = (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.restaurantById) == null ? void 0 : _c2.bookingWidgetSettings)) == null ? void 0 : _d2.themeSettings) == null ? void 0 : _e2.themeDetails) || {},
      ...((_j = (_i = safeParse((_h = (_g = (_f = response == null ? void 0 : response.response) == null ? void 0 : _f.data) == null ? void 0 : _g.restaurantById) == null ? void 0 : _h.bookingWidgetSettings)) == null ? void 0 : _i.widgetSettings) == null ? void 0 : _j.settingsDetails) || {}
    };
    return {
      data: combinedThemeData,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateWidgetTheme2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateThemeSettings$1, data, true);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateThemeSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateBookingWidgetSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateBookingWidgetSettings$2, data, true);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateBookingWidgetSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchMessagesSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(messagesSettingsByRestId$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.messagesSettingsByRestId,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateMessagesSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveMessagesSettings$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.saveMessagesSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchAreas = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeAreas$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeAreas,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createArea2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createArea$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createArea,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateArea2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateArea$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateArea,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteArea2 = async (data) => {
    const response = await graphqlApiCall(deleteArea$1, data);
    return response;
  };
  const fetchStaff2 = async () => {
    return {
      data: [],
      error: "This endpoint not supported"
    };
  };
  const createStaff2 = async () => {
    return {
      data: [],
      error: "This endpoint not supported"
    };
  };
  const updateStaff2 = async () => {
    return {
      data: [],
      error: "This endpoint not supported"
    };
  };
  const deleteStaff2 = async () => {
    return {
      data: [],
      error: "This endpoint not supported"
    };
  };
  const fetchSessions = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeSessions$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createSession2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createSession$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createSession,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateSession2 = async () => {
    return {
      data: null,
      error: "Updating sessions is not yet implemented"
    };
  };
  const deleteSession2 = async (data) => {
    const response = await graphqlApiCall(deleteSession$1, data);
    return response;
  };
  const fetchGlobalSessions = async () => {
    return { data: [], error: null };
  };
  const createGlobalSession2 = async () => {
    return { data: {}, error: null };
  };
  const updateGlobalSession2 = async () => {
    return { data: {}, error: null };
  };
  const deleteGlobalSession2 = async () => {
    return { data: [], error: null };
  };
  const fetchEventSessions = async () => {
    return { data: [], error: null };
  };
  const createEventSession2 = async () => {
    return { data: [], error: null };
  };
  const updateEventSession2 = async () => {
    return { data: [], error: null };
  };
  const deleteEventSession2 = async () => {
    return { data: [], error: null };
  };
  const fetchFloorplan = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeFloorPlan$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeFloorPlan,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateFloorplan = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveFloorPlan$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeFloorPlan,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const checkAvailability = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeAvailabilityCheck$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeAvailabilityCheck,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const checkAvailabilityAllAreas = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeAvailabilityCheckAllAreas$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeAvailabilityCheckAllAreas,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const availabilitySuggestions = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeAvailabilitySuggestions$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeAvailabilitySuggestions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createPaymentSetupIntent2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createPaymentSetupIntent$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createPaymentSetupIntent,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const lookupPaymentMethodName2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(lookupPaymentMethodName$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.lookupPaymentMethodName,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchRestaurant = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(restaurantById$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.restaurantById,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchRestaurantBySlug = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(restaurantBySlug, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.restaurantBySlug,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchLinkedVenues2 = async (data) => {
    let responseData = {};
    await Promise.all(
      data.linkedVenues.map(async (linkedVenue) => {
        try {
          const slugResponse = await fetchRestaurantBySlug({
            slug: linkedVenue.directory
          });
          return slugResponse == null ? void 0 : slugResponse.data;
        } catch (error) {
          devLog("error", "restaurants", error);
        }
        return null;
      })
    ).then((results2) => {
      responseData = {
        data: results2 || [],
        error: null,
        status: "success"
      };
    });
    return responseData;
  };
  const updateRestaurant = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveRestaurant$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.saveRestaurant,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const findRestaurantByName = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(restaurantSearchByName$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.restaurantSearchByName,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const closeEarly2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(closeEarly$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.closeEarly,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const reopen2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(reopen$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.reopen,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const blockTable2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(blockTable$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.blockTable,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const unblockTable2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(unblockTable$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.unblockTable,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateTableBlock2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(editTableBlock$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.editTableBlock,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createTimeslotLimit2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createTimeslotLimit$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createTimeslotLimit,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateTimeslotLimit2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateTimeslotLimit$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateTimeslotLimit,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteTimeslotLimit2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(deleteTimeslotLimit$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.deleteTimeslotLimit,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchTimeslotConditions2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeTimeslotConditions$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeTimeslotConditions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createTimeslotCondition2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createTimeslotCondition$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createTimeslotCondition,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteTimeslotCondition2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(deleteTimeslotCondition$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.deleteTimeslotCondition,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchIntegrations2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeIntegrations$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeIntegrations,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const enableReserveWithGoogle2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(enableReserveWithGoogle$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.enableReserveWithGoogle,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const disableReserveWithGoogle2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(disableReserveWithGoogle$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.disableReserveWithGoogle,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const generateFacebookLoginButton2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(generateFBLoginButton$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.generateFBLoginButton,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const disconnectMetaIntegration2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(disconnectMetaConnection$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.disconnectMetaConnection,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const completeMetaCallback2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(metaCallback$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.metaCallback,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const getFacebookRedirectUrl2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(getFBRedirectUrl$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.getFBRedirectUrl,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const getImageUploadUrl2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeImageUploadUrl$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeImageUploadUrl,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  //! Replace below guests obj conversion to use convertGuestApiData
  const fetchGuests2 = async (data, pagination) => {
    var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m;
    const page = (pagination == null ? void 0 : pagination.page) || 1;
    const perPage = (pagination == null ? void 0 : pagination.pageSize) || 50;
    const response = await graphqlApiCall(obeeGuestsFilter, {
      ...data,
      page,
      pageSize: perPage,
      searchType: (data == null ? void 0 : data.searchType) === "phone" ? "phone" : null
    });
    return {
      data: (_d2 = ((_c2 = (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeGuestsFilter) == null ? void 0 : _c2.guests) || []) == null ? void 0 : _d2.map(convertGuestApiData),
      pagination: {
        currentPage: ((_g = (_f = (_e2 = response == null ? void 0 : response.response) == null ? void 0 : _e2.data) == null ? void 0 : _f.obeeGuestsFilter) == null ? void 0 : _g.currentPage) || 1,
        totalPages: ((_j = (_i = (_h = response == null ? void 0 : response.response) == null ? void 0 : _h.data) == null ? void 0 : _i.obeeGuestsFilter) == null ? void 0 : _j.totalPages) || 1,
        totalResults: ((_m = (_l = (_k = response == null ? void 0 : response.response) == null ? void 0 : _k.data) == null ? void 0 : _l.obeeGuestsFilter) == null ? void 0 : _m.totalResults) || (data == null ? void 0 : data.length)
      },
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateGuest2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateGuest$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateGuest,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchBookingByUserId2 = async (userId) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBookingsForUser$1, { userId });
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBookingsForUser,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const getVoucherRedemptionData = (voucherRedemption) => {
    return {
      id: voucherRedemption.id,
      voucherRef: voucherRedemption == null ? void 0 : voucherRedemption.voucher_ref,
      voucherNumber: voucherRedemption == null ? void 0 : voucherRedemption.voucher_number,
      issueDate: voucherRedemption == null ? void 0 : voucherRedemption.issue_date,
      expiryDate: voucherRedemption == null ? void 0 : voucherRedemption.expiry_date,
      originalValue: voucherRedemption == null ? void 0 : voucherRedemption.original_value,
      purchaserFirstName: voucherRedemption == null ? void 0 : voucherRedemption.purchaser_first_name,
      purchaserLastName: voucherRedemption == null ? void 0 : voucherRedemption.purchaser_last_name,
      recipientName: voucherRedemption == null ? void 0 : voucherRedemption.recipient_name,
      voucherStatus: voucherRedemption == null ? void 0 : voucherRedemption.voucher_status,
      voucherType: voucherRedemption == null ? void 0 : voucherRedemption.voucher_type,
      balance: roundToDecimals(voucherRedemption == null ? void 0 : voucherRedemption.balance),
      // Sometimes after float calculations we get weird numbers
      menu: voucherRedemption == null ? void 0 : voucherRedemption.menu,
      notes: voucherRedemption == null ? void 0 : voucherRedemption.notes
    };
  };
  const getVoucherHistoryData = (voucherHistory) => {
    return {
      gvRedeemId: voucherHistory == null ? void 0 : voucherHistory.gv_redeem_id,
      redemptionAmount: voucherHistory == null ? void 0 : voucherHistory.redemption_amount,
      redemptionDate: voucherHistory == null ? void 0 : voucherHistory.redemption_date,
      redemptionStatus: voucherHistory == null ? void 0 : voucherHistory.redemption_status,
      redemptionTakenBy: voucherHistory == null ? void 0 : voucherHistory.redemption_taken_by,
      gvBalance: voucherHistory == null ? void 0 : voucherHistory.gv_balance
    };
  };
  const fetchVoucherRedemptions2 = async (data, pagination) => {
    var _a, _b2, _c2, _d2, _e2, _f, _g;
    const page = (pagination == null ? void 0 : pagination.page) || 1;
    const perPage = (pagination == null ? void 0 : pagination.pageSize) || 20;
    let params = `page=${page}&per_page=${perPage}&sorts[issue_date]=DESC`;
    const getFilterFields = () => {
      return ["voucher_ref"];
    };
    if (data.search && data.search.trim() !== "") {
      const filterFields = getFilterFields();
      params += filterFields.map((field) => `&filter[${field}]=${data.search}`).join("");
      params += "&filter_on_any_columns=1";
    }
    const response = await obeeAPIProvider("get", "gift-vouchers", params);
    return {
      data: (_a = (response == null ? void 0 : response.gift_vouchers) || []) == null ? void 0 : _a.map(getVoucherRedemptionData),
      pagination: {
        currentPage: ((_c2 = (_b2 = response == null ? void 0 : response.meta) == null ? void 0 : _b2.pagination) == null ? void 0 : _c2.current_page) || 1,
        totalPages: ((_e2 = (_d2 = response == null ? void 0 : response.meta) == null ? void 0 : _d2.pagination) == null ? void 0 : _e2.total_pages) || 1,
        totalResults: ((_g = (_f = response == null ? void 0 : response.meta) == null ? void 0 : _f.pagination) == null ? void 0 : _g.total) || (data == null ? void 0 : data.length)
      },
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchVoucherHistory2 = async (id) => {
    const response = await obeeAPIProvider("get", `gift-vouchers/redemptions/${id}`);
    return {
      data: {
        id: response.id,
        history: ((response == null ? void 0 : response.history) || []).map(getVoucherHistoryData)
      },
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createVoucherRedemption2 = async (data) => {
    const response = await obeeAPIProvider("post", "gift-vouchers/redeem", data);
    return {
      data: response,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchPaymentSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeePaymentSettingsByCriteria, { paymentSettings: data });
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeePaymentSettingsByCriteria,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const chargeNoShow2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(chargeNoShow$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.chargeNoShow,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchNotifications2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeNotifications$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeNotifications,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchNotificationCount2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeNotificationCount$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeNotificationCount,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const subscribeToNotificationEvents2 = async (data, onEvent = () => {
  }) => {
    const callback = (graphql) => graphql.subscribe({
      next: (event) => {
        var _a, _b2, _c2;
        const response2 = event.value.data.subscribeToObeePubSubEvents;
        devLog("success", "subscribeToObeePubSubEvents", response2);
        const state = store$1 == null ? void 0 : store$1.getState();
        const restId = (_b2 = (_a = state == null ? void 0 : state.restaurantActive) == null ? void 0 : _a.restaurant) == null ? void 0 : _b2.objectId;
        const lastCheckedAt = (_c2 = state == null ? void 0 : state.notifications) == null ? void 0 : _c2.lastCheckedAt;
        switch (response2.type) {
          case "new":
          case "update":
          case "cancelled":
          case "waitlist": {
            onEvent(restId, lastCheckedAt);
            break;
          }
          default: {
            devLog(
              "warning",
              "subscribeToNotificationEvents",
              `type: ${response2.type} is not being handled`
            );
            break;
          }
        }
      },
      error: (error) => {
        devLog("error", "subscribeToNotificationEvents", error);
      }
    });
    const response = await graphqlApiCall(subscribeToObeePubSubEvents$1, data, true, callback);
    return {
      data: response == null ? void 0 : response.response,
      // note: we want the response for a Subscription so we can close it later if we want to
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchDailyNotes2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeDailyNotes$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeDailyNotes,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createDailyNote2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createDailyNote$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createDailyNote,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateDailyNote2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateDailyNote$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateDailyNote,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteDailyNote2 = async (data) => {
    const response = await graphqlApiCall(deleteDailyNote$2, data);
    return response;
  };
  const fetchDailyNoteCategories2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeDailyNoteCategories$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeDailyNoteCategories,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchBookingDurations2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBookingDurations$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBookingDurations,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createBookingDuration2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createBookingDuration$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createBookingDuration,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateBookingDuration2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateBookingDuration$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateBookingDuration,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteBookingDuration2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(deleteBookingDuration$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.deleteBookingDuration,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchFullyBookedSessions2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeFullyBookedSessions$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeFullyBookedSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createFullyBookedSessions2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createFullyBookedSessions$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createFullyBookedSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteFullyBookedSessions2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(deleteFullyBookedSessions$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.deleteFullyBookedSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateAreaCapacity2 = async (data) => {
    var _a;
    const response = await graphqlApiCall(updateAreaCapacity$2, data);
    return {
      data: (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchBrandedEmailSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBrandedEmailSettings$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBrandedEmailSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateBrandedEmailSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateBrandedEmailSettings$2, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateBrandedEmailSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const exportGuestBook2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeExportGuestBook$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeExportGuestBook,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchMonthlyView2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeMonthlyViewByDate$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeMonthlyViewByDate,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  return {
    cancelRequests: cancelRequests2,
    isCancel: isCancel2,
    fetchBookings,
    fetchBookingByUserId: fetchBookingByUserId2,
    createBooking,
    updateBooking,
    resubmitBooking: resubmitBooking2,
    confirmWaitlistBooking,
    confirmWaitlistAsBooked: confirmWaitlistAsBooked2,
    sendWaitlistSMS: sendWaitlistSMS2,
    sendGuestEmail: sendGuestEmail2,
    sendGuestSMS: sendGuestSMS2,
    checkBookingUpdate: checkBookingUpdate2,
    fetchTables,
    createTable: createTable2,
    updateTable: updateTable2,
    deleteTable: deleteTable2,
    updateTablePriorities: updateTablePriorities2,
    fetchSettings,
    updateSettings,
    fetchWidgetSettings: fetchWidgetSettings2,
    updateWidgetTheme: updateWidgetTheme2,
    updateBookingWidgetSettings: updateBookingWidgetSettings2,
    fetchMessagesSettings: fetchMessagesSettings2,
    updateMessagesSettings: updateMessagesSettings2,
    fetchAreas,
    createArea: createArea2,
    updateArea: updateArea2,
    deleteArea: deleteArea2,
    fetchStaff: fetchStaff2,
    createStaff: createStaff2,
    updateStaff: updateStaff2,
    deleteStaff: deleteStaff2,
    fetchSessions,
    createSession: createSession2,
    updateSession: updateSession2,
    deleteSession: deleteSession2,
    fetchGlobalSessions,
    createGlobalSession: createGlobalSession2,
    updateGlobalSession: updateGlobalSession2,
    deleteGlobalSession: deleteGlobalSession2,
    fetchEventSessions,
    createEventSession: createEventSession2,
    updateEventSession: updateEventSession2,
    deleteEventSession: deleteEventSession2,
    fetchGuests: fetchGuests2,
    updateGuest: updateGuest2,
    exportGuestBook: exportGuestBook2,
    fetchFloorplan,
    updateFloorplan,
    checkAvailability,
    checkAvailabilityAllAreas,
    availabilitySuggestions,
    createPaymentSetupIntent: createPaymentSetupIntent2,
    lookupPaymentMethodName: lookupPaymentMethodName2,
    fetchRestaurant,
    fetchRestaurantBySlug,
    fetchLinkedVenues: fetchLinkedVenues2,
    updateRestaurant,
    findRestaurantByName,
    closeEarly: closeEarly2,
    reopen: reopen2,
    blockTable: blockTable2,
    unblockTable: unblockTable2,
    updateTableBlock: updateTableBlock2,
    createTimeslotLimit: createTimeslotLimit2,
    updateTimeslotLimit: updateTimeslotLimit2,
    deleteTimeslotLimit: deleteTimeslotLimit2,
    fetchTimeslotConditions: fetchTimeslotConditions2,
    createTimeslotCondition: createTimeslotCondition2,
    deleteTimeslotCondition: deleteTimeslotCondition2,
    fetchIntegrations: fetchIntegrations2,
    enableReserveWithGoogle: enableReserveWithGoogle2,
    disableReserveWithGoogle: disableReserveWithGoogle2,
    generateFacebookLoginButton: generateFacebookLoginButton2,
    disconnectMetaIntegration: disconnectMetaIntegration2,
    completeMetaCallback: completeMetaCallback2,
    getFacebookRedirectUrl: getFacebookRedirectUrl2,
    getImageUploadUrl: getImageUploadUrl2,
    fetchVoucherRedemptions: fetchVoucherRedemptions2,
    fetchVoucherHistory: fetchVoucherHistory2,
    createVoucherRedemption: createVoucherRedemption2,
    fetchPaymentSettings: fetchPaymentSettings2,
    chargeNoShow: chargeNoShow2,
    fetchNotifications: fetchNotifications2,
    fetchNotificationCount: fetchNotificationCount2,
    subscribeToNotificationEvents: subscribeToNotificationEvents2,
    fetchDailyNotes: fetchDailyNotes2,
    createDailyNote: createDailyNote2,
    updateDailyNote: updateDailyNote2,
    deleteDailyNote: deleteDailyNote2,
    fetchDailyNoteCategories: fetchDailyNoteCategories2,
    fetchBookingDurations: fetchBookingDurations2,
    createBookingDuration: createBookingDuration2,
    updateBookingDuration: updateBookingDuration2,
    deleteBookingDuration: deleteBookingDuration2,
    fetchFullyBookedSessions: fetchFullyBookedSessions2,
    createFullyBookedSessions: createFullyBookedSessions2,
    deleteFullyBookedSessions: deleteFullyBookedSessions2,
    updateAreaCapacity: updateAreaCapacity2,
    fetchBrandedEmailSettings: fetchBrandedEmailSettings2,
    updateBrandedEmailSettings: updateBrandedEmailSettings2,
    fetchMonthlyView: fetchMonthlyView2
  };
};
const OBSettings = `
	daysInAdvance
	systemTimeInterval
	bookingsDuration
	waitlist
	abHighchairs
	abVaccination
	abTakenBy
	abConfirmation
	ccCapture
	ccNoShowFee
	ccNoShowChargeType
	ccPaymentPolicy
	ccWaitlistShow
	ccWaitlistPolicy
	ccAddBookings
	terms
	logo
	heroImage
	favicon
	stepperColor
	iconBgColor
	datePickerColor
	linkColor
	availableTimesColor
	formBgColor
	venueMessage
	disabledAccess
	dressCode
	kidFriendly
	kidsPlayArea
	byo
	corkage
	cakeage
	showHighchairs
	groupSizeLimit
	groupSizeMessage
	areaPhotos
	slug
	openingHoursStyle
	cutoffMode
	cutoffValue
	hasCustomDuration
	customOverrides
  addBookingSettings
`;
const RestaurantTheme = `
  theme
  bookingWidgetSettings
`;
const Closure = `
	restId
	startDate
	endDate
	startTime
	endTime
`;
const Restaurant = `
	objectId
	enabled
	name
	region
	menuVersion
	bdmEmail
	bdmName
	bdmPhone
	revPerDiner
	revPerDinerTakeaway
	hours
	platform
	showOppos
	showPredictions
	address1
	address2
	city
	state
	postcode
	phone
	website
	abn
	tradingName
	instagramLink
	facebookLink
	twitterLink
	obeeEnabled
	obeeGoLiveDate
	premium
	ecPayEnabled
	closures {
		${Closure}
	}
`;
const AffiliatedRestaurant = `
	objectId
	enabled
	name
	region
	hours
	platform
	address1
	address2
	city
	state
	postcode
	phone
	website
	abn
	tradingName
	obeeEnabled
	obeeGoLiveDate
	premium
	ecPayEnabled
	closures {
		${Closure}
	}
`;
const OBTableBlock = `
	id
	tableId
	date
	startTime
	endTime
`;
const OBTable = `
	id
	areaId
	tableNumber
	notes
	min
	max
	priority
	isPublic
	blocks {
		${OBTableBlock}
	}
	customDuration
`;
const OBArea = `
	id
	name
	duration
	capacity
	priority
	minGroup
	maxGroup
	cutoffMode
	cutoffValue
`;
const OBSession = `
	id
	areaId
	label
	startTime
	endTime
	isPublic
	day
	date
	sittingTimes
`;
const OBGlobalSession = `
	objectId
	label
	startTime
	endTime
	isPublic
	day
	date
	sittingTimes
`;
const OBGuest = `
	id
	firstName
	lastName
	email
	mobile
	landline
	title
	description
	notes
	allergies
	birthday
	vip
	jobCompany
	interests
	secretary
	address
	postcode
	website
	blog
	facebook
	twitter
	instagram
	pinterest
	linkedIn
	blacklisted
	favouriteMeals
	favouriteDrinks
	preferredTableArea
	smsPromo
	emailPromo
	numVisits
`;
const OBBooking = `
	createdAt
	id
	areaId
	date
	time
	size
	name
	code
	restaurantComments
	customerComments
	source
	status
	tableNumber
	duration
	labels
	kids
	highchairs
	vaccinated
	quotedMins
	staff
	history
	paymentCustomerId
	paymentMethodId
	paymentMethodName
	guests {
		${OBGuest}
	}
	ccNoShowFee
	ccNoShowChargeType
	ccNoShowChargeStatus
	ccNoShowChargeTime
	ccNoShowPaymentIntentId
	waitlistSMS
	commsHistory
	lastEditedByGuest
`;
const OBAvailabilitySuggestion = `
  time
  table {
    ${OBTable}
  }
`;
const OBStaff = `
	objectId
	fullName
	appearAs
	restId
`;
const OBTimeslotLimit = `
	objectId
	restId
	conditionId
	startTime
	endTime
	limitType
	limitValue
	groupSizeOption
	groupSizeMin
	groupSizeMax
	timeInterval
	source
`;
const OBTimeslotCondition = `
	objectId
	areaId
	days
	startDate
	endDate
	limits {
	 ${OBTimeslotLimit}
 }
`;
const Integration = `
	id
	data
	active
`;
const Notification = `
	id
	date
	time
	bSize
	bName
	bMade
	bType
	status
	orderByDate
	tableNumber
	customerComments
	whichNotification
`;
const ObeePubSubEvent = `
	restId
	type
`;
const OBBookingDuration = `
	objectId
	areaIds
	duration
	size
	sizeMax
	sizeOption
`;
const OBFullyBooked = `
	areaId
	name
	capacity
	sessionId
	label
	openingTime
	closingTime
	fullyBooked
	fullyBookedBId
`;
const MessagesSettings$2 = `
	confirmationEmail
	confirmationSMS
	reminderEmail
	reminderSMS
	thankYouEmail
	cancellationEmail
	waitlistEmail
`;
const OBDailyNoteCategory = `
  id
  category
  colour
`;
const OBDailyNote = `
  id
  date
  title
  note
	category {
		${OBDailyNoteCategory}
	}
  insertedBy
  pinned
  createdDate
`;
const OBBookingInputKeys = [
  "areaId",
  "date",
  "time",
  "size",
  "guests",
  "name",
  "restaurantComments",
  "customerComments",
  "source",
  "status",
  "tableNumber",
  "duration",
  "labels",
  "kids",
  "highchairs",
  "vaccinated",
  "quotedMins",
  "staff",
  "emailConfirmation",
  "paymentMethodId",
  "paymentMethodName",
  "setupIntentId",
  "sendConfirmationEmail",
  "sendConfirmationSMS"
  // 'cardToken', // Not used in ECB
  // 'amount',
  // 'paymentSettingId',
  // 'ccMode',
];
const OBGuestInputKeys = [
  "firstName",
  "lastName",
  "email",
  "mobile",
  // 'landline',
  "title",
  "description",
  "notes",
  "allergies",
  "birthday",
  "vip",
  "jobCompany",
  "interests",
  "secretary",
  "address",
  "postcode",
  "website",
  "blog",
  "facebook",
  "twitter",
  "instagram",
  "pinterest",
  "linkedIn",
  "blacklisted",
  "favouriteMeals",
  "favouriteDrinks",
  "preferredTableArea",
  "emailPromo",
  "smsPromo"
];
const ImageUploadUrlInputKeys = ["slug", "fileName"];
const restaurantById = (
  /* GraphQL */
  `
  query RestaurantById($restId: String!) {
    restaurantById(restId: $restId) {
      ${Restaurant}
    }
  }
`
);
const restaurantSearchByName = (
  /* GraphQL */
  `
  query RestaurantSearchByName($name: String!) {
    restaurantSearchByName(name: $name) {
      ${Restaurant}
    }
  }
`
);
const widgetTheme = (
  /* GraphQL */
  `
  query WidgetTheme($restId: String!) {
    obeeSettings(restId: $restId) {
      ${RestaurantTheme}
    }
  }
`
);
const obeeBookings = (
  /* GraphQL */
  `
  query ObeeBookings($restId: String!, $date: AWSDate!) {
    obeeBookings(restId: $restId, date: $date) {
      ${OBBooking}
    }
  }
`
);
const obeeAvailabilityCheck = (
  /* GraphQL */
  `
  query ObeeAvailabilityCheck(
    $restId: String!
    $areaId: Int!
    $date: AWSDate!
    $time: Int!
    $size: Int!
    $public: Boolean
    $returnAll: Boolean
    $excludeBookingId: Int
    $fromForceBooking: Boolean
  ) {
    obeeAvailabilityCheck(restId: $restId, areaId: $areaId, date: $date, time: $time, size: $size, public: $public, returnAll: $returnAll, excludeBookingId: $excludeBookingId, fromForceBooking: $fromForceBooking) {
      ${OBTable}
    }
  }
`
);
const obeeAvailabilityCheckAllAreas = (
  /* GraphQL */
  `
  query ObeeAvailabilityCheckAllAreas(
    $restId: String!
    $date: AWSDate!
    $time: Int!
    $size: Int!
    $public: Boolean
    $returnAll: Boolean
    $excludeBookingId: Int
    $fromForceBooking: Boolean
  ) {
    obeeAvailabilityCheckAllAreas(restId: $restId, date: $date, time: $time, size: $size, public: $public, returnAll: $returnAll, excludeBookingId: $excludeBookingId, fromForceBooking: $fromForceBooking) {
      ${OBTable}
    }
  }
`
);
const obeeAvailabilitySuggestions = (
  /* GraphQL */
  `
  query ObeeAvailabilitySuggestions(
    $restId: String!
    $areaId: Int!
    $date: AWSDate!
    $time: Int!
    $size: Int!
    $length: Int
    $public: Boolean
    $excludeBookingId: Int
  ) {
    obeeAvailabilitySuggestions(
      areaId: $areaId
      restId: $restId
      date: $date
      time: $time
      size: $size
      length: $length
      public: $public
      excludeBookingId: $excludeBookingId
    ) {
      ${OBAvailabilitySuggestion}
    }
  }
`
);
const obeeAreas = (
  /* GraphQL */
  `
  query ObeeAreas($restId: String!) {
    obeeAreas(restId: $restId) {
      ${OBArea}
    }
  }
`
);
const obeeTables = (
  /* GraphQL */
  `
  query ObeeTables($restId: String!, $date: String) {
    obeeTables(restId: $restId, date: $date) {
      ${OBTable}
    }
  }
`
);
const obeeFloorPlan = (
  /* GraphQL */
  `
  query ObeeFloorPlan($restId: String!) {
    obeeFloorPlan(restId: $restId)
  }
`
);
const obeeSessions = (
  /* GraphQL */
  `
  query ObeeSessions($restId: String!) {
    obeeSessions(restId: $restId) {
      ${OBSession}
    }
  }
`
);
const obeeSettings = (
  /* GraphQL */
  `
  query ObeeSettings($restId: String!) {
    obeeSettings(restId: $restId) {
      ${OBSettings}
    }
  }
`
);
const obeeStaffList = (
  /* GraphQL */
  `
  query ObeeStaffList($restId: String!) {
    obeeStaffList(restId: $restId) {
      ${OBStaff}
    }
  }
`
);
const obeeEventSessions = (
  /* GraphQL */
  `
  query ObeeEventSessions($restId: String!) {
    obeeEventSessions(restId: $restId) {
      ${OBGlobalSession}
    }
  }
`
);
const obeeGlobalSessions = (
  /* GraphQL */
  `
  query ObeeGlobalSessions($restId: String!) {
    obeeGlobalSessions(restId: $restId) {
      ${OBGlobalSession}
    }
  }
`
);
const obeeTimeslotConditions = (
  /* GraphQL */
  `
  query ObeeTimeslotConditions($restId: String!) {
    obeeTimeslotConditions(restId: $restId) {
      ${OBTimeslotCondition}
    }
  }
`
);
const obeeBookingUpdateCheck = (
  /* GraphQL */
  `
  query ObeeBookingUpdateCheck(
    $restId: String!
    $bookingId: Int!
    $areaId: Int
    $date: String
    $time: Int
    $size: Int
    $tableNumber: String
    $duration: Int
    $public: Boolean
  ) {
    obeeBookingUpdateCheck(
      restId: $restId
      bookingId: $bookingId
      areaId: $areaId
      date: $date
      time: $time
      size: $size
      tableNumber: $tableNumber
      duration: $duration
      public: $public
    )
  }
`
);
const obeeGuests = (
  /* GraphQL */
  `
  query ObeeGuests($restId: String!, $search: String, $pageSize: String!, $page: String!) {
    obeeGuests(restId: $restId, search: $search, pageSize: $pageSize, page: $page) {
      ${OBGuest}
    }
  }
`
);
const obeeBookingsForUser = (
  /* GraphQL */
  `
  query ObeeBookingsForUser($restId: String!, $userId: Int!) {
    obeeBookingsForUser(restId: $restId, userId: $userId) {
      ${OBBooking}
    }
  }
`
);
const lookupPaymentMethodName$1 = (
  /* GraphQL */
  `
  query LookupPaymentMethodName($paymentMethodId: String!) {
    lookupPaymentMethodName(paymentMethodId: $paymentMethodId)
  }
`
);
const obeeImageUploadUrl = (
  /* GraphQL */
  `
  query ObeeImageUploadUrl($restId: String!, $fileName: String!) {
    obeeImageUploadUrl(restId: $restId, fileName: $fileName)
  }
`
);
const obeeIntegrations = (
  /* GraphQL */
  `
  query ObeeIntegrations($restId: String!) {
    obeeIntegrations(restId: $restId) {
      ${Integration}
    }
  }
`
);
const obeeNotificationCount = (
  /* GraphQL */
  `
  query ObeeNotificationCount($restId: String!, $lastChecked: AWSDateTime!) {
    obeeNotificationCount(restId: $restId, lastChecked: $lastChecked)
  }
`
);
const obeeNotifications = (
  /* GraphQL */
  `
  query ObeeNotifications($restId: String!, $lastChecked: AWSDateTime!) {
    obeeNotifications(restId: $restId, lastChecked: $lastChecked) {
      ${Notification}
    }
  }
`
);
const obeeDailyNotes = (
  /* GraphQL */
  `
  query ObeeDailyNotes($restId: String!, $date: String!) {
    obeeDailyNotes(restId: $restId, date: $date) {
      ${OBDailyNote}
    }
  }
`
);
const obeeDailyNoteCategories = (
  /* GraphQL */
  `
  query ObeeDailyNoteCategories($restId: String!) {
    obeeDailyNoteCategories(restId: $restId) {
      ${OBDailyNoteCategory}
    }
  }
`
);
const obeeBookingDurations = (
  /* GraphQL */
  `
  query ObeeBookingDurations($restId: String!) {
    obeeBookingDurations(restId: $restId) {
      ${OBBookingDuration}
    }
  }
`
);
const obeeFullyBookedSessions = (
  /* GraphQL */
  `
  query ObeeFullyBookedSessions($restId: String!, $date: AWSDate!) {
    obeeFullyBookedSessions(restId: $restId, date: $date) {
      ${OBFullyBooked}
    }
  }
`
);
const messagesSettingsByRestId = (
  /* GraphQL */
  `
  query MessagesSettingsByRestId($restId: String!) {
    messagesSettingsByRestId(restId: $restId) {
      ${MessagesSettings$2}
    }
  }
`
);
const obeeBrandedEmailSettings = (
  /* GraphQL */
  `
  query ObeeBrandedEmailSettings($restId: String!) {
    obeeBrandedEmailSettings(restId: $restId)
  }
`
);
const obeeExportGuestBook = (
  /* GraphQL */
  `
  query ObeeExportGuestBook($restId: String!) {
    obeeExportGuestBook(restId: $restId)
  }
`
);
const affiliatedRestaurants = (
  /* GraphQL */
  `
  query AffiliatedRestaurants($restId: String!) {
    affiliatedRestaurants(restId: $restId) {
      ${AffiliatedRestaurant}
    }
  }
`
);
const obeeMonthlyViewByDate = (
  /* GraphQL */
  `
  query ObeeMonthlyViewByDate($restId: String!, $date: String!, $dateTo: String) {
    obeeMonthlyViewByDate(restId: $restId, date: $date, dateTo: $dateTo)
  }
`
);
const createArea = (
  /* GraphQL */
  `
  mutation CreateArea($restId: String!, $area: OBAreaInput!) {
    createArea(restId: $restId, area: $area) {
      ${OBArea}
    }
  }
`
);
const createSession = (
  /* GraphQL */
  `
  mutation CreateSession($restId: String!, $session: OBSessionInput!) {
    createSession(restId: $restId, session: $session){
      ${OBSession}
    }
  }
`
);
const createTable = (
  /* GraphQL */
  `
  mutation CreateTable($restId: String!, $table: OBTableInput!) {
    createTable(restId: $restId, table: $table) {
      ${OBTable}
    }
  }
`
);
const createObeeBooking$1 = (
  /* GraphQL */
  `
  mutation CreateObeeBooking($restId: String!, $booking: OBBookingInput!) {
    createObeeBooking(restId: $restId, booking: $booking) {
      ${OBBooking}
    }
  }
`
);
const updateObeeBooking$1 = (
  /* GraphQL */
  `
  mutation UpdateObeeBooking($restId: String!, $bookingId: String!, $booking: OBBookingInput!) {
    updateObeeBooking(restId: $restId, bookingId: $bookingId, booking: $booking) {
      ${OBBooking}
    }
  }
`
);
const confirmWaitlist$1 = (
  /* GraphQL */
  `
  mutation ConfirmWaitlist($restId: String!, $bookingId: Int!, $areaId: Int, $tableId: Int, $staff: String) {
    confirmWaitlist(restId: $restId, bookingId: $bookingId, areaId: $areaId, tableId: $tableId, staff: $staff) {
      ${OBBooking}
    }
  }
`
);
const confirmWaitlistAsBooked$1 = (
  /* GraphQL */
  `
  mutation ConfirmWaitlistAsBooked($restId: String!, $bookingId: Int!, $areaId: Int, $tableId: Int, $staff: String) {
    confirmWaitlistAsBooked(restId: $restId, bookingId: $bookingId, areaId: $areaId, tableId: $tableId, staff: $staff) {
      ${OBBooking}
    }
  }
`
);
const sendWaitlistSMS$1 = (
  /* GraphQL */
  `
  mutation SendWaitlistSMS($bookingId: String!, $inHowLong: String!) {
    sendWaitlistSMS(bookingId: $bookingId, inHowLong: $inHowLong)
  }
`
);
const sendGuestEmail$1 = (
  /* GraphQL */
  `
  mutation SendGuestEmail($restId: String!, $bookingId: String!, $emailType: String!) {
    sendGuestEmail(restId: $restId, bookingId: $bookingId, emailType: $emailType)
  }
`
);
const sendGuestSMS$1 = (
  /* GraphQL */
  `
  mutation SendGuestSMS($restId: String!, $bookingId: String!, $smsType: String!) {
    sendGuestSMS(restId: $restId, bookingId: $bookingId, smsType: $smsType)
  }
`
);
const updateArea = (
  /* GraphQL */
  `
  mutation UpdateArea($restId: String!, $areaId: Int!, $area: OBAreaInput!) {
    updateArea(restId: $restId, areaId: $areaId, area: $area) {
      ${OBArea}
    }
  }
`
);
const updateTable = (
  /* GraphQL */
  `
  mutation UpdateTable($restId: String!, $tableId: Int!, $table: OBTableInput!) {
    updateTable(restId: $restId, tableId: $tableId, table: $table) {
      ${OBTable}
    }
  }
`
);
const deleteArea = (
  /* GraphQL */
  `
  mutation DeleteArea($restId: String!, $areaId: Int!) {
    deleteArea(restId: $restId, areaId: $areaId)
  }
`
);
const deleteSession = (
  /* GraphQL */
  `
  mutation DeleteSession($restId: String!, $sessionId: Int!) {
    deleteSession(restId: $restId, sessionId: $sessionId)
  }
`
);
const deleteTable = (
  /* GraphQL */
  `
  mutation DeleteTable($restId: String!, $tableId: Int!) {
    deleteTable(restId: $restId, tableId: $tableId)
  }
`
);
const saveFloorPlan = (
  /* GraphQL */
  `
  mutation SaveFloorPlan($restId: String!, $data: String!) {
    saveFloorPlan(restId: $restId, data: $data)
  }
`
);
const saveObeeSettings = (
  /* GraphQL */
  `
  mutation SaveObeeSettings($restId: String!, $settings: OBSettingsInput!) {
    saveObeeSettings(restId: $restId, settings: $settings){
      ${OBSettings}
    }
  }
`
);
const saveRestaurant = (
  /* GraphQL */
  `
  mutation SaveRestaurant($restId: String!, $restaurant: RestaurantInput!) {
    saveRestaurant(restId: $restId, restaurant: $restaurant){
      ${Restaurant}
    }
  }
`
);
const createStaff$1 = (
  /* GraphQL */
  `
  mutation CreateStaff($restId: String!, $staff: OBStaffInput!) {
    createStaff(restId: $restId, staff: $staff){
      ${OBStaff}
    }
  }
`
);
const updateStaff$1 = (
  /* GraphQL */
  `
  mutation UpdateStaff($restId: String!, $staffId: String!, $staff: OBStaffInput!) {
    updateStaff(restId: $restId, staffId: $staffId, staff: $staff){
      ${OBStaff}
    }
  }
`
);
const deleteStaff$1 = (
  /* GraphQL */
  `
  mutation DeleteStaff($restId: String!, $staffId: String!) {
    deleteStaff(restId: $restId, staffId: $staffId)
  }
`
);
const blockTable$1 = (
  /* GraphQL */
  `
  mutation BlockTable(
    $restId: String!
    $tableId: Int!
    $date: String!
    $startTime: Int
    $endTime: Int!
  ) {
    blockTable(
      restId: $restId
      tableId: $tableId
      date: $date
      startTime: $startTime
      endTime: $endTime
    ) {
      ${OBTableBlock}
    }
  }
`
);
const unblockTable$1 = (
  /* GraphQL */
  `
  mutation UnblockTable($restId: String!, $tableBlockId: Int!) {
    unblockTable(restId: $restId, tableBlockId: $tableBlockId)
  }
`
);
const editTableBlock = (
  /* GraphQL */
  `
  mutation EditTableBlock(
    $restId: String!
    $tableBlockId: Int!
    $startTime: Int
    $endTime: Int
  ) {
    editTableBlock(
      restId: $restId
      tableBlockId: $tableBlockId
      startTime: $startTime
      endTime: $endTime
    ) {
      ${OBTableBlock}
    }
  }
`
);
const createEventSession = (
  /* GraphQL */
  `
  mutation CreateEventSession($restId: String!, $session: OBEventSessionInput!) {
    createEventSession(restId: $restId, session: $session) {
      ${OBGlobalSession}
    }
  }
`
);
const updateEventSession = (
  /* GraphQL */
  `
  mutation UpdateEventSession($restId: String!, $sessionId: String!, $session: OBEventSessionUpdateInput!) {
    updateEventSession(restId: $restId, sessionId: $sessionId, session: $session) {
      ${OBGlobalSession}
    }
  }
`
);
const deleteEventSession = (
  /* GraphQL */
  `
  mutation DeleteEventSession($restId: String!, $sessionId: String!) {
    deleteEventSession(restId: $restId, sessionId: $sessionId)
  }
`
);
const createGlobalSession = (
  /* GraphQL */
  `
  mutation CreateGlobalSession($restId: String!, $session: OBGlobalSessionInput!) {
    createGlobalSession(restId: $restId, session: $session) {
      ${OBGlobalSession}
    }
  }
`
);
const updateGlobalSession = (
  /* GraphQL */
  `
  mutation UpdateGlobalSession($restId: String!, $sessionId: String!, $session: OBGlobalSessionUpdateInput!) {
    updateGlobalSession(restId: $restId, sessionId: $sessionId, session: $session) {
      ${OBGlobalSession}
    }
  }
`
);
const deleteGlobalSession = (
  /* GraphQL */
  `
  mutation DeleteGlobalSession($restId: String!, $sessionId: String!) {
    deleteGlobalSession(restId: $restId, sessionId: $sessionId)
  }
`
);
const updateSession = (
  /* GraphQL */
  `
  mutation UpdateSession($restId: String!, $sessionId: String!, $session: OBSessionUpdateInput!) {
    updateSession(restId: $restId, sessionId: $sessionId, session: $session) {
      ${OBSession}
    }
  }
`
);
const createTimeslotCondition$1 = (
  /* GraphQL */
  `
  mutation CreateTimeslotCondition($restId: String!, $condition: OBTimeslotConditionInput!) {
    createTimeslotCondition(restId: $restId, condition: $condition) {
      ${OBTimeslotCondition}
    }
  }
`
);
const deleteTimeslotCondition$1 = (
  /* GraphQL */
  `
  mutation DeleteTimeslotCondition($restId: String!, $conditionId: String!) {
    deleteTimeslotCondition(restId: $restId, conditionId: $conditionId)
  }
`
);
const createTimeslotLimit$1 = (
  /* GraphQL */
  `
  mutation CreateTimeslotLimit($restId: String!, $conditionId: String!, $limit: OBTimeslotLimitInput!) {
    createTimeslotLimit(restId: $restId, conditionId: $conditionId, limit: $limit) {
      ${OBTimeslotLimit}
    }
  }
`
);
const updateTimeslotLimit$1 = (
  /* GraphQL */
  `
  mutation UpdateTimeslotLimit($restId: String!, $limitId: String!, $limit: OBTimeslotLimitInput!) {
    updateTimeslotLimit(restId: $restId, limitId: $limitId, limit: $limit) {
      ${OBTimeslotLimit}
    }
  }
`
);
const deleteTimeslotLimit$1 = (
  /* GraphQL */
  `
  mutation DeleteTimeslotLimit($restId: String!, $limitId: String!) {
    deleteTimeslotLimit(restId: $restId, limitId: $limitId)
  }
`
);
const updateGuest$1 = (
  /* GraphQL */
  `
  mutation UpdateGuest($restId: String!, $guestId: Int!, $guest: OBGuestUpdateInput!) {
    updateGuest(restId: $restId, guestId: $guestId, guest: $guest) {
      ${OBGuest}
    }
  }
`
);
const saveTablePriorities = (
  /* GraphQL */
  `
  mutation SaveTablePriorities($restId: String!, $tablePriorities: [OBTablePriorityInput]!) {
    saveTablePriorities(restId: $restId, tablePriorities: $tablePriorities) {
      ${OBTable}
    }
  }
`
);
const closeEarly$1 = (
  /* GraphQL */
  `
  mutation CloseEarly($restId: String!) {
    closeEarly(restId: $restId) {
      ${Restaurant}
    }
  }
`
);
const reopen$1 = (
  /* GraphQL */
  `
  mutation Reopen($restId: String!) {
    reopen(restId: $restId) {
      ${Restaurant}
    }
  }
`
);
const createPaymentSetupIntent$1 = (
  /* GraphQL */
  `
  mutation CreatePaymentSetupIntent(
    $name: String!
    $phone: String!
    $email: String
    $userId: String
    $stripeId: String
  ) {
    createPaymentSetupIntent(
      name: $name
      phone: $phone
      email: $email
      userId: $userId
      stripeId: $stripeId
    )
  }
`
);
const enableReserveWithGoogle$1 = (
  /* GraphQL */
  `
  mutation EnableReserveWithGoogle($restId: String!, $merchantTerms: String) {
    enableReserveWithGoogle(restId: $restId, merchantTerms: $merchantTerms) {
      ${Integration}
    }
  }
`
);
const disableReserveWithGoogle$1 = (
  /* GraphQL */
  `
  mutation DisableReserveWithGoogle($restId: String!) {
    disableReserveWithGoogle(restId: $restId) {
      ${Integration}
    }
  }
`
);
const chargeNoShow$1 = (
  /* GraphQL */
  `
  mutation ChargeNoShow($restId: String!, $obBookingId: String!, $charge: OBChargeNoShowInput!) {
    chargeNoShow(restId: $restId, obBookingId: $obBookingId, charge: $charge)
  }
`
);
const createBookingDuration$1 = (
  /* GraphQL */
  `
  mutation CreateBookingDuration($restId: String!, $duration: OBBookingDurationInput!) {
    createBookingDuration(restId: $restId, duration: $duration) {
      ${OBBookingDuration}
    }
  }
`
);
const updateBookingDuration$1 = (
  /* GraphQL */
  `
  mutation UpdateBookingDuration($restId: String!, $bookingDurationId: String!, $duration: OBBookingDurationInput!) {
    updateBookingDuration(restId: $restId, bookingDurationId: $bookingDurationId, duration: $duration) {
      ${OBBookingDuration}
    }
  }
`
);
const deleteBookingDuration$1 = (
  /* GraphQL */
  `
  mutation DeleteBookingDuration($restId: String!, $bookingDurationId: String!) {
    deleteBookingDuration(restId: $restId, bookingDurationId: $bookingDurationId)
  }
`
);
const createFullyBookedSessions$1 = (
  /* GraphQL */
  `
  mutation CreateFullyBookedSessions($restId: String!, $date: AWSDate!, $sessions: [OBFullyBookedCreateInput]!) {
    createFullyBookedSessions(restId: $restId, date: $date, sessions: $sessions) {
      ${OBFullyBooked}
    }
  }
`
);
const deleteFullyBookedSessions$1 = (
  /* GraphQL */
  `
  mutation DeleteFullyBookedSessions($restId: String!, $date: AWSDate!, $sessions: [OBFullyBookedDeleteInput]!) {
    deleteFullyBookedSessions(restId: $restId, date: $date, sessions: $sessions) {
      ${OBFullyBooked}
    }
  }
`
);
const generateFBLoginButton = (
  /* GraphQL */
  `
  mutation GenerateFBLoginButton($restId: String!, $buttonText: String) {
    generateFBLoginButton(restId: $restId, buttonText: $buttonText)
  }
`
);
const disconnectMetaConnection = (
  /* GraphQL */
  `
  mutation DisconnectMetaConnection($restId: String!, $companyId: String) {
    disconnectMetaConnection(restId: $restId, companyId: $companyId)
  }
`
);
const metaCallback = (
  /* GraphQL */
  `
  mutation MetaCallback($restId: String!, $state: String!, $accessToken: String!) {
    metaCallback(restId: $restId, state: $state, accessToken: $accessToken)
  }
`
);
const getFBRedirectUrl = (
  /* GraphQL */
  `
  mutation GetFBRedirectUrl($restId: String!, $queryString: String!) {
    getFBRedirectUrl(restId: $restId, queryString: $queryString)
  }
`
);
const saveMessagesSettings = (
  /* GraphQL */
  `
  mutation SaveMessagesSettings($restId: String!, $settings: MessagesSettingsInput!) {
    saveMessagesSettings(restId: $restId, settings: $settings) {
      ${MessagesSettings$2}
    }
  }
`
);
const updateThemeSettings = (
  /* GraphQL */
  `
  mutation UpdateThemeSettings($restId: String!, $settings: AWSJSON!) {
    updateThemeSettings(restId: $restId, settings: $settings)
  }
`
);
const updateBookingWidgetSettings$1 = (
  /* GraphQL */
  `
  mutation UpdateBookingWidgetSettings($restId: String!, $settings: AWSJSON!) {
    updateBookingWidgetSettings(restId: $restId, settings: $settings)
  }
`
);
const updateBrandedEmailSettings$1 = (
  /* GraphQL */
  `
  mutation UpdateBrandedEmailSettings($restId: String!, $settings: AWSJSON!) {
    updateBrandedEmailSettings(restId: $restId, settings: $settings)
  }
`
);
const updateAreaCapacity$1 = (
  /* GraphQL */
  `
  mutation UpdateAreaCapacity($restId: String!) {
    updateAreaCapacity(restId: $restId)
  }
`
);
const createDailyNote$1 = (
  /* GraphQL */
  `
  mutation CreateDailyNote($restId: String!, $dailyNote: OBDailyNoteInput!) {
    createDailyNote(restId: $restId, dailyNote: $dailyNote){
      ${OBDailyNote}
    }
  }
`
);
const updateDailyNote$1 = (
  /* GraphQL */
  `
  mutation UpdateDailyNote($restId: String!, $id: String!, $dailyNote: OBDailyNoteUpdateInput!) {
    updateDailyNote(restId: $restId, id: $id, dailyNote: $dailyNote){
      ${OBDailyNote}
    }
  }
`
);
const deleteDailyNote$1 = (
  /* GraphQL */
  `
  mutation DeleteDailyNote($restId: String!, $id: String!) {
    deleteDailyNote(restId: $restId, id: $id)
  }
`
);
const subscribeToObeePubSubEvents = (
  /* GraphQL */
  `
  subscription SubscribeToObeePubSubEvents($restId: String!) {
    subscribeToObeePubSubEvents(restId: $restId) {
      ${ObeePubSubEvent}
    }
  }
`
);
const EatClubApiClient = () => {
  const graphqlApiCall = async (query, variables = {}, addRestId = true, graphqlCallback = (graphql) => graphql) => {
    var _a, _b2, _c2, _d2, _e2;
    const state = store$1 == null ? void 0 : store$1.getState();
    const restId = (_b2 = (_a = state == null ? void 0 : state.restaurantActive) == null ? void 0 : _a.restaurant) == null ? void 0 : _b2.objectId;
    const userId = state.user.userInfo.objectId;
    const { userType } = state.user.userInfo;
    const variablesWithExtra = {
      ...variables,
      ...addRestId ? { restId } : {}
    };
    const response = {
      response: null,
      status: null,
      error: null
    };
    try {
      const apiResponse = await graphqlCallback(
        API.graphql(
          {
            query,
            variables: variablesWithExtra,
            authMode: "AMAZON_COGNITO_USER_POOLS"
          },
          {
            "user-id": userId,
            "user-type": userType,
            "rest-id": restId,
            "app-version": getAppVersion()
          }
        )
      );
      response.response = apiResponse;
      response.status = "success";
    } catch (e) {
      devLog("info", "there was an error", e);
      response.status = "error";
      const errorData = safeParse(((_d2 = (_c2 = e == null ? void 0 : e.errors) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.message) || ((_e2 = e == null ? void 0 : e.error) == null ? void 0 : _e2.message) || e);
      response.status = "error";
      response.response = e;
      response.error = {
        message: `${(errorData == null ? void 0 : errorData.message) || errorData}`,
        data: errorData || {}
      };
    }
    devLog(response.status, "API response", response);
    return response;
  };
  const cancelRequests2 = (model, now2) => {
    const state = store$1 == null ? void 0 : store$1.getState();
    const { apiRequests } = state;
    apiRequests.forEach((apiRequest) => {
      if (apiRequest.model === model && now2 > apiRequest.timestamp) {
        devLog("info", "cancelling api request", apiRequest);
        API.cancel(apiRequest.request);
      }
    });
  };
  const isCancel2 = (error) => {
    return API.isCancel(error);
  };
  const fetchBookings = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBookings, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBookings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchBookingByUserId2 = async (userId) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBookingsForUser, { userId });
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBookingsForUser,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createBooking = async (data) => {
    var _a, _b2, _c2;
    const bookingData = data.booking;
    const guestsInput = (_a = bookingData.guests) == null ? void 0 : _a.map((guest) => only(guest, OBGuestInputKeys));
    const bookingInputData = {
      ...removeNullFields(
        only(
          {
            ...bookingData,
            paymentMethodId: bookingData == null ? void 0 : bookingData.cardNumber,
            paymentMethodName: bookingData == null ? void 0 : bookingData.cardToken,
            guests: guestsInput
          },
          OBBookingInputKeys
        )
      )
    };
    const inputData = {
      ...data,
      booking: bookingInputData
    };
    const response = await graphqlApiCall(createObeeBooking$1, inputData);
    return {
      data: (_c2 = (_b2 = response == null ? void 0 : response.response) == null ? void 0 : _b2.data) == null ? void 0 : _c2.createObeeBooking,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateBooking = async (data) => {
    var _a, _b2, _c2;
    const guestsInput = (_a = data.guests) == null ? void 0 : _a.map((guest) => only(guest, OBGuestInputKeys));
    const inputBookingData = only(
      {
        ...data == null ? void 0 : data.booking,
        setupIntentId: data == null ? void 0 : data.setupIntentId,
        paymentMethodId: data == null ? void 0 : data.cardNumber,
        paymentMethodName: data == null ? void 0 : data.cardToken,
        guests: guestsInput
      },
      OBBookingInputKeys
    );
    const inputData = {
      ...data,
      booking: inputBookingData
    };
    const response = await graphqlApiCall(updateObeeBooking$1, inputData);
    return {
      data: (_c2 = (_b2 = response == null ? void 0 : response.response) == null ? void 0 : _b2.data) == null ? void 0 : _c2.updateObeeBooking,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const resubmitBooking2 = async (data) => {
    return createBooking(data);
  };
  const confirmWaitlistBooking = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(confirmWaitlist$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.confirmWaitlist,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const confirmWaitlistAsBooked2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(confirmWaitlistAsBooked$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.confirmWaitlistAsBooked,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const sendWaitlistSMS2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(sendWaitlistSMS$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.sendWaitlistSMSQuery,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const sendGuestEmail2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(sendGuestEmail$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.sendGuestEmail,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const sendGuestSMS2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(sendGuestSMS$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.sendGuestSMS,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const checkBookingUpdate2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBookingUpdateCheck, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBookingUpdateCheck,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchTables = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeTables, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeTables,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createTable$12 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createTable, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createTable,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateTable$12 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateTable, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateTable,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteTable$12 = async (data) => {
    const response = await graphqlApiCall(deleteTable, data);
    return response;
  };
  const updateTablePriorities2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveTablePriorities, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.saveTablePriorities,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchSettings = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeSettings, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateSettings = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveObeeSettings, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.saveObeeSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchWidgetSettings2 = async (data) => {
    var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j;
    const response = await graphqlApiCall(widgetTheme, data);
    const combinedThemeData = {
      ...((_e2 = (_d2 = safeParse((_c2 = (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeSettings) == null ? void 0 : _c2.bookingWidgetSettings)) == null ? void 0 : _d2.themeSettings) == null ? void 0 : _e2.themeDetails) || {},
      ...((_j = (_i = safeParse((_h = (_g = (_f = response == null ? void 0 : response.response) == null ? void 0 : _f.data) == null ? void 0 : _g.obeeSettings) == null ? void 0 : _h.bookingWidgetSettings)) == null ? void 0 : _i.widgetSettings) == null ? void 0 : _j.settingsDetails) || {}
    };
    return {
      data: combinedThemeData,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateWidgetTheme2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateThemeSettings, data, true);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateThemeSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateBookingWidgetSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateBookingWidgetSettings$1, data, true);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateBookingWidgetSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchMessagesSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(messagesSettingsByRestId, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.messagesSettingsByRestId,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateMessagesSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveMessagesSettings, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.saveMessagesSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchAreas = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeAreas, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeAreas,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createArea$12 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createArea, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createArea,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateArea$12 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateArea, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateArea,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteArea$12 = async (data) => {
    const response = await graphqlApiCall(deleteArea, data);
    return response;
  };
  const fetchStaff2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeStaffList, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeStaffList,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createStaff2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createStaff$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createStaff,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateStaff2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateStaff$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateStaff,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteStaff2 = async (data) => {
    const response = await graphqlApiCall(deleteStaff$1, data);
    return response;
  };
  const fetchGuests2 = async (data, pagination) => {
    var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k;
    const response = await graphqlApiCall(obeeGuests, {
      ...data,
      page: (pagination == null ? void 0 : pagination.page) || 1,
      pageSize: (pagination == null ? void 0 : pagination.pageSize) || 50
    });
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeGuests,
      pagination: {
        currentPage: ((_d2 = (_c2 = response == null ? void 0 : response.meta) == null ? void 0 : _c2.pagination) == null ? void 0 : _d2.current_page) || 1,
        // TODO pagination in response
        totalPages: ((_f = (_e2 = response == null ? void 0 : response.meta) == null ? void 0 : _e2.pagination) == null ? void 0 : _f.total_pages) || 1,
        // TODO pagination in response
        totalResults: (_h = (_g = response == null ? void 0 : response.meta) == null ? void 0 : _g.pagination) == null ? void 0 : _h.total,
        // TODO pagination in response
        fetchedResults: (_k = (_j = (_i = response == null ? void 0 : response.response) == null ? void 0 : _i.data) == null ? void 0 : _j.obeeGuests) == null ? void 0 : _k.length
        // In case we don't have a total
      },
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateGuest2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateGuest$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateGuest,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchVoucherRedemptions2 = async () => {
    return { data: [], error: null };
  };
  const fetchVoucherHistory2 = async () => {
    return { data: {}, error: null };
  };
  const createVoucherRedemption2 = async () => {
    return { data: [], error: null };
  };
  const fetchSessions = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeSessions, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createSession$12 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createSession, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createSession,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateSession$1 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateSession, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateSession,
      error: response == null ? void 0 : response.error
    };
  };
  const deleteSession$12 = async (data) => {
    const response = await graphqlApiCall(deleteSession, data);
    return response;
  };
  const fetchGlobalSessions = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeGlobalSessions, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeGlobalSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createGlobalSession$1 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createGlobalSession, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createGlobalSession,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateGlobalSession$1 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateGlobalSession, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateGlobalSession,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteGlobalSession$1 = async (data) => {
    const response = await graphqlApiCall(deleteGlobalSession, data);
    return response;
  };
  const fetchEventSessions = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeEventSessions, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeEventSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createEventSession$1 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createEventSession, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createEventSession,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateEventSession$1 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateEventSession, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateEventSession,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteEventSession$1 = async (data) => {
    const response = await graphqlApiCall(deleteEventSession, data);
    return response;
  };
  const fetchFloorplan = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeFloorPlan, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeFloorPlan,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateFloorplan = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveFloorPlan, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeFloorPlan,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const checkAvailability = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeAvailabilityCheck, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeAvailabilityCheck,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const checkAvailabilityAllAreas = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeAvailabilityCheckAllAreas, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeAvailabilityCheckAllAreas,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const availabilitySuggestions = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeAvailabilitySuggestions, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeAvailabilitySuggestions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createPaymentSetupIntent2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createPaymentSetupIntent$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createPaymentSetupIntent,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const lookupPaymentMethodName2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(lookupPaymentMethodName$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.lookupPaymentMethodName,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchRestaurant = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(restaurantById, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.restaurantById,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchRestaurantBySlug = async () => {
    return {
      data: [],
      error: null,
      status: null
    };
  };
  const fetchLinkedVenues2 = async () => {
    var _a, _b2, _c2, _d2, _e2, _f, _g, _h;
    const state = store$1 == null ? void 0 : store$1.getState();
    const userRestaurantId = ((_d2 = (_c2 = (_b2 = (_a = state == null ? void 0 : state.user) == null ? void 0 : _a.userInfo) == null ? void 0 : _b2.restaurants) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.objectId) || ((_f = (_e2 = state == null ? void 0 : state.restaurantActive) == null ? void 0 : _e2.restaurant) == null ? void 0 : _f.objectId);
    if (!userRestaurantId) {
      return {
        data: [],
        error: null,
        status: "success"
      };
    }
    const response = await graphqlApiCall(
      affiliatedRestaurants,
      { restId: userRestaurantId },
      false
    );
    return {
      data: (_h = (_g = response == null ? void 0 : response.response) == null ? void 0 : _g.data) == null ? void 0 : _h.affiliatedRestaurants,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateRestaurant = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(saveRestaurant, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.saveRestaurant,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const findRestaurantByName = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(restaurantSearchByName, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.restaurantSearchByName,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const closeEarly2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(closeEarly$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.closeEarly,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const reopen2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(reopen$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.reopen,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const blockTable2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(blockTable$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.blockTable,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const unblockTable2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(unblockTable$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.unblockTable,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateTableBlock2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(editTableBlock, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.editTableBlock,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createTimeslotLimit2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createTimeslotLimit$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createTimeslotLimit,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateTimeslotLimit2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateTimeslotLimit$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateTimeslotLimit,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteTimeslotLimit2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(deleteTimeslotLimit$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.deleteTimeslotLimit,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchTimeslotConditions2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeTimeslotConditions, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeTimeslotConditions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createTimeslotCondition2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createTimeslotCondition$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createTimeslotCondition,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteTimeslotCondition2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(deleteTimeslotCondition$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.deleteTimeslotCondition,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchIntegrations2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeIntegrations, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeIntegrations,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const enableReserveWithGoogle2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(enableReserveWithGoogle$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.enableReserveWithGoogle,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const disableReserveWithGoogle2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(disableReserveWithGoogle$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.disableReserveWithGoogle,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const generateFacebookLoginButton2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(generateFBLoginButton, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.generateFBLoginButton,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const disconnectMetaIntegration2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(disconnectMetaConnection, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.disconnectMetaConnection,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const completeMetaCallback2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(metaCallback, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.metaCallback,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const getFacebookRedirectUrl2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(getFBRedirectUrl, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.getFBRedirectUrl,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const getImageUploadUrl2 = async (data) => {
    var _a, _b2;
    const inputData = only(data, ImageUploadUrlInputKeys);
    const response = await graphqlApiCall(obeeImageUploadUrl, inputData);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeImageUploadUrl,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchPaymentSettings2 = async (data) => {
    return {
      data: null,
      error: null,
      status: "success"
    };
  };
  const chargeNoShow2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(chargeNoShow$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.chargeNoShow,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchNotifications2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeNotifications, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeNotifications,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchNotificationCount2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeNotificationCount, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeNotificationCount,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const subscribeToNotificationEvents2 = async (data, onEvent = () => {
  }) => {
    const callback = (graphql) => graphql.subscribe({
      next: (event) => {
        var _a, _b2, _c2;
        const response2 = event.value.data.subscribeToObeePubSubEvents;
        devLog("success", "subscribeToObeePubSubEvents", response2);
        const state = store$1 == null ? void 0 : store$1.getState();
        const restId = (_b2 = (_a = state == null ? void 0 : state.restaurantActive) == null ? void 0 : _a.restaurant) == null ? void 0 : _b2.objectId;
        const lastCheckedAt = (_c2 = state == null ? void 0 : state.notifications) == null ? void 0 : _c2.lastCheckedAt;
        switch (response2.type) {
          case "new":
          case "update":
          case "cancelled":
          case "waitlist": {
            onEvent(restId, lastCheckedAt);
            break;
          }
          default: {
            devLog(
              "warning",
              "subscribeToNotificationEvents",
              `type: ${response2.type} is not being handled`
            );
            break;
          }
        }
      },
      error: (error) => {
        devLog("error", "subscribeToNotificationEvents", error);
      }
    });
    const response = await graphqlApiCall(subscribeToObeePubSubEvents, data, true, callback);
    return {
      data: response == null ? void 0 : response.response,
      // note: we want the response for a Subscription so we can close it later if we want to
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchDailyNotes2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeDailyNotes, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeDailyNotes,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createDailyNote2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createDailyNote$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createDailyNote,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateDailyNote2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateDailyNote$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateDailyNote,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteDailyNote2 = async (data) => {
    const response = await graphqlApiCall(deleteDailyNote$1, data);
    return response;
  };
  const fetchDailyNoteCategories2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeDailyNoteCategories, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeDailyNoteCategories,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchBookingDurations2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBookingDurations, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBookingDurations,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createBookingDuration2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createBookingDuration$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createBookingDuration,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateBookingDuration2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateBookingDuration$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateBookingDuration,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteBookingDuration2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(deleteBookingDuration$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.deleteBookingDuration,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchFullyBookedSessions2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeFullyBookedSessions, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeFullyBookedSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const createFullyBookedSessions2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(createFullyBookedSessions$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.createFullyBookedSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const deleteFullyBookedSessions2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(deleteFullyBookedSessions$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.deleteFullyBookedSessions,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchBrandedEmailSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeBrandedEmailSettings, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeBrandedEmailSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateBrandedEmailSettings2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(updateBrandedEmailSettings$1, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.updateBrandedEmailSettings,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const exportGuestBook2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeExportGuestBook, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeExportGuestBook,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const updateAreaCapacity2 = async (data) => {
    var _a;
    const response = await graphqlApiCall(updateAreaCapacity$1, data);
    return {
      data: (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  const fetchMonthlyView2 = async (data) => {
    var _a, _b2;
    const response = await graphqlApiCall(obeeMonthlyViewByDate, data);
    return {
      data: (_b2 = (_a = response == null ? void 0 : response.response) == null ? void 0 : _a.data) == null ? void 0 : _b2.obeeMonthlyViewByDate,
      error: response == null ? void 0 : response.error,
      status: response == null ? void 0 : response.status
    };
  };
  devLog("info", "HI FROM EATCLUB API CLIENT. THIS SHOULD ONLY RENDER ONCE");
  return {
    graphqlApiCall,
    cancelRequests: cancelRequests2,
    isCancel: isCancel2,
    fetchBookings,
    fetchBookingByUserId: fetchBookingByUserId2,
    createBooking,
    updateBooking,
    resubmitBooking: resubmitBooking2,
    confirmWaitlistBooking,
    confirmWaitlistAsBooked: confirmWaitlistAsBooked2,
    sendWaitlistSMS: sendWaitlistSMS2,
    sendGuestEmail: sendGuestEmail2,
    sendGuestSMS: sendGuestSMS2,
    checkBookingUpdate: checkBookingUpdate2,
    fetchTables,
    createTable: createTable$12,
    updateTable: updateTable$12,
    deleteTable: deleteTable$12,
    updateTablePriorities: updateTablePriorities2,
    fetchSettings,
    updateSettings,
    fetchWidgetSettings: fetchWidgetSettings2,
    updateWidgetTheme: updateWidgetTheme2,
    updateBookingWidgetSettings: updateBookingWidgetSettings2,
    fetchMessagesSettings: fetchMessagesSettings2,
    updateMessagesSettings: updateMessagesSettings2,
    fetchAreas,
    createArea: createArea$12,
    updateArea: updateArea$12,
    deleteArea: deleteArea$12,
    fetchStaff: fetchStaff2,
    createStaff: createStaff2,
    updateStaff: updateStaff2,
    deleteStaff: deleteStaff2,
    fetchGuests: fetchGuests2,
    updateGuest: updateGuest2,
    exportGuestBook: exportGuestBook2,
    fetchSessions,
    createSession: createSession$12,
    updateSession: updateSession$1,
    deleteSession: deleteSession$12,
    fetchGlobalSessions,
    createGlobalSession: createGlobalSession$1,
    updateGlobalSession: updateGlobalSession$1,
    deleteGlobalSession: deleteGlobalSession$1,
    fetchEventSessions,
    createEventSession: createEventSession$1,
    updateEventSession: updateEventSession$1,
    deleteEventSession: deleteEventSession$1,
    fetchFloorplan,
    updateFloorplan,
    checkAvailability,
    checkAvailabilityAllAreas,
    availabilitySuggestions,
    createPaymentSetupIntent: createPaymentSetupIntent2,
    lookupPaymentMethodName: lookupPaymentMethodName2,
    fetchRestaurant,
    fetchRestaurantBySlug,
    fetchLinkedVenues: fetchLinkedVenues2,
    updateRestaurant,
    findRestaurantByName,
    closeEarly: closeEarly2,
    reopen: reopen2,
    blockTable: blockTable2,
    unblockTable: unblockTable2,
    updateTableBlock: updateTableBlock2,
    createTimeslotLimit: createTimeslotLimit2,
    updateTimeslotLimit: updateTimeslotLimit2,
    deleteTimeslotLimit: deleteTimeslotLimit2,
    fetchTimeslotConditions: fetchTimeslotConditions2,
    createTimeslotCondition: createTimeslotCondition2,
    deleteTimeslotCondition: deleteTimeslotCondition2,
    fetchIntegrations: fetchIntegrations2,
    enableReserveWithGoogle: enableReserveWithGoogle2,
    disableReserveWithGoogle: disableReserveWithGoogle2,
    generateFacebookLoginButton: generateFacebookLoginButton2,
    disconnectMetaIntegration: disconnectMetaIntegration2,
    completeMetaCallback: completeMetaCallback2,
    getFacebookRedirectUrl: getFacebookRedirectUrl2,
    getImageUploadUrl: getImageUploadUrl2,
    fetchVoucherRedemptions: fetchVoucherRedemptions2,
    fetchVoucherHistory: fetchVoucherHistory2,
    createVoucherRedemption: createVoucherRedemption2,
    fetchPaymentSettings: fetchPaymentSettings2,
    chargeNoShow: chargeNoShow2,
    fetchNotifications: fetchNotifications2,
    fetchNotificationCount: fetchNotificationCount2,
    subscribeToNotificationEvents: subscribeToNotificationEvents2,
    fetchDailyNotes: fetchDailyNotes2,
    createDailyNote: createDailyNote2,
    updateDailyNote: updateDailyNote2,
    deleteDailyNote: deleteDailyNote2,
    fetchDailyNoteCategories: fetchDailyNoteCategories2,
    fetchBookingDurations: fetchBookingDurations2,
    createBookingDuration: createBookingDuration2,
    updateBookingDuration: updateBookingDuration2,
    deleteBookingDuration: deleteBookingDuration2,
    fetchFullyBookedSessions: fetchFullyBookedSessions2,
    createFullyBookedSessions: createFullyBookedSessions2,
    deleteFullyBookedSessions: deleteFullyBookedSessions2,
    updateAreaCapacity: updateAreaCapacity2,
    fetchBrandedEmailSettings: fetchBrandedEmailSettings2,
    updateBrandedEmailSettings: updateBrandedEmailSettings2,
    fetchMonthlyView: fetchMonthlyView2
  };
};
devLog(
  "info",
  "HELLO FROM BASE API CLIENT. THIS SHOULD ALSO ONLY LOAD ONCE",
  window == null ? void 0 : window.bookingsPlatform
);
const getApiClient = () => {
  var _a, _b2;
  if ((_a = window == null ? void 0 : window.bookingsPlatform) == null ? void 0 : _a.apiClient) {
    return (_b2 = window == null ? void 0 : window.bookingsPlatform) == null ? void 0 : _b2.apiClient;
  }
  let client;
  if (isObee()) {
    client = ObeeApiClient();
  } else {
    client = EatClubApiClient();
  }
  if (!(window == null ? void 0 : window.bookingsPlatform)) {
    window.bookingsPlatform = {};
  }
  window.bookingsPlatform.apiClient = client;
  return client;
};
const cancelRequests = (model, now2) => getApiClient().cancelRequests(model, now2);
const isCancel = (error) => getApiClient().isCancel(error);
const fetchObeeBookings = (data) => getApiClient().fetchBookings(data);
const createObeeBooking = (data) => getApiClient().createBooking(data);
const updateObeeBooking = (data) => getApiClient().updateBooking(data);
const fetchBookingByUserId = (userId) => getApiClient().fetchBookingByUserId(userId);
const checkBookingUpdate = (data) => getApiClient().checkBookingUpdate(data);
const resubmitBooking = (data) => getApiClient().resubmitBooking(data);
const confirmWaitlist = (data) => getApiClient().confirmWaitlistBooking(data);
const confirmWaitlistAsBooked = (data) => getApiClient().confirmWaitlistAsBooked(data);
const sendWaitlistSMS = (data) => getApiClient().sendWaitlistSMS(data);
const sendGuestEmail = (data) => getApiClient().sendGuestEmail(data);
const sendGuestSMS = (data) => getApiClient().sendGuestSMS(data);
const fetchObeeTables = (data) => getApiClient().fetchTables(data);
const createObeeTable = (data) => getApiClient().createTable(data);
const updateObeeTable = (data) => getApiClient().updateTable(data);
const deleteObeeTable = (data) => getApiClient().deleteTable(data);
const updateTablePriorities = (data) => getApiClient().updateTablePriorities(data);
const fetchObeeSettings = (data) => getApiClient().fetchSettings(data);
const updateObeeSettings = (data) => getApiClient().updateSettings(data);
const fetchMessagesSettings = (data) => getApiClient().fetchMessagesSettings(data);
const updateMessagesSettings = (data) => getApiClient().updateMessagesSettings(data);
const fetchBrandedEmailSettings = (data) => getApiClient().fetchBrandedEmailSettings(data);
const updateBrandedEmailSettings = (data) => getApiClient().updateBrandedEmailSettings(data);
const fetchWidgetSettings = (data) => getApiClient().fetchWidgetSettings(data);
const updateWidgetTheme = (data) => getApiClient().updateWidgetTheme(data);
const updateBookingWidgetSettings = (data) => getApiClient().updateBookingWidgetSettings(data);
const fetchObeeAreas = (data) => getApiClient().fetchAreas(data);
const createObeeArea = (data) => getApiClient().createArea(data);
const updateObeeArea = (data) => getApiClient().updateArea(data);
const deleteObeeArea = (data) => getApiClient().deleteArea(data);
const fetchStaff = (data) => getApiClient().fetchStaff(data);
const createStaff = (data) => getApiClient().createStaff(data);
const updateStaff = (data) => getApiClient().updateStaff(data);
const deleteStaff = (data) => getApiClient().deleteStaff(data);
const fetchGuests = (data, pagination) => getApiClient().fetchGuests(data, pagination);
const updateGuest = (data) => getApiClient().updateGuest(data);
const exportGuestBook = (data) => getApiClient().exportGuestBook(data);
const fetchObeeGlobalSessions = (data) => getApiClient().fetchGlobalSessions(data);
const createObeeGlobalSession = (data) => getApiClient().createGlobalSession(data);
const updateObeeGlobalSession = (data) => getApiClient().updateGlobalSession(data);
const deleteObeeGlobalSession = (data) => getApiClient().deleteGlobalSession(data);
const fetchObeeEventSessions = (data) => getApiClient().fetchEventSessions(data);
const createObeeEventSession = (data) => getApiClient().createEventSession(data);
const updateObeeEventSession = (data) => getApiClient().updateEventSession(data);
const deleteObeeEventSession = (data) => getApiClient().deleteEventSession(data);
const fetchObeeSessions = (data) => getApiClient().fetchSessions(data);
const createObeeSession = (data) => getApiClient().createSession(data);
const updateObeeSession = (data) => getApiClient().updateSession(data);
const deleteObeeSession = (data) => getApiClient().deleteSession(data);
const fetchObeeFloorplan = (data) => getApiClient().fetchFloorplan(data);
const updateObeeFloorplan = (data) => getApiClient().updateFloorplan(data);
const updateAreaCapacity = (data) => getApiClient().updateAreaCapacity(data);
const checkObeeAvailability = (data) => getApiClient().checkAvailability(data);
const checkObeeAvailabilityAllAreas = (data) => getApiClient().checkAvailabilityAllAreas(data);
const createPaymentSetupIntent = (data) => getApiClient().createPaymentSetupIntent(data);
const lookupPaymentMethodName = (data) => getApiClient().lookupPaymentMethodName(data);
const fetchLinkedVenues = (data) => getApiClient().fetchLinkedVenues(data);
const closeEarly = (data) => getApiClient().closeEarly(data);
const reopen = (data) => getApiClient().reopen(data);
const blockTable = (data) => getApiClient().blockTable(data);
const unblockTable = (data) => getApiClient().unblockTable(data);
const updateTableBlock = (data) => getApiClient().updateTableBlock(data);
const createTimeslotLimit = (data) => getApiClient().createTimeslotLimit(data);
const updateTimeslotLimit = (data) => getApiClient().updateTimeslotLimit(data);
const deleteTimeslotLimit = (data) => getApiClient().deleteTimeslotLimit(data);
const fetchTimeslotConditions = (data) => getApiClient().fetchTimeslotConditions(data);
const createTimeslotCondition = (data) => getApiClient().createTimeslotCondition(data);
const deleteTimeslotCondition = (data) => getApiClient().deleteTimeslotCondition(data);
const fetchIntegrations = (data) => getApiClient().fetchIntegrations(data);
const enableReserveWithGoogle = (data) => getApiClient().enableReserveWithGoogle(data);
const disableReserveWithGoogle = (data) => getApiClient().disableReserveWithGoogle(data);
const generateFacebookLoginButton = (data) => getApiClient().generateFacebookLoginButton(data);
const disconnectMetaIntegration = (data) => getApiClient().disconnectMetaIntegration(data);
const completeMetaCallback = (data) => getApiClient().completeMetaCallback(data);
const getFacebookRedirectUrl = (data) => getApiClient().getFacebookRedirectUrl(data);
const getImageUploadUrl = (data) => getApiClient().getImageUploadUrl(data);
const fetchVoucherRedemptions = (data, pagination) => getApiClient().fetchVoucherRedemptions(data, pagination);
const fetchVoucherHistory = (id) => getApiClient().fetchVoucherHistory(id);
const createVoucherRedemption = (data) => getApiClient().createVoucherRedemption(data);
const fetchPaymentSettings = (data) => getApiClient().fetchPaymentSettings(data);
const chargeNoShow = (data) => getApiClient().chargeNoShow(data);
const fetchNotifications = (data) => getApiClient().fetchNotifications(data);
const fetchNotificationCount = (data) => getApiClient().fetchNotificationCount(data);
const subscribeToNotificationEvents = (data, onEvent) => getApiClient().subscribeToNotificationEvents(data, onEvent);
const fetchDailyNotes = (data) => getApiClient().fetchDailyNotes(data);
const createDailyNote = (data) => getApiClient().createDailyNote(data);
const updateDailyNote = (data) => getApiClient().updateDailyNote(data);
const deleteDailyNote = (data) => getApiClient().deleteDailyNote(data);
const fetchDailyNoteCategories = (data) => getApiClient().fetchDailyNoteCategories(data);
const fetchBookingDurations = (data) => getApiClient().fetchBookingDurations(data);
const createBookingDuration = (data) => getApiClient().createBookingDuration(data);
const updateBookingDuration = (data) => getApiClient().updateBookingDuration(data);
const deleteBookingDuration = (data) => getApiClient().deleteBookingDuration(data);
const fetchFullyBookedSessions = (data) => getApiClient().fetchFullyBookedSessions(data);
const createFullyBookedSessions = (data) => getApiClient().createFullyBookedSessions(data);
const deleteFullyBookedSessions = (data) => getApiClient().deleteFullyBookedSessions(data);
const fetchMonthlyView = (data) => getApiClient().fetchMonthlyView(data);
const addMessage = (action, dispatch, context = "success", message) => {
  const errorType = context.toUpperCase();
  if (message) {
    dispatch({
      type: ADD_MESSAGE,
      payload: {
        id: `${action}_${errorType}_${(/* @__PURE__ */ new Date()).getTime()}`,
        message,
        severity: context
      }
    });
  }
};
const handleFailure = (error, action, entityName, customErrorMessage, response, dispatch) => {
  let messageToShow = `Unable to complete action for ${entityName}`;
  if (error) {
    messageToShow += `: ${error == null ? void 0 : error.message}`;
  }
  if (!isEmpty(customErrorMessage)) {
    if (typeof customErrorMessage === "function") {
      messageToShow = customErrorMessage(`${error == null ? void 0 : error.message}`);
    } else {
      messageToShow = customErrorMessage;
    }
  }
  devLog("error", entityName, messageToShow, error);
  addMessage(action, dispatch, "error", messageToShow);
  dispatch({
    type: `${action}_FAILURE`,
    payload: { error: messageToShow, errorData: error == null ? void 0 : error.data, response }
  });
};
const handleResponse = (response, action, entityName, dispatch, tempId, tempData = {}, extraValues = {}, onCompletion = null, errorMessage = null) => {
  var _a;
  if ((response == null ? void 0 : response.status) === "error") {
    handleFailure(response == null ? void 0 : response.error, action, entityName, errorMessage, response, dispatch);
    return;
  }
  const data = response == null ? void 0 : response.data;
  const preventLoggingResponse = response.status === "success" && !((_a = window.bookingsConfig) == null ? void 0 : _a.logApiSuccesses);
  if (!preventLoggingResponse) {
    devLog("success", entityName, data);
  }
  if (!isEmpty(onCompletion)) {
    onCompletion(response);
  }
  dispatch({
    type: `${action}_SUCCESS`,
    payload: {
      data,
      pagination: (response == null ? void 0 : response.pagination) || {},
      variables: tempData,
      tempId,
      ...extraValues
    }
  });
};
const beginAction = (action, dispatch, object, tempId, requestId) => {
  dispatch({
    type: SET_ID_APP_LOADING,
    payload: `${action}_${requestId}`
  });
  dispatch({
    type: `${action}_PENDING`,
    payload: {
      data: object,
      tempId
    }
  });
};
const endAction = (action, dispatch, requestId) => {
  dispatch({
    type: REMOVE_ID_APP_LOADING,
    payload: `${action}_${requestId}`
  });
};
const addRequest = (id, timestamp, model, request, dispatch) => {
  dispatch({
    type: ADD_API_REQUEST,
    payload: { id, timestamp, model, request }
  });
};
const removeRequest = (id, dispatch) => {
  dispatch({
    type: REMOVE_API_REQUEST,
    payload: id
  });
};
const makeApiAction = (action, request, pendingObject, entityName, successMessage = null, extraValues = {}, skipLoading = false, errorMessage = null, cancelStaleApiRequests = false, onCompletion = null) => async (dispatch) => {
  const tempId = generateRandomString(8);
  const requestId = generateRandomString(16);
  if (!skipLoading) {
    beginAction(action, dispatch, pendingObject, tempId, requestId);
  }
  if (cancelStaleApiRequests) {
    const now2 = (/* @__PURE__ */ new Date()).getTime();
    cancelRequests(entityName, now2);
    addRequest(requestId, now2, entityName, request, dispatch);
  }
  try {
    if (request) {
      const response = await request();
      handleResponse(
        response,
        action,
        entityName,
        dispatch,
        tempId,
        pendingObject || {},
        extraValues,
        onCompletion,
        errorMessage
      );
      if (!(response == null ? void 0 : response.error) && (response == null ? void 0 : response.status) !== "error" && successMessage) {
        addMessage(action, dispatch, "success", successMessage);
      }
    }
  } catch (error) {
    if (isCancel(error)) {
      devLog("info", "api request cancelled", { id: requestId, entityName });
    } else {
      devLog("error", "API request failed unexpectedly", error);
      handleFailure(error, action, entityName, errorMessage, null, dispatch);
    }
  } finally {
    if (cancelStaleApiRequests) {
      removeRequest(requestId, dispatch);
    }
    if (!skipLoading) {
      endAction(action, dispatch, requestId);
    }
  }
};
const createLocalItem = (newItem, entityName, tempId = null) => (dispatch) => {
  devLog("info", `Generic creation of ${entityName}`, newItem);
  const tempIdToUse = !isEmpty(tempId) ? tempId : `_${generateRandomString(8)}`;
  dispatch({
    type: `CREATE_LOCAL_${entityName}`,
    payload: {
      ...newItem,
      id: tempIdToUse,
      // Risky, but allows this to be referenced by ID
      _tempId: tempIdToUse,
      _isNew: true
    }
  });
};
const createLocalItems = (newItems, entityName, tempId = null) => (dispatch) => {
  devLog("info", `Generic creation of ${entityName}`, newItems);
  const itemsToCreate = newItems.map((newItem) => {
    const tempIdToUse = !isEmpty(tempId) ? tempId : `_${generateRandomString(8)}`;
    return {
      ...newItem,
      id: tempIdToUse,
      // Risky, but allows this to be referenced by ID
      _tempId: tempIdToUse,
      _isNew: true
    };
  });
  dispatch({
    type: `CREATE_LOCAL_${entityName}`,
    payload: itemsToCreate
  });
};
const updateLocalItem = (updatedItem, entityName) => (dispatch) => {
  dispatch({
    type: `UPDATE_LOCAL_${entityName}`,
    payload: updatedItem
  });
};
const deleteLocalItems = (deletedIds, entityName) => (dispatch) => {
  dispatch({
    type: `DELETE_LOCAL_${entityName}`,
    payload: deletedIds
  });
};
const fetchAreasAction = () => (dispatch) => {
  const action = "FETCH_OBEE_AREAS";
  const entityName = "obeeAreas";
  const request = () => fetchObeeAreas();
  dispatch(makeApiAction(action, request, {}, entityName));
};
const getNewArea = (areaType, defaultDuration) => ({
  ...getDefaultValues$1(defaultDuration),
  name: `New ${areaType} area`
});
const createLocalAreaAction = (areaType, defaultDuration = 60, tempId = null) => (dispatch) => {
  const newArea = getNewArea(areaType, defaultDuration);
  dispatch(createLocalItem(newArea, "OBEE_AREA", tempId));
};
const updateLocalAreaAction = (updatedItem) => (dispatch) => {
  dispatch(updateLocalItem(updatedItem, "OBEE_AREA"));
};
const deleteLocalAreasAction = (deletedIds) => (dispatch) => {
  dispatch(deleteLocalItems(deletedIds, "OBEE_AREAS"));
};
const promiseAllInBatches = async (promises, batchSize = 5) => {
  let position = 0;
  let results2 = [];
  while (position < promises.length) {
    const itemsForBatch = promises.slice(position, position + batchSize);
    results2 = [...results2, ...await Promise.allSettled(itemsForBatch.map((item) => item()))];
    position += batchSize;
  }
  return results2;
};
const createBatchedPromises = async (actions, batchSize = 8) => {
  const promises = actions.map((action) => {
    return () => new Promise((resolve) => {
      action.request().then((response) => {
        resolve(action.handleResponse(response));
      });
    });
  });
  const results2 = await promiseAllInBatches(promises, batchSize);
  return results2.map((result) => result == null ? void 0 : result.value);
};
const fetchFloorplanAction = () => (dispatch) => {
  const action = "FETCH_OBEE_FLOORPLAN";
  const entityName = "obeeFloorPlan";
  const data = {};
  const request = () => fetchObeeFloorplan(data);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const updateFloorplanAction = (updatedFloorplan, extraValues, success = true) => (dispatch) => {
  const action = "UPDATE_OBEE_FLOORPLAN";
  const entityName = "obeeFloorPlan";
  const successMessage = success ? "Floor plan has been saved!" : null;
  const errorMessage = "Failed to save floor plan";
  const data = {
    data: JSON.stringify(updatedFloorplan)
  };
  const request = () => updateObeeFloorplan(data);
  dispatch(
    makeApiAction(
      action,
      request,
      data.data,
      entityName,
      successMessage,
      extraValues,
      false,
      errorMessage
    )
  );
};
const updateLocalFloorplanAction = (updatedFloorplan) => (dispatch) => {
  devLog("info", "updating floor plan", updatedFloorplan);
  const data = {
    data: JSON.stringify(updatedFloorplan)
  };
  dispatch({
    type: `UPDATE_OBEE_FLOORPLAN_LOCAL`,
    payload: data
  });
};
const createAreas = async (areaState) => {
  if (isEmpty(areaState.created)) {
    return [[], []];
  }
  const createdAreas = filterByProperty(areaState.data, areaState.created, "id");
  const createdAreaPromises = createdAreas.map((createdArea) => {
    const newAreaData = convertDataForApi$5(createdArea);
    const postData = {
      area: newAreaData
    };
    return {
      // request: () => makeApiRequest(createArea, postData),
      request: () => createObeeArea(postData),
      handleResponse: (response) => ({
        ...response,
        data: (response == null ? void 0 : response.data) || {},
        _tempId: createdArea == null ? void 0 : createdArea._tempId
      })
    };
  });
  const results2 = await createBatchedPromises(createdAreaPromises);
  const successes = results2.filter((result) => result.status === "success") || [];
  const failures = results2.filter((result) => result.status !== "success") || [];
  return [successes, failures];
};
const createTables = async (tableState, createdAreas, failedAreas) => {
  var _a, _b2;
  if (isEmpty(tableState.created)) {
    return [[], []];
  }
  const unjoinedTablesToCreate = (_a = filterByProperty(
    tableState.data,
    tableState.created,
    "id"
  )) == null ? void 0 : _a.filter((table) => !tableIsJoin(table == null ? void 0 : table.tableNumber));
  const joinedTablesToCreate = (_b2 = filterByProperty(tableState.data, tableState.created, "id")) == null ? void 0 : _b2.filter(
    (table) => tableIsJoin(table == null ? void 0 : table.tableNumber)
  );
  const createTablesWithApi = async (tablesToCreate) => {
    const failedAreaIds = flatten(failedAreas, "data.id");
    const createdTablesWithAreas = filterByProperty(tablesToCreate, failedAreaIds, "areaId", true);
    const createTablePromises = createdTablesWithAreas.map((createdTable) => {
      var _a2, _b3;
      const newAreaId = ((_b3 = (_a2 = findObjectByProperty(createdAreas, createdTable == null ? void 0 : createdTable.areaId, "_tempId")) == null ? void 0 : _a2.data) == null ? void 0 : _b3.id) || (createdTable == null ? void 0 : createdTable.areaId);
      const newTableData = convertDataForApi$4({ ...createdTable, areaId: newAreaId });
      const postData = {
        table: newTableData
      };
      return {
        // request: () => makeApiRequest(createTable, postData),
        request: () => createObeeTable(postData),
        handleResponse: (response) => ({
          ...response,
          data: (response == null ? void 0 : response.data) || {},
          _tempId: createdTable == null ? void 0 : createdTable._tempId
        })
      };
    });
    const results2 = await createBatchedPromises(createTablePromises);
    const successes = results2.filter((result) => result.status === "success") || [];
    const failures = results2.filter((result) => result.status !== "success") || [];
    return [successes, failures];
  };
  const createdNormalTables = await createTablesWithApi(unjoinedTablesToCreate);
  const createdJoinedTables = await createTablesWithApi(joinedTablesToCreate);
  return [
    [...createdNormalTables[0], ...createdJoinedTables[0]],
    [...createdNormalTables[1], ...createdJoinedTables[1]]
  ];
};
const updateAreas = async (areaState) => {
  if (isEmpty(areaState.updated)) {
    return [[], []];
  }
  const updateAreaPromises = areaState.updated.map((areaId) => {
    const area = findObjectByProperty(areaState.data, areaId, "id");
    const updatedAreaData = convertDataForApi$5(area);
    const postData = {
      area: updatedAreaData,
      areaId
    };
    return {
      request: () => updateObeeArea(postData),
      handleResponse: (response) => ({
        ...response,
        // data: response?.response?.data?.deleteTable,
        id: areaId
      })
    };
  });
  const results2 = await createBatchedPromises(updateAreaPromises);
  const updatedAreas = results2.filter((area) => area.status === "success");
  const failedUpdateAreas = results2.filter((area) => area.status === "error");
  return [updatedAreas, failedUpdateAreas];
};
const updateTables = async (tableState, updatedTableIds, createdAreas, failedAreas) => {
  if (isEmpty(updatedTableIds)) {
    return [[], []];
  }
  const updatedTables = filterByProperty(tableState.data, updatedTableIds, "id");
  const failedAreaIds = flatten(failedAreas, "data.id");
  const updatedTablesWithAreas = filterByProperty(updatedTables, failedAreaIds, "areaId", true);
  const updateTablePromises = updatedTablesWithAreas.map((updatedTable) => {
    var _a, _b2;
    const newAreaId = ((_b2 = (_a = findObjectByProperty(createdAreas, updatedTable == null ? void 0 : updatedTable.areaId, "_tempId")) == null ? void 0 : _a.data) == null ? void 0 : _b2.id) || (updatedTable == null ? void 0 : updatedTable.areaId);
    const apiTable = findObjectByProperty(tableState.apiData, updatedTable == null ? void 0 : updatedTable.id, "id", {});
    const changes = diffObjects(updatedTable, apiTable);
    devLog("info", "changes", changes);
    const updatedTableData = convertDataForApi$4({ ...updatedTable, areaId: newAreaId });
    if (!("isPublic" in changes)) {
      delete updatedTableData.isPublic;
    }
    const postData = {
      table: updatedTableData,
      tableId: updatedTable == null ? void 0 : updatedTable.id
    };
    return {
      request: () => updateObeeTable(postData),
      handleResponse: (response) => ({
        ...response,
        data: response == null ? void 0 : response.data,
        // TODO check this
        id: updatedTable == null ? void 0 : updatedTable.id
      })
    };
  });
  const results2 = await createBatchedPromises(updateTablePromises);
  const successes = results2.filter((table) => table.status === "success");
  const failedUpdateTables = results2.filter((table) => table.status === "error");
  return [successes, failedUpdateTables];
};
const deleteAreas = async (areaState) => {
  if (isEmpty(areaState.deleted)) {
    return [[], []];
  }
  const deleteAreaPromises = areaState.deleted.map((areaId) => {
    const postData = {
      areaId
    };
    return {
      request: () => deleteObeeArea(postData),
      handleResponse: (response) => ({
        ...response,
        // data: response?.data?.deleteTable,
        id: areaId
      })
    };
  });
  const results2 = await createBatchedPromises(deleteAreaPromises);
  const deletedAreas = results2.filter((area) => area.status === "success");
  const failedDeletedAreas = results2.filter((area) => area.status === "error");
  return [deletedAreas, failedDeletedAreas];
};
const deleteTables = async (tableState) => {
  if (isEmpty(tableState.deleted)) {
    return [[], []];
  }
  const deleteTablePromises = tableState.deleted.map((tableId) => {
    const postData = {
      tableId
    };
    return {
      request: () => deleteObeeTable(postData),
      handleResponse: (response) => ({
        ...response,
        // data: response?.data?.deleteTable,
        id: tableId
      })
    };
  });
  const results2 = await createBatchedPromises(deleteTablePromises);
  const deletedTables = results2.filter((table) => table.status === "success");
  const failedDeleteTables = results2.filter((table) => table.status === "error");
  return [deletedTables, failedDeleteTables];
};
const updatePriorities = async (tableState, createdTables, updateData) => {
  if (isEmpty(updateData)) {
    return [[], []];
  }
  const updatedTablePriorities = updateData.map((updatedTable) => ({
    tableId: updatedTable == null ? void 0 : updatedTable.id,
    priority: updatedTable == null ? void 0 : updatedTable.priority
  }));
  const postData = { tablePriorities: updatedTablePriorities };
  const results2 = await updateTablePriorities(postData);
  devLog(
    "info",
    "UPDATE PRIORITY RESULTS",
    results2,
    updatedTablePriorities,
    updateData,
    tableState
  );
  const newPriorities = results2 == null ? void 0 : results2.data;
  return [newPriorities, results2 == null ? void 0 : results2.error];
};
const doTableBlock = async (blockDetails) => {
  if ((blockDetails == null ? void 0 : blockDetails.updateFlag) !== true) {
    return blockDetails;
  }
  if (!(blockDetails == null ? void 0 : blockDetails.id) && (blockDetails == null ? void 0 : blockDetails.removeFlag) === true) {
    return null;
  }
  if ((blockDetails == null ? void 0 : blockDetails.removeFlag) === true) {
    const postData2 = { tableBlockId: blockDetails.id };
    const results22 = await unblockTable(postData2);
    if (!(results22 == null ? void 0 : results22.data)) {
      return null;
    }
    const blockSuccess = JSON.parse(results22 == null ? void 0 : results22.data);
    return (blockSuccess == null ? void 0 : blockSuccess.status) === "success" ? null : blockDetails;
  }
  let results2 = null;
  if (blockDetails == null ? void 0 : blockDetails.id) {
    const postData2 = {
      tableBlockId: blockDetails == null ? void 0 : blockDetails.id,
      startTime: blockDetails == null ? void 0 : blockDetails.startTime,
      endTime: blockDetails == null ? void 0 : blockDetails.endTime
    };
    results2 = await updateTableBlock(postData2);
    return results2 == null ? void 0 : results2.data;
  }
  const postData = {
    tableId: blockDetails == null ? void 0 : blockDetails.tableId,
    date: blockDetails == null ? void 0 : blockDetails.date,
    startTime: blockDetails == null ? void 0 : blockDetails.startTime,
    endTime: blockDetails == null ? void 0 : blockDetails.endTime
  };
  results2 = await blockTable(postData);
  return results2 == null ? void 0 : results2.data;
};
const undoFloorplanUpdateAction = () => (dispatch) => {
  dispatch({
    type: `UNDO_UPDATE_OBEE_FLOORPLAN_LOCAL`
  });
};
const redoFloorplanUpdateAction = () => (dispatch) => {
  dispatch({
    type: `REDO_UPDATE_OBEE_FLOORPLAN_LOCAL`
  });
};
const handleError$1 = (dispatch, message, logItems = null) => {
  devLog("error", message, logItems);
  addMessage("UPDATE_OBEE_FLOORPLAN", dispatch, "error", message);
};
const saveFloorplanAction = (updatedFloorplan) => (dispatch) => {
  (async () => {
    var _a, _b2, _c2;
    try {
      beginAction("SAVE_FLOORPLAN", dispatch, {});
      const state = store$1 == null ? void 0 : store$1.getState();
      const tableState = state.tables;
      const areaState = state.areas;
      const [successAreas, failedAreas] = await createAreas(areaState);
      const [updatedAreas, failedUpdateAreas] = await updateAreas(areaState);
      const [deletedAreas, failedDeleteAreas] = await deleteAreas(areaState);
      let [successTables, failedTables] = await createTables(tableState, successAreas, failedAreas);
      const updatedTableChanges = diffObjectLists(tableState.data, tableState.apiData, "id", [
        "id"
      ]);
      const createdTables = (_a = filterByProperty(tableState.data, tableState.created, "id")) == null ? void 0 : _a.map(
        (table) => {
          var _a2;
          const successTable = (_a2 = findObjectByProperty(successTables, table == null ? void 0 : table._tempId, "_tempId")) == null ? void 0 : _a2.data;
          if (!isEmpty(successTable)) {
            return { ...successTable, priority: table == null ? void 0 : table.priority };
          }
          return table;
        }
      );
      const tablesWithPriorityUpdated = [...createdTables, ...updatedTableChanges].filter(
        (table) => !isVoid(table == null ? void 0 : table.priority)
      );
      const updatedTablesNoPriority = (_b2 = removeKeyFromObjects(updatedTableChanges, [
        "priority",
        "priorityChanged"
      ]).filter(
        (table) => Object.keys(table).length > 1
        // since the ID is still in there
      )) == null ? void 0 : _b2.map((table) => table == null ? void 0 : table.id);
      let [updatedTables, failedUpdateTables] = await updateTables(
        tableState,
        updatedTablesNoPriority,
        successAreas,
        failedAreas
      );
      const [deletedTables, failedDeleteTables] = await deleteTables(tableState);
      const tableIdMap = successTables.reduce((accum, table) => {
        return { ...accum, [table == null ? void 0 : table._tempId]: table.data.id };
      }, {});
      let priorityError = null;
      if (!isEmpty(tablesWithPriorityUpdated) && isEmpty(failedUpdateTables) && isEmpty(failedTables) && isEmpty(failedDeleteTables)) {
        const priorityTableState = (_c2 = store$1 == null ? void 0 : store$1.getState()) == null ? void 0 : _c2.tables;
        const [updatedPriorityTables, updatePriorityError] = await updatePriorities(
          priorityTableState,
          successTables,
          tablesWithPriorityUpdated
        );
        priorityError = updatePriorityError;
        if (isEmpty(updatePriorityError)) {
          const newPriorityIds = flatten(updatedPriorityTables, "id");
          const getPriorityForTable = (table) => {
            var _a2, _b3, _c3, _d2;
            if (newPriorityIds.includes((_a2 = table == null ? void 0 : table.data) == null ? void 0 : _a2.id)) {
              return (_c3 = findObjectByProperty(updatedPriorityTables, (_b3 = table == null ? void 0 : table.data) == null ? void 0 : _b3.id, "id")) == null ? void 0 : _c3.priority;
            }
            return (_d2 = table == null ? void 0 : table.data) == null ? void 0 : _d2.priority;
          };
          successTables = successTables == null ? void 0 : successTables.map((table) => {
            return {
              ...table,
              data: {
                ...table == null ? void 0 : table.data,
                priority: getPriorityForTable(table)
              }
            };
          });
          updatedTables = updatedTables == null ? void 0 : updatedTables.map((table) => {
            return {
              ...table,
              data: {
                ...table == null ? void 0 : table.data,
                priority: getPriorityForTable(table)
              }
            };
          });
        }
      }
      if (isEmpty(failedUpdateTables) && isEmpty(failedTables) && isEmpty(failedDeleteTables)) {
        const checkBlockStatus = async (table) => {
          const blockStatusForTable = tableState == null ? void 0 : tableState.data.find((tableToFind) => {
            return tableToFind.id === table.id && !isEmpty(tableToFind.blocks);
          });
          if (blockStatusForTable) {
            return await Promise.all(
              blockStatusForTable == null ? void 0 : blockStatusForTable.blocks.map(async (blockData) => {
                return await doTableBlock(blockData);
              })
            );
          }
          return false;
        };
        updatedTables = await Promise.all(
          updatedTables == null ? void 0 : updatedTables.map(async (table) => {
            const checkResults = await checkBlockStatus(table);
            return {
              ...table,
              data: {
                ...table == null ? void 0 : table.data,
                blocks: !isVoid(checkResults) ? checkResults : []
              }
            };
          })
        );
      }
      const areasChanged = !isEmpty(successAreas) || !isEmpty([...successTables, ...updatedTables, ...deletedTables]);
      if (areasChanged) {
        await updateAreaCapacity();
      }
      const areaIdMap = successAreas.reduce((accum, area) => {
        return { ...accum, [area == null ? void 0 : area._tempId]: area.data.id };
      }, {});
      const updatedFloorplanAreas = updatedFloorplan.areas.map((floorplanArea) => {
        var _a2;
        if ((_a2 = Object.keys(areaIdMap)) == null ? void 0 : _a2.includes(floorplanArea == null ? void 0 : floorplanArea.originalId)) {
          return {
            id: areaIdMap[floorplanArea == null ? void 0 : floorplanArea.originalId],
            type: floorplanArea == null ? void 0 : floorplanArea.type,
            x: floorplanArea == null ? void 0 : floorplanArea.x,
            y: floorplanArea == null ? void 0 : floorplanArea.y,
            levelId: floorplanArea == null ? void 0 : floorplanArea.levelId,
            points: floorplanArea == null ? void 0 : floorplanArea.points,
            originalId: floorplanArea == null ? void 0 : floorplanArea.originalId
          };
        }
        return floorplanArea;
      });
      const updatedFloorplanTables = updatedFloorplan.tables.map((floorplanTable) => {
        var _a2;
        if ((_a2 = Object.keys(tableIdMap)) == null ? void 0 : _a2.includes(floorplanTable == null ? void 0 : floorplanTable.originalId)) {
          return {
            id: tableIdMap[floorplanTable == null ? void 0 : floorplanTable.originalId],
            type: floorplanTable == null ? void 0 : floorplanTable.type,
            rotation: floorplanTable == null ? void 0 : floorplanTable.rotation,
            scale: floorplanTable == null ? void 0 : floorplanTable.scale,
            x: floorplanTable == null ? void 0 : floorplanTable.x,
            y: floorplanTable == null ? void 0 : floorplanTable.y,
            originalId: floorplanTable == null ? void 0 : floorplanTable.originalId
          };
        }
        return floorplanTable;
      });
      const newFloorplan = {
        ...updatedFloorplan,
        width: updatedFloorplan == null ? void 0 : updatedFloorplan.width,
        height: updatedFloorplan == null ? void 0 : updatedFloorplan.height,
        levels: updatedFloorplan == null ? void 0 : updatedFloorplan.levels,
        elements: updatedFloorplan == null ? void 0 : updatedFloorplan.elements,
        areas: updatedFloorplanAreas,
        tables: updatedFloorplanTables
      };
      const changedValues = {
        areas: {
          created: successAreas,
          updated: updatedAreas,
          deleted: deletedAreas
        },
        tables: {
          created: successTables,
          updated: updatedTables,
          deleted: deletedTables
        }
      };
      let hasFailed = false;
      const allFailedAreas = [...failedAreas, ...failedUpdateAreas, ...failedDeleteAreas];
      if (!isEmpty(allFailedAreas)) {
        hasFailed = true;
        handleError$1(dispatch, `Some areas failed to save`, allFailedAreas);
      }
      const allFailedTables = [...failedTables, ...failedUpdateTables, ...failedDeleteTables];
      if (!isEmpty(allFailedTables)) {
        hasFailed = true;
        handleError$1(dispatch, `Some tables failed to save`, allFailedTables);
      }
      if (!isEmpty(priorityError)) {
        hasFailed = true;
        handleError$1(dispatch, `Failed to update table priorities ${priorityError}`, priorityError);
      }
      await dispatch(updateFloorplanAction(newFloorplan, changedValues, !hasFailed));
    } catch (error) {
      console.error(error);
    } finally {
      endAction("SAVE_FLOORPLAN", dispatch);
    }
  })();
};
const fullyBookedSessionPropTypes = PropTypes.shape({
  areaId: PropTypes.number,
  name: PropTypes.string,
  capacity: PropTypes.number,
  sessionId: PropTypes.number,
  label: PropTypes.string,
  openingTime: PropTypes.number,
  closingTime: PropTypes.number,
  fullyBooked: PropTypes.bool,
  fullyBookedBId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
const fullyBookedSessionsPropTypes = getEntityPropTypes(fullyBookedSessionPropTypes);
const OBFullyBookedCreateInput = () => ["areaId", "capacity", "openingTime", "closingTime"];
const OBFullyBookedDeleteInput = () => ["areaId", "fullyBookedBId"];
const getFullyBookedSessionForTable = (fullyBookedSessions, sessionFilter, table, currentTimeAsInt) => fullyBookedSessions.find((fullyBookedSession) => {
  if (sessionFilter === "all_sessions") {
    return fullyBookedSession.areaId === (table == null ? void 0 : table.areaId) && fullyBookedSession.fullyBooked && isBetween(currentTimeAsInt, fullyBookedSession.openingTime, fullyBookedSession.closingTime);
  }
  return fullyBookedSession.areaId === (table == null ? void 0 : table.areaId) && fullyBookedSession.fullyBooked && sessionFilter === fullyBookedSession.label;
});
const isAreaFullyBookedAtTime = (area, fullyBookedSessions, time) => {
  const fullyBookedSessionExists = fullyBookedSessions.some(
    (fullyBookedSession) => area.id === fullyBookedSession.areaId && fullyBookedSession.fullyBooked && time >= fullyBookedSession.openingTime && time < fullyBookedSession.closingTime
  );
  return fullyBookedSessionExists;
};
const fetchFullyBookedSessionsAction = (date) => (dispatch) => {
  const action = "FETCH_FULLY_BOOKED_SESSIONS";
  const entityName = "obeeFullyBookedSessions";
  const data = { date: formatDate(date, "YYYY-MM-DD") };
  const errorMessage = "Unable to retrieve fully booked sessions";
  const request = () => fetchFullyBookedSessions(data);
  dispatch(makeApiAction(action, request, {}, entityName, null, {}, false, errorMessage));
};
const handleError = (error, action, entityName, message, dispatch) => {
  devLog("error", entityName, error);
  addMessage(action, dispatch, "error", message);
};
const bulkUpdateFullyBookedSessionsAction = (date, addSessions, removeSessions) => (dispatch) => {
  const action = "BULK_UPDATE_FULLY_BOOKED_SESSIONS";
  const entityName = "bulkUpdateFullyBookedSessions";
  const dateFormatted = formatDate(date, "YYYY-MM-DD");
  const addData = {
    date: dateFormatted,
    sessions: uniqueObjects(only(addSessions, OBFullyBookedCreateInput()))
  };
  const removeData = {
    date: dateFormatted,
    sessions: uniqueObjects(only(removeSessions, OBFullyBookedDeleteInput()))
  };
  const successMessage = "Updated fully booked areas and sessions successfully";
  const errorMessage = "Unable to update fully booked sessions";
  (async () => {
    try {
      const tempId = generateRandomString(8);
      beginAction(action, dispatch, {}, tempId);
      const state = store$1 == null ? void 0 : store$1.getState();
      const fullyBookedSessionsState = state.fullyBookedSessions;
      let { data } = fullyBookedSessionsState;
      let hasFailed = false;
      if (addData.sessions.length > 0) {
        const response = await createFullyBookedSessions(addData);
        if (response == null ? void 0 : response.error) {
          hasFailed = true;
          handleError(
            response == null ? void 0 : response.error,
            action,
            "createFullyBookedSessions",
            "Unable to create fully booked sessions",
            dispatch
          );
        } else {
          devLog("success", "createFullyBookedSessions", response);
          data = response.data;
        }
      }
      if (removeData.sessions.length > 0) {
        const response = await deleteFullyBookedSessions(removeData);
        if (response == null ? void 0 : response.error) {
          hasFailed = true;
          handleError(
            response == null ? void 0 : response.error,
            action,
            "deleteFullyBookedSessions",
            "Unable to delete fully booked sessions",
            dispatch
          );
        } else {
          devLog("success", "deleteFullyBookedSessions", response);
          data = response.data;
        }
      }
      handleResponse({ data }, action, entityName, dispatch, tempId);
      if (!hasFailed) {
        addMessage(action, dispatch, "success", successMessage);
      }
    } catch (error) {
      handleFailure(error, action, entityName, errorMessage, null, dispatch);
    } finally {
      endAction(action, dispatch);
    }
  })();
};
const fetchObeeBookingsAction = (date, skipLoading = false) => (dispatch) => {
  const action = "FETCH_OBEE_BOOKINGS";
  const entityName = "obeeBookings";
  const errorMessage = "Unable to retrieve bookings";
  const data = {
    date: formatDate(date, "YYYY-MM-DD")
  };
  const request = () => fetchObeeBookings(data);
  dispatch(
    makeApiAction(action, request, {}, entityName, null, {}, skipLoading, errorMessage, true)
  );
};
const createObeeBookingAction = (obeeBooking) => (dispatch) => {
  const action = "CREATE_OBEE_BOOKING";
  const entityName = "createObeeBooking";
  const data = {
    booking: obeeBooking
  };
  const successMessage = `${data.booking.source === "walkin" ? "Walk-in" : "Booking"} has been successfully added on ${formatDate(
    data.booking.date,
    "dddd Do MMM"
  )} at ${minutesToTimeString(data.booking.time, "h:mma")}`;
  const errorMessage = `Unable to add ${data.booking.source === "walkin" ? "walk-in" : "booking"}.`;
  const request = () => createObeeBooking(data);
  dispatch(
    makeApiAction(action, request, {}, entityName, successMessage, null, false, errorMessage)
  );
};
const resubmitBookingAction = (obeeBooking, bookingId) => (dispatch) => {
  const action = "CREATE_OBEE_BOOKING";
  const entityName = "resubmitBooking";
  const data = {
    bookingPayment: obeeBooking,
    bookingId
  };
  const successMessage = `Booking has been successfully added`;
  const errorMessage = `Unable to add booking`;
  const request = () => resubmitBooking(data);
  dispatch(
    makeApiAction(action, request, {}, entityName, successMessage, null, false, errorMessage)
  );
};
const updateObeeBookingAction = (obeeBooking) => (dispatch) => {
  if (obeeBooking === null) {
    return;
  }
  const action = "UPDATE_OBEE_BOOKING";
  const entityName = "updateObeeBooking";
  const data = {
    bookingId: obeeBooking.id,
    booking: obeeBooking
  };
  const successMessage = `${data.booking.source === "walkin" ? "Walk-in" : "Booking"} has been successfully updated`;
  const errorMessage = `Unable to update ${data.booking.source === "walkin" ? "walk-in" : "booking"}`;
  const request = () => updateObeeBooking(data);
  dispatch(
    makeApiAction(
      action,
      request,
      obeeBooking,
      entityName,
      successMessage,
      null,
      false,
      errorMessage
    )
  );
};
const updateCheckAction = (bookingId, areaId, date, time, size, tableNumber, duration, isPublic) => (dispatch) => {
  const action = "UPDATE_CHECK";
  const entityName = "obeeBookingUpdateCheck";
  const successMessage = null;
  const errorMessage = "Unable to check whether this booking is available";
  const data = {
    bookingId,
    areaId,
    date: formatDate(date, "YYYY-MM-DD"),
    time,
    size,
    tableNumber,
    duration,
    public: isPublic
  };
  const request = () => checkBookingUpdate(data);
  dispatch(
    makeApiAction(action, request, {}, entityName, successMessage, {}, false, errorMessage)
  );
};
const clearUpdateCheckAction = () => (dispatch) => {
  dispatch({
    type: `CLEAR_UPDATE_CHECK`
  });
};
const fetchObeeBookingsForUserAction = (userId, skipLoading = false) => (dispatch) => {
  const action = "FETCH_OBEE_BOOKINGS_FOR_USER";
  const entityName = "obeeBookingsForUser";
  const request = () => fetchBookingByUserId(userId);
  dispatch(makeApiAction(action, request, {}, entityName, null, { userId }, skipLoading));
};
const confirmWaitlistAction = (bookingId) => (dispatch) => {
  const action = "CONFIRM_WAITLIST";
  const entityName = "confirmWaitlist";
  const data = {
    bookingId
  };
  const successMessage = `Booking has been successfully updated`;
  const errorMessage = `Unable to confirm the waitlist. Please try editing the waitlist booking and setting the table`;
  const request = () => confirmWaitlist(data);
  dispatch(
    makeApiAction(action, request, {}, entityName, successMessage, null, false, errorMessage)
  );
};
const confirmWaitlistAsBookedAction = (bookingId) => (dispatch) => {
  const action = "CONFIRM_WAITLIST_AS_BOOKED";
  const entityName = "confirmWaitlistAsBooked";
  const data = {
    bookingId
  };
  const successMessage = `Booking has been successfully updated`;
  const errorMessage = `Unable to book the waitlist booking. Please try again`;
  const request = () => confirmWaitlistAsBooked(data);
  dispatch(
    makeApiAction(action, request, {}, entityName, successMessage, null, false, errorMessage)
  );
};
const sendWaitlistSMSAction = (bookingId, inHowLong) => (dispatch) => {
  const action = "SEND_WAITLIST_SMS";
  const entityName = "sendWaitlistSMS";
  const data = {
    bookingId,
    inHowLong
  };
  const successMessage = `SMS has successfully been sent`;
  const errorMessage = `Unable to send SMS. Please try again`;
  const request = () => sendWaitlistSMS(data);
  dispatch(
    makeApiAction(action, request, {}, entityName, successMessage, data, false, errorMessage)
  );
};
const sendGuestEmailAction = (bookingId, emailType) => async (dispatch) => {
  const action = "SEND_GUEST_EMAIL";
  const entityName = "sendGuestEmail";
  const data = {
    bookingId,
    emailType
  };
  const successMessage = `Email has successfully been sent`;
  const errorMessage = `Unable to send email. Please try again`;
  const request = () => sendGuestEmail(data);
  await dispatch(
    makeApiAction(action, request, {}, entityName, successMessage, data, false, errorMessage)
  );
};
const sendGuestSMSAction = (bookingId, smsType) => async (dispatch) => {
  const action = "SEND_GUEST_SMS";
  const entityName = "sendGuestSMS";
  const data = {
    bookingId,
    smsType
  };
  const successMessage = `SMS has successfully been sent`;
  const errorMessage = `Unable to send SMS. Please try again`;
  const request = () => sendGuestSMS(data);
  await dispatch(
    makeApiAction(action, request, {}, entityName, successMessage, data, false, errorMessage)
  );
};
const chargeNoShowAction = (booking) => (dispatch) => {
  var _a;
  const action = "CHARGE_NO_SHOW";
  const entityName = "chargeNoShow";
  const successMessage = "No-show fee charged";
  const errorMessage = "No-show fee charge request failed";
  const data = {
    ...isObee() ? {
      obBookingId: booking.id,
      charge: {
        areaId: booking.areaId,
        amount: booking.ccNoShowFee,
        date: booking.date,
        time: booking.time,
        size: booking.size,
        userEmail: (_a = booking.guests[0]) == null ? void 0 : _a.email,
        includeGST: true
      }
    } : { obBookingId: booking.id }
  };
  const request = () => chargeNoShow(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      successMessage,
      { obBookingId: booking.id },
      false,
      errorMessage
    )
  );
};
const clearChargeNoShowAction = () => (dispatch) => {
  dispatch({
    type: `CLEAR_CHARGE_NO_SHOW`
  });
};
const fetchGlobalSessionsAction = () => (dispatch) => {
  const action = "FETCH_OBEE_GLOBAL_SESSIONS";
  const data = {};
  const entityName = "obeeGlobalSessions";
  const request = () => fetchObeeGlobalSessions(data);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const createGlobalSessionAction = (sessionData) => (dispatch) => {
  const action = "CREATE_OBEE_GLOBAL_SESSION";
  const newSessionData = only(sessionData, globalSessionInputKeys());
  const successMessage = "Session created successfully";
  const errorMessage = "Unable to create session";
  const data = {
    session: newSessionData
  };
  const entityName = "createGlobalSession";
  const request = () => createObeeGlobalSession(data);
  dispatch(makeApiAction(action, request, {}, entityName, successMessage, {}, false, errorMessage));
};
const updateGlobalSessionAction = (updatedSession) => (dispatch) => {
  const action = "UPDATE_OBEE_GLOBAL_SESSION";
  const newSessionData = only(updatedSession, globalSessionUpdateInputKeys());
  const successMessage = "Session updated successfully";
  const errorMessage = "Unable to update session";
  const data = {
    sessionId: updatedSession.objectId,
    session: newSessionData
  };
  const entityName = "updateGlobalSession";
  const request = () => updateObeeGlobalSession(data);
  dispatch(
    makeApiAction(
      action,
      request,
      { ...newSessionData, objectId: updatedSession.objectId },
      entityName,
      successMessage,
      {},
      false,
      errorMessage
    )
  );
};
const deleteGlobalSessionAction = (deletedSessionId) => (dispatch) => {
  const action = "DELETE_OBEE_GLOBAL_SESSION";
  const data = {
    sessionId: deletedSessionId
  };
  const returnValues = {
    objectId: deletedSessionId
  };
  const successMessage = "Session deleted successfully";
  const errorMessage = "Unable to delete session";
  const entityName = "deleteGlobalSession";
  const request = () => deleteObeeGlobalSession(data);
  dispatch(
    makeApiAction(
      action,
      request,
      returnValues,
      entityName,
      successMessage,
      returnValues,
      false,
      errorMessage
    )
  );
};
const fetchEventSessionsAction = () => (dispatch) => {
  const action = "FETCH_OBEE_EVENT_SESSIONS";
  const data = {};
  const entityName = "obeeEventSessions";
  const request = () => fetchObeeEventSessions(data);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const createEventSessionAction = (sessionData) => (dispatch) => {
  const action = "CREATE_OBEE_EVENT_SESSION";
  const newSessionData = only(sessionData, eventSessionInputKeys());
  const successMessage = "Event created successfully";
  const errorMessage = "Unable to create event";
  const data = {
    session: newSessionData
  };
  const entityName = "createEventSession";
  const request = () => createObeeEventSession(data);
  dispatch(makeApiAction(action, request, {}, entityName, successMessage, {}, false, errorMessage));
};
const updateEventSessionAction = (updatedSession) => (dispatch) => {
  const action = "UPDATE_OBEE_EVENT_SESSION";
  const newSessionData = only(updatedSession, eventSessionUpdateInputKeys());
  const successMessage = "Event updated successfully";
  const errorMessage = "Unable to update event";
  const data = {
    sessionId: updatedSession.objectId,
    session: newSessionData
  };
  const entityName = "updateEventSession";
  const request = () => updateObeeEventSession(data);
  dispatch(
    makeApiAction(
      action,
      request,
      { ...newSessionData, objectId: updatedSession.objectId },
      entityName,
      successMessage,
      {},
      false,
      errorMessage
    )
  );
};
const deleteEventSessionAction = (deletedSessionId) => (dispatch) => {
  const action = "DELETE_OBEE_EVENT_SESSION";
  const data = {
    sessionId: deletedSessionId
  };
  const returnValues = {
    objectId: deletedSessionId
  };
  const successMessage = "Event deleted successfully";
  const errorMessage = "Unable to delete event";
  const entityName = "deleteEventSession";
  const request = () => deleteObeeEventSession(data);
  dispatch(
    makeApiAction(
      action,
      request,
      returnValues,
      entityName,
      successMessage,
      returnValues,
      false,
      errorMessage
    )
  );
};
const fetchSessionsAction = () => (dispatch) => {
  const action = "FETCH_OBEE_SESSIONS";
  const entityName = "obeeSessions";
  const request = () => fetchObeeSessions();
  dispatch(makeApiAction(action, request, {}, entityName));
};
const updateSessionAction = (updatedSession) => (dispatch) => {
  const action = "UPDATE_OBEE_SESSION";
  const entityName = "updateSession";
  const successMessage = "Session updated successfully";
  const errorMessage = "Unable to update session";
  const newSessionData = only(updatedSession, sessionUpdateInputKeys());
  const data = {
    session: newSessionData,
    sessionId: `${updatedSession.id}`
  };
  const request = () => updateObeeSession(data);
  dispatch(makeApiAction(action, request, {}, entityName, successMessage, {}, false, errorMessage));
};
const createSessionAction = (sessionData) => (dispatch) => {
  const createdSession = only(sessionData, sessionInputKeys());
  const action = "CREATE_OBEE_SESSION";
  const entityName = "createSession";
  const successMessage = "Session created successfully";
  const errorMessage = "Unable to create session";
  const data = {
    session: createdSession
  };
  const request = () => createObeeSession(data);
  dispatch(makeApiAction(action, request, {}, entityName, successMessage, {}, false, errorMessage));
};
const deleteSessionAction = (deletedSessionId) => (dispatch) => {
  const action = "DELETE_OBEE_SESSION";
  const entityName = "deleteSession";
  const successMessage = "Session deleted successfully";
  const errorMessage = "Unable to delete session";
  const data = {
    sessionId: deletedSessionId
  };
  const returnValues = {
    id: deletedSessionId
  };
  const request = () => deleteObeeSession(data);
  dispatch(
    makeApiAction(
      action,
      request,
      returnValues,
      entityName,
      successMessage,
      returnValues,
      false,
      errorMessage
    )
  );
};
const fetchSettingsAction = () => (dispatch) => {
  const action = "FETCH_OBEE_SETTINGS";
  const entityName = "fetchObeeSettings";
  const data = {};
  const request = () => fetchObeeSettings(data);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const updateSettingsAction = (settings) => (dispatch) => {
  const action = "UPDATE_OBEE_SETTING";
  const entityName = "saveObeeSettings";
  const data = { settings: only(settings, OBSettingsInputKeys()) };
  const successMessage = "Settings successfully updated";
  const errorMessage = "Unable to update settings";
  const request = () => updateObeeSettings(data);
  dispatch(
    makeApiAction(action, request, settings, entityName, successMessage, null, false, errorMessage)
  );
};
const fetchTablesAction = (date = null, skipLoading = false) => (dispatch) => {
  const action = "FETCH_OBEE_TABLES";
  const entityName = "obeeTables";
  const data = {
    date: date ? formatDate(date, "YYYY-MM-DD") : null
  };
  const request = () => fetchObeeTables(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      null,
      {},
      skipLoading,
      "Unable to retrieve tables",
      true
    )
  );
};
const blockTableAction = (table, date, endTime, startTime = null) => (dispatch) => {
  const action = "BLOCK_OBEE_TABLE";
  const entityName = "blockTable";
  const data = {
    tableId: table.id,
    date,
    endTime,
    startTime
  };
  const request = () => blockTable(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      `Table ${table.tableNumber} blocked successfully`,
      {},
      false,
      `Unable to block table ${table.tableNumber}`
    )
  );
};
const unblockTableAction = (table, tableBlockId) => (dispatch) => {
  const action = "UNBLOCK_OBEE_TABLE";
  const entityName = "unblockTable";
  const data = {
    tableBlockId
  };
  const request = () => unblockTable(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      `Table ${table.tableNumber} unblocked successfully`,
      {
        tableId: table.id,
        tableBlockId
      },
      false,
      `Unable to unblock table ${table.tableNumber}`
    )
  );
};
const editTableBlockAction = (table, tableBlockId, endTime, startTime = null) => (dispatch) => {
  const action = "EDIT_BLOCK_OBEE_TABLE";
  const entityName = "editTableBlock";
  const data = {
    tableBlockId,
    startTime,
    endTime
  };
  const request = () => updateTableBlock(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      `Table ${table.tableNumber} block updated successfully`,
      {
        tableId: table.id,
        tableBlockId
      },
      false,
      `Unable to update block for table ${table.tableNumber}`
    )
  );
};
const getNewTable = (minSeats, maxSeats, areaId, tableNumber, notes = null, otherData = {}) => {
  const tables = store$1.getState().tables.data;
  return {
    ...getDefaultValues(tableNumber),
    tableNumber,
    notes,
    // tableName: `${name}`,
    areaId,
    minSeats,
    maxSeats,
    priority: tables.length,
    // This table is the lowest priority
    ...otherData
  };
};
const createLocalTableAction = ({ minSeats, maxSeats, areaId, tableNumber, notes, ...otherData }, tempId = null) => (dispatch) => {
  const newTable = getNewTable(minSeats, maxSeats, areaId, tableNumber, notes, otherData);
  dispatch(createLocalItem(getData$8(newTable), "OBEE_TABLE", tempId));
};
const createLocalTablesAction = (tables, tempId = null) => (dispatch) => {
  const newTables = tables.map((table, index) => {
    const newTable = getNewTable(
      table == null ? void 0 : table.minSeats,
      table == null ? void 0 : table.maxSeats,
      table == null ? void 0 : table.areaId,
      table == null ? void 0 : table.tableNumber,
      table == null ? void 0 : table.notes,
      table
    );
    return { ...newTable, priority: newTable.priority + index };
  });
  dispatch(createLocalItems(newTables, "OBEE_TABLES", tempId));
};
const getUpdatedTables = (updatedTables) => {
  const tableState = store$1.getState().tables;
  const tablesWithChangedNumbers = updatedTables.map((table) => {
    const dataTable = getLocalItem(table, tableState, "id");
    return {
      oldTableNumber: dataTable.tableNumber,
      newTableNumber: table.tableNumber
    };
  }).filter((table) => {
    return !isVoid(table.oldTableNumber) && !isVoid(table.newTableNumber) && table.oldTableNumber !== (table == null ? void 0 : table.newTableNumber);
  });
  const updatedTableList = tableState.data.map((tableToCheck) => {
    const updatedTable = updatedTables.find(
      (updatedTableToFind) => tableToCheck.id === updatedTableToFind.id
    );
    if (!isEmpty(updatedTable)) {
      return updatedTable;
    }
    if (!tableToCheck.isJoin || isEmpty(tablesWithChangedNumbers)) {
      return null;
    }
    const tableNumbers = tableToCheck.tableNumber.split(",");
    tablesWithChangedNumbers.forEach((tableWithChangedNumber) => {
      if (tableNumbers.includes(tableWithChangedNumber.oldTableNumber)) {
        tableNumbers[tableNumbers.indexOf(tableWithChangedNumber.oldTableNumber)] = tableWithChangedNumber.newTableNumber;
      }
    });
    const updatedTableNumber = tableNumbers.sort(sortAlphaNumeric).join(",");
    if (updatedTableNumber === tableToCheck.tableNumber) {
      return null;
    }
    return {
      ...tableToCheck,
      tableNumbers,
      tableNumber: updatedTableNumber
    };
  }).filter((table) => table !== null);
  return updatedTableList;
};
const updateLocalTableAction = (updatedTable) => (dispatch) => {
  const allUpdatedTables = getUpdatedTables([updatedTable]);
  dispatch({
    type: "UPDATE_LOCAL_OBEE_TABLES",
    payload: allUpdatedTables
  });
};
const bulkUpdateLocalTablesAction = (updatedTables) => (dispatch) => {
  if (isEmpty(updatedTables)) {
    return;
  }
  const allUpdatedTables = getUpdatedTables(updatedTables);
  dispatch({
    type: "UPDATE_LOCAL_OBEE_TABLES",
    payload: allUpdatedTables
  });
};
const refreshLocalTablePriorities = (remainingTables, tableState) => (dispatch) => {
  const remainingTablesByPriority = sortListByProperty(remainingTables, "priority");
  const newRemainingTables = getRefreshedTablePriorities(remainingTablesByPriority, tableState);
  const changedTables = newRemainingTables.filter((table) => table.priorityChanged);
  dispatch(bulkUpdateLocalTablesAction(changedTables));
};
const deleteLocalTablesAction = (deletedTableIds) => (dispatch) => {
  const tableState = store$1.getState().tables;
  const tables = tableState.data;
  let tablesToDelete = deletedTableIds;
  const deletedTableNumbers = tables.filter((table) => deletedTableIds.includes(table.id)).map((table) => table.tableNumber);
  const keptTables = tables.filter((table) => !deletedTableIds.includes(table.id));
  const counts = {};
  keptTables.map((table) => table.tableNumber).forEach((tableNumber) => {
    counts[tableNumber] = counts[tableNumber] ? counts[tableNumber] + 1 : 1;
  });
  let joinsToDelete = [];
  deletedTableNumbers.forEach((tableNumber) => {
    if (isVoid(counts == null ? void 0 : counts[tableNumber]) || (counts == null ? void 0 : counts[tableNumber]) <= 1) {
      joinsToDelete = [
        ...joinsToDelete,
        ...tables.filter(
          (table) => table.tableNumbers.length > 1 && table.tableNumbers.includes(tableNumber)
        ).map((table) => table.id)
      ];
    }
  });
  tablesToDelete = [...tablesToDelete, ...joinsToDelete];
  const remainingTables = tables.filter((table) => !tablesToDelete.includes(table.id));
  dispatch(refreshLocalTablePriorities(remainingTables, tableState));
  dispatch({
    type: "DELETE_LOCAL_OBEE_TABLES",
    payload: tablesToDelete
  });
};
const useActions = (actions, deps) => {
  const dispatch = useDispatch();
  return useMemo(
    () => {
      if (Array.isArray(actions)) {
        return actions.map((a) => bindActionCreators(a, dispatch));
      }
      return bindActionCreators(actions, dispatch);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps ? [dispatch, ...deps] : [dispatch]
  );
};
const useRefetchBookings = () => {
  const dispatchData = useActions({
    fetchTables: fetchTablesAction,
    fetchObeeBookings: fetchObeeBookingsAction,
    fetchFullyBookedSessions: fetchFullyBookedSessionsAction
  });
  return useCallback((date) => {
    dispatchData.fetchTables(date);
    dispatchData.fetchObeeBookings(date);
    dispatchData.fetchFullyBookedSessions(date);
  }, []);
};
const useFetchBookingsData = () => {
  const isFirstRender = useRef(true);
  const dispatchData = useActions({
    fetchAreas: fetchAreasAction,
    fetchTables: fetchTablesAction,
    fetchObeeBookings: fetchObeeBookingsAction,
    fetchFloorplan: fetchFloorplanAction,
    fetchSessions: fetchSessionsAction,
    fetchFullyBookedSessions: fetchFullyBookedSessionsAction,
    fetchObeeSettings: fetchSettingsAction
  });
  const stateData = useSelector((state) => ({
    areas: state.areas,
    tables: state.tables,
    obeeBookings: state.obeeBookings,
    date: state.obeeScreen.date,
    floorplan: state.floorplan,
    obeeSessions: state.obeeSessions,
    obeeSettings: state.obeeSettings,
    fullyBookedSessions: state.fullyBookedSessions,
    restId: state.restaurantActive.restaurant.objectId
  }));
  const { date, restId } = stateData;
  const initialDataLoading = useFetchOnFirstRender(
    [
      dispatchData.fetchAreas,
      dispatchData.fetchSessions,
      // Fetched from the header
      dispatchData.fetchObeeSettings,
      dispatchData.fetchFloorplan
      // Only floorplan fetches this
    ],
    [stateData.areas, stateData.obeeSessions, stateData.obeeSettings, stateData.floorplan]
  );
  const bookingsDataLoading = useFetchOnFirstRender(
    [
      dispatchData.fetchTables,
      dispatchData.fetchObeeBookings,
      dispatchData.fetchFullyBookedSessions
    ],
    [stateData.tables, stateData.obeeBookings, stateData.fullyBookedSessions],
    [restId, date],
    false,
    true,
    [date]
  );
  const hasCompletedLoad = !(initialDataLoading || bookingsDataLoading);
  const dateAsString = formatDate(date);
  useEffect(() => {
    if (date && restId && hasCompletedLoad && !isFirstRender.current) {
      dispatchData.fetchTables(date);
      dispatchData.fetchObeeBookings(date);
      dispatchData.fetchFullyBookedSessions(date);
    }
    isFirstRender.current = false;
  }, [dateAsString, restId]);
  const pollSeconds = 60;
  useInterval(() => {
    if (date && restId) {
      devLog("info", "fetching bookings once per minute");
      dispatchData.fetchObeeBookings(date, true);
      dispatchData.fetchTables(date, true);
    }
  }, 1e3 * pollSeconds);
  return !hasCompletedLoad || stateData.obeeSessions.pending || // sessions are fetched from the header
  stateData.tables.pending || stateData.fullyBookedSessions.pending;
};
const setObeeDateAction = (newDate) => (dispatch) => {
  if (newDate) {
    sessionStorage.setItem("date", formatDate(newDate, "YYYY-MM-DD"));
    sessionStorage.setItem("dateSetOn", formatDate(/* @__PURE__ */ new Date(), "YYYY-MM-DD"));
  }
  dispatch({
    type: SET_OBEE_DATE,
    payload: newDate
  });
};
const setSessionFilterAction = (newSessionFilter) => (dispatch) => {
  dispatch({
    type: SET_SESSION_FILTER,
    payload: newSessionFilter
  });
};
const setFloorplanViewAction = (newFloorplanView) => (dispatch) => {
  dispatch({
    type: SET_FLOORPLAN_VIEW,
    payload: newFloorplanView
  });
};
const setObeeShowAddBookingModalAction = (show, quickBooking = null, preventChanges = false, defaultDate = null) => (dispatch) => {
  dispatch({
    type: SET_OBEE_SHOW_ADD_BOOKING_MODAL,
    payload: { show, quickBooking: show ? quickBooking : null, preventChanges, defaultDate }
    // NOTE: Remove quickBooking on close
  });
};
const setObeeBookingDetailsModalAction = (bookingId, defaultTab = "booking", newBookingStatus = null) => (dispatch) => {
  dispatch({
    type: SET_OBEE_BOOKING_DETAILS_MODAL,
    payload: { bookingId, defaultTab, newBookingStatus }
  });
};
const setShowDailyNotesModalAction = (show) => (dispatch) => {
  dispatch({
    type: SET_SHOW_DAILY_NOTES_MODAL,
    payload: show
  });
};
const setRunSheetDisplayModeAction = (displayMode) => (dispatch) => {
  dispatch({
    type: SET_RUNSHEET_DISPLAY_MODE,
    payload: displayMode
  });
};
const setRunSheetDisplayOverviewAction = (overview) => (dispatch) => {
  dispatch({
    type: SET_RUNSHEET_DISPLAY_OVERVIEW,
    payload: overview
  });
};
const setRunSheetTimeSeparatorAction = (timeSeparator) => (dispatch) => {
  dispatch({
    type: SET_RUNSHEET_TIME_SEPARATOR,
    payload: timeSeparator
  });
};
const setCalendarMonthAction = (newDate) => (dispatch) => {
  dispatch({
    type: SET_CALENDAR_MONTH,
    payload: newDate
  });
};
const setRunSheetTimeSeparatorIntervalAction = (newValue) => (dispatch) => {
  dispatch({
    type: SET_RUNSHEET_TIME_SEPARATOR_INTERVAL,
    payload: newValue
  });
};
const useStyles$1X = createUseStyles(
  (theme2) => ({
    dailyNote: {
      marginTop: "-16px",
      padding: "8px 28px 8px 12px",
      borderRadius: "12px",
      backgroundColor: theme2.colors.lightShade,
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      color: theme2.colors.charcoal,
      fontSize: "14px",
      maxHeight: "72px",
      whiteSpace: "pre-wrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      minWidth: "140px",
      flexGrow: 0,
      flexShrink: 1,
      cursor: "pointer",
      [theme2.breakpoints.down("md")]: {
        marginTop: "-8px",
        maxHeight: "60px"
      },
      "&:hover": {
        backgroundColor: theme2.colors.linenDark
      }
    },
    noteIconBackground: {
      width: "32px",
      height: "32px",
      flexShrink: 0,
      borderRadius: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme2.colors.linen
    },
    dailyNoteText: {
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    dailyNoteTitle: {
      fontWeight: theme2.fontWeights.medium,
      maxWidth: "100px",
      maxHeight: "54px",
      lineHeight: "18px",
      overflow: "hidden",
      whiteSpace: "pre-wrap",
      textOverflow: "ellipsis"
    },
    dailyNoteMessage: {
      paddingLeft: "8px",
      maxHeight: "54px",
      lineHeight: "18px",
      overflow: "hidden",
      maxWidth: "580px",
      whiteSpace: "pre-wrap",
      textOverflow: "ellipsis"
    }
  }),
  { name: "NotePreviewBig" }
);
const SvgDailyNotes = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 23 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M4.8218 3.67383L2.27318 18.5878L18.8168 22.9998L21.1503 14.324", stroke: "black" }), /* @__PURE__ */ React$7.createElement("rect", { x: 4.95193, y: 3.43848, width: 17.4531, height: 16.6319, fill: "currentColor", stroke: "black" }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.4995 3.30599C16.4995 4.85348 15.2384 6.11198 13.6779 6.11198C12.1174 6.11198 10.8563 4.85348 10.8563 3.30599C10.8563 1.7585 12.1174 0.5 13.6779 0.5C15.2384 0.5 16.4995 1.7585 16.4995 3.30599Z", fill: "currentColor", stroke: "black" }));
const NotesSVG = SvgDailyNotes;
const NotePreviewBig = ({ date, dailyNotes, dailyNoteCategories, setShowDailyNotesModal }) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g;
  const theme2 = useTheme$1();
  const classes = useStyles$1X();
  const notesForDay = useMemo(
    () => dailyNotes.data.filter((note) => note.pinned).filter((note) => note.date === formatDate(date, "YYYY-MM-DD")).sort((a, b) => sortByDate(a.createdDate, b.createdDate, "YYYY-MM-DD HH:mm:ss", true)).map((note) => ({
      ...note,
      color: getDailyNoteColor(
        findObjectByProperty(dailyNoteCategories == null ? void 0 : dailyNoteCategories.data, note == null ? void 0 : note.category, "id"),
        theme2
      )
    })),
    [dailyNotes.data, dailyNoteCategories.data, date]
  );
  if (isEmpty(notesForDay)) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.dailyNote, onClick: () => setShowDailyNotesModal(true) }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.noteIconBackground,
      style: { backgroundColor: (_a = notesForDay[0]) == null ? void 0 : _a.color }
    },
    /* @__PURE__ */ React__default.createElement(NotesSVG, { style: { flexShrink: 0, height: "23px", width: "22px", marginLeft: "-2px" } })
  ), ((_b2 = notesForDay[0]) == null ? void 0 : _b2.title) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.dailyNoteTitle }, (_c2 = notesForDay[0]) == null ? void 0 : _c2.title), ((_d2 = notesForDay[0]) == null ? void 0 : _d2.title) && ((_e2 = notesForDay[0]) == null ? void 0 : _e2.note) && /* @__PURE__ */ React__default.createElement(Divider, { direction: "vertical", color: theme2.colors.linenDark }), ((_f = notesForDay[0]) == null ? void 0 : _f.note) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.dailyNoteMessage }, (_g = notesForDay[0]) == null ? void 0 : _g.note));
};
NotePreviewBig.defaultProps = {
  date: moment$2()
};
NotePreviewBig.propTypes = {
  date: momentPropTypes.momentObj,
  dailyNotes: dailyNotesPropTypes.isRequired,
  dailyNoteCategories: dailyNotesPropTypes.isRequired,
  setShowDailyNotesModal: PropTypes.func.isRequired
};
const mapStateToProps$3s = (state) => ({
  date: state.obeeScreen.date,
  dailyNotes: state.dailyNotes,
  dailyNoteCategories: state.dailyNoteCategories
});
const mapDispatchToProps$3r = (dispatch) => bindActionCreators(
  {
    setShowDailyNotesModal: setShowDailyNotesModalAction
  },
  dispatch
);
const NotePreviewBig$1 = connect(mapStateToProps$3s, mapDispatchToProps$3r)(NotePreviewBig);
const drawerWidth = 295;
const mobileHeaderBreakpoint = 740;
const headerHeight$4 = 65;
const mobileHeaderHeight = 110;
const useStyles$1W = createUseStyles(
  (theme2) => ({
    container: {
      backgroundColor: theme2.colors.white,
      minHeight: "100svh",
      [theme2.breakpoints.up("md")]: {
        width: "100%",
        marginLeft: 0,
        justifyContent: "center"
      }
    },
    containerInner: {
      [theme2.breakpoints.up("md")]: {
        justifyContent: "center",
        marginLeft: "auto",
        marginRight: "auto"
      }
    },
    appBar: {
      color: theme2.colors.charcoal,
      backgroundColor: theme2.colors.linen,
      boxShadow: "none",
      position: "fixed",
      zIndex: "50",
      borderBottom: `1px solid ${theme2.colors.headerBorder}`,
      height: "65px",
      padding: "0",
      "@media print": {
        display: "none"
      },
      [`@media (max-width: ${mobileHeaderBreakpoint}px)`]: {
        height: "110px"
      }
    },
    menuButton: {
      height: "50px"
    },
    menuLogo: {
      left: "0",
      margin: "0 auto",
      position: "absolute",
      right: "0",
      width: "150px"
    },
    sidebar: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      backgroundColor: theme2.colors.linen,
      height: "100%"
    },
    list: {
      marginTop: "16px",
      fontSize: "22px"
    },
    header: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "space-between",
      padding: "0 20px",
      position: "relative",
      width: "100%",
      gap: "8px",
      overflowX: "auto",
      // So it's still somewhat useable on mobile
      [theme2.breakpoints.down("sm")]: {
        padding: "0 10px"
      }
    },
    mobileRow: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      padding: "0 20px",
      position: "relative",
      width: "100%",
      gap: "8px",
      overflowX: "auto",
      // So it's still somewhat useable on mobile
      [theme2.breakpoints.down("sm")]: {
        padding: "0 10px"
      }
    },
    leftRow: {
      display: "flex",
      alignItems: "center",
      gap: "2px",
      flexBasis: "33%"
    },
    middle: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      [theme2.breakpoints.down("sm")]: {
        gap: "8px"
      }
    },
    headerRight: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "8px",
      flexBasis: "33%"
    },
    headerToolbar: {
      height: "100%",
      padding: "0 20px"
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      backgroundColor: theme2.colors.linen
    },
    drawerPaper: {
      width: drawerWidth,
      overflowX: "hidden"
    },
    hide: {
      display: "none"
    },
    logo: {
      height: "35px",
      width: "300px",
      display: "block"
    },
    expandArrow: {
      marginTop: "3px",
      color: theme2.colors.black,
      transitionDuration: "0.1s"
    },
    pageContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer"
    },
    menuText: {
      color: theme2.colors.menuText
    },
    pageText: {
      fontWeight: theme2.fontWeights.medium,
      cursor: "pointer",
      whiteSpace: "nowrap"
    },
    restaurantDropdownArrow: {
      color: theme2.colors.black,
      marginTop: "2px",
      width: "7px",
      transitionDuration: "0.1s"
    },
    menuItemContent: {
      display: "flex",
      gap: "10px",
      marginLeft: "-10px",
      ...theme2.typography.body.PL,
      lineHeight: "32px"
    },
    liveBookingsContent: (props) => ({
      position: "relative",
      paddingTop: "65px",
      transition: (props == null ? void 0 : props.navigationOpen) ? "margin-left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms" : "margin-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
      [`@media (max-width: ${mobileHeaderBreakpoint}px)`]: {
        paddingTop: `${mobileHeaderHeight}px`
      },
      "@media print": {
        paddingTop: "0 !important",
        marginLeft: "0 !important"
        // hide side nav for runsheet print
      }
    })
  }),
  { name: "LiveBookingsHeader" }
);
const useStyles$1V = createUseStyles(
  (theme2) => ({
    container: {
      "@media print": {
        display: "none"
      },
      height: "calc(100dvh - 65px)",
      backgroundColor: theme2.colors.linen,
      // Mobile header is taller
      [`@media (max-width: ${mobileHeaderBreakpoint}px)`]: {
        height: `calc(100dvh - ${mobileHeaderHeight}px)`
      }
    },
    printOnly: {
      display: "none",
      "@media print": {
        display: "block"
      }
    },
    innerContainer: {
      padding: "0 16px",
      overflowX: "auto",
      overflowY: "auto",
      overscrollBehavior: "auto"
    },
    tableContainer: {
      overflowX: "auto",
      overflowY: "auto",
      overscrollBehavior: "auto",
      height: "100%",
      backgroundColor: theme2.colors.white,
      borderRadius: "24px"
    },
    header: {
      paddingTop: "20px",
      paddingBottom: "16px",
      paddingLeft: "36px",
      paddingRight: "28px",
      backgroundColor: theme2.colors.linen,
      display: "flex",
      justifyContent: "space-between",
      // flexWrap: 'wrap',
      gap: "40px",
      alignItems: "center",
      [theme2.breakpoints.down("md")]: {
        padding: `8px 20px 8px 20px`,
        gap: "20px"
      },
      [theme2.breakpoints.down("xs")]: {
        flexWrap: "wrap",
        gap: "8px"
      },
      "@media (max-height: 650px)": {
        paddingTop: "20px"
      }
    },
    title: {
      ...theme2.typography.heading.H2,
      paddingTop: "20px",
      paddingBottom: "20px",
      lineHeight: "22px"
    },
    printButtonContainer: {
      width: "224px",
      display: "flex",
      justifyContent: "flex-end"
    },
    printButton: {
      display: "flex",
      gap: "10px",
      ...theme2.typography.body.PL,
      lineHeight: "18px",
      verticalAlign: "baseline",
      position: "relative",
      cursor: "pointer",
      padding: "10px",
      marginTop: "10px",
      borderRadius: "10px",
      userSelect: "none",
      alignItems: "center",
      justifyContent: "flex-end",
      flexShrink: 0,
      flexGrow: 0,
      "&:hover": {
        backgroundColor: theme2.colors.white
      }
    },
    columnHeaderContent: {
      padding: "0 24px 0 32px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      gap: "40px",
      borderBottom: `1px solid ${theme2.colors.shark}`,
      [theme2.breakpoints.down("md")]: {
        padding: `0 20px`
      }
    },
    columnHeadersContainer: {
      display: "flex",
      fontSize: "15px",
      fontWeight: "500",
      justifyContent: "space-between",
      gap: "20px",
      padding: "10px 0",
      alignItems: "center"
    },
    content: {
      padding: "0 24px 48px 32px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      gap: "40px",
      [theme2.breakpoints.down("md")]: {
        padding: `0 20px 48px 20px`
      }
    },
    printContent: {
      paddingTop: "48px",
      paddingBottom: "48px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      gap: "40px"
    },
    listContainer: {
      "@media print": {
        display: "none"
      },
      backgroundColor: theme2.colors.white
    },
    listHeader: {
      display: "flex",
      justifyContent: "space-between",
      gap: "20px",
      paddingBottom: "10px",
      paddingTop: "32px"
    },
    listHeading: {
      color: theme2.colors.charcoal,
      fontSize: "22px",
      lineHeight: "normal",
      fontWeight: theme2.fontWeights.medium
    },
    headingNumbers: {
      display: "flex",
      gap: "24px",
      paddingRight: "12px"
    },
    headingNumber: {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      flexGrow: 1,
      justifyContent: "space-between",
      minWidth: "75px"
    },
    hourDivider: {
      display: "flex",
      justifyContent: "space-between",
      gap: "20px",
      marginLeft: "-20px",
      padding: "12px 12px 12px 20px",
      backgroundColor: theme2.colors.lightCloud,
      borderRadius: "10px",
      fontSize: "15px",
      fontWeight: theme2.fontWeights.medium,
      color: theme2.colors.charcoal,
      [theme2.breakpoints.down("md")]: {
        marginLeft: `-10px`
      }
    },
    headingNumbersHour: {
      display: "flex",
      gap: "24px"
    },
    headingNumberHour: {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      flexGrow: 1,
      justifyContent: "space-between",
      minWidth: "75px"
    },
    sessionContainer: {
      "& $bookingCardContainer": {
        "&:last-child": {
          borderBottom: "none"
        }
      }
    },
    bookingCardContainer: {
      display: "flex",
      flexDirection: "column",
      padding: "10px 0 12px",
      gap: "10px",
      // padding: '0',
      fontSize: "15px",
      color: theme2.colors.charcoal,
      borderBottom: `1px solid ${theme2.colors.cloud}`
    },
    bookingCardInnerContainer: {
      display: "flex",
      justifyContent: "space-between",
      gap: "20px",
      // padding: '5px 0',
      alignItems: "center"
    },
    bookingCardTagsContainer: {
      padding: "8px 0px 5px 22px"
    },
    bookingCardRow: {
      width: "100%",
      minHeight: "20px",
      position: "relative",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    bookingSourceIcon: {
      color: theme2.colors.charcoal,
      cursor: "pointer"
    },
    bookingCardCommentRow: {
      display: "inline-flex",
      minWidth: "230px",
      width: "100%",
      fontSize: "15px",
      lineHeight: "17px"
      // wordBreak: 'break-all',
    },
    bookingButtonRow: {
      display: "inline-flex",
      gap: "10px",
      minWidth: "40px",
      maxWidth: "40px"
    },
    statusCell: {
      display: "inline-flex",
      width: "100%",
      minWidth: "260px",
      maxWidth: "260px",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      marginLeft: "auto",
      textAlign: "right",
      gap: "8px",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    tableNumber: {
      border: `1px solid ${theme2.colors.shark}`,
      color: theme2.colors.smoke,
      padding: "4px 8px",
      borderRadius: "8px",
      width: "fit-content"
    },
    areaName: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
      // width: '100px',
      // '&:hover': {
      //   width: 'auto',
      //   position: 'absolute',
      //   // top: 0,
      // },
    },
    tabContainer: {
      display: "block",
      flexShrink: 0,
      flexGrow: 0
    },
    arrivalColumn: {
      minWidth: "80px",
      maxWidth: "90px",
      display: "flex",
      columnGap: "16px",
      alignItems: "center",
      overflow: "visible"
      // to show pillar outline
    },
    tableColumn: {
      minWidth: "40px",
      maxWidth: "80px"
    },
    areaColumn: {
      minWidth: "60px",
      maxWidth: "150px"
    },
    guestColumn: {
      minWidth: "160px",
      maxWidth: "200px",
      display: "flex",
      flexDirection: "column"
      // rowGap: '4px',
    },
    partyColumn: {
      minWidth: "60px",
      maxWidth: "80px"
    },
    sourceColumn: {
      minWidth: "60px",
      maxWidth: "80px"
    },
    summaryText: {
      fontSize: "15px",
      lineHeight: "normal",
      minWidth: "20px"
    },
    summaryLabel: {
      fontSize: "15px",
      fontWeight: theme2.fontWeights.medium,
      lineHeight: "normal"
    },
    statusColumn: {
      maxWidth: "260px",
      minWidth: "260px",
      width: "100%",
      textAlign: "right"
    },
    bookingCardCommentOverflow: {
      display: "-webkit-box",
      WebkitLineClamp: "3",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    guestItemContainer: {
      display: "flex",
      gap: "8px",
      alignItems: "center"
    },
    guestItemName: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      cursor: "pointer",
      fontWeight: theme2.fontWeights.medium
    },
    guestItemSize: {
      display: "flex",
      gap: "4px",
      alignItems: "center"
    },
    guestItemNumber: {
      color: theme2.colors.smoke,
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: "12px"
    },
    guestVisitNumber: {
      border: `1px solid ${theme2.colors.yetAnotherGray11}`,
      borderRadius: "8px",
      color: theme2.colors.black,
      fontSize: "12px",
      padding: "4px 8px",
      cursor: "pointer"
    },
    partyItemSize: {
      display: "inline-flex",
      gap: "8px",
      cursor: "pointer",
      alignItems: "center",
      backgroundColor: theme2.colors.whiteSmoke,
      borderRadius: "10px",
      padding: "6px 9px"
    },
    smsButtonRow: {
      minWidth: "200px",
      maxWidth: "200px"
    },
    smsMessage: {
      fontSize: "12px",
      color: theme2.colors.smoke,
      display: "-webkit-box",
      WebkitLineClamp: 2,
      lineClamp: 2,
      boxOrient: "vertical",
      maxHeight: "30px",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    displayModeContainer: {
      display: "inline-flex",
      // border: `1px solid ${theme.colors.shark}`,
      // borderRadius: theme.borderRadius.xxxl,
      // padding: '6px 5px 6px 15px',
      gap: "10px",
      height: "25px",
      color: theme2.colors.charcoal,
      fontSize: "15px",
      lineHeight: "normal",
      fontWeight: theme2.fontWeights.medium,
      alignItems: "center",
      justifyContent: "center"
    },
    displayModeLabel: {
      textTransform: "capitalize",
      cursor: "pointer",
      userSelect: "none"
    },
    displayModePopoverButton: {
      // border: `1px solid ${theme.colors.shark}`,
      // borderRadius: '100%',
      // width: '25px',
      // height: '25px',
      // cursor: 'pointer',
      // paddingTop: '2px',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderLeft: `1px solid ${theme2.colors.shark}`
    },
    inlineCommentsContainer: {
      display: "flex",
      alignItems: "center",
      fontSize: "15px",
      lineHeight: "21px",
      fontWeight: theme2.fontWeights.regular,
      maxWidth: "540px"
    },
    printedInlineCommentsContainer: {
      maxWidth: "700px"
    },
    inlineCommentsInnerContainer: {
      display: "-webkit-box",
      position: "relative",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "100%"
      // wordBreak: 'break-all',
    },
    printedCommentsInnerContainer: {
      display: "block"
    },
    inlineCommentsHeader: {
      fontWeight: theme2.fontWeights.medium
    },
    inlineCommentsReadMore: {
      display: "inline-block",
      color: theme2.colors.smoke,
      textDecoration: "underline",
      cursor: "pointer",
      marginLeft: "5px"
    },
    mobileBookingCardContainer: {
      gap: "14px"
    }
  }),
  { name: "RunSheet" }
);
const SvgPrinter = (props) => /* @__PURE__ */ React$7.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 15", fill: "none", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 2.65813, y: 0.25, width: 10.8728, height: 6.54022, rx: 0.75, fill: "currentColor", stroke: "#303030", strokeWidth: 0.5 }), /* @__PURE__ */ React$7.createElement("path", { d: "M13.6504 4.92822H13.7604C14.538 4.92822 15.1684 5.55863 15.1684 6.33627V6.33627C15.1684 7.11391 14.538 7.74431 13.7604 7.74431H2.40804C1.6304 7.74431 1 7.11391 1 6.33627V6.33627C1 5.55863 1.63092 4.92822 2.40856 4.92822V4.92822", stroke: "#303030" }), /* @__PURE__ */ React$7.createElement("path", { d: "M1 6.21216V13.0806C1 13.6329 1.44772 14.0806 2 14.0806H14.1633C14.7156 14.0806 15.1633 13.6329 15.1633 13.0806V6.21216", stroke: "#303030" }), /* @__PURE__ */ React$7.createElement("rect", { x: 2.82377, y: 10.3965, width: 1.0737, height: 1.0737, rx: 0.536848, stroke: "#303030", strokeWidth: 0.5 }), /* @__PURE__ */ React$7.createElement("rect", { x: 4.76994, y: 10.3962, width: 1.0737, height: 1.0737, rx: 0.536848, stroke: "#303030", strokeWidth: 0.5 }));
const PrinterIconSVG$1 = SvgPrinter;
const useStyles$1U = createUseStyles((theme2) => ({
  popover: {},
  modalBody: {
    ...theme2.typography.body.textLarge
  }
}));
const Popover = ({
  isOpen,
  onClose,
  anchorEl,
  children,
  style,
  anchorOrigin,
  transformOrigin,
  innerStyle,
  innerProps,
  disableScrollLock,
  ...others
}) => {
  const classes = useStyles$1U();
  return /* @__PURE__ */ React__default.createElement(
    Popover$2,
    {
      anchorEl,
      keepMounted: false,
      open: isOpen,
      onClose,
      className: classes.popover,
      anchorOrigin,
      transformOrigin,
      style: { ...style },
      disableScrollLock: true,
      PaperProps: {
        style: {
          // To override default app styles
          fontSize: "0.938rem",
          // 15px
          letterSpacing: "0.01071em",
          lineHeight: 1.5,
          fontWeight: 400,
          marginTop: "24px",
          // position: 'absolute',
          padding: "16px",
          // top: '25px',
          // left: '10px',
          boxShadow: "0px 4px 14px rgba(111, 111, 111, 0.25)",
          borderRadius: "18px",
          ...innerStyle
        }
      },
      transitionDuration: 100,
      ...others,
      ...innerProps
    },
    children
  );
};
Popover.defaultProps = {
  style: {},
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  },
  disableScrollLock: false
};
Popover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  anchorOrigin: PropTypes.shape({}),
  transformOrigin: PropTypes.shape({}),
  style: PropTypes.shape({}),
  disableScrollLock: PropTypes.bool
};
const mapStateToProps$3r = () => ({});
const mapDispatchToProps$3q = (dispatch) => bindActionCreators({}, dispatch);
const Popover$1 = connect(mapStateToProps$3r, mapDispatchToProps$3q)(Popover);
const useStyles$1T = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    fontSize: "15px",
    lineHeight: "26px",
    color: theme2.colors.charcoal
  },
  header: {
    fontWeight: theme2.fontWeights.medium
  },
  historyContainer: {
    display: "flex",
    maxWidth: "300px",
    flexDirection: "column",
    whiteSpace: "pre-wrap"
  }
}));
const HistoryPopover = ({ anchor, setAnchor, booking, innerStyle = {} }) => {
  const classes = useStyles$1T();
  const theme2 = useTheme$1();
  const lastUpdatedByGuestTime = formatTime(booking == null ? void 0 : booking.lastEditedByGuest, "h:mm:ssa D/M/YY");
  const lastUpdatedContent = `Booking updated online at ${lastUpdatedByGuestTime} by customer\r
`;
  const getHistory = () => {
    var _a, _b2, _c2;
    if (isEmpty(booking == null ? void 0 : booking.history)) {
      return "";
    }
    const bookingHistory = (_a = booking == null ? void 0 : booking.history) == null ? void 0 : _a.split(lastUpdatedContent);
    if (bookingHistory.length > 1) {
      return (_c2 = (_b2 = bookingHistory[1]) == null ? void 0 : _b2.split("\nBooking")) == null ? void 0 : _c2[0];
    }
    return "";
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl: anchor,
      innerStyle: {
        borderRadius: theme2.borderRadius.xl,
        border: `1px solid ${theme2.colors.cloud}`,
        backgroundColor: theme2.colors.white,
        boxShadow: `0px 4px 8px 0px rgba(151, 151, 151, 0.25)`,
        marginLeft: "8px",
        marginTop: "-5px",
        padding: "12px 20px",
        ...innerStyle
      },
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, "Updated by Guest"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.historyContainer }, getHistory()))
  );
};
HistoryPopover.defaultProps = {
  anchor: null,
  setAnchor: () => {
  },
  innerStyle: {}
};
HistoryPopover.propTypes = {
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func,
  booking: obeeBookingPropTypes.isRequired,
  innerStyle: PropTypes.shape({})
};
const HistoryPopover$1 = HistoryPopover;
const useStyles$1S = createUseStyles((theme2) => ({
  container: {
    position: "relative",
    backgroundColor: theme2.colors.white,
    borderRadius: "6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${theme2.colors.cloud}`,
    padding: "8px 16px"
  },
  arrow: {
    display: "block",
    height: "19px",
    width: "19px",
    backgroundColor: theme2.colors.white,
    border: "inherit",
    position: "absolute",
    top: "-9px",
    left: "calc(50% - 10px)",
    clipPath: "polygon(0% 0%, 100% 100%, 0% 100%)",
    transform: "rotate(-225deg)",
    borderRadius: "0 0 0 6px"
  },
  tooltipText: {
    lineHeight: "20px"
  }
}));
const SourcePopover = ({ anchor, setAnchor, booking, innerStyle }) => {
  const classes = useStyles$1S();
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl: anchor,
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      innerStyle: {
        borderRadius: theme2.borderRadius.xl,
        border: "none",
        backgroundColor: "transparent",
        boxShadow: `0px 4px 8px 0px rgba(151, 151, 151, 0.25)`,
        marginTop: "9px",
        marginLeft: "-16px",
        padding: 0,
        overflow: "visible",
        ...innerStyle
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.arrow }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.tooltipText }, booking.sourceLabel))
  );
};
SourcePopover.defaultProps = {
  anchor: null,
  setAnchor: () => {
  },
  innerStyle: {},
  booking: null
};
SourcePopover.propTypes = {
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func,
  booking: obeeBookingPropTypes,
  innerStyle: PropTypes.shape({})
};
const SourcePopover$1 = SourcePopover;
const SvgCloseSmall = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M17.7856 1.3571L1.49875 17.4997", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M1 1L17.7885 17.2768", stroke: "currentColor" }));
const CloseSVG = SvgCloseSmall;
const restaurantPropTypes = PropTypes.shape({
  objectId: PropTypes.string,
  enabled: PropTypes.bool,
  name: PropTypes.string,
  region: PropTypes.string,
  menuVersion: PropTypes.number,
  bdmEmail: PropTypes.string,
  bdmName: PropTypes.string,
  bdmPhone: PropTypes.string,
  revPerDiner: PropTypes.number,
  revPerDinerTakeaway: PropTypes.number,
  hours: PropTypes.string,
  hoursParsed: PropTypes.shape({}),
  platform: PropTypes.string,
  showOppos: PropTypes.bool,
  showPredictions: PropTypes.bool,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postcode: PropTypes.string,
  phone: PropTypes.string,
  website: PropTypes.string,
  abn: PropTypes.string,
  tradingName: PropTypes.string,
  instagramLink: PropTypes.string,
  facebookLink: PropTypes.string,
  twitterLink: PropTypes.string,
  obeeEnabled: PropTypes.bool,
  premium: PropTypes.bool,
  ecPayEnabled: PropTypes.bool,
  obeeToken: PropTypes.string,
  // Only for obee FOH
  slug: PropTypes.string,
  // Only for obee FOH
  obeeGoLiveDate: PropTypes.string,
  obeeIsLive: PropTypes.bool,
  // Obee only
  closedEarly: PropTypes.bool,
  theme: PropTypes.string,
  // EC only
  closures: PropTypes.arrayOf(
    PropTypes.shape({
      restId: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      startTime: PropTypes.number,
      endTime: PropTypes.number
    })
  )
});
const restaurantActivePropTypes = PropTypes.shape({
  restaurant: restaurantPropTypes,
  id: PropTypes.string,
  restaurantFetching: PropTypes.bool,
  fetching: PropTypes.bool
});
const closedEarlyToday = (restaurant, date) => {
  if (restaurant == null ? void 0 : restaurant.closedEarly) {
    return true;
  }
  let dateToUse = date;
  if (isVoid(date)) {
    dateToUse = moment().startOf("day");
  }
  return (restaurant == null ? void 0 : restaurant.closedEarly) || ((restaurant == null ? void 0 : restaurant.closures) || []).some(
    (closure) => dateToUse.isBetween(moment(closure.startDate), moment(closure.endDate), "day", "[]")
  );
};
const DeferRender = ({ isShowing, children }) => {
  const [hasShown, setHasShown] = useState(false);
  useEffect(() => {
    if (isShowing) {
      setHasShown(true);
    }
  }, [isShowing]);
  if (!hasShown) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
};
DeferRender.defaultProps = {
  isShowing: false
};
DeferRender.propTypes = {
  isShowing: PropTypes.bool,
  children: PropTypes.node.isRequired
};
const DeferRender$1 = DeferRender;
const ValueField = ({ label, value, style, ...others }) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    ValueField$2,
    {
      label,
      value,
      placeholder: "Empty",
      ...others,
      style: {
        ...style,
        container: {
          ...style == null ? void 0 : style.container
        },
        innerContainer: {
          display: "flex",
          gap: "10px",
          padding: "6px 0",
          alignItems: "baseline",
          ...style == null ? void 0 : style.innerContainer
        },
        label: {
          color: theme2.colors.smoke,
          width: "100px",
          flexShrink: 0,
          marginBottom: 0,
          ...style == null ? void 0 : style.label
        },
        placeholder: {
          color: theme2.colors.nimbus,
          ...style == null ? void 0 : style.placeholder
        },
        valueField: {
          width: "100%",
          color: theme2.colors.charcoal,
          padding: "0 12px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...style == null ? void 0 : style.valueField
        }
      }
    }
  );
};
ValueField.defaultProps = {
  label: "",
  value: "",
  style: {}
};
ValueField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.shape({
    container: PropTypes.shape({}),
    innerContainer: PropTypes.shape({}),
    label: PropTypes.shape({}),
    placeholder: PropTypes.shape({}),
    valueField: PropTypes.shape({})
  })
};
const ValueField$1 = ValueField;
const useStyles$1R = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    fontSize: "15px",
    position: "relative"
  },
  header: {
    display: "flex",
    background: theme2.colors.white,
    // padding: '8px 12px',
    position: "sticky",
    top: 0,
    zIndex: 2
  },
  button: {
    display: "flex",
    marginLeft: "auto",
    "&:hover": {
      color: theme2.colors.black,
      cursor: "pointer"
    }
  }
}));
const popoverStyle = {
  minWidth: "450px",
  marginTop: "10px",
  maxHeight: "600px",
  borderRadius: "12px",
  padding: "28px",
  marginLeft: "24px"
};
const headerHeight$3 = 40;
const mobileBuffer$1 = 40;
const desktopBuffer$1 = 20;
createUseStyles(
  (theme2) => ({
    content: (props) => ({
      backgroundColor: theme2.colors.white,
      border: "4px solid white",
      borderRadius: "24px",
      minWidth: `${props == null ? void 0 : props.modalWidth}px`,
      width: "fit-content",
      boxShadow: "0px 4px 14px rgba(111, 111, 111, 0.25)",
      minHeight: "450px",
      maxHeight: `calc(100dvh - ${(props == null ? void 0 : props.isMobile) ? mobileBuffer$1 : desktopBuffer$1}px)`,
      // Extra buffer for mobile browsers
      height: "100%",
      position: "fixed",
      top: 0,
      zIndex: 1100
    }),
    modalHeader: {
      backgroundColor: theme2.colors.linen,
      display: "flex",
      justifyContent: "flex-end",
      // padding: '6px 10px',
      borderRadius: "20px 20px 0 0",
      // border: '4px solid white',
      alignItems: "flex-start",
      height: (props) => `${(props == null ? void 0 : props.headerHeight) ?? headerHeight$3}px`
    },
    modalBody: {
      height: `calc(100% - ${headerHeight$3}px)`,
      // Header offset
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      position: "relative",
      fontSize: "15px",
      borderRadius: "0 0 8px 8px",
      overflowY: theme2.overlay
    },
    button: {
      position: "absolute",
      top: "0",
      padding: "16px",
      display: "flex",
      "&:hover": {
        color: theme2.colors.charcoal,
        cursor: "pointer"
      }
    },
    hiddenFromPrint: {
      ...theme2.utilities.noPrint
    }
  }),
  { name: "Modal" }
);
const smallButtonStyles$1 = (theme2) => ({
  container: { width: "100%" },
  button: {
    fontSize: "inherit",
    fontWeight: theme2.fontWeights.medium,
    width: "100%",
    height: "36px",
    display: "flex",
    padding: "0 20px",
    alignItems: "center",
    justifyContent: "center"
  }
});
const largeButtonStyles = (theme2) => ({
  container: { width: "100%" },
  button: {
    fontSize: "inherit",
    fontWeight: theme2.fontWeights.medium,
    width: "100%",
    height: "44px",
    display: "flex",
    padding: "0 20px",
    alignItems: "center",
    justifyContent: "center"
  }
});
const listPopoverStyles$2 = {
  popover: { minWidth: "fit-content", maxHeight: "550px", padding: "8px" },
  item: { fontSize: "15px" }
};
const popoverAnchors$3 = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  }
};
const SendMessagePopover = ({
  anchor,
  setAnchor,
  booking,
  sendWaitlistSMS: sendWaitlistSMS2,
  restaurant,
  settings
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const theme2 = useTheme$1();
  const classes = useStyles$1R();
  const close = () => {
    setAnchor(null);
  };
  const smallButtonStyle = smallButtonStyles$1(theme2);
  const messageOptions = [
    (_c2 = (_b2 = (_a = settings == null ? void 0 : settings.data) == null ? void 0 : _a.messaging) == null ? void 0 : _b2.sms_waitlist) == null ? void 0 : _c2.quickOption1,
    (_f = (_e2 = (_d2 = settings == null ? void 0 : settings.data) == null ? void 0 : _d2.messaging) == null ? void 0 : _e2.sms_waitlist) == null ? void 0 : _f.quickOption2,
    (_i = (_h = (_g = settings == null ? void 0 : settings.data) == null ? void 0 : _g.messaging) == null ? void 0 : _h.sms_waitlist) == null ? void 0 : _i.quickOption3
  ].filter((item) => !!item);
  const messageBody = (((_l = (_k = (_j = settings == null ? void 0 : settings.data) == null ? void 0 : _j.messaging) == null ? void 0 : _k.sms_waitlist) == null ? void 0 : _l.smsBody) || "").replace("[fname]", (_n = (_m = booking == null ? void 0 : booking.guests) == null ? void 0 : _m[0]) == null ? void 0 : _n.firstName).replace("[size]", booking == null ? void 0 : booking.size).replace("[x]", "[Insert response]");
  return /* @__PURE__ */ React__default.createElement(DeferRender$1, { isShowing: !!anchor }, /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      anchorEl: anchor,
      isOpen: !!anchor,
      onClose: close,
      innerStyle: popoverStyle,
      anchorOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.button,
        onClick: close,
        style: {
          position: "absolute",
          right: "24px",
          top: "24px",
          zIndex: 10,
          transition: "all 0.1s"
        }
      },
      /* @__PURE__ */ React__default.createElement(CloseSVG, { style: { width: "18px", height: "18px" } })
    ), /* @__PURE__ */ React__default.createElement(Spacer, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 40 }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: {
          fontWeight: theme2.fontWeights.medium,
          textWrap: "balance",
          fontSize: "22px",
          lineHeight: "32px",
          marginRight: "50px"
        }
      },
      "Let ",
      (_p = (_o = booking == null ? void 0 : booking.guests) == null ? void 0 : _o[0]) == null ? void 0 : _p.firstName,
      " know that a table is available"
    ), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 12 }, /* @__PURE__ */ React__default.createElement(
      ValueField$1,
      {
        label: "Sender display",
        value: restaurant.name,
        style: { label: { width: "120px" } }
      }
    ), /* @__PURE__ */ React__default.createElement(
      ValueField$1,
      {
        label: "Message",
        multiLine: true,
        value: messageBody,
        style: {
          label: { width: "120px" },
          valueField: { maxWidth: "250px" }
        }
      }
    ), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 12 }, /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, "Select a response"), /* @__PURE__ */ React__default.createElement(Spacer, { gap: 12 }, messageOptions.map((option) => /* @__PURE__ */ React__default.createElement(
      Button,
      {
        key: option,
        type: "tertiary",
        style: {
          ...smallButtonStyle,
          container: { ...smallButtonStyle == null ? void 0 : smallButtonStyle.container, width: "fit-content" }
        },
        onClick: () => {
          sendWaitlistSMS2(booking == null ? void 0 : booking.id, option);
          close();
        }
      },
      option
    ))))))))
  ));
};
SendMessagePopover.defaultProps = {
  anchorEl: null,
  booking: null
};
SendMessagePopover.propTypes = {
  anchorEl: PropTypes.shape({}),
  booking: obeeBookingPropTypes,
  sendWaitlistSMS: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired
};
const mapStateToProps$3q = (state) => ({
  restaurant: state.restaurantActive.restaurant,
  settings: state.obeeSettings
});
const mapDispatchToProps$3p = (dispatch) => bindActionCreators(
  {
    sendWaitlistSMS: sendWaitlistSMSAction
  },
  dispatch
);
const SendMessagePopover$1 = connect(mapStateToProps$3q, mapDispatchToProps$3p)(SendMessagePopover);
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M11.585 6.0425C11.585 9.10353 9.10356 11.585 6.04251 11.585C2.98147 11.585 0.5 9.10353 0.5 6.0425C0.5 2.98146 2.98147 0.5 6.04251 0.5C9.10356 0.5 11.585 2.98146 11.585 6.0425Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.2265 10.2256L14.0008 13.9998", stroke: "currentColor", strokeLinecap: "round" }));
const MagnifyingGlassSVG = SvgMagnifyingGlass;
const SvgGuest = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 14 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 7, cy: 4, r: 3.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M1 13.2763V16.0003C1 16.5526 1.44562 17 1.99791 17H12.001C12.5533 17 13 16.5528 13 16.0005V13C13 11.2476 11.313 9.67505 9.85623 9.1694C9.28552 8.97131 8.69269 9.18396 8.11218 9.35115C7.81553 9.43659 7.45088 9.5 7 9.5C6.31948 9.5 5.68429 9.35554 5.28814 9.20895C5.01947 9.10953 4.72676 8.99093 4.4433 9.03245C2.1615 9.36669 1 12.1921 1 13.2763Z", stroke: "currentColor" }));
const GuestSVG = SvgGuest;
const SvgTableJoined = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 29 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 14.5, cy: 14.5, r: 14.5, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.00767 10.4484C9.00767 11.2714 8.40206 11.8675 7.73919 11.8675C7.07632 11.8675 6.4707 11.2714 6.4707 10.4484C6.4707 9.62539 7.07632 9.0293 7.73919 9.0293C8.40206 9.0293 9.00767 9.62539 9.00767 10.4484Z", stroke: "#F0F0F0" }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.00767 19.0846C9.00767 19.9077 8.40206 20.5038 7.73919 20.5038C7.07632 20.5038 6.4707 19.9077 6.4707 19.0846C6.4707 18.2616 7.07632 17.6655 7.73919 17.6655C8.40206 17.6655 9.00767 18.2616 9.00767 19.0846Z", stroke: "#F0F0F0" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.85938 10.4033C10.1638 10.4033 12.2634 10.3169 13.9057 11.6773C16.2542 13.6227 17.5587 14.7783 19.4718 14.7783H21.6323", stroke: "#F0F0F0" }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.08203 19.2139C10.3864 19.2139 12.2622 19.3003 13.9045 17.9399C16.253 15.9945 17.5575 14.8389 19.4706 14.8389H22.3695", stroke: "#F0F0F0" }), /* @__PURE__ */ React$7.createElement("path", { d: "M19.9746 11.6479L22.8484 14.9744L19.9746 17.8851", stroke: "#F2EFEE" }));
const TableJoinedSVG = SvgTableJoined;
const RoundButton = ({ children, style, onClick, ...other }) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "standard",
      style: {
        ...style,
        button: {
          fontSize: "15px",
          lineHeight: "15px",
          backgroundColor: "white",
          // padding: '9px 14px',
          // border: '1px solid #DFDFDF',
          border: `1px solid ${theme2.colors.shark}`,
          fontWeight: "inherit",
          boxShadow: "none",
          borderRadius: "80px",
          height: "36px",
          padding: "0 20px",
          // eslint-disable-next-line react/prop-types
          ...style == null ? void 0 : style.button
        }
      },
      onClick,
      ...other
    },
    children
  );
};
RoundButton.defaultProps = {
  children: null,
  style: {},
  onClick: () => {
  }
};
RoundButton.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({}),
  onClick: PropTypes.func
};
const useStyles$1Q = createUseStyles((theme2) => ({
  container: (props) => {
    var _a;
    return {
      backgroundColor: theme2.colors.white,
      fontSize: "12px",
      padding: "0 6px",
      border: `1px solid ${theme2.colors.yetAnotherGray11}`,
      // boxShadow: '0px 4px 4px rgba(176, 176, 176, 0.25)',
      borderRadius: "6px",
      lineHeight: "20px",
      ...props == null ? void 0 : props.style,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.container
    };
  }
}));
const Label = ({ label, children, style, className, ...others }) => {
  const classes = useStyles$1Q({ style });
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.container} ${className}`, ...others }, label, children);
};
Label.defaultProps = {
  label: "",
  children: "",
  style: {},
  className: ""
};
Label.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.shape({}),
  className: PropTypes.string
};
const mapStateToProps$3p = () => ({});
const mapDispatchToProps$3o = (dispatch) => bindActionCreators({}, dispatch);
const Label$1 = connect(mapStateToProps$3p, mapDispatchToProps$3o)(Label);
const useStyles$1P = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    fontSize: "15px",
    // height: '440px',
    minHeight: "440px",
    maxHeight: "600px"
  },
  header: {
    display: "flex",
    background: theme2.colors.white,
    padding: "20px",
    position: "sticky",
    top: 0,
    zIndex: 2
  },
  button: {
    display: "flex",
    marginLeft: "auto",
    paddingLeft: "64px",
    "&:hover": {
      color: theme2.colors.charcoal,
      cursor: "pointer"
    }
  },
  areaHeader: {
    position: "sticky",
    top: "-1px",
    background: theme2.colors.white
  },
  tableOptions: {
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  },
  tableOption: {
    width: "100%",
    minHeight: "36px",
    // height: '36px',
    display: "flex",
    gap: "10px",
    cursor: "pointer",
    padding: "4px 8px",
    alignItems: "center",
    borderRadius: "8px",
    userSelect: "none",
    "&:hover": {
      backgroundColor: theme2.colors.notificationBackgroundGray
    }
  },
  areaName: {
    fontWeight: theme2.fontWeights.medium,
    padding: "0 8px"
  },
  availabilityPillContainer: {
    marginLeft: "auto",
    display: "flex",
    gap: "8px",
    padding: "4px",
    borderRadius: "8px",
    alignItems: "center"
  },
  availabilityPillNotch: {
    width: "7px",
    borderRadius: "6px",
    height: "15px"
  },
  availabilityPillText: {
    fontSize: "12px",
    fontWeight: theme2.fontWeights.medium,
    // TODO this had a typo in old branch
    letterSpacing: "1.5px",
    lineHeight: "15px",
    textTransform: "uppercase"
  },
  tableNumber: {
    border: `1px solid ${theme2.colors.smoke}`,
    borderRadius: "6px",
    padding: "4px",
    lineHeight: "18px",
    alignItems: "center",
    height: "fit-content",
    minWidth: "48px",
    textAlign: "center",
    color: theme2.colors.smoke,
    userSelect: "none",
    backgroundColor: theme2.colors.white,
    maxWidth: "150px",
    textOverflow: "ellipsis",
    overflowX: "hidden"
  },
  footer: {
    marginTop: "auto",
    background: theme2.colors.white,
    padding: "8px 12px",
    borderTop: "1px solid #DCDCDC",
    position: "sticky",
    bottom: 0,
    zIndex: 2
  }
}));
const searchBarStyles = (theme2) => ({
  innerContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center"
  },
  label: {
    color: theme2.colors.nimbus,
    marginBottom: "0",
    width: "120px"
  },
  textField: {
    flexGrow: 1
  },
  textFieldInner: {
    width: "100%"
  },
  input: {
    backgroundColor: "#F6F6F6",
    border: "1px solid transparent",
    width: "100%",
    color: theme2.colors.charcoal,
    padding: "8px 10px 8px 32px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: "20px",
    fontSize: "15px",
    borderRadius: "8px"
  },
  inputActive: {
    outline: `1px solid ${theme2.colors.smoke}`
  },
  inputHover: {
    backgroundColor: theme2.colors.yetAnotherGray13
  },
  placeholder: {
    color: theme2.colors.nimbus
  },
  inputPrefix: {
    display: "flex"
  }
});
const TableSelectorPopover = ({
  anchorEl,
  setAnchorEl,
  areaId,
  setTable,
  setAreaId,
  setIsAvailableTable,
  obeeTables: obeeTables2,
  obeeAreas: obeeAreas2,
  clearError,
  setIsCreatedTable,
  obeeBookings: obeeBookings2,
  time,
  fullyBookedSessions,
  bookingId,
  date,
  guestAmount,
  fromForceBooking,
  anchorOrigin,
  transformOrigin,
  popoverStyle: popoverStyle2,
  innerProps
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1P();
  const [searchInput, setSearchInput] = useState("");
  const [filteredTables, setFilteredTables] = useState([]);
  const [isJoined, setIsJoined] = useState(false);
  const [joinedTables, setJoinedTables] = useState([]);
  const tablesToSearch = obeeTables2.data;
  const [loading, setLoading] = useState(false);
  const [availability, setAvailability] = useState([]);
  useEffect(() => {
    if (!isEmpty(anchorEl)) {
      const data = {
        date: formatDate(date, "YYYY-MM-DD"),
        time,
        size: guestAmount,
        public: false,
        returnAll: true,
        excludeBookingId: bookingId,
        fromForceBooking
      };
      setLoading(true);
      checkObeeAvailabilityAllAreas(data).then((response) => {
        setLoading(false);
        setAvailability(response == null ? void 0 : response.data);
      });
    }
  }, [anchorEl]);
  useEffect(() => {
    const updateFilter = () => {
      var _a, _b2;
      const input = searchInput.replace(/\s/g, "").toLowerCase();
      const newResults = tablesToSearch == null ? void 0 : tablesToSearch.filter((table) => {
        const tableNumberSearch = (table.tableNumber || "").replace(/\s/g, "").toLowerCase();
        const areaForTable = getAreaById(obeeAreas2.data, table.areaId);
        if (isEmpty(areaForTable)) {
          return false;
        }
        if (fuzzySearch(tableNumberSearch, input)) {
          return true;
        }
        if (input.split(",").some((inputSplit) => inputSplit === tableNumberSearch)) {
          return true;
        }
        const areaSearch = areaForTable.name.replace(/\s/g, "").toLowerCase();
        return areaSearch.includes(input);
      });
      const newResultsByArea = groupObjects(newResults, "areaId");
      const selectableAreas = (_b2 = (_a = obeeAreas2.data.filter((area) => {
        const tables = (newResultsByArea == null ? void 0 : newResultsByArea[area.id]) ?? [];
        if (isAreaCapacityBased(area, obeeTables2.data)) {
          const areaSearch = area.name.replace(/\s/g, "").toLowerCase();
          return areaSearch.includes(input);
        }
        return !isEmpty(tables);
      })) == null ? void 0 : _a.sort((a, b) => {
        if (areaId === "all") {
          return 0;
        }
        if ((a == null ? void 0 : a.id) === areaId) {
          return -1;
        }
        if ((b == null ? void 0 : b.id) === areaId) {
          return 1;
        }
        return 0;
      })) == null ? void 0 : _b2.map((area) => {
        const areaBookings = getAllAreaBookings(area, obeeBookings2.data);
        if (isAreaBookedAtTime(area, areaBookings, time, bookingId)) {
          return { ...area, available: false };
        }
        if (isAreaFullyBookedAtTime(area, fullyBookedSessions.data, time)) {
          return { ...area, available: false };
        }
        return {
          ...area,
          available: true
        };
      });
      const availableTableIds = availability.map((table) => table == null ? void 0 : table.id);
      const tablesByArea = selectableAreas.map((area) => {
        const tables = (newResultsByArea == null ? void 0 : newResultsByArea[area.id]) ?? [];
        const areaIdAsInt = parseInt(area.id, 10);
        const mappedTables = tables.map((table) => {
          return { ...table, available: availableTableIds.includes(table == null ? void 0 : table.id) };
        });
        const sortedTables = sortMultiple(mappedTables, [
          (a, b) => sortAlphaNumericByProperty(a, b, "tableNumber"),
          (a, b) => sortBoolToStart(a, b, "isJoin", true),
          (a, b) => sortBoolToStart(a, b, "available")
        ]);
        return {
          id: areaIdAsInt,
          name: area.name,
          capacity: area.capacity,
          available: area.available,
          // TODO availability checker needs backend update
          tables: sortedTables
        };
      });
      setFilteredTables(tablesByArea);
    };
    updateFilter();
  }, [
    bookingId,
    searchInput,
    tablesToSearch,
    obeeAreas2.data,
    obeeBookings2.data,
    time,
    fullyBookedSessions.data,
    availability
  ]);
  useEffect(() => {
    if (!anchorEl) {
      setSearchInput("");
    }
  }, [anchorEl]);
  const popoverStyles2 = {
    width: "400px",
    marginTop: "10px",
    padding: 0,
    maxHeight: "600px",
    borderRadius: "24px",
    ...popoverStyle2
  };
  const getAvailabilityPill = (isAvailable) => /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.availabilityPillContainer,
      style: {
        background: isAvailable ? theme2.colors.availableBackground : theme2.colors.apricotLight
      }
    },
    /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.availabilityPillNotch,
        style: { background: isAvailable ? theme2.colors.pillAvailable : theme2.colors.apricot }
      }
    ),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.availabilityPillText }, isAvailable ? "available" : "unavailable")
  );
  const close = () => {
    unstable_batchedUpdates(() => {
      setIsJoined(false);
      setJoinedTables([]);
      setAnchorEl(null);
      setSearchInput("");
    });
  };
  const toggleJoinedTable = (isSelected, table) => {
    if (isSelected) {
      setJoinedTables([...joinedTables, table]);
    } else {
      setJoinedTables(
        joinedTables.filter((joinedTable) => joinedTable.tableNumber !== table.tableNumber)
      );
    }
  };
  const makeJoinFromTables = (tables) => {
    const tableNumbers = immutableSort(
      tables.map((table) => table.tableNumber),
      sortAlphaNumeric
    );
    const joinedTable = {
      tableNumber: tableNumbers.join(","),
      areaId: tables[0].areaId,
      minSeats: tables.reduce((accum, table) => accum + (table.minSeats || 0), 0),
      maxSeats: tables.reduce((accum, table) => accum + (table.maxSeats || 0), 0),
      isPublic: tables.every((table) => table.isPublic),
      isJoin: true,
      blocks: tables.map((table) => table.blocks).flat(),
      customDuration: -1,
      // ignore custom durations for on the fly joins
      tableNumbers,
      available: tables.every((table) => table.available)
    };
    return joinedTable;
  };
  const handleCreateJoin = () => {
    const joinedTable = makeJoinFromTables(joinedTables);
    setTable(joinedTable);
    setIsAvailableTable(joinedTable.available);
    setIsCreatedTable(true);
    close();
    clearError();
  };
  const selectTable = (table, isJoined2 = false, isSelected = false, isDisabled) => {
    if (isJoined2) {
      if (!isDisabled) {
        toggleJoinedTable(!isSelected, table);
      }
    } else {
      unstable_batchedUpdates(() => {
        close();
        clearError();
        setTable(table);
        setIsAvailableTable(table.available);
        setIsCreatedTable(false);
      });
    }
  };
  const smallButtonStyle = smallButtonStyles$1(theme2);
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      anchorEl,
      isOpen: !!anchorEl,
      onClose: close,
      innerStyle: popoverStyles2,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
        ...anchorOrigin
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right",
        ...transformOrigin
      },
      innerProps
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", className: classes.header }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: "m" }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: {
          fontWeight: theme2.fontWeights.medium,
          whiteSpace: "nowrap",
          fontSize: "22px"
        }
      },
      "Seating"
    ), /* @__PURE__ */ React__default.createElement(
      RoundButton,
      {
        onClick: () => {
          setJoinedTables([]);
          setIsJoined(!isJoined);
        },
        active: isJoined,
        forceHoverState: isJoined
      },
      "Join tables"
    ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.button, onClick: close }, /* @__PURE__ */ React__default.createElement(CloseSVG, { style: { width: "18px", height: "18px" } }))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.searchBarContainer }, /* @__PURE__ */ React__default.createElement(
      TextField$2,
      {
        inputPrefix: /* @__PURE__ */ React__default.createElement(
          MagnifyingGlassSVG,
          {
            style: { color: theme2.colors.yetAnotherGray16, width: "15px" }
          }
        ),
        style: searchBarStyles(theme2),
        placeholder: areaId === "all" ? "Search area or table number" : "Search table number",
        onChange: setSearchInput,
        value: searchInput
      }
    ))), loading ? /* @__PURE__ */ React__default.createElement(Box, { style: { textAlign: "center", padding: "20px" } }, "Checking table availabilities", /* @__PURE__ */ React__default.createElement(Spinner, { style: { marginLeft: "auto", marginRight: "auto", paddingTop: "16px" } })) : (
      // Content
      /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", style: { padding: "0 12px 8px 12px", overflow: "scroll" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableOptions }, filteredTables.length === 0 && /* @__PURE__ */ React__default.createElement(Box, null, "No tables found matching the search."), filteredTables.map((area) => /* @__PURE__ */ React__default.createElement(Spacer, { gap: 0, direction: "vertical", key: area.id }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaName }, area.name)), isEmpty(area.tables) && /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.tableOption,
          onClick: () => {
            unstable_batchedUpdates(() => {
              close();
              clearError();
              setTable(null);
              setIsAvailableTable(area.available);
              setIsCreatedTable(false);
              setAreaId(area == null ? void 0 : area.id);
            });
          },
          tabIndex: 0
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableNumber }, area.name),
        /* @__PURE__ */ React__default.createElement(Spacer, null, /* @__PURE__ */ React__default.createElement(GuestSVG, { height: 16 }), /* @__PURE__ */ React__default.createElement(Box, { style: { whiteSpace: "nowrap" } }, `Max ${area.capacity}`)),
        getAvailabilityPill(area.available)
      ), /* @__PURE__ */ React__default.createElement(Spacer, { gap: 0, direction: "vertical" }, area.tables.map((table) => {
        if (isJoined && table.isJoin) {
          return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
        }
        const isSelected = joinedTables.some(
          (joinedTable) => joinedTable.tableNumber === table.tableNumber
        );
        const isDisabled = joinedTables.some(
          (joinedTable) => joinedTable.areaId !== area.id
        );
        return /* @__PURE__ */ React__default.createElement(Spacer, { key: table.tableNumber }, /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.tableOption,
            onClick: () => {
              selectTable(table, isJoined, isSelected, isDisabled);
            },
            onKeyDown: (event) => {
              if (event.key === "Enter") {
                selectTable(table, isJoined, isSelected, isDisabled);
              }
            },
            title: `Tables: ${table.tableNumber}`,
            tabIndex: 0
          },
          isJoined && /* @__PURE__ */ React__default.createElement(
            Checkbox,
            {
              color: theme2.colors.charcoal,
              selected: isSelected,
              onChange: (selected) => toggleJoinedTable(selected, table),
              style: { checkboxBox: { height: "24px", width: "24px" } },
              disabled: isDisabled
            }
          ),
          /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableNumber }, table.tableNumber),
          table.isJoin && /* @__PURE__ */ React__default.createElement(TableJoinedSVG, { style: { height: "26px" } }),
          /* @__PURE__ */ React__default.createElement(Spacer, null, /* @__PURE__ */ React__default.createElement(GuestSVG, { height: 16 }), /* @__PURE__ */ React__default.createElement(
            Box,
            {
              style: { whiteSpace: "nowrap" }
            },
            `${table.min}-${table.max}`
          )),
          !table.isPublic && /* @__PURE__ */ React__default.createElement(Label$1, null, "Private"),
          getAvailabilityPill(table.available)
        ));
      }))))))
    ), isJoined && /* @__PURE__ */ React__default.createElement(Spacer, { className: classes.footer, style: { justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        style: {
          ...smallButtonStyle,
          container: {
            ...smallButtonStyle == null ? void 0 : smallButtonStyle.container,
            width: "fit-content"
          }
        },
        onClick: () => {
          setJoinedTables([]);
          setIsJoined(!isJoined);
        }
      },
      "Cancel"
    ), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        style: {
          ...smallButtonStyle,
          container: {
            ...smallButtonStyle == null ? void 0 : smallButtonStyle.container,
            width: "fit-content"
          }
        },
        disabled: joinedTables.length < 2,
        onClick: handleCreateJoin
      },
      "Join selected tables"
    )))
  );
};
TableSelectorPopover.defaultProps = {
  anchorEl: null,
  clearError: () => {
  },
  setIsAvailableTable: () => {
  },
  setIsCreatedTable: () => {
  },
  bookingId: null,
  areaId: null,
  fromForceBooking: false,
  innerProps: {}
};
TableSelectorPopover.propTypes = {
  obeeTables: tablesPropTypes.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  anchorEl: PropTypes.shape({}),
  setAnchorEl: PropTypes.func.isRequired,
  areaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setTable: PropTypes.func.isRequired,
  setIsAvailableTable: PropTypes.func,
  setIsCreatedTable: PropTypes.func,
  clearError: PropTypes.func,
  obeeBookings: obeeBookingsPropTypes.isRequired,
  time: PropTypes.number.isRequired,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired,
  bookingId: PropTypes.number,
  setAreaId: PropTypes.func.isRequired,
  fromForceBooking: PropTypes.bool
};
const mapStateToProps$3o = (state) => ({
  obeeAreas: state.areas,
  obeeTables: state.tables,
  obeeBookings: state.obeeBookings,
  fullyBookedSessions: state.fullyBookedSessions
});
const mapDispatchToProps$3n = (dispatch) => bindActionCreators({}, dispatch);
const TableSelectorPopover$1 = connect(mapStateToProps$3o, mapDispatchToProps$3n)(TableSelectorPopover);
const useStyles$1O = createUseStyles((theme2) => ({
  container: (props) => {
    var _a;
    return {
      "& input": {
        "&::placeholder": {
          color: theme2.colors.nimbus,
          ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.placeholder
        }
      }
    };
  }
}));
const CleanTextField$1 = ({
  label,
  value,
  onChange,
  autofocus,
  onFocus: onFocus2,
  onBlur: onBlur2,
  style,
  required,
  disabled,
  editable,
  error,
  showOutline,
  ...others
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1O({ style });
  return /* @__PURE__ */ React__default.createElement(
    TextField$2,
    {
      className: classes.container,
      label,
      value,
      type: "text",
      onChange,
      placeholder: "Empty",
      autofocus,
      onFocus: onFocus2,
      onBlur: onBlur2,
      required,
      disabled,
      editable,
      error,
      ...others,
      style: {
        ...style,
        container: {
          ...style == null ? void 0 : style.container
        },
        innerContainer: {
          display: "flex",
          gap: "10px",
          alignItems: "baseline",
          ...style == null ? void 0 : style.innerContainer
        },
        label: {
          color: theme2.colors.smoke,
          width: "100px",
          flexShrink: 0,
          marginBottom: 0,
          ...style == null ? void 0 : style.label
        },
        textFieldInner: {
          ...style == null ? void 0 : style.textFieldInner
        },
        input: {
          border: showOutline ? `1px solid ${theme2.colors.shark}` : "1px solid transparent",
          width: "100%",
          color: disabled ? theme2.colors.nimbus : theme2.colors.charcoal,
          padding: "10px 14px",
          paddingLeft: "14px",
          borderRadius: "6px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          transition: "background-color 0.1s",
          height: "36px",
          ...style == null ? void 0 : style.input
        },
        inputActive: {
          outline: `1px solid ${theme2.colors.smoke}`,
          ...style == null ? void 0 : style.inputActive
        },
        inputHover: {
          backgroundColor: !disabled && theme2.colors.yetAnotherGray12,
          ...style == null ? void 0 : style.inputHover
        },
        placeholder: {
          color: theme2.colors.nimbus,
          ...style == null ? void 0 : style.placeholder
        },
        textField: {
          width: "100%",
          ...style == null ? void 0 : style.textField
        },
        errorText: {
          margin: "4px 0 0 110px",
          color: theme2.colors.red,
          fontSize: "10px",
          ...style == null ? void 0 : style.errorText
        },
        inputPrefix: {
          ...style == null ? void 0 : style.inputPrefix
        },
        disabled: {
          backgroundColor: theme2.colors.dateSelectBackground,
          borderRadius: "6px",
          ...style == null ? void 0 : style.disabled
        }
      }
    }
  );
};
CleanTextField$1.defaultProps = {
  label: "",
  value: "",
  onChange: () => {
  },
  onFocus: () => {
  },
  onBlur: () => {
  },
  autofocus: false,
  style: {},
  required: false,
  disabled: false,
  editable: true,
  showOutline: false,
  error: null
};
CleanTextField$1.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  autofocus: PropTypes.bool,
  style: PropTypes.shape({
    container: PropTypes.shape({}),
    innerContainer: PropTypes.shape({}),
    label: PropTypes.shape({}),
    textFieldInner: PropTypes.shape({}),
    input: PropTypes.shape({}),
    inputActive: PropTypes.shape({}),
    inputHover: PropTypes.shape({}),
    placeholder: PropTypes.shape({}),
    textField: PropTypes.shape({}),
    errorText: PropTypes.shape({}),
    inputPrefix: PropTypes.shape({}),
    disabled: PropTypes.shape({})
  }),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  editable: PropTypes.bool,
  showOutline: PropTypes.bool,
  error: PropTypes.string
};
const mapStateToProps$3n = () => ({});
const mapDispatchToProps$3m = (dispatch) => bindActionCreators({}, dispatch);
const CleanTextFieldComponent = connect(mapStateToProps$3n, mapDispatchToProps$3m)(CleanTextField$1);
const useStyles$1N = createUseStyles((theme2) => ({
  container: {
    position: "relative"
  },
  inputContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  tableNumber: {
    border: `1px solid ${theme2.colors.shark}`,
    color: theme2.colors.smoke,
    padding: "4px 6px",
    borderRadius: "4px",
    width: "fit-content",
    cursor: "pointer",
    userSelect: "none",
    "&:hover": {
      backgroundColor: theme2.colors.notificationBackgroundGray
    }
  },
  input: {
    "& input": {
      padding: "4px 8px !important"
    }
  }
}));
const TableUpdater = ({ obeeTables: obeeTables2, obeeAreas: obeeAreas2, booking, updateObeeBooking: updateObeeBooking2 }) => {
  const classes = useStyles$1N();
  const theme2 = useTheme$1();
  const [tableNumberAnchorEl, setTableNumberAnchorEl] = useState(null);
  const [noTableName, setNoTableName] = useState((booking == null ? void 0 : booking.tableNumber) || "");
  const onSelectTable = (newTable) => {
    if (isVoid(newTable)) {
      return;
    }
    updateObeeBooking2({
      ...booking,
      tableNumber: newTable == null ? void 0 : newTable.tableNumber,
      areaId: newTable == null ? void 0 : newTable.areaId
    });
    setTableNumberAnchorEl(null);
  };
  const onSelectArea = (newAreaId) => {
    updateObeeBooking2({
      ...booking,
      tableNumber: null,
      areaId: newAreaId
    });
  };
  const onNoTableNameChange = useCallback((value) => {
    //! This tableNumber cannot contain commas -> refer to getData in ObeeBookings.js
    setNoTableName(trim(value.replace(/,/g, "")));
  }, []);
  const onNoTableNameBlur = useCallback(() => {
    if (isEmpty(noTableName) && isEmpty(booking == null ? void 0 : booking.tableNumber)) {
      return;
    }
    if (noTableName === (booking == null ? void 0 : booking.tableNumber)) {
      return;
    }
    if ((booking == null ? void 0 : booking.tableNumber) !== noTableName) {
      updateObeeBooking2({
        ...booking,
        tableNumber: noTableName
      });
    }
  }, [noTableName, booking, updateObeeBooking2]);
  const area = getAreaById(obeeAreas2.data, booking == null ? void 0 : booking.areaId);
  const capacityBasedArea = isAreaCapacityBased(area, obeeTables2.data);
  const inputTextStyles = {
    fontSize: "15px",
    textFieldInner: {
      padding: "0",
      margin: "0"
    },
    input: {
      fontSize: "15px",
      textOverflow: "unset",
      resize: "none",
      height: "32px",
      maxWidth: "80px",
      minWidth: "60px",
      width: "100%",
      padding: "4px 8px",
      textAlign: "center",
      borderRadius: "8px",
      border: `1px solid ${theme2.colors.yetAnotherGray21}`
    },
    container: {},
    inputActive: {
      outline: "none"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, capacityBasedArea ? /* @__PURE__ */ React__default.createElement(Box, { className: classes.inputContainer }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      title: noTableName,
      value: noTableName,
      onChange: (value) => onNoTableNameChange(value),
      onBlur: () => onNoTableNameBlur(),
      className: classes.input,
      style: inputTextStyles
    }
  )) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.tableNumber,
      onClick: (e) => setTableNumberAnchorEl(e.currentTarget),
      onKeyDown: (event) => {
        if (event.key === "Enter") {
          setTableNumberAnchorEl(event.currentTarget);
        }
      },
      tabIndex: 0
    },
    (booking == null ? void 0 : booking.tableNumberDisplay) || "-"
  ), /* @__PURE__ */ React__default.createElement(
    TableSelectorPopover$1,
    {
      anchorEl: tableNumberAnchorEl,
      setAnchorEl: setTableNumberAnchorEl,
      areaId: "all",
      time: booking.startTime,
      setTable: onSelectTable,
      setAreaId: onSelectArea,
      date: booking.date,
      guestAmount: booking.size,
      bookingId: booking == null ? void 0 : booking.id
    }
  )));
};
TableUpdater.defaultProps = {};
TableUpdater.propTypes = {
  obeeTables: tablesPropTypes.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  booking: obeeBookingPropTypes.isRequired,
  updateObeeBooking: PropTypes.func.isRequired
};
const mapStateToProps$3m = (state) => ({
  obeeAreas: state.areas,
  obeeTables: state.tables
});
const mapDispatchToProps$3l = (dispatch) => bindActionCreators(
  {
    updateObeeBooking: updateObeeBookingAction
  },
  dispatch
);
const TableUpdater$1 = connect(mapStateToProps$3m, mapDispatchToProps$3l)(TableUpdater);
const SvgPencil = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M12.9568 5.01576L5.48978 12.5165C5.2411 12.7663 4.93083 12.9459 4.59039 13.0372L1.50114 13.8656C1.27825 13.9254 1.07415 13.7217 1.13355 13.4987L1.98146 10.3154C2.07281 9.97251 2.25374 9.66008 2.5057 9.41018L9.9336 2.04327M12.9568 5.01576L9.9336 2.04327M12.9568 5.01576L13.9112 4.08681C14.5102 3.50373 14.517 2.54344 13.9263 1.95193L13.0375 1.06203C12.4519 0.475596 11.5016 0.47529 10.9155 1.06134L9.9336 2.04327", stroke: "currentColor" }));
const EditSVG = SvgPencil;
const SvgCheckSmall = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 14 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M0.734375 6.84155L3.73438 9.84155L12.7344 0.841553", stroke: "currentColor", strokeWidth: 1.5 }));
const CheckSVG = SvgCheckSmall;
const SquareButton = ({ children, style, onClick, ...other }) => /* @__PURE__ */ React__default.createElement(
  Button,
  {
    type: "standard",
    style: {
      ...style,
      button: {
        backgroundColor: "white",
        padding: "9px 14px",
        border: "1px solid #DFDFDF",
        borderRadius: "6px",
        fontWeight: "400",
        boxShadow: "none",
        // eslint-disable-next-line react/prop-types
        ...style == null ? void 0 : style.button
      }
    },
    onClick,
    ...other
  },
  children
);
SquareButton.defaultProps = {
  children: null,
  style: {},
  onClick: () => {
  }
};
SquareButton.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({}),
  onClick: PropTypes.func
};
const useStyles$1M = createUseStyles(
  (theme2) => ({
    container: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "8px"
    },
    bookingStatus: {
      ...theme2.typography.heading.SUBHEAD,
      position: "relative",
      borderRadius: theme2.borderRadius.l,
      padding: "10px 13px",
      textTransform: "uppercase",
      backgroundColor: (props) => {
        var _a;
        return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.backgroundColor;
      },
      border: (props) => {
        var _a;
        return `1px solid ${(_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.outline}`;
      },
      color: (props) => {
        var _a;
        return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.color;
      },
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      letterSpacing: "1.2px",
      whiteSpace: "nowrap",
      // width: '125px', // TODO only have set width on runsheet
      justifyContent: "center",
      userSelect: "none",
      "&:hover": {
        cursor: "pointer"
      }
    },
    nextBookingStatus: {
      width: "66px",
      backgroundColor: `${theme2.colors.white} !important`,
      flexGrow: 1,
      padding: "10px 15px",
      gap: 0,
      justifyContent: "center",
      display: (props) => {
        var _a;
        return `${(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.nextButtonDisplay}` ?? "flex";
      }
    }
  }),
  { name: "StatusSelector" }
);
const SvgDownCaret = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 11 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M1 1L5.5 7L10 1", stroke: "currentColor" }));
const DownCaretSVG = SvgDownCaret;
const useStyles$1L = createUseStyles((theme2) => ({
  popoverContainer: {
    padding: "10px 0",
    "& $statusItemContainer": {
      "&:last-child": {
        "& $statusItemInnerContainer": {
          borderBottom: "none"
        }
      }
    }
  },
  statusActiveItem: {
    borderRadius: "100px",
    height: "45px",
    width: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  statusItemContainer: {
    color: theme2.colors.smoke,
    padding: "0 16px",
    transition: "background 0.1s",
    "&:hover": {
      background: theme2.colors.statusBackground,
      cursor: "pointer"
    }
  },
  statusItemInnerContainer: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    padding: "9px 0",
    borderBottom: `1px solid ${theme2.colors.cloud}`,
    fontSize: theme2.fontSizes.m2,
    lineHeight: "normal",
    color: theme2.colors.charcoal
  }
}));
const StatusPopover = ({
  statusListAnchorEl,
  setStatusListAnchorEl,
  onSave,
  obeeSettings: obeeSettings2,
  isWalkin,
  isWaitlist
}) => {
  var _a;
  const classes = useStyles$1L();
  const getStatusesLabel = (status) => {
    const bookingStatus = getStatusDetails(status);
    return /* @__PURE__ */ React__default.createElement(Box, { className: classes.statusItemContainer, onClick: () => onSave(status) }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.statusItemInnerContainer }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.statusActiveItem}`,
        style: {
          backgroundColor: bookingStatus == null ? void 0 : bookingStatus.backgroundColor,
          border: `1px solid ${(bookingStatus == null ? void 0 : bookingStatus.iconOutline) ?? (bookingStatus == null ? void 0 : bookingStatus.outline)}`
        }
      },
      status === STATUS_TYPES.CONFIRMED ? /* @__PURE__ */ React__default.createElement(
        CheckSVG,
        {
          style: {
            width: "8px",
            height: "8px"
          }
        }
      ) : ""
    ), /* @__PURE__ */ React__default.createElement(Box, null, bookingStatus == null ? void 0 : bookingStatus.label)));
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl: statusListAnchorEl,
      isOpen: !!statusListAnchorEl,
      onClose: () => setStatusListAnchorEl(null),
      innerStyle: { marginTop: "10px", borderRadius: "24px", padding: "0", minWidth: "200px" },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    },
    isWaitlist ? /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.popoverContainer }, !isWalkin && getStatusesLabel(STATUS_TYPES.BOOKED), getStatusesLabel(STATUS_TYPES.CONFIRMED), getStatusesLabel(STATUS_TYPES.CANCELLED))) : /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.popoverContainer }, !isWalkin && getStatusesLabel(STATUS_TYPES.BOOKED), !isWalkin && getStatusesLabel(STATUS_TYPES.CONFIRMED), getStatusesLabel(STATUS_TYPES.ARRIVED), getStatusesLabel(STATUS_TYPES.FINISHED), !isWalkin && getStatusesLabel(STATUS_TYPES.NO_SHOW), getStatusesLabel(STATUS_TYPES.CANCELLED), ((_a = obeeSettings2.data) == null ? void 0 : _a.waitlist) && getStatusesLabel(STATUS_TYPES.WAITING)))
  );
};
StatusPopover.defaultProps = {
  statusListAnchorEl: null,
  setStatusListAnchorEl: () => {
  },
  onSave: () => {
  },
  isWalkin: true,
  isWaitlist: false
};
StatusPopover.propTypes = {
  statusListAnchorEl: PropTypes.shape({}),
  setStatusListAnchorEl: PropTypes.func,
  onSave: PropTypes.func,
  obeeSettings: obeeSettingPropTypes.isRequired,
  isWalkin: PropTypes.bool,
  isWaitlist: PropTypes.bool
};
const mapStateToProps$3l = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$3k = (dispatch) => bindActionCreators({}, dispatch);
const StatusPopover$1 = connect(mapStateToProps$3l, mapDispatchToProps$3k)(StatusPopover);
const StatusSelector = ({
  status,
  onChange,
  onClose,
  style,
  booking,
  updateObeeBooking: updateObeeBooking2,
  obeeSettings: obeeSettings2,
  confirmWaitlist: confirmWaitlist2,
  confirmWaitlistAsBooked: confirmWaitlistAsBooked2
}) => {
  const bookingStatus = getStatusDetails(status);
  const nextBookingStatus = bookingStatus.nextStatus ? getStatusDetails(bookingStatus.nextStatus) : null;
  const classes = useStyles$1M({ bookingStatus, style });
  const [statusListAnchorEl, setStatusListAnchorEl] = useState(null);
  const isWalkin = (booking == null ? void 0 : booking.source) === "walkin";
  const onStatusSave = (newStatus) => {
    var _a;
    setStatusListAnchorEl(null);
    if (newStatus !== status) {
      onChange(newStatus);
      let newDuration = booking.duration;
      if (newStatus === STATUS_TYPES.FINISHED) {
        const nowAsInt = formatIntFromTime(moment$2());
        if (nowAsInt >= booking.startTime && nowAsInt < booking.endTime) {
          const timeInterval = (_a = obeeSettings2.data) == null ? void 0 : _a.systemTimeInterval;
          newDuration = roundToNearest(nowAsInt, timeInterval, "floor") - booking.startTime;
          newDuration = Math.max(newDuration, timeInterval);
        }
      }
      if (status === STATUS_TYPES.WAITING && newStatus === STATUS_TYPES.CONFIRMED) {
        confirmWaitlist2(booking.id);
        return;
      }
      if (booking.status === STATUS_TYPES.WAITING && newStatus === STATUS_TYPES.BOOKED) {
        confirmWaitlistAsBooked2(booking.id);
        return;
      }
      if (newStatus === STATUS_TYPES.WAITING) {
        updateObeeBooking2({
          ...booking,
          tableNumber: null,
          tableId: -1,
          areaId: 0,
          status: newStatus
        });
        return;
      }
      updateObeeBooking2({
        ...booking,
        duration: newDuration,
        status: newStatus
      });
    }
    onClose();
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, !!nextBookingStatus && /* @__PURE__ */ React__default.createElement(
    RoundButton,
    {
      style: { button: { padding: 0, border: "none", borderRadius: "unset" } },
      onClick: () => onStatusSave(nextBookingStatus.id)
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingStatus} ${classes.nextBookingStatus}` }, bookingStatus.nextStatusLabel)
  ), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.bookingStatus,
      onClick: (e) => setStatusListAnchorEl(e.currentTarget)
    },
    status === STATUS_TYPES.CONFIRMED && /* @__PURE__ */ React__default.createElement(
      CheckSVG,
      {
        style: {
          width: "10px",
          height: "7.5px"
        }
      }
    ),
    bookingStatus.label,
    /* @__PURE__ */ React__default.createElement(DownCaretSVG, { style: { width: "7px", height: "7px" } })
  ), /* @__PURE__ */ React__default.createElement(
    StatusPopover$1,
    {
      setStatusListAnchorEl,
      statusListAnchorEl,
      onSave: onStatusSave,
      isWalkin,
      isWaitlist: (booking == null ? void 0 : booking.status) === "waitlist"
    }
  ));
};
StatusSelector.defaultProps = {
  onChange: () => {
  },
  onClose: () => {
  },
  style: {}
};
StatusSelector.propTypes = {
  status: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  style: PropTypes.shape({}),
  booking: obeeBookingPropTypes.isRequired,
  updateObeeBooking: PropTypes.func.isRequired,
  confirmWaitlist: PropTypes.func.isRequired,
  confirmWaitlistAsBooked: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$3k = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$3j = (dispatch) => bindActionCreators(
  {
    updateObeeBooking: updateObeeBookingAction,
    confirmWaitlist: confirmWaitlistAction,
    confirmWaitlistAsBooked: confirmWaitlistAsBookedAction
  },
  dispatch
);
const StatusSelector$1 = connect(mapStateToProps$3k, mapDispatchToProps$3j)(StatusSelector);
const RunSheetStatus = ({ booking }) => {
  return /* @__PURE__ */ React__default.createElement(
    StatusSelector$1,
    {
      status: booking.status,
      booking,
      style: { display: "flex", justifyContent: "flex-end" }
    }
  );
};
RunSheetStatus.propTypes = {
  booking: obeeBookingPropTypes.isRequired
};
const RunSheetStatus$1 = RunSheetStatus;
const useStyles$1K = createUseStyles(
  (theme2) => ({
    container: (props) => {
      var _a;
      return {
        display: "flex",
        gap: "8px",
        padding: ((_a = props == null ? void 0 : props.printStyles) == null ? void 0 : _a.container) || "0 8px 0 0",
        flexWrap: "wrap",
        alignItems: "center",
        "@media (max-width: 1024px)": {
          padding: "0 8px 0 0"
        }
      };
    },
    tag: {
      ...theme2.typography.heading.SUBHEAD,
      padding: "8px 16px",
      borderRadius: theme2.borderRadius.xxxl,
      backgroundColor: theme2.colors.whiteSmoke,
      display: "inline-flex",
      alignItems: "center",
      color: theme2.colors.jet,
      border: `1px solid ${theme2.colors.whiteSmoke}`
    },
    tagContainer: {
      gap: "8px"
    },
    blacklistTag: {
      backgroundColor: theme2.colors.blacklistBlack,
      color: theme2.colors.white
    },
    vipTag: {
      backgroundColor: theme2.colors.vipYellow
    },
    dietaryTag: (props) => {
      var _a, _b2, _c2;
      return {
        backgroundColor: ((_a = props == null ? void 0 : props.printStyles) == null ? void 0 : _a.dietaryTag) ? theme2.colors.white : theme2.colors.darkYellowBrown,
        color: ((_b2 = props == null ? void 0 : props.printStyles) == null ? void 0 : _b2.dietaryTag) ? (_c2 = props == null ? void 0 : props.printStyles) == null ? void 0 : _c2.dietaryTag : theme2.colors.white,
        cursor: "pointer"
      };
    },
    birthdayTag: {
      backgroundColor: theme2.colors.birthdayPurple
    },
    favouriteTag: {
      backgroundColor: theme2.colors.favouriteBrown,
      padding: "7px 16px",
      gap: "6px",
      cursor: "pointer"
    },
    tagLabel: {
      color: theme2.colors.charcoal,
      fontWeight: theme2.fontWeights.medium
    },
    tagContent: {
      color: theme2.colors.charcoal
    },
    activeTag: {
      border: `1.5px solid ${theme2.colors.black}`
    }
  }),
  { name: "RunSheetTags" }
);
const SvgStar = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 18, height: 17, viewBox: "0 0 18 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M8.52447 1.08156C8.67415 0.620905 9.32585 0.620901 9.47553 1.08156L10.7696 5.06434C10.9704 5.68237 11.5464 6.10081 12.1962 6.10081H16.3839C16.8683 6.10081 17.0697 6.72062 16.6778 7.00532L13.2899 9.46681C12.7641 9.84878 12.5442 10.5258 12.745 11.1439L14.0391 15.1266C14.1887 15.5873 13.6615 15.9704 13.2696 15.6857L9.88168 13.2242C9.35595 12.8422 8.64405 12.8422 8.11832 13.2242L4.73037 15.6857C4.33851 15.9704 3.81127 15.5873 3.96095 15.1266L5.25503 11.1439C5.45584 10.5258 5.23585 9.84878 4.71012 9.46681L1.32217 7.00532C0.930313 6.72062 1.1317 6.10081 1.61606 6.10081H5.8038C6.45364 6.10081 7.02958 5.68237 7.23039 5.06434L8.52447 1.08156Z", stroke: "currentColor" }));
const StarIcon = SvgStar;
const useStyles$1J = createUseStyles((theme2) => ({
  container: {
    position: "relative",
    backgroundColor: theme2.colors.white,
    borderRadius: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${theme2.colors.cloud}`
  },
  arrow: {
    display: "block",
    height: "19px",
    width: "19px",
    backgroundColor: theme2.colors.white,
    border: "inherit",
    position: "absolute",
    top: "-9px",
    left: "calc(50% - 10px)",
    clipPath: "polygon(0% 0%, 100% 100%, 0% 100%)",
    transform: "rotate(-225deg)",
    borderRadius: "0 0 0 6px"
  },
  tooltipContainer: {
    maxWidth: "330px"
  },
  tooltipContentContainer: {
    display: "flex",
    flexDirection: "column"
  },
  favouritesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    fontSize: "15px",
    color: theme2.colors.charcoal,
    padding: "16px 20px"
  },
  favouritesLabel: {
    fontWeight: theme2.fontWeights.medium
  },
  favouritesContent: {
    color: theme2.colors.smoke
  },
  borderTop: {
    borderTop: `1px solid ${theme2.colors.yetAnotherGray13}`
  }
}));
const FavouritesPopover = ({ anchor, setAnchor, booking, innerStyle }) => {
  var _a;
  const classes = useStyles$1J();
  const theme2 = useTheme$1();
  const guestsData = ((_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a.data) || (booking == null ? void 0 : booking.guests) || [];
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl: anchor,
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      innerStyle: {
        borderRadius: "24px",
        border: "none",
        backgroundColor: theme2.colors.white,
        boxShadow: `0px 4px 8px 0px rgba(151, 151, 151, 0.25)`,
        marginTop: "15px",
        padding: 0,
        overflow: "visible",
        ...innerStyle
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.arrow }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.tooltipContainer }, guestsData.map((guest) => {
      return /* @__PURE__ */ React__default.createElement(Box, { key: guest.id, className: classes.tooltipContentContainer }, !isEmpty(guest.favouriteDrinks) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.favouritesContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.favouritesLabel }, "Favourite drinks"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.favouritesContent }, guest.favouriteDrinks)), !isEmpty(guest.favouriteMeals) && /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: `${classes.favouritesContainer} ${!isEmpty(guest.favouriteDrinks) ? classes.borderTop : ""}`
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.favouritesLabel }, "Favourite meals"),
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.favouritesContent }, guest.favouriteMeals)
      ));
    })))
  );
};
FavouritesPopover.defaultProps = {
  anchor: null,
  setAnchor: () => {
  },
  innerStyle: {},
  booking: null
};
FavouritesPopover.propTypes = {
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func,
  innerStyle: PropTypes.shape({}),
  booking: obeeBookingPropTypes
};
const mapStateToProps$3j = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$3i = (dispatch) => bindActionCreators({}, dispatch);
const FavouritesPopover$1 = connect(mapStateToProps$3j, mapDispatchToProps$3i)(FavouritesPopover);
const useStyles$1I = createUseStyles((theme2) => ({
  container: {
    position: "relative",
    backgroundColor: theme2.colors.white,
    borderRadius: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${theme2.colors.cloud}`
  },
  arrow: {
    display: "block",
    height: "19px",
    width: "19px",
    backgroundColor: theme2.colors.white,
    border: "inherit",
    position: "absolute",
    top: "-9px",
    clipPath: "polygon(0% 0%, 100% 100%, 0% 100%)",
    transform: "rotate(-225deg)",
    borderRadius: "0 0 0 6px"
  },
  tooltipContainer: {
    maxWidth: "330px"
  },
  tooltipContentContainer: {
    display: "flex",
    flexDirection: "column"
  },
  dietariesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    fontSize: "15px",
    color: theme2.colors.charcoal,
    padding: "16px 20px"
  },
  dietariesLabel: {
    fontWeight: theme2.fontWeights.medium
  },
  dietariesContent: {
    color: theme2.colors.smoke
  },
  borderTop: {
    borderTop: `1px solid ${theme2.colors.yetAnotherGray13}`
  }
}));
const DietariesPopover = ({ anchor, setAnchor, booking, innerStyle }) => {
  var _a;
  const classes = useStyles$1I();
  const theme2 = useTheme$1();
  const guestsData = ((_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a.data) || (booking == null ? void 0 : booking.guests) || [];
  const hasDietaryInCustomerComment = hasDietaries(booking == null ? void 0 : booking.customerComments);
  const hasDietaryInRestaurantComment = hasDietaries(booking == null ? void 0 : booking.restaurantComments);
  const anchorPos = anchor == null ? void 0 : anchor.getBoundingClientRect();
  const anchorWidth = (anchorPos == null ? void 0 : anchorPos.width) || 0;
  const anchorLeft = (anchorPos == null ? void 0 : anchorPos.left) || 0;
  const arrowWidth = 27;
  const anchorCenter = anchorLeft + anchorWidth / 2 - arrowWidth;
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl: anchor,
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      innerStyle: {
        borderRadius: "24px",
        border: "none",
        backgroundColor: theme2.colors.white,
        boxShadow: `0px 4px 8px 0px rgba(151, 151, 151, 0.25)`,
        marginTop: "15px",
        padding: 0,
        overflow: "visible",
        ...innerStyle
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.arrow, style: { left: `${anchorCenter}px` } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.tooltipContainer }, guestsData.map((guest) => {
      return /* @__PURE__ */ React__default.createElement(Box, { key: guest.id, className: classes.tooltipContentContainer }, !isEmpty(guest.allergies) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.dietariesContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.dietariesLabel }, "Guest dietary"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.dietariesContent }, guest.allergies)));
    }), (hasDietaryInCustomerComment || hasDietaryInRestaurantComment) && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.dietariesContainer}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.dietariesLabel }, "Booking comment dietary"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.dietariesContent }, hasDietaryInCustomerComment ? booking == null ? void 0 : booking.customerComments : booking == null ? void 0 : booking.restaurantComments))))
  );
};
DietariesPopover.defaultProps = {
  anchor: null,
  setAnchor: () => {
  },
  innerStyle: {},
  booking: null
};
DietariesPopover.propTypes = {
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func,
  innerStyle: PropTypes.shape({}),
  booking: obeeBookingPropTypes
};
const mapStateToProps$3i = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$3h = (dispatch) => bindActionCreators({}, dispatch);
const DietariesPopover$1 = connect(mapStateToProps$3i, mapDispatchToProps$3h)(DietariesPopover);
const RunSheetTags = ({
  booking,
  runsheetDisplayMode,
  runsheetDisplayModeOverview,
  primaryTagsOnly,
  printStyles
}) => {
  const classes = useStyles$1K({ printStyles });
  const isVip = getVIPstatus(booking);
  const isBlacklisted = getBlacklistStatus(booking);
  const isBirthday = !!(booking == null ? void 0 : booking.isBirthday);
  const isAnniversary = !!(booking == null ? void 0 : booking.isAnniversary);
  const isCelebration = !!(booking == null ? void 0 : booking.isCelebration);
  const hasDietaries2 = !!(booking == null ? void 0 : booking.hasDietaries);
  const hasFavourites = !!(booking == null ? void 0 : booking.hasFavourites);
  const [favouritesAnchor, setFavouritesAnchor] = useState(null);
  const [dietariesAnchor, setDietariesAnchor] = useState(null);
  const secondaryTags = useMemo(() => getSecondaryTags(), []);
  const showSecondaryTag = (tag) => {
    if (primaryTagsOnly || runsheetDisplayMode !== RUNSHEET_DISPLAYMODE.ALL && !!runsheetDisplayModeOverview[tag] === false) {
      return null;
    }
    if (tag === "Booked on" && (booking == null ? void 0 : booking.source) === "walkin") {
      return null;
    }
    const tagValue = getShowSecondaryTag(booking, tag);
    return tagValue !== "" ? /* @__PURE__ */ React__default.createElement(Box, { key: tag, className: `${classes.tag} ${classes.tagContainer}` }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tagLabel}` }, tag), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tagContent}` }, tagValue)) : null;
  };
  const hasTags = !isEmpty(
    [
      isVip,
      hasDietaries2,
      isBirthday,
      isAnniversary,
      isCelebration,
      hasFavourites,
      ...secondaryTags.map((tag) => showSecondaryTag(tag))
    ].filter((tag) => !!tag)
  );
  if (!hasTags) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.container}` }, isBlacklisted && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.blacklistTag}` }, "Blacklisted"), isVip && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.vipTag}` }, "VIP"), hasDietaries2 && /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.tag} ${classes.dietaryTag}`,
      onClick: (e) => {
        e.stopPropagation();
        setDietariesAnchor(e.currentTarget);
      }
    },
    "Dietaries"
  ), isBirthday && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.birthdayTag}` }, "Birthday"), isAnniversary && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.birthdayTag}` }, "Anniversary"), isCelebration && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.birthdayTag}` }, "Celebration"), hasFavourites && /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.tag} ${classes.favouriteTag} ${favouritesAnchor ? classes.activeTag : ""}`,
      onClick: (e) => {
        e.stopPropagation();
        setFavouritesAnchor(e.currentTarget);
      }
    },
    /* @__PURE__ */ React__default.createElement(StarIcon, { width: "17", height: "17" }),
    /* @__PURE__ */ React__default.createElement(Box, null, "Food & drinks")
  ), secondaryTags.map((tag) => showSecondaryTag(tag)), hasFavourites && /* @__PURE__ */ React__default.createElement(
    FavouritesPopover$1,
    {
      anchor: favouritesAnchor,
      onClose: () => setFavouritesAnchor(null),
      setAnchor: setFavouritesAnchor,
      booking
    }
  ), hasDietaries2 && /* @__PURE__ */ React__default.createElement(
    DietariesPopover$1,
    {
      anchor: dietariesAnchor,
      onClose: () => setDietariesAnchor(null),
      setAnchor: setDietariesAnchor,
      booking
    }
  ));
};
RunSheetTags.defaultProps = {
  printStyles: {},
  primaryTagsOnly: false
};
RunSheetTags.propTypes = {
  booking: obeeBookingPropTypes.isRequired,
  printStyles: PropTypes.shape({}),
  runsheetDisplayMode: PropTypes.string.isRequired,
  runsheetDisplayModeOverview: PropTypes.shape({}).isRequired,
  primaryTagsOnly: PropTypes.bool
};
const mapStateToProps$3h = (state) => ({
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode,
  runsheetDisplayModeOverview: state.obeeScreen.runsheetDisplayModeOverview,
  settings: state.obeeSettings
});
const mapDispatchToProps$3g = (dispatch) => bindActionCreators({}, dispatch);
const RunSheetTags$1 = connect(mapStateToProps$3h, mapDispatchToProps$3g)(RunSheetTags);
const useStyles$1H = createUseStyles((theme2) => ({
  header: {
    height: "36px",
    width: "100%",
    backgroundColor: theme2.colors.linen,
    display: "flex",
    justifyContent: "flex-end"
  },
  commentsPopoverContent: {
    padding: "30px",
    maxWidth: "300px",
    whiteSpace: "pre-wrap",
    textAlign: "left",
    alignItems: "left",
    display: "flex",
    flexDirection: "column",
    gap: "30px"
  },
  commentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  },
  heading: {
    fontSize: "18px",
    fontWeight: theme2.fontWeights.medium
  },
  comment: {
    color: theme2.colors.smoke
  }
}));
const CommentsPopover = ({ anchor, setAnchor, booking, innerStyle }) => {
  const classes = useStyles$1H();
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl: anchor,
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      innerStyle: {
        borderRadius: "12px",
        padding: "0",
        minWidth: "150px",
        marginLeft: "12px",
        marginTop: "0",
        ...innerStyle
      },
      anchorOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { onMouseOver: (e) => e.stopPropagation() }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: { padding: "10px 16px 10px 10px" },
        onClick: (e) => {
          e.stopPropagation();
          setAnchor(null);
        }
      },
      /* @__PURE__ */ React__default.createElement(CloseSVG, { width: "14", height: "14" })
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.commentsPopoverContent }, (booking == null ? void 0 : booking.customerComments) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.commentContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Guest comments"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.comment }, booking == null ? void 0 : booking.customerComments)), (booking == null ? void 0 : booking.restaurantComments) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.commentContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Restaurant comments"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.comment }, booking == null ? void 0 : booking.restaurantComments))))
  );
};
CommentsPopover.defaultProps = {
  anchor: null,
  setAnchor: () => {
  },
  innerStyle: {},
  booking: null
};
CommentsPopover.propTypes = {
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func,
  innerStyle: PropTypes.shape({}),
  booking: obeeBookingPropTypes
};
const mapStateToProps$3g = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$3f = (dispatch) => bindActionCreators({}, dispatch);
const CommentsPopover$1 = connect(mapStateToProps$3g, mapDispatchToProps$3f)(CommentsPopover);
const DynamicText = ({ text }) => {
  const [numLines, setNumLines] = useState(1);
  const textRef = useRef(null);
  const width = useWindowSize()[0];
  useLayoutEffect(() => {
    const lineHeight2 = parseInt(window.getComputedStyle(textRef.current).lineHeight, 10);
    const containerHeight = textRef.current.clientHeight;
    const containerWidth = textRef.current.clientWidth;
    const calculatedNumLines = Math.round(containerHeight / lineHeight2);
    if (calculatedNumLines === 3) {
      if (containerWidth <= 470) {
        setNumLines(calculatedNumLines);
      }
    } else {
      setNumLines(calculatedNumLines);
    }
  }, [text, width]);
  let fontSize;
  let lineHeight;
  if (numLines === 3) {
    fontSize = "12px";
    lineHeight = "14px";
  } else {
    fontSize = "15px";
    lineHeight = "17px";
  }
  return /* @__PURE__ */ React__default.createElement("div", { style: { fontSize, lineHeight }, ref: textRef }, text);
};
const ReadMore = ({ text, commentAnchorEl, setCommentAnchorEl, showFullComments }) => {
  const classes = useStyles$1V();
  const hasShowMore = showFullComments ? false : text.length > 100;
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.inlineCommentsContainer} ${showFullComments ? classes.printedInlineCommentsContainer : ""}`
    },
    /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.inlineCommentsInnerContainer} ${showFullComments ? classes.printedCommentsInnerContainer : ""}`
      },
      /* @__PURE__ */ React__default.createElement("span", { className: classes.inlineCommentsHeader }, "Comments - "),
      /* @__PURE__ */ React__default.createElement("span", null, `${showFullComments ? text : text.slice(0, 100)}${hasShowMore ? "..." : ""}`),
      hasShowMore && /* @__PURE__ */ React__default.createElement(
        Box,
        {
          onClick: (e) => setCommentAnchorEl(e.currentTarget),
          className: classes.inlineCommentsReadMore
        },
        commentAnchorEl === null ? "Show more" : " Show less"
      )
    )
  );
};
const RunSheetCommentsView = ({ booking, classnames, showFullComments }) => {
  const classes = useStyles$1V();
  const theme2 = useTheme$1();
  const isMobile = useBreakpointDown(runsheetIpadViewBreakpoint);
  const [commentAnchorEl, setCommentAnchorEl] = useState(null);
  const getComments = () => {
    if (isEmpty(booking == null ? void 0 : booking.restaurantComments) && isEmpty(booking == null ? void 0 : booking.customerComments)) {
      return "No comments";
    }
    return isMobile || showFullComments ? /* @__PURE__ */ React__default.createElement(
      ReadMore,
      {
        text: getFullComments(booking),
        commentAnchorEl,
        setCommentAnchorEl,
        showFullComments
      }
    ) : /* @__PURE__ */ React__default.createElement(DynamicText, { text: getFullComments(booking) });
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.bookingCardCommentRow} ${!showFullComments ? classes.bookingCardCommentOverflow : ""} ${classnames}`,
      title: getFullComments(booking),
      style: {
        color: isEmpty(booking.restaurantComments) && isEmpty(booking.customerComments) && theme2.colors.nimbus
      }
    },
    getComments()
  ), !showFullComments && /* @__PURE__ */ React__default.createElement(
    CommentsPopover$1,
    {
      booking,
      setAnchor: setCommentAnchorEl,
      anchor: commentAnchorEl,
      innerStyle: {
        marginBottom: "10px",
        marginTop: "-10px"
      }
    }
  ));
};
RunSheetCommentsView.defaultProps = {
  classnames: "",
  showFullComments: false
};
RunSheetCommentsView.propTypes = {
  booking: runSheetBookingPropTypes.isRequired,
  classnames: PropTypes.string,
  showFullComments: PropTypes.bool
};
DynamicText.propTypes = {
  text: PropTypes.string.isRequired
};
ReadMore.defaultProps = {
  commentAnchorEl: null,
  setCommentAnchorEl: () => {
  }
};
ReadMore.propTypes = {
  text: PropTypes.string.isRequired,
  showFullComments: PropTypes.bool.isRequired,
  commentAnchorEl: PropTypes.shape({}),
  setCommentAnchorEl: PropTypes.func
};
const RunSheetCommentsView$1 = RunSheetCommentsView;
const useStyles$1G = createUseStyles((theme2) => ({
  container: (props) => {
    var _a, _b2, _c2, _d2;
    return {
      display: "inline-flex",
      padding: "0 10px",
      marginLeft: "auto",
      borderRadius: "4px",
      lineHeight: "24px",
      position: "relative",
      fontSize: "12px",
      fontWeight: theme2.fontWeights.regular,
      textTransform: "uppercase",
      color: (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.color,
      userSelect: "none",
      width: "fit-content",
      backgroundColor: (_b2 = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _b2.backgroundColor,
      border: `1px solid ${((_c2 = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _c2.iconOutline) ?? ((_d2 = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _d2.outline)}`,
      alignItems: "center",
      gap: "5px"
    };
  },
  bookingStatus: {
    ...theme2.typography.heading.SUBHEAD,
    position: "relative",
    borderRadius: theme2.borderRadius.s,
    padding: "4px 10px",
    textTransform: "uppercase",
    backgroundColor: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.backgroundColor;
    },
    color: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.color;
    },
    display: "flex",
    alignItems: "center",
    gap: "8px",
    letterSpacing: "1.2px",
    whiteSpace: "nowrap",
    "&:hover": {
      cursor: "pointer"
    }
  },
  bookingStatusPill: {
    width: "12px",
    height: "45px",
    borderRadius: theme2.borderRadius.xxxl,
    backgroundColor: (props) => {
      var _a;
      return ((_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.backgroundColor) ?? theme2.colors.linen;
    },
    position: "relative"
  },
  bookingEditByGuest: {
    boxShadow: `0 0 0px 1px ${theme2.colors.black}, 0 0 0px 4px white, 0px 0px 0 5px ${theme2.colors.charcoal}`,
    cursor: "pointer",
    marginTop: "8px",
    marginBottom: "5px"
  },
  runsheetFinishedTextLineThrough: {
    textDecoration: (props) => {
      var _a;
      return ((_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.runsheetTextDecoration) ?? "none";
    }
  },
  runsheetFinishedText: {
    color: (props) => {
      var _a;
      return ((_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.runsheetText) ?? "inherit";
    }
  },
  bookingStatusPillConfirmed: {
    border: (props) => {
      var _a;
      return ((_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.outline) ? `1px solid ${props.bookingStatus.outline}` : "none";
    }
  },
  bookingStatusPillConfirmedCheck: {
    position: "absolute",
    top: "50%",
    left: "50%",
    padding: "6px",
    borderRadius: theme2.borderRadius.xxxl,
    backgroundColor: (props) => {
      var _a;
      return ((_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.backgroundColor) ?? theme2.colors.linen;
    },
    border: (props) => {
      var _a;
      return ((_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.outline) ? `1px solid ${props.bookingStatus.outline}` : "none";
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transform: "translate(-50%, -50%)"
  }
}));
const SvgSpeechBubble = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("mask", { id: "path-1-inside-1_13633_61568", fill: "white" }, /* @__PURE__ */ React$7.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1836 17.1484C18.927 15.3281 20 12.8473 20 10.113C20 4.52774 15.5228 0 10 0C4.47715 0 0 4.52774 0 10.113C0 15.6982 4.47715 20.226 10 20.226C11.4004 20.226 12.7336 19.9348 13.9436 19.4092L18.8702 20.9935C18.9799 21.0287 19.0782 20.9133 19.0263 20.8101L17.1836 17.1484Z" })), /* @__PURE__ */ React$7.createElement("path", { d: "M17.1836 17.1484L16.4614 16.4566L15.9727 16.9668L16.2903 17.5979L17.1836 17.1484ZM13.9436 19.4092L14.2498 18.4572L13.8909 18.3418L13.5452 18.492L13.9436 19.4092ZM18.8702 20.9935L19.1764 20.0415L19.1764 20.0415L18.8702 20.9935ZM19.0263 20.8101L19.9195 20.3606L19.9195 20.3606L19.0263 20.8101ZM19 10.113C19 12.5809 18.0326 14.8162 16.4614 16.4566L17.9057 17.8401C19.8214 15.84 21 13.1137 21 10.113H19ZM10 1C14.96 1 19 5.0694 19 10.113H21C21 3.98607 16.0857 -1 10 -1V1ZM1 10.113C1 5.0694 5.04 1 10 1V-1C3.91431 -1 -1 3.98607 -1 10.113H1ZM10 19.226C5.04 19.226 1 15.1566 1 10.113H-1C-1 16.2399 3.91431 21.226 10 21.226V19.226ZM13.5452 18.492C12.4584 18.9641 11.2606 19.226 10 19.226V21.226C11.5403 21.226 13.0089 20.9055 14.3421 20.3264L13.5452 18.492ZM19.1764 20.0415L14.2498 18.4572L13.6375 20.3612L18.5641 21.9455L19.1764 20.0415ZM18.133 21.2596C17.7907 20.5795 18.4319 19.8021 19.1764 20.0415L18.5641 21.9455C19.5279 22.2554 20.3656 21.247 19.9195 20.3606L18.133 21.2596ZM16.2903 17.5979L18.133 21.2596L19.9195 20.3606L18.0768 16.6988L16.2903 17.5979Z", fill: "currentColor", mask: "url(#path-1-inside-1_13633_61568)" }), /* @__PURE__ */ React$7.createElement("ellipse", { cx: 5.87852, cy: 10.1134, rx: 1.05626, ry: 1.06819, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("ellipse", { cx: 9.99962, cy: 10.1131, rx: 1.05626, ry: 1.06819, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("ellipse", { cx: 14.1188, cy: 10.1134, rx: 1.05626, ry: 1.06819, fill: "currentColor" }));
const SpeechBubbleIconSVG = SvgSpeechBubble;
const RunSheetBooking = ({
  booking,
  setObeeShowAddBookingModal,
  setObeeBookingDetailsModal,
  isWaitlist,
  areaName,
  settings,
  runsheetDisplayMode,
  runsheetDisplayModeOverview
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const bookingStatus = getStatusDetails(booking == null ? void 0 : booking.status);
  const theme2 = useTheme$1();
  const classes = useStyles$1V();
  const statusClasses = useStyles$1G({ bookingStatus });
  const isMobile = useBreakpointDown(runsheetIpadViewBreakpoint);
  const canSendMessage = (booking == null ? void 0 : booking.status) === STATUS_TYPES.WAITING && ((_b2 = (_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a[0]) == null ? void 0 : _b2.mobile) && ((_e2 = (_d2 = (_c2 = settings == null ? void 0 : settings.data) == null ? void 0 : _c2.messaging) == null ? void 0 : _d2.sms_waitlist) == null ? void 0 : _e2.enabled);
  const [messagesAnchor, setMessagesAnchor] = useState(null);
  const [historyAnchorEl, setHistoryAnchorEl] = useState(null);
  const [sourceAnchorEl, setSourceAnchorEl] = useState(null);
  const smallButtonStyles2 = {
    button: {
      padding: "10px 12px",
      outline: `1px solid ${theme2.colors.yetAnotherGray21}`,
      borderRadius: "8px",
      alignItems: "center"
    }
  };
  const smsButtonStyles = {
    button: {
      ...smallButtonStyles2.button,
      padding: "2px 8px"
    }
  };
  const showBookingDetails = (bookingId, tab = "booking") => {
    setObeeShowAddBookingModal(false);
    setObeeBookingDetailsModal(bookingId, tab);
  };
  const kidsText = getKidsText(booking);
  const smsMessage = extractSmsMessage(booking, (_h = (_g = (_f = settings == null ? void 0 : settings.data) == null ? void 0 : _f.messaging) == null ? void 0 : _g.sms_waitlist) == null ? void 0 : _h.smsBody);
  const waitlistOverdueInMinutes = getWaitlistOverdueInMinutes(booking);
  const isWaitlistOverdue = waitlistOverdueInMinutes > 0;
  const numVisit = getNumberVisits(booking);
  const isWalkin = (booking == null ? void 0 : booking.source) === "walkin";
  const SHOW_SOURCE_COLUMN = useMemo(() => {
    return runsheetDisplayModeOverview.Source || runsheetDisplayMode === RUNSHEET_DISPLAYMODE.ALL;
  }, [runsheetDisplayModeOverview, runsheetDisplayMode]);
  const SHOW_BOOKINGS = useMemo(() => {
    if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.FINISHED) {
      if (!runsheetDisplayModeOverview["Finished bookings"] && runsheetDisplayMode === RUNSHEET_DISPLAYMODE.FILTERED) {
        return false;
      }
    }
    return true;
  }, [runsheetDisplayModeOverview, runsheetDisplayMode, booking == null ? void 0 : booking.status]);
  const hasComments = useMemo(() => {
    if (isEmpty(booking == null ? void 0 : booking.restaurantComments) && isEmpty(booking == null ? void 0 : booking.customerComments)) {
      return false;
    }
    return true;
  }, [booking == null ? void 0 : booking.restaurantComments, booking == null ? void 0 : booking.customerComments]);
  return SHOW_BOOKINGS && /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.bookingCardContainer} ${isMobile ? classes.mobileBookingCardContainer : ""}`
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardInnerContainer}` }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.arrivalColumn}` }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${statusClasses.bookingStatusPill} ${!isEmpty(booking.lastEditedByGuest) ? statusClasses.bookingEditByGuest : ""} ${(booking == null ? void 0 : booking.status) === STATUS_TYPES.CONFIRMED ? statusClasses.bookingStatusPillConfirmed : ""}`,
        onClick: (e) => !isEmpty(booking.lastEditedByGuest) ? setHistoryAnchorEl(e.currentTarget) : null,
        title: !isEmpty(booking.lastEditedByGuest) ? "Updated by Guest" : ""
      },
      (booking == null ? void 0 : booking.status) === STATUS_TYPES.CONFIRMED && /* @__PURE__ */ React__default.createElement(Box, { className: statusClasses.bookingStatusPillConfirmedCheck }, /* @__PURE__ */ React__default.createElement(
        CheckSVG,
        {
          style: {
            width: "6px",
            height: "5px"
          }
        }
      )),
      " "
    ), /* @__PURE__ */ React__default.createElement(Box, { className: `${statusClasses.runsheetFinishedText}` }, formatTimeFromInt(booking.startTime, "h:mma"))), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.guestColumn}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestItemContainer }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.guestItemName} ${statusClasses.runsheetFinishedText} ${statusClasses.runsheetFinishedTextLineThrough}`,
        title: getBookingName(booking),
        onClick: () => showBookingDetails(booking.id, "booking")
      },
      getBookingName(booking)
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestItemContainer }, !isEmpty((_j = (_i = booking.guests) == null ? void 0 : _i[0]) == null ? void 0 : _j.mobile) && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.guestItemNumber} ${statusClasses.runsheetFinishedText} ${statusClasses.runsheetFinishedTextLineThrough}`
      },
      (_l = (_k = booking.guests) == null ? void 0 : _k[0]) == null ? void 0 : _l.mobile
    ), !isWalkin && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.guestVisitNumber,
        onClick: () => showBookingDetails(booking.id, "history")
      },
      numVisit
    ))), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.partyColumn}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.partyItemContainer }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.partyItemSize} ${statusClasses.runsheetFinishedText}`,
        onClick: () => showBookingDetails(booking.id, "customer")
      },
      /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { height: "15px" } }),
      /* @__PURE__ */ React__default.createElement(Box, null, booking.size)
    ), !isEmpty(kidsText) && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${statusClasses.runsheetFinishedText} ${statusClasses.runsheetFinishedTextLineThrough}`,
        style: { fontSize: "12px", marginTop: "4px", whiteSpace: "pre" }
      },
      "inc. ",
      kidsText
    ))), !isWaitlist && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.tableColumn}` }, /* @__PURE__ */ React__default.createElement(TableUpdater$1, { booking })), !isWaitlist && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.areaColumn}` }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.areaName} ${statusClasses.runsheetFinishedText} ${statusClasses.runsheetFinishedTextLineThrough}`
      },
      areaName
    )), !isMobile && /* @__PURE__ */ React__default.createElement(
      RunSheetCommentsView$1,
      {
        booking,
        classnames: `${statusClasses.runsheetFinishedText} ${statusClasses.runsheetFinishedTextLineThrough}`
      }
    ), SHOW_SOURCE_COLUMN && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.sourceColumn}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingCardRow }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.bookingSourceIcon,
        onClick: (e) => setSourceAnchorEl(e.currentTarget)
      },
      getSourceIcon(booking)
    ))), isWaitlist && /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", className: classes.smsButtonRow }, canSendMessage && /* @__PURE__ */ React__default.createElement(
      SquareButton,
      {
        style: smsButtonStyles,
        onClick: (e) => {
          e.stopPropagation();
          setMessagesAnchor(e.currentTarget);
        }
      },
      /* @__PURE__ */ React__default.createElement(SpeechBubbleIconSVG, { style: { height: "15px", width: "15px" } })
    ), /* @__PURE__ */ React__default.createElement(Box, null, booking.status === STATUS_TYPES.WAITING && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Added:"), " ", formatTime(booking.createdAt), ",", " ", getRelativeTime(moment(booking.createdAt))), booking.status === STATUS_TYPES.WAITING && (booking == null ? void 0 : booking.quotedMins) > 0 && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Quoted:"), " ", `${booking.quotedMins} mins`, " ", isWaitlistOverdue ? /* @__PURE__ */ React__default.createElement("span", { style: { color: theme2.colors.red } }, "(", waitlistOverdueInMinutes, " mins)") : ""), canSendMessage && (!isEmpty((_m = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _m.dateTimeSent) || !isEmpty((_n = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _n.responseMessage)) && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, canSendMessage && !isEmpty((_o = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _o.dateTimeSent) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Sent:"), " ", formatTime(booking.waitlistSMS.dateTimeSent), ",", " ", getRelativeTime(moment(booking.waitlistSMS.dateTimeSent))), canSendMessage && !isEmpty(smsMessage) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage, title: smsMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Message:"), " ", smsMessage), canSendMessage && !isEmpty((_p = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _p.responseMessage) && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.smsMessage,
        title: (_q = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _q.responseMessage
      },
      /* @__PURE__ */ React__default.createElement("b", null, "Response:"),
      " ",
      (_r = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _r.responseMessage
    )))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.statusCell }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingButtonRow}` }, /* @__PURE__ */ React__default.createElement(
      SquareButton,
      {
        style: { ...smallButtonStyles2, button: { width: "40px" } },
        onClick: () => showBookingDetails(booking.id, "booking")
      },
      /* @__PURE__ */ React__default.createElement(EditSVG, { style: { height: "15px", width: "15px", flexShrink: 0 } })
    )), /* @__PURE__ */ React__default.createElement(RunSheetStatus$1, { booking })), /* @__PURE__ */ React__default.createElement(
      SendMessagePopover$1,
      {
        anchor: messagesAnchor,
        onClose: () => setMessagesAnchor(null),
        setAnchor: setMessagesAnchor,
        booking
      }
    ), /* @__PURE__ */ React__default.createElement(
      HistoryPopover$1,
      {
        anchor: historyAnchorEl,
        setAnchor: setHistoryAnchorEl,
        booking
      }
    ), /* @__PURE__ */ React__default.createElement(SourcePopover$1, { anchor: sourceAnchorEl, setAnchor: setSourceAnchorEl, booking })),
    isMobile && hasComments && /* @__PURE__ */ React__default.createElement(
      RunSheetCommentsView$1,
      {
        booking,
        classnames: `${statusClasses.runsheetFinishedText} ${statusClasses.runsheetFinishedTextLineThrough}`
      }
    ),
    /* @__PURE__ */ React__default.createElement(RunSheetTags$1, { booking })
  );
};
RunSheetBooking.defaultProps = {
  isWaitlist: false,
  areaName: "-"
};
RunSheetBooking.propTypes = {
  booking: runSheetBookingPropTypes.isRequired,
  setObeeShowAddBookingModal: PropTypes.func.isRequired,
  setObeeBookingDetailsModal: PropTypes.func.isRequired,
  isWaitlist: PropTypes.bool,
  areaName: PropTypes.string,
  settings: obeeSettingsPropTypes.isRequired,
  runsheetDisplayMode: PropTypes.string.isRequired,
  runsheetDisplayModeOverview: PropTypes.shape({}).isRequired
};
const mapStateToProps$3f = (state) => ({
  areas: state.areas,
  settings: state.obeeSettings,
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode,
  runsheetDisplayModeOverview: state.obeeScreen.runsheetDisplayModeOverview
});
const mapDispatchToProps$3e = (dispatch) => bindActionCreators(
  {
    setObeeShowAddBookingModal: setObeeShowAddBookingModalAction,
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction
  },
  dispatch
);
const RunSheetBooking$1 = connect(mapStateToProps$3f, mapDispatchToProps$3e)(RunSheetBooking);
const RunSheetList = ({
  name: name2,
  bookings,
  isWaitlist,
  areas,
  fullyBookedSessionAreas,
  sortable,
  obeeSettings: obeeSettings2,
  runsheetTimeSeparator,
  runsheetTimeSeparatorInterval,
  runsheetDisplayMode,
  runsheetDisplayModeOverview
}) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$1V();
  const totalGuests = bookings.reduce((accum, booking) => accum + ((booking == null ? void 0 : booking.size) || 0), 0);
  const emptyBookings = useMemo(() => bookings.length === 0 && !bookings.pending, [bookings]);
  const timeSeparator = !runsheetTimeSeparator || isEmpty(runsheetTimeSeparatorInterval) ? 0 : runsheetTimeSeparatorInterval / 3600;
  const bookingsByTimeSeparator = useMemo(() => {
    const bookingsGuestsByTimeSeparator = {};
    if (emptyBookings) {
      return bookingsGuestsByTimeSeparator;
    }
    if (timeSeparator === 0 || sortable.column.label !== DEFAULT_SORTABLE.column.label) {
      return {
        _0: {
          bookingNums: bookings.length,
          guests: totalGuests,
          label: "All",
          bookings,
          time: 0
        }
      };
    }
    bookings.forEach((booking) => {
      const bookingHour = (booking == null ? void 0 : booking.startTime) / 60;
      const bookingTimeSeparator = Math.floor(bookingHour / timeSeparator) * timeSeparator;
      if (!bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`]) {
        bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`] = {
          bookingNums: 0,
          guests: 0,
          label: formatTimeFromInt(bookingTimeSeparator * 60, "h:mma"),
          bookings: [],
          time: bookingTimeSeparator
        };
      }
      bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`].bookingNums += 1;
      bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`].guests += (booking == null ? void 0 : booking.size) || 0;
      bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`].bookings.push(booking);
    });
    return bookingsGuestsByTimeSeparator;
  }, [bookings, timeSeparator, emptyBookings, sortable.column.label]);
  const [sortableBookings, setSortableBookings] = useState([]);
  const TABLE_NUMBER_SORTABLE_KEY = "tableNumber";
  const areasById = useMemo(() => {
    return groupObjects(areas.data, "id", false);
  }, [areas.data]);
  const showSeparatorTotals = ((_b2 = (_a = obeeSettings2.data) == null ? void 0 : _a.runsheetSettings) == null ? void 0 : _b2.runsheetSeparatorShowTotals) === 1;
  const checkIfBookingsToShow = useCallback(
    (bookingsToCheck) => {
      if (isEmpty(bookingsToCheck)) {
        return false;
      }
      const showBookings = bookingsToCheck.some((booking) => {
        if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.FINISHED) {
          if (!runsheetDisplayModeOverview["Finished bookings"] && runsheetDisplayMode === RUNSHEET_DISPLAYMODE.FILTERED) {
            return false;
          }
        }
        return true;
      });
      return showBookings;
    },
    [runsheetDisplayModeOverview, runsheetDisplayMode]
  );
  useEffect(() => {
    let toBeSortedBookings = Object.values(bookingsByTimeSeparator);
    if (toBeSortedBookings.length === 0) {
      return;
    }
    if (sortable.column.label === DEFAULT_SORTABLE.column.label) {
      toBeSortedBookings = sortListByProperty(
        toBeSortedBookings,
        "time",
        sortable.direction !== "asc"
      );
    }
    const sortableBookingsObj = toBeSortedBookings.map((groupedBookings) => {
      const hasBookingsToShow = checkIfBookingsToShow(groupedBookings == null ? void 0 : groupedBookings.bookings);
      if (hasBookingsToShow) {
        groupedBookings.bookings = sortRunSheetListByProperty(
          sortable.column.label !== TABLE_NUMBER_SORTABLE_KEY ? sortRunSheetListByProperty(groupedBookings == null ? void 0 : groupedBookings.bookings, TABLE_NUMBER_SORTABLE_KEY) : groupedBookings == null ? void 0 : groupedBookings.bookings,
          sortable.column.sortKey,
          sortable.direction !== "asc"
        );
        return groupedBookings;
      }
      return null;
    }).filter((item) => item !== null);
    setSortableBookings(sortableBookingsObj);
  }, [
    bookingsByTimeSeparator,
    sortable.column,
    sortable.direction,
    timeSeparator,
    checkIfBookingsToShow
  ]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.listContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.listHeader }, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", alignItems: "center", gap: "12px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.listHeading }, name2), fullyBookedSessionAreas.length > 0 && /* @__PURE__ */ React__default.createElement(
    Label$1,
    {
      label: `Fully booked: ${fullyBookedSessionAreas.join(", ")}`,
      style: {
        backgroundColor: theme2.colors.infoBlueLight,
        fontWeight: theme2.fontWeights.medium
      }
    }
  ), emptyBookings && /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.yetAnotherGray25 } }, "No Bookings")), !emptyBookings && /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumbers }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumber }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryLabel }, "Guests"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, `${totalGuests}`)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumber }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryLabel }, "Bookings"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, bookings.length)))), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, !emptyBookings && /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionContainer }, sortableBookings == null ? void 0 : sortableBookings.map((groupedBookings) => {
    var _a2;
    const totalGroupedGuests = (groupedBookings == null ? void 0 : groupedBookings.guests) || 0;
    const totalGroupedBookings = (groupedBookings == null ? void 0 : groupedBookings.bookingNums) || 0;
    const hasBookingsToShow = checkIfBookingsToShow(groupedBookings == null ? void 0 : groupedBookings.bookings);
    return hasBookingsToShow && /* @__PURE__ */ React__default.createElement(Box, { key: groupedBookings == null ? void 0 : groupedBookings.label }, groupedBookings.label !== "All" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.hourDivider }, groupedBookings == null ? void 0 : groupedBookings.label, showSeparatorTotals && /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumbersHour }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumberHour }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryLabel }, "Guests"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, totalGroupedGuests)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumberHour }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryLabel }, "Bookings"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, totalGroupedBookings)))), totalGroupedBookings > 0 && ((_a2 = groupedBookings == null ? void 0 : groupedBookings.bookings) == null ? void 0 : _a2.map((booking) => {
      var _a3;
      return /* @__PURE__ */ React__default.createElement(
        RunSheetBooking$1,
        {
          key: booking == null ? void 0 : booking.id,
          booking,
          isWaitlist,
          areaName: (_a3 = areasById == null ? void 0 : areasById[booking == null ? void 0 : booking.areaId]) == null ? void 0 : _a3.name
        }
      );
    })));
  }))));
};
RunSheetList.defaultProps = {
  isWaitlist: false,
  name: "Unnamed session",
  fullyBookedSessionAreas: [],
  sortable: DEFAULT_SORTABLE
};
RunSheetList.propTypes = {
  name: PropTypes.string,
  bookings: PropTypes.arrayOf(runSheetBookingPropTypes).isRequired,
  isWaitlist: PropTypes.bool,
  areas: areasPropTypes.isRequired,
  fullyBookedSessionAreas: PropTypes.arrayOf(PropTypes.string),
  sortable: PropTypes.shape({
    column: PropTypes.shape({
      label: PropTypes.string,
      sortKey: PropTypes.string
    }),
    direction: PropTypes.string
  }),
  obeeSettings: obeeSettingsPropTypes.isRequired,
  runsheetTimeSeparator: PropTypes.bool.isRequired,
  runsheetTimeSeparatorInterval: PropTypes.number.isRequired,
  runsheetDisplayMode: PropTypes.string.isRequired,
  runsheetDisplayModeOverview: PropTypes.shape({}).isRequired
};
const mapStateToProps$3e = (state) => ({
  areas: state.areas,
  obeeSettings: state.obeeSettings,
  runsheetTimeSeparator: state.obeeScreen.runsheetTimeSeparator,
  runsheetTimeSeparatorInterval: state.obeeScreen.runsheetTimeSeparatorInterval,
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode,
  runsheetDisplayModeOverview: state.obeeScreen.runsheetDisplayModeOverview
});
const mapDispatchToProps$3d = (dispatch) => bindActionCreators({}, dispatch);
const RunSheetList$1 = connect(mapStateToProps$3e, mapDispatchToProps$3d)(RunSheetList);
const RunSheetBookingTab = ({
  date,
  bookings,
  sessions,
  fullyBookedSessions,
  sortable,
  runsheetDisplayMode,
  runsheetDisplayModeOverview
}) => {
  const { bookingsBySession } = bookings;
  let sessionLabels2 = unique(sessions.map((session) => session.label).sort(sortSessions));
  const hasBookingsWithoutSession = !isEmpty(bookingsBySession == null ? void 0 : bookingsBySession["No session"]);
  if (hasBookingsWithoutSession) {
    sessionLabels2 = [...sessionLabels2, "No session"];
  }
  const SHOW_CANCELLED_BOOKINGS = useMemo(() => {
    if (!runsheetDisplayModeOverview.Cancellations && runsheetDisplayMode === RUNSHEET_DISPLAYMODE.FILTERED) {
      return false;
    }
    return bookings.cancelledBookings.length > 0;
  }, [bookings.cancelledBookings, runsheetDisplayMode, runsheetDisplayModeOverview]);
  return /* @__PURE__ */ React__default.createElement(Box, null, sessionLabels2.length === 0 && /* @__PURE__ */ React__default.createElement(Box, { style: { padding: "50px 0 10px 0" } }, "There are no sessions to show for ", formatDate(date, "dddd Do MMM")), sessionLabels2.map((sessionLabel) => {
    const bookingsForSession = (bookingsBySession == null ? void 0 : bookingsBySession[sessionLabel]) || [];
    const fullyBookedSessionAreas = fullyBookedSessions.data.filter(
      (fullyBookedSession) => fullyBookedSession.label === sessionLabel && fullyBookedSession.fullyBooked
    ).map((fullyBookedSession) => fullyBookedSession.name);
    return /* @__PURE__ */ React__default.createElement(Box, { key: sessionLabel }, /* @__PURE__ */ React__default.createElement(
      RunSheetList$1,
      {
        name: getLabelForValue(sessionLabel, getSessionList()),
        bookings: bookingsForSession,
        fullyBookedSessionAreas,
        sortable
      }
    ));
  }), SHOW_CANCELLED_BOOKINGS && /* @__PURE__ */ React__default.createElement(RunSheetList$1, { name: "Cancelled", bookings: bookings.cancelledBookings, sortable }), bookings.noShowBookings.length > 0 && /* @__PURE__ */ React__default.createElement(RunSheetList$1, { name: "No show", bookings: bookings.noShowBookings, sortable }));
};
RunSheetBookingTab.propTypes = {
  date: PropTypes.instanceOf(moment$2).isRequired,
  bookings: PropTypes.instanceOf(Object).isRequired,
  sessions: PropTypes.arrayOf(sessionPropTypes).isRequired,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired,
  sortable: PropTypes.shape({}).isRequired,
  runsheetDisplayMode: PropTypes.string.isRequired,
  runsheetDisplayModeOverview: PropTypes.shape({}).isRequired
};
const mapStateToProps$3d = (state) => ({
  fullyBookedSessions: state.fullyBookedSessions,
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode,
  runsheetDisplayModeOverview: state.obeeScreen.runsheetDisplayModeOverview
});
const mapDispatchToProps$3c = () => ({});
const RunSheetBookingTab$1 = connect(mapStateToProps$3d, mapDispatchToProps$3c)(RunSheetBookingTab);
const RunSheetWaitingListTab = ({ bookings, sessionFilter, sortable }) => {
  return /* @__PURE__ */ React__default.createElement(Box, null, !bookings.waitlistBookings.length && /* @__PURE__ */ React__default.createElement(Box, { style: { paddingTop: "50px" } }, `There are no bookings on the Waitlist${sessionFilter === "all_sessions" ? "" : ` for ${getLabelForValue(sessionFilter, getSessionList())}`}.`), bookings.waitlistBookings.length > 0 && /* @__PURE__ */ React__default.createElement(
    RunSheetList$1,
    {
      name: "Waitlist",
      bookings: bookings.waitlistBookings,
      isWaitlist: true,
      sortable
    }
  ));
};
RunSheetWaitingListTab.propTypes = {
  sessionFilter: PropTypes.string.isRequired,
  bookings: PropTypes.instanceOf(Object).isRequired,
  sortable: PropTypes.shape({}).isRequired
};
const mapStateToProps$3c = () => ({});
const mapDispatchToProps$3b = () => ({});
const RunSheetWaitingListTab$1 = connect(mapStateToProps$3c, mapDispatchToProps$3b)(RunSheetWaitingListTab);
const useStyles$1F = createUseStyles((theme2) => ({
  container: (props) => {
    var _a;
    return {
      ...props == null ? void 0 : props.style,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.container
    };
  },
  pagebreak: {
    pageBreakBefore: "always"
  },
  content: {
    paddingTop: "48px",
    paddingBottom: "48px",
    marginBottom: "40px"
  },
  listHeader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    paddingBottom: "10px"
  },
  listHeading: {
    ...theme2.typography.heading.H4
  },
  headingNumbers: {
    display: "flex",
    gap: "24px",
    paddingRight: "12px"
  },
  headingNumber: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
    flexGrow: 1,
    justifyContent: "space-between",
    minWidth: "75px"
  },
  hourDivider: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    padding: "12px 10px",
    backgroundColor: theme2.colors.lightCloud,
    border: `1px solid ${theme2.colors.lightCloud}`,
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.charcoal
  },
  headingNumbersHour: {
    display: "flex",
    gap: "24px"
  },
  headingNumberHour: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
    flexGrow: 1,
    justifyContent: "space-between",
    minWidth: "75px"
  },
  sessionContainer: {
    "& $bookingCardContainer": {
      "&:last-child": {
        borderBottom: "none"
      }
    }
  },
  listContainer: {},
  bookingCardContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 10px 16px 10px",
    gap: "4px",
    color: theme2.colors.charcoal,
    borderBottom: `1px solid ${theme2.colors.cloud}`,
    ...theme2.typography.body.PS
  },
  bookingCardInnerContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    alignItems: "center"
  },
  bookingCardRow: {
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  bookingCardCommentRow: {
    width: "100%",
    flexGrow: 1,
    color: theme2.colors.smoke,
    fontSize: "10px"
  },
  bookingButtonRow: {
    display: "inline-flex",
    gap: "10px"
  },
  statusCell: {
    width: "100%",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    minWidth: "120px",
    maxWidth: "120px",
    marginLeft: "auto",
    display: "flex",
    justifyContent: "flex-end"
  },
  tableNumber: {
    border: `1px solid ${theme2.colors.shark}`,
    color: theme2.colors.smoke,
    padding: "4px 6px",
    borderRadius: "4px",
    width: "fit-content"
  },
  noTableNumber: {
    width: "100%",
    padding: "4px 8px",
    textAlign: "center",
    borderRadius: "8px",
    border: `1px solid ${theme2.colors.yetAnotherGray21}`,
    fontSize: "15px",
    textOverflow: "unset",
    resize: "none",
    height: "36px"
  },
  areaName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100px"
  },
  boxesContainer: {
    display: "inline-flex",
    gap: "4px",
    fontSize: "8px",
    marginTop: "-4px",
    minWidth: "65px",
    maxWidth: "65px"
  },
  statusBox: {
    height: "32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between"
  },
  checkbox: {
    border: `1px solid ${theme2.colors.charcoal}`,
    width: "20px",
    height: "20px",
    borderRadius: "4px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center"
  },
  checkboxInner: {
    position: "absolute",
    fontSize: "10px"
  },
  arrivalColumn: {
    minWidth: "70px",
    maxWidth: "90px"
  },
  areaColumn: {
    minWidth: "60px",
    maxWidth: "100px"
  },
  tableColumn: {
    minWidth: "80px",
    maxWidth: "80px"
  },
  guestColumn: {
    minWidth: "180px",
    maxWidth: "180px",
    display: "flex",
    flexDirection: "column",
    rowGap: "4px"
  },
  partyColumn: {
    minWidth: "80px",
    maxWidth: "80px"
  },
  guestIcon: {
    paddingLeft: "15px"
  },
  commentsColumn: {
    fontSize: "inherit",
    color: "inherit",
    justifyContent: "left",
    minWidth: "200px"
  },
  sourceColumn: {
    minWidth: "80px",
    maxWidth: "80px"
  },
  statusColumn: {
    maxWidth: "140px",
    minWidth: "120px",
    width: "100%",
    textAlign: "right"
  },
  summaryText: {
    fontSize: "15px",
    lineHeight: "normal",
    minWidth: "20px"
  },
  summaryLabel: {
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium,
    lineHeight: "normal"
  },
  printColumnHeaderContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "20px"
  },
  columnHeadersContainer: {
    display: "flex",
    fontSize: "15px",
    fontWeight: "500",
    justifyContent: "space-between",
    gap: "20px",
    padding: "12px 0px 12px 0",
    alignItems: "center"
  },
  guestItemContainer: {
    display: "flex",
    gap: "8px"
  },
  guestItemName: {
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  guestItemSize: {
    display: "flex",
    gap: "4px",
    alignItems: "center"
  },
  guestItemNumber: {
    color: theme2.colors.smoke,
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  guestVisitNumber: {
    border: `1px solid ${theme2.colors.yetAnotherGray11}`,
    borderRadius: "8px",
    color: theme2.colors.black,
    fontSize: "12px",
    padding: "4px 8px"
  },
  partyItemSize: {
    display: "inline-flex",
    gap: "8px",
    cursor: "pointer",
    alignItems: "center",
    backgroundColor: theme2.colors.whiteSmoke,
    borderRadius: "10px",
    padding: "6px 9px"
  },
  mobileBookingCardContainer: {
    gap: "8px"
  }
}));
const SvgSlash = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("line", { x1: 0.646447, y1: 13.6464, x2: 13.6464, y2: 0.646446, stroke: "#313131" }));
const SlashSVG = SvgSlash;
const SvgConfirmedCheck = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 7, cy: 7, r: 6.5, fill: "white", stroke: "#275E56" }), /* @__PURE__ */ React$7.createElement("path", { d: "M4 7.66667L5.5 9L10 5", stroke: "#313131" }));
const ConfirmedCheckIcon = SvgConfirmedCheck;
const RunSheetStatusPrinted = ({ booking }) => {
  const bookingStatus = getStatusDetails(booking == null ? void 0 : booking.status);
  const classes = useStyles$1G({ bookingStatus });
  return /* @__PURE__ */ React__default.createElement("div", { className: classes.container }, (booking == null ? void 0 : booking.status) === STATUS_TYPES.CONFIRMED && /* @__PURE__ */ React__default.createElement(
    ConfirmedCheckIcon,
    {
      style: {
        width: "10px",
        height: "8px"
      }
    }
  ), (bookingStatus == null ? void 0 : bookingStatus.label) || "no status");
};
RunSheetStatusPrinted.defaultProps = {};
RunSheetStatusPrinted.propTypes = {
  booking: obeeBookingPropTypes.isRequired
};
const mapStateToProps$3b = () => ({});
const mapDispatchToProps$3a = (dispatch) => bindActionCreators({}, dispatch);
const RunSheetStatusPrinted$1 = connect(mapStateToProps$3b, mapDispatchToProps$3a)(RunSheetStatusPrinted);
const RunSheetListPrinted = ({
  name: name2,
  bookings,
  isWaitlist,
  areas,
  tables,
  fullyBookedSessionAreas,
  obeeSettings: obeeSettings2,
  sortable,
  runsheetTimeSeparatorInterval,
  runsheetDisplayMode,
  runsheetDisplayModeOverview
}) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$1F();
  const totalGuests = bookings.reduce((accum, booking) => accum + ((booking == null ? void 0 : booking.size) || 0), 0);
  const areasById = useMemo(() => {
    return groupObjects(areas.data, "id", false);
  }, [areas.data]);
  const emptyBookings = useMemo(() => bookings.length === 0 && !bookings.pending, [bookings]);
  const SHOW_SOURCE_COLUMN = useMemo(() => {
    return runsheetDisplayModeOverview.Source || runsheetDisplayMode === RUNSHEET_DISPLAYMODE.ALL;
  }, [runsheetDisplayModeOverview, runsheetDisplayMode]);
  const hasComments = (booking) => {
    if (isEmpty(booking == null ? void 0 : booking.restaurantComments) && isEmpty(booking == null ? void 0 : booking.customerComments)) {
      return false;
    }
    return true;
  };
  const timeSeparator = isEmpty(runsheetTimeSeparatorInterval) ? 0 : runsheetTimeSeparatorInterval / 3600;
  const bookingsByTimeSeparator = useMemo(() => {
    const bookingsGuestsByTimeSeparator = {};
    if (emptyBookings) {
      return bookingsGuestsByTimeSeparator;
    }
    if (timeSeparator === 0 || sortable.column.label !== DEFAULT_SORTABLE.column.label) {
      return {
        _0: {
          bookingNums: bookings.length,
          guests: totalGuests,
          label: "All",
          bookings,
          time: 0
        }
      };
    }
    bookings.forEach((booking) => {
      const bookingHour = (booking == null ? void 0 : booking.startTime) / 60;
      const bookingTimeSeparator = Math.floor(bookingHour / timeSeparator) * timeSeparator;
      if (!bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`]) {
        bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`] = {
          bookingNums: 0,
          guests: 0,
          label: formatTimeFromInt(bookingTimeSeparator * 60, "h:mma"),
          bookings: [],
          time: bookingTimeSeparator
        };
      }
      bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`].bookingNums += 1;
      bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`].guests += (booking == null ? void 0 : booking.size) || 0;
      bookingsGuestsByTimeSeparator[`_${bookingTimeSeparator}`].bookings.push(booking);
    });
    return bookingsGuestsByTimeSeparator;
  }, [bookings, timeSeparator, emptyBookings, sortable.column.label]);
  const [sortableBookings, setSortableBookings] = useState([]);
  const TABLE_NUMBER_SORTABLE_KEY = "tableNumber";
  const showSeparatorTotals = ((_b2 = (_a = obeeSettings2.data) == null ? void 0 : _a.runsheetSettings) == null ? void 0 : _b2.runsheetSeparatorShowTotals) === 1;
  const checkIfBookingsToShow = useCallback(
    (bookingsToCheck) => {
      if (isEmpty(bookingsToCheck)) {
        return false;
      }
      const showBookings = bookingsToCheck.some((booking) => {
        if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.FINISHED) {
          if (!runsheetDisplayModeOverview["Finished bookings"] && runsheetDisplayMode === RUNSHEET_DISPLAYMODE.FILTERED) {
            return false;
          }
        }
        return true;
      });
      return showBookings;
    },
    [runsheetDisplayModeOverview, runsheetDisplayMode]
  );
  useEffect(() => {
    let toBeSortedBookings = Object.values(bookingsByTimeSeparator);
    if (toBeSortedBookings.length === 0) {
      return;
    }
    if (sortable.column.label === DEFAULT_SORTABLE.column.label) {
      toBeSortedBookings = sortListByProperty(
        toBeSortedBookings,
        "time",
        sortable.direction !== "asc"
      );
    }
    const sortableBookingsObj = toBeSortedBookings.map((groupedBookings) => {
      const hasBookingsToShow = checkIfBookingsToShow(groupedBookings == null ? void 0 : groupedBookings.bookings);
      if (hasBookingsToShow) {
        groupedBookings.bookings = sortRunSheetListByProperty(
          sortable.column.label !== TABLE_NUMBER_SORTABLE_KEY ? sortRunSheetListByProperty(groupedBookings == null ? void 0 : groupedBookings.bookings, TABLE_NUMBER_SORTABLE_KEY) : groupedBookings == null ? void 0 : groupedBookings.bookings,
          sortable.column.sortKey,
          sortable.direction !== "asc"
        );
        return groupedBookings;
      }
      return null;
    }).filter((item) => item !== null);
    setSortableBookings(sortableBookingsObj);
  }, [
    bookingsByTimeSeparator,
    sortable.column,
    sortable.direction,
    timeSeparator,
    checkIfBookingsToShow
  ]);
  const printStyles = {
    container: {
      padding: "4px 8px 0 0"
    },
    dietaryTag: {
      color: "inherit"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.listHeader }, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", alignItems: "center", gap: "12px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.listHeading }, name2), fullyBookedSessionAreas.length > 0 && /* @__PURE__ */ React__default.createElement(
    Label$1,
    {
      label: `Fully booked: ${fullyBookedSessionAreas.join(", ")}`,
      style: {
        backgroundColor: theme2.colors.infoBlueLight,
        fontWeight: theme2.fontWeights.medium
      }
    }
  ), emptyBookings && /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.yetAnotherGray25 } }, "No Bookings")), !emptyBookings && /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumbers }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumber }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryLabel }, "Guests"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, `${totalGuests}`)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumber }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryLabel }, "Bookings"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, bookings.length)))), !emptyBookings && /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionContainer }, sortableBookings == null ? void 0 : sortableBookings.map((groupedBookings) => {
    var _a2;
    const totalGroupedGuests = (groupedBookings == null ? void 0 : groupedBookings.guests) || 0;
    const totalGroupedBookings = (groupedBookings == null ? void 0 : groupedBookings.bookingNums) || 0;
    const hasBookingsToShow = checkIfBookingsToShow(groupedBookings == null ? void 0 : groupedBookings.bookings);
    return hasBookingsToShow && /* @__PURE__ */ React__default.createElement(Box, { key: groupedBookings == null ? void 0 : groupedBookings.label, className: classes.sessionInnerContainer }, groupedBookings.label !== "All" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.hourDivider }, groupedBookings == null ? void 0 : groupedBookings.label, showSeparatorTotals && /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumbersHour }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumberHour }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryLabel }, "Guests"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, totalGroupedGuests)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headingNumberHour }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryLabel }, "Bookings"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, totalGroupedBookings)))), totalGroupedBookings > 0 && ((_a2 = groupedBookings == null ? void 0 : groupedBookings.bookings) == null ? void 0 : _a2.map((booking) => {
      var _a3, _b3, _c2;
      const isWalkin = (booking == null ? void 0 : booking.source) === "walkin";
      const kidsText = getKidsText(booking);
      const area = getAreaById(areas.data, booking == null ? void 0 : booking.areaId);
      const capacityBasedArea = isAreaCapacityBased(area, tables.data);
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: booking.id,
          className: `${classes.bookingCardContainer} ${classes.mobileBookingCardContainer}`
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardInnerContainer}` }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.arrivalColumn}` }, formatTimeFromInt(booking.startTime, "h:mma")), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.guestColumn}` }, getBookingName(booking), !isWalkin && /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestItemNumber }, (_b3 = (_a3 = booking.guests) == null ? void 0 : _a3[0]) == null ? void 0 : _b3.mobile)), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.partyColumn}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.partyItemContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.partyItemSize }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { height: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, booking.size)), !isEmpty(kidsText) && /* @__PURE__ */ React__default.createElement(
          Box,
          {
            style: {
              fontSize: "12px",
              marginTop: "4px",
              whiteSpace: "pre"
            }
          },
          "inc. ",
          kidsText
        ))), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.tableColumn}` }, !isWaitlist && /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: capacityBasedArea ? classes.noTableNumber : classes.tableNumber
          },
          (booking == null ? void 0 : booking.tableNumberDisplay) || ""
        )), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.areaColumn}` }, !isWaitlist && /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaName }, ((_c2 = areasById == null ? void 0 : areasById[booking == null ? void 0 : booking.areaId]) == null ? void 0 : _c2.name) || "-")), SHOW_SOURCE_COLUMN && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.sourceColumn}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingCardRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingSourceIcon }, getSourceIcon(booking)))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.statusCell }, /* @__PURE__ */ React__default.createElement(RunSheetStatusPrinted$1, { booking })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.boxesContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.statusBox }, /* @__PURE__ */ React__default.createElement(Box, null, "Seated"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.checkbox }, /* @__PURE__ */ React__default.createElement(
          SlashSVG,
          {
            className: classes.checkboxInner,
            style: {
              width: "14px",
              display: [
                STATUS_TYPES.ARRIVED,
                STATUS_TYPES.FINISHED
              ].includes(booking == null ? void 0 : booking.status) ? "inherit" : "none"
            }
          }
        ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.checkboxInner }, "S"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.statusBox }, /* @__PURE__ */ React__default.createElement(Box, null, "Finished"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.checkbox }, /* @__PURE__ */ React__default.createElement(
          SlashSVG,
          {
            className: classes.checkboxInner,
            style: {
              display: (booking == null ? void 0 : booking.status) === STATUS_TYPES.FINISHED ? "inherit" : "none",
              width: "14px"
            }
          }
        ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.checkboxInner }, "F"))))),
        hasComments(booking) && /* @__PURE__ */ React__default.createElement(
          RunSheetCommentsView$1,
          {
            booking,
            classnames: classes.commentsColumn,
            showFullComments: true
          }
        ),
        /* @__PURE__ */ React__default.createElement(RunSheetTags$1, { booking, printStyles })
      );
    })));
  })));
};
RunSheetListPrinted.defaultProps = {
  isWaitlist: false,
  name: "Unnamed session",
  fullyBookedSessionAreas: []
};
RunSheetListPrinted.propTypes = {
  name: PropTypes.string,
  bookings: PropTypes.arrayOf(obeeBookingPropTypes).isRequired,
  isWaitlist: PropTypes.bool,
  areas: areasPropTypes.isRequired,
  tables: tablesPropTypes.isRequired,
  fullyBookedSessionAreas: PropTypes.arrayOf(PropTypes.string),
  obeeSettings: obeeSettingsPropTypes.isRequired,
  sortable: PropTypes.shape({
    column: PropTypes.shape({
      label: PropTypes.string,
      sortKey: PropTypes.string
    }),
    direction: PropTypes.string
  }).isRequired,
  runsheetTimeSeparatorInterval: PropTypes.number.isRequired,
  runsheetDisplayMode: PropTypes.string.isRequired,
  runsheetDisplayModeOverview: PropTypes.shape({}).isRequired
};
const mapStateToProps$3a = (state) => ({
  areas: state.areas,
  tables: state.tables,
  obeeSettings: state.obeeSettings,
  runsheetTimeSeparatorInterval: state.obeeScreen.runsheetTimeSeparatorInterval,
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode,
  runsheetDisplayModeOverview: state.obeeScreen.runsheetDisplayModeOverview
});
const mapDispatchToProps$39 = (dispatch) => bindActionCreators({}, dispatch);
const RunSheetListPrinted$1 = connect(mapStateToProps$3a, mapDispatchToProps$39)(RunSheetListPrinted);
const RunSheetPrintView = ({
  date,
  bookings,
  restaurant,
  obeeSettings: obeeSettings2,
  fullyBookedSessions,
  sessions,
  sortable,
  runsheetDisplayMode,
  runsheetDisplayModeOverview
}) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$1V();
  const printClasses = useStyles$1F();
  const { bookingsBySession } = bookings;
  const sessionLabels2 = unique(sessions.map((session) => session.label).sort(sortSessions));
  const SHOW_SOURCE_COLUMN = useMemo(() => {
    return runsheetDisplayModeOverview.Source || runsheetDisplayMode === RUNSHEET_DISPLAYMODE.ALL;
  }, [runsheetDisplayModeOverview, runsheetDisplayMode]);
  const SHOW_CANCELLED_BOOKINGS = useMemo(() => {
    if (!runsheetDisplayModeOverview.Cancellations && runsheetDisplayMode === RUNSHEET_DISPLAYMODE.FILTERED) {
      return false;
    }
    return bookings.cancelledBookings.length > 0;
  }, [bookings.cancelledBookings, runsheetDisplayMode, runsheetDisplayModeOverview]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.printOnly }, /* @__PURE__ */ React__default.createElement(Box, null, "Run Sheet"), /* @__PURE__ */ React__default.createElement(Box, null, (_a = restaurant == null ? void 0 : restaurant.restaurant) == null ? void 0 : _a.name), /* @__PURE__ */ React__default.createElement(Box, null, formatDate(date, "dddd Do MMM")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.printContent }, /* @__PURE__ */ React__default.createElement(Box, { className: printClasses.container }, /* @__PURE__ */ React__default.createElement(Box, { className: printClasses.printColumnHeaderContent }, /* @__PURE__ */ React__default.createElement(Box, { className: printClasses.columnHeadersContainer }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${printClasses.bookingCardRow} ${printClasses.arrivalColumn}`,
      style: { maxWidth: "100px" }
    },
    "Arrival"
  ), /* @__PURE__ */ React__default.createElement(Box, { className: `${printClasses.bookingCardRow} ${printClasses.guestColumn}` }, "Guest"), /* @__PURE__ */ React__default.createElement(Box, { className: `${printClasses.bookingCardRow} ${printClasses.partyColumn}` }, "Party"), /* @__PURE__ */ React__default.createElement(Box, { className: `${printClasses.bookingCardRow} ${printClasses.tableColumn}` }, "Table"), /* @__PURE__ */ React__default.createElement(Box, { className: `${printClasses.bookingCardRow} ${printClasses.areaColumn}` }, "Area"), SHOW_SOURCE_COLUMN && /* @__PURE__ */ React__default.createElement(Box, { className: `${printClasses.bookingCardRow} ${printClasses.sourceColumn}` }, "Source"), /* @__PURE__ */ React__default.createElement(Box, { className: `${printClasses.bookingCardRow} ${printClasses.statusColumn}` }, "Status"), /* @__PURE__ */ React__default.createElement(Box, { className: printClasses.boxesContainer }, " "))), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.gray8 })), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, sessionLabels2.length === 0 && /* @__PURE__ */ React__default.createElement(Box, null, "There are no sessions to show for ", formatDate(date, "dddd Do MMM"), ".")), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, sessionLabels2.map((sessionLabel) => {
    const bookingsForSession = (bookingsBySession == null ? void 0 : bookingsBySession[sessionLabel]) || [];
    const fullyBookedSessionAreas = fullyBookedSessions.data.filter(
      (fullyBookedSession) => fullyBookedSession.label === sessionLabel && fullyBookedSession.fullyBooked
    ).map((fullyBookedSession) => fullyBookedSession.name);
    return /* @__PURE__ */ React__default.createElement(
      RunSheetListPrinted$1,
      {
        key: sessionLabel,
        name: getLabelForValue(sessionLabel, getSessionList()),
        bookings: bookingsForSession || [],
        fullyBookedSessionAreas,
        sortable
      }
    );
  })), ((_b2 = obeeSettings2.data) == null ? void 0 : _b2.waitlist) && bookings.waitlistBookings.length > 0 && /* @__PURE__ */ React__default.createElement(
    RunSheetListPrinted$1,
    {
      name: "Waitlist",
      bookings: bookings.waitlistBookings,
      isWaitlist: true,
      sortable
    }
  ), SHOW_CANCELLED_BOOKINGS && /* @__PURE__ */ React__default.createElement(
    RunSheetListPrinted$1,
    {
      name: "Cancelled",
      bookings: bookings.cancelledBookings,
      sortable
    }
  ), bookings.noShowBookings.length > 0 && /* @__PURE__ */ React__default.createElement(
    RunSheetListPrinted$1,
    {
      name: "No show",
      bookings: bookings.noShowBookings,
      sortable
    }
  )));
};
RunSheetPrintView.propTypes = {
  date: PropTypes.instanceOf(moment$2).isRequired,
  bookings: PropTypes.instanceOf(Object).isRequired,
  restaurant: PropTypes.shape({
    restaurant: PropTypes.shape({
      name: PropTypes.string
    })
  }).isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  sessions: PropTypes.arrayOf(sessionPropTypes).isRequired,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired,
  sortable: PropTypes.shape({}).isRequired,
  runsheetDisplayMode: PropTypes.string.isRequired,
  runsheetDisplayModeOverview: PropTypes.shape({}).isRequired
};
const mapStateToProps$39 = (state) => ({
  obeeSettings: state.obeeSettings,
  fullyBookedSessions: state.fullyBookedSessions,
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode,
  runsheetDisplayModeOverview: state.obeeScreen.runsheetDisplayModeOverview
});
const mapDispatchToProps$38 = () => ({});
const RunSheetPrintView$1 = connect(mapStateToProps$39, mapDispatchToProps$38)(RunSheetPrintView);
const useStyles$1E = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    fontSize: "15px",
    lineHeight: "normal",
    color: theme2.colors.charcoal,
    maxWidth: "300px"
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    fontWeight: theme2.fontWeights.medium
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "0 10px"
  },
  infoButton: {
    border: `1px solid ${theme2.colors.black}`,
    borderRadius: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "27px",
    height: "27px"
  },
  informationContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "0 10px"
  },
  informationTitle: {
    fontWeight: theme2.fontWeights.medium
  },
  timeSeparatorContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    padding: "0 10px",
    cursor: "pointer"
  },
  timeSeparatorPopoverContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    fontSize: "15px",
    lineHeight: "normal",
    color: theme2.colors.smoke,
    width: "260px"
  },
  timeSeparatorPopoverSectionContainer: {
    display: "flex",
    alignItems: "center"
  },
  timeIntervalPopoverContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    fontSize: "15px",
    lineHeight: "normal",
    color: theme2.colors.smoke,
    width: "140px"
  },
  timeIntervalPopoverItem: {
    cursor: "pointer",
    transition: "color 0.2s ease-in-out",
    "&:hover": {
      color: theme2.colors.charcoal
    }
  },
  timeIntervalPopoverItemActive: {
    color: theme2.colors.charcoal
  },
  timeIntervalPopoverTimeContainer: {
    padding: "4px 6px",
    border: "1px solid #DFDFDF",
    borderRadius: "4px"
  }
}));
const Dropdown = ({
  label,
  value,
  items,
  onSelect: onSelect2,
  onFocus: onFocus2,
  onBlur: onBlur2,
  multiSelect,
  disabled,
  style,
  ...other
}) => {
  const theme2 = useTheme$1();
  const styles2 = {
    outerContainer: {
      display: "flex",
      gap: "40px",
      alignItems: "center",
      direction: "row",
      height: "40px",
      ...style == null ? void 0 : style.outerContainer
    },
    disabled: {
      color: theme2.colors.nimbus,
      backgroundColor: theme2.colors.dateSelectBackground
    },
    label: {
      color: theme2.colors.smoke,
      marginBottom: "0",
      ...style == null ? void 0 : style.label
      // width: '100px',
    },
    dropdown: {
      // backgroundColor: '#EDEDED',
      // marginLeft: '-2px',
      border: `1px solid ${theme2.colors.shark}`,
      width: "100%",
      color: theme2.colors.smoke,
      // padding: '10px',
      borderRadius: "6px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: "16px",
      // paddingRight: '40px',
      minWidth: "250px",
      lineHeight: "18px",
      transition: "background-color 0.1s",
      ...style == null ? void 0 : style.dropdown
    },
    dropdownSubMenu: {
      border: `1px solid ${theme2.colors.shark}`,
      // width: '100%',
      color: theme2.colors.smoke,
      borderRadius: "6px",
      textOverflow: "ellipsis",
      overflow: "visible",
      minWidth: "250px",
      ...style == null ? void 0 : style.dropdownSubMenu
    },
    dropdownHover: {
      backgroundColor: theme2.colors.yetAnotherGray12,
      filter: "none"
    },
    menuItemHover: {
      backgroundColor: theme2.colors.yetAnotherGray12,
      filter: "none"
    },
    dropdownOpen: {
      border: `1px solid ${theme2.colors.smoke}`,
      borderBottom: "1px solid transparent",
      backgroundColor: theme2.colors.yetAnotherGray12,
      borderRadius: "6px 6px 0 0"
    },
    menu: {
      fontSize: "16px",
      top: "36px"
    },
    menuOpen: {
      borderColor: theme2.colors.smoke
    },
    dropdownContentInner: {
      maxWidth: "100%",
      padding: "10px 14px",
      lineHeight: "18px",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    inputHover: {
      backgroundColor: theme2.colors.yetAnotherGray13
    },
    placeholder: {
      color: theme2.colors.nimbus
    },
    menuItem: {
      padding: "16px 14px"
    },
    menuItemSelected: {
      fontWeight: theme2.fontWeights.medium
    }
  };
  if (multiSelect) {
    return /* @__PURE__ */ React__default.createElement(
      MultiSelectDropdown,
      {
        label,
        selectedItems: value,
        items,
        type: "text",
        onSelect: onSelect2,
        placeholder: "Empty",
        onFocus: onFocus2,
        onBlur: onBlur2,
        style: styles2,
        disabled,
        ...other
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(
    Dropdown$2,
    {
      label,
      value,
      items,
      type: "text",
      onSelect: onSelect2,
      placeholder: "Empty",
      onFocus: onFocus2,
      onBlur: onBlur2,
      disabled,
      style: styles2,
      ...other
    }
  );
};
Dropdown.defaultProps = {
  label: "",
  value: "",
  onSelect: () => {
  },
  onFocus: () => {
  },
  onBlur: () => {
  },
  items: [],
  multiSelect: false,
  disabled: false
};
Dropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  multiSelect: PropTypes.bool,
  disabled: PropTypes.bool
};
const mapStateToProps$38 = () => ({});
const mapDispatchToProps$37 = (dispatch) => bindActionCreators({}, dispatch);
const Dropdown$1 = connect(mapStateToProps$38, mapDispatchToProps$37)(Dropdown);
const weekdays = () => [
  { label: "Monday", value: "mon" },
  { label: "Tuesday", value: "tue" },
  { label: "Wednesday", value: "wed" },
  { label: "Thursday", value: "thu" },
  { label: "Friday", value: "fri" },
  { label: "Saturday", value: "sat" },
  { label: "Sunday", value: "sun" }
];
const yesNoContact = () => [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "Contact us", value: "contact_us" }
];
const dressCode = () => [
  { label: "No dress code", value: "no" },
  { label: "Casual", value: "casual" },
  { label: "Smart casual", value: "smart_casual" },
  { label: "Formal", value: "formal" }
];
const beerOptions = () => [
  { label: "Beer", value: "beer" },
  { label: "Wine", value: "wine" }
];
const byoLicensedOptions = () => [
  { label: "Bar service only", value: "bar_service" },
  { label: "Unlicensed", value: "unlicensed" }
];
const multiVenueAvailability = () => [
  { label: "No", value: "no" },
  { label: "If no availability at this venue", value: "no_availability" },
  { label: "Always", value: "always" }
];
const timeSeparatorOptions = [
  // { label: 'None', value: 0 },
  { label: "15 minutes", value: 900 },
  { label: "30 minutes", value: 1800 },
  { label: "1 hour", value: 3600 }
];
const marketingPreferenceOptions = () => [
  { label: "SMS", value: "smsPromo" },
  { label: "Email", value: "emailPromo" }
];
const RunSheetTimeIntervalPopover = ({
  anchor,
  setAnchor,
  restId,
  // TODO potential multi venue use case
  obeeSettings: obeeSettings2,
  // TODO maybe update venue settings
  runsheetTimeSeparatorInterval,
  setRunSheetTimeSeparatorInterval
}) => {
  const classes = useStyles$1E();
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl: anchor,
      innerStyle: {
        borderRadius: theme2.borderRadius.xxl,
        border: `1px solid ${theme2.colors.cloud}`,
        backgroundColor: theme2.colors.white,
        boxShadow: `0px 4px 8px 0px rgba(151, 151, 151, 0.25)`,
        marginTop: "-20px",
        marginLeft: 0,
        padding: "20px"
      },
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      anchorOrigin: {
        vertical: "center",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "center"
      },
      disableRestoreFocus: true
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeIntervalPopoverContainer }, timeSeparatorOptions.map((item) => /* @__PURE__ */ React__default.createElement(
      Box,
      {
        key: item.label,
        className: `${classes.timeIntervalPopoverItem} ${runsheetTimeSeparatorInterval === item.value ? classes.timeIntervalPopoverItemActive : ""}`,
        onClick: () => {
          setRunSheetTimeSeparatorInterval(item.value);
          setAnchor(null);
        }
      },
      item.label
    )))
  );
};
RunSheetTimeIntervalPopover.defaultProps = {
  anchor: null,
  setAnchor: () => {
  },
  innerStyle: {}
};
RunSheetTimeIntervalPopover.propTypes = {
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func,
  runsheetTimeSeparatorInterval: PropTypes.number.isRequired,
  setRunSheetTimeSeparatorInterval: PropTypes.func.isRequired,
  restId: PropTypes.string.isRequired,
  obeeSettings: obeeSettingPropTypes.isRequired,
  innerStyle: PropTypes.shape({})
};
const mapStateToProps$37 = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  obeeSettings: state.obeeSettings,
  runsheetTimeSeparatorInterval: state.obeeScreen.runsheetTimeSeparatorInterval
});
const mapDispatchToProps$36 = (dispatch) => bindActionCreators(
  {
    setRunSheetTimeSeparatorInterval: setRunSheetTimeSeparatorIntervalAction
  },
  dispatch
);
const RunSheetTimeIntervalPopover$1 = connect(mapStateToProps$37, mapDispatchToProps$36)(RunSheetTimeIntervalPopover);
const RunSheetTimeSeparatorPopover = ({
  anchor,
  setAnchor,
  restId,
  // TODO potential multi venue use case
  obeeSettings: obeeSettings2,
  // TODO maybe update venue settings
  runsheetTimeSeparator,
  setRunSheetTimeSeparator,
  runsheetTimeSeparatorInterval,
  innerStyle = {}
}) => {
  var _a;
  const classes = useStyles$1E();
  const theme2 = useTheme$1();
  const [timeIntervalAnchorEl, setTimeIntervalAnchorEl] = useState(null);
  const style = {
    labelRow: { width: "140px" },
    textLabel: { color: theme2.colors.smoke, fontSize: "15px" },
    inputContainer: { marginLeft: "15px" }
  };
  const currentTimeIntervalLabel = (_a = timeSeparatorOptions.find(
    (item) => item.value === runsheetTimeSeparatorInterval
  )) == null ? void 0 : _a.label;
  const onToggleTimeSeparator = () => {
    const newRunSheetTimeSeparator = !runsheetTimeSeparator;
    setRunSheetTimeSeparator(newRunSheetTimeSeparator);
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      anchorEl: anchor,
      innerStyle: {
        borderRadius: theme2.borderRadius.xxl,
        border: `1px solid ${theme2.colors.cloud}`,
        backgroundColor: theme2.colors.white,
        boxShadow: `0px 4px 8px 0px rgba(151, 151, 151, 0.25)`,
        marginTop: 0,
        marginLeft: "-15px",
        padding: "20px",
        ...innerStyle
      },
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      anchorOrigin: {
        vertical: "center",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      disableRestoreFocus: true
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeSeparatorPopoverContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeSeparatorPopoverSectionContainer }, /* @__PURE__ */ React__default.createElement(
      Toggle,
      {
        label: "Status",
        checked: !!runsheetTimeSeparator,
        onChange: onToggleTimeSeparator,
        style
      }
    )), runsheetTimeSeparator !== false && /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeSeparatorPopoverSectionContainer, style: { gap: "25px" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { width: "140px" } }, "Time Interval"), /* @__PURE__ */ React__default.createElement(
      RoundButton,
      {
        style: {
          button: { padding: 0, border: "none", borderRadius: "unset", height: "auto" }
        },
        onClick: (e) => setTimeIntervalAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeIntervalPopoverTimeContainer }, currentTimeIntervalLabel)
    ), /* @__PURE__ */ React__default.createElement(
      RunSheetTimeIntervalPopover$1,
      {
        anchor: timeIntervalAnchorEl,
        setAnchor: setTimeIntervalAnchorEl
      }
    )))
  );
};
RunSheetTimeSeparatorPopover.defaultProps = {
  anchor: null,
  setAnchor: () => {
  },
  innerStyle: {}
};
RunSheetTimeSeparatorPopover.propTypes = {
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func,
  restId: PropTypes.string.isRequired,
  obeeSettings: obeeSettingPropTypes.isRequired,
  runsheetTimeSeparator: PropTypes.bool.isRequired,
  runsheetTimeSeparatorInterval: PropTypes.number.isRequired,
  setRunSheetTimeSeparator: PropTypes.func.isRequired,
  innerStyle: PropTypes.shape({})
};
const mapStateToProps$36 = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  obeeSettings: state.obeeSettings,
  runsheetTimeSeparator: state.obeeScreen.runsheetTimeSeparator,
  runsheetTimeSeparatorInterval: state.obeeScreen.runsheetTimeSeparatorInterval
});
const mapDispatchToProps$35 = (dispatch) => bindActionCreators(
  {
    setRunSheetTimeSeparator: setRunSheetTimeSeparatorAction
  },
  dispatch
);
const RunSheetTimeSeparatorPopover$1 = connect(mapStateToProps$36, mapDispatchToProps$35)(RunSheetTimeSeparatorPopover);
const SvgChevronRight = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 8 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M1 12C1.8 11.2 5 8 6.5 6.5L1 1", stroke: "currentColor" }));
const ChevronRight = SvgChevronRight;
const RunSheetDisplayModePopover = ({
  anchor,
  setAnchor,
  restId,
  // TODO potential multi venue use case
  runsheetDisplayMode,
  obeeSettings: obeeSettings2,
  // TODO maybe update venue settings
  updateObeeSettings: updateObeeSettings2,
  // TODO maybe update venue settings
  setRunSheetDisplayMode,
  runsheetDisplayModeOverview,
  setRunSheetDisplayModeOverview,
  runsheetTimeSeparator,
  innerStyle = {}
}) => {
  const classes = useStyles$1E();
  const theme2 = useTheme$1();
  const [timeSeparatorAnchorEl, setTimeSeparatorAnchorEl] = useState(null);
  const onChangeDisplayMode = useCallback(
    (displayMode) => {
      setRunSheetDisplayMode(displayMode);
    },
    [setRunSheetDisplayMode]
  );
  const onChangeDisplayModeOverview = useCallback(
    (option, value) => {
      const newOverview = {
        ...runsheetDisplayModeOverview,
        [option]: value
      };
      setRunSheetDisplayModeOverview(newOverview);
    },
    [runsheetDisplayModeOverview, setRunSheetDisplayModeOverview]
  );
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      anchorEl: anchor,
      innerStyle: {
        borderRadius: theme2.borderRadius.xxl,
        border: `1px solid ${theme2.colors.cloud}`,
        backgroundColor: theme2.colors.white,
        boxShadow: `0px 4px 8px 0px rgba(151, 151, 151, 0.25)`,
        marginLeft: "5px",
        marginTop: "10px",
        padding: "20px 10px",
        ...innerStyle
      },
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      disableRestoreFocus: true
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.header,
        style: {
          borderBottom: runsheetDisplayMode === RUNSHEET_DISPLAYMODE.ALL ? "none" : `1px solid ${theme2.colors.cloud}`,
          paddingBottom: runsheetDisplayMode === RUNSHEET_DISPLAYMODE.ALL ? "0" : "15px"
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerTitle }, /* @__PURE__ */ React__default.createElement(Box, null, "Display mode")),
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerContent }, /* @__PURE__ */ React__default.createElement(
        SegmentedControl,
        {
          onSelect: onChangeDisplayMode,
          items: [
            { label: RUNSHEET_DISPLAYMODE.FILTERED, value: RUNSHEET_DISPLAYMODE.FILTERED },
            { label: RUNSHEET_DISPLAYMODE.ALL, value: RUNSHEET_DISPLAYMODE.ALL }
          ],
          style: {
            groupContainer: {
              borderRadius: theme2.borderRadius.xl,
              backgroundColor: theme2.colors.yetAnotherGray12,
              padding: "4px"
            },
            optionContainer: {
              alignItems: "center"
            },
            option: {
              width: "125px",
              fontSize: "15px",
              backgroundColor: theme2.colors.yetAnotherGray12,
              color: theme2.fontWeights.yetAnotherGray23,
              fontWeight: theme2.fontWeights.regular,
              textTransform: "capitalize"
            },
            selectedOption: {
              backgroundColor: theme2.colors.white,
              border: `1px solid ${theme2.colors.yetAnotherGray22}`,
              borderRadius: theme2.borderRadius.l,
              boxShadow: "0px 4px 4px 0px rgba(159, 159, 159, 0.25)",
              padding: "8px 25px",
              color: theme2.colors.charcoal,
              fontWeight: theme2.fontWeights.medium
            }
          },
          value: runsheetDisplayMode
        }
      ))
    ), runsheetDisplayMode !== RUNSHEET_DISPLAYMODE.ALL && /* @__PURE__ */ React__default.createElement(Box, { className: classes.informationContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.informationTitle }, "Information"), Object.keys(RUNSHEET_DISPLAYMODE_OVERVIEW_OPTIONS).map((option) => {
      return /* @__PURE__ */ React__default.createElement(Box, { key: option, className: classes.optionContainer }, /* @__PURE__ */ React__default.createElement(
        Checkbox,
        {
          color: theme2.colors.charcoal,
          label: option,
          onChange: (value) => onChangeDisplayModeOverview(option, value),
          selected: runsheetDisplayModeOverview[option],
          style: {
            label: { color: theme2.colors.charcoal, lineHeight: "normal" },
            checkboxBox: { height: "22px", width: "22px" }
          }
        }
      ));
    })), /* @__PURE__ */ React__default.createElement(
      Divider,
      {
        style: {
          color: theme2.colors.yetAnotherGray24,
          marginLeft: "-10px",
          marginRight: "-10px"
        }
      }
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.timeSeparatorContainer,
        onClick: (e) => timeSeparatorAnchorEl ? setTimeSeparatorAnchorEl(null) : setTimeSeparatorAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(Box, null, "Time separator:", " ", /* @__PURE__ */ React__default.createElement("span", { style: { fontWeight: theme2.fontWeights.medium } }, runsheetTimeSeparator !== false ? "On" : "Off")),
      /* @__PURE__ */ React__default.createElement(
        ChevronRight,
        {
          style: {
            width: "8px",
            transform: timeSeparatorAnchorEl && "rotate(180deg)",
            transition: "transform 0.1s"
          }
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      RunSheetTimeSeparatorPopover$1,
      {
        anchor: timeSeparatorAnchorEl,
        setAnchor: setTimeSeparatorAnchorEl
      }
    ))
  );
};
RunSheetDisplayModePopover.defaultProps = {
  anchor: null,
  setAnchor: () => {
  },
  innerStyle: {}
};
RunSheetDisplayModePopover.propTypes = {
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func,
  restId: PropTypes.string.isRequired,
  runsheetDisplayMode: PropTypes.string.isRequired,
  runsheetDisplayModeOverview: PropTypes.shape({}).isRequired,
  obeeSettings: obeeSettingPropTypes.isRequired,
  updateObeeSettings: PropTypes.func.isRequired,
  setRunSheetDisplayMode: PropTypes.func.isRequired,
  setRunSheetDisplayModeOverview: PropTypes.func.isRequired,
  runsheetTimeSeparator: PropTypes.bool.isRequired,
  innerStyle: PropTypes.shape({})
};
const mapStateToProps$35 = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode,
  runsheetDisplayModeOverview: state.obeeScreen.runsheetDisplayModeOverview,
  runsheetTimeSeparator: state.obeeScreen.runsheetTimeSeparator,
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$34 = (dispatch) => bindActionCreators(
  {
    updateObeeSettings: updateSettingsAction,
    setRunSheetDisplayMode: setRunSheetDisplayModeAction,
    setRunSheetDisplayModeOverview: setRunSheetDisplayOverviewAction
  },
  dispatch
);
const RunSheetDisplayModePopover$1 = connect(mapStateToProps$35, mapDispatchToProps$34)(RunSheetDisplayModePopover);
const RunSheetDisplayMode = ({ runsheetDisplayMode, setRunSheetDisplayMode }) => {
  const classes = useStyles$1V();
  const [displayModeAnchorEl, setDisplayModeAnchorEl] = useState(null);
  const onChangeDisplayMode = () => {
    if (runsheetDisplayMode === RUNSHEET_DISPLAYMODE.ALL) {
      setRunSheetDisplayMode(RUNSHEET_DISPLAYMODE.FILTERED);
    } else {
      setRunSheetDisplayMode(RUNSHEET_DISPLAYMODE.ALL);
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingCardRow} ${classes.statusColumn}` }, /* @__PURE__ */ React__default.createElement(
    RoundButton,
    {
      onClick: onChangeDisplayMode,
      style: { button: { padding: "0 0 0 14px", overflow: "hidden" } }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.displayModeContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.displayModeLabel }, "Show: ", runsheetDisplayMode), /* @__PURE__ */ React__default.createElement(
      RoundButton,
      {
        type: "custom",
        style: {
          button: {
            padding: "0",
            height: "34px",
            width: "30px",
            border: "none",
            paddingRight: "3px"
          },
          buttonHover: { filter: "none" }
        },
        className: classes.displayModePopoverButton,
        onClick: (e) => setDisplayModeAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(
        DownCaretSVG,
        {
          style: {
            width: "9px",
            height: "6px",
            transform: displayModeAnchorEl && "rotate(180deg)",
            transition: "transform 0.1s"
          }
        }
      )
    ))
  ), /* @__PURE__ */ React__default.createElement(RunSheetDisplayModePopover$1, { anchor: displayModeAnchorEl, setAnchor: setDisplayModeAnchorEl }));
};
RunSheetDisplayMode.propTypes = {
  runsheetDisplayMode: PropTypes.string.isRequired,
  setRunSheetDisplayMode: PropTypes.func.isRequired
};
const mapStateToProps$34 = (state) => ({
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode
});
const mapDispatchToProps$33 = (dispatch) => bindActionCreators(
  {
    setRunSheetDisplayMode: setRunSheetDisplayModeAction
  },
  dispatch
);
const RunSheetDisplayMode$1 = connect(mapStateToProps$34, mapDispatchToProps$33)(RunSheetDisplayMode);
const useStyles$1D = createUseStyles(
  (theme2) => ({
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "8px"
    },
    sortIcon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: theme2.colors.black
    },
    activeSorting: {
      width: "18px",
      height: "18px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: theme2.colors.linen,
      border: `1px solid ${theme2.colors.black}`,
      borderRadius: theme2.borderRadius.xxxl
    }
  }),
  { name: "RunSheetSortableHeaderStyles" }
);
const RunSheetSortableHeader = ({ headerName, sortable, onChangeSorting, classnames, styles: styles2 }) => {
  const classes = useStyles$1D();
  const activeSorting = useMemo(() => {
    if (sortable.column.label === headerName) {
      return true;
    }
    return false;
  }, [sortable.column, headerName]);
  const sortIconStyle = useMemo(() => {
    if (activeSorting && sortable.direction === "asc") {
      return { transform: "rotate(180deg)" };
    }
    return {};
  }, [activeSorting, sortable.direction]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classnames} ${classes.container}`, style: styles2 }, /* @__PURE__ */ React__default.createElement(
    RoundButton,
    {
      type: "custom",
      onClick: () => onChangeSorting(
        Object.values(RUNSHEET_SORTABLE_HEADERS).find((h) => h.label === headerName)
      ),
      style: {
        button: {
          backgroundColor: "inherit",
          border: "none",
          borderRadius: 0,
          height: "auto",
          padding: 0
        },
        text: {
          gap: "8px"
        }
      }
    },
    headerName,
    /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.sortIcon} ${activeSorting ? classes.activeSorting : ""}` }, /* @__PURE__ */ React__default.createElement(
      DownCaretSVG,
      {
        style: {
          width: "9px",
          height: "6px",
          transition: "transform 0.1s",
          ...sortIconStyle
        }
      }
    ))
  ));
};
RunSheetSortableHeader.defaultProps = {
  classnames: "",
  styles: {}
};
RunSheetSortableHeader.propTypes = {
  headerName: PropTypes.string.isRequired,
  sortable: PropTypes.shape({
    column: PropTypes.instanceOf(Object).isRequired,
    direction: PropTypes.string.isRequired
  }).isRequired,
  onChangeSorting: PropTypes.func.isRequired,
  classnames: PropTypes.string,
  styles: PropTypes.shape({})
};
const mapStateToProps$33 = () => ({});
const mapDispatchToProps$32 = () => ({});
const RunSheetSortableHeader$1 = connect(mapStateToProps$33, mapDispatchToProps$32)(RunSheetSortableHeader);
const RunSheet$1 = ({
  date,
  obeeBookings: obeeBookings2,
  restaurant,
  obeeSettings: obeeSettings2,
  obeeSessions: obeeSessions2,
  sessionFilter,
  areas,
  runsheetDisplayMode,
  runsheetDisplayModeOverview
}) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$1V();
  const history = useHistory();
  const isMobile = useBreakpointDown(runsheetIpadViewBreakpoint);
  const query = useQuery();
  const type2 = query.get("type");
  const loading = useFetchBookingsData();
  const [activeTab, setActiveTab] = useState(type2 || "bookings");
  const [filteredBookings, setFilteredBookings] = useState({
    sessionBookings: [],
    waitlistBookings: [],
    cancelledBookings: [],
    noShowBookings: [],
    bookingsBySession: {}
  });
  const [sortable, setSortable] = useState(DEFAULT_SORTABLE);
  const todaySessions = useMemo(() => {
    return getTodaySessions(date, obeeSessions2, sessionFilter);
  }, [obeeSessions2.data, date, sessionFilter]);
  const bookingsForSession = useMemo(() => {
    return getBookingsForSessions(
      obeeBookings2.data,
      todaySessions,
      true,
      sessionFilter === "all_sessions"
    ).filter((booking) => (booking == null ? void 0 : booking.date) === formatDate(date, "YYYY-MM-DD"));
  }, [todaySessions, obeeBookings2.data]);
  const areasById = useMemo(() => {
    return groupObjects(areas.data, "id", false);
  }, [areas.data]);
  const getComments = (booking) => {
    if (isEmpty(booking == null ? void 0 : booking.restaurantComments) && isEmpty(booking == null ? void 0 : booking.customerComments)) {
      return "No comments";
    }
    return getFullComments(booking);
  };
  useEffect(() => {
    const runsheetBookings = bookingsForSession.map((booking) => {
      var _a2;
      return {
        ...booking,
        areaName: (_a2 = areasById == null ? void 0 : areasById[booking == null ? void 0 : booking.areaId]) == null ? void 0 : _a2.name,
        fullComments: getComments(booking)
      };
    });
    const sortedBookings = sortListByProperty(
      sortListByProperty(runsheetBookings, "tableNumber"),
      "startTime"
    );
    let sessionBookings = [];
    let waitlistBookings = [];
    let cancelledBookings = [];
    let noShowBookings = [];
    sortedBookings == null ? void 0 : sortedBookings.forEach((booking) => {
      if ((booking == null ? void 0 : booking.date) !== formatDate(date, "YYYY-MM-DD")) {
        return;
      }
      if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.WAITING) {
        waitlistBookings = [...waitlistBookings, booking];
        return;
      }
      if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.CANCELLED) {
        cancelledBookings = [...cancelledBookings, booking];
        return;
      }
      if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.NO_SHOW) {
        noShowBookings = [...noShowBookings, booking];
        return;
      }
      sessionBookings = [...sessionBookings, booking];
    });
    const bookingsBySession = groupBookingsBySessionLabel(sessionBookings, todaySessions);
    setFilteredBookings({
      sessionBookings,
      waitlistBookings,
      cancelledBookings,
      noShowBookings,
      bookingsBySession
    });
  }, [bookingsForSession, areasById]);
  const changeActiveTab = (newValue) => {
    setActiveTab(newValue);
    setSortable(DEFAULT_SORTABLE);
    if (newValue === "waitlist") {
      history.replace({
        search: `?type=${newValue}`
      });
    } else {
      history.replace({
        search: ""
      });
    }
  };
  const SHOW_SOURCE_COLUMN = useMemo(() => {
    return runsheetDisplayModeOverview.Source || runsheetDisplayMode === RUNSHEET_DISPLAYMODE.ALL;
  }, [runsheetDisplayModeOverview, runsheetDisplayMode]);
  const onChangeSorting = useCallback(
    (column) => {
      if (sortable.column.label === column.label) {
        setSortable({
          ...sortable,
          direction: sortable.direction === "asc" ? "desc" : "asc"
        });
      } else {
        setSortable({
          column,
          direction: "asc"
        });
      }
    },
    [sortable]
  );
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.tabContainer }, /* @__PURE__ */ React__default.createElement(
    BookingsTabBar$1,
    {
      setActiveTab: changeActiveTab,
      activeTab,
      waitingBookings: filteredBookings == null ? void 0 : filteredBookings.waitlistBookings,
      showWaitlist: (_a = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _a.waitlist
    }
  )), /* @__PURE__ */ React__default.createElement(NotePreviewBig$1, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.printButtonContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.printButton, onClick: () => window.print() }, /* @__PURE__ */ React__default.createElement(PrinterIconSVG$1, { style: { color: theme2.colors.linen, width: "24px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Print")))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableContainer }, /* @__PURE__ */ React__default.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.columnHeaderContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.columnHeadersContainer }, /* @__PURE__ */ React__default.createElement(
    RunSheetSortableHeader$1,
    {
      headerName: "Arrival",
      classnames: `${classes.bookingCardRow} ${classes.arrivalColumn}`,
      sortable,
      onChangeSorting
    }
  ), /* @__PURE__ */ React__default.createElement(
    RunSheetSortableHeader$1,
    {
      headerName: "Guest",
      classnames: `${classes.bookingCardRow} ${classes.guestColumn}`,
      sortable,
      onChangeSorting
    }
  ), /* @__PURE__ */ React__default.createElement(
    RunSheetSortableHeader$1,
    {
      headerName: "Party",
      classnames: `${classes.bookingCardRow} ${classes.partyColumn}`,
      sortable,
      onChangeSorting
    }
  ), activeTab === "bookings" && /* @__PURE__ */ React__default.createElement(
    RunSheetSortableHeader$1,
    {
      headerName: "Table",
      classnames: `${classes.bookingCardRow} ${classes.tableColumn}`,
      sortable,
      onChangeSorting
    }
  ), activeTab === "bookings" && /* @__PURE__ */ React__default.createElement(
    RunSheetSortableHeader$1,
    {
      headerName: "Area",
      classnames: `${classes.bookingCardRow} ${classes.areaColumn}`,
      sortable,
      onChangeSorting
    }
  ), !isMobile && /* @__PURE__ */ React__default.createElement(
    RunSheetSortableHeader$1,
    {
      headerName: "Comments",
      classnames: `${classes.bookingCardCommentRow}`,
      style: { minWidth: "100px" },
      sortable,
      onChangeSorting
    }
  ), SHOW_SOURCE_COLUMN && /* @__PURE__ */ React__default.createElement(
    RunSheetSortableHeader$1,
    {
      headerName: "Source",
      classnames: `${classes.bookingCardRow} ${classes.sourceColumn}`,
      sortable,
      onChangeSorting
    }
  ), activeTab === "waitlist" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsButtonRow }, " "), /* @__PURE__ */ React__default.createElement(RunSheetDisplayMode$1, null))), loading ? /* @__PURE__ */ React__default.createElement(
    Skeleton$1,
    {
      style: {
        root: {
          display: "block",
          width: "100%",
          height: "500px",
          paddingRight: "72px",
          marginTop: "20px",
          paddingLeft: "72px",
          marginBottom: "20px"
        },
        skeleton: {
          backgroundColor: theme2.colors.loadingShimmer
        }
      }
    }
  ) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, activeTab === "bookings" && /* @__PURE__ */ React__default.createElement(
    RunSheetBookingTab$1,
    {
      date,
      bookings: filteredBookings,
      sessions: todaySessions,
      sortable
    }
  ), activeTab === "waitlist" && /* @__PURE__ */ React__default.createElement(
    RunSheetWaitingListTab$1,
    {
      bookings: filteredBookings,
      sessionFilter,
      sortable
    }
  )))))), /* @__PURE__ */ React__default.createElement(
    RunSheetPrintView$1,
    {
      date,
      bookings: filteredBookings,
      restaurant,
      sessions: todaySessions,
      sortable
    }
  ));
};
RunSheet$1.defaultProps = {
  date: moment$2()
};
RunSheet$1.propTypes = {
  date: momentPropTypes.momentObj,
  obeeBookings: obeeBookingsPropTypes.isRequired,
  restaurant: restaurantActivePropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  sessionFilter: PropTypes.string.isRequired,
  areas: areasPropTypes.isRequired,
  runsheetDisplayMode: PropTypes.string.isRequired,
  runsheetDisplayModeOverview: PropTypes.shape({}).isRequired,
  dailyNotes: dailyNotesPropTypes.isRequired
};
const mapStateToProps$32 = (state) => ({
  date: state.obeeScreen.date,
  obeeBookings: state.obeeBookings,
  restaurant: state.restaurantActive,
  obeeSettings: state.obeeSettings,
  obeeSessions: state.obeeSessions,
  sessionFilter: state.obeeScreen.sessionFilter,
  areas: state.areas,
  runsheetDisplayMode: state.obeeScreen.runsheetDisplayMode,
  runsheetDisplayModeOverview: state.obeeScreen.runsheetDisplayModeOverview,
  dailyNotes: state.dailyNotes
});
const mapDispatchToProps$31 = (dispatch) => bindActionCreators({}, dispatch);
const RunSheetScreen = connect(mapStateToProps$32, mapDispatchToProps$31)(RunSheet$1);
const SvgEatclubPlate = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 29 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M23.6647 17.2748C24.8135 18.4088 26.0294 18.6319 27.4878 17.9442C27.8346 17.7796 28.4277 18.1088 28.9424 18.2186C28.9014 18.4453 28.8902 18.5917 28.8492 18.7307C27.2491 24.1737 21.9602 28.4242 16.1976 28.8851C7.01108 29.6167 1.59166 23.1568 0.312332 17.2017C-1.44068 9.02984 4.38156 1.13603 12.8632 0.108154C14.529 -0.0905176 16.2169 -0.0151035 17.8574 0.331288C18.2789 0.419078 18.4691 0.5215 18.3684 1.01532C18.2565 1.54938 18.0663 1.91883 17.5926 2.27365C16.5184 3.07839 16.2797 4.19406 16.7459 5.5292C13.4114 4.9732 10.5097 5.74136 8.11884 8.05683C6.60826 9.52 5.69073 11.3051 5.48559 13.3755C5.03055 17.9954 7.7757 22.0009 12.1918 23.2519C16.1503 24.3822 21.535 22.8019 23.6647 17.2748Z", fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17.2598 6.55638C16.5175 7.5111 16.0849 8.50239 16.3049 9.69122C16.4989 10.7374 17.0434 11.5385 17.9087 12.1676C18.1102 12.314 18.3153 12.581 18.3339 12.8114C18.5391 15.1123 20.4376 16.6047 22.7762 16.2682C22.8395 16.2645 22.903 16.2645 22.9664 16.2682C22.8545 18.7995 20.0534 21.7039 16.9502 22.5342C13.3696 23.4889 9.55023 22.055 7.54359 19.0043C5.52576 15.9353 5.78311 11.9555 8.18138 9.11327C10.3559 6.54175 14.3132 5.40779 17.2598 6.55638Z", fill: "currentColor" }));
const PlateSVG = SvgEatclubPlate;
const SvgObeeArrow = (props) => /* @__PURE__ */ React$7.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 214.86 281.18", ...props }, /* @__PURE__ */ React$7.createElement("path", { fill: "currentColor", d: "M248.3,178.28,37.9,1.74a2,2,0,0,0-2.41-.35,2,2,0,0,0-1.17,2.16L58.5,280.21a2.55,2.55,0,0,0,1.62,2,2.3,2.3,0,0,0,2.36-.61l75.12-89.52,109.27-9.53a2.56,2.56,0,0,0,2.18-1.78A2.23,2.23,0,0,0,248.3,178.28ZM66.09,93.37h-8.7V73.86h8.73Zm35,11.67-7.55-4.36,9.76-16.89,7.53,4.36Zm23.8,22.53,16.88-9.76,4.35,7.58-16.88,9.73Zm32,47.17-19.52,0V166h19.52Z", transform: "translate(-34.3 -1.14)" }));
const ObeeArrowSVG = SvgObeeArrow;
const Logo = () => {
  const theme2 = useTheme$1();
  const obee2 = isObee();
  if (obee2) {
    return /* @__PURE__ */ React__default.createElement(
      ObeeArrowSVG,
      {
        style: {
          // color: theme.colors.brandPrimary,
          color: theme2.colors.charcoal,
          // marginTop: '2px',
          width: "29px",
          height: "29px"
        }
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(PlateSVG, { style: { color: theme2.colors.charcoal, width: "26px", height: "26px" } });
};
const Logo$1 = Logo;
const setFormEditingAction = (formId, hasUnsavedChanges = false) => (dispatch) => {
  dispatch({
    type: "SET_FORM_EDITING",
    payload: { formId, hasUnsavedChanges }
  });
};
const formAwareRedirectAction = (redirectFunction) => (dispatch) => {
  const state = store$1 == null ? void 0 : store$1.getState();
  const formState = state == null ? void 0 : state.form;
  if (formState == null ? void 0 : formState.hasUnsavedChanges) {
    if (!window.confirm("You have unsaved changes on this page. Are you sure you want to leave?")) {
      return false;
    }
  }
  dispatch({
    type: "CLEAR_FORM_EDITING"
  });
  redirectFunction();
  return true;
};
const canEditAll = () => {
  var _a, _b2, _c2, _d2, _e2;
  const user = (_a = store$1.getState()) == null ? void 0 : _a.user;
  if ((_b2 = window.bookingsConfig) == null ? void 0 : _b2.editNone) {
    return false;
  }
  if (isObee()) {
    return (user == null ? void 0 : user.isAdmin) === true || ((_c2 = window.bookingsConfig) == null ? void 0 : _c2.editAll) === true;
  }
  return ((_d2 = user == null ? void 0 : user.userInfo) == null ? void 0 : _d2.userType) === "staff" || ((_e2 = window.bookingsConfig) == null ? void 0 : _e2.editAll) === true;
};
const hasNewWidget = (obeeSettings2) => {
  var _a;
  return canEditAll() || ((_a = obeeSettings2 == null ? void 0 : obeeSettings2.customOverrides) == null ? void 0 : _a.hasNewWidget) || false;
};
const fetchWidgetSettingsAction = () => (dispatch) => {
  const action = "FETCH_WIDGET_SETTINGS";
  const entityName = "fetchWidgetSettings";
  const data = {};
  const request = () => fetchWidgetSettings(data);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const updateWidgetSettingsAction = (settings) => (dispatch) => {
  const action = "UPDATE_WIDGET_SETTING";
  const entityName = "saveWidgetSettings";
  const data = convertDataForApi(settings);
  const successMessage = "Widget settings successfully updated";
  const errorMessage = "Unable to update widget settings";
  devLog("info", "updating widget settings:", settings, data, data.theme, data.settings);
  const request = async () => {
    return Promise.all([
      updateWidgetTheme({ settings: data.theme }),
      updateBookingWidgetSettings({ settings: data.settings })
    ]);
  };
  dispatch(
    makeApiAction(
      action,
      request,
      settings,
      entityName,
      successMessage,
      null,
      false,
      errorMessage,
      true,
      () => {
        setTimeout(() => {
          dispatch(fetchSettingsAction());
        }, 50);
      }
    )
  );
};
const formPropTypes$1 = PropTypes.shape({
  fields: PropTypes.shape({}),
  hasUnsavedChanges: PropTypes.bool,
  form: PropTypes.shape({}),
  setFieldValue: PropTypes.func,
  save: PropTypes.func,
  clear: PropTypes.func,
  setFieldValues: PropTypes.func
});
const useForm = (formFields, onSave, onSetEditing = null, options = null) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  useState(false);
  useState(null);
  const [form, setForm] = useState({});
  const getDefaultFieldValues = (providedFields) => {
    const defaultFieldValues = (field) => ({
      id: field == null ? void 0 : field.id,
      value: field.value,
      oldValue: field.value,
      isChanged: false,
      error: null,
      // From API if save failed
      setValue: () => {
      },
      validate: () => {
      },
      validationError: null,
      // before saved
      // onChange: (newValue) =>
      //   setFieldValue(field?.id, newValue, field?.entityName, field?.entityId), // exposed?
      setError: () => {
      }
      // exposed
    });
    const nestedFields = providedFields.filter((field) => !isEmpty(field == null ? void 0 : field.entityName));
    let fieldProperties = {};
    nestedFields.forEach((field) => {
      if (!fieldProperties[field.entityName]) {
        fieldProperties[field.entityName] = {};
      }
      if (!fieldProperties[field.entityName][field.entityId]) {
        fieldProperties[field.entityName][field.entityId] = {};
      }
      fieldProperties[field.entityName][field.entityId][field.id] = defaultFieldValues(field);
    });
    fieldProperties = {
      ...fieldProperties,
      ...groupObjects(
        providedFields.map((field) => defaultFieldValues(field)),
        "id",
        false
      )
    };
    return fieldProperties;
  };
  const defaultFormValues = useMemo(() => {
    return getDefaultFieldValues(formFields);
  }, [formFields]);
  const [fields, setFields] = useState(defaultFormValues);
  const getChangedFields = (fieldsToCheck) => {
    if (!isObject$1(fieldsToCheck)) {
      return false;
    }
    const changedFields = Object.entries(fieldsToCheck).filter(([_key, value]) => {
      if (Object == null ? void 0 : Object.hasOwn(value, "isChanged")) {
        return value == null ? void 0 : value.isChanged;
      }
      return !isEmpty(
        Object.entries(value).filter(([_entityKey, entityValue]) => {
          return checkHasChangedFields(entityValue);
        })
      );
    });
    return changedFields;
  };
  function checkHasChangedFields(fieldsToCheck) {
    return !isEmpty(getChangedFields(fieldsToCheck));
  }
  const convertFieldsForSaving = (fieldsToSave, level = 0) => {
    if (level > 5) {
      return null;
    }
    const submissionFields = {};
    fieldsToSave.forEach(([changedFieldId, changedFieldValue]) => {
      if (Object == null ? void 0 : Object.hasOwn(changedFieldValue, "value")) {
        if (Array.isArray(changedFieldValue == null ? void 0 : changedFieldValue.value)) {
          submissionFields[changedFieldId] = stringifyArray(changedFieldValue == null ? void 0 : changedFieldValue.value);
        } else {
          submissionFields[changedFieldId] = changedFieldValue == null ? void 0 : changedFieldValue.value;
        }
        return;
      }
      const entityValues = {};
      Object.entries(changedFieldValue).forEach(([entityKey, entityValue]) => {
        entityValues[entityKey] = convertFieldsForSaving(Object.entries(entityValue), level + 1);
      });
      submissionFields[changedFieldId] = stringifyObject(entityValues);
    });
    return submissionFields;
  };
  const save = useCallback(() => {
    const fieldsToSave = (options == null ? void 0 : options.saveAll) ? fields : getChangedFields(fields);
    const submissionFields = convertFieldsForSaving(fieldsToSave);
    if (onSave) {
      onSave(submissionFields);
    }
  }, [fields, onSave, options]);
  const clear2 = useCallback(() => {
    setFields(getDefaultFieldValues(formFields));
    setHasUnsavedChanges(false);
  }, [fields]);
  const setFieldValue = useCallback(
    async (id, value, entityName = null, entityId = null) => {
      var _a, _b2;
      if (entityName) {
        if (isEmpty((_b2 = (_a = fields == null ? void 0 : fields[entityName]) == null ? void 0 : _a[entityId]) == null ? void 0 : _b2[id])) {
          console.error(`Field ${id} does not exist on form`);
          return;
        }
      } else {
        if (isEmpty(fields == null ? void 0 : fields[id])) {
          console.error(`Field ${id} does not exist on form`);
          return;
        }
      }
      const newFields = { ...fields };
      if (entityName) {
        const isChanged = !areEqual$2(value, newFields[entityName][entityId][id].oldValue);
        newFields[entityName][entityId][id] = {
          ...newFields[entityName][entityId][id],
          value,
          isChanged
        };
      } else {
        const isChanged = !areEqual$2(value, newFields[id].oldValue);
        newFields[id] = {
          ...newFields[id],
          value,
          isChanged
        };
      }
      setFields(newFields);
      setHasUnsavedChanges(checkHasChangedFields(newFields));
    },
    [fields]
  );
  const setFieldValues = useCallback(
    async (items) => {
      const newFields = { ...fields };
      items.forEach((item) => {
        if (item == null ? void 0 : item.entityName) {
          const isChanged = (item == null ? void 0 : item.value) !== newFields[item == null ? void 0 : item.entityName][item == null ? void 0 : item.entityId][item == null ? void 0 : item.id].oldValue;
          newFields[item == null ? void 0 : item.entityName][item == null ? void 0 : item.entityId][item == null ? void 0 : item.id] = {
            ...newFields[item == null ? void 0 : item.entityName][item == null ? void 0 : item.entityId][item == null ? void 0 : item.id],
            value: item == null ? void 0 : item.value,
            isChanged
          };
        } else {
          const isChanged = (item == null ? void 0 : item.value) !== newFields[item == null ? void 0 : item.id].oldValue;
          newFields[item == null ? void 0 : item.id] = {
            ...newFields[item == null ? void 0 : item.id],
            value: item == null ? void 0 : item.value,
            isChanged
          };
        }
      });
      setFields(newFields);
      setHasUnsavedChanges(checkHasChangedFields(newFields));
    },
    [fields]
  );
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setFields(defaultFormValues);
    setHasUnsavedChanges(checkHasChangedFields(defaultFormValues));
  }, [formFields]);
  React__default.useEffect(() => {
    if (hasUnsavedChanges) {
      window.onbeforeunload = () => {
        return "You have unsaved changes on this page. Are you sure you want to leave??";
      };
    } else {
      window.onbeforeunload = null;
    }
    if (onSetEditing) {
      onSetEditing(hasUnsavedChanges);
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [hasUnsavedChanges]);
  return { hasUnsavedChanges, fields, form, setFieldValue, save, clear: clear2, setFieldValues };
};
const useStyles$1C = createUseStyles((theme2) => ({
  container: {
    fontSize: "15px",
    color: theme2.colors.smoke
  },
  label: {
    fontSize: "15px",
    color: theme2.colors.jet,
    fontWeight: theme2.fontWeights.medium
  },
  infoText: {}
}));
const ImageUpload = ({
  onChange,
  onError,
  onUpload,
  onRemove,
  minWidth,
  minHeight,
  fileNamePrepend,
  fileLink,
  maxSizeInMB,
  formatsAccepted,
  label,
  maxWidth,
  maxHeight
}) => {
  const classes = useStyles$1C();
  return /* @__PURE__ */ React__default.createElement(Spacer, { className: classes.container, direction: "vertical", gap: 12 }, label && /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label), /* @__PURE__ */ React__default.createElement(
    FileUpload,
    {
      fileLink,
      onChange,
      minWidth,
      minHeight,
      maxHeight,
      maxWidth,
      onRemove,
      onError,
      maxSizeInMB,
      handleImageUpload: onUpload,
      fileNamePrepend,
      includeTimestamp: true,
      allowedFileTypes: ["image/jpeg", "image/jpg", "image/png", "image/webp"]
    }
  ), /* @__PURE__ */ React__default.createElement(Spacer, { gap: 8 }, /* @__PURE__ */ React__default.createElement(Box, null, "Recommended sizing"), /* @__PURE__ */ React__default.createElement(
    Tooltip,
    {
      showOnHover: false,
      message: /* @__PURE__ */ React__default.createElement(Box, { className: classes.infoText }, "Maximum file size: ", maxSizeInMB, " MB", /* @__PURE__ */ React__default.createElement("br", null), "Formats accepted: ", formatsAccepted)
    }
  )));
};
ImageUpload.defaultProps = {
  onError: (e) => e,
  onUpload: (e) => e,
  onRemove: (e) => e,
  minWidth: null,
  minHeight: null,
  fileNamePrepend: null,
  fileLink: null,
  onChange: () => {
  },
  style: {},
  maxSizeInMB: 1,
  formatsAccepted: "jpeg, jpg, png, webp",
  label: null,
  maxWidth: 600,
  maxHeight: 600
};
ImageUpload.propTypes = {
  onError: PropTypes.func,
  onUpload: PropTypes.func,
  onRemove: PropTypes.func,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  fileNamePrepend: PropTypes.string,
  fileLink: PropTypes.string,
  maxSizeInMB: PropTypes.number,
  formatsAccepted: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.shape({}),
  label: PropTypes.string,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number
};
const mapStateToProps$31 = () => ({});
const mapDispatchToProps$30 = (dispatch) => bindActionCreators({}, dispatch);
const ImageUpload$1 = connect(mapStateToProps$31, mapDispatchToProps$30)(ImageUpload);
const useStyles$1B = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    alignItems: "baseline",
    gap: (props) => (props == null ? void 0 : props.inlineLabel) ? "10px" : (props == null ? void 0 : props.gap) ?? "8px",
    // alignItems: 'center',
    flexDirection: (props) => (props == null ? void 0 : props.inlineLabel) ? "row" : "column"
  },
  field: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "space-between",
    height: (props) => (props == null ? void 0 : props.allowTyping) ? "38px" : "48px",
    padding: (props) => (props == null ? void 0 : props.allowTyping) ? "0 14px 0 0" : "10px 12px",
    borderRadius: "6px",
    boxSizing: "border-box",
    width: "100%",
    fontSize: "16px",
    minWidth: "100px",
    // borderRadius: '4px',
    border: `1px solid ${theme2.colors.shark}`
    // cursor: 'text',
  },
  label: {
    color: theme2.colors.smoke,
    fontSize: "15px",
    userSelect: "none",
    minWidth: "120px"
  },
  incrementButton: {},
  value: {
    minWidth: "60px",
    color: theme2.colors.charcoal,
    display: "flex",
    gap: "6px",
    alignItems: "center",
    whiteSpace: "nowrap"
  },
  prefix: {
    display: "flex",
    gap: "16px",
    alignItems: "center"
  },
  buttons: {
    display: "flex",
    gap: "8px",
    borderRadius: "40px"
  }
}));
const SvgMinus = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 13 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M12 1L1 1", stroke: "currentColor", strokeLinecap: "round" }));
const MinusIconSVG = SvgMinus;
const SvgPlus = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M6.5 1V12", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12 6.5L1 6.5", stroke: "currentColor", strokeLinecap: "round" }));
const PlusIconSVG = SvgPlus;
const NumberIncrement = ({
  label,
  value,
  onChange,
  min,
  max,
  prefix,
  suffix,
  allowTyping,
  inlineLabel,
  onBlur: onBlur2,
  textIfNone,
  // What to show if the value is zero
  gap
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1B({ allowTyping, inlineLabel, gap });
  const increment = (e) => {
    e == null ? void 0 : e.stopPropagation();
    const newValue = value + 1;
    if (max !== null && newValue > max) {
      return;
    }
    onChange(newValue);
  };
  const decrement = (e) => {
    e == null ? void 0 : e.stopPropagation();
    const newValue = value - 1;
    if (min !== null && newValue < min) {
      return;
    }
    onChange(newValue);
  };
  const handleBlur = () => {
    if (isEmpty(value)) {
      onChange(0);
      setTimeout(() => {
        onBlur2();
      }, 50);
      return;
    }
    if (!isEmpty(max) && value > max) {
      onChange(max);
      setTimeout(() => {
        onBlur2();
      }, 50);
      return;
    }
    if (!isEmpty(min) && value < min) {
      onChange(min);
      setTimeout(() => {
        onBlur2();
      }, 50);
      return;
    }
    onBlur2();
  };
  const buttonStyles2 = {
    button: {
      display: "flex",
      justifyContent: "center",
      userSelect: "none",
      width: "24px",
      height: "24px",
      backgroundColor: "white",
      border: `1px solid ${theme2.colors.shark}`,
      borderRadius: "40px",
      alignItems: "center"
    },
    buttonHover: {
      backgroundColor: theme2.colors.lightCloud,
      border: `1px solid ${theme2.colors.charcoal}`
    },
    buttonActive: {
      backgroundColor: theme2.colors.lightCloud,
      border: `1px solid ${theme2.colors.charcoal}`
    }
  };
  const valueToShow = value === 0 ? textIfNone ?? value : value;
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label), /* @__PURE__ */ React__default.createElement(Box, { className: classes.field }, allowTyping ? /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      value: valueToShow ?? "",
      onFocus: () => {
        if (value === 0) {
          onChange(null);
        }
      },
      onChange,
      onBlur: handleBlur,
      suffix,
      minNumber: 0,
      style: {
        container: { flex: 1 },
        input: { borderRadius: "6px 0 0 6px", width: "100%" }
      }
    }
  ) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.value }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.prefix }, prefix), /* @__PURE__ */ React__default.createElement("span", { style: { whiteSpace: "nowrap" } }, valueToShow, " ", suffix)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttons }, /* @__PURE__ */ React__default.createElement(Button, { type: "custom", onClick: decrement, style: buttonStyles2 }, /* @__PURE__ */ React__default.createElement(MinusIconSVG, { style: { height: "2px" } })), /* @__PURE__ */ React__default.createElement(Button, { type: "custom", onClick: increment, style: buttonStyles2 }, /* @__PURE__ */ React__default.createElement(PlusIconSVG, { style: { height: "13px" } })))));
};
NumberIncrement.defaultProps = {
  label: null,
  value: null,
  min: null,
  max: null,
  onChange: () => {
  },
  onBlur: () => {
  },
  prefix: null,
  suffix: null,
  allowTyping: false,
  inlineLabel: false,
  textIfNone: null,
  gap: null
};
NumberIncrement.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  prefix: PropTypes.element,
  suffix: PropTypes.element,
  allowTyping: PropTypes.bool,
  inlineLabel: PropTypes.bool,
  textIfNone: PropTypes.string,
  gap: PropTypes.string
  // Custom gap style
};
const mapStateToProps$30 = () => ({});
const mapDispatchToProps$2$ = (dispatch) => bindActionCreators({}, dispatch);
const NumberIncrement$1 = connect(mapStateToProps$30, mapDispatchToProps$2$)(NumberIncrement);
const TextField = ({
  label,
  value,
  onChange,
  autofocus,
  onFocus: onFocus2,
  onBlur: onBlur2,
  required,
  disabled,
  editable,
  error,
  minNumber,
  maxNumber,
  type: type2,
  inputSuffix,
  inputPrefix,
  icon,
  ...others
}) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    TextField$2,
    {
      label,
      value,
      type: type2,
      minNumber,
      maxNumber,
      onChange,
      placeholder: "Empty",
      autofocus,
      onFocus: onFocus2,
      onBlur: onBlur2,
      required,
      disabled,
      editable,
      error,
      inputSuffix,
      inputPrefix,
      icon,
      style: {
        container: {
          "& input": {
            "&::placeholder": {
              color: theme2.colors.nimbus
            }
          }
        },
        innerContainer: {
          display: "flex",
          gap: "8px",
          alignItems: "baseline",
          flexDirection: "column"
        },
        label: {
          color: theme2.colors.smoke,
          // color: theme.colors.red,
          // width: '100px',
          flexShrink: 0,
          marginBottom: 0,
          overflowX: "visible"
        },
        textFieldInner: {},
        input: {
          border: `1px solid ${theme2.colors.shark}`,
          width: "100%",
          color: disabled ? theme2.colors.nimbus : theme2.colors.charcoal,
          padding: "4px 14px",
          // paddingLeft: '14px',
          borderRadius: "0",
          overflow: "hidden",
          textOverflow: "ellipsis",
          transition: "background-color 0.1s",
          height: "48px",
          lineHeight: "40px"
        },
        inputActive: {
          outline: `1px solid ${theme2.colors.smoke}`
        },
        inputHover: {
          backgroundColor: !disabled && theme2.colors.yetAnotherGray12
        },
        placeholder: {
          color: theme2.colors.nimbus
        },
        textField: {
          width: "100%",
          height: "48px"
        },
        errorText: {
          margin: "4px 0 0 110px",
          color: theme2.colors.red,
          fontSize: "10px"
        },
        inputPrefix: {},
        disabled: {
          backgroundColor: theme2.colors.dateSelectBackground
          // borderRadius: '6px',
        }
      },
      ...others
    }
  );
};
TextField.defaultProps = {
  label: "",
  value: "",
  onChange: () => {
  },
  onFocus: () => {
  },
  onBlur: () => {
  },
  autofocus: false,
  required: false,
  disabled: false,
  editable: true,
  minNumber: null,
  maxNumber: null,
  type: "text",
  error: null,
  inputSuffix: null,
  inputPrefix: null,
  icon: null
};
TextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  autofocus: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  editable: PropTypes.bool,
  minNumber: PropTypes.number,
  maxNumber: PropTypes.number,
  type: PropTypes.string,
  error: PropTypes.string,
  inputSuffix: PropTypes.string,
  inputPrefix: PropTypes.string,
  icon: PropTypes.element
};
const mapStateToProps$2$ = () => ({});
const mapDispatchToProps$2_ = (dispatch) => bindActionCreators({}, dispatch);
const TextField$1 = connect(mapStateToProps$2$, mapDispatchToProps$2_)(TextField);
const addMessageAction = (id, message, severity) => (dispatch) => {
  dispatch({
    type: ADD_MESSAGE,
    payload: { id, message, severity }
  });
};
const obeeImageUploadUrlAction = (file, fileName) => new Promise((resolve, reject) => {
  var _a, _b2, _c2;
  const state = store$1 == null ? void 0 : store$1.getState();
  const restId = state.restaurantActive.restaurant.objectId;
  const slug = ((_a = state.restaurantActive.restaurant) == null ? void 0 : _a.slug) || ((_c2 = (_b2 = state == null ? void 0 : state.obeeSettings) == null ? void 0 : _b2.data) == null ? void 0 : _c2.slug);
  const data = { restId, slug, fileName };
  (async () => {
    try {
      const apiResponse = await getImageUploadUrl(data);
      devLog("success", "obeeImageUploadUrl", apiResponse);
      if (apiResponse.status === "error") {
        throw new Error("Unable to upload image");
      }
      const parsedResponse = safeParse(apiResponse.data);
      const fetchResponse = await fetch(
        new Request(parsedResponse.uploadUrl, {
          method: "PUT",
          headers: new Headers({
            // Accept: 'image/*',
            // 'Content-Type': 'image/*',
            "x-amz-acl": "public-read"
          }),
          body: file
        })
      );
      if (fetchResponse.status !== 200) {
        throw new Error("Unable to upload image");
      }
      resolve(parsedResponse.link);
    } catch (error) {
      devLog("error", "obeeImageUploadUrl", error);
      reject(error);
    }
  })();
});
const platformName = isObee() ? "Obee" : "EatClub";
var webfontloader = { exports: {} };
(function(module2) {
  (function() {
    function aa(a, b, c) {
      return a.call.apply(a.bind, arguments);
    }
    function ba(a, b, c) {
      if (!a)
        throw Error();
      if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
          var c2 = Array.prototype.slice.call(arguments);
          Array.prototype.unshift.apply(c2, d);
          return a.apply(b, c2);
        };
      }
      return function() {
        return a.apply(b, arguments);
      };
    }
    function p(a, b, c) {
      p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;
      return p.apply(null, arguments);
    }
    var q = Date.now || function() {
      return +/* @__PURE__ */ new Date();
    };
    function ca(a, b) {
      this.a = a;
      this.o = b || a;
      this.c = this.o.document;
    }
    var da = !!window.FontFace;
    function t(a, b, c, d) {
      b = a.c.createElement(b);
      if (c)
        for (var e in c)
          c.hasOwnProperty(e) && ("style" == e ? b.style.cssText = c[e] : b.setAttribute(e, c[e]));
      d && b.appendChild(a.c.createTextNode(d));
      return b;
    }
    function u(a, b, c) {
      a = a.c.getElementsByTagName(b)[0];
      a || (a = document.documentElement);
      a.insertBefore(c, a.lastChild);
    }
    function v(a) {
      a.parentNode && a.parentNode.removeChild(a);
    }
    function w(a, b, c) {
      b = b || [];
      c = c || [];
      for (var d = a.className.split(/\s+/), e = 0; e < b.length; e += 1) {
        for (var f = false, g = 0; g < d.length; g += 1)
          if (b[e] === d[g]) {
            f = true;
            break;
          }
        f || d.push(b[e]);
      }
      b = [];
      for (e = 0; e < d.length; e += 1) {
        f = false;
        for (g = 0; g < c.length; g += 1)
          if (d[e] === c[g]) {
            f = true;
            break;
          }
        f || b.push(d[e]);
      }
      a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function y(a, b) {
      for (var c = a.className.split(/\s+/), d = 0, e = c.length; d < e; d++)
        if (c[d] == b)
          return true;
      return false;
    }
    function ea(a) {
      return a.o.location.hostname || a.a.location.hostname;
    }
    function z(a, b, c) {
      function d() {
        m && e && f && (m(g), m = null);
      }
      b = t(a, "link", { rel: "stylesheet", href: b, media: "all" });
      var e = false, f = true, g = null, m = c || null;
      da ? (b.onload = function() {
        e = true;
        d();
      }, b.onerror = function() {
        e = true;
        g = Error("Stylesheet failed to load");
        d();
      }) : setTimeout(function() {
        e = true;
        d();
      }, 0);
      u(a, "head", b);
    }
    function A(a, b, c, d) {
      var e = a.c.getElementsByTagName("head")[0];
      if (e) {
        var f = t(a, "script", { src: b }), g = false;
        f.onload = f.onreadystatechange = function() {
          g || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (g = true, c && c(null), f.onload = f.onreadystatechange = null, "HEAD" == f.parentNode.tagName && e.removeChild(f));
        };
        e.appendChild(f);
        setTimeout(function() {
          g || (g = true, c && c(Error("Script load timeout")));
        }, d || 5e3);
        return f;
      }
      return null;
    }
    function B() {
      this.a = 0;
      this.c = null;
    }
    function C(a) {
      a.a++;
      return function() {
        a.a--;
        D(a);
      };
    }
    function E(a, b) {
      a.c = b;
      D(a);
    }
    function D(a) {
      0 == a.a && a.c && (a.c(), a.c = null);
    }
    function F(a) {
      this.a = a || "-";
    }
    F.prototype.c = function(a) {
      for (var b = [], c = 0; c < arguments.length; c++)
        b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
      return b.join(this.a);
    };
    function G(a, b) {
      this.c = a;
      this.f = 4;
      this.a = "n";
      var c = (b || "n4").match(/^([nio])([1-9])$/i);
      c && (this.a = c[1], this.f = parseInt(c[2], 10));
    }
    function fa(a) {
      return H(a) + " " + (a.f + "00") + " 300px " + I(a.c);
    }
    function I(a) {
      var b = [];
      a = a.split(/,\s*/);
      for (var c = 0; c < a.length; c++) {
        var d = a[c].replace(/['"]/g, "");
        -1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d);
      }
      return b.join(",");
    }
    function J(a) {
      return a.a + a.f;
    }
    function H(a) {
      var b = "normal";
      "o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");
      return b;
    }
    function ga(a) {
      var b = 4, c = "n", d = null;
      a && ((d = a.match(/(normal|oblique|italic)/i)) && d[1] && (c = d[1].substr(0, 1).toLowerCase()), (d = a.match(/([1-9]00|normal|bold)/i)) && d[1] && (/bold/i.test(d[1]) ? b = 7 : /[1-9]00/.test(d[1]) && (b = parseInt(d[1].substr(0, 1), 10))));
      return c + b;
    }
    function ha(a, b) {
      this.c = a;
      this.f = a.o.document.documentElement;
      this.h = b;
      this.a = new F("-");
      this.j = false !== b.events;
      this.g = false !== b.classes;
    }
    function ia(a) {
      a.g && w(a.f, [a.a.c("wf", "loading")]);
      K(a, "loading");
    }
    function L(a) {
      if (a.g) {
        var b = y(a.f, a.a.c("wf", "active")), c = [], d = [a.a.c("wf", "loading")];
        b || c.push(a.a.c("wf", "inactive"));
        w(a.f, c, d);
      }
      K(a, "inactive");
    }
    function K(a, b, c) {
      if (a.j && a.h[b])
        if (c)
          a.h[b](c.c, J(c));
        else
          a.h[b]();
    }
    function ja() {
      this.c = {};
    }
    function ka(a, b, c) {
      var d = [], e;
      for (e in b)
        if (b.hasOwnProperty(e)) {
          var f = a.c[e];
          f && d.push(f(b[e], c));
        }
      return d;
    }
    function M(a, b) {
      this.c = a;
      this.f = b;
      this.a = t(this.c, "span", { "aria-hidden": "true" }, this.f);
    }
    function N(a) {
      u(a.c, "body", a.a);
    }
    function O(a) {
      return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + I(a.c) + ";" + ("font-style:" + H(a) + ";font-weight:" + (a.f + "00") + ";");
    }
    function P(a, b, c, d, e, f) {
      this.g = a;
      this.j = b;
      this.a = d;
      this.c = c;
      this.f = e || 3e3;
      this.h = f || void 0;
    }
    P.prototype.start = function() {
      var a = this.c.o.document, b = this, c = q(), d = new Promise(function(d2, e2) {
        function f2() {
          q() - c >= b.f ? e2() : a.fonts.load(fa(b.a), b.h).then(function(a2) {
            1 <= a2.length ? d2() : setTimeout(f2, 25);
          }, function() {
            e2();
          });
        }
        f2();
      }), e = null, f = new Promise(function(a2, d2) {
        e = setTimeout(d2, b.f);
      });
      Promise.race([f, d]).then(function() {
        e && (clearTimeout(e), e = null);
        b.g(b.a);
      }, function() {
        b.j(b.a);
      });
    };
    function Q(a, b, c, d, e, f, g) {
      this.v = a;
      this.B = b;
      this.c = c;
      this.a = d;
      this.s = g || "BESbswy";
      this.f = {};
      this.w = e || 3e3;
      this.u = f || null;
      this.m = this.j = this.h = this.g = null;
      this.g = new M(this.c, this.s);
      this.h = new M(this.c, this.s);
      this.j = new M(this.c, this.s);
      this.m = new M(this.c, this.s);
      a = new G(this.a.c + ",serif", J(this.a));
      a = O(a);
      this.g.a.style.cssText = a;
      a = new G(this.a.c + ",sans-serif", J(this.a));
      a = O(a);
      this.h.a.style.cssText = a;
      a = new G("serif", J(this.a));
      a = O(a);
      this.j.a.style.cssText = a;
      a = new G("sans-serif", J(this.a));
      a = O(a);
      this.m.a.style.cssText = a;
      N(this.g);
      N(this.h);
      N(this.j);
      N(this.m);
    }
    var R = { D: "serif", C: "sans-serif" }, S = null;
    function T() {
      if (null === S) {
        var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
        S = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10));
      }
      return S;
    }
    Q.prototype.start = function() {
      this.f.serif = this.j.a.offsetWidth;
      this.f["sans-serif"] = this.m.a.offsetWidth;
      this.A = q();
      U(this);
    };
    function la(a, b, c) {
      for (var d in R)
        if (R.hasOwnProperty(d) && b === a.f[R[d]] && c === a.f[R[d]])
          return true;
      return false;
    }
    function U(a) {
      var b = a.g.a.offsetWidth, c = a.h.a.offsetWidth, d;
      (d = b === a.f.serif && c === a.f["sans-serif"]) || (d = T() && la(a, b, c));
      d ? q() - a.A >= a.w ? T() && la(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? V(a, a.v) : V(a, a.B) : ma(a) : V(a, a.v);
    }
    function ma(a) {
      setTimeout(p(function() {
        U(this);
      }, a), 50);
    }
    function V(a, b) {
      setTimeout(p(function() {
        v(this.g.a);
        v(this.h.a);
        v(this.j.a);
        v(this.m.a);
        b(this.a);
      }, a), 0);
    }
    function W(a, b, c) {
      this.c = a;
      this.a = b;
      this.f = 0;
      this.m = this.j = false;
      this.s = c;
    }
    var X = null;
    W.prototype.g = function(a) {
      var b = this.a;
      b.g && w(b.f, [b.a.c("wf", a.c, J(a).toString(), "active")], [b.a.c("wf", a.c, J(a).toString(), "loading"), b.a.c("wf", a.c, J(a).toString(), "inactive")]);
      K(b, "fontactive", a);
      this.m = true;
      na(this);
    };
    W.prototype.h = function(a) {
      var b = this.a;
      if (b.g) {
        var c = y(b.f, b.a.c("wf", a.c, J(a).toString(), "active")), d = [], e = [b.a.c("wf", a.c, J(a).toString(), "loading")];
        c || d.push(b.a.c("wf", a.c, J(a).toString(), "inactive"));
        w(b.f, d, e);
      }
      K(b, "fontinactive", a);
      na(this);
    };
    function na(a) {
      0 == --a.f && a.j && (a.m ? (a = a.a, a.g && w(a.f, [a.a.c("wf", "active")], [a.a.c("wf", "loading"), a.a.c("wf", "inactive")]), K(a, "active")) : L(a.a));
    }
    function oa(a) {
      this.j = a;
      this.a = new ja();
      this.h = 0;
      this.f = this.g = true;
    }
    oa.prototype.load = function(a) {
      this.c = new ca(this.j, a.context || this.j);
      this.g = false !== a.events;
      this.f = false !== a.classes;
      pa(this, new ha(this.c, a), a);
    };
    function qa(a, b, c, d, e) {
      var f = 0 == --a.h;
      (a.f || a.g) && setTimeout(function() {
        var a2 = e || null, m = d || null || {};
        if (0 === c.length && f)
          L(b.a);
        else {
          b.f += c.length;
          f && (b.j = f);
          var h, l = [];
          for (h = 0; h < c.length; h++) {
            var k = c[h], n = m[k.c], r2 = b.a, x = k;
            r2.g && w(r2.f, [r2.a.c("wf", x.c, J(x).toString(), "loading")]);
            K(r2, "fontloading", x);
            r2 = null;
            if (null === X)
              if (window.FontFace) {
                var x = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), xa = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                X = x ? 42 < parseInt(x[1], 10) : xa ? false : true;
              } else
                X = false;
            X ? r2 = new P(p(b.g, b), p(b.h, b), b.c, k, b.s, n) : r2 = new Q(p(b.g, b), p(b.h, b), b.c, k, b.s, a2, n);
            l.push(r2);
          }
          for (h = 0; h < l.length; h++)
            l[h].start();
        }
      }, 0);
    }
    function pa(a, b, c) {
      var d = [], e = c.timeout;
      ia(b);
      var d = ka(a.a, c, a.c), f = new W(a.c, b, e);
      a.h = d.length;
      b = 0;
      for (c = d.length; b < c; b++)
        d[b].load(function(b2, d2, c2) {
          qa(a, f, b2, d2, c2);
        });
    }
    function ra(a, b) {
      this.c = a;
      this.a = b;
    }
    ra.prototype.load = function(a) {
      function b() {
        if (f["__mti_fntLst" + d]) {
          var c2 = f["__mti_fntLst" + d](), e2 = [], h;
          if (c2)
            for (var l = 0; l < c2.length; l++) {
              var k = c2[l].fontfamily;
              void 0 != c2[l].fontStyle && void 0 != c2[l].fontWeight ? (h = c2[l].fontStyle + c2[l].fontWeight, e2.push(new G(k, h))) : e2.push(new G(k));
            }
          a(e2);
        } else
          setTimeout(function() {
            b();
          }, 50);
      }
      var c = this, d = c.a.projectId, e = c.a.version;
      if (d) {
        var f = c.c.o;
        A(this.c, (c.a.api || "https://fast.fonts.net/jsapi") + "/" + d + ".js" + (e ? "?v=" + e : ""), function(e2) {
          e2 ? a([]) : (f["__MonotypeConfiguration__" + d] = function() {
            return c.a;
          }, b());
        }).id = "__MonotypeAPIScript__" + d;
      } else
        a([]);
    };
    function sa(a, b) {
      this.c = a;
      this.a = b;
    }
    sa.prototype.load = function(a) {
      var b, c, d = this.a.urls || [], e = this.a.families || [], f = this.a.testStrings || {}, g = new B();
      b = 0;
      for (c = d.length; b < c; b++)
        z(this.c, d[b], C(g));
      var m = [];
      b = 0;
      for (c = e.length; b < c; b++)
        if (d = e[b].split(":"), d[1])
          for (var h = d[1].split(","), l = 0; l < h.length; l += 1)
            m.push(new G(d[0], h[l]));
        else
          m.push(new G(d[0]));
      E(g, function() {
        a(m, f);
      });
    };
    function ta(a, b) {
      a ? this.c = a : this.c = ua;
      this.a = [];
      this.f = [];
      this.g = b || "";
    }
    var ua = "https://fonts.googleapis.com/css";
    function va(a, b) {
      for (var c = b.length, d = 0; d < c; d++) {
        var e = b[d].split(":");
        3 == e.length && a.f.push(e.pop());
        var f = "";
        2 == e.length && "" != e[1] && (f = ":");
        a.a.push(e.join(f));
      }
    }
    function wa(a) {
      if (0 == a.a.length)
        throw Error("No fonts to load!");
      if (-1 != a.c.indexOf("kit="))
        return a.c;
      for (var b = a.a.length, c = [], d = 0; d < b; d++)
        c.push(a.a[d].replace(/ /g, "+"));
      b = a.c + "?family=" + c.join("%7C");
      0 < a.f.length && (b += "&subset=" + a.f.join(","));
      0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));
      return b;
    }
    function ya(a) {
      this.f = a;
      this.a = [];
      this.c = {};
    }
    var za = { latin: "BESbswy", "latin-ext": "çöüğş", cyrillic: "йяЖ", greek: "αβΣ", khmer: "កខគ", Hanuman: "កខគ" }, Aa = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" }, Ba = { i: "i", italic: "i", n: "n", normal: "n" }, Ca = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Da(a) {
      for (var b = a.f.length, c = 0; c < b; c++) {
        var d = a.f[c].split(":"), e = d[0].replace(/\+/g, " "), f = ["n4"];
        if (2 <= d.length) {
          var g;
          var m = d[1];
          g = [];
          if (m)
            for (var m = m.split(","), h = m.length, l = 0; l < h; l++) {
              var k;
              k = m[l];
              if (k.match(/^[\w-]+$/)) {
                var n = Ca.exec(k.toLowerCase());
                if (null == n)
                  k = "";
                else {
                  k = n[2];
                  k = null == k || "" == k ? "n" : Ba[k];
                  n = n[1];
                  if (null == n || "" == n)
                    n = "4";
                  else
                    var r2 = Aa[n], n = r2 ? r2 : isNaN(n) ? "4" : n.substr(0, 1);
                  k = [k, n].join("");
                }
              } else
                k = "";
              k && g.push(k);
            }
          0 < g.length && (f = g);
          3 == d.length && (d = d[2], g = [], d = d ? d.split(",") : g, 0 < d.length && (d = za[d[0]]) && (a.c[e] = d));
        }
        a.c[e] || (d = za[e]) && (a.c[e] = d);
        for (d = 0; d < f.length; d += 1)
          a.a.push(new G(e, f[d]));
      }
    }
    function Ea(a, b) {
      this.c = a;
      this.a = b;
    }
    var Fa = { Arimo: true, Cousine: true, Tinos: true };
    Ea.prototype.load = function(a) {
      var b = new B(), c = this.c, d = new ta(this.a.api, this.a.text), e = this.a.families;
      va(d, e);
      var f = new ya(e);
      Da(f);
      z(c, wa(d), C(b));
      E(b, function() {
        a(f.a, f.c, Fa);
      });
    };
    function Ga(a, b) {
      this.c = a;
      this.a = b;
    }
    Ga.prototype.load = function(a) {
      var b = this.a.id, c = this.c.o;
      b ? A(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function(b2) {
        if (b2)
          a([]);
        else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
          b2 = c.Typekit.config.fn;
          for (var e = [], f = 0; f < b2.length; f += 2)
            for (var g = b2[f], m = b2[f + 1], h = 0; h < m.length; h++)
              e.push(new G(g, m[h]));
          try {
            c.Typekit.load({ events: false, classes: false, async: true });
          } catch (l) {
          }
          a(e);
        }
      }, 2e3) : a([]);
    };
    function Ha(a, b) {
      this.c = a;
      this.f = b;
      this.a = [];
    }
    Ha.prototype.load = function(a) {
      var b = this.f.id, c = this.c.o, d = this;
      b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}), c.__webfontfontdeckmodule__[b] = function(b2, c2) {
        for (var g = 0, m = c2.fonts.length; g < m; ++g) {
          var h = c2.fonts[g];
          d.a.push(new G(h.name, ga("font-weight:" + h.weight + ";font-style:" + h.style)));
        }
        a(d.a);
      }, A(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + ea(this.c) + "/" + b + ".js", function(b2) {
        b2 && a([]);
      })) : a([]);
    };
    var Y = new oa(window);
    Y.a.c.custom = function(a, b) {
      return new sa(b, a);
    };
    Y.a.c.fontdeck = function(a, b) {
      return new Ha(b, a);
    };
    Y.a.c.monotype = function(a, b) {
      return new ra(b, a);
    };
    Y.a.c.typekit = function(a, b) {
      return new Ga(b, a);
    };
    Y.a.c.google = function(a, b) {
      return new Ea(b, a);
    };
    var Z = { load: p(Y.load, Y) };
    module2.exports ? module2.exports = Z : (window.WebFont = Z, window.WebFontConfig && Y.load(window.WebFontConfig));
  })();
})(webfontloader);
var webfontloaderExports = webfontloader.exports;
const WebFont = /* @__PURE__ */ getDefaultExportFromCjs(webfontloaderExports);
const availableFonts = [
  isObee() ? "Inter" : "Gordita",
  "Open Sans",
  // Inter and open sans at the top rather than alphabetical, since they are the most popular
  "Droid Sans",
  "Droid Serif",
  "Lato",
  "Lora",
  "Merriweather",
  "Montserrat",
  "Noto Sans",
  "Open Sans Condensed",
  "Oswald",
  "Poppins",
  "Prompt",
  "PT Sans",
  "Roboto",
  "Roboto Condensed",
  "Roboto Slab",
  "Raleway",
  "Slabo 27px",
  "Source Sans Pro",
  "Ubuntu"
];
if (!window.hasLoadedFontList) {
  window.hasLoadedFontList = true;
  WebFont.load({ google: { families: availableFonts } });
}
const FontSelector = ({ label, value, onSelect: onSelect2 }) => {
  const dropdownItems = availableFonts.map((font) => ({
    label: /* @__PURE__ */ React__default.createElement("span", { style: { fontFamily: font } }, font),
    value: font
  }));
  return /* @__PURE__ */ React__default.createElement(Dropdown$1, { label, items: dropdownItems, value, onSelect: onSelect2 });
};
FontSelector.defaultProps = {
  label: "Font",
  value: null,
  onSelect: () => {
  }
};
FontSelector.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onSelect: PropTypes.func
};
const mapStateToProps$2_ = () => ({});
const mapDispatchToProps$2Z = (dispatch) => bindActionCreators({}, dispatch);
const FontSelector$1 = connect(mapStateToProps$2_, mapDispatchToProps$2Z)(FontSelector);
const useStyles$1A = createUseStyles((theme2) => ({
  settingsSectionContainer: () => ({
    borderTop: `1px solid ${theme2.colors.nimbus}`,
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    fontSize: "15px",
    padding: "20px 0 0 0 ",
    // gap: '8px',
    fontWeight: theme2.fontWeights.regular
  }),
  children: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    // color: theme.colors.smoke,
    fontWeight: theme2.fontWeights.regular
  },
  subSection: (props) => ({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    borderBottom: (props == null ? void 0 : props.noBottomBorder) ? "1px solid transparent" : `1px solid ${theme2.colors.yetAnotherGray13}`,
    // padding: '0 0 20px 0',
    paddingBottom: "20px"
  }),
  heading: {
    ...theme2.typography.heading.H4,
    fontWeight: theme2.fontWeights.medium
  },
  subHeading: {
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium
  },
  infoText: {
    fontSize: "15px",
    color: theme2.colors.smoke
  }
}));
const buttonStyles$7 = (theme2) => ({
  button: {
    fontSize: "15px",
    padding: "5px 16px",
    fontWeight: "500",
    borderRadius: "8px"
  },
  buttonActive: {
    border: `1px solid ${theme2.colors.jet}`
  }
});
const subSectionHeaderStyles = {
  justifyContent: "space-between"
};
const SettingsSection = ({ children, basicSettings, advancedSettings, heading }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1A();
  const hasAdvancedSettings = !isEmpty(advancedSettings);
  const [showingAdvanced, setShowingAdvanced] = useState(false);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsSectionContainer }, /* @__PURE__ */ React__default.createElement(Spacer, { style: { justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, heading), hasAdvancedSettings && /* @__PURE__ */ React__default.createElement(
    SquareButton,
    {
      forceHoverState: showingAdvanced,
      onClick: () => setShowingAdvanced(!showingAdvanced),
      style: buttonStyles$7(theme2)
    },
    showingAdvanced ? "Show less" : "Advanced"
  )), /* @__PURE__ */ React__default.createElement(Spacer, { className: classes.children, gap: 20, direction: "vertical" }, showingAdvanced ? advancedSettings : basicSettings || children));
};
SettingsSection.defaultProps = {
  children: null,
  basicSettings: null,
  advancedSettings: null,
  heading: null
};
SettingsSection.propTypes = {
  children: PropTypes.node,
  basicSettings: PropTypes.node,
  advancedSettings: PropTypes.node,
  heading: PropTypes.string
};
const mapStateToProps$2Z = () => ({});
const mapDispatchToProps$2Y = (dispatch) => bindActionCreators({}, dispatch);
const SettingsSection$1 = connect(mapStateToProps$2Z, mapDispatchToProps$2Y)(SettingsSection);
const SettingsSubSection = ({ children, heading, noBottomBorder }) => {
  const classes = useStyles$1A({ noBottomBorder });
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.subSection }, heading && /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, heading), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 16 }, children));
};
SettingsSection$1.defaultProps = {
  children: null,
  heading: null,
  noBottomBorder: null
};
SettingsSubSection.propTypes = {
  children: PropTypes.node,
  heading: PropTypes.string,
  noBottomBorder: PropTypes.bool
};
const mapStateToProps$2Y = () => ({});
const mapDispatchToProps$2X = (dispatch) => bindActionCreators({}, dispatch);
const SettingsSubSection$1 = connect(mapStateToProps$2Y, mapDispatchToProps$2X)(SettingsSubSection);
const TogglableSubSection = ({
  children,
  heading,
  noBottomBorder,
  showToggle,
  toggleValue,
  onChangeToggle,
  disableToggle
}) => {
  const classes = useStyles$1A({ noBottomBorder });
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.subSection }, /* @__PURE__ */ React__default.createElement(Spacer, { style: subSectionHeaderStyles }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, heading), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      label: "",
      checked: toggleValue,
      onChange: () => onChangeToggle(!toggleValue),
      disabled: disableToggle
    }
  )), (!showToggle || toggleValue) && /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 16 }, children));
};
TogglableSubSection.defaultProps = {
  children: null,
  heading: null,
  noBottomBorder: null,
  showToggle: true,
  toggleValue: false,
  disableToggle: false,
  onChangeToggle: (e) => e
};
TogglableSubSection.propTypes = {
  children: PropTypes.node,
  heading: PropTypes.string,
  noBottomBorder: PropTypes.bool,
  showToggle: PropTypes.bool,
  toggleValue: PropTypes.bool,
  disableToggle: PropTypes.bool,
  // Prevent the user from changing the toggle's value
  onChangeToggle: PropTypes.func
};
const mapStateToProps$2X = () => ({});
const mapDispatchToProps$2W = (dispatch) => bindActionCreators({}, dispatch);
const TogglableSubSection$1 = connect(mapStateToProps$2X, mapDispatchToProps$2W)(TogglableSubSection);
const SvgFontWeight = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { width: 15, height: 2.72727, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { y: 4.0918, width: 15, height: 4.09091, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { y: 9.54492, width: 15, height: 5.45455, fill: "currentColor" }));
const FontWeightSVG = SvgFontWeight;
const Appearance = ({ addMessage: addMessage2, restaurant, form }) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const theme2 = useTheme$1();
  const handleError2 = (message) => {
    addMessage2(`UPLOAD_IMAGE_ERROR_${(/* @__PURE__ */ new Date()).getTime()}`, `${message}`, "error");
  };
  const LogoUpload = useCallback(
    () => {
      var _a2;
      return /* @__PURE__ */ React__default.createElement(
        ImageUpload$1,
        {
          fileLink: (_a2 = form.fields.navigationLogoUrl) == null ? void 0 : _a2.value,
          onChange: (value) => form.setFieldValue("navigationLogoUrl", value),
          minWidth: 240,
          minHeight: 130,
          onRemove: () => {
            form.setFieldValues([
              { id: "navigationLogoUrl", value: "" },
              { id: "navigationShowVenueName", value: true }
            ]);
          },
          onError: handleError2,
          onUpload: obeeImageUploadUrlAction,
          fileNamePrepend: `${restaurant.objectId}_logo`,
          label: "Logo",
          maxSizeInMB: 2
        }
      );
    },
    [restaurant.objectId, (_a = form.fields.navigationLogoUrl) == null ? void 0 : _a.value]
  );
  const onChangeTheme = (isDarkTheme) => {
    if (isDarkTheme && !form.fields.darkTheme.value) {
      form.setFieldValues([
        { id: "darkTheme", value: isDarkTheme },
        { id: "mainTextColour", value: "#ffffff" },
        { id: "secondaryTextColour", value: "#ffffff" },
        { id: "secondaryTextOpacity", value: "70" },
        { id: "outlineColour", value: "#ffffff" },
        { id: "outlineOpacity", value: "20" },
        { id: "activeOutlineColour", value: "#ffffff" },
        { id: "availabilityBackgroundBoxBgColour", value: "#333333" },
        { id: "navigationHeaderTextColour", value: "#ffffff" },
        { id: "providerLogoStyle", value: "white" }
      ]);
      return;
    }
    if (!isDarkTheme && form.fields.darkTheme.value) {
      form.setFieldValues([
        { id: "darkTheme", value: isDarkTheme },
        { id: "mainTextColour", value: theme2.colors.charcoal },
        { id: "secondaryTextColour", value: theme2.colors.smoke },
        { id: "secondaryTextOpacity", value: "100" },
        { id: "outlineColour", value: "#E6E6E6" },
        { id: "outlineOpacity", value: "100" },
        { id: "activeOutlineColour", value: theme2.colors.charcoal },
        { id: "availabilityBackgroundBoxBgColour", value: theme2.colors.white },
        { id: "navigationHeaderTextColour", value: theme2.colors.charcoal },
        { id: "providerLogoStyle", value: "coloured" }
      ]);
    }
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(SettingsSection$1, { heading: "Theme" }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    SegmentedControl,
    {
      onSelect: onChangeTheme,
      items: [
        { label: "Light", value: false },
        { label: "Dark", value: true }
      ],
      style: {
        option: {
          width: "120px",
          fontSize: "16px"
        }
      },
      value: (_c2 = (_b2 = form.fields) == null ? void 0 : _b2.darkTheme) == null ? void 0 : _c2.value
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, ((_e2 = (_d2 = form.fields) == null ? void 0 : _d2.darkTheme) == null ? void 0 : _e2.value) ? "Dark background with lighter text and outlines." : "Light background with darker text and outlines."))), /* @__PURE__ */ React__default.createElement(
    SettingsSection$1,
    {
      heading: "Navigation",
      basicSettings: /* @__PURE__ */ React__default.createElement(LogoUpload, null),
      advancedSettings: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, null, /* @__PURE__ */ React__default.createElement(LogoUpload, null), /* @__PURE__ */ React__default.createElement(
        Dropdown$1,
        {
          label: "Logo alignment",
          items: [
            { value: "left", label: "Left" },
            { value: "middle", label: "Centre" }
          ],
          value: form.fields.navigationLogoAlignment.value,
          onSelect: (value) => form.setFieldValue("navigationLogoAlignment", value)
        }
      ), /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16, style: { flexWrap: "wrap" } }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          value: form.fields.navigationBgColour.value,
          onChange: (newValue) => form.setFieldValue("navigationBgColour", newValue),
          label: "Navigation background colour"
        }
      ), /* @__PURE__ */ React__default.createElement(
        TextField$1,
        {
          value: form.fields.navigationBgColourTransparency.value,
          onChange: (newValue) => form.setFieldValue("navigationBgColourTransparency", newValue),
          placeholder: 100,
          label: "Background opacity",
          inputSuffix: "%",
          inputPrefix: "Opacity"
        }
      )), /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          value: form.fields.navigationUnderlineColour.value,
          onChange: (newValue) => form.setFieldValue("navigationUnderlineColour", newValue),
          label: "Underline colour",
          inputSuffix: "%"
        }
      )), /* @__PURE__ */ React__default.createElement(
        TogglableSubSection$1,
        {
          heading: "Venue name",
          toggleValue: form.fields.navigationShowVenueName.value,
          onChangeToggle: (newValue) => form.setFieldValue("navigationShowVenueName", newValue),
          disableToggle: isEmpty((_f = form.fields.navigationLogoUrl) == null ? void 0 : _f.value)
        },
        /* @__PURE__ */ React__default.createElement(
          ColorPicker,
          {
            value: form.fields.navigationVenueNameTextColour.value,
            onChange: (newValue) => form.setFieldValue("navigationVenueNameTextColour", newValue),
            label: "Venue name colour"
          }
        )
      ), /* @__PURE__ */ React__default.createElement(
        TogglableSubSection$1,
        {
          heading: "Reservations label",
          toggleValue: form.fields.navigationShowHeaderText.value,
          onChangeToggle: (newValue) => form.setFieldValue("navigationShowHeaderText", newValue)
        },
        /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
          TextField$1,
          {
            label: "Reservations label text",
            value: form.fields.navigationHeaderText.value,
            onChange: (newValue) => form.setFieldValue("navigationHeaderText", newValue)
          }
        ), /* @__PURE__ */ React__default.createElement(
          ColorPicker,
          {
            label: "Text colour",
            value: form.fields.navigationHeaderTextColour.value,
            onChange: (newValue) => form.setFieldValue("navigationHeaderTextColour", newValue)
          }
        ))
      ), /* @__PURE__ */ React__default.createElement(
        TogglableSubSection$1,
        {
          heading: "Need help button",
          noBottomBorder: true,
          toggleValue: form.fields.navigationShowNeedHelp.value,
          onChangeToggle: (newValue) => form.setFieldValue("navigationShowNeedHelp", newValue)
        },
        /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
          ColorPicker,
          {
            label: "Text colour",
            value: form.fields.navigationNeedHelpButtonTextColour.value,
            onChange: (newValue) => form.setFieldValue("navigationNeedHelpButtonTextColour", newValue)
          }
        ), /* @__PURE__ */ React__default.createElement(
          ColorPicker,
          {
            label: "Outline colour",
            value: form.fields.navigationNeedHelpButtonBorderColour.value,
            onChange: (newValue) => form.setFieldValue("navigationNeedHelpButtonBorderColour", newValue)
          }
        ))
      ))
    }
  ), /* @__PURE__ */ React__default.createElement(
    SettingsSection$1,
    {
      heading: "Background",
      basicSettings: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, form.fields.backgroundType.value === "solid" ? /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Background colour",
          value: form.fields.backgroundValue.value,
          onChange: (newValue) => form.setFieldValue("backgroundValue", newValue)
        }
      ) : /* @__PURE__ */ React__default.createElement(
        ImageUpload$1,
        {
          fileLink: (_g = form.fields.backgroundImageUrl) == null ? void 0 : _g.value,
          onChange: (value) => form.setFieldValue("backgroundImageUrl", value),
          minWidth: 300,
          minHeight: 300,
          maxWidth: 3e3,
          maxHeight: 3e3,
          onRemove: () => form.setFieldValue("backgroundImageUrl", ""),
          onError: handleError2,
          onUpload: obeeImageUploadUrlAction,
          fileNamePrepend: `${restaurant.objectId}_background`,
          label: "Background image",
          maxSizeInMB: 5
        }
      )),
      advancedSettings: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
        Dropdown$1,
        {
          label: "Type",
          items: [
            { value: "solid", label: "Solid colour" },
            { value: "image", label: "Image background" }
          ],
          value: form.fields.backgroundType.value,
          onSelect: (newValue) => form.setFieldValue("backgroundType", newValue)
        }
      ), form.fields.backgroundType.value === "solid" ? /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Background colour",
          value: form.fields.backgroundValue.value,
          onChange: (newValue) => form.setFieldValue("backgroundValue", newValue)
        }
      ) : /* @__PURE__ */ React__default.createElement(
        ImageUpload$1,
        {
          fileLink: (_h = form.fields.backgroundImageUrl) == null ? void 0 : _h.value,
          onChange: (value) => form.setFieldValue("backgroundImageUrl", value),
          minWidth: 300,
          minHeight: 300,
          maxWidth: 3e3,
          maxHeight: 3e3,
          onRemove: () => form.setFieldValue("backgroundImageUrl", ""),
          onError: handleError2,
          onUpload: obeeImageUploadUrlAction,
          fileNamePrepend: `${restaurant.objectId}_background`,
          label: "Background image",
          maxSizeInMB: 5
        }
      ), /* @__PURE__ */ React__default.createElement(
        Dropdown$1,
        {
          label: `${platformName}logo`,
          items: [
            { value: "coloured", label: "Coloured" },
            { value: "black", label: "Black" },
            { value: "white", label: "White" }
          ],
          value: form.fields.providerLogoStyle.value,
          onSelect: (newValue) => form.setFieldValue("providerLogoStyle", newValue)
        }
      ), canEditAll() && /* @__PURE__ */ React__default.createElement(
        Dropdown$1,
        {
          label: `Show ${platformName} logo`,
          items: [
            { value: true, label: "Show" },
            { value: false, label: "Hide" }
          ],
          value: form.fields.showProviderLogo.value,
          onSelect: (newValue) => form.setFieldValue("showProviderLogo", newValue)
        }
      ))
    }
  ), /* @__PURE__ */ React__default.createElement(
    SettingsSection$1,
    {
      heading: "Availability form",
      basicSettings: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Typography" }, /* @__PURE__ */ React__default.createElement(
        FontSelector$1,
        {
          value: form.fields.availabilityFontFamilies.value,
          onSelect: (value) => {
            form.setFieldValues([
              { id: "availabilityFontFamilies", value },
              { id: "generalFontFamilies", value }
            ]);
          }
        }
      )), /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Main button" }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Main button background",
          value: (_i = form.fields.availabilityMainButtonBgColour) == null ? void 0 : _i.value,
          onChange: (value) => form.setFieldValue("availabilityMainButtonBgColour", value)
        }
      )), /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Fields", noBottomBorder: true }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Active state colour",
          value: (_j = form.fields.availabilityFieldsActiveStateColour) == null ? void 0 : _j.value,
          onChange: (newValue) => form.setFieldValue("availabilityFieldsActiveStateColour", newValue)
        }
      ))),
      advancedSettings: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Typography" }, /* @__PURE__ */ React__default.createElement(
        FontSelector$1,
        {
          value: form.fields.availabilityFontFamilies.value,
          onSelect: (value) => {
            form.setFieldValues([
              { id: "availabilityFontFamilies", value },
              { id: "generalFontFamilies", value }
            ]);
          }
        }
      ), /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Main text colour",
          value: (_k = form.fields.mainTextColour) == null ? void 0 : _k.value,
          onChange: (newValue) => form.setFieldValue("mainTextColour", newValue)
        }
      ), /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Secondary text colour",
          value: (_l = form.fields.secondaryTextColour) == null ? void 0 : _l.value,
          onChange: (newValue) => form.setFieldValue("secondaryTextColour", newValue)
        }
      ), /* @__PURE__ */ React__default.createElement(
        TextField$1,
        {
          label: "Hint text opacity",
          value: form.fields.secondaryTextOpacity.value,
          onChange: (newValue) => form.setFieldValue("secondaryTextOpacity", newValue),
          placeholder: 100,
          inputPrefix: "Opacity ",
          inputSuffix: "%"
        }
      ))), /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Main button" }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Main button background",
          value: (_m = form.fields.availabilityMainButtonBgColour) == null ? void 0 : _m.value,
          onChange: (value) => form.setFieldValue("availabilityMainButtonBgColour", value)
        }
      ), /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Text colour",
          value: (_n = form.fields.availabilityMainButtonTextColour) == null ? void 0 : _n.value,
          onChange: (value) => form.setFieldValue("availabilityMainButtonTextColour", value)
        }
      ), /* @__PURE__ */ React__default.createElement(
        NumberIncrement$1,
        {
          label: "Corner radius",
          value: (_o = form.fields.availabilityMainButtonCornerRadius) == null ? void 0 : _o.value,
          onChange: (value) => form.setFieldValue("availabilityMainButtonCornerRadius", value),
          suffix: "px",
          min: 0
        }
      ))), /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Timeboxes" }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Active state colour",
          value: (_p = form.fields.availabilityFieldsActiveStateColour) == null ? void 0 : _p.value,
          onChange: (newValue) => form.setFieldValue("availabilityFieldsActiveStateColour", newValue)
        }
      ), /* @__PURE__ */ React__default.createElement(
        TextField$1,
        {
          label: "Colour opacity",
          value: form.fields.availabilityFieldsColourOpacity.value,
          onChange: (newValue) => form.setFieldValue("availabilityFieldsColourOpacity", newValue),
          placeholder: 100,
          inputPrefix: "Opacity ",
          inputSuffix: "%"
        }
      ))), /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Outlines" }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Outline colour",
          value: (_q = form.fields.outlineColour) == null ? void 0 : _q.value,
          onChange: (newValue) => form.setFieldValue("outlineColour", newValue)
        }
      ), /* @__PURE__ */ React__default.createElement(
        TextField$1,
        {
          label: "Outline opacity",
          value: form.fields.outlineOpacity.value,
          onChange: (newValue) => form.setFieldValue("outlineOpacity", newValue),
          placeholder: 100,
          inputPrefix: "Opacity ",
          inputSuffix: "%"
        }
      ), /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Active outline colour",
          value: (_r = form.fields.activeOutlineColour) == null ? void 0 : _r.value,
          onChange: (newValue) => form.setFieldValue("activeOutlineColour", newValue)
        }
      ))), /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Form background" }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Background colour",
          value: form.fields.availabilityBackgroundBoxBgColour.value,
          onChange: (newValue) => form.setFieldValue("availabilityBackgroundBoxBgColour", newValue)
        }
      ), /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Border colour",
          value: form.fields.availabilityBackgroundBoxBorderColour.value,
          onChange: (newValue) => form.setFieldValue("availabilityBackgroundBoxBorderColour", newValue)
        }
      ), /* @__PURE__ */ React__default.createElement(
        TextField$1,
        {
          label: "Border weight",
          value: form.fields.availabilityBackgroundBoxBorderWeight.value,
          inputPrefix: /* @__PURE__ */ React__default.createElement(FontWeightSVG, null),
          minNumber: 0,
          inputSuffix: "px",
          onChange: (newValue) => form.setFieldValue("availabilityBackgroundBoxBorderWeight", newValue)
        }
      ))), /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Date selector" }, /* @__PURE__ */ React__default.createElement(
        Dropdown$1,
        {
          label: "Type",
          items: [
            { value: "calendar", label: "Day with calendar" },
            { value: "7_days", label: "Next 7 days" },
            { value: "calendar_always", label: "Always show calendar" }
          ],
          value: form.fields.dateSelectorType.value,
          onSelect: (value) => form.setFieldValue("dateSelectorType", value)
        }
      )), /* @__PURE__ */ React__default.createElement(SettingsSubSection$1, { heading: "Multi-venue labels", noBottomBorder: true }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Text colour",
          value: form.fields.bodyTextColour.value,
          onChange: (newValue) => form.setFieldValue("bodyTextColour", newValue)
        }
      ), /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Button outline colour",
          value: form.fields.bodyButtonBorderColour.value,
          onChange: (newValue) => form.setFieldValue("bodyButtonBorderColour", newValue)
        }
      ), /* @__PURE__ */ React__default.createElement(
        ColorPicker,
        {
          label: "Button text colour",
          value: form.fields.bodyButtonTextColour.value,
          onChange: (newValue) => form.setFieldValue("bodyButtonTextColour", newValue)
        }
      ))))
    }
  ));
};
Appearance.propTypes = {
  addMessage: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  form: PropTypes.shape({
    fields: PropTypes.shape(
      convertArrayToObjectWithDefaultValues(widgetSettingKeys, PropTypes.shape({}))
    ),
    hasUnsavedChanges: PropTypes.bool,
    setFieldValue: PropTypes.func,
    setFieldValues: PropTypes.func
  }).isRequired
};
const mapStateToProps$2W = (state) => ({
  restaurant: state.restaurantActive.restaurant
});
const mapDispatchToProps$2V = (dispatch) => bindActionCreators(
  {
    addMessage: addMessageAction,
    setFormEditing: setFormEditingAction,
    formAwareRedirect: formAwareRedirectAction
  },
  dispatch
);
const Appearance$1 = connect(mapStateToProps$2W, mapDispatchToProps$2V)(Appearance);
const useStyles$1z = createUseStyles((theme2) => ({
  container: {
    fontSize: "15px",
    maxWidth: "600px",
    paddingBottom: "100px"
  },
  // TODO differentiate between labels and actual sections
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    fontSize: "15px",
    fontWeight: theme2.fontWeights.regular,
    color: theme2.colors.smoke
  },
  label: {
    ...theme2.typography.body.subheading
  },
  heading: {
    ...theme2.typography.heading.H2
  },
  subHeading: {
    // fontSize: '15px',
    // fontWeight: theme.fontWeights.bold,
    color: theme2.colors.smoke
  },
  infoText: {
    fontSize: "15px",
    color: theme2.colors.smoke
  },
  settings: {
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },
  copyToClipboard: {
    fontSize: "15px",
    padding: "8px 10px",
    transition: "background 0.1s",
    borderRadius: "6px",
    "&:hover": {
      background: theme2.colors.dateSelectBackground,
      cursor: "pointer"
    }
  },
  header: {
    borderBottom: `1px solid ${theme2.colors.gray3}`,
    overflow: "visible",
    gap: "40px",
    paddingBottom: "16px"
  }
}));
const Areas = ({ obeeSettings: obeeSettings2, updateObeeSettings: updateObeeSettings2, addMessage: addMessage2, restaurant, areas, form }) => {
  var _a, _b2, _c2, _d2, _e2;
  const classes = useStyles$1z();
  ((_b2 = (_a = obeeSettings2.data) == null ? void 0 : _a.areaPhotos) == null ? void 0 : _b2.map((areaPhoto) => safeParse(areaPhoto))) || [];
  const handleError2 = (message) => {
    addMessage2(`UPLOAD_IMAGE_ERROR_${(/* @__PURE__ */ new Date()).getTime()}`, `${message}`, "error");
  };
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 20 }, /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "18px", lineHeight: 1.5, maxWidth: "360px" } }, "Insert images for each of your areas to help guests know where they’re sitting."), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      label: "Area images",
      checked: (_d2 = (_c2 = form.fields) == null ? void 0 : _c2.showAreaImages) == null ? void 0 : _d2.value,
      onChange: () => {
        var _a2, _b3;
        return form.setFieldValue("showAreaImages", !((_b3 = (_a2 = form.fields) == null ? void 0 : _a2.showAreaImages) == null ? void 0 : _b3.value));
      },
      style: { container: { width: "400px", justifyContent: "space-between" } }
    }
  ), (_e2 = areas.data) == null ? void 0 : _e2.map((area) => {
    var _a2, _b3, _c3, _d3, _e3, _f, _g, _h, _i;
    return /* @__PURE__ */ React__default.createElement(SettingsSection$1, { heading: area == null ? void 0 : area.name, key: area == null ? void 0 : area.id }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, ((_b3 = (_a2 = form.fields) == null ? void 0 : _a2.showAreaImages) == null ? void 0 : _b3.value) && /* @__PURE__ */ React__default.createElement(
      ImageUpload$1,
      {
        fileLink: (_f = (_e3 = (_d3 = (_c3 = form.fields) == null ? void 0 : _c3.areas) == null ? void 0 : _d3[area.id]) == null ? void 0 : _e3.imageLink) == null ? void 0 : _f.value,
        onChange: (value) => form.setFieldValue("imageLink", value, "areas", area.id),
        onUpload: obeeImageUploadUrlAction,
        onRemove: () => form.setFieldValue("imageLink", "", "areas", area.id),
        onError: handleError2,
        minWidth: 600,
        fileNamePrepend: `${restaurant.objectId}_area-${area.id}`,
        maxWidth: 2e3,
        maxHeight: 2e3
      }
    ), /* @__PURE__ */ React__default.createElement(
      TextArea,
      {
        label: "Description",
        value: `${(_i = (_h = (_g = form.fields) == null ? void 0 : _g.areas) == null ? void 0 : _h[area.id]) == null ? void 0 : _i.description.value}`,
        onChange: (value) => form.setFieldValue("description", value, "areas", area.id)
      }
    )));
  }));
};
Areas.propTypes = {
  updateObeeSettings: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  addMessage: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  form: PropTypes.shape({
    fields: widgetSettingPropTypes,
    hasUnsavedChanges: PropTypes.bool,
    setFieldValue: PropTypes.func,
    setFieldValues: PropTypes.func
  }).isRequired,
  areas: areasPropTypes.isRequired
};
const mapStateToProps$2V = (state) => ({
  obeeSettings: state.obeeSettings,
  restaurant: state.restaurantActive.restaurant,
  areas: state.areas
});
const mapDispatchToProps$2U = (dispatch) => bindActionCreators(
  {
    updateObeeSettings: updateSettingsAction,
    addMessage: addMessageAction
  },
  dispatch
);
const Areas$1 = connect(mapStateToProps$2V, mapDispatchToProps$2U)(Areas);
const ToggleGroup = ({
  toggles,
  message,
  onChange,
  variant,
  fullWidth,
  wrapperStyle,
  toggleStyle
}) => {
  const theme2 = useTheme$1();
  const fullWidthStyles = {
    wrapper: {
      justifyContent: "space-between"
    },
    textLabel: {
      width: "auto",
      flexGrow: 1
    }
  };
  const boldVariantStyles = {
    textLabel: {
      fontWeight: "bold",
      color: theme2.colors.charcoal,
      fontSize: "18px"
    }
  };
  const toggleStyles = {
    wrapper: {
      justifyContent: "flex-start",
      ...fullWidth ? fullWidthStyles.wrapper : {},
      ...toggleStyle.wrapper
    },
    textLabel: {
      width: "210px",
      fontWeight: "inherit",
      color: "inherit",
      fontSize: "inherit",
      ...fullWidth ? fullWidthStyles.textLabel : {},
      ...variant === "bold" ? boldVariantStyles.textLabel : {},
      ...toggleStyle.textLabel
    },
    inputContainer: { ...toggleStyle.inputContainer },
    labelRow: { ...toggleStyle.labelRow }
  };
  const circularIcon = (icon) => {
    if (!icon) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
    }
    return /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: {
          backgroundColor: theme2.colors.linen,
          height: "38px",
          width: "38px",
          minHeight: "38px",
          minWidth: "38px",
          borderRadius: "38px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      },
      icon
    );
  };
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 12 }, toggles.map((toggle) => /* @__PURE__ */ React__default.createElement(
    Spacer,
    {
      direction: "vertical",
      key: toggle == null ? void 0 : toggle.id,
      gap: 20,
      style: {
        paddingTop: "12px",
        borderTop: `1px solid ${theme2.colors.gray7}`,
        ...wrapperStyle || {}
      }
    },
    /* @__PURE__ */ React__default.createElement(
      Toggle,
      {
        label: /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, circularIcon(toggle == null ? void 0 : toggle.icon), " ", toggle == null ? void 0 : toggle.label),
        description: toggle == null ? void 0 : toggle.description,
        checked: toggle == null ? void 0 : toggle.value,
        style: toggleStyles,
        onChange: () => (toggle == null ? void 0 : toggle.onChange) ? toggle.onChange(!(toggle == null ? void 0 : toggle.value)) : onChange(toggle == null ? void 0 : toggle.id, !(toggle == null ? void 0 : toggle.value)),
        disabled: toggle == null ? void 0 : toggle.disabled
      }
    ),
    /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (toggle == null ? void 0 : toggle.value) && (toggle == null ? void 0 : toggle.subSection) && /* @__PURE__ */ React__default.createElement(Box, { style: { marginBottom: "20px" } }, toggle == null ? void 0 : toggle.subSection))
  )), message && /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, message));
};
ToggleGroup.defaultProps = {
  toggles: [],
  message: null,
  onChange: (e) => e,
  fullWidth: false,
  variant: null,
  wrapperStyle: {},
  toggleStyle: {}
};
ToggleGroup.propTypes = {
  message: PropTypes.string,
  onChange: PropTypes.func,
  toggles: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.node,
      description: PropTypes.node,
      subSection: PropTypes.node
    })
  ),
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  wrapperStyle: PropTypes.shape({}),
  toggleStyle: PropTypes.shape({
    labelRow: PropTypes.shape({}),
    textLabel: PropTypes.shape({}),
    inputContainer: PropTypes.shape({})
  })
};
const mapStateToProps$2U = () => ({});
const mapDispatchToProps$2T = (dispatch) => bindActionCreators({}, dispatch);
const ToggleGroup$1 = connect(mapStateToProps$2U, mapDispatchToProps$2T)(ToggleGroup);
const Children = ({ form }) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h;
  return /* @__PURE__ */ React__default.createElement(Box, { style: { marginTop: "20px" } }, /* @__PURE__ */ React__default.createElement(
    ToggleGroup$1,
    {
      variant: "bold",
      toggles: [
        // {
        //   label: 'Venue message',
        //   value: form.fields?.showChildren?.value,
        //   id: 'showVenueMessage',
        //   description: 'Provide a message to guests before they start making a booking',
        // },
        {
          label: "Children",
          value: (_b2 = (_a = form.fields) == null ? void 0 : _a.showChildren) == null ? void 0 : _b2.value,
          id: "showChildren",
          description: "Request number of children"
        },
        {
          disabled: !((_d2 = (_c2 = form.fields) == null ? void 0 : _c2.showChildren) == null ? void 0 : _d2.value),
          label: "High chairs",
          value: ((_f = (_e2 = form.fields) == null ? void 0 : _e2.showChildren) == null ? void 0 : _f.value) && ((_h = (_g = form.fields) == null ? void 0 : _g.showHighChairs) == null ? void 0 : _h.value),
          id: "showHighChairs",
          description: "Request number of high chairs (only shown if children is also shown)"
        }
      ],
      onChange: (id, newValue) => form.setFieldValue(id, newValue),
      fullWidth: true
    }
  ));
};
Children.propTypes = {
  form: formPropTypes$1.isRequired
};
const mapStateToProps$2T = () => ({});
const mapDispatchToProps$2S = (dispatch) => bindActionCreators({}, dispatch);
const Children$1 = connect(mapStateToProps$2T, mapDispatchToProps$2S)(Children);
const useStyles$1y = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    fontSize: "15px",
    maxWidth: "600px"
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  heading: {
    ...theme2.typography.heading.H3
  },
  subHeading: {
    fontSize: "15px",
    fontWeight: theme2.fontWeights.bold
  },
  infoText: {
    fontSize: "15px",
    color: theme2.colors.smoke
  },
  settings: {
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },
  copyToClipboard: {
    fontSize: "15px",
    padding: "8px 10px",
    transition: "background 0.1s",
    borderRadius: "6px",
    "&:hover": {
      background: theme2.colors.dateSelectBackground,
      cursor: "pointer"
    }
  }
}));
const textFieldStyles = (theme2) => ({
  label: { color: theme2.colors.smoke, width: "140px" },
  input: { fontSize: "15px", padding: "8px 10px" }
});
const useStyles$1x = createUseStyles((theme2) => ({
  container: (props) => {
    var _a;
    return {
      width: "400px",
      display: "flex",
      gap: "10px",
      alignItems: "center",
      height: "40px",
      fontSize: "inherit",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.container
    };
  },
  label: (props) => {
    var _a;
    return {
      width: "140px",
      flexShrink: 0,
      color: theme2.colors.smoke,
      fontSize: "15px",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.label
    };
  },
  activeValue: (props) => {
    var _a;
    return {
      background: theme2.colors.dateSelectBackground,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.activeValue
    };
  },
  value: (props) => {
    var _a, _b2, _c2;
    return {
      display: "flex",
      alignItems: "center",
      padding: "0 14px",
      height: "40px",
      // padding: '10px 14px',
      width: "100%",
      borderRadius: "6px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      userSelect: "none",
      justifyContent: "space-between",
      color: theme2.colors.charcoal,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.value,
      "&:hover": {
        background: theme2.colors.dateSelectBackground,
        cursor: "pointer",
        ...(_c2 = (_b2 = props == null ? void 0 : props.style) == null ? void 0 : _b2.value) == null ? void 0 : _c2["&:hover"]
      }
    };
  },
  valueOverflow: (props) => {
    var _a;
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.valueOverflow
    };
  },
  valuePlaceholder: (props) => {
    var _a;
    return {
      color: theme2.colors.nimbus,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.valuePlaceholder
    };
  },
  errorText: (props) => {
    var _a;
    return {
      color: theme2.colors.errorRed,
      fontSize: "10px",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.errorText
    };
  }
}));
const CleanDropdownPopover = ({
  label,
  value,
  // this is what shows as selected
  items,
  multiselect,
  onSelect: onSelect2,
  placeholder,
  selectedItems,
  showArrow,
  style,
  popoverProps,
  disabled,
  error,
  clearError,
  multiselectFormat,
  valueFormat,
  // To override the format of the value if it's different to the item's value and label
  onClose,
  // When closed
  ...props
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1x({ style, disabled });
  const [anchor, setAnchor] = useState(null);
  const getValueLabel = () => {
    if (!isEmpty(value)) {
      if (multiselect) {
        if (multiselectFormat !== null) {
          return multiselectFormat(value);
        }
        return value.map((val) => getLabelForValue(val, items)).join(", ");
      }
      if (valueFormat !== null) {
        return valueFormat(value);
      }
      return getLabelForValue(value, items);
    }
    return placeholder;
  };
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.wrapper }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, label && /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.value} ${!!anchor && classes.activeValue} ${isEmpty(value) && classes.valuePlaceholder}`,
      style: {
        ...disabled ? {
          cursor: "default",
          backgroundColor: theme2.colors.dateSelectBackground,
          color: theme2.colors.nimbus
        } : {},
        ...error ? { border: `1px solid ${theme2.colors.red}` } : {}
      },
      onClick: (e) => {
        if (disabled) {
          return;
        }
        setAnchor(e.currentTarget);
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.valueOverflow }, getValueLabel()),
    showArrow ? /* @__PURE__ */ React__default.createElement(DownCaretSVG, { style: { width: "11px" } }) : null
  )), !isEmpty(error) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.errorText }, error)), !disabled && /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      multiselect,
      selectedItems,
      onSelect: (newValue) => {
        clearError();
        onSelect2(newValue);
      },
      anchor,
      items,
      isOpen: !!anchor,
      style: {
        /* eslint-disable-next-line react/prop-types */
        popover: { maxHeight: "360px", ...style == null ? void 0 : style.popover },
        /* eslint-disable-next-line react/prop-types */
        item: { ...style == null ? void 0 : style.item },
        /* eslint-disable-next-line react/prop-types */
        items: { ...style == null ? void 0 : style.items }
      },
      onClose: () => {
        onClose();
        setAnchor(null);
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
        // eslint-disable-next-line react/prop-types
        ...props == null ? void 0 : props.anchorOrigin
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left",
        // eslint-disable-next-line react/prop-types
        ...props == null ? void 0 : props.transformOrigin
      },
      popoverProps
    }
  ));
};
CleanDropdownPopover.defaultProps = {
  multiselect: false,
  placeholder: "Empty",
  selectedItems: [],
  label: null,
  style: {},
  showArrow: false,
  popoverProps: {},
  value: null,
  props: null,
  disabled: false,
  onSelect: () => {
  },
  clearError: () => {
  },
  onClose: () => {
  },
  error: null,
  multiselectFormat: null,
  valueFormat: null
};
CleanDropdownPopover.propTypes = {
  label: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  multiselect: PropTypes.bool,
  showArrow: PropTypes.bool,
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  selectedItems: PropTypes.arrayOf(PropTypes.any),
  style: PropTypes.shape({}),
  popoverProps: PropTypes.shape({}),
  props: PropTypes.shape({}),
  disabled: PropTypes.bool,
  clearError: PropTypes.func,
  onClose: PropTypes.func,
  error: PropTypes.string,
  multiselectFormat: PropTypes.func,
  valueFormat: PropTypes.func
};
const CleanDropdownPopover$1 = CleanDropdownPopover;
const desktopPadding = 96;
const mobilePadding = 20;
const headerNavHeight$1 = 66;
const useStyles$1w = createUseStyles((theme2) => ({
  container: {},
  pageContent: {
    maxWidth: "1800px"
  },
  tabBarContainer: {
    display: "flex",
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 99
  },
  logoContainer: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  tabBar: {
    display: "flex",
    gap: 0,
    // maxWidth: '100%',
    overflowX: theme2.overlay,
    alignItems: "center",
    background: theme2.colors.linen,
    height: `${headerNavHeight$1}px`,
    padding: `0 ${desktopPadding}px`,
    // padding: '0',
    width: "100%",
    position: "sticky",
    top: 0,
    zIndex: 98,
    overflow: "hidden",
    [theme2.breakpoints.down("sm")]: {
      padding: `18px ${mobilePadding}px`
    }
  },
  topHeaderContainer: {
    position: "fixed",
    width: "100%",
    maxWidth: "100vw",
    height: "65px",
    display: "flex",
    justifyContent: "space-between",
    padding: "18px 20px",
    zIndex: 100,
    alignItems: "center",
    pointerEvents: "none",
    borderBottom: "1px solid transparent",
    top: 0,
    [theme2.breakpoints.down("sm")]: {
      padding: `18px ${mobilePadding}px`
    }
  },
  topHeaderItem: {
    height: "100%",
    // backgroundColor: theme.colors.LINEN,
    padding: "0 20px",
    // To cover the tabs that scroll behind the items
    margin: "0 -20px",
    display: "flex",
    alignItems: "center"
  },
  title: {
    ...theme2.typography.heading.H1,
    alignItems: "flex-end",
    background: theme2.colors.linen,
    display: "flex",
    height: "133px",
    padding: `18px ${desktopPadding}px 8px ${desktopPadding}px`,
    [theme2.breakpoints.down("sm")]: {
      padding: `18px ${mobilePadding}px 8px ${mobilePadding}px`
    }
  },
  heading: {
    ...theme2.typography.heading.H3,
    lineHeight: "22px",
    marginBottom: "16px"
  },
  content: {
    padding: "48px 0",
    margin: `0 ${desktopPadding}px`,
    minHeight: `calc(100dvh - ${headerNavHeight$1}px)`,
    // To prevent the header resetting its position on tab change
    [theme2.breakpoints.down("sm")]: {
      padding: "32px 0",
      margin: `0 ${mobilePadding}px`
    }
  },
  subNavigation: {
    display: "flex",
    padding: `0 ${desktopPadding}px`,
    alignItems: "center",
    borderBottom: "1px solid #E6E6E6",
    // TODO use theme
    justifyContent: "space-between",
    margin: `-48px -${desktopPadding}px 0 -${desktopPadding}px`,
    height: `${headerNavHeight$1}px`,
    top: `${headerNavHeight$1}px`,
    position: "sticky",
    zIndex: 2,
    background: theme2.colors.white,
    [theme2.breakpoints.down("sm")]: {
      padding: `0 ${mobilePadding}px`,
      margin: `-32px -${mobilePadding}px 0 -${mobilePadding}px`
    }
  },
  rightRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    alignItems: "center"
  },
  settingsPage: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    fontSize: "15px",
    paddingBottom: "80px"
  },
  settingGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  subheading: {
    ...theme2.typography.body.H4,
    fontWeight: theme2.fontWeights.bold
  },
  subheadingInfo: {
    fontSize: "15px",
    color: theme2.colors.smoke,
    marginBottom: "4px"
  },
  inlineSubHeading: {
    ...theme2.typography.body.H4,
    fontWeight: theme2.fontWeights.bold,
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  twoColumn: {
    display: "flex",
    flexBasis: "50%",
    justifyContent: "space-between",
    maxWidth: "1000px",
    // Arbitrary number
    flexWrap: "wrap",
    gap: "10px"
  },
  settings: {
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },
  buttonRow: {
    display: "flex",
    gap: "16px"
  },
  iconButton: {
    color: theme2.colors.smoke,
    width: "42px",
    height: "42px",
    transition: "color 0.1s",
    "&:hover": {
      color: theme2.colors.charcoal,
      cursor: "pointer"
    }
  },
  paymentsSetting: {
    border: "1px solid #D9D9D9",
    // TODO use theme
    width: "100%",
    padding: "20px",
    borderRadius: "12px"
  },
  paymentsSettingEnabled: {
    color: theme2.colors.roquette,
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: "14px"
  },
  paymentsSettingDetails: {
    padding: "20px 0",
    borderTop: "1px solid #D9D9D9",
    // TODO use theme
    borderBottom: "1px solid #D9D9D9",
    // TODO use theme
    margin: "20px 0"
  },
  paymentsSettingDetailsRow: {
    display: "grid",
    gridTemplateColumns: "1fr 2fr",
    maxWidth: "860px",
    alignItems: "baseline",
    gap: "14px"
  },
  centeredPopup: {
    // This is a hack to have a centered box
    backgroundColor: theme2.colors.white,
    width: "480px",
    left: "calc(50% - 240px)",
    position: "fixed",
    borderRadius: "8px",
    boxShadow: "0px 4px 4px rgba(151, 151, 151, 0.25)",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    gap: "28px"
  },
  topSection: {
    padding: "34px 18px 0",
    marginBottom: "20px"
  },
  bottomSection: {
    padding: "16px 25px",
    borderTop: `1px solid ${theme2.colors.linkIconBackground}`
  },
  modalTitle: {
    ...theme2.typography.heading.H4,
    color: theme2.colors.charcoal,
    paddingBottom: "24px",
    paddingLeft: "8px"
  },
  iconLabel: {
    display: "flex",
    gap: "8px",
    alignItems: "center"
  },
  currencyInput: {
    userSelect: "none",
    borderRadius: "6px",
    padding: "9px 14px",
    marginLeft: "-10px",
    outline: "none",
    "&:hover": {
      background: theme2.colors.notificationBackgroundGray
    },
    "&:focus-visible": {
      outline: "1px solid"
    }
  },
  // Can't believe this works lol
  faderContainer: {
    zIndex: 99,
    position: "absolute",
    height: "56px",
    display: "flex"
  },
  faderBlock: {
    backgroundColor: theme2.colors.linen,
    width: "70px",
    height: "100%"
  },
  faderGradient: {
    backgroundImage: `linear-gradient(to right, ${theme2.colors.linen}, rgb(0, 0, 0, 0))`,
    width: "20px",
    height: "100%"
  },
  areasContainer: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    maxWidth: "1440px",
    margin: "auto",
    flexWrap: "wrap"
  },
  areaCardContainer: {
    padding: "20px",
    background: theme2.colors.dune,
    borderRadius: "8px",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    minWidth: "300px",
    maxWidth: "500px",
    flex: 1
  },
  areaCardImageContainer: {
    background: theme2.colors.white,
    width: "100%",
    minHeight: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "500px"
  },
  areaCardImage: {
    width: "100%"
  },
  areaCardTextContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: "12px"
  },
  areaCardTextHeading: {
    ...theme2.typography.heading.H3
  },
  areaCardTextParagraph: {
    fontSize: "15px",
    textAlign: "center"
  },
  overflowIcon: {
    opacity: 0,
    transition: "opacity 0.1s",
    flexShrink: 0
  },
  overflowLabel: {
    display: "flex",
    gap: "12px",
    height: "100%",
    width: "100%",
    alignItems: "center",
    "&:hover": {
      "& .overflowIcon": {
        opacity: 1
      }
    }
  },
  overflowButton: {
    height: "36px",
    width: "36px",
    borderRadius: "100%",
    border: "1px solid #DCDCDC",
    // TODO use theme
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"
  },
  infoButton: {
    borderRadius: "100%",
    width: "25px",
    height: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme2.colors.dune,
    userSelect: "none",
    "&:hover": {
      cursor: "pointer"
    }
  },
  cutoffDropdownContainer: {
    marginTop: "4px",
    maxWidth: "300px",
    color: theme2.colors.smoke,
    marginLeft: "150px",
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  cutoffDropdownItem: {
    display: "flex",
    gap: "8px",
    alignItems: "baseline"
  },
  cutoffModalContainer: {
    maxWidth: "435px",
    padding: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "30px"
  },
  cutoffModalHeader: {
    fontWeight: theme2.fontWeights.black,
    fontSize: "28px",
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  cutoffModalItem: {
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  },
  cutoffListContainer: {
    padding: "0 18px",
    margin: 0
  },
  cutoffListItem: {
    padding: 0,
    marginBottom: "12px"
  },
  cutoffInformation: {
    marginLeft: "12px"
  },
  sittingRowContainer: {
    padding: "20px 25px",
    display: "flex",
    flexDirection: "column",
    gap: "5px"
  },
  sittingsTitle: {
    padding: "0 25px",
    ...theme2.typography.body.PL,
    fontWeight: theme2.fontWeights.medium
  },
  sittingRow: {
    display: "flex",
    border: `1px solid ${theme2.colors.cloud}`,
    borderRadius: "4px",
    cursor: "pointer"
  },
  sittingRowNumber: {
    ...theme2.typography.body.PL,
    backgroundColor: theme2.colors.cloud,
    padding: "8px",
    width: "30px",
    height: "36px",
    textAlign: "center",
    verticalAlign: "center"
  },
  sittingRowDetails: {
    ...theme2.typography.body.PL,
    verticalAlign: "center",
    padding: "8px",
    height: "34px",
    width: "100%"
  }
}));
const linkStyles = (theme2) => ({
  color: theme2.colors.olive3,
  fontWeight: theme2.fontWeights.medium,
  fontSize: "15px"
});
const tabBarStyles$4 = (theme2) => ({
  fontWeight: theme2.fontWeights.regular,
  ...theme2.components.scrollbarWide,
  // TODO might not be necessary anymore
  marginLeft: "-13px",
  // Align with "Settings" title
  // marginRight: '26px', // So it can scroll past the exit button
  containerInner: {
    gap: "12px"
  },
  tab: {
    // cursor: 'pointer',
    padding: "0 13px",
    // paddingBottom: '9px', // TODO might need to be uncommented
    borderRadius: "100px",
    fontSize: "15px",
    lineHeight: "15px",
    // minWidth: '100px',
    transition: "background-color 0.1s",
    whiteSpace: "nowrap",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    border: "1px solid transparent",
    overflowX: theme2.overlay
  },
  tabActive: {
    fontWeight: theme2.fontWeights.medium,
    backgroundColor: "transparent",
    padding: "9px 13px",
    paddingBottom: "9px",
    color: "black",
    border: "1px solid black",
    borderBottom: "1px solid black"
    // defaults to red
  },
  tabHover: {
    backgroundColor: "transparent",
    color: theme2.colors.brandPrimary,
    filter: "none"
  }
});
const secondaryButtonStyles = (theme2) => ({
  container: {
    width: "100%"
  },
  button: {
    fontWeight: theme2.fontWeights.medium,
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontSize: "15px",
    lineHeight: "auto",
    height: "40px",
    padding: "0 12px",
    color: "black",
    border: "1px solid black",
    borderBottom: "1px solid black",
    // defaults to red
    width: "100%",
    flexGrow: 1
  }
});
const cleanButtonStyles = (theme2) => ({
  container: {
    position: "relative",
    height: "36px"
  },
  button: {
    fontSize: "15px",
    lineHeight: "auto",
    height: "36px",
    borderRadius: "8px",
    padding: "0 12px",
    color: theme2.colors.smoke,
    fontWeight: theme2.fontWeights.regular,
    backgroundColor: "transparent",
    width: "100%",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "center",
    textAlign: "left"
  },
  text: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  buttonHover: {
    backgroundColor: theme2.colors.white,
    filter: "none"
    // TODO show full button text on hover
    // overflow: 'visible',
    // position: 'absolute',
    // zIndex: '10',
    // width: '500px',
  }
});
const cleanDropdownPopoverStyles = {
  value: { height: "36px", padding: "0 12px" },
  container: { fontSize: "inherit", height: "unset", maxWidth: "400px" },
  errorText: { margin: "3px 0 0 0" },
  item: { fontSize: "15px", padding: "0 16px", height: "36px" },
  popover: { padding: "8px" },
  items: { display: "flex", flexDirection: "column", gap: "4px" }
};
const listPopoverStyles$1 = {
  container: { maxWidth: "400px" },
  popover: { minWidth: "fit-content", padding: "8px" },
  item: { fontSize: "15px", lineHeight: "22px", padding: "8px 16px", height: "unset" }
};
const LegacyWidgetSettings = ({
  obeeSettings: obeeSettings2,
  updateObeeSettings: updateObeeSettings2,
  obeeAreas: obeeAreas2,
  fetchObeeAreas: fetchObeeAreas2,
  fetchObeeSettings: fetchObeeSettings2,
  addMessage: addMessage2,
  restaurant
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i;
  const theme2 = useTheme$1();
  const classes = useStyles$1y();
  const [themeColor, setThemeColor] = useState((_a = obeeSettings2.data) == null ? void 0 : _a.stepperColor);
  const [venueMessage, setVenueMessage] = useState((_b2 = obeeSettings2.data) == null ? void 0 : _b2.groupSizeMessage);
  const loading = useFetchOnFirstRender(
    [fetchObeeAreas2, fetchObeeSettings2],
    [obeeAreas2, obeeSettings2]
  );
  useEffect(() => {
    unstable_batchedUpdates(() => {
      var _a2, _b3;
      setThemeColor((_a2 = obeeSettings2.data) == null ? void 0 : _a2.stepperColor);
      setVenueMessage((_b3 = obeeSettings2.data) == null ? void 0 : _b3.groupSizeMessage);
    });
  }, [obeeSettings2.data]);
  const bookingWidgetUrl = useMemo(
    () => {
      var _a2, _b3;
      return `${(_a2 = window.bookingsConfig) == null ? void 0 : _a2.bookingWidgetBaseUrl}/${(_b3 = obeeSettings2.data) == null ? void 0 : _b3.slug}`;
    },
    [(_c2 = obeeSettings2.data) == null ? void 0 : _c2.slug]
  );
  const changeSetting = (label, newValue) => {
    var _a2;
    if (((_a2 = obeeSettings2.data) == null ? void 0 : _a2[label]) !== newValue) {
      const changedSetting = {};
      changedSetting[label] = newValue;
      updateObeeSettings2(changedSetting);
    }
  };
  const areaImages = ((_e2 = (_d2 = obeeSettings2.data) == null ? void 0 : _d2.areaPhotos) == null ? void 0 : _e2.map((areaPhoto) => safeParse(areaPhoto))) || [];
  const handleError2 = (message) => {
    addMessage2(`UPLOAD_IMAGE_ERROR_${(/* @__PURE__ */ new Date()).getTime()}`, `${message}`, "error");
  };
  const handleFileChange = (fileLink, target) => {
    changeSetting(target, fileLink);
  };
  const handleAreaImageUpdate = (fileLink, areaId) => {
    const newAreaImages = areaImages.map((areaImage) => {
      if (areaImage.areaId === areaId) {
        return { areaId: areaImage.areaId, imageLink: fileLink };
      }
      return areaImage;
    });
    changeSetting(
      "areaPhotos",
      newAreaImages.map((areaImage) => JSON.stringify(areaImage))
    );
  };
  const handleAreaImageCreate = (fileLink, areaId) => {
    const newAreaImages = [...areaImages, { areaId, imageLink: fileLink }];
    changeSetting(
      "areaPhotos",
      newAreaImages.map((areaImage) => JSON.stringify(areaImage))
    );
  };
  const handleAreaImageUpload = (fileLink, areaId) => {
    if (areaImages.find((areaImage) => areaImage.areaId === areaId)) {
      handleAreaImageUpdate(fileLink, areaId);
    } else {
      handleAreaImageCreate(fileLink, areaId);
    }
  };
  const handleAreaImageRemove = (id) => {
    const newAreaImages = areaImages.filter((areaImage) => areaImage.areaId !== id);
    changeSetting(
      "areaPhotos",
      newAreaImages.map((areaImage) => JSON.stringify(areaImage))
    );
  };
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    addMessage2(
      `COPY_MESSAGE_SUCCESS_${(/* @__PURE__ */ new Date()).getTime()}`,
      `URL copied to clipboard!`,
      "success"
    );
  };
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(Box, null, "Loading ...");
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Booking widget link"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "10px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke, width: "140px" } }, "URL"), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.copyToClipboard,
      onClick: () => copyToClipboard(bookingWidgetUrl)
    },
    bookingWidgetUrl
  )))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Premium widget appearance"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Logo"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.infoText }, "Maximum file size: 1 MB", /* @__PURE__ */ React__default.createElement("br", null), "Formats accepted: JPEG, JPG, PNG"), /* @__PURE__ */ React__default.createElement(
    FileUpload,
    {
      fileLink: (_f = obeeSettings2.data) == null ? void 0 : _f.logo,
      onChange: (fileLink) => handleFileChange(fileLink, "logo"),
      minWidth: 240,
      minHeight: 130,
      onRemove: () => changeSetting("logo", ""),
      onError: handleError2,
      maxSizeInMB: 1,
      handleImageUpload: obeeImageUploadUrlAction,
      fileNamePrepend: `${restaurant.objectId}_logo`,
      includeTimestamp: true
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Hero image"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.infoText }, "Maximum file size: 1MB", /* @__PURE__ */ React__default.createElement("br", null), "Formats accepted: JPEG, JPG, PNG"), /* @__PURE__ */ React__default.createElement(
    FileUpload,
    {
      fileLink: (_g = obeeSettings2.data) == null ? void 0 : _g.heroImage,
      onChange: (fileLink) => handleFileChange(fileLink, "heroImage"),
      minWidth: 600,
      onRemove: () => changeSetting("heroImage", ""),
      onError: handleError2,
      maxSizeInMB: 1,
      handleImageUpload: obeeImageUploadUrlAction,
      fileNamePrepend: `${restaurant.objectId}_hero`,
      includeTimestamp: true
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Area images"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.infoText }, "Maximum file size: 1MB", /* @__PURE__ */ React__default.createElement("br", null), "Formats accepted: JPEG, JPG, PNG"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, (_h = obeeAreas2.data) == null ? void 0 : _h.map((area) => {
    var _a2;
    return /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.infoText }, area.name), /* @__PURE__ */ React__default.createElement(
      FileUpload,
      {
        fileLink: (_a2 = areaImages.find((areaImage) => areaImage.areaId === area.id)) == null ? void 0 : _a2.imageLink,
        onChange: (fileLink) => handleAreaImageUpload(fileLink, area.id),
        minWidth: 600,
        onRemove: () => handleAreaImageRemove(area.id),
        onError: handleError2,
        maxSizeInMB: 1,
        handleImageUpload: obeeImageUploadUrlAction,
        fileNamePrepend: `${restaurant.objectId}_area-${area.id}`,
        includeTimestamp: true
      }
    ));
  }))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Browser tab icon"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.infoText }, "Maximum file size: 1MB", /* @__PURE__ */ React__default.createElement("br", null), "Formats accepted: JPEG, JPG, PNG"), /* @__PURE__ */ React__default.createElement(
    FileUpload,
    {
      fileLink: (_i = obeeSettings2.data) == null ? void 0 : _i.favicon,
      onChange: (fileLink) => handleFileChange(fileLink, "favicon"),
      maxHeight: 16,
      minHeight: 16,
      onRemove: () => changeSetting("favicon", ""),
      onError: handleError2,
      maxSizeInMB: 1,
      handleImageUpload: obeeImageUploadUrlAction,
      fileNamePrepend: `${restaurant.objectId}_favicon`,
      includeTimestamp: true
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section, style: { maxWidth: "600px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Intro message"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.infoText }, "Personal message."), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Message",
      value: venueMessage,
      onChange: setVenueMessage,
      onBlur: () => changeSetting("groupSizeMessage", venueMessage),
      style: textFieldStyles(theme2)
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Color"), /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: themeColor,
      onChange: setThemeColor,
      onBlur: () => changeSetting("stepperColor", themeColor),
      placeholder: "#193d38"
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "High chairs"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.infoText }, "Shows a field in the booking widget."), /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      style: cleanDropdownPopoverStyles,
      label: "Status",
      value: obeeSettings2.data.showHighchairs,
      onSelect: (value) => changeSetting("showHighchairs", value),
      items: [
        { label: "On", value: true },
        { label: "Off", value: false }
      ]
    }
  )));
};
LegacyWidgetSettings.propTypes = {
  updateObeeSettings: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  fetchObeeSettings: PropTypes.func.isRequired,
  fetchObeeAreas: PropTypes.func.isRequired,
  addMessage: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired
};
const mapStateToProps$2S = (state) => ({
  obeeSettings: state.obeeSettings,
  restaurant: state.restaurantActive.restaurant,
  obeeAreas: state.areas
});
const mapDispatchToProps$2R = (dispatch) => bindActionCreators(
  {
    fetchObeeSettings: fetchSettingsAction,
    updateObeeSettings: updateSettingsAction,
    fetchObeeAreas: fetchAreasAction,
    addMessage: addMessageAction
  },
  dispatch
);
const LegacyWidgetSettings$1 = connect(mapStateToProps$2S, mapDispatchToProps$2R)(LegacyWidgetSettings);
const Messaging$2 = ({ form, restaurantName }) => {
  var _a, _b2, _c2, _d2, _e2;
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 32 }, /* @__PURE__ */ React__default.createElement(Spacer, { style: { justifyContent: "space-between", width: "100%" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "18px", lineHeight: "28px", maxWidth: "380px" } }, "Do you want to add a way for customers to opt in to your marketing?"), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      checked: (_b2 = (_a = form.fields) == null ? void 0 : _a.showMarketingOptIn) == null ? void 0 : _b2.value,
      onChange: () => {
        var _a2, _b3;
        return form.setFieldValue("showMarketingOptIn", !((_b3 = (_a2 = form.fields) == null ? void 0 : _a2.showMarketingOptIn) == null ? void 0 : _b3.value));
      }
    }
  )), ((_d2 = (_c2 = form.fields) == null ? void 0 : _c2.showMarketingOptIn) == null ? void 0 : _d2.value) && /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Opt-in message",
      value: (_e2 = form.fields.marketingOptInMessage) == null ? void 0 : _e2.value,
      onChange: (newValue) => form.setFieldValue("marketingOptInMessage", newValue),
      placeholder: `I would like to receive marketing updates from ${restaurantName}`
    }
  ));
};
Messaging$2.propTypes = {
  form: formPropTypes$1.isRequired
};
const mapStateToProps$2R = (state) => ({
  restaurantName: state.restaurantActive.restaurant.name
});
const mapDispatchToProps$2Q = (dispatch) => bindActionCreators({}, dispatch);
const Marketing = connect(mapStateToProps$2R, mapDispatchToProps$2Q)(Messaging$2);
const Messaging = ({ form }) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 32 }, /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Announcement message",
      value: (_a = form.fields) == null ? void 0 : _a.venueMessage.value,
      onChange: (value) => form.setFieldValue("venueMessage", value),
      placeholder: "Empty"
    }
  ), /* @__PURE__ */ React__default.createElement(Spacer, { style: { justifyContent: "space-between", width: "100%" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "18px", lineHeight: "28px", maxWidth: "380px" } }, "Do you want to add custom messages for when bookings are unavailable?"), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      checked: (_c2 = (_b2 = form.fields) == null ? void 0 : _b2.showCustomMessages) == null ? void 0 : _c2.value,
      onChange: () => {
        var _a2, _b3;
        return form.setFieldValue("showCustomMessages", !((_b3 = (_a2 = form.fields) == null ? void 0 : _a2.showCustomMessages) == null ? void 0 : _b3.value));
      }
    }
  )), ((_e2 = (_d2 = form.fields) == null ? void 0 : _d2.showCustomMessages) == null ? void 0 : _e2.value) && /* @__PURE__ */ React__default.createElement(
    ToggleGroup$1,
    {
      fullWidth: true,
      variant: "bold",
      onChange: (id, newValue) => form.setFieldValue(id, newValue),
      toggles: [
        // TODO this is hidden for now because it isn't actually being used
        // {
        //   label: 'Venue closed',
        //   value: form.fields?.showVenueClosedMessage?.value,
        //   id: 'showVenueClosedMessage',
        //   subSection: (
        //     <TextArea
        //       label='Message'
        //       value={form.fields?.venueClosedMessage.value}
        //       onChange={(value) => form.setFieldValue('venueClosedMessage', value)}
        //       placeholder='Select another day to try again.'
        //     />
        //   ),
        // },
        {
          label: "No availability on a specific day",
          value: (_g = (_f = form.fields) == null ? void 0 : _f.showNoAvailabilityDayMessage) == null ? void 0 : _g.value,
          id: "showNoAvailabilityDayMessage",
          subSection: /* @__PURE__ */ React__default.createElement(
            TextArea,
            {
              label: "Message",
              value: (_h = form.fields) == null ? void 0 : _h.noAvailabilityDayMessage.value,
              onChange: (value) => form.setFieldValue("noAvailabilityDayMessage", value),
              placeholder: "Select another day to try again."
            }
          )
        },
        {
          label: "No availability at a specific time",
          value: (_j = (_i = form.fields) == null ? void 0 : _i.showNoAvailabilityTimeMessage) == null ? void 0 : _j.value,
          id: "showNoAvailabilityTimeMessage",
          subSection: /* @__PURE__ */ React__default.createElement(
            TextArea,
            {
              label: "Message",
              value: (_k = form.fields) == null ? void 0 : _k.noAvailabilityTimeMessage.value,
              onChange: (value) => form.setFieldValue("noAvailabilityTimeMessage", value),
              placeholder: "Select an alternate time."
            }
          )
        },
        // {
        //   label: 'Area is fully booked',
        //   value: form.fields?.showFullyBookedMessage?.value,
        //   id: 'showFullyBookedMessage',
        //   subSection: (
        //     <TextArea
        //       label='Message'
        //       value={form.fields?.fullyBookedMessage.value}
        //       onChange={(value) => form.setFieldValue('fullyBookedMessage', value)}
        //       placeholder='The restaurant area is fully booked for this time'
        //     />
        //   ),
        // },
        {
          label: "Booking changes past cutoff time",
          value: (_m = (_l = form.fields) == null ? void 0 : _l.showCutoffMessage) == null ? void 0 : _m.value,
          id: "showCutoffMessage",
          subSection: /* @__PURE__ */ React__default.createElement(
            TextArea,
            {
              label: "Message",
              value: (_n = form.fields) == null ? void 0 : _n.cutoffMessage.value,
              onChange: (value) => form.setFieldValue("cutoffMessage", value),
              placeholder: "Unable to change booking"
            }
          )
        },
        {
          label: "Group size is above available capacity",
          value: (_p = (_o = form.fields) == null ? void 0 : _o.showMaxGroupMessage) == null ? void 0 : _p.value,
          id: "showMaxGroupMessage",
          subSection: /* @__PURE__ */ React__default.createElement(
            TextArea,
            {
              label: "Message",
              value: (_q = form.fields) == null ? void 0 : _q.maxGroupMessage.value,
              onChange: (value) => form.setFieldValue("maxGroupMessage", value),
              placeholder: "No availability for this group size"
            }
          )
        }
      ]
    }
  ), /* @__PURE__ */ React__default.createElement(
    ToggleGroup$1,
    {
      fullWidth: true,
      variant: "bold",
      onChange: (id, value) => form.setFieldValue(id, value),
      wrapperStyle: { marginBottom: "40px" },
      toggles: [
        {
          label: "Show contact information when booking is past cutoff time",
          value: (_s = (_r = form.fields) == null ? void 0 : _r.showVenueInfoOnCutoff) == null ? void 0 : _s.value,
          id: "showVenueInfoOnCutoff",
          subSection: /* @__PURE__ */ React__default.createElement(
            Dropdown$1,
            {
              label: "Show",
              items: [
                { value: "email", label: "Email" },
                { value: "phone", label: "Phone" },
                { value: "email_and_phone", label: "Email and phone" }
              ],
              value: form.fields.cutoffContactType.value,
              onSelect: (value) => form.setFieldValue("cutoffContactType", value)
            }
          )
        }
      ]
    }
  ));
};
Messaging.propTypes = {
  form: formPropTypes$1.isRequired
};
const mapStateToProps$2Q = () => ({});
const mapDispatchToProps$2P = (dispatch) => bindActionCreators({}, dispatch);
const Messaging$1 = connect(mapStateToProps$2Q, mapDispatchToProps$2P)(Messaging);
const SmallButton$2 = ({ children, ...props }) => {
  const theme2 = useTheme$1();
  const buttonStyles2 = () => ({
    button: {
      fontSize: "15px",
      padding: "5px 16px",
      fontWeight: "500",
      borderRadius: "8px"
    },
    buttonActive: {
      border: `1px solid ${theme2.colors.jet}`
    }
  });
  return /* @__PURE__ */ React__default.createElement(SquareButton, { style: buttonStyles2(), ...props }, children);
};
SmallButton$2.defaultProps = {
  children: null,
  basicSettings: null,
  advancedSettings: null,
  heading: null
};
SmallButton$2.propTypes = {
  children: PropTypes.node,
  basicSettings: PropTypes.node,
  advancedSettings: PropTypes.node,
  heading: PropTypes.string
};
const mapStateToProps$2P = () => ({});
const mapDispatchToProps$2O = (dispatch) => bindActionCreators({}, dispatch);
const SmallButton$3 = connect(mapStateToProps$2P, mapDispatchToProps$2O)(SmallButton$2);
const useStyles$1v = createUseStyles((theme2) => ({
  title: {
    ...theme2.typography.heading.H4
  }
}));
const listPopoverStyles = {
  popover: { minWidth: "fit-content", maxHeight: "550px", padding: "8px" },
  item: { fontSize: "15px" }
};
const SvgActionMenuVertical = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 5 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M4.5 2.32604C4.5 3.30119 3.63914 4.15209 2.5 4.15209C1.36086 4.15209 0.5 3.30119 0.5 2.32604C0.5 1.3509 1.36086 0.5 2.5 0.5C3.63914 0.5 4.5 1.3509 4.5 2.32604Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M4.5 9.30432C4.5 10.2795 3.63914 11.1304 2.5 11.1304C1.36086 11.1304 0.5 10.2795 0.5 9.30432C0.5 8.32917 1.36086 7.47827 2.5 7.47827C3.63914 7.47827 4.5 8.32917 4.5 9.30432Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M4.5 16.2825C4.5 17.2576 3.63914 18.1085 2.5 18.1085C1.36086 18.1085 0.5 17.2576 0.5 16.2825C0.5 15.3073 1.36086 14.4564 2.5 14.4564C3.63914 14.4564 4.5 15.3073 4.5 16.2825Z", stroke: "currentColor" }));
const ActionMenuIconSVG$1 = SvgActionMenuVertical;
const SvgDragHandleSmall = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 10 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 2, cy: 2, r: 2, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 2, cy: 8, r: 2, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 2, cy: 14, r: 2, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 8, cy: 2, r: 2, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 8, cy: 8, r: 2, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 8, cy: 14, r: 2, fill: "currentColor" }));
const DragHandleSVG = SvgDragHandleSmall;
const useStyles$1u = createUseStyles((theme2) => ({
  container: {},
  iconButton: {
    color: theme2.colors.smoke,
    transition: "color 0.1s",
    "&:hover": {
      color: theme2.colors.charcoal,
      cursor: "pointer"
    }
  },
  dragListItem: {
    // cursor: 'default',
    display: "flex",
    alignItems: "center",
    gap: "16px",
    border: `1px solid ${theme2.colors.shark}`,
    borderRadius: "6px",
    boxShadow: (props) => (props == null ? void 0 : props.isDragging) ? "0px 4px 4px rgba(151, 151, 151, 0.25)" : "inherit",
    backgroundColor: "white",
    margin: (props) => (props == null ? void 0 : props.isDragging) ? "8px" : 0
    // backgroundColor: (props) => (props?.isDragging ? theme.colors.lightCloud : 'white'),
  },
  dragHandle: {
    backgroundColor: theme2.colors.lightCloud,
    color: theme2.colors.yetAnotherGray20,
    borderRadius: "6px 0 0 6px"
  },
  dragHandleInner: {
    width: "24px",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    height: "42px"
  },
  iconArrow: {
    opacity: 0,
    width: "11px",
    color: theme2.colors.charcoal,
    transition: "transform 0.1s, opacity 0.1s",
    marginTop: "2px"
  },
  tableControl: {
    userSelect: "none",
    borderRadius: "6px",
    width: "fit-content",
    padding: "8px 10px",
    border: "1px solid transparent",
    "&:hover": {
      cursor: "pointer",
      background: theme2.colors.backgroundLight
    }
  },
  tableGroupingHeader: {
    paddingTop: "30px",
    fontWeight: theme2.fontWeights.medium
  },
  tableCard: {
    padding: "8px",
    border: "1px solid black",
    borderRadius: "4px",
    width: "fit-content",
    backgroundColor: theme2.colors.white
  },
  tablePublicControl: {
    userSelect: "none",
    borderRadius: "6px",
    padding: "8px 10px",
    display: "flex",
    justifyContent: "space-between",
    width: "200px",
    margin: "-4px -5px",
    "&:hover": {
      cursor: "pointer",
      background: theme2.colors.backgroundLight
    }
  }
}));
const actionButtonStyles$1 = (theme2) => ({
  container: {
    width: "20px",
    height: "40px",
    borderRadius: "20px"
  },
  button: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 10px",
    // width: '40px',
    height: "40px",
    borderRadius: "20px",
    // backgroundColor: 'white',
    // color: 'black',
    // boxShadow: '0px 4px 4px rgba(176, 176, 176, 0.25)',
    // cursor: 'pointer',
    color: theme2.colors.smoke
  },
  text: {
    // TODO this should be on the button style in component library
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "20px"
  },
  bannerText: {}
});
const DraggableListItem = ({ id, title, description: description2, item, provided, showMenu, isDragging }) => {
  var _a;
  const theme2 = useTheme$1();
  const [hovered, setHovered] = useState(false);
  const classes = useStyles$1u({ isDragging, hovered });
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.dragListItem,
      ref: provided.innerRef,
      onMouseOver: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      onFocus: () => setHovered(true),
      ...provided.draggableProps,
      style: {
        ...(_a = provided.draggableProps) == null ? void 0 : _a.style
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.dragHandle }, /* @__PURE__ */ React__default.createElement(Box, { ...provided.dragHandleProps, className: classes.dragHandleInner }, /* @__PURE__ */ React__default.createElement(DragHandleSVG, { style: { width: "10px" } }))),
    /* @__PURE__ */ React__default.createElement(Box, { style: { flexGrow: 0, fontWeight: "bold" } }, title),
    /* @__PURE__ */ React__default.createElement(Box, { style: { flexGrow: 0, color: theme2.colors.gray8 } }, " | "),
    /* @__PURE__ */ React__default.createElement(Box, { style: { flexGrow: 1, color: theme2.colors.smoke } }, description2),
    /* @__PURE__ */ React__default.createElement(Spacer, { style: { width: "20px" } }, /* @__PURE__ */ React__default.createElement(Button, { type: "icon", style: actionButtonStyles$1(theme2), onClick: showMenu }, /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG$1, { style: { height: "20px", width: "5px" } })))
  );
};
DraggableListItem.defaultProps = {
  areaName: "",
  showMenu: () => {
  }
};
DraggableListItem.propTypes = {
  provided: PropTypes.shape({
    innerRef: PropTypes.func,
    draggableProps: PropTypes.shape({
      style: PropTypes.shape({})
    }),
    dragHandleProps: PropTypes.shape({})
  }).isRequired,
  tableRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]).isRequired,
  areaName: PropTypes.string,
  isDragging: PropTypes.bool.isRequired,
  showMenu: PropTypes.func
};
const mapStateToProps$2O = () => ({});
const mapDispatchToProps$2N = (dispatch) => bindActionCreators({}, dispatch);
const DraggableListItem$1 = connect(mapStateToProps$2O, mapDispatchToProps$2N)(DraggableListItem);
const DraggableList = ({ items, onChange, onClickOverflow }) => {
  useTheme$1();
  const tableRef = useRef(null);
  const classes = useStyles$1u({ isDragging: false });
  const [sortedItems, setSortedItems] = useState(items);
  useEffect(() => {
    setSortedItems(items);
  }, [items]);
  const onDragEnd2 = (result) => {
    var _a, _b2, _c2, _d2;
    if (isEmpty((_a = result == null ? void 0 : result.source) == null ? void 0 : _a.index) || isEmpty((_b2 = result == null ? void 0 : result.destination) == null ? void 0 : _b2.index) || ((_c2 = result == null ? void 0 : result.source) == null ? void 0 : _c2.index) === ((_d2 = result == null ? void 0 : result.destination) == null ? void 0 : _d2.index)) {
      return;
    }
    const newList = arrayMove(items, result.source.index, result.destination.index);
    setSortedItems(newList);
    onChange(newList);
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(DragDropContext, { onDragEnd: onDragEnd2, key: "priority" }, /* @__PURE__ */ React__default.createElement(
    Droppable,
    {
      droppableId: "priority",
      type: sortedItems
    },
    (dropProvided) => /* @__PURE__ */ React__default.createElement(
      Box,
      {
        ...dropProvided.droppableProps,
        ref: dropProvided.innerRef,
        style: { display: "flex", flexDirection: "column", gap: "8px" }
      },
      sortedItems.length > 0 ? sortedItems.map((item, index) => /* @__PURE__ */ React__default.createElement(Draggable$2, { key: `${item.id}`, draggableId: `${item.id}`, index }, (dragProvided, snapshot) => /* @__PURE__ */ React__default.createElement(
        DraggableListItem$1,
        {
          id: item.id,
          title: item.title,
          description: item.description,
          provided: dragProvided,
          tableIndex: index,
          tableRef,
          isDragging: snapshot.isDragging,
          showMenu: (e) => onClickOverflow(e, item.id)
        }
      ))) : /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { style: { padding: "16px 20px" }, colSpan: 4 }, "No suggested venues have been selected")),
      dropProvided.placeholder
    )
  ))));
};
DraggableList.defaultProps = {
  items: [],
  onChange: (e) => e,
  onClickOverflow: (e) => e
};
DraggableList.propTypes = {
  onChange: PropTypes.func,
  onClickOverflow: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string
    })
  )
};
const mapStateToProps$2N = (state) => ({});
const mapDispatchToProps$2M = (dispatch) => bindActionCreators({}, dispatch);
const DraggableList$1 = connect(mapStateToProps$2N, mapDispatchToProps$2M)(DraggableList);
const useStyles$1t = createUseStyles((theme2) => ({
  buttonContainer: {
    width: "100%",
    gap: "15px",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row-reverse",
    [theme2.breakpoints.down("md")]: {
      flexDirection: "column-reverse",
      alignItems: "center"
    }
  },
  modalHeader: {
    ...theme2.typography.heading.H2,
    fontSize: theme2.fontSizes.hm,
    display: "flex",
    gap: "12px",
    alignItems: "center",
    color: theme2.colors.charcoal
  },
  modalBody: {
    ...theme2.typography.body.bodyText2,
    color: theme2.colors.smoke
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "24px"
  }
}));
const modalStyles$5 = (theme2) => ({
  backgroundColor: "#00000070",
  header: {
    background: theme2.colors.modalHighlight,
    height: "40px",
    padding: "0 24px",
    justifyContent: "flex-end",
    position: "sticky",
    top: 0,
    zIndex: 99,
    display: "flex",
    alignItems: "center"
  },
  footerInner: { padding: "12px 24px" },
  content: { padding: "40px" },
  footer: { padding: 0 }
});
const PromptModal = ({
  isOpen,
  onClose,
  onConfirm,
  heading,
  confirmLabel,
  allowCancel,
  children,
  loadingConfirm,
  // Whether to disable the button. e.g. if loading or posting data
  closeLabel,
  inputStyle,
  disableConfirm
  // Whether to disable the button. e.g. if data is invalid
}) => {
  const classes = useStyles$1t();
  const isMobile = useHasMobile();
  const theme2 = useTheme$1();
  const modalStyle = modalStyles$5(theme2);
  const [isClosing, setIsClosing] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);
  const handleClick = () => {
    onConfirm();
  };
  const handleClose = (...props) => {
    setIsClosing(true);
    onClose(...props);
  };
  return /* @__PURE__ */ React__default.createElement(
    Modal,
    {
      inputStyle: { maxWidth: "650px", maxHeight: "600px", ...inputStyle },
      style: modalStyle,
      inputProps: {
        BackdropProps: { style: { backgroundColor: theme2.colors.smoke, opacity: 0.4 } }
      },
      isOpen,
      onClose: handleClose,
      showCloseText: false,
      footer: /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonContainer }, /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "primary",
          onClick: handleClick,
          style: {
            container: { width: isMobile && "100%" },
            button: { width: isMobile && "100%" }
          },
          disabled: isClosing || disableConfirm,
          loading: loadingConfirm
        },
        confirmLabel
      ), allowCancel && /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "tertiary",
          onClick: onClose,
          style: {
            container: { width: isMobile && "100%" },
            button: { width: isMobile && "100%" }
          }
        },
        closeLabel
      ))
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalContent }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, heading)), /* @__PURE__ */ React__default.createElement(Box, { style: { whiteSpace: "pre-line" } }, children)))
  );
};
PromptModal.defaultProps = {
  onConfirm: () => {
  },
  confirmLabel: "Continue",
  allowCancel: true,
  loadingConfirm: false,
  closeLabel: "Cancel",
  inputStyle: {},
  disableConfirm: false,
  children: null,
  onClose: () => {
  }
};
PromptModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  // When the primary button is clicked. Note: This does not close the modal
  heading: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  confirmLabel: PropTypes.string,
  allowCancel: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  loadingConfirm: PropTypes.bool,
  closeLabel: PropTypes.string,
  inputStyle: PropTypes.shape({}),
  disableConfirm: PropTypes.bool
};
const PromptModal$1 = PromptModal;
const SuggestedVenuesModal = ({ isOpen, onClose, form, linkedRestaurants, onConfirm }) => {
  const theme2 = useTheme$1();
  const [suggestedVenues, setSuggestedVenues] = useState(
    linkedRestaurants == null ? void 0 : linkedRestaurants.filter(
      (restaurant) => {
        var _a, _b2, _c2;
        return (_c2 = (_b2 = (_a = form.fields) == null ? void 0 : _a.linkedVenues) == null ? void 0 : _b2.value) == null ? void 0 : _c2.includes(restaurant.objectId);
      }
    )
  );
  useEffect(() => {
    if (isOpen) {
      setSuggestedVenues(
        linkedRestaurants == null ? void 0 : linkedRestaurants.filter(
          (restaurant) => {
            var _a, _b2, _c2;
            return (_c2 = (_b2 = (_a = form.fields) == null ? void 0 : _a.linkedVenues) == null ? void 0 : _b2.value) == null ? void 0 : _c2.includes(restaurant.objectId);
          }
        )
      );
    }
  }, [isOpen, linkedRestaurants]);
  const toggleVenue = (selectedItem) => {
    if (suggestedVenues == null ? void 0 : suggestedVenues.includes(selectedItem)) {
      setSuggestedVenues(suggestedVenues.filter((item) => item !== selectedItem));
    } else {
      setSuggestedVenues([...suggestedVenues, selectedItem]);
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    PromptModal$1,
    {
      isOpen,
      onClose,
      onConfirm: () => onConfirm(suggestedVenues),
      inputStyle: { maxWidth: "680px", maxHeight: "535px" },
      heading: /* @__PURE__ */ React__default.createElement(Box, null, "Add a venue to suggest"),
      confirmLabel: "Add selection"
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: "4px" }, linkedRestaurants.length > 0 && linkedRestaurants.map((linkedRestaurant) => {
      return /* @__PURE__ */ React__default.createElement(Spacer, { key: linkedRestaurant.objectId, direction: "vertical", gap: 0 }, /* @__PURE__ */ React__default.createElement(
        Checkbox,
        {
          key: linkedRestaurant.id,
          color: theme2.colors.charcoal,
          label: /* @__PURE__ */ React__default.createElement(Spacer, null, /* @__PURE__ */ React__default.createElement(Box, { style: { fontWeight: theme2.fontWeights.bold } }, linkedRestaurant.name), /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, " | ", generateAddressString(
            linkedRestaurant.address1,
            linkedRestaurant.address2,
            linkedRestaurant.city,
            linkedRestaurant.state
          ))),
          onChange: (e) => toggleVenue(linkedRestaurant),
          selected: findObjectByProperty(
            suggestedVenues,
            linkedRestaurant == null ? void 0 : linkedRestaurant.objectId,
            "objectId"
          ),
          style: {
            container: {
              borderRadius: "12px",
              margin: "0 -12px",
              padding: "4px 12px",
              width: "100%"
            },
            label: { color: theme2.colors.charcoal, fontSize: "15px" },
            checkboxBox: { height: "24px", width: "24px" }
          }
        }
      ));
    }))
  );
};
SuggestedVenuesModal.defaultProps = {
  linkedRestaurants: []
};
SuggestedVenuesModal.propTypes = {
  linkedRestaurants: PropTypes.arrayOf(PropTypes.shape({})),
  form: formPropTypes$1.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};
const mapStateToProps$2M = () => ({});
const mapDispatchToProps$2L = (dispatch) => bindActionCreators({}, dispatch);
const SuggestedVenuesModal$1 = connect(mapStateToProps$2M, mapDispatchToProps$2L)(SuggestedVenuesModal);
const SuggestedVenues = ({ form, linkedRestaurants }) => {
  var _a, _b2, _c2, _d2;
  const theme2 = useTheme$1();
  const classes = useStyles$1v();
  const [suggestedVenues, setSuggestedVenues] = useState(
    (_b2 = (_a = form.fields) == null ? void 0 : _a.linkedVenues) == null ? void 0 : _b2.value.map((linkedVenue) => findObjectByProperty(linkedRestaurants, linkedVenue, "objectId")).filter((item) => !!item)
  );
  const [showModal, setShowModal] = useState(false);
  const [overflowAnchor, setOverflowAnchor] = useState(null);
  const [venueEditing, setVenueEditing] = useState(null);
  const onClose = () => {
    setShowModal(false);
  };
  const update = (newSuggestedVenues) => {
    const newSuggestedVenueIds = newSuggestedVenues.map((venue) => venue == null ? void 0 : venue.objectId);
    const updatedSuggestedVenues = [...suggestedVenues, ...linkedRestaurants].filter(filterUnique).filter((venue) => newSuggestedVenueIds.includes(venue == null ? void 0 : venue.objectId)).filter((item) => !!item);
    setSuggestedVenues(updatedSuggestedVenues);
    form.setFieldValue(
      "linkedVenues",
      updatedSuggestedVenues == null ? void 0 : updatedSuggestedVenues.map((venue) => venue == null ? void 0 : venue.objectId)
    );
    setShowModal(false);
  };
  const removeVenue = (venueId) => {
    const newSuggestedVenues = suggestedVenues.filter((venue) => (venue == null ? void 0 : venue.objectId) !== venueId);
    setVenueEditing(null);
    update(newSuggestedVenues);
  };
  useEffect(() => {
    var _a2, _b3;
    setSuggestedVenues(
      (((_b3 = (_a2 = form.fields) == null ? void 0 : _a2.linkedVenues) == null ? void 0 : _b3.value) || []).map((linkedVenue) => findObjectByProperty(linkedRestaurants, linkedVenue, "objectId")).filter((item) => !!item)
    );
  }, [(_d2 = (_c2 = form.fields) == null ? void 0 : _c2.linkedVenues) == null ? void 0 : _d2.value]);
  const suggestedVenuesForSorting = suggestedVenues.map((venue) => ({
    id: venue.objectId,
    title: venue.name,
    description: generateAddressString(venue.address1, venue.address2, venue.city, venue.state)
  }));
  return /* @__PURE__ */ React__default.createElement(
    Spacer,
    {
      direction: "vertical",
      gap: 20,
      style: {
        paddingTop: "12px",
        borderTop: `1px solid ${theme2.colors.gray7}`
      }
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { style: { justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Venues suggested to customer:"), /* @__PURE__ */ React__default.createElement(
      SmallButton$3,
      {
        onClick: () => {
          setShowModal(true);
        }
      },
      "Add venue"
    )),
    /* @__PURE__ */ React__default.createElement(
      DraggableList$1,
      {
        items: suggestedVenuesForSorting,
        onChange: (newList) => {
          setSuggestedVenues(
            newList == null ? void 0 : newList.map((venue) => findObjectByProperty(linkedRestaurants, venue == null ? void 0 : venue.id, "objectId")).filter((item) => !!item)
          );
          form.setFieldValue(
            "linkedVenues",
            newList == null ? void 0 : newList.map((venue) => venue == null ? void 0 : venue.id)
          );
        },
        onClickOverflow: (e, venueId) => {
          setOverflowAnchor(e.currentTarget);
          setVenueEditing(venueId);
        }
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      SuggestedVenuesModal$1,
      {
        isOpen: showModal,
        onClose,
        onConfirm: update,
        form,
        linkedRestaurants,
        confirmLabel: "Add selection"
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      ListPopover,
      {
        items: [
          {
            key: "remove",
            label: "Remove",
            onClick: () => removeVenue(venueEditing)
          }
        ],
        anchor: overflowAnchor,
        isOpen: !isEmpty(overflowAnchor) && !isEmpty(venueEditing),
        onClose: () => setOverflowAnchor(null),
        style: listPopoverStyles,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }
    )
  );
};
SuggestedVenues.defaultProps = {
  linkedRestaurants: []
};
SuggestedVenues.propTypes = {
  linkedRestaurants: PropTypes.arrayOf(PropTypes.shape({})),
  form: formPropTypes$1.isRequired
};
const mapStateToProps$2L = () => ({});
const mapDispatchToProps$2K = (dispatch) => bindActionCreators({}, dispatch);
const SuggestedVenues$1 = connect(mapStateToProps$2L, mapDispatchToProps$2K)(SuggestedVenues);
const MultiVenues = ({ form, linkedVenues, linkedRestaurants, loading, restaurant }) => {
  var _a, _b2, _c2, _d2, _e2, _f;
  const theme2 = useTheme$1();
  const dropdownStyles = {
    outerContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    },
    label: {
      maxWidth: "280px",
      fontSize: "18px",
      lineHeight: "28px",
      color: theme2.colors.charcoal
    },
    dropdown: { minWidth: "300px" }
  };
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(
      Skeleton$1,
      {
        height: 200,
        style: { skeleton: { backgroundColor: theme2.colors.loadingShimmer } }
      }
    );
  }
  if (!canEditAll() && isEmpty(linkedRestaurants)) {
    return /* @__PURE__ */ React__default.createElement(Box, null, "Your account does not have any linked venues. Settings will appear here if your account has linked venues.");
  }
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 40, style: { marginTop: "40px" } }, /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: `Venue description for ${restaurant == null ? void 0 : restaurant.name} (shown if your other venues link to this one)`,
      value: (_b2 = (_a = form.fields) == null ? void 0 : _a.venueDescription) == null ? void 0 : _b2.value,
      onChange: (newValue) => form.setFieldValue("venueDescription", newValue),
      placeholder: "Empty"
    }
  ), /* @__PURE__ */ React__default.createElement(
    Dropdown$1,
    {
      label: "Suggest booking at your other venues",
      value: (_d2 = (_c2 = form.fields) == null ? void 0 : _c2.suggestAvailability) == null ? void 0 : _d2.value,
      items: multiVenueAvailability(),
      onSelect: (newValue) => form.setFieldValue("suggestAvailability", newValue),
      style: dropdownStyles
    }
  ), ["no_availability", "always"].includes((_f = (_e2 = form.fields) == null ? void 0 : _e2.suggestAvailability) == null ? void 0 : _f.value) && /* @__PURE__ */ React__default.createElement(SuggestedVenues$1, { form, linkedRestaurants }));
};
MultiVenues.defaultProps = {
  linkedVenues: []
};
MultiVenues.propTypes = {
  linkedVenues: PropTypes.arrayOf(PropTypes.shape({})),
  linkedRestaurants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
  form: formPropTypes$1.isRequired,
  restaurant: restaurantPropTypes.isRequired
};
const mapStateToProps$2K = (state) => ({
  linkedVenues: state.restaurant.linkedVenues,
  restaurant: state.restaurant.restaurant
});
const mapDispatchToProps$2J = (dispatch) => bindActionCreators({}, dispatch);
const MultiVenues$1 = connect(mapStateToProps$2K, mapDispatchToProps$2J)(MultiVenues);
const useStyles$1s = createUseStyles((theme2) => ({
  indexListContainer: {
    fontWeight: theme2.fontWeights.medium,
    fontSize: "18px"
  },
  step: {
    borderBottom: `1px solid ${theme2.colors.gray7}`,
    padding: "4px"
  },
  number: {
    color: theme2.colors.gray4,
    width: "25px"
  }
}));
const buttonOffset = 23;
const buttonStyles$6 = (theme2) => ({
  button: {
    border: "1px solid transparent",
    width: `calc(100% + ${buttonOffset * 2}px)`,
    padding: "12px 14px",
    borderRadius: "8px",
    marginLeft: "-23px",
    // To align it to the left
    marginRight: "-23px",
    fontWeight: theme2.fontWeights.medium
  }
});
const IndexList = ({ steps, setStep }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1s();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.indexListContainer }, steps.filter((step) => !step.hideInList).map((step, index) => /* @__PURE__ */ React__default.createElement(Box, { key: step == null ? void 0 : step.title, className: classes.step }, /* @__PURE__ */ React__default.createElement(
    SquareButton,
    {
      type: "text",
      onClick: () => setStep(step == null ? void 0 : step.id),
      fullWidth: true,
      centered: false,
      style: buttonStyles$6(theme2)
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { gap: 20 }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.number }, fixedDigits(index + 1)), step.title, step.label && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: {
          fontSize: "16px",
          color: theme2.colors.smoke,
          fontWeight: theme2.fontWeights.regular
        }
      },
      step.label
    ))
  ))));
};
IndexList.defaultProps = {
  steps: [],
  setStep: (e) => e
};
IndexList.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({})),
  setStep: PropTypes.func
};
const mapStateToProps$2J = () => ({});
const mapDispatchToProps$2I = (dispatch) => bindActionCreators({}, dispatch);
const IndexList$1 = connect(mapStateToProps$2J, mapDispatchToProps$2I)(IndexList);
const Overview = ({ addMessage: addMessage2, setStep, steps, slug, restaurant }) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$1z();
  const bookingWidgetUrl = `${(_a = window.bookingsConfig) == null ? void 0 : _a.bookingWidgetBaseUrl}/${slug}`;
  const copyToClipboard = (text, message = "URL copied to clipboard!") => {
    navigator.clipboard.writeText(text);
    addMessage2(`COPY_MESSAGE_SUCCESS_${(/* @__PURE__ */ new Date()).getTime()}`, message, "success");
  };
  const widgetEmbedCode = `<div class='${isObee() ? "obee" : "eatclub"}-widget' account="${slug}" hide-header='false' min-height='450' add-height='50' scrolltop='true' widget-type='booking'></div><script src='${(_b2 = window.bookingsConfig) == null ? void 0 : _b2.bookingWidgetBaseUrl}/iframe.js'><\/script>`;
  const premiumWord = isObee() ? "Branded" : "Premium";
  const stepsToShow = steps.map((step) => ({
    ...step,
    label: !hasBrandingSettings(restaurant) && (step == null ? void 0 : step.premiumOnly) ? `${premiumWord} only` : ""
  }));
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 40 }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Spacer, { className: classes.header, gap: 40, style: { justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Overview"), /* @__PURE__ */ React__default.createElement(
    SquareButton,
    {
      style: { fontSize: "15px" },
      onClick: () => copyToClipboard(bookingWidgetUrl)
    },
    bookingWidgetUrl
  )), /* @__PURE__ */ React__default.createElement(IndexList$1, { steps: stepsToShow, setStep })), hasBrandingSettings(restaurant) && /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical" }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        ...theme2.typography.heading.H4,
        fontWeight: theme2.fontWeights.medium
      }
    },
    "Widget embed code"
  ), /* @__PURE__ */ React__default.createElement(Box, null, "You can paste this into the HTML of your restaurant's website to embed the booking widget."), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      onClick: () => copyToClipboard(widgetEmbedCode, "Embed code copied to clipboard!"),
      style: {
        backgroundColor: theme2.colors.lightCloud,
        padding: "20px",
        borderRadius: "8px",
        cursor: "pointer"
      }
    },
    widgetEmbedCode
  ))));
};
Overview.propTypes = {
  addMessage: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  slug: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
const mapStateToProps$2I = (state) => {
  var _a, _b2, _c2, _d2;
  return {
    slug: ((_b2 = (_a = state.restaurantActive) == null ? void 0 : _a.restaurant) == null ? void 0 : _b2.slug) || ((_d2 = (_c2 = state == null ? void 0 : state.obeeSettings) == null ? void 0 : _c2.data) == null ? void 0 : _d2.slug),
    restaurant: state.restaurantActive.restaurant
  };
};
const mapDispatchToProps$2H = (dispatch) => bindActionCreators(
  {
    addMessage: addMessageAction
  },
  dispatch
);
const Overview$1 = connect(mapStateToProps$2I, mapDispatchToProps$2H)(Overview);
const PrimaryButtonSmall = ({ children, ...other }) => {
  const theme2 = useTheme$1();
  const styles2 = {
    button: {
      padding: "0 24px",
      fontWeight: theme2.fontWeights.medium,
      fontSize: "15px",
      height: "36px",
      borderColor: "transparent"
      // color: theme.colors.charcoal,
      // borderColor: theme.colors.shark,
    },
    buttonHover: {
      backgroundColor: theme2.colors.black,
      filter: "none"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Button, { type: "primary", style: styles2, ...other }, children);
};
PrimaryButtonSmall.defaultProps = {
  children: null
};
PrimaryButtonSmall.propTypes = {
  children: PropTypes.node
};
const SecondaryButton = ({ children, style, ...other }) => {
  const theme2 = useTheme$1();
  const styles2 = {
    ...style,
    button: {
      padding: "0 24px",
      fontWeight: theme2.fontWeights.medium,
      fontSize: "15px",
      lineHeight: "15px",
      height: "36px",
      color: theme2.colors.charcoal,
      border: `1px solid ${theme2.colors.charcoal}`,
      boxShadow: "none",
      borderRadius: "80px",
      backgroundColor: "white",
      ...style == null ? void 0 : style.button
    }
  };
  return /* @__PURE__ */ React__default.createElement(Button, { type: "standard", style: styles2, ...other }, children);
};
SecondaryButton.defaultProps = {
  children: null,
  style: {}
};
SecondaryButton.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({})
};
const formPropTypes = PropTypes.shape({
  formEditingId: PropTypes.string,
  hasUnsavedChanges: PropTypes.bool
});
const useStyles$1q = createUseStyles((theme2) => ({
  widgetSettingsFooterContainer: {
    width: "100%",
    height: "61px",
    backgroundColor: theme2.colors.white,
    position: "fixed",
    bottom: (props) => (props == null ? void 0 : props.show) ? 0 : -61,
    opacity: (props) => (props == null ? void 0 : props.show) ? 1 : 0,
    left: "0",
    // boxShadow: '0px 4px 4px rgba(200, 199, 199, 0.25)',
    display: "flex",
    alignItems: "center",
    transition: "bottom 0.5s, opacity 0.5s",
    padding: "0 96px",
    borderTop: `1px solid ${theme2.colors.cloud}`,
    gap: "20px"
  }
}));
const useStyles$1r = useStyles$1q;
const SaveFooter = ({ form }) => {
  const classes = useStyles$1r({ show: form.hasUnsavedChanges });
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.widgetSettingsFooterContainer }, /* @__PURE__ */ React__default.createElement(PrimaryButtonSmall, { disabled: !form.hasUnsavedChanges, onClick: form.save }, "Save changes"), /* @__PURE__ */ React__default.createElement(SecondaryButton, { disabled: !form.hasUnsavedChanges, onClick: form.clear }, "Cancel changes"));
};
SaveFooter.propTypes = {
  form: formPropTypes.isRequired
};
const mapStateToProps$2H = () => ({});
const mapDispatchToProps$2G = (dispatch) => bindActionCreators({}, dispatch);
const SaveFooter$1 = connect(mapStateToProps$2H, mapDispatchToProps$2G)(SaveFooter);
const useStyles$1p = createUseStyles((theme2) => ({
  container: {
    position: "relative",
    width: "100%",
    maxWidth: "400px",
    justifyContent: "space-between",
    backgroundColor: theme2.colors.white,
    border: `1px solid ${theme2.colors.gray7}`,
    borderRadius: "8px",
    boxShadow: "0px 4px 4px 0px rgba(196, 196, 196, 0.25);",
    alignItems: "stretch"
  },
  content: {}
}));
const buttonStyles$5 = (theme2) => ({
  borderRadius: "8px",
  border: "none",
  height: "100%",
  whiteSpace: "nowrap",
  cursor: "pointer",
  userSelect: "none",
  // backgroundColor: '#F5F2ED',
  transitionDuration: "0.1s",
  // overflow: 'hidden',
  button: {
    borderRadius: "8px",
    border: "none",
    height: "38px",
    fontWeight: theme2.fontWeights.medium
  },
  buttonHover: {
    filter: "none",
    color: "black"
  }
});
const leftButton = (theme2) => {
  var _a, _b2;
  return {
    ...buttonStyles$5(theme2),
    button: {
      ...(_a = buttonStyles$5(theme2)) == null ? void 0 : _a.button,
      borderRadius: "7px 0 0 7px"
    },
    buttonHover: {
      ...(_b2 = buttonStyles$5(theme2)) == null ? void 0 : _b2.buttonHover,
      filter: "brightness(95%)"
    }
  };
};
const rightButton = (theme2) => {
  var _a, _b2;
  return {
    ...buttonStyles$5(theme2),
    button: {
      ...(_a = buttonStyles$5(theme2)) == null ? void 0 : _a.button,
      borderRadius: "0 7px 7px 0"
    },
    buttonHover: {
      ...(_b2 = buttonStyles$5(theme2)) == null ? void 0 : _b2.buttonHover,
      filter: "brightness(95%)"
    }
  };
};
const popoverStyles$6 = {
  innerStyle: {
    padding: 0,
    marginTop: "16px",
    borderRadius: "6px",
    width: "100%",
    overflow: "auto",
    bottom: "16px"
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  }
};
const SvgDateSelectLeftArrow = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M7 13L1 6.99997L7 0.99997", stroke: "currentColor" }));
const LeftArrowSVG = SvgDateSelectLeftArrow;
const StepSelector = ({ steps, activeStep, setStep }) => {
  const classes = useStyles$1p();
  const theme2 = useTheme$1();
  const [anchor, setAnchor] = useState(null);
  const selectableSteps = steps.filter((step2) => !step2.hideInSelector);
  const stepsList = useMemo(
    () => steps == null ? void 0 : steps.map((step2, index) => ({
      id: step2 == null ? void 0 : step2.id,
      label: `${index !== 0 ? `${index}:` : ""} ${step2 == null ? void 0 : step2.title}`,
      value: step2 == null ? void 0 : step2.id
    })),
    [steps]
  );
  const step = findObjectByProperty(steps, activeStep, "id");
  const wrapperRef = useRef(null);
  const stepIndex = selectableSteps.findIndex((step2) => step2.id === activeStep);
  const handleSelect = (newValue) => {
    setStep(newValue);
  };
  const goToNextStep = () => {
    var _a;
    if (stepIndex === steps.length - 1) {
      setStep(0);
      return;
    }
    setStep((_a = steps[stepIndex + 1]) == null ? void 0 : _a.id);
  };
  const goToPreviousStep = () => {
    var _a;
    setStep((_a = steps[stepIndex - 1]) == null ? void 0 : _a.id);
  };
  if (stepIndex < 0) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
    Spacer,
    {
      ref: wrapperRef,
      className: classes.container,
      style: { justifyContent: "space-between" }
    },
    /* @__PURE__ */ React__default.createElement(SquareButton, { style: leftButton(theme2), onClick: goToPreviousStep }, /* @__PURE__ */ React__default.createElement(LeftArrowSVG, { style: { width: "8px" } })),
    /* @__PURE__ */ React__default.createElement(
      SquareButton,
      {
        style: buttonStyles$5(theme2),
        onClick: () => {
          setAnchor(wrapperRef.current);
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, step == null ? void 0 : step.title)
    ),
    /* @__PURE__ */ React__default.createElement(SquareButton, { style: rightButton(theme2), onClick: goToNextStep }, /* @__PURE__ */ React__default.createElement(LeftArrowSVG, { style: { transform: "rotate(180deg)", width: "8px" } }))
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: stepsList,
      onClose: () => setAnchor(null),
      isOpen: !!anchor,
      anchor,
      onSelect: handleSelect,
      innerStyle: { ...popoverStyles$6.innerStyle },
      anchorOrigin: popoverStyles$6.anchorOrigin,
      transformOrigin: popoverStyles$6.transformOrigin,
      selectedItems: [activeStep]
    }
  ));
};
StepSelector.propTypes = {};
const mapStateToProps$2G = () => ({});
const mapDispatchToProps$2F = (dispatch) => bindActionCreators({}, dispatch);
const StepSelector$1 = connect(mapStateToProps$2G, mapDispatchToProps$2F)(StepSelector);
const useStyles$1o = createUseStyles((theme2) => ({
  container: {
    position: "relative"
  },
  items: {
    display: "flex"
  },
  listItem: {
    height: "36px",
    // lineHeight: '24px',
    // ...theme.eatclub.typography.body.PL,
    // fontSize: '18px',
    alignItems: "center",
    borderRadius: "8px",
    padding: "8px",
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    gap: "8px",
    width: "100%",
    // ...props?.style?.listItem,
    "&:hover": {
      backgroundColor: theme2.colors.whiteSmoke
      // ...props?.style?.listItem?.hover,
    }
  },
  listItemSelected: {
    fontWeight: theme2.fontWeights.medium
  },
  categoryLabel: (props) => {
    var _a;
    return {
      fontSize: "14px",
      color: theme2.colors.nimbus,
      fontWeight: theme2.fontWeights.medium,
      padding: "10px",
      paddingLeft: "20px",
      paddingRight: "20px",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.categoryLabel
    };
  }
}));
const CheckboxSelection = ({ items, defaultSelectedItems, onConfirm, style, disabled }) => {
  const classes = useStyles$1o({ style, disabled });
  const [selectedItems, setSelectedItems] = useState(defaultSelectedItems);
  const handleConfirm = () => {
    const itemValues = items.map((item) => item == null ? void 0 : item.value);
    onConfirm(selectedItems.filter((item) => itemValues.includes(item)));
  };
  const handleChange = (selectedItem) => {
    if (selectedItems == null ? void 0 : selectedItems.includes(selectedItem)) {
      setSelectedItems(selectedItems.filter((item) => item !== selectedItem));
    } else {
      setSelectedItems([...selectedItems, selectedItem]);
    }
  };
  const styles2 = {
    container: {
      ...style,
      ...style == null ? void 0 : style.container
    },
    item: {
      userSelect: "none",
      ...style == null ? void 0 : style.item
    }
  };
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 16 }, /* @__PURE__ */ React__default.createElement(Box, null, items == null ? void 0 : items.map((item) => {
    return /* @__PURE__ */ React__default.createElement(
      Box,
      {
        key: `${(item == null ? void 0 : item.key) || (item == null ? void 0 : item.label)}_${item == null ? void 0 : item.value}`,
        className: `${classes.listItem} ${(selectedItems == null ? void 0 : selectedItems.includes(item == null ? void 0 : item.id)) && classes.listItemSelected}`,
        style: {
          ...styles2 == null ? void 0 : styles2.item
        },
        onClick: (e) => {
          if (item == null ? void 0 : item.onClick) {
            item == null ? void 0 : item.onClick(e);
          }
          handleChange(item == null ? void 0 : item.value);
        }
      },
      /* @__PURE__ */ React__default.createElement(
        Checkbox,
        {
          selected: selectedItems.includes(item == null ? void 0 : item.value),
          color: "black",
          style: { display: "flex", checkboxBox: { padding: 0 } },
          onChange: (e) => {
            if (item == null ? void 0 : item.onClick) {
              item == null ? void 0 : item.onClick(e);
            }
            handleChange(item == null ? void 0 : item.value);
          }
        }
      ),
      item == null ? void 0 : item.label
    );
  })), /* @__PURE__ */ React__default.createElement(SecondaryButton, { onClick: handleConfirm }, "Confirm"));
};
CheckboxSelection.defaultProps = {
  defaultSelectedItems: [],
  style: {},
  props: null,
  disabled: false,
  onConfirm: () => {
  }
};
CheckboxSelection.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  defaultSelectedItems: PropTypes.arrayOf(PropTypes.any),
  style: PropTypes.shape({}),
  props: PropTypes.shape({}),
  disabled: PropTypes.bool,
  onConfirm: PropTypes.func
};
const CheckboxSelection$1 = CheckboxSelection;
const SvgByo = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 25 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M0.188 8.52C0.188 8.784 0.404 9 0.656 9H3.92C5.756 9 6.968 8.148 6.968 6.708V6.684C6.968 5.532 6.164 4.956 5.168 4.656C5.828 4.368 6.5 3.804 6.5 2.712V2.688C6.5 2.148 6.308 1.704 5.96 1.344C5.48 0.875999 4.724 0.599999 3.764 0.599999H0.656C0.404 0.599999 0.188 0.816 0.188 1.08V8.52ZM1.124 4.344V1.452H3.68C4.88 1.452 5.54 1.992 5.54 2.82V2.844C5.54 3.828 4.748 4.344 3.608 4.344H1.124ZM1.124 8.148V5.184H3.776C5.24 5.184 6.008 5.712 6.008 6.624V6.648C6.008 7.584 5.216 8.148 3.944 8.148H1.124ZM11.0766 8.58C11.0766 8.844 11.2926 9.06 11.5566 9.06C11.8206 9.06 12.0366 8.844 12.0366 8.58V5.676L15.1446 1.356C15.2046 1.26 15.2766 1.128 15.2766 1.008C15.2766 0.756 15.0726 0.539999 14.8086 0.539999C14.6046 0.539999 14.4846 0.659999 14.3646 0.827999L11.5686 4.824L8.79659 0.827999C8.67659 0.659999 8.54459 0.539999 8.34059 0.539999C8.07659 0.539999 7.84859 0.756 7.84859 1.008C7.84859 1.128 7.89659 1.236 7.95659 1.332L11.0766 5.7V8.58ZM20.2599 9.144C22.8159 9.144 24.5559 7.116 24.5559 4.8V4.776C24.5559 2.46 22.8399 0.456 20.2839 0.456C17.7279 0.456 15.9879 2.484 15.9879 4.8V4.824C15.9879 7.14 17.7039 9.144 20.2599 9.144ZM20.2839 8.268C18.3639 8.268 16.9719 6.708 16.9719 4.8V4.776C16.9719 2.868 18.3399 1.332 20.2599 1.332C22.1799 1.332 23.5719 2.892 23.5719 4.8V4.824C23.5719 6.732 22.2039 8.268 20.2839 8.268Z", fill: "black" }));
const BYOIconSVG = SvgByo;
const SvgCorkage = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 10 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M5.19048 27C4.38433 27 3.43602 26.9297 2.62758 26.8449C1.67785 26.7452 1 25.9366 1 24.9817V10.7971C1 10.1921 3.28571 7.4058 3.28571 7.4058C3.28571 7.4058 3.66667 7.02899 3.66667 6.65217V1.75362C3.66667 1.22668 4.04762 1 5 1C6.00209 1 6.33333 1.37681 6.33333 1.75362V6.65217C6.33333 7.02899 6.33333 7.02899 6.71429 7.4058C7.31662 8.00159 9 10.0435 9 10.7971V24.9817C9 25.9366 8.32437 26.7577 7.37545 26.8647C6.70505 26.9404 5.9327 27 5.19048 27Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 3.40625, y: 11.6738, width: 3.19048, height: 11.8116, rx: 0.5, stroke: "#313131" }));
const CorkageIconSVG = SvgCorkage;
const SvgDressCode = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M16.4167 3.08398H16.8333H19C20.1046 3.08398 21 3.97941 21 5.08398V18.9575C21 20.0621 20.1046 20.9575 19 20.9575H3C1.89543 20.9575 1 20.0621 1 18.9575V5.08398C1 3.97942 1.89543 3.08398 3 3.08398H5.16667H6", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M6 0.957031V7.34596C6 7.72625 6.40772 7.96734 6.74094 7.78408L11.3048 5.27415M6 0.957031H16.8333M6 0.957031L11.3048 5.27415M16.8333 0.957031V7.34596C16.8333 7.72625 16.4256 7.96734 16.0924 7.78408L11.5285 5.27415M16.8333 0.957031L11.5285 5.27415M11.3048 5.27415V5.27415C11.3745 5.23585 11.4589 5.23585 11.5285 5.27415V5.27415", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("line", { x1: 11.5, y1: 5.63672, x2: 11.5, y2: 20.9569, stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("line", { x1: 14, y1: 11.9473, x2: 18.8333, y2: 11.9473, stroke: "#313131", strokeLinecap: "round" }));
const DressCodeIconSVG = SvgDressCode;
const SvgKidsMenu = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M7.37716 4.07931L3.15224 2.03924C2.15623 1.5583 1 2.28397 1 3.39001V15.9224C1 16.4935 1.32434 17.0151 1.83657 17.2677L7.37716 20M7.37716 4.07931L13.7543 1M7.37716 4.07931V20M13.7543 1L19.1633 3.6668C19.6756 3.91938 20 4.44099 20 5.01217V17.6556C20 18.7503 18.8653 19.4763 17.8714 19.0175L13.7543 17.1172M13.7543 1V17.1172M13.7543 17.1172L7.37716 20", stroke: "black", strokeLinecap: "round" }));
const KidsMenuIconSVG = SvgKidsMenu;
const SvgPlayground = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 24 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M19.8164 9.83203V23.9426", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.7578 11.2433L13.002 9.61719", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M6.92188 17.2422V24.2975", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.4063 16.8887L10.4063 24.2967", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M19.8164 10.1855V24.2961", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M14 10.123L14 14.1725", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.52996 16.8866H2C1.44772 16.8866 1 16.4389 1 15.8866V9.83128V9.83128C1 9.63645 1.15794 9.47852 1.35276 9.47852H5.52996M5.52996 16.8866H10.7568M5.52996 16.8866V9.47852M5.52996 9.47852H9.75683C10.3091 9.47852 10.7568 9.92623 10.7568 10.4785V11.9479", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M4.19392 13.0072C4.19392 13.508 4.05933 13.9385 3.86809 14.2289C3.67416 14.5234 3.4629 14.6238 3.30008 14.6238C3.13727 14.6238 2.92601 14.5234 2.73208 14.2289C2.54084 13.9385 2.40625 13.508 2.40625 13.0072C2.40625 12.5065 2.54084 12.076 2.73208 11.7856C2.92601 11.4911 3.13727 11.3906 3.30008 11.3906C3.4629 11.3906 3.67416 11.4911 3.86809 11.7856C4.05933 12.076 4.19392 12.5065 4.19392 13.0072Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17 20.2457C15.9546 19.8929 15.7998 19.8375 14.878 16.5335C13.8939 13.0058 11.1062 11.9475 8.66705 11.242C7.2856 10.8424 5.81808 14.4169 8.25734 15.1224C11.12 15.9504 10.7578 17.9445 11.4547 20.7667C12.0122 23.0243 13.8939 24.2943 16.3331 24.6471", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.5581 22.5299C18.5581 23.6233 17.6841 24.4992 16.6189 24.4992C15.5537 24.4992 14.6797 23.6233 14.6797 22.5299C14.6797 21.4364 15.5537 20.5605 16.6189 20.5605C17.6841 20.5605 18.5581 21.4364 18.5581 22.5299Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M13.1953 4.54102V9.18525C13.1953 9.73753 13.643 10.1852 14.1953 10.1852H19.8614C20.4137 10.1852 20.8614 9.73753 20.8614 9.18525V4.54102", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.2697 7.36343C18.2697 8.06723 17.7078 8.62725 17.0274 8.62725C16.3471 8.62725 15.7852 8.06723 15.7852 7.36343C15.7852 6.65963 16.3471 6.09961 17.0274 6.09961C17.7078 6.09961 18.2697 6.65963 18.2697 7.36343Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.6328 4.4387L17.0317 0.612818L22.4305 4.4387H11.6328Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M2.74219 16.8887V24.2967", stroke: "#313131", strokeLinecap: "round" }));
const PlaygroundIconSVG = SvgPlayground;
const SvgTheCake = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 22 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 2.81641, y: 9.74414, width: 16.3684, height: 9.57994, rx: 1.5, stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 13.0238, y: 6.16643, width: 0.578947, height: 2.9477, rx: 0.289474, stroke: "#313131", strokeWidth: 0.578947 }), /* @__PURE__ */ React$7.createElement("rect", { x: 8.39494, y: 6.16643, width: 0.578947, height: 2.9477, rx: 0.289474, stroke: "#313131", strokeWidth: 0.578947 }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.9229 3.52665C9.9229 4.23152 9.36204 4.78997 8.68606 4.78997C8.01008 4.78997 7.44922 4.23152 7.44922 3.52665C7.44922 3.12607 7.62133 2.31128 7.91997 1.58923C8.06768 1.2321 8.23266 0.932005 8.39733 0.730283C8.57432 0.513471 8.67471 0.5 8.68606 0.5C8.69741 0.5 8.7978 0.513471 8.97479 0.730283C9.13947 0.932005 9.30445 1.2321 9.45215 1.58923C9.7508 2.31128 9.9229 3.12607 9.9229 3.52665Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M14.5518 3.52665C14.5518 4.23152 13.991 4.78997 13.315 4.78997C12.639 4.78997 12.0781 4.23152 12.0781 3.52665C12.0781 3.12607 12.2502 2.31128 12.5489 1.58923C12.6966 1.2321 12.8616 0.932005 13.0262 0.730283C13.2032 0.513471 13.3036 0.5 13.315 0.5C13.3263 0.5 13.4267 0.513471 13.6037 0.730283C13.7684 0.932005 13.9334 1.2321 14.0811 1.58923C14.3797 2.31128 14.5518 3.12607 14.5518 3.52665Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M2.89453 13.3573C3.08751 13.7492 3.12611 14.5329 4.05243 14.5329C5.21032 14.5329 5.21032 12.7695 6.36822 12.7695C7.52611 12.7695 7.52611 14.5329 8.684 14.5329C9.8419 14.5329 10.4208 12.7695 10.9998 12.7695C11.5787 12.7695 10.9998 14.5329 12.7366 14.5329C14.4735 14.5329 13.8945 12.7695 15.0524 12.7695C16.2103 12.7695 15.6314 14.5329 17.3682 14.5329C19.1051 14.5329 17.9472 12.7695 19.1051 12.7695", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("mask", { id: "path-7-inside-1_12786_58638", fill: "white" }, /* @__PURE__ */ React$7.createElement("rect", { y: 17.4727, width: 22, height: 3.52665, rx: 0.5 })), /* @__PURE__ */ React$7.createElement("rect", { y: 17.4727, width: 22, height: 3.52665, rx: 0.5, fill: "white", stroke: "#313131", strokeWidth: 2, mask: "url(#path-7-inside-1_12786_58638)" }));
const CakeIconSVG$1 = SvgTheCake;
const SvgWheelchair = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 16 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M9.43359 12.1582H12.2602C13.0232 12.1582 13.7198 12.5923 14.0558 13.2773L16.9981 19.2751", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M3.90943 9.68945C2.17017 10.7149 1 12.6315 1 14.8268C1 18.1022 3.60519 20.7575 6.81886 20.7575C9.12208 20.7575 11.1128 19.3936 12.0558 17.415", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.64727 2.37229C8.64727 3.41535 7.82012 4.24458 6.81973 4.24458C5.81934 4.24458 4.99219 3.41535 4.99219 2.37229C4.99219 1.32923 5.81934 0.5 6.81973 0.5C7.82012 0.5 8.64727 1.32923 8.64727 2.37229Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("g", { filter: "url(#filter0_d_12786_58606)" }, /* @__PURE__ */ React$7.createElement("path", { d: "M13.2225 9.93023L9.57557 9.93023C9.23229 9.93023 8.94147 9.67989 8.89009 9.34017L8.5468 7.07009C8.40006 6.09972 7.46828 5.45707 6.50869 5.66441V5.66441C5.62346 5.85568 5.03731 6.70496 5.17268 7.60015L6.0847 13.631C6.27646 14.899 7.4726 15.7553 8.73496 15.5283L10.4531 15.2193V15.2193C11.5706 14.9876 12.6994 15.539 13.2011 16.5616L15.2591 20.7567", stroke: "#313131", strokeLinecap: "round" })), /* @__PURE__ */ React$7.createElement("defs", null, /* @__PURE__ */ React$7.createElement("filter", { id: "filter0_d_12786_58606", x: 0.652344, y: 5.125, width: 19.1055, height: 24.1328, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React$7.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React$7.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React$7.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ React$7.createElement("feGaussianBlur", { stdDeviation: 2 }), /* @__PURE__ */ React$7.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React$7.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ React$7.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_12786_58606" }), /* @__PURE__ */ React$7.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_12786_58606", result: "shape" }))));
const WheelchairIconSVG = SvgWheelchair;
const CorkageSubMenu = ({ form, onClose }) => {
  var _a, _b2, _c2, _d2;
  const theme2 = useTheme$1();
  const [corkagePer, setCorkagePer] = useState((_b2 = (_a = form.fields) == null ? void 0 : _a.corkagePer) == null ? void 0 : _b2.value);
  const [corkageFee, setCorkageFee] = useState((_d2 = (_c2 = form.fields) == null ? void 0 : _c2.corkageFee) == null ? void 0 : _d2.value);
  const textFieldStyles2 = {
    input: { border: `1px solid ${theme2.colors.shark}`, paddingLeft: "20px" },
    label: { width: "60px" },
    innerContainer: { gap: "8px" }
  };
  const dropdownStyles = {
    label: { width: "60px" },
    dropdown: { width: "100%" },
    outerContainer: { gap: "8px" }
  };
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", style: { padding: "8px" } }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Fee",
      value: corkageFee,
      onChange: setCorkageFee,
      inputPrefix: "$",
      style: textFieldStyles2
    }
  ), /* @__PURE__ */ React__default.createElement(
    Dropdown$1,
    {
      label: "per",
      items: [
        { label: "Bottle", value: "bottle" },
        { label: "Booking", value: "booking" }
      ],
      value: corkagePer,
      onSelect: setCorkagePer,
      style: dropdownStyles
    }
  ), /* @__PURE__ */ React__default.createElement(
    SecondaryButton,
    {
      onClick: () => {
        if (onClose) {
          onClose();
        }
        form.setFieldValues([
          { id: "corkageOption", value: "yes" },
          { id: "corkageFee", value: corkageFee },
          { id: "corkagePer", value: corkagePer }
        ]);
      }
    },
    "Confirm"
  ));
};
CorkageSubMenu.propTypes = {
  form: formPropTypes$1.isRequired,
  onClose: PropTypes.func.isRequired
};
const mapStateToProps$2F = () => ({});
const mapDispatchToProps$2E = (dispatch) => bindActionCreators({}, dispatch);
const CorkageSubMenu$1 = connect(mapStateToProps$2F, mapDispatchToProps$2E)(CorkageSubMenu);
const Venues = ({ form }) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J;
  const dropdownStyles = {
    outerContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    },
    label: { maxWidth: "280px" },
    dropdown: { minWidth: "250px" }
  };
  const byoLicenseValue = () => {
    var _a2, _b3, _c3, _d3;
    if (isEmpty((_b3 = (_a2 = form.fields) == null ? void 0 : _a2.byoOption) == null ? void 0 : _b3.value)) {
      return null;
    }
    if (beerOptions().map((option) => option.value).includes((_d3 = (_c3 = form.fields) == null ? void 0 : _c3.byoOption) == null ? void 0 : _d3.value[0])) {
      return "yes";
    }
    return "no";
  };
  const byoLicenseOptions = [
    {
      label: "Yes",
      value: "yes",
      subItems: (onClose) => {
        var _a2, _b3;
        return /* @__PURE__ */ React__default.createElement(
          CheckboxSelection$1,
          {
            key: "yes",
            items: beerOptions(),
            defaultSelectedItems: ((_b3 = (_a2 = form.fields) == null ? void 0 : _a2.byoOption) == null ? void 0 : _b3.value) || [],
            onConfirm: (selectedItems) => {
              if (onClose) {
                onClose();
              }
              form.setFieldValue("byoOption", selectedItems);
            }
          }
        );
      }
    },
    {
      label: "No",
      value: "no",
      subItems: byoLicensedOptions(),
      onSelect: (newValue) => {
        form.setFieldValue("byoOption", newValue);
      }
    }
  ];
  const corkageOptions = [
    {
      label: "Yes",
      value: "yes",
      subItems: (onClose) => /* @__PURE__ */ React__default.createElement(CorkageSubMenu$1, { form, onClose })
    },
    {
      label: "No",
      value: "no"
    },
    {
      label: "Contact us",
      value: "contact_us"
    }
  ];
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 40 }, /* @__PURE__ */ React__default.createElement(Spacer, { style: { justifyContent: "space-between", width: "100%" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "18px", lineHeight: "28px", maxWidth: "360px" } }, "Do you want to display helpful information about your venue to guests?"), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      checked: (_b2 = (_a = form.fields) == null ? void 0 : _a.displayHelpfulInfo) == null ? void 0 : _b2.value,
      onChange: () => {
        var _a2, _b3;
        return form.setFieldValue("displayHelpfulInfo", !((_b3 = (_a2 = form.fields) == null ? void 0 : _a2.displayHelpfulInfo) == null ? void 0 : _b3.value));
      }
    }
  )), ((_d2 = (_c2 = form.fields) == null ? void 0 : _c2.displayHelpfulInfo) == null ? void 0 : _d2.value) && /* @__PURE__ */ React__default.createElement(
    ToggleGroup$1,
    {
      fullWidth: true,
      variant: "bold",
      onChange: (id, newValue) => form.setFieldValue(id, newValue),
      toggles: [
        {
          id: "hasDisabledAccess",
          icon: /* @__PURE__ */ React__default.createElement(WheelchairIconSVG, { width: "16", height: "22" }),
          label: "Disabled access & facilities",
          value: (_f = (_e2 = form.fields) == null ? void 0 : _e2.hasDisabledAccess) == null ? void 0 : _f.value,
          onChange: (newValue) => {
            form.setFieldValues([
              { id: "hasDisabledAccess", value: newValue },
              { id: "disabledOption", value: newValue ? "yes" : "no" }
            ]);
          },
          subSection: /* @__PURE__ */ React__default.createElement(
            Dropdown$1,
            {
              label: "Do you provide wheelchair access, ramps, disabled toilets, parking etc.?",
              value: (_h = (_g = form.fields) == null ? void 0 : _g.disabledOption) == null ? void 0 : _h.value,
              items: yesNoContact(),
              onSelect: (newValue) => form.setFieldValue("disabledOption", newValue),
              style: dropdownStyles
            }
          )
        },
        {
          id: "hasDressCode",
          icon: /* @__PURE__ */ React__default.createElement(DressCodeIconSVG, { width: "22", height: "22" }),
          label: "Dress code",
          value: (_j = (_i = form.fields) == null ? void 0 : _i.hasDressCode) == null ? void 0 : _j.value,
          subSection: /* @__PURE__ */ React__default.createElement(
            Dropdown$1,
            {
              label: "Do you have a dress code?",
              value: (_l = (_k = form.fields) == null ? void 0 : _k.dressCodeOption) == null ? void 0 : _l.value,
              items: dressCode(),
              onSelect: (newValue) => form.setFieldValue("dressCodeOption", newValue),
              style: dropdownStyles
            }
          )
        },
        {
          id: "hasKidsMenu",
          icon: /* @__PURE__ */ React__default.createElement(KidsMenuIconSVG, { width: "21", height: "21" }),
          label: "Child friendly / Kids menu",
          value: (_n = (_m = form.fields) == null ? void 0 : _m.hasKidsMenu) == null ? void 0 : _n.value,
          onChange: (newValue) => {
            form.setFieldValues([
              { id: "hasKidsMenu", value: newValue },
              { id: "kidsMenuOption", value: newValue ? "yes" : "no" }
            ]);
          },
          subSection: /* @__PURE__ */ React__default.createElement(
            Dropdown$1,
            {
              label: "Is your venue suitable for children? Do you provide meals suitable for kids?",
              value: (_p = (_o = form.fields) == null ? void 0 : _o.kidsMenuOption) == null ? void 0 : _p.value,
              items: yesNoContact(),
              onSelect: (newValue) => form.setFieldValue("kidsMenuOption", newValue),
              style: dropdownStyles
            }
          )
        },
        {
          id: "hasPlayArea",
          icon: /* @__PURE__ */ React__default.createElement(PlaygroundIconSVG, { width: "24", height: "26" }),
          label: "Children's play area",
          value: (_r = (_q = form.fields) == null ? void 0 : _q.hasPlayArea) == null ? void 0 : _r.value,
          onChange: (newValue) => {
            form.setFieldValues([
              { id: "hasPlayArea", value: newValue },
              { id: "playAreaOption", value: newValue ? "yes" : "no" }
            ]);
          },
          subSection: /* @__PURE__ */ React__default.createElement(
            Dropdown$1,
            {
              label: "Do you have a children's play area or kids club on site?",
              value: (_t = (_s = form.fields) == null ? void 0 : _s.playAreaOption) == null ? void 0 : _t.value,
              items: yesNoContact(),
              onSelect: (newValue) => form.setFieldValue("playAreaOption", newValue),
              style: dropdownStyles
            }
          )
        },
        {
          id: "hasBYO",
          icon: /* @__PURE__ */ React__default.createElement(BYOIconSVG, { width: "25", height: "10" }),
          label: "BYO",
          value: (_v = (_u = form.fields) == null ? void 0 : _u.hasBYO) == null ? void 0 : _v.value,
          subSection: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
            Dropdown$1,
            {
              label: "Does your venue hold a BYO license? ",
              value: byoLicenseValue(),
              valueOverride: (
                // TODO refactor this
                Array.isArray((_x = (_w = form.fields) == null ? void 0 : _w.byoOption) == null ? void 0 : _x.value) ? (_z = (_y = form.fields) == null ? void 0 : _y.byoOption) == null ? void 0 : _z.value.map((value) => getLabelForValue(value, beerOptions())).sort(sortAlphaNumeric).join(", ") : getLabelForValue(
                  (_B = (_A = form.fields) == null ? void 0 : _A.byoOption) == null ? void 0 : _B.value,
                  byoLicensedOptions(),
                  false
                )
              ),
              items: byoLicenseOptions,
              style: dropdownStyles
            }
          ))
        },
        {
          id: "hasCorkage",
          icon: /* @__PURE__ */ React__default.createElement(CorkageIconSVG, { width: "10", height: "28" }),
          label: "Corkage",
          value: (_D = (_C = form.fields) == null ? void 0 : _C.hasCorkage) == null ? void 0 : _D.value,
          subSection: /* @__PURE__ */ React__default.createElement(
            Dropdown$1,
            {
              label: "Does your venue charge for corkage? ",
              value: (_F = (_E = form.fields) == null ? void 0 : _E.corkageOption) == null ? void 0 : _F.value,
              items: corkageOptions,
              onSelect: (newValue) => form.setFieldValue("corkageOption", newValue),
              style: dropdownStyles
            }
          )
        },
        {
          id: "hasCakes",
          icon: /* @__PURE__ */ React__default.createElement(CakeIconSVG$1, { width: "22", height: "21" }),
          label: "Cakes",
          value: (_H = (_G = form.fields) == null ? void 0 : _G.hasCakes) == null ? void 0 : _H.value,
          onChange: (newValue) => {
            form.setFieldValues([
              { id: "hasCakes", value: newValue },
              { id: "cakesOption", value: newValue ? "yes" : "no" }
            ]);
          },
          subSection: /* @__PURE__ */ React__default.createElement(
            Dropdown$1,
            {
              label: "Can you store cakes?",
              value: (_J = (_I = form.fields) == null ? void 0 : _I.cakesOption) == null ? void 0 : _J.value,
              items: yesNoContact(),
              onSelect: (newValue) => form.setFieldValue("cakesOption", newValue),
              style: dropdownStyles
            }
          )
        }
      ]
    }
  ));
};
Venues.propTypes = {
  form: formPropTypes$1.isRequired
};
const mapStateToProps$2E = () => ({});
const mapDispatchToProps$2D = (dispatch) => bindActionCreators({}, dispatch);
const Venues$1 = connect(mapStateToProps$2E, mapDispatchToProps$2D)(Venues);
const BookingWidget = ({
  obeeSettings: obeeSettings2,
  obeeAreas: obeeAreas2,
  fetchObeeAreas: fetchObeeAreas2,
  fetchObeeSettings: fetchObeeSettings2,
  widgetSettings: widgetSettings2,
  fetchWidgetSettings: fetchWidgetSettings2,
  updateWidgetSettings,
  setFormEditing,
  linkedVenues,
  restaurant
}) => {
  var _a;
  const history = useHistory();
  const query = useQuery();
  const [hasLoadedLinkedRestaurants, setHasLoadedLinkedRestaurants] = useState(
    isEmpty(linkedVenues)
  );
  const [linkedRestaurants, setLinkedRestaurants] = useState([]);
  const [useOldSettings, setUseOldSettings] = useState(false);
  useEffect(() => {
    var _a2;
    if (!isObee()) {
      fetch((_a2 = window.bookingsConfig) == null ? void 0 : _a2.legacyVenuesURL).then((response) => response.text()).then((data) => {
        var _a3, _b2;
        if (!isEmpty((_a3 = obeeSettings2.data) == null ? void 0 : _a3.slug)) {
          const legacyVenues = safeParse(data, []);
          setUseOldSettings(legacyVenues.includes((_b2 = obeeSettings2.data) == null ? void 0 : _b2.slug));
        }
      }).catch(() => {
      });
    }
  }, [(_a = obeeSettings2.data) == null ? void 0 : _a.slug]);
  useEffect(() => {
    const fetchVenues = async () => {
      if (!isObee() || linkedVenues.length > 0 && (restaurant == null ? void 0 : restaurant.objectId)) {
        const response = await fetchLinkedVenues({
          linkedVenues
        });
        if (response.data) {
          setHasLoadedLinkedRestaurants(true);
          setLinkedRestaurants(
            response.data.filter((result) => result && (result == null ? void 0 : result.objectId) !== restaurant.objectId)
          );
        }
      }
    };
    fetchVenues();
  }, [linkedVenues, restaurant.objectId]);
  const formFields = useMemo(() => {
    var _a2, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa;
    const fields = [
      // Appearance
      { id: "showAreaImages", value: (_a2 = widgetSettings2.data) == null ? void 0 : _a2.showAreaImages },
      {
        id: "availabilityBackgroundBoxBgColour",
        value: (_b2 = widgetSettings2.data) == null ? void 0 : _b2.availabilityBackgroundBoxBgColour
      },
      {
        id: "availabilityBackgroundBoxBorderColour",
        value: (_c2 = widgetSettings2.data) == null ? void 0 : _c2.availabilityBackgroundBoxBorderColour
      },
      {
        id: "availabilityBackgroundBoxBorderWeight",
        value: (_d2 = widgetSettings2.data) == null ? void 0 : _d2.availabilityBackgroundBoxBorderWeight
      },
      {
        id: "availabilityFieldsActiveStateColour",
        value: (_e2 = widgetSettings2.data) == null ? void 0 : _e2.availabilityFieldsActiveStateColour
      },
      {
        id: "availabilityFieldsColourOpacity",
        value: (_f = widgetSettings2.data) == null ? void 0 : _f.availabilityFieldsColourOpacity
      },
      { id: "availabilityFontFamilies", value: (_g = widgetSettings2.data) == null ? void 0 : _g.availabilityFontFamilies },
      {
        id: "availabilityMainButtonBgColour",
        value: (_h = widgetSettings2.data) == null ? void 0 : _h.availabilityMainButtonBgColour
      },
      {
        id: "availabilityMainButtonCornerRadius",
        value: (_i = widgetSettings2.data) == null ? void 0 : _i.availabilityMainButtonCornerRadius
      },
      {
        id: "availabilityMainButtonTextColour",
        value: (_j = widgetSettings2.data) == null ? void 0 : _j.availabilityMainButtonTextColour
      },
      { id: "backgroundType", value: (_k = widgetSettings2.data) == null ? void 0 : _k.backgroundType },
      { id: "backgroundValue", value: (_l = widgetSettings2.data) == null ? void 0 : _l.backgroundValue },
      { id: "backgroundImageUrl", value: (_m = widgetSettings2.data) == null ? void 0 : _m.backgroundImageUrl },
      { id: "generalFontFamilies", value: (_n = widgetSettings2.data) == null ? void 0 : _n.generalFontFamilies },
      { id: "navigationBgColour", value: (_o = widgetSettings2.data) == null ? void 0 : _o.navigationBgColour },
      { id: "navigationHeaderText", value: (_p = widgetSettings2.data) == null ? void 0 : _p.navigationHeaderText },
      { id: "navigationLogoAlignment", value: (_q = widgetSettings2.data) == null ? void 0 : _q.navigationLogoAlignment },
      { id: "navigationLogoUrl", value: ((_r = widgetSettings2.data) == null ? void 0 : _r.navigationLogoUrl) || "" },
      {
        id: "navigationNeedHelpButtonBorderColour",
        value: (_s = widgetSettings2.data) == null ? void 0 : _s.navigationNeedHelpButtonBorderColour
      },
      {
        id: "navigationNeedHelpButtonTextColour",
        value: (_t = widgetSettings2.data) == null ? void 0 : _t.navigationNeedHelpButtonTextColour
      },
      // not used
      {
        id: "navigationShowHeaderForEmbed",
        value: (_u = widgetSettings2.data) == null ? void 0 : _u.navigationShowHeaderForEmbed
      },
      { id: "navigationShowHeaderText", value: (_v = widgetSettings2.data) == null ? void 0 : _v.navigationShowHeaderText },
      { id: "navigationShowNeedHelp", value: (_w = widgetSettings2.data) == null ? void 0 : _w.navigationShowNeedHelp },
      { id: "navigationShowUnderline", value: (_x = widgetSettings2.data) == null ? void 0 : _x.navigationShowUnderline },
      { id: "navigationShowVenueName", value: (_y = widgetSettings2.data) == null ? void 0 : _y.navigationShowVenueName },
      { id: "navigationUnderlineColour", value: (_z = widgetSettings2.data) == null ? void 0 : _z.navigationUnderlineColour },
      { id: "navigationUnderlineHeight", value: (_A = widgetSettings2.data) == null ? void 0 : _A.navigationUnderlineHeight },
      {
        id: "navigationVenueNameTextColour",
        value: (_B = widgetSettings2.data) == null ? void 0 : _B.navigationVenueNameTextColour
      },
      { id: "providerLogoAlignment", value: (_C = widgetSettings2.data) == null ? void 0 : _C.providerLogoAlignment },
      { id: "providerLogoStyle", value: (_D = widgetSettings2.data) == null ? void 0 : _D.providerLogoStyle },
      { id: "showProviderLogo", value: (_E = widgetSettings2.data) == null ? void 0 : _E.showProviderLogo },
      {
        id: "navigationBgColourTransparency",
        value: (_F = widgetSettings2.data) == null ? void 0 : _F.navigationBgColourTransparency
      },
      { id: "navigationHeaderTextColour", value: (_G = widgetSettings2.data) == null ? void 0 : _G.navigationHeaderTextColour },
      { id: "dateSelectorType", value: ((_H = widgetSettings2.data) == null ? void 0 : _H.dateSelectorType) || "calendar" },
      { id: "bodyTextColour", value: (_I = widgetSettings2.data) == null ? void 0 : _I.bodyTextColour },
      {
        id: "bodyButtonTextColour",
        value: (_J = widgetSettings2.data) == null ? void 0 : _J.bodyButtonTextColour
      },
      {
        id: "bodyButtonBorderColour",
        value: (_K = widgetSettings2.data) == null ? void 0 : _K.bodyButtonBorderColour
      },
      // Areas
      { id: "showAreaImages", value: ((_L = widgetSettings2.data) == null ? void 0 : _L.showAreaImages) || false },
      // Data collection
      { id: "showChildren", value: ((_M = widgetSettings2.data) == null ? void 0 : _M.showChildren) || false },
      { id: "showHighChairs", value: ((_N = widgetSettings2.data) == null ? void 0 : _N.showHighChairs) || false },
      { id: "showMarketingOptIn", value: ((_O = widgetSettings2.data) == null ? void 0 : _O.showMarketingOptIn) ?? true },
      { id: "marketingOptInMessage", value: ((_P = widgetSettings2.data) == null ? void 0 : _P.marketingOptInMessage) || null },
      // Helpful information
      { id: "displayHelpfulInfo", value: ((_Q = widgetSettings2.data) == null ? void 0 : _Q.displayHelpfulInfo) || false },
      { id: "hasDisabledAccess", value: ((_R = widgetSettings2.data) == null ? void 0 : _R.hasDisabledAccess) || false },
      { id: "hasDressCode", value: ((_S = widgetSettings2.data) == null ? void 0 : _S.hasDressCode) || false },
      { id: "hasKidsMenu", value: ((_T = widgetSettings2.data) == null ? void 0 : _T.hasKidsMenu) || false },
      { id: "hasPlayArea", value: ((_U = widgetSettings2.data) == null ? void 0 : _U.hasPlayArea) || false },
      { id: "hasBYO", value: ((_V = widgetSettings2.data) == null ? void 0 : _V.hasBYO) || false },
      { id: "hasCorkage", value: ((_W = widgetSettings2.data) == null ? void 0 : _W.hasCorkage) || false },
      { id: "hasCakes", value: ((_X = widgetSettings2.data) == null ? void 0 : _X.hasCakes) || false },
      { id: "disabledOption", value: ((_Y = widgetSettings2.data) == null ? void 0 : _Y.disabledOption) || null },
      { id: "dressCodeOption", value: ((_Z = widgetSettings2.data) == null ? void 0 : _Z.dressCodeOption) || null },
      { id: "kidsMenuOption", value: ((__ = widgetSettings2.data) == null ? void 0 : __.kidsMenuOption) || null },
      { id: "playAreaOption", value: ((_$ = widgetSettings2.data) == null ? void 0 : _$.playAreaOption) || null },
      { id: "byoOption", value: ((_aa = widgetSettings2.data) == null ? void 0 : _aa.byoOption) || null },
      { id: "corkageOption", value: ((_ba = widgetSettings2.data) == null ? void 0 : _ba.corkageOption) || null },
      { id: "corkageFee", value: ((_ca = widgetSettings2.data) == null ? void 0 : _ca.corkageFee) || null },
      { id: "corkagePer", value: ((_da = widgetSettings2.data) == null ? void 0 : _da.corkagePer) || null },
      { id: "cakesOption", value: ((_ea = widgetSettings2.data) == null ? void 0 : _ea.cakesOption) || null },
      // Multi venue
      {
        id: "suggestAvailability",
        value: ((_fa = widgetSettings2.data) == null ? void 0 : _fa.suggestAvailability) === true ? "no_availability" : ((_ga = widgetSettings2.data) == null ? void 0 : _ga.suggestAvailability) || "no"
      },
      { id: "linkedVenues", value: ((_ha = widgetSettings2.data) == null ? void 0 : _ha.linkedVenues) || [] },
      { id: "venueDescription", value: ((_ia = widgetSettings2.data) == null ? void 0 : _ia.venueDescription) || "" },
      // Messages
      {
        id: "venueMessage",
        value: ((_ja = widgetSettings2.data) == null ? void 0 : _ja.venueMessage) || null
      },
      // Unavailability
      { id: "showCustomMessages", value: ((_ka = widgetSettings2.data) == null ? void 0 : _ka.showCustomMessages) || false },
      { id: "showVenueClosedMessage", value: ((_la = widgetSettings2.data) == null ? void 0 : _la.showVenueClosedMessage) || false },
      {
        id: "showNoAvailabilityDayMessage",
        value: ((_ma = widgetSettings2.data) == null ? void 0 : _ma.showNoAvailabilityDayMessage) || false
      },
      {
        id: "showNoAvailabilityTimeMessage",
        value: ((_na = widgetSettings2.data) == null ? void 0 : _na.showNoAvailabilityTimeMessage) || false
      },
      {
        id: "showCutoffMessage",
        value: ((_oa = widgetSettings2.data) == null ? void 0 : _oa.showCutoffMessage) || false
      },
      { id: "venueClosedMessage", value: ((_pa = widgetSettings2.data) == null ? void 0 : _pa.venueClosedMessage) || null },
      {
        id: "noAvailabilityDayMessage",
        value: ((_qa = widgetSettings2.data) == null ? void 0 : _qa.noAvailabilityDayMessage) || null
      },
      {
        id: "noAvailabilityTimeMessage",
        value: ((_ra = widgetSettings2.data) == null ? void 0 : _ra.noAvailabilityTimeMessage) || null
      },
      {
        id: "cutoffMessage",
        value: ((_sa = widgetSettings2.data) == null ? void 0 : _sa.cutoffMessage) || false
      },
      {
        id: "showMaxGroupMessage",
        value: ((_ta = widgetSettings2.data) == null ? void 0 : _ta.showMaxGroupMessage) || false
      },
      {
        id: "maxGroupMessage",
        value: ((_ua = widgetSettings2.data) == null ? void 0 : _ua.maxGroupMessage) || null
      },
      {
        id: "showVenueInfoOnCutoff",
        value: ((_va = widgetSettings2.data) == null ? void 0 : _va.showVenueInfoOnCutoff) || false
      },
      {
        id: "cutoffContactType",
        value: ((_wa = widgetSettings2.data) == null ? void 0 : _wa.cutoffContactType) || "email"
      },
      // Dark mode support
      {
        id: "darkTheme",
        value: ((_xa = widgetSettings2.data) == null ? void 0 : _xa.darkTheme) || false
      },
      {
        id: "mainTextColour",
        value: (_ya = widgetSettings2.data) == null ? void 0 : _ya.mainTextColour
      },
      {
        id: "secondaryTextColour",
        // Used for field labels
        value: (_za = widgetSettings2.data) == null ? void 0 : _za.secondaryTextColour
      },
      {
        id: "secondaryTextOpacity",
        // Used for field labels
        value: ((_Aa = widgetSettings2.data) == null ? void 0 : _Aa.secondaryTextOpacity) || 100
      },
      {
        id: "outlineColour",
        value: (_Ba = widgetSettings2.data) == null ? void 0 : _Ba.outlineColour
      },
      {
        id: "outlineOpacity",
        // Button outlines and dividers
        value: ((_Ca = widgetSettings2.data) == null ? void 0 : _Ca.outlineOpacity) || 100
      },
      {
        id: "activeOutlineColour",
        value: (_Da = widgetSettings2.data) == null ? void 0 : _Da.activeOutlineColour
      }
    ];
    const parsedAreas = safeParse((_Ea = widgetSettings2.data) == null ? void 0 : _Ea.areas) || {};
    (_Fa = obeeAreas2.data) == null ? void 0 : _Fa.forEach((area) => {
      var _a3, _b3;
      fields.push({
        id: "imageLink",
        value: (_a3 = parsedAreas == null ? void 0 : parsedAreas[area.id]) == null ? void 0 : _a3.imageLink,
        entityId: area == null ? void 0 : area.id,
        // If provided, nest under the area id
        entityName: "areas"
      });
      fields.push({
        id: "description",
        value: ((_b3 = parsedAreas == null ? void 0 : parsedAreas[area.id]) == null ? void 0 : _b3.description) || "",
        // value: `${index}`,
        entityId: area == null ? void 0 : area.id,
        entityName: "areas"
      });
    });
    return fields;
  }, [widgetSettings2.data, obeeSettings2.data, obeeAreas2.data]);
  const form = useForm(
    formFields,
    updateWidgetSettings,
    (value) => setFormEditing("widgetSettings", value)
  );
  const classes = useStyles$1z({ hasUnsavedChanges: form.hasUnsavedChanges });
  const loading = useFetchOnFirstRender(
    [fetchObeeAreas2, fetchObeeSettings2, fetchWidgetSettings2],
    [obeeAreas2, obeeSettings2, widgetSettings2]
  );
  const queryStep = (query == null ? void 0 : query.get("step")) || "overview";
  const [step, setStep] = useState(queryStep);
  useEffect(() => {
    if (queryStep !== step) {
      setStep(queryStep);
    }
  }, [queryStep]);
  const handleChangeStep = (newStep) => {
    if (newStep === step) {
      return;
    }
    history.push({
      search: `?tab=bookingWidget&step=${newStep}`
    });
    setStep(newStep);
  };
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(Skeleton$1, { height: 600 });
  }
  const steps = [
    { title: "Overview", description: "", id: "overview", hideInList: true },
    { title: "Appearance and brand", description: "", id: "appearance", premiumOnly: true },
    { title: "Areas", description: "", id: "areas" },
    {
      title: "Data collection",
      description: "",
      id: "children"
      // Used to be called children and marketing
    },
    { title: "Helpful Information", description: "", id: "venue" },
    { title: "Multiple venues", description: "", id: "multiVenues", premiumOnly: true },
    {
      title: "Unavailability and messaging",
      description: "",
      id: "messaging",
      premiumOnly: true
    },
    {
      title: "Marketing opt-in",
      description: "",
      id: "marketing"
    }
  ];
  const getStep = () => {
    if (!hasBrandingSettings(restaurant)) {
      const stepData = steps.find((search) => search.id === step);
      if ((stepData == null ? void 0 : stepData.premiumOnly) && !canEditAll()) {
        if (isObee()) {
          return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 20 }, /* @__PURE__ */ React__default.createElement(Box, null, stepData == null ? void 0 : stepData.title, " is available on Branded and Plus plans."), /* @__PURE__ */ React__default.createElement(Spacer, { style: { fontSize: "14px" }, gap: 8 }, /* @__PURE__ */ React__default.createElement(
            SquareButton,
            {
              style: { button: { fontSize: "14px" } },
              href: "https://help.obeeapp.com/article/357-how-to-change-your-plan"
            },
            "Change my plan"
          ), /* @__PURE__ */ React__default.createElement(
            SquareButton,
            {
              style: { button: { fontSize: "14px" } },
              href: "mailto:support@obeeapp.com"
            },
            "Contact Obee Support"
          )));
        }
        return /* @__PURE__ */ React__default.createElement(Box, null, stepData == null ? void 0 : stepData.title, " is a premium only feature. Please contact support for more information on upgrading.");
      }
    }
    switch (step) {
      case "appearance":
        return /* @__PURE__ */ React__default.createElement(Appearance$1, { form });
      case "areas":
        return /* @__PURE__ */ React__default.createElement(Areas$1, { form });
      case "children":
        return /* @__PURE__ */ React__default.createElement(Children$1, { form });
      case "venue":
        return /* @__PURE__ */ React__default.createElement(Venues$1, { form });
      case "multiVenues":
        return /* @__PURE__ */ React__default.createElement(
          MultiVenues$1,
          {
            form,
            linkedRestaurants,
            loading: !hasLoadedLinkedRestaurants
          }
        );
      case "messaging":
        return /* @__PURE__ */ React__default.createElement(Messaging$1, { form });
      case "marketing":
        return /* @__PURE__ */ React__default.createElement(Marketing, { form });
      case "overview":
      default:
        return /* @__PURE__ */ React__default.createElement(Overview$1, { steps, setStep: handleChangeStep });
    }
  };
  if (!canEditAll() && useOldSettings) {
    return /* @__PURE__ */ React__default.createElement(LegacyWidgetSettings$1, null);
  }
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 20, className: classes.container }, step !== "overview" && /* @__PURE__ */ React__default.createElement(StepSelector$1, { setStep: handleChangeStep, steps, activeStep: step }), getStep(), /* @__PURE__ */ React__default.createElement(SaveFooter$1, { form }));
};
BookingWidget.defaultProps = {
  linkedVenues: []
};
BookingWidget.propTypes = {
  obeeSettings: obeeSettingsPropTypes.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  fetchObeeSettings: PropTypes.func.isRequired,
  fetchObeeAreas: PropTypes.func.isRequired,
  fetchWidgetSettings: PropTypes.func.isRequired,
  updateWidgetSettings: PropTypes.func.isRequired,
  setFormEditing: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  widgetSettings: widgetSettingsPropTypes.isRequired,
  linkedVenues: PropTypes.arrayOf(PropTypes.shape({}))
};
const mapStateToProps$2D = (state) => ({
  obeeSettings: state.obeeSettings,
  widgetSettings: state.widgetSettings,
  restaurant: state.restaurantActive.restaurant,
  obeeAreas: state.areas,
  setFormEditing: PropTypes.func.isRequired,
  linkedVenues: state.restaurant.linkedVenues
});
const mapDispatchToProps$2C = (dispatch) => bindActionCreators(
  {
    fetchObeeSettings: fetchSettingsAction,
    fetchWidgetSettings: fetchWidgetSettingsAction,
    updateWidgetSettings: updateWidgetSettingsAction,
    fetchObeeAreas: fetchAreasAction,
    setFormEditing: setFormEditingAction
  },
  dispatch
);
const BookingWidgetSettings = connect(mapStateToProps$2D, mapDispatchToProps$2C)(BookingWidget);
const useStyles$1n = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "36px",
    marginBottom: "100px",
    minHeight: "87px",
    maxWidth: "1200px",
    ...theme2.typography.body.PL
  },
  upsellBanner: {
    backgroundColor: theme2.colors.olive5,
    borderRadius: "8px",
    padding: "17px 14px",
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    alignItems: "center",
    [theme2.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  upsellBannerLeft: {
    display: "flex",
    gap: "16px",
    alignItems: "center"
  },
  upsellBannerRight: {
    display: "flex",
    gap: "20px",
    alignItems: "center"
  },
  upsellBannerLogo: {},
  upsellBannerText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "8px",
    alignItems: "center",
    textAlign: "left"
  },
  upsellBannerTitle: {
    ...theme2.typography.heading.H4,
    lineHeight: "18px",
    fontWeight: theme2.fontWeights.black,
    color: theme2.colors.olive,
    width: "100%"
  },
  upsellBannerDescription: {
    ...theme2.typography.body.P,
    lineHeight: "1.5",
    width: "100%"
  },
  upsellBannerRightText: {
    ...theme2.typography.body.P,
    lineHeight: "1.5",
    marginTop: "2px"
  },
  upsellBannerRightButton: {},
  emailItems: {
    display: "flex",
    flexBasis: "50%",
    flexWrap: "wrap",
    gap: "22px",
    [theme2.breakpoints.down("md")]: {
      flexBasis: "100%"
    }
  },
  emailItemContainer: {
    padding: "20px",
    border: `1px solid ${theme2.colors.yetAnotherGray3}`,
    maxWidth: "calc(50% - 11px)",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme2.colors.yetAnotherGray4,
      border: "1px solid black",
      boxShadow: "0px 4px 4px rgba(176, 176, 176, 0.25)",
      transition: "all 0.05s ease"
    },
    [theme2.breakpoints.down("sm")]: {
      maxWidth: "100%"
    }
  },
  emailItemImage: {},
  emailItemBottom: {},
  emailItemTitle: {
    ...theme2.typography.heading.H3
  },
  emailItemDescription: {
    ...theme2.typography.body.P,
    marginTop: "5px",
    lineHeight: "26px"
  },
  previewImage: {
    width: "100%"
  },
  previewContainer: {
    ...theme2.typography.body.PL,
    display: "flex",
    width: "100%"
  },
  previewLeft: {
    flexBasis: "40%",
    width: "100%"
  },
  backButton: {
    display: "flex",
    alignItems: "center"
  },
  previewRight: {
    flexBasis: "60%",
    width: "100%",
    backgroundColor: theme2.colors.yetAnotherGray4,
    padding: "50px"
  },
  previewInner: {
    maxWidth: "400px",
    // backgroundColor: 'white',
    marginLeft: "auto",
    marginRight: "auto"
  },
  previewLabel: {
    ...theme2.typography.body.PS,
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.yetAnotherGray5,
    backgroundColor: "none",
    textTransform: "uppercase",
    textAlign: "center",
    width: "100%",
    // marginTop: '50px',
    marginBottom: "30px"
  },
  previewContent: {
    zoom: 0.66
    // scale the content to fit
    // -moz-transform: scale(0.5);
  },
  title: {
    ...theme2.typography.heading.H2,
    color: theme2.colors.charcoal,
    marginTop: "10px",
    marginBottom: "20px"
  },
  summary: {
    ...theme2.typography.body.PL,
    lineHeight: 1.5,
    color: theme2.colors.charcoal
  }
}));
const useStyles$1m = createUseStyles((theme2) => ({
  container: {
    width: "600px",
    backgroundColor: theme2.colors.white,
    border: `1px solid ${theme2.colors.grayBorder}`,
    borderRadius: "4px",
    userSelect: "none"
  },
  header: {
    // eslint-disable-next-line no-undef
    backgroundColor: theme2.colors.linen,
    height: "80px"
  },
  content: {
    padding: "64px 56px 40px 56px"
  },
  contentTop: {},
  heading: {
    paddingBottom: "60px",
    fontWeight: "900",
    fontSize: "32px"
  },
  details: { color: theme2.colors.jet },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    border: 0,
    borderSpacing: 0
  },
  tableCell: {
    padding: 0,
    height: "35px"
  },
  summary: {
    paddingTop: "30px",
    paddingBottom: "40px"
  },
  divider: {
    borderTop: "1px solid #DCDCDB"
  },
  terms: {
    color: theme2.colors.charcoal
  },
  paymentPolicy: {
    color: theme2.colors.charcoal
  },
  subHeading: {
    paddingTop: "30px",
    paddingBottom: "20px",
    fontSize: "22px",
    fontWeight: "bold"
  },
  blockText: {
    lineHeight: "1.5",
    fontSize: "16px"
  },
  footer: {
    padding: "64px 56px"
  },
  footerLeft: {},
  footerRight: {
    fontSize: "14px",
    textAlign: "right"
  },
  socialRow: {
    display: "flex"
  }
}));
const ConfirmationEmail = () => {
  const classes = useStyles$1m();
  const terms = "Terms go here";
  const paymentPolicy = "Payment policy here";
  const restaurantName = "TODO";
  const restaurantAddress = "TODO";
  const restaurantSuburb = "TODO";
  const restaurantWebsite = "TODO";
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.contentTop }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Thank you, your table has been reserved"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.details }, /* @__PURE__ */ React__default.createElement("table", { className: classes.table }, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "Venue:"), /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "[Venue name]")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "Name:"), /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "[Customer name]")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "Date:"), /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "DD/MM/YYYY")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "Arrival:"), /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "Time")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "Guests:"), /* @__PURE__ */ React__default.createElement("td", { className: classes.tableCell }, "Party size")))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summary }, "You can ", /* @__PURE__ */ React__default.createElement("span", null, "change"), " or cancel your booking online.")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.divider }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.terms }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Booking policy / terms and conditions"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockText }, terms)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentPolicy, style: { paddingTop: "40px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Payment policy"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockText, style: { fontSize: "18px" } }, paymentPolicy))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.footer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.footerLeft }, "Left"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.footerRight }, /* @__PURE__ */ React__default.createElement(Box, null, restaurantName), /* @__PURE__ */ React__default.createElement(Box, null, restaurantAddress), /* @__PURE__ */ React__default.createElement(Box, null, restaurantSuburb), /* @__PURE__ */ React__default.createElement(Box, null, restaurantWebsite), /* @__PURE__ */ React__default.createElement(Box, { className: classes.socialRow }, /* @__PURE__ */ React__default.createElement(Box, null, "insta"), /* @__PURE__ */ React__default.createElement(Box, null, "face"), /* @__PURE__ */ React__default.createElement(Box, null, "twit")))));
};
ConfirmationEmail.propTypes = {};
const mapStateToProps$2C = () => ({});
const mapDispatchToProps$2B = (dispatch) => bindActionCreators({}, dispatch);
const ConfirmationEmail$1 = connect(mapStateToProps$2C, mapDispatchToProps$2B)(ConfirmationEmail);
const SplitView = ({ left, right }) => {
  const classes = useStyles$1n();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.previewContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.previewLeft }, left), /* @__PURE__ */ React__default.createElement(Box, { className: classes.previewRight }, right));
};
SplitView.propTypes = {
  left: PropTypes.shape({}).isRequired,
  right: PropTypes.shape({}).isRequired
};
const mapStateToProps$2B = () => ({});
const mapDispatchToProps$2A = (dispatch) => bindActionCreators({}, dispatch);
const SplitView$1 = connect(mapStateToProps$2B, mapDispatchToProps$2A)(SplitView);
const SvgPersonalise = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 48 47", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 1.29297, y: 0.5, width: 46, height: 46, rx: 6.5, fill: "#F5F2ED", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 10.543, y: 7.44434, width: 27.5, height: 32.1113, rx: 1.5, fill: "white", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 18.293, y: 12.6055, width: 15, height: 2, rx: 1, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 16.293, cy: 13.6055, r: 1, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 18.293, y: 16.6055, width: 15, height: 2, rx: 1, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 16.293, cy: 17.6055, r: 1, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 18.293, y: 20.6055, width: 15, height: 2, rx: 1, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 16.293, cy: 21.6055, r: 1, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 15.293, y: 35.2178, width: 9.97083, height: 2, rx: 1, transform: "rotate(-90 15.293 35.2178)", fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 19.0625, y: 35.2178, width: 9.97083, height: 2, rx: 1, transform: "rotate(-90 19.0625 35.2178)", fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 23.25, y: 25.71, width: 9.60498, height: 9.0446, rx: 1, fill: "white", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 31.4407, y: 28.6957, width: 17.9224, height: 2.27465, rx: 1.13732, transform: "rotate(-50.3119 31.4407 28.6957)", fill: "white", stroke: "currentColor", strokeWidth: 0.843635 }), /* @__PURE__ */ React$7.createElement("path", { d: "M30.4051 28.1046C30.867 27.5762 31.5451 27.2325 32.4509 27.2626L34.5367 28.8666C34.5099 29.7319 34.2994 30.5555 33.5581 31.14C32.8084 31.7313 31.4283 32.1498 28.8909 31.9821C29.2975 31.6089 29.6591 31.0507 29.6578 30.2554C29.6564 29.4372 29.9213 28.658 30.4051 28.1046Z", fill: "white", stroke: "currentColor", strokeWidth: 0.843635, strokeLinecap: "round" }));
const PersonaliseSVG = SvgPersonalise;
const UpsellBanner = () => {
  const classes = useStyles$1n();
  const buttonStyles2 = {
    button: {
      backgroundColor: "transparent"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBanner }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBannerLeft }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBannerLogo }, /* @__PURE__ */ React__default.createElement(PersonaliseSVG, { style: { width: "48px" } })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBannerText }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBannerTitle }, "Personalise your communication"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBannerDescription }, "Add your logo, personal messages, images & button colours."))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBannerRight }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBannerRightText }, "Only an extra $50 per month"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.upsellBannerRightButton }, /* @__PURE__ */ React__default.createElement(Button, { style: buttonStyles2, type: "secondary" }, "View plan"))));
};
UpsellBanner.propTypes = {};
const mapStateToProps$2A = () => ({});
const mapDispatchToProps$2z = (dispatch) => bindActionCreators({}, dispatch);
const UpsellBanner$1 = connect(mapStateToProps$2A, mapDispatchToProps$2z)(UpsellBanner);
const EmailPreview = ({ email, onBack }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1n();
  const buttonStyles2 = {
    button: {
      color: theme2.colors.olive3,
      fontSize: "16px"
    }
  };
  const title = "Confirmation email";
  const summary = "Provides confirmation for the guest that their table has been reserved for them.";
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(UpsellBanner$1, null), /* @__PURE__ */ React__default.createElement(
    SplitView$1,
    {
      left: /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Button, { type: "text", style: buttonStyles2 }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.backButton }, /* @__PURE__ */ React__default.createElement(Box, null, "Back"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, title), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summary }, summary)),
      right: /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.previewLabel }, "Preview"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.previewInner }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.previewContent }, /* @__PURE__ */ React__default.createElement(ConfirmationEmail$1, null))))
    }
  ));
};
EmailPreview.defaultProps = {
  onBack: () => {
  }
};
EmailPreview.propTypes = {
  onBack: PropTypes.func
};
const mapStateToProps$2z = () => ({});
const mapDispatchToProps$2y = (dispatch) => bindActionCreators({}, dispatch);
const EmailPreview$1 = connect(mapStateToProps$2z, mapDispatchToProps$2y)(EmailPreview);
const headerHeight$2 = 32;
const mobileBuffer = 40;
const desktopBuffer = 16;
const useStyles$1l = createUseStyles(
  (theme2) => ({
    content: (props) => {
      var _a;
      return {
        display: "relative",
        backgroundColor: theme2.colors.white,
        border: "4px solid white",
        borderRadius: "24px",
        minWidth: `${props == null ? void 0 : props.modalWidth}px`,
        width: "fit-content",
        boxShadow: "0px 4px 14px rgba(111, 111, 111, 0.25)",
        minHeight: "450px",
        maxHeight: `calc(100dvh - ${(props == null ? void 0 : props.isMobile) ? mobileBuffer : desktopBuffer}px)`,
        // Extra buffer for mobile browsers
        height: "100%",
        position: "fixed",
        top: "8px",
        right: "4px",
        zIndex: 1100,
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.content
      };
    },
    modalHeader: (props) => {
      var _a;
      return {
        position: "relative",
        width: "100%",
        overflow: "visible",
        backgroundColor: theme2.colors.linen,
        borderRadius: "20px 20px 0 0",
        height: `${(props == null ? void 0 : props.headerHeight) ?? headerHeight$2}px`,
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.modalHeader
      };
    },
    modalBody: {
      height: (props) => `calc(100% - ${(props == null ? void 0 : props.headerHeight) ?? headerHeight$2}px)`,
      // Header offset
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      position: "relative",
      fontSize: "15px",
      // borderRadius: '24px',
      overflowY: theme2.overlay,
      overflowX: "hidden"
    },
    button: {
      position: "absolute",
      top: "-4px",
      right: "-2px",
      zIndex: "100",
      padding: "12px",
      display: "flex",
      "&:hover": {
        color: theme2.colors.charcoal,
        cursor: "pointer"
      }
    },
    hiddenFromPrint: {
      ...theme2.utilities.noPrint
    }
  }),
  { name: "LiveBookingModal" }
);
const LiveBookingModal = ({ isOpen, onClose, children, modalWidth, headerHeight: headerHeight2, style }) => {
  const isMobile = useHasMobile();
  const classes = useStyles$1l({ isMobile, modalWidth, headerHeight: headerHeight2, style });
  const ref = useRef(null);
  useKeyboardListener(
    ref,
    () => {
      if (isOpen) {
        onClose();
      }
    },
    [],
    [document.body]
  );
  return require$$2.createPortal(
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.hiddenFromPrint }, isOpen && /* @__PURE__ */ React__default.createElement(Box, { className: classes.content, ref }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.modalHeader}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button, onClick: onClose }, /* @__PURE__ */ React__default.createElement(CloseSVG, { style: { width: "19px", height: "18px" } }))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, children))),
    document.body
  );
};
LiveBookingModal.defaultProps = {
  onClose: () => {
  },
  modalWidth: 350,
  headerHeight: null
};
LiveBookingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  modalWidth: PropTypes.number,
  headerHeight: PropTypes.number
};
const mapStateToProps$2y = () => ({});
const mapDispatchToProps$2x = (dispatch) => bindActionCreators({}, dispatch);
const LiveBookingModal$1 = connect(mapStateToProps$2y, mapDispatchToProps$2x)(LiveBookingModal);
const SvgLightBulb = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 41 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.293945, width: 40, height: 41.6901, rx: 3.0562, fill: "#E7B78B" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.5404 22.9639C15.7205 25.2354 16.1366 27.1283 16.1366 27.6962C18.2567 28.302 20.9319 28.3272 22.0045 28.264C22.0045 25.614 24.087 23.5318 25.4121 21.8282C26.7371 20.1246 28.63 16.7174 26.7371 13.6888C24.8442 10.6601 19.2243 9.69149 15.1906 11.228C11.2151 12.7424 8.56532 20.1246 12.5404 22.9639Z", fill: "#EAD16A" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17.0102 28.3004C17.0102 27.7325 16.594 25.8396 13.414 23.5681C9.43889 20.7288 11.8115 13.064 15.787 11.5497C19.8207 10.0132 25.7178 11.2643 27.6107 14.2929C29.5035 17.3216 27.6107 20.7288 26.2856 22.4324C24.9606 24.136 22.8781 26.2182 22.8781 28.8682", stroke: "black", strokeWidth: 0.509367 }), /* @__PURE__ */ React$7.createElement("path", { d: "M15.8595 31.708C15.5475 31.9923 15.1481 32.7598 16.0474 33.5558C17.1716 34.5508 24.4603 33.4363 24.8562 32.9873C25.1496 32.6545 25.1422 31.9923 24.3924 31.708", stroke: "black", strokeWidth: 0.509367 }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.2581 28.6797C20.8011 28.6794 23.7035 29.3107 24.5869 29.6261C25.3393 29.8948 25.5286 30.9513 24.2079 31.3297C23.228 31.6106 18.1627 31.8037 17.0153 31.7083C14.739 31.5191 14.7385 28.6798 16.2581 28.6797Z", stroke: "black", strokeWidth: 0.509367 }), /* @__PURE__ */ React$7.createElement("path", { d: "M15.6854 33.7897C15.3069 34.0421 14.8147 34.6983 15.8747 35.304C17.1998 36.0612 22.4996 35.8719 23.8246 35.4933C25.1496 35.1147 25.1496 33.7897 24.7711 33.4111", stroke: "black", strokeWidth: 0.509367 }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.3348 36.251C18.1455 36.6296 18.1076 37.3867 19.4705 37.3867C20.8334 37.3867 21.1742 36.6296 21.1742 36.251", stroke: "black", strokeWidth: 0.509367 }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.903 27.5429C18.6085 25.1355 17.6663 19.948 16.2529 18.457", stroke: "black", strokeWidth: 0.509367 }), /* @__PURE__ */ React$7.createElement("path", { d: "M20.2282 27.5442C20.1651 24.5787 20.3797 18.4583 21.7426 17.7012", stroke: "black", strokeWidth: 0.509367 }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.0635 22.0537C16.379 21.2334 17.1992 19.5929 17.9564 19.5929C18.9028 19.5929 19.66 20.7287 21.9314 20.1608C23.7486 19.7065 24.5815 18.2048 24.7708 17.5107", stroke: "black", strokeWidth: 0.509367 }), /* @__PURE__ */ React$7.createElement("path", { d: "M26.4746 9.3652C27.06 8.75891 27.6286 8.13776 28.2247 7.54166C28.4813 7.28511 28.7836 7.06428 28.8978 6.72168", stroke: "black", strokeWidth: 0.509367, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.2685 11.974C11.4041 11.1096 10.4203 10.4625 9.3313 9.91797", stroke: "black", strokeWidth: 0.509367, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.9185 18.7293C8.96514 18.6189 8.00962 18.531 7.05469 18.4355", stroke: "black", strokeWidth: 0.509367, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M29.8923 17.8479C31.5336 17.8342 33.1718 17.8479 34.8122 17.8479", stroke: "black", strokeWidth: 0.509367, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.3874 25.1914C11.246 25.5875 10.7496 25.9441 10.4655 26.2194C10.0232 26.648 9.57406 27.0627 9.11108 27.4678", stroke: "black", strokeWidth: 0.509367, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M27.6887 23.0615C28.8548 24.2003 30.0302 25.4158 31.3603 26.3659", stroke: "black", strokeWidth: 0.509367, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M19.0244 8.96314C18.6328 7.68163 18.6237 6.3723 18.3635 5.07129", stroke: "black", strokeWidth: 0.509367, strokeLinecap: "round" }));
const IconLightBulb = SvgLightBulb;
const useStyles$1k = createUseStyles((theme2) => ({
  buttonContainer: {
    width: "100%",
    gap: "15px",
    justifyContent: "space-between",
    display: "flex",
    [theme2.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center"
    }
  },
  modalHeader: {
    ...theme2.typography.heading.H2,
    fontSize: "28px",
    fontWeight: "bold",
    color: theme2.colors.charcoal,
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  modalBody: {
    ...theme2.typography.body.bodyText,
    fontSize: theme2.fontSizes.m2,
    lineHeight: "1.6",
    color: theme2.colors.smoke
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  }
}));
const modalStyles$4 = (theme2) => ({
  backgroundColor: "#00000070",
  header: {
    background: theme2.colors.modalHighlight,
    height: "40px",
    padding: "0 24px",
    justifyContent: "flex-end",
    position: "sticky",
    top: 0,
    zIndex: 99,
    display: "flex",
    alignItems: "center"
  },
  footerInner: { padding: "12px 24px" },
  content: { padding: "40px" },
  footer: { padding: 0 }
});
const SvgWarning = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 21, cy: 21, r: 21, fill: "white" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 21, cy: 21, r: 21, fill: "currentColor", fillOpacity: 0.25 }), /* @__PURE__ */ React$7.createElement("path", { d: "M20.5802 31.9202C26.8431 31.9202 31.9202 26.8431 31.9202 20.5802C31.9202 14.3173 26.8431 9.24023 20.5802 9.24023C14.3173 9.24023 9.24023 14.3173 9.24023 20.5802C9.24023 26.8431 14.3173 31.9202 20.5802 31.9202Z", fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M21.6 21.935L21.825 16.625V14.255H19.245V16.625L19.47 21.935H21.6ZM19.11 24.725C19.11 23.915 19.77 23.255 20.55 23.255C21.36 23.255 22.02 23.915 22.02 24.725C22.02 25.52 21.36 26.165 20.55 26.165C19.77 26.165 19.11 25.52 19.11 24.725Z", fill: "white" }));
const IconWarning = SvgWarning;
const SvgWarnDestructive = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 43 43", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 21.2305, cy: 21.5801, r: 21, fill: "#F7E6D9" }), /* @__PURE__ */ React$7.createElement("path", { d: "M21.2306 32.5003C27.4935 32.5003 32.5706 27.4232 32.5706 21.1603C32.5706 14.8974 27.4935 9.82031 21.2306 9.82031C14.9677 9.82031 9.89062 14.8974 9.89062 21.1603C9.89062 27.4232 14.9677 32.5003 21.2306 32.5003Z", fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17.4492 25.0143C18.7087 23.7928 23.222 19.4157 25.3212 17.3799", stroke: "white", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17.4492 17.3799C17.974 17.8888 22.6972 22.4695 25.3212 25.0143", stroke: "white", strokeLinecap: "round" }));
const WarnDestructive = SvgWarnDestructive;
const CommsModal = ({
  isOpen,
  onClose,
  onConfirm,
  heading,
  prompt,
  context,
  confirmLabel,
  inputStyle,
  children
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j;
  const theme2 = useTheme$1();
  const classes = useStyles$1k();
  const isMobile = useHasMobile();
  const modalStyle = modalStyles$4(theme2);
  const getContextIcon = () => {
    switch (context) {
      case "none":
        return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
      case "error": {
        return /* @__PURE__ */ React__default.createElement(
          WarnDestructive,
          {
            color: theme2.colors.errorRed,
            style: { flexShrink: 0, height: "43px" }
          }
        );
      }
      default: {
        return /* @__PURE__ */ React__default.createElement(IconWarning, { color: theme2.colors.warning, style: { flexShrink: 0, height: "40px" } });
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Modal,
    {
      inputStyle: {
        maxWidth: "680px",
        maxHeight: "535px",
        marginTop: "-100px",
        width: "fit-content",
        ...inputStyle
      },
      style: modalStyle,
      inputProps: {
        BackdropProps: { style: { backgroundColor: theme2.colors.smoke, opacity: 0.4 } },
        disableEnforceFocus: true
      },
      isOpen,
      onClose,
      showCloseText: false,
      footer: /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonContainer }, context !== "error" && /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "tertiary",
          onClick: onClose,
          style: {
            ...(_a = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _a.Button,
            container: { width: isMobile && "100%", ...(_c2 = (_b2 = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _b2.Button) == null ? void 0 : _c2.container },
            button: {
              width: isMobile && "100%",
              border: `1px solid ${theme2.colors.shark}`,
              ...(_e2 = (_d2 = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _d2.Button) == null ? void 0 : _e2.button
            }
          }
        },
        "Cancel"
      ), /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "primary",
          onClick: () => {
            onConfirm();
            onClose();
          },
          style: {
            ...(_f = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _f.Button,
            marginLeft: "auto",
            // make sure the confirm CTA sits to the right if there is no cancel
            container: { width: isMobile && "100%", ...(_h = (_g = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _g.Button) == null ? void 0 : _h.container },
            button: { width: isMobile && "100%", ...(_j = (_i = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _i.Button) == null ? void 0 : _j.button }
          }
        },
        confirmLabel
      ))
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalContent }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, getContextIcon(), heading)), /* @__PURE__ */ React__default.createElement(Box, { style: { whiteSpace: "pre-line" } }, prompt, children)))
  );
};
CommsModal.defaultProps = {
  onConfirm: () => {
  },
  context: "warning",
  confirmLabel: "Continue",
  prompt: null,
  children: null,
  heading: null,
  inputStyle: {},
  isOpen: false,
  onClose: () => {
  }
};
CommsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  heading: PropTypes.string,
  prompt: PropTypes.string,
  children: PropTypes.node,
  context: PropTypes.string,
  confirmLabel: PropTypes.string,
  inputStyle: PropTypes.shape({})
};
const CommsModal$1 = CommsModal;
const GeneralWarningModal = ({ isOpen, onClose, prompt, heading, onConfirm, confirmLabel }) => {
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      isOpen,
      onClose,
      onConfirm,
      heading,
      prompt,
      confirmLabel
    }
  );
};
GeneralWarningModal.defaultProps = {
  heading: "",
  onConfirm: () => {
  },
  confirmLabel: "Continue"
};
GeneralWarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  prompt: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  heading: PropTypes.string,
  onConfirm: PropTypes.func
};
const GeneralWarningModal$1 = GeneralWarningModal;
const useStyles$1j = createUseStyles({
  container: {
    display: "inline-block"
  },
  content: {
    // maxWidth: '500px',
    display: "inline-flex",
    flexDirection: "column",
    gap: "16px",
    width: "auto"
  },
  cardsSection: {
    display: "inline-flex",
    flexDirection: "column",
    gap: "16px"
  },
  addNewContainer: {
    fontSize: "15px",
    display: "inline-flex",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  },
  boxContainer: {
    display: "inline-flex",
    gap: "16px",
    alignItems: "flex-start",
    flexWrap: "wrap"
    // display: 'grid',
    // gridTemplateColumns: 'repeat(auto-fill,minmax(160px, 1fr))',
  }
});
const buttonStyles$4 = (theme2) => ({
  color: theme2.colors.olive3
});
const fieldStyles$3 = {
  // label: { maxWidth: '180px' },
  value: { height: "36px", padding: "0 12px" },
  container: {
    fontSize: "inherit",
    height: "unset",
    maxWidth: "100%"
  },
  errorText: { margin: "3px 0 0 150px" },
  item: { fontSize: "15px", padding: "0 16px", height: "36px" },
  popover: { padding: "8px" },
  items: { display: "flex", flexDirection: "column", gap: "4px" }
};
const popoverAnchors$2 = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  }
};
const SvgBin = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.27537 1.61061C5.44338 1.26422 5.79842 1.02539 6.20925 1.02539H7.93788C8.34871 1.02539 8.70376 1.26422 8.87176 1.61061H5.27537ZM4.22227 1.61061C4.42791 0.703008 5.23945 0.0253906 6.20925 0.0253906H7.93788C8.90769 0.0253906 9.71922 0.703008 9.92487 1.61061H13.4747C13.7509 1.61061 13.9747 1.83447 13.9747 2.11061C13.9747 2.38675 13.7509 2.61061 13.4747 2.61061H0.599609C0.323467 2.61061 0.0996094 2.38675 0.0996094 2.11061C0.0996094 1.83447 0.323467 1.61061 0.599609 1.61061H4.22227ZM11.8156 4.53063H2.18137V13.1344C2.18137 14.2389 3.0768 15.1344 4.18137 15.1344H9.81557C10.9201 15.1344 11.8156 14.2389 11.8156 13.1344V4.53063ZM2.18137 3.53063H1.18137V4.53063V13.1344C1.18137 14.7912 2.52451 16.1344 4.18137 16.1344H9.81557C11.4724 16.1344 12.8156 14.7912 12.8156 13.1344V4.53063V3.53063H11.8156H2.18137ZM5.4089 7.79712C5.4089 7.52097 5.18504 7.29712 4.9089 7.29712C4.63275 7.29712 4.4089 7.52097 4.4089 7.79712V11.5052C4.4089 11.7813 4.63275 12.0052 4.9089 12.0052C5.18504 12.0052 5.4089 11.7813 5.4089 11.5052V7.79712ZM7.01021 6.04844C7.28635 6.04844 7.51021 6.27229 7.51021 6.54844L7.51021 12.7547C7.51021 13.0308 7.28635 13.2547 7.01021 13.2547C6.73407 13.2547 6.51021 13.0308 6.51021 12.7547L6.51021 6.54844C6.51021 6.27229 6.73407 6.04844 7.01021 6.04844ZM9.61152 7.79712C9.61152 7.52097 9.38766 7.29712 9.11152 7.29712C8.83538 7.29712 8.61152 7.52097 8.61152 7.79712V11.5052C8.61152 11.7813 8.83538 12.0052 9.11152 12.0052C9.38766 12.0052 9.61152 11.7813 9.61152 11.5052V7.79712Z", fill: "currentColor" }));
const BinSVG = SvgBin;
const useStyles$1i = createUseStyles((theme2) => ({
  container: {
    borderRadius: "8px",
    border: `1px solid ${theme2.colors.shark}`,
    overflow: "hidden",
    width: "288px"
  },
  header: {
    backgroundColor: theme2.colors.linen,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: theme2.fontWeights.medium,
    padding: "0 24px",
    height: "40px"
  },
  content: {
    padding: "16px 24px"
  }
}));
const fieldStyles$2 = {
  label: { maxWidth: "100px" },
  // value: { height: '36px', padding: '0 12px' },
  container: { fontSize: "inherit", height: "unset", maxWidth: "100%" }
  // item: { fontSize: '15px', padding: '0 16px', height: '36px' },
  // items: { display: 'flex', flexDirection: 'column', gap: '4px' },
};
const iconButtonStyles$2 = (theme2) => ({
  color: theme2.colors.smoke,
  position: "absolute",
  top: "0",
  right: "0",
  button: {
    padding: "10px 12px"
  },
  text: {
    height: "20px"
  }
});
const SvgKebab = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 5 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 2.49414, cy: 2.68701, r: 2, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 2.49414, cy: 2.68701, r: 2, fill: "currentColor", fillOpacity: 0.2 }), /* @__PURE__ */ React$7.createElement("circle", { cx: 2.49414, cy: 15.3125, r: 2, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 2.49414, cy: 15.3125, r: 2, fill: "currentColor", fillOpacity: 0.2 }), /* @__PURE__ */ React$7.createElement("circle", { cx: 2.49414, cy: 8.99951, r: 2, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 2.49414, cy: 8.99951, r: 2, fill: "currentColor", fillOpacity: 0.2 }));
const KebabSvg = SvgKebab;
const DurationCard = ({ title, bookingDuration, onOverflow, areasList }) => {
  const classes = useStyles$1i();
  const theme2 = useTheme$1();
  const iconButtonStyle = iconButtonStyles$2(theme2);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, /* @__PURE__ */ React__default.createElement(Box, null, title), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "custom",
      style: iconButtonStyle,
      onClick: (e) => onOverflow(e, bookingDuration)
    },
    /* @__PURE__ */ React__default.createElement(KebabSvg, { style: { height: "14px" } })
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(
    ValueField$1,
    {
      label: "Duration",
      value: getLabelForValue(bookingDuration == null ? void 0 : bookingDuration.duration, bookingDurationAmounts),
      style: fieldStyles$2
    }
  ), /* @__PURE__ */ React__default.createElement(
    ValueField$1,
    {
      label: "Party size",
      value: getFriendlyGroupSizeText(bookingDuration == null ? void 0 : bookingDuration.groupSize),
      style: fieldStyles$2
    }
  ), /* @__PURE__ */ React__default.createElement(
    ValueField$1,
    {
      label: "Areas",
      value: getAreaNameList(areasList, bookingDuration == null ? void 0 : bookingDuration.areaIds),
      style: fieldStyles$2
    }
  )));
};
DurationCard.defaultProps = {
  title: "Duration",
  onOverflow: () => {
  },
  areasList: []
};
DurationCard.propTypes = {
  title: PropTypes.string,
  onOverflow: PropTypes.func,
  areasList: PropTypes.arrayOf(PropTypes.shape({})),
  bookingDuration: bookingDurationPropTypes.isRequired
};
const DurationCard$1 = DurationCard;
const fetchBookingDurationsAction = (data, skipLoading = false) => (dispatch) => {
  const action = "FETCH_BOOKING_DURATIONS";
  const entityName = "obeeBookingDurations";
  const errorMessage = "Unable to retrieve booking durations";
  const request = () => fetchBookingDurations(data);
  dispatch(
    makeApiAction(action, request, {}, entityName, null, {}, skipLoading, errorMessage, true)
  );
};
const createBookingDurationAction = (duration, skipLoading = false) => (dispatch) => {
  const action = "CREATE_BOOKING_DURATION";
  const entityName = "createBookingDuration";
  const successMessage = "Booking duration created successfully";
  const errorMessage = "Unable to create booking duration";
  const state = store$1.getState();
  const isAllAreas = state.areas.data.length === duration.areaIds.length;
  const data = {
    duration: convertDataForApi$1(duration, isAllAreas)
  };
  const request = () => createBookingDuration(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      successMessage,
      {},
      skipLoading,
      errorMessage,
      true
    )
  );
};
const updateBookingDurationAction = (duration, skipLoading = false) => (dispatch) => {
  const action = "UPDATE_BOOKING_DURATION";
  const entityName = "updateBookingDuration";
  const successMessage = "Booking duration updated successfully";
  const errorMessage = "Unable to update booking duration";
  const state = store$1.getState();
  const isAllAreas = state.areas.data.length === duration.areaIds.length;
  const data = {
    bookingDurationId: duration == null ? void 0 : duration.objectId,
    duration: convertDataForApi$1(duration, isAllAreas)
  };
  const request = () => updateBookingDuration(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      successMessage,
      {},
      skipLoading,
      errorMessage,
      true
    )
  );
};
const deleteBookingDurationAction = (id, skipLoading = false) => (dispatch) => {
  const action = "DELETE_BOOKING_DURATION";
  const entityName = "deleteBookingDuration";
  const successMessage = "Booking duration deleted successfully";
  const errorMessage = "Unable to delete booking duration";
  const data = {
    bookingDurationId: id
  };
  const request = () => deleteBookingDuration(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      successMessage,
      { id },
      skipLoading,
      errorMessage,
      true
    )
  );
};
const useStyles$1h = createUseStyles((theme2) => ({
  wrapper: {
    fontSize: "15px"
  },
  container: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    height: "40px"
  },
  label: {
    width: "140px",
    flexShrink: 0,
    color: theme2.colors.smoke
  },
  activeValue: {
    background: theme2.colors.dateSelectBackground
  },
  value: {
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
    height: "40px",
    width: "100%",
    borderRadius: "6px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    userSelect: "none",
    color: theme2.colors.charcoal,
    "&:hover": {
      background: theme2.colors.dateSelectBackground,
      cursor: "pointer"
    }
  },
  valuePlaceholder: {
    color: theme2.colors.nimbus
  },
  inlineFields: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    userSelect: "none"
  },
  popover: {
    width: "100%",
    padding: "12px 10px",
    fontSize: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    justifyContent: "space-between"
  },
  popoverTop: {
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  },
  optionInputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px"
  },
  popoverBottom: {
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  }
}));
const inlineFieldStyles = (theme2) => ({
  // width: '40px',
  // maxWidth: '40px',
  height: "36px",
  fontSize: "15px",
  lineHeight: "normal",
  textField: {
    width: "70px",
    height: "36px"
  },
  input: {
    width: "70px",
    minWidth: "70px",
    lineHeight: "34px",
    padding: "0 12px",
    paddingLeft: "12px",
    height: "36px !important",
    fontSize: "15px",
    backgroundColor: theme2.colors.dateSelectBackground
  },
  inputHover: {
    background: theme2.colors.cloud
  }
});
const confirmButtonStyles = (theme2) => ({
  fontWeight: theme2.fontWeights.medium,
  fontSize: "15px"
});
const GroupSizeSelector = ({ onSave, groupSize, placeholder, areas }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1h();
  const [anchor, setAnchor] = useState(null);
  const [localGroupSizeOption, setLocalGroupSizeOption] = useState((groupSize == null ? void 0 : groupSize.option) || "more");
  const [localGroupSizeMin, setLocalGroupSizeMin] = useState((groupSize == null ? void 0 : groupSize.min) || 8);
  const [localGroupSizeMax, setLocalGroupSizeMax] = useState((groupSize == null ? void 0 : groupSize.max) || 10);
  const [localGroupSizeExact, setLocalGroupSizeExact] = useState((groupSize == null ? void 0 : groupSize.exact) || 10);
  useEffect(() => {
    setLocalGroupSizeOption((groupSize == null ? void 0 : groupSize.option) || "more");
    setLocalGroupSizeMin((groupSize == null ? void 0 : groupSize.min) || 8);
    setLocalGroupSizeMax((groupSize == null ? void 0 : groupSize.max) || 10);
    setLocalGroupSizeExact((groupSize == null ? void 0 : groupSize.exact) || 10);
  }, [anchor, groupSize]);
  const save = () => {
    const min = parseInt(`${localGroupSizeMin}`, 10);
    const max = parseInt(`${localGroupSizeMax}`, 10);
    const exact = parseInt(`${localGroupSizeExact}`, 10);
    const maxCapacity = areas.data.reduce((accum, area) => accum + (area.capacity || 0), 0);
    devLog("info", "venue max capacity", maxCapacity);
    const isValid = () => {
      switch (localGroupSizeOption) {
        case "exactly":
          return exact > 0 && exact <= maxCapacity;
        case "more":
          return min > 0 && min < maxCapacity;
        case "less":
          return max > 0 && max <= maxCapacity;
        case "between":
          return min > 0 && max > min && max <= maxCapacity;
        case "any":
        default:
          return true;
      }
    };
    if (!isValid()) {
      return;
    }
    onSave({
      option: localGroupSizeOption,
      min,
      max,
      exact
    });
    setAnchor(null);
  };
  const groupSizeOptions = [
    { label: "Any size", value: "any" },
    { label: "Exactly", value: "exactly" },
    { label: "More", value: "more" },
    { label: "Less", value: "less" },
    { label: "Between", value: "between" }
  ];
  const label = "Group size";
  const value = getFriendlyGroupSizeText(groupSize);
  const getInputsForOption = () => {
    switch (localGroupSizeOption) {
      case "exactly":
        return /* @__PURE__ */ React__default.createElement(Box, { className: classes.optionInputs }, /* @__PURE__ */ React__default.createElement("span", null, "Exactly "), /* @__PURE__ */ React__default.createElement(
          CleanTextFieldComponent,
          {
            value: localGroupSizeExact,
            onChange: setLocalGroupSizeExact,
            style: inlineFieldStyles(theme2)
          }
        ));
      case "more":
        return /* @__PURE__ */ React__default.createElement(Box, { className: classes.optionInputs }, /* @__PURE__ */ React__default.createElement(
          CleanTextFieldComponent,
          {
            value: localGroupSizeMin,
            onChange: setLocalGroupSizeMin,
            style: inlineFieldStyles(theme2)
          }
        ), /* @__PURE__ */ React__default.createElement("span", null, " or more"));
      case "less":
        return /* @__PURE__ */ React__default.createElement(Box, { className: classes.optionInputs }, /* @__PURE__ */ React__default.createElement(
          CleanTextFieldComponent,
          {
            value: localGroupSizeMax,
            onChange: setLocalGroupSizeMax,
            style: inlineFieldStyles(theme2)
          }
        ), /* @__PURE__ */ React__default.createElement("span", null, " or less"));
      case "between":
        return /* @__PURE__ */ React__default.createElement(Box, { className: classes.optionInputs }, /* @__PURE__ */ React__default.createElement("span", null, "Between "), /* @__PURE__ */ React__default.createElement(
          CleanTextFieldComponent,
          {
            value: localGroupSizeMin,
            onChange: setLocalGroupSizeMin,
            style: inlineFieldStyles(theme2)
          }
        ), /* @__PURE__ */ React__default.createElement("span", null, " and "), /* @__PURE__ */ React__default.createElement(
          CleanTextFieldComponent,
          {
            value: localGroupSizeMax,
            onChange: setLocalGroupSizeMax,
            style: inlineFieldStyles(theme2)
          }
        ));
      case "any":
      default:
        return null;
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.wrapper }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.value} ${anchor ? classes.activeValue : null} ${isEmpty(value) ? classes.valuePlaceholder : null}`,
      onClick: (e) => setAnchor(e.currentTarget)
    },
    !isEmpty(value) ? value : placeholder
  )), /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen: !!anchor,
      anchorEl: anchor,
      innerStyle: {
        borderRadius: "8px",
        marginLeft: "0",
        marginTop: "10px",
        padding: "0",
        width: "100%",
        maxWidth: "fit-content"
      },
      onClose: () => setAnchor(null),
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.popover }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.popoverTop }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        items: groupSizeOptions,
        onSelect: setLocalGroupSizeOption,
        value: localGroupSizeOption,
        showArrow: true,
        style: cleanDropdownPopoverStyles,
        popoverProps: {
          innerProps: {
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "right"
            }
          }
        }
      }
    ), getInputsForOption()), /* @__PURE__ */ React__default.createElement(Box, { className: classes.popoverBottom }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        style: confirmButtonStyles(theme2),
        onClick: () => {
          save();
        }
      },
      "Confirm"
    )))
  ));
};
GroupSizeSelector.defaultProps = {
  placeholder: "Empty"
};
GroupSizeSelector.propTypes = {
  onSave: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  groupSize: PropTypes.shape({
    option: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    exact: PropTypes.number
  }).isRequired,
  areas: areasPropTypes.isRequired
};
const mapStateToProps$2x = (state) => ({
  areas: state.areas
});
const mapDispatchToProps$2w = (dispatch) => bindActionCreators({}, dispatch);
const GroupSizeSelector$1 = connect(mapStateToProps$2x, mapDispatchToProps$2w)(GroupSizeSelector);
const defaultGroupSize$1 = { option: "any", min: 8, max: 10, exact: 10 };
const CreateBookingDurationModal = ({
  isOpen,
  onClose,
  areas,
  createBookingDuration: createBookingDuration2,
  bookingDurations
}) => {
  const [amount, setAmount] = useState(60);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [groupSize, setGroupSize] = useState(defaultGroupSize$1);
  const [amountError, setAmountError] = useState(null);
  const [selectedAreasError, setSelectedAreasError] = useState(null);
  const [groupSizeError, setGroupSizeError] = useState(null);
  const [pending, setPending2] = useState(false);
  useEffect(() => {
    if (isOpen && pending && bookingDurations.success) {
      setPending2(false);
      onClose();
    }
  }, [pending, bookingDurations.success, onClose]);
  const areasList = useMemo(
    () => areas.data.map((area) => ({
      label: area == null ? void 0 : area.name,
      value: `${area == null ? void 0 : area.id}`
    })),
    [areas.data]
  );
  useEffect(() => {
    if (isOpen) {
      setAmount(60);
      setSelectedAreas([]);
      setGroupSize(defaultGroupSize$1);
      setPending2(false);
      setAmountError(null);
      setSelectedAreasError(null);
      setGroupSizeError(null);
    }
  }, [isOpen]);
  const validate = () => {
    let isValid = true;
    if (isEmpty(amount)) {
      setAmountError("This field is required");
      isValid = false;
    }
    if (isEmpty(selectedAreas)) {
      setSelectedAreasError("This field is required");
      isValid = false;
    }
    if (isEmpty(groupSize)) {
      setGroupSizeError("This field is required");
      isValid = false;
    }
    return isValid;
  };
  const handleSubmit = () => {
    const isValid = validate();
    if (isValid) {
      setPending2(true);
      createBookingDuration2({
        areaIds: selectedAreas,
        duration: amount,
        groupSize
      });
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    PromptModal$1,
    {
      onClose,
      isOpen,
      heading: "Create booking duration",
      confirmLabel: "Create duration",
      onConfirm: handleSubmit,
      loadingConfirm: (bookingDurations == null ? void 0 : bookingDurations.pending) || pending
    },
    /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "15px" } }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Duration",
        items: bookingDurationAmounts,
        value: amount,
        onSelect: setAmount,
        style: fieldStyles$3,
        error: amountError,
        clearError: () => setAmountError(null)
      }
    ), /* @__PURE__ */ React__default.createElement(
      GroupSizeSelector$1,
      {
        onSave: setGroupSize,
        groupSize,
        error: groupSizeError,
        clearError: () => setGroupSizeError(null),
        label: "Party size"
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Areas",
        items: areasList,
        value: selectedAreas,
        onSelect: (areaId) => {
          setSelectedAreas(toggleListItem(selectedAreas, areaId));
        },
        multiselectFormat: (areasSelected) => {
          return getAreaNameList(areasList, areasSelected);
        },
        placeholder: "Empty",
        error: selectedAreasError,
        clearError: () => setSelectedAreasError(null),
        style: fieldStyles$3,
        selectedItems: selectedAreas,
        multiselect: true,
        ...popoverAnchors$2
      }
    )))
  );
};
CreateBookingDurationModal.propTypes = {
  obeeSettings: obeeSettingsPropTypes.isRequired,
  areas: areasPropTypes.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  createBookingDuration: PropTypes.func.isRequired,
  bookingDurations: bookingDurationsPropTypes.isRequired
};
const mapStateToProps$2w = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  obeeSettings: state.obeeSettings,
  areas: state.areas,
  bookingDurations: state.bookingDurations
});
const mapDispatchToProps$2v = (dispatch) => bindActionCreators(
  {
    createBookingDuration: createBookingDurationAction
  },
  dispatch
);
const CreateBookingDurationModal$1 = connect(mapStateToProps$2w, mapDispatchToProps$2v)(CreateBookingDurationModal);
const defaultGroupSize = { option: "any", min: 8, max: 10, exact: 10 };
const EditBookingDurationModal = ({
  bookingDuration,
  isOpen,
  onClose,
  updateBookingDuration: updateBookingDuration2,
  bookingDurations,
  areas
}) => {
  const [amount, setAmount] = useState(null);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [groupSize, setGroupSize] = useState(defaultGroupSize);
  const [amountError, setAmountError] = useState(null);
  const [selectedAreasError, setSelectedAreasError] = useState(null);
  const [groupSizeError, setGroupSizeError] = useState(null);
  const [pending, setPending2] = useState(false);
  useEffect(() => {
    if (isOpen && pending && bookingDurations.success) {
      setPending2(false);
      onClose();
    }
  }, [pending, bookingDurations.success, onClose]);
  const areasList = useMemo(
    () => areas.data.map((area) => ({
      label: area == null ? void 0 : area.name,
      value: `${area == null ? void 0 : area.id}`
    })),
    [areas.data]
  );
  useEffect(() => {
    if (isOpen) {
      setAmount((bookingDuration == null ? void 0 : bookingDuration.duration) || null);
      setSelectedAreas((bookingDuration == null ? void 0 : bookingDuration.areaIds) || areas.data.map((area) => `${area.id}`));
      setGroupSize((bookingDuration == null ? void 0 : bookingDuration.groupSize) || defaultGroupSize);
      setAmountError(null);
      setSelectedAreasError(null);
      setGroupSizeError(null);
    }
  }, [isOpen]);
  const validate = () => {
    let isValid = true;
    if (isEmpty(amount)) {
      setAmountError("This field is required");
      isValid = false;
    }
    if (isEmpty(selectedAreas)) {
      setSelectedAreasError("This field is required");
      isValid = false;
    }
    if (isEmpty(groupSize)) {
      setGroupSizeError("This field is required");
      isValid = false;
    }
    return isValid;
  };
  const handleSubmit = () => {
    const isValid = validate();
    if (isValid) {
      setPending2(true);
      updateBookingDuration2({
        ...bookingDuration,
        duration: amount,
        areaIds: selectedAreas,
        groupSize
      });
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    PromptModal$1,
    {
      onClose,
      isOpen,
      heading: "Edit booking duration",
      confirmLabel: "Save changes",
      onConfirm: handleSubmit,
      loadingConfirm: (bookingDurations == null ? void 0 : bookingDurations.pending) || pending
    },
    /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "15px" } }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Duration",
        items: bookingDurationAmounts,
        value: amount,
        onSelect: setAmount,
        style: fieldStyles$3,
        error: amountError,
        clearError: () => setAmountError(null)
      }
    ), /* @__PURE__ */ React__default.createElement(
      GroupSizeSelector$1,
      {
        onSave: setGroupSize,
        groupSize,
        error: groupSizeError,
        clearError: () => setGroupSizeError(null),
        label: "Party size"
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Areas",
        items: areasList,
        value: selectedAreas,
        onSelect: (areaId) => {
          setSelectedAreas(toggleListItem(selectedAreas, areaId));
        },
        multiselectFormat: (areasSelected) => {
          return getAreaNameList(areasList, areasSelected);
        },
        placeholder: "Empty",
        error: selectedAreasError,
        clearError: () => setSelectedAreasError(null),
        style: fieldStyles$3,
        selectedItems: selectedAreas,
        multiselect: true,
        ...popoverAnchors$2
      }
    ))
  );
};
EditBookingDurationModal.defaultProps = {
  bookingDuration: null
};
EditBookingDurationModal.propTypes = {
  obeeSettings: obeeSettingsPropTypes.isRequired,
  areas: areasPropTypes.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  updateBookingDuration: PropTypes.func.isRequired,
  bookingDuration: bookingDurationPropTypes,
  bookingDurations: bookingDurationsPropTypes.isRequired
};
const mapStateToProps$2v = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  obeeSettings: state.obeeSettings,
  areas: state.areas,
  bookingDurations: state.bookingDurations
});
const mapDispatchToProps$2u = (dispatch) => bindActionCreators(
  {
    updateBookingDuration: updateBookingDurationAction
  },
  dispatch
);
const EditBookingDurationModal$1 = connect(mapStateToProps$2v, mapDispatchToProps$2u)(EditBookingDurationModal);
const BookingDurations = ({
  obeeSettings: obeeSettings2,
  changeSetting,
  deleteBookingDuration: deleteBookingDuration2,
  bookingDurations,
  areas,
  fetchAreas,
  fetchBookingDurations: fetchBookingDurations2
}) => {
  var _a, _b2;
  const classes = useStyles$1j();
  const theme2 = useTheme$1();
  const loading = useFetchOnFirstRender(
    [fetchAreas, fetchBookingDurations2],
    [areas, bookingDurations]
  );
  const buttonStyle = buttonStyles$4(theme2);
  const [bookingDurationToOverflow, setBookingDurationToOverflow] = useState(null);
  const [overflowAnchor, setOverflowAnchor] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const areasList = useMemo(
    () => areas.data.map((area) => ({
      label: area == null ? void 0 : area.name,
      value: `${area == null ? void 0 : area.id}`
      // Must be a string
    })),
    [areas.data]
  );
  const addNew = () => {
    setShowAddModal(true);
  };
  const handleDeleteDuration = (id) => {
    deleteBookingDuration2(id);
  };
  const popoverItems = useMemo(
    () => [
      {
        label: /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "12px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(EditSVG, { height: 18 }), /* @__PURE__ */ React__default.createElement(Box, null, "Edit")),
        key: "edit",
        onClick: () => {
          setShowEditModal(true);
        }
      },
      {
        label: /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "12px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(BinSVG, { height: 18 }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete")),
        key: "delete",
        onClick: () => {
          handleDeleteDuration(bookingDurationToOverflow == null ? void 0 : bookingDurationToOverflow.objectId);
        }
      }
    ],
    [bookingDurationToOverflow == null ? void 0 : bookingDurationToOverflow.objectId]
  );
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(Skeleton$1, { height: 60, style: { maxWidth: "500px" } });
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: "Default",
      items: bookingDurationAmounts,
      value: (_a = obeeSettings2.data) == null ? void 0 : _a.bookingsDuration,
      onSelect: (value) => changeSetting("bookingsDuration", value),
      style: cleanDropdownPopoverStyles
    }
  )), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.shark, style: { width: "auto", display: "block" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.addNewContainer }, /* @__PURE__ */ React__default.createElement(Box, null, "Add custom durations based on area and group size"), /* @__PURE__ */ React__default.createElement(Button, { type: "text", style: buttonStyle, onClick: addNew }, "Add new")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.boxContainer }, (_b2 = bookingDurations == null ? void 0 : bookingDurations.data) == null ? void 0 : _b2.map((bookingDuration, index) => /* @__PURE__ */ React__default.createElement(Box, { key: bookingDuration == null ? void 0 : bookingDuration.objectId }, /* @__PURE__ */ React__default.createElement(
    DurationCard$1,
    {
      title: `Duration ${index + 1}`,
      bookingDuration,
      onOverflow: (e, duration) => {
        setBookingDurationToOverflow(duration);
        setOverflowAnchor(e.currentTarget);
      },
      areasList
    }
  ))))), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: popoverItems,
      anchor: overflowAnchor,
      isOpen: !!overflowAnchor,
      onClose: () => {
        setOverflowAnchor(null);
      },
      popoverProps: {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      },
      style: {
        ...listPopoverStyles$1,
        popover: { ...listPopoverStyles$1.popover, minWidth: "150px" },
        container: { maxWidth: "500px" }
      }
    }
  ), /* @__PURE__ */ React__default.createElement(CreateBookingDurationModal$1, { onClose: () => setShowAddModal(false), isOpen: showAddModal }), /* @__PURE__ */ React__default.createElement(
    EditBookingDurationModal$1,
    {
      onClose: () => setShowEditModal(false),
      isOpen: showEditModal,
      bookingDuration: bookingDurationToOverflow
    }
  ));
};
BookingDurations.propTypes = {
  obeeSettings: obeeSettingsPropTypes.isRequired,
  changeSetting: PropTypes.func.isRequired,
  bookingDurations: bookingDurationsPropTypes.isRequired,
  deleteBookingDuration: PropTypes.func.isRequired,
  areas: areasPropTypes.isRequired,
  fetchBookingDurations: PropTypes.func.isRequired,
  fetchAreas: PropTypes.func.isRequired
};
const mapStateToProps$2u = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  obeeSettings: state.obeeSettings,
  bookingDurations: state.bookingDurations,
  areas: state.areas
});
const mapDispatchToProps$2t = (dispatch) => bindActionCreators(
  {
    deleteBookingDuration: deleteBookingDurationAction,
    fetchAreas: fetchAreasAction,
    fetchBookingDurations: fetchBookingDurationsAction
  },
  dispatch
);
const BookingDurations$1 = connect(mapStateToProps$2u, mapDispatchToProps$2t)(BookingDurations);
const GeneralSettings = ({ obeeSettings: obeeSettings2, updateObeeSettings: updateObeeSettings2 }) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g;
  const theme2 = useTheme$1();
  const [openCutOffModal, setOpenCutoffModal] = useState(false);
  const [openWaitlistWarning, setOpenWaitlistWarning] = useState(false);
  const classes = useStyles$1w();
  const times = numberRange(0, 1440, 30, true);
  const changeSetting = (label, newValue) => {
    const changedSetting = {};
    changedSetting[label] = newValue;
    updateObeeSettings2(changedSetting);
  };
  const changeSettings = (newValues) => {
    updateObeeSettings2(newValues);
  };
  const getCutoffLabel = (heading, description2) => /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, heading), /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, description2));
  const items = [
    { label: "30 mins", value: "0.50" },
    { label: "1 hour", value: "1.00" },
    { label: "2 hours", value: "2.00" },
    { label: "3 hours", value: "3.00" },
    { label: "4 hours", value: "4.00" },
    { label: "5 hours", value: "5.00" }
  ];
  const inlineDropdownStyles = {
    ...cleanDropdownPopoverStyles,
    container: {
      ...cleanDropdownPopoverStyles == null ? void 0 : cleanDropdownPopoverStyles.container,
      width: "auto",
      color: theme2.colors.charcoal
    }
  };
  const getCutoffModeDefaults = (cutoffMode) => {
    if (cutoffMode === "off") {
      return { cutoffMode, cutoffValue: obeeSettings2.data.cutoffValue };
    }
    if (cutoffMode === "set_time") {
      return {
        cutoffMode,
        ...obeeSettings2.data.cutoffMode !== "set_time" ? { cutoffValue: "11:00:00" } : { cutoffValue: obeeSettings2.data.cutoffValue }
      };
    }
    if (cutoffMode === "hours_before" || cutoffMode === "rolling") {
      return {
        cutoffMode,
        ...!["hours_before", "rolling"].includes(obeeSettings2.data.cutoffMode) ? { cutoffValue: "1.00" } : { cutoffValue: obeeSettings2.data.cutoffValue }
      };
    }
    return {};
  };
  const getCutoffDropdown = () => {
    if (obeeSettings2.data.cutoffMode === "set_time") {
      return /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffDropdownContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffInformation }, "For same day reservations, prevent guests from booking online from"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffDropdownItem }, /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          style: inlineDropdownStyles,
          value: obeeSettings2.data.cutoffValue,
          onSelect: (value) => updateObeeSettings2({ cutoffMode: obeeSettings2.data.cutoffMode, cutoffValue: value }),
          placeholder: "select time",
          items: times.map((time) => {
            const moment2 = momentFromInt(time);
            return {
              label: moment2.format("h:mm a"),
              value: moment2.format("kk:mm:ss")
            };
          })
        }
      ), /* @__PURE__ */ React__default.createElement(Box, null, "onwards")));
    }
    if (["hours_before", "rolling"].includes(obeeSettings2.data.cutoffMode)) {
      return /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffDropdownContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffInformation }, obeeSettings2.data.cutoffMode === "hours_before" ? "Prevent guests from booking online for a session that starts in" : "Prevent guests from booking online for a booking that starts in"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffDropdownItem }, /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          style: inlineDropdownStyles,
          value: obeeSettings2.data.cutoffValue,
          onSelect: (value) => updateObeeSettings2({ cutoffMode: obeeSettings2.data.cutoffMode, cutoffValue: value }),
          placeholder: "select time",
          items
        }
      ), /* @__PURE__ */ React__default.createElement(Box, null, "or less")));
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsPage }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingGroup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, "Set days to book in advance"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: "Days",
      items: [
        { label: "60", value: 60 },
        { label: "90", value: 90 }
      ],
      value: obeeSettings2.data.daysInAdvance,
      onSelect: (value) => changeSetting("daysInAdvance", value),
      style: cleanDropdownPopoverStyles
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingGroup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, "Waiting list"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: "Status",
      items: [
        { label: "On", value: true },
        { label: "Off", value: false }
      ],
      value: obeeSettings2.data.waitlist,
      disabled: isObee(),
      onSelect: (value) => {
        if (value === false) {
          setOpenWaitlistWarning(true);
        } else {
          changeSetting("waitlist", value);
        }
      },
      style: cleanDropdownPopoverStyles
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingGroup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, "System time intervals"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: "Minutes",
      items: [
        { label: "15 minutes", value: 15 },
        { label: "30 minutes", value: 30 }
      ],
      value: (_a = obeeSettings2.data) == null ? void 0 : _a.systemTimeInterval,
      onSelect: (value) => changeSetting("systemTimeInterval", value),
      style: cleanDropdownPopoverStyles,
      disabled: true
    }
  ))), !isObee() && /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingGroup, style: { paddingBottom: "20px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, "Booking duration"), /* @__PURE__ */ React__default.createElement(BookingDurations$1, { changeSetting })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingGroup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.inlineSubHeading }, /* @__PURE__ */ React__default.createElement(Box, null, "Online cut-off"), /* @__PURE__ */ React__default.createElement(Box, { onClick: () => setOpenCutoffModal(!openCutOffModal), className: classes.infoButton }, "?")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheadingInfo }, "Set a cut-off time which prevents guests making an online booking."), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      style: cleanDropdownPopoverStyles,
      label: "Status",
      valueFormat: (value) => {
        if (["set_time", "hours_before", "rolling"].includes(value)) {
          return "On";
        }
        return "Off";
      },
      value: obeeSettings2.data.cutoffMode,
      onSelect: (value) => updateObeeSettings2(getCutoffModeDefaults(value)),
      items: [
        { label: "On", value: "set_time" },
        { label: "Off", value: "off" }
      ]
    }
  )), ["set_time", "hours_before", "rolling"].includes(obeeSettings2.data.cutoffMode) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      style: {
        ...cleanDropdownPopoverStyles,
        item: {
          ...cleanDropdownPopoverStyles.item,
          height: "unset",
          padding: "8px 16px",
          maxWidth: "350px"
        }
      },
      label: "Type",
      valueFormat: getCutoffModeLabel,
      value: obeeSettings2.data.cutoffMode,
      onSelect: (value) => updateObeeSettings2(getCutoffModeDefaults(value)),
      items: [
        {
          label: getCutoffLabel(
            "Fixed",
            "Prevent guests from booking online from a specific time for the same day"
          ),
          value: "set_time"
        },
        {
          label: getCutoffLabel(
            "Sessional",
            "Prevent guests from booking a session that starts in specific hours"
          ),
          value: "hours_before"
        },
        {
          label: getCutoffLabel(
            "Rolling",
            "Prevent guests from making a booking that starts in specific hours"
          ),
          value: "rolling"
        }
      ]
    }
  )), getCutoffDropdown()), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingGroup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, "Email and SMS confirmation"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheadingInfo }, "When creating a booking, show options to send confirmation messages"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      style: { ...cleanDropdownPopoverStyles, label: { width: "240px" } },
      label: "Show confirmation email option",
      value: (_b2 = obeeSettings2.data) == null ? void 0 : _b2.showEmailConfirmation,
      onSelect: (value) => (
        // Obee API is weird and needs to update both the confirmation and the default at the same time even if only one changed
        changeSettings({
          showEmailConfirmation: value,
          showEmailConfirmationDefaultChecked: obeeSettings2.data.showEmailConfirmationDefaultChecked
        })
      ),
      items: [
        { label: "Yes", value: true },
        { label: "No", value: false }
      ]
    }
  ), ((_c2 = obeeSettings2.data) == null ? void 0 : _c2.showEmailConfirmation) && /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      style: { ...cleanDropdownPopoverStyles, label: { width: "240px" } },
      label: "Confirmation email default value",
      value: (_d2 = obeeSettings2.data) == null ? void 0 : _d2.showEmailConfirmationDefaultChecked,
      onSelect: (value) => changeSettings({
        showEmailConfirmation: obeeSettings2.data.showEmailConfirmation,
        showEmailConfirmationDefaultChecked: value
      }),
      items: [
        { label: "Selected", value: true },
        { label: "Not selected", value: false }
      ]
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      style: { ...cleanDropdownPopoverStyles, label: { width: "240px" } },
      label: "Show confirmation SMS option",
      value: (_e2 = obeeSettings2.data) == null ? void 0 : _e2.showSMSConfirmation,
      onSelect: (value) => changeSettings({
        showSMSConfirmation: value,
        showSMSConfirmationDefaultChecked: obeeSettings2.data.showSMSConfirmationDefaultChecked
      }),
      items: [
        { label: "Yes", value: true },
        { label: "No", value: false }
      ]
    }
  ), ((_f = obeeSettings2.data) == null ? void 0 : _f.showSMSConfirmation) && /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      style: { ...cleanDropdownPopoverStyles, label: { width: "240px" } },
      label: "Confirmation SMS default value",
      value: (_g = obeeSettings2.data) == null ? void 0 : _g.showSMSConfirmationDefaultChecked,
      onSelect: (value) => changeSettings({
        showSMSConfirmation: obeeSettings2.data.showSMSConfirmation,
        showSMSConfirmationDefaultChecked: value
      }),
      items: [
        { label: "Selected", value: true },
        { label: "Not selected", value: false }
      ]
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingGroup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, "Taken by"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheadingInfo }, "Staff can initial any changes or edits they make to bookings."), /* @__PURE__ */ React__default.createElement(Box, { className: classes.settings }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      style: cleanDropdownPopoverStyles,
      label: "Status",
      value: obeeSettings2.data.abTakenBy,
      onSelect: (value) => changeSetting("abTakenBy", value),
      items: [
        { label: "Mandatory", value: "mandatory" },
        { label: "Optional", value: "optional" },
        { label: "Off", value: "off" }
      ],
      disabled: isObee()
    }
  ))), /* @__PURE__ */ React__default.createElement(
    LiveBookingModal$1,
    {
      isOpen: openCutOffModal,
      onClose: () => setOpenCutoffModal(false),
      modalWidth: 435
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffModalContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffModalHeader }, /* @__PURE__ */ React__default.createElement(IconLightBulb, { style: { height: "42px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Online cut-off")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffModalItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, "What is online cut-off"), /* @__PURE__ */ React__default.createElement(Box, { style: { whiteSpace: "pre-line" } }, `The online cut-off is designed to stop inconvenient changes to your table allocations, by preventing guests from making, editing and cancelling bookings online at short notice.
              
              If a guest attempts to make, edit or cancel a reservation, and a cut-off applies, a message explaining the cut-off will be displayed. For guests trying to make a bookings, the message will also mention that tables may still be available and will list your venue’s phone number to call for further information.
              
              If no online cut-off is set, guests will be able to make a booking any time, and edit or cancel their existing booking right up until the time it begins.`)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.cutoffModalItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading }, "There are three types of online cut-offs:"), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement("ul", { className: classes.cutoffListContainer }, /* @__PURE__ */ React__default.createElement("li", { className: classes.cutoffListItem }, /* @__PURE__ */ React__default.createElement("b", null, "The fixed cut-off time"), " prevents guests from booking online from a specified time"), /* @__PURE__ */ React__default.createElement("li", { className: classes.cutoffListItem }, /* @__PURE__ */ React__default.createElement("b", null, "The sessional cut-off time"), " prevents guests from booking online for a session that begins in a specified amount of hours"), /* @__PURE__ */ React__default.createElement("li", { className: classes.cutoffListItem }, /* @__PURE__ */ React__default.createElement("b", null, "The rolling cut-off time"), " prevents guests from booking online for a reservation that begins in a specified amount of hours")))))
  ), /* @__PURE__ */ React__default.createElement(
    GeneralWarningModal$1,
    {
      isOpen: openWaitlistWarning,
      onClose: () => setOpenWaitlistWarning(false),
      prompt: `This will remove existing waitlist bookings for future dates.
        Are you sure you want to continue?`,
      heading: "Turn off the waitlist?",
      onConfirm: () => changeSetting("waitlist", false)
    }
  ));
};
GeneralSettings.propTypes = {
  updateObeeSettings: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired
  // restaurant
  // user
};
const mapStateToProps$2t = (state) => ({
  obeeSettings: state.obeeSettings,
  restaurant: state.restaurantActive.restaurant,
  user: state.user
});
const mapDispatchToProps$2s = (dispatch) => bindActionCreators(
  {
    updateObeeSettings: updateSettingsAction
  },
  dispatch
);
const GeneralSettings$1 = connect(mapStateToProps$2t, mapDispatchToProps$2s)(GeneralSettings);
const enableReserveWithGoogleAction = (merchantTerms = "") => (dispatch) => {
  const action = "ENABLE_RESERVE_WITH_GOOGLE";
  const data = {
    merchantTerms: merchantTerms == null ? void 0 : merchantTerms.trim()
  };
  const request = () => enableReserveWithGoogle(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      "enableReserveWithGoogle",
      null,
      null,
      false,
      "Failed to enable Reserve with Google. Please try again. If this issue persists please contact your partner ops manager."
    )
  );
};
const disableReserveWithGoogleAction = () => (dispatch) => {
  const action = "DISABLE_RESERVE_WITH_GOOGLE";
  const data = {};
  const request = () => disableReserveWithGoogle(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      "disableReserveWithGoogle",
      "Reserve with Google has been disabled. Keep in mind this can take up to 24 hours to take effect.",
      null,
      false,
      "Failed to disable Reserve with Google. Please try again. If this issue persists please contact your partner ops manager."
    )
  );
};
const fetchIntegrationsAction = (skipLoading = false) => (dispatch) => {
  const action = "FETCH_OBEE_INTEGRATIONS";
  const entityName = "obeeIntegrations";
  const request = () => fetchIntegrations();
  dispatch(makeApiAction(action, request, {}, entityName, null, {}, skipLoading));
};
const reserveWithGoogleApiPropTypes = PropTypes.shape({
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const useStyles$1g = createUseStyles((theme2) => ({
  buttonContainer: {
    width: "100%",
    gap: "15px",
    justifyContent: "space-between",
    display: "flex",
    marginTop: "15px",
    [theme2.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center"
    }
  },
  modalHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  heading: {
    ...theme2.typography.h2
  },
  subHeading: {
    fontSize: theme2.fontSizes.l
  },
  sectionHeading: {
    fontWeight: theme2.fontWeights.bold
  },
  sectionHeadingLarge: {
    fontWeight: theme2.fontWeights.bold,
    fontSize: theme2.fontSizes.l
  },
  modalBody: {
    ...theme2.typography.paragraph,
    color: theme2.colors.charcoal,
    "& ol": {
      margin: 0
    }
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    marginBottom: "20px",
    paddingRight: "10px",
    marginRight: "-10px",
    // overflow: theme.overlay,
    overflowY: "auto",
    maxHeight: "min(600px, 100dvh - 320px)"
    // Looks good on small height
  },
  sectionBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  error: {
    color: theme2.colors.errorRed,
    fontSize: "12px"
  },
  smallHeading: {
    ...theme2.typography.heading.H2
  },
  largeHeading: {},
  spaceBetween: {
    display: "flex",
    gap: "12px",
    justifyContent: "space-between",
    alignItems: "baseline"
  }
}));
const modalStyles$3 = (theme2, isMobile) => ({
  container: { padding: "20px" },
  modal: { minWidth: isMobile ? "100px" : "650px", maxWidth: "650px" },
  content: { padding: isMobile ? "35px 20px 15px 20px" : "35px 35px 15px" },
  header: { padding: "20px", background: theme2.colors.linen }
});
const checkboxStyles = (theme2) => ({
  checkbox: { alignItems: "start" },
  checkboxBox: { marginTop: "2px" },
  container: { color: theme2.colors.black }
});
const accordionStyles = (theme2) => ({
  itemSummary: {
    borderBottom: `1px solid ${theme2.colors.shark}`
  }
});
const textAreaStyles$1 = (value) => ({
  container: {
    cursor: "text"
  },
  label: {
    // color: focused || value ? '#A1A1A1' : '#6E6E6D',
    // fontSize: focused || value ? '16px' : '18px',
    userSelect: "none"
  },
  textAreaInner: {
    // margin: '0 -12px',
    // padding: '12px',
    // border: '1px solid green',
    // backgroundColor: 'blue',
    // border: focused ? '1px solid black' : '1px solid transparent',
    // backgroundColor: hovered || focused ? '#F5F5F5' : 'white',
    borderRadius: "6px",
    display: "flex",
    position: "relative",
    lineHeight: "24px",
    alignItems: "center"
  },
  disabled: {},
  input: {
    border: "1px solid transparent",
    backgroundColor: "transparent",
    outline: "none",
    alignItems: "center",
    lineHeight: "1.5",
    fontSize: "inherit",
    fontFamily: "inherit",
    padding: "0",
    width: "100%"
  },
  inputProps: {
    // root: {
    //   height: '500px',
    // },
  }
});
const EnableGoogleModal = ({
  isOpen,
  onClose,
  onSuccess,
  disabled,
  integrations,
  enableReserveWithGoogle: enableReserveWithGoogle2,
  reserveWithGoogle,
  obeeSettings: obeeSettings2
}) => {
  var _a, _b2, _c2, _d2, _e2;
  const theme2 = useTheme$1();
  const classes = useStyles$1g();
  const isMobile = useHasMobile();
  const companyName = isObee() ? "Obee" : "EatClub";
  const googleIntegration = useMemo(() => {
    return findObjectByProperty(integrations.data, "RwG", "id");
  }, [integrations.data]);
  const [acceptFaqs, setAcceptFaqs] = useState(false);
  const [acceptPayment, setAcceptPayment] = useState(false);
  const [acceptAuthorise, setAcceptAuthorise] = useState(false);
  const [faqsError, setFaqsError] = useState(null);
  const [paymentError, setPaymentError] = useState(null);
  const [authoriseError, setAuthoriseError] = useState(null);
  const [terms, setTerms] = useState((_a = googleIntegration == null ? void 0 : googleIntegration.data) == null ? void 0 : _a.merchant_specific_terms);
  const [submitting, setSubmitting] = useState(false);
  useEffect(() => {
    var _a2;
    if (isOpen) {
      setTerms((_a2 = googleIntegration == null ? void 0 : googleIntegration.data) == null ? void 0 : _a2.merchant_specific_terms);
    }
    if (isOpen && (googleIntegration == null ? void 0 : googleIntegration.active)) {
      setAcceptFaqs(true);
      setAcceptPayment(true);
      setAcceptAuthorise(true);
      setFaqsError(null);
      setPaymentError(null);
      setAuthoriseError(null);
      setSubmitting(false);
    }
  }, [isOpen]);
  const handleClose = () => {
    setAcceptFaqs(false);
    setAcceptPayment(false);
    setAcceptAuthorise(false);
    setFaqsError(null);
    setPaymentError(null);
    setAuthoriseError(null);
    onClose();
  };
  const validate = () => {
    let valid = true;
    if (!acceptPayment) {
      valid = false;
      setPaymentError(true);
    }
    if (!acceptFaqs) {
      valid = false;
      setFaqsError(true);
    }
    if (!acceptAuthorise) {
      valid = false;
      setAuthoriseError(true);
    }
    return valid;
  };
  const validateAndSubmit = () => {
    if (!validate()) {
      return;
    }
    setSubmitting(true);
    enableReserveWithGoogle2(terms);
  };
  useEffect(() => {
    if (submitting && (googleIntegration == null ? void 0 : googleIntegration.active)) {
      onSuccess();
      handleClose();
    }
  }, [submitting, googleIntegration == null ? void 0 : googleIntegration.active]);
  useEffect(() => {
    if (submitting && integrations.error) {
      setSubmitting(false);
    }
  }, [integrations.error]);
  const accordionItems = useMemo(
    () => [
      {
        id: "questions",
        summary: /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement("b", null, "Need help?"), " - Questions to consider"),
        details: /* @__PURE__ */ React__default.createElement("ul", { className: classes.list }, /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Do you have terms and conditions specific to areas, days, and times? As Reserve with Google does not support these, we suggest you review these for Reserve with Google T&C"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Is there a minimum spend?"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Can special dietary requirements be catered for? Any requirements or only some? Is advanced notice of any special dietary requirements needed?"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Does an additional service charge apply? For Sundays or public holidays?"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Can bookings be changed or cancelled online? Or does this need to be done by phone?"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Anything specific to your venue, such as directions to where you’re located, your menu, and if they must be on specific menus for different times, days or group sizes?"))
      }
    ],
    []
  );
  const useDefaultTerms = () => {
    var _a2;
    const defaultTerms = parseRichText((_a2 = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _a2.terms);
    if (isEmpty(defaultTerms)) {
      setTerms(parseRichText(getDefaultTermsAndConditions()));
    } else {
      setTerms(defaultTerms);
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Modal,
    {
      fullWidth: false,
      style: modalStyles$3(theme2, isMobile),
      isOpen,
      onClose: handleClose,
      showCloseText: false
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Enable Reserve with Google"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Streamlined bookings from your Google Business profile")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionBlock }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "What is Reserve with Google"), /* @__PURE__ */ React__default.createElement(Box, null, "Reserve with Google allows guests to make a booking for your venue directly from your Business Profile in Google Search and Google Maps. It is completely free and these bookings are automatically added to your ", companyName, " Bookings.", ((_b2 = window.bookingsConfig) == null ? void 0 : _b2.faqsUrl) && /* @__PURE__ */ React__default.createElement("span", null, "Find out more in", " ", /* @__PURE__ */ React__default.createElement(
      Button,
      {
        href: (_c2 = window.bookingsConfig) == null ? void 0 : _c2.faqsUrl,
        type: "text",
        style: { display: "inline-block" },
        underline: true,
        newTab: true
      },
      "FAQs"
    ), "."))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionBlock }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "How to get started"), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement("ol", null, /* @__PURE__ */ React__default.createElement("li", null, "Before you start, make sure you have created your Google business profile here. If you don’t have one you can get started here."), /* @__PURE__ */ React__default.createElement("li", null, "Once that’s set up, fill out the request form below"), /* @__PURE__ */ React__default.createElement("li", null, "We’ll set you up, which usually takes around 1 day"), /* @__PURE__ */ React__default.createElement("li", null, "Finally, receive a confirmation email, and you’re ready to go!")))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionBlock }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeadingLarge }, "Enable Reserve with Google integration"), /* @__PURE__ */ React__default.createElement(Box, null, "Accepting bookings through Reserve with Google is not the same as", " ", isObee() ? "Obee" : "EatClub", " Bookings. Reserve with Google does not support terms and conditions specific to areas, days, and times. We suggest you amend your T&C for Reserve with Google.")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionBlock }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.spaceBetween }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "Display terms and conditions"), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        style: { color: theme2.colors.olive3, fontWeight: "bold" },
        disabled,
        onClick: useDefaultTerms
      },
      "Start with default"
    )), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      TextArea,
      {
        placeholder: "Type your terms and conditions here",
        resizable: false,
        style: { ...textAreaStyles$1() },
        minRows: 10,
        value: terms,
        onChange: setTerms,
        disabled,
        autoChangeHeight: true
      }
    ))), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.charcoal }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.accordion }, /* @__PURE__ */ React__default.createElement(Accordion, { items: accordionItems, style: accordionStyles(theme2) })), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.charcoal }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.checkboxes }, /* @__PURE__ */ React__default.createElement(
      Checkbox,
      {
        label: /* @__PURE__ */ React__default.createElement(Box, null, "I have read and understand the Reserve with Google", " ", ((_d2 = window.bookingsConfig) == null ? void 0 : _d2.faqsUrl) && /* @__PURE__ */ React__default.createElement(
          Button,
          {
            href: (_e2 = window.bookingsConfig) == null ? void 0 : _e2.faqsUrl,
            type: "text",
            style: { display: "inline-block", fontWeight: "bold" },
            onClick: (e) => e.stopPropagation(),
            underline: true,
            newTab: true
          },
          "FAQs"
        )),
        disabled,
        onChange: setAcceptFaqs,
        selected: acceptFaqs,
        style: checkboxStyles(theme2),
        error: faqsError,
        clearError: setFaqsError,
        color: theme2.colors.charcoal
      }
    ), /* @__PURE__ */ React__default.createElement(
      Checkbox,
      {
        label: `I understand that ${isObee() ? "Obee" : "EatClub"} Bookings payment is not supported through Reserve with Google.`,
        disabled,
        onChange: setAcceptPayment,
        selected: acceptPayment,
        style: checkboxStyles(theme2),
        error: paymentError,
        clearError: setPaymentError,
        color: theme2.colors.charcoal
      }
    ), /* @__PURE__ */ React__default.createElement(
      Checkbox,
      {
        label: "I am authorised to enable Reserve with Google.",
        disabled,
        onChange: setAcceptAuthorise,
        selected: acceptAuthorise,
        style: checkboxStyles(theme2),
        error: authoriseError,
        clearError: setAuthoriseError,
        color: theme2.colors.charcoal
      }
    ))), (faqsError || paymentError || authoriseError) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.error }, "You must accept all of the terms to enable Reserve with Google"), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonContainer }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "tertiary",
        onClick: handleClose,
        style: {
          container: { width: isMobile && "100%" },
          button: { width: isMobile && "100%" }
        }
      },
      "Cancel"
    ), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "primary",
        onClick: validateAndSubmit,
        style: {
          container: { width: isMobile && "100%" },
          button: { width: isMobile && "100%" }
        },
        loading: reserveWithGoogle.pending,
        disabled
      },
      "Enable Reserve with Google"
    )))
  );
};
EnableGoogleModal.defaultProps = {
  disabled: false
};
EnableGoogleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  enableReserveWithGoogle: PropTypes.func.isRequired,
  integrations: integrationsPropTypes.isRequired,
  reserveWithGoogle: reserveWithGoogleApiPropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$2s = (state) => ({
  integrations: state.obeeIntegrations,
  reserveWithGoogle: state.reserveWithGoogle,
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$2r = (dispatch) => bindActionCreators(
  {
    enableReserveWithGoogle: enableReserveWithGoogleAction
  },
  dispatch
);
const EnableGoogleModal$1 = connect(mapStateToProps$2s, mapDispatchToProps$2r)(EnableGoogleModal);
const useStyles$1f = createUseStyles((theme2) => ({
  buttonContainer: {
    width: "100%",
    gap: "15px",
    justifyContent: "space-between",
    display: "flex",
    marginTop: "15px",
    [theme2.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center"
    }
  },
  modalHeader: {
    ...theme2.typography.h2,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    maxWidth: "420px"
  },
  description: {
    ...theme2.typography.paragraphLarge,
    color: theme2.colors.smoke,
    maxWidth: "480px"
  },
  modalBody: {
    ...theme2.typography.default,
    color: theme2.colors.charcoal,
    textAlign: "center",
    paddingBottom: "90px",
    "& ol": {
      margin: 0
    }
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    alignItems: "center",
    marginBottom: "20px",
    // overflow: theme.overlay,
    overflowY: "auto",
    maxHeight: "min(600px, 100dvh - 320px)"
    // Looks good on small height
  }
}));
const modalStyles$2 = (theme2, isMobile) => ({
  container: { padding: "20px" },
  modal: { minWidth: isMobile ? "100px" : "650px", maxWidth: "650px" },
  content: { padding: isMobile ? "35px 20px 15px 20px" : "35px 35px 15px" },
  header: { padding: "20px", background: theme2.colors.linen }
});
const SvgGoogleSuccess = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 222 136", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M36.0383 67.9139C31.0837 90.674 28.4206 130.806 57.4049 109.254C93.6353 82.3131 129.866 13.1092 166.561 17.7541C181.425 19.6356 180.031 42.837 174.457 55.8432", stroke: "#424242" }), /* @__PURE__ */ React$7.createElement("rect", { x: 144.943, y: 59.0947, width: 76.0491, height: 24.1536, rx: 12.0768, transform: "rotate(15 144.943 59.0947)", fill: "#4285F4" }), /* @__PURE__ */ React$7.createElement("path", { d: "M156.676 75.7435L158.566 76.2497L159.475 80.183L161.051 80.6054L160.034 76.3327C161.343 76.2237 162.204 75.4231 162.514 74.264C162.893 72.8499 162.451 71.2532 160.168 70.6413L156.76 69.7282L154.328 78.804L155.754 79.1861L156.676 75.7435ZM158.852 74.9476L157.021 74.4569L157.832 71.4316L159.663 71.9223C161.147 72.3199 161.239 73.2267 161.056 73.9106C160.866 74.6176 160.232 75.3172 158.852 74.9476ZM166.357 76.5236C167.215 76.7534 167.782 77.4645 167.592 78.3578L164.347 77.4882C164.701 76.6762 165.511 76.2969 166.357 76.5236ZM168.692 79.7706C168.756 79.6262 168.793 79.4871 168.83 79.348C169.33 77.4818 168.598 75.8569 166.674 75.3413C164.877 74.8599 163.164 75.9663 162.695 77.7166C162.202 79.5596 163.246 81.3178 165.077 81.8085C166.306 82.1378 167.683 81.7738 168.342 80.7078L167.3 80.0063C166.843 80.6914 166.128 80.8103 165.374 80.6084C164.47 80.3662 163.766 79.4695 163.998 78.5128L168.692 79.7706ZM171.435 83.4997C173.081 83.9407 174.112 83.1983 174.373 82.2247C174.737 80.8685 173.788 80.1423 172.67 79.681C171.866 79.3415 171.524 79.0883 171.658 78.5899C171.763 78.1958 172.301 78.0419 172.788 78.1723C173.565 78.3804 173.78 78.9225 173.772 79.3678L175.018 79.4033C175.101 78.7672 174.767 77.5099 173.133 77.072C171.753 76.7024 170.558 77.3634 170.294 78.3487C169.927 79.7164 170.842 80.3343 171.917 80.8211C172.761 81.1962 173.091 81.4463 172.961 81.9331C172.846 82.362 172.386 82.5493 171.737 82.3753C171.029 82.1859 170.672 81.6181 170.711 81.0569L169.436 81.0384C169.331 81.7556 169.731 83.0431 171.435 83.4997ZM179.431 80.0268C180.289 80.2566 180.856 80.9676 180.666 81.861L177.421 80.9914C177.775 80.1794 178.585 79.8 179.431 80.0268ZM181.766 83.2738C181.83 83.1293 181.867 82.9902 181.904 82.8511C182.404 80.985 181.672 79.36 179.748 78.8445C177.951 78.3631 176.238 79.4695 175.769 81.2197C175.276 83.0627 176.32 84.821 178.151 85.3117C179.38 85.6409 180.757 85.2769 181.416 84.211L180.374 83.5094C179.917 84.1945 179.202 84.3135 178.448 84.1116C177.544 83.8693 176.84 82.9726 177.072 82.0159L181.766 83.2738ZM187.156 82.457L187.535 81.0428C187.437 80.9917 187.254 80.9304 187.208 80.918C186.559 80.7441 185.797 80.9001 185.234 81.4699L185.489 80.5194L184.144 80.1591L182.486 86.3488L183.865 86.7184L184.707 83.5772C184.992 82.5108 185.716 82.034 186.771 82.3166C186.794 82.3228 187.046 82.4027 187.156 82.457ZM188.925 88.0743L190.305 88.4439L194.548 82.9468L193.099 82.5586L190.052 86.6495L189.459 81.5834L187.964 81.1827L188.925 88.0743ZM197.882 84.9706C198.739 85.2004 199.307 85.9115 199.117 86.8048L195.871 85.9352C196.226 85.1232 197.035 84.7439 197.882 84.9706ZM200.217 88.2176C200.28 88.0732 200.318 87.9341 200.355 87.795C200.855 85.9288 200.122 84.3039 198.198 83.7883C196.402 83.3069 194.689 84.4133 194.22 86.1636C193.726 88.0066 194.771 89.7648 196.602 90.2555C197.831 90.5848 199.208 90.2208 199.866 89.1548L198.824 88.4533C198.367 89.1384 197.652 89.2573 196.899 89.0554C195.995 88.8132 195.291 87.9165 195.522 86.9598L200.217 88.2176Z", fill: "white" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 107.106, cy: 75.8159, r: 44.5913, fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("path", { d: "M123.132 61.8818L127.674 66.4237L114.447 79.6513L109.905 75.1094L123.132 61.8818Z", fill: "#ED412D" }), /* @__PURE__ */ React$7.createElement("path", { d: "M111.877 73.1377L116.419 77.6796L105.779 88.3196L101.237 83.7777L111.877 73.1377Z", fill: "#4285F4" }), /* @__PURE__ */ React$7.createElement("path", { d: "M101.237 83.7773L105.779 88.3192L101.237 92.8611L96.6948 88.3192L101.237 83.7773Z", fill: "#F3BB12" }), /* @__PURE__ */ React$7.createElement("path", { d: "M86.96 78.5829L91.5019 74.041L101.563 84.102L97.0209 88.6439L86.96 78.5829Z", fill: "#2DA94F" }), /* @__PURE__ */ React$7.createElement("rect", { x: 30.683, y: 41.102, width: 55.5483, height: 27.6678, rx: 7.5, transform: "rotate(-30 30.683 41.102)", fill: "#313131", stroke: "black" }), /* @__PURE__ */ React$7.createElement("path", { d: "M34.7924 43.8794C32.5497 39.9948 33.9385 35.0257 37.8703 32.8669L72.0488 14.1009C75.5182 12.1961 79.859 13.1144 82.2596 16.2612L89.468 25.7103C92.3939 29.5456 91.2853 35.0787 87.1076 37.4907L52.033 57.741C48.2067 59.9502 43.314 58.6392 41.1048 54.8128L34.7924 43.8794Z", fill: "#E7C63E" }), /* @__PURE__ */ React$7.createElement("path", { d: "M41.4148 44.1724L45.7588 41.6644L46.0496 50.808L47.5253 49.956L47.1641 40.7144L46.5581 39.6648L40.7488 43.0188L41.4148 44.1724ZM49.5322 42.5065C49.8142 42.9949 50.4639 43.1602 50.9627 42.8722C51.4719 42.5782 51.6329 41.9449 51.3509 41.4565C51.0569 40.9473 50.4279 40.77 49.9187 41.064C49.4199 41.352 49.2382 41.9973 49.5322 42.5065ZM51.7642 46.3724C52.0462 46.8609 52.7019 47.0365 53.2007 46.7485C53.7099 46.4545 53.8649 45.8109 53.5829 45.3224C53.2889 44.8132 52.6599 44.6359 52.1507 44.9299C51.6519 45.2179 51.4702 45.8632 51.7642 46.3724ZM59.721 39.8386C59.121 38.7994 58.1899 38.6026 57.2261 38.7572C57.72 38.0287 57.9484 37.1763 57.3724 36.1786C56.6584 34.9419 55.0923 34.5574 53.3464 35.5654C51.5485 36.6034 51.3444 38.2178 51.7693 39.3858L53.1412 38.954C52.7723 38.0031 53.2062 37.1706 54.0064 36.7086C54.9313 36.1746 55.7122 36.375 56.1202 37.0817C56.4982 37.7364 56.2402 38.6336 55.3984 39.1196L54.5982 39.5816L55.2642 40.7352L56.1372 40.2312C57.0517 39.7032 57.9304 39.8332 58.3924 40.6334C58.8064 41.3505 58.4249 42.2497 57.5624 42.7477C56.9596 43.0957 55.8027 43.3479 55.0273 42.3407L53.951 43.3086C55.1364 44.7858 56.9293 44.6513 58.1972 43.9193C59.9327 42.9173 60.447 41.0961 59.721 39.8386ZM65.6404 39.6219C67.6981 38.4339 68.0019 35.7921 66.6519 33.4538C65.3079 31.1259 62.9009 30.0769 60.8432 31.2649C58.7959 32.4469 58.4818 35.0947 59.8258 37.4226C61.1758 39.7608 63.5828 40.8099 65.6404 39.6219ZM61.5004 32.4512C62.7891 31.7072 64.4081 32.6154 65.3441 34.2366C66.2921 35.8786 66.2719 37.6916 64.9832 38.4356C63.6946 39.1796 62.092 38.2758 61.144 36.6338C60.196 34.9918 60.2118 33.1952 61.5004 32.4512ZM74.5692 30.6148C73.7652 29.2222 71.9007 28.3449 70.1964 29.3289C69.708 29.6109 68.9238 30.3408 68.8942 31.3694L68.3962 30.5068L67.1907 31.2028L71.9727 39.4855L73.2094 38.7715L71.1634 35.2277C71.9898 35.6512 73.0511 35.3295 73.4772 35.0835C75.1192 34.1355 75.4392 32.1217 74.5692 30.6148ZM70.0026 33.2652C69.4506 32.3091 69.6433 31.1309 70.6513 30.5489C71.6594 29.9669 72.7761 30.3891 73.3281 31.3452C73.8801 32.3013 73.671 33.4751 72.6733 34.0511C71.6653 34.6331 70.5546 34.2213 70.0026 33.2652ZM79.316 27.4447L81.116 30.5623L82.3423 29.8543L80.5543 26.7574C80.0683 25.9157 80.2016 25.0905 80.9706 24.6465C81.8228 24.1545 82.4913 24.5445 82.9473 25.3343L84.7533 28.4623L85.99 27.7483L84.01 24.3189C83.284 23.0614 82.1009 22.4282 80.6979 23.2382C79.8458 23.7302 79.4854 24.3539 79.293 25.2687C78.6572 24.8875 77.9024 24.8522 77.0502 25.3442C76.6137 25.5962 76.0239 26.1584 75.9018 27.1711L75.4698 26.4229L74.2643 27.1189L77.4683 32.6683L78.705 31.9543L76.923 28.8678C76.437 28.0261 76.5643 27.1905 77.3229 26.7525C78.1751 26.2605 78.866 26.6652 79.316 27.4447Z", fill: "#F2E6B4" }));
const GoogleSuccess = SvgGoogleSuccess;
const GoogleSuccessModal = ({ isOpen, onClose, heading, description: description2, buttonText }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1f();
  const isMobile = useHasMobile();
  const handleClose = () => {
    onClose();
  };
  return /* @__PURE__ */ React__default.createElement(
    Modal,
    {
      fullWidth: false,
      style: modalStyles$2(theme2, isMobile),
      isOpen,
      onClose,
      showCloseText: false
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalContent }, /* @__PURE__ */ React__default.createElement(GoogleSuccess, { style: { width: "222px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, heading), /* @__PURE__ */ React__default.createElement(Box, { className: classes.description }, description2), /* @__PURE__ */ React__default.createElement(Button, { type: "primary", onClick: handleClose }, buttonText)))
  );
};
GoogleSuccessModal.defaultProps = {
  buttonText: "Okay, I've got it",
  heading: "Success, Reserve with Google is now enabled",
  description: "Please allow up to 24 hours for the booking button to appear on your Google business account. "
};
GoogleSuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string
};
const GoogleSuccessModal$1 = GoogleSuccessModal;
const SvgCircleArrowUp = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 21, cy: 21, r: 20.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12 26L20.5 15L29 26", stroke: "black" }));
const IconCircleArrowUp = SvgCircleArrowUp;
const useStyles$1e = createUseStyles((theme2) => ({
  container: {
    position: "relative",
    border: "1px solid #D9D9D9",
    // TODO use theme
    width: "100%",
    borderRadius: "12px",
    minHeight: "80px",
    backgroundColor: "white",
    userSelect: "none",
    ...theme2.typography.body.PL
  },
  innerContainer: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    padding: "15px 28px"
  },
  leftSide: {},
  rightSide: {},
  titleSection: {
    display: "flex",
    alignItems: "center",
    gap: "25px",
    marginBottom: "16px"
  },
  heading: {
    ...theme2.typography.heading.H3,
    lineHeight: "22px"
  },
  paymentsSetting: {
    border: "1px solid #D9D9D9",
    width: "100%",
    padding: "30px",
    borderRadius: "12px"
  },
  enabled: {
    fontWeight: theme2.fontWeights.medium,
    fontSize: theme2.fontSizes.m,
    color: theme2.colors.roquette,
    backgroundColor: theme2.colors.greenBackground,
    padding: "7px 12px",
    borderRadius: "6px"
  },
  iconButton: (props) => ({
    color: theme2.colors.smoke,
    width: "42px",
    height: "42px",
    transition: "color 0.1s",
    transform: !(props == null ? void 0 : props.isOpen) ? "rotate(180deg)" : "none",
    "&:hover": {
      color: theme2.colors.charcoal,
      cursor: "pointer"
    }
  }),
  leftBar: {
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    overflow: "hidden",
    maxWidth: "6px",
    zIndex: 1,
    "& > *": {
      backgroundColor: theme2.colors.roquette,
      height: "100%",
      width: "24px",
      borderRadius: "12px 0 0 12px"
    }
  },
  actionsSection: {
    height: "60px",
    position: "relative",
    borderTop: "1px solid #D9D9D9",
    // TODO use theme
    padding: "0 28px",
    backgroundColor: "white",
    borderRadius: "0 0 12px 12px",
    zIndex: 2
  },
  actions: {
    display: "flex",
    gap: "24px",
    alignItems: "center",
    height: "100%"
  },
  textButton: {
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.olive3
  }
}));
const IntegrationCard = ({ enabled, title, description: description2, loading, onClick, actions }) => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!enabled) {
      setIsOpen(false);
    }
  }, [enabled]);
  const classes = useStyles$1e({ isOpen });
  const toggleOpen = () => {
    if (!enabled) {
      return;
    }
    setIsOpen(!isOpen);
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, enabled && /* @__PURE__ */ React__default.createElement(Box, { className: classes.leftBar }, /* @__PURE__ */ React__default.createElement(Box, null)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer, onClick: toggleOpen }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.leftSide }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.titleSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, title), enabled && /* @__PURE__ */ React__default.createElement(Box, { className: classes.enabled }, "Enabled")), /* @__PURE__ */ React__default.createElement(Box, null, description2)), loading ? /* @__PURE__ */ React__default.createElement(Spinner, { style: { height: "20px" } }) : enabled ? /* @__PURE__ */ React__default.createElement(IconCircleArrowUp, { className: classes.iconButton, onClick: toggleOpen }) : /* @__PURE__ */ React__default.createElement(Button, { onClick, text: "Enable" })), isOpen && !isEmpty(actions) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.actionsSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.actions }, actions.map((action) => /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "text",
      className: classes.textButton,
      key: action.id,
      onClick: action == null ? void 0 : action.onClick
    },
    action.label
  )))));
};
IntegrationCard.defaultProps = {
  enabled: false,
  title: "",
  description: "",
  loading: false,
  onClick: () => {
  },
  actions: []
};
IntegrationCard.propTypes = {
  enabled: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  actions: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, label: PropTypes.string, onClick: PropTypes.func })
  )
};
const mapStateToProps$2r = () => ({});
const mapDispatchToProps$2q = (dispatch) => bindActionCreators({}, dispatch);
const IntegrationCard$1 = connect(mapStateToProps$2r, mapDispatchToProps$2q)(IntegrationCard);
const generateFBLoginButtonAction = () => (dispatch, buttonText) => {
  const action = "GENERATE_FB_LOGIN_BUTTON";
  const data = {
    buttonText
  };
  const request = () => generateFacebookLoginButton(data);
  dispatch(
    makeApiAction(
      action,
      request,
      data,
      "generateFBLoginButton",
      null,
      {},
      false,
      "Failed to generate login button for facebook. Please try again later"
    )
  );
};
const metaLoginButtonApiPropTypes = PropTypes.shape({
  data: PropTypes.string,
  apiData: PropTypes.string,
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const useStyles$1d = createUseStyles((theme2) => ({
  buttonContainer: {
    width: "100%",
    gap: "15px",
    justifyContent: "space-between",
    display: "flex",
    marginTop: "15px",
    [theme2.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center"
    }
  },
  modalHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  heading: {
    ...theme2.typography.h2
  },
  subHeading: {
    fontSize: theme2.fontSizes.l
  },
  sectionHeading: {
    fontWeight: theme2.fontWeights.bold
  },
  sectionHeadingLarge: {
    fontWeight: theme2.fontWeights.bold,
    fontSize: theme2.fontSizes.l
  },
  modalBody: {
    ...theme2.typography.default,
    color: theme2.colors.charcoal,
    "& ol": {
      margin: 0
    }
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    marginBottom: "20px",
    paddingRight: "10px",
    marginRight: "-10px",
    // overflow: theme.overlay,
    overflowY: "auto",
    maxHeight: "min(1000px, 100dvh - 320px)"
    // Looks good on small height
  },
  sectionBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  },
  error: {
    color: theme2.colors.errorRed,
    fontSize: "12px"
  },
  smallHeading: {
    ...theme2.typography.heading.H2
  },
  largeHeading: {},
  spaceBetween: {
    display: "flex",
    gap: "12px",
    justifyContent: "space-between",
    alignItems: "baseline"
  }
}));
const modalStyles$1 = (isMobile, theme2) => ({
  container: { padding: "20px" },
  modal: { minWidth: isMobile ? "100px" : "650px", maxWidth: "650px" },
  content: { padding: isMobile ? "35px 20px 15px 20px" : "35px 35px 15px" },
  header: { padding: "20px", background: theme2.colors.linen }
});
const FakeFacebookButton = ({ text }) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        width: "250px",
        backgroundColor: theme2.colors.facebookBlue,
        borderRadius: "8px",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "15px",
        fontWeight: theme2.fontWeights.bold,
        height: "40px"
      }
    },
    text
  );
};
FakeFacebookButton.defaultProps = {
  text: "Book Now"
};
FakeFacebookButton.propTypes = {
  text: PropTypes.string
};
const mapStateToProps$2q = () => ({});
const mapDispatchToProps$2p = (dispatch) => bindActionCreators({}, dispatch);
const FakeFacebookButton$1 = connect(mapStateToProps$2q, mapDispatchToProps$2p)(FakeFacebookButton);
const buttonOptions = [
  {
    label: /* @__PURE__ */ React__default.createElement(FakeFacebookButton$1, { text: "Book Now" }),
    value: "Book Now"
  },
  {
    label: /* @__PURE__ */ React__default.createElement(FakeFacebookButton$1, { text: "Reserve" }),
    value: "Reserve"
  }
];
const EnableMetaModal = ({
  isOpen,
  onClose,
  onSuccess,
  disabled,
  integrations,
  generateFBLoginButton: generateFBLoginButton2,
  metaLoginButton
}) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$1d();
  const isMobile = useHasMobile();
  const metaIntegration = useMemo(() => {
    return findObjectByProperty(integrations.data, "Meta", "id");
  }, [integrations.data]);
  const [buttonText, setButtonText] = useState(((_a = metaIntegration == null ? void 0 : metaIntegration.data) == null ? void 0 : _a.buttonText) || "Book Now");
  const [submitting, setSubmitting] = useState(false);
  useEffect(() => {
    if (isOpen && !disabled) {
      generateFBLoginButton2(buttonText);
    }
  }, [isOpen, buttonText, disabled]);
  useEffect(() => {
    if (isOpen && (metaIntegration == null ? void 0 : metaIntegration.active)) {
      setSubmitting(false);
    }
  }, [isOpen]);
  const handleClose = () => {
    onClose();
  };
  const validateAndSubmit = () => {
    setSubmitting(true);
    window.location.href = metaLoginButton == null ? void 0 : metaLoginButton.data;
  };
  useEffect(() => {
    if (submitting && (metaIntegration == null ? void 0 : metaIntegration.active)) {
      onSuccess();
      handleClose();
    }
  }, [submitting, metaIntegration == null ? void 0 : metaIntegration.active]);
  useEffect(() => {
    if (submitting && integrations.error) {
      setSubmitting(false);
    }
  }, [integrations.error]);
  return /* @__PURE__ */ React__default.createElement(
    Modal,
    {
      fullWidth: false,
      style: modalStyles$1(isMobile, theme2),
      isOpen,
      onClose: handleClose,
      showCloseText: false
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Reserve with Meta (Facebook + Instagram)"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Streamlined bookings from your Facebook & Instagram business page")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionBlock }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "What is Meta"), /* @__PURE__ */ React__default.createElement(Box, null, "Meta is the parent company of Facebook & Instagram.")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionBlock }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "What is Reserve with Meta (Facebook + Instagram)"), /* @__PURE__ */ React__default.createElement(Box, null, "You can add a Reserve button on your Facebook & Instagram business account to accept bookings, and it is completely free. When they click Reserve button, your guests will be redirected to your booking widget to complete bookings as usual.")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionBlock }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "How to get started"), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement("ol", null, /* @__PURE__ */ React__default.createElement("li", null, "Before you start, make sure you have created your Facebook & Instagram business account. If you don’t have one you can get started", " ", /* @__PURE__ */ React__default.createElement("a", { href: "https://www.facebook.com/business/help/473994396650734" }, "here"), "."), /* @__PURE__ */ React__default.createElement("li", null, "Once that’s setup, click the button below to connect to Facebook. You can also connect Instagram from this button."), /* @__PURE__ */ React__default.createElement("li", null, "Go through the Facebook prompts to add a booking button on your business accounts."), /* @__PURE__ */ React__default.createElement("li", null, "Now you have your button added, you are ready to accept bookings!")))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionBlock }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeadingLarge }, "Connect to Meta"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.spaceBetween }, /* @__PURE__ */ React__default.createElement(Box, null, "Select your booking button text"), /* @__PURE__ */ React__default.createElement(
      RadioButtonGroup,
      {
        items: buttonOptions,
        size: "16px",
        innerSize: "16px",
        style: {
          buttonCircle: {
            color: "white"
          },
          buttonCircleInnerSelected: {
            backgroundColor: theme2.colors.charcoal
          }
        },
        disabled,
        icon: /* @__PURE__ */ React__default.createElement(
          CheckSVG,
          {
            style: {
              width: "12px",
              height: "9px"
            }
          }
        ),
        onSelect: setButtonText,
        value: buttonText
      }
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.spaceBetween, style: { marginTop: "20px" } }, /* @__PURE__ */ React__default.createElement(Box, null, "Log in to your business account"), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "primary",
        onClick: validateAndSubmit,
        loading: metaLoginButton == null ? void 0 : metaLoginButton.pending,
        disabled
      },
      "Enable Meta integration"
    )))))
  );
};
EnableMetaModal.defaultProps = {
  disabled: false
};
EnableMetaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  generateFBLoginButton: PropTypes.func.isRequired,
  integrations: integrationsPropTypes.isRequired,
  metaLoginButton: metaLoginButtonApiPropTypes.isRequired
};
const mapStateToProps$2p = (state) => ({
  integrations: state.obeeIntegrations,
  metaLoginButton: state.metaLoginButton
});
const mapDispatchToProps$2o = (dispatch) => bindActionCreators(
  {
    generateFBLoginButton: generateFBLoginButtonAction
  },
  dispatch
);
const EnableMetaModal$1 = connect(mapStateToProps$2p, mapDispatchToProps$2o)(EnableMetaModal);
const useStyles$1c = createUseStyles((theme2) => ({
  buttonContainer: {
    width: "100%",
    gap: "15px",
    justifyContent: "space-between",
    display: "flex",
    marginTop: "15px",
    [theme2.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center"
    }
  },
  modalHeader: {
    ...theme2.typography.h2,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    maxWidth: "420px"
  },
  description: {
    ...theme2.typography.paragraphLarge,
    color: theme2.colors.smoke,
    maxWidth: "480px"
  },
  modalBody: {
    ...theme2.typography.default,
    color: theme2.colors.charcoal,
    textAlign: "center",
    paddingBottom: "90px",
    "& ol": {
      margin: 0
    }
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    alignItems: "center",
    marginBottom: "20px",
    // overflow: theme.overlay,
    overflowY: "auto",
    maxHeight: "min(600px, 100dvh - 320px)"
    // Looks good on small height
  }
}));
const modalStyles = (isMobile, theme2) => ({
  container: { padding: "20px" },
  modal: { minWidth: isMobile ? "100px" : "650px", maxWidth: "650px" },
  content: { padding: isMobile ? "35px 20px 15px 20px" : "35px 35px 15px" },
  header: { padding: "20px", background: theme2.colors.linen }
});
const MetaSuccessModal = ({ isOpen, onClose, heading, description: description2, buttonText }) => {
  const classes = useStyles$1c();
  const theme2 = useTheme$1();
  const isMobile = useHasMobile();
  const handleClose = () => {
    onClose();
  };
  return /* @__PURE__ */ React__default.createElement(
    Modal,
    {
      fullWidth: false,
      style: modalStyles(isMobile, theme2),
      isOpen,
      onClose: handleClose,
      showCloseText: false
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, heading), /* @__PURE__ */ React__default.createElement(Box, { className: classes.description }, description2), /* @__PURE__ */ React__default.createElement(Button, { type: "primary", onClick: handleClose }, buttonText)))
  );
};
MetaSuccessModal.defaultProps = {
  buttonText: "Okay, I've got it",
  heading: "Success, Reserve with Meta is now enabled",
  description: "Please allow up to 24 hours for the booking button to appear on your Meta business account. "
};
MetaSuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string
};
const MetaSuccessModal$1 = MetaSuccessModal;
const storeLocalValueForRestaurant = (property, value) => {
  const state = store$1 == null ? void 0 : store$1.getState();
  const restaurantId = state.restaurantActive.restaurant.objectId;
  const restaurantData = JSON.parse(localStorage.getItem(`restaurant_${restaurantId}`)) || {};
  if (!restaurantId) {
    console.error("no restaurant ID when storing value");
    return;
  }
  restaurantData[property] = value;
  localStorage.setItem(`restaurant_${restaurantId}`, JSON.stringify(restaurantData));
};
const getLocalRestaurantValues = () => {
  const state = store$1 == null ? void 0 : store$1.getState();
  const restaurantId = state.restaurantActive.restaurant.objectId;
  if (!restaurantId) {
    console.error("no restaurant ID when reading value");
    return {};
  }
  return JSON.parse(localStorage.getItem(`restaurant_${restaurantId}`)) || {};
};
const getLocalValueForRestaurant = (property, defaultValue = null) => {
  const data = getLocalRestaurantValues();
  return (data == null ? void 0 : data[property]) !== void 0 ? data == null ? void 0 : data[property] : defaultValue;
};
const GeneralErrorModal = ({ isOpen, onClose, prompt, heading, confirmLabel, children }) => {
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      context: "error",
      isOpen,
      onClose,
      heading,
      prompt,
      confirmLabel
    },
    children
  );
};
GeneralErrorModal.defaultProps = {
  heading: "Booking can’t be moved",
  confirmLabel: "Ok",
  prompt: "",
  children: "",
  isOpen: false,
  onClose: () => {
  }
};
GeneralErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  prompt: PropTypes.string,
  children: PropTypes.node,
  heading: PropTypes.string,
  confirmLabel: PropTypes.string
};
const GeneralErrorModal$1 = GeneralErrorModal;
const disableMetaIntegrationAction = () => (dispatch) => {
  const action = "DISABLE_META_INTEGRATION";
  const variables = {};
  const data = {};
  const request = () => disconnectMetaIntegration(data);
  dispatch(
    makeApiAction(
      action,
      request,
      data,
      "disconnectMetaIntegration",
      "Reserve with Meta has been disabled.",
      variables,
      false,
      "Failed to disable Reserve with Meta. Please try again. If this issue persists please contact your partner ops manager."
    )
  );
};
const IntegrationsSettings = ({
  fetchIntegrations: fetchIntegrations2,
  integrations,
  metaIntegrationDisable,
  disableReserveWithGoogle: disableReserveWithGoogle2,
  disableMetaIntegration,
  obeeSettings: obeeSettings2
}) => {
  const classes = useStyles$1w();
  const history = useHistory();
  const query = useQuery();
  const googleIntegration = findObjectByProperty(integrations == null ? void 0 : integrations.data, "RwG", "id");
  const metaIntegration = findObjectByProperty(integrations == null ? void 0 : integrations.data, "Meta", "id");
  const [showGoogleModal, setShowGoogleModal] = useState(false);
  const [showGoogleSuccessModal, setShowGoogleSuccessModal] = useState(false);
  const [googleEnabled, setGoogleEnabled] = useState(
    getLocalValueForRestaurant("googleEnabled", false)
  );
  const [showGoogleCancelModal, setShowGoogleCancelModal] = useState(false);
  const [showMetaCancelModal, setShowMetaCancelModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorHeading, setErrorHeading] = useState(null);
  const [errorDescription, setErrorDescription] = useState(null);
  const [showMetaModal, setShowMetaModal] = useState(false);
  const [showMetaSuccessModal, setShowMetaSuccessModal] = useState(false);
  const [forceMetaSuccess, setForceMetaSuccess] = useState(false);
  const [metaEnabled, setMetaEnabled] = useState(getLocalValueForRestaurant("metaEnabled", false));
  const loading = useFetchOnFirstRender([fetchIntegrations2], [integrations]) || integrations.pending;
  useEffect(() => {
    if (integrations.success) {
      storeLocalValueForRestaurant("googleEnabled", !!(googleIntegration == null ? void 0 : googleIntegration.active));
      storeLocalValueForRestaurant("metaEnabled", !!(metaIntegration == null ? void 0 : metaIntegration.active));
      setGoogleEnabled(!!(googleIntegration == null ? void 0 : googleIntegration.active));
      setMetaEnabled(!!(metaIntegration == null ? void 0 : metaIntegration.active));
    }
  }, [integrations.data]);
  useEffect(() => {
    var _a;
    if (query.get("error")) {
      setErrorDescription(query.get("error"));
      setErrorHeading("An error occurred");
      setShowErrorModal(true);
    }
    const platform = query.get("integration");
    const facebookComplete = platform === "meta" && query.get("status") === "success";
    if (facebookComplete) {
      setForceMetaSuccess(true);
    }
    history.replace({
      pathname: `${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/settings`,
      search: "?tab=integrations"
    });
  }, []);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageContent }, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", flexDirection: "column", gap: "40px" } }, /* @__PURE__ */ React__default.createElement(
    IntegrationCard$1,
    {
      description: "Streamlined bookings from your Google Business profile",
      title: "Reserve with Google",
      loading,
      enabled: googleEnabled,
      onClick: () => {
        setShowGoogleModal(true);
      },
      actions: [
        {
          id: "view",
          label: "View feature overview",
          onClick: () => {
            setShowGoogleModal(true);
          }
        },
        {
          id: "disable",
          label: "Disable feature",
          onClick: () => {
            setShowGoogleCancelModal(true);
          }
        }
      ]
    }
  ), /* @__PURE__ */ React__default.createElement(
    IntegrationCard$1,
    {
      title: "Reserve with Meta (Facebook + Instagram)",
      description: "Streamlined bookings from your Facebook & Instagram business page",
      loading: loading || metaIntegrationDisable.pending,
      enabled: metaEnabled || forceMetaSuccess,
      onClick: () => {
        setShowMetaModal(true);
      },
      actions: [
        {
          id: "view",
          label: "View feature overview",
          onClick: () => {
            setShowMetaModal(true);
          }
        },
        {
          id: "disable",
          label: "Disable feature",
          onClick: () => {
            setShowMetaCancelModal(true);
          }
        }
      ]
    }
  ))), /* @__PURE__ */ React__default.createElement(
    GoogleSuccessModal$1,
    {
      isOpen: showGoogleSuccessModal,
      onClose: () => {
        setShowGoogleSuccessModal(false);
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    EnableGoogleModal$1,
    {
      isOpen: showGoogleModal,
      onClose: () => setShowGoogleModal(false),
      disabled: googleEnabled,
      onSuccess: () => {
        setShowGoogleModal(false);
        setShowGoogleSuccessModal(true);
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      onClose: () => {
        setShowGoogleCancelModal(false);
      },
      isOpen: showGoogleCancelModal,
      onConfirm: disableReserveWithGoogle2,
      confirmLabel: "Disable",
      heading: "Disable Reserve with Google",
      prompt: "Accepting bookings on Google will be disabled.\n        It will take up to 24 hours for this to take effect. Are you sure you want to continue?"
    }
  ), /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      onClose: () => {
        setShowMetaCancelModal(false);
      },
      isOpen: showMetaCancelModal,
      onConfirm: () => {
        setForceMetaSuccess(false);
        disableMetaIntegration();
      },
      confirmLabel: "Disable",
      heading: "Disable Reserve with Meta",
      prompt: "Accepting bookings on Facebook and Instagram will be disabled. Are you sure you want to continue?"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GeneralErrorModal$1,
    {
      onClose: () => {
        setShowErrorModal(false);
      },
      isOpen: showErrorModal,
      heading: errorHeading,
      prompt: errorDescription,
      confirmLabel: "Ok"
    }
  ), /* @__PURE__ */ React__default.createElement(
    MetaSuccessModal$1,
    {
      isOpen: showMetaSuccessModal,
      onClose: () => {
        setShowMetaSuccessModal(false);
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    EnableMetaModal$1,
    {
      isOpen: showMetaModal,
      onClose: () => setShowMetaModal(false),
      disabled: metaEnabled,
      onSuccess: () => {
        setShowMetaModal(false);
        setShowMetaSuccessModal(true);
      }
    }
  ));
};
IntegrationsSettings.defaultProps = {};
IntegrationsSettings.propTypes = {
  fetchIntegrations: PropTypes.func.isRequired,
  disableReserveWithGoogle: PropTypes.func.isRequired,
  disableMetaIntegration: PropTypes.func.isRequired,
  integrations: integrationsPropTypes.isRequired,
  metaIntegrationDisable: PropTypes.shape({
    error: PropTypes.string,
    pending: PropTypes.bool,
    success: PropTypes.bool
  }).isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$2o = (state) => ({
  integrations: state.obeeIntegrations,
  metaIntegrationDisable: state.metaIntegration,
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$2n = (dispatch) => bindActionCreators(
  {
    fetchIntegrations: fetchIntegrationsAction,
    enableReserveWithGoogle: enableReserveWithGoogleAction,
    disableReserveWithGoogle: disableReserveWithGoogleAction,
    disableMetaIntegration: disableMetaIntegrationAction
  },
  dispatch
);
const IntegrationsSettings$1 = connect(mapStateToProps$2o, mapDispatchToProps$2n)(IntegrationsSettings);
const fetchMessagesSettingsAction = () => (dispatch) => {
  const action = "FETCH_MESSAGES_SETTINGS";
  const entityName = "fetchMessagesSettings";
  const data = {};
  const request = () => fetchMessagesSettings(data);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const updateMessagesSettingsAction = (settings) => (dispatch) => {
  const action = "UPDATE_MESSAGES_SETTING";
  const entityName = "saveMessagesSettings";
  const data = { settings: only(settings, MessagesSettingsInputKeys()) };
  const successMessage = "Message settings successfully updated";
  const errorMessage = "Unable to update message settings";
  const request = () => updateMessagesSettings(data);
  dispatch(
    makeApiAction(action, request, settings, entityName, successMessage, null, false, errorMessage)
  );
};
const fetchBrandedEmailSettingsAction = () => (dispatch) => {
  const action = "FETCH_BRANDED_EMAIL_SETTINGS";
  const entityName = "fetchBrandedEmailSettings";
  const data = {};
  const request = () => fetchBrandedEmailSettings(data);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const updateBrandedEmailSettingsAction = (settings) => (dispatch) => {
  const action = "UPDATE_BRANDED_EMAIL_SETTING";
  const entityName = "updateBrandedEmailSettings";
  const data = { settings: stringifyObject(settings) };
  const successMessage = "Branded email settings successfully updated";
  const errorMessage = "Unable to update branded email settings";
  const request = () => updateBrandedEmailSettings(data);
  dispatch(
    makeApiAction(action, request, settings, entityName, successMessage, null, false, errorMessage)
  );
};
const EnableSmsModal = ({ isOpen, onClose, onConfirm, heading }) => {
  const theme2 = useTheme$1();
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  return /* @__PURE__ */ React__default.createElement(
    PromptModal$1,
    {
      isOpen,
      onClose: () => {
        setAgreeToTerms(false);
        onClose();
      },
      heading,
      confirmLabel: "Enable SMS",
      onConfirm: () => {
        onConfirm();
        onClose();
      },
      disableConfirm: !agreeToTerms
    },
    /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", flexDirection: "column", gap: "16px" } }, /* @__PURE__ */ React__default.createElement(Box, null, "When you send an SMS, there will be a cost of 12 cents per message. This is a cost that will be added to your weekly billing cycle. Total costs are dependent on how many SMS messages are sent."), /* @__PURE__ */ React__default.createElement(
      Checkbox,
      {
        label: "I agree to these additional costs",
        selected: agreeToTerms,
        onChange: setAgreeToTerms,
        color: theme2.colors.charcoal
      }
    ))
  );
};
EnableSmsModal.defaultProps = {
  onConfirm: () => {
  },
  heading: "Confirmation",
  isOpen: false,
  onClose: () => {
  }
};
EnableSmsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  heading: PropTypes.string
};
const mapStateToProps$2n = (state) => ({});
const mapDispatchToProps$2m = (dispatch) => bindActionCreators({}, dispatch);
const EnableSmsModal$1 = connect(mapStateToProps$2n, mapDispatchToProps$2m)(EnableSmsModal);
const useStyles$1b = createUseStyles((theme2) => ({
  messageSettingCardContainer: {},
  messageSettingCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    userSelect: "none",
    gap: "40px",
    height: "54px"
  },
  messageSettingCardHeading: {
    ...theme2.typography.heading.smallHeading
  },
  messageSettingCardDetail: {
    ...theme2.typography.body.bodyText,
    color: theme2.colors.smoke
  },
  left: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%"
  },
  right: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-end",
    userSelect: "none",
    gap: "40px"
  }
}));
const MessageSettingCard = ({
  title,
  description: description2,
  onChangeEmail,
  onChangeSms,
  allowChangeEmail,
  allowChangeSms,
  enableEmail,
  enableSms
}) => {
  const classes = useStyles$1b();
  const handleToggleEmail = (newValue) => {
    onChangeEmail(newValue);
  };
  const handleToggleSms = (newValue) => {
    onChangeSms(newValue);
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.messageSettingCardContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.messageSettingCard }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.left }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.messageSettingCardHeading }, title), /* @__PURE__ */ React__default.createElement(Box, { className: classes.messageSettingCardDetail }, description2)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.right }, allowChangeEmail && /* @__PURE__ */ React__default.createElement(Toggle, { label: "Email", checked: enableEmail, onChange: handleToggleEmail }), /* @__PURE__ */ React__default.createElement(Box, { style: { width: "102px" } }, allowChangeSms && /* @__PURE__ */ React__default.createElement(Toggle, { label: "SMS", checked: enableSms, onChange: handleToggleSms })))));
};
MessageSettingCard.defaultProps = {
  title: "Confirmation",
  description: "Send booking details to let the guest know their table is reserved.",
  allowChangeEmail: true,
  allowChangeSms: false,
  enableEmail: false,
  enableSms: false,
  onChangeEmail: () => {
  },
  onChangeSms: () => {
  }
};
MessageSettingCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  allowChangeEmail: PropTypes.bool,
  allowChangeSms: PropTypes.bool,
  enableEmail: PropTypes.bool,
  enableSms: PropTypes.bool,
  onChangeEmail: PropTypes.func,
  onChangeSms: PropTypes.func
};
const mapStateToProps$2m = (state) => ({});
const mapDispatchToProps$2l = (dispatch) => bindActionCreators({}, dispatch);
const MessagesSettingCard = connect(mapStateToProps$2m, mapDispatchToProps$2l)(MessageSettingCard);
const Messages = ({ messagesSettings, updateMessagesSettings: updateMessagesSettings2, fetchMessagesSettings: fetchMessagesSettings2 }) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g;
  const [showSmsConfirmationForConfirmation, setShowSmsConfirmationForConfirmation] = useState(false);
  const [showSmsConfirmationForReminder, setShowSmsConfirmationForReminder] = useState(false);
  const classes = useStyles$1w();
  const loading = useFetchOnFirstRender([fetchMessagesSettings2], [messagesSettings]);
  const [enableConfirmationEmail, setEnableConfirmationEmail] = useState(
    (_a = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _a.confirmationEmail
  );
  const [enableConfirmationSms, setEnableConfirmationSms] = useState(
    (_b2 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _b2.confirmationSMS
  );
  const [enableReminderEmail, setEnableReminderEmail] = useState(
    (_c2 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _c2.reminderEmail
  );
  const [enableReminderSms, setEnableReminderSms] = useState((_d2 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _d2.reminderSMS);
  const [enableThankYouEmail, setEnableThankYouEmail] = useState(
    (_e2 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _e2.thankYouEmail
  );
  const [enableCancellationEmail, setEnableCancellationEmail] = useState(
    (_f = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _f.cancellationEmail
  );
  const [enableWaitlistEmail, setEnableWaitlistEmail] = useState(
    (_g = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _g.waitlistEmail
  );
  useEffect(() => {
    var _a2, _b3, _c3, _d3, _e3, _f2, _g2;
    setEnableConfirmationEmail((_a2 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _a2.confirmationEmail);
    setEnableConfirmationSms((_b3 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _b3.confirmationSMS);
    setEnableReminderEmail((_c3 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _c3.reminderEmail);
    setEnableReminderSms((_d3 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _d3.reminderSMS);
    setEnableThankYouEmail((_e3 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _e3.thankYouEmail);
    setEnableCancellationEmail((_f2 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _f2.cancellationEmail);
    setEnableWaitlistEmail((_g2 = messagesSettings == null ? void 0 : messagesSettings.data) == null ? void 0 : _g2.waitlistEmail);
  }, [messagesSettings.data]);
  const changeSetting = (label, newValue) => {
    const changedSetting = {};
    changedSetting[label] = newValue;
    updateMessagesSettings2(changedSetting);
  };
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(Skeleton$1, { height: 600 });
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsPage, style: { maxWidth: "1300px" } }, /* @__PURE__ */ React__default.createElement(
    MessagesSettingCard,
    {
      title: "Confirmation",
      description: "Send the booking details just after a guest has made a booking",
      allowChangeSms: true,
      enableEmail: !isObee() && enableConfirmationEmail,
      enableSms: enableConfirmationSms,
      onChangeEmail: (newValue) => {
        setEnableConfirmationEmail(newValue);
        changeSetting("confirmationEmail", newValue);
      },
      onChangeSms: (newValue) => {
        if (newValue === true) {
          setShowSmsConfirmationForConfirmation(true);
          return;
        }
        setEnableConfirmationSms(newValue);
        changeSetting("confirmationSMS", newValue);
      }
    }
  ), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(
    MessagesSettingCard,
    {
      title: "Reminder",
      description: "Request the guest confirm that they’re still coming to their booking",
      allowChangeSms: true,
      enableEmail: !isObee() && enableReminderEmail,
      enableSms: enableReminderSms,
      onChangeEmail: (newValue) => {
        setEnableReminderEmail(newValue);
        changeSetting("reminderEmail", newValue);
      },
      onChangeSms: (newValue) => {
        if (newValue === true) {
          setShowSmsConfirmationForReminder(true);
          return;
        }
        setEnableReminderSms(newValue);
        changeSetting("reminderSMS", newValue);
      }
    }
  ), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(
    EnableSmsModal$1,
    {
      isOpen: showSmsConfirmationForConfirmation,
      onClose: () => setShowSmsConfirmationForConfirmation(false),
      heading: "Send SMS confirmations",
      onConfirm: () => {
        setEnableConfirmationSms(true);
        changeSetting("confirmationSMS", true);
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    EnableSmsModal$1,
    {
      isOpen: showSmsConfirmationForReminder,
      onClose: () => setShowSmsConfirmationForReminder(false),
      heading: "Send SMS reminders",
      onConfirm: () => {
        setEnableReminderSms(true);
        changeSetting("reminderSMS", true);
      }
    }
  ));
};
Messages.propTypes = {
  updateMessagesSettings: PropTypes.func.isRequired,
  fetchMessagesSettings: PropTypes.func.isRequired,
  messagesSettings: messagesSettingsPropTypes.isRequired
};
const mapStateToProps$2l = (state) => ({
  messagesSettings: state.messagesSettings,
  restaurant: state.restaurantActive.restaurant,
  user: state.user
});
const mapDispatchToProps$2k = (dispatch) => bindActionCreators(
  {
    updateMessagesSettings: updateMessagesSettingsAction,
    fetchMessagesSettings: fetchMessagesSettingsAction
  },
  dispatch
);
const Messages$1 = connect(mapStateToProps$2l, mapDispatchToProps$2k)(Messages);
const BrandingSection = ({ children, label }) => {
  const theme2 = useTheme$1();
  const isBreakpointDownSm = useBreakpointDown("sm");
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        alignItems: "baseline",
        display: "grid",
        gap: "32px",
        paddingTop: "10px",
        gridTemplateColumns: !isBreakpointDownSm && "160px auto"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { style: { ...theme2.typography.heading.smallHeading } }, label),
    /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: "l", style: { maxWidth: "480px" } }, children)
  );
};
BrandingSection.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired
};
const BrandingSection$1 = BrandingSection;
const Branding = ({
  addMessage: addMessage2,
  brandedEmailSettings,
  restaurant,
  fetchBrandedEmailSettings: fetchBrandedEmailSettings2,
  setFormEditing,
  updateBrandedEmailSettings: updateBrandedEmailSettings2
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g;
  const classes = useStyles$1w();
  const handleError2 = (message) => {
    addMessage2(`UPLOAD_IMAGE_ERROR_${(/* @__PURE__ */ new Date()).getTime()}`, `${message}`, "error");
  };
  const loading = useFetchOnFirstRender([fetchBrandedEmailSettings2], [brandedEmailSettings]);
  const textAreaStyle = { label: { color: "#6E6E6D", fontWeight: 500 } };
  const colorPickerStyle = {
    colorPicker: { minWidth: "unset" },
    inputContainer: { width: "128px" },
    label: { whiteSpace: "nowrap" }
  };
  const formFields = useMemo(() => {
    var _a2, _b3, _c3, _d3, _e3, _f2, _g2, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
    const fields = [
      // Messaging
      { id: "confirmationMessage", value: ((_a2 = brandedEmailSettings.data) == null ? void 0 : _a2.confirmationMessage) ?? "" },
      { id: "reminderMessage", value: ((_b3 = brandedEmailSettings.data) == null ? void 0 : _b3.reminderMessage) ?? "" },
      { id: "followupMessage", value: ((_c3 = brandedEmailSettings.data) == null ? void 0 : _c3.followupMessage) ?? "" },
      { id: "cancellationMessage", value: ((_d3 = brandedEmailSettings.data) == null ? void 0 : _d3.cancellationMessage) ?? "" },
      { id: "waitlistMessage", value: ((_e3 = brandedEmailSettings.data) == null ? void 0 : _e3.waitlistMessage) ?? "" },
      // Theming
      // Navigation
      { id: "logoUrl", value: (_f2 = brandedEmailSettings.data) == null ? void 0 : _f2.logoUrl },
      {
        id: "navigationBackgroundColor",
        value: (_g2 = brandedEmailSettings.data) == null ? void 0 : _g2.navigationBackgroundColor
      },
      // Main content
      { id: "featureImageUrl", value: (_h = brandedEmailSettings.data) == null ? void 0 : _h.featureImageUrl },
      { id: "bodyBackgroundColor", value: (_i = brandedEmailSettings.data) == null ? void 0 : _i.bodyBackgroundColor },
      { id: "emailBackgroundColor", value: (_j = brandedEmailSettings.data) == null ? void 0 : _j.emailBackgroundColor },
      { id: "emailBorderColor", value: (_k = brandedEmailSettings.data) == null ? void 0 : _k.emailBorderColor },
      { id: "fontColor", value: (_l = brandedEmailSettings.data) == null ? void 0 : _l.fontColor },
      { id: "buttonColor", value: (_m = brandedEmailSettings.data) == null ? void 0 : _m.buttonColor },
      { id: "buttonTextColor", value: (_n = brandedEmailSettings.data) == null ? void 0 : _n.buttonTextColor },
      { id: "bookingLabelColor", value: (_o = brandedEmailSettings.data) == null ? void 0 : _o.bookingLabelColor },
      { id: "textLinkColor", value: (_p = brandedEmailSettings.data) == null ? void 0 : _p.textLinkColor },
      // Footer
      { id: "showProviderLogo", value: (_q = brandedEmailSettings.data) == null ? void 0 : _q.showProviderLogo }
    ];
    return fields;
  }, [brandedEmailSettings.data]);
  const form = useForm(
    formFields,
    updateBrandedEmailSettings2,
    (value) => setFormEditing("messagesSettings", value)
  );
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(Skeleton$1, { height: 600 });
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsPage, style: { maxWidth: "1300px" } }, /* @__PURE__ */ React__default.createElement(BrandingSection$1, { label: "Messaging" }, /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Confirmation message",
      style: textAreaStyle,
      value: `${(_a = form.fields.confirmationMessage) == null ? void 0 : _a.value}`,
      onChange: (newValue) => form.setFieldValue("confirmationMessage", newValue),
      placeholder: "Empty"
    }
  ), /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Reminder message",
      style: textAreaStyle,
      value: `${(_b2 = form.fields.reminderMessage) == null ? void 0 : _b2.value}`,
      onChange: (newValue) => form.setFieldValue("reminderMessage", newValue),
      placeholder: "Empty"
    }
  ), /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Thank you message",
      style: textAreaStyle,
      value: `${(_c2 = form.fields.followupMessage) == null ? void 0 : _c2.value}`,
      onChange: (newValue) => form.setFieldValue("followupMessage", newValue),
      placeholder: "Empty"
    }
  ), /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Cancellation message",
      style: textAreaStyle,
      value: `${(_d2 = form.fields.cancellationMessage) == null ? void 0 : _d2.value}`,
      onChange: (newValue) => form.setFieldValue("cancellationMessage", newValue),
      placeholder: "Empty"
    }
  ), /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Waitlist message",
      style: textAreaStyle,
      value: `${(_e2 = form.fields.waitlistMessage) == null ? void 0 : _e2.value}`,
      onChange: (newValue) => form.setFieldValue("waitlistMessage", newValue),
      placeholder: "Empty"
    }
  )), (hasBrandingSettings(restaurant) || canEditAll()) && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(BrandingSection$1, { label: "Theming" }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { fontWeight: 500, marginBottom: "10px" } }, "Navigation"), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: "l" }, /* @__PURE__ */ React__default.createElement(
    ImageUpload$1,
    {
      fileLink: (_f = form.fields.logoUrl) == null ? void 0 : _f.value,
      onChange: (value) => form.setFieldValue("logoUrl", value),
      minWidth: 240,
      minHeight: 130,
      onRemove: () => form.setFieldValue("logoUrl", ""),
      onError: handleError2,
      onUpload: obeeImageUploadUrlAction,
      fileNamePrepend: `${restaurant.objectId}_email_logo`,
      label: "Logo"
    }
  ), /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.navigationBackgroundColor.value,
      onChange: (newValue) => form.setFieldValue("navigationBackgroundColor", newValue),
      label: "Navigation background colour",
      style: colorPickerStyle
    }
  ))), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { fontWeight: 500, marginBottom: "10px" } }, "Main content"), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: "l" }, /* @__PURE__ */ React__default.createElement(
    ImageUpload$1,
    {
      fileLink: (_g = form.fields.featureImageUrl) == null ? void 0 : _g.value,
      onChange: (value) => form.setFieldValue("featureImageUrl", value),
      minWidth: 240,
      minHeight: 130,
      onRemove: () => form.setFieldValue("featureImageUrl", ""),
      onError: handleError2,
      onUpload: obeeImageUploadUrlAction,
      fileNamePrepend: `${restaurant.objectId}_email_main_image`,
      label: "Main image"
    }
  ), /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.bodyBackgroundColor.value,
      onChange: (newValue) => form.setFieldValue("bodyBackgroundColor", newValue),
      label: "Main background colour",
      style: colorPickerStyle
    }
  ), /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.emailBackgroundColor.value,
      onChange: (newValue) => form.setFieldValue("emailBackgroundColor", newValue),
      label: "Template background colour",
      style: colorPickerStyle
    }
  ), /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.emailBorderColor.value,
      onChange: (newValue) => form.setFieldValue("emailBorderColor", newValue),
      label: "Border colour",
      style: colorPickerStyle
    }
  )), /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.fontColor.value,
      onChange: (newValue) => form.setFieldValue("fontColor", newValue),
      label: "Font colour",
      style: colorPickerStyle
    }
  ), /* @__PURE__ */ React__default.createElement(Spacer, { gap: 16 }, /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.buttonColor.value,
      onChange: (newValue) => form.setFieldValue("buttonColor", newValue),
      label: "Button colour",
      style: colorPickerStyle
    }
  ), /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.buttonTextColor.value,
      onChange: (newValue) => form.setFieldValue("buttonTextColor", newValue),
      label: "Button text colour",
      style: colorPickerStyle
    }
  ), /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.bookingLabelColor.value,
      onChange: (newValue) => form.setFieldValue("bookingLabelColor", newValue),
      label: "Booking label colour",
      style: colorPickerStyle
    }
  ), /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: form.fields.textLinkColor.value,
      onChange: (newValue) => form.setFieldValue("textLinkColor", newValue),
      label: "Text link colour",
      style: colorPickerStyle
    }
  )))), /* @__PURE__ */ React__default.createElement(Divider, null), canEditAll() && /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { fontWeight: 500, marginBottom: "10px" } }, "Footer"), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: "l" }, /* @__PURE__ */ React__default.createElement(
    Dropdown$1,
    {
      label: `${isObee() ? "Obee" : "EatClub"} logo`,
      items: [
        { value: true, label: "Show" },
        { value: false, label: "Hide" }
      ],
      value: form.fields.showProviderLogo.value,
      onSelect: (value) => form.setFieldValue("showProviderLogo", value)
    }
  ))))), /* @__PURE__ */ React__default.createElement(SaveFooter$1, { form }));
};
Branding.propTypes = {
  addMessage: PropTypes.func.isRequired,
  brandedEmailSettings: brandedEmailSettingsPropTypes.isRequired,
  fetchBrandedEmailSettings: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  setFormEditing: PropTypes.func.isRequired,
  updateBrandedEmailSettings: PropTypes.func.isRequired
};
const mapStateToProps$2k = (state) => ({
  brandedEmailSettings: state.brandedEmailSettings,
  restaurant: state.restaurantActive.restaurant
});
const mapDispatchToProps$2j = (dispatch) => bindActionCreators(
  {
    addMessage: addMessageAction,
    fetchBrandedEmailSettings: fetchBrandedEmailSettingsAction,
    setFormEditing: setFormEditingAction,
    updateBrandedEmailSettings: updateBrandedEmailSettingsAction
  },
  dispatch
);
const Branding$1 = connect(mapStateToProps$2k, mapDispatchToProps$2j)(Branding);
const MessagesSettings = () => {
  const history = useHistory();
  const query = useQuery();
  const classes = useStyles$1w();
  const steps = [
    { title: "Messages", id: "messages" },
    { title: "Branding", id: "branding" }
  ];
  const [activeStep, setActiveStep] = useState((query == null ? void 0 : query.get("step")) || "messages");
  const handleChangeStep = (step) => {
    history.replace({
      search: `?tab=messages&step=${step}`
    });
    setActiveStep(step);
  };
  const getStep = () => {
    if (isObee()) {
      switch (activeStep) {
        case "branding":
        default:
          return /* @__PURE__ */ React__default.createElement(Branding$1, null);
      }
    } else {
      switch (activeStep) {
        case "branding":
          return /* @__PURE__ */ React__default.createElement(Branding$1, null);
        case "messages":
        default:
          return /* @__PURE__ */ React__default.createElement(Messages$1, null);
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsPage, style: { maxWidth: "1300px" } }, !isObee() && /* @__PURE__ */ React__default.createElement(Box, { className: classes.subNavigation }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: "l" }, steps.map((step) => /* @__PURE__ */ React__default.createElement(
    Button,
    {
      id: step.id,
      onClick: () => handleChangeStep(step.id),
      type: "text",
      style: {
        fontSize: "18px",
        fontWeight: step.id === activeStep && 700,
        borderBottom: step.id === activeStep ? "2px solid black" : "1px solid #E6E6E6",
        button: {
          padding: "22px 0"
        }
      }
    },
    step.title
  )))), getStep());
};
MessagesSettings.propTypes = {};
const mapStateToProps$2j = (state) => ({});
const mapDispatchToProps$2i = (dispatch) => bindActionCreators({}, dispatch);
const MessagesSettings$1 = connect(mapStateToProps$2j, mapDispatchToProps$2i)(MessagesSettings);
const closeRestaurantEarlyAction = (sessions) => (dispatch) => {
  const action = "CLOSE_RESTAURANT";
  const entityName = "closeEarly";
  const successMessage = "Restaurant is now closed for the day";
  const errorMessage = "Failed to set restaurant as closed";
  const data = {};
  (async () => {
    const fullyBookedInputData = {
      date: moment$2().format("YYYY-MM-DD"),
      sessions: only(sessions, OBFullyBookedCreateInput())
    };
    const response = await createFullyBookedSessions(fullyBookedInputData);
    if (response == null ? void 0 : response.error) {
      const message = "Unable to fully book when trying to close early";
      devLog("error", "closeEarly", message);
      dispatch(addMessageAction(action, message, "error"));
      return;
    }
    dispatch({
      type: `BULK_UPDATE_FULLY_BOOKED_SESSIONS_SUCCESS`,
      payload: response
    });
    const request = () => closeEarly(data);
    dispatch(
      makeApiAction(action, request, {}, entityName, successMessage, null, false, errorMessage)
    );
  })();
};
const reopenRestaurantAction = (sessions) => (dispatch) => {
  const action = "REOPEN_RESTAURANT";
  const entityName = "reopen";
  const successMessage = "Restaurant is now reopened for the day";
  const errorMessage = "Failed to set restaurant as reopened";
  const data = {};
  (async () => {
    const fullyBookedInputData = {
      date: moment$2().format("YYYY-MM-DD"),
      sessions: only(sessions, OBFullyBookedDeleteInput())
    };
    const response = await deleteFullyBookedSessions(fullyBookedInputData);
    if (response == null ? void 0 : response.error) {
      const message = "Unable to remove fully book status when reopening";
      devLog("error", "reopen", message);
      dispatch(addMessageAction(action, message, "error"));
      return;
    }
    dispatch({
      type: `BULK_UPDATE_FULLY_BOOKED_SESSIONS_SUCCESS`,
      payload: response
    });
    const request = () => reopen(data);
    dispatch(
      makeApiAction(action, request, {}, entityName, successMessage, null, false, errorMessage)
    );
  })();
};
const SvgSitting = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 9, cy: 9, r: 8.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 9.05005, y1: 3.6001, x2: 9.05005, y2: 13.5001, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 13.5, y1: 8.6001, x2: 4.5, y2: 8.6001, stroke: "currentColor" }));
const PlusSVG = SvgSitting;
const useStyles$1a = createUseStyles((theme2) => ({
  modalHeader: {
    background: theme2.colors.linen,
    padding: "0 24px",
    height: "40px",
    display: "flex",
    alignItems: "center"
  },
  innerContainer: {
    color: theme2.colors.charcoal,
    display: "flex",
    flexDirection: "column",
    fontSize: "15px"
  },
  fieldsContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 24px",
    gap: "20px"
  },
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  title: {
    ...theme2.typography.heading.H4
  },
  subtitle: {
    ...theme2.typography.body.PL,
    color: theme2.colors.smoke,
    marginBottom: "20px"
  },
  bottomSection: {
    borderTop: `1px solid ${theme2.colors.linkIconBackground}`
  },
  button: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    fontSize: "15px"
  },
  showField: {
    marginTop: "10px",
    fontSize: "14px",
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.olive3
  },
  sittingRowContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  sittingsTitle: {
    fontWeight: theme2.fontWeights.medium
  },
  sittingRow: {
    display: "flex",
    border: `1px solid ${theme2.colors.cloud}`,
    borderRadius: "4px",
    cursor: "pointer",
    boxShadow: "0px 4px 3px rgba(240, 240, 240, 0.25)",
    height: "36px"
  },
  sittingRowNumber: {
    backgroundColor: theme2.colors.cloud,
    padding: "8px",
    width: "30px",
    textAlign: "center",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  sittingRowDetails: {
    padding: "8px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  sittingsContent: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 24px",
    gap: "20px"
  },
  styleCardContainer: {
    border: "1px solid #D9D9D9",
    borderRadius: "16px",
    fontSize: "15px",
    display: "flex",
    height: "180px",
    width: "100%",
    transition: "border 0.1s",
    "&:hover": {
      cursor: "pointer",
      border: `1px solid ${theme2.colors.charcoal}`
    }
  },
  styleCardIcon: {
    background: "#D9D9D9",
    // TODO use theme
    width: "90px",
    height: "100%",
    borderRadius: "16px",
    flexShrink: 0
  },
  styleCardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "20px",
    fontSize: "15px"
  },
  styleCardHeading: {
    fontWeight: theme2.fontWeights.bold,
    display: "flex",
    gap: "20px",
    alignItems: " center",
    fontSize: "18px",
    color: theme2.colors.charcoal
  },
  styleCardSubHeading: {
    color: theme2.colors.smoke
  },
  enabled: {
    color: theme2.colors.charcoal,
    fontWeight: theme2.fontWeights.medium,
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginTop: "auto"
  }
}));
const tabBarStyles$3 = (theme2) => ({
  overflowX: "auto",
  fontWeight: theme2.fontWeights.regular,
  marginRight: "37px",
  containerInner: {
    gap: "12px"
  },
  tab: {
    padding: "0 13px",
    borderRadius: "100px",
    fontSize: "15px",
    lineHeight: "15px",
    transition: "background-color 0.1s",
    whiteSpace: "nowrap",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    border: "1px solid transparent",
    overflowX: theme2.overlay
  },
  tabActive: {
    fontWeight: theme2.fontWeights.medium,
    backgroundColor: "transparent",
    padding: "9px 13px",
    paddingBottom: "9px",
    color: "black",
    border: "1px solid black",
    borderBottom: "1px solid black"
  },
  tabHover: {
    backgroundColor: theme2.colors.whiteSmoke,
    color: theme2.colors.charcoal,
    filter: "none"
  }
});
const customButtonStyles = (theme2) => ({
  container: { width: "100%", padding: "8px" },
  button: {
    width: "100%",
    padding: "0 16px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    height: "36px"
  },
  buttonHover: { backgroundColor: theme2.colors.notificationBackgroundGray }
});
const fieldStyles$1 = {
  value: { height: "36px", padding: "0 12px" },
  container: { fontSize: "inherit", height: "unset", width: "450px" },
  errorText: { margin: "3px 0 0 0" },
  item: { fontSize: "15px", padding: "0 16px", height: "36px" },
  popover: { padding: "8px" },
  items: { display: "flex", flexDirection: "column", gap: "4px" }
};
const buttonStyles$3 = {
  container: { width: "100%", padding: "12px 24px" },
  button: {
    width: "100%",
    padding: "0 24px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "15px"
  }
};
const smallButtonStyles = {
  button: {
    height: "36px",
    display: "flex",
    justifyContent: "center",
    fontSize: "15px"
  }
};
const popoverAnchors$1 = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "right"
  }
};
const CreateSitting = ({
  anchor,
  onClose,
  onCreateSitting,
  sessionStartTime,
  sessionEndTime,
  existingSittings
}) => {
  const classes = useStyles$1a();
  const [startTime, setStartTime] = useState(formatTimeFromInt(sessionStartTime, "h:mma"));
  const [startTimeError, setStartTimeError] = useState(null);
  const allTimes = numberRange(sessionStartTime, sessionEndTime - 15, 15, true).map((time) => {
    const timeFormatted = formatTimeFromInt(time, "h:mma");
    return {
      label: timeFormatted,
      value: timeFormatted
    };
  });
  useEffect(() => {
    if (anchor) {
      setStartTime(formatTimeFromInt(sessionStartTime, "h:mma"));
    }
  }, [anchor]);
  useEffect(() => {
    if (anchor) {
      setStartTimeError(null);
    }
  }, [anchor, startTime]);
  const valid = () => {
    const startTimeAsInt = formatIntFromTime(moment$2(startTime, "h:mma"));
    if (startTimeAsInt < sessionStartTime || startTimeAsInt > sessionEndTime) {
      setStartTimeError("This sitting time falls outside of the session times.");
      return false;
    }
    if (existingSittings.some((existingSitting) => existingSitting.startTime === startTime)) {
      setStartTimeError("This sitting time exists.");
      return false;
    }
    return true;
  };
  const createNewSitting = () => {
    if (valid()) {
      const newSitting = {
        startTime
      };
      onCreateSitting(newSitting);
      onClose();
    }
  };
  const popoverAnchors2 = {
    anchorOrigin: {
      vertical: "center",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "center",
      horizontal: "right"
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchor,
      onClose,
      anchorEl: anchor,
      innerStyle: {
        marginLeft: "-10px",
        marginTop: "0",
        borderRadius: "6px",
        padding: "0"
      },
      ...popoverAnchors2
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Add sitting")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingsContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Start time",
        items: allTimes,
        value: startTime,
        onSelect: setStartTime,
        error: startTimeError,
        style: cleanDropdownPopoverStyles,
        disabled: isEmpty(allTimes)
      }
    ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        style: buttonStyles$3,
        type: "tertiary",
        onClick: createNewSitting,
        disabled: !isEmpty(startTimeError)
      },
      "Add sitting"
    ))))
  );
};
CreateSitting.defaultProps = {
  anchor: null,
  onCreateSitting: () => {
  },
  existingSittings: null,
  sessionStartTime: null,
  sessionEndTime: null
};
CreateSitting.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.func,
  onCreateSitting: PropTypes.func,
  sessionStartTime: PropTypes.number,
  sessionEndTime: PropTypes.number,
  existingSittings: PropTypes.arrayOf(PropTypes.string)
};
const mapStateToProps$2i = () => ({});
const mapDispatchToProps$2h = (dispatch) => bindActionCreators({}, dispatch);
const CreateSitting$1 = connect(mapStateToProps$2i, mapDispatchToProps$2h)(CreateSitting);
const sittingPropTypes = PropTypes.shape({
  id: PropTypes.string,
  sessionId: PropTypes.string,
  startTime: PropTypes.number,
  endTime: PropTypes.number
});
PropTypes.shape({
  data: PropTypes.arrayOf(sittingPropTypes),
  apiData: PropTypes.arrayOf(sittingPropTypes),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // The reducers are inconsistent
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  pending: PropTypes.bool
});
const EditSitting = ({
  anchor,
  onClose,
  onEditSitting,
  onDelete: onDelete2,
  sitting,
  sessionStartTime,
  sessionEndTime,
  existingSittings
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1a();
  const [startTime, setStartTime] = useState(sitting == null ? void 0 : sitting.startTime);
  const [startTimeError, setStartTimeError] = useState(null);
  const allTimes = numberRange(sessionStartTime, sessionEndTime - 15, 15, true).map((time) => {
    const timeFormatted = formatTimeFromInt(time, "h:mma");
    return {
      label: timeFormatted,
      value: timeFormatted
    };
  });
  useEffect(() => {
    if (anchor) {
      setStartTime(sitting == null ? void 0 : sitting.startTime);
    }
  }, [anchor, sitting]);
  useEffect(() => {
    if (anchor) {
      setStartTimeError(null);
    }
  }, [anchor, startTime]);
  const valid = () => {
    const startTimeAsInt = formatIntFromTime(moment$2(startTime, "h:mma"));
    if (startTimeAsInt < sessionStartTime || startTimeAsInt > sessionEndTime) {
      setStartTimeError("This sitting time falls outside of the session times.");
      return false;
    }
    if (existingSittings.some(
      (existingSitting) => existingSitting.startTime === startTime && existingSitting.startTime !== (sitting == null ? void 0 : sitting.startTime)
    )) {
      setStartTimeError("This sitting time exists.");
      return false;
    }
    return true;
  };
  const editSitting = () => {
    if (valid()) {
      const updatedSitting = {
        ...sitting,
        startTime
      };
      onEditSitting(updatedSitting);
      onClose();
    }
  };
  const handleDelete = () => {
    onClose();
    onDelete2();
  };
  const popoverAnchors2 = {
    anchorOrigin: {
      vertical: "center",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "center",
      horizontal: "right"
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen: !!anchor,
      onClose,
      anchorEl: anchor,
      innerStyle: {
        marginLeft: "-10px",
        marginTop: "0",
        borderRadius: "6px",
        padding: "0"
      },
      ...popoverAnchors2
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Edit sitting")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingsContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Start time",
        items: allTimes,
        value: startTime,
        onSelect: setStartTime,
        error: startTimeError,
        style: cleanDropdownPopoverStyles,
        disabled: isEmpty(allTimes)
      }
    ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: {
          container: { width: "100%", padding: "10px 12px" },
          button: {
            width: "100%",
            padding: "6px 12px",
            borderRadius: "6px"
          },
          buttonHover: { backgroundColor: theme2.colors.notificationBackgroundGray }
        },
        centered: false,
        onClick: handleDelete
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete sitting"))
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        style: buttonStyles$3,
        type: "tertiary",
        onClick: editSitting,
        disabled: !isEmpty(startTimeError)
      },
      "Update sitting"
    ))))
  );
};
EditSitting.defaultProps = {
  anchor: null,
  sitting: null,
  onEditSitting: () => {
  },
  onDelete: () => {
  },
  existingSittings: null,
  sessionStartTime: 0,
  sessionEndTime: 0
};
EditSitting.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.func,
  sitting: sittingPropTypes,
  onEditSitting: PropTypes.func,
  onDelete: PropTypes.func,
  sessionStartTime: PropTypes.number,
  sessionEndTime: PropTypes.number,
  existingSittings: PropTypes.arrayOf(PropTypes.string)
};
const mapStateToProps$2h = () => ({});
const mapDispatchToProps$2g = (dispatch) => bindActionCreators({}, dispatch);
const EditSitting$1 = connect(mapStateToProps$2h, mapDispatchToProps$2g)(EditSitting);
const CreateSession = ({
  anchor,
  onClose,
  restaurantOpen,
  restaurantClose,
  areaId,
  createGlobalSession: createGlobalSession2,
  createSession: createSession2,
  obeeGlobalSessions: obeeGlobalSessions2,
  obeeSessions: obeeSessions2
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1a();
  const [days, setDays] = useState(["mon", "tue", "wed", "thu", "fri"]);
  const [daysError, setDaysError] = useState(null);
  const [label, setLabel] = useState("dinner");
  const [startTime, setStartTime] = useState(restaurantOpen);
  const [startTimeError, setStartTimeError] = useState(null);
  const [endTime, setEndTime] = useState(restaurantOpen + 60);
  const [endTimeError, setEndTimeError] = useState(null);
  const [sittings, setSittings] = useState([]);
  const [sittingAnchor, setSittingAnchor] = useState(null);
  const [editSittingAnchor, setEditSittingAnchor] = useState(null);
  const [editingSitting, setEditingSitting] = useState(null);
  const [creating, setCreating] = useState(false);
  const allTimes = numberRange(restaurantOpen, Math.min(restaurantClose, 1425), 15, true).map(
    (time) => ({
      label: formatTimeFromInt(time, "h:mm a"),
      value: time
    })
  );
  const allWeekdays = weekdays();
  useEffect(() => {
    if (anchor) {
      unstable_batchedUpdates(() => {
        setDays(["mon", "tue", "wed", "thu", "fri"]);
        setLabel("dinner");
        setStartTime(restaurantOpen);
        setEndTime(restaurantOpen + 60);
        setSittings([]);
      });
    }
  }, [anchor]);
  useEffect(() => {
    unstable_batchedUpdates(() => {
      setStartTimeError(null);
      setEndTimeError(null);
    });
    if (isEmpty(days)) {
      setDaysError("This field is required.");
    } else {
      setDaysError(null);
    }
    const sessionsToCheck = (areaId === 0 ? obeeGlobalSessions2.data : obeeSessions2.data.filter((sessionToCheck) => sessionToCheck.areaId === areaId)).filter((sessionToCheck) => days.includes(sessionToCheck.day));
    const isOverlapping = sessionsToCheck.some(
      (sessionToCheck) => startTime < sessionToCheck.startTime && endTime > sessionToCheck.startTime || startTime < sessionToCheck.endTime && endTime > sessionToCheck.endTime
    );
    if (isOverlapping) {
      setStartTimeError("This session time overlaps with another session.");
      setEndTimeError("This session time overlaps with another session.");
      return;
    }
    if (startTime >= endTime) {
      setStartTimeError("The start time must be before the close time.");
    } else {
      setStartTimeError(null);
    }
    if (endTime <= startTime) {
      setEndTimeError("The close time must be after the start time.");
    } else {
      setEndTimeError(null);
    }
  }, [startTime, endTime, days, areaId]);
  const createNewSession = () => {
    setCreating(true);
    const sittingTimes = immutableSort(
      sittings,
      (a, b) => sortMomentByProperty(a, b, "startTime", "h:mma")
    ).map((sitting) => sitting.startTime);
    if (areaId === 0) {
      const newGlobalSession = {
        label,
        startTime,
        endTime,
        isPublic: true,
        days,
        sittingTimes: isEmpty(sittingTimes) ? null : sittingTimes
      };
      createGlobalSession2(newGlobalSession);
    } else {
      const newSession = {
        areaId,
        label,
        startTime,
        endTime,
        isPublic: true,
        days,
        sittingTimes: isEmpty(sittingTimes) ? null : sittingTimes
      };
      createSession2(newSession);
    }
  };
  useEffect(() => {
    if (obeeGlobalSessions2.success && creating) {
      setCreating(false);
      onClose();
    }
  }, [obeeGlobalSessions2.success]);
  useEffect(() => {
    if (obeeGlobalSessions2.error && creating) {
      setCreating(false);
    }
  }, [obeeGlobalSessions2.error]);
  useEffect(() => {
    if (obeeSessions2.success && creating) {
      setCreating(false);
      onClose();
    }
  }, [obeeSessions2.success]);
  useEffect(() => {
    if (obeeSessions2.error && creating) {
      setCreating(false);
    }
  }, [obeeSessions2.error]);
  const addSitting = (newSitting) => {
    setSittings([...sittings, { ...newSitting, pseudoId: generateRandomString(8) }]);
  };
  const updateSitting = (updatedSitting) => {
    setSittings(updateObjectByProperty(sittings, updatedSitting, "pseudoId"));
  };
  const removeSitting = () => {
    setSittings(removeFromArray(sittings, editingSitting));
    setEditingSitting(null);
  };
  const toggleDay = (day) => {
    if (days.includes(day)) {
      const index = days.indexOf(day);
      const newDays = [...days];
      newDays.splice(index, 1);
      setDays(newDays);
    } else {
      setDays([...days, day]);
    }
  };
  const hasErrors = useMemo(
    () => !isEmpty(daysError) || !isEmpty(startTimeError) || !isEmpty(endTimeError),
    [daysError, startTimeError, endTimeError]
  );
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen: !!anchor,
      onClose,
      anchorEl: anchor,
      innerStyle: {
        marginTop: "10px",
        borderRadius: "6px",
        padding: "0"
      },
      ...popoverAnchors$1
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Session")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.fieldsContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Day",
        items: allWeekdays,
        value: days,
        onSelect: toggleDay,
        multiselect: true,
        multiselectFormat: getDayRange,
        selectedItems: days,
        placeholder: "Select days for session",
        error: daysError,
        style: cleanDropdownPopoverStyles
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Label",
        items: sessionLabels(theme2),
        value: label,
        onSelect: setLabel,
        style: cleanDropdownPopoverStyles
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Start time",
        items: allTimes,
        value: startTime,
        onSelect: setStartTime,
        error: startTimeError,
        style: cleanDropdownPopoverStyles
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Close time",
        items: allTimes,
        value: endTime,
        onSelect: setEndTime,
        error: endTimeError,
        style: cleanDropdownPopoverStyles
      }
    )), sittings.length > 0 && /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", flexDirection: "column", gap: "8px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingsTitle }, "Sittings"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingRowContainer }, immutableSort(
      sittings,
      (a, b) => sortMomentByProperty(a, b, "startTime", "h:mma")
    ).map((sitting, index) => /* @__PURE__ */ React__default.createElement(
      Box,
      {
        key: sitting == null ? void 0 : sitting.pseudoId,
        className: classes.sittingRow,
        onClick: (e) => {
          setEditingSitting(sitting);
          setEditSittingAnchor(e.currentTarget);
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingRowNumber }, index + 1),
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingRowDetails }, "Starts ", sitting == null ? void 0 : sitting.startTime)
    )))))), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.linkIconBackground }), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: customButtonStyles(theme2),
        onClick: (e) => setSittingAnchor(e.currentTarget),
        disabled: startTime >= endTime
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(PlusSVG, { style: { color: theme2.colors.gray3, height: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Add sitting"))
    ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        style: buttonStyles$3,
        loading: creating,
        onClick: createNewSession,
        disabled: hasErrors || creating
      },
      "Create session"
    )))),
    /* @__PURE__ */ React__default.createElement(
      CreateSitting$1,
      {
        anchor: sittingAnchor,
        onClose: () => setSittingAnchor(null),
        onCreateSitting: addSitting,
        sessionStartTime: startTime,
        sessionEndTime: endTime,
        existingSittings: sittings
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      EditSitting$1,
      {
        anchor: editSittingAnchor,
        onClose: () => setEditSittingAnchor(null),
        onDelete: removeSitting,
        onEditSitting: updateSitting,
        sitting: editingSitting,
        sessionStartTime: startTime,
        sessionEndTime: endTime,
        existingSittings: sittings
      }
    )
  );
};
CreateSession.defaultProps = {
  anchor: null,
  restaurantOpen: 0,
  restaurantClose: 1440
};
CreateSession.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.func,
  restaurantOpen: PropTypes.number,
  restaurantClose: PropTypes.number,
  areaId: PropTypes.number.isRequired,
  createGlobalSession: PropTypes.func.isRequired,
  createSession: PropTypes.func.isRequired,
  obeeGlobalSessions: globalSessionsPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired
};
const mapStateToProps$2g = (state) => ({
  obeeGlobalSessions: state.obeeGlobalSessions,
  obeeSessions: state.obeeSessions
});
const mapDispatchToProps$2f = (dispatch) => bindActionCreators(
  {
    createGlobalSession: createGlobalSessionAction,
    createSession: createSessionAction
  },
  dispatch
);
const CreateSession$1 = connect(mapStateToProps$2g, mapDispatchToProps$2f)(CreateSession);
const SvgOverflow = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 5 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("ellipse", { cx: 2.54903, cy: 2.06668, rx: 1.79024, ry: 1.84207, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("ellipse", { cx: 2.54903, cy: 7.2244, rx: 1.79024, ry: 1.84207, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("ellipse", { cx: 2.54903, cy: 12.3826, rx: 1.79024, ry: 1.84207, fill: "currentColor" }));
const IconOverflowSVG = SvgOverflow;
const useStyles$19 = createUseStyles((theme2) => ({
  container: {
    overflowX: "auto"
  },
  overflowBtn: {
    color: theme2.colors.nimbus,
    padding: "4px",
    transition: "color 0.1s",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    "&:hover": {
      color: theme2.colors.smoke,
      cursor: "pointer"
    }
  }
}));
const useStyles$18 = createUseStyles((theme2) => ({
  container: (props) => {
    var _a;
    return {
      width: "400px",
      display: "flex",
      gap: "10px",
      alignItems: "center",
      height: "40px",
      fontSize: "18px",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.container
    };
  },
  label: (props) => {
    var _a;
    return {
      width: "140px",
      flexShrink: 0,
      color: theme2.colors.smoke,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.label
    };
  },
  activeValue: (props) => {
    var _a;
    return {
      background: theme2.colors.dateSelectBackground,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.activeValue
    };
  },
  value: (props) => {
    var _a, _b2, _c2;
    return {
      display: "flex",
      alignItems: "center",
      padding: "0 14px",
      height: "40px",
      // padding: '10px 14px',
      width: "100%",
      borderRadius: "6px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      userSelect: "none",
      justifyContent: "space-between",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.value,
      "&:hover": {
        background: theme2.colors.dateSelectBackground,
        cursor: "pointer",
        ...(_c2 = (_b2 = props == null ? void 0 : props.style) == null ? void 0 : _b2.value) == null ? void 0 : _c2["&:hover"]
      }
    };
  },
  valueOverflow: {
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  valuePlaceholder: (props) => {
    var _a;
    return {
      color: theme2.colors.nimbus,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.valuePlaceholder
    };
  },
  errorText: (props) => {
    var _a;
    return {
      color: theme2.colors.errorRed,
      fontSize: "10px",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.errorText
    };
  }
}));
const DatePopover = ({
  value,
  onSetDate,
  isOpen,
  onClose,
  anchor,
  datePickerProps,
  anchorOrigin,
  transformOrigin
}) => {
  const theme2 = useTheme$1();
  const handleCloseMenu = () => {
    onClose(null);
  };
  const changeDay = (newDay) => {
    onSetDate(moment$2(newDay));
    handleCloseMenu();
  };
  return /* @__PURE__ */ React__default.createElement(Box, { style: { position: "relative" } }, /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen,
      onClose: () => handleCloseMenu(),
      anchorEl: anchor,
      innerStyle: { marginTop: "10px", padding: "12px", borderRadius: "6px" },
      innerProps: { disableScrollLock: true },
      anchorOrigin,
      transformOrigin
    },
    /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      ObeeDatePicker,
      {
        inputProps: { inline: true, ...datePickerProps },
        onSelect: changeDay,
        value,
        showTodayButton: true,
        style: { header: { backgroundColor: theme2.colors.menuHighlightBackground } }
      }
    ))
  ));
};
DatePopover.defaultProps = {
  anchor: null,
  datePickerProps: {},
  value: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  }
};
DatePopover.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
  onSetDate: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.object,
  datePickerProps: PropTypes.shape({}),
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string
  }),
  transformOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string
  })
};
const mapStateToProps$2f = () => ({});
const mapDispatchToProps$2e = (dispatch) => bindActionCreators({}, dispatch);
const DatePopover$1 = connect(mapStateToProps$2f, mapDispatchToProps$2e)(DatePopover);
const CleanDatePopover = ({
  label,
  value,
  onSelect: onSelect2,
  placeholder,
  format,
  datePickerProps,
  disabled,
  error,
  clearError,
  style
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$18({ style, disabled });
  const [anchor, setAnchor] = useState(null);
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.wrapper }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.value} ${!!anchor && classes.activeValue} ${isEmpty(value) && classes.valuePlaceholder}`,
      style: {
        ...disabled ? {
          cursor: "default",
          backgroundColor: theme2.colors.dateSelectBackground,
          color: theme2.colors.nimbus
        } : {},
        ...error ? { border: `1px solid ${theme2.colors.red}` } : {}
      },
      onClick: (e) => {
        if (!disabled) {
          setAnchor(e.currentTarget);
        }
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.valueOverflow }, !isEmpty(value) ? formatDate(value, format) : placeholder)
  )), !isEmpty(error) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.errorText }, error)), !disabled && /* @__PURE__ */ React__default.createElement(
    DatePopover$1,
    {
      value,
      anchor,
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      onSetDate: (newValue) => {
        onSelect2(newValue);
        clearError();
      },
      datePickerProps
    }
  ));
};
CleanDatePopover.defaultProps = {
  placeholder: "",
  value: null,
  format: "ddd Do MMM YYYY",
  datePickerProps: {},
  disabled: false,
  onSelect: () => {
  },
  clearError: () => {
  },
  error: null,
  style: {}
};
CleanDatePopover.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  datePickerProps: PropTypes.shape({}),
  disabled: PropTypes.bool,
  clearError: PropTypes.func,
  error: PropTypes.string,
  style: PropTypes.shape({})
};
const CleanDatePopover$1 = CleanDatePopover;
const EditEventSession = ({
  anchor,
  onClose,
  restaurantOpen,
  restaurantClose,
  deleteEventSession: deleteEventSession2,
  session
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1a();
  const [label, setLabel] = useState("");
  const [labelError, setLabelError] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [startTimeError, setStartTimeError] = useState(null);
  const [finishTime, setFinishTime] = useState(null);
  const [finishTimeError, setFinishTimeError] = useState(null);
  const [date, setDate] = useState(null);
  const [dateError, setDateError] = useState(null);
  const [type2, setType] = useState("differentHours");
  const allTimes = numberRange(restaurantOpen, restaurantClose, 15, true).map((time) => ({
    label: formatTimeFromInt(time, "h:mm a"),
    value: time
  }));
  const requiredErrorMessage = "This field is required.";
  useErrorListener(label, isEmpty, setLabelError, requiredErrorMessage);
  useErrorListener(date, isEmpty, setDateError, requiredErrorMessage);
  useEffect(() => {
    if (startTime >= finishTime) {
      setStartTimeError("The start time must be before the close time.");
    } else {
      setStartTimeError(null);
    }
    if (finishTime <= startTime) {
      setFinishTimeError("The close time must be after the start time.");
    } else {
      setFinishTimeError(null);
    }
  }, [startTime, finishTime]);
  useEffect(() => {
    if (anchor) {
      unstable_batchedUpdates(() => {
        setLabel(session == null ? void 0 : session.label);
        setStartTime(session == null ? void 0 : session.startTime);
        setFinishTime(session == null ? void 0 : session.endTime);
        setDate(session == null ? void 0 : session.date);
        setType((session == null ? void 0 : session.startTime) === (session == null ? void 0 : session.endTime) ? "closed" : "differentHours");
      });
    }
  }, [anchor]);
  const isClosed = type2 === "closed";
  const onDateSelect = (value) => {
    setDate(formatDate(value, "YYYY-MM-DD"));
  };
  const handleDelete = () => {
    deleteEventSession2(session == null ? void 0 : session.objectId);
    onClose(null, false);
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen: !!anchor,
      onClose: () => {
        const isValid = [
          labelError,
          dateError,
          ...isClosed ? [] : [startTimeError, finishTimeError]
        ].every((error) => isEmpty(error));
        if (isValid) {
          const newSession = {
            ...session,
            label,
            startTime: isClosed ? 0 : startTime,
            endTime: isClosed ? 0 : finishTime,
            date
          };
          onClose(newSession, !deepEqual(session, newSession));
        } else {
          onClose(null, false);
        }
      },
      anchorEl: anchor,
      innerStyle: {
        borderRadius: "6px",
        padding: "0",
        marginTop: "10px",
        width: "100%",
        maxWidth: "500px"
      },
      ...popoverAnchors$1
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Events & holidays")), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: { display: "flex", flexDirection: "column", padding: "20px 24px", gap: "20px" }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
        CleanTextFieldComponent,
        {
          label: "Event name",
          placeholder: "Empty",
          style: {
            label: { fontSize: "15px", width: "140px" },
            input: { fontSize: "15px", height: "36px", padding: "0 12px" },
            ...fieldStyles$1
          },
          value: label,
          onChange: setLabel,
          error: labelError
        }
      ), /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "Date",
          placeholder: "Empty",
          value: date,
          onSelect: onDateSelect,
          style: fieldStyles$1,
          error: dateError
        }
      ), /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Type",
          items: typeItems,
          value: type2,
          onSelect: setType,
          style: fieldStyles$1
        }
      ), !isClosed && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Start time",
          items: allTimes,
          value: startTime,
          onSelect: setStartTime,
          error: startTimeError,
          style: fieldStyles$1
        }
      ), /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Finish time",
          items: allTimes,
          value: finishTime,
          onSelect: setFinishTime,
          error: finishTimeError,
          style: fieldStyles$1
        }
      )))
    ), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.linkIconBackground }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: {
          container: { width: "100%", padding: "8px" },
          button: {
            width: "100%",
            padding: "8px 16px",
            borderRadius: "6px"
          },
          buttonHover: { backgroundColor: theme2.colors.notificationBackgroundGray }
        },
        onClick: handleDelete
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete specific date"))
    ))))
  );
};
EditEventSession.defaultProps = {
  anchor: null,
  restaurantOpen: 0,
  restaurantClose: 1440,
  session: null
};
EditEventSession.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.func,
  restaurantOpen: PropTypes.number,
  restaurantClose: PropTypes.number,
  deleteEventSession: PropTypes.func.isRequired,
  session: globalSessionPropTypes
};
const mapStateToProps$2e = () => ({});
const mapDispatchToProps$2d = (dispatch) => bindActionCreators(
  {
    createEventSession: createEventSessionAction,
    deleteEventSession: deleteEventSessionAction
  },
  dispatch
);
const EditEventSession$1 = connect(mapStateToProps$2e, mapDispatchToProps$2d)(EditEventSession);
const EventsTable = ({
  fetchEventSessions,
  obeeEventSessions: obeeEventSessions2,
  startTime,
  endTime,
  updateEventSession: updateEventSession2,
  deleteEventSession: deleteEventSession2
}) => {
  const classes = useStyles$19();
  const [anchor, setAnchor] = useState(null);
  const [eventToEdit, setEventToEdit] = useState(null);
  const [eventOverflowAnchorEl, setEventOverflowAnchorEl] = useState(null);
  const loading = useFetchOnFirstRender([fetchEventSessions], [obeeEventSessions2]);
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(Box, null, "Loading...");
  }
  if (isEmpty(obeeEventSessions2.data)) {
    return /* @__PURE__ */ React__default.createElement(Box, null, "Events & holidays will show here");
  }
  const tableHeaders = [
    { id: "date", label: "Date" },
    { id: "name", label: "Name" },
    { id: "start", label: "Start time" },
    { id: "close", label: "Close time" },
    { id: "overflow", label: "" }
  ];
  const tableData = obeeEventSessions2.data.map((session) => {
    const isClosed = session.startTime === session.endTime;
    return {
      date: formatDate(session.date, "ddd, Do MMMM YYYY"),
      name: session.label,
      start: isClosed ? "Closed" : formatTimeFromInt(session.startTime, "h:mma"),
      close: isClosed ? "Closed" : formatTimeFromInt(session.endTime, "h:mma"),
      overflow: /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.overflowBtn,
          onClick: (e) => {
            unstable_batchedUpdates(() => {
              setEventOverflowAnchorEl(e.currentTarget);
              setEventToEdit(session);
            });
          }
        },
        /* @__PURE__ */ React__default.createElement(IconOverflowSVG, { style: { height: "15px" } })
      )
    };
  });
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Table, { headers: tableHeaders, body: tableData, style: { cellContent: { width: "100%" } } }), !isEmpty(eventToEdit) && /* @__PURE__ */ React__default.createElement(
    EditEventSession$1,
    {
      session: eventToEdit,
      onClose: (updatedSession, hasChanged) => {
        if (hasChanged) {
          updateEventSession2(updatedSession);
        }
        unstable_batchedUpdates(() => {
          setAnchor(null);
          setEventToEdit(null);
        });
      },
      anchor,
      restaurantOpen: roundToNearest(startTime, 15, "floor"),
      restaurantClose: roundToNearest(endTime, 15, "floor")
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: [
        {
          label: /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "12px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { height: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Edit")),
          onClick: () => {
            setAnchor(eventOverflowAnchorEl);
          }
        },
        {
          label: /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "12px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { height: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete")),
          onClick: () => {
            deleteEventSession2(eventToEdit == null ? void 0 : eventToEdit.objectId);
          }
        }
      ],
      anchor: eventOverflowAnchorEl,
      isOpen: !!eventOverflowAnchorEl,
      onClose: () => {
        unstable_batchedUpdates(() => {
          setEventOverflowAnchorEl(null);
        });
      },
      popoverProps: {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        }
      },
      style: listPopoverStyles$1
    }
  ));
};
EventsTable.propTypes = {
  fetchEventSessions: PropTypes.func.isRequired,
  obeeEventSessions: eventSessionsPropTypes.isRequired,
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  updateEventSession: PropTypes.func.isRequired,
  deleteEventSession: PropTypes.func.isRequired
};
const mapStateToProps$2d = (state) => ({
  obeeEventSessions: state.obeeEventSessions
});
const mapDispatchToProps$2c = (dispatch) => bindActionCreators(
  {
    fetchEventSessions: fetchEventSessionsAction,
    updateEventSession: updateEventSessionAction,
    deleteEventSession: deleteEventSessionAction
  },
  dispatch
);
const EventsTable$1 = connect(mapStateToProps$2d, mapDispatchToProps$2c)(EventsTable);
const minColumnWidth = 165;
const useStyles$17 = createUseStyles((theme2) => ({
  container: {
    overflowX: "auto"
  },
  timeColumn: {
    borderRight: "1px solid #D9D9D9",
    // TODO use theme
    background: theme2.colors.white,
    width: "60px",
    flexShrink: 0
  },
  time: {
    height: "30px",
    color: theme2.colors.nimbus,
    ...theme2.typography.body.PXS,
    whiteSpace: "nowrap",
    textAlign: "right",
    letterSpacing: "1px",
    // marginTop: '-8px',
    display: "flex",
    alignItems: "center",
    transform: "translateY(-15px)"
  },
  calendar: {
    display: "flex"
  },
  calendarDays: {
    display: "flex",
    width: "100%"
  },
  header: {
    display: "flex",
    paddingLeft: "60px",
    flexBasis: "200px",
    // minWidth: '1515px',
    letterSpacing: "1.5px"
  },
  dayColumn: {
    position: "relative",
    minWidth: `${minColumnWidth}px`,
    borderRight: "1px solid #D9D9D9",
    width: "100%"
  },
  dayColumnHeader: {
    minWidth: `${minColumnWidth}px`,
    width: "100%",
    textAlign: "center",
    fontSize: "12px",
    textTransform: "uppercase",
    color: theme2.colors.charcoal,
    height: "50px",
    lineHeight: "50px"
  },
  dayColumnTimes: {},
  timeBox: {
    padding: "8px",
    height: "30px",
    // margin: '1px',
    borderTop: "1px solid #E5E5E5",
    // TODO use theme
    backgroundColor: "white"
    // '&:hover': {
    //   border: '1px solid black',
    // },
  },
  timeBlock: {
    padding: "12px 4px",
    height: "30px",
    // margin: '1px',
    position: "absolute",
    minWidth: `calc(${minColumnWidth}px - 16px)`,
    left: "8px",
    borderTop: "1px solid #E5E5E5",
    // TODO use theme
    backgroundColor: theme2.colors.peach,
    border: "1px solid transparent",
    cursor: "pointer",
    transition: "border 0.1s",
    width: "calc(100% - 16px)",
    overflow: "hidden",
    "&:hover": {
      border: "1px solid black",
      overflow: "visible"
    }
  },
  timeBlockTop: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "0 8px"
  },
  timeBlockHeading: {
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.charcoal
  },
  timeBlockTime: {
    ...theme2.typography.body.PXS,
    color: theme2.colors.smoke
  },
  sittingTimes: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  sittingTime: {
    fontSize: "12px",
    padding: "4px 12px",
    background: theme2.colors.white,
    borderRadius: "4px",
    boxShadow: "0px 4px 4px rgba(215, 215, 215, 0.25)"
  }
}));
const userPropTypes = PropTypes.shape({
  userInfo: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    objectId: PropTypes.string,
    userType: PropTypes.string,
    restaurants: PropTypes.arrayOf(PropTypes.shape({}))
    // TODO fix this
  }),
  userFetching: PropTypes.bool,
  userError: PropTypes.bool,
  userErrorMessage: PropTypes.string
});
const EditSession = ({
  session,
  anchor,
  onClose,
  restaurantOpen,
  restaurantClose,
  deleteGlobalSession: deleteGlobalSession2,
  areaId,
  deleteSession: deleteSession2,
  restaurant,
  obeeGlobalSessions: obeeGlobalSessions2,
  obeeSessions: obeeSessions2,
  user
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1a();
  const [label, setLabel] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [startTimeError, setStartTimeError] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [endTimeError, setEndTimeError] = useState(null);
  const [sittings, setSittings] = useState([]);
  const [sittingAnchor, setSittingAnchor] = useState(null);
  const [editSittingAnchor, setEditSittingAnchor] = useState(null);
  const [editingSitting, setEditingSitting] = useState(null);
  const [showGeneralWarningModal, setShowGeneralWarningModal] = useState(false);
  const allTimes = numberRange(restaurantOpen, Math.min(restaurantClose, 1425), 15, true).map(
    (time) => ({
      label: formatTimeFromInt(time, "h:mm a"),
      value: time
    })
  );
  useEffect(() => {
    if (anchor && session) {
      unstable_batchedUpdates(() => {
        var _a;
        setLabel(session == null ? void 0 : session.label);
        setStartTime(session == null ? void 0 : session.startTime);
        setEndTime(session == null ? void 0 : session.endTime);
        setSittings(
          ((_a = session == null ? void 0 : session.sittingTimes) == null ? void 0 : _a.map((sittingTime) => ({
            startTime: sittingTime,
            pseudoId: generateRandomString(8)
          }))) || []
          // if sittings are null for the session fallback to [] for edits
        );
      });
    }
  }, [anchor, session]);
  useEffect(() => {
    unstable_batchedUpdates(() => {
      setStartTimeError(null);
      setEndTimeError(null);
    });
    const sessionsToCheck = (areaId === 0 ? obeeGlobalSessions2.data.filter(
      (sessionToCheck) => sessionToCheck.objectId !== session.objectId
    ) : obeeSessions2.data.filter(
      (sessionToCheck) => sessionToCheck.id !== session.id && sessionToCheck.areaId === areaId
    )).filter((sessionToCheck) => sessionToCheck.day === session.day);
    const isOverlapping = sessionsToCheck.some(
      (sessionToCheck) => startTime < sessionToCheck.startTime && endTime > sessionToCheck.startTime || startTime < sessionToCheck.endTime && endTime > sessionToCheck.endTime
    );
    if (isOverlapping) {
      setStartTimeError("This session time overlaps with another session.");
      setEndTimeError("This session time overlaps with another session.");
      return;
    }
    if (startTime >= endTime) {
      setStartTimeError("The start time must be before the close time.");
    } else {
      setStartTimeError(null);
    }
    if (endTime <= startTime) {
      setEndTimeError("The close time must be after the start time.");
    } else {
      setEndTimeError(null);
    }
  }, [startTime, endTime, areaId]);
  const handleDelete = () => {
    if (areaId === 0) {
      deleteGlobalSession2(session == null ? void 0 : session.objectId);
    } else {
      deleteSession2(session == null ? void 0 : session.id);
    }
    onClose(null, false);
  };
  const onDelete2 = () => {
    if (restaurant == null ? void 0 : restaurant.obeeIsLive) {
      setShowGeneralWarningModal(true);
    } else {
      handleDelete();
    }
  };
  const addSitting = (newSitting) => {
    setSittings([...sittings, { ...newSitting, pseudoId: generateRandomString(8) }]);
  };
  const updateSitting = (updatedSitting) => {
    setSittings(updateObjectByProperty(sittings, updatedSitting, "pseudoId"));
  };
  const removeSitting = () => {
    setSittings(removeFromArray(sittings, editingSitting));
    setEditingSitting(null);
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen: !!anchor,
      onClose: () => {
        const isValid = isEmpty(startTimeError) && isEmpty(endTimeError);
        const sittingTimes = isEmpty(session.sittingTimes) && isEmpty(sittings) ? null : immutableSort(
          sittings,
          (a, b) => sortMomentByProperty(a, b, "startTime", "h:mma")
        ).map((sitting) => sitting.startTime);
        if (isValid) {
          const newSession = {
            ...session,
            label,
            startTime,
            endTime,
            sittingTimes
          };
          onClose(newSession, !deepEqual(session, newSession));
        } else {
          onClose(null, false);
        }
      },
      anchorEl: anchor,
      innerStyle: { marginLeft: "20px", marginTop: "0", borderRadius: "6px", padding: "0" },
      anchorOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer, style: { justifyContent: "unset" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Session")), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: { display: "flex", flexDirection: "column", padding: "20px 24px", gap: "20px" }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Label",
          items: sessionLabels(theme2),
          value: label,
          onSelect: setLabel,
          style: cleanDropdownPopoverStyles
        }
      ), /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Start time",
          items: allTimes,
          value: startTime,
          onSelect: setStartTime,
          error: startTimeError,
          style: cleanDropdownPopoverStyles
        }
      ), /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Close time",
          items: allTimes,
          value: endTime,
          onSelect: setEndTime,
          error: endTimeError,
          style: cleanDropdownPopoverStyles
        }
      )),
      (sittings == null ? void 0 : sittings.length) > 0 && /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", flexDirection: "column", gap: "20px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingsTitle }, "Sittings"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingRowContainer }, immutableSort(
        sittings,
        (a, b) => sortMomentByProperty(a, b, "startTime", "h:mma")
      ).map((sitting, index) => /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: sitting == null ? void 0 : sitting.pseudoId,
          className: classes.sittingRow,
          onClick: (e) => {
            setEditingSitting(sitting);
            setEditSittingAnchor(e.currentTarget);
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingRowNumber }, index + 1),
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingRowDetails }, "Starts ", sitting == null ? void 0 : sitting.startTime)
      )))))
    ), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.linkIconBackground }), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: customButtonStyles(theme2),
        onClick: (e) => setSittingAnchor(e.currentTarget),
        disabled: startTime >= endTime
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(PlusSVG, { style: { color: theme2.colors.gray3, height: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Add sitting"))
    ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: customButtonStyles(theme2),
        onClick: onDelete2,
        disabled: (restaurant == null ? void 0 : restaurant.obeeIsLive) && !canEditAll()
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete session"))
    ))),
    /* @__PURE__ */ React__default.createElement(
      CreateSitting$1,
      {
        anchor: sittingAnchor,
        onClose: () => setSittingAnchor(null),
        onCreateSitting: addSitting,
        sessionStartTime: startTime,
        sessionEndTime: endTime,
        existingSittings: sittings
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      EditSitting$1,
      {
        anchor: editSittingAnchor,
        onClose: () => setEditSittingAnchor(null),
        onDelete: removeSitting,
        onEditSitting: updateSitting,
        sitting: editingSitting,
        sessionStartTime: startTime,
        sessionEndTime: endTime,
        existingSittings: sittings
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      GeneralWarningModal$1,
      {
        isOpen: showGeneralWarningModal,
        onClose: () => setShowGeneralWarningModal(false),
        onConfirm: handleDelete,
        confirmLabel: "Continue, delete session",
        heading: "Delete session?",
        prompt: "This may create some conflicts with existing future bookings in your system."
      }
    )
  );
};
EditSession.defaultProps = {
  anchor: null,
  restaurantOpen: 0,
  restaurantClose: 1440,
  session: null
};
EditSession.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.func,
  session: PropTypes.oneOfType([sessionPropTypes, globalSessionPropTypes]),
  restaurantOpen: PropTypes.number,
  restaurantClose: PropTypes.number,
  areaId: PropTypes.number.isRequired,
  deleteGlobalSession: PropTypes.func.isRequired,
  deleteSession: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  obeeGlobalSessions: globalSessionsPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  user: userPropTypes.isRequired
};
const mapStateToProps$2c = (state) => ({
  restaurant: state.restaurantActive.restaurant,
  obeeGlobalSessions: state.obeeGlobalSessions,
  obeeSessions: state.obeeSessions,
  user: state.user
});
const mapDispatchToProps$2b = (dispatch) => bindActionCreators(
  {
    deleteGlobalSession: deleteGlobalSessionAction,
    deleteSession: deleteSessionAction
  },
  dispatch
);
const EditSession$1 = connect(mapStateToProps$2c, mapDispatchToProps$2b)(EditSession);
const Calendar$2 = ({
  startTime,
  endTime,
  areaId,
  obeeGlobalSessions: obeeGlobalSessions2,
  updateObeeGlobalSession: updateObeeGlobalSession2,
  obeeSessions: obeeSessions2,
  updateObeeSession: updateObeeSession2,
  restaurant
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$17();
  const [editingSession, setEditingSession] = useState(null);
  const [sessionAnchor, setSessionAnchor] = useState(null);
  const [showGeneralWarningModal, setShowGeneralWarningModal] = useState(false);
  const [sessionToUpdate, setSessionToUpdate] = useState(null);
  const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const getSessions = () => {
    if (!isObee() && areaId === 0) {
      return groupByProperty(obeeGlobalSessions2.data, "day");
    }
    const areaSessions = obeeSessions2.data.filter((session) => session.areaId === areaId);
    const areaSessionsByDay = groupByProperty(areaSessions, "day");
    return areaSessionsByDay;
  };
  const interval = 60;
  const times = numberRange(startTime, endTime, interval, true);
  const cellHeight2 = 30;
  const timeBlockPadding = 4;
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, days.map((day) => /* @__PURE__ */ React__default.createElement(Box, { key: day, className: classes.dayColumnHeader }, day))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendar }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeColumn }, times.map((time) => /* @__PURE__ */ React__default.createElement(Box, { key: time, className: classes.time }, formatTimeFromInt(time, null, " a")))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarDays }, days.map((day, index) => {
    var _a, _b2;
    const openingHoursForDay = (_b2 = (_a = getSessions()) == null ? void 0 : _a.find(
      (sessionByDay) => sessionByDay.name === day
    )) == null ? void 0 : _b2.items;
    return /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.dayColumn,
        style: {
          borderRight: index === days.length - 1 && `1px solid ${theme2.colors.cloud}`
        },
        key: day
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.dayColumnTimes }, times.map((time) => /* @__PURE__ */ React__default.createElement(Box, { key: time, className: classes.timeBox }))),
      openingHoursForDay == null ? void 0 : openingHoursForDay.map((session) => {
        var _a2;
        const height = Math.max(1, (session.endTime - session.startTime) / 60) * cellHeight2 - 2 * timeBlockPadding;
        return /* @__PURE__ */ React__default.createElement(
          Box,
          {
            key: session.id,
            onClick: (e) => {
              setEditingSession(session);
              setSessionAnchor(e.currentTarget);
            },
            className: classes.timeBlock,
            style: {
              top: `${Math.max(0, session.startTime - startTime) / 60 * cellHeight2 + timeBlockPadding}px`,
              height,
              backgroundColor: getSessionColors(session.label, theme2).backgroundColor
            }
          },
          /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeBlockTop }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeBlockHeading }, getListLabel(session.label, theme2)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeBlockTime }, `${formatTimeFromInt(session.startTime)} to ${formatTimeFromInt(
            session.endTime
          )}`), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sittingTimes }, (_a2 = session.sittingTimes) == null ? void 0 : _a2.map((sittingTime) => /* @__PURE__ */ React__default.createElement(Box, { key: sittingTime, className: classes.sittingTime }, sittingTime))))
        );
      })
    );
  }))), !!editingSession && /* @__PURE__ */ React__default.createElement(
    EditSession$1,
    {
      session: editingSession,
      onClose: (updatedSession, hasChanged) => {
        if (hasChanged) {
          if (restaurant == null ? void 0 : restaurant.obeeIsLive) {
            unstable_batchedUpdates(() => {
              setShowGeneralWarningModal(true);
              setSessionToUpdate(updatedSession);
            });
          } else {
            if (areaId === 0) {
              updateObeeGlobalSession2(updatedSession);
            } else {
              updateObeeSession2(updatedSession);
            }
          }
        }
        unstable_batchedUpdates(() => {
          setEditingSession(null);
          setSessionAnchor(null);
        });
      },
      anchor: sessionAnchor,
      restaurantOpen: roundToNearest(startTime, 15, "floor"),
      restaurantClose: roundToNearest(endTime, 15, "floor"),
      areaId
    }
  )), /* @__PURE__ */ React__default.createElement(
    GeneralWarningModal$1,
    {
      isOpen: showGeneralWarningModal,
      onClose: () => unstable_batchedUpdates(() => {
        setShowGeneralWarningModal(false);
        setSessionToUpdate(null);
      }),
      onConfirm: () => {
        if (areaId === 0) {
          updateObeeGlobalSession2(sessionToUpdate);
        } else {
          updateObeeSession2(sessionToUpdate);
        }
      },
      confirmLabel: "Continue, update session",
      heading: "Update session?",
      prompt: "This may create some conflicts with existing future bookings in your system."
    }
  ));
};
Calendar$2.defaultProps = {
  startTime: 0,
  endTime: 0
};
Calendar$2.propTypes = {
  obeeGlobalSessions: globalSessionsPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  startTime: PropTypes.number,
  endTime: PropTypes.number,
  areaId: PropTypes.number.isRequired,
  updateObeeGlobalSession: PropTypes.func.isRequired,
  updateObeeSession: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired
};
const mapStateToProps$2b = (state) => ({
  obeeGlobalSessions: state.obeeGlobalSessions,
  obeeSessions: state.obeeSessions,
  restaurant: state.restaurantActive.restaurant
});
const mapDispatchToProps$2a = (dispatch) => bindActionCreators(
  {
    fetchObeeGlobalSessions: fetchGlobalSessionsAction,
    updateObeeGlobalSession: updateGlobalSessionAction,
    updateObeeSession: updateSessionAction
  },
  dispatch
);
const Calendar$3 = connect(mapStateToProps$2b, mapDispatchToProps$2a)(Calendar$2);
const CreateEventSession = ({
  anchor,
  onClose,
  restaurantOpen,
  restaurantClose,
  createEventSession: createEventSession2,
  obeeEventSessions: obeeEventSessions2
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1a();
  const [label, setLabel] = useState(null);
  const [labelError, setLabelError] = useState(null);
  const [startTime, setStartTime] = useState(restaurantOpen);
  const [startTimeError, setStartTimeError] = useState(null);
  const [finishTime, setFinishTime] = useState(restaurantOpen + 60);
  const [finishTimeError, setFinishTimeError] = useState(null);
  const [date, setDate] = useState(null);
  const [dateError, setDateError] = useState(null);
  const [type2, setType] = useState("differentHours");
  const [creating, setCreating] = useState(false);
  const allTimes = numberRange(restaurantOpen, restaurantClose, 15, true).map((time) => ({
    label: formatTimeFromInt(time, "h:mm a"),
    value: time
  }));
  useEffect(() => {
    if (anchor) {
      unstable_batchedUpdates(() => {
        setLabel(null);
        setStartTime(restaurantOpen);
        setFinishTime(restaurantOpen + 60);
        setDate(null);
        setType("differentHours");
      });
    }
  }, [anchor]);
  const validate = () => {
    let isValid = true;
    unstable_batchedUpdates(() => {
      setStartTimeError(null);
      setFinishTimeError(null);
      setLabelError(null);
      setDateError(null);
    });
    if (isEmpty(label)) {
      setLabelError("This field is required.");
      isValid = false;
    }
    if (isEmpty(date)) {
      setDateError("This field is required.");
      isValid = false;
    }
    if (type2 === "closed") {
      return isValid;
    }
    if (startTime >= finishTime) {
      setStartTimeError("The start time must be before the close time.");
      isValid = false;
    }
    if (finishTime <= startTime) {
      setFinishTimeError("The close time must be after the start time.");
      isValid = false;
    }
    return isValid;
  };
  const isClosed = type2 === "closed";
  const createNewSession = () => {
    setCreating(true);
    const isValid = validate();
    if (isValid) {
      createEventSession2({
        label,
        startTime: isClosed ? 0 : startTime,
        endTime: isClosed ? 0 : finishTime,
        date,
        isPublic: true
      });
    } else {
      setCreating(false);
    }
  };
  useEffect(() => {
    if (obeeEventSessions2.success && creating) {
      setCreating(false);
      onClose();
    }
  }, [obeeEventSessions2.success]);
  useEffect(() => {
    if (obeeEventSessions2.error && creating) {
      setCreating(false);
    }
  }, [obeeEventSessions2.error]);
  const onDateSelect = (value) => {
    setDateError(null);
    setDate(formatDate(value, "YYYY-MM-DD"));
  };
  const hasErrors = useMemo(
    () => [labelError, startTimeError, finishTimeError, dateError].some((error) => !isEmpty(error)),
    [labelError, startTimeError, finishTimeError, dateError]
  );
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen: !!anchor,
      onClose,
      anchorEl: anchor,
      innerStyle: {
        marginTop: "10px",
        borderRadius: "6px",
        padding: "0"
      },
      ...popoverAnchors$1
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Events & holidays")), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: { display: "flex", flexDirection: "column", padding: "20px 24px", gap: "20px" }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
        CleanTextFieldComponent,
        {
          label: "Event name",
          placeholder: "Empty",
          style: {
            label: { fontSize: "15px", width: "140px" },
            input: { fontSize: "15px", height: "36px", padding: "0 12px", paddingLeft: "12px" },
            ...cleanDropdownPopoverStyles
          },
          value: label,
          onChange: setLabel,
          error: labelError,
          clearError: () => setLabelError(null)
        }
      ), /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "Date",
          placeholder: "Empty",
          value: date,
          onSelect: onDateSelect,
          error: dateError,
          style: cleanDropdownPopoverStyles,
          clearError: () => setDateError(null)
        }
      ), /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Type",
          items: typeItems,
          value: type2,
          onSelect: setType,
          style: cleanDropdownPopoverStyles
        }
      ), !isClosed && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Start time",
          items: allTimes,
          value: startTime,
          onSelect: setStartTime,
          error: startTimeError,
          style: cleanDropdownPopoverStyles,
          clearError: () => setStartTimeError(null)
        }
      ), /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Finish time",
          items: allTimes,
          value: finishTime,
          onSelect: setFinishTime,
          error: finishTimeError,
          style: cleanDropdownPopoverStyles,
          clearError: () => setFinishTimeError(null)
        }
      )))
    ), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.linkIconBackground }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        style: buttonStyles$3,
        onClick: createNewSession,
        loading: creating,
        disabled: hasErrors || creating
      },
      "Create specific date"
    ))))
  );
};
CreateEventSession.defaultProps = {
  anchor: null,
  restaurantOpen: 0,
  restaurantClose: 1440
};
CreateEventSession.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.func,
  restaurantOpen: PropTypes.number,
  restaurantClose: PropTypes.number,
  createEventSession: PropTypes.func.isRequired,
  obeeEventSessions: eventSessionsPropTypes.isRequired
};
const mapStateToProps$2a = (state) => ({
  obeeEventSessions: state.obeeEventSessions
});
const mapDispatchToProps$29 = (dispatch) => bindActionCreators(
  {
    createEventSession: createEventSessionAction
  },
  dispatch
);
const CreateEventSession$1 = connect(mapStateToProps$2a, mapDispatchToProps$29)(CreateEventSession);
const SvgCheckInCircle = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 27 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 13.5, cy: 13.5, r: 13.5, fill: "#DEE8E7" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8 14.3333L10.84 17L19 9", stroke: "#2F423F" }));
const CheckInCircle = SvgCheckInCircle;
const HoursStyleCard = ({ onClick, heading, subHeading, enabled }) => {
  const classes = useStyles$1a();
  return /* @__PURE__ */ React__default.createElement(Box, { onClick, className: classes.styleCardContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.styleCardContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.styleCardHeading }, /* @__PURE__ */ React__default.createElement(Box, null, heading)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.styleCardSubHeading }, subHeading), /* @__PURE__ */ React__default.createElement(Box, { className: classes.enabled }, enabled ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, null, "Selected"), /* @__PURE__ */ React__default.createElement(CheckInCircle, { style: { width: "18px", height: "18px" } })) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        color: "#CDCDCD"
        // TODO use theme
      }
    },
    "Select"
  )))));
};
HoursStyleCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired
};
const HoursStyleCard$1 = HoursStyleCard;
const OpeningHoursStyleModal = ({ isOpen, onClose, obeeSettings: obeeSettings2, updateObeeSettings: updateObeeSettings2 }) => {
  var _a, _b2, _c2;
  const [updating, setUpdating] = useState(false);
  const [openingHoursStyle, setOpeningHoursStyle] = useState((_a = obeeSettings2.data) == null ? void 0 : _a.openingHoursStyle);
  useEffect(() => {
    var _a2;
    if (isOpen) {
      setOpeningHoursStyle((_a2 = obeeSettings2.data) == null ? void 0 : _a2.openingHoursStyle);
    }
  }, [isOpen, (_b2 = obeeSettings2.data) == null ? void 0 : _b2.openingHoursStyle]);
  const update = () => {
    setUpdating(true);
    updateObeeSettings2({ openingHoursStyle });
  };
  useEffect(() => {
    if (obeeSettings2.success && updating) {
      setUpdating(false);
      onClose();
    }
  }, [obeeSettings2.success]);
  useEffect(() => {
    if (obeeSettings2.error && updating) {
      setUpdating(false);
    }
  }, [obeeSettings2.error]);
  return /* @__PURE__ */ React__default.createElement(
    PromptModal$1,
    {
      isOpen,
      onClose,
      inputStyle: { maxWidth: "680px", maxHeight: "535px" },
      onConfirm: update,
      heading: "Set opening hours for",
      confirmLabel: isEmpty((_c2 = obeeSettings2.data) == null ? void 0 : _c2.openingHoursStyle) ? "Get started" : "Update",
      loadingConfirm: updating
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { gap: "m" }, /* @__PURE__ */ React__default.createElement(
      HoursStyleCard$1,
      {
        onClick: () => setOpeningHoursStyle("default"),
        heading: "All Areas",
        subHeading: "Set opening hours that apply to all of your areas.",
        enabled: openingHoursStyle === "default"
      }
    ), /* @__PURE__ */ React__default.createElement(
      HoursStyleCard$1,
      {
        onClick: () => setOpeningHoursStyle("custom"),
        heading: "Area specific",
        subHeading: "Set different opening hours for each of your individual areas.",
        enabled: openingHoursStyle === "custom"
      }
    ))
  );
};
OpeningHoursStyleModal.propTypes = {
  obeeSettings: obeeSettingsPropTypes.isRequired,
  updateObeeSettings: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
const mapStateToProps$29 = (state) => ({
  obeeAreas: state.areas,
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$28 = (dispatch) => bindActionCreators(
  {
    updateObeeSettings: updateSettingsAction
  },
  dispatch
);
const OpeningHoursStyleModal$1 = connect(mapStateToProps$29, mapDispatchToProps$28)(OpeningHoursStyleModal);
const HoursSettings = ({
  fetchObeeAreas: fetchObeeAreas2,
  obeeAreas: obeeAreas2,
  fetchObeeGlobalSessions: fetchObeeGlobalSessions2,
  fetchSessions,
  obeeGlobalSessions: obeeGlobalSessions2,
  closeRestaurant,
  reopenRestaurant,
  obeeSessions: obeeSessions2,
  obeeSettings: obeeSettings2,
  user,
  restaurant,
  closeEarly: closeEarly2,
  fullyBookedSessions,
  fetchFullyBookedSessions: fetchFullyBookedSessions2
}) => {
  var _a, _b2, _c2;
  const theme2 = useTheme$1();
  const classes = useStyles$1w();
  const ref = useRef(null);
  const getActiveTab = useCallback(
    () => {
      var _a2, _b3, _c3;
      return ((_a2 = obeeSettings2.data) == null ? void 0 : _a2.openingHoursStyle) === "default" ? 0 : (_c3 = (_b3 = obeeAreas2.data) == null ? void 0 : _b3[0]) == null ? void 0 : _c3.id;
    },
    [(_a = obeeSettings2.data) == null ? void 0 : _a.openingHoursStyle, obeeAreas2.data]
  );
  const [activeTab, setActiveTab] = useState(getActiveTab());
  const [sessionAnchor, setSessionAnchor] = useState(null);
  const [eventSessionAnchor, setEventSessionAnchor] = useState(null);
  const [overflowAnchor, setOverflowAnchor] = useState(null);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [showReopenModal, setShowReopenModal] = useState(false);
  const [showOpeningHoursStyleModal, setShowOpeningHoursStyleModal] = useState(false);
  const restaurantOpenTime = 360;
  const restaurantCloseTime = 1380;
  const loading = useFetchOnFirstRender(
    [fetchObeeGlobalSessions2, fetchSessions, fetchObeeAreas2],
    [obeeGlobalSessions2, obeeSessions2, obeeAreas2]
  );
  useEffect(() => {
    fetchFullyBookedSessions2();
  }, []);
  useEffect(() => {
    if (obeeAreas2.success) {
      setActiveTab(getActiveTab());
    }
  }, [obeeAreas2.success, getActiveTab]);
  useEffect(() => {
    if (obeeGlobalSessions2.success) {
      fetchSessions();
    }
  }, [obeeGlobalSessions2.success]);
  useEffect(() => {
    setActiveTab(getActiveTab());
  }, [(_b2 = obeeSettings2.data) == null ? void 0 : _b2.openingHoursStyle, getActiveTab]);
  useEffect(() => {
    var _a2;
    if (obeeSettings2.success && isVoid((_a2 = obeeSettings2.data) == null ? void 0 : _a2.openingHoursStyle)) {
      setShowOpeningHoursStyleModal(true);
    }
  }, [obeeSettings2.success]);
  const getCalendarStartTime = () => {
    return Math.max(0, roundToNearest(restaurantOpenTime - 60, 15, "floor"));
  };
  const getCalendarEndTime = () => {
    return Math.min(1440, roundToNearest(restaurantCloseTime + 60, 15, "ceil"));
  };
  const startTime = getCalendarStartTime();
  const endTime = getCalendarEndTime();
  const tabs = [
    ...((_c2 = obeeSettings2.data) == null ? void 0 : _c2.openingHoursStyle) === "default" ? [{ label: "All areas", value: 0 }] : [
      ...obeeAreas2.data.map((area) => ({
        label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.overflowLabel }, /* @__PURE__ */ React__default.createElement(Box, null, area == null ? void 0 : area.name)),
        value: area == null ? void 0 : area.id
      }))
    ]
  ];
  tabs.push({ label: "Events & holidays", value: -1 });
  if (loading) {
    return /* @__PURE__ */ React__default.createElement(
      Skeleton$1,
      {
        height: 800,
        style: {
          skeleton: {
            backgroundColor: theme2.colors.loadingShimmer
          }
        }
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsPage, style: { fontSize: "15px", marginLeft: "-10px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subNavigation }, /* @__PURE__ */ React__default.createElement(TabBar$2, { tabs, value: activeTab, onSelect: setActiveTab, style: tabBarStyles$3(theme2) }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.rightRow }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, closedEarlyToday(restaurant) ? /* @__PURE__ */ React__default.createElement(
    Button,
    {
      onClick: () => setShowReopenModal(true),
      type: "tertiary",
      style: smallButtonStyles,
      loading: closeEarly2.pending
    },
    "Reopen"
  ) : /* @__PURE__ */ React__default.createElement(
    Button,
    {
      onClick: () => setShowCloseModal(true),
      type: "tertiary",
      style: smallButtonStyles,
      loading: closeEarly2.pending
    },
    "Close early"
  )), /* @__PURE__ */ React__default.createElement(Box, { ref }, activeTab !== -1 && /* @__PURE__ */ React__default.createElement(Button, { onClick: () => setSessionAnchor(ref.current), style: smallButtonStyles }, "Add session"), activeTab === -1 && /* @__PURE__ */ React__default.createElement(Button, { onClick: () => setEventSessionAnchor(ref.current), style: smallButtonStyles }, "Add new")), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (!(restaurant == null ? void 0 : restaurant.obeeIsLive) || canEditAll()) && /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.overflowButton,
      onClick: (e) => setOverflowAnchor(e.currentTarget)
    },
    /* @__PURE__ */ React__default.createElement(IconOverflowSVG, { style: { height: "15px", color: "#9A9A9A" } })
  )))), activeTab !== -1 && /* @__PURE__ */ React__default.createElement(Calendar$3, { startTime, endTime, areaId: activeTab }), activeTab === -1 && /* @__PURE__ */ React__default.createElement(EventsTable$1, { startTime, endTime }), !!sessionAnchor && /* @__PURE__ */ React__default.createElement(
    CreateSession$1,
    {
      onClose: () => setSessionAnchor(null),
      anchor: sessionAnchor,
      restaurantOpen: roundToNearest(startTime, 15, "floor"),
      restaurantClose: roundToNearest(endTime, 15, "floor"),
      areaId: activeTab
    }
  ), !!eventSessionAnchor && /* @__PURE__ */ React__default.createElement(
    CreateEventSession$1,
    {
      onClose: () => setEventSessionAnchor(null),
      anchor: eventSessionAnchor,
      restaurantOpen: roundToNearest(startTime, 15, "floor"),
      restaurantClose: roundToNearest(endTime, 15, "floor")
    }
  ), /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      isOpen: showCloseModal,
      onClose: () => setShowCloseModal(false),
      onConfirm: () => {
        closeRestaurant(fullyBookedSessions.data);
        setShowCloseModal(false);
      },
      heading: "Close early for the day",
      prompt: "Are you sure you want to close your restaurant for the day?",
      context: "none",
      confirmLabel: "Confirm",
      inputStyle: { maxWidth: "500px", maxHeight: "535px" }
    }
  ), /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      isOpen: showReopenModal,
      onClose: () => setShowReopenModal(false),
      onConfirm: () => {
        reopenRestaurant(fullyBookedSessions.data);
        setShowReopenModal(false);
      },
      heading: "Reopen for the day",
      prompt: "Are you sure you want to reopen your restaurant for the day?",
      context: "none",
      confirmLabel: "Confirm",
      inputStyle: { maxWidth: "500px", maxHeight: "535px", fontSize: "15px" }
    }
  ), /* @__PURE__ */ React__default.createElement(
    OpeningHoursStyleModal$1,
    {
      isOpen: showOpeningHoursStyleModal,
      onClose: () => setShowOpeningHoursStyleModal(false)
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: [
        {
          label: /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", alignItems: "center", gap: "12px" } }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { height: "15px", width: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Edit opening hour area preferences")),
          onClick: () => setShowOpeningHoursStyleModal(true)
        }
      ],
      anchor: overflowAnchor,
      isOpen: !isEmpty(overflowAnchor),
      onClose: () => setOverflowAnchor(null),
      style: listPopoverStyles$1,
      ...popoverAnchors$1
    }
  ));
};
HoursSettings.propTypes = {
  fetchObeeAreas: PropTypes.func.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  fetchObeeGlobalSessions: PropTypes.func.isRequired,
  obeeGlobalSessions: globalSessionsPropTypes.isRequired,
  closeRestaurant: PropTypes.func.isRequired,
  reopenRestaurant: PropTypes.func.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  updateObeeSettings: PropTypes.func.isRequired,
  user: userPropTypes.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  closeEarly: PropTypes.shape({
    pending: PropTypes.bool
  }).isRequired
};
const mapStateToProps$28 = (state) => ({
  user: state.user,
  obeeAreas: state.areas,
  obeeSessions: state.obeeSessions,
  obeeGlobalSessions: state.obeeGlobalSessions,
  obeeSettings: state.obeeSettings,
  restaurant: state.restaurantActive.restaurant,
  closeEarly: state.closeEarly,
  fullyBookedSessions: state.fullyBookedSessions
});
const mapDispatchToProps$27 = (dispatch) => bindActionCreators(
  {
    fetchObeeAreas: fetchAreasAction,
    fetchObeeGlobalSessions: fetchGlobalSessionsAction,
    closeRestaurant: closeRestaurantEarlyAction,
    fetchSessions: fetchSessionsAction,
    reopenRestaurant: reopenRestaurantAction,
    updateObeeSettings: updateSettingsAction,
    fetchFullyBookedSessions: fetchFullyBookedSessionsAction
  },
  dispatch
);
const HoursSettings$1 = connect(mapStateToProps$28, mapDispatchToProps$27)(HoursSettings);
const fetchObeeStaffListAction = () => (dispatch) => {
  const action = "FETCH_OBEE_STAFF";
  const entityName = "obeeStaffList";
  const request = () => fetchStaff();
  dispatch(makeApiAction(action, request, {}, entityName));
};
const createObeeStaffAction = (obeeStaff) => (dispatch) => {
  const action = "CREATE_OBEE_STAFF";
  const data = {
    staff: { ...removeNullFields(obeeStaff) }
  };
  const entityName = "createStaff";
  const successMessage = "Staff member created";
  const errorMessage = `Unable to create staff member`;
  const request = () => createStaff(data);
  dispatch(makeApiAction(action, request, {}, entityName, successMessage, {}, false, errorMessage));
};
const updateObeeStaffAction = (staffId, staff) => (dispatch) => {
  const action = "UPDATE_OBEE_STAFF";
  const data = {
    staffId,
    staff: { ...removeNullFields(staff) }
  };
  const entityName = "updateStaff";
  const successMessage = "Staff member updated";
  const errorMessage = `Unable to update staff member`;
  const request = () => updateStaff(data);
  dispatch(makeApiAction(action, request, {}, entityName, successMessage, {}, false, errorMessage));
};
const deleteObeeStaffAction = (staffId) => (dispatch) => {
  const action = "DELETE_OBEE_STAFF";
  const data = { staffId };
  const entityName = "deleteStaff";
  const successMessage = "Staff member deleted";
  const errorMessage = `Unable to delete staff member`;
  const request = () => deleteStaff(data);
  dispatch(
    makeApiAction(action, request, data, entityName, successMessage, data, false, errorMessage)
  );
};
const obeeStaffDataPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    objectId: PropTypes.string,
    fullName: PropTypes.string,
    appearAs: PropTypes.string,
    restId: PropTypes.string
  })
);
const obeeStaffPropTypes = PropTypes.shape({
  apiData: obeeStaffDataPropTypes,
  data: obeeStaffDataPropTypes,
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const StaffSettings = ({
  obeeStaff,
  updateStaff: updateStaff2,
  deleteStaff: deleteStaff2,
  createStaff: createStaff2,
  fetchObeeStaffList
}) => {
  const classes = useStyles$1w();
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [staff, setStaff] = useState(copyObjects(obeeStaff.data));
  const loading = useFetchOnFirstRender([fetchObeeStaffList], [obeeStaff]);
  useEffect(() => {
    setStaff(copyObjects(obeeStaff.data));
  }, [obeeStaff.data]);
  const createStaffMember = () => {
    setStaff([
      ...staff,
      { objectId: generateRandomString(8), fullName: "", appearAs: "", _new: true }
    ]);
  };
  const updateStaffMember = (staffId) => {
    const staffMemberToUpdate = { ...findObjectByProperty(staff, staffId, "objectId") };
    const { objectId, fullName, appearAs, _new, _changed } = staffMemberToUpdate;
    if (isEmpty(fullName)) {
      return;
    }
    if (_new) {
      createStaff2({ fullName, appearAs });
    } else {
      const oldStaffData = findObjectByProperty(obeeStaff.apiData, staffId, "objectId");
      if (_changed && (oldStaffData.fullName !== fullName || oldStaffData.appearAs !== appearAs)) {
        updateStaff2(objectId, { fullName, appearAs });
      }
    }
  };
  const changeStaffMember = (staffId, property, newValue) => {
    const staffToUpdate = { ...findObjectByProperty(staff, staffId, "objectId") };
    staffToUpdate[property] = newValue;
    staffToUpdate._changed = true;
    const updatedStaff = [...updateObjectByProperty(staff, staffToUpdate, "objectId")];
    setStaff(updatedStaff);
  };
  const staffForTable = staff.map((staffMember) => ({
    id: staffMember.objectId,
    fullName: /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        value: staffMember.fullName,
        onChange: (newValue) => changeStaffMember(staffMember.objectId, "fullName", newValue),
        onBlur: () => updateStaffMember(staffMember.objectId),
        placeholder: "Enter name",
        style: { input: { padding: "8px 10px", fontSize: "15px" } }
      }
    ),
    appearAs: /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        value: staffMember.appearAs,
        style: { input: { padding: "8px 10px", fontSize: "15px", marginLeft: "-10px" } },
        onChange: (newValue) => changeStaffMember(staffMember.objectId, "appearAs", newValue),
        onBlur: () => updateStaffMember(staffMember.objectId),
        placeholder: staffMember.fullName
      }
    )
  }));
  const handleRowSelection = (newValue, rowId) => {
    if (!newValue) {
      setSelectedStaff(selectedStaff.filter((staffId) => staffId !== rowId));
    } else if (!selectedStaff.includes(rowId)) {
      setSelectedStaff([...selectedStaff, rowId]);
    }
  };
  const deleteSelectedStaff = () => {
    selectedStaff.map((staffId) => deleteStaff2(staffId));
    setSelectedStaff([]);
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsPage }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subNavigation }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonRow }, /* @__PURE__ */ React__default.createElement(
    SquareButton,
    {
      style: { button: { fontSize: "15px" } },
      disabled: loading,
      onClick: createStaffMember
    },
    "Add staff"
  ), /* @__PURE__ */ React__default.createElement(
    SquareButton,
    {
      style: { button: { fontSize: "15px" } },
      disabled: loading || !selectedStaff.length,
      onClick: deleteSelectedStaff
    },
    "Delete"
  ))), loading ? /* @__PURE__ */ React__default.createElement(Skeleton$1, { height: 240, style: { skeleton: { borderRadius: "6px 6px 0 0" } } }) : /* @__PURE__ */ React__default.createElement(
    Table,
    {
      headers: [
        { id: "fullName", label: "Staff full name" },
        { id: "appearAs", label: "Appear as" }
      ],
      body: staffForTable,
      allowSelectRows: true,
      onSelectRow: handleRowSelection,
      selectedRows: selectedStaff
    }
  ));
};
StaffSettings.propTypes = {
  obeeStaff: obeeStaffPropTypes.isRequired,
  updateStaff: PropTypes.func.isRequired,
  createStaff: PropTypes.func.isRequired,
  deleteStaff: PropTypes.func.isRequired,
  fetchObeeStaffList: PropTypes.func.isRequired
};
const mapStateToProps$27 = (state) => ({
  obeeStaff: state.obeeStaff
});
const mapDispatchToProps$26 = (dispatch) => bindActionCreators(
  {
    updateStaff: updateObeeStaffAction,
    createStaff: createObeeStaffAction,
    deleteStaff: deleteObeeStaffAction,
    fetchObeeStaffList: fetchObeeStaffListAction
  },
  dispatch
);
const StaffSettings$1 = connect(mapStateToProps$27, mapDispatchToProps$26)(StaffSettings);
const PaymentPolicyExample = ({ anchorEl, setAnchorEl, setDescription }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1w();
  const description2 = "Please note we require credit card details as security for your booking. Nothing will be debited from your card at the time of booking, however we do require [_____] hours notice for any changes or cancellations to your booking. Failure to do so will incur a cancellation fee of [$__ per ____]";
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchorEl,
      anchorEl,
      onClose: () => setAnchorEl(null),
      innerStyle: {
        marginTop: "10px",
        borderRadius: "6px",
        padding: "20px",
        maxWidth: "400px"
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subheading, style: { fontSize: theme2.fontSizes.h4 } }, "Payment policy example"), /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "15px", padding: "10px 0" } }, description2), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        style: { ...linkStyles(theme2), width: "fit-content" },
        onClick: () => {
          setDescription(description2);
          setAnchorEl(null);
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { style: { alignItems: "center", display: "flex", gap: "4px" } }, /* @__PURE__ */ React__default.createElement(Box, null, "Start with example"), /* @__PURE__ */ React__default.createElement(ChevronRight, { style: { height: "8px", width: "8px" } }))
    ))
  );
};
PaymentPolicyExample.defaultProps = {
  anchorEl: null
};
PaymentPolicyExample.propTypes = {
  anchorEl: PropTypes.shape({}),
  setAnchorEl: PropTypes.func.isRequired,
  setDescription: PropTypes.func.isRequired
};
const mapStateToProps$26 = () => ({});
const mapDispatchToProps$25 = (dispatch) => bindActionCreators({}, dispatch);
const PaymentPolicyExample$1 = connect(mapStateToProps$26, mapDispatchToProps$25)(PaymentPolicyExample);
const PaymentSettings = ({ updateObeeSettings: updateObeeSettings2, obeeSettings: obeeSettings2 }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1w();
  const [open, setOpen] = useState(false);
  const [exampleAnchorEl, setExampleAnchorEl] = useState(null);
  const [waitlistExampleAnchorEl, setWaitlistExampleAnchorEl] = useState(null);
  const format = (value) => {
    const formatter = new Intl.NumberFormat("en-AU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return formatter.format(parseFloat(`${value}`)).toLocaleString().replace(/[$,]+/g, "");
  };
  const [noShowFee, setNoShowFee] = useState(
    format(parseFloat(`${obeeSettings2.data.ccNoShowFee / 100}`))
  );
  const [paymentPolicy, setPaymentPolicy] = useState(obeeSettings2.data.ccPaymentPolicy);
  const [waitlistPolicy, setWaitlistPolicy] = useState(obeeSettings2.data.ccWaitlistPolicy);
  useEffect(() => {
    setNoShowFee(format(parseFloat(`${obeeSettings2.data.ccNoShowFee / 100}`)));
    setPaymentPolicy(obeeSettings2.data.ccPaymentPolicy);
    setWaitlistPolicy(obeeSettings2.data.ccWaitlistPolicy);
  }, [
    obeeSettings2.data.ccNoShowFee,
    obeeSettings2.data.ccPaymentPolicy,
    obeeSettings2.data.ccWaitlistPolicy
  ]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsPage }, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "30px", flexDirection: "column" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentsSetting }, /* @__PURE__ */ React__default.createElement(Box, { style: { alignItems: "center", display: "flex", justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "25px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Collect credit card details as security"), obeeSettings2.data.ccCapture && /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentsSettingEnabled }, /* @__PURE__ */ React__default.createElement(CheckInCircle, { style: { height: "18px", width: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Enabled"))), /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, "Charge no show fees in the event of late cancellations and no shows.")), obeeSettings2.data.ccCapture ? /* @__PURE__ */ React__default.createElement(
    IconCircleArrowUp,
    {
      className: classes.iconButton,
      onClick: () => setOpen(!open),
      style: { transform: !open && "rotate(180deg)" }
    }
  ) : /* @__PURE__ */ React__default.createElement(
    Button,
    {
      onClick: () => {
        updateObeeSettings2({ ccCapture: true });
      }
    },
    "Enable"
  )), obeeSettings2.data.ccCapture && open && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentsSettingDetails }, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", flexDirection: "column", gap: "15px" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { fontWeight: theme2.fontWeights.bold } }, "Bookings widget"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentsSettingDetailsRow }, /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, /* @__PURE__ */ React__default.createElement(Box, null, "No show fee"), /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "14px" } }, "Per ", obeeSettings2.data.ccNoShowChargeType, " AUD, incl GST")), /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", alignItems: "baseline", gap: "8px" } }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      value: noShowFee,
      onChange: setNoShowFee,
      type: "currency",
      placeholder: "Empty",
      inputPrefix: "$",
      onBlur: () => {
        if (noShowFee === null || noShowFee === "") {
          if (obeeSettings2.data.ccNoShowFee !== null && obeeSettings2.data.ccNoShowFee !== 0) {
            updateObeeSettings2({
              ccNoShowFee: 0
            });
          }
          return;
        }
        const value = Math.floor(Number(format(noShowFee) * 100));
        if (value !== obeeSettings2.data.ccNoShowFee) {
          updateObeeSettings2({
            ccNoShowFee: value
          });
        }
      },
      style: {
        container: { marginLeft: "-10px" },
        input: {
          padding: "8px 10px",
          paddingLeft: "20px",
          fontSize: "15px"
        }
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      placeholder: "Empty",
      value: obeeSettings2.data.ccNoShowChargeType,
      onSelect: (value) => {
        updateObeeSettings2({ ccNoShowChargeType: value });
      },
      items: [
        { label: "per guest", value: "guest" },
        { label: "per group", value: "group" }
      ],
      style: {
        ...cleanDropdownPopoverStyles,
        container: {
          ...cleanDropdownPopoverStyles.container,
          marginLeft: "-10px",
          marginTop: "-10px"
        }
      }
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentsSettingDetailsRow }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        color: theme2.colors.smoke,
        alignSelf: "flex-start",
        marginTop: "14px"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { style: { maxWidth: "200px" } }, "Payment policy"),
    /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        style: { ...linkStyles(theme2), width: "fit-content", marginTop: "8px" },
        onClick: (e) => setExampleAnchorEl(e.currentTarget)
      },
      "View example"
    )
  ), /* @__PURE__ */ React__default.createElement(
    InlineTextArea,
    {
      value: paymentPolicy,
      onChange: setPaymentPolicy,
      onBlur: (e) => {
        if (paymentPolicy !== obeeSettings2.data.ccPaymentPolicy) {
          updateObeeSettings2({ ccPaymentPolicy: e.target.value });
        }
      },
      placeholder: "Empty",
      style: {
        textFieldInner: { padding: 0, margin: 0 },
        input: {
          fontSize: "15px",
          padding: "10px",
          width: "100%",
          resize: "none"
        },
        container: { marginLeft: "-10px" }
      }
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentsSettingDetailsRow }, /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, /* @__PURE__ */ React__default.createElement(Box, { style: { maxWidth: "200px" } }, "Show for waitlist requests")), /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      placeholder: "Empty",
      value: obeeSettings2.data.ccWaitlistShow,
      onSelect: (value) => {
        updateObeeSettings2({ ccWaitlistShow: value });
      },
      items: [
        { label: "Mandatory", value: "mandatory" },
        { label: "Optional", value: "optional" },
        { label: "Off", value: "off" }
      ],
      style: {
        ...cleanDropdownPopoverStyles,
        container: {
          ...cleanDropdownPopoverStyles.container,
          marginLeft: "-10px",
          marginTop: "-10px"
        }
      }
    }
  )), obeeSettings2.data.ccWaitlistShow && obeeSettings2.data.ccWaitlistShow !== "off" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentsSettingDetailsRow }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        color: theme2.colors.smoke,
        alignSelf: "flex-start",
        marginTop: "14px"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { style: { maxWidth: "200px" } }, "Waitlist payment policy"),
    /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        style: { ...linkStyles(theme2), width: "fit-content", marginTop: "8px" },
        onClick: (e) => setWaitlistExampleAnchorEl(e.currentTarget)
      },
      "View example"
    )
  ), /* @__PURE__ */ React__default.createElement(
    InlineTextArea,
    {
      value: waitlistPolicy,
      onChange: setWaitlistPolicy,
      onBlur: (e) => {
        if (waitlistPolicy !== obeeSettings2.data.ccWaitlistPolicy) {
          updateObeeSettings2({ ccWaitlistPolicy: e.target.value });
        }
      },
      placeholder: "Empty",
      style: {
        textFieldInner: { padding: 0, margin: 0 },
        input: {
          fontSize: "15px",
          padding: "10px 14px",
          width: "100%",
          resize: "none"
        },
        container: { marginLeft: "-10px" }
      }
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { mt: "50px", style: { fontWeight: theme2.fontWeights.bold } }, "Booking options"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.paymentsSettingDetailsRow }, /* @__PURE__ */ React__default.createElement(Box, { style: { color: theme2.colors.smoke } }, /* @__PURE__ */ React__default.createElement(Box, { style: { maxWidth: "220px" } }, "Show Add booking area Phone bookings", /* @__PURE__ */ React__default.createElement("br", null), "(Internal only)")), /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      placeholder: "Empty",
      value: obeeSettings2.data.ccAddBookings,
      onSelect: (value) => {
        updateObeeSettings2({ ccAddBookings: value });
      },
      items: [
        { label: "Mandatory", value: ccAddBookingsValues.mandatory },
        { label: "Optional", value: ccAddBookingsValues.optional },
        { label: "Off", value: ccAddBookingsValues.off }
      ],
      style: {
        ...cleanDropdownPopoverStyles,
        container: {
          ...cleanDropdownPopoverStyles.container,
          marginLeft: "-10px",
          marginTop: "-10px"
        }
      }
    }
  )))), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "text",
      style: { ...linkStyles(theme2), width: "fit-content" },
      onClick: () => {
        updateObeeSettings2({ ccCapture: false });
      }
    },
    "Disable credit card collect no charge"
  )))), /* @__PURE__ */ React__default.createElement(
    PaymentPolicyExample$1,
    {
      anchorEl: exampleAnchorEl,
      setAnchorEl: setExampleAnchorEl,
      setDescription: setPaymentPolicy
    }
  ), /* @__PURE__ */ React__default.createElement(
    PaymentPolicyExample$1,
    {
      anchorEl: waitlistExampleAnchorEl,
      setAnchorEl: setWaitlistExampleAnchorEl,
      setDescription: setWaitlistPolicy
    }
  ));
};
PaymentSettings.propTypes = {
  updateObeeSettings: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$25 = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$24 = (dispatch) => bindActionCreators({ updateObeeSettings: updateSettingsAction }, dispatch);
const PaymentSettings$1 = connect(mapStateToProps$25, mapDispatchToProps$24)(PaymentSettings);
const imageFloorplanListView = "data:image/png;base64,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";
const imageFloorplanMapView = "data:image/png;base64,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";
const AreasSettings = () => {
  var _a, _b2;
  const classes = useStyles$1w();
  const history = useHistory();
  const items = [
    {
      image: imageFloorplanMapView,
      heading: "Floor Plan View",
      paragraph: "Edit areas and tables from the floor plan",
      link: `${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/floorplan/edit?view=map`
    },
    {
      image: imageFloorplanListView,
      heading: "Table View",
      paragraph: "Edit areas and tables your drag and drop table",
      link: `${(_b2 = window.bookingsConfig) == null ? void 0 : _b2.routePrefix}/floorplan/edit?view=list`
    }
  ];
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.settingsPage }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.areasContainer }, items.map((item) => /* @__PURE__ */ React__default.createElement(Box, { key: item == null ? void 0 : item.heading, className: classes.areaCardContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaCardImageContainer }, /* @__PURE__ */ React__default.createElement("img", { src: item.image, alt: item.heading, className: classes.areaCardImage })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaCardTextContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaCardTextHeading }, item.heading), /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaCardTextParagraph }, item.paragraph)), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "secondary",
      onClick: () => history.push(item.link),
      style: { ...buttonStyles$3, button: { ...buttonStyles$3.button, width: "180px" } }
    },
    "Launch"
  ))))));
};
const AreasSettings$1 = AreasSettings;
var immutable = { exports: {} };
(function(module2, exports) {
  (function(global2, factory2) {
    module2.exports = factory2();
  })(commonjsGlobal, function() {
    var SLICE$0 = Array.prototype.slice;
    function createClass(ctor, superClass) {
      if (superClass) {
        ctor.prototype = Object.create(superClass.prototype);
      }
      ctor.prototype.constructor = ctor;
    }
    function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }
    createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }
    createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }
    createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    function isIterable(maybeIterable) {
      return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
    }
    function isKeyed(maybeKeyed) {
      return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
    }
    function isIndexed(maybeIndexed) {
      return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
    }
    function isAssociative(maybeAssociative) {
      return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
    }
    function isOrdered(maybeOrdered) {
      return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
    }
    Iterable.isIterable = isIterable;
    Iterable.isKeyed = isKeyed;
    Iterable.isIndexed = isIndexed;
    Iterable.isAssociative = isAssociative;
    Iterable.isOrdered = isOrdered;
    Iterable.Keyed = KeyedIterable;
    Iterable.Indexed = IndexedIterable;
    Iterable.Set = SetIterable;
    var IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@";
    var IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@";
    var IS_INDEXED_SENTINEL = "@@__IMMUTABLE_INDEXED__@@";
    var IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@";
    var DELETE = "delete";
    var SHIFT = 5;
    var SIZE = 1 << SHIFT;
    var MASK = SIZE - 1;
    var NOT_SET = {};
    var CHANGE_LENGTH = { value: false };
    var DID_ALTER = { value: false };
    function MakeRef(ref) {
      ref.value = false;
      return ref;
    }
    function SetRef(ref) {
      ref && (ref.value = true);
    }
    function OwnerID() {
    }
    function arrCopy(arr, offset) {
      offset = offset || 0;
      var len = Math.max(0, arr.length - offset);
      var newArr = new Array(len);
      for (var ii = 0; ii < len; ii++) {
        newArr[ii] = arr[ii + offset];
      }
      return newArr;
    }
    function ensureSize(iter) {
      if (iter.size === void 0) {
        iter.size = iter.__iterate(returnTrue3);
      }
      return iter.size;
    }
    function wrapIndex(iter, index) {
      if (typeof index !== "number") {
        var uint32Index = index >>> 0;
        if ("" + uint32Index !== index || uint32Index === 4294967295) {
          return NaN;
        }
        index = uint32Index;
      }
      return index < 0 ? ensureSize(iter) + index : index;
    }
    function returnTrue3() {
      return true;
    }
    function wholeSlice(begin, end, size) {
      return (begin === 0 || size !== void 0 && begin <= -size) && (end === void 0 || size !== void 0 && end >= size);
    }
    function resolveBegin(begin, size) {
      return resolveIndex(begin, size, 0);
    }
    function resolveEnd(end, size) {
      return resolveIndex(end, size, size);
    }
    function resolveIndex(index, size, defaultIndex) {
      return index === void 0 ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === void 0 ? index : Math.min(size, index);
    }
    var ITERATE_KEYS = 0;
    var ITERATE_VALUES = 1;
    var ITERATE_ENTRIES = 2;
    var REAL_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
    function Iterator(next) {
      this.next = next;
    }
    Iterator.prototype.toString = function() {
      return "[Iterator]";
    };
    Iterator.KEYS = ITERATE_KEYS;
    Iterator.VALUES = ITERATE_VALUES;
    Iterator.ENTRIES = ITERATE_ENTRIES;
    Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
      return this.toString();
    };
    Iterator.prototype[ITERATOR_SYMBOL] = function() {
      return this;
    };
    function iteratorValue(type2, k, v, iteratorResult) {
      var value = type2 === 0 ? k : type2 === 1 ? v : [k, v];
      iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value,
        done: false
      };
      return iteratorResult;
    }
    function iteratorDone() {
      return { value: void 0, done: true };
    }
    function hasIterator(maybeIterable) {
      return !!getIteratorFn(maybeIterable);
    }
    function isIterator(maybeIterator) {
      return maybeIterator && typeof maybeIterator.next === "function";
    }
    function getIterator(iterable) {
      var iteratorFn = getIteratorFn(iterable);
      return iteratorFn && iteratorFn.call(iterable);
    }
    function getIteratorFn(iterable) {
      var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    function isArrayLike(value) {
      return value && typeof value.length === "number";
    }
    createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === void 0 ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
    }
    Seq.of = function() {
      return Seq(arguments);
    };
    Seq.prototype.toSeq = function() {
      return this;
    };
    Seq.prototype.toString = function() {
      return this.__toString("Seq {", "}");
    };
    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };
    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };
    Seq.prototype.__iterator = function(type2, reverse) {
      return seqIterator(this, type2, reverse, true);
    };
    createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === void 0 ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
    }
    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };
    createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === void 0 ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }
    IndexedSeq.of = function() {
      return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };
    IndexedSeq.prototype.toString = function() {
      return this.__toString("Seq [", "]");
    };
    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };
    IndexedSeq.prototype.__iterator = function(type2, reverse) {
      return seqIterator(this, type2, reverse, false);
    };
    createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (value === null || value === void 0 ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
    }
    SetSeq.of = function() {
      return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function() {
      return this;
    };
    Seq.isSeq = isSeq;
    Seq.Keyed = KeyedSeq;
    Seq.Set = SetSeq;
    Seq.Indexed = IndexedSeq;
    var IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@";
    Seq.prototype[IS_SEQ_SENTINEL] = true;
    createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }
    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };
    ArraySeq.prototype.__iterator = function(type2, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(
        function() {
          return ii > maxIndex ? iteratorDone() : iteratorValue(type2, ii, array[reverse ? maxIndex - ii++ : ii++]);
        }
      );
    };
    createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys2 = Object.keys(object);
      this._object = object;
      this._keys = keys2;
      this.size = keys2.length;
    }
    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== void 0 && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };
    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };
    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys2 = this._keys;
      var maxIndex = keys2.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys2[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };
    ObjectSeq.prototype.__iterator = function(type2, reverse) {
      var object = this._object;
      var keys2 = this._keys;
      var maxIndex = keys2.length - 1;
      var ii = 0;
      return new Iterator(function() {
        var key = keys2[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ? iteratorDone() : iteratorValue(type2, key, object[key]);
      });
    };
    ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }
    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };
    IterableSeq.prototype.__iteratorUncached = function(type2, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type2, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function() {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type2, iterations++, step.value);
      });
    };
    createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }
    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    IteratorSeq.prototype.__iteratorUncached = function(type2, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type2, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function() {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type2, iterations, cache[iterations++]);
      });
    };
    function isSeq(maybeSeq) {
      return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
    }
    var EMPTY_SEQ;
    function emptySequence() {
      return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
    }
    function keyedSeqFromValue(value) {
      var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === "object" ? new ObjectSeq(value) : void 0;
      if (!seq) {
        throw new TypeError(
          "Expected Array or iterable object of [k, v] entries, or keyed object: " + value
        );
      }
      return seq;
    }
    function indexedSeqFromValue(value) {
      var seq = maybeIndexedSeqFromValue(value);
      if (!seq) {
        throw new TypeError(
          "Expected Array or iterable object of values: " + value
        );
      }
      return seq;
    }
    function seqFromValue(value) {
      var seq = maybeIndexedSeqFromValue(value) || typeof value === "object" && new ObjectSeq(value);
      if (!seq) {
        throw new TypeError(
          "Expected Array or iterable object of values, or keyed object: " + value
        );
      }
      return seq;
    }
    function maybeIndexedSeqFromValue(value) {
      return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : void 0;
    }
    function seqIterate(seq, fn, reverse, useKeys) {
      var cache = seq._cache;
      if (cache) {
        var maxIndex = cache.length - 1;
        for (var ii = 0; ii <= maxIndex; ii++) {
          var entry = cache[reverse ? maxIndex - ii : ii];
          if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
            return ii + 1;
          }
        }
        return ii;
      }
      return seq.__iterateUncached(fn, reverse);
    }
    function seqIterator(seq, type2, reverse, useKeys) {
      var cache = seq._cache;
      if (cache) {
        var maxIndex = cache.length - 1;
        var ii = 0;
        return new Iterator(function() {
          var entry = cache[reverse ? maxIndex - ii : ii];
          return ii++ > maxIndex ? iteratorDone() : iteratorValue(type2, useKeys ? entry[0] : ii - 1, entry[1]);
        });
      }
      return seq.__iteratorUncached(type2, reverse);
    }
    function fromJS2(json, converter) {
      return converter ? fromJSWith(converter, json, "", { "": json }) : fromJSDefault(json);
    }
    function fromJSWith(converter, json, key, parentJSON) {
      if (Array.isArray(json)) {
        return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k) {
          return fromJSWith(converter, v, k, json);
        }));
      }
      if (isPlainObj(json)) {
        return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k) {
          return fromJSWith(converter, v, k, json);
        }));
      }
      return json;
    }
    function fromJSDefault(json) {
      if (Array.isArray(json)) {
        return IndexedSeq(json).map(fromJSDefault).toList();
      }
      if (isPlainObj(json)) {
        return KeyedSeq(json).map(fromJSDefault).toMap();
      }
      return json;
    }
    function isPlainObj(value) {
      return value && (value.constructor === Object || value.constructor === void 0);
    }
    function is(valueA, valueB) {
      if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
      if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
          return true;
        }
        if (!valueA || !valueB) {
          return false;
        }
      }
      if (typeof valueA.equals === "function" && typeof valueB.equals === "function" && valueA.equals(valueB)) {
        return true;
      }
      return false;
    }
    function deepEqual2(a, b) {
      if (a === b) {
        return true;
      }
      if (!isIterable(b) || a.size !== void 0 && b.size !== void 0 && a.size !== b.size || a.__hash !== void 0 && b.__hash !== void 0 && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
        return false;
      }
      if (a.size === 0 && b.size === 0) {
        return true;
      }
      var notAssociative = !isAssociative(a);
      if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
          var entry = entries.next().value;
          return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
      }
      var flipped = false;
      if (a.size === void 0) {
        if (b.size === void 0) {
          if (typeof a.cacheResult === "function") {
            a.cacheResult();
          }
        } else {
          flipped = true;
          var _ = a;
          a = b;
          b = _;
        }
      }
      var allEqual = true;
      var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
          allEqual = false;
          return false;
        }
      });
      return allEqual && a.size === bSize;
    }
    createClass(Repeat2, IndexedSeq);
    function Repeat2(value, times) {
      if (!(this instanceof Repeat2)) {
        return new Repeat2(value, times);
      }
      this._value = value;
      this.size = times === void 0 ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }
    Repeat2.prototype.toString = function() {
      if (this.size === 0) {
        return "Repeat []";
      }
      return "Repeat [ " + this._value + " " + this.size + " times ]";
    };
    Repeat2.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };
    Repeat2.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };
    Repeat2.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this : new Repeat2(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat2.prototype.reverse = function() {
      return this;
    };
    Repeat2.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };
    Repeat2.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };
    Repeat2.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };
    Repeat2.prototype.__iterator = function(type2, reverse) {
      var this$0 = this;
      var ii = 0;
      return new Iterator(
        function() {
          return ii < this$0.size ? iteratorValue(type2, ii++, this$0._value) : iteratorDone();
        }
      );
    };
    Repeat2.prototype.equals = function(other) {
      return other instanceof Repeat2 ? is(this._value, other._value) : deepEqual2(other);
    };
    var EMPTY_REPEAT;
    function invariant2(condition, error) {
      if (!condition)
        throw new Error(error);
    }
    createClass(Range, IndexedSeq);
    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant2(step !== 0, "Cannot step a Range by 0");
      start = start || 0;
      if (end === void 0) {
        end = Infinity;
      }
      step = step === void 0 ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }
    Range.prototype.toString = function() {
      if (this.size === 0) {
        return "Range []";
      }
      return "Range [ " + this._start + "..." + this._end + (this._step > 1 ? " by " + this._step : "") + " ]";
    };
    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index;
        }
      }
      return -1;
    };
    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };
    Range.prototype.__iterator = function(type2, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function() {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type2, ii++, v);
      });
    };
    Range.prototype.equals = function(other) {
      return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual2(this, other);
    };
    var EMPTY_RANGE;
    createClass(Collection, Iterable);
    function Collection() {
      throw TypeError("Abstract");
    }
    createClass(KeyedCollection, Collection);
    function KeyedCollection() {
    }
    createClass(IndexedCollection, Collection);
    function IndexedCollection() {
    }
    createClass(SetCollection, Collection);
    function SetCollection() {
    }
    Collection.Keyed = KeyedCollection;
    Collection.Indexed = IndexedCollection;
    Collection.Set = SetCollection;
    var imul = typeof Math.imul === "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function imul2(a, b) {
      a = a | 0;
      b = b | 0;
      var c = a & 65535;
      var d = b & 65535;
      return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0;
    };
    function smi(i32) {
      return i32 >>> 1 & 1073741824 | i32 & 3221225471;
    }
    function hash(o) {
      if (o === false || o === null || o === void 0) {
        return 0;
      }
      if (typeof o.valueOf === "function") {
        o = o.valueOf();
        if (o === false || o === null || o === void 0) {
          return 0;
        }
      }
      if (o === true) {
        return 1;
      }
      var type2 = typeof o;
      if (type2 === "number") {
        var h = o | 0;
        if (h !== o) {
          h ^= o * 4294967295;
        }
        while (o > 4294967295) {
          o /= 4294967295;
          h ^= o;
        }
        return smi(h);
      }
      if (type2 === "string") {
        return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
      }
      if (typeof o.hashCode === "function") {
        return o.hashCode();
      }
      if (type2 === "object") {
        return hashJSObj(o);
      }
      if (typeof o.toString === "function") {
        return hashString(o.toString());
      }
      throw new Error("Value type " + type2 + " cannot be hashed.");
    }
    function cachedHashString(string) {
      var hash2 = stringHashCache[string];
      if (hash2 === void 0) {
        hash2 = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
          STRING_HASH_CACHE_SIZE = 0;
          stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hash2;
      }
      return hash2;
    }
    function hashString(string) {
      var hash2 = 0;
      for (var ii = 0; ii < string.length; ii++) {
        hash2 = 31 * hash2 + string.charCodeAt(ii) | 0;
      }
      return smi(hash2);
    }
    function hashJSObj(obj) {
      var hash2;
      if (usingWeakMap) {
        hash2 = weakMap.get(obj);
        if (hash2 !== void 0) {
          return hash2;
        }
      }
      hash2 = obj[UID_HASH_KEY];
      if (hash2 !== void 0) {
        return hash2;
      }
      if (!canDefineProperty) {
        hash2 = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hash2 !== void 0) {
          return hash2;
        }
        hash2 = getIENodeHash(obj);
        if (hash2 !== void 0) {
          return hash2;
        }
      }
      hash2 = ++objHashUID;
      if (objHashUID & 1073741824) {
        objHashUID = 0;
      }
      if (usingWeakMap) {
        weakMap.set(obj, hash2);
      } else if (isExtensible !== void 0 && isExtensible(obj) === false) {
        throw new Error("Non-extensible objects are not allowed as keys.");
      } else if (canDefineProperty) {
        Object.defineProperty(obj, UID_HASH_KEY, {
          "enumerable": false,
          "configurable": false,
          "writable": false,
          "value": hash2
        });
      } else if (obj.propertyIsEnumerable !== void 0 && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        obj.propertyIsEnumerable = function() {
          return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[UID_HASH_KEY] = hash2;
      } else if (obj.nodeType !== void 0) {
        obj[UID_HASH_KEY] = hash2;
      } else {
        throw new Error("Unable to set a non-enumerable property on object.");
      }
      return hash2;
    }
    var isExtensible = Object.isExtensible;
    var canDefineProperty = function() {
      try {
        Object.defineProperty({}, "@", {});
        return true;
      } catch (e) {
        return false;
      }
    }();
    function getIENodeHash(node) {
      if (node && node.nodeType > 0) {
        switch (node.nodeType) {
          case 1:
            return node.uniqueID;
          case 9:
            return node.documentElement && node.documentElement.uniqueID;
        }
      }
    }
    var usingWeakMap = typeof WeakMap === "function";
    var weakMap;
    if (usingWeakMap) {
      weakMap = /* @__PURE__ */ new WeakMap();
    }
    var objHashUID = 0;
    var UID_HASH_KEY = "__immutablehash__";
    if (typeof Symbol === "function") {
      UID_HASH_KEY = Symbol(UID_HASH_KEY);
    }
    var STRING_HASH_CACHE_MIN_STRLEN = 16;
    var STRING_HASH_CACHE_MAX_SIZE = 255;
    var STRING_HASH_CACHE_SIZE = 0;
    var stringHashCache = {};
    function assertNotInfinite(size) {
      invariant2(
        size !== Infinity,
        "Cannot perform this action with an infinite size."
      );
    }
    createClass(Map2, KeyedCollection);
    function Map2(value) {
      return value === null || value === void 0 ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
        var iter = KeyedIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function(v, k) {
          return map.set(k, v);
        });
      });
    }
    Map2.prototype.toString = function() {
      return this.__toString("Map {", "}");
    };
    Map2.prototype.get = function(k, notSetValue) {
      return this._root ? this._root.get(0, void 0, k, notSetValue) : notSetValue;
    };
    Map2.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };
    Map2.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function() {
        return v;
      });
    };
    Map2.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };
    Map2.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function() {
        return NOT_SET;
      });
    };
    Map2.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
    };
    Map2.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = void 0;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? void 0 : updatedValue;
    };
    Map2.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = void 0;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };
    Map2.prototype.merge = function() {
      return mergeIntoMapWith(this, void 0, arguments);
    };
    Map2.prototype.mergeWith = function(merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };
    Map2.prototype.mergeIn = function(keyPath) {
      var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m) {
          return typeof m.merge === "function" ? m.merge.apply(m, iters) : iters[iters.length - 1];
        }
      );
    };
    Map2.prototype.mergeDeep = function() {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };
    Map2.prototype.mergeDeepWith = function(merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };
    Map2.prototype.mergeDeepIn = function(keyPath) {
      var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m) {
          return typeof m.mergeDeep === "function" ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
        }
      );
    };
    Map2.prototype.sort = function(comparator) {
      return OrderedMap2(sortFactory(this, comparator));
    };
    Map2.prototype.sortBy = function(mapper, comparator) {
      return OrderedMap2(sortFactory(this, comparator, mapper));
    };
    Map2.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };
    Map2.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };
    Map2.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };
    Map2.prototype.wasAltered = function() {
      return this.__altered;
    };
    Map2.prototype.__iterator = function(type2, reverse) {
      return new MapIterator(this, type2, reverse);
    };
    Map2.prototype.__iterate = function(fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };
    Map2.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    function isMap(maybeMap) {
      return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
    }
    Map2.isMap = isMap;
    var IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@";
    var MapPrototype = Map2.prototype;
    MapPrototype[IS_MAP_SENTINEL] = true;
    MapPrototype[DELETE] = MapPrototype.remove;
    MapPrototype.removeIn = MapPrototype.deleteIn;
    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }
    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };
    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;
      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }
      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);
      if (removed && entries.length === 1) {
        return;
      }
      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }
      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);
      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }
      if (isEditable) {
        this.entries = newEntries;
        return this;
      }
      return new ArrayMapNode(ownerID, newEntries);
    };
    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }
    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === void 0) {
        keyHash = hash(key);
      }
      var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
    };
    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === void 0) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;
      if (!exists && value === NOT_SET) {
        return this;
      }
      var idx = popCount(bitmap & bit - 1);
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : void 0;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }
      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }
      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }
      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }
      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }
      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };
    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }
    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === void 0) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };
    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === void 0) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];
      if (removed && !node) {
        return this;
      }
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }
      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }
      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);
      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }
      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };
    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }
    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };
    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === void 0) {
        keyHash = hash(key);
      }
      var removed = value === NOT_SET;
      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }
      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;
      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }
      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);
      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }
      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);
      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }
      if (isEditable) {
        this.entries = newEntries;
        return this;
      }
      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };
    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }
    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };
    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }
      SetRef(didAlter);
      if (removed) {
        SetRef(didChangeSize);
        return;
      }
      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }
      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };
    ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
      var entries = this.entries;
      for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
          return false;
        }
      }
    };
    BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
      var nodes = this.nodes;
      for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) {
          return false;
        }
      }
    };
    ValueNode.prototype.iterate = function(fn, reverse) {
      return fn(this.entry);
    };
    createClass(MapIterator, Iterator);
    function MapIterator(map, type2, reverse) {
      this._type = type2;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }
    MapIterator.prototype.next = function() {
      var type2 = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type2, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type2, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type2, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };
    function mapIteratorValue(type2, entry) {
      return iteratorValue(type2, entry[0], entry[1]);
    }
    function mapIteratorFrame(node, prev) {
      return {
        node,
        index: 0,
        __prev: prev
      };
    }
    function makeMap(size, root2, ownerID, hash2) {
      var map = Object.create(MapPrototype);
      map.size = size;
      map._root = root2;
      map.__ownerID = ownerID;
      map.__hash = hash2;
      map.__altered = false;
      return map;
    }
    var EMPTY_MAP;
    function emptyMap() {
      return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
    }
    function updateMap(map, k, v) {
      var newRoot;
      var newSize;
      if (!map._root) {
        if (v === NOT_SET) {
          return map;
        }
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
      } else {
        var didChangeSize = MakeRef(CHANGE_LENGTH);
        var didAlter = MakeRef(DID_ALTER);
        newRoot = updateNode(map._root, map.__ownerID, 0, void 0, k, v, didChangeSize, didAlter);
        if (!didAlter.value) {
          return map;
        }
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
      }
      if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = void 0;
        map.__altered = true;
        return map;
      }
      return newRoot ? makeMap(newSize, newRoot) : emptyMap();
    }
    function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (!node) {
        if (value === NOT_SET) {
          return node;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [key, value]);
      }
      return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
    }
    function isLeafNode(node) {
      return node.constructor === ValueNode || node.constructor === HashCollisionNode;
    }
    function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
      if (node.keyHash === keyHash) {
        return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
      }
      var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
      var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var newNode;
      var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);
      return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
    }
    function createNodes(ownerID, entries, key, value) {
      if (!ownerID) {
        ownerID = new OwnerID();
      }
      var node = new ValueNode(ownerID, hash(key), [key, value]);
      for (var ii = 0; ii < entries.length; ii++) {
        var entry = entries[ii];
        node = node.update(ownerID, 0, void 0, entry[0], entry[1]);
      }
      return node;
    }
    function packNodes(ownerID, nodes, count, excluding) {
      var bitmap = 0;
      var packedII = 0;
      var packedNodes = new Array(count);
      for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
        var node = nodes[ii];
        if (node !== void 0 && ii !== excluding) {
          bitmap |= bit;
          packedNodes[packedII++] = node;
        }
      }
      return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
    }
    function expandNodes(ownerID, nodes, bitmap, including, node) {
      var count = 0;
      var expandedNodes = new Array(SIZE);
      for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
        expandedNodes[ii] = bitmap & 1 ? nodes[count++] : void 0;
      }
      expandedNodes[including] = node;
      return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
    }
    function mergeIntoMapWith(map, merger, iterables) {
      var iters = [];
      for (var ii = 0; ii < iterables.length; ii++) {
        var value = iterables[ii];
        var iter = KeyedIterable(value);
        if (!isIterable(value)) {
          iter = iter.map(function(v) {
            return fromJS2(v);
          });
        }
        iters.push(iter);
      }
      return mergeIntoCollectionWith(map, merger, iters);
    }
    function deepMerger(existing, value, key) {
      return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
    }
    function deepMergerWith(merger) {
      return function(existing, value, key) {
        if (existing && existing.mergeDeepWith && isIterable(value)) {
          return existing.mergeDeepWith(merger, value);
        }
        var nextValue = merger(existing, value, key);
        return is(existing, nextValue) ? existing : nextValue;
      };
    }
    function mergeIntoCollectionWith(collection, merger, iters) {
      iters = iters.filter(function(x) {
        return x.size !== 0;
      });
      if (iters.length === 0) {
        return collection;
      }
      if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
        return collection.constructor(iters[0]);
      }
      return collection.withMutations(function(collection2) {
        var mergeIntoMap = merger ? function(value, key) {
          collection2.update(
            key,
            NOT_SET,
            function(existing) {
              return existing === NOT_SET ? value : merger(existing, value, key);
            }
          );
        } : function(value, key) {
          collection2.set(key, value);
        };
        for (var ii = 0; ii < iters.length; ii++) {
          iters[ii].forEach(mergeIntoMap);
        }
      });
    }
    function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
      var isNotSet = existing === NOT_SET;
      var step = keyPathIter.next();
      if (step.done) {
        var existingValue = isNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
      }
      invariant2(
        isNotSet || existing && existing.set,
        "invalid keyPath"
      );
      var key = step.value;
      var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
      var nextUpdated = updateInDeepMap(
        nextExisting,
        keyPathIter,
        notSetValue,
        updater
      );
      return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
    }
    function popCount(x) {
      x = x - (x >> 1 & 1431655765);
      x = (x & 858993459) + (x >> 2 & 858993459);
      x = x + (x >> 4) & 252645135;
      x = x + (x >> 8);
      x = x + (x >> 16);
      return x & 127;
    }
    function setIn(array, idx, val, canEdit) {
      var newArray = canEdit ? array : arrCopy(array);
      newArray[idx] = val;
      return newArray;
    }
    function spliceIn(array, idx, val, canEdit) {
      var newLen = array.length + 1;
      if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
      }
      var newArray = new Array(newLen);
      var after = 0;
      for (var ii = 0; ii < newLen; ii++) {
        if (ii === idx) {
          newArray[ii] = val;
          after = -1;
        } else {
          newArray[ii] = array[ii + after];
        }
      }
      return newArray;
    }
    function spliceOut(array, idx, canEdit) {
      var newLen = array.length - 1;
      if (canEdit && idx === newLen) {
        array.pop();
        return array;
      }
      var newArray = new Array(newLen);
      var after = 0;
      for (var ii = 0; ii < newLen; ii++) {
        if (ii === idx) {
          after = 1;
        }
        newArray[ii] = array[ii + after];
      }
      return newArray;
    }
    var MAX_ARRAY_MAP_SIZE = SIZE / 4;
    var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
    var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
    createClass(List2, IndexedCollection);
    function List2(value) {
      var empty = emptyList();
      if (value === null || value === void 0) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list) {
        list.setSize(size);
        iter.forEach(function(v, i) {
          return list.set(i, v);
        });
      });
    }
    List2.of = function() {
      return this(arguments);
    };
    List2.prototype.toString = function() {
      return this.__toString("List [", "]");
    };
    List2.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };
    List2.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };
    List2.prototype.remove = function(index) {
      return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List2.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };
    List2.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = void 0;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };
    List2.prototype.push = function() {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };
    List2.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };
    List2.prototype.unshift = function() {
      var values = arguments;
      return this.withMutations(function(list) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };
    List2.prototype.shift = function() {
      return setListBounds(this, 1);
    };
    List2.prototype.merge = function() {
      return mergeIntoListWith(this, void 0, arguments);
    };
    List2.prototype.mergeWith = function(merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };
    List2.prototype.mergeDeep = function() {
      return mergeIntoListWith(this, deepMerger, arguments);
    };
    List2.prototype.mergeDeepWith = function(merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };
    List2.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };
    List2.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };
    List2.prototype.__iterator = function(type2, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function() {
        var value = values();
        return value === DONE ? iteratorDone() : iteratorValue(type2, index++, value);
      });
    };
    List2.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };
    List2.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    function isList(maybeList) {
      return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
    }
    List2.isList = isList;
    var IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@";
    var ListPrototype = List2.prototype;
    ListPrototype[IS_LIST_SENTINEL] = true;
    ListPrototype[DELETE] = ListPrototype.remove;
    ListPrototype.setIn = MapPrototype.setIn;
    ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
    ListPrototype.update = MapPrototype.update;
    ListPrototype.updateIn = MapPrototype.updateIn;
    ListPrototype.mergeIn = MapPrototype.mergeIn;
    ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    ListPrototype.withMutations = MapPrototype.withMutations;
    ListPrototype.asMutable = MapPrototype.asMutable;
    ListPrototype.asImmutable = MapPrototype.asImmutable;
    ListPrototype.wasAltered = MapPrototype.wasAltered;
    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }
    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : this.array.length === 0) {
        return this;
      }
      var originIndex = index >>> level & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = void 0;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };
    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = index - 1 >>> level & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }
      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }
      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };
    var DONE = {};
    function iterateList(list, reverse) {
      var left = list._origin;
      var right = list._capacity;
      var tailPos = getTailOffset(right);
      var tail = list._tail;
      return iterateNodeOrLeaf(list._root, list._level, 0);
      function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
      }
      function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) {
          to = SIZE;
        }
        return function() {
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          return array && array[idx];
        };
      }
      function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) {
          to = SIZE;
        }
        return function() {
          do {
            if (values) {
              var value = values();
              if (value !== DONE) {
                return value;
              }
              values = null;
            }
            if (from === to) {
              return DONE;
            }
            var idx = reverse ? --to : from++;
            values = iterateNodeOrLeaf(
              array && array[idx],
              level - SHIFT,
              offset + (idx << level)
            );
          } while (true);
        };
      }
    }
    function makeList(origin, capacity, level, root2, tail, ownerID, hash2) {
      var list = Object.create(ListPrototype);
      list.size = capacity - origin;
      list._origin = origin;
      list._capacity = capacity;
      list._level = level;
      list._root = root2;
      list._tail = tail;
      list.__ownerID = ownerID;
      list.__hash = hash2;
      list.__altered = false;
      return list;
    }
    var EMPTY_LIST;
    function emptyList() {
      return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
    }
    function updateList(list, index, value) {
      index = wrapIndex(list, index);
      if (index !== index) {
        return list;
      }
      if (index >= list.size || index < 0) {
        return list.withMutations(function(list2) {
          index < 0 ? setListBounds(list2, index).set(0, value) : setListBounds(list2, 0, index + 1).set(index, value);
        });
      }
      index += list._origin;
      var newTail = list._tail;
      var newRoot = list._root;
      var didAlter = MakeRef(DID_ALTER);
      if (index >= getTailOffset(list._capacity)) {
        newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
      } else {
        newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
      }
      if (!didAlter.value) {
        return list;
      }
      if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = void 0;
        list.__altered = true;
        return list;
      }
      return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
    }
    function updateVNode(node, ownerID, level, index, value, didAlter) {
      var idx = index >>> level & MASK;
      var nodeHas = node && idx < node.array.length;
      if (!nodeHas && value === void 0) {
        return node;
      }
      var newNode;
      if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) {
          return node;
        }
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
      }
      if (nodeHas && node.array[idx] === value) {
        return node;
      }
      SetRef(didAlter);
      newNode = editableVNode(node, ownerID);
      if (value === void 0 && idx === newNode.array.length - 1) {
        newNode.array.pop();
      } else {
        newNode.array[idx] = value;
      }
      return newNode;
    }
    function editableVNode(node, ownerID) {
      if (ownerID && node && ownerID === node.ownerID) {
        return node;
      }
      return new VNode(node ? node.array.slice() : [], ownerID);
    }
    function listNodeFor(list, rawIndex) {
      if (rawIndex >= getTailOffset(list._capacity)) {
        return list._tail;
      }
      if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while (node && level > 0) {
          node = node.array[rawIndex >>> level & MASK];
          level -= SHIFT;
        }
        return node;
      }
    }
    function setListBounds(list, begin, end) {
      if (begin !== void 0) {
        begin = begin | 0;
      }
      if (end !== void 0) {
        end = end | 0;
      }
      var owner = list.__ownerID || new OwnerID();
      var oldOrigin = list._origin;
      var oldCapacity = list._capacity;
      var newOrigin = oldOrigin + begin;
      var newCapacity = end === void 0 ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
      if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
        return list;
      }
      if (newOrigin >= newCapacity) {
        return list.clear();
      }
      var newLevel = list._level;
      var newRoot = list._root;
      var offsetShift = 0;
      while (newOrigin + offsetShift < 0) {
        newRoot = new VNode(newRoot && newRoot.array.length ? [void 0, newRoot] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
      }
      if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
      }
      var oldTailOffset = getTailOffset(oldCapacity);
      var newTailOffset = getTailOffset(newCapacity);
      while (newTailOffset >= 1 << newLevel + SHIFT) {
        newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
        newLevel += SHIFT;
      }
      var oldTail = list._tail;
      var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
      if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for (var level = newLevel; level > SHIFT; level -= SHIFT) {
          var idx = oldTailOffset >>> level & MASK;
          node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
      }
      if (newCapacity < oldCapacity) {
        newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
      }
      if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
      } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        while (newRoot) {
          var beginIndex = newOrigin >>> newLevel & MASK;
          if (beginIndex !== newTailOffset >>> newLevel & MASK) {
            break;
          }
          if (beginIndex) {
            offsetShift += (1 << newLevel) * beginIndex;
          }
          newLevel -= SHIFT;
          newRoot = newRoot.array[beginIndex];
        }
        if (newRoot && newOrigin > oldOrigin) {
          newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        }
        if (newRoot && newTailOffset < oldTailOffset) {
          newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        }
        if (offsetShift) {
          newOrigin -= offsetShift;
          newCapacity -= offsetShift;
        }
      }
      if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = void 0;
        list.__altered = true;
        return list;
      }
      return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
    }
    function mergeIntoListWith(list, merger, iterables) {
      var iters = [];
      var maxSize = 0;
      for (var ii = 0; ii < iterables.length; ii++) {
        var value = iterables[ii];
        var iter = IndexedIterable(value);
        if (iter.size > maxSize) {
          maxSize = iter.size;
        }
        if (!isIterable(value)) {
          iter = iter.map(function(v) {
            return fromJS2(v);
          });
        }
        iters.push(iter);
      }
      if (maxSize > list.size) {
        list = list.setSize(maxSize);
      }
      return mergeIntoCollectionWith(list, merger, iters);
    }
    function getTailOffset(size) {
      return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
    }
    createClass(OrderedMap2, Map2);
    function OrderedMap2(value) {
      return value === null || value === void 0 ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
        var iter = KeyedIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function(v, k) {
          return map.set(k, v);
        });
      });
    }
    OrderedMap2.of = function() {
      return this(arguments);
    };
    OrderedMap2.prototype.toString = function() {
      return this.__toString("OrderedMap {", "}");
    };
    OrderedMap2.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== void 0 ? this._list.get(index)[1] : notSetValue;
    };
    OrderedMap2.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };
    OrderedMap2.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };
    OrderedMap2.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap2.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };
    OrderedMap2.prototype.__iterate = function(fn, reverse) {
      var this$0 = this;
      return this._list.__iterate(
        function(entry) {
          return entry && fn(entry[1], entry[0], this$0);
        },
        reverse
      );
    };
    OrderedMap2.prototype.__iterator = function(type2, reverse) {
      return this._list.fromEntrySeq().__iterator(type2, reverse);
    };
    OrderedMap2.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    function isOrderedMap(maybeOrderedMap) {
      return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
    }
    OrderedMap2.isOrderedMap = isOrderedMap;
    OrderedMap2.prototype[IS_ORDERED_SENTINEL] = true;
    OrderedMap2.prototype[DELETE] = OrderedMap2.prototype.remove;
    function makeOrderedMap(map, list, ownerID, hash2) {
      var omap = Object.create(OrderedMap2.prototype);
      omap.size = map ? map.size : 0;
      omap._map = map;
      omap._list = list;
      omap.__ownerID = ownerID;
      omap.__hash = hash2;
      return omap;
    }
    var EMPTY_ORDERED_MAP;
    function emptyOrderedMap() {
      return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
    }
    function updateOrderedMap(omap, k, v) {
      var map = omap._map;
      var list = omap._list;
      var i = map.get(k);
      var has = i !== void 0;
      var newMap;
      var newList;
      if (v === NOT_SET) {
        if (!has) {
          return omap;
        }
        if (list.size >= SIZE && list.size >= map.size * 2) {
          newList = list.filter(function(entry, idx) {
            return entry !== void 0 && i !== idx;
          });
          newMap = newList.toKeyedSeq().map(function(entry) {
            return entry[0];
          }).flip().toMap();
          if (omap.__ownerID) {
            newMap.__ownerID = newList.__ownerID = omap.__ownerID;
          }
        } else {
          newMap = map.remove(k);
          newList = i === list.size - 1 ? list.pop() : list.set(i, void 0);
        }
      } else {
        if (has) {
          if (v === list.get(i)[1]) {
            return omap;
          }
          newMap = map;
          newList = list.set(i, [k, v]);
        } else {
          newMap = map.set(k, list.size);
          newList = list.set(list.size, [k, v]);
        }
      }
      if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = void 0;
        return omap;
      }
      return makeOrderedMap(newMap, newList);
    }
    createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }
    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function() {
      var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function() {
          return this$0._iter.toSeq().reverse();
        };
      }
      return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function(mapper, context) {
      var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function() {
          return this$0._iter.toSeq().map(mapper, context);
        };
      }
      return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {
      var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ? function(v, k) {
          return fn(v, k, this$0);
        } : (ii = reverse ? resolveSize(this) : 0, function(v) {
          return fn(v, reverse ? --ii : ii++, this$0);
        }),
        reverse
      );
    };
    ToKeyedSequence.prototype.__iterator = function(type2, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type2, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function() {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type2, reverse ? --ii : ii++, step.value, step);
      });
    };
    ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }
    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v) {
        return fn(v, iterations++, this$0);
      }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function(type2, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function() {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type2, iterations++, step.value, step);
      });
    };
    createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }
    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function(fn, reverse) {
      var this$0 = this;
      return this._iter.__iterate(function(v) {
        return fn(v, v, this$0);
      }, reverse);
    };
    ToSetSequence.prototype.__iterator = function(type2, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function() {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type2, step.value, step.value, step);
      });
    };
    createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }
    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {
      var this$0 = this;
      return this._iter.__iterate(function(entry) {
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function(type2, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function() {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type2,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };
    ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
    function flipFactory(iterable) {
      var flipSequence = makeSequence(iterable);
      flipSequence._iter = iterable;
      flipSequence.size = iterable.size;
      flipSequence.flip = function() {
        return iterable;
      };
      flipSequence.reverse = function() {
        var reversedSequence = iterable.reverse.apply(this);
        reversedSequence.flip = function() {
          return iterable.reverse();
        };
        return reversedSequence;
      };
      flipSequence.has = function(key) {
        return iterable.includes(key);
      };
      flipSequence.includes = function(key) {
        return iterable.has(key);
      };
      flipSequence.cacheResult = cacheResultThrough;
      flipSequence.__iterateUncached = function(fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(function(v, k) {
          return fn(k, v, this$0) !== false;
        }, reverse);
      };
      flipSequence.__iteratorUncached = function(type2, reverse) {
        if (type2 === ITERATE_ENTRIES) {
          var iterator = iterable.__iterator(type2, reverse);
          return new Iterator(function() {
            var step = iterator.next();
            if (!step.done) {
              var k = step.value[0];
              step.value[0] = step.value[1];
              step.value[1] = k;
            }
            return step;
          });
        }
        return iterable.__iterator(
          type2 === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
          reverse
        );
      };
      return flipSequence;
    }
    function mapFactory(iterable, mapper, context) {
      var mappedSequence = makeSequence(iterable);
      mappedSequence.size = iterable.size;
      mappedSequence.has = function(key) {
        return iterable.has(key);
      };
      mappedSequence.get = function(key, notSetValue) {
        var v = iterable.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
      };
      mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(
          function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$0) !== false;
          },
          reverse
        );
      };
      mappedSequence.__iteratorUncached = function(type2, reverse) {
        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          return iteratorValue(
            type2,
            key,
            mapper.call(context, entry[1], key, iterable),
            step
          );
        });
      };
      return mappedSequence;
    }
    function reverseFactory(iterable, useKeys) {
      var reversedSequence = makeSequence(iterable);
      reversedSequence._iter = iterable;
      reversedSequence.size = iterable.size;
      reversedSequence.reverse = function() {
        return iterable;
      };
      if (iterable.flip) {
        reversedSequence.flip = function() {
          var flipSequence = flipFactory(iterable);
          flipSequence.reverse = function() {
            return iterable.flip();
          };
          return flipSequence;
        };
      }
      reversedSequence.get = function(key, notSetValue) {
        return iterable.get(useKeys ? key : -1 - key, notSetValue);
      };
      reversedSequence.has = function(key) {
        return iterable.has(useKeys ? key : -1 - key);
      };
      reversedSequence.includes = function(value) {
        return iterable.includes(value);
      };
      reversedSequence.cacheResult = cacheResultThrough;
      reversedSequence.__iterate = function(fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(function(v, k) {
          return fn(v, k, this$0);
        }, !reverse);
      };
      reversedSequence.__iterator = function(type2, reverse) {
        return iterable.__iterator(type2, !reverse);
      };
      return reversedSequence;
    }
    function filterFactory(iterable, predicate, context, useKeys) {
      var filterSequence = makeSequence(iterable);
      if (useKeys) {
        filterSequence.has = function(key) {
          var v = iterable.get(key, NOT_SET);
          return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
        };
        filterSequence.get = function(key, notSetValue) {
          var v = iterable.get(key, NOT_SET);
          return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
        };
      }
      filterSequence.__iterateUncached = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        iterable.__iterate(function(v, k, c) {
          if (predicate.call(context, v, k, c)) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0);
          }
        }, reverse);
        return iterations;
      };
      filterSequence.__iteratorUncached = function(type2, reverse) {
        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
          while (true) {
            var step = iterator.next();
            if (step.done) {
              return step;
            }
            var entry = step.value;
            var key = entry[0];
            var value = entry[1];
            if (predicate.call(context, value, key, iterable)) {
              return iteratorValue(type2, useKeys ? key : iterations++, value, step);
            }
          }
        });
      };
      return filterSequence;
    }
    function countByFactory(iterable, grouper, context) {
      var groups = Map2().asMutable();
      iterable.__iterate(function(v, k) {
        groups.update(
          grouper.call(context, v, k, iterable),
          0,
          function(a) {
            return a + 1;
          }
        );
      });
      return groups.asImmutable();
    }
    function groupByFactory(iterable, grouper, context) {
      var isKeyedIter = isKeyed(iterable);
      var groups = (isOrdered(iterable) ? OrderedMap2() : Map2()).asMutable();
      iterable.__iterate(function(v, k) {
        groups.update(
          grouper.call(context, v, k, iterable),
          function(a) {
            return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
          }
        );
      });
      var coerce = iterableClass(iterable);
      return groups.map(function(arr) {
        return reify(iterable, coerce(arr));
      });
    }
    function sliceFactory(iterable, begin, end, useKeys) {
      var originalSize = iterable.size;
      if (begin !== void 0) {
        begin = begin | 0;
      }
      if (end !== void 0) {
        end = end | 0;
      }
      if (wholeSlice(begin, end, originalSize)) {
        return iterable;
      }
      var resolvedBegin = resolveBegin(begin, originalSize);
      var resolvedEnd = resolveEnd(end, originalSize);
      if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
        return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
      }
      var resolvedSize = resolvedEnd - resolvedBegin;
      var sliceSize;
      if (resolvedSize === resolvedSize) {
        sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
      }
      var sliceSeq = makeSequence(iterable);
      sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || void 0;
      if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
        sliceSeq.get = function(index, notSetValue) {
          index = wrapIndex(this, index);
          return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
        };
      }
      sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$0 = this;
        if (sliceSize === 0) {
          return 0;
        }
        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        iterable.__iterate(function(v, k) {
          if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
          }
        });
        return iterations;
      };
      sliceSeq.__iteratorUncached = function(type2, reverse) {
        if (sliceSize !== 0 && reverse) {
          return this.cacheResult().__iterator(type2, reverse);
        }
        var iterator = sliceSize !== 0 && iterable.__iterator(type2, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
          while (skipped++ < resolvedBegin) {
            iterator.next();
          }
          if (++iterations > sliceSize) {
            return iteratorDone();
          }
          var step = iterator.next();
          if (useKeys || type2 === ITERATE_VALUES) {
            return step;
          } else if (type2 === ITERATE_KEYS) {
            return iteratorValue(type2, iterations - 1, void 0, step);
          } else {
            return iteratorValue(type2, iterations - 1, step.value[1], step);
          }
        });
      };
      return sliceSeq;
    }
    function takeWhileFactory(iterable, predicate, context) {
      var takeSequence = makeSequence(iterable);
      takeSequence.__iterateUncached = function(fn, reverse) {
        var this$0 = this;
        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }
        var iterations = 0;
        iterable.__iterate(
          function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
          }
        );
        return iterations;
      };
      takeSequence.__iteratorUncached = function(type2, reverse) {
        var this$0 = this;
        if (reverse) {
          return this.cacheResult().__iterator(type2, reverse);
        }
        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
          if (!iterating) {
            return iteratorDone();
          }
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var k = entry[0];
          var v = entry[1];
          if (!predicate.call(context, v, k, this$0)) {
            iterating = false;
            return iteratorDone();
          }
          return type2 === ITERATE_ENTRIES ? step : iteratorValue(type2, k, v, step);
        });
      };
      return takeSequence;
    }
    function skipWhileFactory(iterable, predicate, context, useKeys) {
      var skipSequence = makeSequence(iterable);
      skipSequence.__iterateUncached = function(fn, reverse) {
        var this$0 = this;
        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }
        var isSkipping = true;
        var iterations = 0;
        iterable.__iterate(function(v, k, c) {
          if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0);
          }
        });
        return iterations;
      };
      skipSequence.__iteratorUncached = function(type2, reverse) {
        var this$0 = this;
        if (reverse) {
          return this.cacheResult().__iterator(type2, reverse);
        }
        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
          var step, k, v;
          do {
            step = iterator.next();
            if (step.done) {
              if (useKeys || type2 === ITERATE_VALUES) {
                return step;
              } else if (type2 === ITERATE_KEYS) {
                return iteratorValue(type2, iterations++, void 0, step);
              } else {
                return iteratorValue(type2, iterations++, step.value[1], step);
              }
            }
            var entry = step.value;
            k = entry[0];
            v = entry[1];
            skipping && (skipping = predicate.call(context, v, k, this$0));
          } while (skipping);
          return type2 === ITERATE_ENTRIES ? step : iteratorValue(type2, k, v, step);
        });
      };
      return skipSequence;
    }
    function concatFactory(iterable, values) {
      var isKeyedIterable = isKeyed(iterable);
      var iters = [iterable].concat(values).map(function(v) {
        if (!isIterable(v)) {
          v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
        } else if (isKeyedIterable) {
          v = KeyedIterable(v);
        }
        return v;
      }).filter(function(v) {
        return v.size !== 0;
      });
      if (iters.length === 0) {
        return iterable;
      }
      if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
          return singleton;
        }
      }
      var concatSeq = new ArraySeq(iters);
      if (isKeyedIterable) {
        concatSeq = concatSeq.toKeyedSeq();
      } else if (!isIndexed(iterable)) {
        concatSeq = concatSeq.toSetSeq();
      }
      concatSeq = concatSeq.flatten(true);
      concatSeq.size = iters.reduce(
        function(sum, seq) {
          if (sum !== void 0) {
            var size = seq.size;
            if (size !== void 0) {
              return sum + size;
            }
          }
        },
        0
      );
      return concatSeq;
    }
    function flattenFactory(iterable, depth, useKeys) {
      var flatSequence = makeSequence(iterable);
      flatSequence.__iterateUncached = function(fn, reverse) {
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
          var this$0 = this;
          iter.__iterate(function(v, k) {
            if ((!depth || currentDepth < depth) && isIterable(v)) {
              flatDeep(v, currentDepth + 1);
            } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
              stopped = true;
            }
            return !stopped;
          }, reverse);
        }
        flatDeep(iterable, 0);
        return iterations;
      };
      flatSequence.__iteratorUncached = function(type2, reverse) {
        var iterator = iterable.__iterator(type2, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
          while (iterator) {
            var step = iterator.next();
            if (step.done !== false) {
              iterator = stack.pop();
              continue;
            }
            var v = step.value;
            if (type2 === ITERATE_ENTRIES) {
              v = v[1];
            }
            if ((!depth || stack.length < depth) && isIterable(v)) {
              stack.push(iterator);
              iterator = v.__iterator(type2, reverse);
            } else {
              return useKeys ? step : iteratorValue(type2, iterations++, v, step);
            }
          }
          return iteratorDone();
        });
      };
      return flatSequence;
    }
    function flatMapFactory(iterable, mapper, context) {
      var coerce = iterableClass(iterable);
      return iterable.toSeq().map(
        function(v, k) {
          return coerce(mapper.call(context, v, k, iterable));
        }
      ).flatten(true);
    }
    function interposeFactory(iterable, separator) {
      var interposedSequence = makeSequence(iterable);
      interposedSequence.size = iterable.size && iterable.size * 2 - 1;
      interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        iterable.__iterate(
          function(v, k) {
            return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
          },
          reverse
        );
        return iterations;
      };
      interposedSequence.__iteratorUncached = function(type2, reverse) {
        var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
          if (!step || iterations % 2) {
            step = iterator.next();
            if (step.done) {
              return step;
            }
          }
          return iterations % 2 ? iteratorValue(type2, iterations++, separator) : iteratorValue(type2, iterations++, step.value, step);
        });
      };
      return interposedSequence;
    }
    function sortFactory(iterable, comparator, mapper) {
      if (!comparator) {
        comparator = defaultComparator;
      }
      var isKeyedIterable = isKeyed(iterable);
      var index = 0;
      var entries = iterable.toSeq().map(
        function(v, k) {
          return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
        }
      ).toArray();
      entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
      }).forEach(
        isKeyedIterable ? function(v, i) {
          entries[i].length = 2;
        } : function(v, i) {
          entries[i] = v[1];
        }
      );
      return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
    }
    function maxFactory(iterable, comparator, mapper) {
      if (!comparator) {
        comparator = defaultComparator;
      }
      if (mapper) {
        var entry = iterable.toSeq().map(function(v, k) {
          return [v, mapper(v, k, iterable)];
        }).reduce(function(a, b) {
          return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
      } else {
        return iterable.reduce(function(a, b) {
          return maxCompare(comparator, a, b) ? b : a;
        });
      }
    }
    function maxCompare(comparator, a, b) {
      var comp = comparator(b, a);
      return comp === 0 && b !== a && (b === void 0 || b === null || b !== b) || comp > 0;
    }
    function zipWithFactory(keyIter, zipper, iters) {
      var zipSequence = makeSequence(keyIter);
      zipSequence.size = new ArraySeq(iters).map(function(i) {
        return i.size;
      }).min();
      zipSequence.__iterate = function(fn, reverse) {
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
        return iterations;
      };
      zipSequence.__iteratorUncached = function(type2, reverse) {
        var iterators = iters.map(
          function(i) {
            return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
          }
        );
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
          var steps;
          if (!isDone) {
            steps = iterators.map(function(i) {
              return i.next();
            });
            isDone = steps.some(function(s) {
              return s.done;
            });
          }
          if (isDone) {
            return iteratorDone();
          }
          return iteratorValue(
            type2,
            iterations++,
            zipper.apply(null, steps.map(function(s) {
              return s.value;
            }))
          );
        });
      };
      return zipSequence;
    }
    function reify(iter, seq) {
      return isSeq(iter) ? seq : iter.constructor(seq);
    }
    function validateEntry(entry) {
      if (entry !== Object(entry)) {
        throw new TypeError("Expected [K, V] tuple: " + entry);
      }
    }
    function resolveSize(iter) {
      assertNotInfinite(iter.size);
      return ensureSize(iter);
    }
    function iterableClass(iterable) {
      return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
    }
    function makeSequence(iterable) {
      return Object.create(
        (isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype
      );
    }
    function cacheResultThrough() {
      if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
      } else {
        return Seq.prototype.cacheResult.call(this);
      }
    }
    function defaultComparator(a, b) {
      return a > b ? 1 : a < b ? -1 : 0;
    }
    function forceIterator(keyPath) {
      var iter = getIterator(keyPath);
      if (!iter) {
        if (!isArrayLike(keyPath)) {
          throw new TypeError("Expected iterable or array-like: " + keyPath);
        }
        iter = getIterator(Iterable(keyPath));
      }
      return iter;
    }
    createClass(Record2, KeyedCollection);
    function Record2(defaultValues, name2) {
      var hasInitialized;
      var RecordType = function Record22(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys2 = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys2);
          RecordTypePrototype.size = keys2.length;
          RecordTypePrototype._name = name2;
          RecordTypePrototype._keys = keys2;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map2(values);
      };
      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;
      return RecordType;
    }
    Record2.prototype.toString = function() {
      return this.__toString(recordName(this) + " {", "}");
    };
    Record2.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };
    Record2.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };
    Record2.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };
    Record2.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };
    Record2.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };
    Record2.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };
    Record2.prototype.__iterator = function(type2, reverse) {
      var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k) {
        return this$0.get(k);
      }).__iterator(type2, reverse);
    };
    Record2.prototype.__iterate = function(fn, reverse) {
      var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k) {
        return this$0.get(k);
      }).__iterate(fn, reverse);
    };
    Record2.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };
    var RecordPrototype = Record2.prototype;
    RecordPrototype[DELETE] = RecordPrototype.remove;
    RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
    RecordPrototype.merge = MapPrototype.merge;
    RecordPrototype.mergeWith = MapPrototype.mergeWith;
    RecordPrototype.mergeIn = MapPrototype.mergeIn;
    RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
    RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
    RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    RecordPrototype.setIn = MapPrototype.setIn;
    RecordPrototype.update = MapPrototype.update;
    RecordPrototype.updateIn = MapPrototype.updateIn;
    RecordPrototype.withMutations = MapPrototype.withMutations;
    RecordPrototype.asMutable = MapPrototype.asMutable;
    RecordPrototype.asImmutable = MapPrototype.asImmutable;
    function makeRecord(likeRecord, map, ownerID) {
      var record = Object.create(Object.getPrototypeOf(likeRecord));
      record._map = map;
      record.__ownerID = ownerID;
      return record;
    }
    function recordName(record) {
      return record._name || record.constructor.name || "Record";
    }
    function setProps(prototype, names) {
      try {
        names.forEach(setProp.bind(void 0, prototype));
      } catch (error) {
      }
    }
    function setProp(prototype, name2) {
      Object.defineProperty(prototype, name2, {
        get: function() {
          return this.get(name2);
        },
        set: function(value) {
          invariant2(this.__ownerID, "Cannot set on an immutable record.");
          this.set(name2, value);
        }
      });
    }
    createClass(Set2, SetCollection);
    function Set2(value) {
      return value === null || value === void 0 ? emptySet() : isSet2(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
        var iter = SetIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function(v) {
          return set.add(v);
        });
      });
    }
    Set2.of = function() {
      return this(arguments);
    };
    Set2.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };
    Set2.prototype.toString = function() {
      return this.__toString("Set {", "}");
    };
    Set2.prototype.has = function(value) {
      return this._map.has(value);
    };
    Set2.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };
    Set2.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };
    Set2.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };
    Set2.prototype.union = function() {
      var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x) {
        return x.size !== 0;
      });
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value) {
            return set.add(value);
          });
        }
      });
    };
    Set2.prototype.intersect = function() {
      var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter) {
        return SetIterable(iter);
      });
      var originalSet = this;
      return this.withMutations(function(set) {
        originalSet.forEach(function(value) {
          if (!iters.every(function(iter) {
            return iter.includes(value);
          })) {
            set.remove(value);
          }
        });
      });
    };
    Set2.prototype.subtract = function() {
      var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter) {
        return SetIterable(iter);
      });
      var originalSet = this;
      return this.withMutations(function(set) {
        originalSet.forEach(function(value) {
          if (iters.some(function(iter) {
            return iter.includes(value);
          })) {
            set.remove(value);
          }
        });
      });
    };
    Set2.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };
    Set2.prototype.mergeWith = function(merger) {
      var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };
    Set2.prototype.sort = function(comparator) {
      return OrderedSet2(sortFactory(this, comparator));
    };
    Set2.prototype.sortBy = function(mapper, comparator) {
      return OrderedSet2(sortFactory(this, comparator, mapper));
    };
    Set2.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };
    Set2.prototype.__iterate = function(fn, reverse) {
      var this$0 = this;
      return this._map.__iterate(function(_, k) {
        return fn(k, k, this$0);
      }, reverse);
    };
    Set2.prototype.__iterator = function(type2, reverse) {
      return this._map.map(function(_, k) {
        return k;
      }).__iterator(type2, reverse);
    };
    Set2.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };
    function isSet2(maybeSet) {
      return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
    }
    Set2.isSet = isSet2;
    var IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@";
    var SetPrototype = Set2.prototype;
    SetPrototype[IS_SET_SENTINEL] = true;
    SetPrototype[DELETE] = SetPrototype.remove;
    SetPrototype.mergeDeep = SetPrototype.merge;
    SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
    SetPrototype.withMutations = MapPrototype.withMutations;
    SetPrototype.asMutable = MapPrototype.asMutable;
    SetPrototype.asImmutable = MapPrototype.asImmutable;
    SetPrototype.__empty = emptySet;
    SetPrototype.__make = makeSet;
    function updateSet(set, newMap) {
      if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
      }
      return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
    }
    function makeSet(map, ownerID) {
      var set = Object.create(SetPrototype);
      set.size = map ? map.size : 0;
      set._map = map;
      set.__ownerID = ownerID;
      return set;
    }
    var EMPTY_SET2;
    function emptySet() {
      return EMPTY_SET2 || (EMPTY_SET2 = makeSet(emptyMap()));
    }
    createClass(OrderedSet2, Set2);
    function OrderedSet2(value) {
      return value === null || value === void 0 ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
        var iter = SetIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function(v) {
          return set.add(v);
        });
      });
    }
    OrderedSet2.of = function() {
      return this(arguments);
    };
    OrderedSet2.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };
    OrderedSet2.prototype.toString = function() {
      return this.__toString("OrderedSet {", "}");
    };
    function isOrderedSet(maybeOrderedSet) {
      return isSet2(maybeOrderedSet) && isOrdered(maybeOrderedSet);
    }
    OrderedSet2.isOrderedSet = isOrderedSet;
    var OrderedSetPrototype = OrderedSet2.prototype;
    OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
    OrderedSetPrototype.__empty = emptyOrderedSet;
    OrderedSetPrototype.__make = makeOrderedSet;
    function makeOrderedSet(map, ownerID) {
      var set = Object.create(OrderedSetPrototype);
      set.size = map ? map.size : 0;
      set._map = map;
      set.__ownerID = ownerID;
      return set;
    }
    var EMPTY_ORDERED_SET;
    function emptyOrderedSet() {
      return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
    }
    createClass(Stack2, IndexedCollection);
    function Stack2(value) {
      return value === null || value === void 0 ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
    }
    Stack2.of = function() {
      return this(arguments);
    };
    Stack2.prototype.toString = function() {
      return this.__toString("Stack [", "]");
    };
    Stack2.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };
    Stack2.prototype.peek = function() {
      return this._head && this._head.value;
    };
    Stack2.prototype.push = function() {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = void 0;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };
    Stack2.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value) {
        newSize++;
        head = {
          value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = void 0;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };
    Stack2.prototype.pop = function() {
      return this.slice(1);
    };
    Stack2.prototype.unshift = function() {
      return this.push.apply(this, arguments);
    };
    Stack2.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };
    Stack2.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };
    Stack2.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = void 0;
        this.__hash = void 0;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };
    Stack2.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = void 0;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };
    Stack2.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    Stack2.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };
    Stack2.prototype.__iterator = function(type2, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type2);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function() {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type2, iterations++, value);
        }
        return iteratorDone();
      });
    };
    function isStack(maybeStack) {
      return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
    }
    Stack2.isStack = isStack;
    var IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@";
    var StackPrototype = Stack2.prototype;
    StackPrototype[IS_STACK_SENTINEL] = true;
    StackPrototype.withMutations = MapPrototype.withMutations;
    StackPrototype.asMutable = MapPrototype.asMutable;
    StackPrototype.asImmutable = MapPrototype.asImmutable;
    StackPrototype.wasAltered = MapPrototype.wasAltered;
    function makeStack(size, head, ownerID, hash2) {
      var map = Object.create(StackPrototype);
      map.size = size;
      map._head = head;
      map.__ownerID = ownerID;
      map.__hash = hash2;
      map.__altered = false;
      return map;
    }
    var EMPTY_STACK;
    function emptyStack() {
      return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
    }
    function mixin(ctor, methods) {
      var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
      };
      Object.keys(methods).forEach(keyCopier);
      Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
      return ctor;
    }
    Iterable.Iterator = Iterator;
    mixin(Iterable, {
      // ### Conversion to other types
      toArray: function() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        this.valueSeq().__iterate(function(v, i) {
          array[i] = v;
        });
        return array;
      },
      toIndexedSeq: function() {
        return new ToIndexedSequence(this);
      },
      toJS: function() {
        return this.toSeq().map(
          function(value) {
            return value && typeof value.toJS === "function" ? value.toJS() : value;
          }
        ).__toJS();
      },
      toJSON: function() {
        return this.toSeq().map(
          function(value) {
            return value && typeof value.toJSON === "function" ? value.toJSON() : value;
          }
        ).__toJS();
      },
      toKeyedSeq: function() {
        return new ToKeyedSequence(this, true);
      },
      toMap: function() {
        return Map2(this.toKeyedSeq());
      },
      toObject: function() {
        assertNotInfinite(this.size);
        var object = {};
        this.__iterate(function(v, k) {
          object[k] = v;
        });
        return object;
      },
      toOrderedMap: function() {
        return OrderedMap2(this.toKeyedSeq());
      },
      toOrderedSet: function() {
        return OrderedSet2(isKeyed(this) ? this.valueSeq() : this);
      },
      toSet: function() {
        return Set2(isKeyed(this) ? this.valueSeq() : this);
      },
      toSetSeq: function() {
        return new ToSetSequence(this);
      },
      toSeq: function() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
      },
      toStack: function() {
        return Stack2(isKeyed(this) ? this.valueSeq() : this);
      },
      toList: function() {
        return List2(isKeyed(this) ? this.valueSeq() : this);
      },
      // ### Common JavaScript methods and properties
      toString: function() {
        return "[Iterable]";
      },
      __toString: function(head, tail) {
        if (this.size === 0) {
          return head + tail;
        }
        return head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
      },
      // ### ES6 Collection methods (ES6 Array and Map)
      concat: function() {
        var values = SLICE$0.call(arguments, 0);
        return reify(this, concatFactory(this, values));
      },
      includes: function(searchValue) {
        return this.some(function(value) {
          return is(value, searchValue);
        });
      },
      entries: function() {
        return this.__iterator(ITERATE_ENTRIES);
      },
      every: function(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
          if (!predicate.call(context, v, k, c)) {
            returnValue = false;
            return false;
          }
        });
        return returnValue;
      },
      filter: function(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
      },
      find: function(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
      },
      findEntry: function(predicate, context) {
        var found;
        this.__iterate(function(v, k, c) {
          if (predicate.call(context, v, k, c)) {
            found = [k, v];
            return false;
          }
        });
        return found;
      },
      findLastEntry: function(predicate, context) {
        return this.toSeq().reverse().findEntry(predicate, context);
      },
      forEach: function(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
      },
      join: function(separator) {
        assertNotInfinite(this.size);
        separator = separator !== void 0 ? "" + separator : ",";
        var joined = "";
        var isFirst = true;
        this.__iterate(function(v) {
          isFirst ? isFirst = false : joined += separator;
          joined += v !== null && v !== void 0 ? v.toString() : "";
        });
        return joined;
      },
      keys: function() {
        return this.__iterator(ITERATE_KEYS);
      },
      map: function(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
      },
      reduce: function(reducer, initialReduction, context) {
        assertNotInfinite(this.size);
        var reduction;
        var useFirst;
        if (arguments.length < 2) {
          useFirst = true;
        } else {
          reduction = initialReduction;
        }
        this.__iterate(function(v, k, c) {
          if (useFirst) {
            useFirst = false;
            reduction = v;
          } else {
            reduction = reducer.call(context, reduction, v, k, c);
          }
        });
        return reduction;
      },
      reduceRight: function(reducer, initialReduction, context) {
        var reversed = this.toKeyedSeq().reverse();
        return reversed.reduce.apply(reversed, arguments);
      },
      reverse: function() {
        return reify(this, reverseFactory(this, true));
      },
      slice: function(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
      },
      some: function(predicate, context) {
        return !this.every(not(predicate), context);
      },
      sort: function(comparator) {
        return reify(this, sortFactory(this, comparator));
      },
      values: function() {
        return this.__iterator(ITERATE_VALUES);
      },
      // ### More sequential methods
      butLast: function() {
        return this.slice(0, -1);
      },
      isEmpty: function() {
        return this.size !== void 0 ? this.size === 0 : !this.some(function() {
          return true;
        });
      },
      count: function(predicate, context) {
        return ensureSize(
          predicate ? this.toSeq().filter(predicate, context) : this
        );
      },
      countBy: function(grouper, context) {
        return countByFactory(this, grouper, context);
      },
      equals: function(other) {
        return deepEqual2(this, other);
      },
      entrySeq: function() {
        var iterable = this;
        if (iterable._cache) {
          return new ArraySeq(iterable._cache);
        }
        var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
          return iterable.toSeq();
        };
        return entriesSequence;
      },
      filterNot: function(predicate, context) {
        return this.filter(not(predicate), context);
      },
      findLast: function(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
      },
      first: function() {
        return this.find(returnTrue3);
      },
      flatMap: function(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
      },
      flatten: function(depth) {
        return reify(this, flattenFactory(this, depth, true));
      },
      fromEntrySeq: function() {
        return new FromEntriesSequence(this);
      },
      get: function(searchKey, notSetValue) {
        return this.find(function(_, key) {
          return is(key, searchKey);
        }, void 0, notSetValue);
      },
      getIn: function(searchKeyPath, notSetValue) {
        var nested = this;
        var iter = forceIterator(searchKeyPath);
        var step;
        while (!(step = iter.next()).done) {
          var key = step.value;
          nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
          if (nested === NOT_SET) {
            return notSetValue;
          }
        }
        return nested;
      },
      groupBy: function(grouper, context) {
        return groupByFactory(this, grouper, context);
      },
      has: function(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
      },
      hasIn: function(searchKeyPath) {
        return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
      },
      isSubset: function(iter) {
        iter = typeof iter.includes === "function" ? iter : Iterable(iter);
        return this.every(function(value) {
          return iter.includes(value);
        });
      },
      isSuperset: function(iter) {
        iter = typeof iter.isSubset === "function" ? iter : Iterable(iter);
        return iter.isSubset(this);
      },
      keySeq: function() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
      },
      last: function() {
        return this.toSeq().reverse().first();
      },
      max: function(comparator) {
        return maxFactory(this, comparator);
      },
      maxBy: function(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
      },
      min: function(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
      },
      minBy: function(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
      },
      rest: function() {
        return this.slice(1);
      },
      skip: function(amount) {
        return this.slice(Math.max(0, amount));
      },
      skipLast: function(amount) {
        return reify(this, this.toSeq().reverse().skip(amount).reverse());
      },
      skipWhile: function(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
      },
      skipUntil: function(predicate, context) {
        return this.skipWhile(not(predicate), context);
      },
      sortBy: function(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
      },
      take: function(amount) {
        return this.slice(0, Math.max(0, amount));
      },
      takeLast: function(amount) {
        return reify(this, this.toSeq().reverse().take(amount).reverse());
      },
      takeWhile: function(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
      },
      takeUntil: function(predicate, context) {
        return this.takeWhile(not(predicate), context);
      },
      valueSeq: function() {
        return this.toIndexedSeq();
      },
      // ### Hashable Object
      hashCode: function() {
        return this.__hash || (this.__hash = hashIterable(this));
      }
      // ### Internal
      // abstract __iterate(fn, reverse)
      // abstract __iterator(type, reverse)
    });
    var IterablePrototype = Iterable.prototype;
    IterablePrototype[IS_ITERABLE_SENTINEL] = true;
    IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
    IterablePrototype.__toJS = IterablePrototype.toArray;
    IterablePrototype.__toStringMapper = quoteString;
    IterablePrototype.inspect = IterablePrototype.toSource = function() {
      return this.toString();
    };
    IterablePrototype.chain = IterablePrototype.flatMap;
    IterablePrototype.contains = IterablePrototype.includes;
    (function() {
      try {
        Object.defineProperty(IterablePrototype, "length", {
          get: function() {
            if (!Iterable.noLengthWarning) {
              var stack;
              try {
                throw new Error();
              } catch (error) {
                stack = error.stack;
              }
              if (stack.indexOf("_wrapObject") === -1) {
                console && console.warn && console.warn(
                  "iterable.length has been deprecated, use iterable.size or iterable.count(). This warning will become a silent error in a future version. " + stack
                );
                return this.size;
              }
            }
          }
        });
      } catch (e) {
      }
    })();
    mixin(KeyedIterable, {
      // ### More sequential methods
      flip: function() {
        return reify(this, flipFactory(this));
      },
      findKey: function(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
      },
      findLastKey: function(predicate, context) {
        return this.toSeq().reverse().findKey(predicate, context);
      },
      keyOf: function(searchValue) {
        return this.findKey(function(value) {
          return is(value, searchValue);
        });
      },
      lastKeyOf: function(searchValue) {
        return this.findLastKey(function(value) {
          return is(value, searchValue);
        });
      },
      mapEntries: function(mapper, context) {
        var this$0 = this;
        var iterations = 0;
        return reify(
          this,
          this.toSeq().map(
            function(v, k) {
              return mapper.call(context, [k, v], iterations++, this$0);
            }
          ).fromEntrySeq()
        );
      },
      mapKeys: function(mapper, context) {
        var this$0 = this;
        return reify(
          this,
          this.toSeq().flip().map(
            function(k, v) {
              return mapper.call(context, k, v, this$0);
            }
          ).flip()
        );
      }
    });
    var KeyedIterablePrototype = KeyedIterable.prototype;
    KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
    KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
    KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
    KeyedIterablePrototype.__toStringMapper = function(v, k) {
      return JSON.stringify(k) + ": " + quoteString(v);
    };
    mixin(IndexedIterable, {
      // ### Conversion to other types
      toKeyedSeq: function() {
        return new ToKeyedSequence(this, false);
      },
      // ### ES6 Collection methods (ES6 Array and Map)
      filter: function(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
      },
      findIndex: function(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
      },
      indexOf: function(searchValue) {
        var key = this.toKeyedSeq().keyOf(searchValue);
        return key === void 0 ? -1 : key;
      },
      lastIndexOf: function(searchValue) {
        var key = this.toKeyedSeq().reverse().keyOf(searchValue);
        return key === void 0 ? -1 : key;
      },
      reverse: function() {
        return reify(this, reverseFactory(this, false));
      },
      slice: function(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
      },
      splice: function(index, removeNum) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum | 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) {
          return this;
        }
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(
          this,
          numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
        );
      },
      // ### More collection methods
      findLastIndex: function(predicate, context) {
        var key = this.toKeyedSeq().findLastKey(predicate, context);
        return key === void 0 ? -1 : key;
      },
      first: function() {
        return this.get(0);
      },
      flatten: function(depth) {
        return reify(this, flattenFactory(this, depth, false));
      },
      get: function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || (this.size === Infinity || this.size !== void 0 && index > this.size) ? notSetValue : this.find(function(_, key) {
          return key === index;
        }, void 0, notSetValue);
      },
      has: function(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== void 0 ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
      },
      interpose: function(separator) {
        return reify(this, interposeFactory(this, separator));
      },
      interleave: function() {
        var iterables = [this].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
        var interleaved = zipped.flatten(true);
        if (zipped.size) {
          interleaved.size = zipped.size * iterables.length;
        }
        return reify(this, interleaved);
      },
      last: function() {
        return this.get(-1);
      },
      skipWhile: function(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
      },
      zip: function() {
        var iterables = [this].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, iterables));
      },
      zipWith: function(zipper) {
        var iterables = arrCopy(arguments);
        iterables[0] = this;
        return reify(this, zipWithFactory(this, zipper, iterables));
      }
    });
    IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
    IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
    mixin(SetIterable, {
      // ### ES6 Collection methods (ES6 Array and Map)
      get: function(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
      },
      includes: function(value) {
        return this.has(value);
      },
      // ### More sequential methods
      keySeq: function() {
        return this.valueSeq();
      }
    });
    SetIterable.prototype.has = IterablePrototype.includes;
    mixin(KeyedSeq, KeyedIterable.prototype);
    mixin(IndexedSeq, IndexedIterable.prototype);
    mixin(SetSeq, SetIterable.prototype);
    mixin(KeyedCollection, KeyedIterable.prototype);
    mixin(IndexedCollection, IndexedIterable.prototype);
    mixin(SetCollection, SetIterable.prototype);
    function keyMapper(v, k) {
      return k;
    }
    function entryMapper(v, k) {
      return [k, v];
    }
    function not(predicate) {
      return function() {
        return !predicate.apply(this, arguments);
      };
    }
    function neg(predicate) {
      return function() {
        return -predicate.apply(this, arguments);
      };
    }
    function quoteString(value) {
      return typeof value === "string" ? JSON.stringify(value) : value;
    }
    function defaultZipper() {
      return arrCopy(arguments);
    }
    function defaultNegComparator(a, b) {
      return a < b ? 1 : a > b ? -1 : 0;
    }
    function hashIterable(iterable) {
      if (iterable.size === Infinity) {
        return 0;
      }
      var ordered = isOrdered(iterable);
      var keyed = isKeyed(iterable);
      var h = ordered ? 1 : 0;
      var size = iterable.__iterate(
        keyed ? ordered ? function(v, k) {
          h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
        } : function(v, k) {
          h = h + hashMerge(hash(v), hash(k)) | 0;
        } : ordered ? function(v) {
          h = 31 * h + hash(v) | 0;
        } : function(v) {
          h = h + hash(v) | 0;
        }
      );
      return murmurHashOfSize(size, h);
    }
    function murmurHashOfSize(size, h) {
      h = imul(h, 3432918353);
      h = imul(h << 15 | h >>> -15, 461845907);
      h = imul(h << 13 | h >>> -13, 5);
      h = (h + 3864292196 | 0) ^ size;
      h = imul(h ^ h >>> 16, 2246822507);
      h = imul(h ^ h >>> 13, 3266489909);
      h = smi(h ^ h >>> 16);
      return h;
    }
    function hashMerge(a, b) {
      return a ^ b + 2654435769 + (a << 6) + (a >> 2) | 0;
    }
    var Immutable2 = {
      Iterable,
      Seq,
      Collection,
      Map: Map2,
      OrderedMap: OrderedMap2,
      List: List2,
      Stack: Stack2,
      Set: Set2,
      OrderedSet: OrderedSet2,
      Record: Record2,
      Range,
      Repeat: Repeat2,
      is,
      fromJS: fromJS2
    };
    return Immutable2;
  });
})(immutable);
var immutableExports = immutable.exports;
var Immutable$o = immutableExports;
var OrderedMap$6 = Immutable$o.OrderedMap;
var BlockMapBuilder$5 = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap$6(blocks.map(function(block) {
      return [block.getKey(), block];
    }));
  }
};
var BlockMapBuilder_1 = BlockMapBuilder$5;
function _inheritsLoose$a(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var _require$7 = immutableExports, Map$c = _require$7.Map, OrderedSet$6 = _require$7.OrderedSet, Record$7 = _require$7.Record;
var EMPTY_SET$3 = OrderedSet$6();
var defaultRecord$5 = {
  style: EMPTY_SET$3,
  entity: null
};
var CharacterMetadataRecord = Record$7(defaultRecord$5);
var CharacterMetadata$c = /* @__PURE__ */ function(_CharacterMetadataRec) {
  _inheritsLoose$a(CharacterMetadata2, _CharacterMetadataRec);
  function CharacterMetadata2() {
    return _CharacterMetadataRec.apply(this, arguments) || this;
  }
  var _proto = CharacterMetadata2.prototype;
  _proto.getStyle = function getStyle() {
    return this.get("style");
  };
  _proto.getEntity = function getEntity() {
    return this.get("entity");
  };
  _proto.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };
  CharacterMetadata2.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set("style", record.getStyle().add(style));
    return CharacterMetadata2.create(withStyle);
  };
  CharacterMetadata2.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set("style", record.getStyle().remove(style));
    return CharacterMetadata2.create(withoutStyle);
  };
  CharacterMetadata2.applyEntity = function applyEntity2(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set("entity", entityKey);
    return CharacterMetadata2.create(withEntity);
  };
  CharacterMetadata2.create = function create2(config2) {
    if (!config2) {
      return EMPTY;
    }
    var defaultConfig = {
      style: EMPTY_SET$3,
      entity: null
    };
    var configMap = Map$c(defaultConfig).merge(config2);
    var existing = pool.get(configMap);
    if (existing) {
      return existing;
    }
    var newCharacter = new CharacterMetadata2(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };
  CharacterMetadata2.fromJS = function fromJS2(_ref) {
    var style = _ref.style, entity = _ref.entity;
    return new CharacterMetadata2({
      style: Array.isArray(style) ? OrderedSet$6(style) : style,
      entity: Array.isArray(entity) ? OrderedSet$6(entity) : entity
    });
  };
  return CharacterMetadata2;
}(CharacterMetadataRecord);
var EMPTY = new CharacterMetadata$c();
var pool = Map$c([[Map$c(defaultRecord$5), EMPTY]]);
CharacterMetadata$c.EMPTY = EMPTY;
var CharacterMetadata_1 = CharacterMetadata$c;
function findRangesImmutable$5(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }
  var cursor = 0;
  haystack.reduce(function(value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }
      cursor = nextIndex;
    }
    return nextValue;
  });
  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}
var findRangesImmutable_1 = findRangesImmutable$5;
function _inheritsLoose$9(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var CharacterMetadata$b = CharacterMetadata_1;
var findRangesImmutable$4 = findRangesImmutable_1;
var Immutable$n = immutableExports;
var List$d = Immutable$n.List, Map$b = Immutable$n.Map, OrderedSet$5 = Immutable$n.OrderedSet, Record$6 = Immutable$n.Record, Repeat$6 = Immutable$n.Repeat;
var EMPTY_SET$2 = OrderedSet$5();
var defaultRecord$4 = {
  key: "",
  type: "unstyled",
  text: "",
  characterList: List$d(),
  depth: 0,
  data: Map$b()
};
var ContentBlockRecord$2 = Record$6(defaultRecord$4);
var decorateCharacterList$1 = function decorateCharacterList2(config2) {
  if (!config2) {
    return config2;
  }
  var characterList = config2.characterList, text = config2.text;
  if (text && !characterList) {
    config2.characterList = List$d(Repeat$6(CharacterMetadata$b.EMPTY, text.length));
  }
  return config2;
};
var ContentBlock$7 = /* @__PURE__ */ function(_ContentBlockRecord) {
  _inheritsLoose$9(ContentBlock2, _ContentBlockRecord);
  function ContentBlock2(config2) {
    return _ContentBlockRecord.call(this, decorateCharacterList$1(config2)) || this;
  }
  var _proto = ContentBlock2.prototype;
  _proto.getKey = function getKey() {
    return this.get("key");
  };
  _proto.getType = function getType() {
    return this.get("type");
  };
  _proto.getText = function getText() {
    return this.get("text");
  };
  _proto.getCharacterList = function getCharacterList() {
    return this.get("characterList");
  };
  _proto.getLength = function getLength() {
    return this.getText().length;
  };
  _proto.getDepth = function getDepth() {
    return this.get("depth");
  };
  _proto.getData = function getData2() {
    return this.get("data");
  };
  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET$2;
  };
  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };
  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable$4(this.getCharacterList(), haveEqualStyle$1, filterFn, callback);
  };
  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable$4(this.getCharacterList(), haveEqualEntity$1, filterFn, callback);
  };
  return ContentBlock2;
}(ContentBlockRecord$2);
function haveEqualStyle$1(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}
function haveEqualEntity$1(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}
var ContentBlock_1 = ContentBlock$7;
function _inheritsLoose$8(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var CharacterMetadata$a = CharacterMetadata_1;
var findRangesImmutable$3 = findRangesImmutable_1;
var Immutable$m = immutableExports;
var List$c = Immutable$m.List, Map$a = Immutable$m.Map, OrderedSet$4 = Immutable$m.OrderedSet, Record$5 = Immutable$m.Record, Repeat$5 = Immutable$m.Repeat;
var EMPTY_SET$1 = OrderedSet$4();
var defaultRecord$3 = {
  parent: null,
  characterList: List$c(),
  data: Map$a(),
  depth: 0,
  key: "",
  text: "",
  type: "unstyled",
  children: List$c(),
  prevSibling: null,
  nextSibling: null
};
var haveEqualStyle = function haveEqualStyle2(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};
var haveEqualEntity = function haveEqualEntity2(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};
var decorateCharacterList = function decorateCharacterList22(config2) {
  if (!config2) {
    return config2;
  }
  var characterList = config2.characterList, text = config2.text;
  if (text && !characterList) {
    config2.characterList = List$c(Repeat$5(CharacterMetadata$a.EMPTY, text.length));
  }
  return config2;
};
var ContentBlockNode$c = /* @__PURE__ */ function(_ref) {
  _inheritsLoose$8(ContentBlockNode2, _ref);
  function ContentBlockNode2() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultRecord$3;
    return _ref.call(this, decorateCharacterList(props)) || this;
  }
  var _proto = ContentBlockNode2.prototype;
  _proto.getKey = function getKey() {
    return this.get("key");
  };
  _proto.getType = function getType() {
    return this.get("type");
  };
  _proto.getText = function getText() {
    return this.get("text");
  };
  _proto.getCharacterList = function getCharacterList() {
    return this.get("characterList");
  };
  _proto.getLength = function getLength() {
    return this.getText().length;
  };
  _proto.getDepth = function getDepth() {
    return this.get("depth");
  };
  _proto.getData = function getData2() {
    return this.get("data");
  };
  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET$1;
  };
  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };
  _proto.getChildKeys = function getChildKeys() {
    return this.get("children");
  };
  _proto.getParentKey = function getParentKey() {
    return this.get("parent");
  };
  _proto.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get("prevSibling");
  };
  _proto.getNextSiblingKey = function getNextSiblingKey() {
    return this.get("nextSibling");
  };
  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable$3(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };
  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable$3(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };
  return ContentBlockNode2;
}(Record$5(defaultRecord$3));
var ContentBlockNode_1 = ContentBlockNode$c;
var CharacterMetadata$9 = CharacterMetadata_1;
var _require$6 = immutableExports, Map$9 = _require$6.Map;
var ContentStateInlineStyle$1 = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },
  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};
function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function(_, k) {
    return k === startKey;
  }).takeUntil(function(_, k) {
    return k === endKey;
  }).concat(Map$9([[endKey, blockMap.get(endKey)]])).map(function(block, blockKey) {
    var sliceStart;
    var sliceEnd;
    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }
    var chars = block.getCharacterList();
    var current;
    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata$9.applyStyle(current, inlineStyle) : CharacterMetadata$9.removeStyle(current, inlineStyle));
      sliceStart++;
    }
    return block.set("characterList", chars);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}
var ContentStateInlineStyle_1 = ContentStateInlineStyle$1;
var CharacterMetadata$8 = CharacterMetadata_1;
function applyEntityToContentBlock$1(contentBlock, startArg, end, entityKey) {
  var start = startArg;
  var characterList = contentBlock.getCharacterList();
  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata$8.applyEntity(characterList.get(start), entityKey));
    start++;
  }
  return contentBlock.set("characterList", characterList);
}
var applyEntityToContentBlock_1 = applyEntityToContentBlock$1;
var applyEntityToContentBlock = applyEntityToContentBlock_1;
var Immutable$l = immutableExports;
function applyEntityToContentState$1(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function(_, k) {
    return k === startKey;
  }).takeUntil(function(_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable$l.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function(block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}
var applyEntityToContentState_1 = applyEntityToContentState$1;
var DraftEntitySegments$1 = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(" ");
    segments = segments.map(function(segment2, ii) {
      if (direction === "forward") {
        if (ii > 0) {
          return " " + segment2;
        }
      } else if (ii < segments.length - 1) {
        return segment2 + " ";
      }
      return segment2;
    });
    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;
    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length;
      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }
      segmentStart = segmentEnd;
    }
    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;
    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === "forward") {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }
    return {
      start: removalStart,
      end: removalEnd
    };
  }
};
var DraftEntitySegments_1 = DraftEntitySegments$1;
var validateFormat = process.env.NODE_ENV !== "production" ? function(format) {
  if (format === void 0) {
    throw new Error("invariant(...): Second argument must be a string.");
  }
} : function(format) {
};
function invariant$u(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  validateFormat(format);
  if (!condition) {
    var error;
    if (format === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function() {
        return String(args[argIndex++]);
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
}
var invariant_1 = invariant$u;
var invariant$t = invariant_1;
function getRangesForDraftEntity$1(block, key) {
  var ranges = [];
  block.findEntityRanges(function(c) {
    return c.getEntity() === key;
  }, function(start, end) {
    ranges.push({
      start,
      end
    });
  });
  !!!ranges.length ? process.env.NODE_ENV !== "production" ? invariant$t(false, "Entity key not found in this range.") : invariant$t(false) : void 0;
  return ranges;
}
var getRangesForDraftEntity_1 = getRangesForDraftEntity$1;
var DraftEntitySegments = DraftEntitySegments_1;
var getRangesForDraftEntity = getRangesForDraftEntity_1;
var invariant$s = invariant_1;
function getCharacterRemovalRange$1(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);
  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }
  var newSelectionState = selectionState;
  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }
  return newSelectionState;
}
function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var entity = entityMap.__get(entityKey);
  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end;
  if (mutability === "MUTABLE") {
    return selectionState;
  }
  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function(range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });
  !(entityRanges.length == 1) ? process.env.NODE_ENV !== "production" ? invariant$s(false, "There should only be one entity range within this removal range.") : invariant$s(false) : void 0;
  var entityRange = entityRanges[0];
  if (mutability === "IMMUTABLE") {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  }
  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }
  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}
var getCharacterRemovalRange_1 = getCharacterRemovalRange$1;
var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);
function generateRandomKey$a() {
  var key;
  while (key === void 0 || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}
var generateRandomKey_1 = generateRandomKey$a;
var ContentBlockNode$b = ContentBlockNode_1;
var generateRandomKey$9 = generateRandomKey_1;
var Immutable$k = immutableExports;
var OrderedMap$5 = Immutable$k.OrderedMap;
var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys2(blockMap) {
  var newKeysRef = {};
  var lastRootBlock;
  return OrderedMap$5(blockMap.withMutations(function(blockMapState) {
    blockMapState.forEach(function(block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey();
      var key = generateRandomKey$9();
      newKeysRef[oldKey] = key;
      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);
        if (nextBlock) {
          blockMapState.setIn([nextKey, "prevSibling"], key);
        } else {
          blockMapState.setIn([oldKey, "nextSibling"], null);
        }
      }
      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);
        if (prevBlock) {
          blockMapState.setIn([prevKey, "nextSibling"], key);
        } else {
          blockMapState.setIn([oldKey, "prevSibling"], null);
        }
      }
      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, "children"], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        blockMapState.setIn([oldKey, "parent"], null);
        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), "nextSibling"], key);
          blockMapState.setIn([oldKey, "prevSibling"], newKeysRef[lastRootBlock.getKey()]);
        }
        lastRootBlock = blockMapState.get(oldKey);
      }
      childrenKeys.forEach(function(childKey) {
        var childBlock = blockMapState.get(childKey);
        if (childBlock) {
          blockMapState.setIn([childKey, "parent"], key);
        } else {
          blockMapState.setIn([oldKey, "children"], block.getChildKeys().filter(function(child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function(block) {
    return [newKeysRef[block.getKey()], block.set("key", newKeysRef[block.getKey()])];
  }));
};
var randomizeContentBlockKeys = function randomizeContentBlockKeys2(blockMap) {
  return OrderedMap$5(blockMap.toArray().map(function(block) {
    var key = generateRandomKey$9();
    return [key, block.set("key", key)];
  }));
};
var randomizeBlockMapKeys$2 = function randomizeBlockMapKeys2(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode$b;
  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }
  return randomizeContentBlockNodeKeys(blockMap);
};
var randomizeBlockMapKeys_1 = randomizeBlockMapKeys$2;
var CharacterMetadata$7 = CharacterMetadata_1;
var findRangesImmutable$2 = findRangesImmutable_1;
var invariant$r = invariant_1;
function removeEntitiesAtEdges$2(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();
  var updatedBlocks = {};
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);
  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);
  if (startKey === endKey) {
    endBlock = updatedStart;
  }
  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);
  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }
  if (!Object.keys(updatedBlocks).length) {
    return contentState.set("selectionAfter", selectionState);
  }
  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}
function getRemovalRange2(characters, entityKey, offset) {
  var removalRange;
  findRangesImmutable$2(
    characters,
    // the list to iterate through
    function(a, b) {
      return a.getEntity() === b.getEntity();
    },
    // 'isEqual' callback
    function(element) {
      return element.getEntity() === entityKey;
    },
    // 'filter' callback
    function(start, end) {
      if (start <= offset && end >= offset) {
        removalRange = {
          start,
          end
        };
      }
    }
  );
  !(typeof removalRange === "object") ? process.env.NODE_ENV !== "production" ? invariant$r(false, "Removal range must exist within character list.") : invariant$r(false) : void 0;
  return removalRange;
}
function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : void 0;
  var charAfter = offset < chars.count() ? chars.get(offset) : void 0;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : void 0;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : void 0;
  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);
    if (entity.getMutability() !== "MUTABLE") {
      var _getRemovalRange = getRemovalRange2(chars, entityAfterCursor, offset), start = _getRemovalRange.start, end = _getRemovalRange.end;
      var current;
      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata$7.applyEntity(current, null));
        start++;
      }
      return block.set("characterList", chars);
    }
  }
  return block;
}
var removeEntitiesAtEdges_1 = removeEntitiesAtEdges$2;
var randomizeBlockMapKeys$1 = randomizeBlockMapKeys_1;
var removeEntitiesAtEdges$1 = removeEntitiesAtEdges_1;
var getContentStateFragment$4 = function getContentStateFragment2(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var contentWithoutEdgeEntities = removeEntitiesAtEdges$1(contentState, selectionState);
  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;
  return randomizeBlockMapKeys$1(blockMap.slice(startIndex, endIndex).map(function(block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();
    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }
    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }
    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }
    return block;
  }));
};
var getContentStateFragment_1 = getContentStateFragment$4;
function insertIntoList$2(targetListArg, toInsert, offset) {
  var targetList = targetListArg;
  if (offset === targetList.count()) {
    toInsert.forEach(function(c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function(c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }
  return targetList;
}
var insertIntoList_1 = insertIntoList$2;
var BlockMapBuilder$4 = BlockMapBuilder_1;
var ContentBlockNode$a = ContentBlockNode_1;
var Immutable$j = immutableExports;
var insertIntoList$1 = insertIntoList_1;
var invariant$q = invariant_1;
var randomizeBlockMapKeys = randomizeBlockMapKeys_1;
var List$b = Immutable$j.List;
var updateExistingBlock = function updateExistingBlock2(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var mergeBlockData2 = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "REPLACE_WITH_NEW_DATA";
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;
  var data = null;
  switch (mergeBlockData2) {
    case "MERGE_OLD_DATA_TO_NEW_DATA":
      data = fragmentBlock.getData().merge(targetBlock.getData());
      break;
    case "REPLACE_WITH_NEW_DATA":
      data = fragmentBlock.getData();
      break;
  }
  var type2 = targetBlock.getType();
  if (text && type2 === "unstyled") {
    type2 = fragmentBlock.getType();
  }
  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList$1(chars, fragmentBlock.getCharacterList(), targetOffset),
    type: type2,
    data
  });
  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};
var updateHead = function updateHead2(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList();
  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();
  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};
var updateTail = function updateTail2(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList();
  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();
  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};
var getRootBlocks = function getRootBlocks2(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = [];
  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }
  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();
    if (!lastSiblingKey) {
      break;
    }
    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }
  return rootBlocks;
};
var updateBlockMapLinks$3 = function updateBlockMapLinks2(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function(blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];
    if (blockMapState.get(headKey)) {
      blockMapState.setIn([targetKey, "nextSibling"], headKey);
      blockMapState.setIn([headKey, "prevSibling"], targetKey);
    } else {
      blockMapState.setIn([targetKey, "nextSibling"], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), "prevSibling"], targetKey);
    }
    blockMapState.setIn([lastRootFragmentBlockKey, "nextSibling"], targetNextKey);
    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, "prevSibling"], lastRootFragmentBlockKey);
    }
    fragmentRootBlocks.forEach(function(blockKey) {
      return blockMapState.setIn([blockKey, "parent"], targetParentKey);
    });
    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();
      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;
      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();
      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
      blockMapState.setIn([targetParentKey, "children"], List$b(newChildrenKeysArray));
    }
  });
};
var insertFragment$1 = function insertFragment2(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode$a;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
  blockMap.forEach(function(block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }
    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    }
    fragment.slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function(fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    });
    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });
  var updatedBlockMap = BlockMapBuilder$4.createFromArray(newBlockArr);
  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks$3(updatedBlockMap, blockMap, target, head);
  }
  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};
var insertFragmentIntoContentState$1 = function insertFragmentIntoContentState2(contentState, selectionState, fragmentBlockMap) {
  var mergeBlockData2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "REPLACE_WITH_NEW_DATA";
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== "production" ? invariant$q(false, "`insertFragment` should only be called with a collapsed selection state.") : invariant$q(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();
  var targetBlock = blockMap.get(targetKey);
  if (targetBlock instanceof ContentBlockNode$a) {
    !targetBlock.getChildKeys().isEmpty() ? process.env.NODE_ENV !== "production" ? invariant$q(false, "`insertFragment` should not be called when a container node is selected.") : invariant$q(false) : void 0;
  }
  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset, mergeBlockData2);
  }
  return insertFragment$1(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};
var insertFragmentIntoContentState_1 = insertFragmentIntoContentState$1;
var Immutable$i = immutableExports;
var insertIntoList = insertIntoList_1;
var invariant$p = invariant_1;
var Repeat$4 = Immutable$i.Repeat;
function insertTextIntoContentState$1(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== "production" ? invariant$p(false, "`insertText` should only be called with a collapsed range.") : invariant$p(false) : void 0;
  var len = null;
  if (text != null) {
    len = text.length;
  }
  if (len == null || len === 0) {
    return contentState;
  }
  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();
  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat$4(characterMetadata, len).toList(), offset)
  });
  var newOffset = offset + len;
  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}
var insertTextIntoContentState_1 = insertTextIntoContentState$1;
var Immutable$h = immutableExports;
var Map$8 = Immutable$h.Map;
function modifyBlockForContentState$2(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function(_, k) {
    return k === startKey;
  }).takeUntil(function(_, k) {
    return k === endKey;
  }).concat(Map$8([[endKey, blockMap.get(endKey)]])).map(operation);
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}
var modifyBlockForContentState_1 = modifyBlockForContentState$2;
var ContentBlockNode$9 = ContentBlockNode_1;
var getNextDelimiterBlockKey$2 = function getNextDelimiterBlockKey2(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode$9;
  if (!isExperimentalTreeBlock) {
    return null;
  }
  var nextSiblingKey = block.getNextSiblingKey();
  if (nextSiblingKey) {
    return nextSiblingKey;
  }
  var parent = block.getParentKey();
  if (!parent) {
    return null;
  }
  var nextNonDescendantBlock = blockMap.get(parent);
  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }
  if (!nextNonDescendantBlock) {
    return null;
  }
  return nextNonDescendantBlock.getNextSiblingKey();
};
var getNextDelimiterBlockKey_1 = getNextDelimiterBlockKey$2;
var ContentBlockNode$8 = ContentBlockNode_1;
var getNextDelimiterBlockKey$1 = getNextDelimiterBlockKey_1;
var Immutable$g = immutableExports;
Immutable$g.List;
var Map$7 = Immutable$g.Map;
var transformBlock$2 = function transformBlock2(key, blockMap, func) {
  if (!key) {
    return;
  }
  var block = blockMap.get(key);
  if (!block) {
    return;
  }
  blockMap.set(key, func(block));
};
var getAncestorsKeys = function getAncestorsKeys2(blockKey, blockMap) {
  var parents = [];
  if (!blockKey) {
    return parents;
  }
  var blockNode = blockMap.get(blockKey);
  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();
    if (parentKey) {
      parents.push(parentKey);
    }
    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }
  return parents;
};
var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys2(block, blockMap) {
  var nextDelimiters = [];
  if (!block) {
    return nextDelimiters;
  }
  var nextDelimiter = getNextDelimiterBlockKey$1(block, blockMap);
  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);
    nextDelimiters.push(nextDelimiter);
    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey$1(_block, blockMap) : null;
  }
  return nextDelimiters;
};
var getNextValidSibling = function getNextValidSibling2(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }
  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();
  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }
  return nextValidSiblingKey;
};
var getPrevValidSibling = function getPrevValidSibling2(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }
  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();
  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }
  return prevValidSiblingKey;
};
var updateBlockMapLinks$2 = function updateBlockMapLinks22(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function(blocks) {
    transformBlock$2(startBlock.getKey(), blocks, function(block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    });
    transformBlock$2(endBlock.getKey(), blocks, function(block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    });
    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function(parentKey) {
      return transformBlock$2(parentKey, blocks, function(block) {
        return block.merge({
          children: block.getChildKeys().filter(function(key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
    transformBlock$2(startBlock.getNextSiblingKey(), blocks, function(block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    });
    transformBlock$2(startBlock.getPrevSiblingKey(), blocks, function(block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap)
      });
    });
    transformBlock$2(endBlock.getNextSiblingKey(), blocks, function(block) {
      return block.merge({
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    });
    transformBlock$2(endBlock.getPrevSiblingKey(), blocks, function(block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    });
    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function(parentKey) {
      transformBlock$2(parentKey, blocks, function(block) {
        return block.merge({
          children: block.getChildKeys().filter(function(key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function(delimiterKey) {
      return transformBlock$2(delimiterKey, blocks, function(block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
    if (blockMap.get(startBlock.getKey()) == null && blockMap.get(endBlock.getKey()) != null && endBlock.getParentKey() === startBlock.getKey() && endBlock.getPrevSiblingKey() == null) {
      var prevSiblingKey = startBlock.getPrevSiblingKey();
      transformBlock$2(endBlock.getKey(), blocks, function(block) {
        return block.merge({
          prevSibling: prevSiblingKey
        });
      });
      transformBlock$2(prevSiblingKey, blocks, function(block) {
        return block.merge({
          nextSibling: endBlock.getKey()
        });
      });
      var prevSibling = prevSiblingKey ? blockMap.get(prevSiblingKey) : null;
      var newParentKey = prevSibling ? prevSibling.getParentKey() : null;
      startBlock.getChildKeys().forEach(function(childKey) {
        transformBlock$2(childKey, blocks, function(block) {
          return block.merge({
            parent: newParentKey
            // set to null if there is no parent
          });
        });
      });
      if (newParentKey != null) {
        var newParent = blockMap.get(newParentKey);
        transformBlock$2(newParentKey, blocks, function(block) {
          return block.merge({
            children: newParent.getChildKeys().concat(startBlock.getChildKeys())
          });
        });
      }
      transformBlock$2(startBlock.getChildKeys().find(function(key) {
        var block = blockMap.get(key);
        return block.getNextSiblingKey() === null;
      }), blocks, function(block) {
        return block.merge({
          nextSibling: startBlock.getNextSiblingKey()
        });
      });
    }
  });
};
var removeRangeFromContentState$1 = function removeRangeFromContentState2(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey);
  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode$8;
  var parentAncestors = [];
  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);
    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    }
    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    }
    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey$1(endBlock, blockMap), blockMap));
  }
  var characterList;
  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }
  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList
  });
  var shouldDeleteParent = isExperimentalTreeBlock && startOffset === 0 && endOffset === 0 && endBlock.getParentKey() === startKey && endBlock.getPrevSiblingKey() == null;
  var newBlocks = shouldDeleteParent ? Map$7([[startKey, null]]) : blockMap.toSeq().skipUntil(function(_, k) {
    return k === startKey;
  }).takeUntil(function(_, k) {
    return k === endKey;
  }).filter(function(_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map$7([[endKey, null]])).map(function(_, k) {
    return k === startKey ? modifiedStart : null;
  });
  var updatedBlockMap = blockMap.merge(newBlocks).filter(function(block) {
    return !!block;
  });
  if (isExperimentalTreeBlock && startBlock !== endBlock) {
    updatedBlockMap = updateBlockMapLinks$2(updatedBlockMap, startBlock, endBlock, blockMap);
  }
  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};
var removeFromList = function removeFromList2(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }
  return targetList;
};
var removeRangeFromContentState_1 = removeRangeFromContentState$1;
var ContentBlockNode$7 = ContentBlockNode_1;
var generateRandomKey$8 = generateRandomKey_1;
var Immutable$f = immutableExports;
var invariant$o = invariant_1;
var modifyBlockForContentState$1 = modifyBlockForContentState_1;
var List$a = Immutable$f.List, Map$6 = Immutable$f.Map;
var transformBlock$1 = function transformBlock22(key, blockMap, func) {
  if (!key) {
    return;
  }
  var block = blockMap.get(key);
  if (!block) {
    return;
  }
  blockMap.set(key, func(block));
};
var updateBlockMapLinks$1 = function updateBlockMapLinks23(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function(blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey();
    transformBlock$1(originalBlock.getParentKey(), blocks, function(block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
      return block.merge({
        children: List$a(newChildrenArray)
      });
    });
    transformBlock$1(originalBlock.getNextSiblingKey(), blocks, function(block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    });
    transformBlock$1(originalBlockKey, blocks, function(block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    });
    transformBlock$1(belowBlockKey, blocks, function(block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};
var splitBlockInContentState$1 = function splitBlockInContentState2(contentState, selectionState) {
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== "production" ? invariant$o(false, "Selection range must be collapsed.") : invariant$o(false) : void 0;
  var key = selectionState.getAnchorKey();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();
  if (!text) {
    var blockType = blockToSplit.getType();
    if (blockType === "unordered-list-item" || blockType === "ordered-list-item") {
      return modifyBlockForContentState$1(contentState, selectionState, function(block) {
        return block.merge({
          type: "unstyled",
          depth: 0
        });
      });
    }
  }
  var offset = selectionState.getAnchorOffset();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey$8();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode$7;
  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map$6()
  });
  var blocksBefore = blockMap.toSeq().takeUntil(function(v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function(v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();
  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ? process.env.NODE_ENV !== "production" ? invariant$o(false, "ContentBlockNode must not have children") : invariant$o(false) : void 0;
    newBlocks = updateBlockMapLinks$1(newBlocks, blockAbove, blockBelow);
  }
  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};
var splitBlockInContentState_1 = splitBlockInContentState$1;
var CharacterMetadata$6 = CharacterMetadata_1;
var ContentStateInlineStyle = ContentStateInlineStyle_1;
var applyEntityToContentState = applyEntityToContentState_1;
var getCharacterRemovalRange = getCharacterRemovalRange_1;
var getContentStateFragment$3 = getContentStateFragment_1;
var Immutable$e = immutableExports;
var insertFragmentIntoContentState = insertFragmentIntoContentState_1;
var insertTextIntoContentState = insertTextIntoContentState_1;
var invariant$n = invariant_1;
var modifyBlockForContentState = modifyBlockForContentState_1;
var removeEntitiesAtEdges = removeEntitiesAtEdges_1;
var removeRangeFromContentState = removeRangeFromContentState_1;
var splitBlockInContentState = splitBlockInContentState_1;
var OrderedSet$3 = Immutable$e.OrderedSet;
var DraftModifier$e = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
    var character = CharacterMetadata$6.create({
      style: inlineStyle || OrderedSet$3(),
      entity: entityKey || null
    });
    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },
  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ? process.env.NODE_ENV !== "production" ? invariant$n(false, "Target range must be collapsed for `insertText`.") : invariant$n(false) : void 0;
    return DraftModifier$e.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },
  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment$3(contentState, removalRange);
    var afterRemoval = DraftModifier$e.removeRange(contentState, removalRange, "backward");
    return DraftModifier$e.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },
  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var mergeBlockData2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "REPLACE_WITH_NEW_DATA";
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment, mergeBlockData2);
  },
  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey, endKey, startBlock, endBlock;
    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }
    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();
    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1);
    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, adjustedRemovalRange);
      }
    }
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
    return removeRangeFromContentState(withoutEntities, rangeToRemove);
  },
  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },
  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },
  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },
  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function(block) {
      return block.merge({
        type: blockType,
        depth: 0
      });
    });
  },
  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function(block) {
      return block.merge({
        data: blockData
      });
    });
  },
  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function(block) {
      return block.merge({
        data: block.getData().merge(blockData)
      });
    });
  },
  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};
var DraftModifier_1 = DraftModifier$e;
function getOwnObjectValues$2(obj) {
  return Object.keys(obj).map(function(key) {
    return obj[key];
  });
}
var getOwnObjectValues_1 = getOwnObjectValues$2;
function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$j(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$j(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var findRangesImmutable$1 = findRangesImmutable_1;
var getOwnObjectValues$1 = getOwnObjectValues_1;
var Immutable$d = immutableExports;
var List$9 = Immutable$d.List, Repeat$3 = Immutable$d.Repeat, Record$4 = Immutable$d.Record;
var returnTrue = function returnTrue2() {
  return true;
};
var defaultLeafRange = {
  start: null,
  end: null
};
var LeafRange = Record$4(defaultLeafRange);
var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};
var DecoratorRange = Record$4(defaultDecoratorRange);
var BlockTree$1 = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();
    if (!textLength) {
      return List$9.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List$9.of(new LeafRange({
          start: 0,
          end: 0
        }))
      }));
    }
    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List$9(Repeat$3(null, textLength));
    var chars = block.getCharacterList();
    findRangesImmutable$1(decorations, areEqual$1, returnTrue, function(start, end) {
      leafSets.push(new DecoratorRange({
        start,
        end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });
    return List$9(leafSets);
  },
  fromJS: function fromJS(_ref) {
    var leaves = _ref.leaves, other = _objectWithoutPropertiesLoose(_ref, ["leaves"]);
    return new DecoratorRange(_objectSpread$b({}, other, {
      leaves: leaves != null ? List$9(Array.isArray(leaves) ? leaves : getOwnObjectValues$1(leaves)).map(function(leaf) {
        return LeafRange(leaf);
      }) : null
    }));
  }
};
function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function(c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable$1(inlineStyles, areEqual$1, returnTrue, function(start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List$9(leaves);
}
function areEqual$1(a, b) {
  return a === b;
}
var BlockTree_1 = BlockTree$1;
function _inheritsLoose$7(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var Immutable$c = immutableExports;
var Record$3 = Immutable$c.Record;
var DraftEntityInstanceRecord = Record$3({
  type: "TOKEN",
  mutability: "IMMUTABLE",
  data: Object
});
var DraftEntityInstance$2 = /* @__PURE__ */ function(_DraftEntityInstanceR) {
  _inheritsLoose$7(DraftEntityInstance2, _DraftEntityInstanceR);
  function DraftEntityInstance2() {
    return _DraftEntityInstanceR.apply(this, arguments) || this;
  }
  var _proto = DraftEntityInstance2.prototype;
  _proto.getType = function getType() {
    return this.get("type");
  };
  _proto.getMutability = function getMutability() {
    return this.get("mutability");
  };
  _proto.getData = function getData2() {
    return this.get("data");
  };
  return DraftEntityInstance2;
}(DraftEntityInstanceRecord);
var DraftEntityInstance_1 = DraftEntityInstance$2;
function uuid$1() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r2 = Math.random() * 16 | 0;
    var v = c == "x" ? r2 : r2 & 3 | 8;
    return v.toString(16);
  });
}
var uuid_1 = uuid$1;
function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$i(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$i(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DraftEntityInstance$1 = DraftEntityInstance_1;
var Immutable$b = immutableExports;
var invariant$m = invariant_1;
var uuid = uuid_1;
var Map$5 = Immutable$b.Map;
var instances = Map$5();
var instanceKey = uuid();
function logWarning(oldMethodCall, newMethodCall) {
  console.warn("WARNING: " + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}
var DraftEntity$4 = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning("DraftEntity.getLastCreatedEntityKey", "contentState.getLastCreatedEntityKey");
    return DraftEntity$4.__getLastCreatedEntityKey();
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type2, mutability, data) {
    logWarning("DraftEntity.create", "contentState.createEntity");
    return DraftEntity$4.__create(type2, mutability, data);
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add2(instance) {
    logWarning("DraftEntity.add", "contentState.addEntity");
    return DraftEntity$4.__add(instance);
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning("DraftEntity.get", "contentState.getEntity");
    return DraftEntity$4.__get(key);
  },
  /**
   * Get all the entities in the content state.
   */
  __getAll: function __getAll() {
    return instances;
  },
  /**
   * Load the entity map with the given set of entities.
   */
  __loadWithEntities: function __loadWithEntities(entities) {
    instances = entities;
    instanceKey = uuid();
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning("DraftEntity.mergeData", "contentState.mergeEntityData");
    return DraftEntity$4.__mergeData(key, toMerge);
  },
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning("DraftEntity.replaceData", "contentState.replaceEntityData");
    return DraftEntity$4.__replaceData(key, newData);
  },
  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.
  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return instanceKey;
  },
  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type2, mutability, data) {
    return DraftEntity$4.__add(new DraftEntityInstance$1({
      type: type2,
      mutability,
      data: data || {}
    }));
  },
  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    instanceKey = uuid();
    instances = instances.set(instanceKey, instance);
    return instanceKey;
  },
  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ? process.env.NODE_ENV !== "production" ? invariant$m(false, "Unknown DraftEntity key: %s.", key) : invariant$m(false) : void 0;
    return instance;
  },
  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity$4.__get(key);
    var newData = _objectSpread$a({}, instance.getData(), toMerge);
    var newInstance = instance.set("data", newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },
  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity$4.__get(key);
    var newInstance = instance.set("data", newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};
var DraftEntity_1 = DraftEntity$4;
function _inheritsLoose$6(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var Immutable$a = immutableExports;
var Record$2 = Immutable$a.Record;
var defaultRecord$2 = {
  anchorKey: "",
  anchorOffset: 0,
  focusKey: "",
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};
var SelectionStateRecord = Record$2(defaultRecord$2);
var SelectionState$4 = /* @__PURE__ */ function(_SelectionStateRecord) {
  _inheritsLoose$6(SelectionState2, _SelectionStateRecord);
  function SelectionState2() {
    return _SelectionStateRecord.apply(this, arguments) || this;
  }
  var _proto = SelectionState2.prototype;
  _proto.serialize = function serialize() {
    return "Anchor: " + this.getAnchorKey() + ":" + this.getAnchorOffset() + ", Focus: " + this.getFocusKey() + ":" + this.getFocusOffset() + ", Is Backward: " + String(this.getIsBackward()) + ", Has Focus: " + String(this.getHasFocus());
  };
  _proto.getAnchorKey = function getAnchorKey() {
    return this.get("anchorKey");
  };
  _proto.getAnchorOffset = function getAnchorOffset() {
    return this.get("anchorOffset");
  };
  _proto.getFocusKey = function getFocusKey() {
    return this.get("focusKey");
  };
  _proto.getFocusOffset = function getFocusOffset() {
    return this.get("focusOffset");
  };
  _proto.getIsBackward = function getIsBackward() {
    return this.get("isBackward");
  };
  _proto.getHasFocus = function getHasFocus() {
    return this.get("hasFocus");
  };
  _proto.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();
    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionStart && selectionStart <= end || // selectionStart is between start and end, or
      start <= selectionEnd && selectionEnd <= end;
    }
    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }
    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
    return start <= offsetToCheck && end >= offsetToCheck;
  };
  _proto.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };
  _proto.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };
  _proto.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };
  _proto.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };
  _proto.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };
  SelectionState2.createEmpty = function createEmpty(key) {
    return new SelectionState2({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };
  return SelectionState2;
}(SelectionStateRecord);
var SelectionState_1 = SelectionState$4;
var gkx$8 = function(name2) {
  if (typeof window !== "undefined" && window.__DRAFT_GKX) {
    return !!window.__DRAFT_GKX[name2];
  }
  return false;
};
var REGEX_BLOCK_DELIMITER = new RegExp("\r", "g");
function sanitizeDraftText$2(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, "");
}
var sanitizeDraftText_1 = sanitizeDraftText$2;
function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$h(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$h(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inheritsLoose$5(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var BlockMapBuilder$3 = BlockMapBuilder_1;
var CharacterMetadata$5 = CharacterMetadata_1;
var ContentBlock$6 = ContentBlock_1;
var ContentBlockNode$6 = ContentBlockNode_1;
var DraftEntity$3 = DraftEntity_1;
var SelectionState$3 = SelectionState_1;
var generateRandomKey$7 = generateRandomKey_1;
var getOwnObjectValues = getOwnObjectValues_1;
var gkx$7 = gkx$8;
var Immutable$9 = immutableExports;
var sanitizeDraftText$1 = sanitizeDraftText_1;
var List$8 = Immutable$9.List, Record$1 = Immutable$9.Record, Repeat$2 = Immutable$9.Repeat, ImmutableMap = Immutable$9.Map, OrderedMap$4 = Immutable$9.OrderedMap;
var defaultRecord$1 = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};
var ContentStateRecord = Record$1(defaultRecord$1);
var ContentBlockNodeRecord = gkx$7("draft_tree_data_support") ? ContentBlockNode$6 : ContentBlock$6;
var ContentState$3 = /* @__PURE__ */ function(_ContentStateRecord) {
  _inheritsLoose$5(ContentState2, _ContentStateRecord);
  function ContentState2() {
    return _ContentStateRecord.apply(this, arguments) || this;
  }
  var _proto = ContentState2.prototype;
  _proto.getEntityMap = function getEntityMap() {
    return DraftEntity$3;
  };
  _proto.getBlockMap = function getBlockMap() {
    return this.get("blockMap");
  };
  _proto.getSelectionBefore = function getSelectionBefore() {
    return this.get("selectionBefore");
  };
  _proto.getSelectionAfter = function getSelectionAfter() {
    return this.get("selectionAfter");
  };
  _proto.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };
  _proto.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function(v) {
      return v === key;
    }).skip(1).first();
  };
  _proto.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function(v) {
      return v === key;
    }).skip(1).first();
  };
  _proto.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function(_, k) {
      return k === key;
    }).skip(1).first();
  };
  _proto.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function(_, k) {
      return k === key;
    }).skip(1).first();
  };
  _proto.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };
  _proto.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };
  _proto.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };
  _proto.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function(block) {
      return block ? block.getText() : "";
    }).join(delimiter || "\n");
  };
  _proto.getLastCreatedEntityKey = function getLastCreatedEntityKey2() {
    return DraftEntity$3.__getLastCreatedEntityKey();
  };
  _proto.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || // make sure that there are no zero width space chars
    escape(blockMap.first().getText()).replace(/%u200B/g, "").length > 0;
  };
  _proto.createEntity = function createEntity(type2, mutability, data) {
    DraftEntity$3.__create(type2, mutability, data);
    return this;
  };
  _proto.mergeEntityData = function mergeEntityData(key, toMerge) {
    DraftEntity$3.__mergeData(key, toMerge);
    return this;
  };
  _proto.replaceEntityData = function replaceEntityData(key, newData) {
    DraftEntity$3.__replaceData(key, newData);
    return this;
  };
  _proto.addEntity = function addEntity(instance) {
    DraftEntity$3.__add(instance);
    return this;
  };
  _proto.getEntity = function getEntity(key) {
    return DraftEntity$3.__get(key);
  };
  _proto.getAllEntities = function getAllEntities() {
    return DraftEntity$3.__getAll();
  };
  _proto.loadWithEntities = function loadWithEntities(entities) {
    return DraftEntity$3.__loadWithEntities(entities);
  };
  ContentState2.createFromBlockArray = function createFromBlockArray(blocks, entityMap) {
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder$3.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState$3() : SelectionState$3.createEmpty(blockMap.first().getKey());
    return new ContentState2({
      blockMap,
      entityMap: entityMap || DraftEntity$3,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };
  ContentState2.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /\r\n?|\n/g;
    var strings = text.split(delimiter);
    var blocks = strings.map(function(block) {
      block = sanitizeDraftText$1(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey$7(),
        text: block,
        type: "unstyled",
        characterList: List$8(Repeat$2(CharacterMetadata$5.EMPTY, block.length))
      });
    });
    return ContentState2.createFromBlockArray(blocks);
  };
  ContentState2.fromJS = function fromJS2(state) {
    return new ContentState2(_objectSpread$9({}, state, {
      blockMap: OrderedMap$4(state.blockMap).map(ContentState2.createContentBlockFromJS),
      selectionBefore: new SelectionState$3(state.selectionBefore),
      selectionAfter: new SelectionState$3(state.selectionAfter)
    }));
  };
  ContentState2.createContentBlockFromJS = function createContentBlockFromJS(block) {
    var characterList = block.characterList;
    return new ContentBlockNodeRecord(_objectSpread$9({}, block, {
      data: ImmutableMap(block.data),
      characterList: characterList != null ? List$8((Array.isArray(characterList) ? characterList : getOwnObjectValues(characterList)).map(function(c) {
        return CharacterMetadata$5.fromJS(c);
      })) : void 0
    }));
  };
  return ContentState2;
}(ContentStateRecord);
var ContentState_1 = ContentState$3;
var invariant$l = invariant_1;
var NEUTRAL = "NEUTRAL";
var LTR = "LTR";
var RTL = "RTL";
var globalDir = null;
function isStrong(dir) {
  return dir === LTR || dir === RTL;
}
function getHTMLDir(dir) {
  !isStrong(dir) ? process.env.NODE_ENV !== "production" ? invariant$l(false, "`dir` must be a strong direction to be converted to HTML Direction") : invariant$l(false) : void 0;
  return dir === LTR ? "ltr" : "rtl";
}
function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ? process.env.NODE_ENV !== "production" ? invariant$l(false, "`dir` must be a strong direction to be converted to HTML Direction") : invariant$l(false) : void 0;
  !isStrong(otherDir) ? process.env.NODE_ENV !== "production" ? invariant$l(false, "`otherDir` must be a strong direction to be converted to HTML Direction") : invariant$l(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
}
function setGlobalDir(dir) {
  globalDir = dir;
}
function initGlobalDir() {
  setGlobalDir(LTR);
}
function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }
  !globalDir ? process.env.NODE_ENV !== "production" ? invariant$l(false, "Global direction not set.") : invariant$l(false) : void 0;
  return globalDir;
}
var UnicodeBidiDirection$3 = {
  // Values
  NEUTRAL,
  LTR,
  RTL,
  // Helpers
  isStrong,
  getHTMLDir,
  getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir,
  initGlobalDir,
  getGlobalDir
};
var UnicodeBidiDirection_1 = UnicodeBidiDirection$3;
var UnicodeBidiDirection$2 = UnicodeBidiDirection_1;
var invariant$k = invariant_1;
var RANGE_BY_BIDI_TYPE = {
  L: "A-Za-zªµºÀ-ÖØ-öø-ƺƻƼ-ƿǀ-ǃǄ-ʓʔʕ-ʯʰ-ʸʻ-ˁː-ˑˠ-ˤˮͰ-ͳͶ-ͷͺͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁ҂Ҋ-ԯԱ-Ֆՙ՚-՟ա-և։ःऄ-हऻऽा-ीॉ-ौॎ-ॏॐक़-ॡ।-॥०-९॰ॱॲ-ঀং-ঃঅ-ঌএ-ঐও-নপ-রলশ-হঽা-ীে-ৈো-ৌৎৗড়-ঢ়য়-ৡ০-৯ৰ-ৱ৴-৹৺ਃਅ-ਊਏ-ਐਓ-ਨਪ-ਰਲ-ਲ਼ਵ-ਸ਼ਸ-ਹਾ-ੀਖ਼-ੜਫ਼੦-੯ੲ-ੴઃઅ-ઍએ-ઑઓ-નપ-રલ-ળવ-હઽા-ીૉો-ૌૐૠ-ૡ૦-૯૰ଂ-ଃଅ-ଌଏ-ଐଓ-ନପ-ରଲ-ଳଵ-ହଽାୀେ-ୈୋ-ୌୗଡ଼-ଢ଼ୟ-ୡ୦-୯୰ୱ୲-୷ஃஅ-ஊஎ-ஐஒ-கங-சஜஞ-டண-தந-பம-ஹா-ிு-ூெ-ைொ-ௌௐௗ௦-௯௰-௲ఁ-ఃఅ-ఌఎ-ఐఒ-నప-హఽు-ౄౘ-ౙౠ-ౡ౦-౯౿ಂ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽಾಿೀ-ೄೆೇ-ೈೊ-ೋೕ-ೖೞೠ-ೡ೦-೯ೱ-ೲം-ഃഅ-ഌഎ-ഐഒ-ഺഽാ-ീെ-ൈൊ-ൌൎൗൠ-ൡ൦-൯൰-൵൹ൺ-ൿං-ඃඅ-ඖක-නඳ-රලව-ෆා-ෑෘ-ෟ෦-෯ෲ-ෳ෴ก-ะา-ำเ-ๅๆ๏๐-๙๚-๛ກ-ຂຄງ-ຈຊຍດ-ທນ-ຟມ-ຣລວສ-ຫອ-ະາ-ຳຽເ-ໄໆ໐-໙ໜ-ໟༀ༁-༃༄-༒༓༔༕-༗༚-༟༠-༩༪-༳༴༶༸༾-༿ཀ-ཇཉ-ཬཿ྅ྈ-ྌ྾-࿅࿇-࿌࿎-࿏࿐-࿔࿕-࿘࿙-࿚က-ဪါ-ာေးျ-ြဿ၀-၉၊-၏ၐ-ၕၖ-ၗၚ-ၝၡၢ-ၤၥ-ၦၧ-ၭၮ-ၰၵ-ႁႃ-ႄႇ-ႌႎႏ႐-႙ႚ-ႜ႞-႟Ⴀ-ჅჇჍა-ჺ჻ჼჽ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፠-፨፩-፼ᎀ-ᎏᎠ-Ᏼᐁ-ᙬ᙭-᙮ᙯ-ᙿᚁ-ᚚᚠ-ᛪ᛫-᛭ᛮ-ᛰᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱ᜵-᜶ᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳាើ-ៅះ-ៈ។-៖ៗ៘-៚ៜ០-៩᠐-᠙ᠠ-ᡂᡃᡄ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᤣ-ᤦᤩ-ᤫᤰ-ᤱᤳ-ᤸ᥆-᥏ᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧀᧁ-ᧇᧈ-ᧉ᧐-᧙᧚ᨀ-ᨖᨙ-ᨚ᨞-᨟ᨠ-ᩔᩕᩗᩡᩣ-ᩤᩭ-ᩲ᪀-᪉᪐-᪙᪠-᪦ᪧ᪨-᪭ᬄᬅ-ᬳᬵᬻᬽ-ᭁᭃ-᭄ᭅ-ᭋ᭐-᭙᭚-᭠᭡-᭪᭴-᭼ᮂᮃ-ᮠᮡᮦ-ᮧ᮪ᮮ-ᮯ᮰-᮹ᮺ-ᯥᯧᯪ-ᯬᯮ᯲-᯳᯼-᯿ᰀ-ᰣᰤ-ᰫᰴ-ᰵ᰻-᰿᱀-᱉ᱍ-ᱏ᱐-᱙ᱚ-ᱷᱸ-ᱽ᱾-᱿᳀-᳇᳓᳡ᳩ-ᳬᳮ-ᳱᳲ-ᳳᳵ-ᳶᴀ-ᴫᴬ-ᵪᵫ-ᵷᵸᵹ-ᶚᶛ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼ‎ⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℵ-ℸℹℼ-ℿⅅ-ⅉⅎ⅏Ⅰ-ↂↃ-ↄↅ-ↈ⌶-⍺⎕⒜-ⓩ⚬⠀-⣿Ⰰ-Ⱞⰰ-ⱞⱠ-ⱻⱼ-ⱽⱾ-ⳤⳫ-ⳮⳲ-ⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯ⵰ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々〆〇〡-〩〮-〯〱-〵〸-〺〻〼ぁ-ゖゝ-ゞゟァ-ヺー-ヾヿㄅ-ㄭㄱ-ㆎ㆐-㆑㆒-㆕㆖-㆟ㆠ-ㆺㇰ-ㇿ㈀-㈜㈠-㈩㈪-㉇㉈-㉏㉠-㉻㉿㊀-㊉㊊-㊰㋀-㋋㋐-㋾㌀-㍶㍻-㏝㏠-㏾㐀-䶵一-鿌ꀀ-ꀔꀕꀖ-ꒌꓐ-ꓷꓸ-ꓽ꓾-꓿ꔀ-ꘋꘌꘐ-ꘟ꘠-꘩ꘪ-ꘫꙀ-ꙭꙮꚀ-ꚛꚜ-ꚝꚠ-ꛥꛦ-ꛯ꛲-꛷Ꜣ-ꝯꝰꝱ-ꞇ꞉-꞊Ꞌ-ꞎꞐ-ꞭꞰ-Ʇꟷꟸ-ꟹꟺꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꠣ-ꠤꠧ꠰-꠵꠶-꠷ꡀ-ꡳꢀ-ꢁꢂ-ꢳꢴ-ꣃ꣎-꣏꣐-꣙ꣲ-ꣷ꣸-꣺ꣻ꤀-꤉ꤊ-ꤥ꤮-꤯ꤰ-ꥆꥒ-꥓꥟ꥠ-ꥼꦃꦄ-ꦲꦴ-ꦵꦺ-ꦻꦽ-꧀꧁-꧍ꧏ꧐-꧙꧞-꧟ꧠ-ꧤꧦꧧ-ꧯ꧰-꧹ꧺ-ꧾꨀ-ꨨꨯ-ꨰꨳ-ꨴꩀ-ꩂꩄ-ꩋꩍ꩐-꩙꩜-꩟ꩠ-ꩯꩰꩱ-ꩶ꩷-꩹ꩺꩻꩽꩾ-ꪯꪱꪵ-ꪶꪹ-ꪽꫀꫂꫛ-ꫜꫝ꫞-꫟ꫠ-ꫪꫫꫮ-ꫯ꫰-꫱ꫲꫳ-ꫴꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚ꭛ꭜ-ꭟꭤ-ꭥꯀ-ꯢꯣ-ꯤꯦ-ꯧꯩ-ꯪ꯫꯬꯰-꯹가-힣ힰ-ퟆퟋ-ퟻ-豈-舘並-龎ﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚｦ-ｯｰｱ-ﾝﾞ-ﾟﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
  R: "֐־׀׃׆׈-׏א-ת׫-ׯװ-ײ׳-״׵-׿߀-߉ߊ-ߪߴ-ߵߺ߻-߿ࠀ-ࠕࠚࠤࠨ࠮-࠯࠰-࠾࠿ࡀ-ࡘ࡜-࡝࡞࡟-࢟‏יִײַ-ﬨשׁ-זּ﬷טּ-לּ﬽מּ﬿נּ-סּ﭂ףּ-פּ﭅צּ-ﭏ",
  AL: "؈؋؍؛؜؝؞-؟ؠ-ؿـف-ي٭ٮ-ٯٱ-ۓ۔ەۥ-ۦۮ-ۯۺ-ۼ۽-۾ۿ܀-܍܎܏ܐܒ-ܯ݋-݌ݍ-ޥޱ޲-޿ࢠ-ࢲࢳ-ࣣﭐ-ﮱ﮲-﯁﯂-﯒ﯓ-ﴽ﵀-﵏ﵐ-ﶏ﶐-﶑ﶒ-ﷇ﷈-﷏ﷰ-ﷻ﷼﷾-﷿ﹰ-ﹴ﹵ﹶ-ﻼ﻽-﻾"
};
var REGEX_STRONG = new RegExp("[" + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + "]");
var REGEX_RTL = new RegExp("[" + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + "]");
function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}
function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);
  if (strongChar == null) {
    return UnicodeBidiDirection$2.NEUTRAL;
  }
  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection$2.RTL : UnicodeBidiDirection$2.LTR;
}
function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection$2.NEUTRAL;
  if (!str.length) {
    return fallback;
  }
  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection$2.NEUTRAL ? fallback : blockDir;
}
function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection$2.getGlobalDir();
  }
  !UnicodeBidiDirection$2.isStrong(strongFallback) ? process.env.NODE_ENV !== "production" ? invariant$k(false, "Fallback direction must be a strong direction") : invariant$k(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}
function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection$2.LTR;
}
function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection$2.RTL;
}
var UnicodeBidi$2 = {
  firstStrongChar,
  firstStrongCharDir,
  resolveBlockDir,
  getDirection,
  isDirectionLTR,
  isDirectionRTL
};
var UnicodeBidi_1 = UnicodeBidi$2;
function _defineProperty$g(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var UnicodeBidi$1 = UnicodeBidi_1;
var UnicodeBidiDirection$1 = UnicodeBidiDirection_1;
var invariant$j = invariant_1;
var UnicodeBidiService$1 = /* @__PURE__ */ function() {
  function UnicodeBidiService2(defaultDir) {
    _defineProperty$g(this, "_defaultDir", void 0);
    _defineProperty$g(this, "_lastDir", void 0);
    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection$1.getGlobalDir();
    } else {
      !UnicodeBidiDirection$1.isStrong(defaultDir) ? process.env.NODE_ENV !== "production" ? invariant$j(false, "Default direction must be a strong direction (LTR or RTL)") : invariant$j(false) : void 0;
    }
    this._defaultDir = defaultDir;
    this.reset();
  }
  var _proto = UnicodeBidiService2.prototype;
  _proto.reset = function reset() {
    this._lastDir = this._defaultDir;
  };
  _proto.getDirection = function getDirection2(str) {
    this._lastDir = UnicodeBidi$1.getDirection(str, this._lastDir);
    return this._lastDir;
  };
  return UnicodeBidiService2;
}();
var UnicodeBidiService_1 = UnicodeBidiService$1;
var nullthrows$c = function nullthrows2(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};
var nullthrows_1 = nullthrows$c;
var UnicodeBidiService = UnicodeBidiService_1;
var Immutable$8 = immutableExports;
var nullthrows$b = nullthrows_1;
var OrderedMap$3 = Immutable$8.OrderedMap;
var bidiService;
var EditorBidiService$1 = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }
    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function(block) {
      return nullthrows$b(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap$3(blockMap.keySeq().zip(nextBidi));
    if (prevBidiMap != null && Immutable$8.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }
    return bidiMap;
  }
};
var EditorBidiService_1 = EditorBidiService$1;
function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$f(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$f(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var BlockTree = BlockTree_1;
var ContentState$2 = ContentState_1;
var EditorBidiService = EditorBidiService_1;
var SelectionState$2 = SelectionState_1;
var Immutable$7 = immutableExports;
var OrderedSet$2 = Immutable$7.OrderedSet, Record = Immutable$7.Record, Stack = Immutable$7.Stack, OrderedMap$2 = Immutable$7.OrderedMap, List$7 = Immutable$7.List;
var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};
var EditorStateRecord = Record(defaultRecord);
var EditorState$q = /* @__PURE__ */ function() {
  EditorState2.createEmpty = function createEmpty(decorator) {
    return this.createWithText("", decorator);
  };
  EditorState2.createWithText = function createWithText(text, decorator) {
    return EditorState2.createWithContent(ContentState$2.createFromText(text), decorator);
  };
  EditorState2.createWithContent = function createWithContent(contentState, decorator) {
    if (contentState.getBlockMap().count() === 0) {
      return EditorState2.createEmpty(decorator);
    }
    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState2.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState$2.createEmpty(firstKey)
    });
  };
  EditorState2.create = function create2(config2) {
    var currentContent = config2.currentContent, decorator = config2.decorator;
    var recordConfig = _objectSpread$8({}, config2, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });
    return new EditorState2(new EditorStateRecord(recordConfig));
  };
  EditorState2.fromJS = function fromJS2(config2) {
    return new EditorState2(new EditorStateRecord(_objectSpread$8({}, config2, {
      directionMap: config2.directionMap != null ? OrderedMap$2(config2.directionMap) : config2.directionMap,
      inlineStyleOverride: config2.inlineStyleOverride != null ? OrderedSet$2(config2.inlineStyleOverride) : config2.inlineStyleOverride,
      nativelyRenderedContent: config2.nativelyRenderedContent != null ? ContentState$2.fromJS(config2.nativelyRenderedContent) : config2.nativelyRenderedContent,
      redoStack: config2.redoStack != null ? Stack(config2.redoStack.map(function(v) {
        return ContentState$2.fromJS(v);
      })) : config2.redoStack,
      selection: config2.selection != null ? new SelectionState$2(config2.selection) : config2.selection,
      treeMap: config2.treeMap != null ? OrderedMap$2(config2.treeMap).map(function(v) {
        return List$7(v).map(function(v2) {
          return BlockTree.fromJS(v2);
        });
      }) : config2.treeMap,
      undoStack: config2.undoStack != null ? Stack(config2.undoStack.map(function(v) {
        return ContentState$2.fromJS(v);
      })) : config2.undoStack,
      currentContent: ContentState$2.fromJS(config2.currentContent)
    })));
  };
  EditorState2.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function(state) {
      var existingDecorator = state.get("decorator");
      var decorator = existingDecorator;
      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }
      var newContent = put.currentContent || editorState.getCurrentContent();
      if (decorator !== existingDecorator) {
        var treeMap = state.get("treeMap");
        var newTreeMap;
        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }
        state.merge({
          decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }
      var existingContent = editorState.getCurrentContent();
      if (newContent !== existingContent) {
        state.set("treeMap", regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }
      state.merge(put);
    });
    return new EditorState2(map);
  };
  var _proto = EditorState2.prototype;
  _proto.toJS = function toJS() {
    return this.getImmutable().toJS();
  };
  _proto.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get("allowUndo");
  };
  _proto.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get("currentContent");
  };
  _proto.getUndoStack = function getUndoStack() {
    return this.getImmutable().get("undoStack");
  };
  _proto.getRedoStack = function getRedoStack() {
    return this.getImmutable().get("redoStack");
  };
  _proto.getSelection = function getSelection() {
    return this.getImmutable().get("selection");
  };
  _proto.getDecorator = function getDecorator() {
    return this.getImmutable().get("decorator");
  };
  _proto.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get("inCompositionMode");
  };
  _proto.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get("forceSelection");
  };
  _proto.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get("nativelyRenderedContent");
  };
  _proto.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get("lastChangeType");
  };
  _proto.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get("inlineStyleOverride");
  };
  EditorState2.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState2.set(editorState, {
      inlineStyleOverride
    });
  };
  _proto.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();
    if (override != null) {
      return override;
    }
    var content = this.getCurrentContent();
    var selection = this.getSelection();
    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }
    return getInlineStyleForNonCollapsedSelection(content, selection);
  };
  _proto.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(["treeMap", blockKey]);
  };
  _proto.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };
  _proto.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };
  _proto.getDirectionMap = function getDirectionMap2() {
    return this.getImmutable().get("directionMap");
  };
  EditorState2.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  };
  EditorState2.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set("hasFocus", true);
    }
    return updateSelection(editorState, selection, true);
  };
  EditorState2.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();
    return EditorState2.acceptSelection(editorState, new SelectionState$2({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  };
  EditorState2.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState2.moveSelectionToEnd(editorState);
    return EditorState2.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  };
  EditorState2.push = function push(editorState, contentState, changeType) {
    var forceSelection = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }
    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
    if (!editorState.getAllowUndo()) {
      return EditorState2.set(editorState, {
        currentContent: contentState,
        directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection,
        inlineStyleOverride: null
      });
    }
    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;
    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set("selectionBefore", selection);
    } else if (changeType === "insert-characters" || changeType === "backspace-character" || changeType === "delete-character") {
      newContent = newContent.set("selectionBefore", currentContent.getSelectionBefore());
    }
    var inlineStyleOverride = editorState.getInlineStyleOverride();
    var overrideChangeTypes = ["adjust-depth", "change-block-type", "split-block"];
    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }
    var editorStateChanges = {
      currentContent: newContent,
      directionMap,
      undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection,
      inlineStyleOverride
    };
    return EditorState2.set(editorState, editorStateChanges);
  };
  EditorState2.undo = function undo2(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }
    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }
    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState2.set(editorState, {
      currentContent: newCurrentContent,
      directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: "undo",
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  };
  EditorState2.redo = function redo2(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }
    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }
    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState2.set(editorState, {
      currentContent: newCurrentContent,
      directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: "redo",
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  };
  function EditorState2(immutable2) {
    _defineProperty$f(this, "_immutable", void 0);
    this._immutable = immutable2;
  }
  _proto.getImmutable = function getImmutable() {
    return this._immutable;
  };
  return EditorState2;
}();
function updateSelection(editorState, selection, forceSelection) {
  return EditorState$q.set(editorState, {
    selection,
    forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}
function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function(block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}
function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set("entityMap", newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get("treeMap");
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function(block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function(block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}
function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function(block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function(block) {
    return BlockTree.generate(content, block, decorator);
  }));
}
function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== "insert-characters" && changeType !== "backspace-character" && changeType !== "delete-character";
}
function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }
  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  }
  return lookUpwardForInlineStyle(content, startKey);
}
function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);
  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  }
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }
  return lookUpwardForInlineStyle(content, startKey);
}
function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function(_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function(block, _) {
    return block.getLength();
  }).first();
  if (lastNonEmpty) {
    return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  }
  return OrderedSet$2();
}
var EditorState_1 = EditorState$q;
var ContentBlockNode$5 = ContentBlockNode_1;
var getNextDelimiterBlockKey = getNextDelimiterBlockKey_1;
var Immutable$6 = immutableExports;
var invariant$i = invariant_1;
var OrderedMap$1 = Immutable$6.OrderedMap, List$6 = Immutable$6.List;
var transformBlock = function transformBlock23(key, blockMap, func) {
  if (!key) {
    return;
  }
  var block = blockMap.get(key);
  if (!block) {
    return;
  }
  blockMap.set(key, func(block));
};
var updateBlockMapLinks = function updateBlockMapLinks24(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  }
  var isInsertedAfterTarget = insertionMode === "after";
  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
  return blockMap.withMutations(function(blocks) {
    transformBlock(originalParentKey, blocks, function(block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList["delete"](parentChildrenList.indexOf(originalBlockKey))
      });
    });
    transformBlock(originalPrevSiblingKey, blocks, function(block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    });
    transformBlock(originalNextSiblingKey, blocks, function(block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    });
    transformBlock(newNextSiblingKey, blocks, function(block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
    transformBlock(newPrevSiblingKey, blocks, function(block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    });
    transformBlock(newParentKey, blocks, function(block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
      return block.merge({
        children: List$6(newChildrenArray)
      });
    });
    transformBlock(originalBlockKey, blocks, function(block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};
var moveBlockInContentState$1 = function moveBlockInContentState2(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== "replace") ? process.env.NODE_ENV !== "production" ? invariant$i(false, "Replacing blocks is not supported.") : invariant$i(false) : void 0;
  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();
  !(blockKey !== targetKey) ? process.env.NODE_ENV !== "production" ? invariant$i(false, "Block cannot be moved next to itself.") : invariant$i(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode$5;
  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap["delete"](blockKey);
  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function(blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
      blocks.toSeq().skipUntil(function(block) {
        return block.getKey() === blockKey;
      }).takeWhile(function(block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function(block) {
        blocksToBeMoved.push(block);
        blocks["delete"](block.getKey());
      });
    });
  }
  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function(v) {
    return v === targetBlock;
  });
  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function(v) {
    return v === targetBlock;
  }).skip(1);
  var slicedBlocks = blocksToBeMoved.map(function(block) {
    return [block.getKey(), block];
  });
  var newBlocks = OrderedMap$1();
  if (insertionMode === "before") {
    var blockBefore = contentState.getBlockBefore(targetKey);
    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ? process.env.NODE_ENV !== "production" ? invariant$i(false, "Block cannot be moved next to itself.") : invariant$i(false) : void 0;
    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === "after") {
    var blockAfter = contentState.getBlockAfter(targetKey);
    !(!blockAfter || blockAfter.getKey() !== blockKey) ? process.env.NODE_ENV !== "production" ? invariant$i(false, "Block cannot be moved next to itself.") : invariant$i(false) : void 0;
    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }
  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};
var moveBlockInContentState_1 = moveBlockInContentState$1;
function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$e(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$e(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var BlockMapBuilder$2 = BlockMapBuilder_1;
var CharacterMetadata$4 = CharacterMetadata_1;
var ContentBlock$5 = ContentBlock_1;
var ContentBlockNode$4 = ContentBlockNode_1;
var DraftModifier$d = DraftModifier_1;
var EditorState$p = EditorState_1;
var generateRandomKey$6 = generateRandomKey_1;
var gkx$6 = gkx$8;
var Immutable$5 = immutableExports;
var moveBlockInContentState = moveBlockInContentState_1;
var experimentalTreeDataSupport$5 = gkx$6("draft_tree_data_support");
var ContentBlockRecord$1 = experimentalTreeDataSupport$5 ? ContentBlockNode$4 : ContentBlock$5;
var List$5 = Immutable$5.List, Repeat$1 = Immutable$5.Repeat;
var AtomicBlockUtils$1 = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var afterRemoval = DraftModifier$d.removeRange(contentState, selectionState, "backward");
    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier$d.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();
    var asAtomicBlock = DraftModifier$d.setBlockType(afterSplit, insertionTarget, "atomic");
    var charData = CharacterMetadata$4.create({
      entity: entityKey
    });
    var atomicBlockConfig = {
      key: generateRandomKey$6(),
      type: "atomic",
      text: character,
      characterList: List$5(Repeat$1(charData, character.length))
    };
    var atomicDividerBlockConfig = {
      key: generateRandomKey$6(),
      type: "unstyled"
    };
    if (experimentalTreeDataSupport$5) {
      atomicBlockConfig = _objectSpread$7({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _objectSpread$7({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }
    var fragmentArray = [new ContentBlockRecord$1(atomicBlockConfig), new ContentBlockRecord$1(atomicDividerBlockConfig)];
    var fragment = BlockMapBuilder$2.createFromArray(fragmentArray);
    var withAtomicBlock = DraftModifier$d.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set("hasFocus", true)
    });
    return EditorState$p.push(editorState, newContent, "insert-fragment");
  },
  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var withMovedAtomicBlock;
    if (insertionMode === "before" || insertionMode === "after") {
      var targetBlock = contentState.getBlockForKey(insertionMode === "before" ? targetRange.getStartKey() : targetRange.getEndKey());
      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier$d.removeRange(contentState, targetRange, "backward");
      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());
      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, "before");
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, "after");
      } else {
        var afterSplit = DraftModifier$d.splitBlock(afterRemoval, selectionAfterRemoval);
        var selectionAfterSplit = afterSplit.getSelectionAfter();
        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());
        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, "before");
      }
    }
    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set("hasFocus", true)
    });
    return EditorState$p.push(editorState, newContent, "move-block");
  }
};
var AtomicBlockUtils_1 = AtomicBlockUtils$1;
function _defineProperty$d(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Immutable$4 = immutableExports;
var List$4 = Immutable$4.List;
var DELIMITER = ".";
var CompositeDraftDecorator$1 = /* @__PURE__ */ function() {
  function CompositeDraftDecorator2(decorators) {
    _defineProperty$d(this, "_decorators", void 0);
    this._decorators = decorators.slice();
  }
  var _proto = CompositeDraftDecorator2.prototype;
  _proto.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);
    this._decorators.forEach(function(decorator, ii) {
      var counter = 0;
      var strategy = decorator.strategy;
      var callback = function callback2(start, end) {
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };
      strategy(block, callback, contentState);
    });
    return List$4(decorations);
  };
  _proto.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };
  _proto.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };
  return CompositeDraftDecorator2;
}();
function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }
  return true;
}
function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}
var CompositeDraftDecorator_1 = CompositeDraftDecorator$1;
function cx$5(classNames) {
  if (typeof classNames == "object") {
    return Object.keys(classNames).filter(function(className) {
      return classNames[className];
    }).map(replace).join(" ");
  }
  return Array.prototype.map.call(arguments, replace).join(" ");
}
function replace(str) {
  return str.replace(/\//g, "-");
}
var cx_1 = cx$5;
var React$6 = React__default;
var cx$4 = cx_1;
var _require$5 = immutableExports, Map$4 = _require$5.Map;
var UL_WRAP = React$6.createElement("ul", {
  className: cx$4("public/DraftStyleDefault/ul")
});
var OL_WRAP = React$6.createElement("ol", {
  className: cx$4("public/DraftStyleDefault/ol")
});
var PRE_WRAP = React$6.createElement("pre", {
  className: cx$4("public/DraftStyleDefault/pre")
});
var DefaultDraftBlockRenderMap$3 = Map$4({
  "header-one": {
    element: "h1"
  },
  "header-two": {
    element: "h2"
  },
  "header-three": {
    element: "h3"
  },
  "header-four": {
    element: "h4"
  },
  "header-five": {
    element: "h5"
  },
  "header-six": {
    element: "h6"
  },
  section: {
    element: "section"
  },
  article: {
    element: "article"
  },
  "unordered-list-item": {
    element: "li",
    wrapper: UL_WRAP
  },
  "ordered-list-item": {
    element: "li",
    wrapper: OL_WRAP
  },
  blockquote: {
    element: "blockquote"
  },
  atomic: {
    element: "figure"
  },
  "code-block": {
    element: "pre",
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: "div",
    aliasedElements: ["p"]
  }
});
var DefaultDraftBlockRenderMap_1 = DefaultDraftBlockRenderMap$3;
var DefaultDraftInlineStyle$2 = {
  BOLD: {
    fontWeight: "bold"
  },
  CODE: {
    fontFamily: "monospace",
    wordWrap: "break-word"
  },
  ITALIC: {
    fontStyle: "italic"
  },
  STRIKETHROUGH: {
    textDecoration: "line-through"
  },
  UNDERLINE: {
    textDecoration: "underline"
  }
};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
      return test2[n];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
var uaParser = { exports: {} };
(function(module2, exports) {
  (function(window2, undefined$1) {
    var LIBVERSION = "0.7.37", EMPTY2 = "", UNKNOWN2 = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes2, extensions) {
      var mergedRegexes = {};
      for (var i in regexes2) {
        if (extensions[i] && extensions[i].length % 2 === 0) {
          mergedRegexes[i] = extensions[i].concat(regexes2[i]);
        } else {
          mergedRegexes[i] = regexes2[i];
        }
      }
      return mergedRegexes;
    }, enumerize = function(arr) {
      var enums = {};
      for (var i = 0; i < arr.length; i++) {
        enums[arr[i].toUpperCase()] = arr[i];
      }
      return enums;
    }, has = function(str1, str2) {
      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
      return str.toLowerCase();
    }, majorize = function(version2) {
      return typeof version2 === STR_TYPE ? version2.replace(/[^\d\.]/g, EMPTY2).split(".")[0] : undefined$1;
    }, trim2 = function(str, len) {
      if (typeof str === STR_TYPE) {
        str = str.replace(/^\s\s*/, EMPTY2);
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    };
    var rgxMapper = function(ua, arrays) {
      var i = 0, j, k, p, q, matches, match;
      while (i < arrays.length && !matches) {
        var regex = arrays[i], props = arrays[i + 1];
        j = k = 0;
        while (j < regex.length && !matches) {
          if (!regex[j]) {
            break;
          }
          matches = regex[j++].exec(ua);
          if (!!matches) {
            for (p = 0; p < props.length; p++) {
              match = matches[++k];
              q = props[p];
              if (typeof q === OBJ_TYPE && q.length > 0) {
                if (q.length === 2) {
                  if (typeof q[1] == FUNC_TYPE) {
                    this[q[0]] = q[1].call(this, match);
                  } else {
                    this[q[0]] = q[1];
                  }
                } else if (q.length === 3) {
                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                  } else {
                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                  }
                } else if (q.length === 4) {
                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                }
              } else {
                this[q] = match ? match : undefined$1;
              }
            }
          }
        }
        i += 2;
      }
    }, strMapper = function(str, map) {
      for (var i in map) {
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j = 0; j < map[i].length; j++) {
            if (has(map[i][j], str)) {
              return i === UNKNOWN2 ? undefined$1 : i;
            }
          }
        } else if (has(map[i], str)) {
          return i === UNKNOWN2 ? undefined$1 : i;
        }
      }
      return str;
    };
    var oldSafariMap = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, windowsVersionMap = {
      "ME": "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      "2000": "NT 5.0",
      "XP": ["NT 5.1", "NT 5.2"],
      "Vista": "NT 6.0",
      "7": "NT 6.1",
      "8": "NT 6.2",
      "8.1": "NT 6.3",
      "10": ["NT 6.4", "NT 10.0"],
      "RT": "ARM"
    };
    var regexes = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [VERSION, [NAME, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [VERSION, [NAME, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [NAME, VERSION],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [VERSION, [NAME, OPERA + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [VERSION, [NAME, OPERA]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [VERSION, [NAME, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [NAME, VERSION],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [VERSION, [NAME, "UC" + BROWSER]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [VERSION, [NAME, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [VERSION, [NAME, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [VERSION, [NAME, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [VERSION, [NAME, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [VERSION, [NAME, "Smart Lenovo " + BROWSER]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [VERSION, [NAME, FIREFOX + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [VERSION, [NAME, OPERA + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [VERSION, [NAME, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [VERSION, [NAME, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [VERSION, [NAME, OPERA + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [VERSION, [NAME, "MIUI " + BROWSER]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [VERSION, [NAME, FIREFOX]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[NAME, "360 " + BROWSER]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[NAME, /(.+)/, "$1 " + BROWSER], VERSION],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [VERSION, [NAME, SAMSUNG + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[NAME, /_/g, " "], VERSION],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [VERSION, [NAME, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[NAME, "Sogou Mobile"], VERSION],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [NAME, VERSION],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [NAME],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[NAME, FACEBOOK], VERSION],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [NAME, VERSION],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [VERSION, [NAME, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [VERSION, [NAME, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [VERSION, [NAME, CHROME + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[NAME, CHROME + " WebView"], VERSION],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [VERSION, [NAME, "Android " + BROWSER]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [NAME, VERSION],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [VERSION, [NAME, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [VERSION, NAME],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [NAME, [VERSION, strMapper, oldSafariMap]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [NAME, VERSION],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[NAME, "Netscape"], VERSION],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [VERSION, [NAME, FIREFOX + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [NAME, VERSION],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [NAME, [VERSION, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[ARCHITECTURE, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[ARCHITECTURE, lowerize]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[ARCHITECTURE, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[ARCHITECTURE, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[ARCHITECTURE, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[ARCHITECTURE, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[ARCHITECTURE, /ower/, EMPTY2, lowerize]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[ARCHITECTURE, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[ARCHITECTURE, lowerize]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
        [
          /(macintosh);/i
        ],
        [MODEL, [VENDOR, APPLE]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, TABLET]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [MODEL, VENDOR, [TYPE, TABLET]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [MODEL, [VENDOR, "Ulefone"], [TYPE, MOBILE]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [VENDOR, [TYPE, SMARTTV]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[VENDOR, LG], [TYPE, SMARTTV]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [VENDOR, MODEL, [TYPE, SMARTTV]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[VENDOR, trim2], [MODEL, trim2], [TYPE, SMARTTV]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[TYPE, SMARTTV]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [VENDOR, MODEL, [TYPE, CONSOLE]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [VENDOR, MODEL, [TYPE, WEARABLE]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [VENDOR, [TYPE, EMBEDDED]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [MODEL, [TYPE, MOBILE]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [MODEL, [TYPE, TABLET]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[TYPE, TABLET]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[TYPE, MOBILE]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [MODEL, [VENDOR, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [VERSION, [NAME, EDGE + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [VERSION, [NAME, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [NAME, VERSION],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [VERSION, NAME]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [NAME, VERSION],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [NAME, [VERSION, strMapper, windowsVersionMap]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[VERSION, strMapper, windowsVersionMap], [NAME, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[VERSION, /_/g, "."], [NAME, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[NAME, MAC_OS], [VERSION, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [VERSION, NAME],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [NAME, VERSION],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [VERSION, [NAME, BLACKBERRY]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [VERSION, [NAME, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [VERSION, [NAME, FIREFOX + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [VERSION, [NAME, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [VERSION, [NAME, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [VERSION, [NAME, CHROME + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[NAME, CHROMIUM_OS], VERSION],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [NAME, VERSION],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[NAME, "Solaris"], VERSION],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [NAME, VERSION]
      ]
    };
    var UAParser2 = function(ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof UAParser2)) {
        return new UAParser2(ua, extensions).getResult();
      }
      var _navigator = typeof window2 !== UNDEF_TYPE && window2.navigator ? window2.navigator : undefined$1;
      var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY2);
      var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;
      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
      var _isSelfNav = _navigator && _navigator.userAgent == _ua;
      this.getBrowser = function() {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser[MAJOR] = majorize(_browser[VERSION]);
        if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
          _browser[NAME] = "Brave";
        }
        return _browser;
      };
      this.getCPU = function() {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function() {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
          _device[TYPE] = MOBILE;
        }
        if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
          _device[MODEL] = "iPad";
          _device[TYPE] = TABLET;
        }
        return _device;
      };
      this.getEngine = function() {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function() {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") {
          _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
        }
        return _os;
      };
      this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function() {
        return _ua;
      };
      this.setUA = function(ua2) {
        _ua = typeof ua2 === STR_TYPE && ua2.length > UA_MAX_LENGTH ? trim2(ua2, UA_MAX_LENGTH) : ua2;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser2.VERSION = LIBVERSION;
    UAParser2.BROWSER = enumerize([NAME, VERSION, MAJOR]);
    UAParser2.CPU = enumerize([ARCHITECTURE]);
    UAParser2.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser2.ENGINE = UAParser2.OS = enumerize([NAME, VERSION]);
    {
      if (module2.exports) {
        exports = module2.exports = UAParser2;
      }
      exports.UAParser = UAParser2;
    }
    var $ = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
    if ($ && !$.ua) {
      var parser2 = new UAParser2();
      $.ua = parser2.getResult();
      $.ua.get = function() {
        return parser2.getUA();
      };
      $.ua.set = function(ua) {
        parser2.setUA(ua);
        var result = parser2.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var uaParserExports = uaParser.exports;
var UAParser = uaParserExports;
var UNKNOWN = "Unknown";
var PLATFORM_MAP = {
  "Mac OS": "Mac OS X"
};
function convertPlatformName(name2) {
  return PLATFORM_MAP[name2] || name2;
}
function getBrowserVersion(version2) {
  if (!version2) {
    return {
      major: "",
      minor: ""
    };
  }
  var parts = version2.split(".");
  return {
    major: parts[0],
    minor: parts[1]
  };
}
var parser = new UAParser();
var results = parser.getResult();
var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};
var UserAgentData$1 = uaData;
var invariant$h = invariant_1;
var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;
function checkOrExpression(range, version2) {
  var expressions = range.split(orRegex);
  if (expressions.length > 1) {
    return expressions.some(function(range2) {
      return VersionRange$1.contains(range2, version2);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version2);
  }
}
function checkRangeExpression(range, version2) {
  var expressions = range.split(rangeRegex);
  !(expressions.length > 0 && expressions.length <= 2) ? process.env.NODE_ENV !== "production" ? invariant$h(false, 'the "-" operator expects exactly 2 operands') : invariant$h(false) : void 0;
  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version2);
  } else {
    var startVersion = expressions[0], endVersion = expressions[1];
    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ? process.env.NODE_ENV !== "production" ? invariant$h(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant$h(false) : void 0;
    return checkSimpleExpression(">=" + startVersion, version2) && checkSimpleExpression("<=" + endVersion, version2);
  }
}
function checkSimpleExpression(range, version2) {
  range = range.trim();
  if (range === "") {
    return true;
  }
  var versionComponents = version2.split(componentRegex);
  var _getModifierAndCompon = getModifierAndComponents(range), modifier = _getModifierAndCompon.modifier, rangeComponents = _getModifierAndCompon.rangeComponents;
  switch (modifier) {
    case "<":
      return checkLessThan(versionComponents, rangeComponents);
    case "<=":
      return checkLessThanOrEqual(versionComponents, rangeComponents);
    case ">=":
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
    case ">":
      return checkGreaterThan(versionComponents, rangeComponents);
    case "~":
    case "~>":
      return checkApproximateVersion(versionComponents, rangeComponents);
    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}
function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}
function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}
function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}
function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}
function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}
function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();
  if (upperBound.length > 1) {
    upperBound.pop();
  }
  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);
  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + "";
  }
  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}
function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ? process.env.NODE_ENV !== "production" ? invariant$h(false, "expected regex to match but it did not") : invariant$h(false) : void 0;
  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}
function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}
function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}
function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = "0";
  }
}
function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();
  zeroPad(a, b.length);
  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);
    if (matches) {
      b[i] = a[i] = "0";
      if (matches[0] === "*" && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = "0";
        }
      }
    }
  }
  zeroPad(b, a.length);
  return [a, b];
}
function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);
  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare$1(aNumeric, bNumeric);
  } else {
    return compare$1(a, b);
  }
}
function compare$1(a, b) {
  !(typeof a === typeof b) ? process.env.NODE_ENV !== "production" ? invariant$h(false, '"a" and "b" must be of the same type') : invariant$h(false) : void 0;
  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}
function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b), aNormalized = _normalizeVersions[0], bNormalized = _normalizeVersions[1];
  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);
    if (result) {
      return result;
    }
  }
  return 0;
}
var VersionRange$1 = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version2) {
    return checkOrExpression(range.trim(), version2.trim());
  }
};
var VersionRange_1 = VersionRange$1;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function mapObject$1(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name2 in object) {
    if (hasOwnProperty.call(object, name2)) {
      result[name2] = callback.call(context, object[name2], name2, object);
    }
  }
  return result;
}
var mapObject_1 = mapObject$1;
function memoizeStringOnly$1(callback) {
  var cache = {};
  return function(string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}
var memoizeStringOnly_1 = memoizeStringOnly$1;
var UserAgentData = UserAgentData$1;
var VersionRange = VersionRange_1;
var mapObject = mapObject_1;
var memoizeStringOnly = memoizeStringOnly_1;
function compare(name2, version2, query, normalizer) {
  if (name2 === query) {
    return true;
  }
  if (!query.startsWith(name2)) {
    return false;
  }
  var range = query.slice(name2.length);
  if (version2) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version2);
  }
  return false;
}
function normalizePlatformVersion(version2) {
  if (UserAgentData.platformName === "Windows") {
    return version2.replace(/^\s*NT/, "");
  }
  return version2;
}
var UserAgent$e = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },
  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },
  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },
  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },
  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },
  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};
var UserAgent_1 = mapObject(UserAgent$e, memoizeStringOnly);
function getCorrectDocumentFromNode$4(node) {
  if (!node || !node.ownerDocument) {
    return document;
  }
  return node.ownerDocument;
}
var getCorrectDocumentFromNode_1 = getCorrectDocumentFromNode$4;
function isElement$7(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }
  return node.nodeType === Node.ELEMENT_NODE;
}
var isElement_1 = isElement$7;
var isElement$6 = isElement_1;
function getSelectionOffsetKeyForNode$2(node) {
  if (isElement$6(node)) {
    var castedNode = node;
    var offsetKey = castedNode.getAttribute("data-offset-key");
    if (offsetKey) {
      return offsetKey;
    }
    for (var ii = 0; ii < castedNode.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode$2(castedNode.childNodes[ii]);
      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }
  return null;
}
var getSelectionOffsetKeyForNode_1 = getSelectionOffsetKeyForNode$2;
var getCorrectDocumentFromNode$3 = getCorrectDocumentFromNode_1;
var getSelectionOffsetKeyForNode$1 = getSelectionOffsetKeyForNode_1;
function findAncestorOffsetKey$4(node) {
  var searchNode = node;
  while (searchNode && searchNode !== getCorrectDocumentFromNode$3(node).documentElement) {
    var key = getSelectionOffsetKeyForNode$1(searchNode);
    if (key != null) {
      return key;
    }
    searchNode = searchNode.parentNode;
  }
  return null;
}
var findAncestorOffsetKey_1 = findAncestorOffsetKey$4;
function getWindowForNode$2(node) {
  if (!node || !node.ownerDocument || !node.ownerDocument.defaultView) {
    return window;
  }
  return node.ownerDocument.defaultView;
}
var getWindowForNode_1 = getWindowForNode$2;
function _defineProperty$c(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var UserAgent$d = UserAgent_1;
var findAncestorOffsetKey$3 = findAncestorOffsetKey_1;
var getWindowForNode$1 = getWindowForNode_1;
var Immutable$3 = immutableExports;
var invariant$g = invariant_1;
var nullthrows$a = nullthrows_1;
var Map$3 = Immutable$3.Map;
var DOM_OBSERVER_OPTIONS = {
  subtree: true,
  characterData: true,
  childList: true,
  characterDataOldValue: false,
  attributes: false
};
var USE_CHAR_DATA = UserAgent$d.isBrowser("IE <= 11");
var DOMObserver$1 = /* @__PURE__ */ function() {
  function DOMObserver2(container) {
    var _this = this;
    _defineProperty$c(this, "observer", void 0);
    _defineProperty$c(this, "container", void 0);
    _defineProperty$c(this, "mutations", void 0);
    _defineProperty$c(this, "onCharData", void 0);
    this.container = container;
    this.mutations = Map$3();
    var containerWindow = getWindowForNode$1(container);
    if (containerWindow.MutationObserver && !USE_CHAR_DATA) {
      this.observer = new containerWindow.MutationObserver(function(mutations) {
        return _this.registerMutations(mutations);
      });
    } else {
      this.onCharData = function(e) {
        !(e.target instanceof Node) ? process.env.NODE_ENV !== "production" ? invariant$g(false, "Expected target to be an instance of Node") : invariant$g(false) : void 0;
        _this.registerMutation({
          type: "characterData",
          target: e.target
        });
      };
    }
  }
  var _proto = DOMObserver2.prototype;
  _proto.start = function start() {
    if (this.observer) {
      this.observer.observe(this.container, DOM_OBSERVER_OPTIONS);
    } else {
      this.container.addEventListener("DOMCharacterDataModified", this.onCharData);
    }
  };
  _proto.stopAndFlushMutations = function stopAndFlushMutations() {
    var observer = this.observer;
    if (observer) {
      this.registerMutations(observer.takeRecords());
      observer.disconnect();
    } else {
      this.container.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    var mutations = this.mutations;
    this.mutations = Map$3();
    return mutations;
  };
  _proto.registerMutations = function registerMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      this.registerMutation(mutations[i]);
    }
  };
  _proto.getMutationTextContent = function getMutationTextContent(mutation) {
    var type2 = mutation.type, target = mutation.target, removedNodes = mutation.removedNodes;
    if (type2 === "characterData") {
      if (target.textContent !== "") {
        if (USE_CHAR_DATA) {
          return target.textContent.replace("\n", "");
        }
        return target.textContent;
      }
    } else if (type2 === "childList") {
      if (removedNodes && removedNodes.length) {
        return "";
      } else if (target.textContent !== "") {
        return target.textContent;
      }
    }
    return null;
  };
  _proto.registerMutation = function registerMutation(mutation) {
    var textContent = this.getMutationTextContent(mutation);
    if (textContent != null) {
      var offsetKey = nullthrows$a(findAncestorOffsetKey$3(mutation.target));
      this.mutations = this.mutations.set(offsetKey, textContent);
    }
  };
  return DOMObserver2;
}();
var DOMObserver_1 = DOMObserver$1;
var KEY_DELIMITER = "-";
var DraftOffsetKey$4 = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },
  decode: function decode(offsetKey) {
    var _offsetKey$split$reve = offsetKey.split(KEY_DELIMITER).reverse(), leafKey = _offsetKey$split$reve[0], decoratorKey = _offsetKey$split$reve[1], blockKeyParts = _offsetKey$split$reve.slice(2);
    return {
      // Recomposes the parts of blockKey after reversing them
      blockKey: blockKeyParts.reverse().join(KEY_DELIMITER),
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};
var DraftOffsetKey_1 = DraftOffsetKey$4;
var Keys$4 = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};
var DraftJsDebugLogging$2 = {
  logBlockedSelectionEvent: function logBlockedSelectionEvent() {
    return null;
  },
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};
function isHTMLElement$4(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }
  if (!node.ownerDocument.defaultView) {
    return node instanceof HTMLElement;
  }
  if (node instanceof node.ownerDocument.defaultView.HTMLElement) {
    return true;
  }
  return false;
}
var isHTMLElement_1 = isHTMLElement$4;
var invariant$f = invariant_1;
var isHTMLElement$3 = isHTMLElement_1;
function getContentEditableContainer$2(editor) {
  var editorNode = editor.editorContainer;
  !editorNode ? process.env.NODE_ENV !== "production" ? invariant$f(false, "Missing editorNode") : invariant$f(false) : void 0;
  !isHTMLElement$3(editorNode.firstChild) ? process.env.NODE_ENV !== "production" ? invariant$f(false, "editorNode.firstChild is not an HTMLElement") : invariant$f(false) : void 0;
  var htmlElement = editorNode.firstChild;
  return htmlElement;
}
var getContentEditableContainer_1 = getContentEditableContainer$2;
var DraftOffsetKey$3 = DraftOffsetKey_1;
var nullthrows$9 = nullthrows_1;
function getUpdatedSelectionState$2(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows$9(editorState.getSelection());
  if (!anchorKey || !focusKey) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Invalid selection state.", arguments, editorState.toJS());
    }
    return selection;
  }
  var anchorPath = DraftOffsetKey$3.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeafBlockTree = editorState.getBlockTree(anchorBlockKey);
  var anchorLeaf = anchorLeafBlockTree && anchorLeafBlockTree.getIn([anchorPath.decoratorKey, "leaves", anchorPath.leafKey]);
  var focusPath = DraftOffsetKey$3.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeafBlockTree = editorState.getBlockTree(focusBlockKey);
  var focusLeaf = focusLeafBlockTree && focusLeafBlockTree.getIn([focusPath.decoratorKey, "leaves", focusPath.leafKey]);
  if (!anchorLeaf || !focusLeaf) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Invalid selection state.", arguments, editorState.toJS());
    }
    return selection;
  }
  var anchorLeafStart = anchorLeaf.get("start");
  var focusLeafStart = focusLeaf.get("start");
  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
  var areEqual3 = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
  if (areEqual3) {
    return selection;
  }
  var isBackward = false;
  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get("end");
    var focusLeafEnd = focusLeaf.get("end");
    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function(v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }
  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward
  });
}
var getUpdatedSelectionState_1 = getUpdatedSelectionState$2;
var findAncestorOffsetKey$2 = findAncestorOffsetKey_1;
var getSelectionOffsetKeyForNode = getSelectionOffsetKeyForNode_1;
var getUpdatedSelectionState$1 = getUpdatedSelectionState_1;
var invariant$e = invariant_1;
var isElement$5 = isElement_1;
var nullthrows$8 = nullthrows_1;
function getDraftEditorSelectionWithNodes$2(editorState, root2, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState$1(editorState, nullthrows$8(findAncestorOffsetKey$2(anchorNode)), anchorOffset, nullthrows$8(findAncestorOffsetKey$2(focusNode)), focusOffset),
      needsRecovery: false
    };
  }
  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true;
  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows$8(findAncestorOffsetKey$2(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root2, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows$8(findAncestorOffsetKey$2(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root2, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root2, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root2, focusNode, focusOffset);
    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== "BR";
    }
  }
  return {
    selectionState: getUpdatedSelectionState$1(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery
  };
}
function getFirstLeaf(node) {
  while (node.firstChild && // data-blocks has no offset
  (isElement$5(node.firstChild) && node.firstChild.getAttribute("data-blocks") === "true" || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }
  return node;
}
function getLastLeaf(node) {
  while (node.lastChild && // data-blocks has no offset
  (isElement$5(node.lastChild) && node.lastChild.getAttribute("data-blocks") === "true" || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }
  return node;
}
function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey$2(node);
  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ? process.env.NODE_ENV !== "production" ? invariant$e(false, "Unknown node in selection range.") : invariant$e(false) : void 0;
  if (editorRoot === node) {
    node = node.firstChild;
    !isElement$5(node) ? process.env.NODE_ENV !== "production" ? invariant$e(false, "Invalid DraftEditorContents node.") : invariant$e(false) : void 0;
    var castedNode = node;
    node = castedNode;
    !(node.getAttribute("data-contents") === "true") ? process.env.NODE_ENV !== "production" ? invariant$e(false, "Invalid DraftEditorContents structure.") : invariant$e(false) : void 0;
    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  }
  if (childOffset === 0) {
    var key = null;
    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows$8(getSelectionOffsetKeyForNode(firstLeaf));
    }
    return {
      key,
      offset: 0
    };
  }
  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;
  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    leafKey = nullthrows$8(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows$8(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }
  return {
    key: leafKey,
    offset: textLength
  };
}
function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === "\n" ? 0 : textContent.length;
}
var getDraftEditorSelectionWithNodes_1 = getDraftEditorSelectionWithNodes$2;
var getDraftEditorSelectionWithNodes$1 = getDraftEditorSelectionWithNodes_1;
function getDraftEditorSelection$2(editorState, root2) {
  var selection = root2.ownerDocument.defaultView.getSelection();
  var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset, rangeCount = selection.rangeCount;
  if (
    // No active selection.
    rangeCount === 0 || // No selection, ever. As in, the user hasn't selected anything since
    // opening the document.
    anchorNode == null || focusNode == null
  ) {
    return {
      selectionState: editorState.getSelection().set("hasFocus", false),
      needsRecovery: false
    };
  }
  return getDraftEditorSelectionWithNodes$1(editorState, root2, anchorNode, anchorOffset, focusNode, focusOffset);
}
var getDraftEditorSelection_1 = getDraftEditorSelection$2;
var DraftJsDebugLogging$1 = DraftJsDebugLogging$2;
var EditorState$o = EditorState_1;
var getContentEditableContainer$1 = getContentEditableContainer_1;
var getDraftEditorSelection$1 = getDraftEditorSelection_1;
function editOnSelect$1(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    if (editor._blockSelectEvents) {
      var _editorState = editor.props.editorState;
      var selectionState = _editorState.getSelection();
      DraftJsDebugLogging$1.logBlockedSelectionEvent({
        // For now I don't think we need any other info
        anonymizedDom: "N/A",
        extraParams: JSON.stringify({
          stacktrace: new Error().stack
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }
    return;
  }
  var editorState = editor.props.editorState;
  var documentSelection = getDraftEditorSelection$1(editorState, getContentEditableContainer$1(editor));
  var updatedSelectionState = documentSelection.selectionState;
  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState$o.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState$o.acceptSelection(editorState, updatedSelectionState);
    }
    editor.update(editorState);
  }
}
var editOnSelect_1 = editOnSelect$1;
function notEmptyKey$2(key) {
  return key != null && key != "";
}
var draftKeyUtils = {
  notEmptyKey: notEmptyKey$2
};
var _require$4 = draftKeyUtils, notEmptyKey$1 = _require$4.notEmptyKey;
function getEntityKeyForSelection$3(contentState, targetSelection) {
  var entityKey;
  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();
    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }
      return filterKey(contentState.getEntityMap(), entityKey);
    }
    return null;
  }
  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);
  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
  return filterKey(contentState.getEntityMap(), entityKey);
}
function filterKey(entityMap, entityKey) {
  if (notEmptyKey$1(entityKey)) {
    var entity = entityMap.__get(entityKey);
    return entity.getMutability() === "MUTABLE" ? entityKey : null;
  }
  return null;
}
var getEntityKeyForSelection_1 = getEntityKeyForSelection$3;
var DOMObserver = DOMObserver_1;
var DraftModifier$c = DraftModifier_1;
var DraftOffsetKey$2 = DraftOffsetKey_1;
var EditorState$n = EditorState_1;
var Keys$3 = Keys$4;
var UserAgent$c = UserAgent_1;
var editOnSelect = editOnSelect_1;
var getContentEditableContainer = getContentEditableContainer_1;
var getDraftEditorSelection = getDraftEditorSelection_1;
var getEntityKeyForSelection$2 = getEntityKeyForSelection_1;
var nullthrows$7 = nullthrows_1;
var isIE$2 = UserAgent$c.isBrowser("IE");
var RESOLVE_DELAY = 20;
var resolved = false;
var stillComposing = false;
var domObserver = null;
function startDOMObserver(editor) {
  if (!domObserver) {
    domObserver = new DOMObserver(getContentEditableContainer(editor));
    domObserver.start();
  }
}
var DraftEditorCompositionHandler$1 = {
  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
    startDOMObserver(editor);
  },
  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function() {
      if (!resolved) {
        DraftEditorCompositionHandler$1.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },
  onSelect: editOnSelect,
  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      DraftEditorCompositionHandler$1.resolveComposition(editor);
      editor._onKeyDown(e);
      return;
    }
    if (e.which === Keys$3.RIGHT || e.which === Keys$3.LEFT) {
      e.preventDefault();
    }
  },
  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(_editor, e) {
    if (e.which === Keys$3.RETURN) {
      e.preventDefault();
    }
  },
  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }
    var mutations = nullthrows$7(domObserver).stopAndFlushMutations();
    domObserver = null;
    resolved = true;
    var editorState = EditorState$n.set(editor._latestEditorState, {
      inCompositionMode: false
    });
    editor.exitCurrentMode();
    if (!mutations.size) {
      editor.update(editorState);
      return;
    }
    var contentState = editorState.getCurrentContent();
    mutations.forEach(function(composedChars, offsetKey) {
      var _DraftOffsetKey$decod = DraftOffsetKey$2.decode(offsetKey), blockKey = _DraftOffsetKey$decod.blockKey, decoratorKey = _DraftOffsetKey$decod.decoratorKey, leafKey = _DraftOffsetKey$decod.leafKey;
      var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, "leaves", leafKey]), start = _editorState$getBlock.start, end = _editorState$getBlock.end;
      var replacementRange = editorState.getSelection().merge({
        anchorKey: blockKey,
        focusKey: blockKey,
        anchorOffset: start,
        focusOffset: end,
        isBackward: false
      });
      var entityKey = getEntityKeyForSelection$2(contentState, replacementRange);
      var currentStyle = contentState.getBlockForKey(blockKey).getInlineStyleAt(start);
      contentState = DraftModifier$c.replaceText(contentState, replacementRange, composedChars, currentStyle, entityKey);
      editorState = EditorState$n.set(editorState, {
        currentContent: contentState
      });
    });
    var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
    var compositionEndSelectionState = documentSelection.selectionState;
    editor.restoreEditorDOM();
    var editorStateWithUpdatedSelection = isIE$2 ? EditorState$n.forceSelection(editorState, compositionEndSelectionState) : EditorState$n.acceptSelection(editorState, compositionEndSelectionState);
    editor.update(EditorState$n.push(editorStateWithUpdatedSelection, contentState, "insert-characters"));
  }
};
var DraftEditorCompositionHandler_1 = DraftEditorCompositionHandler$1;
var DraftEditorDecoratedLeaves_react;
var hasRequiredDraftEditorDecoratedLeaves_react;
function requireDraftEditorDecoratedLeaves_react() {
  if (hasRequiredDraftEditorDecoratedLeaves_react)
    return DraftEditorDecoratedLeaves_react;
  hasRequiredDraftEditorDecoratedLeaves_react = 1;
  var _assign2 = objectAssign;
  function _extends2() {
    _extends2 = _assign2 || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _inheritsLoose2(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }
  var DraftOffsetKey2 = DraftOffsetKey_1;
  var React2 = React__default;
  var UnicodeBidi2 = UnicodeBidi_1;
  var UnicodeBidiDirection2 = UnicodeBidiDirection_1;
  var DraftEditorDecoratedLeaves = /* @__PURE__ */ function(_React$Component) {
    _inheritsLoose2(DraftEditorDecoratedLeaves2, _React$Component);
    function DraftEditorDecoratedLeaves2() {
      return _React$Component.apply(this, arguments) || this;
    }
    var _proto = DraftEditorDecoratedLeaves2.prototype;
    _proto.render = function render() {
      var _this$props = this.props, block = _this$props.block, children = _this$props.children, contentState = _this$props.contentState, decorator = _this$props.decorator, decoratorKey = _this$props.decoratorKey, direction = _this$props.direction, leafSet = _this$props.leafSet, text = _this$props.text;
      var blockKey = block.getKey();
      var leavesForLeafSet = leafSet.get("leaves");
      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey2.encode(blockKey, parseInt(decoratorKey, 10), 0);
      var decoratedText = text.slice(leavesForLeafSet.first().get("start"), leavesForLeafSet.last().get("end"));
      var dir = UnicodeBidiDirection2.getHTMLDirIfDifferent(UnicodeBidi2.getDirection(decoratedText), direction);
      return React2.createElement(DecoratorComponent, _extends2({}, decoratorProps, {
        contentState,
        decoratedText,
        dir,
        key: decoratorOffsetKey,
        entityKey: block.getEntityAt(leafSet.get("start")),
        offsetKey: decoratorOffsetKey
      }), children);
    };
    return DraftEditorDecoratedLeaves2;
  }(React2.Component);
  DraftEditorDecoratedLeaves_react = DraftEditorDecoratedLeaves;
  return DraftEditorDecoratedLeaves_react;
}
function _assertThisInitialized$4(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose$4(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _defineProperty$b(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var React$5 = React__default;
var UserAgent$b = UserAgent_1;
var invariant$d = invariant_1;
var isElement$4 = isElement_1;
var useNewlineChar = UserAgent$b.isBrowser("IE <= 11");
function isNewline(node) {
  return useNewlineChar ? node.textContent === "\n" : node.tagName === "BR";
}
var NEWLINE_A = function NEWLINE_A2(ref) {
  return useNewlineChar ? React$5.createElement("span", {
    key: "A",
    "data-text": "true",
    ref
  }, "\n") : React$5.createElement("br", {
    key: "A",
    "data-text": "true",
    ref
  });
};
var NEWLINE_B = function NEWLINE_B2(ref) {
  return useNewlineChar ? React$5.createElement("span", {
    key: "B",
    "data-text": "true",
    ref
  }, "\n") : React$5.createElement("br", {
    key: "B",
    "data-text": "true",
    ref
  });
};
var DraftEditorTextNode$1 = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose$4(DraftEditorTextNode2, _React$Component);
  function DraftEditorTextNode2(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _defineProperty$b(_assertThisInitialized$4(_this), "_forceFlag", void 0);
    _defineProperty$b(_assertThisInitialized$4(_this), "_node", void 0);
    _this._forceFlag = false;
    return _this;
  }
  var _proto = DraftEditorTextNode2.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = this._node;
    var shouldBeNewline = nextProps.children === "";
    !isElement$4(node) ? process.env.NODE_ENV !== "production" ? invariant$d(false, "node is not an Element") : invariant$d(false) : void 0;
    var elementNode = node;
    if (shouldBeNewline) {
      return !isNewline(elementNode);
    }
    return elementNode.textContent !== nextProps.children;
  };
  _proto.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };
  _proto.render = function render() {
    var _this2 = this;
    if (this.props.children === "") {
      return this._forceFlag ? NEWLINE_A(function(ref) {
        return _this2._node = ref;
      }) : NEWLINE_B(function(ref) {
        return _this2._node = ref;
      });
    }
    return React$5.createElement("span", {
      key: this._forceFlag ? "A" : "B",
      "data-text": "true",
      ref: function ref(_ref) {
        return _this2._node = _ref;
      }
    }, this.props.children);
  };
  return DraftEditorTextNode2;
}(React$5.Component);
var DraftEditorTextNode_react = DraftEditorTextNode$1;
var isElement$3 = isElement_1;
function isHTMLBRElement$2(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }
  return isElement$3(node) && node.nodeName === "BR";
}
var isHTMLBRElement_1 = isHTMLBRElement$2;
var DraftEffects$2 = {
  initODS: function initODS() {
  },
  handleExtensionCausedError: function handleExtensionCausedError() {
  }
};
function isNode$2(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === "function" ? object instanceof defaultView.Node : typeof object === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string"));
}
var isNode_1 = isNode$2;
var isNode$1 = isNode_1;
function isTextNode$1(object) {
  return isNode$1(object) && object.nodeType == 3;
}
var isTextNode_1 = isTextNode$1;
var isTextNode = isTextNode_1;
function containsNode$3(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode$3(outerNode, innerNode.parentNode);
  } else if ("contains" in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}
var containsNode_1 = containsNode$3;
function getActiveElement$2(doc) {
  doc = doc || (typeof document !== "undefined" ? document : void 0);
  if (typeof doc === "undefined") {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
var getActiveElement_1 = getActiveElement$2;
var DraftEffects$1 = DraftEffects$2;
var DraftJsDebugLogging = DraftJsDebugLogging$2;
var UserAgent$a = UserAgent_1;
var containsNode$2 = containsNode_1;
var getActiveElement$1 = getActiveElement_1;
var getCorrectDocumentFromNode$2 = getCorrectDocumentFromNode_1;
var invariant$c = invariant_1;
var isElement$2 = isElement_1;
var isIE$1 = UserAgent$a.isBrowser("IE");
function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return "[empty]";
  }
  var anonymized = anonymizeTextWithin(node, getNodeLabels);
  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }
  !isElement$2(anonymized) ? process.env.NODE_ENV !== "production" ? invariant$c(false, "Node must be an Element if it is not a text node.") : invariant$c(false) : void 0;
  var castedElement = anonymized;
  return castedElement.outerHTML;
}
function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== void 0 ? getNodeLabels(node) : [];
  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return getCorrectDocumentFromNode$2(node).createTextNode("[text " + length + (labels.length ? " | " + labels.join(", ") : "") + "]");
  }
  var clone = node.cloneNode();
  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute("data-labels", labels.join(", "));
  }
  var childNodes = node.childNodes;
  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }
  return clone;
}
function getAnonymizedEditorDOM(node, getNodeLabels) {
  var currentNode = node;
  var castedNode = currentNode;
  while (currentNode) {
    if (isElement$2(currentNode) && castedNode.hasAttribute("contenteditable")) {
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
      castedNode = currentNode;
    }
  }
  return "Could not find contentEditable parent of node";
}
function getNodeLength$1(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}
function setDraftEditorSelection$1(selectionState, node, blockKey, nodeStart, nodeEnd) {
  var documentObject = getCorrectDocumentFromNode$2(node);
  if (!containsNode$2(documentObject.documentElement, node)) {
    return;
  }
  var selection = documentObject.defaultView.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward();
  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }
  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }
  if (!isBackward) {
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    }
    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}
function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement$1();
  var extend = selection.extend;
  if (extend && node != null && containsNode$2(activeElement, node)) {
    if (offset > getNodeLength$1(node)) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({
          offset
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }
    var nodeWasFocus = node === selection.focusNode;
    try {
      if (selection.rangeCount > 0 && selection.extend) {
        selection.extend(node, offset);
      }
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function(n) {
          var labels = [];
          if (n === activeElement) {
            labels.push("active element");
          }
          if (n === selection.anchorNode) {
            labels.push("selection anchor node");
          }
          if (n === selection.focusNode) {
            labels.push("selection focus node");
          }
          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? "" + e : null,
          offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      });
      throw e;
    }
  } else {
    if (node && selection.rangeCount > 0) {
      var range = selection.getRangeAt(0);
      range.setEnd(node, offset);
      selection.addRange(range.cloneRange());
    }
  }
}
function addPointToSelection(selection, node, offset, selectionState) {
  var range = getCorrectDocumentFromNode$2(node).createRange();
  if (offset > getNodeLength$1(node)) {
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({
        offset
      }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
    DraftEffects$1.handleExtensionCausedError();
  }
  range.setStart(node, offset);
  if (isIE$1) {
    try {
      selection.addRange(range);
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("Call to selection.addRange() threw exception: ", e);
      }
    }
  } else {
    selection.addRange(range);
  }
}
var setDraftEditorSelection_1 = {
  setDraftEditorSelection: setDraftEditorSelection$1,
  addFocusToSelection
};
var _assign$2 = objectAssign;
function _assertThisInitialized$3(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose$3(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _defineProperty$a(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DraftEditorTextNode = DraftEditorTextNode_react;
var React$4 = React__default;
var invariant$b = invariant_1;
var isHTMLBRElement$1 = isHTMLBRElement_1;
var setDraftEditorSelection = setDraftEditorSelection_1.setDraftEditorSelection;
var DraftEditorLeaf$1 = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose$3(DraftEditorLeaf2, _React$Component);
  function DraftEditorLeaf2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty$a(_assertThisInitialized$3(_this), "leaf", void 0);
    return _this;
  }
  var _proto = DraftEditorLeaf2.prototype;
  _proto._setSelection = function _setSelection() {
    var selection = this.props.selection;
    if (selection == null || !selection.getHasFocus()) {
      return;
    }
    var _this$props = this.props, block = _this$props.block, start = _this$props.start, text = _this$props.text;
    var blockKey = block.getKey();
    var end = start + text.length;
    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    }
    var node = this.leaf;
    !node ? process.env.NODE_ENV !== "production" ? invariant$b(false, "Missing node") : invariant$b(false) : void 0;
    var child = node.firstChild;
    !child ? process.env.NODE_ENV !== "production" ? invariant$b(false, "Missing child") : invariant$b(false) : void 0;
    var targetNode;
    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (isHTMLBRElement$1(child)) {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ? process.env.NODE_ENV !== "production" ? invariant$b(false, "Missing targetNode") : invariant$b(false) : void 0;
    }
    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = this.leaf;
    !leafNode ? process.env.NODE_ENV !== "production" ? invariant$b(false, "Missing leafNode") : invariant$b(false) : void 0;
    var shouldUpdate = leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
    return shouldUpdate;
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };
  _proto.componentDidMount = function componentDidMount() {
    this._setSelection();
  };
  _proto.render = function render() {
    var _this2 = this;
    var block = this.props.block;
    var text = this.props.text;
    if (text.endsWith("\n") && this.props.isLast) {
      text += "\n";
    }
    var _this$props2 = this.props, customStyleMap = _this$props2.customStyleMap, customStyleFn = _this$props2.customStyleFn, offsetKey = _this$props2.offsetKey, styleSet = _this$props2.styleSet;
    var styleObj = styleSet.reduce(function(map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];
      if (style !== void 0 && map.textDecoration !== style.textDecoration) {
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(" ").trim();
      }
      return _assign$2(map, style, mergedStyles);
    }, {});
    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign$2(styleObj, newStyles);
    }
    return React$4.createElement("span", {
      "data-offset-key": offsetKey,
      ref: function ref(_ref) {
        return _this2.leaf = _ref;
      },
      style: styleObj
    }, React$4.createElement(DraftEditorTextNode, null, text));
  };
  return DraftEditorLeaf2;
}(React$4.Component);
var DraftEditorLeaf_react = DraftEditorLeaf$1;
var DraftEditorNode_react;
var hasRequiredDraftEditorNode_react;
function requireDraftEditorNode_react() {
  if (hasRequiredDraftEditorNode_react)
    return DraftEditorNode_react;
  hasRequiredDraftEditorNode_react = 1;
  function _inheritsLoose2(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }
  var DraftEditorDecoratedLeaves = requireDraftEditorDecoratedLeaves_react();
  var DraftEditorLeaf2 = DraftEditorLeaf_react;
  var DraftOffsetKey2 = DraftOffsetKey_1;
  var Immutable2 = immutableExports;
  var React2 = React__default;
  var cx2 = cx_1;
  Immutable2.List;
  var DraftEditorNode = /* @__PURE__ */ function(_React$Component) {
    _inheritsLoose2(DraftEditorNode2, _React$Component);
    function DraftEditorNode2() {
      return _React$Component.apply(this, arguments) || this;
    }
    var _proto = DraftEditorNode2.prototype;
    _proto.render = function render() {
      var _this$props = this.props, block = _this$props.block, contentState = _this$props.contentState, customStyleFn = _this$props.customStyleFn, customStyleMap = _this$props.customStyleMap, decorator = _this$props.decorator, direction = _this$props.direction, forceSelection = _this$props.forceSelection, hasSelection = _this$props.hasSelection, selection = _this$props.selection, tree = _this$props.tree;
      var blockKey = block.getKey();
      var text = block.getText();
      var lastLeafSet = tree.size - 1;
      var children = this.props.children || tree.map(function(leafSet, ii) {
        var decoratorKey = leafSet.get("decoratorKey");
        var leavesForLeafSet = leafSet.get("leaves");
        var lastLeaf = leavesForLeafSet.size - 1;
        var Leaves = leavesForLeafSet.map(function(leaf, jj) {
          var offsetKey = DraftOffsetKey2.encode(blockKey, ii, jj);
          var start = leaf.get("start");
          var end = leaf.get("end");
          return React2.createElement(DraftEditorLeaf2, {
            key: offsetKey,
            offsetKey,
            block,
            start,
            selection: hasSelection ? selection : null,
            forceSelection,
            text: text.slice(start, end),
            styleSet: block.getInlineStyleAt(start),
            customStyleMap,
            customStyleFn,
            isLast: decoratorKey === lastLeafSet && jj === lastLeaf
          });
        }).toArray();
        if (!decoratorKey || !decorator) {
          return Leaves;
        }
        return React2.createElement(DraftEditorDecoratedLeaves, {
          block,
          children: Leaves,
          contentState,
          decorator,
          decoratorKey,
          direction,
          leafSet,
          text,
          key: ii
        });
      }).toArray();
      return React2.createElement("div", {
        "data-offset-key": DraftOffsetKey2.encode(blockKey, 0, 0),
        className: cx2({
          "public/DraftStyleDefault/block": true,
          "public/DraftStyleDefault/ltr": direction === "LTR",
          "public/DraftStyleDefault/rtl": direction === "RTL"
        })
      }, children);
    };
    return DraftEditorNode2;
  }(React2.Component);
  DraftEditorNode_react = DraftEditorNode;
  return DraftEditorNode_react;
}
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}
var Scroll$2 = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? (
      // In practice, they will either both have the same value,
      // or one will be zero and the other will be the scroll position
      // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
      doc.body.scrollTop || doc.documentElement.scrollTop
    ) : element.scrollTop;
  },
  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },
  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};
var Scroll_1 = Scroll$2;
var _hyphenPattern = /-(.)/g;
function camelize$1(string) {
  return string.replace(_hyphenPattern, function(_, character) {
    return character.toUpperCase();
  });
}
var camelize_1 = camelize$1;
var _uppercasePattern = /([A-Z])/g;
function hyphenate$1(string) {
  return string.replace(_uppercasePattern, "-$1").toLowerCase();
}
var hyphenate_1 = hyphenate$1;
var camelize = camelize_1;
var hyphenate = hyphenate_1;
function asString(value) {
  return value == null ? value : String(value);
}
function getStyleProperty$1(node, name2) {
  var computedStyle;
  if (window.getComputedStyle) {
    computedStyle = window.getComputedStyle(node, null);
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name2)));
    }
  }
  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null);
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name2)));
    }
    if (name2 === "display") {
      return "none";
    }
  }
  if (node.currentStyle) {
    if (name2 === "float") {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }
    return asString(node.currentStyle[camelize(name2)]);
  }
  return asString(node.style && node.style[camelize(name2)]);
}
var getStyleProperty_1 = getStyleProperty$1;
var getStyleProperty = getStyleProperty_1;
function _isNodeScrollable(element, name2) {
  var overflow = Style$3.get(element, name2);
  return overflow === "auto" || overflow === "scroll";
}
var Style$3 = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,
  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }
    var ownerDocument = node.ownerDocument;
    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, "overflow") || _isNodeScrollable(node, "overflowY") || _isNodeScrollable(node, "overflowX")) {
        return node;
      }
      node = node.parentNode;
    }
    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }
};
var Style_1 = Style$3;
var containsNode$1 = containsNode_1;
function getElementRect$1(elem) {
  var docElem = elem.ownerDocument.documentElement;
  if (!("getBoundingClientRect" in elem) || !containsNode$1(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }
  var rect = elem.getBoundingClientRect();
  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}
var getElementRect_1 = getElementRect$1;
var getElementRect = getElementRect_1;
function getElementPosition$1(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}
var getElementPosition_1 = getElementPosition$1;
var isWebkit = typeof navigator !== "undefined" && navigator.userAgent.indexOf("AppleWebKit") > -1;
function getDocumentScrollElement$1(doc) {
  doc = doc || document;
  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }
  return !isWebkit && doc.compatMode === "CSS1Compat" ? doc.documentElement : doc.body;
}
var getDocumentScrollElement_1 = getDocumentScrollElement$1;
function getUnboundedScrollPosition$1(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}
var getUnboundedScrollPosition_1 = getUnboundedScrollPosition$1;
var getDocumentScrollElement = getDocumentScrollElement_1;
var getUnboundedScrollPosition = getUnboundedScrollPosition_1;
function getScrollPosition$3(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }
  var scrollPosition = getUnboundedScrollPosition(scrollable);
  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;
  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
  return scrollPosition;
}
var getScrollPosition_1 = getScrollPosition$3;
function getViewportWidth() {
  var width;
  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }
  if (!width && document.body) {
    width = document.body.clientWidth;
  }
  return width || 0;
}
function getViewportHeight() {
  var height;
  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }
  if (!height && document.body) {
    height = document.body.clientHeight;
  }
  return height || 0;
}
function getViewportDimensions$1() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}
getViewportDimensions$1.withoutScrollbars = function() {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};
var getViewportDimensions_1 = getViewportDimensions$1;
var DraftEditorBlockNode_react;
var hasRequiredDraftEditorBlockNode_react;
function requireDraftEditorBlockNode_react() {
  if (hasRequiredDraftEditorBlockNode_react)
    return DraftEditorBlockNode_react;
  hasRequiredDraftEditorBlockNode_react = 1;
  var _assign2 = objectAssign;
  function _extends2() {
    _extends2 = _assign2 || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _inheritsLoose2(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys2 = Object.keys(source);
      if (typeof Object.getOwnPropertySymbols === "function") {
        ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }
      ownKeys2.forEach(function(key) {
        _defineProperty2(target, key, source[key]);
      });
    }
    return target;
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var DraftEditorNode = requireDraftEditorNode_react();
  var DraftOffsetKey2 = DraftOffsetKey_1;
  var React2 = React__default;
  var Scroll2 = Scroll_1;
  var Style2 = Style_1;
  var getElementPosition2 = getElementPosition_1;
  var getScrollPosition2 = getScrollPosition_1;
  var getViewportDimensions2 = getViewportDimensions_1;
  var Immutable2 = immutableExports;
  var invariant2 = invariant_1;
  var isHTMLElement2 = isHTMLElement_1;
  var SCROLL_BUFFER2 = 10;
  Immutable2.List;
  var isBlockOnSelectionEdge3 = function isBlockOnSelectionEdge22(selection, key) {
    return selection.getAnchorKey() === key || selection.getFocusKey() === key;
  };
  var shouldNotAddWrapperElement = function shouldNotAddWrapperElement2(block, contentState) {
    var nextSiblingKey = block.getNextSiblingKey();
    return nextSiblingKey ? contentState.getBlockForKey(nextSiblingKey).getType() === block.getType() : false;
  };
  var applyWrapperElementToSiblings = function applyWrapperElementToSiblings2(wrapperTemplate, Element2, nodes) {
    var wrappedSiblings = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = void 0;
    try {
      for (var _iterator = nodes.reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var sibling = _step.value;
        if (sibling.type !== Element2) {
          break;
        }
        wrappedSiblings.push(sibling);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    nodes.splice(nodes.indexOf(wrappedSiblings[0]), wrappedSiblings.length + 1);
    var childrenIs = wrappedSiblings.reverse();
    var key = childrenIs[0].key;
    nodes.push(React2.cloneElement(wrapperTemplate, {
      key: "".concat(key, "-wrap"),
      "data-offset-key": DraftOffsetKey2.encode(key, 0, 0)
    }, childrenIs));
    return nodes;
  };
  var getDraftRenderConfig = function getDraftRenderConfig2(block, blockRenderMap) {
    var configForType = blockRenderMap.get(block.getType()) || blockRenderMap.get("unstyled");
    var wrapperTemplate = configForType.wrapper;
    var Element2 = configForType.element || blockRenderMap.get("unstyled").element;
    return {
      Element: Element2,
      wrapperTemplate
    };
  };
  var getCustomRenderConfig = function getCustomRenderConfig2(block, blockRendererFn2) {
    var customRenderer = blockRendererFn2(block);
    if (!customRenderer) {
      return {};
    }
    var CustomComponent = customRenderer.component, customProps = customRenderer.props, customEditable = customRenderer.editable;
    return {
      CustomComponent,
      customProps,
      customEditable
    };
  };
  var getElementPropsConfig = function getElementPropsConfig2(block, editorKey, offsetKey, blockStyleFn2, customConfig, ref) {
    var elementProps = {
      "data-block": true,
      "data-editor": editorKey,
      "data-offset-key": offsetKey,
      key: block.getKey(),
      ref
    };
    var customClass = blockStyleFn2(block);
    if (customClass) {
      elementProps.className = customClass;
    }
    if (customConfig.customEditable !== void 0) {
      elementProps = _objectSpread2({}, elementProps, {
        contentEditable: customConfig.customEditable,
        suppressContentEditableWarning: true
      });
    }
    return elementProps;
  };
  var DraftEditorBlockNode = /* @__PURE__ */ function(_React$Component) {
    _inheritsLoose2(DraftEditorBlockNode2, _React$Component);
    function DraftEditorBlockNode2() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _defineProperty2(_assertThisInitialized2(_this), "wrapperRef", React2.createRef());
      return _this;
    }
    var _proto = DraftEditorBlockNode2.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      var _this$props = this.props, block = _this$props.block, direction = _this$props.direction, tree = _this$props.tree;
      var isContainerNode = !block.getChildKeys().isEmpty();
      var blockHasChanged = block !== nextProps.block || tree !== nextProps.tree || direction !== nextProps.direction || isBlockOnSelectionEdge3(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
      return isContainerNode || blockHasChanged;
    };
    _proto.componentDidMount = function componentDidMount() {
      var selection = this.props.selection;
      var endKey = selection.getEndKey();
      if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
        return;
      }
      var blockNode = this.wrapperRef.current;
      if (!blockNode) {
        return;
      }
      var scrollParent = Style2.getScrollParent(blockNode);
      var scrollPosition = getScrollPosition2(scrollParent);
      var scrollDelta;
      if (scrollParent === window) {
        var nodePosition = getElementPosition2(blockNode);
        var nodeBottom = nodePosition.y + nodePosition.height;
        var viewportHeight = getViewportDimensions2().height;
        scrollDelta = nodeBottom - viewportHeight;
        if (scrollDelta > 0) {
          window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER2);
        }
      } else {
        !isHTMLElement2(blockNode) ? process.env.NODE_ENV !== "production" ? invariant2(false, "blockNode is not an HTMLElement") : invariant2(false) : void 0;
        var htmlBlockNode = blockNode;
        var blockBottom = htmlBlockNode.offsetHeight + htmlBlockNode.offsetTop;
        var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
        scrollDelta = blockBottom - scrollBottom;
        if (scrollDelta > 0) {
          Scroll2.setTop(scrollParent, Scroll2.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER2);
        }
      }
    };
    _proto.render = function render() {
      var _this2 = this;
      var _this$props2 = this.props, block = _this$props2.block, blockRenderMap = _this$props2.blockRenderMap, blockRendererFn2 = _this$props2.blockRendererFn, blockStyleFn2 = _this$props2.blockStyleFn, contentState = _this$props2.contentState, decorator = _this$props2.decorator, editorKey = _this$props2.editorKey, editorState = _this$props2.editorState, customStyleFn = _this$props2.customStyleFn, customStyleMap = _this$props2.customStyleMap, direction = _this$props2.direction, forceSelection = _this$props2.forceSelection, selection = _this$props2.selection, tree = _this$props2.tree;
      var children = null;
      if (block.children.size) {
        children = block.children.reduce(function(acc, key) {
          var offsetKey2 = DraftOffsetKey2.encode(key, 0, 0);
          var child = contentState.getBlockForKey(key);
          var customConfig2 = getCustomRenderConfig(child, blockRendererFn2);
          var Component2 = customConfig2.CustomComponent || DraftEditorBlockNode2;
          var _getDraftRenderConfig = getDraftRenderConfig(child, blockRenderMap), Element22 = _getDraftRenderConfig.Element, wrapperTemplate = _getDraftRenderConfig.wrapperTemplate;
          var elementProps2 = getElementPropsConfig(child, editorKey, offsetKey2, blockStyleFn2, customConfig2, null);
          var childProps = _objectSpread2({}, _this2.props, {
            tree: editorState.getBlockTree(key),
            blockProps: customConfig2.customProps,
            offsetKey: offsetKey2,
            block: child
          });
          acc.push(React2.createElement(Element22, elementProps2, React2.createElement(Component2, childProps)));
          if (!wrapperTemplate || shouldNotAddWrapperElement(child, contentState)) {
            return acc;
          }
          applyWrapperElementToSiblings(wrapperTemplate, Element22, acc);
          return acc;
        }, []);
      }
      var blockKey = block.getKey();
      var offsetKey = DraftOffsetKey2.encode(blockKey, 0, 0);
      var customConfig = getCustomRenderConfig(block, blockRendererFn2);
      var Component = customConfig.CustomComponent;
      var blockNode = Component != null ? React2.createElement(Component, _extends2({}, this.props, {
        tree: editorState.getBlockTree(blockKey),
        blockProps: customConfig.customProps,
        offsetKey,
        block
      })) : React2.createElement(DraftEditorNode, {
        block,
        children,
        contentState,
        customStyleFn,
        customStyleMap,
        decorator,
        direction,
        forceSelection,
        hasSelection: isBlockOnSelectionEdge3(selection, blockKey),
        selection,
        tree
      });
      if (block.getParentKey()) {
        return blockNode;
      }
      var _getDraftRenderConfig2 = getDraftRenderConfig(block, blockRenderMap), Element2 = _getDraftRenderConfig2.Element;
      var elementProps = getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn2, customConfig, this.wrapperRef);
      return React2.createElement(Element2, elementProps, blockNode);
    };
    return DraftEditorBlockNode2;
  }(React2.Component);
  DraftEditorBlockNode_react = DraftEditorBlockNode;
  return DraftEditorBlockNode_react;
}
var DraftEditorContentsExperimental_react;
var hasRequiredDraftEditorContentsExperimental_react;
function requireDraftEditorContentsExperimental_react() {
  if (hasRequiredDraftEditorContentsExperimental_react)
    return DraftEditorContentsExperimental_react;
  hasRequiredDraftEditorContentsExperimental_react = 1;
  var _assign2 = objectAssign;
  function _extends2() {
    _extends2 = _assign2 || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _inheritsLoose2(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }
  var DraftEditorBlockNode = requireDraftEditorBlockNode_react();
  var DraftOffsetKey2 = DraftOffsetKey_1;
  var React2 = React__default;
  var nullthrows3 = nullthrows_1;
  var DraftEditorContentsExperimental = /* @__PURE__ */ function(_React$Component) {
    _inheritsLoose2(DraftEditorContentsExperimental2, _React$Component);
    function DraftEditorContentsExperimental2() {
      return _React$Component.apply(this, arguments) || this;
    }
    var _proto = DraftEditorContentsExperimental2.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      var prevEditorState = this.props.editorState;
      var nextEditorState = nextProps.editorState;
      var prevDirectionMap = prevEditorState.getDirectionMap();
      var nextDirectionMap = nextEditorState.getDirectionMap();
      if (prevDirectionMap !== nextDirectionMap) {
        return true;
      }
      var didHaveFocus = prevEditorState.getSelection().getHasFocus();
      var nowHasFocus = nextEditorState.getSelection().getHasFocus();
      if (didHaveFocus !== nowHasFocus) {
        return true;
      }
      var nextNativeContent = nextEditorState.getNativelyRenderedContent();
      var wasComposing = prevEditorState.isInCompositionMode();
      var nowComposing = nextEditorState.isInCompositionMode();
      if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
        return false;
      }
      var prevContent = prevEditorState.getCurrentContent();
      var nextContent = nextEditorState.getCurrentContent();
      var prevDecorator = prevEditorState.getDecorator();
      var nextDecorator = nextEditorState.getDecorator();
      return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
    };
    _proto.render = function render() {
      var _this$props = this.props, blockRenderMap = _this$props.blockRenderMap, blockRendererFn2 = _this$props.blockRendererFn, blockStyleFn2 = _this$props.blockStyleFn, customStyleMap = _this$props.customStyleMap, customStyleFn = _this$props.customStyleFn, editorState = _this$props.editorState, editorKey = _this$props.editorKey, textDirectionality = _this$props.textDirectionality;
      var content = editorState.getCurrentContent();
      var selection = editorState.getSelection();
      var forceSelection = editorState.mustForceSelection();
      var decorator = editorState.getDecorator();
      var directionMap = nullthrows3(editorState.getDirectionMap());
      var blocksAsArray = content.getBlocksAsArray();
      var rootBlock = blocksAsArray[0];
      var processedBlocks = [];
      var nodeBlock = rootBlock;
      while (nodeBlock) {
        var blockKey = nodeBlock.getKey();
        var blockProps = {
          blockRenderMap,
          blockRendererFn: blockRendererFn2,
          blockStyleFn: blockStyleFn2,
          contentState: content,
          customStyleFn,
          customStyleMap,
          decorator,
          editorKey,
          editorState,
          forceSelection,
          selection,
          block: nodeBlock,
          direction: textDirectionality ? textDirectionality : directionMap.get(blockKey),
          tree: editorState.getBlockTree(blockKey)
        };
        var configForType = blockRenderMap.get(nodeBlock.getType()) || blockRenderMap.get("unstyled");
        var wrapperTemplate = configForType.wrapper;
        processedBlocks.push({
          /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
           * comment suppresses an error found when Flow v0.112 was deployed. To
           * see the error delete this comment and run Flow. */
          block: React2.createElement(DraftEditorBlockNode, _extends2({
            key: blockKey
          }, blockProps)),
          wrapperTemplate,
          key: blockKey,
          offsetKey: DraftOffsetKey2.encode(blockKey, 0, 0)
        });
        var nextBlockKey = nodeBlock.getNextSiblingKey();
        nodeBlock = nextBlockKey ? content.getBlockForKey(nextBlockKey) : null;
      }
      var outputBlocks = [];
      for (var ii = 0; ii < processedBlocks.length; ) {
        var info = processedBlocks[ii];
        if (info.wrapperTemplate) {
          var blocks = [];
          do {
            blocks.push(processedBlocks[ii].block);
            ii++;
          } while (ii < processedBlocks.length && processedBlocks[ii].wrapperTemplate === info.wrapperTemplate);
          var wrapperElement = React2.cloneElement(info.wrapperTemplate, {
            key: info.key + "-wrap",
            "data-offset-key": info.offsetKey
          }, blocks);
          outputBlocks.push(wrapperElement);
        } else {
          outputBlocks.push(info.block);
          ii++;
        }
      }
      return React2.createElement("div", {
        "data-contents": "true"
      }, outputBlocks);
    };
    return DraftEditorContentsExperimental2;
  }(React2.Component);
  DraftEditorContentsExperimental_react = DraftEditorContentsExperimental;
  return DraftEditorContentsExperimental_react;
}
var _assign$1 = objectAssign;
function _extends$2() {
  _extends$2 = _assign$1 || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _assertThisInitialized$2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DraftEditorLeaf = DraftEditorLeaf_react;
var DraftOffsetKey$1 = DraftOffsetKey_1;
var React$3 = React__default;
var Scroll$1 = Scroll_1;
var Style$2 = Style_1;
var UnicodeBidi = UnicodeBidi_1;
var UnicodeBidiDirection = UnicodeBidiDirection_1;
var cx$3 = cx_1;
var getElementPosition = getElementPosition_1;
var getScrollPosition$2 = getScrollPosition_1;
var getViewportDimensions = getViewportDimensions_1;
var invariant$a = invariant_1;
var isHTMLElement$2 = isHTMLElement_1;
var nullthrows$6 = nullthrows_1;
var SCROLL_BUFFER = 10;
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge2(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
var DraftEditorBlock$1 = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose$2(DraftEditorBlock2, _React$Component);
  function DraftEditorBlock2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty$9(_assertThisInitialized$2(_this), "_node", void 0);
    return _this;
  }
  var _proto = DraftEditorBlock2.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  };
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.preventScroll) {
      return;
    }
    var selection = this.props.selection;
    var endKey = selection.getEndKey();
    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }
    var blockNode = this._node;
    if (blockNode == null) {
      return;
    }
    var scrollParent = Style$2.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition$2(scrollParent);
    var scrollDelta;
    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;
      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !isHTMLElement$2(blockNode) ? process.env.NODE_ENV !== "production" ? invariant$a(false, "blockNode is not an HTMLElement") : invariant$a(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var pOffset = scrollParent.offsetTop + scrollParent.offsetHeight;
      var scrollBottom = pOffset + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;
      if (scrollDelta > 0) {
        Scroll$1.setTop(scrollParent, Scroll$1.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };
  _proto._renderChildren = function _renderChildren() {
    var _this2 = this;
    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
    return this.props.tree.map(function(leafSet, ii) {
      var leavesForLeafSet = leafSet.get("leaves");
      if (leavesForLeafSet.size === 0) {
        return null;
      }
      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function(leaf, jj) {
        var offsetKey = DraftOffsetKey$1.encode(blockKey, ii, jj);
        var start2 = leaf.get("start");
        var end2 = leaf.get("end");
        return React$3.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey,
          block,
          start: start2,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start2, end2),
          styleSet: block.getInlineStyleAt(start2),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();
      var decoratorKey = leafSet.get("decoratorKey");
      if (decoratorKey == null) {
        return leaves;
      }
      if (!_this2.props.decorator) {
        return leaves;
      }
      var decorator = nullthrows$6(_this2.props.decorator);
      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
      if (!DecoratorComponent) {
        return leaves;
      }
      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey$1.encode(blockKey, ii, 0);
      var start = leavesForLeafSet.first().get("start");
      var end = leavesForLeafSet.last().get("end");
      var decoratedText = text.slice(start, end);
      var entityKey = block.getEntityAt(leafSet.get("start"));
      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
      var commonProps = {
        contentState: _this2.props.contentState,
        decoratedText,
        dir,
        start,
        end,
        blockKey,
        entityKey,
        offsetKey: decoratorOffsetKey
      };
      return React$3.createElement(DecoratorComponent, _extends$2({}, decoratorProps, commonProps, {
        key: decoratorOffsetKey
      }), leaves);
    }).toArray();
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props, direction = _this$props.direction, offsetKey = _this$props.offsetKey;
    var className = cx$3({
      "public/DraftStyleDefault/block": true,
      "public/DraftStyleDefault/ltr": direction === "LTR",
      "public/DraftStyleDefault/rtl": direction === "RTL"
    });
    return React$3.createElement("div", {
      "data-offset-key": offsetKey,
      className,
      ref: function ref(_ref) {
        return _this3._node = _ref;
      }
    }, this._renderChildren());
  };
  return DraftEditorBlock2;
}(React$3.Component);
var DraftEditorBlock_react = DraftEditorBlock$1;
var joinClasses_1;
var hasRequiredJoinClasses;
function requireJoinClasses() {
  if (hasRequiredJoinClasses)
    return joinClasses_1;
  hasRequiredJoinClasses = 1;
  function joinClasses(className) {
    var newClassName = className || "";
    var argLength = arguments.length;
    if (argLength > 1) {
      for (var index = 1; index < argLength; index++) {
        var nextClass = arguments[index];
        if (nextClass) {
          newClassName = (newClassName ? newClassName + " " : "") + nextClass;
        }
      }
    }
    return newClassName;
  }
  joinClasses_1 = joinClasses;
  return joinClasses_1;
}
var DraftEditorContentsCore_react;
var hasRequiredDraftEditorContentsCore_react;
function requireDraftEditorContentsCore_react() {
  if (hasRequiredDraftEditorContentsCore_react)
    return DraftEditorContentsCore_react;
  hasRequiredDraftEditorContentsCore_react = 1;
  var _assign2 = objectAssign;
  function _extends2() {
    _extends2 = _assign2 || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys2 = Object.keys(source);
      if (typeof Object.getOwnPropertySymbols === "function") {
        ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }
      ownKeys2.forEach(function(key) {
        _defineProperty2(target, key, source[key]);
      });
    }
    return target;
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inheritsLoose2(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }
  var DraftEditorBlock2 = DraftEditorBlock_react;
  var DraftOffsetKey2 = DraftOffsetKey_1;
  var React2 = React__default;
  var cx2 = cx_1;
  var joinClasses = requireJoinClasses();
  var nullthrows3 = nullthrows_1;
  var getListItemClasses = function getListItemClasses2(type2, depth, shouldResetCount, direction) {
    return cx2({
      "public/DraftStyleDefault/unorderedListItem": type2 === "unordered-list-item",
      "public/DraftStyleDefault/orderedListItem": type2 === "ordered-list-item",
      "public/DraftStyleDefault/reset": shouldResetCount,
      "public/DraftStyleDefault/depth0": depth === 0,
      "public/DraftStyleDefault/depth1": depth === 1,
      "public/DraftStyleDefault/depth2": depth === 2,
      "public/DraftStyleDefault/depth3": depth === 3,
      "public/DraftStyleDefault/depth4": depth >= 4,
      "public/DraftStyleDefault/listLTR": direction === "LTR",
      "public/DraftStyleDefault/listRTL": direction === "RTL"
    });
  };
  var DraftEditorContents2 = /* @__PURE__ */ function(_React$Component) {
    _inheritsLoose2(DraftEditorContents22, _React$Component);
    function DraftEditorContents22() {
      return _React$Component.apply(this, arguments) || this;
    }
    var _proto = DraftEditorContents22.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      var prevEditorState = this.props.editorState;
      var nextEditorState = nextProps.editorState;
      var prevDirectionMap = prevEditorState.getDirectionMap();
      var nextDirectionMap = nextEditorState.getDirectionMap();
      if (prevDirectionMap !== nextDirectionMap) {
        return true;
      }
      var didHaveFocus = prevEditorState.getSelection().getHasFocus();
      var nowHasFocus = nextEditorState.getSelection().getHasFocus();
      if (didHaveFocus !== nowHasFocus) {
        return true;
      }
      var nextNativeContent = nextEditorState.getNativelyRenderedContent();
      var wasComposing = prevEditorState.isInCompositionMode();
      var nowComposing = nextEditorState.isInCompositionMode();
      if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
        return false;
      }
      var prevContent = prevEditorState.getCurrentContent();
      var nextContent = nextEditorState.getCurrentContent();
      var prevDecorator = prevEditorState.getDecorator();
      var nextDecorator = nextEditorState.getDecorator();
      return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
    };
    _proto.render = function render() {
      var _this$props = this.props, blockRenderMap = _this$props.blockRenderMap, blockRendererFn2 = _this$props.blockRendererFn, blockStyleFn2 = _this$props.blockStyleFn, customStyleMap = _this$props.customStyleMap, customStyleFn = _this$props.customStyleFn, editorState = _this$props.editorState, editorKey = _this$props.editorKey, preventScroll = _this$props.preventScroll, textDirectionality = _this$props.textDirectionality;
      var content = editorState.getCurrentContent();
      var selection = editorState.getSelection();
      var forceSelection = editorState.mustForceSelection();
      var decorator = editorState.getDecorator();
      var directionMap = nullthrows3(editorState.getDirectionMap());
      var blocksAsArray = content.getBlocksAsArray();
      var processedBlocks = [];
      var currentDepth = null;
      var lastWrapperTemplate = null;
      for (var ii = 0; ii < blocksAsArray.length; ii++) {
        var _block = blocksAsArray[ii];
        var key = _block.getKey();
        var blockType = _block.getType();
        var customRenderer = blockRendererFn2(_block);
        var CustomComponent = void 0, customProps = void 0, customEditable = void 0;
        if (customRenderer) {
          CustomComponent = customRenderer.component;
          customProps = customRenderer.props;
          customEditable = customRenderer.editable;
        }
        var direction = textDirectionality ? textDirectionality : directionMap.get(key);
        var offsetKey = DraftOffsetKey2.encode(key, 0, 0);
        var componentProps = {
          contentState: content,
          block: _block,
          blockProps: customProps,
          blockStyleFn: blockStyleFn2,
          customStyleMap,
          customStyleFn,
          decorator,
          direction,
          forceSelection,
          offsetKey,
          preventScroll,
          selection,
          tree: editorState.getBlockTree(key)
        };
        var configForType = blockRenderMap.get(blockType) || blockRenderMap.get("unstyled");
        var wrapperTemplate = configForType.wrapper;
        var Element2 = configForType.element || blockRenderMap.get("unstyled").element;
        var depth = _block.getDepth();
        var _className = "";
        if (blockStyleFn2) {
          _className = blockStyleFn2(_block);
        }
        if (Element2 === "li") {
          var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
          _className = joinClasses(_className, getListItemClasses(blockType, depth, shouldResetCount, direction));
        }
        var Component = CustomComponent || DraftEditorBlock2;
        var childProps = {
          className: _className,
          "data-block": true,
          "data-editor": editorKey,
          "data-offset-key": offsetKey,
          key
        };
        if (customEditable !== void 0) {
          childProps = _objectSpread2({}, childProps, {
            contentEditable: customEditable,
            suppressContentEditableWarning: true
          });
        }
        var child = React2.createElement(
          Element2,
          childProps,
          /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
           * comment suppresses an error found when Flow v0.112 was deployed. To
           * see the error delete this comment and run Flow. */
          React2.createElement(Component, _extends2({}, componentProps, {
            key
          }))
        );
        processedBlocks.push({
          block: child,
          wrapperTemplate,
          key,
          offsetKey
        });
        if (wrapperTemplate) {
          currentDepth = _block.getDepth();
        } else {
          currentDepth = null;
        }
        lastWrapperTemplate = wrapperTemplate;
      }
      var outputBlocks = [];
      for (var _ii = 0; _ii < processedBlocks.length; ) {
        var info = processedBlocks[_ii];
        if (info.wrapperTemplate) {
          var blocks = [];
          do {
            blocks.push(processedBlocks[_ii].block);
            _ii++;
          } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
          var wrapperElement = React2.cloneElement(info.wrapperTemplate, {
            key: info.key + "-wrap",
            "data-offset-key": info.offsetKey
          }, blocks);
          outputBlocks.push(wrapperElement);
        } else {
          outputBlocks.push(info.block);
          _ii++;
        }
      }
      return React2.createElement("div", {
        "data-contents": "true"
      }, outputBlocks);
    };
    return DraftEditorContents22;
  }(React2.Component);
  DraftEditorContentsCore_react = DraftEditorContents2;
  return DraftEditorContentsCore_react;
}
var gkx$5 = gkx$8;
var experimentalTreeDataSupport$4 = gkx$5("draft_tree_data_support");
var DraftEditorContents_react = experimentalTreeDataSupport$4 ? requireDraftEditorContentsExperimental_react() : requireDraftEditorContentsCore_react();
var PhotosMimeType$1 = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === "image";
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType$1.isImage(mimeString) && // see http://fburl.com/10972194
    (parts[1] === "jpeg" || parts[1] === "pjpeg");
  }
};
function getParts(mimeString) {
  return mimeString.split("/");
}
var PhotosMimeType_1 = PhotosMimeType$1;
var invariant$9 = invariant_1;
function toArray(obj) {
  var length = obj.length;
  !(!Array.isArray(obj) && (typeof obj === "object" || typeof obj === "function")) ? process.env.NODE_ENV !== "production" ? invariant$9(false, "toArray: Array-like object expected") : invariant$9(false) : void 0;
  !(typeof length === "number") ? process.env.NODE_ENV !== "production" ? invariant$9(false, "toArray: Object needs a length property") : invariant$9(false) : void 0;
  !(length === 0 || length - 1 in obj) ? process.env.NODE_ENV !== "production" ? invariant$9(false, "toArray: Object should have keys for indices") : invariant$9(false) : void 0;
  !(typeof obj.callee !== "function") ? process.env.NODE_ENV !== "production" ? invariant$9(false, "toArray: Object can't be `arguments`. Use rest params (function(...args) {}) or Array.from() instead.") : invariant$9(false) : void 0;
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
    }
  }
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && // arrays are objects, NodeLists are functions in Safari
    (typeof obj == "object" || typeof obj == "function") && // quacks like an array
    "length" in obj && // not window
    !("setInterval" in obj) && // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != "number" && // a real array
    (Array.isArray(obj) || // arguments
    "callee" in obj || // HTMLCollection/NodeList
    "item" in obj)
  );
}
function createArrayFromMixed$1(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}
var createArrayFromMixed_1 = createArrayFromMixed$1;
function makeEmptyFunction(arg) {
  return function() {
    return arg;
  };
}
var emptyFunction$2 = function emptyFunction2() {
};
emptyFunction$2.thatReturns = makeEmptyFunction;
emptyFunction$2.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction$2.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction$2.thatReturnsNull = makeEmptyFunction(null);
emptyFunction$2.thatReturnsThis = function() {
  return this;
};
emptyFunction$2.thatReturnsArgument = function(arg) {
  return arg;
};
var emptyFunction_1 = emptyFunction$2;
var PhotosMimeType = PhotosMimeType_1;
var createArrayFromMixed = createArrayFromMixed_1;
var emptyFunction$1 = emptyFunction_1;
var CR_LF_REGEX = new RegExp("\r\n", "g");
var LF_ONLY = "\n";
var RICH_TEXT_TYPES = {
  "text/rtf": 1,
  "text/html": 1
};
function getFileFromDataTransfer(item) {
  if (item.kind == "file") {
    return item.getAsFile();
  }
}
var DataTransfer$2 = /* @__PURE__ */ function() {
  function DataTransfer2(data) {
    this.data = data;
    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }
  var _proto = DataTransfer2.prototype;
  _proto.isRichText = function isRichText() {
    if (this.getHTML() && this.getText()) {
      return true;
    }
    if (this.isImage()) {
      return false;
    }
    return this.types.some(function(type2) {
      return RICH_TEXT_TYPES[type2];
    });
  };
  _proto.getText = function getText() {
    var text;
    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData("Text");
      } else if (this.types.indexOf("text/plain") != -1) {
        text = this.data.getData("text/plain");
      }
    }
    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };
  _proto.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData("Text");
      } else if (this.types.indexOf("text/html") != -1) {
        return this.data.getData("text/html");
      }
    }
  };
  _proto.isLink = function isLink() {
    return this.types.some(function(type2) {
      return type2.indexOf("Url") != -1 || type2.indexOf("text/uri-list") != -1 || type2.indexOf("text/x-moz-url");
    });
  };
  _proto.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf("text/x-moz-url") != -1) {
        var url = this.data.getData("text/x-moz-url").split("\n");
        return url[0];
      }
      return this.types.indexOf("text/uri-list") != -1 ? this.data.getData("text/uri-list") : this.data.getData("url");
    }
    return null;
  };
  _proto.isImage = function isImage2() {
    var isImage22 = this.types.some(function(type22) {
      return type22.indexOf("application/x-moz-file") != -1;
    });
    if (isImage22) {
      return true;
    }
    var items = this.getFiles();
    for (var i = 0; i < items.length; i++) {
      var type2 = items[i].type;
      if (!PhotosMimeType.isImage(type2)) {
        return false;
      }
    }
    return true;
  };
  _proto.getCount = function getCount() {
    if (this.data.hasOwnProperty("items")) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty("mozItemCount")) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }
    return null;
  };
  _proto.getFiles = function getFiles() {
    if (this.data.items) {
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction$1.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };
  _proto.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };
  return DataTransfer2;
}();
var DataTransfer_1 = DataTransfer$2;
var invariant$8 = invariant_1;
var TEXT_CLIPPING_REGEX = /\.textClipping$/;
var TEXT_TYPES = {
  "text/plain": true,
  "text/html": true,
  "text/rtf": true
};
var TEXT_SIZE_UPPER_BOUND = 5e3;
function getTextContentFromFiles$2(files2, callback) {
  var readCount = 0;
  var results2 = [];
  files2.forEach(function(file) {
    readFile(file, function(text) {
      readCount++;
      text && results2.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
      if (readCount == files2.length) {
        callback(results2.join("\r"));
      }
    });
  });
}
function readFile(file, callback) {
  if (!commonjsGlobal.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback("");
    return;
  }
  if (file.type === "") {
    var _contents = "";
    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      _contents = file.name.replace(TEXT_CLIPPING_REGEX, "");
    }
    callback(_contents);
    return;
  }
  var reader = new FileReader();
  reader.onload = function() {
    var result = reader.result;
    !(typeof result === "string") ? process.env.NODE_ENV !== "production" ? invariant$8(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant$8(false) : void 0;
    callback(result);
  };
  reader.onerror = function() {
    callback("");
  };
  reader.readAsText(file);
}
var getTextContentFromFiles_1 = getTextContentFromFiles$2;
function isEventHandled$4(value) {
  return value === "handled" || value === true;
}
var isEventHandled_1 = isEventHandled$4;
var DataTransfer$1 = DataTransfer_1;
var DraftModifier$b = DraftModifier_1;
var EditorState$m = EditorState_1;
var findAncestorOffsetKey$1 = findAncestorOffsetKey_1;
var getCorrectDocumentFromNode$1 = getCorrectDocumentFromNode_1;
var getTextContentFromFiles$1 = getTextContentFromFiles_1;
var getUpdatedSelectionState = getUpdatedSelectionState_1;
var getWindowForNode = getWindowForNode_1;
var isEventHandled$3 = isEventHandled_1;
var nullthrows$5 = nullthrows_1;
function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;
  var eventTargetDocument = getCorrectDocumentFromNode$1(event.currentTarget);
  if (typeof eventTargetDocument.caretRangeFromPoint === "function") {
    var dropRange = eventTargetDocument.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }
  node = nullthrows$5(node);
  offset = nullthrows$5(offset);
  var offsetKey = nullthrows$5(findAncestorOffsetKey$1(node));
  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}
var DraftEditorDragHandler$1 = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
    endDrag(editor);
  },
  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer$1(e.nativeEvent.dataTransfer);
    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
    e.preventDefault();
    editor._dragCount = 0;
    editor.exitCurrentMode();
    if (dropSelection == null) {
      return;
    }
    var files2 = data.getFiles();
    if (files2.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled$3(editor.props.handleDroppedFiles(dropSelection, files2))) {
        return;
      }
      getTextContentFromFiles$1(files2, function(fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }
    var dragType = editor._internalDrag ? "internal" : "external";
    if (editor.props.handleDrop && isEventHandled$3(editor.props.handleDrop(dropSelection, data, dragType)))
      ;
    else if (editor._internalDrag) {
      editor.update(moveText2(editorState, dropSelection));
    } else {
      editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
    }
    endDrag(editor);
  }
};
function endDrag(editor) {
  editor._internalDrag = false;
  var editorNode = editor.editorContainer;
  if (editorNode) {
    var mouseUpEvent = new MouseEvent("mouseup", {
      view: getWindowForNode(editorNode),
      bubbles: true,
      cancelable: true
    });
    editorNode.dispatchEvent(mouseUpEvent);
  }
}
function moveText2(editorState, targetSelection) {
  var newContentState = DraftModifier$b.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState$m.push(editorState, newContentState, "insert-fragment");
}
function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier$b.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState$m.push(editorState, newContentState, "insert-fragment");
}
var DraftEditorDragHandler_1 = DraftEditorDragHandler$1;
function isSelectionAtLeafStart$1(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();
  var isAtStart = false;
  blockTree.some(function(leafSet) {
    if (offset === leafSet.get("start")) {
      isAtStart = true;
      return true;
    }
    if (offset < leafSet.get("end")) {
      return leafSet.get("leaves").some(function(leaf) {
        var leafStart = leaf.get("start");
        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }
        return false;
      });
    }
    return false;
  });
  return isAtStart;
}
var isSelectionAtLeafStart_1 = isSelectionAtLeafStart$1;
(function(global2, undefined$1) {
  if (global2.setImmediate) {
    return;
  }
  var nextHandle = 1;
  var tasksByHandle = {};
  var currentlyRunningATask = false;
  var doc = global2.document;
  var registerImmediate;
  function setImmediate2(callback) {
    if (typeof callback !== "function") {
      callback = new Function("" + callback);
    }
    var args = new Array(arguments.length - 1);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i + 1];
    }
    var task = { callback, args };
    tasksByHandle[nextHandle] = task;
    registerImmediate(nextHandle);
    return nextHandle++;
  }
  function clearImmediate(handle) {
    delete tasksByHandle[handle];
  }
  function run(task) {
    var callback = task.callback;
    var args = task.args;
    switch (args.length) {
      case 0:
        callback();
        break;
      case 1:
        callback(args[0]);
        break;
      case 2:
        callback(args[0], args[1]);
        break;
      case 3:
        callback(args[0], args[1], args[2]);
        break;
      default:
        callback.apply(undefined$1, args);
        break;
    }
  }
  function runIfPresent(handle) {
    if (currentlyRunningATask) {
      setTimeout(runIfPresent, 0, handle);
    } else {
      var task = tasksByHandle[handle];
      if (task) {
        currentlyRunningATask = true;
        try {
          run(task);
        } finally {
          clearImmediate(handle);
          currentlyRunningATask = false;
        }
      }
    }
  }
  function installNextTickImplementation() {
    registerImmediate = function(handle) {
      process.nextTick(function() {
        runIfPresent(handle);
      });
    };
  }
  function canUsePostMessage() {
    if (global2.postMessage && !global2.importScripts) {
      var postMessageIsAsynchronous = true;
      var oldOnMessage = global2.onmessage;
      global2.onmessage = function() {
        postMessageIsAsynchronous = false;
      };
      global2.postMessage("", "*");
      global2.onmessage = oldOnMessage;
      return postMessageIsAsynchronous;
    }
  }
  function installPostMessageImplementation() {
    var messagePrefix = "setImmediate$" + Math.random() + "$";
    var onGlobalMessage = function(event) {
      if (event.source === global2 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
        runIfPresent(+event.data.slice(messagePrefix.length));
      }
    };
    if (global2.addEventListener) {
      global2.addEventListener("message", onGlobalMessage, false);
    } else {
      global2.attachEvent("onmessage", onGlobalMessage);
    }
    registerImmediate = function(handle) {
      global2.postMessage(messagePrefix + handle, "*");
    };
  }
  function installMessageChannelImplementation() {
    var channel = new MessageChannel();
    channel.port1.onmessage = function(event) {
      var handle = event.data;
      runIfPresent(handle);
    };
    registerImmediate = function(handle) {
      channel.port2.postMessage(handle);
    };
  }
  function installReadyStateChangeImplementation() {
    var html = doc.documentElement;
    registerImmediate = function(handle) {
      var script = doc.createElement("script");
      script.onreadystatechange = function() {
        runIfPresent(handle);
        script.onreadystatechange = null;
        html.removeChild(script);
        script = null;
      };
      html.appendChild(script);
    };
  }
  function installSetTimeoutImplementation() {
    registerImmediate = function(handle) {
      setTimeout(runIfPresent, 0, handle);
    };
  }
  var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global2);
  attachTo = attachTo && attachTo.setTimeout ? attachTo : global2;
  if ({}.toString.call(global2.process) === "[object process]") {
    installNextTickImplementation();
  } else if (canUsePostMessage()) {
    installPostMessageImplementation();
  } else if (global2.MessageChannel) {
    installMessageChannelImplementation();
  } else if (doc && "onreadystatechange" in doc.createElement("script")) {
    installReadyStateChangeImplementation();
  } else {
    installSetTimeoutImplementation();
  }
  attachTo.setImmediate = setImmediate2;
  attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof commonjsGlobal === "undefined" ? commonjsGlobal : commonjsGlobal : self);
var setImmediate$1 = commonjsGlobal.setImmediate;
var DraftModifier$a = DraftModifier_1;
var EditorState$l = EditorState_1;
var UserAgent$9 = UserAgent_1;
var getEntityKeyForSelection$1 = getEntityKeyForSelection_1;
var isEventHandled$2 = isEventHandled_1;
var isSelectionAtLeafStart = isSelectionAtLeafStart_1;
var nullthrows$4 = nullthrows_1;
var setImmediate = setImmediate$1;
var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = "/";
var isFirefox$1 = UserAgent$9.isBrowser("Firefox");
function mustPreventDefaultForCharacter(character) {
  return isFirefox$1 && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}
function replaceText2(editorState, text, inlineStyle, entityKey, forceSelection) {
  var contentState = DraftModifier$a.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState$l.push(editorState, contentState, "insert-characters", forceSelection);
}
function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== void 0) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = void 0;
  }
  var editorState = editor._latestEditorState;
  var chars = e.data;
  if (!chars) {
    return;
  }
  if (editor.props.handleBeforeInput && isEventHandled$2(editor.props.handleBeforeInput(chars, editorState, e.timeStamp))) {
    e.preventDefault();
    return;
  }
  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var anchorKey = selection.getAnchorKey();
  if (!selection.isCollapsed()) {
    e.preventDefault();
    editor.update(replaceText2(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection$1(editorState.getCurrentContent(), editorState.getSelection()), true));
    return;
  }
  var newEditorState = replaceText2(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection$1(editorState.getCurrentContent(), editorState.getSelection()), false);
  var mustPreventNative = false;
  if (!mustPreventNative) {
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }
  if (!mustPreventNative) {
    var oldBlockTree = editorState.getBlockTree(anchorKey);
    var newBlockTree = newEditorState.getBlockTree(anchorKey);
    mustPreventNative = oldBlockTree.size !== newBlockTree.size || oldBlockTree.zip(newBlockTree).some(function(_ref) {
      var oldLeafSet = _ref[0], newLeafSet = _ref[1];
      var oldStart = oldLeafSet.get("start");
      var adjustedStart = oldStart + (oldStart >= selectionStart ? chars.length : 0);
      var oldEnd = oldLeafSet.get("end");
      var adjustedEnd = oldEnd + (oldEnd >= selectionStart ? chars.length : 0);
      var newStart = newLeafSet.get("start");
      var newEnd = newLeafSet.get("end");
      var newDecoratorKey = newLeafSet.get("decoratorKey");
      return (
        // Different decorators
        oldLeafSet.get("decoratorKey") !== newDecoratorKey || // Different number of inline styles
        oldLeafSet.get("leaves").size !== newLeafSet.get("leaves").size || // Different effective decorator position
        adjustedStart !== newStart || adjustedEnd !== newEnd || // Decorator already existed and its length changed
        newDecoratorKey != null && newEnd - newStart !== oldEnd - oldStart
      );
    });
  }
  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }
  if (!mustPreventNative) {
    mustPreventNative = nullthrows$4(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows$4(editorState.getDirectionMap()).get(anchorKey);
  }
  if (mustPreventNative) {
    e.preventDefault();
    newEditorState = EditorState$l.set(newEditorState, {
      forceSelection: true
    });
    editor.update(newEditorState);
    return;
  }
  newEditorState = EditorState$l.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  });
  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function() {
    if (editor._pendingStateFromBeforeInput !== void 0) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = void 0;
    }
  });
}
var editOnBeforeInput_1 = editOnBeforeInput;
var EditorState$k = EditorState_1;
var containsNode = containsNode_1;
var getActiveElement = getActiveElement_1;
function editOnBlur(editor, e) {
  var ownerDocument = e.currentTarget.ownerDocument;
  if (
    // This ESLint rule conflicts with `sketchy-null-bool` flow check
    // eslint-disable-next-line no-extra-boolean-cast
    !Boolean(editor.props.preserveSelectionOnBlur) && getActiveElement(ownerDocument) === ownerDocument.body
  ) {
    var _selection = ownerDocument.defaultView.getSelection();
    var editorNode = editor.editor;
    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (!currentSelection.getHasFocus()) {
    return;
  }
  var selection = currentSelection.set("hasFocus", false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState$k.acceptSelection(editorState, selection));
}
var editOnBlur_1 = editOnBlur;
var EditorState$j = EditorState_1;
function editOnCompositionStart(editor, e) {
  editor.setMode("composite");
  editor.update(EditorState$j.set(editor._latestEditorState, {
    inCompositionMode: true
  }));
  editor._onCompositionStart(e);
}
var editOnCompositionStart_1 = editOnCompositionStart;
var getContentStateFragment$2 = getContentStateFragment_1;
function getFragmentFromSelection$2(editorState) {
  var selectionState = editorState.getSelection();
  if (selectionState.isCollapsed()) {
    return null;
  }
  return getContentStateFragment$2(editorState.getCurrentContent(), selectionState);
}
var getFragmentFromSelection_1 = getFragmentFromSelection$2;
var getFragmentFromSelection$1 = getFragmentFromSelection_1;
function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }
  editor.setClipboard(getFragmentFromSelection$1(editor._latestEditorState));
}
var editOnCopy_1 = editOnCopy;
function isInstanceOfNode(target) {
  if (!target || !("ownerDocument" in target)) {
    return false;
  }
  if ("ownerDocument" in target) {
    var node = target;
    if (!node.ownerDocument.defaultView) {
      return node instanceof Node;
    }
    if (node instanceof node.ownerDocument.defaultView.Node) {
      return true;
    }
  }
  return false;
}
var isInstanceOfNode_1 = isInstanceOfNode;
var DraftModifier$9 = DraftModifier_1;
var EditorState$i = EditorState_1;
var Style$1 = Style_1;
var getFragmentFromSelection = getFragmentFromSelection_1;
var getScrollPosition$1 = getScrollPosition_1;
var isNode = isInstanceOfNode_1;
function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition;
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }
  if (isNode(element)) {
    var node = element;
    scrollPosition = getScrollPosition$1(Style$1.getScrollParent(node));
  }
  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment);
  editor.setMode("cut");
  setTimeout(function() {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}
function removeFragment(editorState) {
  var newContent = DraftModifier$9.removeRange(editorState.getCurrentContent(), editorState.getSelection(), "forward");
  return EditorState$i.push(editorState, newContent, "remove-range");
}
var editOnCut_1 = editOnCut;
function editOnDragOver(editor, e) {
  editor.setMode("drag");
  e.preventDefault();
}
var editOnDragOver_1 = editOnDragOver;
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode("drag");
}
var editOnDragStart_1 = editOnDragStart;
var EditorState$h = EditorState_1;
var UserAgent$8 = UserAgent_1;
function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (currentSelection.getHasFocus()) {
    return;
  }
  var selection = currentSelection.set("hasFocus", true);
  editor.props.onFocus && editor.props.onFocus(e);
  if (UserAgent$8.isBrowser("Chrome < 60.0.3081.0")) {
    editor.update(EditorState$h.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState$h.acceptSelection(editorState, selection));
  }
}
var editOnFocus_1 = editOnFocus;
var invariant$7 = invariant_1;
var SURROGATE_HIGH_START = 55296;
var SURROGATE_HIGH_END = 56319;
var SURROGATE_LOW_START = 56320;
var SURROGATE_LOW_END = 57343;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}
function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ? process.env.NODE_ENV !== "production" ? invariant$7(false, "isSurrogatePair: Invalid index %s for string length %s.", index, str.length) : invariant$7(false) : void 0;
  if (index + 1 === str.length) {
    return false;
  }
  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}
function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}
function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}
function strlen$1(str) {
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }
  var len = 0;
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }
  return len;
}
function substr$2(str, start, length) {
  start = start || 0;
  length = length === void 0 ? Infinity : length || 0;
  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  }
  var size = str.length;
  if (size <= 0 || start > size || length <= 0) {
    return "";
  }
  var posA = 0;
  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }
    if (posA >= size) {
      return "";
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }
    if (posA < 0) {
      posA = 0;
    }
  }
  var posB = size;
  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }
  return str.substring(posA, posB);
}
function substring(str, start, end) {
  start = start || 0;
  end = end === void 0 ? Infinity : end || 0;
  if (start < 0) {
    start = 0;
  }
  if (end < 0) {
    end = 0;
  }
  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr$2(str, start, length);
}
function getCodePoints(str) {
  var codePoints = [];
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }
  return codePoints;
}
var UnicodeUtils$7 = {
  getCodePoints,
  getUTF16Length,
  hasSurrogateUnit,
  isCodeUnitInSurrogateRange,
  isSurrogatePair,
  strlen: strlen$1,
  substring,
  substr: substr$2
};
var UnicodeUtils_1 = UnicodeUtils$7;
var emptyFunction = emptyFunction_1;
function printWarning(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var argIndex = 0;
  var message = "Warning: " + format.replace(/%s/g, function() {
    return args[argIndex++];
  });
  if (typeof console !== "undefined") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (x) {
  }
}
var warning$3 = process.env.NODE_ENV !== "production" ? function(condition, format) {
  if (format === void 0) {
    throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
  }
  if (!condition) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }
    printWarning.apply(void 0, [format].concat(args));
  }
} : emptyFunction;
var warning_1 = warning$3;
var warning$2 = warning_1;
function moveSelectionBackward$3(editorState, maxDistance) {
  var selection = editorState.getSelection();
  process.env.NODE_ENV !== "production" ? warning$2(selection.isCollapsed(), "moveSelectionBackward should only be called with a collapsed SelectionState") : void 0;
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var focusKey = key;
  var focusOffset = 0;
  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);
    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }
  return selection.merge({
    focusKey,
    focusOffset,
    isBackward: true
  });
}
var moveSelectionBackward_1 = moveSelectionBackward$3;
var DraftModifier$8 = DraftModifier_1;
var gkx$4 = gkx$8;
var experimentalTreeDataSupport$3 = gkx$4("draft_tree_data_support");
function removeTextWithStrategy$5(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  var anchorKey = selection.getAnchorKey();
  var focusKey = selection.getFocusKey();
  var anchorBlock = content.getBlockForKey(anchorKey);
  if (experimentalTreeDataSupport$3) {
    if (direction === "forward") {
      if (anchorKey !== focusKey) {
        return content;
      }
    }
  }
  if (selection.isCollapsed()) {
    if (direction === "forward") {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }
      if (experimentalTreeDataSupport$3) {
        var isAtEndOfBlock = selection.getAnchorOffset() === content.getBlockForKey(anchorKey).getLength();
        if (isAtEndOfBlock) {
          var anchorBlockSibling = content.getBlockForKey(anchorBlock.nextSibling);
          if (!anchorBlockSibling || anchorBlockSibling.getLength() === 0) {
            return content;
          }
        }
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }
    target = strategy(editorState);
    if (target === selection) {
      return content;
    }
  }
  return DraftModifier$8.removeRange(content, target, direction);
}
var removeTextWithStrategy_1 = removeTextWithStrategy$5;
var EditorState$g = EditorState_1;
var UnicodeUtils$6 = UnicodeUtils_1;
var moveSelectionBackward$2 = moveSelectionBackward_1;
var removeTextWithStrategy$4 = removeTextWithStrategy_1;
function keyCommandPlainBackspace$2(editorState) {
  var afterRemoval = removeTextWithStrategy$4(editorState, function(strategyState) {
    var selection2 = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection2.getAnchorKey();
    var offset = selection2.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward$2(strategyState, charBehind ? UnicodeUtils$6.getUTF16Length(charBehind, 0) : 1);
  }, "backward");
  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }
  var selection = editorState.getSelection();
  return EditorState$g.push(editorState, afterRemoval.set("selectionBefore", selection), selection.isCollapsed() ? "backspace-character" : "remove-range");
}
var keyCommandPlainBackspace_1 = keyCommandPlainBackspace$2;
var DraftModifier$7 = DraftModifier_1;
var DraftOffsetKey = DraftOffsetKey_1;
var EditorState$f = EditorState_1;
var UserAgent$7 = UserAgent_1;
var _require$3 = draftKeyUtils, notEmptyKey = _require$3.notEmptyKey;
var findAncestorOffsetKey = findAncestorOffsetKey_1;
var keyCommandPlainBackspace$1 = keyCommandPlainBackspace_1;
var nullthrows$3 = nullthrows_1;
var isGecko = UserAgent$7.isEngine("Gecko");
var DOUBLE_NEWLINE = "\n\n";
function onInputType(inputType, editorState) {
  switch (inputType) {
    case "deleteContentBackward":
      return keyCommandPlainBackspace$1(editorState);
  }
  return editorState;
}
function editOnInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== void 0) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = void 0;
  }
  var castedEditorElement = editor.editor;
  var domSelection = castedEditorElement.ownerDocument.defaultView.getSelection();
  var anchorNode = domSelection.anchorNode, isCollapsed = domSelection.isCollapsed;
  var isNotTextOrElementNode = (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.TEXT_NODE && (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.ELEMENT_NODE;
  if (anchorNode == null || isNotTextOrElementNode) {
    return;
  }
  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    var span = anchorNode.parentNode;
    if (span == null) {
      return;
    }
    anchorNode.nodeValue = span.textContent;
    for (var child = span.firstChild; child != null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }
  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows$3(findAncestorOffsetKey(anchorNode));
  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey), blockKey = _DraftOffsetKey$decod.blockKey, decoratorKey = _DraftOffsetKey$decod.decoratorKey, leafKey = _DraftOffsetKey$decod.leafKey;
  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, "leaves", leafKey]), start = _editorState$getBlock.start, end = _editorState$getBlock.end;
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end);
  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  }
  if (domText === modelText) {
    var inputType = e.nativeEvent.inputType;
    if (inputType) {
      var newEditorState = onInputType(inputType, editorState);
      if (newEditorState !== editorState) {
        editor.restoreEditorDOM();
        editor.update(newEditorState);
        return;
      }
    }
    return;
  }
  var selection = editorState.getSelection();
  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });
  var entityKey = block.getEntityAt(start);
  var entity = notEmptyKey(entityKey) ? content.getEntity(entityKey) : null;
  var entityType = entity != null ? entity.getMutability() : null;
  var preserveEntity = entityType === "MUTABLE";
  var changeType = preserveEntity ? "spellcheck-change" : "apply-entity";
  var newContent = DraftModifier$7.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
  var anchorOffset, focusOffset, startOffset, endOffset;
  if (isGecko) {
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();
    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  }
  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({
      anchorOffset,
      focusOffset
    })
  });
  editor.update(EditorState$f.push(editorState, contentWithAdjustedDOMSelection, changeType));
}
var editOnInput_1 = editOnInput;
var Keys$2 = Keys$4;
function isSoftNewlineEvent$1(e) {
  return e.which === Keys$2.RETURN && (e.getModifierState("Shift") || e.getModifierState("Alt") || e.getModifierState("Control"));
}
var isSoftNewlineEvent_1 = isSoftNewlineEvent$1;
var UserAgent$6 = UserAgent_1;
var isSoftNewlineEvent = isSoftNewlineEvent_1;
var isOSX$1 = UserAgent$6.isPlatform("Mac OS X");
var KeyBindingUtil$3 = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },
  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX$1 && e.altKey;
  },
  usesMacOSHeuristics: function usesMacOSHeuristics() {
    return isOSX$1;
  },
  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX$1 ? !!e.metaKey && !e.altKey : KeyBindingUtil$3.isCtrlKeyCommand(e);
  },
  isSoftNewlineEvent
};
var KeyBindingUtil_1 = KeyBindingUtil$3;
var DraftModifier$6 = DraftModifier_1;
var EditorState$e = EditorState_1;
var getContentStateFragment$1 = getContentStateFragment_1;
var nullthrows$2 = nullthrows_1;
var clipboard = null;
var SecondaryClipboard$1 = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;
    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();
      if (blockEnd === selection.getAnchorOffset()) {
        var keyAfter = content.getKeyAfter(anchorKey);
        if (keyAfter == null) {
          return editorState;
        }
        targetRange = selection.set("focusKey", keyAfter).set("focusOffset", 0);
      } else {
        targetRange = selection.set("focusOffset", blockEnd);
      }
    } else {
      targetRange = selection;
    }
    targetRange = nullthrows$2(targetRange);
    clipboard = getContentStateFragment$1(content, targetRange);
    var afterRemoval = DraftModifier$6.removeRange(content, targetRange, "forward");
    if (afterRemoval === content) {
      return editorState;
    }
    return EditorState$e.push(editorState, afterRemoval, "remove-range");
  },
  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }
    var newContent = DraftModifier$6.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
    return EditorState$e.push(editorState, newContent, "insert-fragment");
  }
};
var SecondaryClipboard_1 = SecondaryClipboard$1;
var UserAgent$5 = UserAgent_1;
var invariant$6 = invariant_1;
var isChrome$2 = UserAgent$5.isBrowser("Chrome");
function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];
  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    var atCommonAncestor = ancestor === range.commonAncestorContainer;
    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }
    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);
    if (atCommonAncestor) {
      var _ref;
      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }
    tempRange.setEndBefore(ancestor);
  }
  process.env.NODE_ENV !== "production" ? invariant$6(false, "Found an unexpected detached subtree when getting range client rects.") : invariant$6(false);
}
var getRangeClientRects$2 = isChrome$2 ? getRangeClientRectsChrome : function(range) {
  return Array.from(range.getClientRects());
};
var getRangeClientRects_1 = getRangeClientRects$2;
var UnicodeUtils$5 = UnicodeUtils_1;
var getCorrectDocumentFromNode = getCorrectDocumentFromNode_1;
var getRangeClientRects$1 = getRangeClientRects_1;
var invariant$5 = invariant_1;
function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var correctDocument = getCorrectDocumentFromNode(element);
  var div = correctDocument.createElement("div");
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = "absolute";
  div.textContent = "M";
  var documentBody = correctDocument.body;
  !documentBody ? process.env.NODE_ENV !== "production" ? invariant$5(false, "Missing document.body") : invariant$5(false) : void 0;
  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);
  return rect.height;
}
function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;
  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];
    if (rect.width === 0 || rect.width === 1) {
      continue;
    }
    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }
  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}
function getNodeLength(node) {
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;
    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;
    default:
      return node.childNodes.length;
  }
}
function expandRangeToStartOfLine$1(range) {
  !range.collapsed ? process.env.NODE_ENV !== "production" ? invariant$5(false, "expandRangeToStartOfLine: Provided range is not collapsed.") : invariant$5(false) : void 0;
  range = range.cloneRange();
  var containingElement = range.startContainer;
  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }
  var lineHeight = getLineHeightPx(containingElement);
  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);
  while (areRectsOnOneLine(getRangeClientRects$1(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ? process.env.NODE_ENV !== "production" ? invariant$5(false, "Found unexpected detached subtree when traversing.") : invariant$5(false) : void 0;
    range.setStartBefore(bestContainer);
    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== "inline") {
      break;
    }
  }
  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;
  do {
    var nodeValue = currentContainer.nodeValue;
    var ii = maxIndexToConsider;
    for (; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils$5.isSurrogatePair(nodeValue, ii - 1)) {
        continue;
      }
      range.setStart(currentContainer, ii);
      if (areRectsOnOneLine(getRangeClientRects$1(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }
    if (ii === -1 || currentContainer.childNodes.length === 0) {
      break;
    }
    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);
  range.setStart(bestContainer, bestOffset);
  return range;
}
var expandRangeToStartOfLine_1 = expandRangeToStartOfLine$1;
var EditorState$d = EditorState_1;
var expandRangeToStartOfLine = expandRangeToStartOfLine_1;
var getDraftEditorSelectionWithNodes = getDraftEditorSelectionWithNodes_1;
var moveSelectionBackward$1 = moveSelectionBackward_1;
var removeTextWithStrategy$3 = removeTextWithStrategy_1;
function keyCommandBackspaceToStartOfLine$1(editorState, e) {
  var afterRemoval = removeTextWithStrategy$3(editorState, function(strategyState) {
    var selection = strategyState.getSelection();
    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward$1(strategyState, 1);
    }
    var ownerDocument = e.currentTarget.ownerDocument;
    var domSelection = ownerDocument.defaultView.getSelection();
    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);
    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, "backward");
  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }
  return EditorState$d.push(editorState, afterRemoval, "remove-range");
}
var keyCommandBackspaceToStartOfLine_1 = keyCommandBackspaceToStartOfLine$1;
var PUNCTUATION = `[.,+*?$|#{}()'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;・、。〈-】〔-〟：-？！-／［-｀｛-･⸮؟٪-٬؛،؍﴾﴿᠁।၊။‐-‧‰-⁞¡-±´-¸º»¿]`;
var TokenizeUtil$1 = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};
var TokenizeUtil = TokenizeUtil$1;
var punctuation = TokenizeUtil.getPunctuation();
var CHAMELEON_CHARS = "['‘’]";
var WHITESPACE_AND_PUNCTUATION = "\\s|(?![_])" + punctuation;
var DELETE_STRING = "^(?:" + WHITESPACE_AND_PUNCTUATION + ")*(?:" + CHAMELEON_CHARS + "|(?!" + WHITESPACE_AND_PUNCTUATION + ").)*(?:(?!" + WHITESPACE_AND_PUNCTUATION + ").)";
var DELETE_REGEX = new RegExp(DELETE_STRING);
var BACKSPACE_STRING = "(?:(?!" + WHITESPACE_AND_PUNCTUATION + ").)(?:" + CHAMELEON_CHARS + "|(?!" + WHITESPACE_AND_PUNCTUATION + ").)*(?:" + WHITESPACE_AND_PUNCTUATION + ")*$";
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}
var DraftRemovableWord$2 = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },
  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};
var DraftRemovableWord_1 = DraftRemovableWord$2;
var DraftRemovableWord$1 = DraftRemovableWord_1;
var EditorState$c = EditorState_1;
var moveSelectionBackward = moveSelectionBackward_1;
var removeTextWithStrategy$2 = removeTextWithStrategy_1;
function keyCommandBackspaceWord$1(editorState) {
  var afterRemoval = removeTextWithStrategy$2(editorState, function(strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord$1.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, "backward");
  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }
  return EditorState$c.push(editorState, afterRemoval, "remove-range");
}
var keyCommandBackspaceWord_1 = keyCommandBackspaceWord$1;
var warning$1 = warning_1;
function moveSelectionForward$2(editorState, maxDistance) {
  var selection = editorState.getSelection();
  process.env.NODE_ENV !== "production" ? warning$1(selection.isCollapsed(), "moveSelectionForward should only be called with a collapsed SelectionState") : void 0;
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();
  var focusKey = key;
  var focusOffset;
  var block = content.getBlockForKey(key);
  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }
  return selection.merge({
    focusKey,
    focusOffset
  });
}
var moveSelectionForward_1 = moveSelectionForward$2;
var DraftRemovableWord = DraftRemovableWord_1;
var EditorState$b = EditorState_1;
var moveSelectionForward$1 = moveSelectionForward_1;
var removeTextWithStrategy$1 = removeTextWithStrategy_1;
function keyCommandDeleteWord$1(editorState) {
  var afterRemoval = removeTextWithStrategy$1(editorState, function(strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text);
    return moveSelectionForward$1(strategyState, toRemove.length || 1);
  }, "forward");
  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }
  return EditorState$b.push(editorState, afterRemoval, "remove-range");
}
var keyCommandDeleteWord_1 = keyCommandDeleteWord$1;
var DraftModifier$5 = DraftModifier_1;
var EditorState$a = EditorState_1;
function keyCommandInsertNewline$1(editorState) {
  var contentState = DraftModifier$5.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState$a.push(editorState, contentState, "split-block");
}
var keyCommandInsertNewline_1 = keyCommandInsertNewline$1;
var EditorState$9 = EditorState_1;
function keyCommandMoveSelectionToEndOfBlock$1(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState$9.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}
var keyCommandMoveSelectionToEndOfBlock_1 = keyCommandMoveSelectionToEndOfBlock$1;
var EditorState$8 = EditorState_1;
function keyCommandMoveSelectionToStartOfBlock$1(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState$8.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}
var keyCommandMoveSelectionToStartOfBlock_1 = keyCommandMoveSelectionToStartOfBlock$1;
var EditorState$7 = EditorState_1;
var UnicodeUtils$4 = UnicodeUtils_1;
var moveSelectionForward = moveSelectionForward_1;
var removeTextWithStrategy = removeTextWithStrategy_1;
function keyCommandPlainDelete$1(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function(strategyState) {
    var selection2 = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection2.getAnchorKey();
    var offset = selection2.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils$4.getUTF16Length(charAhead, 0) : 1);
  }, "forward");
  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }
  var selection = editorState.getSelection();
  return EditorState$7.push(editorState, afterRemoval.set("selectionBefore", selection), selection.isCollapsed() ? "delete-character" : "remove-range");
}
var keyCommandPlainDelete_1 = keyCommandPlainDelete$1;
var DraftModifier$4 = DraftModifier_1;
var EditorState$6 = EditorState_1;
var getContentStateFragment = getContentStateFragment_1;
function keyCommandTransposeCharacters$1(editorState) {
  var selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    return editorState;
  }
  var offset = selection.getAnchorOffset();
  if (offset === 0) {
    return editorState;
  }
  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength();
  if (length <= 1) {
    return editorState;
  }
  var removalRange;
  var finalSelection;
  if (offset === length) {
    removalRange = selection.set("anchorOffset", offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set("focusOffset", offset + 1);
    finalSelection = removalRange.set("anchorOffset", offset + 1);
  }
  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier$4.removeRange(content, removalRange, "backward");
  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });
  var afterInsert = DraftModifier$4.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  var newEditorState = EditorState$6.push(editorState, afterInsert, "insert-fragment");
  return EditorState$6.acceptSelection(newEditorState, finalSelection);
}
var keyCommandTransposeCharacters_1 = keyCommandTransposeCharacters$1;
var EditorState$5 = EditorState_1;
function keyCommandUndo$1(e, editorState, updateFn) {
  var undoneState = EditorState$5.undo(editorState);
  if (editorState.getLastChangeType() === "spellcheck-change") {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState$5.set(undoneState, {
      nativelyRenderedContent
    }));
    return;
  }
  e.preventDefault();
  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  }
  updateFn(EditorState$5.set(editorState, {
    nativelyRenderedContent: null
  }));
  setTimeout(function() {
    updateFn(undoneState);
  }, 0);
}
var keyCommandUndo_1 = keyCommandUndo$1;
var DraftModifier$3 = DraftModifier_1;
var EditorState$4 = EditorState_1;
var KeyBindingUtil$2 = KeyBindingUtil_1;
var Keys$1 = Keys$4;
var SecondaryClipboard = SecondaryClipboard_1;
var UserAgent$4 = UserAgent_1;
var isEventHandled$1 = isEventHandled_1;
var keyCommandBackspaceToStartOfLine = keyCommandBackspaceToStartOfLine_1;
var keyCommandBackspaceWord = keyCommandBackspaceWord_1;
var keyCommandDeleteWord = keyCommandDeleteWord_1;
var keyCommandInsertNewline = keyCommandInsertNewline_1;
var keyCommandMoveSelectionToEndOfBlock = keyCommandMoveSelectionToEndOfBlock_1;
var keyCommandMoveSelectionToStartOfBlock = keyCommandMoveSelectionToStartOfBlock_1;
var keyCommandPlainBackspace = keyCommandPlainBackspace_1;
var keyCommandPlainDelete = keyCommandPlainDelete_1;
var keyCommandTransposeCharacters = keyCommandTransposeCharacters_1;
var keyCommandUndo = keyCommandUndo_1;
var isOptionKeyCommand2 = KeyBindingUtil$2.isOptionKeyCommand;
var isChrome$1 = UserAgent$4.isBrowser("Chrome");
function onKeyCommand(command, editorState, e) {
  switch (command) {
    case "redo":
      return EditorState$4.redo(editorState);
    case "delete":
      return keyCommandPlainDelete(editorState);
    case "delete-word":
      return keyCommandDeleteWord(editorState);
    case "backspace":
      return keyCommandPlainBackspace(editorState);
    case "backspace-word":
      return keyCommandBackspaceWord(editorState);
    case "backspace-to-start-of-line":
      return keyCommandBackspaceToStartOfLine(editorState, e);
    case "split-block":
      return keyCommandInsertNewline(editorState);
    case "transpose-characters":
      return keyCommandTransposeCharacters(editorState);
    case "move-selection-to-start-of-block":
      return keyCommandMoveSelectionToStartOfBlock(editorState);
    case "move-selection-to-end-of-block":
      return keyCommandMoveSelectionToEndOfBlock(editorState);
    case "secondary-cut":
      return SecondaryClipboard.cut(editorState);
    case "secondary-paste":
      return SecondaryClipboard.paste(editorState);
    default:
      return editorState;
  }
}
function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;
  function callDeprecatedHandler(handlerName) {
    var deprecatedHandler = editor.props[handlerName];
    if (deprecatedHandler) {
      deprecatedHandler(e);
      return true;
    } else {
      return false;
    }
  }
  switch (keyCode) {
    case Keys$1.RETURN:
      e.preventDefault();
      if (editor.props.handleReturn && isEventHandled$1(editor.props.handleReturn(e, editorState))) {
        return;
      }
      break;
    case Keys$1.ESC:
      e.preventDefault();
      if (callDeprecatedHandler("onEscape")) {
        return;
      }
      break;
    case Keys$1.TAB:
      if (callDeprecatedHandler("onTab")) {
        return;
      }
      break;
    case Keys$1.UP:
      if (callDeprecatedHandler("onUpArrow")) {
        return;
      }
      break;
    case Keys$1.RIGHT:
      if (callDeprecatedHandler("onRightArrow")) {
        return;
      }
      break;
    case Keys$1.DOWN:
      if (callDeprecatedHandler("onDownArrow")) {
        return;
      }
      break;
    case Keys$1.LEFT:
      if (callDeprecatedHandler("onLeftArrow")) {
        return;
      }
      break;
    case Keys$1.SPACE:
      if (isChrome$1 && isOptionKeyCommand2(e)) {
        e.preventDefault();
      }
  }
  var command = editor.props.keyBindingFn(e);
  if (command == null || command === "") {
    if (keyCode === Keys$1.SPACE && isChrome$1 && isOptionKeyCommand2(e)) {
      var contentState = DraftModifier$3.replaceText(editorState.getCurrentContent(), editorState.getSelection(), " ");
      editor.update(EditorState$4.push(editorState, contentState, "insert-characters"));
    }
    return;
  }
  if (command === "undo") {
    keyCommandUndo(e, editorState, editor.update);
    return;
  }
  e.preventDefault();
  if (editor.props.handleKeyCommand && isEventHandled$1(editor.props.handleKeyCommand(command, editorState, e.timeStamp))) {
    return;
  }
  var newState = onKeyCommand(command, editorState, e);
  if (newState !== editorState) {
    editor.update(newState);
  }
}
var editOnKeyDown_1 = editOnKeyDown;
function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var URI$1 = /* @__PURE__ */ function() {
  function URI2(uri) {
    _defineProperty$8(this, "_uri", void 0);
    this._uri = uri;
  }
  var _proto = URI2.prototype;
  _proto.toString = function toString() {
    return this._uri;
  };
  return URI2;
}();
var URI_1 = URI$1;
var UserAgent$3 = UserAgent_1;
var invariant$4 = invariant_1;
var isOldIE = UserAgent$3.isBrowser("IE <= 9");
function getSafeBodyFromHTML$2(html) {
  var doc;
  var root2 = null;
  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument("foo");
    !doc.documentElement ? process.env.NODE_ENV !== "production" ? invariant$4(false, "Missing doc.documentElement") : invariant$4(false) : void 0;
    doc.documentElement.innerHTML = html;
    root2 = doc.getElementsByTagName("body")[0];
  }
  return root2;
}
var getSafeBodyFromHTML_1 = getSafeBodyFromHTML$2;
var isElement$1 = isElement_1;
function isHTMLAnchorElement$1(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }
  return isElement$1(node) && node.nodeName === "A";
}
var isHTMLAnchorElement_1 = isHTMLAnchorElement$1;
var isElement = isElement_1;
function isHTMLImageElement$1(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }
  return isElement(node) && node.nodeName === "IMG";
}
var isHTMLImageElement_1 = isHTMLImageElement$1;
var _knownListItemDepthCl;
function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$7(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var CharacterMetadata$3 = CharacterMetadata_1;
var ContentBlock$4 = ContentBlock_1;
var ContentBlockNode$3 = ContentBlockNode_1;
var DefaultDraftBlockRenderMap$2 = DefaultDraftBlockRenderMap_1;
var DraftEntity$2 = DraftEntity_1;
var URI = URI_1;
var cx$2 = cx_1;
var generateRandomKey$5 = generateRandomKey_1;
var getSafeBodyFromHTML$1 = getSafeBodyFromHTML_1;
var gkx$3 = gkx$8;
var _require$2 = immutableExports, List$3 = _require$2.List, Map$2 = _require$2.Map, OrderedSet$1 = _require$2.OrderedSet;
var isHTMLAnchorElement = isHTMLAnchorElement_1;
var isHTMLBRElement = isHTMLBRElement_1;
var isHTMLElement$1 = isHTMLElement_1;
var isHTMLImageElement = isHTMLImageElement_1;
var experimentalTreeDataSupport$2 = gkx$3("draft_tree_data_support");
var NBSP = "&nbsp;";
var SPACE = " ";
var REGEX_CR = new RegExp("\r", "g");
var REGEX_LF = new RegExp("\n", "g");
var REGEX_LEADING_LF = new RegExp("^\n", "g");
var REGEX_NBSP = new RegExp(NBSP, "g");
var REGEX_CARRIAGE = new RegExp("&#13;?", "g");
var REGEX_ZWS = new RegExp("&#8203;?", "g");
var boldValues = ["bold", "bolder", "500", "600", "700", "800", "900"];
var notBoldValues = ["light", "lighter", "normal", "100", "200", "300", "400"];
var anchorAttr = ["className", "href", "rel", "target", "title"];
var imgAttr = ["alt", "className", "height", "src", "width"];
var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty$7(_knownListItemDepthCl, cx$2("public/DraftStyleDefault/depth0"), 0), _defineProperty$7(_knownListItemDepthCl, cx$2("public/DraftStyleDefault/depth1"), 1), _defineProperty$7(_knownListItemDepthCl, cx$2("public/DraftStyleDefault/depth2"), 2), _defineProperty$7(_knownListItemDepthCl, cx$2("public/DraftStyleDefault/depth3"), 3), _defineProperty$7(_knownListItemDepthCl, cx$2("public/DraftStyleDefault/depth4"), 4), _knownListItemDepthCl);
var HTMLTagToRawInlineStyleMap = Map$2({
  b: "BOLD",
  code: "CODE",
  del: "STRIKETHROUGH",
  em: "ITALIC",
  i: "ITALIC",
  s: "STRIKETHROUGH",
  strike: "STRIKETHROUGH",
  strong: "BOLD",
  u: "UNDERLINE",
  mark: "HIGHLIGHT"
});
var buildBlockTypeMap = function buildBlockTypeMap2(blockRenderMap) {
  var blockTypeMap = {};
  blockRenderMap.mapKeys(function(blockType, desc) {
    var elements = [desc.element];
    if (desc.aliasedElements !== void 0) {
      elements.push.apply(elements, desc.aliasedElements);
    }
    elements.forEach(function(element) {
      if (blockTypeMap[element] === void 0) {
        blockTypeMap[element] = blockType;
      } else if (typeof blockTypeMap[element] === "string") {
        blockTypeMap[element] = [blockTypeMap[element], blockType];
      } else {
        blockTypeMap[element].push(blockType);
      }
    });
  });
  return Map$2(blockTypeMap);
};
var detectInlineStyle = function detectInlineStyle2(node) {
  if (isHTMLElement$1(node)) {
    var element = node;
    if (element.style.fontFamily.includes("monospace")) {
      return "CODE";
    }
  }
  return null;
};
var getListItemDepth = function getListItemDepth2(node) {
  var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  Object.keys(knownListItemDepthClasses).some(function(depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};
var isValidAnchor = function isValidAnchor2(node) {
  if (!isHTMLAnchorElement(node)) {
    return false;
  }
  var anchorNode = node;
  if (!anchorNode.href || anchorNode.protocol !== "http:" && anchorNode.protocol !== "https:" && anchorNode.protocol !== "mailto:" && anchorNode.protocol !== "tel:") {
    return false;
  }
  try {
    var _ = new URI(anchorNode.href);
    return true;
  } catch (_2) {
    return false;
  }
};
var isValidImage = function isValidImage2(node) {
  if (!isHTMLImageElement(node)) {
    return false;
  }
  var imageNode = node;
  return !!(imageNode.attributes.getNamedItem("src") && imageNode.attributes.getNamedItem("src").value);
};
var styleFromNodeAttributes = function styleFromNodeAttributes2(node, style) {
  if (!isHTMLElement$1(node)) {
    return style;
  }
  var htmlElement = node;
  var fontWeight = htmlElement.style.fontWeight;
  var fontStyle = htmlElement.style.fontStyle;
  var textDecoration = htmlElement.style.textDecoration;
  return style.withMutations(function(style2) {
    if (boldValues.indexOf(fontWeight) >= 0) {
      style2.add("BOLD");
    } else if (notBoldValues.indexOf(fontWeight) >= 0) {
      style2.remove("BOLD");
    }
    if (fontStyle === "italic") {
      style2.add("ITALIC");
    } else if (fontStyle === "normal") {
      style2.remove("ITALIC");
    }
    if (textDecoration === "underline") {
      style2.add("UNDERLINE");
    }
    if (textDecoration === "line-through") {
      style2.add("STRIKETHROUGH");
    }
    if (textDecoration === "none") {
      style2.remove("UNDERLINE");
      style2.remove("STRIKETHROUGH");
    }
  });
};
var isListNode = function isListNode2(nodeName) {
  return nodeName === "ul" || nodeName === "ol";
};
var ContentBlocksBuilder = /* @__PURE__ */ function() {
  function ContentBlocksBuilder2(blockTypeMap, disambiguate) {
    _defineProperty$7(this, "characterList", List$3());
    _defineProperty$7(this, "currentBlockType", "unstyled");
    _defineProperty$7(this, "currentDepth", 0);
    _defineProperty$7(this, "currentEntity", null);
    _defineProperty$7(this, "currentText", "");
    _defineProperty$7(this, "wrapper", null);
    _defineProperty$7(this, "blockConfigs", []);
    _defineProperty$7(this, "contentBlocks", []);
    _defineProperty$7(this, "entityMap", DraftEntity$2);
    _defineProperty$7(this, "blockTypeMap", void 0);
    _defineProperty$7(this, "disambiguate", void 0);
    this.clear();
    this.blockTypeMap = blockTypeMap;
    this.disambiguate = disambiguate;
  }
  var _proto = ContentBlocksBuilder2.prototype;
  _proto.clear = function clear2() {
    this.characterList = List$3();
    this.blockConfigs = [];
    this.currentBlockType = "unstyled";
    this.currentDepth = 0;
    this.currentEntity = null;
    this.currentText = "";
    this.entityMap = DraftEntity$2;
    this.wrapper = null;
    this.contentBlocks = [];
  };
  _proto.addDOMNode = function addDOMNode(node) {
    var _this$blockConfigs;
    this.contentBlocks = [];
    this.currentDepth = 0;
    (_this$blockConfigs = this.blockConfigs).push.apply(_this$blockConfigs, this._toBlockConfigs([node], OrderedSet$1()));
    this._trimCurrentText();
    if (this.currentText !== "") {
      this.blockConfigs.push(this._makeBlockConfig());
    }
    return this;
  };
  _proto.getContentBlocks = function getContentBlocks() {
    if (this.contentBlocks.length === 0) {
      if (experimentalTreeDataSupport$2) {
        this._toContentBlocks(this.blockConfigs);
      } else {
        this._toFlatContentBlocks(this.blockConfigs);
      }
    }
    return {
      contentBlocks: this.contentBlocks,
      entityMap: this.entityMap
    };
  };
  _proto._makeBlockConfig = function _makeBlockConfig() {
    var config2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var key = config2.key || generateRandomKey$5();
    var block = _objectSpread$6({
      key,
      type: this.currentBlockType,
      text: this.currentText,
      characterList: this.characterList,
      depth: this.currentDepth,
      parent: null,
      children: List$3(),
      prevSibling: null,
      nextSibling: null,
      childConfigs: []
    }, config2);
    this.characterList = List$3();
    this.currentBlockType = "unstyled";
    this.currentText = "";
    return block;
  };
  _proto._toBlockConfigs = function _toBlockConfigs(nodes, style) {
    var blockConfigs = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var nodeName = node.nodeName.toLowerCase();
      if (nodeName === "body" || isListNode(nodeName)) {
        this._trimCurrentText();
        if (this.currentText !== "") {
          blockConfigs.push(this._makeBlockConfig());
        }
        var wasCurrentDepth = this.currentDepth;
        var wasWrapper = this.wrapper;
        if (isListNode(nodeName)) {
          this.wrapper = nodeName;
          if (isListNode(wasWrapper)) {
            this.currentDepth++;
          }
        }
        blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
        this.currentDepth = wasCurrentDepth;
        this.wrapper = wasWrapper;
        continue;
      }
      var blockType = this.blockTypeMap.get(nodeName);
      if (blockType !== void 0) {
        this._trimCurrentText();
        if (this.currentText !== "") {
          blockConfigs.push(this._makeBlockConfig());
        }
        var _wasCurrentDepth = this.currentDepth;
        var _wasWrapper = this.wrapper;
        this.wrapper = nodeName === "pre" ? "pre" : this.wrapper;
        if (typeof blockType !== "string") {
          blockType = this.disambiguate(nodeName, this.wrapper) || blockType[0] || "unstyled";
        }
        if (!experimentalTreeDataSupport$2 && isHTMLElement$1(node) && (blockType === "unordered-list-item" || blockType === "ordered-list-item")) {
          var htmlElement = node;
          this.currentDepth = getListItemDepth(htmlElement, this.currentDepth);
        }
        var key = generateRandomKey$5();
        var childConfigs = this._toBlockConfigs(Array.from(node.childNodes), style);
        this._trimCurrentText();
        blockConfigs.push(this._makeBlockConfig({
          key,
          childConfigs,
          type: blockType
        }));
        this.currentDepth = _wasCurrentDepth;
        this.wrapper = _wasWrapper;
        continue;
      }
      if (nodeName === "#text") {
        this._addTextNode(node, style);
        continue;
      }
      if (nodeName === "br") {
        this._addBreakNode(node, style);
        continue;
      }
      if (isValidImage(node)) {
        this._addImgNode(node, style);
        continue;
      }
      if (isValidAnchor(node)) {
        this._addAnchorNode(node, blockConfigs, style);
        continue;
      }
      var newStyle = style;
      if (HTMLTagToRawInlineStyleMap.has(nodeName)) {
        newStyle = newStyle.add(HTMLTagToRawInlineStyleMap.get(nodeName));
      }
      newStyle = styleFromNodeAttributes(node, newStyle);
      var inlineStyle = detectInlineStyle(node);
      if (inlineStyle != null) {
        newStyle = newStyle.add(inlineStyle);
      }
      blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), newStyle));
    }
    return blockConfigs;
  };
  _proto._appendText = function _appendText(text, style) {
    var _this$characterList;
    this.currentText += text;
    var characterMetadata = CharacterMetadata$3.create({
      style,
      entity: this.currentEntity
    });
    this.characterList = (_this$characterList = this.characterList).push.apply(_this$characterList, Array(text.length).fill(characterMetadata));
  };
  _proto._trimCurrentText = function _trimCurrentText() {
    var l = this.currentText.length;
    var begin = l - this.currentText.trimLeft().length;
    var end = this.currentText.trimRight().length;
    var entity = this.characterList.findEntry(function(characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    begin = entity !== void 0 ? Math.min(begin, entity[0]) : begin;
    entity = this.characterList.reverse().findEntry(function(characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    end = entity !== void 0 ? Math.max(end, l - entity[0]) : end;
    if (begin > end) {
      this.currentText = "";
      this.characterList = List$3();
    } else {
      this.currentText = this.currentText.slice(begin, end);
      this.characterList = this.characterList.slice(begin, end);
    }
  };
  _proto._addTextNode = function _addTextNode(node, style) {
    var text = node.textContent;
    var trimmedText = text.trim();
    if (trimmedText === "" && this.wrapper !== "pre") {
      text = " ";
    }
    if (this.wrapper !== "pre") {
      text = text.replace(REGEX_LEADING_LF, "");
      text = text.replace(REGEX_LF, SPACE);
    }
    this._appendText(text, style);
  };
  _proto._addBreakNode = function _addBreakNode(node, style) {
    if (!isHTMLBRElement(node)) {
      return;
    }
    this._appendText("\n", style);
  };
  _proto._addImgNode = function _addImgNode(node, style) {
    if (!isHTMLImageElement(node)) {
      return;
    }
    var image = node;
    var entityConfig = {};
    imgAttr.forEach(function(attr) {
      var imageAttribute = image.getAttribute(attr);
      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    });
    this.currentEntity = this.entityMap.__create("IMAGE", "IMMUTABLE", entityConfig);
    if (gkx$3("draftjs_fix_paste_for_img")) {
      if (image.getAttribute("role") !== "presentation") {
        this._appendText("📷", style);
      }
    } else {
      this._appendText("📷", style);
    }
    this.currentEntity = null;
  };
  _proto._addAnchorNode = function _addAnchorNode(node, blockConfigs, style) {
    if (!isHTMLAnchorElement(node)) {
      return;
    }
    var anchor = node;
    var entityConfig = {};
    anchorAttr.forEach(function(attr) {
      var anchorAttribute = anchor.getAttribute(attr);
      if (anchorAttribute) {
        entityConfig[attr] = anchorAttribute;
      }
    });
    entityConfig.url = new URI(anchor.href).toString();
    this.currentEntity = this.entityMap.__create("LINK", "MUTABLE", entityConfig || {});
    blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
    this.currentEntity = null;
  };
  _proto._toContentBlocks = function _toContentBlocks(blockConfigs) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var l = blockConfigs.length - 1;
    for (var i = 0; i <= l; i++) {
      var config2 = blockConfigs[i];
      config2.parent = parent;
      config2.prevSibling = i > 0 ? blockConfigs[i - 1].key : null;
      config2.nextSibling = i < l ? blockConfigs[i + 1].key : null;
      config2.children = List$3(config2.childConfigs.map(function(child) {
        return child.key;
      }));
      this.contentBlocks.push(new ContentBlockNode$3(_objectSpread$6({}, config2)));
      this._toContentBlocks(config2.childConfigs, config2.key);
    }
  };
  _proto._hoistContainersInBlockConfigs = function _hoistContainersInBlockConfigs(blockConfigs) {
    var _this = this;
    var hoisted = List$3(blockConfigs).flatMap(function(blockConfig) {
      if (blockConfig.type !== "unstyled" || blockConfig.text !== "") {
        return [blockConfig];
      }
      return _this._hoistContainersInBlockConfigs(blockConfig.childConfigs);
    });
    return hoisted;
  };
  _proto._toFlatContentBlocks = function _toFlatContentBlocks(blockConfigs) {
    var _this2 = this;
    var cleanConfigs = this._hoistContainersInBlockConfigs(blockConfigs);
    cleanConfigs.forEach(function(config2) {
      var _this2$_extractTextFr = _this2._extractTextFromBlockConfigs(config2.childConfigs), text = _this2$_extractTextFr.text, characterList = _this2$_extractTextFr.characterList;
      _this2.contentBlocks.push(new ContentBlock$4(_objectSpread$6({}, config2, {
        text: config2.text + text,
        characterList: config2.characterList.concat(characterList)
      })));
    });
  };
  _proto._extractTextFromBlockConfigs = function _extractTextFromBlockConfigs(blockConfigs) {
    var l = blockConfigs.length - 1;
    var text = "";
    var characterList = List$3();
    for (var i = 0; i <= l; i++) {
      var config2 = blockConfigs[i];
      text += config2.text;
      characterList = characterList.concat(config2.characterList);
      if (text !== "" && config2.type !== "unstyled") {
        text += "\n";
        characterList = characterList.push(characterList.last());
      }
      var children = this._extractTextFromBlockConfigs(config2.childConfigs);
      text += children.text;
      characterList = characterList.concat(children.characterList);
    }
    return {
      text,
      characterList
    };
  };
  return ContentBlocksBuilder2;
}();
var convertFromHTMLToContentBlocks$1 = function convertFromHTMLToContentBlocks2(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSafeBodyFromHTML$1;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DefaultDraftBlockRenderMap$2;
  html = html.trim().replace(REGEX_CR, "").replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, "").replace(REGEX_ZWS, "");
  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }
  var blockTypeMap = buildBlockTypeMap(blockRenderMap);
  var disambiguate = function disambiguate2(tag, wrapper) {
    if (tag === "li") {
      return wrapper === "ol" ? "ordered-list-item" : "unordered-list-item";
    }
    return null;
  };
  return new ContentBlocksBuilder(blockTypeMap, disambiguate).addDOMNode(safeBody).getContentBlocks();
};
var convertFromHTMLToContentBlocks_1 = convertFromHTMLToContentBlocks$1;
function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$6(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ContentBlock$3 = ContentBlock_1;
var ContentBlockNode$2 = ContentBlockNode_1;
var convertFromHTMLToContentBlocks = convertFromHTMLToContentBlocks_1;
var generateRandomKey$4 = generateRandomKey_1;
var getSafeBodyFromHTML = getSafeBodyFromHTML_1;
var gkx$2 = gkx$8;
var Immutable$2 = immutableExports;
var sanitizeDraftText = sanitizeDraftText_1;
var List$2 = Immutable$2.List, Repeat = Immutable$2.Repeat;
var experimentalTreeDataSupport$1 = gkx$2("draft_tree_data_support");
var ContentBlockRecord = experimentalTreeDataSupport$1 ? ContentBlockNode$2 : ContentBlock$3;
var DraftPasteProcessor$1 = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type2) {
    return textBlocks.reduce(function(acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey$4();
      var blockNodeConfig = {
        key,
        type: type2,
        text: textLine,
        characterList: List$2(Repeat(character, textLine.length))
      };
      if (experimentalTreeDataSupport$1 && index !== 0) {
        var prevSiblingIndex = index - 1;
        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _objectSpread$5({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }
      acc.push(new ContentBlockRecord(blockNodeConfig));
      return acc;
    }, []);
  }
};
var DraftPasteProcessor_1 = DraftPasteProcessor$1;
function adjustBlockDepthForContentState$1(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function(_, k) {
    return k === startKey;
  }).takeUntil(function(_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function(block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set("depth", depth);
  });
  blockMap = blockMap.merge(blocks);
  return contentState.merge({
    blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}
var adjustBlockDepthForContentState_1 = adjustBlockDepthForContentState$1;
var DraftModifier$2 = DraftModifier_1;
var EditorState$3 = EditorState_1;
var adjustBlockDepthForContentState = adjustBlockDepthForContentState_1;
var nullthrows$1 = nullthrows_1;
var RichTextEditorUtil$2 = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function(v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === "LINK";
    });
  },
  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },
  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return {
      url: uri.toString()
    };
  },
  handleKeyCommand: function handleKeyCommand(editorState, command, eventTimeStamp) {
    switch (command) {
      case "bold":
        return RichTextEditorUtil$2.toggleInlineStyle(editorState, "BOLD");
      case "italic":
        return RichTextEditorUtil$2.toggleInlineStyle(editorState, "ITALIC");
      case "underline":
        return RichTextEditorUtil$2.toggleInlineStyle(editorState, "UNDERLINE");
      case "code":
        return RichTextEditorUtil$2.toggleCode(editorState);
      case "backspace":
      case "backspace-word":
      case "backspace-to-start-of-line":
        return RichTextEditorUtil$2.onBackspace(editorState);
      case "delete":
      case "delete-word":
      case "delete-to-end-of-block":
        return RichTextEditorUtil$2.onDelete(editorState);
      default:
        return null;
    }
  },
  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier$2.insertText(editorState.getCurrentContent(), editorState.getSelection(), "\n", editorState.getCurrentInlineStyle(), null);
    var newEditorState = EditorState$3.push(editorState, contentState, "insert-characters");
    return EditorState$3.forceSelection(newEditorState, contentState.getSelectionAfter());
  },
  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    }
    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);
    if (blockBefore && blockBefore.getType() === "atomic") {
      var blockMap = content.getBlockMap()["delete"](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap,
        selectionAfter: selection
      });
      if (withoutAtomicBlock !== content) {
        return EditorState$3.push(editorState, withoutAtomicBlock, "remove-range");
      }
    }
    var withoutBlockStyle = RichTextEditorUtil$2.tryToRemoveBlockStyle(editorState);
    if (withoutBlockStyle) {
      return EditorState$3.push(editorState, withoutBlockStyle, "change-block-type");
    }
    return null;
  },
  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      return null;
    }
    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength();
    if (selection.getStartOffset() < length) {
      return null;
    }
    var blockAfter = content.getBlockAfter(startKey);
    if (!blockAfter || blockAfter.getType() !== "atomic") {
      return null;
    }
    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });
    var withoutAtomicBlock = DraftModifier$2.removeRange(content, atomicBlockTarget, "forward");
    if (withoutAtomicBlock !== content) {
      return EditorState$3.push(editorState, withoutAtomicBlock, "remove-range");
    }
    return null;
  },
  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();
    if (key !== selection.getFocusKey()) {
      return editorState;
    }
    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type2 = block.getType();
    if (type2 !== "unordered-list-item" && type2 !== "ordered-list-item") {
      return editorState;
    }
    event.preventDefault();
    var depth = block.getDepth();
    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }
    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
    return EditorState$3.push(editorState, withAdjustment, "adjust-depth");
  },
  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection;
    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows$1(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }
    var hasAtomicBlock = content.getBlockMap().skipWhile(function(_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function(_, k) {
      return k !== endKey;
    }).some(function(v) {
      return v.getType() === "atomic";
    });
    if (hasAtomicBlock) {
      return editorState;
    }
    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? "unstyled" : blockType;
    return EditorState$3.push(editorState, DraftModifier$2.setBlockType(content, target, typeToSet), "change-block-type");
  },
  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();
    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil$2.toggleBlockType(editorState, "code-block");
    }
    return RichTextEditorUtil$2.toggleInlineStyle(editorState, "CODE");
  },
  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle();
    if (selection.isCollapsed()) {
      return EditorState$3.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    }
    var content = editorState.getCurrentContent();
    var newContent;
    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier$2.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier$2.applyInlineStyle(content, selection, inlineStyle);
    }
    return EditorState$3.push(editorState, newContent, "change-inline-style");
  },
  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier$2.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
    return EditorState$3.push(editorState, withoutLink, "apply-entity");
  },
  /**
   * When a collapsed cursor is at the start of a styled block, changes block
   * type to 'unstyled'. Returns null if selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();
    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);
      var type2 = block.getType();
      var blockBefore = content.getBlockBefore(key);
      if (type2 === "code-block" && blockBefore && blockBefore.getType() === "code-block" && blockBefore.getLength() !== 0) {
        return null;
      }
      if (type2 !== "unstyled") {
        return DraftModifier$2.setBlockType(content, selection, "unstyled");
      }
    }
    return null;
  }
};
var RichTextEditorUtil_1 = RichTextEditorUtil$2;
var NEWLINE_REGEX = /\r\n?|\n/g;
function splitTextIntoTextBlocks$1(text) {
  return text.split(NEWLINE_REGEX);
}
var splitTextIntoTextBlocks_1 = splitTextIntoTextBlocks$1;
var BlockMapBuilder$1 = BlockMapBuilder_1;
var CharacterMetadata$2 = CharacterMetadata_1;
var DataTransfer = DataTransfer_1;
var DraftModifier$1 = DraftModifier_1;
var DraftPasteProcessor = DraftPasteProcessor_1;
var EditorState$2 = EditorState_1;
var RichTextEditorUtil$1 = RichTextEditorUtil_1;
var getEntityKeyForSelection = getEntityKeyForSelection_1;
var getTextContentFromFiles = getTextContentFromFiles_1;
var isEventHandled = isEventHandled_1;
var splitTextIntoTextBlocks = splitTextIntoTextBlocks_1;
function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData);
  if (!data.isRichText()) {
    var files2 = data.getFiles();
    var defaultFileText = data.getText();
    if (files2.length > 0) {
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files2))) {
        return;
      }
      getTextContentFromFiles(files2, function(fileText) {
        fileText = fileText || defaultFileText;
        if (!fileText) {
          return;
        }
        var editorState2 = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character2 = CharacterMetadata$2.create({
          style: editorState2.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState2.getCurrentContent(), editorState2.getSelection())
        });
        var currentBlockType2 = RichTextEditorUtil$1.getCurrentBlockType(editorState2);
        var text2 = DraftPasteProcessor.processText(blocks, character2, currentBlockType2);
        var fragment = BlockMapBuilder$1.createFromArray(text2);
        var withInsertedText = DraftModifier$1.replaceWithFragment(editorState2.getCurrentContent(), editorState2.getSelection(), fragment);
        editor.update(EditorState$2.push(editorState2, withInsertedText, "insert-fragment"));
      });
      return;
    }
  }
  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;
  if (editor.props.formatPastedText) {
    var _editor$props$formatP = editor.props.formatPastedText(text, html), formattedText = _editor$props$formatP.text, formattedHtml = _editor$props$formatP.html;
    text = formattedText;
    html = formattedHtml;
  }
  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }
  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }
  if (!editor.props.stripPastedStyles) {
    var internalClipboard = editor.getClipboard();
    if (!editor.props.formatPastedText && data.isRichText() && internalClipboard) {
      var _html;
      if (
        // If the editorKey is present in the pasted HTML, it should be safe to
        // assume this is an internal paste.
        ((_html = html) === null || _html === void 0 ? void 0 : _html.indexOf(editor.getEditorKey())) !== -1 || // The copy may have been made within a single block, in which case the
        // editor key won't be part of the paste. In this case, just check
        // whether the pasted text matches the internal clipboard.
        textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text
      ) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes("com.apple.webarchive") && !data.types.includes("text/html") && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    }
    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks, entityMap = htmlFragment.entityMap;
        if (contentBlocks) {
          var htmlMap = BlockMapBuilder$1.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    }
    editor.setClipboard(null);
  }
  if (textBlocks.length) {
    var character = CharacterMetadata$2.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });
    var currentBlockType = RichTextEditorUtil$1.getCurrentBlockType(editorState);
    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
    var textMap = BlockMapBuilder$1.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}
function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier$1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
  return EditorState$2.push(editorState, newContent.set("entityMap", entityMap), "insert-fragment");
}
function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function(block, ii) {
    return block.getText() === textBlocks[ii];
  });
}
var editOnPaste_1 = editOnPaste;
var UserAgent$2 = UserAgent_1;
var onBeforeInput = editOnBeforeInput_1;
var onBlur = editOnBlur_1;
var onCompositionStart2 = editOnCompositionStart_1;
var onCopy = editOnCopy_1;
var onCut = editOnCut_1;
var onDragOver = editOnDragOver_1;
var onDragStart = editOnDragStart_1;
var onFocus = editOnFocus_1;
var onInput = editOnInput_1;
var onKeyDown2 = editOnKeyDown_1;
var onPaste = editOnPaste_1;
var onSelect = editOnSelect_1;
var isChrome = UserAgent$2.isBrowser("Chrome");
var isFirefox = UserAgent$2.isBrowser("Firefox");
var selectionHandler = isChrome || isFirefox ? onSelect : function(e) {
};
var DraftEditorEditHandler$1 = {
  onBeforeInput,
  onBlur,
  onCompositionStart: onCompositionStart2,
  onCopy,
  onCut,
  onDragOver,
  onDragStart,
  onFocus,
  onInput,
  onKeyDown: onKeyDown2,
  onPaste,
  onSelect,
  // In certain cases, contenteditable on chrome does not fire the onSelect
  // event, causing problems with cursor positioning. Therefore, the selection
  // state update handler is added to more events to ensure that the selection
  // state is always synced with the actual cursor positions.
  onMouseUp: selectionHandler,
  onKeyUp: selectionHandler
};
var DraftEditorEditHandler_1 = DraftEditorEditHandler$1;
var ReactDOMComet = require$$2;
var flushControlled$1 = ReactDOMComet.unstable_flushControlled;
var DraftEditorFlushControlled = flushControlled$1;
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var React$2 = React__default;
var cx$1 = cx_1;
var DraftEditorPlaceholder$1 = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose$1(DraftEditorPlaceholder2, _React$Component);
  function DraftEditorPlaceholder2() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = DraftEditorPlaceholder2.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };
  _proto.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();
    var className = cx$1({
      "public/DraftEditorPlaceholder/root": true,
      "public/DraftEditorPlaceholder/hasFocus": hasFocus
    });
    var contentStyle = {
      whiteSpace: "pre-wrap"
    };
    return React$2.createElement("div", {
      className
    }, React$2.createElement("div", {
      className: cx$1("public/DraftEditorPlaceholder/inner"),
      id: this.props.accessibilityID,
      style: contentStyle
    }, this.props.text));
  };
  return DraftEditorPlaceholder2;
}(React$2.Component);
var DraftEditorPlaceholder_react = DraftEditorPlaceholder$1;
var KeyBindingUtil$1 = KeyBindingUtil_1;
var Keys = Keys$4;
var UserAgent$1 = UserAgent_1;
var isOSX = UserAgent$1.isPlatform("Mac OS X");
var shouldFixFirefoxMovement = isOSX && UserAgent$1.isBrowser("Firefox < 29");
var hasCommandModifier2 = KeyBindingUtil$1.hasCommandModifier, isCtrlKeyCommand2 = KeyBindingUtil$1.isCtrlKeyCommand;
function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand2(e);
}
function getZCommand(e) {
  if (!hasCommandModifier2(e)) {
    return null;
  }
  return e.shiftKey ? "redo" : "undo";
}
function getDeleteCommand(e) {
  if (!isOSX && e.shiftKey) {
    return null;
  }
  return shouldRemoveWord(e) ? "delete-word" : "delete";
}
function getBackspaceCommand(e) {
  if (hasCommandModifier2(e) && isOSX) {
    return "backspace-to-start-of-line";
  }
  return shouldRemoveWord(e) ? "backspace-word" : "backspace";
}
function getDefaultKeyBinding$2(e) {
  switch (e.keyCode) {
    case 66:
      return hasCommandModifier2(e) ? "bold" : null;
    case 68:
      return isCtrlKeyCommand2(e) ? "delete" : null;
    case 72:
      return isCtrlKeyCommand2(e) ? "backspace" : null;
    case 73:
      return hasCommandModifier2(e) ? "italic" : null;
    case 74:
      return hasCommandModifier2(e) ? "code" : null;
    case 75:
      return isOSX && isCtrlKeyCommand2(e) ? "secondary-cut" : null;
    case 77:
      return isCtrlKeyCommand2(e) ? "split-block" : null;
    case 79:
      return isCtrlKeyCommand2(e) ? "split-block" : null;
    case 84:
      return isOSX && isCtrlKeyCommand2(e) ? "transpose-characters" : null;
    case 85:
      return hasCommandModifier2(e) ? "underline" : null;
    case 87:
      return isOSX && isCtrlKeyCommand2(e) ? "backspace-word" : null;
    case 89:
      if (isCtrlKeyCommand2(e)) {
        return isOSX ? "secondary-paste" : "redo";
      }
      return null;
    case 90:
      return getZCommand(e) || null;
    case Keys.RETURN:
      return "split-block";
    case Keys.DELETE:
      return getDeleteCommand(e);
    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier2(e) ? "move-selection-to-start-of-block" : null;
    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier2(e) ? "move-selection-to-end-of-block" : null;
    default:
      return null;
  }
}
var getDefaultKeyBinding_1 = getDefaultKeyBinding$2;
var _assign = objectAssign;
function _extends$1() {
  _extends$1 = _assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$5(target, key, source[key]);
    });
  }
  return target;
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var DefaultDraftBlockRenderMap$1 = DefaultDraftBlockRenderMap_1;
var DefaultDraftInlineStyle$1 = DefaultDraftInlineStyle$2;
var DraftEditorCompositionHandler = DraftEditorCompositionHandler_1;
var DraftEditorContents = DraftEditorContents_react;
var DraftEditorDragHandler = DraftEditorDragHandler_1;
var DraftEditorEditHandler = DraftEditorEditHandler_1;
var flushControlled = DraftEditorFlushControlled;
var DraftEditorPlaceholder = DraftEditorPlaceholder_react;
var DraftEffects = DraftEffects$2;
var EditorState$1 = EditorState_1;
var React$1 = React__default;
var Scroll = Scroll_1;
var Style = Style_1;
var UserAgent = UserAgent_1;
var cx = cx_1;
var generateRandomKey$3 = generateRandomKey_1;
var getDefaultKeyBinding$1 = getDefaultKeyBinding_1;
var getScrollPosition = getScrollPosition_1;
var gkx$1 = gkx$8;
var invariant$3 = invariant_1;
var isHTMLElement = isHTMLElement_1;
var nullthrows = nullthrows_1;
var isIE = UserAgent.isBrowser("IE");
var allowSpellCheck = !isIE;
var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};
var didInitODS = false;
var UpdateDraftEditorFlags = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(UpdateDraftEditorFlags2, _React$Component);
  function UpdateDraftEditorFlags2() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = UpdateDraftEditorFlags2.prototype;
  _proto.render = function render() {
    return null;
  };
  _proto.componentDidMount = function componentDidMount() {
    this._update();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this._update();
  };
  _proto._update = function _update() {
    var editor = this.props.editor;
    editor._latestEditorState = this.props.editorState;
    editor._blockSelectEvents = true;
  };
  return UpdateDraftEditorFlags2;
}(React$1.Component);
var DraftEditor$1 = /* @__PURE__ */ function(_React$Component2) {
  _inheritsLoose(DraftEditor2, _React$Component2);
  function DraftEditor2(props) {
    var _this;
    _this = _React$Component2.call(this, props) || this;
    _defineProperty$5(_assertThisInitialized$1(_this), "_blockSelectEvents", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_clipboard", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_handler", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_dragCount", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_internalDrag", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_editorKey", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_placeholderAccessibilityID", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_latestEditorState", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_latestCommittedEditorState", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_pendingStateFromBeforeInput", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onBeforeInput", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onBlur", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onCharacterData", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onCompositionEnd", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onCompositionStart", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onCopy", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onCut", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onDragEnd", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onDragOver", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onDragStart", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onDrop", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onInput", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onFocus", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onKeyDown", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onKeyPress", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onKeyUp", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onMouseDown", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onMouseUp", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onPaste", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_onSelect", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "editor", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "editorContainer", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "focus", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "blur", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "setMode", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "exitCurrentMode", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "restoreEditorDOM", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "setClipboard", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "getClipboard", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "getEditorKey", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "update", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "onDragEnter", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "onDragLeave", void 0);
    _defineProperty$5(_assertThisInitialized$1(_this), "_handleEditorContainerRef", function(node) {
      _this.editorContainer = node;
      _this.editor = node !== null ? node.firstChild : null;
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "focus", function(scrollPosition) {
      var editorState = _this.props.editorState;
      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = _this.editor;
      if (!editorNode) {
        return;
      }
      var scrollParent = Style.getScrollParent(editorNode);
      var _ref = scrollPosition || getScrollPosition(scrollParent), x = _ref.x, y = _ref.y;
      !isHTMLElement(editorNode) ? process.env.NODE_ENV !== "production" ? invariant$3(false, "editorNode is not an HTMLElement") : invariant$3(false) : void 0;
      editorNode.focus();
      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      }
      if (!alreadyHasFocus) {
        _this.update(EditorState$1.forceSelection(editorState, editorState.getSelection()));
      }
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "blur", function() {
      var editorNode = _this.editor;
      if (!editorNode) {
        return;
      }
      !isHTMLElement(editorNode) ? process.env.NODE_ENV !== "production" ? invariant$3(false, "editorNode is not an HTMLElement") : invariant$3(false) : void 0;
      editorNode.blur();
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "setMode", function(mode) {
      var _this$props = _this.props, onPaste2 = _this$props.onPaste, onCut2 = _this$props.onCut, onCopy2 = _this$props.onCopy;
      var editHandler = _objectSpread$4({}, handlerMap.edit);
      if (onPaste2) {
        editHandler.onPaste = onPaste2;
      }
      if (onCut2) {
        editHandler.onCut = onCut2;
      }
      if (onCopy2) {
        editHandler.onCopy = onCopy2;
      }
      var handler = _objectSpread$4({}, handlerMap, {
        edit: editHandler
      });
      _this._handler = handler[mode];
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "exitCurrentMode", function() {
      _this.setMode("edit");
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "restoreEditorDOM", function(scrollPosition) {
      _this.setState({
        contentsKey: _this.state.contentsKey + 1
      }, function() {
        _this.focus(scrollPosition);
      });
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "setClipboard", function(clipboard2) {
      _this._clipboard = clipboard2;
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "getClipboard", function() {
      return _this._clipboard;
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "update", function(editorState) {
      _this._latestEditorState = editorState;
      _this.props.onChange(editorState);
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "onDragEnter", function() {
      _this._dragCount++;
    });
    _defineProperty$5(_assertThisInitialized$1(_this), "onDragLeave", function() {
      _this._dragCount--;
      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    });
    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey$3();
    _this._placeholderAccessibilityID = "placeholder-" + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;
    _this._onBeforeInput = _this._buildHandler("onBeforeInput");
    _this._onBlur = _this._buildHandler("onBlur");
    _this._onCharacterData = _this._buildHandler("onCharacterData");
    _this._onCompositionEnd = _this._buildHandler("onCompositionEnd");
    _this._onCompositionStart = _this._buildHandler("onCompositionStart");
    _this._onCopy = _this._buildHandler("onCopy");
    _this._onCut = _this._buildHandler("onCut");
    _this._onDragEnd = _this._buildHandler("onDragEnd");
    _this._onDragOver = _this._buildHandler("onDragOver");
    _this._onDragStart = _this._buildHandler("onDragStart");
    _this._onDrop = _this._buildHandler("onDrop");
    _this._onInput = _this._buildHandler("onInput");
    _this._onFocus = _this._buildHandler("onFocus");
    _this._onKeyDown = _this._buildHandler("onKeyDown");
    _this._onKeyPress = _this._buildHandler("onKeyPress");
    _this._onKeyUp = _this._buildHandler("onKeyUp");
    _this._onMouseDown = _this._buildHandler("onMouseDown");
    _this._onMouseUp = _this._buildHandler("onMouseUp");
    _this._onPaste = _this._buildHandler("onPaste");
    _this._onSelect = _this._buildHandler("onSelect");
    _this.getEditorKey = function() {
      return _this._editorKey;
    };
    if (process.env.NODE_ENV !== "production") {
      ["onDownArrow", "onEscape", "onLeftArrow", "onRightArrow", "onTab", "onUpArrow"].forEach(function(propName) {
        if (props.hasOwnProperty(propName)) {
          console.warn("Supplying an `".concat(propName, "` prop to `DraftEditor` has ") + "been deprecated. If your handler needs access to the keyboard event, supply a custom `keyBindingFn` prop that falls back to the default one (eg. https://is.gd/wHKQ3W).");
        }
      });
    }
    _this.state = {
      contentsKey: 0
    };
    return _this;
  }
  var _proto2 = DraftEditor2.prototype;
  _proto2._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;
    return function(e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];
        if (method) {
          if (flushControlled) {
            flushControlled(function() {
              return method(_this2, e);
            });
          } else {
            method(_this2, e);
          }
        }
      }
    };
  };
  _proto2._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };
  _proto2._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };
      return React$1.createElement(DraftEditorPlaceholder, placeHolderProps);
    }
    return null;
  };
  _proto2._renderARIADescribedBy = function _renderARIADescribedBy() {
    var describedBy = this.props.ariaDescribedBy || "";
    var placeholderID = this._showPlaceholder() ? this._placeholderAccessibilityID : "";
    return describedBy.replace("{{editor_id_placeholder}}", placeholderID) || void 0;
  };
  _proto2.render = function render() {
    var _this$props2 = this.props, blockRenderMap = _this$props2.blockRenderMap, blockRendererFn2 = _this$props2.blockRendererFn, blockStyleFn2 = _this$props2.blockStyleFn, customStyleFn = _this$props2.customStyleFn, customStyleMap = _this$props2.customStyleMap, editorState = _this$props2.editorState, preventScroll = _this$props2.preventScroll, readOnly = _this$props2.readOnly, textAlignment = _this$props2.textAlignment, textDirectionality = _this$props2.textDirectionality;
    var rootClass = cx({
      "DraftEditor/root": true,
      "DraftEditor/alignLeft": textAlignment === "left",
      "DraftEditor/alignRight": textAlignment === "right",
      "DraftEditor/alignCenter": textAlignment === "center"
    });
    var contentStyle = {
      outline: "none",
      // fix parent-draggable Safari bug. #1326
      userSelect: "text",
      WebkitUserSelect: "text",
      whiteSpace: "pre-wrap",
      wordWrap: "break-word"
    };
    var ariaRole = this.props.role || "textbox";
    var ariaExpanded = ariaRole === "combobox" ? !!this.props.ariaExpanded : null;
    var editorContentsProps = {
      blockRenderMap,
      blockRendererFn: blockRendererFn2,
      blockStyleFn: blockStyleFn2,
      customStyleMap: _objectSpread$4({}, DefaultDraftInlineStyle$1, customStyleMap),
      customStyleFn,
      editorKey: this._editorKey,
      editorState,
      preventScroll,
      textDirectionality
    };
    return React$1.createElement("div", {
      className: rootClass
    }, this._renderPlaceholder(), React$1.createElement("div", {
      className: cx("DraftEditor/editorContainer"),
      ref: this._handleEditorContainerRef
    }, React$1.createElement("div", {
      "aria-activedescendant": readOnly ? null : this.props.ariaActiveDescendantID,
      "aria-autocomplete": readOnly ? null : this.props.ariaAutoComplete,
      "aria-controls": readOnly ? null : this.props.ariaControls,
      "aria-describedby": this._renderARIADescribedBy(),
      "aria-expanded": readOnly ? null : ariaExpanded,
      "aria-label": this.props.ariaLabel,
      "aria-labelledby": this.props.ariaLabelledBy,
      "aria-multiline": this.props.ariaMultiline,
      "aria-owns": readOnly ? null : this.props.ariaOwneeID,
      autoCapitalize: this.props.autoCapitalize,
      autoComplete: this.props.autoComplete,
      autoCorrect: this.props.autoCorrect,
      className: cx({
        // Chrome's built-in translation feature mutates the DOM in ways
        // that Draft doesn't expect (ex: adding <font> tags inside
        // DraftEditorLeaf spans) and causes problems. We add notranslate
        // here which makes its autotranslation skip over this subtree.
        notranslate: !readOnly,
        "public/DraftEditor/content": true
      }),
      contentEditable: !readOnly,
      "data-testid": this.props.webDriverTestID,
      onBeforeInput: this._onBeforeInput,
      onBlur: this._onBlur,
      onCompositionEnd: this._onCompositionEnd,
      onCompositionStart: this._onCompositionStart,
      onCopy: this._onCopy,
      onCut: this._onCut,
      onDragEnd: this._onDragEnd,
      onDragEnter: this.onDragEnter,
      onDragLeave: this.onDragLeave,
      onDragOver: this._onDragOver,
      onDragStart: this._onDragStart,
      onDrop: this._onDrop,
      onFocus: this._onFocus,
      onInput: this._onInput,
      onKeyDown: this._onKeyDown,
      onKeyPress: this._onKeyPress,
      onKeyUp: this._onKeyUp,
      onMouseUp: this._onMouseUp,
      onPaste: this._onPaste,
      onSelect: this._onSelect,
      ref: this.props.editorRef,
      role: readOnly ? null : ariaRole,
      spellCheck: allowSpellCheck && this.props.spellCheck,
      style: contentStyle,
      suppressContentEditableWarning: true,
      tabIndex: this.props.tabIndex
    }, React$1.createElement(UpdateDraftEditorFlags, {
      editor: this,
      editorState
    }), React$1.createElement(DraftEditorContents, _extends$1({}, editorContentsProps, {
      key: "contents" + this.state.contentsKey
    })))));
  };
  _proto2.componentDidMount = function componentDidMount() {
    this._blockSelectEvents = false;
    if (!didInitODS && gkx$1("draft_ods_enabled")) {
      didInitODS = true;
      DraftEffects.initODS();
    }
    this.setMode("edit");
    if (isIE) {
      if (!this.editor) {
        commonjsGlobal.execCommand("AutoUrlDetect", false, false);
      } else {
        this.editor.ownerDocument.execCommand("AutoUrlDetect", false, false);
      }
    }
  };
  _proto2.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestEditorState = this.props.editorState;
    this._latestCommittedEditorState = this.props.editorState;
  };
  return DraftEditor2;
}(React$1.Component);
_defineProperty$5(DraftEditor$1, "defaultProps", {
  ariaDescribedBy: "{{editor_id_placeholder}}",
  blockRenderMap: DefaultDraftBlockRenderMap$1,
  blockRendererFn: function blockRendererFn() {
    return null;
  },
  blockStyleFn: function blockStyleFn() {
    return "";
  },
  keyBindingFn: getDefaultKeyBinding$1,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
});
var DraftEditor_react = DraftEditor$1;
var RawDraftContentState$1 = {};
var DraftStringKey$2 = {
  stringify: function stringify(key) {
    return "_" + String(key);
  },
  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};
var DraftStringKey_1 = DraftStringKey$2;
var DraftStringKey$1 = DraftStringKey_1;
var UnicodeUtils$3 = UnicodeUtils_1;
var strlen = UnicodeUtils$3.strlen;
function encodeEntityRanges$1(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function(character) {
    return !!character.getEntity();
  }, function(start, end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey$1.stringify(key)])
    });
  });
  return encoded;
}
var encodeEntityRanges_1 = encodeEntityRanges$1;
var UnicodeUtils$2 = UnicodeUtils_1;
var findRangesImmutable = findRangesImmutable_1;
var areEqual = function areEqual2(a, b) {
  return a === b;
};
var isTruthy = function isTruthy2(a) {
  return !!a;
};
var EMPTY_ARRAY = [];
function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = [];
  var filteredInlines = styleList.map(function(style) {
    return style.has(styleToEncode);
  }).toList();
  findRangesImmutable(
    filteredInlines,
    areEqual,
    // We only want to keep ranges with nonzero style values.
    isTruthy,
    function(start, end) {
      var text = block.getText();
      ranges.push({
        offset: UnicodeUtils$2.strlen(text.slice(0, start)),
        length: UnicodeUtils$2.strlen(text.slice(start, end)),
        style: styleToEncode
      });
    }
  );
  return ranges;
}
function encodeInlineStyleRanges$1(block) {
  var styleList = block.getCharacterList().map(function(c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function(style) {
    return getEncodedInlinesForType(block, styleList, style);
  });
  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}
var encodeInlineStyleRanges_1 = encodeInlineStyleRanges$1;
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ContentBlock$2 = ContentBlock_1;
var ContentBlockNode$1 = ContentBlockNode_1;
var DraftStringKey = DraftStringKey_1;
var encodeEntityRanges = encodeEntityRanges_1;
var encodeInlineStyleRanges = encodeInlineStyleRanges_1;
var invariant$2 = invariant_1;
var createRawBlock = function createRawBlock2(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};
var insertRawBlock = function insertRawBlock2(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock$2) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }
  !(block instanceof ContentBlockNode$1) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "block is not a BlockNode") : invariant$2(false) : void 0;
  var parentKey = block.getParentKey();
  var rawBlock = blockCacheRef[block.getKey()] = _objectSpread$3({}, createRawBlock(block, entityMap), {
    children: []
  });
  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }
  rawBlocks.push(rawBlock);
};
var encodeRawBlocks = function encodeRawBlocks2(contentState, rawState) {
  var entityMap = rawState.entityMap;
  var rawBlocks = [];
  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;
  contentState.getBlockMap().forEach(function(block) {
    block.findEntityRanges(function(character) {
      return character.getEntity() !== null;
    }, function(start) {
      var entityKey = block.getEntityAt(start);
      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }
      entityCacheRef[stringifiedEntityKey] = entityKey;
      entityMap[stringifiedEntityKey] = "".concat(entityStorageKey);
      entityStorageKey++;
    });
    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });
  return {
    blocks: rawBlocks,
    entityMap
  };
};
var encodeRawEntityMap = function encodeRawEntityMap2(contentState, rawState) {
  var blocks = rawState.blocks, entityMap = rawState.entityMap;
  var rawEntityMap = {};
  Object.keys(entityMap).forEach(function(key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });
  return {
    blocks,
    entityMap: rawEntityMap
  };
};
var convertFromDraftStateToRaw$1 = function convertFromDraftStateToRaw2(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  };
  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);
  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
  return rawDraftContentState;
};
var convertFromDraftStateToRaw_1 = convertFromDraftStateToRaw$1;
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var generateRandomKey$2 = generateRandomKey_1;
var invariant$1 = invariant_1;
var traverseInDepthOrder = function traverseInDepthOrder2(blocks, fn) {
  var stack = [].concat(blocks).reverse();
  while (stack.length) {
    var _block = stack.pop();
    fn(_block);
    var children = _block.children;
    !Array.isArray(children) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Invalid tree raw block") : invariant$1(false) : void 0;
    stack = stack.concat([].concat(children.reverse()));
  }
};
var isListBlock = function isListBlock2(block) {
  if (!(block && block.type)) {
    return false;
  }
  var type2 = block.type;
  return type2 === "unordered-list-item" || type2 === "ordered-list-item";
};
var addDepthToChildren = function addDepthToChildren2(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function(child) {
      return child.type === block.type ? _objectSpread$2({}, child, {
        depth: (block.depth || 0) + 1
      }) : child;
    });
  }
};
var DraftTreeAdapter$1 = {
  /**
   * Converts from a tree raw state back to draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;
    var transformedBlocks = [];
    !Array.isArray(blocks) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Invalid raw state") : invariant$1(false) : void 0;
    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }
    traverseInDepthOrder(blocks, function(block) {
      var newBlock = _objectSpread$2({}, block);
      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block);
        if (block.children != null && block.children.length > 0) {
          return;
        }
      }
      delete newBlock.children;
      transformedBlocks.push(newBlock);
    });
    draftTreeState.blocks = transformedBlocks;
    return _objectSpread$2({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },
  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var transformedBlocks = [];
    var parentStack = [];
    draftState.blocks.forEach(function(block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;
      var treeBlock = _objectSpread$2({}, block, {
        children: []
      });
      if (!isList) {
        transformedBlocks.push(treeBlock);
        return;
      }
      var lastParent = parentStack[0];
      if (lastParent == null && depth === 0) {
        transformedBlocks.push(treeBlock);
      } else if (lastParent == null || lastParent.depth < depth - 1) {
        var newParent = {
          key: generateRandomKey$2(),
          text: "",
          depth: depth - 1,
          type: block.type,
          children: [],
          entityRanges: [],
          inlineStyleRanges: []
        };
        parentStack.unshift(newParent);
        if (depth === 1) {
          transformedBlocks.push(newParent);
        } else if (lastParent != null) {
          lastParent.children.push(newParent);
        }
        newParent.children.push(treeBlock);
      } else if (lastParent.depth === depth - 1) {
        lastParent.children.push(treeBlock);
      } else {
        while (lastParent != null && lastParent.depth >= depth) {
          parentStack.shift();
          lastParent = parentStack[0];
        }
        if (depth > 0) {
          lastParent.children.push(treeBlock);
        } else {
          transformedBlocks.push(treeBlock);
        }
      }
    });
    return _objectSpread$2({}, draftState, {
      blocks: transformedBlocks
    });
  }
};
var DraftTreeAdapter_1 = DraftTreeAdapter$1;
var warning = warning_1;
var DraftTreeInvariants$1 = {
  /**
   * Check if the block is valid
   */
  isValidBlock: function isValidBlock(block, blockMap) {
    var key = block.getKey();
    var parentKey = block.getParentKey();
    if (parentKey != null) {
      var parent = blockMap.get(parentKey);
      if (!parent.getChildKeys().includes(key)) {
        process.env.NODE_ENV !== "production" ? warning(true, "Tree is missing parent -> child pointer on %s", key) : void 0;
        return false;
      }
    }
    var children = block.getChildKeys().map(function(k) {
      return blockMap.get(k);
    });
    if (!children.every(function(c) {
      return c.getParentKey() === key;
    })) {
      process.env.NODE_ENV !== "production" ? warning(true, "Tree is missing child -> parent pointer on %s", key) : void 0;
      return false;
    }
    var prevSiblingKey = block.getPrevSiblingKey();
    if (prevSiblingKey != null) {
      var prevSibling = blockMap.get(prevSiblingKey);
      if (prevSibling.getNextSiblingKey() !== key) {
        process.env.NODE_ENV !== "production" ? warning(true, "Tree is missing nextSibling pointer on %s's prevSibling", key) : void 0;
        return false;
      }
    }
    var nextSiblingKey = block.getNextSiblingKey();
    if (nextSiblingKey != null) {
      var nextSibling = blockMap.get(nextSiblingKey);
      if (nextSibling.getPrevSiblingKey() !== key) {
        process.env.NODE_ENV !== "production" ? warning(true, "Tree is missing prevSibling pointer on %s's nextSibling", key) : void 0;
        return false;
      }
    }
    if (nextSiblingKey !== null && prevSiblingKey !== null) {
      if (prevSiblingKey === nextSiblingKey) {
        process.env.NODE_ENV !== "production" ? warning(true, "Tree has a two-node cycle at %s", key) : void 0;
        return false;
      }
    }
    if (block.text != "") {
      if (block.getChildKeys().size > 0) {
        process.env.NODE_ENV !== "production" ? warning(true, "Leaf node %s has children", key) : void 0;
        return false;
      }
    }
    return true;
  },
  /**
   * Checks that this is a connected tree on all the blocks
   * starting from the first block, traversing nextSibling and child pointers
   * should be a tree (preorder traversal - parent, then children)
   * num of connected node === number of blocks
   */
  isConnectedTree: function isConnectedTree(blockMap) {
    var eligibleFirstNodes = blockMap.toArray().filter(function(block) {
      return block.getParentKey() == null && block.getPrevSiblingKey() == null;
    });
    if (eligibleFirstNodes.length !== 1) {
      process.env.NODE_ENV !== "production" ? warning(true, "Tree is not connected. More or less than one first node") : void 0;
      return false;
    }
    var firstNode = eligibleFirstNodes.shift();
    var nodesSeen = 0;
    var currentKey = firstNode.getKey();
    var visitedStack = [];
    while (currentKey != null) {
      var currentNode = blockMap.get(currentKey);
      var childKeys = currentNode.getChildKeys();
      var nextSiblingKey = currentNode.getNextSiblingKey();
      if (childKeys.size > 0) {
        if (nextSiblingKey != null) {
          visitedStack.unshift(nextSiblingKey);
        }
        var children = childKeys.map(function(k) {
          return blockMap.get(k);
        });
        var _firstNode = children.find(function(block) {
          return block.getPrevSiblingKey() == null;
        });
        if (_firstNode == null) {
          process.env.NODE_ENV !== "production" ? warning(true, "%s has no first child", currentKey) : void 0;
          return false;
        }
        currentKey = _firstNode.getKey();
      } else {
        if (currentNode.getNextSiblingKey() != null) {
          currentKey = currentNode.getNextSiblingKey();
        } else {
          currentKey = visitedStack.shift();
        }
      }
      nodesSeen++;
    }
    if (nodesSeen !== blockMap.size) {
      process.env.NODE_ENV !== "production" ? warning(true, "Tree is not connected. %s nodes were seen instead of %s", nodesSeen, blockMap.size) : void 0;
      return false;
    }
    return true;
  },
  /**
   * Checks that the block map is a connected tree with valid blocks
   */
  isValidTree: function isValidTree(blockMap) {
    var _this = this;
    var blocks = blockMap.toArray();
    if (!blocks.every(function(block) {
      return _this.isValidBlock(block, blockMap);
    })) {
      return false;
    }
    return this.isConnectedTree(blockMap);
  }
};
var DraftTreeInvariants_1 = DraftTreeInvariants$1;
var CharacterMetadata$1 = CharacterMetadata_1;
var Immutable$1 = immutableExports;
var List$1 = Immutable$1.List;
function createCharacterList$1(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function(style, ii) {
    var entity = entities[ii];
    return CharacterMetadata$1.create({
      style,
      entity
    });
  });
  return List$1(characterArray);
}
var createCharacterList_1 = createCharacterList$1;
var UnicodeUtils$1 = UnicodeUtils_1;
var substr$1 = UnicodeUtils$1.substr;
function decodeEntityRanges$1(text, ranges) {
  var entities = Array(text.length).fill(null);
  if (ranges) {
    ranges.forEach(function(range) {
      var start = substr$1(text, 0, range.offset).length;
      var end = start + substr$1(text, range.offset, range.length).length;
      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }
  return entities;
}
var decodeEntityRanges_1 = decodeEntityRanges$1;
var UnicodeUtils = UnicodeUtils_1;
var _require$1 = immutableExports, OrderedSet = _require$1.OrderedSet;
var substr = UnicodeUtils.substr;
var EMPTY_SET = OrderedSet();
function decodeInlineStyleRanges$1(text, ranges) {
  var styles2 = Array(text.length).fill(EMPTY_SET);
  if (ranges) {
    ranges.forEach(function(range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;
      while (cursor < end) {
        styles2[cursor] = styles2[cursor].add(range.style);
        cursor++;
      }
    });
  }
  return styles2;
}
var decodeInlineStyleRanges_1 = decodeInlineStyleRanges$1;
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ContentBlock$1 = ContentBlock_1;
var ContentBlockNode = ContentBlockNode_1;
var ContentState$1 = ContentState_1;
var DraftEntity$1 = DraftEntity_1;
var DraftTreeAdapter = DraftTreeAdapter_1;
var DraftTreeInvariants = DraftTreeInvariants_1;
var SelectionState$1 = SelectionState_1;
var createCharacterList = createCharacterList_1;
var decodeEntityRanges = decodeEntityRanges_1;
var decodeInlineStyleRanges = decodeInlineStyleRanges_1;
var generateRandomKey$1 = generateRandomKey_1;
var gkx = gkx$8;
var Immutable = immutableExports;
var invariant = invariant_1;
var experimentalTreeDataSupport = gkx("draft_tree_data_support");
var List = Immutable.List, Map$1 = Immutable.Map, OrderedMap = Immutable.OrderedMap;
var decodeBlockNodeConfig = function decodeBlockNodeConfig2(block, entityMap) {
  var key = block.key, type2 = block.type, data = block.data, text = block.text, depth = block.depth;
  var blockNodeConfig = {
    text,
    depth: depth || 0,
    type: type2 || "unstyled",
    key: key || generateRandomKey$1(),
    data: Map$1(data),
    characterList: decodeCharacterList(block, entityMap)
  };
  return blockNodeConfig;
};
var decodeCharacterList = function decodeCharacterList2(block, entityMap) {
  var text = block.text, rawEntityRanges = block.entityRanges, rawInlineStyleRanges = block.inlineStyleRanges;
  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || [];
  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function(range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function(range) {
    return _objectSpread$1({}, range, {
      key: entityMap[range.key]
    });
  })));
};
var addKeyIfMissing = function addKeyIfMissing2(block) {
  return _objectSpread$1({}, block, {
    key: block.key || generateRandomKey$1()
  });
};
var updateNodeStack = function updateNodeStack2(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function(block) {
    return _objectSpread$1({}, block, {
      parentRef
    });
  });
  return stack.concat(nodesWithParentRef.reverse());
};
var decodeContentBlockNodes = function decodeContentBlockNodes2(blocks, entityMap) {
  return blocks.map(addKeyIfMissing).reduce(function(blockMap, block, index) {
    !Array.isArray(block.children) ? process.env.NODE_ENV !== "production" ? invariant(false, "invalid RawDraftContentBlock can not be converted to ContentBlockNode") : invariant(false) : void 0;
    var children = block.children.map(addKeyIfMissing);
    var contentBlockNode = new ContentBlockNode(_objectSpread$1({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function(child) {
        return child.key;
      }))
    }));
    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);
    var stack = updateNodeStack([], children, contentBlockNode);
    while (stack.length > 0) {
      var node = stack.pop();
      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();
      var _index = siblings.indexOf(node.key);
      var isValidBlock2 = Array.isArray(node.children);
      if (!isValidBlock2) {
        !isValidBlock2 ? process.env.NODE_ENV !== "production" ? invariant(false, "invalid RawDraftContentBlock can not be converted to ContentBlockNode") : invariant(false) : void 0;
        break;
      }
      var _children = node.children.map(addKeyIfMissing);
      var _contentBlockNode = new ContentBlockNode(_objectSpread$1({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function(child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      }));
      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);
      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }
    return blockMap;
  }, OrderedMap());
};
var decodeContentBlocks = function decodeContentBlocks2(blocks, entityMap) {
  return OrderedMap(blocks.map(function(block) {
    var contentBlock = new ContentBlock$1(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};
var decodeRawBlocks = function decodeRawBlocks2(rawState, entityMap) {
  var isTreeRawBlock = rawState.blocks.find(function(block) {
    return Array.isArray(block.children) && block.children.length > 0;
  });
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;
  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }
  var blockMap = decodeContentBlockNodes(rawBlocks, entityMap);
  if (process.env.NODE_ENV !== "production") {
    !DraftTreeInvariants.isValidTree(blockMap) ? process.env.NODE_ENV !== "production" ? invariant(false, "Should be a valid tree") : invariant(false) : void 0;
  }
  return blockMap;
};
var decodeRawEntityMap = function decodeRawEntityMap2(rawState) {
  var rawEntityMap = rawState.entityMap;
  var entityMap = {};
  Object.keys(rawEntityMap).forEach(function(rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey], type2 = _rawEntityMap$rawEnti.type, mutability = _rawEntityMap$rawEnti.mutability, data = _rawEntityMap$rawEnti.data;
    entityMap[rawEntityKey] = DraftEntity$1.__create(type2, mutability, data || {});
  });
  return entityMap;
};
var convertFromRawToDraftState$1 = function convertFromRawToDraftState2(rawState) {
  !Array.isArray(rawState.blocks) ? process.env.NODE_ENV !== "production" ? invariant(false, "invalid RawDraftContentState") : invariant(false) : void 0;
  var entityMap = decodeRawEntityMap(rawState);
  var blockMap = decodeRawBlocks(rawState, entityMap);
  var selectionState = blockMap.isEmpty() ? new SelectionState$1() : SelectionState$1.createEmpty(blockMap.first().getKey());
  return new ContentState$1({
    blockMap,
    entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};
var convertFromRawToDraftState_1 = convertFromRawToDraftState$1;
var getRangeClientRects = getRangeClientRects_1;
function getRangeBoundingClientRect$1(range) {
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;
  if (rects.length) {
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }
    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];
      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }
  return {
    top,
    right,
    bottom,
    left,
    width: right - left,
    height: bottom - top
  };
}
var getRangeBoundingClientRect_1 = getRangeBoundingClientRect$1;
var getRangeBoundingClientRect = getRangeBoundingClientRect_1;
function getVisibleSelectionRect$1(global2) {
  var selection = global2.getSelection();
  if (!selection.rangeCount) {
    return null;
  }
  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top, right = boundingRect.right, bottom = boundingRect.bottom, left = boundingRect.left;
  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }
  return boundingRect;
}
var getVisibleSelectionRect_1 = getVisibleSelectionRect$1;
var AtomicBlockUtils = AtomicBlockUtils_1;
var BlockMapBuilder = BlockMapBuilder_1;
var CharacterMetadata = CharacterMetadata_1;
var CompositeDraftDecorator = CompositeDraftDecorator_1;
var ContentBlock = ContentBlock_1;
var ContentState = ContentState_1;
var DefaultDraftBlockRenderMap = DefaultDraftBlockRenderMap_1;
var DefaultDraftInlineStyle = DefaultDraftInlineStyle$2;
var DraftEditor = DraftEditor_react;
var DraftEditorBlock = DraftEditorBlock_react;
var DraftEntity = DraftEntity_1;
var DraftModifier = DraftModifier_1;
var DraftEntityInstance = DraftEntityInstance_1;
var EditorState = EditorState_1;
var KeyBindingUtil = KeyBindingUtil_1;
var RawDraftContentState = RawDraftContentState$1;
var RichTextEditorUtil = RichTextEditorUtil_1;
var SelectionState = SelectionState_1;
var convertFromDraftStateToRaw = convertFromDraftStateToRaw_1;
var convertFromRawToDraftState = convertFromRawToDraftState_1;
var generateRandomKey = generateRandomKey_1;
var getDefaultKeyBinding = getDefaultKeyBinding_1;
var getVisibleSelectionRect = getVisibleSelectionRect_1;
var convertFromHTML = convertFromHTMLToContentBlocks_1;
var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState,
  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,
  BlockMapBuilder,
  CharacterMetadata,
  ContentBlock,
  ContentState,
  RawDraftContentState,
  SelectionState,
  AtomicBlockUtils,
  KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,
  DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle,
  convertFromHTML,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding,
  getVisibleSelectionRect
};
var Draft = DraftPublic;
const getVariantStyle = (variant, theme2) => {
  if (!theme2) {
    return {};
  }
  switch (variant) {
    case "clean":
      return {
        container: {
          display: "flex",
          gap: "10px",
          alignItems: "center",
          width: "100%"
        },
        label: {
          color: theme2.colors.nimbus,
          marginBottom: "0",
          width: "120px"
        },
        textArea: {
          width: "100%",
          border: "1px solid transparent"
        },
        hovered: {
          backgroundColor: "#F6F6F6"
        },
        focused: {
          border: `1px solid ${theme2.colors.charcoal}`
        }
      };
    default: {
      return {};
    }
  }
};
const useStyles$15 = createUseStyles((theme2) => ({
  container: (props) => {
    var _a;
    return {
      ...props == null ? void 0 : props.style,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.container
    };
  },
  label: (props) => {
    var _a;
    return {
      marginBottom: "10px",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.label
    };
  },
  textArea: (props) => {
    var _a, _b2, _c2;
    return {
      cursor: "text",
      borderRadius: "4px",
      padding: "9px 14px",
      minHeight: "300px",
      border: `1px solid ${theme2.colors.nimbus}`,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.textArea,
      ...(props == null ? void 0 : props.disabled) ? (_b2 = props == null ? void 0 : props.style) == null ? void 0 : _b2.disabled : {},
      "&:hover": {
        ...(_c2 = props == null ? void 0 : props.style) == null ? void 0 : _c2.hovered
      }
    };
  },
  textAreaFocused: (props) => {
    var _a;
    return {
      border: `1px solid ${theme2.colors.charcoal}`,
      background: `${theme2.colors.white} !important`,
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.focused
    };
  },
  tooltipButton: (props) => {
    var _a;
    return {
      padding: "6px 8px",
      borderRadius: "6px",
      transition: "background 0.1s",
      "&:hover": {
        cursor: "pointer",
        background: "#F6F6F6"
      },
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.tooltipButton
    };
  },
  popover: (props) => {
    var _a;
    return {
      gap: "4px",
      position: "absolute",
      borderRadius: "6px",
      padding: "6px 8px",
      boxShadow: "0px 4px 4px rgba(151, 151, 151, 0.25)",
      marginTop: "-52px",
      zIndex: 99,
      background: theme2.colors.white,
      userSelect: "none",
      cursor: "auto",
      ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.popover
    };
  }
}));
const useStyles$16 = useStyles$15;
const RichTextArea = ({
  className = "",
  style = {},
  label = "",
  onChange = () => {
  },
  onBlur: onBlur2 = () => {
  },
  value = "",
  placeholder = "",
  disabled = false,
  variant = null
}) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$16({
    style: mergeDeep$1(getVariantStyle(variant, theme2), style),
    disabled
  });
  const editorRef = useRef(null);
  const textAreaRef = useRef(null);
  const popoverRef = useRef(null);
  const [editorState, setEditorState] = useState(() => Draft.EditorState.createEmpty());
  const [anchorPosition, setAnchorPosition] = useState({ left: 0, top: 0 });
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setAnchorPosition({ left: 0, top: 0 });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popoverRef]);
  useEffect(() => {
    if (value) {
      try {
        const contentState = editorState.getCurrentContent();
        const currentContentState = JSON.stringify(Draft.convertToRaw(contentState));
        if (currentContentState !== value) {
          const contentState2 = Draft.convertFromRaw(JSON.parse(value));
          const stateWithContent = Draft.EditorState.createWithContent(contentState2);
          const currentSelection = editorState.getSelection();
          const stateWithContentAndSelection = Draft.EditorState.forceSelection(
            stateWithContent,
            currentSelection
          );
          setEditorState(stateWithContentAndSelection);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [value]);
  const handleChange = (editorState2) => {
    try {
      const selection = window.getSelection();
      if (selection.type === "Range") {
        const range = selection == null ? void 0 : selection.getRangeAt(0);
        const clientRect = range == null ? void 0 : range.getBoundingClientRect();
        const { left, top } = clientRect;
        if (left !== 0 && top !== 0) {
          setAnchorPosition({ left, top });
        }
      } else {
        setAnchorPosition({ left: 0, top: 0 });
      }
      const contentState = editorState2.getCurrentContent();
      onChange(JSON.stringify(Draft.convertToRaw(contentState)));
      setEditorState(editorState2);
    } catch (error) {
      console.error(error);
    }
  };
  const handleBlur = () => {
    try {
      const contentState = editorState.getCurrentContent();
      onBlur2(JSON.stringify(Draft.convertToRaw(contentState)));
    } catch (error) {
      console.error(error);
    }
  };
  const handleKeyCommand2 = (command, editorState2) => {
    const newState = Draft.RichUtils.handleKeyCommand(editorState2, command);
    if (newState) {
      handleChange(newState);
      return "handled";
    }
    return "not-handled";
  };
  const toggleTooltip = (e, style2) => {
    e.preventDefault();
    const newState = Draft.RichUtils.toggleInlineStyle(editorState, style2);
    if (newState) {
      handleChange(newState);
    }
  };
  const getTooltip = (element, style2) => /* @__PURE__ */ React__default.createElement(
    Box,
    {
      onMouseDown: (e) => e.preventDefault(),
      className: classes.tooltipButton,
      onClick: (e) => toggleTooltip(e, style2)
    },
    element
  );
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${className} ${classes.container}` }, label && /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      ref: textAreaRef,
      className: `${classes.textArea} ${((_a = editorRef.current) == null ? void 0 : _a.editor) === document.activeElement && classes.textAreaFocused}`,
      onClick: (_b2 = editorRef.current) == null ? void 0 : _b2.focus,
      onMouseDown: (e) => {
        var _a2;
        if (((_a2 = editorRef.current) == null ? void 0 : _a2.editor) === document.activeElement && textAreaRef.current === e.target) {
          e.preventDefault();
          setEditorState(Draft.EditorState.moveFocusToEnd(editorState));
        }
      }
    },
    /* @__PURE__ */ React__default.createElement(
      Draft.Editor,
      {
        onBlur: handleBlur,
        ref: editorRef,
        editorState,
        onChange: handleChange,
        placeholder,
        readOnly: disabled,
        handleKeyCommand: handleKeyCommand2
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.popover,
        ref: popoverRef,
        style: {
          display: anchorPosition.top === 0 && anchorPosition.left === 0 ? "none" : "flex",
          top: anchorPosition.top,
          left: anchorPosition.left
        }
      },
      getTooltip(
        /* @__PURE__ */ React__default.createElement("span", { style: { fontWeight: theme2.fontWeights.bold, color: theme2.colors.olive3 } }, "Bold"),
        "BOLD"
      ),
      getTooltip(/* @__PURE__ */ React__default.createElement("span", { style: { fontStyle: "italic" } }, "Italic"), "ITALIC"),
      getTooltip(/* @__PURE__ */ React__default.createElement("span", { style: { textDecoration: "underline" } }, "Underline"), "UNDERLINE")
    )
  ));
};
RichTextArea.defaultProps = {
  className: "",
  style: {},
  label: "",
  onChange: noop,
  onBlur: noop,
  value: "",
  placeholder: "",
  disabled: false,
  variant: null
};
RichTextArea.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.string
};
const sideBarWidth = 435;
const headerNavHeight = 66;
const useStyles$14 = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    gap: "100px",
    fontSize: "15px"
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    maxWidth: "800px"
  },
  rightColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    backgroundColor: theme2.colors.dune,
    minHeight: `calc(100dvh - ${headerNavHeight}px)`,
    margin: "-48px -96px",
    padding: "48px 20px",
    width: `${sideBarWidth}px`,
    [theme2.breakpoints.down("sm")]: {
      padding: "32px 20px",
      margin: `-32px -20px`
    }
  },
  heading: {
    ...theme2.typography.heading.H3
  },
  pageDescription: {
    fontSize: "18px",
    color: theme2.colors.smoke
  },
  subHeading: {
    ...theme2.typography.heading.H3
  },
  prefillInstructions: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "18px",
    display: "flex",
    flexDirection: "column",
    gap: "18px"
  },
  prefillHeading: {
    ...theme2.typography.heading.H4
  },
  prefillDescription: {
    fontSize: "15px",
    color: theme2.colors.smoke
  },
  textButton: {},
  accordion: {},
  accordionItem: {},
  termsText: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginBottom: "20px",
    fontSize: "15px"
  },
  boldText: {
    fontWeight: "bold"
  },
  highlightedText: {
    color: theme2.colors.informationBlue
  },
  list: {},
  listItem: {
    marginBottom: "15px"
  }
}));
const TermsSettings = ({ obeeSettings: obeeSettings2, updateObeeSettings: updateObeeSettings2 }) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$14({ noBooking: false });
  const [terms, setTerms] = useState((_a = obeeSettings2.data) == null ? void 0 : _a.terms);
  const [anchor, setAnchor] = useState(null);
  const updateTerms = (updatedTerms) => {
    var _a2;
    if (updatedTerms !== ((_a2 = obeeSettings2.data) == null ? void 0 : _a2.terms)) {
      updateObeeSettings2({ terms: updatedTerms });
    }
  };
  useEffect(() => {
    var _a2;
    setTerms((_a2 = obeeSettings2.data) == null ? void 0 : _a2.terms);
  }, [(_b2 = obeeSettings2.data) == null ? void 0 : _b2.terms]);
  const setTermsToPremade = () => {
    setTerms(getDefaultTermsAndConditions());
  };
  const accordionItems = [
    {
      id: "questions",
      summary: "Questions to consider",
      details: /* @__PURE__ */ React__default.createElement("ul", { className: classes.list }, /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Is there a minimum spend?"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Can special dietary requirements be catered for? Any requirements or only some? Is advanced notice of any special dietary requirements needed?"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Does an additional service charge apply? For Sundays or public holidays?"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Can bookings be changed or cancelled online? Or does this need to be done by phone?"), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Anything specific to your venue, such as directions to where you're located, your menu, and if they must be on specific menus for different times, days or group sizes?"))
    },
    {
      id: "tips",
      summary: "Tips & recommendations",
      details: /* @__PURE__ */ React__default.createElement("ul", null, /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "We recommend keeping your terms and conditions short and concise, communicating only the most important information for your venue."), /* @__PURE__ */ React__default.createElement("li", { className: classes.listItem }, "Use your website - We recommend creating a comprehensive overview of your booking policy (and an FAQ style page is a great idea too) and then in your terms and conditions you can refer guests to these pages. It's also easier for you to maintain as the website can become your source of truth on the booking policy and only one place that you need to keep up to date."))
    }
  ];
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.leftColumn }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Terms and conditions"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageDescription }, "Important information shown to the customer when they’re making a booking."), /* @__PURE__ */ React__default.createElement(Box, { style: { marginLeft: "-10px" } }, /* @__PURE__ */ React__default.createElement(
    RichTextArea,
    {
      variant: "clean",
      onChange: setTerms,
      onBlur: updateTerms,
      value: terms,
      style: { textArea: { padding: "10px" } },
      placeholder: "Write your terms and conditions here"
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.rightColumn }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Guidance"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.prefillInstructions }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.prefillHeading }, "Default terms & conditions"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.prefillDescription }, "Get started with prefilled terms & conditions. These are suggested only."), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "text",
      className: classes.textButton,
      style: { ...linkStyles(theme2), fontWeight: "normal" },
      onClick: (e) => setAnchor(e.currentTarget)
    },
    "View"
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.accordion }, /* @__PURE__ */ React__default.createElement(Accordion, { items: accordionItems }))), /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen: !!anchor,
      anchorEl: anchor,
      onClose: () => setAnchor(null),
      innerStyle: {
        marginTop: 0,
        borderRadius: "6px",
        padding: "20px",
        maxWidth: "500px",
        marginLeft: "-10px"
      },
      anchorOrigin: {
        vertical: "center",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "right"
      }
    },
    /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.termsText }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement("span", { className: classes.boldText }, "Minimum spend -"), " We have a minimum spend of", /* @__PURE__ */ React__default.createElement("span", { className: classes.highlightedText }, " [$XX] "), " per booking."), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement("span", { className: classes.boldText }, "Booking duration -"), " We offer a [X hrs] dining duration for bookings. Your table will only be held for", " ", /* @__PURE__ */ React__default.createElement("span", { className: classes.highlightedText }, " [XX minutes] "), " after your booking time. Please advise us if you will be late as soon as possible. We require credit card details to secure all bookings. There is", " ", /* @__PURE__ */ React__default.createElement("span", { className: classes.highlightedText }, " [$$] "), " to secure this booking."), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement("span", { className: classes.boldText }, "Surcharge -"), " A", " ", /* @__PURE__ */ React__default.createElement("span", { className: classes.highlightedText }, "[XX%]"), " surcharge is applied to food and beverage on public holidays."), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement("span", { className: classes.boldText }, "Contact -"), " If you have any questions about your booking, please contact us on", " ", /* @__PURE__ */ React__default.createElement("span", { className: classes.highlightedText }, "[Phone number]"), "."), /* @__PURE__ */ React__default.createElement(Box, { className: classes.boldText }, "We look forward to seeing you.")), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        className: classes.textButton,
        style: { ...linkStyles(theme2), fontWeight: theme2.fontWeights.medium },
        onClick: () => {
          setTermsToPremade();
          setAnchor(null);
        }
      },
      "Get started with the default >"
    ))
  ));
};
TermsSettings.propTypes = {
  obeeSettings: obeeSettingsPropTypes.isRequired,
  updateObeeSettings: PropTypes.func.isRequired
};
const mapStateToProps$24 = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$23 = (dispatch) => bindActionCreators(
  {
    updateObeeSettings: updateSettingsAction
  },
  dispatch
);
const TermsSettings$1 = connect(mapStateToProps$24, mapDispatchToProps$23)(TermsSettings);
const EmailItem = ({ email }) => {
  const classes = useStyles$1n();
  const history = useHistory();
  const preview = () => {
    history.replace({
      search: `?tab=emailCommunication&preview=${email.id}`
    });
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.emailItemContainer, onClick: preview }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.emailItemImage }, /* @__PURE__ */ React__default.createElement("img", { className: classes.previewImage, src: email.image, alt: `${email.title} preview` })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.emailItemBottom }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.emailItemTitle }, email.title), /* @__PURE__ */ React__default.createElement(Box, { className: classes.emailItemDescription }, email.description)));
};
EmailItem.propTypes = {
  email: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired
};
const mapStateToProps$23 = () => ({});
const mapDispatchToProps$22 = (dispatch) => bindActionCreators({}, dispatch);
const EmailItem$1 = connect(mapStateToProps$23, mapDispatchToProps$22)(EmailItem);
const EmailCommunicationSettings = () => {
  const classes = useStyles$1n();
  const emailTemplates = [
    {
      id: "confirmation",
      title: "Confirmation",
      description: "Provides confirmation for the guest that their table has been reserved for them."
      // image: ConfirmationImage,
    },
    {
      id: "reminder",
      title: "Reminder",
      description: "Sends at your preferred time prior to the booking, requesting the guest to confirm the booking details."
      // image: ReminderImage,
    },
    {
      id: "cancellation",
      title: "Cancellation",
      description: "Provides confirmation for the guest that their booking is cancelled and invites them to create another booking."
      // image: CancellationImage,
    },
    {
      id: "thank_you",
      title: "Thank you",
      description: "Completes your guest's experience with a thank you note and invites them to create another booking."
      // image: ThankYouImage,
    },
    {
      id: "waitlist",
      title: "Waitlist",
      description: "Provides confirmation that the guest is on the waiting list and their request details."
      // image: WaitlistImage,
    }
  ];
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(UpsellBanner$1, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.emailItems }, emailTemplates.map((template) => /* @__PURE__ */ React__default.createElement(EmailItem$1, { key: template.id, email: template }))));
};
EmailCommunicationSettings.propTypes = {};
const mapStateToProps$22 = () => ({});
const mapDispatchToProps$21 = (dispatch) => bindActionCreators({}, dispatch);
const EmailCommunicationSettings$1 = connect(mapStateToProps$22, mapDispatchToProps$21)(EmailCommunicationSettings);
const createBookingLimitRuleAction = (newBookingLimitRule, condition) => (dispatch) => {
  const action = "CREATE_OBEE_BOOKING_LIMIT_RULE";
  const entityName = "createTimeslotLimit";
  const successMessage = "Limit created";
  const errorMessage = "Failed to create limit";
  const newItem = convertDataForApi$3(newBookingLimitRule);
  const data = {
    conditionId: condition == null ? void 0 : condition.objectId,
    limit: newItem
  };
  const request = () => createTimeslotLimit(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      successMessage,
      { conditionId: condition == null ? void 0 : condition.objectId },
      false,
      errorMessage
    )
  );
};
const updateBookingLimitRuleAction = (updatedBookingLimitRule, condition) => (dispatch) => {
  const action = "UPDATE_OBEE_BOOKING_LIMIT_RULE";
  const updatedItem = convertDataForApi$3(updatedBookingLimitRule);
  const entityName = "updateTimeslotLimit";
  const successMessage = "Limit updated";
  const errorMessage = "Failed to update limit";
  const data = {
    limitId: updatedBookingLimitRule == null ? void 0 : updatedBookingLimitRule.objectId,
    limit: updatedItem
  };
  const request = () => updateTimeslotLimit(data);
  dispatch(
    makeApiAction(
      action,
      request,
      updatedItem,
      entityName,
      successMessage,
      { conditionId: condition == null ? void 0 : condition.objectId },
      false,
      errorMessage
    )
  );
};
const deleteBookingLimitRuleAction = (conditionId, deletedBookingLimitId) => (dispatch) => {
  const action = "DELETE_OBEE_BOOKING_LIMIT_RULE";
  const entityName = "deleteTimeslotLimit";
  const successMessage = "Limit deleted";
  const errorMessage = "Failed to delete limit";
  const data = {
    limitId: deletedBookingLimitId
  };
  const request = () => deleteTimeslotLimit(data);
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      successMessage,
      { conditionId, limitId: deletedBookingLimitId },
      false,
      errorMessage
    )
  );
};
const fetchBookingLimitsAction = () => (dispatch) => {
  const action = "FETCH_OBEE_BOOKING_LIMITS";
  const entityName = "obeeTimeslotConditions";
  const request = () => fetchTimeslotConditions();
  dispatch(makeApiAction(action, request, {}, entityName));
};
const createConditionAction = (newCondition, restaurantOpen, restaurantClose) => (dispatch) => {
  const action = "CREATE_OBEE_BOOKING_LIMIT";
  const entityName = "createTimeslotCondition";
  const successMessage = "Condition created";
  const errorMessage = "Failed to create condition";
  const newItem = convertDataForApi$2(newCondition);
  const data = {
    condition: newItem
  };
  const bookingLimitsState = store$1.getState().bookingLimits;
  const findMatchingCondition = (conditionToCheck, otherConditions) => {
    return otherConditions.find((bookingLimit) => {
      if ((bookingLimit == null ? void 0 : bookingLimit.startDate) !== (conditionToCheck == null ? void 0 : conditionToCheck.startDate) || (bookingLimit == null ? void 0 : bookingLimit.endDate) !== (conditionToCheck == null ? void 0 : conditionToCheck.endDate) || (bookingLimit == null ? void 0 : bookingLimit.areaId) !== (conditionToCheck == null ? void 0 : conditionToCheck.selectedArea)) {
        return false;
      }
      if ((bookingLimit == null ? void 0 : bookingLimit.dayType) === (conditionToCheck == null ? void 0 : conditionToCheck.dayType)) {
        if ((bookingLimit == null ? void 0 : bookingLimit.dayType) === "all") {
          return true;
        }
        if ((bookingLimit == null ? void 0 : bookingLimit.dayType) === "weekdays" && arraysEqual(bookingLimit == null ? void 0 : bookingLimit.days, conditionToCheck == null ? void 0 : conditionToCheck.conditionDays)) {
          return true;
        }
      }
      return false;
    });
  };
  const existingCondition = findMatchingCondition(newCondition, bookingLimitsState.data);
  if (existingCondition) {
    devLog("info", "existing condition found", { existingCondition, newCondition });
    dispatch(createBookingLimitRuleAction(newCondition, existingCondition));
    return;
  }
  devLog("info", "variables", data);
  const request = () => createTimeslotCondition(data);
  dispatch(
    makeApiAction(action, request, newItem, entityName, successMessage, {}, false, errorMessage)
  );
};
const deleteBookingLimitAction = (deletedBookingLimitId) => (dispatch) => {
  const action = "DELETE_OBEE_BOOKING_LIMIT";
  const entityName = "deleteTimeslotCondition";
  const successMessage = "Condition deleted";
  const errorMessage = "Failed to delete condition";
  const data = {
    conditionId: deletedBookingLimitId
  };
  const request = () => deleteTimeslotCondition(data);
  const returnValues = {
    id: deletedBookingLimitId
  };
  dispatch(
    makeApiAction(
      action,
      request,
      {},
      entityName,
      successMessage,
      returnValues,
      false,
      errorMessage
    )
  );
};
const headerHeight$1 = 65;
const cellHeight = 46;
const sidebarWidth$1 = 230;
const settingsMarginWidth = 96;
const settingsMarginHeight = 48;
const settingsTabletMarginHeight = 32;
const columnWidth = 320;
const ruleBlockPadding = 5;
const useStyles$13 = createUseStyles((theme2) => ({
  container: {
    ...theme2.typography.body.PL,
    margin: `-${settingsMarginHeight}px -${settingsMarginWidth}px`,
    [theme2.breakpoints.down("sm")]: {
      margin: `-${settingsTabletMarginHeight}px -20px`
    }
  },
  pageContent: {
    display: "flex",
    backgroundColor: theme2.colors.linen,
    overflow: "hidden"
  },
  sidebar: {
    boxSizing: "border-box",
    backgroundColor: theme2.colors.linen,
    width: `${sidebarWidth$1}px`,
    minWidth: `${sidebarWidth$1}px`,
    maxWidth: `${sidebarWidth$1}px`,
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    height: `calc(100dvh - ${headerHeight$1}px)`,
    // overflow: 'hidden',
    overflowY: theme2.overlay
  },
  sidebarTop: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  sidebarHeading: {
    ...theme2.typography.heading.H4
  },
  areasList: (props) => ({
    flex: "1",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    height: "calc(100% - 100px)",
    fontSize: "15px",
    // height: `calc(100vh - ${headerHeight}px)`,
    // width: `${sidebarWidth - 20}px`,
    // overflowY: 'auto',
    overflowX: "visible",
    overflowY: (props == null ? void 0 : props.popoverOpen) ? "hidden" : theme2.overlay,
    padding: "16px",
    margin: "-16px"
    // So scroll bar looks nice
  }),
  area: {},
  areaName: {
    fontWeight: theme2.fontWeights.medium
  },
  areaDays: {
    paddingTop: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "3px"
  },
  timeslotLimits: {
    position: "relative",
    marginRight: "10px",
    height: `calc(100dvh - ${headerHeight$1}px)`,
    backgroundColor: theme2.colors.white,
    flex: "1",
    borderRadius: "30px 0 0 0",
    overflow: "hidden"
    // for the nice round corner
  },
  heading: {
    ...theme2.typography.heading.H2
  },
  timeslotHeader: {
    height: "52px",
    // TODO fit to style guide
    paddingLeft: "130px",
    // timeBox width + padding
    display: "inline-flex",
    alignItems: "center",
    minWidth: "100%",
    backgroundColor: theme2.colors.white,
    borderBottom: `1px solid ${theme2.colors.shark}`,
    position: "sticky",
    top: 0,
    zIndex: 2
  },
  columnHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: `${columnWidth}px`,
    // TODO double check this
    minWidth: `${columnWidth}px`,
    padding: "0 20px",
    gap: "16px",
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium
  },
  limitColumnContainer: {
    display: "flex",
    // gap: '30px',
    top: `${cellHeight / 2 + 52 + 32}px`,
    // 52 is the header height 32 padding
    left: "132px",
    position: "absolute"
    // height: '100%',
  },
  limitColumn: {
    position: "relative",
    width: `${columnWidth}px`,
    padding: "0 20px",
    height: "100%",
    borderRight: `1px solid ${theme2.colors.yetAnotherGray2}`
  },
  limitItem: {
    position: "absolute",
    width: `${columnWidth - 40}px`,
    //
    border: `1px solid ${theme2.colors.dune}`,
    backgroundColor: theme2.colors.white,
    boxShadow: "0px 4px 8px rgba(216, 216, 216, 0.25)",
    borderRadius: "6px",
    // paddingBottom: '12px',
    overflow: "hidden"
  },
  limitItemNoBooking: {
    border: `1px dashed ${theme2.colors.charcoal}`
  },
  limitItemContents: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    padding: "8px 32px 8px 16px",
    gap: "8px"
    // TODO 4 if small
  },
  limitItemContentsNoBooking: {
    paddingLeft: "640px"
  },
  columnHeading: {
    fontSize: "15px",
    lineHeight: 1.4,
    fontWeight: theme2.fontWeights.medium
  },
  columnSubHeading: {
    fontSize: "15px",
    color: theme2.colors.nimbus,
    lineHeight: 1.4
  },
  // tabBar: {
  //   display: 'flex',
  //   gap: '12px',
  //   overflowX: 'auto',
  // },
  // tab: {
  //   padding: '10px 12px',
  //   position: 'relative',
  //   borderRadius: '8px',
  //   border: `1px solid ${theme.colors.shark}`,
  //   width: '187px',
  //   height: '62px', // TODO should be 38 (probably)
  //   display: 'flex',
  //   flexDirection: 'column',
  //   justifyContent: 'space-between',
  //   userSelect: 'none',
  //   overflow: 'hidden',
  //   '&:hover': {
  //     borderColor: theme.colors.charcoal,
  //   },
  // },
  addConditionBox: {
    padding: "10px 12px",
    position: "relative",
    borderRadius: "8px",
    border: `1px solid ${theme2.colors.shark}`,
    width: "187px",
    height: "62px",
    // TODO should be 38 (probably)
    alignItems: "center",
    verticalAlign: "center",
    cursor: "pointer",
    userSelect: "none",
    "&:hover": {
      borderColor: theme2.colors.charcoal
    }
  },
  tabTitle: {
    ...theme2.typography.body.P,
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.charcoal,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  tabDays: {
    ...theme2.typography.body.PS,
    color: theme2.colors.smoke,
    textTransform: "capitalize"
  },
  tabEdit: {
    position: "absolute",
    right: "10px",
    top: "5px"
  },
  addCondition: {
    ...theme2.typography.body.P,
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.charcoal,
    lineHeight: "36px",
    // textAlign: 'center',
    userSelect: "none"
    // marginLeft: '-10px',
  },
  dayColumn: {
    display: "flex",
    flexDirection: "column",
    minWidth: `${columnWidth * 2 + 90 + 40}px`,
    // 2 * columnWidth + timeBox width + padding
    padding: "32px 0"
  },
  timeBoxContainer: {
    paddingLeft: "40px",
    display: "flex"
  },
  timeBox: {
    height: `${cellHeight}px`,
    lineHeight: `${cellHeight}px`,
    backgroundColor: "white",
    fontSize: "15px",
    // padding: '20px 6px',
    // textAlign: 'right',
    width: "90px",
    flexShrink: 0
  },
  timeBoxRow: {
    height: `${cellHeight / 2}px`,
    borderTop: `1px solid ${theme2.colors.yetAnotherGray2}`,
    // marginTop: '-65px',
    marginTop: `${cellHeight / 2}px`,
    backgroundColor: "white",
    width: "100%"
  },
  timeslotsContainer: {
    position: "relative",
    height: "100%",
    overflow: theme2.overlay
  },
  columnContainerTop: (props) => ({
    height: "16px",
    // TODO 8 if small (one cell high)
    borderRadius: "6px 6px 0 0",
    backgroundColor: (props == null ? void 0 : props.noBooking) ? theme2.colors.nimbus : theme2.colors.linen
  }),
  addLimitGroup: {
    ...theme2.typography.body.P,
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.charcoal,
    lineHeight: "36px",
    textAlign: "center",
    userSelect: "none",
    marginLeft: "-20px"
  },
  innerContainer: {
    color: theme2.colors.charcoal,
    display: "flex",
    flexDirection: "column"
  },
  popup: {
    backgroundColor: theme2.colors.white,
    maxWidth: "800px",
    // padding: '20px 24px',
    // left: 'calc(50% - 350px)',
    // position: 'fixed',
    // borderRadius: '8px',
    // boxShadow: '0px 4px 4px rgba(151, 151, 151, 0.25)',
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap"
    // gap: '28px',
  },
  content: {
    width: "348px",
    padding: "20px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    maxHeight: "600px",
    overflowY: theme2.overlay
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  },
  footer: {
    background: theme2.colors.white,
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    alignItems: "center",
    padding: "12px 24px",
    borderTop: `1px solid ${theme2.colors.linkIconBackground}`,
    position: "sticky",
    bottom: 0
  },
  modalHeader: {
    background: theme2.colors.linen,
    height: "40px",
    padding: "0 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "sticky",
    top: 0
  },
  modalTitle: {
    ...theme2.typography.heading.H4
  },
  modalDescription: {
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.jet
    // paddingBottom: '24px',
    // paddingLeft: '8px',
    // marginBottom: '20px',
  },
  inputFields: {
    display: "flex",
    flexDirection: "column",
    gap: "3px"
  },
  hiddenInputFields: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "3px",
    overflow: "hidden",
    transition: "max-height 0.4s ease"
  },
  cardContainer: {
    display: "flex",
    gap: "16px"
  },
  card: {
    display: "flex",
    gap: "16px"
  },
  limitCardIcon: {
    backgroundColor: theme2.colors.linen,
    borderRadius: "8px",
    padding: "10px 10px 10px 6px",
    alignItems: "center"
  },
  cardTitle: {
    ...theme2.typography.heading.H4,
    color: theme2.colors.charcoal,
    marginBottom: "10px"
  },
  cardDescription: {
    ...theme2.typography.body.PS,
    lineHeight: "22px",
    color: theme2.colors.smoke
  },
  textButton: {},
  limitCards: {
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  },
  limitCardContainer: {
    border: `1px solid ${theme2.colors.nimbus}`,
    borderRadius: "6px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    fontSize: "16px",
    fontWeight: theme2.fontWeights.medium,
    padding: "8px 16px",
    color: theme2.colors.charcoal
  },
  flexRow: {
    display: "inline-flex",
    gap: "8px",
    alignItems: "center"
  },
  ruleDetails: {
    color: theme2.colors.smoke,
    fontWeight: theme2.fontWeights.medium,
    fontSize: "12px"
  },
  loadingBox: {
    marginTop: "50%",
    marginLeft: "50%"
  },
  selectedFilter: {
    height: "36px",
    // to match other buttons
    border: `1px solid ${theme2.colors.black}`,
    backgroundColor: theme2.colors.selectedListItem,
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    gap: 0,
    alignItems: "center",
    userSelect: "none",
    maxWidth: "100%"
  },
  selectedFilterLabel: {
    padding: "0 0 0 11px",
    // Not 12 because of the 1px border
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    flexGrow: 0,
    color: theme2.colors.smoke
  }
}));
const addButtonStyles = (theme2) => ({
  button: {
    height: "auto",
    padding: "6px 20px",
    boxShadow: "none",
    backgroundColor: theme2.colors.white,
    color: theme2.colors.jet,
    borderRadius: "100px",
    border: `1px solid #DFDFDF`,
    // TODO use theme
    lineHeight: "normal",
    fontWeight: theme2.fontWeights.medium
  }
});
const fieldStyles = (theme2) => ({
  label: { fontSize: "15px", width: "140px" },
  input: {
    padding: "8px 10px",
    paddingLeft: "10px",
    fontSize: "15px"
  },
  inputActive: { border: `1px solid ${theme2.colors.smoke}`, outline: "none" },
  errorText: {
    color: theme2.colors.errorRed,
    fontSize: "10px",
    marginLeft: 0
  }
});
const popoverStyles$5 = {
  header: {
    padding: 0
  },
  footerInner: {
    padding: "0 10px"
  },
  content: {
    padding: "0"
  },
  footer: {
    padding: 0
  }
};
const popoverWithBackgroundStyles = {
  ...popoverStyles$5,
  backgroundColor: "#FFFFFFAD",
  // Semi-transparent white
  transition: "background-color 0.2s ease"
};
const popoverAnchors = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  }
};
const iconButtonStyles$1 = (theme2) => ({
  color: theme2.colors.smoke,
  position: "absolute",
  top: "5px",
  right: "5px",
  button: {
    padding: "10px"
  }
});
const AddConditionModal = ({
  areas,
  isOpen,
  onClose,
  anchor,
  restaurantOpen,
  restaurantClose,
  createBookingLimit
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$13({ noBooking: false });
  const saving = useRef(false);
  const [selectedArea, setSelectedArea] = useState("all");
  const [dayType, setDayType] = useState("all");
  const [conditionDays, setConditionDays] = useState([]);
  const [date, setDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [limitType, setLimitType] = useState(null);
  const [limitAmount, setLimitAmount] = useState(null);
  const [timeInterval, setTimeInterval] = useState(null);
  const [groupSize, setGroupSize] = useState({ option: "more", min: 8, max: 10, exact: 10 });
  const [startTime, setStartTime] = useState("allDay");
  const [endTime, setEndTime] = useState("allDay");
  const [source, setSource] = useState("all");
  const [selectedAreaError, setSelectedAreaError] = useState(null);
  const [dayTypeError, setDayTypeError] = useState(null);
  const [conditionDaysError, setConditionDaysError] = useState(null);
  const [dateError, setDateError] = useState(null);
  const [startDateError, setStartDateError] = useState(null);
  const [endDateError, setEndDateError] = useState(null);
  const [limitTypeError, setLimitTypeError] = useState(null);
  const [limitAmountError, setLimitAmountError] = useState(null);
  const [timeIntervalError, setTimeIntervalError] = useState(null);
  const [groupSizeError, setGroupSizeError] = useState(null);
  const [startTimeError, setStartTimeError] = useState(null);
  const [endTimeError, setEndTimeError] = useState(null);
  const [sourceError, setSourceError] = useState(null);
  const clearErrors = () => {
    unstable_batchedUpdates(() => {
      setSelectedAreaError(null);
      setDayTypeError(null);
      setConditionDaysError(null);
      setDateError(null);
      setStartDateError(null);
      setEndDateError(null);
      setLimitTypeError(null);
      setLimitAmountError(null);
      setTimeIntervalError(null);
      setGroupSizeError(null);
      setStartTimeError(null);
      setEndTimeError(null);
      setSourceError(null);
    });
  };
  useEffect(() => {
    if (isOpen) {
      setSelectedArea("all");
      setConditionDays([]);
      setDayType("all");
      setDate(null);
      setStartDate(null);
      setEndDate(null);
      setLimitType(null);
      setLimitAmount(null);
      setTimeInterval(null);
      setGroupSize({ option: "more", min: 8, max: 10, exact: 10 });
      setStartTime("allDay");
      setEndTime("allDay");
      setSource("all");
      clearErrors();
      saving.current = false;
    }
  }, [isOpen]);
  const interval = 15;
  const validate = () => {
    let isValid = true;
    const requiredFields = [
      { value: selectedArea, setError: setSelectedAreaError },
      { value: dayType, setError: setDayTypeError },
      { value: limitType, setError: setLimitTypeError },
      ...limitType === "noBookings" ? [] : [{ value: limitAmount, setError: setLimitAmountError }],
      // if `Limit Type` is `Don't allow any bookings` we can't set a limitAmount
      { value: startTime, setError: setStartTimeError },
      { value: endTime, setError: setEndTimeError }
    ];
    requiredFields.forEach((field) => {
      if (isEmpty(field.value)) {
        field.setError("This field is required");
        isValid = false;
      }
    });
    if (dayType === "weekdays" && conditionDays.length === 0) {
      setConditionDaysError("You must choose at least one day");
      isValid = false;
    }
    if (dayType === "date" && isEmpty(date)) {
      setDateError("You must select a date");
      isValid = false;
    }
    if (dayType === "dateRange" && isEmpty(date)) {
      if (isEmpty(startDate)) {
        setStartDateError("You must select a start date");
        isValid = false;
      }
      if (isEmpty(endDate)) {
        setEndDateError("You must select an end date");
        isValid = false;
      }
    }
    if (limitType === "maxGroups" && (groupSize == null ? void 0 : groupSize.option) === null) {
      setGroupSizeError("Group size is not valid");
      isValid = false;
    }
    return isValid;
  };
  const addCondition = () => {
    saving.current = true;
    const isValid = validate();
    if (!isValid) {
      saving.current = false;
      return;
    }
    createBookingLimit(
      {
        selectedArea,
        conditionDays,
        dayType,
        date,
        startDate,
        endDate,
        limitType,
        limitAmount,
        timeInterval,
        groupSize,
        startTime,
        endTime,
        source
      },
      restaurantOpen,
      restaurantClose
    );
    onClose();
  };
  const startTimes = useMemo(() => {
    const restaurantOpenFormatted = formatTimeFromInt(restaurantOpen, "h:mma");
    const restaurantCloseFormatted = formatTimeFromInt(restaurantClose, "h:mma");
    return [
      { label: "-", value: null },
      {
        label: `All day (${restaurantOpenFormatted}-${restaurantCloseFormatted})`,
        value: "allDay"
      },
      ...getAllTimes(restaurantOpen, restaurantClose, interval)
    ];
  }, [restaurantOpen, restaurantClose]);
  const endTimes = useMemo(() => {
    const restaurantOpenFormatted = formatTimeFromInt(restaurantOpen, "h:mma");
    const restaurantCloseFormatted = formatTimeFromInt(restaurantClose, "h:mma");
    const allDayLabel = `All day (${restaurantOpenFormatted}-${restaurantCloseFormatted})`;
    if (startTime === "allDay") {
      return [
        { label: "-", value: null },
        {
          label: allDayLabel,
          value: "allDay"
        },
        ...getAllTimes(restaurantOpen + interval, restaurantClose, interval)
      ];
    }
    return [
      { label: "-", value: null },
      { label: allDayLabel, value: "allDay" },
      ...getAllTimes(startTime, restaurantClose, interval)
    ];
  }, [startTime, restaurantOpen, restaurantClose]);
  const changeStartTime = (newTime) => {
    if (newTime === "allDay") {
      setStartTime(newTime);
      setEndTime(newTime);
      return;
    }
    if (endTime === "allDay") {
      setEndTime(restaurantClose);
    }
    if (isEmpty(newTime)) {
      setStartTime(newTime);
      return;
    }
    const maxStartTime = restaurantClose - interval;
    const updatedTime = Math.min(maxStartTime, newTime);
    setStartTime(updatedTime);
    if (updatedTime >= endTime) {
      setEndTime(updatedTime + interval);
    }
  };
  const changeEndTime = (newTime) => {
    if (newTime === "allDay") {
      setStartTime(newTime);
      setEndTime(newTime);
      return;
    }
    if (startTime === "allDay") {
      setStartTime(restaurantOpen);
    }
    if (isEmpty(newTime)) {
      setEndTime(newTime);
      return;
    }
    const minEndTime = restaurantOpen + interval;
    const updatedTime = Math.max(minEndTime, newTime);
    setEndTime(updatedTime);
    if (updatedTime <= startTime) {
      setStartTime(restaurantOpen);
    }
  };
  const toggleDay = (day) => {
    if (conditionDays.includes(day)) {
      const index = conditionDays.indexOf(day);
      const newDays = [...conditionDays];
      newDays.splice(index, 1);
      setConditionDays(newDays);
    } else {
      setConditionDays([...conditionDays, day]);
    }
  };
  const areasList = useMemo(
    () => [
      { label: "All areas", value: "all" },
      ...areas.data.map((area) => ({
        label: area == null ? void 0 : area.name,
        value: area == null ? void 0 : area.id
      }))
    ],
    [areas.data]
  );
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen,
      onClose,
      anchorEl: anchor,
      style: popoverWithBackgroundStyles,
      innerStyle: {
        padding: 0,
        marginTop: 0,
        borderRadius: "6px",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        marginLeft: "10px",
        overflowY: theme2.overlay
      },
      innerProps: {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.popup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalTitle }, "Create new booking limit"), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: {
          display: "flex",
          height: "16px",
          width: "16px",
          text: {
            display: "flex",
            alignItems: "center"
          }
        },
        onClick: onClose
      },
      /* @__PURE__ */ React__default.createElement(CloseSVG, { style: { width: "16px", height: "16px" } })
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalDescription }, "1. Where & when it applies"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.inputFields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Area",
        items: areasList,
        value: selectedArea,
        style: cleanDropdownPopoverStyles,
        onSelect: setSelectedArea,
        placeholder: "Select area",
        error: selectedAreaError,
        clearError: () => setSelectedAreaError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Day/Date",
        items: dayOptions,
        value: dayType,
        style: cleanDropdownPopoverStyles,
        onSelect: setDayType,
        placeholder: "Empty",
        error: dayTypeError,
        clearError: () => setDayTypeError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: dayType === "weekdays" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Days",
          items: weekdays(),
          value: conditionDays,
          selectedItems: conditionDays,
          style: cleanDropdownPopoverStyles,
          onSelect: toggleDay,
          placeholder: "Empty",
          multiselect: true,
          multiselectFormat: getDayRange,
          error: conditionDaysError,
          clearError: () => setConditionDaysError(null),
          ...popoverAnchors
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: dayType === "date" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "Specific Date",
          items: weekdays(),
          value: date,
          format: "DD/MM/YYYY",
          style: cleanDropdownPopoverStyles,
          onSelect: (value) => setDate(value),
          placeholder: "Empty",
          error: dateError,
          clearError: () => setDateError(null),
          ...popoverAnchors
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: dayType === "dateRange" ? "110px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "Start date",
          value: startDate,
          format: "DD/MM/YYYY",
          style: cleanDropdownPopoverStyles,
          onSelect: (value) => setStartDate(value),
          placeholder: "Empty",
          datePickerProps: { disablePast: true },
          error: startDateError,
          clearError: () => setStartDateError(null),
          ...popoverAnchors
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "End date",
          value: endDate,
          format: "DD/MM/YYYY",
          style: cleanDropdownPopoverStyles,
          onSelect: (value) => setEndDate(value),
          placeholder: "Empty",
          datePickerProps: { minDate: startDate },
          error: endDateError,
          clearError: () => setEndDateError(null),
          ...popoverAnchors
        }
      )
    )), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalDescription }, "2. Limit details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.inputFields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Start time",
        items: startTimes,
        value: startTime,
        style: cleanDropdownPopoverStyles,
        onSelect: changeStartTime,
        error: startTimeError,
        clearError: () => setStartTimeError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "End time",
        items: endTimes,
        value: endTime,
        style: cleanDropdownPopoverStyles,
        onSelect: changeEndTime,
        error: endTimeError,
        clearError: () => setEndTimeError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Limit Type",
        items: limitTypeOptions,
        value: limitType,
        style: cleanDropdownPopoverStyles,
        onSelect: setLimitType,
        placeholder: "Empty",
        error: limitTypeError,
        clearError: () => setLimitTypeError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: limitType === "maxGuests" || limitType === "maxGroups" ? "110px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanTextFieldComponent,
        {
          label: `Max ${limitType === "maxGuests" ? "guests" : "groups"}`,
          value: limitAmount,
          onChange: setLimitAmount,
          style: fieldStyles,
          placeholder: "Empty",
          error: limitAmountError,
          clearError: () => setLimitAmountError(null)
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Time interval",
          items: timeIntervals,
          value: timeInterval,
          style: cleanDropdownPopoverStyles,
          onSelect: setTimeInterval,
          placeholder: "Empty",
          error: timeIntervalError,
          clearError: () => setTimeIntervalError(null),
          ...popoverAnchors
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: limitType === "maxGroups" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        GroupSizeSelector$1,
        {
          onSave: setGroupSize,
          groupSize,
          error: groupSizeError,
          clearError: () => setGroupSizeError(null)
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Source",
        items: sources,
        value: source,
        style: cleanDropdownPopoverStyles,
        onSelect: setSource,
        placeholder: "Empty",
        error: sourceError,
        clearError: () => setSourceError(null),
        ...popoverAnchors
      }
    )))))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.footer }, /* @__PURE__ */ React__default.createElement(Button, { type: "secondary", style: largeButtonStyles(theme2), onClick: onClose }, "Cancel"), /* @__PURE__ */ React__default.createElement(Button, { style: largeButtonStyles(theme2), onClick: addCondition, disabled: saving.current }, "Add limit")))
  );
};
AddConditionModal.defaultProps = {
  anchor: null
};
AddConditionModal.propTypes = {
  areas: areasPropTypes.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.shape({}),
  restaurantOpen: PropTypes.number.isRequired,
  restaurantClose: PropTypes.number.isRequired,
  createBookingLimit: PropTypes.func.isRequired
};
const mapStateToProps$21 = (state) => ({
  areas: state.areas
});
const mapDispatchToProps$20 = (dispatch) => bindActionCreators(
  {
    createBookingLimit: createConditionAction
  },
  dispatch
);
const AddConditionModal$1 = connect(mapStateToProps$21, mapDispatchToProps$20)(AddConditionModal);
const AddRuleModal = ({
  areas,
  isOpen,
  onClose,
  anchor,
  restaurantOpen,
  restaurantClose,
  createBookingLimitRule,
  condition,
  defaultLimitType
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$13({ noBooking: false });
  const interval = 15;
  const saving = useRef(false);
  const [limitType, setLimitType] = useState(null);
  const [limitAmount, setLimitAmount] = useState(null);
  const [timeInterval, setTimeInterval] = useState(null);
  const [groupSize, setGroupSize] = useState({ option: "more", min: 8, max: 10, exact: 10 });
  const [startTimes, endTimes, startTime, endTime, setStartTime, setEndTime] = useStartAndEndTimes(
    interval,
    restaurantOpen,
    restaurantClose
  );
  const [source, setSource] = useState("all");
  const [limitTypeError, setLimitTypeError] = useState(null);
  const [limitAmountError, setLimitAmountError] = useState(null);
  const [timeIntervalError, setTimeIntervalError] = useState(null);
  const [groupSizeError, setGroupSizeError] = useState(null);
  const [startTimeError, setStartTimeError] = useState(null);
  const [endTimeError, setEndTimeError] = useState(null);
  const [sourceError, setSourceError] = useState(null);
  const clearErrors = () => {
    unstable_batchedUpdates(() => {
      setLimitTypeError(null);
      setLimitAmountError(null);
      setTimeIntervalError(null);
      setGroupSizeError(null);
      setStartTimeError(null);
      setEndTimeError(null);
      setSourceError(null);
    });
  };
  useEffect(() => {
    if (isOpen) {
      setLimitType(defaultLimitType);
      setLimitAmount(null);
      setTimeInterval(null);
      setGroupSize({ option: "more", min: 8, max: 10, exact: 10 });
      setStartTime("allDay");
      setEndTime("allDay");
      setSource("all");
      clearErrors();
      saving.current = false;
    }
  }, [isOpen]);
  const title = useMemo(() => {
    switch (limitType) {
      case "maxGuests":
        return "Add guest limit";
      case "maxGroups":
        return "Add group limit";
      default:
        return "Add limit";
    }
  }, [limitType]);
  const validate = () => {
    let isValid = true;
    const requiredFields = [
      { value: limitType, setError: setLimitTypeError },
      ...limitType === "noBookings" ? [] : [{ value: limitAmount, setError: setLimitAmountError }],
      // if `Limit Type` is `Don't allow any bookings` we can't set a limitAmount
      { value: startTime, setError: setStartTimeError },
      { value: endTime, setError: setEndTimeError }
    ];
    requiredFields.forEach((field) => {
      if (isEmpty(field.value)) {
        field.setError("This field is required");
        isValid = false;
      }
    });
    if (limitType === "maxGroups" && (groupSize == null ? void 0 : groupSize.option) === null) {
      setGroupSizeError("Group size is not valid");
      isValid = false;
    }
    return isValid;
  };
  const addLimit = () => {
    saving.current = true;
    const isValid = validate();
    if (!isValid) {
      saving.current = false;
      return;
    }
    createBookingLimitRule(
      {
        limitType,
        limitAmount,
        timeInterval,
        groupSize,
        startTime,
        endTime,
        source
      },
      condition
    );
    onClose();
  };
  const areasList = useMemo(
    () => [
      { label: "All areas", value: "all" },
      ...areas.data.map((area) => ({
        label: area == null ? void 0 : area.name,
        value: area == null ? void 0 : area.id
      }))
    ],
    [areas.data]
  );
  const selectedArea = valueIfValue(condition == null ? void 0 : condition.areaId, -1, "all");
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen,
      onClose,
      anchorEl: anchor,
      style: popoverWithBackgroundStyles,
      innerStyle: {
        padding: 0,
        marginTop: "10px",
        borderRadius: "6px",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        overflowY: theme2.overflow
      },
      innerProps: {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.popup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalTitle }, title), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: {
          display: "flex",
          height: "16px",
          width: "16px",
          text: {
            display: "flex",
            alignItems: "center"
          }
        },
        onClick: onClose
      },
      /* @__PURE__ */ React__default.createElement(CloseSVG, { style: { width: "16px", height: "16px" } })
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalDescription }, "1. Where & when it applies"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.inputFields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Area",
        items: areasList,
        value: selectedArea,
        style: cleanDropdownPopoverStyles,
        placeholder: "Select area",
        disabled: true
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Day/Date",
        items: dayOptions,
        value: condition == null ? void 0 : condition.dayType,
        style: cleanDropdownPopoverStyles,
        placeholder: "Empty",
        disabled: true
      }
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: (condition == null ? void 0 : condition.dayType) === "weekdays" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Days",
          items: weekdays(),
          value: condition == null ? void 0 : condition.days,
          selectedItems: condition == null ? void 0 : condition.days,
          style: cleanDropdownPopoverStyles,
          placeholder: "Empty",
          multiselect: true,
          multiselectFormat: getDayRange,
          disabled: true
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: (condition == null ? void 0 : condition.dayType) === "date" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "Specific Date",
          items: weekdays(),
          value: condition == null ? void 0 : condition.startDate,
          format: "DD-MM-YYYY",
          style: cleanDropdownPopoverStyles,
          placeholder: "Empty",
          disabled: true
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: (condition == null ? void 0 : condition.dayType) === "dateRange" ? "110px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "Start date",
          value: condition == null ? void 0 : condition.startDate,
          format: "DD-MM-YYYY",
          style: cleanDropdownPopoverStyles,
          placeholder: "Empty",
          disabled: true
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "End date",
          value: condition == null ? void 0 : condition.endDate,
          format: "DD-MM-YYYY",
          style: cleanDropdownPopoverStyles,
          placeholder: "Empty",
          disabled: true
        }
      )
    )), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalDescription }, "2. Limit details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.inputFields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Start time",
        items: startTimes,
        value: startTime,
        style: cleanDropdownPopoverStyles,
        onSelect: setStartTime,
        error: startTimeError,
        clearError: () => setStartTimeError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "End time",
        items: endTimes,
        value: endTime,
        style: cleanDropdownPopoverStyles,
        onSelect: setEndTime,
        error: endTimeError,
        clearError: () => setEndTimeError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Limit Type",
        items: limitTypeOptions,
        value: limitType,
        style: cleanDropdownPopoverStyles,
        onSelect: setLimitType,
        placeholder: "Empty",
        error: limitTypeError,
        clearError: () => setLimitTypeError(null),
        ...popoverAnchors,
        disabled: true
      }
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: limitType === "maxGuests" || limitType === "maxGroups" ? "110px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanTextFieldComponent,
        {
          label: `Max ${limitType === "maxGuests" ? "guests" : "groups"}`,
          value: limitAmount,
          onChange: setLimitAmount,
          style: fieldStyles(theme2),
          placeholder: "Empty",
          error: limitAmountError,
          clearError: () => setLimitAmountError(null)
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Time interval",
          items: timeIntervals,
          value: timeInterval,
          style: cleanDropdownPopoverStyles,
          onSelect: setTimeInterval,
          placeholder: "Empty",
          error: timeIntervalError,
          clearError: () => setTimeIntervalError(null),
          ...popoverAnchors
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: limitType === "maxGroups" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        GroupSizeSelector$1,
        {
          onSave: setGroupSize,
          groupSize,
          error: groupSizeError,
          clearError: () => setGroupSizeError(null)
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Source",
        items: sources,
        value: source,
        style: cleanDropdownPopoverStyles,
        onSelect: setSource,
        placeholder: "Empty",
        error: sourceError,
        clearError: () => setSourceError(null),
        ...popoverAnchors
      }
    )))))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.footer }, /* @__PURE__ */ React__default.createElement(Button, { type: "secondary", style: largeButtonStyles(theme2), onClick: onClose }, "Cancel"), /* @__PURE__ */ React__default.createElement(Button, { style: largeButtonStyles(theme2), onClick: addLimit, disabled: saving.current }, "Add limit")))
  ));
};
AddRuleModal.defaultProps = {
  anchor: null,
  bookingLimitId: null,
  condition: null,
  defaultLimitType: null
};
AddRuleModal.propTypes = {
  areas: areasPropTypes.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.shape({}),
  restaurantOpen: PropTypes.number.isRequired,
  restaurantClose: PropTypes.number.isRequired,
  createBookingLimitRule: PropTypes.func.isRequired,
  bookingLimitId: PropTypes.string,
  condition: bookingLimitPropTypes,
  defaultLimitType: PropTypes.string
};
const mapStateToProps$20 = (state) => ({
  areas: state.areas
});
const mapDispatchToProps$1$ = (dispatch) => bindActionCreators(
  {
    createBookingLimitRule: createBookingLimitRuleAction
  },
  dispatch
);
const AddRuleModal$1 = connect(mapStateToProps$20, mapDispatchToProps$1$)(AddRuleModal);
const EditRuleModal = ({
  areas,
  isOpen,
  onClose,
  anchor,
  restaurantOpen,
  restaurantClose,
  updateBookingLimitRule,
  condition,
  rule
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$13({ noBooking: false });
  const interval = 15;
  const saving = useRef(false);
  const [limitType, setLimitType] = useState(null);
  const [limitAmount, setLimitAmount] = useState(null);
  const [timeInterval, setTimeInterval] = useState(null);
  const [groupSize, setGroupSize] = useState({ option: "more", min: 8, max: 10, exact: 10 });
  const [startTimes, endTimes, startTime, endTime, setStartTime, setEndTime] = useStartAndEndTimes(
    interval,
    restaurantOpen,
    restaurantClose,
    isEmpty(rule == null ? void 0 : rule.startTime) ? "allDay" : rule == null ? void 0 : rule.startTime,
    isEmpty(rule == null ? void 0 : rule.endTime) ? "allDay" : rule == null ? void 0 : rule.endTime
  );
  const [source, setSource] = useState("all");
  const [limitTypeError, setLimitTypeError] = useState(null);
  const [limitAmountError, setLimitAmountError] = useState(null);
  const [timeIntervalError, setTimeIntervalError] = useState(null);
  const [groupSizeError, setGroupSizeError] = useState(null);
  const [startTimeError, setStartTimeError] = useState(null);
  const [endTimeError, setEndTimeError] = useState(null);
  const [sourceError, setSourceError] = useState(null);
  const clearErrors = () => {
    unstable_batchedUpdates(() => {
      setLimitTypeError(null);
      setLimitAmountError(null);
      setTimeIntervalError(null);
      setGroupSizeError(null);
      setStartTimeError(null);
      setEndTimeError(null);
      setSourceError(null);
    });
  };
  useEffect(() => {
    if (isOpen) {
      setLimitType((rule == null ? void 0 : rule.limitType) || null);
      setLimitAmount((rule == null ? void 0 : rule.limitAmount) || null);
      setTimeInterval(isEmpty(rule == null ? void 0 : rule.timeInterval) ? null : rule == null ? void 0 : rule.timeInterval);
      setGroupSize((rule == null ? void 0 : rule.groupSize) || { option: "more", min: 8, max: 10, exact: 10 });
      setStartTime(isEmpty(rule == null ? void 0 : rule.startTime) ? "allDay" : rule == null ? void 0 : rule.startTime);
      setEndTime(isEmpty(rule == null ? void 0 : rule.endTime) ? "allDay" : rule == null ? void 0 : rule.endTime);
      setSource(isEmpty(rule == null ? void 0 : rule.source) ? "all" : rule == null ? void 0 : rule.source);
      clearErrors();
      saving.current = false;
    }
  }, [isOpen, rule]);
  const title = useMemo(() => {
    switch (limitType) {
      case "maxGuests":
        return "Edit guest limit";
      case "maxGroups":
        return "Edit group limit";
      default:
        return "Edit limit";
    }
  }, [limitType]);
  const validate = () => {
    let isValid = true;
    const requiredFields = [
      { value: limitType, setError: setLimitTypeError },
      ...limitType === "noBookings" ? [] : [{ value: limitAmount, setError: setLimitAmountError }],
      // if `Limit Type` is `Don't allow any bookings` we can't set a limitAmount
      { value: startTime, setError: setStartTimeError },
      { value: endTime, setError: setEndTimeError }
    ];
    requiredFields.forEach((field) => {
      if (isEmpty(field.value)) {
        field.setError("This field is required");
        isValid = false;
      }
    });
    if (limitType === "maxGroups" && (groupSize == null ? void 0 : groupSize.option) === null) {
      setGroupSizeError("Group size is not valid");
      isValid = false;
    }
    return isValid;
  };
  const editLimit = () => {
    saving.current = true;
    const isValid = validate();
    if (!isValid) {
      saving.current = false;
      return;
    }
    updateBookingLimitRule(
      {
        ...rule,
        limitType,
        limitAmount,
        timeInterval,
        groupSize,
        startTime,
        endTime,
        source
      },
      condition
    );
    onClose();
  };
  const areasList = useMemo(
    () => [
      { label: "All areas", value: "all" },
      ...areas.data.map((area) => ({
        label: area == null ? void 0 : area.name,
        value: area == null ? void 0 : area.id
      }))
    ],
    [areas.data]
  );
  const selectedArea = valueIfValue(condition == null ? void 0 : condition.areaId, -1, "all");
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen,
      onClose,
      anchorEl: anchor,
      style: popoverStyles$5,
      innerStyle: {
        padding: 0,
        marginTop: 0,
        borderRadius: "6px",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        marginLeft: "10px",
        overflowY: theme2.overlay
      },
      innerProps: {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.popup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalTitle }, title), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: {
          display: "flex",
          height: "16px",
          width: "16px",
          text: {
            display: "flex",
            alignItems: "center"
          }
        },
        onClick: onClose
      },
      /* @__PURE__ */ React__default.createElement(CloseSVG, { style: { width: "16px", height: "16px" } })
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalDescription }, "1. Where & when it applies"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.inputFields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Area",
        items: areasList,
        value: selectedArea,
        style: cleanDropdownPopoverStyles,
        placeholder: "Select area",
        ...popoverAnchors,
        disabled: true
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Day/Date",
        items: dayOptions,
        value: condition == null ? void 0 : condition.dayType,
        style: cleanDropdownPopoverStyles,
        placeholder: "Empty",
        disabled: true
      }
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: (condition == null ? void 0 : condition.dayType) === "weekdays" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Days",
          items: weekdays(),
          value: condition == null ? void 0 : condition.days,
          selectedItems: condition == null ? void 0 : condition.days,
          style: cleanDropdownPopoverStyles,
          placeholder: "Empty",
          multiselect: true,
          multiselectFormat: getDayRange,
          disabled: true
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: (condition == null ? void 0 : condition.dayType) === "date" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "Specific Date",
          items: weekdays(),
          value: condition == null ? void 0 : condition.startDate,
          format: "DD-MM-YYYY",
          style: cleanDropdownPopoverStyles,
          placeholder: "Empty",
          disabled: true
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: (condition == null ? void 0 : condition.dayType) === "dateRange" ? "110px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "Start date",
          value: condition == null ? void 0 : condition.startDate,
          format: "DD-MM-YYYY",
          style: cleanDropdownPopoverStyles,
          placeholder: "Empty",
          disabled: true
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        CleanDatePopover$1,
        {
          label: "End date",
          value: condition == null ? void 0 : condition.endDate,
          format: "DD-MM-YYYY",
          style: cleanDropdownPopoverStyles,
          placeholder: "Empty",
          disabled: true
        }
      )
    )), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalDescription }, "2. Limit details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.inputFields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Start time",
        items: startTimes,
        value: startTime,
        onSelect: setStartTime,
        error: startTimeError,
        style: cleanDropdownPopoverStyles,
        clearError: () => setStartTimeError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "End time",
        items: endTimes,
        value: endTime,
        onSelect: setEndTime,
        error: endTimeError,
        style: cleanDropdownPopoverStyles,
        clearError: () => setEndTimeError(null),
        ...popoverAnchors
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Limit Type",
        items: limitTypeOptions,
        value: limitType,
        style: cleanDropdownPopoverStyles,
        onSelect: setLimitType,
        placeholder: "Empty",
        error: limitTypeError,
        clearError: () => setLimitTypeError(null),
        ...popoverAnchors,
        disabled: true
      }
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: limitType === "maxGuests" || limitType === "maxGroups" ? "110px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        CleanTextFieldComponent,
        {
          label: `Max ${limitType === "maxGuests" ? "guests" : "groups"}`,
          value: limitAmount,
          onChange: setLimitAmount,
          style: fieldStyles,
          placeholder: "Empty",
          error: limitAmountError,
          clearError: () => setLimitAmountError(null)
        }
      ),
      /* @__PURE__ */ React__default.createElement(
        CleanDropdownPopover$1,
        {
          label: "Time interval",
          items: timeIntervals,
          value: timeInterval,
          style: cleanDropdownPopoverStyles,
          onSelect: setTimeInterval,
          placeholder: "Empty",
          error: timeIntervalError,
          clearError: () => setTimeIntervalError(null),
          ...popoverAnchors
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.hiddenInputFields,
        style: {
          maxHeight: limitType === "maxGroups" ? "60px" : 0
        }
      },
      /* @__PURE__ */ React__default.createElement(
        GroupSizeSelector$1,
        {
          onSave: setGroupSize,
          groupSize,
          error: groupSizeError,
          clearError: () => setGroupSizeError(null)
        }
      )
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        label: "Source",
        items: sources,
        value: source,
        style: cleanDropdownPopoverStyles,
        onSelect: setSource,
        placeholder: "Empty",
        error: sourceError,
        clearError: () => setSourceError(null),
        ...popoverAnchors
      }
    )))))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.footer }, /* @__PURE__ */ React__default.createElement(Button, { type: "secondary", style: largeButtonStyles(theme2), onClick: onClose }, "Cancel"), /* @__PURE__ */ React__default.createElement(Button, { style: largeButtonStyles(theme2), onClick: editLimit, disabled: saving.current }, "Update limit")))
  ));
};
EditRuleModal.defaultProps = {
  anchor: null,
  bookingLimitId: null,
  rule: null,
  condition: null
};
EditRuleModal.propTypes = {
  areas: areasPropTypes.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.shape({}),
  restaurantOpen: PropTypes.number.isRequired,
  restaurantClose: PropTypes.number.isRequired,
  updateBookingLimitRule: PropTypes.func.isRequired,
  bookingLimitId: PropTypes.string,
  rule: rulePropTypes,
  condition: bookingLimitPropTypes
};
const mapStateToProps$1$ = (state) => ({
  areas: state.areas
});
const mapDispatchToProps$1_ = (dispatch) => bindActionCreators(
  {
    updateBookingLimitRule: updateBookingLimitRuleAction
  },
  dispatch
);
const EditRuleModal$1 = connect(mapStateToProps$1$, mapDispatchToProps$1_)(EditRuleModal);
const DeleteBookingLimitModal = ({ bookingLimit, onClose, deleteBookingLimit, isOpen }) => {
  const handleDelete = () => {
    deleteBookingLimit(bookingLimit == null ? void 0 : bookingLimit.objectId);
    onClose();
  };
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      isOpen: isOpen && !isEmpty(bookingLimit),
      onClose,
      onConfirm: handleDelete,
      heading: "Delete booking limit",
      prompt: "This will remove all of the booking limits for that area and day. Please confirm you want to proceed",
      confirmLabel: "Delete"
    }
  );
};
DeleteBookingLimitModal.defaultProps = {
  bookingLimit: null
};
DeleteBookingLimitModal.propTypes = {
  deleteBookingLimit: PropTypes.func.isRequired,
  bookingLimit: bookingLimitPropTypes,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};
const mapStateToProps$1_ = () => ({});
const mapDispatchToProps$1Z = (dispatch) => bindActionCreators(
  {
    deleteBookingLimit: deleteBookingLimitAction
  },
  dispatch
);
const DeleteBookingLimitModal$1 = connect(mapStateToProps$1_, mapDispatchToProps$1Z)(DeleteBookingLimitModal);
const DeleteBookingLimitRuleModal = ({ limit, rule, onClose, deleteBookingLimitRule, isOpen }) => {
  const handleDelete = () => {
    deleteBookingLimitRule(limit == null ? void 0 : limit.objectId, rule == null ? void 0 : rule.objectId);
    onClose();
  };
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      isOpen: isOpen && !isEmpty(rule),
      onClose,
      onConfirm: handleDelete,
      heading: "Delete limit",
      prompt: "This will remove the limit. Please confirm you want to proceed",
      confirmLabel: "Delete"
    }
  );
};
DeleteBookingLimitRuleModal.defaultProps = {
  limit: null,
  rule: null
};
DeleteBookingLimitRuleModal.propTypes = {
  deleteBookingLimitRule: PropTypes.func.isRequired,
  limit: bookingLimitPropTypes,
  rule: rulePropTypes,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};
const mapStateToProps$1Z = () => ({});
const mapDispatchToProps$1Y = (dispatch) => bindActionCreators(
  {
    deleteBookingLimitRule: deleteBookingLimitRuleAction
  },
  dispatch
);
const DeleteBookingLimitRuleModal$1 = connect(mapStateToProps$1Z, mapDispatchToProps$1Y)(DeleteBookingLimitRuleModal);
const SvgTime = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 9, cy: 9, r: 8.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.67891 10.9283L8.67891 4.00003", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 9, y1: 10.4283, x2: 12.8571, y2: 10.4283, stroke: "currentColor" }));
const TimeIconSVG = SvgTime;
const SvgDisabled = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 7C13 10.3137 10.3137 13 7 13C5.50492 13 4.13756 12.4532 3.08701 11.5486L11.5633 3.1041C12.4591 4.15236 13 5.51301 13 7ZM2.38585 10.8356L10.8528 2.40029C9.8105 1.52627 8.46671 1 7 1C3.68629 1 1 3.68629 1 7C1 8.45862 1.52048 9.79567 2.38585 10.8356ZM14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z", fill: "currentColor" }));
const DisabledSVG = SvgDisabled;
const NoBookingRuleBlock = ({ rule, onEdit, startTime, endTime }) => {
  const classes = useStyles$13({ noBooking: true });
  const interval = 15;
  const ruleStartTime = valueIfValue(rule.startTime, "allDay", startTime);
  const ruleEndTime = valueIfValue(rule.endTime, "allDay", endTime);
  const getBlockHeight = () => {
    return Math.max(30, ruleEndTime - ruleStartTime) / interval * cellHeight - ruleBlockPadding * 2;
  };
  const groupSizeText = getGroupSize(rule);
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.limitItem} ${classes.limitItemNoBooking}`,
      style: {
        top: Math.max(0, ruleStartTime - startTime) / interval * cellHeight + ruleBlockPadding,
        height: getBlockHeight(),
        width: "920px"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.columnContainerTop }),
    /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.limitItemContents} ${classes.limitItemContentsNoBooking}` }, /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: iconButtonStyles$1, onClick: onEdit }, /* @__PURE__ */ React__default.createElement(KebabSvg, { style: { height: "18px" } })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.columnHeading }, "Don't allow any bookings"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.flexRow }, /* @__PURE__ */ React__default.createElement(TimeIconSVG, { style: { height: "15px", width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.ruleDetails }, getTimeRange(rule))), groupSizeText && /* @__PURE__ */ React__default.createElement(Box, { className: classes.flexRow }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { height: "15px", width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.ruleDetails }, groupSizeText)), rule.source !== "all" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.flexRow }, /* @__PURE__ */ React__default.createElement(DisabledSVG, { style: { height: "15px", width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.ruleDetails }, getLabelForValue(rule.source, sources))))
  );
};
NoBookingRuleBlock.defaultProps = {
  startTime: 0,
  endTime: 1439
};
NoBookingRuleBlock.propTypes = {
  rule: rulePropTypes.isRequired,
  onEdit: PropTypes.func.isRequired,
  startTime: PropTypes.number,
  // Restaurant start time
  endTime: PropTypes.number
  // Restaurant end time
};
const mapStateToProps$1Y = (dispatch) => bindActionCreators({}, dispatch);
const mapDispatchToProps$1X = (dispatch) => bindActionCreators({}, dispatch);
const NoBookingRuleBlock$1 = connect(mapStateToProps$1Y, mapDispatchToProps$1X)(NoBookingRuleBlock);
const RuleBlock = ({ rule, onEdit, startTime, endTime }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$13({ noBooking: false });
  const interval = 15;
  const ruleStartTime = valueIfValue(rule.startTime, "allDay", startTime);
  const ruleEndTime = valueIfValue(rule.endTime, "allDay", endTime);
  const getBlockHeight = () => {
    return Math.max(30, ruleEndTime - ruleStartTime) / interval * cellHeight - ruleBlockPadding * 2;
  };
  const groupSizeText = getGroupSize(rule);
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.limitItem,
      style: {
        top: Math.max(0, ruleStartTime - startTime) / interval * cellHeight + ruleBlockPadding,
        height: getBlockHeight()
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.columnContainerTop }),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.limitItemContents }, /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: iconButtonStyles$1(theme2), onClick: onEdit }, /* @__PURE__ */ React__default.createElement(KebabSvg, { style: { height: "15px" } })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.columnHeading }, getLimitSize(rule), " ", getTimeInterval(rule)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.flexRow }, /* @__PURE__ */ React__default.createElement(TimeIconSVG, { style: { height: "15px", width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.ruleDetails }, getTimeRange(rule))), groupSizeText && /* @__PURE__ */ React__default.createElement(Box, { className: classes.flexRow }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { height: "15px", width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.ruleDetails }, groupSizeText)))
  );
};
RuleBlock.defaultProps = {
  startTime: 0,
  endTime: 1439
};
RuleBlock.propTypes = {
  rule: rulePropTypes.isRequired,
  onEdit: PropTypes.func.isRequired,
  startTime: PropTypes.number,
  // Restaurant start time
  endTime: PropTypes.number
  // Restaurant end time
};
const mapStateToProps$1X = (dispatch) => bindActionCreators({}, dispatch);
const mapDispatchToProps$1W = (dispatch) => bindActionCreators({}, dispatch);
const RuleBlock$1 = connect(mapStateToProps$1X, mapDispatchToProps$1W)(RuleBlock);
const SvgTimeslotGroup = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 33 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M23.0113 12.8969C23.2649 19.0694 20.1875 23.0694 15.2164 23.6383C9.99157 23.8452 5.24023 18.6973 5.24023 12.7245C5.24023 6.56934 8.58682 2.15556 13.5257 2.15556C18.4645 2.15556 22.6731 7.00038 23.0113 12.8969Z", fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("path", { d: "M13.6531 23.4458C9.60536 21.8435 6.48047 17.3669 6.48047 12.3478C6.48047 5.73912 10.0736 1.0001 15.3764 1.0001C20.6792 1.0001 25.1979 6.20192 25.561 12.533C25.6923 15.7304 24.9912 18.385 23.6308 20.3447", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M22.7767 19.2392C22.8195 19.1751 22.8614 19.1101 22.9026 19.0444C23.9557 17.3623 24.4912 15.1503 24.383 12.5186C24.0649 6.97043 20.105 2.41188 15.458 2.41188C10.8109 2.41188 7.66211 6.56486 7.66211 12.3563C7.66211 16.7935 10.4491 20.7469 14.0418 22.1185", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.0148 12.5397C18.0064 12.5077 18.008 12.4868 18.0088 12.4802C18.0097 12.4726 18.0113 12.467 18.0139 12.4609C18.0163 12.4555 18.0243 12.4392 18.0446 12.4184C18.0655 12.397 18.1069 12.3638 18.1717 12.3462C18.1718 12.3461 18.1719 12.3461 18.172 12.3461C18.314 12.3074 18.4024 12.3779 18.4101 12.3846C18.4188 12.392 18.4223 12.3972 18.4238 12.3996C18.4251 12.4016 18.429 12.4081 18.4329 12.4213C18.4321 12.4228 18.4313 12.4244 18.4304 12.4262C18.4265 12.4338 18.4208 12.4434 18.4127 12.4544C18.3879 12.4883 18.3303 12.5478 18.232 12.5747C18.2319 12.5747 18.2318 12.5747 18.2317 12.5747C18.1379 12.6003 18.0671 12.5795 18.0411 12.5694C18.0328 12.5662 18.0263 12.5631 18.0214 12.5604C18.0194 12.5553 18.0171 12.5484 18.0148 12.5397ZM18.0106 12.5536C18.0106 12.5536 18.011 12.5539 18.0117 12.5545L18.0106 12.5536ZM18.0263 12.5713C18.0269 12.5722 18.0271 12.5727 18.0271 12.5727L18.0263 12.5713Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17.5991 12.0882C17.5924 12.0882 17.5542 12.0815 17.4885 12.0687M17.5991 12.7637C17.5801 12.7494 17.5427 12.7303 17.4885 12.7067M17.5991 12.7637C17.9044 12.993 17.6526 12.8212 17.4885 12.7067M17.5991 12.7637C17.4746 12.563 17.2782 12.143 17.4885 12.0687M17.4885 12.7067C16.6729 12.3519 12.0954 11.1521 9.73047 10.328C10.5065 10.433 16.5735 11.8911 17.4885 12.0687", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.981 12.2182C18.8934 12.0865 18.6987 11.8063 18.6211 11.7387C19.5063 11.355 21.5168 9.16254 22.2872 8.39258C21.5408 9.24005 19.751 11.0992 18.981 12.2182Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.305 29.2242L14.2876 24.0063C15.7413 20.1805 20.9246 19.6262 23.1544 23.0582L26.5444 28.276C28.7055 31.6024 26.3183 36.0001 22.3516 36.0001H16.979C13.4788 36.0001 11.0618 32.4962 12.305 29.2242Z", fill: "#F7D2D2" }), /* @__PURE__ */ React$7.createElement("path", { d: "M21.1119 24.5096C21.1119 24.7433 21.0525 24.9077 20.982 25.0008C20.9237 25.0777 20.8419 25.1312 20.6921 25.1312C20.516 25.1312 20.3043 25.0545 20.138 24.9172C19.9719 24.78 19.9043 24.6297 19.9043 24.5096C19.9043 24.1587 20.1822 23.888 20.5081 23.888C20.834 23.888 21.1119 24.1587 21.1119 24.5096Z", fill: "#FDF2F2", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.9629 27.4613V28.0246C18.9629 28.3834 19.2426 28.6795 19.601 28.6965C20.082 28.7193 20.7619 28.7483 21.3778 28.7627C21.751 28.7715 22.0011 28.4741 21.9371 28.1063C21.8873 27.8198 21.8404 27.48 21.8404 27.1567C21.8404 26.7424 21.6543 26.4371 21.4225 26.2595C21.1519 26.052 20.7959 26.2414 20.4549 26.2414C20.385 26.2414 20.3169 26.2334 20.2542 26.2207C20.035 26.1763 19.782 26.0619 19.5932 26.1818C19.1751 26.4475 18.9629 27.161 18.9629 27.4613Z", fill: "#FDF2F2", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17.5787 27.6029C17.5787 27.8366 17.5193 28.0011 17.4488 28.0941C17.3905 28.171 17.3087 28.2245 17.1589 28.2245C16.9828 28.2245 16.7711 28.1478 16.6048 28.0105C16.4387 27.8733 16.3711 27.723 16.3711 27.6029C16.3711 27.252 16.6489 26.9813 16.9749 26.9813C17.3008 26.9813 17.5787 27.252 17.5787 27.6029Z", fill: "#FDF2F2", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M15.4297 30.5546V31.1179C15.4297 31.4767 15.7094 31.7728 16.0678 31.7898C16.5488 31.8126 17.2287 31.8416 17.8446 31.8561C18.2178 31.8648 18.4679 31.5674 18.4039 31.1996C18.3541 30.9132 18.3072 30.5733 18.3072 30.25C18.3072 29.8357 18.1211 29.5304 17.8893 29.3528C17.6187 29.1453 17.2627 29.3347 16.9217 29.3347C16.8518 29.3347 16.7837 29.3268 16.721 29.3141C16.5018 29.2696 16.2488 29.1552 16.06 29.2752C15.6419 29.5408 15.4297 30.2544 15.4297 30.5546Z", fill: "#FDF2F2", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M24.6432 27.6029C24.6432 27.8366 24.5838 28.0011 24.5133 28.0941C24.455 28.171 24.3732 28.2245 24.2233 28.2245C24.0472 28.2245 23.8355 28.1478 23.6692 28.0105C23.5031 27.8733 23.4355 27.723 23.4355 27.6029C23.4355 27.252 23.7134 26.9813 24.0394 26.9813C24.3653 26.9813 24.6432 27.252 24.6432 27.6029Z", fill: "#FDF2F2", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M22.4941 30.5546V31.1179C22.4941 31.4767 22.7738 31.7728 23.1322 31.7898C23.6132 31.8126 24.2931 31.8416 24.9091 31.8561C25.2823 31.8648 25.5323 31.5674 25.4684 31.1996C25.4186 30.9132 25.3716 30.5733 25.3716 30.25C25.3716 29.8357 25.1855 29.5304 24.9538 29.3528C24.6832 29.1453 24.3272 29.3347 23.9862 29.3347C23.9162 29.3347 23.8482 29.3268 23.7855 29.3141C23.5662 29.2696 23.3132 29.1552 23.1245 29.2752C22.7064 29.5408 22.4941 30.2544 22.4941 30.5546Z", fill: "#FDF2F2", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.6072 31.2204L16.6886 20.4788C17.5608 18.1833 20.6708 17.8507 22.0087 19.9099L28.9875 30.6515C30.2841 32.6473 28.8518 35.2859 26.4718 35.2859H15.4116C13.3115 35.2859 11.8613 33.1836 12.6072 31.2204Z", stroke: "black" }), /* @__PURE__ */ React$7.createElement("path", { d: "M27.7755 18.2883C28.3849 17.8946 29.192 17.1761 29.5806 16.5608", stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M28.2383 19.9579L31.5624 18.963", stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M28.6211 21.7561C29.1168 21.8188 30.3987 21.7936 30.6906 22.2958", stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.78551 18.8334C-1.13861 24.3906 -1.13851 31.8363 9.69701 27.573", stroke: "black" }), /* @__PURE__ */ React$7.createElement("path", { d: "M6.0094 20.3982C1.02776 24.3964 1.02783 29.7532 8.82356 26.686", stroke: "black" }));
const GroupLimitSVG = SvgTimeslotGroup;
const SvgTimeslotGuest = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 33 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M23.0101 12.8968C23.2637 19.0693 20.1865 23.0693 15.2157 23.6382C9.99125 23.8451 5.24023 18.6972 5.24023 12.7244C5.24023 6.56926 8.58659 2.15547 13.5251 2.15547C18.4636 2.15547 22.6719 7.00029 23.0101 12.8968Z", fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("path", { d: "M13.6604 23.4457C9.61296 21.8434 6.48828 17.3668 6.48828 12.3477C6.48828 5.73901 10.0812 1 15.3836 1C20.686 1 25.2044 6.20181 25.5675 12.5329C25.6989 15.7303 24.9978 18.3848 23.6375 20.3446", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M22.7835 19.239C22.8262 19.1749 22.8682 19.11 22.9093 19.0443C23.9625 17.3622 24.4979 15.1502 24.3897 12.5184C24.0716 6.97032 20.1119 2.41178 15.4652 2.41178C10.8185 2.41178 7.66992 6.56476 7.66992 12.3562C7.66992 16.7934 10.4567 20.7468 14.0492 22.1184", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.0226 12.5397C18.0142 12.5077 18.0158 12.4868 18.0166 12.4802C18.0174 12.4726 18.019 12.467 18.0217 12.4609C18.0241 12.4555 18.032 12.4391 18.0524 12.4183C18.0733 12.397 18.1147 12.3638 18.1795 12.3461C18.1796 12.3461 18.1797 12.346 18.1798 12.346C18.3218 12.3073 18.4102 12.3779 18.4179 12.3845C18.4266 12.3919 18.4301 12.3971 18.4316 12.3995C18.4329 12.4016 18.4368 12.4081 18.4407 12.4212C18.4399 12.4228 18.4391 12.4244 18.4382 12.4261C18.4343 12.4337 18.4286 12.4433 18.4205 12.4543C18.3957 12.4883 18.3381 12.5478 18.2398 12.5746C18.2397 12.5746 18.2396 12.5747 18.2395 12.5747C18.1457 12.6002 18.0749 12.5794 18.0489 12.5694C18.0405 12.5661 18.034 12.563 18.0292 12.5604C18.0272 12.5552 18.0249 12.5483 18.0226 12.5397ZM18.0184 12.5536C18.0184 12.5535 18.0188 12.5538 18.0195 12.5544L18.0184 12.5536ZM18.034 12.5712C18.0346 12.5721 18.0349 12.5726 18.0349 12.5726L18.034 12.5712Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17.6045 12.0882C17.5978 12.0882 17.5595 12.0814 17.4939 12.0686M17.6045 12.7636C17.5855 12.7493 17.548 12.7302 17.4939 12.7066M17.6045 12.7636C17.9097 12.9929 17.6579 12.8211 17.4939 12.7066M17.6045 12.7636C17.48 12.5629 17.2836 12.1429 17.4939 12.0686M17.4939 12.7066C16.6783 12.3519 12.1011 11.152 9.73633 10.328C10.5123 10.4329 16.5789 11.891 17.4939 12.0686", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.9868 12.2181C18.8992 12.0865 18.7045 11.8062 18.627 11.7386C19.5121 11.3549 21.5225 9.16246 22.2928 8.39249C21.5465 9.23996 19.7568 11.0991 18.9868 12.2181Z", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.3087 29.2242L14.2909 24.0069C15.7445 20.1809 20.9281 19.6267 23.1578 23.0588L26.5473 28.2761C28.7082 31.6024 26.321 36 22.3544 36H16.9828C13.4825 36 11.0656 32.4962 12.3087 29.2242Z", fill: "#F7D2D2" }), /* @__PURE__ */ React$7.createElement("path", { d: "M21.3499 26.375C21.3499 26.6739 21.2742 26.8974 21.1714 27.0332C21.0807 27.1529 20.9505 27.2328 20.7365 27.2328C20.4963 27.2328 20.2168 27.1297 19.9988 26.9496C19.781 26.7697 19.6777 26.5603 19.6777 26.375C19.6777 25.8937 20.0596 25.5173 20.5138 25.5173C20.968 25.5173 21.3499 25.8937 21.3499 26.375Z", fill: "#FDF2F2", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.6426 29.9481V30.7647C18.6426 31.1235 18.922 31.4195 19.2804 31.4369C19.9001 31.4669 20.868 31.5093 21.7079 31.5267C22.0812 31.5344 22.3354 31.2362 22.2678 30.869C22.1992 30.4965 22.1256 30.0249 22.1256 29.5794C22.1256 29.0779 21.9003 28.7083 21.6198 28.4933C21.2923 28.2421 20.8613 28.4714 20.4486 28.4714C20.3358 28.4714 20.2272 28.4543 20.1324 28.4293C19.9161 28.3724 19.6691 28.2585 19.4707 28.3617C18.9216 28.6474 18.6426 29.5694 18.6426 29.9481Z", fill: "#FDF2F2", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.611 31.2203L16.692 20.479C17.5641 18.1835 20.6743 17.8509 22.0121 19.9102L28.9902 30.6514C30.2868 32.6472 28.8545 35.2858 26.4745 35.2858H15.4154C13.3153 35.2858 11.8651 33.1835 12.611 31.2203Z", stroke: "black" }), /* @__PURE__ */ React$7.createElement("path", { d: "M27.7754 18.2882C28.3848 17.8945 29.1919 17.1761 29.5805 16.5607", stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M28.2402 19.9578L31.565 18.9627", stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M28.6211 21.7561C29.1167 21.8188 30.3986 21.7936 30.6904 22.2958", stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.78519 18.8333C-1.13847 24.3905 -1.13836 31.8362 9.69642 27.573", stroke: "black" }), /* @__PURE__ */ React$7.createElement("path", { d: "M6.00721 20.3981C1.02591 24.3963 1.02598 29.7532 8.82119 26.686", stroke: "black" }));
const GuestLimitSVG = SvgTimeslotGuest;
const TimeslotLimitsSettings = ({
  areas,
  obeeSessions: obeeSessions2,
  bookingLimits,
  fetchSessions,
  fetchAreas,
  fetchBookingLimits
}) => {
  const theme2 = useTheme$1();
  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(1440);
  const [showAddCondition, setShowAddCondition] = useState(false);
  const [addConditionAnchor, setAddConditionAnchor] = useState(null);
  const [showDeleteCondition, setShowDeleteCondition] = useState(false);
  const [showConditionActions, setShowConditionActions] = useState(false);
  const [editConditionAnchor, setEditConditionAnchor] = useState(null);
  const [showAddLimit, setShowAddLimit] = useState(false);
  const [newRuleLimitType, setNewRuleLimitType] = useState(null);
  const [showDeleteLimit, setShowDeleteLimit] = useState(false);
  const [addLimitAnchor, setAddLimitAnchor] = useState(null);
  const [ruleEditing, setRuleEditing] = useState(null);
  const [editRuleAnchorEl, setEditRuleAnchorEl] = useState(null);
  const [editLimitAnchor, setEditLimitAnchor] = useState(null);
  const popoverOpen = editConditionAnchor || editRuleAnchorEl || editLimitAnchor || showDeleteCondition || showDeleteLimit;
  const classes = useStyles$13({ noBooking: false, popoverOpen });
  const loading = useFetchOnFirstRender(
    [fetchSessions, fetchAreas, fetchBookingLimits],
    [obeeSessions2, areas, bookingLimits]
  );
  useEffect(() => {
    if (!obeeSessions2.data) {
      return;
    }
    let earliestTime = 1440;
    let latestTime = 0;
    obeeSessions2.data.filter((session) => session.endTime - session.startTime > 0).forEach((session) => {
      if (session.startTime < earliestTime) {
        earliestTime = session.startTime;
      }
      if (session.endTime > latestTime) {
        latestTime = session.endTime;
      }
    });
    setStartTime(roundToNearest(earliestTime, 15, "floor"));
    setEndTime(roundToNearest(latestTime, 15, "ceil"));
  }, [obeeSessions2]);
  const interval = 15;
  const times = numberRange(startTime, endTime, interval, true);
  const editRuleItems = [
    {
      value: "edit",
      label: "Edit",
      onClick: () => {
        setEditLimitAnchor(editRuleAnchorEl);
      }
    },
    {
      value: "delete",
      label: "Delete limit",
      onClick: () => {
        setShowDeleteLimit(true);
      }
    }
  ];
  const editConditionItems = [
    {
      value: "delete",
      label: "Delete",
      onClick: () => {
        setShowDeleteCondition(true);
      }
    }
  ];
  const [selectedFilter, setSelectedFilter] = useState(null);
  const limitsByArea = useMemo(() => {
    var _a;
    if (!areas.data) {
      return [];
    }
    const sortedDays = immutableSort(bookingLimits.data, (a, b) => {
      if (a.dayType === "all" || a.dayType === "weekdays" && a.days.length === 7) {
        return -1;
      }
      if (b.dayType === "all" || b.dayType === "weekdays" && b.days.length === 7) {
        return 1;
      }
      if (a.dayType === "weekdays" && b.dayType !== "weekdays") {
        return -1;
      }
      if (b.dayType === "weekdays" && a.dayType !== "weekdays") {
        return 1;
      }
      if (a.dayType === "weekdays" && b.dayType === "weekdays") {
        const sortValue = sortByDay(a.days[0], b.days[0]);
        if (sortValue === 0) {
          return sortByDay(a.days[a.days.length - 1], b.days[b.days.length - 1]);
        }
        return sortByDay(a.days[0], b.days[0]);
      }
      return 0;
    });
    const isAllAreas = (areaId) => areaId === "all" || areaId === -1 || areaId === null;
    return (_a = groupByProperty(sortedDays, "areaId", "id").map((areaLimit) => {
      const areaForLimit = findObjectByProperty(areas.data, areaLimit.id, "id");
      return {
        ...areaLimit,
        name: isAllAreas(areaLimit.id) ? "All areas" : areaForLimit == null ? void 0 : areaForLimit.name
      };
    })) == null ? void 0 : _a.sort((a, b) => {
      if (isAllAreas(a.id)) {
        return -1;
      }
      if (isAllAreas(b == null ? void 0 : b.id)) {
        return 1;
      }
      return sortAlphaNumeric(a.name, b.name);
    });
  }, [bookingLimits.data, areas.data]);
  useEffect(() => {
    var _a, _b2, _c2;
    const validLimits = limitsByArea == null ? void 0 : limitsByArea.filter((limit) => (limit == null ? void 0 : limit.id) !== null);
    const selectedLimit = ((_b2 = (_a = findObjectByProperty(validLimits, selectedFilter == null ? void 0 : selectedFilter.area, "id")) == null ? void 0 : _a.items) == null ? void 0 : _b2[selectedFilter == null ? void 0 : selectedFilter.index]) || null;
    if ((selectedFilter === null || selectedLimit === null) && !isEmpty(validLimits)) {
      setSelectedFilter({
        area: (_c2 = validLimits == null ? void 0 : validLimits[0]) == null ? void 0 : _c2.id,
        index: 0
      });
    }
  }, [limitsByArea]);
  const limitToShow = useMemo(() => {
    var _a, _b2;
    if (isEmpty(selectedFilter)) {
      return null;
    }
    return (_b2 = (_a = findObjectByProperty(limitsByArea, selectedFilter.area, "id")) == null ? void 0 : _a.items) == null ? void 0 : _b2[selectedFilter.index];
  }, [limitsByArea, selectedFilter]);
  const rulesForLimit = useMemo(() => {
    if (isEmpty(limitToShow)) {
      return [];
    }
    return (limitToShow == null ? void 0 : limitToShow.rules) || [];
  }, [limitToShow]);
  const columns = useMemo(() => {
    if (isEmpty(limitToShow)) {
      return [];
    }
    let guestRules = [];
    let groupRules = [];
    let noBookingRules = [];
    sortListByProperty(rulesForLimit, "startTime").forEach((rule) => {
      switch (rule == null ? void 0 : rule.limitType) {
        case "maxGuests":
          guestRules = [...guestRules, rule];
          break;
        case "maxGroups":
          groupRules = [...groupRules, rule];
          break;
        case "noBookings":
          noBookingRules = [...noBookingRules, rule];
          break;
      }
    });
    return [
      {
        id: 0,
        type: "guest",
        rules: guestRules,
        icon: /* @__PURE__ */ React__default.createElement(GuestLimitSVG, { style: { height: "36px" } }),
        label: "Guest limit",
        showHeader: true
      },
      {
        id: 1,
        type: "group",
        rules: groupRules,
        icon: /* @__PURE__ */ React__default.createElement(GroupLimitSVG, { style: { height: "36px" } }),
        label: "Group limit",
        showHeader: true
      },
      {
        id: 2,
        type: "noBookings",
        rules: noBookingRules,
        label: "No bookings",
        showHeader: false
      }
    ];
  }, [rulesForLimit]);
  const getTypeFromColumnType = (columnType) => {
    const limitTypeMap = {
      guest: "maxGuests",
      group: "maxGroups",
      noBookings: "noBookings"
    };
    return (limitTypeMap == null ? void 0 : limitTypeMap[columnType]) || null;
  };
  const getLimitDays = (limit) => {
    switch (limit.dayType) {
      case "weekdays":
        return getDayRange(limit == null ? void 0 : limit.days);
      case "date":
        return formatDate(limit == null ? void 0 : limit.startDate, "DD.MM.YY");
      case "dateRange":
        return `${formatDate(limit == null ? void 0 : limit.startDate, "DD.MM.YY")} - ${formatDate(
          limit == null ? void 0 : limit.endDate,
          "DD.MM.YY"
        )}`;
      case "all":
      default:
        return "Every day";
    }
  };
  devLog("info", "limitsByArea", limitsByArea);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, isObee() ? /* @__PURE__ */ React__default.createElement(Button, { href: "https://obee.com.au/democameronv3/admin/settings_adv_rules.php" }, "Click here to go to the old obee settings to change the booking rules") : /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sidebar }, loading ? /* @__PURE__ */ React__default.createElement(
    Skeleton$1,
    {
      height: 40,
      style: {
        skeleton: {
          backgroundColor: theme2.colors.loadingShimmer
        }
      }
    }
  ) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sidebarTop }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "secondary",
      style: secondaryButtonStyles(theme2),
      onClick: (e) => {
        setShowAddCondition(true);
        setAddConditionAnchor(e.currentTarget);
      }
    },
    "+ Create new limit"
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.areasList }, limitsByArea.map((limitByArea) => /* @__PURE__ */ React__default.createElement(Box, { className: classes.area, key: limitByArea == null ? void 0 : limitByArea.id }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaName }, limitByArea.name), /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaDays }, limitByArea.items.map((limit, index) => {
    const isSelected = (limitByArea == null ? void 0 : limitByArea.id) === (selectedFilter == null ? void 0 : selectedFilter.area) && index === (selectedFilter == null ? void 0 : selectedFilter.index) && selectedFilter !== null;
    if (isSelected) {
      return /* @__PURE__ */ React__default.createElement(Box, { key: limit == null ? void 0 : limit.objectId, className: classes.selectedFilter }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.selectedFilterLabel }, getLimitDays(limit)), /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "custom",
          style: {
            display: "flex",
            alignItems: "center",
            button: {
              color: theme2.colors.nimbus,
              padding: "0 10px",
              width: "auto",
              height: "18px"
            },
            buttonHover: {
              color: theme2.colors.gray3
            }
          },
          onClick: (e) => {
            setShowConditionActions(true);
            setEditConditionAnchor(e.currentTarget);
          }
        },
        /* @__PURE__ */ React__default.createElement(KebabSvg, { style: { height: "18px" } })
      ));
    }
    return /* @__PURE__ */ React__default.createElement(
      Button,
      {
        key: limit == null ? void 0 : limit.objectId,
        type: "text",
        fullWidth: true,
        style: cleanButtonStyles(theme2),
        onClick: () => {
          setSelectedFilter({ area: limitByArea == null ? void 0 : limitByArea.id, index });
        }
      },
      getLimitDays(limit)
    );
  }))))))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeslotLimits }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeslotsContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeslotHeader }, columns.map((column) => /* @__PURE__ */ React__default.createElement(Box, { key: column == null ? void 0 : column.id, className: classes.columnHeader }, column.showHeader && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, column.icon, /* @__PURE__ */ React__default.createElement(Box, { style: { flexGrow: 1 } }, column.label), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "secondary",
      style: addButtonStyles(theme2),
      text: "Add",
      onClick: (e) => {
        setNewRuleLimitType(getTypeFromColumnType(column.type));
        setShowAddLimit(true);
        setAddLimitAnchor(e.currentTarget);
      }
    }
  ))))), !loading && /* @__PURE__ */ React__default.createElement(Box, { className: classes.dayColumn }, times.map((time) => /* @__PURE__ */ React__default.createElement(Box, { key: time, className: classes.timeBoxContainer }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.timeBox,
      style: {
        color: time % 60 ? theme2.colors.yetAnotherGray14 : theme2.colors.charcoal
      }
    },
    formatTimeFromInt(time, "h:mma")
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeBoxRow })))), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.limitColumnContainer,
      style: { height: `${(times.length - 1) * cellHeight}px` }
    },
    columns.filter((column) => column.type === "noBookings").map((column) => /* @__PURE__ */ React__default.createElement(
      Box,
      {
        key: column.id,
        className: classes.limitColumn,
        style: { position: "absolute" }
      },
      column.rules.map((rule) => /* @__PURE__ */ React__default.createElement(
        NoBookingRuleBlock$1,
        {
          key: rule == null ? void 0 : rule.objectId,
          rule,
          onEdit: (e) => {
            setRuleEditing(rule);
            setEditRuleAnchorEl(e.currentTarget);
          },
          startTime,
          endTime
        }
      ))
    )),
    columns.filter((column) => column.type !== "noBookings").map((column) => /* @__PURE__ */ React__default.createElement(Box, { key: column.id, className: classes.limitColumn }, column.rules.map((rule) => /* @__PURE__ */ React__default.createElement(
      RuleBlock$1,
      {
        key: rule == null ? void 0 : rule.objectId,
        rule,
        onEdit: (e) => {
          setRuleEditing(rule);
          setEditRuleAnchorEl(e.currentTarget);
        },
        startTime,
        endTime
      }
    ))))
  )))), /* @__PURE__ */ React__default.createElement(
    AddConditionModal$1,
    {
      isOpen: showAddCondition,
      onClose: () => setShowAddCondition(false),
      anchor: addConditionAnchor,
      restaurantOpen: startTime,
      restaurantClose: endTime,
      title: "Create new booking limit"
    }
  ), /* @__PURE__ */ React__default.createElement(
    AddRuleModal$1,
    {
      isOpen: showAddLimit,
      onClose: () => {
        setShowAddLimit(false);
        setNewRuleLimitType(null);
      },
      anchor: addLimitAnchor,
      restaurantOpen: startTime,
      restaurantClose: endTime,
      condition: limitToShow,
      defaultLimitType: newRuleLimitType
    }
  ), /* @__PURE__ */ React__default.createElement(
    EditRuleModal$1,
    {
      isOpen: !!editLimitAnchor,
      onClose: () => setEditLimitAnchor(null),
      anchor: editLimitAnchor,
      restaurantOpen: startTime,
      restaurantClose: endTime,
      condition: limitToShow,
      rule: ruleEditing
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: editRuleItems,
      anchor: editRuleAnchorEl,
      isOpen: !!editRuleAnchorEl,
      onClose: () => setEditRuleAnchorEl(null),
      style: listPopoverStyles$1,
      popoverProps: {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: editConditionItems,
      anchor: editConditionAnchor,
      isOpen: !!editConditionAnchor && showConditionActions,
      onClose: () => setEditConditionAnchor(null),
      style: listPopoverStyles$1,
      popoverProps: {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    DeleteBookingLimitModal$1,
    {
      onClose: () => {
        setSelectedFilter(null);
        setShowDeleteCondition(false);
      },
      bookingLimit: limitToShow,
      isOpen: showDeleteCondition
    }
  ), /* @__PURE__ */ React__default.createElement(
    DeleteBookingLimitRuleModal$1,
    {
      onClose: () => setShowDeleteLimit(false),
      limit: limitToShow,
      rule: ruleEditing,
      isOpen: showDeleteLimit
    }
  ));
};
TimeslotLimitsSettings.defaultProps = {};
TimeslotLimitsSettings.propTypes = {
  obeeSessions: sessionsPropTypes.isRequired,
  areas: areasPropTypes.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  fetchAreas: PropTypes.func.isRequired,
  fetchBookingLimits: PropTypes.func.isRequired,
  bookingLimits: bookingLimitsPropTypes.isRequired
};
const mapStateToProps$1W = (state) => ({
  obeeSessions: state.obeeSessions,
  areas: state.areas,
  bookingLimits: state.bookingLimits
});
const mapDispatchToProps$1V = (dispatch) => bindActionCreators(
  {
    updateObeeSettings: updateSettingsAction,
    fetchSessions: fetchSessionsAction,
    fetchAreas: fetchAreasAction,
    fetchBookingLimits: fetchBookingLimitsAction
  },
  dispatch
);
const TimeslotLimitsSettings$1 = connect(mapStateToProps$1W, mapDispatchToProps$1V)(TimeslotLimitsSettings);
const Settings$1 = ({ fetchObeeSettings: fetchObeeSettings2, obeeSettings: obeeSettings2, formAwareRedirect }) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g;
  const theme2 = useTheme$1();
  const breakpointDownSm = useMediaQuery$1(theme2.breakpoints.down("sm"));
  const classes = useStyles$1w();
  const query = useQuery();
  const tab = query.get("tab");
  const preview = query.get("preview");
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(tab || "general");
  const [previousRoute, setPreviousRoute] = useState(
    ((_b2 = (_a = history.location) == null ? void 0 : _a.state) == null ? void 0 : _b2.from) || `${(_c2 = window.bookingsConfig) == null ? void 0 : _c2.routePrefix}/runsheet`
  );
  const [headerPosition, setHeaderPosition] = useState(0);
  const loading = useFetchOnFirstRender([fetchObeeSettings2], [obeeSettings2]);
  useLayoutEffect(() => {
    const handleScroll = () => {
      const headerMaxOffset = 133;
      setHeaderPosition(
        Math.min(1, Math.max((window.scrollY / headerMaxOffset).toPrecision(2), 0))
      );
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    var _a2, _b3, _c3, _d3;
    if ((_b3 = (_a2 = history.location) == null ? void 0 : _a2.state) == null ? void 0 : _b3.from) {
      setPreviousRoute((_d3 = (_c3 = history.location) == null ? void 0 : _c3.state) == null ? void 0 : _d3.from);
    }
  }, [(_e2 = (_d2 = history.location) == null ? void 0 : _d2.state) == null ? void 0 : _e2.from]);
  const handleChangeTab = async (newTab) => {
    formAwareRedirect(() => {
      history.replace({
        search: `?tab=${newTab}`
      });
      setActiveTab(newTab);
    });
  };
  const showTab = () => {
    switch (activeTab) {
      case "hours":
        return /* @__PURE__ */ React__default.createElement(HoursSettings$1, null);
      case "messages":
        return /* @__PURE__ */ React__default.createElement(MessagesSettings$1, null);
      case "staff":
        return /* @__PURE__ */ React__default.createElement(StaffSettings$1, null);
      case "payment":
        return /* @__PURE__ */ React__default.createElement(PaymentSettings$1, null);
      case "terms":
        return /* @__PURE__ */ React__default.createElement(TermsSettings$1, null);
      case "areas":
        return /* @__PURE__ */ React__default.createElement(AreasSettings$1, null);
      case "timeslotLimits":
        return /* @__PURE__ */ React__default.createElement(TimeslotLimitsSettings$1, null);
      case "emailCommunication":
        if (preview) {
          return /* @__PURE__ */ React__default.createElement(EmailPreview$1, { email: preview });
        }
        return /* @__PURE__ */ React__default.createElement(EmailCommunicationSettings$1, null);
      case "integrations":
        return /* @__PURE__ */ React__default.createElement(IntegrationsSettings$1, null);
      case "bookingWidget":
        return /* @__PURE__ */ React__default.createElement(BookingWidgetSettings, null);
      case "general":
      default:
        return /* @__PURE__ */ React__default.createElement(GeneralSettings$1, null);
    }
  };
  const getTabs = () => {
    if (isObee()) {
      return [
        // { label: 'General', value: 'general' }, // TODO
        // { label: 'Opening hours', value: 'hours' }, // TODO
        { label: "Messages", value: "messages" },
        // TODO
        // { label: 'Staff', value: 'staff' }, // TODO
        // { label: 'Payments', value: 'payment' }, // TODO
        // { label: 'Terms & conditions', value: 'terms' }, // TODO
        // { label: 'Areas & tables', value: 'areas' }, // TODO
        // { label: 'Booking rules', value: 'timeslotLimits' }, // TODO
        // { label: 'Integrations', value: 'integrations' }, // TODO
        // { label: 'Email Communication', value: 'emailCommunication' }, // TODO
        hasNewWidget(obeeSettings2.data) ? { label: "Booking Widget", value: "bookingWidget" } : null
      ].filter((item) => item);
    }
    return [
      { label: "General", value: "general" },
      { label: "Opening hours", value: "hours" },
      { label: "Messages", value: "messages" },
      { label: "Staff", value: "staff" },
      { label: "Payments", value: "payment" },
      { label: "Terms & conditions", value: "terms" },
      { label: "Areas & tables", value: "areas" },
      { label: "Booking limits", value: "timeslotLimits" },
      { label: "Integrations", value: "integrations" },
      // { label: 'Email Communication', value: 'emailCommunication' },
      { label: "Booking Widget", value: "bookingWidget" }
    ];
  };
  const tabs = getTabs();
  const bookingButtonStyle = {
    pointerEvents: "auto",
    button: {
      backgroundColor: theme2.colors.charcoal,
      fontWeight: theme2.fontWeights.medium,
      height: "40px",
      padding: "8px 20px",
      fontSize: "15px",
      display: "flex",
      alignItems: "center",
      ...(_g = (_f = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _f.Button) == null ? void 0 : _g.button
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topHeaderContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topHeaderItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.logoContainer }, /* @__PURE__ */ React__default.createElement(Logo$1, { style: { color: theme2.colors.charcoal } }))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.topHeaderItem }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      style: bookingButtonStyle,
      onClick: () => {
        formAwareRedirect(() => {
          devLog("info", "going back", previousRoute);
          return history.push(previousRoute);
        });
      }
    },
    "Exit"
  ))), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.title,
      style: {
        padding: breakpointDownSm && `18px ${headerPosition * 76 + 20}px 8px ${headerPosition * 76 + 20}px`
      }
    },
    "Settings"
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.tabBarContainer }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.faderContainer,
      style: { left: 0, width: `${headerPosition * 80}px` }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.faderBlock, style: { width: "60px" } }),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.faderGradient })
  ), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.tabBar,
      style: { padding: breakpointDownSm && `18px ${headerPosition * 76 + 20}px` }
    },
    /* @__PURE__ */ React__default.createElement(
      TabBar$2,
      {
        tabs,
        value: activeTab,
        onSelect: handleChangeTab,
        style: tabBarStyles$4(theme2)
      }
    )
  ), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.faderContainer,
      style: { right: 0, width: `${headerPosition * 120}px` }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.faderGradient, style: { transform: "scaleX(-1)" } }),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.faderBlock, style: { width: "100px" } })
  )), loading && /* @__PURE__ */ React__default.createElement(LinearProgress, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, showTab()));
};
Settings$1.defaultProps = {};
Settings$1.propTypes = {
  fetchObeeSettings: PropTypes.func.isRequired,
  formAwareRedirect: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$1V = (state) => {
  var _a, _b2, _c2, _d2;
  return {
    restId: state.restaurantActive.restaurant.objectId,
    slug: ((_b2 = (_a = state.restaurantActive) == null ? void 0 : _a.restaurant) == null ? void 0 : _b2.slug) || ((_d2 = (_c2 = state == null ? void 0 : state.obeeSettings) == null ? void 0 : _c2.data) == null ? void 0 : _d2.slug),
    obeeSettings: state.obeeSettings
  };
};
const mapDispatchToProps$1U = (dispatch) => bindActionCreators(
  {
    fetchObeeSettings: fetchSettingsAction,
    formAwareRedirect: formAwareRedirectAction
  },
  dispatch
);
const SettingsScreen = connect(mapStateToProps$1V, mapDispatchToProps$1U)(Settings$1);
var roundNumber = function(num, decimal) {
  return Number(num.toFixed(decimal));
};
var checkIsNumber = function(num, defaultValue) {
  return typeof num === "number" ? num : defaultValue;
};
var handleCallback = function(context, event, callback) {
  if (callback && typeof callback === "function") {
    callback(context, event);
  }
};
var easeOut = function(t) {
  return -Math.cos(t * Math.PI) / 2 + 0.5;
};
var linear = function(t) {
  return t;
};
var easeInQuad = function(t) {
  return t * t;
};
var easeOutQuad = function(t) {
  return t * (2 - t);
};
var easeInOutQuad = function(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
var easeInCubic = function(t) {
  return t * t * t;
};
var easeOutCubic = function(t) {
  return --t * t * t + 1;
};
var easeInOutCubic = function(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
var easeInQuart = function(t) {
  return t * t * t * t;
};
var easeOutQuart = function(t) {
  return 1 - --t * t * t * t;
};
var easeInOutQuart = function(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
var easeInQuint = function(t) {
  return t * t * t * t * t;
};
var easeOutQuint = function(t) {
  return 1 + --t * t * t * t * t;
};
var easeInOutQuint = function(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var animations = {
  easeOut,
  linear,
  easeInQuad,
  easeOutQuad,
  easeInOutQuad,
  easeInCubic,
  easeOutCubic,
  easeInOutCubic,
  easeInQuart,
  easeOutQuart,
  easeInOutQuart,
  easeInQuint,
  easeOutQuint,
  easeInOutQuint
};
var handleCancelAnimationFrame = function(animation) {
  if (typeof animation === "number") {
    cancelAnimationFrame(animation);
  }
};
var handleCancelAnimation = function(contextInstance) {
  if (!contextInstance.mounted)
    return;
  handleCancelAnimationFrame(contextInstance.animation);
  contextInstance.animate = false;
  contextInstance.animation = null;
  contextInstance.velocity = null;
};
function handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
  if (!contextInstance.mounted)
    return;
  var startTime = (/* @__PURE__ */ new Date()).getTime();
  var lastStep = 1;
  handleCancelAnimation(contextInstance);
  contextInstance.animation = function() {
    if (!contextInstance.mounted) {
      return handleCancelAnimationFrame(contextInstance.animation);
    }
    var frameTime = (/* @__PURE__ */ new Date()).getTime() - startTime;
    var animationProgress = frameTime / animationTime;
    var animationType = animations[animationName];
    var step = animationType(animationProgress);
    if (frameTime >= animationTime) {
      callback(lastStep);
      contextInstance.animation = null;
    } else if (contextInstance.animation) {
      callback(step);
      requestAnimationFrame(contextInstance.animation);
    }
  };
  requestAnimationFrame(contextInstance.animation);
}
function isValidTargetState(targetState) {
  var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
  if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) {
    return false;
  }
  return true;
}
function animate(contextInstance, targetState, animationTime, animationName) {
  var isValid = isValidTargetState(targetState);
  if (!contextInstance.mounted || !isValid)
    return;
  var setTransformState = contextInstance.setTransformState;
  var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
  var scaleDiff = targetState.scale - scale;
  var positionXDiff = targetState.positionX - positionX;
  var positionYDiff = targetState.positionY - positionY;
  if (animationTime === 0) {
    setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
  } else {
    handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
      var newScale = scale + scaleDiff * step;
      var newPositionX = positionX + positionXDiff * step;
      var newPositionY = positionY + positionYDiff * step;
      setTransformState(newScale, newPositionX, newPositionY);
    });
  }
}
function getComponentsSizes(wrapperComponent, contentComponent, newScale) {
  var wrapperWidth = wrapperComponent.offsetWidth;
  var wrapperHeight = wrapperComponent.offsetHeight;
  var contentWidth = contentComponent.offsetWidth;
  var contentHeight = contentComponent.offsetHeight;
  var newContentWidth = contentWidth * newScale;
  var newContentHeight = contentHeight * newScale;
  var newDiffWidth = wrapperWidth - newContentWidth;
  var newDiffHeight = wrapperHeight - newContentHeight;
  return {
    wrapperWidth,
    wrapperHeight,
    newContentWidth,
    newDiffWidth,
    newContentHeight,
    newDiffHeight
  };
}
var getBounds = function(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
  var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0;
  var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0;
  var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
  var maxPositionX = scaleWidthFactor;
  var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
  var maxPositionY = scaleHeightFactor;
  return { minPositionX, maxPositionX, minPositionY, maxPositionY };
};
var calculateBounds = function(contextInstance, newScale) {
  var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
  var centerZoomedOut = contextInstance.setup.centerZoomedOut;
  if (!wrapperComponent || !contentComponent) {
    throw new Error("Components are not mounted");
  }
  var _a = getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
  var bounds = getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
  return bounds;
};
var boundLimiter = function(value, minBound, maxBound, isActive) {
  if (!isActive)
    return roundNumber(value, 2);
  if (value < minBound)
    return roundNumber(minBound, 2);
  if (value > maxBound)
    return roundNumber(maxBound, 2);
  return roundNumber(value, 2);
};
var handleCalculateBounds = function(contextInstance, newScale) {
  var bounds = calculateBounds(contextInstance, newScale);
  contextInstance.bounds = bounds;
  return bounds;
};
function getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
  var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
  var paddingX = 0;
  var paddingY = 0;
  if (wrapperComponent) {
    paddingX = paddingValueX;
    paddingY = paddingValueY;
  }
  var x = boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
  var y = boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
  return { x, y };
}
function handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
  var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
  var scaleDifference = newScale - scale;
  if (typeof mouseX !== "number" || typeof mouseY !== "number") {
    console.error("Mouse X and Y position were not provided!");
    return { x: positionX, y: positionY };
  }
  var calculatedPositionX = positionX - mouseX * scaleDifference;
  var calculatedPositionY = positionY - mouseY * scaleDifference;
  var newPositions = getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
  return newPositions;
}
function checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
  var scalePadding = enablePadding ? zoomPadding : 0;
  var minScaleWithPadding = minScale - scalePadding;
  if (!Number.isNaN(maxScale) && zoom >= maxScale)
    return maxScale;
  if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding)
    return minScaleWithPadding;
  return zoom;
}
var isPanningStartAllowed = function(contextInstance, event) {
  var excluded = contextInstance.setup.panning.excluded;
  var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
  var target = event.target;
  var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
  var isWrapperChild = targetIsShadowDom ? event.composedPath().some(function(el) {
    if (!(el instanceof Element)) {
      return false;
    }
    return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
  }) : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
  var isAllowed = isInitialized && target && isWrapperChild;
  if (!isAllowed)
    return false;
  var isExcluded = isExcludedNode(target, excluded);
  if (isExcluded)
    return false;
  return true;
};
var isPanningAllowed = function(contextInstance) {
  var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
  var disabled = setup.panning.disabled;
  var isAllowed = isInitialized && isPanning && !disabled;
  if (!isAllowed)
    return false;
  return true;
};
var handlePanningSetup = function(contextInstance, event) {
  var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
  contextInstance.isPanning = true;
  var x = event.clientX;
  var y = event.clientY;
  contextInstance.startCoords = { x: x - positionX, y: y - positionY };
};
var handleTouchPanningSetup = function(contextInstance, event) {
  var touches = event.touches;
  var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
  contextInstance.isPanning = true;
  var oneFingerTouch = touches.length === 1;
  if (oneFingerTouch) {
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    contextInstance.startCoords = { x: x - positionX, y: y - positionY };
  }
};
function handlePanToBounds(contextInstance) {
  var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
  var _b2 = contextInstance.setup, disabled = _b2.disabled, limitToBounds = _b2.limitToBounds, centerZoomedOut = _b2.centerZoomedOut;
  var wrapperComponent = contextInstance.wrapperComponent;
  if (disabled || !wrapperComponent || !contextInstance.bounds)
    return;
  var _c2 = contextInstance.bounds, maxPositionX = _c2.maxPositionX, minPositionX = _c2.minPositionX, maxPositionY = _c2.maxPositionY, minPositionY = _c2.minPositionY;
  var xChanged = positionX > maxPositionX || positionX < minPositionX;
  var yChanged = positionY > maxPositionY || positionY < minPositionY;
  var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
  var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
  var _d2 = handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d2.x, y = _d2.y;
  return {
    scale,
    positionX: xChanged ? x : positionX,
    positionY: yChanged ? y : positionY
  };
}
function handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
  var limitToBounds = contextInstance.setup.limitToBounds;
  var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
  var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
  if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) {
    return;
  }
  var _b2 = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b2.x, y = _b2.y;
  contextInstance.setTransformState(scale, x, y);
}
var getPanningClientPosition = function(contextInstance, clientX, clientY) {
  var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
  var panning = contextInstance.setup.panning;
  var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
  var positionX = transformState.positionX, positionY = transformState.positionY;
  if (!startCoords) {
    return { x: positionX, y: positionY };
  }
  var mouseX = clientX - startCoords.x;
  var mouseY = clientY - startCoords.y;
  var newPositionX = lockAxisX ? positionX : mouseX;
  var newPositionY = lockAxisY ? positionY : mouseY;
  return { x: newPositionX, y: newPositionY };
};
var getPaddingValue = function(contextInstance, size) {
  var setup = contextInstance.setup, transformState = contextInstance.transformState;
  var scale = transformState.scale;
  var minScale = setup.minScale, disablePadding = setup.disablePadding;
  if (size > 0 && scale >= minScale && !disablePadding) {
    return size;
  }
  return 0;
};
var isVelocityCalculationAllowed = function(contextInstance) {
  var mounted = contextInstance.mounted;
  var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
  var scale = contextInstance.transformState.scale;
  var disabledVelocity = velocityAnimation.disabled;
  var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
  if (!isAllowed)
    return false;
  return true;
};
var isVelocityAllowed = function(contextInstance) {
  var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
  var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
  var scale = contextInstance.transformState.scale;
  var disabledVelocity = velocityAnimation.disabled;
  var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
  if (!isAllowed)
    return false;
  if (!velocity || !bounds)
    return false;
  return true;
};
function getVelocityMoveTime(contextInstance, velocity) {
  var velocityAnimation = contextInstance.setup.velocityAnimation;
  var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
  if (equalToMove) {
    return animationTime * velocity * sensitivity;
  }
  return animationTime;
}
function getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
  if (limitToBounds) {
    if (startPosition > maxPosition && currentPosition > maxPosition) {
      var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
      if (calculatedPosition > maxTarget)
        return maxTarget;
      if (calculatedPosition < maxPosition)
        return maxPosition;
      return calculatedPosition;
    }
    if (startPosition < minPosition && currentPosition < minPosition) {
      var calculatedPosition = minPosition + (newPosition - minPosition) * step;
      if (calculatedPosition < minTarget)
        return minTarget;
      if (calculatedPosition > minPosition)
        return minPosition;
      return calculatedPosition;
    }
  }
  if (isLocked)
    return startPosition;
  return boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function getSizeMultiplier(wrapperComponent, equalToMove) {
  var defaultMultiplier = 1;
  if (equalToMove) {
    return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
  }
  return defaultMultiplier;
}
function handleCalculateVelocity(contextInstance, position) {
  var isAllowed = isVelocityCalculationAllowed(contextInstance);
  if (!isAllowed) {
    return;
  }
  var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
  var wrapperComponent = contextInstance.wrapperComponent;
  var equalToMove = setup.velocityAnimation.equalToMove;
  var now2 = Date.now();
  if (lastMousePosition && velocityTime && wrapperComponent) {
    var sizeMultiplier = getSizeMultiplier(wrapperComponent, equalToMove);
    var distanceX = position.x - lastMousePosition.x;
    var distanceY = position.y - lastMousePosition.y;
    var velocityX = distanceX / sizeMultiplier;
    var velocityY = distanceY / sizeMultiplier;
    var interval = now2 - velocityTime;
    var speed = distanceX * distanceX + distanceY * distanceY;
    var velocity = Math.sqrt(speed) / interval;
    contextInstance.velocity = { velocityX, velocityY, total: velocity };
  }
  contextInstance.lastMousePosition = position;
  contextInstance.velocityTime = now2;
}
function handleVelocityPanning(contextInstance) {
  var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
  var isAllowed = isVelocityAllowed(contextInstance);
  if (!isAllowed || !velocity || !bounds || !wrapperComponent) {
    return;
  }
  var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
  var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
  var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
  var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
  var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
  var animationType = zoomAnimation.animationType;
  var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
  var alignAnimationTime = velocityAlignmentTime;
  var moveAnimationTime = getVelocityMoveTime(contextInstance, total);
  var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
  var paddingValueX = getPaddingValue(contextInstance, sizeX);
  var paddingValueY = getPaddingValue(contextInstance, sizeY);
  var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
  var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
  var maxTargetX = maxPositionX + paddingX;
  var minTargetX = minPositionX - paddingX;
  var maxTargetY = maxPositionY + paddingY;
  var minTargetY = minPositionY - paddingY;
  var startState = contextInstance.transformState;
  var startTime = (/* @__PURE__ */ new Date()).getTime();
  handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var frameTime = (/* @__PURE__ */ new Date()).getTime() - startTime;
    var animationProgress = frameTime / alignAnimationTime;
    var alignAnimation = animations[alignmentAnimation.animationType];
    var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
    var customStep = 1 - step;
    var newPositionX = positionX + velocityX * customStep;
    var newPositionY = positionY + velocityY * customStep;
    var currentPositionX = getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
    var currentPositionY = getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
    if (positionX !== newPositionX || positionY !== newPositionY) {
      contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
    }
  });
}
function handlePanningStart(contextInstance, event) {
  var scale = contextInstance.transformState.scale;
  handleCancelAnimation(contextInstance);
  handleCalculateBounds(contextInstance, scale);
  if (window.TouchEvent !== void 0 && event instanceof TouchEvent) {
    handleTouchPanningSetup(contextInstance, event);
  } else {
    handlePanningSetup(contextInstance, event);
  }
}
function handleAlignToBounds(contextInstance) {
  var scale = contextInstance.transformState.scale;
  var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
  var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
  var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
  if (isDisabled)
    return;
  var targetState = handlePanToBounds(contextInstance);
  if (targetState) {
    animate(contextInstance, targetState, animationTime, animationType);
  }
}
function handlePanning(contextInstance, clientX, clientY) {
  var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
  var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
  if (!startCoords)
    return;
  var _b2 = getPanningClientPosition(contextInstance, clientX, clientY), x = _b2.x, y = _b2.y;
  var paddingValueX = getPaddingValue(contextInstance, sizeX);
  var paddingValueY = getPaddingValue(contextInstance, sizeY);
  handleCalculateVelocity(contextInstance, { x, y });
  handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function handlePanningEnd(contextInstance) {
  if (contextInstance.isPanning) {
    var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
    var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    contextInstance.isPanning = false;
    contextInstance.animate = false;
    contextInstance.animation = null;
    var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
    var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
    var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
    var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
    var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
    var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
    var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
    var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
    if (shouldAnimate) {
      handleVelocityPanning(contextInstance);
    } else {
      handleAlignToBounds(contextInstance);
    }
  }
}
function handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
  var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
  var newScale = checkZoomBounds(roundNumber(scale, 2), minScale, maxScale, 0, false);
  var bounds = handleCalculateBounds(contextInstance, newScale);
  var _b2 = handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b2.x, y = _b2.y;
  return { scale: newScale, positionX: x, positionY: y };
}
function handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
  var scale = contextInstance.transformState.scale;
  var wrapperComponent = contextInstance.wrapperComponent;
  var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
  var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
  var isDisabled = disabled || scale >= minScale;
  if (scale >= 1 || limitToBounds) {
    handleAlignToBounds(contextInstance);
  }
  if (isDisabled || !wrapperComponent || !contextInstance.mounted)
    return;
  var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
  var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
  var targetState = handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
  if (targetState) {
    animate(contextInstance, targetState, animationTime, animationType);
  }
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var initialState = {
  previousScale: 1,
  scale: 1,
  positionX: 0,
  positionY: 0
};
var initialSetup = {
  disabled: false,
  minPositionX: null,
  maxPositionX: null,
  minPositionY: null,
  maxPositionY: null,
  minScale: 1,
  maxScale: 8,
  limitToBounds: true,
  centerZoomedOut: false,
  centerOnInit: false,
  disablePadding: false,
  smooth: true,
  wheel: {
    step: 0.2,
    disabled: false,
    smoothStep: 1e-3,
    wheelDisabled: false,
    touchPadDisabled: false,
    activationKeys: [],
    excluded: []
  },
  panning: {
    disabled: false,
    velocityDisabled: false,
    lockAxisX: false,
    lockAxisY: false,
    allowLeftClickPan: true,
    allowMiddleClickPan: true,
    allowRightClickPan: true,
    wheelPanning: false,
    activationKeys: [],
    excluded: []
  },
  pinch: {
    step: 5,
    disabled: false,
    excluded: []
  },
  doubleClick: {
    disabled: false,
    step: 0.7,
    mode: "zoomIn",
    animationType: "easeOut",
    animationTime: 200,
    excluded: []
  },
  zoomAnimation: {
    disabled: false,
    size: 0.4,
    animationTime: 200,
    animationType: "easeOut"
  },
  alignmentAnimation: {
    disabled: false,
    sizeX: 100,
    sizeY: 100,
    animationTime: 200,
    velocityAlignmentTime: 400,
    animationType: "easeOut"
  },
  velocityAnimation: {
    disabled: false,
    sensitivity: 1,
    animationTime: 400,
    animationType: "easeOut",
    equalToMove: true
  }
};
var createState = function(props) {
  var _a, _b2, _c2, _d2;
  return {
    previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : initialState.scale,
    scale: (_b2 = props.initialScale) !== null && _b2 !== void 0 ? _b2 : initialState.scale,
    positionX: (_c2 = props.initialPositionX) !== null && _c2 !== void 0 ? _c2 : initialState.positionX,
    positionY: (_d2 = props.initialPositionY) !== null && _d2 !== void 0 ? _d2 : initialState.positionY
  };
};
var createSetup = function(props) {
  var newSetup = __assign({}, initialSetup);
  Object.keys(props).forEach(function(key) {
    var validValue = typeof props[key] !== "undefined";
    var validParameter = typeof initialSetup[key] !== "undefined";
    if (validParameter && validValue) {
      var dataType = Object.prototype.toString.call(initialSetup[key]);
      var isObject2 = dataType === "[object Object]";
      var isArray = dataType === "[object Array]";
      if (isObject2) {
        newSetup[key] = __assign(__assign({}, initialSetup[key]), props[key]);
      } else if (isArray) {
        newSetup[key] = __spreadArray(__spreadArray([], initialSetup[key], true), props[key], true);
      } else {
        newSetup[key] = props[key];
      }
    }
  });
  return newSetup;
};
var handleCalculateButtonZoom = function(contextInstance, delta, step) {
  var scale = contextInstance.transformState.scale;
  var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
  var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
  var size = zoomAnimation.size;
  if (!wrapperComponent) {
    throw new Error("Wrapper is not mounted");
  }
  var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
  var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, false);
  return newScale;
};
function handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
  var wrapperComponent = contextInstance.wrapperComponent;
  var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
  if (!wrapperComponent)
    return console.error("No WrapperComponent found");
  var wrapperWidth = wrapperComponent.offsetWidth;
  var wrapperHeight = wrapperComponent.offsetHeight;
  var mouseX = (wrapperWidth / 2 - positionX) / scale;
  var mouseY = (wrapperHeight / 2 - positionY) / scale;
  var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
  var targetState = handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
  if (!targetState) {
    return console.error("Error during zoom event. New transformation state was not calculated.");
  }
  animate(contextInstance, targetState, animationTime, animationType);
}
function resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
  var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
  var limitToBounds = setup.limitToBounds;
  var initialTransformation = createState(contextInstance.props);
  var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
  if (!wrapperComponent)
    return;
  var newBounds = calculateBounds(contextInstance, initialTransformation.scale);
  var boundedPositions = getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
  var newState = {
    scale: initialTransformation.scale,
    positionX: boundedPositions.x,
    positionY: boundedPositions.y
  };
  if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) {
    return;
  }
  onResetTransformation === null || onResetTransformation === void 0 ? void 0 : onResetTransformation();
  animate(contextInstance, newState, animationTime, animationType);
}
function getOffset(element, wrapper, content, state) {
  var offset = element.getBoundingClientRect();
  var wrapperOffset = wrapper.getBoundingClientRect();
  var contentOffset = content.getBoundingClientRect();
  var xOff = wrapperOffset.x * state.scale;
  var yOff = wrapperOffset.y * state.scale;
  return {
    x: (offset.x - contentOffset.x + xOff) / state.scale,
    y: (offset.y - contentOffset.y + yOff) / state.scale
  };
}
function calculateZoomToNode(contextInstance, node, customZoom) {
  var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
  var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
  if (!wrapperComponent || !contentComponent)
    return transformState;
  var wrapperRect = wrapperComponent.getBoundingClientRect();
  var nodeRect = node.getBoundingClientRect();
  var nodeOffset = getOffset(node, wrapperComponent, contentComponent, transformState);
  var nodeLeft = nodeOffset.x;
  var nodeTop = nodeOffset.y;
  var nodeWidth = nodeRect.width / transformState.scale;
  var nodeHeight = nodeRect.height / transformState.scale;
  var scaleX = wrapperComponent.offsetWidth / nodeWidth;
  var scaleY = wrapperComponent.offsetHeight / nodeHeight;
  var newScale = checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
  var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
  var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
  var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
  var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
  var bounds = calculateBounds(contextInstance, newScale);
  var _b2 = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b2.x, y = _b2.y;
  return { positionX: x, positionY: y, scale: newScale };
}
var zoomIn = function(contextInstance) {
  return function(step, animationTime, animationType) {
    if (step === void 0) {
      step = 0.5;
    }
    if (animationTime === void 0) {
      animationTime = 300;
    }
    if (animationType === void 0) {
      animationType = "easeOut";
    }
    handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
  };
};
var zoomOut = function(contextInstance) {
  return function(step, animationTime, animationType) {
    if (step === void 0) {
      step = 0.5;
    }
    if (animationTime === void 0) {
      animationTime = 300;
    }
    if (animationType === void 0) {
      animationType = "easeOut";
    }
    handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
  };
};
var setTransform = function(contextInstance) {
  return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
    if (animationTime === void 0) {
      animationTime = 300;
    }
    if (animationType === void 0) {
      animationType = "easeOut";
    }
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var disabled = contextInstance.setup.disabled;
    if (disabled || !wrapperComponent || !contentComponent)
      return;
    var targetState = {
      positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
      positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
      scale: Number.isNaN(newScale) ? scale : newScale
    };
    animate(contextInstance, targetState, animationTime, animationType);
  };
};
var resetTransform = function(contextInstance) {
  return function(animationTime, animationType) {
    if (animationTime === void 0) {
      animationTime = 200;
    }
    if (animationType === void 0) {
      animationType = "easeOut";
    }
    resetTransformations(contextInstance, animationTime, animationType);
  };
};
var centerView = function(contextInstance) {
  return function(scale, animationTime, animationType) {
    if (animationTime === void 0) {
      animationTime = 200;
    }
    if (animationType === void 0) {
      animationType = "easeOut";
    }
    var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    if (wrapperComponent && contentComponent) {
      var targetState = getCenterPosition(scale || transformState.scale, wrapperComponent, contentComponent);
      animate(contextInstance, targetState, animationTime, animationType);
    }
  };
};
var zoomToElement = function(contextInstance) {
  return function(node, scale, animationTime, animationType) {
    if (animationTime === void 0) {
      animationTime = 600;
    }
    if (animationType === void 0) {
      animationType = "easeOut";
    }
    handleCancelAnimation(contextInstance);
    var wrapperComponent = contextInstance.wrapperComponent;
    var target = typeof node === "string" ? document.getElementById(node) : node;
    if (wrapperComponent && target && wrapperComponent.contains(target)) {
      var targetState = calculateZoomToNode(contextInstance, target, scale);
      animate(contextInstance, targetState, animationTime, animationType);
    }
  };
};
var getControls = function(contextInstance) {
  return {
    instance: contextInstance,
    zoomIn: zoomIn(contextInstance),
    zoomOut: zoomOut(contextInstance),
    setTransform: setTransform(contextInstance),
    resetTransform: resetTransform(contextInstance),
    centerView: centerView(contextInstance),
    zoomToElement: zoomToElement(contextInstance)
  };
};
var getState = function(contextInstance) {
  return {
    instance: contextInstance,
    state: contextInstance.transformState
  };
};
var getContext = function(contextInstance) {
  var ref = {};
  Object.assign(ref, getState(contextInstance));
  Object.assign(ref, getControls(contextInstance));
  return ref;
};
var passiveSupported = false;
function makePassiveEventOption() {
  try {
    var options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    return options;
  } catch (err) {
    passiveSupported = false;
    return passiveSupported;
  }
}
var isExcludedNode = function(node, excluded) {
  return excluded.some(function(exclude) {
    return node.matches("".concat(exclude, ", .").concat(exclude, ", ").concat(exclude, " *, .").concat(exclude, " *"));
  });
};
var cancelTimeout = function(timeout) {
  if (timeout) {
    clearTimeout(timeout);
  }
};
var getTransformStyles = function(x, y, scale) {
  return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var getCenterPosition = function(scale, wrapperComponent, contentComponent) {
  var contentWidth = contentComponent.offsetWidth * scale;
  var contentHeight = contentComponent.offsetHeight * scale;
  var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
  var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
  return {
    scale,
    positionX: centerPositionX,
    positionY: centerPositionY
  };
};
function mergeRefs(refs) {
  return function(value) {
    refs.forEach(function(ref) {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}
var isWheelAllowed = function(contextInstance, event) {
  var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
  var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
  var target = event.target;
  var isAllowed = isInitialized && !isPanning && !disabled && target;
  if (!isAllowed)
    return false;
  if (wheelDisabled && !event.ctrlKey)
    return false;
  if (touchPadDisabled && event.ctrlKey)
    return false;
  var isExcluded = isExcludedNode(target, excluded);
  if (isExcluded)
    return false;
  return true;
};
var getDeltaY = function(event) {
  if (event) {
    return event.deltaY < 0 ? 1 : -1;
  }
  return 0;
};
function getDelta(event, customDelta) {
  var deltaY = getDeltaY(event);
  var delta = checkIsNumber(customDelta, deltaY);
  return delta;
}
function getMousePosition(event, contentComponent, scale) {
  var contentRect = contentComponent.getBoundingClientRect();
  var mouseX = 0;
  var mouseY = 0;
  if ("clientX" in event) {
    mouseX = (event.clientX - contentRect.left) / scale;
    mouseY = (event.clientY - contentRect.top) / scale;
  } else {
    var touch = event.touches[0];
    mouseX = (touch.clientX - contentRect.left) / scale;
    mouseY = (touch.clientY - contentRect.top) / scale;
  }
  if (Number.isNaN(mouseX) || Number.isNaN(mouseY))
    console.error("No mouse or touch offset found");
  return {
    x: mouseX,
    y: mouseY
  };
}
var handleCalculateWheelZoom = function(contextInstance, delta, step, disable, getTarget) {
  var scale = contextInstance.transformState.scale;
  var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
  var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
  var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
  if (!wrapperComponent) {
    throw new Error("Wrapper is not mounted");
  }
  var targetScale = scale + delta * step;
  if (getTarget)
    return targetScale;
  var paddingEnabled = disable ? false : !disabled;
  var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
  return newScale;
};
var handleWheelZoomStop = function(contextInstance, event) {
  var previousWheelEvent = contextInstance.previousWheelEvent;
  var scale = contextInstance.transformState.scale;
  var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
  if (!previousWheelEvent)
    return false;
  if (scale < maxScale || scale > minScale)
    return true;
  if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
    return true;
  if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY)
    return true;
  if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY)
    return true;
  if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
    return true;
  return false;
};
var isPinchStartAllowed = function(contextInstance, event) {
  var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
  var isInitialized = contextInstance.isInitialized;
  var target = event.target;
  var isAllowed = isInitialized && !disabled && target;
  if (!isAllowed)
    return false;
  var isExcluded = isExcludedNode(target, excluded);
  if (isExcluded)
    return false;
  return true;
};
var isPinchAllowed = function(contextInstance) {
  var disabled = contextInstance.setup.pinch.disabled;
  var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
  var isAllowed = isInitialized && !disabled && pinchStartDistance;
  if (!isAllowed)
    return false;
  return true;
};
var calculateTouchMidPoint = function(event, scale, contentComponent) {
  var contentRect = contentComponent.getBoundingClientRect();
  var touches = event.touches;
  var firstPointX = roundNumber(touches[0].clientX - contentRect.left, 5);
  var firstPointY = roundNumber(touches[0].clientY - contentRect.top, 5);
  var secondPointX = roundNumber(touches[1].clientX - contentRect.left, 5);
  var secondPointY = roundNumber(touches[1].clientY - contentRect.top, 5);
  return {
    x: (firstPointX + secondPointX) / 2 / scale,
    y: (firstPointY + secondPointY) / 2 / scale
  };
};
var getTouchDistance = function(event) {
  return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var calculatePinchZoom = function(contextInstance, currentDistance) {
  var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
  var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
  var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
  if (!pinchStartScale || pinchStartDistance === null || !currentDistance) {
    throw new Error("Pinch touches distance was not provided");
  }
  if (currentDistance < 0) {
    return contextInstance.transformState.scale;
  }
  var touchProportion = currentDistance / pinchStartDistance;
  var scaleDifference = touchProportion * pinchStartScale;
  return checkZoomBounds(roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};
var wheelStopEventTime = 160;
var wheelAnimationTime = 100;
var handleWheelStart = function(contextInstance, event) {
  var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
  if (!contextInstance.wheelStopEventTimer) {
    handleCancelAnimation(contextInstance);
    handleCallback(getContext(contextInstance), event, onWheelStart);
    handleCallback(getContext(contextInstance), event, onZoomStart);
  }
};
var handleWheelZoom = function(contextInstance, event) {
  var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
  var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
  var scale = transformState.scale;
  var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
  var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
  var step = wheel.step, smoothStep = wheel.smoothStep;
  if (!contentComponent) {
    throw new Error("Component not mounted");
  }
  event.preventDefault();
  event.stopPropagation();
  var delta = getDelta(event, null);
  var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
  var newScale = handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
  if (scale === newScale)
    return;
  var bounds = handleCalculateBounds(contextInstance, newScale);
  var mousePosition = getMousePosition(event, contentComponent, scale);
  var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
  var isLimitedToBounds = limitToBounds && isPaddingDisabled;
  var _b2 = handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b2.x, y = _b2.y;
  contextInstance.previousWheelEvent = event;
  contextInstance.setTransformState(newScale, x, y);
  handleCallback(getContext(contextInstance), event, onWheel);
  handleCallback(getContext(contextInstance), event, onZoom);
};
var handleWheelStop = function(contextInstance, event) {
  var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
  cancelTimeout(contextInstance.wheelAnimationTimer);
  contextInstance.wheelAnimationTimer = setTimeout(function() {
    if (!contextInstance.mounted)
      return;
    handleAlignToScaleBounds(contextInstance, event.x, event.y);
    contextInstance.wheelAnimationTimer = null;
  }, wheelAnimationTime);
  var hasStoppedZooming = handleWheelZoomStop(contextInstance, event);
  if (hasStoppedZooming) {
    cancelTimeout(contextInstance.wheelStopEventTimer);
    contextInstance.wheelStopEventTimer = setTimeout(function() {
      if (!contextInstance.mounted)
        return;
      contextInstance.wheelStopEventTimer = null;
      handleCallback(getContext(contextInstance), event, onWheelStop);
      handleCallback(getContext(contextInstance), event, onZoomStop);
    }, wheelStopEventTime);
  }
};
var handlePinchStart = function(contextInstance, event) {
  var distance = getTouchDistance(event);
  contextInstance.pinchStartDistance = distance;
  contextInstance.lastDistance = distance;
  contextInstance.pinchStartScale = contextInstance.transformState.scale;
  contextInstance.isPanning = false;
  handleCancelAnimation(contextInstance);
};
var handlePinchZoom = function(contextInstance, event) {
  var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance;
  var scale = contextInstance.transformState.scale;
  var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation;
  var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
  if (pinchStartDistance === null || !contentComponent)
    return;
  var midPoint = calculateTouchMidPoint(event, scale, contentComponent);
  if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y))
    return;
  var currentDistance = getTouchDistance(event);
  var newScale = calculatePinchZoom(contextInstance, currentDistance);
  if (newScale === scale)
    return;
  var bounds = handleCalculateBounds(contextInstance, newScale);
  var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
  var isLimitedToBounds = limitToBounds && isPaddingDisabled;
  var _b2 = handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b2.x, y = _b2.y;
  contextInstance.pinchMidpoint = midPoint;
  contextInstance.lastDistance = currentDistance;
  contextInstance.setTransformState(newScale, x, y);
};
var handlePinchStop = function(contextInstance) {
  var pinchMidpoint = contextInstance.pinchMidpoint;
  contextInstance.velocity = null;
  contextInstance.lastDistance = null;
  contextInstance.pinchMidpoint = null;
  contextInstance.pinchStartScale = null;
  contextInstance.pinchStartDistance = null;
  handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var handleDoubleClickStop = function(contextInstance, event) {
  var onZoomStop = contextInstance.props.onZoomStop;
  var animationTime = contextInstance.setup.doubleClick.animationTime;
  cancelTimeout(contextInstance.doubleClickStopEventTimer);
  contextInstance.doubleClickStopEventTimer = setTimeout(function() {
    contextInstance.doubleClickStopEventTimer = null;
    handleCallback(getContext(contextInstance), event, onZoomStop);
  }, animationTime);
};
var handleDoubleClickResetMode = function(contextInstance, event) {
  var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
  var _b2 = contextInstance.setup.doubleClick, animationTime = _b2.animationTime, animationType = _b2.animationType;
  handleCallback(getContext(contextInstance), event, onZoomStart);
  resetTransformations(contextInstance, animationTime, animationType, function() {
    return handleCallback(getContext(contextInstance), event, onZoom);
  });
  handleDoubleClickStop(contextInstance, event);
};
function getDoubleClickScale(mode, scale) {
  if (mode === "toggle") {
    return scale === 1 ? 1 : -1;
  }
  return mode === "zoomOut" ? -1 : 1;
}
function handleDoubleClick(contextInstance, event) {
  var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
  var scale = transformState.scale;
  var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
  var _b2 = setup.doubleClick, disabled = _b2.disabled, mode = _b2.mode, step = _b2.step, animationTime = _b2.animationTime, animationType = _b2.animationType;
  if (disabled)
    return;
  if (doubleClickStopEventTimer)
    return;
  if (mode === "reset") {
    return handleDoubleClickResetMode(contextInstance, event);
  }
  if (!contentComponent)
    return console.error("No ContentComponent found");
  var delta = getDoubleClickScale(mode, contextInstance.transformState.scale);
  var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
  if (scale === newScale)
    return;
  handleCallback(getContext(contextInstance), event, onZoomStart);
  var mousePosition = getMousePosition(event, contentComponent, scale);
  var targetState = handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
  if (!targetState) {
    return console.error("Error during zoom event. New transformation state was not calculated.");
  }
  handleCallback(getContext(contextInstance), event, onZoom);
  animate(contextInstance, targetState, animationTime, animationType);
  handleDoubleClickStop(contextInstance, event);
}
var isDoubleClickAllowed = function(contextInstance, event) {
  var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
  var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
  var target = event.target;
  var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
  var isAllowed = isInitialized && target && isWrapperChild && !disabled;
  if (!isAllowed)
    return false;
  var isExcluded = isExcludedNode(target, excluded);
  if (isExcluded)
    return false;
  return true;
};
var ZoomPanPinch = (
  /** @class */
  /* @__PURE__ */ function() {
    function ZoomPanPinch2(props) {
      var _this = this;
      this.mounted = true;
      this.onChangeCallbacks = /* @__PURE__ */ new Set();
      this.onInitCallbacks = /* @__PURE__ */ new Set();
      this.wrapperComponent = null;
      this.contentComponent = null;
      this.isInitialized = false;
      this.bounds = null;
      this.previousWheelEvent = null;
      this.wheelStopEventTimer = null;
      this.wheelAnimationTimer = null;
      this.isPanning = false;
      this.isWheelPanning = false;
      this.startCoords = null;
      this.lastTouch = null;
      this.distance = null;
      this.lastDistance = null;
      this.pinchStartDistance = null;
      this.pinchStartScale = null;
      this.pinchMidpoint = null;
      this.doubleClickStopEventTimer = null;
      this.velocity = null;
      this.velocityTime = null;
      this.lastMousePosition = null;
      this.animate = false;
      this.animation = null;
      this.maxBounds = null;
      this.pressedKeys = {};
      this.mount = function() {
        _this.initializeWindowEvents();
      };
      this.unmount = function() {
        _this.cleanupWindowEvents();
      };
      this.update = function(newProps) {
        _this.props = newProps;
        handleCalculateBounds(_this, _this.transformState.scale);
        _this.setup = createSetup(newProps);
      };
      this.initializeWindowEvents = function() {
        var _a, _b2;
        var passive = makePassiveEventOption();
        var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
        var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
        (_b2 = _this.wrapperComponent) === null || _b2 === void 0 ? void 0 : _b2.addEventListener("wheel", _this.onWheelPanning, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mousemove", _this.onPanning, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
        currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
      };
      this.cleanupWindowEvents = function() {
        var _a, _b2;
        var passive = makePassiveEventOption();
        var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
        var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
        currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
        currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
        document.removeEventListener("mouseleave", _this.clearPanning, passive);
        handleCancelAnimation(_this);
        (_b2 = _this.observer) === null || _b2 === void 0 ? void 0 : _b2.disconnect();
      };
      this.handleInitializeWrapperEvents = function(wrapper) {
        var passive = makePassiveEventOption();
        wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
        wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
        wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
        wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
        wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
      };
      this.handleInitialize = function(contentComponent) {
        var centerOnInit = _this.setup.centerOnInit;
        _this.applyTransformation();
        _this.onInitCallbacks.forEach(function(callback) {
          return callback(getContext(_this));
        });
        if (centerOnInit) {
          _this.setCenter();
          _this.observer = new ResizeObserver(function() {
            var _a;
            var currentWidth = contentComponent.offsetWidth;
            var currentHeight = contentComponent.offsetHeight;
            if (currentWidth > 0 || currentHeight > 0) {
              _this.onInitCallbacks.forEach(function(callback) {
                return callback(getContext(_this));
              });
              _this.setCenter();
              (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
            }
          });
          setTimeout(function() {
            var _a;
            (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
          }, 5e3);
          _this.observer.observe(contentComponent);
        }
      };
      this.onWheelZoom = function(event) {
        var disabled = _this.setup.disabled;
        if (disabled)
          return;
        var isAllowed = isWheelAllowed(_this, event);
        if (!isAllowed)
          return;
        var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
        if (!keysPressed)
          return;
        handleWheelStart(_this, event);
        handleWheelZoom(_this, event);
        handleWheelStop(_this, event);
      };
      this.onWheelPanning = function(event) {
        var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
        if (!_this.wrapperComponent || !_this.contentComponent || disabled || !wheel.wheelDisabled || panning.disabled || !panning.wheelPanning || event.ctrlKey) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        var _b2 = _this.transformState, positionX = _b2.positionX, positionY = _b2.positionY;
        var mouseX = positionX - event.deltaX;
        var mouseY = positionY - event.deltaY;
        var newPositionX = panning.lockAxisX ? positionX : mouseX;
        var newPositionY = panning.lockAxisY ? positionY : mouseY;
        var _c2 = _this.setup.alignmentAnimation, sizeX = _c2.sizeX, sizeY = _c2.sizeY;
        var paddingValueX = getPaddingValue(_this, sizeX);
        var paddingValueY = getPaddingValue(_this, sizeY);
        if (newPositionX === positionX && newPositionY === positionY)
          return;
        handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
      };
      this.onPanningStart = function(event) {
        var disabled = _this.setup.disabled;
        var onPanningStart = _this.props.onPanningStart;
        if (disabled)
          return;
        var isAllowed = isPanningStartAllowed(_this, event);
        if (!isAllowed)
          return;
        var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
        if (!keysPressed)
          return;
        if (event.button === 0 && !_this.setup.panning.allowLeftClickPan)
          return;
        if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan)
          return;
        if (event.button === 2 && !_this.setup.panning.allowRightClickPan)
          return;
        event.preventDefault();
        event.stopPropagation();
        handleCancelAnimation(_this);
        handlePanningStart(_this, event);
        handleCallback(getContext(_this), event, onPanningStart);
      };
      this.onPanning = function(event) {
        var disabled = _this.setup.disabled;
        var onPanning = _this.props.onPanning;
        if (disabled)
          return;
        var isAllowed = isPanningAllowed(_this);
        if (!isAllowed)
          return;
        var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
        if (!keysPressed)
          return;
        event.preventDefault();
        event.stopPropagation();
        handlePanning(_this, event.clientX, event.clientY);
        handleCallback(getContext(_this), event, onPanning);
      };
      this.onPanningStop = function(event) {
        var onPanningStop = _this.props.onPanningStop;
        if (_this.isPanning) {
          handlePanningEnd(_this);
          handleCallback(getContext(_this), event, onPanningStop);
        }
      };
      this.onPinchStart = function(event) {
        var disabled = _this.setup.disabled;
        var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
        if (disabled)
          return;
        var isAllowed = isPinchStartAllowed(_this, event);
        if (!isAllowed)
          return;
        handlePinchStart(_this, event);
        handleCancelAnimation(_this);
        handleCallback(getContext(_this), event, onPinchingStart);
        handleCallback(getContext(_this), event, onZoomStart);
      };
      this.onPinch = function(event) {
        var disabled = _this.setup.disabled;
        var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
        if (disabled)
          return;
        var isAllowed = isPinchAllowed(_this);
        if (!isAllowed)
          return;
        event.preventDefault();
        event.stopPropagation();
        handlePinchZoom(_this, event);
        handleCallback(getContext(_this), event, onPinching);
        handleCallback(getContext(_this), event, onZoom);
      };
      this.onPinchStop = function(event) {
        var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
        if (_this.pinchStartScale) {
          handlePinchStop(_this);
          handleCallback(getContext(_this), event, onPinchingStop);
          handleCallback(getContext(_this), event, onZoomStop);
        }
      };
      this.onTouchPanningStart = function(event) {
        var disabled = _this.setup.disabled;
        var onPanningStart = _this.props.onPanningStart;
        if (disabled)
          return;
        var isAllowed = isPanningStartAllowed(_this, event);
        if (!isAllowed)
          return;
        var isDoubleTap = _this.lastTouch && +/* @__PURE__ */ new Date() - _this.lastTouch < 200;
        if (isDoubleTap && event.touches.length === 1) {
          _this.onDoubleClick(event);
        } else {
          _this.lastTouch = +/* @__PURE__ */ new Date();
          handleCancelAnimation(_this);
          var touches = event.touches;
          var isPanningAction = touches.length === 1;
          var isPinchAction = touches.length === 2;
          if (isPanningAction) {
            handleCancelAnimation(_this);
            handlePanningStart(_this, event);
            handleCallback(getContext(_this), event, onPanningStart);
          }
          if (isPinchAction) {
            _this.onPinchStart(event);
          }
        }
      };
      this.onTouchPanning = function(event) {
        var disabled = _this.setup.disabled;
        var onPanning = _this.props.onPanning;
        if (_this.isPanning && event.touches.length === 1) {
          if (disabled)
            return;
          var isAllowed = isPanningAllowed(_this);
          if (!isAllowed)
            return;
          event.preventDefault();
          event.stopPropagation();
          var touch = event.touches[0];
          handlePanning(_this, touch.clientX, touch.clientY);
          handleCallback(getContext(_this), event, onPanning);
        } else if (event.touches.length > 1) {
          _this.onPinch(event);
        }
      };
      this.onTouchPanningStop = function(event) {
        _this.onPanningStop(event);
        _this.onPinchStop(event);
      };
      this.onDoubleClick = function(event) {
        var disabled = _this.setup.disabled;
        if (disabled)
          return;
        var isAllowed = isDoubleClickAllowed(_this, event);
        if (!isAllowed)
          return;
        handleDoubleClick(_this, event);
      };
      this.clearPanning = function(event) {
        if (_this.isPanning) {
          _this.onPanningStop(event);
        }
      };
      this.setKeyPressed = function(e) {
        _this.pressedKeys[e.key] = true;
      };
      this.setKeyUnPressed = function(e) {
        _this.pressedKeys[e.key] = false;
      };
      this.isPressingKeys = function(keys2) {
        if (!keys2.length) {
          return true;
        }
        return Boolean(keys2.find(function(key) {
          return _this.pressedKeys[key];
        }));
      };
      this.setTransformState = function(scale, positionX, positionY) {
        var onTransformed = _this.props.onTransformed;
        if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
          if (scale !== _this.transformState.scale) {
            _this.transformState.previousScale = _this.transformState.scale;
            _this.transformState.scale = scale;
          }
          _this.transformState.positionX = positionX;
          _this.transformState.positionY = positionY;
          _this.applyTransformation();
          var ctx_1 = getContext(_this);
          _this.onChangeCallbacks.forEach(function(callback) {
            return callback(ctx_1);
          });
          handleCallback(ctx_1, { scale, positionX, positionY }, onTransformed);
        } else {
          console.error("Detected NaN set state values");
        }
      };
      this.setCenter = function() {
        if (_this.wrapperComponent && _this.contentComponent) {
          var targetState = getCenterPosition(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
          _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
        }
      };
      this.handleTransformStyles = function(x, y, scale) {
        if (_this.props.customTransform) {
          return _this.props.customTransform(x, y, scale);
        }
        return getTransformStyles(x, y, scale);
      };
      this.applyTransformation = function() {
        if (!_this.mounted || !_this.contentComponent)
          return;
        var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var transform = _this.handleTransformStyles(positionX, positionY, scale);
        _this.contentComponent.style.transform = transform;
      };
      this.getContext = function() {
        return getContext(_this);
      };
      this.onChange = function(callback) {
        if (!_this.onChangeCallbacks.has(callback)) {
          _this.onChangeCallbacks.add(callback);
        }
        return function() {
          _this.onChangeCallbacks.delete(callback);
        };
      };
      this.onInit = function(callback) {
        if (!_this.onInitCallbacks.has(callback)) {
          _this.onInitCallbacks.add(callback);
        }
        return function() {
          _this.onInitCallbacks.delete(callback);
        };
      };
      this.init = function(wrapperComponent, contentComponent) {
        _this.cleanupWindowEvents();
        _this.wrapperComponent = wrapperComponent;
        _this.contentComponent = contentComponent;
        handleCalculateBounds(_this, _this.transformState.scale);
        _this.handleInitializeWrapperEvents(wrapperComponent);
        _this.handleInitialize(contentComponent);
        _this.initializeWindowEvents();
        _this.isInitialized = true;
        var ctx = getContext(_this);
        handleCallback(ctx, void 0, _this.props.onInit);
      };
      this.props = props;
      this.setup = createSetup(this.props);
      this.transformState = createState(this.props);
    }
    return ZoomPanPinch2;
  }()
);
var Context = React__default.createContext(null);
var getContent = function(children, ctx) {
  if (typeof children === "function") {
    return children(ctx);
  }
  return children;
};
var TransformWrapper = React__default.forwardRef(function(props, ref) {
  var instance = useRef(new ZoomPanPinch(props)).current;
  var content = getContent(props.children, getControls(instance));
  useImperativeHandle(ref, function() {
    return getControls(instance);
  }, [instance]);
  useEffect(function() {
    instance.update(props);
  }, [instance, props]);
  return React__default.createElement(Context.Provider, { value: instance }, content);
});
React__default.forwardRef(function(props, ref) {
  var localRef = useRef(null);
  var instance = useContext(Context);
  useEffect(function() {
    return instance.onChange(function(ctx) {
      if (localRef.current) {
        var positionX = 0;
        var positionY = 0;
        localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
      }
    });
  }, [instance]);
  return React__default.createElement("div", __assign({}, props, { ref: mergeRefs([localRef, ref]) }));
});
function styleInject(css, ref) {
  if (ref === void 0)
    ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === "undefined") {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";
  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var styles = { "wrapper": "transform-component-module_wrapper__SPB86", "content": "transform-component-module_content__FBWxo" };
styleInject(css_248z);
var TransformComponent = function(_a) {
  var children = _a.children, _b2 = _a.wrapperClass, wrapperClass = _b2 === void 0 ? "" : _b2, _c2 = _a.contentClass, contentClass = _c2 === void 0 ? "" : _c2, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d2 = _a.wrapperProps, wrapperProps = _d2 === void 0 ? {} : _d2, _e2 = _a.contentProps, contentProps = _e2 === void 0 ? {} : _e2;
  var _f = useContext(Context), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
  var wrapperRef = useRef(null);
  var contentRef = useRef(null);
  useEffect(function() {
    var wrapper = wrapperRef.current;
    var content = contentRef.current;
    if (wrapper !== null && content !== null && init) {
      init === null || init === void 0 ? void 0 : init(wrapper, content);
    }
    return function() {
      cleanupWindowEvents === null || cleanupWindowEvents === void 0 ? void 0 : cleanupWindowEvents();
    };
  }, []);
  return React__default.createElement(
    "div",
    __assign({}, wrapperProps, { ref: wrapperRef, className: "react-transform-wrapper ".concat(styles.wrapper, " ").concat(wrapperClass), style: wrapperStyle }),
    React__default.createElement("div", __assign({}, contentProps, { ref: contentRef, className: "react-transform-component ".concat(styles.content, " ").concat(contentClass), style: contentStyle }), children)
  );
};
const SvgZoom = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M6.58824 12.8333C3.23136 12.8333 0.5 10.078 0.5 6.66667C0.5 3.25532 3.23136 0.5 6.58824 0.5C9.94513 0.5 12.6765 3.25532 12.6765 6.66667C12.6765 8.43229 11.9446 10.0229 10.7717 11.1469C9.67981 12.1933 8.20792 12.8333 6.58824 12.8333Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { y1: -0.5, x2: 4.6864, y2: -0.5, transform: "matrix(0.702911 0.711278 -0.702911 0.711278 10.7059 11.6667)", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M2.96471 7L10.8706 7", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M6.91766 11L6.91766 3", stroke: "currentColor", strokeLinecap: "round" }));
const ZoomSVG = SvgZoom;
const ShortBookingTimeModal = ({
  isOpen,
  onClose,
  onConfirm,
  shortBookingTimeData,
  obeeSettings: obeeSettings2
}) => {
  const getDuration = () => {
    var _a, _b2, _c2, _d2, _e2, _f, _g, _h;
    switch ((_a = shortBookingTimeData == null ? void 0 : shortBookingTimeData.conflict) == null ? void 0 : _a.type) {
      case BOOKING_CONFLICT_TYPE.BOOKING: {
        return ((_b2 = shortBookingTimeData == null ? void 0 : shortBookingTimeData.conflict) == null ? void 0 : _b2.time) - ((_c2 = shortBookingTimeData == null ? void 0 : shortBookingTimeData.over) == null ? void 0 : _c2.time);
      }
      case BOOKING_CONFLICT_TYPE.BLOCK: {
        return ((_d2 = shortBookingTimeData == null ? void 0 : shortBookingTimeData.conflict) == null ? void 0 : _d2.startTime) - ((_e2 = shortBookingTimeData == null ? void 0 : shortBookingTimeData.over) == null ? void 0 : _e2.time);
      }
      case BOOKING_CONFLICT_TYPE.SESSION: {
        return ((_f = shortBookingTimeData == null ? void 0 : shortBookingTimeData.conflict) == null ? void 0 : _f.endTime) - ((_g = shortBookingTimeData == null ? void 0 : shortBookingTimeData.over) == null ? void 0 : _g.time);
      }
      default: {
        return (_h = obeeSettings2.data) == null ? void 0 : _h.bookingsDuration;
      }
    }
  };
  const getPrompt = () => {
    var _a, _b2, _c2, _d2;
    switch ((_a = shortBookingTimeData == null ? void 0 : shortBookingTimeData.conflict) == null ? void 0 : _a.type) {
      case BOOKING_CONFLICT_TYPE.BOOKING: {
        return `The next booking starts at ${formatTimeFromInt(
          (_b2 = shortBookingTimeData == null ? void 0 : shortBookingTimeData.conflict) == null ? void 0 : _b2.time
        )}, meaning this booking will have a shorter sitting time of ${getDuration()} mins.`;
      }
      case BOOKING_CONFLICT_TYPE.BLOCK: {
        return `The table is blocked at ${formatTimeFromInt(
          (_c2 = shortBookingTimeData == null ? void 0 : shortBookingTimeData.conflict) == null ? void 0 : _c2.startTime
        )}, meaning this booking will have a shorter sitting time of ${getDuration()} mins.`;
      }
      case BOOKING_CONFLICT_TYPE.SESSION: {
        return `The session ends at ${formatTimeFromInt(
          (_d2 = shortBookingTimeData == null ? void 0 : shortBookingTimeData.conflict) == null ? void 0 : _d2.endTime
        )}, meaning this booking will have a shorter sitting time of ${getDuration()} mins.`;
      }
      default: {
        return "";
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      isOpen,
      onClose,
      onConfirm: () => onConfirm({
        ...shortBookingTimeData == null ? void 0 : shortBookingTimeData.booking,
        ...shortBookingTimeData == null ? void 0 : shortBookingTimeData.over,
        duration: getDuration()
      }),
      heading: "Short booking time",
      prompt: getPrompt(),
      confirmLabel: "Continue, update booking"
    }
  );
};
ShortBookingTimeModal.defaultProps = {
  shortBookingTimeData: null
};
ShortBookingTimeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  shortBookingTimeData: PropTypes.shape({
    booking: obeeBookingPropTypes,
    // the booking that was dragged
    conflict: obeeBookingPropTypes,
    // the booking that it was conflicted with
    over: PropTypes.shape({
      time: PropTypes.number,
      areaId: PropTypes.number,
      tableNumber: PropTypes.string
    })
    // the cell data where the booking was dropped
  }),
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$1U = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$1T = (dispatch) => bindActionCreators({}, dispatch);
const ShortBookingTimeModal$1 = connect(mapStateToProps$1U, mapDispatchToProps$1T)(ShortBookingTimeModal);
const SwapBookingsModal = ({ isOpen, onClose, onConfirm, swapBookingsData }) => {
  const booking = swapBookingsData == null ? void 0 : swapBookingsData.booking;
  const bookingToSwap = swapBookingsData == null ? void 0 : swapBookingsData.bookingToSwap;
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      isOpen,
      onClose,
      onConfirm: () => onConfirm([
        // updated booking that was dragged
        {
          ...booking,
          areaId: bookingToSwap == null ? void 0 : bookingToSwap.areaId,
          tableNumber: bookingToSwap == null ? void 0 : bookingToSwap.tableNumber,
          time: bookingToSwap == null ? void 0 : bookingToSwap.time
        },
        // updated booking that it can swap with
        {
          ...bookingToSwap,
          areaId: booking == null ? void 0 : booking.areaId,
          tableNumber: booking == null ? void 0 : booking.tableNumber,
          time: booking == null ? void 0 : booking.time
        }
      ]),
      heading: "Swap bookings",
      prompt: `Booking for ${getBookingName(booking)} at table ${booking == null ? void 0 : booking.tableNumberDisplay} will be moved to table ${bookingToSwap == null ? void 0 : bookingToSwap.tableNumberDisplay}.

      Booking for ${getBookingName(bookingToSwap)} at table ${bookingToSwap == null ? void 0 : bookingToSwap.tableNumberDisplay} will be moved to table ${booking == null ? void 0 : booking.tableNumberDisplay}.`,
      confirmLabel: "Continue, swap booking"
    }
  );
};
SwapBookingsModal.defaultProps = {
  swapBookingsData: null
};
SwapBookingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  swapBookingsData: PropTypes.shape({
    booking: obeeBookingPropTypes,
    // the booking that was dragged
    bookingToSwap: obeeBookingPropTypes
    // the booking that it can swap with
  })
};
const SwapBookingsModal$1 = SwapBookingsModal;
const TableCapacityModal = ({ isOpen, onClose, onConfirm, tableCapacityData }) => {
  const getConflict = () => {
    var _a;
    if (tableCapacityData) {
      const { booking, conflict } = tableCapacityData;
      if (booking.size > conflict.maxSeats) {
        return `This booking's party size of ${booking == null ? void 0 : booking.size} exceeds the table's max seating limit of ${conflict == null ? void 0 : conflict.maxSeats}.`;
      }
      if (booking.size < conflict.minSeats) {
        return `This booking's party size of ${booking == null ? void 0 : booking.size} is less than the table's min seating limit of ${conflict == null ? void 0 : conflict.minSeats}.`;
      }
    }
    return `This booking's party size of ${(_a = tableCapacityData == null ? void 0 : tableCapacityData.booking) == null ? void 0 : _a.size} exceeds the  table's seating limit.`;
  };
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      isOpen,
      onClose,
      onConfirm: () => onConfirm({ ...tableCapacityData == null ? void 0 : tableCapacityData.booking, ...tableCapacityData == null ? void 0 : tableCapacityData.over }),
      heading: "Exceeds Table Capacity",
      prompt: getConflict(),
      confirmLabel: "Continue, update booking"
    }
  );
};
TableCapacityModal.defaultProps = {
  tableCapacityData: null
};
TableCapacityModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  tableCapacityData: PropTypes.shape({
    booking: obeeBookingPropTypes,
    // the booking that was dragged
    conflict: tablePropTypes,
    // the table that it was conflicted with
    over: PropTypes.shape({
      time: PropTypes.number,
      areaId: PropTypes.number,
      tableNumber: PropTypes.string
    })
    // the cell data where the booking was dropped
  })
};
const TableCapacityModal$1 = TableCapacityModal;
const clearObeeAvailabilityAction = () => (dispatch) => {
  dispatch({
    type: `CLEAR_OBEE_AVAILABILITY`
  });
};
const checkObeeAvailabilityAction = (date, areaId, time, size, isPublic, returnAll, excludeBookingId = null) => (dispatch) => {
  const action = "CHECK_OBEE_AVAILABILITY";
  const entityName = "obeeAvailabilityCheck";
  const error = (errorMessage) => `Unable to retrieve obeeAvailabilityCheck: ${errorMessage}`;
  const data = {
    date: formatDate(date, "YYYY-MM-DD"),
    areaId,
    time,
    size,
    public: false,
    returnAll
  };
  const request = () => checkObeeAvailability(data);
  dispatch(makeApiAction(action, request, {}, entityName, null, {}, false, error));
};
const checkObeeAvailabilityAllAreasAction = (date, time, size, isPublic, returnAll, excludeBookingId = null) => (dispatch) => {
  const action = "CHECK_OBEE_AVAILABILITY";
  const entityName = "obeeAvailabilityCheckAllAreas";
  const error = (errorMessage) => `Unable to retrieve obee availability for all areas: ${errorMessage}`;
  const data = {
    date: formatDate(date, "YYYY-MM-DD"),
    time,
    size,
    public: false,
    returnAll
  };
  const request = () => checkObeeAvailabilityAllAreas(data);
  dispatch(makeApiAction(action, request, {}, entityName, null, {}, false, error));
};
const SvgClock = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 9, cy: 9.26953, r: 8.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.67871 11.1978L8.67871 4.26944", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 9, y1: 10.6978, x2: 12.8571, y2: 10.6978, stroke: "currentColor" }));
const ClockSVG = SvgClock;
const HeaderButton = ({ type: type2, style, ...props }) => {
  const theme2 = useTheme$1();
  const buttonStyles2 = {
    container: {
      ...style,
      ...style == null ? void 0 : style.container
    },
    button: {
      ...theme2.typography.buttonText,
      borderRadius: "100px",
      color: theme2.colors.charcoal,
      padding: type2 === "round" ? "0" : "0 12px",
      // border: '1px solid transparent',
      // height: '36px',
      display: "flex",
      textAlign: "center",
      alignItems: "center",
      justifyContent: type2 === "round" ? "center" : "flex-start",
      width: type2 === "round" ? "40px" : "auto",
      height: "40px",
      transition: "all 0.1s",
      backgroundColor: "transparent",
      border: `1px solid ${theme2.colors.headerButtonOutline}`,
      ...style == null ? void 0 : style.button
    },
    buttonHover: {
      // backgroundColor: theme.colors.LINEN_DARK,
      backgroundColor: theme2.colors.white,
      border: `1px solid ${theme2.colors.charcoal}`,
      filter: "none"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles2, ...props });
};
HeaderButton.defaultProps = {
  type: null,
  style: {}
};
HeaderButton.propTypes = {
  type: PropTypes.string,
  style: PropTypes.shape({ button: PropTypes.shape({}), container: PropTypes.shape({}) })
};
const mapStateToProps$1T = () => ({});
const mapDispatchToProps$1S = (dispatch) => bindActionCreators({}, dispatch);
const HeaderButton$1 = connect(mapStateToProps$1T, mapDispatchToProps$1S)(HeaderButton);
const useStyles$12 = createUseStyles(
  (theme2) => ({
    textDropdownContainer: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      // padding: '4px 8px',
      marginLeft: "-8px",
      // to offset padding for text buttons
      borderRadius: "6px",
      maxWidth: "fit-content",
      transition: "background 0.1s",
      userSelect: "none",
      "&:hover": {
        cursor: "pointer",
        background: theme2.colors.alabaster
      }
    }
  }),
  { name: "TextDropdown" }
);
const TextDropdown = ({ value, items, onSelect: onSelect2 }) => {
  const classes = useStyles$12();
  const theme2 = useTheme$1();
  const [anchor, setAnchor] = useState(null);
  const label = getLabelForValue(value, items);
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      title: label,
      type: "custom",
      className: classes.textDropdownContainer,
      onClick: (e) => setAnchor(e.currentTarget),
      forceHoverState: !!anchor,
      style: {
        button: {
          color: theme2.colors.charcoal,
          fontWeight: theme2.fontWeights.medium,
          alignItems: "center",
          padding: "4px 8px",
          borderRadius: "6px",
          width: "fit-content",
          transition: "background 0.05s",
          userSelect: "none"
        }
      }
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { gap: 8 }, /* @__PURE__ */ React__default.createElement(Box, { style: { maxWidth: "220px", textOverflow: "ellipsis", overflow: "hidden" } }, label), /* @__PURE__ */ React__default.createElement(
      DownCaretSVG,
      {
        style: {
          width: "10px",
          height: "10px",
          marginTop: "2px",
          transform: anchor && "rotate(180deg)",
          transition: "transform 0.1s"
        }
      }
    ))
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      isOpen: !!anchor,
      onClose: () => setAnchor(null),
      anchor,
      items,
      onSelect: onSelect2,
      style: { item: { fontSize: "16px" } },
      value
    }
  ));
};
TextDropdown.defaultProps = {
  value: null,
  items: [],
  onSelect: (e) => e
};
TextDropdown.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func
};
const TextDropdown$1 = TextDropdown;
const useStyles$11 = createUseStyles(
  (theme2) => ({
    dailyNoteContainer: {
      padding: "0 10px 10px 20px",
      maxHeight: "150px",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    dailyNote: {
      padding: "12px 8px 12px 8px",
      borderRadius: "12px",
      backgroundColor: theme2.colors.lightShade,
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      color: theme2.colors.charcoal,
      fontSize: "14px"
    },
    noteIconBackground: {
      width: "32px",
      height: "32px",
      flexShrink: 0,
      borderRadius: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme2.colors.linen
    },
    noteIcon: {
      flexShrink: 0,
      height: "23px",
      width: "22px",
      marginLeft: "-2px"
    },
    dailyNoteText: {
      color: theme2.colors.charcoal,
      fontSize: "14px",
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    dailyNoteTitle: {
      fontWeight: theme2.fontWeights.medium,
      whiteSpace: "pre-wrap",
      textOverflow: "ellipsis"
    },
    dailyNoteMessage: {
      whiteSpace: "pre-wrap",
      textOverflow: "ellipsis"
    }
  }),
  { name: "NotePreviewSmall" }
);
const NotePreviewSmall = ({ date, dailyNotes, dailyNoteCategories }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$11();
  const notesForDay = useMemo(
    () => dailyNotes.data.filter((note) => note.pinned).filter((note) => note.date === formatDate(date, "YYYY-MM-DD")).sort((a, b) => sortByDate(a.createdDate, b.createdDate, "YYYY-MM-DD HH:mm:ss", true)).map((note) => ({
      ...note,
      color: getDailyNoteColor(
        findObjectByProperty(dailyNoteCategories == null ? void 0 : dailyNoteCategories.data, note == null ? void 0 : note.category, "id"),
        theme2
      )
    })),
    [dailyNotes.data, date]
  );
  if (isEmpty(notesForDay)) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.dailyNoteContainer }, notesForDay.map((note) => /* @__PURE__ */ React__default.createElement(Box, { className: classes.dailyNote }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.noteIconBackground, style: { backgroundColor: note.color } }, /* @__PURE__ */ React__default.createElement(NotesSVG, { className: classes.noteIcon })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.dailyNoteText }, (note == null ? void 0 : note.title) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.dailyNoteTitle }, note == null ? void 0 : note.title), (note == null ? void 0 : note.note) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.dailyNoteMessage }, note == null ? void 0 : note.note)))));
};
NotePreviewSmall.defaultProps = {
  date: moment$2()
};
NotePreviewSmall.propTypes = {
  date: momentPropTypes.momentObj,
  dailyNotes: dailyNotesPropTypes.isRequired,
  dailyNoteCategories: dailyNotesPropTypes.isRequired
};
const mapStateToProps$1S = (state) => ({
  date: state.obeeScreen.date,
  dailyNotes: state.dailyNotes,
  dailyNoteCategories: state.dailyNoteCategories
});
const mapDispatchToProps$1R = (dispatch) => bindActionCreators({}, dispatch);
const NotePreviewSmall$1 = connect(mapStateToProps$1S, mapDispatchToProps$1R)(NotePreviewSmall);
const useStyles$10 = createUseStyles((theme2) => ({
  cakeContainer: {
    position: "relative",
    backgroundColor: theme2.colors.cakeBackground,
    width: "22px",
    maxWidth: "22px",
    minWidth: "22px",
    height: "22px",
    minHeight: "22px",
    maxHeight: "22px",
    borderRadius: "20px",
    color: theme2.colors.labelText,
    justifyContent: "center"
  },
  cake: {
    position: "absolute",
    left: "1px",
    top: "3px",
    width: "19px"
  }
}));
const SvgCake = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M2.5 9C2.5 8.17157 3.17157 7.5 4 7.5H15C15.8284 7.5 16.5 8.17157 16.5 9V14C16.5 14.8284 15.8284 15.5 15 15.5H2.5V9Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 11.25, y: 5.25, width: 0.5, height: 2.5, rx: 0.25, stroke: "currentColor", strokeWidth: 0.5 }), /* @__PURE__ */ React$7.createElement("rect", { x: 7.25, y: 5.25, width: 0.5, height: 2.5, rx: 0.25, stroke: "currentColor", strokeWidth: 0.5 }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.5 3C8.5 3.55228 8.05228 4 7.5 4C6.94772 4 6.5 3.55228 6.5 3C6.5 2.67347 6.64491 1.99123 6.90035 1.38292C7.02635 1.08285 7.16537 0.835082 7.3011 0.671312C7.41779 0.530517 7.48577 0.505283 7.5 0.500877C7.51423 0.505283 7.58221 0.530517 7.6989 0.671312C7.83463 0.835082 7.97365 1.08285 8.09965 1.38292C8.35509 1.99123 8.5 2.67347 8.5 3Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.5 3C12.5 3.55228 12.0523 4 11.5 4C10.9477 4 10.5 3.55228 10.5 3C10.5 2.67347 10.6449 1.99123 10.9003 1.38292C11.0263 1.08285 11.1654 0.835082 11.3011 0.671312C11.4178 0.530517 11.4858 0.505283 11.5 0.500877C11.5142 0.505283 11.5822 0.530517 11.6989 0.671312C11.8346 0.835082 11.9737 1.08285 12.0997 1.38292C12.3551 1.99123 12.5 2.67347 12.5 3Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M2.5 10.5C2.66667 10.8333 2.7 11.5 3.5 11.5C4.5 11.5 4.5 10 5.5 10C6.5 10 6.5 11.5 7.5 11.5C8.5 11.5 9 10 9.5 10C10 10 9.5 11.5 11 11.5C12.5 11.5 12 10 13 10C14 10 13.5 11.5 15 11.5C16.5 11.5 15.5 10 16.5 10", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("mask", { id: "path-7-inside-1_2363_14175", fill: "white" }, /* @__PURE__ */ React$7.createElement("rect", { y: 15, width: 19, height: 3, rx: 0.5 })), /* @__PURE__ */ React$7.createElement("rect", { y: 15, width: 19, height: 3, rx: 0.5, stroke: "currentColor", strokeWidth: 2, mask: "url(#path-7-inside-1_2363_14175)" }));
const CakeIconSVG = SvgCake;
const Cake = () => {
  const classes = useStyles$10();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.cakeContainer }, /* @__PURE__ */ React__default.createElement(CakeIconSVG, { className: classes.cake }));
};
Cake.defaultProps = {};
Cake.propTypes = {};
var cjs = { exports: {} };
var Draggable$1 = {};
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length; )
    (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
const clsx_m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx,
  default: clsx
}, Symbol.toStringTag, { value: "Module" }));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(clsx_m);
var domFns = {};
var shims = {};
Object.defineProperty(shims, "__esModule", {
  value: true
});
shims.dontSetMe = dontSetMe;
shims.findInArray = findInArray;
shims.int = int;
shims.isFunction = isFunction;
shims.isNum = isNum;
function findInArray(array, callback) {
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array]))
      return array[i];
  }
}
function isFunction(func) {
  return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function isNum(num) {
  return typeof num === "number" && !isNaN(num);
}
function int(a) {
  return parseInt(a, 10);
}
function dontSetMe(props, propName, componentName) {
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}
var getPrefix$1 = {};
Object.defineProperty(getPrefix$1, "__esModule", {
  value: true
});
getPrefix$1.browserPrefixToKey = browserPrefixToKey;
getPrefix$1.browserPrefixToStyle = browserPrefixToStyle;
getPrefix$1.default = void 0;
getPrefix$1.getPrefix = getPrefix;
var prefixes = ["Moz", "Webkit", "O", "ms"];
function getPrefix() {
  var _window$document, _window$document$docu;
  var prop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window === "undefined")
    return "";
  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
  if (!style)
    return "";
  if (prop in style)
    return "";
  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style)
      return prefixes[i];
  }
  return "";
}
function browserPrefixToKey(prop, prefix) {
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}
function browserPrefixToStyle(prop, prefix) {
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function kebabToTitleCase(str) {
  var out = "";
  var shouldCapitalize = true;
  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === "-") {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}
var _default = getPrefix();
getPrefix$1.default = _default;
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$3(obj);
}
Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;
var _shims$2 = shims;
var _getPrefix = _interopRequireWildcard$1(getPrefix$1);
function _getRequireWildcardCache$1(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$1(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof$3(obj) !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$1(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var matchesSelectorFunc = "";
function matchesSelector(el, selector) {
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$2.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(method) {
      return (0, _shims$2.isFunction)(el[method]);
    });
  }
  if (!(0, _shims$2.isFunction)(el[matchesSelectorFunc]))
    return false;
  return el[matchesSelectorFunc](selector);
}
function matchesSelectorAndParentsTo(el, selector, baseNode) {
  var node = el;
  do {
    if (matchesSelector(node, selector))
      return true;
    if (node === baseNode)
      return false;
    node = node.parentNode;
  } while (node);
  return false;
}
function addEvent(el, event, handler, inputOptions) {
  if (!el)
    return;
  var options = _objectSpread({
    capture: true
  }, inputOptions);
  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent("on" + event, handler);
  } else {
    el["on" + event] = handler;
  }
}
function removeEvent(el, event, handler, inputOptions) {
  if (!el)
    return;
  var options = _objectSpread({
    capture: true
  }, inputOptions);
  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent("on" + event, handler);
  } else {
    el["on" + event] = null;
  }
}
function outerHeight(node) {
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims$2.int)(computedStyle.borderTopWidth);
  height += (0, _shims$2.int)(computedStyle.borderBottomWidth);
  return height;
}
function outerWidth(node) {
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims$2.int)(computedStyle.borderLeftWidth);
  width += (0, _shims$2.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node) {
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims$2.int)(computedStyle.paddingTop);
  height -= (0, _shims$2.int)(computedStyle.paddingBottom);
  return height;
}
function innerWidth(node) {
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims$2.int)(computedStyle.paddingLeft);
  width -= (0, _shims$2.int)(computedStyle.paddingRight);
  return width;
}
function offsetXYFromParent(evt, offsetParent2, scale) {
  var isBody = offsetParent2 === offsetParent2.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent2.getBoundingClientRect();
  var x = (evt.clientX + offsetParent2.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent2.scrollTop - offsetParentRect.top) / scale;
  return {
    x,
    y
  };
}
function createCSSTransform(controlPos, positionOffset) {
  var translation = getTranslation(controlPos, positionOffset, "px");
  return _defineProperty$1({}, (0, _getPrefix.browserPrefixToKey)("transform", _getPrefix.default), translation);
}
function createSVGTransform(controlPos, positionOffset) {
  var translation = getTranslation(controlPos, positionOffset, "");
  return translation;
}
function getTranslation(_ref2, positionOffset, unitSuffix) {
  var x = _ref2.x, y = _ref2.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }
  return translation;
}
function getTouch(e, identifier) {
  return e.targetTouches && (0, _shims$2.findInArray)(e.targetTouches, function(t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims$2.findInArray)(e.changedTouches, function(t) {
    return identifier === t.identifier;
  });
}
function getTouchIdentifier(e) {
  if (e.targetTouches && e.targetTouches[0])
    return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0])
    return e.changedTouches[0].identifier;
}
function addUserSelectStyles(doc) {
  if (!doc)
    return;
  var styleEl = doc.getElementById("react-draggable-style-el");
  if (!styleEl) {
    styleEl = doc.createElement("style");
    styleEl.type = "text/css";
    styleEl.id = "react-draggable-style-el";
    styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
    styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
    doc.getElementsByTagName("head")[0].appendChild(styleEl);
  }
  if (doc.body)
    addClassName(doc.body, "react-draggable-transparent-selection");
}
function removeUserSelectStyles(doc) {
  if (!doc)
    return;
  try {
    if (doc.body)
      removeClassName(doc.body, "react-draggable-transparent-selection");
    if (doc.selection) {
      doc.selection.empty();
    } else {
      var selection = (doc.defaultView || window).getSelection();
      if (selection && selection.type !== "Caret") {
        selection.removeAllRanges();
      }
    }
  } catch (e) {
  }
}
function addClassName(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}
function removeClassName(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
  }
}
var positionFns = {};
Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;
var _shims$1 = shims;
var _domFns$1 = domFns;
function getBoundPosition(draggable, x, y) {
  if (!draggable.props.bounds)
    return [x, y];
  var bounds = draggable.props.bounds;
  bounds = typeof bounds === "string" ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);
  if (typeof bounds === "string") {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;
    if (bounds === "parent") {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    var boundNodeEl = boundNode;
    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
    bounds = {
      left: -node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingLeft) + (0, _shims$1.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingTop) + (0, _shims$1.int)(nodeStyle.marginTop),
      right: (0, _domFns$1.innerWidth)(boundNodeEl) - (0, _domFns$1.outerWidth)(node) - node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingRight) - (0, _shims$1.int)(nodeStyle.marginRight),
      bottom: (0, _domFns$1.innerHeight)(boundNodeEl) - (0, _domFns$1.outerHeight)(node) - node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingBottom) - (0, _shims$1.int)(nodeStyle.marginBottom)
    };
  }
  if ((0, _shims$1.isNum)(bounds.right))
    x = Math.min(x, bounds.right);
  if ((0, _shims$1.isNum)(bounds.bottom))
    y = Math.min(y, bounds.bottom);
  if ((0, _shims$1.isNum)(bounds.left))
    x = Math.max(x, bounds.left);
  if ((0, _shims$1.isNum)(bounds.top))
    y = Math.max(y, bounds.top);
  return [x, y];
}
function snapToGrid(grid, pendingX, pendingY) {
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}
function canDragX(draggable) {
  return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function canDragY(draggable) {
  return draggable.props.axis === "both" || draggable.props.axis === "y";
}
function getControlPosition(e, touchIdentifier, draggableCore) {
  var touchObj = typeof touchIdentifier === "number" ? (0, _domFns$1.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === "number" && !touchObj)
    return null;
  var node = findDOMNode(draggableCore);
  var offsetParent2 = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns$1.offsetXYFromParent)(touchObj || e, offsetParent2, draggableCore.props.scale);
}
function createCoreData(draggable, x, y) {
  var state = draggable.state;
  var isStart = !(0, _shims$1.isNum)(state.lastX);
  var node = findDOMNode(draggable);
  if (isStart) {
    return {
      node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x,
      y
    };
  } else {
    return {
      node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x,
      y
    };
  }
}
function createDraggableData(draggable, coreData) {
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}
function cloneBounds(bounds) {
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}
function findDOMNode(draggable) {
  var node = draggable.findDOMNode();
  if (!node) {
    throw new Error("<DraggableCore>: Unmounted during event!");
  }
  return node;
}
var DraggableCore$2 = {};
var log$1 = {};
Object.defineProperty(log$1, "__esModule", {
  value: true
});
log$1.default = log;
function log() {
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
Object.defineProperty(DraggableCore$2, "__esModule", {
  value: true
});
DraggableCore$2.default = void 0;
var React = _interopRequireWildcard(React__default);
var _propTypes = _interopRequireDefault(PropTypes);
var _reactDom = _interopRequireDefault(require$$2);
var _domFns = domFns;
var _positionFns = positionFns;
var _shims = shims;
var _log = _interopRequireDefault(log$1);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof$2(obj) !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d2 = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d2 = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d2)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var eventsFor = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
var dragEventFor = eventsFor.mouse;
var DraggableCore$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits(DraggableCore2, _React$Component);
  var _super = _createSuper(DraggableCore2);
  function DraggableCore2() {
    var _this;
    _classCallCheck(this, DraggableCore2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });
    _defineProperty(_assertThisInitialized(_this), "mounted", false);
    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function(e) {
      _this.props.onMouseDown(e);
      if (!_this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0)
        return false;
      var thisNode = _this.findDOMNode();
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error("<DraggableCore> not mounted on DragStart!");
      }
      var ownerDocument = thisNode.ownerDocument;
      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      }
      if (e.type === "touchstart" && !_this.props.keepTouchEvents) {
        e.preventDefault();
      }
      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      _this.setState({
        touchIdentifier
      });
      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
      if (position == null)
        return;
      var x = position.x, y = position.y;
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)("DraggableCore: handleDragStart: %j", coreEvent);
      (0, _log.default)("calling", _this.props.onStart);
      var shouldUpdate = _this.props.onStart(e, coreEvent);
      if (shouldUpdate === false || _this.mounted === false)
        return;
      if (_this.props.enableUserSelectHack)
        (0, _domFns.addUserSelectStyles)(ownerDocument);
      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      });
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });
    _defineProperty(_assertThisInitialized(_this), "handleDrag", function(e) {
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null)
        return;
      var x = position.x, y = position.y;
      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX, deltaY = y - _this.state.lastY;
        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY)
          return;
        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)("DraggableCore: handleDrag: %j", coreEvent);
      var shouldUpdate = _this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false || _this.mounted === false) {
        try {
          _this.handleDragStop(new MouseEvent("mouseup"));
        } catch (err) {
          var event = document.createEvent("MouseEvents");
          event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          _this.handleDragStop(event);
        }
        return;
      }
      _this.setState({
        lastX: x,
        lastY: y
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function(e) {
      if (!_this.state.dragging)
        return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null)
        return;
      var x = position.x, y = position.y;
      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX || 0;
        var deltaY = y - _this.state.lastY || 0;
        var _snapToGrid3 = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
        var _snapToGrid4 = _slicedToArray(_snapToGrid3, 2);
        deltaX = _snapToGrid4[0];
        deltaY = _snapToGrid4[1];
        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      var shouldContinue = _this.props.onStop(e, coreEvent);
      if (shouldContinue === false || _this.mounted === false)
        return false;
      var thisNode = _this.findDOMNode();
      if (thisNode) {
        if (_this.props.enableUserSelectHack)
          (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }
      (0, _log.default)("DraggableCore: handleDragStop: %j", coreEvent);
      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });
      if (thisNode) {
        (0, _log.default)("DraggableCore: Removing handlers");
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function(e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStart(e);
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function(e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });
    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function(e) {
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });
    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function(e) {
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });
    return _this;
  }
  _createClass(DraggableCore2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      var thisNode = this.findDOMNode();
      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      var thisNode = this.findDOMNode();
      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack)
          (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
  }, {
    key: "findDOMNode",
    value: function findDOMNode2() {
      var _this$props, _this$props2, _this$props2$nodeRef;
      return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React.cloneElement(React.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);
  return DraggableCore2;
}(React.Component);
DraggableCore$2.default = DraggableCore$1;
_defineProperty(DraggableCore$1, "displayName", "DraggableCore");
_defineProperty(DraggableCore$1, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes.default.bool,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props, propName) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error("Draggable's offsetParent must be a DOM Node.");
    }
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes.default.arrayOf(_propTypes.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes.default.number,
  /**
   * `keepTouchEvents`, if true, stops the preventDefault that happens on touch events
   */
  keepTouchEvents: _propTypes.default.bool,
  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
_defineProperty(DraggableCore$1, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function onStart() {
  },
  onDrag: function onDrag() {
  },
  onStop: function onStop() {
  },
  onMouseDown: function onMouseDown() {
  },
  scale: 1
});
(function(exports) {
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
      return typeof obj2;
    } : function(obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof2(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "DraggableCore", {
    enumerable: true,
    get: function get2() {
      return _DraggableCore.default;
    }
  });
  exports.default = void 0;
  var React2 = _interopRequireWildcard2(React__default);
  var _propTypes2 = _interopRequireDefault2(PropTypes);
  var _reactDom2 = _interopRequireDefault2(require$$2);
  var _clsx2 = _interopRequireDefault2(require$$3);
  var _domFns2 = domFns;
  var _positionFns2 = positionFns;
  var _shims2 = shims;
  var _DraggableCore = _interopRequireDefault2(DraggableCore$2);
  var _log2 = _interopRequireDefault2(log$1);
  var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _getRequireWildcardCache2(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
    var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache2 = function _getRequireWildcardCache22(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard2(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof2(obj) !== "object" && typeof obj !== "function") {
      return { default: obj };
    }
    var cache = _getRequireWildcardCache2(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends2() {
    _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null)
      return {};
    var target = _objectWithoutPropertiesLoose2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0)
          continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key))
          continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose2(source, excluded) {
    if (source == null)
      return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      target[key] = source[key];
    }
    return target;
  }
  function ownKeys2(object, enumerableOnly) {
    var keys2 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys2.push.apply(keys2, symbols);
    }
    return keys2;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
        _defineProperty2(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _slicedToArray2(arr, i) {
    return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
  }
  function _nonIterableRest2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray2(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return _arrayLikeToArray2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor)
      n = o.constructor.name;
    if (n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray2(o, minLen);
  }
  function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  function _iterableToArrayLimit2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null)
      return;
    var _arr = [];
    var _n = true;
    var _d2 = false;
    var _s, _e2;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i)
          break;
      }
    } catch (err) {
      _d2 = true;
      _e2 = err;
    } finally {
      try {
        if (!_n && _i["return"] != null)
          _i["return"]();
      } finally {
        if (_d2)
          throw _e2;
      }
    }
    return _arr;
  }
  function _arrayWithHoles2(arr) {
    if (Array.isArray(arr))
      return arr;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    Object.defineProperty(subClass, "prototype", { writable: false });
    if (superClass)
      _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf22(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf22(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var Draggable2 = /* @__PURE__ */ function(_React$Component) {
    _inherits2(Draggable22, _React$Component);
    var _super = _createSuper2(Draggable22);
    function Draggable22(props) {
      var _this;
      _classCallCheck2(this, Draggable22);
      _this = _super.call(this, props);
      _defineProperty2(_assertThisInitialized2(_this), "onDragStart", function(e, coreData) {
        (0, _log2.default)("Draggable: onDragStart: %j", coreData);
        var shouldStart = _this.props.onStart(e, (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData));
        if (shouldStart === false)
          return false;
        _this.setState({
          dragging: true,
          dragged: true
        });
      });
      _defineProperty2(_assertThisInitialized2(_this), "onDrag", function(e, coreData) {
        if (!_this.state.dragging)
          return false;
        (0, _log2.default)("Draggable: onDrag: %j", coreData);
        var uiData = (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData);
        var newState = {
          x: uiData.x,
          y: uiData.y
        };
        if (_this.props.bounds) {
          var x = newState.x, y = newState.y;
          newState.x += _this.state.slackX;
          newState.y += _this.state.slackY;
          var _getBoundPosition = (0, _positionFns2.getBoundPosition)(_assertThisInitialized2(_this), newState.x, newState.y), _getBoundPosition2 = _slicedToArray2(_getBoundPosition, 2), newStateX = _getBoundPosition2[0], newStateY = _getBoundPosition2[1];
          newState.x = newStateX;
          newState.y = newStateY;
          newState.slackX = _this.state.slackX + (x - newState.x);
          newState.slackY = _this.state.slackY + (y - newState.y);
          uiData.x = newState.x;
          uiData.y = newState.y;
          uiData.deltaX = newState.x - _this.state.x;
          uiData.deltaY = newState.y - _this.state.y;
        }
        var shouldUpdate = _this.props.onDrag(e, uiData);
        if (shouldUpdate === false)
          return false;
        _this.setState(newState);
      });
      _defineProperty2(_assertThisInitialized2(_this), "onDragStop", function(e, coreData) {
        if (!_this.state.dragging)
          return false;
        var shouldContinue = _this.props.onStop(e, (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData));
        if (shouldContinue === false)
          return false;
        (0, _log2.default)("Draggable: onDragStop: %j", coreData);
        var newState = {
          dragging: false,
          slackX: 0,
          slackY: 0
        };
        var controlled = Boolean(_this.props.position);
        if (controlled) {
          var _this$props$position = _this.props.position, x = _this$props$position.x, y = _this$props$position.y;
          newState.x = x;
          newState.y = y;
        }
        _this.setState(newState);
      });
      _this.state = {
        // Whether or not we are currently dragging.
        dragging: false,
        // Whether or not we have been dragged before.
        dragged: false,
        // Current transform x and y.
        x: props.position ? props.position.x : props.defaultPosition.x,
        y: props.position ? props.position.y : props.defaultPosition.y,
        prevPropsPosition: _objectSpread2({}, props.position),
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: false
      };
      if (props.position && !(props.onDrag || props.onStop)) {
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
      }
      return _this;
    }
    _createClass2(Draggable22, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) {
          this.setState({
            isElementSVG: true
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.setState({
          dragging: false
        });
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
    }, {
      key: "findDOMNode",
      value: function findDOMNode2() {
        var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom2.default.findDOMNode(this);
      }
    }, {
      key: "render",
      value: function render() {
        var _clsx;
        var _this$props2 = this.props;
        _this$props2.axis;
        _this$props2.bounds;
        var children = _this$props2.children, defaultPosition2 = _this$props2.defaultPosition, defaultClassName = _this$props2.defaultClassName, defaultClassNameDragging = _this$props2.defaultClassNameDragging, defaultClassNameDragged = _this$props2.defaultClassNameDragged, position = _this$props2.position, positionOffset = _this$props2.positionOffset;
        _this$props2.scale;
        var draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);
        var style = {};
        var svgTransform = null;
        var controlled = Boolean(position);
        var draggable = !controlled || this.state.dragging;
        var validPosition = position || defaultPosition2;
        var transformOpts = {
          // Set left if horizontal drag is enabled
          x: (0, _positionFns2.canDragX)(this) && draggable ? this.state.x : validPosition.x,
          // Set top if vertical drag is enabled
          y: (0, _positionFns2.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        if (this.state.isElementSVG) {
          svgTransform = (0, _domFns2.createSVGTransform)(transformOpts, positionOffset);
        } else {
          style = (0, _domFns2.createCSSTransform)(transformOpts, positionOffset);
        }
        var className = (0, _clsx2.default)(children.props.className || "", defaultClassName, (_clsx = {}, _defineProperty2(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty2(_clsx, defaultClassNameDragged, this.state.dragged), _clsx));
        return /* @__PURE__ */ React2.createElement(_DraggableCore.default, _extends2({}, draggableCoreProps, {
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop
        }), /* @__PURE__ */ React2.cloneElement(React2.Children.only(children), {
          className,
          style: _objectSpread2(_objectSpread2({}, children.props.style), style),
          transform: svgTransform
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: (
        // React 16.3+
        // Arity (props, state)
        function getDerivedStateFromProps(_ref, _ref2) {
          var position = _ref.position;
          var prevPropsPosition = _ref2.prevPropsPosition;
          if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, _log2.default)("Draggable: getDerivedStateFromProps %j", {
              position,
              prevPropsPosition
            });
            return {
              x: position.x,
              y: position.y,
              prevPropsPosition: _objectSpread2({}, position)
            };
          }
          return null;
        }
      )
    }]);
    return Draggable22;
  }(React2.Component);
  exports.default = Draggable2;
  _defineProperty2(Draggable2, "displayName", "Draggable");
  _defineProperty2(Draggable2, "propTypes", _objectSpread2(_objectSpread2({}, _DraggableCore.default.propTypes), {}, {
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: _propTypes2.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: _propTypes2.default.oneOfType([_propTypes2.default.shape({
      left: _propTypes2.default.number,
      right: _propTypes2.default.number,
      top: _propTypes2.default.number,
      bottom: _propTypes2.default.number
    }), _propTypes2.default.string, _propTypes2.default.oneOf([false])]),
    defaultClassName: _propTypes2.default.string,
    defaultClassNameDragging: _propTypes2.default.string,
    defaultClassNameDragged: _propTypes2.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: _propTypes2.default.shape({
      x: _propTypes2.default.number,
      y: _propTypes2.default.number
    }),
    positionOffset: _propTypes2.default.shape({
      x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
      y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: _propTypes2.default.shape({
      x: _propTypes2.default.number,
      y: _propTypes2.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: _shims2.dontSetMe,
    style: _shims2.dontSetMe,
    transform: _shims2.dontSetMe
  }));
  _defineProperty2(Draggable2, "defaultProps", _objectSpread2(_objectSpread2({}, _DraggableCore.default.defaultProps), {}, {
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  }));
})(Draggable$1);
var _require = Draggable$1, Draggable = _require.default, DraggableCore = _require.DraggableCore;
cjs.exports = Draggable;
cjs.exports.default = Draggable;
cjs.exports.DraggableCore = DraggableCore;
var cjsExports = cjs.exports;
const ReactDraggable = /* @__PURE__ */ getDefaultExportFromCjs(cjsExports);
function preventDefault(e) {
  if (e.cancelable) {
    e.preventDefault();
  }
}
let supportsPassive = false;
try {
  window.addEventListener(
    "testPassive",
    null,
    Object.defineProperty({}, "passive", {
      // eslint-disable-next-line getter-return
      get() {
        supportsPassive = true;
      }
    })
  );
} catch (e) {
}
const wheelOpt = supportsPassive ? { passive: false } : false;
const disableScroll = () => {
  devLog("info", "disabling touch scroll");
  window.addEventListener("touchmove", preventDefault, wheelOpt);
};
const enableScroll = () => {
  devLog("info", "re-enabling touch scroll");
  window.removeEventListener("touchmove", preventDefault, wheelOpt);
};
const TouchDraggable = ({
  onClick,
  children,
  disabled,
  onStart: onStart2,
  // Callback when the dragging begins. Either instantly, or after the hold time is completed
  onStop: onStop2,
  // When the mouse is released while in a dragging state
  onDrag: onDrag2,
  // Happens every frame while it is being dragged
  holdTime,
  // How many ms to hold for before it is considered dragging
  onInitialPress,
  // As soon as this is clicked/tapped, even if holding is required to start dragging
  onStopPressing,
  // When the mouse is up, regardless of if it was dragging or not
  holdOnDesktop,
  cancelRef,
  // A ref passed in, that if true, cancels click and drag events. e.g. if an internal button was touched
  nodeRef,
  ...props
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const startEvent = useRef({});
  const hasMoved = useRef(false);
  useEffect(() => {
  }, []);
  const beginDrag = useCallback(() => {
    const { e, data } = startEvent.current;
    e.stopPropagation();
    const distanceForMovement = 10;
    if ((data == null ? void 0 : data.x) + (data == null ? void 0 : data.y) > distanceForMovement && hasMoved.current) {
      setIsDragging(true);
      hasMoved.current = false;
      return;
    }
    setIsDragging(true);
    hasMoved.current = false;
    disableScroll();
    onStart2(e, data);
  }, [onStart2]);
  const [startCounter, stopCounter] = useHoldCounter(beginDrag, holdTime);
  const handleStart = (e, data) => {
    try {
      devLog("info", "down on draggable", e, data, disabled, e.target);
      if (disabled) {
        devLog("info", "this is disabled, so not dragging");
        return false;
      }
      if (e == null ? void 0 : e.persist) {
        e == null ? void 0 : e.persist();
      }
      startEvent.current = { e, data };
      const wasTouched = (e == null ? void 0 : e.type) === "touchstart";
      devLog("event type", e == null ? void 0 : e.type);
      onInitialPress(e);
      if (holdOnDesktop || wasTouched) {
        devLog("info", "Starting counter...");
        startCounter();
      } else {
        devLog("info", "About to begin drag");
        beginDrag();
      }
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };
  const handleDrag = useCallback(
    (e, data) => {
      try {
        if (isDragging) {
          const distanceForMovement = 10;
          if (Math.abs(data == null ? void 0 : data.x) + Math.abs(data == null ? void 0 : data.y) > distanceForMovement) {
            hasMoved.current = true;
          }
          onDrag2(e, data);
        } else {
          const distanceForMovement = 10;
          if ((data == null ? void 0 : data.x) + (data == null ? void 0 : data.y) > distanceForMovement && hasMoved.current) {
            devLog("info", "stopping drag early, mouse moved away");
            hasMoved.current = false;
            stopCounter();
            setIsDragging(false);
            onStopPressing(e);
          }
          return false;
        }
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    [isDragging]
  );
  const handleStop = useCallback(
    (e, data) => {
      enableScroll();
      if (!(cancelRef == null ? void 0 : cancelRef.current)) {
        if (isDragging && hasMoved.current) {
          devLog("info", "DRAG");
          e.stopPropagation();
          e.preventDefault();
          onStop2(e, data);
        } else {
          devLog("info", "CLICK");
          onClick(e, data);
        }
      }
      hasMoved.current = false;
      stopCounter();
      setIsDragging(false);
      onStopPressing();
    },
    [onClick, onStop2, onStopPressing]
  );
  return /* @__PURE__ */ React__default.createElement(
    ReactDraggable,
    {
      ...props,
      onStart: handleStart,
      onStop: handleStop,
      onDrag: handleDrag,
      style: { touchAction: "none" }
    },
    children
  );
};
TouchDraggable.defaultProps = {
  onStart: () => {
  },
  onStop: () => {
  },
  onDrag: () => {
  },
  onClick: () => {
  },
  onInitialPress: () => {
  },
  onStopPressing: () => {
  },
  disabled: false,
  holdTime: 400,
  // Defaults to 400ms
  holdOnDesktop: false,
  cancelRef: null
};
TouchDraggable.propTypes = {
  onStart: PropTypes.func,
  onStop: PropTypes.func,
  onClick: PropTypes.func,
  onDrag: PropTypes.func,
  onInitialPress: PropTypes.func,
  onStopPressing: PropTypes.func,
  disabled: PropTypes.bool,
  holdTime: PropTypes.number,
  children: PropTypes.node.isRequired,
  holdOnDesktop: PropTypes.bool,
  cancelRef: PropTypes.shape({ current: PropTypes.bool })
};
const mapStateToProps$1R = () => ({});
const mapDispatchToProps$1Q = (dispatch) => bindActionCreators({}, dispatch);
const TouchDraggable$1 = connect(mapStateToProps$1R, mapDispatchToProps$1Q)(TouchDraggable);
const getShadow = (dragging, pressing) => {
  if (dragging) {
    return "0px 4px 4px rgba(107, 107, 107, 0.25)";
  }
  if (pressing) {
    return "inset 0px 4px 4px rgba(107, 107, 107, 0.25)";
  }
  return "none";
};
const useStyles$$ = createUseStyles((theme2) => ({
  container: (props) => ({
    backgroundColor: (props == null ? void 0 : props.showHovered) || (props == null ? void 0 : props.pressing) ? theme2.colors.sidebarItemHovered : (props == null ? void 0 : props.selected) ? theme2.colors.sidebarSelected : theme2.colors.sidebarBackground,
    border: `1px solid ${(props == null ? void 0 : props.selected) ? theme2.colors.charcoal : "transparent"}`,
    minHeight: "66px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    padding: "8px",
    zIndex: (props == null ? void 0 : props.dragging) ? 1e3 : 1,
    opacity: (props == null ? void 0 : props.dragging) ? 0.95 : 1,
    cursor: "default",
    userSelect: "none",
    boxShadow: getShadow(props == null ? void 0 : props.dragging, props == null ? void 0 : props.pressing),
    transition: "background-color 0.1s, color 0.1s, box-shadow 0.1s",
    position: "relative",
    margin: "0 -8px",
    maxWidth: "291px"
  }),
  containerInner: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px"
  },
  containerRow: {
    display: "flex",
    alignItems: "space-between",
    maxWidth: "291px",
    width: "100%"
    // gap: '4px',
  },
  scrollRef: {
    position: "absolute",
    top: "-100px",
    height: "76px",
    width: "100px",
    pointerEvents: "none"
  },
  timeWrapper: {
    border: `1px solid ${theme2.colors.gray7}`,
    backgroundColor: "white",
    borderRadius: "8px",
    width: "48px",
    height: "48px",
    minWidth: "48px",
    minHeight: "48px",
    maxWidth: "48px",
    maxHeight: "48px",
    flexGrow: 1,
    alignItems: "center",
    textAlign: "center",
    fontSize: "14px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  },
  bottom: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  buttons: {
    display: "none"
  },
  details: {
    position: "relative",
    flexGrow: 1,
    height: "48px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginLeft: "12px"
  },
  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "6px"
  },
  nameContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    overflow: "hidden"
  },
  name: {
    ...theme2.typography.body.P,
    fontWeight: theme2.fontWeights.medium,
    maxWidth: "205px",
    fontSize: "15px",
    lineHeight: "22px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  bookingInfo: {
    display: "flex",
    gap: "7px",
    alignItems: "center",
    fontSize: "15px"
  },
  row: {
    display: "flex",
    gap: "2px",
    alignItems: "center"
  },
  dividerCircle: {
    backgroundColor: theme2.colors.gray4,
    borderRadius: "10px",
    width: "3px",
    height: "3px"
  },
  tableNumber: {
    height: "24px",
    border: `1px solid ${theme2.colors.shark}`,
    borderRadius: "4px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    userSelect: "none",
    maxWidth: "100px",
    flexGrow: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  detail: {
    flexGrow: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  buttonRow: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    color: theme2.colors.buttonText
  },
  buttonContent: {},
  checkmarkContainer: {
    display: "flex",
    color: theme2.colors.buttonText,
    border: `1px solid ${theme2.colors.olive3}`,
    width: "24px",
    height: "24px",
    borderRadius: "24px",
    alignItems: "center",
    justifyContent: "center"
  },
  checkmark: {
    width: "12px",
    height: "9px"
  },
  conflictContainer: {
    position: "relative",
    height: "24px"
  },
  conflict: {
    width: "24px",
    height: "24px"
  },
  bookingTime: {
    fontSize: "15px"
  },
  bookingPeriod: {
    fontSize: "12px"
  },
  bookingActionButton: {
    position: "absolute",
    top: "-12px",
    right: "-1px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "25px",
    width: "47px",
    zIndex: 99,
    background: theme2.colors.white,
    borderRadius: "6px",
    border: "1px solid #E4E4E4",
    // TODO use theme
    "&:hover": {
      cursor: "pointer"
    }
  },
  bookingActionItem: {
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  actionIcon: {
    width: "25px",
    height: "6px",
    color: theme2.colors.charcoal
  },
  bookingCardCommentOverflow: {
    position: "relative",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    height: "21px"
  },
  smsMessage: {
    position: "relative",
    display: "-webkit-box",
    fontSize: "12px",
    color: theme2.colors.smoke,
    WebkitLineClamp: 3,
    lineClamp: 3,
    boxOrient: "vertical",
    maxHeight: "60px",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  tags: {
    paddingTop: "10px"
  }
}));
const SvgExclamation = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 12, cy: 12.0974, r: 12, fill: "#FBE5E5" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 12.0002, cy: 12.0974, r: 8.68966, fill: "#DA5A5A" }), /* @__PURE__ */ React$7.createElement("path", { d: "M13.2316 5.66271H11.3116V7.44771L11.4616 13.7777H13.0816L13.2316 7.44771V5.66271ZM11.0866 16.3427C11.0866 15.6827 11.6266 15.1577 12.2566 15.1577C12.9166 15.1577 13.4416 15.6827 13.4416 16.3427C13.4416 17.0027 12.9166 17.5127 12.2566 17.5127C11.6266 17.5127 11.0866 17.0027 11.0866 16.3427Z", fill: "#F2EFEE" }));
const ExclamationSVG = SvgExclamation;
const SvgSeatIcon = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 18 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M0.552734 0.261475L0.552735 14.4902", stroke: "#313131", strokeWidth: 0.753842, strokeLinejoin: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.552734 7.89404H7.90269V14.5373", stroke: "#313131", strokeWidth: 0.753842, strokeLinejoin: "round" }), /* @__PURE__ */ React$7.createElement("rect", { x: 0.552734, y: 7.70557, width: 7.72688, height: 1.27211, rx: 0.636054, fill: "#F5F2ED", stroke: "#313131", strokeWidth: 0.753842 }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.8145 4.45386V12.2279", stroke: "#313131", strokeWidth: 0.753842 }), /* @__PURE__ */ React$7.createElement("rect", { x: 6.6582, y: 3.85742, width: 10.4884, height: 1.86852, rx: 0.934259, fill: "#F5F2ED", stroke: "#313131", strokeWidth: 0.753842 }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.48242 14.348C9.63698 14.1173 11.7911 12.0864 11.7911 12.0864L14.1939 14.348", stroke: "#313131", strokeWidth: 0.753842 }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.8145 14.4883V12.1797", stroke: "#313131", strokeWidth: 0.753842 }));
const SeatSVG = SvgSeatIcon;
const SvgActionMenuHorizontal = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 25 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 21.8574, cy: 3, r: 2.5, transform: "rotate(90 21.8574 3)", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 12.4277, cy: 3, r: 2.5, transform: "rotate(90 12.4277 3)", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 3, cy: 3, r: 2.5, transform: "rotate(90 3 3)", stroke: "currentColor" }));
const ActionMenuIconSVG = SvgActionMenuHorizontal;
const SvgComment = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M0.5 2.5C0.5 1.39543 1.39543 0.5 2.5 0.5H17.5C18.6046 0.5 19.5 1.39543 19.5 2.5V10.0714C19.5 11.1753 18.6025 12.0714 17.4972 12.0714H17.4778H17.4585H17.4393H17.4201H17.401H17.3819H17.3629H17.344H17.3251H17.3062H17.2874H17.2687H17.25H17.2314H17.2128H17.1943H17.1758H17.1574H17.1391H17.1207H17.1025H17.0843H17.0661H17.048H17.03H17.012H16.994H16.9761H16.9583H16.9405H16.9227H16.905H16.8874H16.8697H16.8522H16.8347H16.8172H16.7998H16.7824H16.7651H16.7478H16.7306H16.7134H16.6963H16.6792H16.6621H16.6451H16.6282H16.6113H16.5944H16.5776H16.5608H16.5441H16.5274H16.5107H16.4941H16.4775H16.461H16.4445H16.4281H16.4117H16.3953H16.379H16.3627H16.3465H16.3303H16.3141H16.298H16.2819H16.2659H16.2499H16.2339H16.218H16.2021H16.1862H16.1704H16.1546H16.1389H16.1232H16.1075H16.0919H16.0763H16.0607H16.0452H16.0297H16.0142H15.9988H15.9834H15.968H15.9527H15.9374H15.9221H15.9069H15.8917H15.8765H15.8614H15.8463H15.8312H15.8162H15.8011H15.7862H15.7712H15.7563H15.7414H15.7265H15.7117H15.6969H15.6821H15.6673H15.6526H15.6379H15.6233H15.6086H15.594H15.5794H15.5648H15.5503H15.5358H15.5213H15.5068H15.4924H15.478H15.4636H15.4492H15.4349H15.4206H15.4063H15.392H15.3778H15.3635H15.3493H15.3351H15.321H15.3068H15.2927H15.2786H15.2645H15.2505H15.2364H15.2224H15.2084H15.1944H15.1805H15.1665H15.1526H15.1387H15.1248H15.1109H15.0971H15.0832H15.0694H15.0556H15.0418H15.028H15.0143H15.0005H14.9868H14.9731H14.9594H14.9457H14.932H14.9183H14.9047H14.8911H14.8774H14.8638H14.8502H14.8366H14.8231H14.8095H14.796H14.7824H14.7689H14.7554H14.7418H14.7283H14.7149H14.7014H14.6879H14.6744H14.661H14.6475H14.6341H14.6207H14.6072H14.5938H14.5804H14.567H14.5536H14.5402H14.5268H14.5134H14.5H14.4867H14.4733H14.4599H14.4466H14.4332H14.4199H14.4065H14.3932H14.3798H14.3665H14.3531H14.3398H14.3264H14.3131H14.2998H14.2864H14.2731H14.2598H14.2464H14.2331H14.2197H14.2064H14.1931H14.1797H14.1664H14.153H14.1397H14.1263H14.113H14.0996H14.0863H14.0729H14.0595H14.0462H14.0328H14.0194H14.006H13.9926H13.9792H13.9658H13.9524H13.939H13.9256H13.9122H13.8987H13.8853H13.8718H13.8584H13.8449H13.8314H13.8179H13.8044H13.7909H13.7774H13.7639H13.7503H13.7368H13.7232H13.7097H13.6961H13.6825H13.6689H13.6553H13.6417H13.628H13.6144H13.6007H13.587H13.5733H13.5596H13.5459H13.5322H13.5184H13.5046H13.4908H13.477H13.4632H13.4494H13.4356H13.4217H13.4078H13.3939H13.38H13.3661H13.3521H13.3381H13.3241H13.3101H13.2961H13.2821H13.268H13.2539H13.2398H13.2257H13.2115H13.1973H13.1831H13.1689H13.1547H13.1404H13.1261H13.1118H13.0975H13.0832H13.0688H13.0544H13.04H13.0255H13.011H12.9965H12.982H12.9675H12.9529H12.9383H12.9237H12.909H12.8943H12.8796H12.8649H12.8501H12.8353H12.8205H12.8057H12.7908H12.7759H12.7609H12.746H12.731H12.716H12.7009H12.6858H12.6707H12.6555H12.6404H12.6252H12.6099H12.5946H12.5793H12.564H12.5486H12.5332H12.5177H12.5023H12.4868H12.4712H12.4556H12.44H12.4244H12.4087H12.3929H12.3772H12.3614H12.3455H12.3297H12.3138H12.2978H12.2818H12.2658H12.2498H12.2337H12.2175H12.2013H12.1851H12.1689H12.1526H12.1362H12.1198H12.1034H12.087H12.0705H12.0539H12.0373H12.0207H12.004H11.9873H11.9706H11.9538H11.9369H11.92H11.9031H11.8861H11.8691H11.852H11.8349H11.8178H11.8006H11.7833H11.766H11.7487H11.7313H11.7139H11.6964H11.6788H11.6613H11.6436H11.626H11.6082H11.5905H11.5726H11.5548H11.5368H11.5189H11.5008H11.4828H11.4646H11.4465H11.4282H11.41H11.3916H11.3732H11.3548H11.3363H11.3178H11.2992H11.2805H11.2618H11.2431H11.2243H11.2054H11.1865H11.1675H11.1484H11.1294H11.1102H11.091H11.0717H11.0524H11.0331H11.0136H10.9941H10.9746H10.955H10.9353H10.9156H10.8958H10.876H10.8561H10.8361H10.8161H10.796H10.7758H10.7556H10.7354H10.715H10.6947H10.6742H10.6537H10.6331H10.6125H10.5918H10.571H10.5502H10.5293H10.5083H10.4873H10.4662H10.445H10.4238H10.4025H10.3812H10.3598H10.3383H10.3167H10.2951H10.2734H10.2517H10.2298H10.2079H10.186H10.164H10.1419H10.1197H10.0975H10.0751H10.0528H10.0303H10.0078H9.98522H9.96256H9.93983H9.91702H9.89415H9.8712H9.84818H9.82509H9.80192H9.77868H9.75537H9.73198H9.70852H9.68498H9.66137H9.63769H9.61392H9.59009H9.56618H9.54219H9.51812H9.49398H9.46976H9.44546H9.42109H9.39664H9.37211H9.3475H9.32281H9.29805H9.2732H9.24828H9.22327H9.19819H9.17302H9.14778H9.12245H9.09705H9.07156H9.04599H9.02034H8.9946C8.56286 12.0714 8.14884 12.2576 7.86331 12.5842L4.2931 16.6683L4.2931 13.5714C4.2931 12.743 3.62153 12.0714 2.7931 12.0714H2.5C1.39543 12.0714 0.5 11.176 0.5 10.0714V2.5Z", stroke: "currentColor" }));
const CommentSVG = SvgComment;
const defaultPosition$1 = { x: 0, y: 0 };
const ReservationCard = ({
  booking,
  setHoveredTable,
  onStopDragging,
  onStartDragging,
  canDrag,
  tableHovered,
  onClick,
  // Select the table on click
  selected,
  // Whether this table has been "clicked"
  setObeeBookingDetailsModal,
  updateBooking,
  conflict,
  scrollToBooking,
  obeeAreas: obeeAreas2,
  obeeTables: obeeTables2,
  canSendMessage,
  messagesAnchor,
  setMessagesAnchor,
  settings,
  thinDraggedBookings
  // Whether dragged bookings should show thin like timeline bars
}) => {
  var _a, _b2, _c2;
  const theme2 = useTheme$1();
  const [isHovered, setIsHovered] = useState(false);
  const [showHovered, setShowHovered] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [pressing, setPressing] = useState(false);
  const [commentAnchorEl, setCommentAnchorEl] = useState(null);
  const classes = useStyles$$({ canDrag, dragging, showHovered, selected, pressing: false });
  const ref = useRef(null);
  const [showConflictText, setShowConflictText] = useState(false);
  const isConfirmed = (booking == null ? void 0 : booking.status) === STATUS_TYPES.CONFIRMED;
  const isSeated = (booking == null ? void 0 : booking.status) === STATUS_TYPES.ARRIVED;
  const canBeSeated = isBooked(booking) && !isFutureDate(booking);
  const [bookingOptionsAnchor, setBookingOptionsAnchor] = useState(null);
  const [_relativeDate, setRelativeDate] = useState("");
  useEffect(() => {
    if (dragging || tableHovered || isHovered) {
      setShowHovered(true);
    } else {
      setShowHovered(false);
    }
  }, [tableHovered, dragging, isHovered]);
  useEffect(() => {
    if (scrollToBooking && selected && ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center"
      });
    }
  }, [scrollToBooking, selected, ref.current]);
  useInterval(() => {
    var _a2;
    if (canSendMessage && !isEmpty((_a2 = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _a2.dateTimeSent)) {
      setRelativeDate(getRelativeTime(moment$2(booking.waitlistSMS.dateTimeSent)));
    }
  }, 1e3 * 60);
  const showBookingDetails = (tab = "booking") => {
    setObeeBookingDetailsModal(booking == null ? void 0 : booking.id, tab);
  };
  const assignSeat = () => {
    updateBooking({
      ...booking,
      status: STATUS_TYPES.ARRIVED
    });
  };
  const setFinished = () => {
    updateBooking({
      ...booking,
      status: STATUS_TYPES.FINISHED
    });
  };
  const bookingTime = formatTimeFromInt(booking == null ? void 0 : booking.startTime, "h:mm", "");
  const bookingPeriod = formatTimeFromInt(booking == null ? void 0 : booking.startTime, "A");
  const handleStartDragging = (e) => {
    setDragging(true);
    onStartDragging(booking, e);
  };
  const handleStopDragging = () => {
    setDragging(false);
    setPressing(false);
    if (dragging) {
      onStopDragging(booking);
    }
  };
  const handleClick = () => {
    setPressing(false);
    setDragging(false);
    if (!commentAnchorEl && !messagesAnchor) {
      onClick();
    }
  };
  const popoverStyles2 = {
    popover: { marginLeft: "6px", marginTop: 0, padding: "6px" },
    item: { padding: "8px 12px", fontSize: "15px" }
  };
  const popoverAnchors2 = {
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  };
  const displayTableNumber = useMemo(() => {
    return getDisplayTableNumberForBooking(obeeAreas2.data, obeeTables2.data, booking);
  }, [booking == null ? void 0 : booking.tableNumberDisplay, booking == null ? void 0 : booking.areaId, obeeAreas2.data, obeeTables2.data]);
  const smsMessage = extractSmsMessage(booking, (_c2 = (_b2 = (_a = settings == null ? void 0 : settings.data) == null ? void 0 : _a.messaging) == null ? void 0 : _b2.sms_waitlist) == null ? void 0 : _c2.smsBody);
  const waitlistOverdueInMinutes = getWaitlistOverdueInMinutes(booking);
  const isWaitlistOverdue = waitlistOverdueInMinutes > 0;
  const conflictRef = useRef(null);
  const getConflictRect = () => {
    var _a2;
    if (!isEmpty(conflict)) {
      return (_a2 = conflictRef == null ? void 0 : conflictRef.current) == null ? void 0 : _a2.getBoundingClientRect();
    }
    return null;
  };
  const renderCard = () => {
    var _a2, _b3, _c3, _d2, _e2;
    return /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.container,
        "data-booking": true,
        onMouseOver: () => {
          setIsHovered(true);
          setHoveredTable(booking);
        },
        onMouseLeave: () => {
          setIsHovered(false);
          setHoveredTable(null);
        },
        onTouchEnd: (e) => {
          setIsHovered(true);
          onClick(e);
        },
        onClick: (e) => onClick(e),
        style: {
          ...dragging && thinDraggedBookings ? {
            maxHeight: "40px",
            minHeight: "40px",
            border: "1px solid black",
            overflow: "hidden"
          } : {}
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { ref, className: classes.scrollRef }),
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.containerInner }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.containerRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeWrapper }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingTime }, bookingTime), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingPeriod }, bookingPeriod)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.details }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.nameContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.name }, getBookingName(booking)), (booking == null ? void 0 : booking.isBirthday) && /* @__PURE__ */ React__default.createElement(Cake, null)), !isEmpty(conflict) && /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.conflictContainer,
          ref: conflictRef,
          onMouseOver: () => setShowConflictText(true),
          onMouseOut: () => setShowConflictText(false)
        },
        /* @__PURE__ */ React__default.createElement(ExclamationSVG, { className: classes.conflict }),
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            style: {
              position: "absolute",
              left: "30px",
              top: "6px",
              width: "20px",
              height: "20px"
            }
          },
          /* @__PURE__ */ React__default.createElement(
            Box,
            {
              style: {
                position: "fixed",
                top: ((_a2 = getConflictRect()) == null ? void 0 : _a2.top) || 0,
                // Fixes when sidebar is scrolled
                backgroundColor: "white",
                borderRadius: "4px",
                opacity: showConflictText ? 1 : 0,
                transition: "opacity 0.2s",
                pointerEvents: "none",
                maxWidth: "200px",
                padding: "4px",
                fontSize: "14px",
                boxShadow: "0px 0px 8px rgba(176, 176, 176, 0.25)",
                zIndex: 10
              }
            },
            conflict
          )
        )
      )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottom }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingInfo }, displayTableNumber && /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingInfo }, /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.tableNumber,
          style: { flexGrow: 1 },
          title: displayTableNumber
        },
        displayTableNumber
      ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.dividerCircle })), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.row} ${classes.detail}` }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { height: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, booking == null ? void 0 : booking.size)), !isEmpty(booking.customerComments) || !isEmpty(booking.restaurantComments) ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.dividerCircle }), /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.bookingCardCommentOverflow,
          title: getFullComments(booking)
        },
        /* @__PURE__ */ React__default.createElement(
          SquareButton,
          {
            style: {
              button: {
                padding: "2px 8px",
                borderRadius: "6px",
                alignItems: "center",
                backgroundColor: "inherit"
              }
            },
            onClick: (e) => {
              e.stopPropagation();
              setCommentAnchorEl(e.currentTarget);
            }
          },
          /* @__PURE__ */ React__default.createElement(CommentSVG, { style: { height: "15px", width: "16px" } })
        ),
        /* @__PURE__ */ React__default.createElement(
          CommentsPopover$1,
          {
            booking,
            anchor: commentAnchorEl,
            setAnchor: setCommentAnchorEl
          }
        )
      )) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null)), isConfirmed && /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.checkmarkContainer }, /* @__PURE__ */ React__default.createElement(CheckSVG, { className: classes.checkmark }))))), canSendMessage && /* @__PURE__ */ React__default.createElement(
        SquareButton,
        {
          style: {
            container: {
              // height: '100%',
              alignItems: "stretch",
              display: "flex",
              "&:hover": {
                backgroundColor: theme2.colors.charcoal
              }
            },
            button: {
              width: "38px",
              height: "100%",
              padding: "2px 8px",
              borderRadius: "6px",
              alignItems: "center",
              backgroundColor: "inherit",
              "&:hover": {
                backgroundColor: theme2.colors.charcoal
              }
            }
          },
          className: classes.smsButton,
          onClick: (e) => {
            e.stopPropagation();
            setMessagesAnchor(e.currentTarget);
          }
        },
        /* @__PURE__ */ React__default.createElement(SpeechBubbleIconSVG, { width: 20 })
      ), /* @__PURE__ */ React__default.createElement(
        ListPopover,
        {
          items: [
            ...canBeSeated ? [
              {
                key: "seatGuest",
                label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingActionItem }, /* @__PURE__ */ React__default.createElement(SeatSVG, { style: { height: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Seat guest")),
                onClick: assignSeat
              }
            ] : [],
            ...isSeated ? [
              {
                key: "finishBooking",
                label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingActionItem }, /* @__PURE__ */ React__default.createElement(SeatSVG, { style: { height: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Set as finished")),
                onClick: setFinished
              }
            ] : [],
            {
              key: "editBooking",
              label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingActionItem }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { height: "15px", width: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Edit booking")),
              onClick: (e) => {
                e.stopPropagation();
                showBookingDetails("booking");
              }
            },
            ...isBooked(booking) && (booking == null ? void 0 : booking.source) !== "walkin" ? [
              {
                key: "markNoShow",
                label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingActionItem }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { height: "15px", width: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Set as no-show")),
                onClick: (e) => {
                  e.stopPropagation();
                  updateBooking({
                    ...booking,
                    status: STATUS_TYPES.NO_SHOW
                  });
                  showBookingDetails("booking");
                }
              }
            ] : []
          ],
          anchor: bookingOptionsAnchor,
          isOpen: !isEmpty(bookingOptionsAnchor),
          onClose: () => {
            setBookingOptionsAnchor(null);
            setIsHovered(false);
          },
          style: { ...popoverStyles2 },
          ...popoverAnchors2
        }
      )), booking.status === STATUS_TYPES.WAITING && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Added:"), " ", formatTime(booking.createdAt), ",", " ", getRelativeTime(moment$2(booking.createdAt))), booking.status === STATUS_TYPES.WAITING && (booking == null ? void 0 : booking.quotedMins) > 0 && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Quoted:"), " ", `${booking.quotedMins} mins`, " ", isWaitlistOverdue ? /* @__PURE__ */ React__default.createElement("span", { style: { color: theme2.colors.red } }, "(", waitlistOverdueInMinutes, " mins)") : ""), canSendMessage && !isEmpty((_b3 = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _b3.dateTimeSent) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Sent:"), " ", formatTime(booking.waitlistSMS.dateTimeSent), ",", " ", getRelativeTime(moment$2(booking.waitlistSMS.dateTimeSent))), canSendMessage && !isEmpty(smsMessage) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage, title: smsMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Message:"), " ", smsMessage), canSendMessage && !isEmpty((_c3 = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _c3.responseMessage) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.smsMessage, title: (_d2 = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _d2.responseMessage }, /* @__PURE__ */ React__default.createElement("b", null, "Response:"), " ", (_e2 = booking == null ? void 0 : booking.waitlistSMS) == null ? void 0 : _e2.responseMessage)),
      !dragging && (selected || showHovered) && /* @__PURE__ */ React__default.createElement(
        Box,
        {
          type: "icon",
          className: classes.bookingActionButton,
          onClick: (e) => {
            e.stopPropagation();
            setBookingOptionsAnchor(e.currentTarget);
          }
        },
        /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG, { className: classes.actionIcon })
      ),
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.tags }, /* @__PURE__ */ React__default.createElement(RunSheetTags$1, { booking, primaryTagsOnly: true }))
    );
  };
  if (canDrag) {
    return /* @__PURE__ */ React__default.createElement(
      TouchDraggable$1,
      {
        className: `table-booking-${booking.id}`,
        position: defaultPosition$1,
        onDrag: handleStartDragging,
        onStop: handleStopDragging,
        onClick: handleClick,
        onInitialPress: () => setPressing(true),
        onStopPressing: () => {
          setPressing(false);
          handleStopDragging();
        },
        disabled: !!messagesAnchor || !!bookingOptionsAnchor || !!commentAnchorEl
      },
      renderCard()
    );
  }
  return renderCard();
};
ReservationCard.defaultProps = {
  onStartDragging: () => {
  },
  onStopDragging: () => {
  },
  onClick: () => {
  },
  canDrag: false,
  selected: false,
  conflict: null,
  scrollToBooking: false,
  thinDraggedBookings: false
};
ReservationCard.propTypes = {
  booking: obeeBookingPropTypes.isRequired,
  setHoveredTable: PropTypes.func.isRequired,
  onStopDragging: PropTypes.func,
  onStartDragging: PropTypes.func,
  onClick: PropTypes.func,
  canDrag: PropTypes.bool,
  selected: PropTypes.bool,
  tableHovered: PropTypes.bool.isRequired,
  setObeeBookingDetailsModal: PropTypes.func.isRequired,
  updateBooking: PropTypes.func.isRequired,
  conflict: PropTypes.string,
  scrollToBooking: PropTypes.bool,
  obeeAreas: areasPropTypes.isRequired,
  obeeTables: areasPropTypes.isRequired,
  thinDraggedBookings: PropTypes.bool
};
const mapStateToProps$1Q = (state) => ({
  obeeAreas: state.areas,
  obeeTables: state.tables,
  settings: state.obeeSettings
});
const mapDispatchToProps$1P = (dispatch) => bindActionCreators(
  {
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction,
    updateBooking: updateObeeBookingAction
  },
  dispatch
);
const ReservationCard$1 = connect(mapStateToProps$1Q, mapDispatchToProps$1P)(ReservationCard);
const useStyles$_ = createUseStyles((theme2) => {
  var _a, _b2;
  return {
    container: {
      padding: "0 10px",
      borderRadius: "24px",
      lineHeight: "24px",
      fontSize: "15px",
      fontWeight: "bold",
      color: theme2.colors.labelText,
      userSelect: "none",
      ...(_b2 = (_a = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _a.ReservationStatusPill) == null ? void 0 : _b2.container
    }
  };
});
const ReservationStatusPill = ({ status }) => {
  const classes = useStyles$_();
  const bookingStatus = getStatusDetails(status);
  const styles2 = {
    backgroundColor: bookingStatus == null ? void 0 : bookingStatus.backgroundColor,
    border: `1px solid ${bookingStatus == null ? void 0 : bookingStatus.outline}`,
    color: bookingStatus == null ? void 0 : bookingStatus.color
  };
  if (bookingStatus == null ? void 0 : bookingStatus.label) {
    return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container, style: styles2 }, bookingStatus == null ? void 0 : bookingStatus.label);
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
};
ReservationStatusPill.defaultProps = {
  status: null
};
ReservationStatusPill.propTypes = {
  status: PropTypes.string
};
const mapStateToProps$1P = () => ({});
const mapDispatchToProps$1O = (dispatch) => bindActionCreators({}, dispatch);
const ReservationStatusPill$1 = connect(mapStateToProps$1P, mapDispatchToProps$1O)(ReservationStatusPill);
const useStyles$Z = createUseStyles((theme2) => ({
  bookingGroup: {
    maxWidth: "291px"
  },
  bookingGroupHeading: {
    position: "sticky",
    top: 0,
    zIndex: "2",
    display: "flex",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme2.colors.shark}`,
    backgroundColor: theme2.colors.sidebarBackground,
    alignItems: "center",
    margin: "0 -8px 4px -8px",
    padding: "0 8px 10px 8px"
  },
  bookingGroupStyles: {
    display: "flex",
    gap: "8px"
  },
  reservationCardsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "12px 0"
  }
}));
const ReservationGroup = ({
  bookings,
  status,
  setHoveredTable,
  hoveredTable,
  onStopDragging,
  onStartDragging,
  canDrag,
  selectedBooking,
  onClick,
  scrollToBooking,
  tables,
  obeeSessions: obeeSessions2,
  // TODO use todaySessions instead, and get from above somewhere
  loading,
  date,
  areas,
  messagesAnchor,
  setMessagesAnchor,
  settings,
  thinDraggedBookings
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$Z();
  bookings.reduce((accum, booking) => accum + ((booking == null ? void 0 : booking.size) || 0), 0);
  const isWaitlist = status === STATUS_TYPES.WAITING;
  const conflicts = useMemo(() => {
    const todaySessions = getTodaySessions(date, obeeSessions2);
    const newConflicts = {};
    const openingHours = getRestaurantHoursFromSessions(obeeSessions2.data);
    bookings.forEach((booking) => {
      const conflictsForBooking = getConflicts(
        booking,
        tables == null ? void 0 : tables.data,
        openingHours.open,
        openingHours.close,
        todaySessions,
        areas == null ? void 0 : areas.data
      );
      if (conflictsForBooking !== false) {
        newConflicts[booking.id] = conflictsForBooking;
      }
    });
    return newConflicts;
  }, [bookings, tables.data, obeeSessions2.data]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingGroup }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingGroupHeading }, /* @__PURE__ */ React__default.createElement(ReservationStatusPill$1, { status })), (bookings == null ? void 0 : bookings.length) === 0 && /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "15px", color: theme2.colors.smoke } }, "There are no bookings to display"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.reservationCardsContainer }, bookings.map((booking) => {
    var _a, _b2, _c2, _d2, _e2;
    return /* @__PURE__ */ React__default.createElement(
      ReservationCard$1,
      {
        key: booking == null ? void 0 : booking.id,
        booking,
        setHoveredTable,
        tableHovered: isTableForBooking(hoveredTable, booking),
        onStartDragging,
        onStopDragging,
        canDrag,
        selected: (booking == null ? void 0 : booking.id) === (selectedBooking == null ? void 0 : selectedBooking.id),
        onClick: () => onClick(booking),
        scrollToBooking,
        conflict: !loading && (conflicts == null ? void 0 : conflicts[booking == null ? void 0 : booking.id]),
        canSendMessage: isWaitlist && ((_b2 = (_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a[0]) == null ? void 0 : _b2.mobile) && ((_e2 = (_d2 = (_c2 = settings == null ? void 0 : settings.data) == null ? void 0 : _c2.messaging) == null ? void 0 : _d2.sms_waitlist) == null ? void 0 : _e2.enabled),
        messagesAnchor,
        setMessagesAnchor,
        thinDraggedBookings
      }
    );
  })));
};
ReservationGroup.defaultProps = {
  hoveredTable: null,
  onStopDragging: () => {
  },
  onStartDragging: () => {
  },
  canDrag: false,
  selectedBooking: null,
  onClick: () => {
  },
  scrollToBooking: false,
  thinDraggedBookings: false
};
ReservationGroup.propTypes = {
  bookings: PropTypes.arrayOf(obeeBookingPropTypes).isRequired,
  status: PropTypes.string.isRequired,
  setHoveredTable: PropTypes.func.isRequired,
  onStopDragging: PropTypes.func,
  onStartDragging: PropTypes.func,
  canDrag: PropTypes.bool,
  hoveredTable: obeeBookingPropTypes,
  // TODO change to hoveredBooking
  selectedBooking: obeeBookingPropTypes,
  onClick: PropTypes.func,
  scrollToBooking: PropTypes.bool,
  tables: tablesPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  date: momentPropTypes.momentObj.isRequired,
  areas: areasPropTypes.isRequired,
  thinDraggedBookings: PropTypes.bool
};
const mapStateToProps$1O = (state) => ({
  tables: state.tables,
  areas: state.areas,
  obeeSessions: state.obeeSessions,
  date: state.obeeScreen.date,
  settings: state.obeeSettings
});
const mapDispatchToProps$1N = (dispatch) => bindActionCreators({}, dispatch);
const ReservationGroup$1 = connect(mapStateToProps$1O, mapDispatchToProps$1N)(ReservationGroup);
const useStyles$Y = createUseStyles((theme2) => ({
  container: {
    position: "relative"
  },
  searchBarContainer: {},
  bookingGroup: {},
  bookingGroupHeading: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme2.colors.shark}`,
    paddingBottom: "10px",
    marginBottom: "10px"
  },
  resultsBox: (props) => ({
    display: "flex",
    flexDirection: "column",
    pointerEvents: (props == null ? void 0 : props.showResults) ? "auto" : "none",
    opacity: (props == null ? void 0 : props.showResults) ? 1 : 0,
    position: "absolute",
    backgroundColor: theme2.colors.white,
    padding: "10px",
    boxShadow: "0px 4px 8px rgba(151, 151, 151, 0.25)",
    borderRadius: "8px",
    width: "100%",
    maxWidth: "295px",
    top: "50px",
    maxHeight: "500px",
    zIndex: "10"
    // marginLeft: '-10px',
  }),
  details: {
    position: "relative",
    flexGrow: 1,
    borderRadius: "8px",
    border: "1px solid transparent",
    color: theme2.colors.smoke,
    padding: "8px",
    userSelect: "none",
    backgroundColor: "white",
    height: "66px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "&:hover": {
      backgroundColor: theme2.colors.dateSelectBackground,
      border: `1px solid ${theme2.colors.smoke}`
    }
  },
  noResultsText: {
    color: theme2.colors.smoke,
    padding: "10px"
  },
  name: {
    ...theme2.typography.body.P,
    fontWeight: theme2.fontWeights.regular,
    width: "100%",
    fontSize: "16px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: "unset"
  },
  bookingInfo: {
    display: "flex",
    gap: "7px",
    alignItems: "center"
  },
  row: {
    display: "flex",
    gap: "2px",
    alignItems: "center"
  },
  dividerCircle: {
    backgroundColor: theme2.colors.gray4,
    borderRadius: "10px",
    width: "3px",
    height: "3px"
  },
  detail: {
    flexGrow: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme2.colors.labelText
  },
  table: {
    flexGrow: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    border: `1px solid ${theme2.colors.yetAnotherGray12}`,
    borderRadius: "4px",
    padding: "0 8px",
    color: theme2.colors.labelText
  },
  buttonRow: {
    alignItems: "center",
    color: theme2.colors.smoke
  },
  buttonContent: {},
  bottom: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    fontSize: "13px"
  },
  menuDivider: {
    height: "1px",
    maxHeight: "1px",
    backgroundColor: theme2.colors.borderGray,
    margin: "6px"
  },
  matchedText: {
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.labelText
  }
}));
const SearchBar = forwardRef(
  ({ bookings, updateBooking, setHoveredTable, onClick, obeeSettings: obeeSettings2 }, ref) => {
    var _a, _b2;
    const theme2 = useTheme$1();
    const [input, setInput] = useState("");
    const [results2, setResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const inputRef = useRef();
    const classes = useStyles$Y({ showResults });
    useHasMobile();
    const updateInput = (newInput) => {
      var _a2;
      setInput(newInput);
      if (!newInput || newInput === "") {
        setShowResults(false);
        setHoveredItem(null);
        setHoveredTable(null);
        return;
      }
      const maxResultsToShow = 5;
      const searchInput = newInput.replace(/\s/g, "").toLowerCase();
      const newResults = (_a2 = bookings == null ? void 0 : bookings.data) == null ? void 0 : _a2.filter((booking) => {
        var _a3;
        if (!((_a3 = obeeSettings2.data) == null ? void 0 : _a3.waitlist) && booking.status === "waitlist") {
          return false;
        }
        const searchString = getBookingName(booking).replace(/\s/g, "").toLowerCase();
        return fuzzySearch(searchString, searchInput);
      }).slice(0, maxResultsToShow);
      const resultsWithMatch = newResults.map((result) => ({
        ...result,
        matchName: separateFuzzySearchText(getBookingName(result), newInput)
      }));
      setShowResults(true);
      setResults(resultsWithMatch);
    };
    useEffect(() => {
      updateInput(input);
    }, [bookings]);
    useImperativeHandle(ref, () => ({
      ...inputRef.current,
      scrollIntoView: (options) => {
        var _a2;
        return (_a2 = inputRef.current) == null ? void 0 : _a2.scrollIntoView(options);
      },
      scrollTo: (options) => {
        var _a2;
        return (_a2 = inputRef.current) == null ? void 0 : _a2.scrollTo(options);
      },
      scroll: (options) => {
        var _a2;
        return (_a2 = inputRef.current) == null ? void 0 : _a2.scroll(options);
      },
      focus: () => {
        var _a2;
        return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
      }
    }));
    const assignSeat = (booking) => {
      updateBooking({
        ...booking,
        status: STATUS_TYPES.ARRIVED
      });
    };
    const resetZoom = () => {
      window.scrollTo({ x: 0, y: 0, animated: true });
      document.body.scrollTo({ x: 0, y: 0, animated: true });
    };
    const styles2 = {
      container: {
        display: "flex",
        gap: "10px",
        alignItems: "center"
      },
      innerContainer: {
        width: "100%"
      },
      label: {
        color: theme2.colors.nimbus,
        marginBottom: "0",
        width: "120px"
      },
      textField: {
        flexGrow: 1
      },
      textFieldInner: {
        width: "100%"
      },
      input: {
        backgroundColor: theme2.colors.white,
        border: `1px solid ${theme2.colors.grayBorder}`,
        width: "100%",
        color: theme2.colors.labelText,
        padding: "9px 14px 9px 45px",
        borderRadius: "20px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: "20px",
        paddingLeft: "45px",
        transition: "box-shadow 0.1s",
        ...(_b2 = (_a = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _a.SearchBar) == null ? void 0 : _b2.input
      },
      inputActive: {
        // outline: 'none',
        outline: "1px solid black",
        boxShadow: "0 4px 8px rgba(220, 220, 219, 0.25)"
      },
      inputHover: {
        backgroundColor: theme2.colors.dateSelectBackground
      },
      placeholder: {
        color: theme2.colors.nimbus
      }
    };
    const smallButtonStyles2 = {
      button: {
        padding: "0 8px",
        border: `1px solid ${theme2.colors.smoke}`,
        borderRadius: "6px",
        alignItems: "center",
        color: theme2.colors.smoke,
        fontSize: "13px"
      }
    };
    return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.searchBarContainer }, /* @__PURE__ */ React__default.createElement(
      TextField$2,
      {
        inputPrefix: /* @__PURE__ */ React__default.createElement(
          MagnifyingGlassSVG,
          {
            style: {
              marginLeft: "10px",
              color: !isEmpty(input) ? theme2.colors.smoke : theme2.colors.yetAnotherGray16,
              width: "15px"
            }
          }
        ),
        style: styles2,
        placeholder: "Search guest name",
        autoCapitalize: "words",
        onChange: updateInput,
        value: input,
        onBlur: () => {
          setTimeout(() => {
            updateInput("");
            resetZoom();
          }, 200);
        },
        ref: inputRef
      }
    )), showResults && /* @__PURE__ */ React__default.createElement(Box, { className: classes.resultsBox }, isEmpty(results2) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.noResultsText }, "No results found for search"), results2 == null ? void 0 : results2.map((result, index) => {
      var _a2;
      hoveredItem === (result == null ? void 0 : result.id);
      const bookingTime = formatTimeFromInt(result == null ? void 0 : result.startTime);
      const canBeSeated = isBooked(result) && !isFutureDate(result);
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: result == null ? void 0 : result.id,
          onMouseEnter: () => {
            setHoveredItem(result == null ? void 0 : result.id);
            setHoveredTable(result);
          },
          onMouseLeave: () => {
            setHoveredItem(null);
            setHoveredTable(null);
          },
          onClick: () => onClick(result)
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.details }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.name }, (_a2 = result == null ? void 0 : result.matchName) == null ? void 0 : _a2.map((nameSegment, nameSegmentIndex) => /* @__PURE__ */ React__default.createElement(
          "span",
          {
            key: `${nameSegment == null ? void 0 : nameSegment.string}_${nameSegmentIndex}`,
            className: (nameSegment == null ? void 0 : nameSegment.isMatch) ? classes.matchedText : ""
          },
          nameSegment == null ? void 0 : nameSegment.string
        ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottom }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingInfo }, /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.detail,
            style: { flexGrow: 1, color: theme2.colors.smoke }
          },
          bookingTime
        ), (result == null ? void 0 : result.tableNumber) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.table, style: { flexGrow: 1 } }, result == null ? void 0 : result.tableNumber), /* @__PURE__ */ React__default.createElement(Box, { className: classes.dividerCircle }), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.row} ${classes.detail}` }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { height: "13px" } }), /* @__PURE__ */ React__default.createElement(Box, null, result == null ? void 0 : result.size))), !canBeSeated && /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonRow }, getStatusLabel(result)), canBeSeated && /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonRow }, /* @__PURE__ */ React__default.createElement(
          SquareButton,
          {
            onClick: () => assignSeat(result),
            style: smallButtonStyles2
          },
          "Seat"
        )))),
        index !== (results2 == null ? void 0 : results2.length) - 1 && /* @__PURE__ */ React__default.createElement(Box, { className: classes.menuDivider })
      );
    })));
  }
);
SearchBar.defaultProps = {
  onClick: () => {
  }
};
SearchBar.propTypes = {
  bookings: obeeBookingsPropTypes.isRequired,
  updateBooking: PropTypes.func.isRequired,
  setHoveredTable: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$1N = (state) => ({
  bookings: state.obeeBookings,
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$1M = (dispatch) => bindActionCreators(
  {
    updateBooking: updateObeeBookingAction
  },
  dispatch
);
const SearchBar$1 = connect(mapStateToProps$1N, mapDispatchToProps$1M, null, { forwardRef: true })(SearchBar);
const headerHeight = 45;
const useStyles$X = createUseStyles(
  (theme2) => {
    var _a, _b2, _c2, _d2, _e2, _f;
    return {
      sidebarTop: {
        backgroundColor: theme2.colors.sidebarBackground,
        // padding: '0 20px',
        paddingTop: "10px",
        zIndex: 5
      },
      container: {
        boxSizing: "border-box",
        backgroundColor: theme2.colors.sidebarBackground,
        width: `${(_b2 = (_a = theme2.components) == null ? void 0 : _a.floorplan) == null ? void 0 : _b2.sidebarWidth}px`,
        minWidth: `${(_d2 = (_c2 = theme2.components) == null ? void 0 : _c2.floorplan) == null ? void 0 : _d2.sidebarWidth}px`,
        maxWidth: `${(_f = (_e2 = theme2.components) == null ? void 0 : _e2.floorplan) == null ? void 0 : _f.sidebarWidth}px`,
        zIndex: 1,
        // So it's drawn over the canvas
        display: "flex",
        flexDirection: "column",
        height: `100%`,
        maxHeight: `calc(100dvh - ${headerHeight}px)`
      },
      sidebarContent: {
        padding: "0 10px 50px 20px",
        flex: "1",
        display: "flex",
        flexDirection: "column",
        overflow: "visible"
      },
      sidebarContentInner: {
        height: "100%",
        overflow: "scroll"
        // Hack to allow overflow x to be visible
      },
      reservations: {
        display: "flex",
        flexDirection: "column",
        gap: "4px"
      },
      actionIcon: {
        width: "19px",
        height: "8px",
        color: theme2.colors.charcoal
      },
      collapsedRunsheet: {
        width: "66px",
        minHeight: "200px",
        height: "100%",
        padding: "0 6px 6px 6px"
      },
      collapsedRunsheetInner: {
        width: "54px",
        border: `1px solid ${theme2.colors.yetAnotherGray15}`,
        borderRadius: "12px",
        height: "100%",
        padding: "12px 0 8px 0",
        justifyContent: "space-between",
        alignItems: "center"
      },
      rotatedTextOuter: {
        transform: "rotate(-90deg)",
        whiteSpace: "nowrap",
        width: "40px"
      },
      rotatedText: {
        minWidth: "120px",
        fontWeight: theme2.fontWeights.medium
      },
      hiddenSidebar: {
        // For the search focus to work on ipad, we need to have the search bar "visible"
        // at all times, so we just make it hard to see when not shown
        height: 0,
        width: 0,
        position: "absolute",
        zIndex: "-10",
        left: "-2000px",
        top: 0,
        // bottom: '0',
        overflow: "hidden",
        pointerEvents: "none"
        // top: '100px', // So it scrolls to the top on ipad
      },
      dailyNoteContainer: {
        padding: "0 10px 10px 20px",
        maxHeight: "150px",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "8px"
      },
      dailyNote: {
        padding: "12px 8px 12px 8px",
        borderRadius: "12px",
        backgroundColor: theme2.colors.linenDark,
        color: theme2.colors.linen,
        display: "flex",
        flexDirection: "row",
        gap: "8px"
      },
      dailyNoteText: {
        color: theme2.colors.charcoal,
        fontSize: "14px",
        display: "flex",
        flexDirection: "column",
        gap: "8px"
      },
      dailyNoteTitle: {
        fontWeight: theme2.fontWeights.medium
      },
      dailyNoteMessage: {}
    };
  },
  { name: "BookingsSidebar" }
);
const collapseButtonStyles = (theme2) => ({
  button: {
    width: "36px",
    height: "36px",
    padding: "10px",
    borderRadius: "18px",
    color: theme2.colors.charcoal,
    zIndex: 1
  },
  buttonHover: {
    backgroundColor: "white",
    filter: "none",
    color: "black"
  }
});
const SvgHamburger = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 20 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M1 1H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M1 7.5H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M1 14H19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const HamburgerSVG = SvgHamburger;
const SvgArrowBasic = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 21 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M0 12.5H20M20 12.5L8.5 1M20 12.5L8.5 24", stroke: "currentColor" }));
const ArrowBasicSVG = SvgArrowBasic;
const BookingsSidebar = ({
  setHighlightedTable,
  // TODO rename to setHighlightedBooking. Table number comes from booking
  bookings,
  hoveredTable,
  selectedBooking,
  selectBooking,
  onStartDragging,
  onStopDragging,
  activeTab,
  setActiveTab,
  scrollToBooking,
  draggedBooking,
  loading,
  waitlist,
  messagesAnchor,
  setMessagesAnchor,
  obeeAreas: obeeAreas2,
  focusedArea,
  setFocusedArea,
  canDragWaitlistBookings,
  thinDraggedBookings,
  dailyNotes,
  date
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$X();
  const [confirmedBookings, setConfirmedBookings] = useState([]);
  const [arrivedBookings, setArrivedBookings] = useState([]);
  const [finishedBookings, setFinishedBookings] = useState([]);
  const [noShowBookings, setNoShowBookings] = useState([]);
  const [cancelledBookings, setCancelledBookings] = useState([]);
  const [waitingBookings, setWaitingBookings] = useState([]);
  const [readyBookings, setReadyBookings] = useState([]);
  const searchBarRef = useRef(null);
  const [collapsed, setCollapsed] = useState(
    getLocalValueForRestaurant("collapse_mini_runsheet", false)
  );
  const collapseHeader = (newValue) => {
    storeLocalValueForRestaurant("collapse_mini_runsheet", newValue);
    setCollapsed(newValue);
  };
  const areaItems = [
    { label: "All areas", value: null },
    ...obeeAreas2.data.map((area) => ({ label: area.name, value: area.id }))
  ];
  useEffect(() => {
    const sortedBookings = sortListByProperty(bookings, "time");
    const bookingsForArea = sortedBookings.filter(
      (booking) => isEmpty(focusedArea) || (booking == null ? void 0 : booking.areaId) === focusedArea
    );
    unstable_batchedUpdates(() => {
      const newConfirmedBookings = filterByProperty(
        bookingsForArea,
        STATUS_TYPES.CONFIRMED,
        "status"
      );
      const newBookedBookings = filterByProperty(
        bookingsForArea,
        [STATUS_TYPES.BOOKED, "", null],
        "status"
      );
      setReadyBookings([...newConfirmedBookings, ...newBookedBookings]);
      setConfirmedBookings(filterByProperty(bookingsForArea, STATUS_TYPES.CONFIRMED, "status"));
      setArrivedBookings(filterByProperty(bookingsForArea, STATUS_TYPES.ARRIVED, "status"));
      setFinishedBookings(filterByProperty(bookingsForArea, STATUS_TYPES.FINISHED, "status"));
      setNoShowBookings(filterByProperty(bookingsForArea, STATUS_TYPES.NO_SHOW, "status"));
      setCancelledBookings(filterByProperty(bookingsForArea, STATUS_TYPES.CANCELLED, "status"));
      setWaitingBookings(
        immutableSort(
          filterByProperty(sortedBookings, STATUS_TYPES.WAITING, "status"),
          (a, b) => sortMomentByProperty(a, b, "createdAt", "YYYY-MM-DD hh:mm:ss")
        )
      );
    });
  }, [bookings, focusedArea]);
  const hasBookings = readyBookings.length || confirmedBookings.length || arrivedBookings.length || finishedBookings.length || noShowBookings.length || cancelledBookings.length;
  const beginSearch = (e) => {
    var _a;
    collapseHeader(false);
    (_a = searchBarRef == null ? void 0 : searchBarRef.current) == null ? void 0 : _a.focus();
    e.preventDefault();
    e.stopPropagation();
  };
  const sidebarContent = useRef(null);
  const offsetRef = useRef(0);
  const handleDragBooking = (booking, e) => {
    var _a;
    if (offsetRef.current === 0) {
      offsetRef.current = (_a = sidebarContent.current) == null ? void 0 : _a.scrollTop;
    }
    onStartDragging(booking, e, 0);
  };
  useEffect(() => {
    if (isEmpty(draggedBooking)) {
      offsetRef.current = 0;
    }
  }, draggedBooking);
  return /* @__PURE__ */ React__default.createElement(Box, { style: { height: "100%" } }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.collapsedRunsheet,
      style: !collapsed ? { display: "none", pointerEvents: "none", height: 0 } : {}
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { className: classes.collapsedRunsheetInner, direction: "vertical" }, /* @__PURE__ */ React__default.createElement(
      HeaderButton$1,
      {
        type: "round",
        onClick: beginSearch,
        style: { button: { width: "38px", height: "38px" } }
      },
      /* @__PURE__ */ React__default.createElement(MagnifyingGlassSVG, { style: { width: "20px", height: "20px" } })
    ), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.rotatedTextOuter }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.rotatedText }, "Run sheet")), /* @__PURE__ */ React__default.createElement(
      HeaderButton$1,
      {
        type: "round",
        onClick: (e) => {
          collapseHeader(false);
          e.preventDefault();
          e.stopPropagation();
        },
        style: { container: { paddingTop: "30px" } }
      },
      /* @__PURE__ */ React__default.createElement(ArrowBasicSVG, { style: { width: "20px" } })
    )))
  ), /* @__PURE__ */ React__default.createElement(Box, { className: `${collapsed ? classes.hiddenSidebar : ""} ${classes.container}` }, loading ? /* @__PURE__ */ React__default.createElement(Skeleton$1, { height: 20 }) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sidebarTop }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 12, style: { padding: "0 0 0 6px" } }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "icon",
      onClick: () => collapseHeader(true),
      style: collapseButtonStyles(theme2)
    },
    /* @__PURE__ */ React__default.createElement(HamburgerSVG, { style: { width: "20px" } })
  ), /* @__PURE__ */ React__default.createElement(
    BookingsTabBar$1,
    {
      setActiveTab,
      activeTab,
      waitingBookings,
      showWaitlist: waitlist,
      style: { containerInner: { gap: "0" } }
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { style: { padding: "10px 20px 10px 20px", maxWidth: "315px" } }, /* @__PURE__ */ React__default.createElement(
    SearchBar$1,
    {
      setHoveredTable: setHighlightedTable,
      onClick: selectBooking,
      ref: searchBarRef
    }
  )), /* @__PURE__ */ React__default.createElement(NotePreviewSmall$1, null), /* @__PURE__ */ React__default.createElement(Box, { style: { marginLeft: "20px", marginBottom: "8px" } }, /* @__PURE__ */ React__default.createElement(TextDropdown$1, { value: focusedArea, items: areaItems, onSelect: setFocusedArea }))), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      ref: sidebarContent,
      className: classes.sidebarContent,
      style: {
        width: "315px",
        position: !isEmpty(draggedBooking) ? "absolute" : "relative",
        top: !isEmpty(draggedBooking) ? `${156 - offsetRef.current}px` : "0",
        overflowY: !isEmpty(draggedBooking) ? "visible" : "scroll",
        overflowX: !isEmpty(draggedBooking) ? "visible" : "hidden"
      }
    },
    activeTab === "bookings" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.reservations }, !hasBookings && focusedArea === null && /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "15px", color: theme2.colors.smoke } }, "There are no bookings to display"), !hasBookings && focusedArea !== null && /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "15px", color: theme2.colors.smoke } }, "There are no bookings to display for this area"), (readyBookings == null ? void 0 : readyBookings.length) > 0 && /* @__PURE__ */ React__default.createElement(
      ReservationGroup$1,
      {
        bookings: readyBookings,
        status: STATUS_TYPES.BOOKED,
        setHoveredTable: setHighlightedTable,
        hoveredTable,
        selectedBooking,
        onClick: selectBooking,
        scrollToBooking,
        loading,
        thinDraggedBookings
      }
    ), (arrivedBookings == null ? void 0 : arrivedBookings.length) > 0 && /* @__PURE__ */ React__default.createElement(
      ReservationGroup$1,
      {
        bookings: arrivedBookings,
        status: STATUS_TYPES.ARRIVED,
        setHoveredTable: setHighlightedTable,
        hoveredTable,
        selectedBooking,
        onClick: selectBooking,
        scrollToBooking,
        loading,
        thinDraggedBookings
      }
    ), (finishedBookings == null ? void 0 : finishedBookings.length) > 0 && /* @__PURE__ */ React__default.createElement(
      ReservationGroup$1,
      {
        bookings: finishedBookings,
        status: STATUS_TYPES.FINISHED,
        setHoveredTable: setHighlightedTable,
        hoveredTable,
        selectedBooking,
        onClick: selectBooking,
        scrollToBooking,
        loading,
        thinDraggedBookings
      }
    ), (noShowBookings == null ? void 0 : noShowBookings.length) > 0 && /* @__PURE__ */ React__default.createElement(
      ReservationGroup$1,
      {
        bookings: noShowBookings,
        status: STATUS_TYPES.NO_SHOW,
        setHoveredTable: setHighlightedTable,
        hoveredTable,
        selectedBooking,
        onClick: selectBooking,
        scrollToBooking,
        loading,
        thinDraggedBookings
      }
    ), (cancelledBookings == null ? void 0 : cancelledBookings.length) > 0 && /* @__PURE__ */ React__default.createElement(
      ReservationGroup$1,
      {
        bookings: cancelledBookings,
        status: STATUS_TYPES.CANCELLED,
        setHoveredTable: setHighlightedTable,
        hoveredTable,
        selectedBooking,
        onClick: selectBooking,
        scrollToBooking,
        loading,
        thinDraggedBookings
      }
    )),
    activeTab === "waitlist" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.reservations }, /* @__PURE__ */ React__default.createElement(
      ReservationGroup$1,
      {
        bookings: waitingBookings,
        status: STATUS_TYPES.WAITING,
        setHoveredTable: () => {
        },
        hoveredTable,
        selectedBooking,
        onClick: selectBooking,
        scrollToBooking,
        loading,
        canDrag: canDragWaitlistBookings,
        onStartDragging: handleDragBooking,
        onStopDragging,
        messagesAnchor,
        setMessagesAnchor,
        thinDraggedBookings
      }
    ))
  ))));
};
BookingsSidebar.defaultProps = {
  onStartDragging: () => {
  },
  onStopDragging: () => {
  },
  selectBooking: () => {
  },
  selectedBooking: null,
  hoveredTable: null,
  setHighlightedTable: () => {
  },
  scrollToBooking: false,
  draggedBooking: null,
  focusedArea: null,
  canDragWaitlistBookings: true,
  thinDraggedBookings: false
};
BookingsSidebar.propTypes = {
  bookings: PropTypes.arrayOf(obeeBookingPropTypes).isRequired,
  setHighlightedTable: PropTypes.func,
  hoveredTable: tablePropTypes,
  selectedBooking: obeeBookingPropTypes,
  selectBooking: PropTypes.func,
  onStartDragging: PropTypes.func,
  onStopDragging: PropTypes.func,
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  scrollToBooking: PropTypes.bool,
  draggedBooking: obeeBookingPropTypes,
  loading: PropTypes.bool.isRequired,
  waitlist: PropTypes.bool.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  focusedArea: PropTypes.number,
  setFocusedArea: PropTypes.func.isRequired,
  canDragWaitlistBookings: PropTypes.bool,
  thinDraggedBookings: PropTypes.bool,
  dailyNotes: dailyNotesPropTypes.isRequired,
  date: momentPropTypes.momentObj
};
const mapStateToProps$1M = (state) => {
  var _a;
  return {
    waitlist: (_a = state.obeeSettings.data) == null ? void 0 : _a.waitlist,
    obeeAreas: state.areas,
    dailyNotes: state.dailyNotes,
    date: state.obeeScreen.date
  };
};
const mapDispatchToProps$1L = (dispatch) => bindActionCreators(
  {
    fetchSessions: fetchSessionsAction
  },
  dispatch
);
const BookingsSidebar$1 = connect(mapStateToProps$1M, mapDispatchToProps$1L)(BookingsSidebar);
const rectangleImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2075%2059'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='2.5'%20y='2.5'%20width='70'%20height='54'%20stroke='currentColor'/%3e%3c/svg%3e";
const circleImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2079%2079'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='39.5'%20cy='39.5'%20r='39'%20stroke='currentColor'/%3e%3c/svg%3e";
const islandImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2097%2057'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.5%200.5H69.5C84.4117%200.5%2096.5%2012.5883%2096.5%2027.5C96.5%2042.4117%2084.4117%2054.5%2069.5%2054.5H2.5V0.5Z'%20stroke='currentColor'/%3e%3c/svg%3e";
const polygonImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2074%2076'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M35.9184%200.877151C36.6214%200.648748%2037.3786%200.648748%2038.0816%200.877151L57.9453%207.33126C58.6482%207.55966%2059.2608%208.00474%2059.6953%208.60271L71.9717%2025.4998C72.4062%2026.0977%2072.6402%2026.8179%2072.6402%2027.557V48.443C72.6402%2049.1821%2072.4062%2049.9022%2071.9717%2050.5002L59.6953%2067.3973C59.2608%2067.9953%2058.6482%2068.4403%2057.9453%2068.6687L38.0816%2075.1228C37.3786%2075.3512%2036.6214%2075.3512%2035.9184%2075.1228L16.0547%2068.6687C15.3518%2068.4403%2014.7392%2067.9953%2014.3047%2067.3973L2.02829%2050.5002C1.59384%2049.9022%201.35985%2049.1821%201.35985%2048.443V27.557C1.35985%2026.8179%201.59384%2026.0978%202.02829%2025.4998L14.3047%208.60271C14.7392%208.00474%2015.3518%207.55966%2016.0547%207.33126L35.9184%200.877151Z'%20stroke='currentColor'/%3e%3c/svg%3e";
const doorImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2067%2038'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.2027%2037C40.0189%2037%2050.25%2013%2052.5135%201H67M17.2027%2037V1H15.5M17.2027%2037H15.5V1M0%201H15.5'%20stroke='black'/%3e%3c/svg%3e";
const singleStairsImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2087%2034'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='0.5'%20y='0.5'%20width='86'%20height='32.6774'%20stroke='currentColor'/%3e%3cline%20x1='16.8203'%20y1='0.604736'%20x2='16.8203'%20y2='33.8504'%20stroke='currentColor'/%3e%3cline%20x1='33.7461'%20y1='0.604736'%20x2='33.7461'%20y2='33.8504'%20stroke='currentColor'/%3e%3cline%20x1='50.6709'%20y1='0.604736'%20x2='50.6709'%20y2='33.8504'%20stroke='currentColor'/%3e%3cline%20x1='67.5957'%20y1='0.604736'%20x2='67.5957'%20y2='33.8504'%20stroke='currentColor'/%3e%3cline%20x1='84.5205'%20y1='0.604736'%20x2='84.5205'%20y2='33.8504'%20stroke='currentColor'/%3e%3c/svg%3e";
const landingStairsImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2091%2065'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='17.5078'%20y='36.2192'%20width='72.9907'%20height='27.6415'%20stroke='currentColor'/%3e%3cline%20x1='31.3887'%20y1='36.2339'%20x2='31.3887'%20y2='64.5082'%20stroke='currentColor'/%3e%3cline%20x1='45.7832'%20y1='36.2339'%20x2='45.7832'%20y2='64.5082'%20stroke='currentColor'/%3e%3cline%20x1='60.1777'%20y1='36.2339'%20x2='60.1777'%20y2='64.5082'%20stroke='currentColor'/%3e%3cline%20x1='74.5713'%20y1='36.2339'%20x2='74.5713'%20y2='64.5082'%20stroke='currentColor'/%3e%3cline%20x1='88.9658'%20y1='36.2339'%20x2='88.9658'%20y2='64.5082'%20stroke='currentColor'/%3e%3crect%20x='17.5078'%20y='0.5'%20width='72.9907'%20height='27.6415'%20stroke='currentColor'/%3e%3cline%20x1='31.3887'%20y1='0.514404'%20x2='31.3887'%20y2='28.7887'%20stroke='currentColor'/%3e%3cline%20x1='45.7832'%20y1='0.514404'%20x2='45.7832'%20y2='28.7887'%20stroke='currentColor'/%3e%3cline%20x1='60.1777'%20y1='0.514404'%20x2='60.1777'%20y2='28.7887'%20stroke='currentColor'/%3e%3cline%20x1='74.5713'%20y1='0.514404'%20x2='74.5713'%20y2='28.7887'%20stroke='currentColor'/%3e%3cline%20x1='88.9658'%20y1='0.514404'%20x2='88.9658'%20y2='28.7887'%20stroke='currentColor'/%3e%3crect%20x='0.5'%20y='0.5'%20width='16.8598'%20height='63.6355'%20stroke='currentColor'/%3e%3c/svg%3e";
const kitchenImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2038%2039'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='2.22852'%20y='2.22852'%20width='33.4286'%20height='34.5813'%20rx='4'%20fill='%23F5F2ED'/%3e%3crect%20x='1'%20y='1'%20width='35.8857'%20height='37'%20rx='3'%20stroke='%236E6E6D'%20stroke-width='2'/%3e%3cpath%20d='M26.0495%2026.7994V16.9802C27.4649%2016.3484%2029.9594%2014.3514%2028.6143%2011.4181C27.2692%208.48475%2024.0642%209.36723%2022.6298%2010.1751C22.2783%209.45009%2021.1023%208%2019.2101%208C16.8448%208%2015.9729%2010.1751%2015.9729%2010.1751C15.9729%2010.1751%2011.8293%207.4718%2010.3188%2011.4181C9.14132%2014.4943%2011.5062%2016.4416%2012.8551%2016.9802V26.7994M26.0495%2026.7994V26.7994C26.0495%2028.5671%2024.6166%2030%2022.849%2030H16.0557C14.288%2030%2012.8551%2028.5671%2012.8551%2026.7994V26.7994M26.0495%2026.7994H12.8551'%20stroke='%230E3AB9'/%3e%3c/svg%3e";
const registerImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2057%2054'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5.1201%2052.0968L7.38891%2046.9468L13.1599%2032.0918L52.0609%2032.0918H53.9082C55.0128%2032.0918%2055.9082%2032.9872%2055.9082%2034.0918L55.9082%2052.5C55.9082%2053.0523%2055.4688%2053.5%2054.9165%2053.5L12.5%2053.5H6.03524C5.31298%2053.5%204.82892%2052.7578%205.1201%2052.0968Z'%20fill='white'%20stroke='%23313131'/%3e%3crect%20x='1'%20y='15.8857'%20width='42.0308'%20height='30.0613'%20rx='2'%20fill='white'%20stroke='%236E6E6D'%20stroke-width='2'/%3e%3crect%20x='4.1582'%20y='18.75'%20width='35.5'%20height='24.5'%20rx='2.75'%20fill='%23F5F2ED'%20stroke='%23313131'%20stroke-width='0.5'/%3e%3cline%20x1='49.5156'%20y1='31.9849'%20x2='49.5156'%20y2='6.5496'%20stroke='%23313131'/%3e%3crect%20x='44.5'%20y='0.5'%20width='10'%20height='4'%20rx='0.5'%20fill='%23313131'%20stroke='%23313131'/%3e%3crect%20x='48.5'%20y='5.12622'%20width='2'%20height='1'%20rx='0.5'%20stroke='%23313131'/%3e%3cpath%20d='M22%2027.1818C22.477%2027.1818%2022.9343%2027.3542%2023.2716%2027.661C23.6087%2027.968%2023.7982%2028.3841%2023.7982%2028.8182C23.7982%2029.0131%2023.9124%2029.1932%2024.0979%2029.2906C24.2833%2029.388%2024.5118%2029.388%2024.6973%2029.2906C24.8827%2029.1932%2024.997%2029.0131%2024.997%2028.8182C24.9971%2028.1894%2024.7586%2027.5799%2024.3216%2027.0929C23.8847%2026.6059%2023.2764%2026.2712%2022.5994%2026.1454V25.5454C22.5994%2025.3505%2022.4851%2025.1705%2022.2997%2025.0731C22.1143%2024.9756%2021.8857%2024.9756%2021.7003%2025.0731C21.5149%2025.1705%2021.4006%2025.3505%2021.4006%2025.5454V26.1454C20.4207%2026.3265%2019.6045%2026.9404%2019.2247%2027.7821C18.8449%2028.6237%2018.9512%2029.5823%2019.5084%2030.3379C20.0656%2031.0935%2021.0002%2031.5464%2022%2031.5455C22.477%2031.5455%2022.9343%2031.7179%2023.2716%2032.0247C23.6087%2032.3316%2023.7982%2032.7478%2023.7982%2033.1818C23.7982%2033.6159%2023.6087%2034.032%2023.2716%2034.339C22.9343%2034.6458%2022.477%2034.8182%2022%2034.8182C21.523%2034.8182%2021.0657%2034.6458%2020.7284%2034.339C20.3913%2034.032%2020.2018%2033.6159%2020.2018%2033.1818C20.2018%2032.9869%2020.0876%2032.8068%2019.9021%2032.7094C19.7167%2032.612%2019.4882%2032.612%2019.3027%2032.7094C19.1173%2032.8068%2019.003%2032.9869%2019.003%2033.1818C19.0029%2033.8106%2019.2414%2034.4201%2019.6784%2034.9071C20.1153%2035.3941%2020.7236%2035.7288%2021.4006%2035.8546V36.4546C21.4006%2036.6495%2021.5149%2036.8295%2021.7003%2036.9269C21.8857%2037.0244%2022.1143%2037.0244%2022.2997%2036.9269C22.4851%2036.8295%2022.5994%2036.6495%2022.5994%2036.4546V35.8546C23.5793%2035.6735%2024.3955%2035.0596%2024.7753%2034.2179C25.1551%2033.3763%2025.0488%2032.4177%2024.4916%2031.6621C23.9344%2030.9065%2022.9998%2030.4536%2022%2030.4545C21.3575%2030.4545%2020.7639%2030.1426%2020.4428%2029.6364C20.1215%2029.1301%2020.1215%2028.5062%2020.4428%2028C20.7639%2027.4938%2021.3575%2027.1818%2022%2027.1818Z'%20fill='%230E3AB9'/%3e%3c/svg%3e";
const toiletImage = "data:image/svg+xml,%3csvg%20viewBox='0%200%2038%2039'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='2.22852'%20y='2.22852'%20width='33.4286'%20height='34.5813'%20rx='4'%20fill='%23F5F2ED'/%3e%3crect%20x='1'%20y='1'%20width='35.8857'%20height='37'%20rx='3'%20stroke='%236E6E6D'%20stroke-width='2'/%3e%3cpath%20d='M9.41707%2020.6072L9.41738%2020.6044L9.8369%2016.7438C9.83692%2016.7437%209.83693%2016.7436%209.83695%2016.7434C9.95261%2015.6981%2010.7462%2014.9856%2011.6175%2014.9856H12.2668H12.916C13.7834%2014.9856%2014.5797%2015.7153%2014.6964%2016.7423L15.0958%2020.6666L15.0957%2020.6666L15.0968%2020.6753C15.1263%2020.9227%2014.9518%2021.054%2014.834%2021.054H14.1946H13.7181L13.6952%2021.5299L13.3755%2028.1619L13.3755%2028.163C13.366%2028.3689%2013.2129%2028.4713%2013.1157%2028.4713H11.3776C11.2802%2028.4713%2011.1273%2028.3688%2011.1179%2028.1631L11.1178%2028.1619L10.7981%2021.5299L10.7752%2021.054H10.2987H9.71938C9.59431%2021.054%209.38443%2020.8923%209.41707%2020.6072Z'%20stroke='%230E3AB9'/%3e%3cpath%20d='M28.4707%2020.6522C28.4891%2020.918%2028.3185%2021.0539%2028.198%2021.0651H27.9554H27.3126L27.4707%2021.6881L28.1058%2024.1899C28.2218%2024.6767%2027.8684%2025.0513%2027.558%2025.0513H27.1804H26.7053L26.6811%2025.5257L26.5419%2028.2486L26.5419%2028.249C26.5376%2028.3345%2026.506%2028.3949%2026.4743%2028.4289C26.4447%2028.4607%2026.415%2028.4713%2026.3855%2028.4713H24.8755C24.8609%2028.4713%2024.8282%2028.4646%2024.7906%2028.4251C24.7535%2028.3861%2024.723%2028.325%2024.7191%2028.2489L24.7191%2028.2486L24.5799%2025.5257L24.5557%2025.0513H24.0806H23.703C23.3651%2025.0513%2023.0261%2024.6712%2023.1526%2024.1997L23.1527%2024.1997L23.1544%2024.1931L23.7903%2021.6881L23.9486%2021.0646L23.3053%2021.0651L23.0871%2021.0652C23.087%2021.0652%2023.087%2021.0652%2023.0869%2021.0652C22.9663%2021.0651%2022.7565%2020.9062%2022.7891%2020.6197L22.7895%2020.6166L23.2067%2016.7404C23.2067%2016.7402%2023.2067%2016.74%2023.2067%2016.7398C23.322%2015.6949%2024.1115%2014.9856%2024.9749%2014.9856H26.2664C27.1265%2014.9856%2027.9194%2015.7133%2028.0347%2016.7414L28.4707%2020.6522Z'%20stroke='%230E3AB9'/%3e%3cpath%20d='M13.9855%2012.2571C13.9855%2013.2117%2013.2115%2013.9857%2012.2568%2013.9857C11.3023%2013.9857%2010.5283%2013.2118%2010.5283%2012.2571C10.5283%2011.3024%2011.3023%2010.5286%2012.2568%2010.5286C13.2116%2010.5286%2013.9855%2011.3024%2013.9855%2012.2571Z'%20stroke='%230E3AB9'/%3e%3cpath%20d='M27.3575%2012.2571C27.3575%2013.2118%2026.5836%2013.9857%2025.629%2013.9857C24.6743%2013.9857%2023.9004%2013.2117%2023.9004%2012.2571C23.9004%2011.3024%2024.6743%2010.5286%2025.629%2010.5286C26.5836%2010.5286%2027.3575%2011.3024%2027.3575%2012.2571Z'%20stroke='%230E3AB9'/%3e%3cpath%20d='M19.8021%2010H19.1979C19.0833%2010%2019%2010.1836%2019%2010.3878V28.6122C19%2028.8367%2019.0937%2029%2019.1979%2029H19.8021C19.9167%2029%2020%2028.8164%2020%2028.6122V10.3878C20%2010.1633%2019.9063%2010.0001%2019.8021%2010.0001V10Z'%20fill='%230E3AB9'/%3e%3c/svg%3e";
const rectangleImageObject = new Image();
rectangleImageObject.src = rectangleImage;
const circleImageObject = new Image();
circleImageObject.src = circleImage;
const islandImageObject = new Image();
islandImageObject.src = islandImage;
const polygonImageObject = new Image();
polygonImageObject.src = polygonImage;
const doorImageObject = new Image();
doorImageObject.src = doorImage;
const singleStairsImageObject = new Image();
singleStairsImageObject.src = singleStairsImage;
const landingStairsImageObject = new Image();
landingStairsImageObject.src = landingStairsImage;
const kitchenImageObject = new Image();
kitchenImageObject.src = kitchenImage;
const registerImageObject = new Image();
registerImageObject.src = registerImage;
const toiletImageObject = new Image();
toiletImageObject.src = toiletImage;
const rectangleTableWidth = 75;
const roundTableWidth = 88;
const chairImageLength = 35;
const barTableWidth = 45;
const cornerRadius = 8;
const rectangleChairGap = 10;
const squareChairGap = 16;
const squareTableEdgeGap = 20;
const getImage = (element) => {
  switch (element.type) {
    case "circle":
      return circleImageObject;
    case "island":
      return islandImageObject;
    case "polygon":
      return polygonImageObject;
    case "door":
      return doorImageObject;
    case "stairs_single":
      return singleStairsImageObject;
    case "stairs_landing":
      return landingStairsImageObject;
    case "kitchen":
      return kitchenImageObject;
    case "register":
      return registerImageObject;
    case "toilet":
      return toiletImageObject;
    case "rectangle":
    default:
      return rectangleImageObject;
  }
};
const drawRoundedRect = (ctx, x, y, width, height, radius) => {
  ctx.beginPath();
  ctx.moveTo(x, y + radius);
  ctx.arcTo(x, y + height, x + radius, y + height, radius);
  ctx.arcTo(x + width, y + height, x + width, y + height - radius, radius);
  ctx.arcTo(x + width, y, x + width - radius, y, radius);
  ctx.arcTo(x, y, x, y + radius, radius);
  ctx.fill();
  ctx.stroke();
  ctx.closePath();
};
const drawRect = (ctx, x, y, width, height) => {
  drawRoundedRect(ctx, x, y, width, height, 0);
};
const drawCircle = (ctx, x, y, radius) => {
  ctx.beginPath();
  ctx.arc(x, y, radius, 0, Math.PI * 2);
  ctx.closePath();
};
const drawArc = (ctx, x, y, radius) => {
  ctx.beginPath();
  ctx.arc(x, y, radius, 0, Math.PI);
};
function drawEllipses(ctx, x1, y1, x2, y2) {
  const radiusX = (x2 - x1) * 0.5;
  const radiusY = (y2 - y1) * 0.5;
  const centerX = x1 + radiusX;
  const centerY = y1 + radiusY;
  const step = 0.01;
  let a = step;
  const pi2 = Math.PI * 2 - step;
  ctx.beginPath();
  ctx.moveTo(centerX + radiusX * Math.cos(0), centerY + radiusY * Math.sin(0));
  for (; a < pi2; a += step) {
    ctx.lineTo(centerX + radiusX * Math.cos(a), centerY + radiusY * Math.sin(a));
  }
  ctx.closePath();
  ctx.strokeStyle = "#000";
  ctx.stroke();
}
const drawObject = (ctx, xPosition, yPosition, width, height, rotation, drawFunction) => {
  const xCenter = xPosition + width / 2;
  const yCenter = yPosition + height / 2;
  const xOrigin = -width / 2;
  const yOrigin = -height / 2;
  ctx.translate(xCenter, yCenter);
  ctx.rotate(rotation * Math.PI / 180);
  drawFunction(xOrigin, yOrigin);
  ctx.rotate(-rotation * Math.PI / 180);
  ctx.translate(-xCenter, -yCenter);
};
const drawShape = (ctx, points, strokeWidth = 0) => {
  if (points.length === 0) {
    return;
  }
  ctx.beginPath();
  ctx.moveTo(points[0].x + strokeWidth, points[0].y + strokeWidth);
  for (let i = 1; i < points.length; i += 1) {
    const point = points[i];
    ctx.lineTo(point.x + strokeWidth, point.y + strokeWidth);
  }
  ctx.lineTo(points[0].x + strokeWidth, points[0].y + strokeWidth);
  ctx.fill();
  ctx.closePath();
};
const drawImage = (ctx, image, xPosition, yPosition, width, height, rotation) => {
  const drawFunction = (xOrigin, yOrigin) => {
    ctx.drawImage(image, xOrigin, yOrigin, width, height);
  };
  drawObject(ctx, xPosition, yPosition, width, height, rotation, drawFunction);
};
const chairPath = new Path2D("M35 11V11C35 5.47715 30.5228 1 25 1H11C5.47715 1 1 5.47715 1 11V11");
const drawChair = (ctx, xPos, yPos, rotation, xFix = 0, yFix = 0) => {
  const rotationAmount = rotation * Math.PI / 180;
  ctx.save();
  ctx.translate(xPos, yPos);
  ctx.rotate(rotationAmount);
  ctx.translate(xFix, yFix);
  ctx.fillStyle = "white";
  ctx.beginPath();
  ctx.fill(chairPath);
  ctx.stroke(chairPath);
  ctx.closePath();
  ctx.restore();
};
const drawRoundTable = (ctx, xPosition, yPosition, scale, rotation, seats, tableFillStyle) => {
  const tableRadius = 44 * scale;
  ctx.translate(xPosition, yPosition);
  ctx.rotate(rotation * Math.PI / 180);
  for (let i = 0; i < seats; i += 1) {
    const angle = 360 / seats * i;
    const distanceFromCenter = tableRadius + 7;
    const chairWidth = 35;
    drawChair(ctx, 0, 0, angle, -chairWidth / 2, -distanceFromCenter);
  }
  ctx.fillStyle = tableFillStyle;
  drawCircle(ctx, 0, 0, tableRadius);
  ctx.fill();
  ctx.stroke();
  ctx.rotate(-rotation * Math.PI / 180);
  ctx.translate(-xPosition, -yPosition);
};
const getHeightOfRectangleTable = (totalSeats, scale) => {
  const seatsPerSide = Math.ceil(totalSeats / 2);
  return (seatsPerSide * chairImageLength + 2 * rectangleChairGap + (seatsPerSide - 1) * rectangleChairGap) * scale;
};
const drawRectangleTable = (ctx, xPosition, yPosition, scale, rotation, seats, fillStyle) => {
  const tableWidth = rectangleTableWidth * scale;
  const seatsPerSide = Math.ceil(seats / 2);
  const tableHeight = getHeightOfRectangleTable(seats, scale);
  const xCenter = xPosition + tableWidth / 2;
  const yCenter = yPosition + tableHeight / 2;
  const xOrigin = -tableWidth / 2;
  const yOrigin = -tableHeight / 2;
  ctx.translate(xCenter, yCenter);
  ctx.rotate(rotation * Math.PI / 180);
  const seatXOffset = 8;
  const totalEmptySpace = tableHeight - chairImageLength * seatsPerSide;
  const chairGapSize = totalEmptySpace / (seatsPerSide + 1);
  const leftSeatAmount = Math.max(1, Math.ceil(seats / 2));
  for (let i = 0; i < leftSeatAmount; i += 1) {
    const yOffset = 35;
    const chairPos = chairGapSize + (chairImageLength + chairGapSize) * i + yOffset;
    drawChair(ctx, xOrigin - seatXOffset, yOrigin + chairPos, 270);
  }
  const rightSeatAmount = seats - leftSeatAmount;
  for (let i = 0; i < rightSeatAmount; i += 1) {
    const chairPos = chairGapSize + (chairImageLength + chairGapSize) * i;
    drawChair(ctx, xOrigin + tableWidth + seatXOffset, yOrigin + chairPos, 90);
  }
  ctx.fillStyle = fillStyle;
  drawRoundedRect(ctx, xOrigin, yOrigin, tableWidth, tableHeight, cornerRadius);
  ctx.rotate(-rotation * Math.PI / 180);
  ctx.translate(-xCenter, -yCenter);
};
const drawSquareTable = (ctx, xPosition, yPosition, scale, rotation, seats, tableFillStyle) => {
  const seatsPerSide = Math.max(1, Math.ceil(seats / 4));
  const minSeatsPerSide = Math.floor(seats / 4);
  const tableWidth = (seatsPerSide * chairImageLength + 2 * squareTableEdgeGap + (seatsPerSide - 1) * squareChairGap) * scale;
  const xCenter = xPosition + tableWidth / 2;
  const yCenter = yPosition + tableWidth / 2;
  const xOrigin = -tableWidth / 2;
  const yOrigin = -tableWidth / 2;
  ctx.translate(xCenter, yCenter);
  ctx.rotate(rotation * Math.PI / 180);
  const seatXOffset = 8;
  const seatYOffsetLeft = 19;
  const seatYOffsetRight = -19;
  const seatXOffsetTop = -19;
  const seatYOffsetTop = -8;
  const seatXOffsetBottom = 19;
  const seatYOffsetBottom = 8;
  const topSeatAmount = seatsPerSide;
  const bottomSeatAmount = minSeatsPerSide + (seats % 4 > 1 ? 1 : 0);
  const rightSeatAmount = minSeatsPerSide + (seats % 4 > 2 ? 1 : 0);
  const leftSeatAmount = minSeatsPerSide;
  for (let i = 0; i < topSeatAmount; i += 1) {
    const spacing = tableWidth / (topSeatAmount + 1);
    const chairPos = spacing * i + spacing + seatXOffsetTop;
    drawChair(ctx, xOrigin + chairPos, yOrigin + seatYOffsetTop, 0);
  }
  for (let i = 0; i < bottomSeatAmount; i += 1) {
    const spacing = tableWidth / (bottomSeatAmount + 1);
    const chairPos = spacing * i + spacing + seatXOffsetBottom;
    drawChair(ctx, xOrigin + chairPos, yOrigin + tableWidth + seatYOffsetBottom, 180);
  }
  for (let i = 0; i < rightSeatAmount; i += 1) {
    const spacing = tableWidth / (rightSeatAmount + 1);
    const chairPos = spacing * i + spacing + seatYOffsetRight;
    drawChair(ctx, xOrigin + tableWidth + seatXOffset, yOrigin + chairPos, 90);
  }
  for (let i = 0; i < leftSeatAmount; i += 1) {
    const spacing = tableWidth / (leftSeatAmount + 1);
    const chairPos = spacing * i + spacing + seatYOffsetLeft;
    drawChair(ctx, xOrigin - seatXOffset, yOrigin + chairPos, 270);
  }
  ctx.fillStyle = tableFillStyle;
  drawRoundedRect(ctx, xOrigin, yOrigin, tableWidth, tableWidth, cornerRadius);
  ctx.rotate(-rotation * Math.PI / 180);
  ctx.translate(-xCenter, -yCenter);
};
const drawBarTable = (ctx, xPosition, yPosition, scale, rotation, seats, tableFillStyle) => {
  const tableWidth = barTableWidth * scale;
  const tableHeight = (chairImageLength * seats + (seats + 1) * rectangleChairGap) * scale;
  const xCenter = xPosition + tableWidth / 2;
  const yCenter = yPosition + tableHeight / 2;
  const xOrigin = -tableWidth / 2;
  const yOrigin = -tableHeight / 2;
  ctx.translate(xCenter, yCenter);
  ctx.rotate(rotation * Math.PI / 180);
  ctx.fillStyle = "white";
  const gapSize = (tableHeight - chairImageLength * seats) / (seats + 1);
  const seatXOffset = 8;
  for (let i = 0; i < seats; i += 1) {
    const chairPos = chairImageLength * (i + 1) + gapSize * (i + 1);
    drawChair(ctx, xOrigin - seatXOffset, yOrigin + chairPos, 270);
  }
  ctx.fillStyle = tableFillStyle;
  drawRoundedRect(ctx, xOrigin, yOrigin, tableWidth, tableHeight, cornerRadius);
  ctx.rotate(-rotation * Math.PI / 180);
  ctx.translate(-xCenter, -yCenter);
};
const drawBoundingBox = (ctx, bounds, theme2, offset = 10, drawCornerSquares = true) => {
  ctx.lineWidth = 1;
  ctx.fillStyle = "transparent";
  ctx.strokeStyle = theme2.colors.olive3;
  drawRect(ctx, bounds.topLeftX - offset, bounds.topLeftY - offset, bounds.width, bounds.height);
  if (drawCornerSquares) {
    const rightSquarePos = bounds.topLeftX - offset - 3 + bounds.width;
    const bottomSquarePos = bounds.topLeftY - offset - 3 + bounds.height;
    ctx.fillStyle = "white";
    drawRect(ctx, rightSquarePos, bottomSquarePos, 6, 6);
  }
  ctx.closePath();
};
const drawText = (ctx, text, xPosition, yPosition, width, height, rotation, fontSize = 18, fontWeight = 400) => {
  const fontFamily2 = isObee() ? "Inter" : "Gordita";
  ctx.font = `${fontWeight} ${fontSize}px ${fontFamily2}`;
  ctx.textBaseline = "top";
  ctx.fillStyle = "black";
  const xCenter = xPosition + width / 2;
  const yCenter = yPosition + height / 2;
  const xOrigin = -width / 2;
  const yOrigin = -height / 2 + 3;
  const leftPadding = 16;
  ctx.translate(xCenter + leftPadding, yCenter - fontSize / 2 + height / 2);
  ctx.rotate(rotation * Math.PI / 180);
  ctx.fillText(text, xOrigin, yOrigin);
  ctx.rotate(-rotation * Math.PI / 180);
  ctx.translate(-xCenter - leftPadding, -yCenter + fontSize / 2 - height / 2);
};
const drawLine = (ctx, xPosition, yPosition, points) => {
  const strokeWidth = 1;
  ctx.lineWidth = strokeWidth;
  if (points.length === 0) {
    return;
  }
  ctx.beginPath();
  ctx.moveTo(xPosition + points[0].x, yPosition + points[0].y);
  for (let i = 1; i < points.length; i += 1) {
    const point = points[i];
    ctx.lineTo(xPosition + point.x, yPosition + point.y);
  }
  ctx.stroke();
  ctx.closePath();
};
const drawElement = (ctx, xPosition, yPosition, element, bounds, rotation, isHovered, isEditing, theme2) => {
  var _a;
  ctx.lineWidth = isHovered ? 1.5 : 1;
  ctx.fillStyle = "white";
  ctx.strokeStyle = isHovered ? theme2.colors.black : theme2.colors.charcoal;
  ctx.setLineDash([]);
  ctx.closePath();
  if (element.type === "line") {
    ctx.strokeStyle = isHovered ? theme2.colors.olive3 : theme2.colors.charcoal;
    drawLine(ctx, xPosition, yPosition, element.points);
    if (isHovered) {
      (_a = element.points) == null ? void 0 : _a.forEach((point) => {
        ctx.fillStyle = theme2.colors.olive3;
        drawCircle(ctx, xPosition + point.x, yPosition + point.y, 5);
        ctx.fill();
        ctx.fillStyle = "transparent";
      });
    }
  } else if (element.type === "text") {
    const text = element.text || "Start typing...";
    if (!isEditing) {
      drawText(ctx, text, xPosition, yPosition, element.width, element.height, element.rotation);
    }
  } else if (element.type === "rectangle") {
    const drawFunction = (xOrigin, yOrigin) => {
      drawRect(ctx, xOrigin, yOrigin, element.width, element.height, element.rotation);
      ctx.fill();
    };
    drawObject(
      ctx,
      xPosition,
      yPosition,
      element.width,
      element.height,
      element.rotation,
      drawFunction
    );
  } else if (element.type === "island") {
    const drawFunction = (xOrigin, yOrigin) => {
      const radius = Math.min(element.width, element.height / 2);
      const drawHeight = Math.min(element.height, radius * 2);
      drawRect(ctx, xOrigin, yOrigin, element.width - radius + 2, drawHeight, element.rotation);
      ctx.translate(xOrigin, yOrigin);
      ctx.rotate(270 * Math.PI / 180);
      drawArc(ctx, -radius, element.width - radius, radius);
      ctx.rotate(-270 * Math.PI / 180);
      ctx.translate(-xOrigin, -yOrigin);
      ctx.fillStyle = "white";
      ctx.fill();
      ctx.stroke();
    };
    drawObject(
      ctx,
      xPosition,
      yPosition,
      element.width,
      element.height,
      element.rotation,
      drawFunction
    );
  } else if (element.type === "circle") {
    const drawFunction = (xOrigin, yOrigin) => {
      drawEllipses(ctx, xOrigin, yOrigin, xOrigin + element.width, yOrigin + element.height);
      ctx.fill();
      ctx.stroke();
    };
    drawObject(
      ctx,
      xPosition,
      yPosition,
      element.width,
      element.height,
      element.rotation,
      drawFunction
    );
  } else {
    drawImage(
      ctx,
      getImage(element),
      xPosition,
      yPosition,
      element.width,
      element.height,
      element.rotation
    );
  }
};
const drawTable = (ctx, xPosition, yPosition, table, floorplanTable, bounds, theme2, drawBounds = false, strokeStyle = null, fillStyle = null) => {
  if (isEmpty(strokeStyle)) {
    strokeStyle = theme2.colors.charcoal;
  }
  if (isEmpty(fillStyle)) {
    fillStyle = theme2.colors.linen;
  }
  ctx.lineWidth = 1;
  ctx.strokeStyle = strokeStyle;
  ctx.setLineDash([]);
  ctx.closePath();
  if (floorplanTable.type === "rectangle" || floorplanTable.type === "long") {
    drawRectangleTable(
      ctx,
      xPosition,
      yPosition,
      floorplanTable.scale,
      floorplanTable.rotation,
      table.maxSeats,
      fillStyle
    );
  } else if (floorplanTable.type === "round") {
    drawRoundTable(
      ctx,
      xPosition,
      yPosition,
      floorplanTable.scale,
      floorplanTable.rotation,
      table.maxSeats,
      fillStyle
    );
  } else if (floorplanTable.type === "square") {
    drawSquareTable(
      ctx,
      xPosition,
      yPosition,
      floorplanTable.scale,
      floorplanTable.rotation,
      table.maxSeats,
      fillStyle
    );
  } else if (floorplanTable.type === "bar") {
    drawBarTable(
      ctx,
      xPosition,
      yPosition,
      floorplanTable.scale,
      floorplanTable.rotation,
      table.maxSeats,
      fillStyle
    );
  }
  if (drawBounds) {
    drawBoundingBox(ctx, bounds, theme2);
  }
};
const createPatternCanvas = (theme2, isOutdoor = false) => {
  let backgroundColor = "white";
  let lineColor = theme2.colors.cloud;
  if (isOutdoor) {
    backgroundColor = theme2.colors.outdoorAreaBackground;
    lineColor = theme2.colors.gray5;
  }
  const patternCanvas = document.createElement("canvas");
  const patternContext = patternCanvas.getContext("2d");
  const width = 25;
  const height = 25;
  patternCanvas.width = width;
  patternCanvas.height = height;
  patternContext.fillStyle = backgroundColor;
  patternContext.fillRect(0, 0, patternCanvas.width, patternCanvas.height);
  patternContext.moveTo(width, 0);
  patternContext.lineTo(width, height);
  patternContext.moveTo(0, height);
  patternContext.lineTo(width, height);
  patternContext.strokeStyle = lineColor;
  patternContext.stroke();
  return patternCanvas;
};
const getBoundsOfShape = (points = [], originX = 0, originY = 0) => {
  let minX = 999;
  let minY = 999;
  let maxX = 0;
  let maxY = 0;
  points.forEach((point) => {
    if ((point == null ? void 0 : point.x) < minX) {
      minX = point.x;
    }
    if ((point == null ? void 0 : point.y) < minY) {
      minY = point.y;
    }
    if ((point == null ? void 0 : point.x) > maxX) {
      maxX = point.x;
    }
    if ((point == null ? void 0 : point.y) > maxY) {
      maxY = point.y;
    }
  });
  return { x: minX, y: minY, width: maxX, height: maxY, originX, originY };
};
const getBoundsOfElement = (element, areaBoundingBox) => {
  const idealX = areaBoundingBox.originX + element.x;
  const idealY = areaBoundingBox.originY + element.y;
  const elementWidth = element.width;
  const elementHeight = element.height;
  const points = [
    { x: idealX, y: idealY },
    // top left
    { x: idealX + elementWidth, y: idealY },
    // top right
    { x: idealX, y: idealY + elementHeight },
    // bottom left
    { x: idealX + elementWidth, y: idealY + elementHeight }
    // bottom right
  ];
  const originPoint = { x: idealX, y: idealY };
  const centerPoint = {
    x: idealX + elementWidth / 2,
    y: idealY + elementHeight / 2
  };
  const squaredDistanceToOrigin = lengthSquared(centerPoint, originPoint);
  const rotatedPoints = points.map((point) => {
    const angleToOrigin = angleBetweenPoints(centerPoint, point);
    const angleWithRotation = angleToOrigin + element.rotation;
    return {
      x: Math.cos(angleWithRotation * Math.PI / 180) * Math.sqrt(squaredDistanceToOrigin) + idealX,
      y: Math.sin(angleWithRotation * Math.PI / 180) * Math.sqrt(squaredDistanceToOrigin) + idealY
    };
  });
  let minX = null;
  let minY = null;
  let maxX = null;
  let maxY = null;
  rotatedPoints.forEach((point) => {
    if (minX === null || point.x < minX) {
      minX = point.x;
    }
    if (maxX === null || point.x > maxX) {
      maxX = point.x;
    }
    if (minY === null || point.y < minY) {
      minY = point.y;
    }
    if (maxY === null || point.y > maxY) {
      maxY = point.y;
    }
  });
  return {
    x: minX + elementWidth / 2,
    y: minY + elementHeight / 2,
    width: maxX - minX,
    height: maxY - minY,
    originX: areaBoundingBox.originX + element.x,
    originY: areaBoundingBox.originY + element.y,
    topLeftX: minX + elementWidth / 2 + 10,
    // I don't know where the plus 10 is coming from
    topLeftY: minY + elementHeight / 2 + 10,
    points: rotatedPoints
  };
};
const getBoundsOfTable = (floorplanTable, maxSeats, areaBoundingBox) => {
  let tableWidth = 50;
  let tableHeight = 50;
  const chairDepth = 7;
  const border = 2;
  const areaBounds = {
    x: (areaBoundingBox == null ? void 0 : areaBoundingBox.originX) || 0,
    y: (areaBoundingBox == null ? void 0 : areaBoundingBox.originY) || 0
  };
  let tableIdealX = areaBounds.x + floorplanTable.x;
  let tableIdealY = areaBounds.y + floorplanTable.y;
  if (floorplanTable.type === "rectangle" || floorplanTable.type === "long") {
    tableIdealX += border;
    tableIdealY += chairDepth + border;
    tableWidth = rectangleTableWidth * floorplanTable.scale + chairDepth * 2 + border;
    const seatsPerSide = Math.max(1, Math.ceil(maxSeats / 2));
    tableHeight = (seatsPerSide * chairImageLength + 2 * rectangleChairGap + (seatsPerSide - 1) * rectangleChairGap) * floorplanTable.scale + border;
  } else if (floorplanTable.type === "round") {
    tableIdealX -= roundTableWidth * floorplanTable.scale + chairDepth - border;
    tableIdealY -= roundTableWidth * floorplanTable.scale + chairDepth - border;
    tableWidth = roundTableWidth * floorplanTable.scale + chairDepth * 2;
    tableHeight = roundTableWidth * floorplanTable.scale + chairDepth * 2;
  } else if (floorplanTable.type === "square") {
    tableIdealX += border;
    tableIdealY += border;
    const seatsPerSide = Math.max(1, Math.ceil(maxSeats / 4));
    tableWidth = (seatsPerSide * chairImageLength + 2 * squareTableEdgeGap + (seatsPerSide - 1) * squareChairGap) * floorplanTable.scale + chairDepth * 2 + border;
    tableHeight = tableWidth;
  } else if (floorplanTable.type === "bar") {
    tableIdealX += border;
    tableIdealY += 10;
    tableWidth = floorplanTable.scale * barTableWidth + chairDepth * 2 + border;
    tableHeight = (maxSeats * chairImageLength + (maxSeats + 1) * rectangleChairGap) * floorplanTable.scale;
  }
  const points = [
    { x: tableIdealX, y: tableIdealY },
    { x: tableIdealX + tableWidth, y: tableIdealY },
    { x: tableIdealX, y: tableIdealY + tableHeight },
    { x: tableIdealX + tableWidth, y: tableIdealY + tableHeight }
  ];
  let centerPoint = {
    x: tableIdealX + tableWidth / 2,
    y: tableIdealY + tableHeight / 2
  };
  const squaredDistanceToOrigin = squareNumbers(tableWidth / 2, tableHeight / 2);
  let rotatedPoints = [
    { x: tableIdealX, y: tableIdealY },
    { x: tableIdealX + tableWidth, y: tableIdealY },
    { x: tableIdealX, y: tableIdealY + tableHeight },
    { x: tableIdealX + tableWidth, y: tableIdealY + tableHeight }
  ];
  if (floorplanTable.type !== "round") {
    rotatedPoints = points.map((point) => {
      const angleToOrigin = angleBetweenPoints(centerPoint, point);
      const angleWithRotation = angleToOrigin + floorplanTable.rotation;
      return {
        x: Math.cos(angleWithRotation * Math.PI / 180) * Math.sqrt(squaredDistanceToOrigin) + tableIdealX,
        y: Math.sin(angleWithRotation * Math.PI / 180) * Math.sqrt(squaredDistanceToOrigin) + tableIdealY
      };
    });
  }
  let minX = null;
  let minY = null;
  let maxX = null;
  let maxY = null;
  rotatedPoints.forEach((point) => {
    if (minX === null || point.x < minX) {
      minX = point.x;
    }
    if (maxX === null || point.x > maxX) {
      maxX = point.x;
    }
    if (minY === null || point.y < minY) {
      minY = point.y;
    }
    if (maxY === null || point.y > maxY) {
      maxY = point.y;
    }
  });
  const boundsWidth = maxX - minX;
  const boundsHeight = maxY - minY;
  let actualTop = floorplanTable.y + areaBounds.y;
  let actualLeft = floorplanTable.x + areaBounds.x;
  let yDistanceFromTop = 0;
  let xDistanceFromLeft = 0;
  if (floorplanTable.type === "round") {
    actualTop -= boundsHeight / 2;
    actualLeft -= boundsWidth / 2;
    centerPoint = { x: floorplanTable.x - boundsWidth / 2, y: floorplanTable.y - boundsHeight / 2 };
    yDistanceFromTop = boundsHeight / 2;
    xDistanceFromLeft = boundsWidth / 2;
  }
  const actualBottom = actualTop + boundsHeight;
  const actualRight = actualLeft + boundsWidth;
  return {
    x: minX + tableWidth / 2,
    y: minY + tableHeight / 2,
    minX,
    minY,
    defaultWidth: boundsWidth / floorplanTable.scale,
    defaultHeight: boundsHeight / floorplanTable.scale,
    width: boundsWidth,
    height: boundsHeight,
    originX: areaBounds.x + floorplanTable.x,
    originY: areaBounds.y + floorplanTable.y,
    topLeftX: minX + tableWidth / 2,
    topLeftY: minY + tableHeight / 2,
    points: rotatedPoints,
    right: maxX + tableWidth / 2,
    // The right edge, hopefully. Used to draw box
    bottom: maxY + tableHeight / 2,
    // The bottom edge, hopefully. Used to draw box
    actualTop,
    // used for alignment
    actualBottom,
    // used for alignment
    actualLeft,
    // used for alignment
    actualRight,
    // used for alignment
    centerPoint,
    // The point in the direct center
    yDistanceFromTop,
    xDistanceFromLeft
  };
};
const getFloorplanTableFromId = (floorplanTables, id) => {
  if (isEmpty(floorplanTables)) {
    return null;
  }
  const floorplanTable = findObjectByProperty(floorplanTables, id, "id");
  if (floorplanTable) {
    return floorplanTable;
  }
  return findObjectByProperty(floorplanTables, id, "originalId", {});
};
const getFloorplanTableFromTableData = (floorplanTables, tableData) => {
  const tableFromId = getFloorplanTableFromId(floorplanTables, tableData == null ? void 0 : tableData.id);
  if (tableFromId) {
    return tableFromId;
  }
  return getFloorplanTableFromId(floorplanTables, tableData == null ? void 0 : tableData._tempId);
};
const getTableDataFromId = (floorplanTableId, tables) => {
  if (isEmpty(tables) || isEmpty(floorplanTableId)) {
    return null;
  }
  return findObjectByProperty(tables, floorplanTableId, "id");
};
const getAllTableData = (tableId, floorplanTables, tables) => {
  const floorplanTable = getFloorplanTableFromId(floorplanTables, tableId);
  return {
    floorplanTable,
    tableData: getTableDataFromId((floorplanTable == null ? void 0 : floorplanTable.id) || tableId, tables)
  };
};
const getFloorplanAreaFromAreaData = (floorplanAreas, areaData) => {
  if (isEmpty(floorplanAreas)) {
    return null;
  }
  const floorplanArea = findObjectByProperty(floorplanAreas, areaData == null ? void 0 : areaData.id, "id");
  if (floorplanArea) {
    return floorplanArea;
  }
  const newlyCreatedArea = findObjectByProperty(
    floorplanAreas,
    areaData == null ? void 0 : areaData._tempId,
    "originalId",
    {}
  );
  return newlyCreatedArea;
};
const getFloorplanAreaFromId = (floorplanAreas, id) => {
  if (isEmpty(floorplanAreas)) {
    return null;
  }
  const floorplanArea = findObjectByProperty(floorplanAreas, id, "id");
  if (floorplanArea) {
    return floorplanArea;
  }
  const newlyCreatedArea = findObjectByProperty(floorplanAreas, id, "originalId", {});
  return newlyCreatedArea;
};
const getAreaDataFromFloorplanArea = (floorplanArea, areas) => {
  if (isEmpty(areas)) {
    return null;
  }
  const area = findObjectByProperty(areas, floorplanArea == null ? void 0 : floorplanArea.id, "id");
  if (area) {
    return area;
  }
  const newArea = findObjectByProperty(areas, floorplanArea == null ? void 0 : floorplanArea.originalId, "id", {});
  return newArea;
};
const getAreaForPoint = (point, floorplanAreas, canvasMargin) => {
  if (point.x < 0 || point.y < 0) {
    return null;
  }
  function pointIsInPoly(points, testX, testY) {
    if (points.length < 3) {
      return false;
    }
    let isInside = false;
    let minX = points[0].x;
    let maxX = points[0].x;
    let minY = points[0].y;
    let maxY = points[0].y;
    for (let n = 1; n < points.length; n += 1) {
      const q = points[n];
      minX = Math.min(q.x, minX);
      maxX = Math.max(q.x, maxX);
      minY = Math.min(q.y, minY);
      maxY = Math.max(q.y, maxY);
    }
    if (testX < minX || testX > maxX || testY < minY || testY > maxY) {
      return false;
    }
    let i = 0;
    let j = points.length - 1;
    for (j; i < points.length - 1; i += 1) {
      if (i !== 0) {
        j = i + 1;
      }
      if (points[i].y > testY !== points[j].y > testY && testX < (points[j].x - points[i].x) * (testY - points[i].y) / (points[j].y - points[i].y) + points[i].x) {
        isInside = !isInside;
      }
    }
    return isInside;
  }
  const paddingFix = 5;
  const boundsContainingPointer = floorplanAreas.filter((floorplanArea) => {
    const boundingBox = (floorplanArea == null ? void 0 : floorplanArea.bounds) || getBoundsOfShape(floorplanArea == null ? void 0 : floorplanArea.points, floorplanArea.x, floorplanArea.y);
    return !(point.x < (floorplanArea == null ? void 0 : floorplanArea.x) + boundingBox.x + canvasMargin + paddingFix || point.y < floorplanArea.y + boundingBox.y + canvasMargin + paddingFix || point.x > (floorplanArea == null ? void 0 : floorplanArea.x) + boundingBox.width + canvasMargin + paddingFix || point.y > (floorplanArea == null ? void 0 : floorplanArea.y) + boundingBox.height + canvasMargin + paddingFix);
  });
  if (boundsContainingPointer.length === 0) {
    return null;
  }
  const areaForPointer = boundsContainingPointer.findLast((floorplanArea) => {
    return pointIsInPoly(
      floorplanArea == null ? void 0 : floorplanArea.points,
      point.x - ((floorplanArea == null ? void 0 : floorplanArea.x) + canvasMargin + paddingFix),
      point.y - ((floorplanArea == null ? void 0 : floorplanArea.y) + canvasMargin + paddingFix)
    );
  });
  return areaForPointer;
};
const getTableForPoint = (point, floorplanTables, tables, canvasMargin, areaBounds, tablePaddingTop = 0, tablePaddingRight = 0, tablePaddingBottom = 0, tablePaddingLeft = 0, currentlyHoveredTableId = null) => {
  const paddingFix = 5;
  const boundsContainingPointer = tables.filter((tableData) => {
    const floorplanTable = getFloorplanTableFromTableData(floorplanTables, tableData);
    if (isEmpty(floorplanTable)) {
      return null;
    }
    const boundingBox = (floorplanTable == null ? void 0 : floorplanTable.bounds) || getBoundsOfTable(floorplanTable, tableData.maxSeats, areaBounds);
    return !(point.x + paddingFix < boundingBox.x - tablePaddingLeft || point.y + paddingFix < boundingBox.y - tablePaddingTop || point.x + paddingFix > boundingBox.x + tablePaddingRight + boundingBox.width || point.y + paddingFix > boundingBox.y + tablePaddingBottom + boundingBox.height);
  });
  if (boundsContainingPointer.length === 0) {
    return null;
  }
  const currentlyHovered = boundsContainingPointer.find(
    (table) => table.id === currentlyHoveredTableId
  );
  if (currentlyHovered) {
    return currentlyHovered;
  }
  return boundsContainingPointer[boundsContainingPointer.length - 1];
};
const getBoundsForArea = (floorplanArea) => {
  const bounds = getBoundsOfShape(floorplanArea.points, floorplanArea.x, floorplanArea.y);
  return bounds;
};
const getBoundsForTable = (floorplanTable, tables, floorplanAreas) => {
  const table = getTableDataFromId(floorplanTable == null ? void 0 : floorplanTable.id, tables);
  const floorplanArea = getFloorplanAreaFromId(floorplanAreas, table == null ? void 0 : table.areaId);
  if (isEmpty(floorplanArea)) {
    console.warn(`No floor plan area found for table ${table == null ? void 0 : table.tableNumber}`, floorplanTable);
    return null;
  }
  const bounds = getBoundsOfTable(floorplanTable, table == null ? void 0 : table.maxSeats, floorplanArea == null ? void 0 : floorplanArea.bounds);
  return bounds;
};
const formatTimeIfInt = (dateString) => {
  if (Number.isNaN(dateString)) {
    return dateString;
  }
  return formatTimeFromInt(dateString);
};
const getFloorplanData = (floorplan, areas, tables) => {
  var _a, _b2, _c2, _d2, _e2, _f;
  const processedFloorplanAreas = (_b2 = (_a = areas == null ? void 0 : areas.data) == null ? void 0 : _a.filter((area) => !isEmpty(area == null ? void 0 : area.id) || !isEmpty(area == null ? void 0 : area._tempId))) == null ? void 0 : _b2.map((area, index) => {
    var _a2, _b3;
    let areaInFloorplan = findObjectByProperty((_a2 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a2.areas, area == null ? void 0 : area.id, "id");
    const areaDefaultHeight = 400;
    const areaDefaultGap = 20;
    if (isEmpty(areaInFloorplan)) {
      areaInFloorplan = {
        ...getDefaultAreaValues(index * (areaDefaultHeight + areaDefaultGap)),
        ...getFloorplanAreaFromAreaData((_b3 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _b3.areas, area),
        id: area == null ? void 0 : area.id
      };
    }
    areaInFloorplan = {
      ...areaInFloorplan,
      bounds: getBoundsForArea(areaInFloorplan),
      // TODO replace with more accurate detection for complex shapes
      name: area.name
    };
    return areaInFloorplan;
  }).filter((area) => area.bounds !== null);
  const floorplanTables = (_d2 = (_c2 = tables == null ? void 0 : tables.data) == null ? void 0 : _c2.filter((table) => !isEmpty(table == null ? void 0 : table.id) || !isEmpty(table == null ? void 0 : table._tempId))) == null ? void 0 : _d2.filter((table) => !table.isJoin);
  const widthForDefault = 120;
  const heightForDefault = 120;
  let processedFloorplanTables = [];
  const defaultTablesPerRow = 8;
  groupByProperty(floorplanTables, "areaId").map(
    (areaTables) => areaTables.items.map((table, index) => {
      var _a2;
      return {
        // Defaults if the table has no data
        type: "rectangle",
        rotation: 0,
        scale: 1,
        x: index % defaultTablesPerRow * widthForDefault + 20,
        // Place them horizontally
        y: Math.floor(index / defaultTablesPerRow) * heightForDefault + 40,
        // Table data gets added here
        ...getFloorplanTableFromTableData((_a2 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a2.tables, table),
        id: table == null ? void 0 : table.id
        // Always override temporary ID with real ID from data
      };
    }).map((floorplanTable) => {
      return {
        ...floorplanTable,
        bounds: getBoundsForTable(floorplanTable, tables.data, processedFloorplanAreas)
      };
    }).filter((floorplanTable) => floorplanTable.bounds !== null).forEach((table) => {
      processedFloorplanTables = [...processedFloorplanTables, table];
    })
  );
  const processedElements = (((_e2 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _e2.elements) || []).map((element) => {
    const areaForElement = findObjectByProperty(processedFloorplanAreas, element == null ? void 0 : element.areaId, "id");
    if (isEmpty(areaForElement)) {
      console.warn("No area for element", element);
      return null;
    }
    return {
      ...element,
      bounds: getBoundsOfElement(element, areaForElement == null ? void 0 : areaForElement.bounds)
    };
  }).filter((element) => element === null || element.bounds !== null);
  return {
    ...floorplan == null ? void 0 : floorplan.data,
    elements: processedElements,
    levels: ((_f = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _f.levels) || [],
    areas: processedFloorplanAreas,
    tables: processedFloorplanTables
  };
};
const getBookingColours = (theme2, booking) => {
  if (booking == null ? void 0 : booking.isLate) {
    return {
      outline: theme2.colors.noShowTableOutline,
      fill: theme2.colors.noShowTableFill
    };
  }
  const statusData = getStatus(booking);
  return {
    outline: (statusData == null ? void 0 : statusData.tableOutline) || theme2.colors.shark,
    fill: (statusData == null ? void 0 : statusData.tableFill) || theme2.colors.charcoal
  };
};
const getBookingToShowOnTable = (bookingsForTable, currentTimeAsInt = null) => {
  var _a, _b2;
  const activeBooking = findObjectByProperty(bookingsForTable, STATUS_TYPES.ARRIVED, "status");
  if (!isEmpty(activeBooking)) {
    return activeBooking;
  }
  const lateBookings = (_a = filterByProperty(
    bookingsForTable,
    [STATUS_TYPES.CONFIRMED, STATUS_TYPES.BOOKED],
    "status"
  )) == null ? void 0 : _a.filter((booking) => booking.startTime < currentTimeAsInt);
  if (!isEmpty(lateBookings)) {
    return lateBookings[lateBookings.length - 1];
  }
  const futureBooking = (_b2 = bookingsForTable.filter((booking) => {
    return showInFloorplan(booking) && booking.startTime >= currentTimeAsInt;
  })) == null ? void 0 : _b2[0];
  return futureBooking;
};
const getAvailabilityColours = ({
  showBookingDragOutline,
  draggedOffTable,
  theme: theme2,
  block,
  fullyBooked,
  latestBooking,
  areaIsInSession
}) => {
  if (showBookingDragOutline) {
    return { outline: "black", fill: "white" };
  }
  if (draggedOffTable) {
    return {
      outline: theme2.colors.bookedTableOutline,
      fill: theme2.colors.bookedTableFill
    };
  }
  if (!isEmpty(block)) {
    return {
      outline: theme2.colors.blockedTableOutline,
      fill: theme2.colors.blockedTableFill
    };
  }
  if (latestBooking == null ? void 0 : latestBooking.isLate) {
    return {
      outline: theme2.colors.lateTableOutline,
      fill: theme2.colors.lateTableFill
    };
  }
  const statusData = getStatus(latestBooking);
  return {
    outline: (statusData == null ? void 0 : statusData.tableOutline) || theme2.colors.availableTableOutline,
    fill: (statusData == null ? void 0 : statusData.tableFill) || theme2.colors.availableTableFill
  };
};
const useStyles$W = createUseStyles((theme2) => ({
  container: (props) => {
    var _a, _b2;
    return {
      position: "relative",
      display: "flex",
      backgroundColor: theme2.colors.white,
      fontSize: "15px",
      color: theme2.colors.charcoal,
      height: "36px",
      lineHeight: "36px",
      borderRadius: "6px",
      // display: 'flex',
      flexGrow: 0,
      padding: "0 8px",
      // gap: '14px',
      justifyContent: "space-between",
      alignItems: "center",
      border: `1px solid ${(_a = getBookingColours(theme2, props == null ? void 0 : props.booking)) == null ? void 0 : _a.outline}`,
      borderLeft: `8px solid ${(_b2 = getBookingColours(theme2, props == null ? void 0 : props.booking)) == null ? void 0 : _b2.outline}`,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      userSelect: "none",
      gap: "4px",
      zIndex: (props == null ? void 0 : props.dragging) ? 1e3 : 1,
      boxShadow: (props == null ? void 0 : props.dragging) ? "0px 4px 4px rgba(107, 107, 107, 0.25)" : "none",
      transition: "box-shadow 0.25s",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme2.colors.linen
      }
    };
  },
  row: {
    display: "flex",
    gap: "4px",
    alignItems: "center"
  },
  iconContainer: {
    position: "relative"
    // Since icon will be absolute
  },
  icon: {
    position: "absolute"
    // Makes it fill container, without placing it in wrong spot
  }
}));
const LargeReservationTime = ({ booking, dragging }) => {
  const classes = useStyles$W({ booking, dragging });
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, formatTimeFromInt(booking == null ? void 0 : booking.startTime, "h:mma"), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.row}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.iconContainer, style: { width: "10px", height: "13px" } }, /* @__PURE__ */ React__default.createElement(GuestSVG, { className: classes.icon, style: { width: "10px", height: "13px" } })), /* @__PURE__ */ React__default.createElement(Box, null, booking == null ? void 0 : booking.size), /* @__PURE__ */ React__default.createElement(Box, { className: classes.iconContainer, style: { width: "16px", height: "16px" } }, (booking == null ? void 0 : booking.status) === STATUS_TYPES.CONFIRMED && !booking.isLate && /* @__PURE__ */ React__default.createElement(
    ConfirmedCheckIcon,
    {
      className: classes.icon,
      style: { width: "16px", height: "16px" }
    }
  ))));
};
LargeReservationTime.propTypes = {
  booking: obeeBookingPropTypes.isRequired,
  dragging: PropTypes.bool.isRequired
};
const mapStateToProps$1L = () => ({});
const mapDispatchToProps$1K = (dispatch) => bindActionCreators({}, dispatch);
const LargeReservationTime$1 = connect(mapStateToProps$1L, mapDispatchToProps$1K)(LargeReservationTime);
const useStyles$V = createUseStyles({
  container: {
    position: "relative",
    overflow: "visible"
  },
  popoverInner: {
    padding: "12px"
  },
  closeButton: {
    position: "absolute",
    top: "0",
    display: "flex",
    alignItems: "center",
    flex: 1
  },
  bookingsListContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  booking: {}
});
const popoverStyles$4 = (theme2) => ({
  popover: {
    padding: "10px",
    borderRadius: "8px",
    marginLeft: "20px",
    border: `1px solid ${theme2.colors.cloud}`
  },
  item: {
    fontSize: "16px",
    color: theme2.colors.grayLight,
    padding: "10px",
    height: "auto"
  }
});
const editButtonStyles = (theme2) => ({
  height: "36px",
  maxHeight: "36px",
  width: "100%",
  button: {
    padding: "0 8px",
    outline: `1px solid ${theme2.colors.gray6}`,
    borderRadius: "6px",
    alignItems: "center",
    height: "36px"
  }
});
const popoverWhenBookingDragged = {
  transition: "all 1s",
  boxShadow: "none",
  backgroundColor: "transparent",
  overflowY: "visible",
  overflowX: "visible"
};
const TableBookingsPopover = ({
  isOpen,
  onClose,
  anchor,
  bookings,
  onStartDraggingBooking,
  onStopDraggingBooking,
  onDragBooking,
  setSelectedBooking,
  dragRef,
  draggedTableBooking,
  onStopPressing,
  setObeeShowAddBookingModal,
  setObeeBookingDetailsModal
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$V();
  const containerRef = useRef(null);
  const hasDragged = !isEmpty(draggedTableBooking);
  const showBookingDetails = (bookingId, tab = "booking") => {
    setObeeShowAddBookingModal(false);
    setObeeBookingDetailsModal(bookingId, tab);
    onClose();
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container, ref: containerRef }, /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      isOpen,
      onClose,
      anchorEl: anchor,
      style: popoverStyles$4(theme2),
      innerStyle: {
        // To override default app styles
        fontSize: "0.938rem",
        // 15px
        letterSpacing: "0.01071em",
        lineHeight: 1.5,
        fontWeight: 400,
        padding: 0,
        marginTop: "-50px",
        borderRadius: "6px",
        boxShadow: "0px 4px 8px rgba(151, 151, 151, 0.25))",
        overflowY: "overlay",
        // TODO use overlay function
        overflowX: "hidden",
        ...hasDragged ? popoverWhenBookingDragged : {}
      },
      innerProps: {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        }
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.popoverInner }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingsListContainer }, bookings.map((booking, index) => {
      const dragging = !isEmpty(draggedTableBooking == null ? void 0 : draggedTableBooking.id) && (draggedTableBooking == null ? void 0 : draggedTableBooking.id) === (booking == null ? void 0 : booking.id);
      const canDrag = isEmpty(draggedTableBooking == null ? void 0 : draggedTableBooking.id) || (draggedTableBooking == null ? void 0 : draggedTableBooking.id) === (booking == null ? void 0 : booking.id);
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: booking.id,
          style: {
            display: "flex",
            justifyContent: "space-between",
            gap: "4px"
          }
        },
        /* @__PURE__ */ React__default.createElement(
          TouchDraggable$1,
          {
            position: { x: 0, y: 0 },
            onStart: () => {
              const popoverOffset = 65;
              const itemHeight = 40;
              onStartDraggingBooking(booking, {
                y: popoverOffset + itemHeight * index
              });
            },
            onStop: onStopDraggingBooking,
            onStopPressing,
            onDrag: onDragBooking,
            onClick: () => setSelectedBooking(booking),
            holdTime: 200,
            disabled: !canDrag
          },
          /* @__PURE__ */ React__default.createElement(
            Box,
            {
              ref: (element) => {
                if (!element || !dragRef) {
                  return;
                }
                dragRef.current = element.getBoundingClientRect();
              },
              style: {
                transition: "opacity 1s",
                opacity: (draggedTableBooking == null ? void 0 : draggedTableBooking.id) && !dragging ? 0 : 1,
                width: "100%"
              }
            },
            /* @__PURE__ */ React__default.createElement(LargeReservationTime$1, { booking, dragging })
          )
        ),
        /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
          SquareButton,
          {
            style: {
              ...editButtonStyles(theme2),
              opacity: hasDragged ? 0 : 1,
              transition: "opacity 1s"
            },
            onClick: () => showBookingDetails(booking.id)
          },
          /* @__PURE__ */ React__default.createElement(EditSVG, { style: { width: "15px" } })
        ))
      );
    })))
  ));
};
TableBookingsPopover.defaultProps = {
  bookings: [],
  anchor: null,
  dragRef: null,
  draggedTableBooking: null
};
TableBookingsPopover.propTypes = {
  bookings: PropTypes.arrayOf(obeeBookingPropTypes),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onStartDraggingBooking: PropTypes.func.isRequired,
  onStopDraggingBooking: PropTypes.func.isRequired,
  onDragBooking: PropTypes.func.isRequired,
  setSelectedBooking: PropTypes.func.isRequired,
  onStopPressing: PropTypes.func.isRequired,
  dragRef: PropTypes.shape({ current: PropTypes.shape({}) }),
  draggedTableBooking: obeeBookingPropTypes,
  anchor: PropTypes.shape({}),
  setObeeShowAddBookingModal: PropTypes.func.isRequired,
  setObeeBookingDetailsModal: PropTypes.func.isRequired
};
const mapStateToProps$1K = () => ({});
const mapDispatchToProps$1J = (dispatch) => bindActionCreators(
  {
    setObeeShowAddBookingModal: setObeeShowAddBookingModalAction,
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction
  },
  dispatch
);
const TableBookingsPopover$1 = connect(mapStateToProps$1K, mapDispatchToProps$1J)(TableBookingsPopover);
const useStyles$U = createUseStyles(
  (theme2) => ({
    container: {
      backgroundColor: theme2.colors.pageBackground,
      // maxHeight: `calc(100vh - 200px)`,
      fontSize: "16px",
      overscrollBehavior: "none",
      "@media print": {
        height: "fit-content",
        width: "fit-content",
        overflow: "visible !important",
        // pageOrientation: 'rotate-left',
        backgroundColor: theme2.colors.white
        // breakInside: 'avoid',
      }
    },
    pageContent: {
      display: "flex",
      width: `100%`,
      height: `calc(100dvh - ${headerHeight$4}px)`,
      overflow: "hidden",
      [`@media (max-width: ${mobileHeaderBreakpoint}px)`]: {
        height: `calc(100dvh - ${mobileHeaderHeight}px)`
      },
      "@media print": {
        height: "fit-content",
        width: "fit-content",
        overflow: "visible !important"
      }
    },
    hiddenFromPrint: {
      ...theme2.utilities.noPrint
    },
    canvasWrapper: {
      position: "relative",
      marginTop: "0",
      marginLeft: "0",
      width: "100%",
      // height: `calc(100dvh - ${headerHeight}px)`,
      overflow: "hidden",
      borderRadius: "30px 0 0 0",
      backgroundColor: theme2.colors.canvasBackground,
      "@media print": {
        height: "fit-content",
        width: "fit-content",
        borderRadius: 0,
        overflow: "visible !important",
        backgroundColor: theme2.colors.white
      }
    },
    canvasContainerOuter: {
      position: "relative",
      marginTop: "0",
      borderRadius: "30px 0 0 0",
      borderTop: `6px solid ${theme2.colors.canvasBorder}`,
      borderLeft: `6px solid ${theme2.colors.canvasBorder}`,
      boxShadow: "inset 0px 6px 5px rgba(105, 105, 105, 0.05)",
      // width: '100%',
      // height: `calc(100vh - ${headerHeight}px)`,
      backgroundColor: theme2.colors.canvasBackground,
      overflow: "hidden",
      // overflow: theme.overlay,
      width: "100%",
      height: "100%",
      "@media print": {
        border: `1px solid ${theme2.colors.cloud}`,
        borderRadius: "16px",
        boxShadow: "none",
        overflow: "visible !important",
        backgroundColor: theme2.colors.white
      }
    },
    canvasContainer: {
      border: `2px solid ${theme2.colors.canvasBorder}`,
      borderRadius: "25px",
      "@media print": {
        border: "none",
        borderRadius: 0,
        overflow: "hidden"
      }
    },
    canvas: {
      minWidth: "100px",
      minHeight: "100px",
      padding: "5px"
    },
    tableActionButton: {
      position: "absolute",
      // top: -30,
      top: -10,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "47px",
      width: "25px",
      zIndex: 99,
      background: theme2.colors.white,
      borderRadius: "6px",
      border: "1px solid #E4E4E4",
      boxShadow: "0px 4px 4px rgba(176, 176, 176, 0.25)",
      "&:hover": {
        cursor: "pointer"
      }
    },
    actionIcon: {
      // width: '37px',
      height: "15px",
      color: theme2.colors.labelText,
      transform: "rotate(90deg)"
    },
    tableLabelContainer: {
      position: "absolute",
      color: theme2.colors.black,
      fontSize: "14px",
      lineHeight: "14px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      padding: "8px",
      // justifyContent: 'center',
      gap: "5px",
      marginTop: "-5px",
      marginLeft: "-5px",
      // height: '100%',
      alignItems: "center",
      // userSelect: 'none',
      textAlign: "center",
      // background: 'rgba(1,0,0,0.2)', // For debugging
      "&:hover": {
        // zIndex: 10,
      }
    },
    tableLabel: (props) => ({
      userSelect: "none",
      fontSize: "12px",
      lineHeight: "12px",
      fontWeight: theme2.fontWeights.medium,
      position: "relative",
      backgroundColor: props == null ? void 0 : props.fill
    }),
    row: {
      display: "flex",
      flexDirection: "row",
      gap: "5px"
    },
    availableText: {
      color: theme2.colors.availableLabelText,
      backgroundColor: theme2.colors.availableLabelBackground,
      fontWeight: theme2.fontWeights.medium,
      alignItems: "center",
      userSelect: "none"
    },
    availableTextLabel: {
      backgroundColor: theme2.colors.availableLabelBackground,
      padding: "2px",
      borderRadius: "4px"
    },
    multiTableContainer: {
      height: "45px",
      // To keep it aligned with single table
      overflow: "visible"
    },
    tableTimesContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "3px",
      alignItems: "center"
    },
    tableDetailsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: "5px",
      gap: "8px",
      textDecoration: "line-through",
      color: theme2.colors.labelText
    },
    additionalDetailsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "5px",
      marginTop: "-2px",
      fontSize: "12px",
      userSelect: "none",
      backgroundColor: (props) => props == null ? void 0 : props.fill,
      borderRadius: "6px",
      width: "fit-content",
      padding: "2px"
    },
    bookingDetailsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
      padding: "20px",
      marginTop: "-15px",
      marginLeft: "0px",
      marginBottom: "-20px",
      boxSizing: "border-box",
      zIndex: 1,
      borderRadius: "6px",
      transition: "background-color 0.1s, color 0.1s, box-shadow 0.1s",
      cursor: "default",
      touchEvents: "none",
      userSelect: "none",
      pointerEvents: "none"
    },
    additionalTableTime: {
      backgroundColor: theme2.colors.white,
      fontSize: "13px",
      lineHeight: "20px",
      height: "20px",
      borderRadius: "6px",
      padding: "0 10px",
      fontWeight: theme2.fontWeights.medium,
      boxShadow: "0px 4px 4px rgba(107, 107, 107, 0.25)"
    },
    floatingButton: {
      backgroundColor: "white",
      borderRadius: "20px",
      boxShadow: "0px 4px 4px rgba(107, 107, 107, 0.25)",
      padding: "6px 5px",
      color: theme2.colors.buttonText,
      width: "16px",
      height: "16px",
      display: "flex",
      justifyContent: "center",
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "2px",
      "&:hover": {
        backgroundColor: theme2.colors.linen
      }
    },
    noShowTime: {
      backgroundColor: theme2.colors.rose,
      borderRadius: "4px",
      height: "21px",
      lineHeight: "21px",
      flexGrow: 0,
      padding: "0 8px"
    },
    tableStatusContainer: {
      position: "absolute",
      top: "-4px",
      right: "8px"
    },
    absoluteAnchor: {
      // This looks weird, but it's a way to get an absolutely positioned anchored nicely
      width: 0,
      position: "relative"
    },
    statusIcons: {
      position: "absolute",
      left: "0",
      display: "inline-flex",
      alignItems: "center",
      gap: "4px"
    },
    scrollRefBox: {
      position: "absolute",
      top: -100,
      // Otherwise it gets cut off at the top when scrolling
      pointerEvents: "none"
      // backgroundColor: 'orange',
    },
    tablePrivateLabelContainer: {
      marginTop: "-80px",
      position: "absolute"
    },
    areaLabelsContainer: {
      position: "absolute",
      whiteSpace: "nowrap",
      display: "flex",
      gap: "8px",
      pointerEvents: "auto"
    },
    areaLabel: {
      boxShadow: "0px 4px 4px rgba(151, 151, 151, 0.25)",
      fontSize: "12px",
      fontWeight: theme2.fontWeights.medium,
      padding: "4px 8px",
      cursor: "pointer",
      userSelect: "none",
      pointerEvents: "auto"
    },
    fullyBookedAreaLabel: {
      alignItems: "center",
      backgroundColor: theme2.colors.infoBlueLight,
      boxShadow: "0px 4px 4px rgba(151, 151, 151, 0.25)",
      display: "flex",
      fontWeight: theme2.fontWeights.medium,
      gap: "8px",
      padding: "4px 8px"
    },
    singleTableDetailsContainer: {},
    zoomToolbar: {
      position: "absolute",
      bottom: "20px",
      right: "20px",
      zIndex: 10,
      ...theme2.utilities.noPrint
    }
  }),
  { name: "ViewFloorplan" }
);
const popoverStyles$3 = (theme2) => ({
  popover: {
    marginTop: "10px",
    padding: "10px",
    borderRadius: "8px",
    marginLeft: "20px"
  },
  item: {
    fontSize: "16px",
    color: theme2.colors.grayLight,
    padding: "10px",
    height: "auto"
  }
});
const zoomPopoverStyles = {
  popover: { minWidth: "180px", maxHeight: "550px", padding: "8px" },
  item: { fontSize: "15px" }
};
const useStyles$T = createUseStyles((theme2) => ({
  container: (props) => {
    var _a, _b2, _c2, _d2;
    return {
      display: "inline-block",
      backgroundColor: ((_a = props == null ? void 0 : props.booking) == null ? void 0 : _a.status) === STATUS_TYPES.CANCELLED ? theme2.colors.cancelledStatusBackground : theme2.colors.white,
      fontSize: "12px",
      color: theme2.colors.labelText,
      height: "21px",
      lineHeight: "21px",
      borderRadius: "4px",
      flexGrow: 0,
      padding: "0 5px",
      alignItems: "center",
      border: `1px solid ${(_b2 = getBookingColours(theme2, props == null ? void 0 : props.booking)) == null ? void 0 : _b2.outline}`,
      borderLeft: `4px solid ${(_c2 = getBookingColours(theme2, props == null ? void 0 : props.booking)) == null ? void 0 : _c2.outline}`,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      zIndex: (props == null ? void 0 : props.dragging) ? 1001 : 1,
      boxShadow: (props == null ? void 0 : props.dragging) ? "0px 4px 4px rgba(107, 107, 107, 0.25)" : "none",
      transition: "box-shadow 0.25s",
      cursor: "pointer",
      position: "relative",
      textDecoration: ((_d2 = props == null ? void 0 : props.booking) == null ? void 0 : _d2.status) === STATUS_TYPES.CANCELLED ? "line-through" : "inherit",
      "&:hover": {
        backgroundColor: theme2.colors.linen
      }
    };
  },
  content: {
    overflow: "hidden"
    // TODO This was a typo before
  },
  icon: {
    position: "absolute",
    right: "-12px",
    top: "-4px"
  }
}));
const ReservationTime = ({ booking, dragging }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$T({ booking, dragging });
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, formatTimeFromInt(booking == null ? void 0 : booking.startTime, "h:mma"), " ", /* @__PURE__ */ React__default.createElement("span", { style: { color: theme2.colors.smoke } }, "|"), " ", booking == null ? void 0 : booking.size), (booking == null ? void 0 : booking.status) === STATUS_TYPES.CONFIRMED && !booking.isLate && /* @__PURE__ */ React__default.createElement(
    ConfirmedCheckIcon,
    {
      className: classes.icon,
      style: { width: "16px", height: "16px" }
    }
  ));
};
ReservationTime.propTypes = {
  booking: obeeBookingPropTypes.isRequired,
  dragging: PropTypes.bool.isRequired
};
const mapStateToProps$1J = () => ({});
const mapDispatchToProps$1I = (dispatch) => bindActionCreators({}, dispatch);
const ReservationTime$1 = connect(mapStateToProps$1J, mapDispatchToProps$1I)(ReservationTime);
const SvgExpand = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M1 1L4 5L7 1", stroke: "currentColor", strokeLinecap: "round" }));
const ExpandSVG = SvgExpand;
const MultiTableDetails = ({
  table,
  tables,
  bookings,
  obeeSettings: obeeSettings2,
  onStartDraggingBooking,
  onStopDraggingBooking,
  onDragTableBooking,
  setSelectedBooking,
  showAllBookings,
  dragRef,
  draggedTableBooking,
  setObeeBookingDetailsModal,
  dragScale
}) => {
  var _a, _b2;
  const classes = useStyles$U();
  const currentTime = moment$2();
  let bookingsForTable = getBookingsForTable(table, bookings);
  bookingsForTable = sortListByProperty(bookingsForTable, "startTime");
  bookingsForTable = bookingsForTable.filter(
    (booking) => (booking == null ? void 0 : booking.status) !== STATUS_TYPES.NO_SHOW && (booking == null ? void 0 : booking.status) !== STATUS_TYPES.UNCONFIRMED && (booking == null ? void 0 : booking.status) !== STATUS_TYPES.CANCELLED && (booking == null ? void 0 : booking.status) !== STATUS_TYPES.FINISHED
  );
  const currentTimeAsInt = formatIntFromTime(currentTime);
  const latestBooking = getBookingToShowOnTable(bookingsForTable, currentTimeAsInt);
  const upcomingBooking = (_a = bookingsForTable.filter((booking) => {
    return booking.startTime >= currentTimeAsInt && showInFloorplan(booking);
  })) == null ? void 0 : _a[0];
  const block = getBlockForTable(latestBooking, table == null ? void 0 : table.tableNumber, tables, currentTimeAsInt);
  const isBlocked = !isEmpty(block);
  const isAvailable = !isBlocked && (!latestBooking || !showInFloorplan(latestBooking)) && (!upcomingBooking || (upcomingBooking == null ? void 0 : upcomingBooking.startTime) > currentTimeAsInt + ((_b2 = obeeSettings2.data) == null ? void 0 : _b2.bookingsDuration));
  const bookingsToShowInitially = bookingsForTable.slice(0, isAvailable ? 1 : 2);
  const bookingsToShow = bookingsToShowInitially;
  const canBeExpanded = bookingsForTable.length > bookingsToShowInitially.length;
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.multiTableContainer} booking-card` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableTimesContainer }, bookingsToShow == null ? void 0 : bookingsToShow.map((booking) => {
    var _a2, _b3;
    const dragging = !isEmpty(draggedTableBooking == null ? void 0 : draggedTableBooking.id) && (draggedTableBooking == null ? void 0 : draggedTableBooking.id) === (booking == null ? void 0 : booking.id) && (table == null ? void 0 : table.tableNumber) === ((_a2 = draggedTableBooking == null ? void 0 : draggedTableBooking.table) == null ? void 0 : _a2.tableNumber);
    const canDrag = isEmpty(draggedTableBooking == null ? void 0 : draggedTableBooking.id) || (draggedTableBooking == null ? void 0 : draggedTableBooking.id) === (booking == null ? void 0 : booking.id) && (table == null ? void 0 : table.tableNumber) === ((_b3 = draggedTableBooking == null ? void 0 : draggedTableBooking.table) == null ? void 0 : _b3.tableNumber);
    return /* @__PURE__ */ React__default.createElement(
      TouchDraggable$1,
      {
        key: `multi_${booking == null ? void 0 : booking.id}_${table == null ? void 0 : table.tableNumber}`,
        className: "booking-card",
        position: { x: 0, y: 0 },
        onStart: () => onStartDraggingBooking(booking),
        onStopPressing: onStopDraggingBooking,
        onDrag: onDragTableBooking,
        onClick: (e) => {
          setSelectedBooking(booking);
          if (e.detail === 2) {
            e.stopPropagation();
            setObeeBookingDetailsModal(booking == null ? void 0 : booking.id, "booking");
          }
        },
        disabled: !canDrag,
        holdTime: 200,
        scale: dragScale
      },
      /* @__PURE__ */ React__default.createElement(
        Box,
        {
          ref: (element) => {
            if (!element || !dragRef) {
              return;
            }
            dragRef.current = element.getBoundingClientRect();
          }
        },
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.bookingDetailsContainer,
            style: {
              zIndex: dragging ? 1001 : 1,
              touchEvents: "none",
              userSelect: "none",
              pointerEvents: "none"
            }
          },
          /* @__PURE__ */ React__default.createElement(ReservationTime$1, { booking, dragging })
        )
      )
    );
  })), canBeExpanded && /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "custom",
      style: {
        button: {
          padding: "8px",
          margin: "-8px"
        }
      },
      onClick: (e) => {
        showAllBookings(e.currentTarget);
        e.stopPropagation();
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.floatingButton }, /* @__PURE__ */ React__default.createElement(ExpandSVG, { style: { width: "8px" } }))
  ));
};
MultiTableDetails.defaultProps = {
  dragRef: null,
  draggedTableBooking: null,
  tablePropertiesAnchor: null
};
MultiTableDetails.propTypes = {
  table: tablePropTypes.isRequired,
  tables: tablesPropTypes.isRequired,
  bookings: PropTypes.arrayOf(obeeBookingPropTypes).isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  onStartDraggingBooking: PropTypes.func.isRequired,
  onStopDraggingBooking: PropTypes.func.isRequired,
  onDragTableBooking: PropTypes.func.isRequired,
  setSelectedBooking: PropTypes.func.isRequired,
  showAllBookings: PropTypes.func.isRequired,
  dragRef: PropTypes.shape({ current: PropTypes.shape({}) }),
  draggedTableBooking: obeeBookingPropTypes,
  tablePropertiesAnchor: PropTypes.shape({
    anchor: PropTypes.shape({}),
    table: tablePropTypes,
    booking: obeeBookingPropTypes,
    available: PropTypes.bool
  }),
  setObeeBookingDetailsModal: PropTypes.func.isRequired
};
const mapStateToProps$1I = (state) => {
  var _a;
  return {
    tables: state.tables,
    restId: state.restaurantActive.restaurant.objectId,
    date: state.obeeScreen.date,
    floorplanView: state.obeeScreen.floorplanView,
    floorplan: state.floorplan,
    obeeAvailability: state.obeeAvailability,
    restaurant: (_a = state.restaurant) == null ? void 0 : _a.restaurant,
    obeeSettings: state.obeeSettings
  };
};
const mapDispatchToProps$1H = (dispatch) => bindActionCreators(
  {
    updateObeeBooking: updateObeeBookingAction,
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction
  },
  dispatch
);
const MultiTableDetails$1 = connect(mapStateToProps$1I, mapDispatchToProps$1H)(MultiTableDetails);
const SvgExit = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M6.25 1H1V11H6.25", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 3, y1: 6, x2: 6.5, y2: 6, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.5 4C5.8 4.4 6.625 5.5 7 6L5.5 8", stroke: "currentColor", strokeLinecap: "round" }));
const IconExit = SvgExit;
const SingleTableDetails = ({
  onStartDraggingBooking,
  onStopDraggingBooking,
  onDragTableBooking,
  setSelectedBooking,
  dragRef,
  draggedTableBooking,
  bookingToShow,
  tableNumber,
  setObeeBookingDetailsModal,
  dragScale
}) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$U();
  if ((bookingToShow == null ? void 0 : bookingToShow.status) === STATUS_TYPES.CANCELLED) {
    return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.singleTableDetailsContainer} booking-card` }, /* @__PURE__ */ React__default.createElement(Box, null, bookingToShow == null ? void 0 : bookingToShow.formattedStartTime), /* @__PURE__ */ React__default.createElement(Box, { className: classes.row, style: { gap: "2px" } }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { height: "13px", textDecoration: "line-through" } })), /* @__PURE__ */ React__default.createElement(Box, null, bookingToShow == null ? void 0 : bookingToShow.size)));
  }
  const getTimeRow = (colours2) => {
    if (bookingToShow == null ? void 0 : bookingToShow.isLate) {
      return /* @__PURE__ */ React__default.createElement(Box, { className: classes.noShowTime, style: { backgroundColor: colours2.fill } }, bookingToShow == null ? void 0 : bookingToShow.formattedStartTime);
    }
    switch (bookingToShow == null ? void 0 : bookingToShow.status) {
      case STATUS_TYPES.ARRIVED:
        return /* @__PURE__ */ React__default.createElement(Box, { className: classes.row, style: { gap: "3px", backgroundColor: colours2.fill } }, /* @__PURE__ */ React__default.createElement(IconExit, { style: { height: "13px" } }), /* @__PURE__ */ React__default.createElement(Box, null, formatTimeFromInt(bookingToShow == null ? void 0 : bookingToShow.endTime)));
      case STATUS_TYPES.NO_SHOW:
        return /* @__PURE__ */ React__default.createElement(Box, { className: classes.noShowTime }, bookingToShow == null ? void 0 : bookingToShow.formattedStartTime);
      default:
        return /* @__PURE__ */ React__default.createElement(Box, null, bookingToShow == null ? void 0 : bookingToShow.formattedStartTime);
    }
  };
  const dragging = !isEmpty(draggedTableBooking == null ? void 0 : draggedTableBooking.id) && (draggedTableBooking == null ? void 0 : draggedTableBooking.id) === (bookingToShow == null ? void 0 : bookingToShow.id) && tableNumber === ((_a = draggedTableBooking == null ? void 0 : draggedTableBooking.table) == null ? void 0 : _a.tableNumber);
  const canDrag = isEmpty(draggedTableBooking == null ? void 0 : draggedTableBooking.id) || (draggedTableBooking == null ? void 0 : draggedTableBooking.id) === (bookingToShow == null ? void 0 : bookingToShow.id) && tableNumber === ((_b2 = draggedTableBooking == null ? void 0 : draggedTableBooking.table) == null ? void 0 : _b2.tableNumber);
  const colours = getBookingColours(theme2, bookingToShow);
  return /* @__PURE__ */ React__default.createElement(
    TouchDraggable$1,
    {
      key: `single_${bookingToShow == null ? void 0 : bookingToShow.id}_${tableNumber}`,
      className: "booking-card",
      position: { x: 0, y: 0 },
      onStart: () => onStartDraggingBooking(bookingToShow),
      scale: dragScale,
      onStopPressing: onStopDraggingBooking,
      onDrag: onDragTableBooking,
      onClick: (e) => {
        setSelectedBooking(bookingToShow);
        if (e.detail === 2) {
          e.stopPropagation();
          setObeeBookingDetailsModal(bookingToShow == null ? void 0 : bookingToShow.id, "booking");
        }
      },
      holdTime: 200,
      disabled: !canDrag
    },
    /* @__PURE__ */ React__default.createElement(
      Box,
      {
        ref: (element) => {
          if (!element) {
            return;
          }
          if (dragRef) {
            dragRef.current = element.getBoundingClientRect();
          }
        }
      },
      /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.bookingDetailsContainer,
          style: {
            backgroundColor: dragging ? colours == null ? void 0 : colours.fill : "transparent",
            border: dragging ? `1px solid ${colours == null ? void 0 : colours.outline}` : "1px solid transparent",
            zIndex: dragging ? 1001 : 1,
            boxShadow: dragging ? "0px 4px 4px rgba(107, 107, 107, 0.25)" : "none",
            touchEvents: "none",
            userSelect: "none",
            pointerEvents: "none"
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { style: { userSelect: "none" } }, getTimeRow(colours)),
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.row, style: { gap: "2px", userSelect: "none" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { backgroundColor: colours.fill } }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { height: "13px" } })), /* @__PURE__ */ React__default.createElement(Box, { style: { backgroundColor: colours.fill } }, bookingToShow == null ? void 0 : bookingToShow.size))
      )
    )
  );
};
SingleTableDetails.defaultProps = {
  draggedTableBooking: null,
  bookingToShow: null,
  dragRef: null,
  tableNumber: null
};
SingleTableDetails.propTypes = {
  bookingToShow: obeeBookingPropTypes,
  onStartDraggingBooking: PropTypes.func.isRequired,
  onStopDraggingBooking: PropTypes.func.isRequired,
  onDragTableBooking: PropTypes.func.isRequired,
  setSelectedBooking: PropTypes.func.isRequired,
  dragRef: PropTypes.shape({ current: PropTypes.shape({}) }),
  draggedTableBooking: obeeBookingPropTypes,
  tableNumber: PropTypes.string,
  setObeeBookingDetailsModal: PropTypes.func.isRequired
};
const mapStateToProps$1H = (state) => {
  var _a;
  return {
    tables: state.tables,
    restId: state.restaurantActive.restaurant.objectId,
    date: state.obeeScreen.date,
    floorplanView: state.obeeScreen.floorplanView,
    floorplan: state.floorplan,
    obeeAvailability: state.obeeAvailability,
    restaurant: (_a = state.restaurant) == null ? void 0 : _a.restaurant,
    obeeSettings: state.obeeSettings
  };
};
const mapDispatchToProps$1G = (dispatch) => bindActionCreators(
  {
    updateObeeBooking: updateObeeBookingAction,
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction
  },
  dispatch
);
const SingleTableDetails$1 = connect(mapStateToProps$1H, mapDispatchToProps$1G)(SingleTableDetails);
const SvgBlock = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 8.9397, cy: 8.68799, r: 8, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 4.9397, y: 7.68799, width: 8, height: 2, fill: "white" }));
const IconBlockSVG = SvgBlock;
const useStyles$S = createUseStyles((theme2) => ({
  container: (props) => ({
    padding: "2px 4px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "6px",
    ...(props == null ? void 0 : props.hovered) && {
      backgroundColor: "white",
      boxShadow: "0px 4px 4px rgba(128, 128, 128, 0.25)"
      // copied from figma
    }
  }),
  tableNumbers: {
    color: theme2.colors.black,
    fontSize: "12px",
    whiteSpace: "nowrap",
    fontWeight: theme2.fontWeights.regular
  }
}));
const JoinTableIcon = ({ joinedTables }) => {
  const theme2 = useTheme$1();
  const [hovered, setHovered] = useState(false);
  const classes = useStyles$S({ hovered });
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.container,
      onMouseMove: () => setHovered(true),
      onMouseLeave: () => setHovered(false)
    },
    /* @__PURE__ */ React__default.createElement(
      TableJoinedSVG,
      {
        style: {
          color: theme2.colors.jet,
          width: "16px",
          height: "16px"
        }
      }
    ),
    hovered && /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableNumbers }, joinList(joinedTables, ", ", ", "))
  );
};
JoinTableIcon.defaultProps = {};
const mapStateToProps$1G = () => ({});
JoinTableIcon.propTypes = {
  joinedTables: PropTypes.arrayOf(PropTypes.string).isRequired
};
const mapDispatchToProps$1F = (dispatch) => bindActionCreators({}, dispatch);
const JoinTableIcon$1 = connect(mapStateToProps$1G, mapDispatchToProps$1F)(JoinTableIcon);
const TableStatusIcon = ({ joinedTables, isBlocked }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$U();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableStatusContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.absoluteAnchor }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.statusIcons }, isBlocked && /* @__PURE__ */ React__default.createElement(
    IconBlockSVG,
    {
      style: {
        color: theme2.colors.charcoal,
        width: "16px",
        height: "16px"
      }
    }
  ), joinedTables.length > 1 && /* @__PURE__ */ React__default.createElement(JoinTableIcon$1, { joinedTables }))));
};
TableStatusIcon.defaultProps = {
  isBlocked: false
};
TableStatusIcon.propTypes = {
  isBlocked: PropTypes.bool,
  joinedTables: PropTypes.arrayOf(PropTypes.string).isRequired
};
const mapStateToProps$1F = () => ({});
const mapDispatchToProps$1E = (dispatch) => bindActionCreators({}, dispatch);
const TableStatusIcon$1 = connect(mapStateToProps$1F, mapDispatchToProps$1E)(TableStatusIcon);
const useStyles$R = createUseStyles((theme2) => ({
  container: {
    backgroundColor: theme2.colors.white,
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.charcoal,
    border: `1px solid ${theme2.colors.cloud}`,
    borderRadius: "8px",
    bottom: "-12px",
    boxShadow: "0px 4px 4px 0px #E8E8E840",
    fontSize: "11px",
    maxWidth: "96px",
    overflow: "hidden",
    padding: "2px 4px",
    position: "absolute",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    zIndex: -1
  }
}));
const BookingNameLabel = ({ booking }) => {
  const classes = useStyles$R();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container, title: booking.name }, booking.name);
};
BookingNameLabel.propTypes = {
  booking: obeeBookingPropTypes.isRequired
};
const BookingNameLabel$1 = BookingNameLabel;
const TableDetails = ({
  table,
  tables,
  bookings,
  obeeSettings: obeeSettings2,
  onStartDraggingBooking,
  onStopDraggingBooking,
  onDragTableBooking,
  selectedBooking,
  setSelectedBooking,
  showAllBookings,
  dragRef,
  draggedTableBooking,
  hoveredTableRef,
  tablePropertiesAnchor,
  setTablePropertiesAnchor,
  floorplanView,
  fullyBookedSessions,
  sessionFilter,
  closingTime,
  inSession,
  draggedBooking,
  // Booking dragged from sidebar
  bounds,
  // bounds of table (position, size)
  dragScale,
  setObeeShowAddBookingModal,
  setObeeBookingDetailsModal,
  obeeSessions: obeeSessions2,
  date
}) => {
  var _a, _b2, _c2, _d2, _e2;
  const theme2 = useTheme$1();
  const currentTime = moment$2();
  const scrollToTable = useRef(false);
  let bookingsForTable = getBookingsForTable(table, bookings);
  bookingsForTable = sortListByProperty(bookingsForTable, "startTime");
  bookingsForTable = bookingsForTable.filter(
    (booking) => (booking == null ? void 0 : booking.status) !== STATUS_TYPES.NO_SHOW && (booking == null ? void 0 : booking.status) !== STATUS_TYPES.FINISHED && (booking == null ? void 0 : booking.status) !== STATUS_TYPES.UNCONFIRMED
  );
  const currentTimeAsInt = formatIntFromTime(currentTime);
  const scrollRef = useRef(null);
  useEffect(() => {
    if (selectedBooking && (scrollToTable == null ? void 0 : scrollToTable.current) && scrollRef.current) {
      scrollToTable.current = false;
      setTimeout(() => {
        scrollRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center"
        });
      }, 50);
    }
  }, [selectedBooking, scrollToTable]);
  const latestBooking = getBookingToShowOnTable(bookingsForTable, currentTimeAsInt);
  const upcomingBooking = (_a = bookingsForTable.filter((booking) => {
    return booking.startTime >= currentTimeAsInt && showInFloorplan(booking);
  })) == null ? void 0 : _a[0];
  const block = getBlockForTable(latestBooking, table == null ? void 0 : table.tableNumber, tables, currentTimeAsInt);
  const isBlocked = !isEmpty(block);
  const blockedTime = getBlockEndTime(block, closingTime == null ? void 0 : closingTime.current);
  const joinedTables = (latestBooking == null ? void 0 : latestBooking.tableNumbers) || [table == null ? void 0 : table.tableNumber];
  const fullyBooked = getFullyBookedSessionForTable(
    fullyBookedSessions.data,
    sessionFilter,
    table,
    currentTimeAsInt
  );
  const hasNoBookings = (!latestBooking || !showInFloorplan(latestBooking)) && (!upcomingBooking || (upcomingBooking == null ? void 0 : upcomingBooking.startTime) > currentTimeAsInt + ((_b2 = obeeSettings2.data) == null ? void 0 : _b2.bookingsDuration));
  const isAvailable = !isBlocked && hasNoBookings;
  const isSeated = (latestBooking == null ? void 0 : latestBooking.status) === STATUS_TYPES.ARRIVED;
  const isHovered = joinedTables.includes((_c2 = hoveredTableRef == null ? void 0 : hoveredTableRef.current) == null ? void 0 : _c2.tableNumber);
  const isSelected = isTableForBooking(table, selectedBooking);
  const isFirstSelectedTable = ((_d2 = selectedBooking == null ? void 0 : selectedBooking.tableNumbers) == null ? void 0 : _d2[0]) === (table == null ? void 0 : table.tableNumber);
  const { outline, fill } = getAvailabilityColours({
    showBookingDragOutline: false,
    draggedOffTable: false,
    theme: theme2,
    block,
    fullyBooked,
    latestBooking,
    areaIsInSession: inSession
  });
  const classes = useStyles$U({ outline, fill });
  const renderTableBookings = () => {
    if (floorplanView === "single") {
      return /* @__PURE__ */ React__default.createElement(
        SingleTableDetails$1,
        {
          bookingToShow: latestBooking,
          onStartDraggingBooking,
          onStopDraggingBooking,
          onDragTableBooking,
          setSelectedBooking,
          dragRef,
          draggedTableBooking,
          tableNumber: table == null ? void 0 : table.tableNumber,
          fill,
          dragScale
        }
      );
    }
    return /* @__PURE__ */ React__default.createElement(
      MultiTableDetails$1,
      {
        table,
        tables,
        bookings,
        obeeSettings: obeeSettings2,
        onStartDraggingBooking,
        onStopDraggingBooking,
        onDragTableBooking,
        setSelectedBooking,
        showAllBookings,
        dragRef,
        draggedTableBooking,
        dragScale
      }
    );
  };
  const renderTableSummary = () => {
    if (hasNoBookings && !isSeated && isBlocked) {
      return /* @__PURE__ */ React__default.createElement(Box, { className: classes.additionalDetailsContainer }, /* @__PURE__ */ React__default.createElement(Box, null, "Until"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.additionalTableTime }, blockedTime));
    }
    if (isAvailable) {
      return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.availableText} ${classes.availableTextLabel}` }, "Available");
    }
    if (!latestBooking) {
      devLog("error", "tableDetails", "Could not render booking on table");
      return /* @__PURE__ */ React__default.createElement(Box, null, "-");
    }
    return renderTableBookings();
  };
  const touchRef = useRef(false);
  const touchRefTimer = useRef(null);
  touchRef.current = false;
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      key: table == null ? void 0 : table.id,
      className: classes.tableLabelContainer,
      "data-table": table == null ? void 0 : table.id,
      style: {
        left: bounds == null ? void 0 : bounds.x,
        top: bounds == null ? void 0 : bounds.y,
        width: bounds.width,
        height: bounds.height,
        justifyContent: "center",
        zIndex: isSelected ? 1001 : isHovered && !draggedBooking ? 999 : 0
      },
      onTouchStart: () => {
        touchRef.current = true;
        touchRefTimer.current = (/* @__PURE__ */ new Date()).getTime();
      },
      onTouchEnd: (e) => {
        var _a2;
        const touchTime = (/* @__PURE__ */ new Date()).getTime() - (touchRefTimer == null ? void 0 : touchRefTimer.current);
        if (!(touchRefTimer == null ? void 0 : touchRefTimer.current) || touchTime > 300) {
          return;
        }
        if (draggedBooking) {
          return;
        }
        e.stopPropagation();
        if (latestBooking) {
          setObeeShowAddBookingModal(false);
          setObeeBookingDetailsModal(latestBooking == null ? void 0 : latestBooking.id, "booking");
        } else {
          const sessionsForDay = getTodaySessions(
            date,
            obeeSessions2,
            "all_sessions",
            (table == null ? void 0 : table.areaId) || "all"
          );
          const bookingInterval = (_a2 = obeeSettings2.data) == null ? void 0 : _a2.systemTimeInterval;
          const availableTimes = getTimeDropdownList(sessionsForDay, null, bookingInterval);
          const newBooking = {
            areaId: table == null ? void 0 : table.areaId,
            tableNumber: table == null ? void 0 : table.tableNumber,
            tableId: table == null ? void 0 : table.tableId,
            minSeats: table == null ? void 0 : table.minSeats,
            time: getNextTime(availableTimes),
            status: STATUS_TYPES.ARRIVED
          };
          setObeeBookingDetailsModal(false);
          setObeeShowAddBookingModal(true, newBooking);
        }
      }
    },
    !draggedBooking && (isHovered || isSelected || ((_e2 = tablePropertiesAnchor == null ? void 0 : tablePropertiesAnchor.table) == null ? void 0 : _e2.id) === (table == null ? void 0 : table.id)) && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        type: "custom",
        className: `${classes.tableActionButton}`,
        onClick: (e) => {
          setTablePropertiesAnchor({
            anchor: e.currentTarget,
            table,
            booking: floorplanView === "single" ? latestBooking : null,
            // No booking editing in multi mode
            available: isEmpty(bookingsForTable),
            inSession
          });
          e.stopPropagation();
        }
      },
      /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG, { className: classes.actionIcon })
    ),
    isSelected && isFirstSelectedTable && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        ref: scrollRef,
        className: classes.scrollRefBox,
        style: {
          width: bounds.width,
          height: bounds.height
        }
      }
    ),
    /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tableLabel} ${isAvailable && classes.availableText}` }, table == null ? void 0 : table.tableNumber),
    /* @__PURE__ */ React__default.createElement(TableStatusIcon$1, { isBlocked, joinedTables }),
    renderTableSummary(),
    latestBooking && /* @__PURE__ */ React__default.createElement(BookingNameLabel$1, { booking: latestBooking })
  );
};
TableDetails.defaultProps = {
  selectedBooking: null,
  dragRef: null,
  draggedTableBooking: null,
  tablePropertiesAnchor: null,
  hoveredTableRef: null,
  closingTime: 1439,
  inSession: true
};
TableDetails.propTypes = {
  table: tablePropTypes.isRequired,
  tables: tablesPropTypes.isRequired,
  bookings: PropTypes.arrayOf(obeeBookingPropTypes).isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  onStartDraggingBooking: PropTypes.func.isRequired,
  onStopDraggingBooking: PropTypes.func.isRequired,
  onDragTableBooking: PropTypes.func.isRequired,
  selectedBooking: obeeBookingPropTypes,
  setSelectedBooking: PropTypes.func.isRequired,
  showAllBookings: PropTypes.func.isRequired,
  dragRef: PropTypes.shape({ current: PropTypes.shape({}) }),
  draggedTableBooking: obeeBookingPropTypes,
  hoveredTableRef: PropTypes.shape({ current: PropTypes.shape({ tableNumber: PropTypes.string }) }),
  tablePropertiesAnchor: PropTypes.shape({
    anchor: PropTypes.shape({}),
    table: tablePropTypes,
    booking: obeeBookingPropTypes,
    available: PropTypes.bool
  }),
  setTablePropertiesAnchor: PropTypes.func.isRequired,
  floorplanView: PropTypes.string.isRequired,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired,
  sessionFilter: PropTypes.string.isRequired,
  closingTime: PropTypes.number,
  inSession: PropTypes.bool
};
const mapStateToProps$1E = (state) => {
  var _a;
  return {
    tables: state.tables,
    restId: state.restaurantActive.restaurant.objectId,
    date: state.obeeScreen.date,
    floorplanView: state.obeeScreen.floorplanView,
    floorplan: state.floorplan,
    obeeAvailability: state.obeeAvailability,
    restaurant: (_a = state.restaurant) == null ? void 0 : _a.restaurant,
    obeeSettings: state.obeeSettings,
    fullyBookedSessions: state.fullyBookedSessions,
    sessionFilter: state.obeeScreen.sessionFilter,
    obeeSessions: state.obeeSessions
  };
};
const mapDispatchToProps$1D = (dispatch) => bindActionCreators(
  {
    updateObeeBooking: updateObeeBookingAction,
    setObeeShowAddBookingModal: setObeeShowAddBookingModalAction,
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction
  },
  dispatch
);
const TableDetails$1 = connect(mapStateToProps$1E, mapDispatchToProps$1D)(TableDetails);
const BlockTableTimePopover = ({
  anchorEl,
  onClose,
  onSelect: onSelect2,
  table,
  blockTable: blockTable2,
  date,
  closingTime,
  systemTimeInterval,
  currentBlock,
  editTableBlock: editTableBlock2,
  todaySessions
}) => {
  const sessionsToUse = (todaySessions || []).filter(
    (session) => (session == null ? void 0 : session.areaId) === (table == null ? void 0 : table.areaId)
  );
  const nowAsInt = formatIntFromTime(moment$2());
  const sessionToUse = sessionsToUse.find(
    (session) => session.startTime <= nowAsInt && session.endTime > nowAsInt
  );
  const block = (endTime) => {
    if (currentBlock) {
      editTableBlock2(table, currentBlock.id, endTime);
    } else {
      blockTable2(
        table,
        formatDate(date, "YYYY-MM-DD"),
        endTime,
        formatIntFromTime(pastNearestMinutes(moment$2(), systemTimeInterval))
      );
    }
    onClose();
  };
  const getNextIntervals = (interval = 15) => {
    const now2 = nextNearestMinutes(moment$2(), interval);
    if (sessionToUse) {
      return numberRange(formatIntFromTime(now2), sessionToUse.endTime, interval).map((time) => {
        const nowInterval = momentFromInt(time);
        return {
          label: formatDate(nowInterval, "h:mm a"),
          onClick: () => {
            block(formatIntFromTime(nowInterval));
          }
        };
      });
    }
    return [];
  };
  const style = {
    item: {
      fontSize: "14px",
      height: "auto",
      padding: "8px"
    },
    popover: {
      marginLeft: "20px",
      marginTop: "-10px",
      maxHeight: "300px"
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      isOpen: !!anchorEl,
      onClose,
      anchor: anchorEl,
      onSelect: onSelect2,
      anchorOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      items: [
        ...sessionToUse ? [
          {
            label: `End of session: ${formatTimeFromInt(sessionToUse.endTime)}`,
            onClick: () => {
              block(sessionToUse.endTime);
            }
          }
        ] : [],
        {
          label: "End of day",
          onClick: () => {
            block(closingTime);
          }
        },
        ...getNextIntervals(systemTimeInterval)
      ],
      style
    }
  );
};
BlockTableTimePopover.defaultProps = {
  anchorEl: null,
  onClose: () => {
  },
  onSelect: () => {
  },
  table: null,
  date: null,
  currentBlock: null
};
BlockTableTimePopover.propTypes = {
  anchorEl: PropTypes.shape({}),
  onClose: PropTypes.func,
  table: tablePropTypes,
  onSelect: PropTypes.func,
  blockTable: PropTypes.func.isRequired,
  date: momentPropTypes.momentObj,
  closingTime: PropTypes.number.isRequired,
  systemTimeInterval: PropTypes.number.isRequired,
  editTableBlock: PropTypes.func.isRequired,
  currentBlock: tableBlockPropTypes,
  todaySessions: PropTypes.arrayOf(sessionPropTypes).isRequired
};
const mapStateToProps$1D = (state) => ({
  date: state.obeeScreen.date
});
const mapDispatchToProps$1C = (dispatch) => bindActionCreators(
  {
    blockTable: blockTableAction,
    editTableBlock: editTableBlockAction
  },
  dispatch
);
const BlockTableTimePopover$1 = connect(mapStateToProps$1D, mapDispatchToProps$1C)(BlockTableTimePopover);
const useStyles$Q = createUseStyles((theme2) => ({
  container: {
    width: "100%",
    backgroundColor: theme2.colors.cloud,
    color: theme2.colors.charcoal,
    minWidth: "220px",
    fontSize: theme2.fontSizes.l,
    borderRadius: "2px"
  },
  top: {
    padding: "12px 16px",
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    justifyContent: "space-between",
    alignItems: "center"
  },
  blockedText: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    alignItems: "center",
    height: "20px"
  },
  blockedTime: {
    backgroundColor: theme2.colors.white,
    fontSize: "13px",
    lineHeight: "20px",
    height: "20px",
    borderRadius: "6px",
    padding: "0 10px",
    fontWeight: theme2.fontWeights.medium
  },
  divider: {
    padding: "0 2px"
  },
  bottom: {
    padding: "6px"
  },
  editButton: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    justifyContent: "space-between",
    alignItems: "center"
  }
}));
const SvgBlockTable = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 9.8005, cy: 11.0002, r: 6.83175, fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.9674 4.31369V4.31369C12.9674 3.14752 12.0221 2.20215 10.8559 2.20215H8.74435C7.57818 2.20215 6.63281 3.14752 6.63281 4.31369V4.31369", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M6.63217 17.6868V17.6868C6.63217 18.853 7.57754 19.7983 8.74371 19.7983L10.8553 19.7983C12.0214 19.7983 12.9668 18.853 12.9668 17.6868V17.6868", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M3.1135 7.83285V7.83285C1.94732 7.83285 1.00195 8.77822 1.00195 9.9444L1.00195 12.0559C1.00195 13.2221 1.94732 14.1675 3.1135 14.1675V14.1675", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.4861 14.1676V14.1676C17.6523 14.1676 18.5977 13.2223 18.5977 12.0561L18.5977 9.94455C18.5977 8.77838 17.6523 7.83301 16.4861 7.83301V7.83301", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 15.2, cy: 5.29272, r: 4.60815, fill: "#E54439" }), /* @__PURE__ */ React$7.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.2002 9.80029C17.6434 9.80029 19.624 7.81968 19.624 5.37646C19.624 2.93325 17.6434 0.952637 15.2002 0.952637C12.757 0.952637 10.7764 2.93325 10.7764 5.37646C10.7764 7.81968 12.757 9.80029 15.2002 9.80029ZM15.2002 10.5376C18.0506 10.5376 20.3613 8.22688 20.3613 5.37646C20.3613 2.52605 18.0506 0.215332 15.2002 0.215332C12.3498 0.215332 10.0391 2.52605 10.0391 5.37646C10.0391 8.22688 12.3498 10.5376 15.2002 10.5376Z", fill: "#E54439" }), /* @__PURE__ */ React$7.createElement("rect", { x: 12.9199, y: 4.62646, width: 4.5625, height: 1.5, fill: "white" }));
const IconBlockTable = SvgBlockTable;
const BlockedTableEditor = ({
  tableId,
  onSelect: onSelect2,
  tables,
  block,
  obeeSettings: obeeSettings2,
  closingTime,
  todaySessions
}) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$Q();
  const [editAnchorEl, setEditAnchorEl] = useState(null);
  const table = useMemo(() => {
    return findObjectByProperty(tables.data, tableId, "id");
  }, [tables == null ? void 0 : tables.data, tableId]);
  useEffect(() => {
    setEditAnchorEl(null);
  }, [table]);
  const buttonStyles2 = {
    container: {
      width: "100%"
    },
    button: {
      width: "100%",
      paddingTop: "6px",
      paddingBottom: "6px",
      paddingLeft: "50px",
      // To align with Blocked text
      paddingRight: "10px",
      borderRadius: "6px",
      fontSize: theme2.fontSizes.l
    },
    buttonHover: { backgroundColor: theme2.colors.white },
    text: {
      display: "flex",
      flexDirection: "row",
      gap: "20px",
      justifyContent: "space-between",
      alignItems: "center"
    }
  };
  if (!table) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes == null ? void 0 : classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes == null ? void 0 : classes.top }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockedText }, /* @__PURE__ */ React__default.createElement(IconBlockTable, { style: { width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Blocked")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockedTime }, getBlockEndTime(block, closingTime, "End of day"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.divider }, /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.yetAnotherGray8 })), /* @__PURE__ */ React__default.createElement(Box, { className: classes == null ? void 0 : classes.bottom }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "custom",
      style: buttonStyles2,
      onClick: (e) => setEditAnchorEl(e.currentTarget),
      className: classes == null ? void 0 : classes.editButton
    },
    /* @__PURE__ */ React__default.createElement(Box, null, "Edit"),
    /* @__PURE__ */ React__default.createElement(ChevronRight, { style: { width: "8px" } })
  )), /* @__PURE__ */ React__default.createElement(
    BlockTableTimePopover$1,
    {
      anchorEl: editAnchorEl,
      onSelect: (item) => {
        onSelect2(item);
        setEditAnchorEl(null);
      },
      onClose: () => setEditAnchorEl(null),
      table,
      closingTime,
      systemTimeInterval: (_a = obeeSettings2.data) == null ? void 0 : _a.systemTimeInterval,
      currentBlock: block,
      todaySessions
    }
  ));
};
BlockedTableEditor.defaultProps = {
  tableId: null,
  onSelect: () => {
  },
  block: null
};
const mapStateToProps$1C = (state) => ({
  tables: state.tables,
  obeeSettings: state.obeeSettings
});
BlockedTableEditor.propTypes = {
  tableId: PropTypes.number,
  tables: tablesPropTypes.isRequired,
  onSelect: PropTypes.func,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  block: tableBlockPropTypes,
  closingTime: PropTypes.number.isRequired,
  todaySessions: PropTypes.arrayOf(sessionPropTypes).isRequired
  // TODO can these come from state?
};
const mapDispatchToProps$1B = (dispatch) => bindActionCreators({}, dispatch);
const BlockedTableEditor$1 = connect(mapStateToProps$1C, mapDispatchToProps$1B)(BlockedTableEditor);
const useStyles$P = createUseStyles((theme2) => ({
  container: {
    width: "100%",
    backgroundColor: theme2.colors.cloud,
    color: theme2.colors.charcoal,
    minWidth: "220px",
    fontSize: theme2.fontSizes.l,
    borderRadius: "2px"
  },
  top: {
    padding: "8px 10px",
    display: "flex",
    flexDirection: "row",
    gap: "4px",
    alignItems: "center"
  },
  tableNumber: {
    backgroundColor: theme2.colors.white,
    fontSize: "12px",
    lineHeight: "26px",
    height: "26px",
    borderRadius: "4px",
    padding: "0 10px",
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.black
  },
  divider: {
    padding: "0 2px"
  },
  bottom: {
    padding: "6px"
  },
  button: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    ...theme2.typography.body.PL
  },
  buttonWithArrow: {
    display: "flex",
    gap: "16px",
    justifyContent: "space-between",
    alignItems: "center",
    color: theme2.colors.charcoal,
    width: "100%"
  },
  editButton: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    justifyContent: "space-between",
    alignItems: "center"
  }
}));
const JoinTableEditor = ({ join }) => {
  const classes = useStyles$P();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes == null ? void 0 : classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes == null ? void 0 : classes.top }, join == null ? void 0 : join.map((joinTableId) => /* @__PURE__ */ React__default.createElement(Box, { key: joinTableId, className: classes.tableNumber }, joinTableId))));
};
JoinTableEditor.defaultProps = {
  join: []
};
const mapStateToProps$1B = () => ({});
JoinTableEditor.propTypes = {
  join: PropTypes.arrayOf(PropTypes.string)
};
const mapDispatchToProps$1A = (dispatch) => bindActionCreators({}, dispatch);
const JoinTableEditor$1 = connect(mapStateToProps$1B, mapDispatchToProps$1A)(JoinTableEditor);
const useStyles$O = createUseStyles((theme2) => ({
  container: {},
  innerContainer: {
    color: theme2.colors.charcoal,
    display: "flex",
    flexDirection: "column",
    minWidth: "250px",
    minHeight: "150px"
  },
  topSection: {
    padding: "12px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "20px",
    alignItems: "center"
  },
  title: {
    fontWeight: theme2.fontWeights.medium,
    fontSize: "12px"
  },
  bottomSection: {
    borderTop: `1px solid ${theme2.colors.linkIconBackground}`,
    padding: "12px",
    display: "flex",
    gap: "8px",
    flexDirection: "column"
  },
  button: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    width: "100%",
    ...theme2.typography.body.PL,
    fontSize: "16px"
  },
  buttonWithArrow: {
    display: "flex",
    gap: "16px",
    justifyContent: "space-between",
    alignItems: "center",
    color: theme2.colors.charcoal
  },
  joinName: {
    fontWeight: theme2.fontWeights.medium
  }
}));
const SvgDrag = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 13.9999, cy: 13.9999, r: 3.21429, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.2144 3.78571L14.0001 1L16.7858 3.78571", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 14.0356, y1: 1.5, x2: 14.0356, y2: 7, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 14.0356, y1: 1.5, x2: 14.0356, y2: 7, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.2144 24.2143L14.0001 27L16.7858 24.2143", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 0.5, y1: -0.5, x2: 6, y2: -0.5, transform: "matrix(-4.37112e-08 -1 -1 4.37112e-08 13.5356 27)", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 0.5, y1: -0.5, x2: 6, y2: -0.5, transform: "matrix(-4.37112e-08 -1 -1 4.37112e-08 13.5356 27)", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M24.2143 11.2144L27 14.0001L24.2143 16.7858", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 26.5, y1: 14.0356, x2: 21, y2: 14.0356, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 26.5, y1: 14.0356, x2: 21, y2: 14.0356, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M3.78571 11.2144L1 14.0001L3.78571 16.7858", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 0.5, y1: -0.5, x2: 6, y2: -0.5, transform: "matrix(1 0 0 -1 1 13.5356)", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 0.5, y1: -0.5, x2: 6, y2: -0.5, transform: "matrix(1 0 0 -1 1 13.5356)", stroke: "currentColor", strokeLinecap: "round" }));
const DragIconSVG = SvgDrag;
const SvgUnblockTable = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 9.70064, cy: 11.1691, r: 6.83175, fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.8683 4.48264V4.48264C12.8683 3.31646 11.9229 2.37109 10.7568 2.37109H8.64523C7.47906 2.37109 6.53369 3.31646 6.53369 4.48264V4.48264", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M6.53256 17.8557V17.8557C6.53256 19.0219 7.47793 19.9673 8.6441 19.9673L10.7556 19.9673C11.9218 19.9673 12.8672 19.0219 12.8672 17.8557V17.8557", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M3.01389 8.0018V8.0018C1.84771 8.0018 0.902344 8.94717 0.902344 10.1133L0.902344 12.2249C0.902344 13.3911 1.84771 14.3364 3.01389 14.3364V14.3364", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.387 14.3366V14.3366C17.5532 14.3366 18.4985 13.3912 18.4985 12.225L18.4985 10.1135C18.4985 8.94732 17.5532 8.00195 16.387 8.00195V8.00195", stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 15.1014, cy: 5.54379, r: 5.16, fill: "#5D995C" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 15.1016, cy: 5.54346, r: 1, fill: "white" }));
const IconUnblockTable = SvgUnblockTable;
const LiveTableProperties = ({
  tableId,
  bookingId,
  anchor,
  onClose,
  tables,
  bookings,
  setObeeBookingDetailsModal,
  setObeeShowAddBookingModal,
  unblockTable: unblockTable2,
  closingTime,
  obeeSettings: obeeSettings2,
  todaySessions,
  isAvailable,
  fullyBookedSessions,
  sessionFilter,
  inSession,
  date,
  obeeSessions: obeeSessions2
}) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$O();
  useHistory();
  const [table, setTable] = useState(null);
  const [booking, setBooking] = useState(null);
  const [blockAnchorEl, setBlockAnchorEl] = useState(null);
  const currentTime = moment$2();
  const currentTimeAsInt = formatIntFromTime(currentTime);
  useEffect(() => {
    if (anchor) {
      const newTable = findObjectByProperty(tables.data, tableId, "id");
      const newBooking = findObjectByProperty(bookings.data, bookingId, "id");
      setTable(newTable);
      setBooking(newBooking);
    }
  }, [anchor, bookings, tables]);
  useEffect(() => {
    if (!anchor) {
      setBlockAnchorEl(null);
    }
  }, [anchor]);
  const buttonStyles2 = {
    container: {},
    button: {
      width: "100%",
      padding: "10px",
      borderRadius: "6px"
    },
    buttonHover: { backgroundColor: theme2.colors.notificationBackgroundGray }
  };
  const block = getBlockForTable(booking, table == null ? void 0 : table.tableNumber, tables, formatIntFromTime(moment$2()));
  const isBlocked = !isEmpty(block);
  const fullyBooked = getFullyBookedSessionForTable(
    fullyBookedSessions.data,
    sessionFilter,
    table,
    currentTimeAsInt
  );
  !isEmpty(fullyBooked);
  const activeJoin = (booking == null ? void 0 : booking.isJoin) || "";
  const joins = (booking == null ? void 0 : booking.tableNumbers) || [];
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchor,
      onClose,
      anchorEl: anchor,
      innerStyle: { marginLeft: "8px", marginTop: "0", borderRadius: "6px", padding: "0" },
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topSection }, activeJoin ? /* @__PURE__ */ React__default.createElement(TableJoinedSVG, { style: { width: "29px", height: "29px" } }) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, table == null ? void 0 : table.tableNumber), !isEmpty(booking) && /* @__PURE__ */ React__default.createElement(
      StatusSelector$1,
      {
        status: booking.status,
        booking,
        onClose,
        onChange: onClose,
        style: { nextButtonDisplay: "none" }
      }
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, activeJoin && /* @__PURE__ */ React__default.createElement(JoinTableEditor$1, { join: joins, onSelect: onClose }), isBlocked && /* @__PURE__ */ React__default.createElement(
      BlockedTableEditor$1,
      {
        tableId: table == null ? void 0 : table.id,
        onSelect: onClose,
        block,
        closingTime,
        todaySessions
      }
    ), !isEmpty(booking) && /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles2,
        onClick: () => {
          setObeeBookingDetailsModal(booking == null ? void 0 : booking.id, "booking");
          onClose();
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { color: theme2.colors.charcoal, height: "18px", width: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Edit booking"))
    ), !isEmpty(booking) && /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles2,
        onClick: () => {
          setObeeBookingDetailsModal(booking == null ? void 0 : booking.id, "customer");
          onClose();
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { color: theme2.colors.charcoal, width: "18px", height: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Customer profile"))
    ), isEmpty(booking) && !isBlocked && /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles2,
        onClick: () => {
          var _a2;
          const bookingInterval = (_a2 = obeeSettings2.data) == null ? void 0 : _a2.systemTimeInterval;
          const sessionsForDay = getTodaySessions(
            date,
            obeeSessions2,
            "all_sessions",
            (table == null ? void 0 : table.areaId) || "all"
          );
          const availableTimes = getTimeDropdownList(sessionsForDay, null, bookingInterval);
          const newBooking = {
            areaId: table == null ? void 0 : table.areaId,
            tableNumber: table == null ? void 0 : table.tableNumber,
            tableId: table == null ? void 0 : table.tableId,
            minSeats: table == null ? void 0 : table.minSeats,
            time: getNextTime(availableTimes),
            status: STATUS_TYPES.ARRIVED
          };
          setObeeShowAddBookingModal(true, newBooking);
          onClose();
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { color: theme2.colors.charcoal, height: "18px", width: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Add booking"))
    ), !isBlocked ? /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles2,
        onClick: (e) => setBlockAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(IconBlockTable, { style: { color: "theme.colors.charcoal", height: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Block table"))
    ) : /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles2,
        onClick: () => {
          unblockTable2(table, block.id);
          onClose();
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(IconUnblockTable, { style: { color: theme2.colors.charcoal, height: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Unblock table"))
    ))),
    /* @__PURE__ */ React__default.createElement(
      BlockTableTimePopover$1,
      {
        anchorEl: blockAnchorEl,
        onSelect: onClose,
        onClose: () => setBlockAnchorEl(null),
        table,
        closingTime,
        systemTimeInterval: (_a = obeeSettings2.data) == null ? void 0 : _a.systemTimeInterval,
        currentBlock: block,
        todaySessions
      }
    )
  );
};
LiveTableProperties.defaultProps = {
  anchor: null,
  tableId: null,
  bookingId: null,
  closingTime: 1439,
  isAvailable: false,
  inSession: true
};
const mapStateToProps$1A = (state) => ({
  tables: state.tables,
  bookings: state.obeeBookings,
  obeeSettings: state.obeeSettings,
  fullyBookedSessions: state.fullyBookedSessions,
  sessionFilter: state.obeeScreen.sessionFilter,
  obeeSessions: state.obeeSessions,
  date: state.obeeScreen.date
});
LiveTableProperties.propTypes = {
  tableId: PropTypes.number,
  bookingId: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.shape({}),
  tables: tablesPropTypes.isRequired,
  bookings: obeeBookingsPropTypes.isRequired,
  unblockTable: PropTypes.func.isRequired,
  setObeeBookingDetailsModal: PropTypes.func.isRequired,
  closingTime: PropTypes.number,
  setObeeShowAddBookingModal: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  todaySessions: PropTypes.arrayOf(sessionPropTypes).isRequired,
  isAvailable: PropTypes.bool,
  inSession: PropTypes.bool,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired,
  sessionFilter: PropTypes.string.isRequired
};
const mapDispatchToProps$1z = (dispatch) => bindActionCreators(
  {
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction,
    setObeeShowAddBookingModal: setObeeShowAddBookingModalAction,
    unblockTable: unblockTableAction
  },
  dispatch
);
const LiveTableProperties$1 = connect(mapStateToProps$1A, mapDispatchToProps$1z)(LiveTableProperties);
const useStyles$N = createUseStyles(
  (theme2) => ({
    container: {
      display: "flex",
      alignItems: "center",
      // gap: '8px',
      border: `1px solid ${theme2.colors.headerButtonOutline}`,
      borderRadius: "100px",
      backgroundColor: (props) => (props == null ? void 0 : props.disabled) ? theme2.colors.cloud : theme2.colors.alabaster,
      // Keep selectors looking okay on mobile
      "@media (max-width: 408px)": {
        maxWidth: "170px"
      },
      "@media (max-width: 370px)": {
        maxWidth: "160px"
      }
    },
    value: {
      width: "142px",
      height: "38px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: (props) => (props == null ? void 0 : props.canClickValue) ? "pointer" : "default",
      userSelect: "none",
      textAlign: "center",
      backgroundColor: (props) => (props == null ? void 0 : props.disabled) ? theme2.colors.lightShade : theme2.colors.white,
      outline: (props) => (props == null ? void 0 : props.isSelected) ? "1px solid black" : "none",
      overflow: "hidden",
      position: "relative",
      "&:hover": {
        backgroundColor: (props) => {
          var _a;
          return (props == null ? void 0 : props.canClickValue) && !(props == null ? void 0 : props.disabled) ? ((_a = props == null ? void 0 : props.style) == null ? void 0 : _a.buttonHoverBackground) || "#FBFBFB" : (props == null ? void 0 : props.disabled) ? theme2.colors.lightShade : theme2.colors.white;
        }
      },
      [theme2.breakpoints.down("sm")]: {
        width: `115px`,
        fontSize: "15px"
      }
    },
    valueInner: {
      width: "142px",
      maxWidth: "142px"
    },
    arrowContainer: {
      height: "38px",
      width: "36px",
      // borderRadius: '100%',
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background 0.1s",
      "&:hover": {
        background: (props) => (props == null ? void 0 : props.disabled) ? "inherit" : theme2.colors.headerButtonOutline,
        cursor: (props) => (props == null ? void 0 : props.disabled) ? "default" : "pointer"
      }
    },
    leftButton: {
      borderRadius: "100px 0 0 100px"
    },
    rightButton: {
      borderRadius: "0 100px 100px 0"
    },
    arrow: {
      width: "8px"
    }
  }),
  { name: "SelectToggle" }
);
const overrideStyles = createUseStyles(
  {
    container: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.style) == null ? void 0 : _a.container;
    },
    value: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.style) == null ? void 0 : _a.value;
    },
    valueInner: (props) => {
      var _a, _b2, _c2;
      return {
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.valueInner,
        ...((_b2 = props == null ? void 0 : props.value) == null ? void 0 : _b2.length) >= 25 ? { fontSize: ((_c2 = props == null ? void 0 : props.style) == null ? void 0 : _c2.fontSizeSmall) || "12px" } : {}
        // If there's a lot of text, shrink the font size a little
      };
    },
    arrowContainer: (props) => {
      var _a, _b2;
      return {
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.arrowContainer,
        "&:hover": {
          ...(_b2 = props == null ? void 0 : props.style) == null ? void 0 : _b2.arrowContainerHovered
        }
      };
    }
  },
  { name: "SelectToggleOverrides" }
);
const SvgDateSelectRightArrow = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M1 0.999969L7 6.99997L1 13", stroke: "currentColor" }));
const RightArrowSVG = SvgDateSelectRightArrow;
const SelectToggle = ({
  value,
  // Text to show in the middle
  onClickValue,
  // What happens when the middle is clicked
  canClickValue,
  // Whether the part in the middle can be clicked
  isSelected,
  // e.g. if clicking the value opens a popover
  disabled,
  // Disable interactivity
  onNext,
  onPrevious,
  loading,
  // TODO
  style
  // Since this baby is going in the component library
}) => {
  const classes = useStyles$N({ style, canClickValue, isSelected, disabled });
  const extraClasses = overrideStyles({ style, value });
  const handleClick = (e) => {
    if (!canClickValue || loading || disabled) {
      return;
    }
    onClickValue(e);
  };
  const handleNext = (e) => {
    if (loading || disabled) {
      return;
    }
    onNext(e);
  };
  const handlePrevious = (e) => {
    if (loading || disabled) {
      return;
    }
    onPrevious(e);
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.container} ${extraClasses.container}` }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.arrowContainer} ${classes.leftButton} ${extraClasses.arrowContainer} `,
      onClick: handlePrevious,
      onMouseDown: (e) => e.preventDefault()
    },
    /* @__PURE__ */ React__default.createElement(LeftArrowSVG, { className: classes.arrow })
  ), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.value} ${extraClasses.value}`, onClick: handleClick }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.valueInner} ${extraClasses.valueInner}` }, value)), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.arrowContainer} ${classes.rightButton}`,
      onClick: handleNext,
      onMouseDown: (e) => e.preventDefault()
    },
    /* @__PURE__ */ React__default.createElement(RightArrowSVG, { className: classes.arrow })
  ));
};
SelectToggle.defaultProps = {
  canClickValue: false,
  onClickValue: () => {
  },
  onNext: () => {
  },
  onPrevious: () => {
  },
  style: {},
  disabled: false,
  loading: false,
  isSelected: false,
  value: null
};
SelectToggle.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClickValue: PropTypes.func,
  canClickValue: PropTypes.bool,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  style: PropTypes.shape({})
};
const SelectToggle$1 = SelectToggle;
const AreaSelector = ({ areas, value, setValue, loading, onOpen, onClose }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme2 = useTheme$1();
  const areaList = useMemo(() => {
    const areasForList = areas.map((area) => ({
      label: area.name,
      value: area.id
    }));
    return [{ label: "All areas", value: null }, ...areasForList];
  }, [areas]);
  const indexOfCurrent = areaList.findIndex((sessionToCheck) => (sessionToCheck == null ? void 0 : sessionToCheck.value) === value) || 0;
  const handleNext = () => {
    var _a;
    const newIndex = mod(indexOfCurrent + 1, areaList.length);
    setValue((_a = areaList[newIndex]) == null ? void 0 : _a.value);
  };
  const handlePrevious = () => {
    var _a;
    const newIndex = mod(indexOfCurrent - 1, areaList.length);
    setValue((_a = areaList[newIndex]) == null ? void 0 : _a.value);
  };
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
    onOpen(event);
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    SelectToggle$1,
    {
      loading,
      canClickValue: areaList.length > 1,
      onClickValue: handleOpenMenu,
      value: loading ? "" : areaList.length === 0 ? "No areas" : getLabelForValue(value, areaList),
      onNext: handleNext,
      onPrevious: handlePrevious,
      disabled: areaList.length <= 1,
      style: {
        width: "200px",
        container: {
          backgroundColor: theme2.colors.white,
          border: `1px solid ${theme2.colors.yetAnotherGray11}`,
          boxShadow: "0px 4px 6.7px 0px rgba(215, 215, 215, 0.25)"
        },
        value: {
          fontWeight: theme2.fontWeights.medium,
          color: theme2.colors.charcoal
        },
        arrowContainer: { color: theme2.colors.smoke },
        arrowContainerHovered: {
          backgroundColor: theme2.colors.lightButtonHover
        },
        buttonHoverBackground: theme2.colors.lightButtonHover
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: areaList,
      anchor: anchorEl,
      isOpen: !!anchorEl,
      onSelect: (newValue) => {
        setValue(newValue);
        onClose();
      },
      onClose: () => {
        setAnchorEl(null);
        onClose();
      },
      style: listPopoverStyles$2,
      ...popoverAnchors$3
    }
  ));
};
AreaSelector.defaultProps = {
  value: null,
  loading: false,
  onOpen: (e) => e,
  onClose: (e) => e,
  areas: []
};
AreaSelector.propTypes = {
  setValue: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.bool,
  areas: PropTypes.arrayOf(PropTypes.shape({})),
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
const mapStateToProps$1z = () => ({});
const mapDispatchToProps$1y = (dispatch) => bindActionCreators({}, dispatch);
const AreaSelector$1 = connect(mapStateToProps$1z, mapDispatchToProps$1y)(AreaSelector);
const ViewFloorplan = ({
  tables,
  areas,
  obeeBookings: obeeBookings2,
  floorplan,
  fetchFloorplan,
  date,
  updateObeeBooking: updateObeeBooking2,
  obeeAvailability,
  obeeSessions: obeeSessions2,
  obeeSettings: obeeSettings2,
  updateBooking,
  sessionFilter,
  setSessionFilter,
  fullyBookedSessions,
  setObeeShowAddBookingModal,
  setObeeBookingDetailsModal
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j;
  const theme2 = useTheme$1();
  const classes = useStyles$U();
  const currentTime = moment$2();
  const currentTimeAsInt = formatIntFromTime(currentTime);
  const [activeTab, setActiveTab] = useState("bookings");
  const [hoveredTable, setHoveredTable] = useState(null);
  const hoveredTableRef = useRef(null);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);
  const [highlightedTable, setHighlightedTable] = useState(null);
  const [tablePropertiesAnchor, setTablePropertiesAnchor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [bookingsForTableAnchor, setBookingsForTableAnchor] = useState(null);
  const [bookingsForSelectedTable, setBookingsForSelectedTable] = useState([]);
  const [messagesAnchor, setMessagesAnchor] = useState(null);
  const [canvasZoomAnchor, setCanvasZoomAnchor] = useState(null);
  const [areasOpen, setAreasOpen] = useState(false);
  const [showGeneralErrorModal, setShowGeneralErrorModal] = useState(false);
  const [generalErrorPrompt, setGeneralErrorPrompt] = useState(null);
  const [showShortBookingTimeModal, setShowShortBookingTimeModal] = useState(false);
  const [shortBookingTimeData, setShortBookingTimeData] = useState(null);
  const [showTableCapacityModal, setShowTableCapacityModal] = useState(false);
  const [tableCapacityData, setTableCapacityData] = useState(null);
  const [showSwapBookingsModal, setShowSwapBookingsModal] = useState(false);
  const [swapBookingsData, setSwapBookingsData] = useState(null);
  const [focusedArea, setFocusedArea] = useState(null);
  const scrollToTable = useRef(false);
  const [scrollToBooking, setScrollToBooking] = useState(false);
  const joinTables = useRef([]);
  const dragOffset = useRef({ x: 0, y: 0 });
  const closingTime = useRef(null);
  const transformComponentRef = useRef(null);
  const [zoomScale, setZoomScale] = useState(
    ((_c2 = (_b2 = (_a = transformComponentRef == null ? void 0 : transformComponentRef.current) == null ? void 0 : _a.instance) == null ? void 0 : _b2.transformState) == null ? void 0 : _c2.scale) ?? 1
  );
  const inverseZoom = safeDivision(1, zoomScale) ?? 1;
  const areaNegativeOffset = useMemo(() => {
    var _a2, _b3;
    if (!focusedArea) {
      return { x: 0, y: 0 };
    }
    const leftPoint = sortListByProperty(focusedArea.points, "x")[0].x;
    const topPoint = sortListByProperty(focusedArea.points, "y")[0].y;
    const borderOffset = 5;
    return {
      x: ((_a2 = focusedArea == null ? void 0 : focusedArea.bounds) == null ? void 0 : _a2.originX) + leftPoint - borderOffset,
      y: ((_b3 = focusedArea == null ? void 0 : focusedArea.bounds) == null ? void 0 : _b3.originY) + topPoint - borderOffset
    };
  }, [focusedArea]);
  useEffect(() => {
    if (!loading && !loaded) {
      setLoaded(true);
    }
  }, [loading]);
  useEffect(() => {
    const finishedLoading = floorplan.success && obeeBookings2.success && areas.success && tables.success && obeeSessions2.success;
    setLoading(!finishedLoading);
  }, [
    obeeBookings2.success,
    areas.success,
    tables.success,
    floorplan.success,
    obeeSessions2.success
  ]);
  useEffect(() => {
    if (scrollToBooking) {
      setScrollToBooking(false);
    }
  }, [scrollToBooking]);
  useEffect(() => {
    if (isEmpty(floorplan == null ? void 0 : floorplan.data) && areas.data && tables.data && obeeBookings2.data) {
      fetchFloorplan();
    }
  }, [areas.data, tables.data, obeeBookings2.data]);
  useEffect(() => {
    var _a2, _b3;
    joinTables.current = (_b3 = (_a2 = tables == null ? void 0 : tables.data) == null ? void 0 : _a2.filter((table) => !isEmpty(table == null ? void 0 : table.id) || !isEmpty(table == null ? void 0 : table._tempId))) == null ? void 0 : _b3.filter((table) => table.isJoin);
  }, [tables == null ? void 0 : tables.data]);
  const floorplanData = useMemo(() => {
    return getFloorplanData(floorplan, areas, tables);
  }, [floorplan.data, areas.data, tables.data]);
  const floorplanElements = (floorplanData == null ? void 0 : floorplanData.elements) || [];
  const floorplanTables = (floorplanData == null ? void 0 : floorplanData.tables) || [];
  const floorplanAreas = (floorplanData == null ? void 0 : floorplanData.areas) || [];
  const isDrawingRef = useRef(null);
  const canvasRef = useRef(null);
  const canvasWrapperRef = useRef(null);
  const mousePosRef = useRef(null);
  const requestRef = useRef(null);
  const previousTimeRef = useRef();
  const triggerRedrawRef = useRef(false);
  const dragRef = useRef(null);
  const [draggedBooking, setDraggedBooking] = useState(null);
  const [draggedTableBooking, setDraggedTableBooking] = useState(null);
  const formattedDate = formatDate(date, "YYYY-MM-DD");
  const todaySessions = useMemo(() => {
    return getTodaySessions(date, obeeSessions2);
  }, [obeeSessions2.data, date, sessionFilter]);
  useEffect(() => {
    const closingSession = todaySessions == null ? void 0 : todaySessions.reduce(
      (prev, curr) => prev.endTime > curr.endTime ? prev : curr,
      {}
    );
    closingTime.current = (closingSession == null ? void 0 : closingSession.endTime) || 1439;
  }, [todaySessions]);
  const filteredSessions = useMemo(() => {
    return getTodaySessions(date, obeeSessions2, sessionFilter);
  }, [obeeSessions2.data, date, sessionFilter]);
  const dateIsToday = formattedDate === formatDate(moment$2(), "YYYY-MM-DD");
  const activeSessions = filteredSessions.filter((session) => {
    if (sessionFilter !== "all_sessions") {
      return session.label === sessionFilter;
    }
    if (!dateIsToday) {
      return true;
    }
    return session.startTime <= currentTimeAsInt && session.endTime > currentTimeAsInt;
  });
  const filteredBookings = useMemo(() => {
    return getBookingsForSessions(
      obeeBookings2.data,
      filteredSessions,
      true,
      sessionFilter === "all_sessions"
    ).filter((booking) => (booking == null ? void 0 : booking.date) === formatDate(date, "YYYY-MM-DD"));
  }, [filteredSessions, obeeBookings2.data]);
  const filteredAreas = useMemo(
    () => floorplanAreas.filter((area) => {
      if (isVoid(focusedArea)) {
        return true;
      }
      return (area == null ? void 0 : area.id) === (focusedArea == null ? void 0 : focusedArea.id);
    }),
    [focusedArea, floorplanAreas]
  );
  const handleSetFocusedArea = (newFocusedArea) => {
    var _a2;
    setFocusedArea(newFocusedArea);
    (_a2 = transformComponentRef.current) == null ? void 0 : _a2.setTransform(0, 0, zoomScale);
    setTimeout(() => {
      var _a3;
      (_a3 = transformComponentRef.current) == null ? void 0 : _a3.setTransform(0, 0, zoomScale, 50);
    }, 50);
  };
  const scrollToTableBounds = useRef({});
  const scrollRef = useRef(null);
  useEffect(() => {
    var _a2, _b3;
    if (selectedBooking && (scrollToTable == null ? void 0 : scrollToTable.current) && scrollRef.current) {
      const tableForSelection = (_a2 = tables == null ? void 0 : tables.data) == null ? void 0 : _a2.find(
        (table) => isTableForBooking(table, selectedBooking)
      );
      const floorplanTable = findObjectByProperty(floorplanTables, tableForSelection == null ? void 0 : tableForSelection.id, "id");
      scrollToTableBounds.current = floorplanTable == null ? void 0 : floorplanTable.bounds;
      (_b3 = transformComponentRef.current) == null ? void 0 : _b3.zoomToElement(scrollRef.current, zoomScale, 200);
      scrollToTable.current = false;
    }
  }, [selectedBooking, scrollToTable.current, zoomScale]);
  const setZoom = (newZoom, newXPosition = 0, newYPosition = 0, instant = false) => {
    var _a2, _b3;
    if (instant) {
      (_a2 = transformComponentRef.current) == null ? void 0 : _a2.setTransform(newXPosition, newYPosition, newZoom, 0, "linear");
    } else {
      (_b3 = transformComponentRef.current) == null ? void 0 : _b3.setTransform(newXPosition, newYPosition, newZoom);
    }
    setZoomScale(newZoom);
  };
  const [showPrintView, setShowPrintView] = useState(false);
  window.onbeforeprint = useCallback(() => {
    setShowPrintView(true);
  }, []);
  window.onafterprint = useCallback(() => {
    setShowPrintView(false);
    setZoom(1);
  }, []);
  const canvasDimensions = useMemo(() => {
    var _a2, _b3, _c3, _d3;
    if (isEmpty(filteredAreas)) {
      return { width: 0, height: 0 };
    }
    const canvasMargin = 5;
    const minCanvasWidth = 500;
    const minCanvasHeight = 500;
    const canvasRightPadding = showPrintView ? 80 : 200;
    const canvasBottomPadding = showPrintView ? 80 : 200;
    let canvasWidth = minCanvasWidth;
    let canvasHeight = minCanvasHeight;
    if (focusedArea) {
      canvasWidth = (_a2 = focusedArea == null ? void 0 : focusedArea.bounds) == null ? void 0 : _a2.width;
      canvasHeight = (_b3 = focusedArea == null ? void 0 : focusedArea.bounds) == null ? void 0 : _b3.height;
    } else {
      floorplanAreas == null ? void 0 : floorplanAreas.forEach((floorplanArea) => {
        var _a3;
        (_a3 = floorplanArea == null ? void 0 : floorplanArea.points) == null ? void 0 : _a3.forEach((point) => {
          if (point.x + floorplanArea.x > canvasWidth) {
            canvasWidth = point.x + floorplanArea.x;
          }
          if (point.y + floorplanArea.y > canvasHeight) {
            canvasHeight = point.y + floorplanArea.y;
          }
        });
      });
    }
    const increment = 1;
    canvasWidth = Math.ceil(canvasWidth / increment) * increment;
    canvasHeight = Math.ceil(canvasHeight / increment) * increment;
    const widthNoPadding = canvasWidth;
    const heightNoPadding = canvasHeight;
    canvasWidth += canvasMargin + canvasRightPadding;
    canvasHeight += canvasMargin + canvasBottomPadding;
    return {
      width: canvasWidth,
      height: canvasHeight,
      focusedAreaWidth: (_c3 = focusedArea == null ? void 0 : focusedArea.bounds) == null ? void 0 : _c3.width,
      focusedAreaHeight: (_d3 = focusedArea == null ? void 0 : focusedArea.bounds) == null ? void 0 : _d3.height,
      widthNoPadding,
      heightNoPadding
    };
  }, [filteredAreas, focusedArea, showPrintView]);
  const fitFloorplanToScreen = useCallback(() => {
    const pageMargins = 230;
    const pageScale = 1;
    let a4PageWidth = pageScale * 1240 - pageMargins;
    let a4PageHeight = pageScale * 1754 - pageMargins;
    {
      const temp = a4PageWidth;
      a4PageWidth = a4PageHeight;
      a4PageHeight = temp;
    }
    const xScale = canvasDimensions.width / a4PageWidth;
    const yScale = canvasDimensions.height / a4PageHeight;
    let scaleToFit = safeDivision(1, Math.max(xScale, yScale));
    scaleToFit = Math.floor(scaleToFit * 100) / 100;
    setZoom(scaleToFit, 0, 0, true);
  }, [
    canvasDimensions,
    setZoomScale,
    (_f = (_e2 = (_d2 = transformComponentRef == null ? void 0 : transformComponentRef.current) == null ? void 0 : _d2.instance) == null ? void 0 : _e2.transformState) == null ? void 0 : _f.scale
  ]);
  useEffect(() => {
    if (showPrintView) {
      fitFloorplanToScreen();
    }
  }, [showPrintView]);
  const simplePinchZoomCancel = (e) => {
    if (e.ctrlKey) {
      e.preventDefault();
    }
  };
  const disableRightClickTest = (e) => {
    e.preventDefault();
  };
  const onWheel = (e) => {
    var _a2, _b3, _c3, _d3, _e3, _f2, _g2, _h2, _i2, _j2, _k, _l, _m;
    if (e.ctrlKey) {
      e.stopPropagation();
      const pinchSpeed = 5e-3;
      const newZoom = Math.min(Math.max(0.5, zoomScale - e.deltaY * pinchSpeed * zoomScale), 2);
      setZoom(
        newZoom,
        (_c3 = (_b3 = (_a2 = transformComponentRef == null ? void 0 : transformComponentRef.current) == null ? void 0 : _a2.instance) == null ? void 0 : _b3.transformState) == null ? void 0 : _c3.positionX,
        (_f2 = (_e3 = (_d3 = transformComponentRef == null ? void 0 : transformComponentRef.current) == null ? void 0 : _d3.instance) == null ? void 0 : _e3.transformState) == null ? void 0 : _f2.positionY,
        true
      );
      return;
    }
    const xMovement = e == null ? void 0 : e.deltaX;
    const yMovement = e == null ? void 0 : e.deltaY;
    const maxExtraXDistance = canvasDimensions.width / 2;
    const maxExtraYDistance = canvasDimensions.height / 2;
    const minWidthAndHeight = 200;
    const newXPos = Math.max(
      Math.min(0, ((_i2 = (_h2 = (_g2 = transformComponentRef == null ? void 0 : transformComponentRef.current) == null ? void 0 : _g2.instance) == null ? void 0 : _h2.transformState) == null ? void 0 : _i2.positionX) - xMovement),
      -Math.max(minWidthAndHeight, canvasDimensions.width - maxExtraXDistance)
    );
    const newYPos = Math.max(
      Math.min(0, ((_l = (_k = (_j2 = transformComponentRef == null ? void 0 : transformComponentRef.current) == null ? void 0 : _j2.instance) == null ? void 0 : _k.transformState) == null ? void 0 : _l.positionY) - yMovement),
      -Math.max(minWidthAndHeight, canvasDimensions.height - maxExtraYDistance)
    );
    (_m = transformComponentRef == null ? void 0 : transformComponentRef.current) == null ? void 0 : _m.setTransform(newXPos, newYPos, zoomScale, 0, "linear");
    e.stopPropagation();
  };
  const disableMultiTouch = (e) => {
    if (e.scale && e.scale !== 1) {
      e.preventDefault();
      return;
    }
    if (e.touches.length > 1)
      ;
  };
  const touchSwipe = (e) => {
    if (e.scale && e.scale !== 1) {
      e.preventDefault();
      return;
    }
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    const object = canvasWrapperRef.current;
    object == null ? void 0 : object.addEventListener("wheel", simplePinchZoomCancel, { passive: false });
    object == null ? void 0 : object.addEventListener("touchSwipe", touchSwipe, { passive: false });
    document.addEventListener("wheel", simplePinchZoomCancel, { passive: false });
    document.addEventListener("touchmove", disableMultiTouch, { passive: false });
    return () => {
      object == null ? void 0 : object.removeEventListener("wheel", simplePinchZoomCancel, { passive: false });
      object == null ? void 0 : object.removeEventListener("touchSwipe", touchSwipe, { passive: false });
      document.removeEventListener("wheel", simplePinchZoomCancel, { passive: false });
      document.removeEventListener("touchmove", disableMultiTouch, { passive: false });
    };
  }, [canvasWrapperRef.current]);
  const waitlistDragRef = useRef();
  const attemptSwap = (bookingToCheck, tableBookings, table, time) => {
    const seatableStatuses = getSeatableStatuses();
    const bookingToSwap = tableBookings == null ? void 0 : tableBookings.find(
      (booking) => time === booking.time && booking.id !== bookingToCheck.id && seatableStatuses.includes(booking.status)
    );
    if (bookingToSwap) {
      const bookingToCheckConflict = getSwapConflict(
        bookingToCheck,
        bookingToSwap,
        tables,
        obeeBookings2 == null ? void 0 : obeeBookings2.data
      );
      const bookingToSwapConflict = getSwapConflict(
        bookingToSwap,
        bookingToCheck,
        tables,
        obeeBookings2 == null ? void 0 : obeeBookings2.data
      );
      const isValidSwap = !bookingToCheckConflict && !bookingToSwapConflict;
      if (isValidSwap) {
        unstable_batchedUpdates(() => {
          setShowSwapBookingsModal(true);
          setSwapBookingsData({ booking: bookingToCheck, bookingToSwap });
        });
      } else {
        unstable_batchedUpdates(() => {
          setShowGeneralErrorModal(true);
          setGeneralErrorPrompt("One or more bookings breach multiple conflicting rules.");
        });
      }
      return true;
    }
    return false;
  };
  const bookingCanMoveToTable = (booking) => {
    const destinationTable = hoveredTableRef.current;
    const sessionsToUse = todaySessions.filter(
      (session) => session.areaId === destinationTable.areaId
    );
    const sessionsForTable = sessionsToUse == null ? void 0 : sessionsToUse.filter(
      (session) => (session == null ? void 0 : session.areaId) === 0 || (session == null ? void 0 : session.areaId) === (destinationTable == null ? void 0 : destinationTable.areaId)
    );
    const isInSession = sessionsForTable.some(
      (session) => (booking == null ? void 0 : booking.startTime) >= session.startTime && (booking == null ? void 0 : booking.startTime) < session.endTime
    );
    if (!isInSession) {
      unstable_batchedUpdates(() => {
        setShowGeneralErrorModal(true);
        setGeneralErrorPrompt(
          `There is no session for table ${destinationTable.tableNumber} at ${formatTimeFromInt(
            booking == null ? void 0 : booking.startTime
          )}.`
        );
      });
      return false;
    }
    const block = getTableBlockForTime(destinationTable, booking == null ? void 0 : booking.startTime);
    if (block) {
      setShowGeneralErrorModal(true);
      setGeneralErrorPrompt(`Table is blocked till ${formatTimeFromInt(block.endTime)}.`);
      return false;
    }
    const tableBookings = filteredBookings.filter(
      (bookingToFilter) => isTableForBooking(destinationTable, bookingToFilter)
    );
    if (isTableInUse(booking, tableBookings, booking == null ? void 0 : booking.startTime, booking.status === "waitlist")) {
      unstable_batchedUpdates(() => {
        setShowGeneralErrorModal(true);
        setGeneralErrorPrompt("Table has conflicting bookings.");
      });
      return false;
    }
    if (attemptSwap(booking, tableBookings, destinationTable, booking == null ? void 0 : booking.startTime)) {
      return false;
    }
    const exceedsTableCapacityConflict = exceedsTableCapacity(booking, destinationTable);
    if (exceedsTableCapacityConflict) {
      unstable_batchedUpdates(() => {
        setShowTableCapacityModal(true);
        setTableCapacityData({
          booking,
          conflict: destinationTable,
          over: {
            areaId: destinationTable.areaId,
            tableNumber: destinationTable.tableNumber,
            time: booking == null ? void 0 : booking.startTime
          }
        });
      });
      return false;
    }
    const shortBookingConflict = getShortBookingConflict(
      booking,
      tableBookings,
      destinationTable,
      booking == null ? void 0 : booking.startTime
    );
    if (shortBookingConflict) {
      unstable_batchedUpdates(() => {
        setShowShortBookingTimeModal(true);
        setShortBookingTimeData({
          booking,
          conflict: shortBookingConflict,
          over: {
            areaId: destinationTable.areaId,
            tableNumber: destinationTable.tableNumber,
            table: destinationTable,
            time: booking == null ? void 0 : booking.startTime
          }
        });
      });
      return false;
    }
    return true;
  };
  const onStopDraggingBooking = (booking) => {
    var _a2, _b3;
    setDraggedBooking(null);
    if (hoveredTableRef.current === null || isTableForBooking(hoveredTableRef.current, booking)) {
      return;
    }
    if (!bookingCanMoveToTable(booking)) {
      return;
    }
    const updatedBooking = {
      ...booking,
      status: STATUS_TYPES.BOOKED,
      tableNumber: (_a2 = hoveredTableRef.current) == null ? void 0 : _a2.tableNumber,
      areaId: (_b3 = hoveredTableRef.current) == null ? void 0 : _b3.areaId
    };
    updateObeeBooking2(updatedBooking);
  };
  const selectBookingFromList = useCallback(
    (booking) => {
      var _a2;
      if (!findObjectByProperty(filteredBookings, booking == null ? void 0 : booking.id, "id")) {
        setSessionFilter("all_sessions");
      }
      setSelectedBooking(booking);
      scrollToTable.current = true;
      const tableForSelection = (_a2 = tables == null ? void 0 : tables.data) == null ? void 0 : _a2.find((table) => isTableForBooking(table, booking));
      const floorplanTable = findObjectByProperty(floorplanTables, tableForSelection == null ? void 0 : tableForSelection.id, "id");
      scrollToTableBounds.current = floorplanTable == null ? void 0 : floorplanTable.bounds;
    },
    [filteredBookings]
  );
  const selectBookingFromTable = (booking) => {
    if (!isEmpty(draggedTableBooking)) {
      return;
    }
    setSelectedTable(null);
    setSelectedBooking(booking);
    if (!scrollToBooking) {
      setScrollToBooking(true);
    }
    setActiveTab("bookings");
  };
  const onStartDraggingTableBooking = (booking, tableForBooking, extraOffset = null) => {
    var _a2;
    devLog("info", "started dragging booking", tableForBooking);
    hoveredTableRef.current = tableForBooking;
    setHoveredTable(tableForBooking);
    setSelectedBooking(booking);
    setDraggedTableBooking({ ...booking, table: tableForBooking });
    setObeeShowAddBookingModal(false);
    setObeeBookingDetailsModal(false);
    const originalTableBounds = (_a2 = findObjectByProperty(
      floorplanTables,
      tableForBooking == null ? void 0 : tableForBooking.id,
      "id"
    )) == null ? void 0 : _a2.bounds;
    const originalCanvasRect = canvasRef.current.getBoundingClientRect();
    dragOffset.current = {
      x: originalTableBounds.x + ((extraOffset == null ? void 0 : extraOffset.x) || 0),
      y: originalTableBounds.y + ((extraOffset == null ? void 0 : extraOffset.y) || 0),
      originalTableBounds,
      originalCanvasRect
    };
  };
  const onStopDraggingTableBooking = () => {
    var _a2, _b3;
    devLog("info", "stopped dragging booking");
    const bookingToUse = draggedTableBooking;
    setDraggedTableBooking(null);
    dragOffset.current = {
      x: 0,
      y: 0
    };
    if (bookingToUse === null || hoveredTableRef.current === null || isTableForBooking(hoveredTableRef.current, bookingToUse)) {
      return;
    }
    if (!bookingCanMoveToTable(bookingToUse)) {
      return;
    }
    const updatedBooking = {
      ...bookingToUse,
      tableNumber: (_a2 = hoveredTableRef.current) == null ? void 0 : _a2.tableNumber,
      areaId: (_b3 = hoveredTableRef.current) == null ? void 0 : _b3.areaId
    };
    updateObeeBooking2(updatedBooking);
  };
  const availableTables = obeeAvailability == null ? void 0 : obeeAvailability.data;
  const drawArea = (ctx, floorplanArea) => {
    var _a2;
    if (!floorplanArea) {
      return;
    }
    const areaData = findObjectByProperty(areas == null ? void 0 : areas.data, floorplanArea == null ? void 0 : floorplanArea.id, "id");
    const isCapacity = isAreaCapacityBased(areaData, tables == null ? void 0 : tables.data);
    const getFillStyle = () => {
      if (isCapacity) {
        return theme2.colors.gray7;
      }
      return floorplanArea.type === "outdoor" ? theme2.colors.outdoorAreaBackground : theme2.colors.white;
    };
    ctx.fillStyle = getFillStyle();
    const pointsWithOffset = (_a2 = floorplanArea == null ? void 0 : floorplanArea.points) == null ? void 0 : _a2.map((point) => ({
      x: (point == null ? void 0 : point.x) + (floorplanArea == null ? void 0 : floorplanArea.x) - areaNegativeOffset.x,
      y: (point == null ? void 0 : point.y) + (floorplanArea == null ? void 0 : floorplanArea.y) - areaNegativeOffset.y
    }));
    drawShape(ctx, pointsWithOffset);
    if (floorplanArea.type === "outdoor") {
      ctx.lineWidth = 1;
      ctx.strokeStyle = theme2.colors.nimbus;
      ctx.setLineDash([5, 3]);
      ctx.stroke();
    } else {
      ctx.lineWidth = 1;
      ctx.strokeStyle = theme2.colors.gray4;
      ctx.setLineDash([]);
      ctx.stroke();
    }
  };
  const draw = (ctx) => {
    isDrawingRef.current = true;
    ctx.scale(1, 1);
    filteredAreas.forEach((floorplanArea) => {
      drawArea(ctx, floorplanArea);
    });
    filteredAreas.forEach((floorplanArea) => {
      const elementsForArea = floorplanElements.filter(
        (element) => (element == null ? void 0 : element.areaId) === (floorplanArea == null ? void 0 : floorplanArea.id)
      );
      elementsForArea.forEach((element) => {
        const elementBounds = element == null ? void 0 : element.bounds;
        drawElement(
          ctx,
          elementBounds.originX - areaNegativeOffset.x,
          elementBounds.originY - areaNegativeOffset.y,
          element,
          elementBounds,
          element.rotation,
          false,
          false,
          theme2
        );
      });
    });
    filteredAreas.forEach((floorplanArea) => {
      const tablesForArea = tables == null ? void 0 : tables.data.filter((table) => (table == null ? void 0 : table.areaId) === (floorplanArea == null ? void 0 : floorplanArea.id));
      const areaIsInSession = activeSessions.some(
        (activeSession) => (activeSession == null ? void 0 : activeSession.areaId) === (floorplanArea == null ? void 0 : floorplanArea.id)
      );
      tablesForArea.filter((table) => !table.isJoin).forEach((table) => {
        var _a2;
        const floorplanTable = findObjectByProperty(floorplanTables, table == null ? void 0 : table.id, "id");
        if (!floorplanTable) {
          console.error(
            "NO FLOOR PLAN TABLE. THIS SHOULDN'T HAPPEN. DID YOU NOT FETCH THE FLOOR PLAN?"
          );
          return;
        }
        let tableBounds = floorplanTable == null ? void 0 : floorplanTable.bounds;
        if (focusedArea) {
          tableBounds = {
            ...tableBounds,
            topLeftX: tableBounds.topLeftX - areaNegativeOffset.x,
            topLeftY: tableBounds.topLeftY - areaNegativeOffset.y,
            originX: tableBounds.originX - areaNegativeOffset.x,
            originY: tableBounds.originY - areaNegativeOffset.y
          };
        }
        let bookingsForTable = getBookingsForTable(table, filteredBookings);
        bookingsForTable = sortListByProperty(bookingsForTable, "startTime");
        const latestBooking = getBookingToShowOnTable(bookingsForTable, currentTimeAsInt);
        const isDragged = draggedBooking !== null || draggedTableBooking !== null;
        const draggedOffTable = draggedTableBooking !== null && (draggedTableBooking == null ? void 0 : draggedTableBooking.tableNumber) === (table == null ? void 0 : table.tableNumber);
        const block = getBlockForTable(
          latestBooking,
          table == null ? void 0 : table.tableNumber,
          tables,
          currentTimeAsInt
        );
        const fullyBooked = getFullyBookedSessionForTable(
          fullyBookedSessions.data,
          sessionFilter,
          table,
          currentTimeAsInt
        );
        const joinedTables = (latestBooking == null ? void 0 : latestBooking.tableNumbers) || [table == null ? void 0 : table.tableNumber];
        const isAvailable = findObjectByProperty(availableTables, table == null ? void 0 : table.areaId, "areaId");
        const isHovered = joinedTables.includes((_a2 = hoveredTableRef.current) == null ? void 0 : _a2.tableNumber);
        const isSelected = isTableForBooking(table, selectedBooking);
        const showPotentialOutline = isDragged && isAvailable;
        const showBookingDragOutline = isDragged && isHovered && isAvailable;
        if (isHovered || showPotentialOutline) {
          ctx.fillStyle = "transparent";
          ctx.setLineDash([]);
          ctx.strokeStyle = "black";
          ctx.strokeWidth = 1;
          ctx.lineWidth = 1;
          const offsetFix = 10;
          const padding = 2;
          drawRoundedRect(
            ctx,
            tableBounds.topLeftX - offsetFix - padding,
            tableBounds.topLeftY - offsetFix - padding,
            tableBounds.width + 2 * padding,
            tableBounds.height + 2 * padding,
            0
          );
        }
        if (isSelected || isTableForBooking(table, highlightedTable)) {
          ctx.fillStyle = "transparent";
          ctx.setLineDash([]);
          ctx.strokeStyle = theme2.colors.black;
          ctx.strokeWidth = 2;
          ctx.lineWidth = 2;
          const offsetFix = 10;
          const padding = 2;
          drawRoundedRect(
            ctx,
            tableBounds.topLeftX - offsetFix - padding,
            tableBounds.topLeftY - offsetFix - padding,
            tableBounds.width + 2 * padding,
            tableBounds.height + 2 * padding,
            0
          );
        }
        const { outline, fill } = getAvailabilityColours({
          showBookingDragOutline,
          draggedOffTable,
          theme: theme2,
          block,
          fullyBooked,
          latestBooking,
          areaIsInSession
        });
        drawTable(
          ctx,
          tableBounds.originX,
          tableBounds.originY,
          table,
          floorplanTable,
          tableBounds,
          theme2,
          false,
          outline,
          fill
        );
      });
    });
  };
  const redraw = () => {
    triggerRedrawRef.current = true;
  };
  const update = (time) => {
    if (canvasRef.current && triggerRedrawRef.current) {
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
      triggerRedrawRef.current = false;
      draw(context);
      requestRef.current = requestAnimationFrame(update);
    }
    previousTimeRef.current = time;
  };
  useEffect(() => {
    if (requestRef.current) {
      cancelAnimationFrame(requestRef.current);
    }
    requestRef.current = requestAnimationFrame(update);
    return () => cancelAnimationFrame(requestRef.current);
  }, [
    canvasRef.current,
    floorplanData,
    hoveredTable,
    hoveredTableRef.current,
    obeeAvailability == null ? void 0 : obeeAvailability.data,
    filteredBookings,
    tables == null ? void 0 : tables.data,
    draggedBooking == null ? void 0 : draggedBooking.id,
    highlightedTable == null ? void 0 : highlightedTable.tableNumber,
    highlightedTable == null ? void 0 : highlightedTable.areaId,
    draggedTableBooking,
    selectedBooking == null ? void 0 : selectedBooking.id,
    canvasDimensions,
    focusedArea
  ]);
  useEffect(() => {
    redraw();
  }, [
    floorplanData,
    hoveredTable,
    hoveredTableRef.current,
    obeeAvailability == null ? void 0 : obeeAvailability.data,
    filteredBookings,
    tables == null ? void 0 : tables.data,
    draggedBooking == null ? void 0 : draggedBooking.id,
    highlightedTable == null ? void 0 : highlightedTable.tableNumber,
    highlightedTable == null ? void 0 : highlightedTable.areaId,
    draggedTableBooking,
    selectedBooking,
    canvasDimensions,
    focusedArea
  ]);
  const handleMouseOverCanvas = useCallback(
    (mouseX, mouseY) => {
      var _a2;
      mousePosRef.current = { x: mouseX, y: mouseY };
      if (mouseX < 0 || mouseY < 0) {
        setHoveredTable(null);
        hoveredTableRef.current = null;
        return;
      }
      if ((bookingsForTableAnchor == null ? void 0 : bookingsForTableAnchor.anchorEl) && !draggedTableBooking) {
        return;
      }
      const mousePoint = {
        x: mousePosRef.current.x + areaNegativeOffset.x,
        y: mousePosRef.current.y + areaNegativeOffset.y
      };
      const areaForPoint = getAreaForPoint(mousePoint, filteredAreas, 10);
      if (!areaForPoint) {
        hoveredTableRef.current = null;
        setHoveredTable(null);
        return;
      }
      if (!isEmpty(tablePropertiesAnchor || messagesAnchor || canvasZoomAnchor) || areasOpen) {
        return;
      }
      const areaBounds = areaForPoint == null ? void 0 : areaForPoint.bounds;
      const tablesForArea = tables == null ? void 0 : tables.data.filter((table) => (table == null ? void 0 : table.areaId) === (areaForPoint == null ? void 0 : areaForPoint.id));
      const tableForPoint = getTableForPoint(
        mousePoint,
        floorplanTables,
        tablesForArea,
        10,
        areaBounds,
        5,
        5,
        5,
        5,
        (_a2 = hoveredTableRef.current) == null ? void 0 : _a2.id
      );
      hoveredTableRef.current = tableForPoint;
      setHoveredTable(tableForPoint);
    },
    [
      areaNegativeOffset,
      bookingsForTableAnchor == null ? void 0 : bookingsForTableAnchor.anchorEl,
      filteredAreas,
      floorplanTables,
      messagesAnchor,
      tablePropertiesAnchor,
      tables == null ? void 0 : tables.data,
      canvasZoomAnchor,
      areasOpen
    ]
  );
  const handleMouseOnCanvas = useCallback(
    (event) => {
      const rect = canvasRef.current.getBoundingClientRect();
      const mouseX = (event.clientX - rect.left) * inverseZoom;
      const mouseY = (event.clientY - rect.top) * inverseZoom;
      return handleMouseOverCanvas(mouseX, mouseY, zoomScale);
    },
    [zoomScale, handleMouseOverCanvas]
  );
  const onStartDraggingBooking = (booking, e) => {
    setDraggedBooking(booking);
    const bookingToDragEl = e.target.closest("[data-booking]") || waitlistDragRef.current;
    if (bookingToDragEl) {
      waitlistDragRef.current = bookingToDragEl;
    }
    if (!bookingToDragEl) {
      return;
    }
    const { x, y, width, height } = bookingToDragEl.getBoundingClientRect();
    const middleX = x + width / 2;
    const middleY = y + height / 2;
    const areaForPoint = getAreaForPoint({ x: middleX, y: middleY }, filteredAreas, 10);
    if (!areaForPoint) {
      hoveredTableRef.current = null;
      setHoveredTable(null);
      return;
    }
    if (!isEmpty(tablePropertiesAnchor || messagesAnchor || canvasZoomAnchor) || areasOpen) {
      return;
    }
    const tableElement = document.elementsFromPoint(middleX, middleY).find((element) => element.getAttribute("data-table") !== null);
    if (!tableElement) {
      setSelectedTable(null);
      return;
    }
    const tableId = tableElement.getAttribute("data-table");
    const table = findObjectByProperty(tables.data, parseInt(tableId, 10), "id");
    setSelectedTable(table);
    setHoveredTable(table);
    hoveredTableRef.current = table;
  };
  const onDragTableBooking = (event, data) => {
    var _a2, _b3, _c3, _d3, _e3, _f2, _g2, _h2, _i2, _j2;
    if (dragRef.current) {
      const bookingWidth = 40;
      const bookingHeight = 40;
      if (dragRef == null ? void 0 : dragRef.current) {
        let mouseXPosOnScreen = event == null ? void 0 : event.clientX;
        let mouseYPosOnScreen = event == null ? void 0 : event.clientY;
        if (event.type === "touchstart" || event.type === "touchmove" || event.type === "touchend" || event.type === "touchcancel") {
          const { changedTouches } = (event == null ? void 0 : event.originalEvent) ?? event;
          const touch = changedTouches[0];
          mouseXPosOnScreen = touch.pageX;
          mouseYPosOnScreen = touch.pageY;
        }
        const scrollMargin = 200;
        let xScrollAmount = 0;
        let yScrollAmount = 0;
        const topOffset = 70;
        const leftOffset = 200;
        const scrollSpeed = 0.1;
        const actualAvailableHeight = document.documentElement.clientHeight;
        const actualAvailableWidth = document.documentElement.clientWidth;
        if (mouseXPosOnScreen <= leftOffset + scrollMargin) {
          const scrollPower = (leftOffset + scrollMargin - mouseXPosOnScreen) * zoomScale * scrollSpeed;
          xScrollAmount = -scrollPower;
        }
        if (mouseXPosOnScreen >= actualAvailableWidth - scrollMargin) {
          const scrollPower = (actualAvailableWidth - scrollMargin - mouseXPosOnScreen) * zoomScale * scrollSpeed;
          xScrollAmount = -scrollPower;
        }
        if (mouseYPosOnScreen <= topOffset + scrollMargin) {
          if (((_c3 = (_b3 = (_a2 = transformComponentRef.current) == null ? void 0 : _a2.instance) == null ? void 0 : _b3.transformState) == null ? void 0 : _c3.positionY) <= 0) {
            const scrollPower = (topOffset + scrollMargin - mouseYPosOnScreen) * zoomScale * scrollSpeed;
            yScrollAmount = -scrollPower;
          }
        }
        if (mouseYPosOnScreen >= actualAvailableHeight - scrollMargin) {
          const scrollPower = (mouseYPosOnScreen - (actualAvailableHeight - scrollMargin)) * zoomScale * scrollSpeed;
          yScrollAmount = scrollPower;
        }
        const maxScrollPower = 10;
        if (xScrollAmount < -maxScrollPower) {
          xScrollAmount = -maxScrollPower;
        }
        if (xScrollAmount > maxScrollPower) {
          xScrollAmount = maxScrollPower;
        }
        if (yScrollAmount < -maxScrollPower) {
          yScrollAmount = -maxScrollPower;
        }
        if (yScrollAmount > maxScrollPower) {
          yScrollAmount = maxScrollPower;
        }
        const minWidthAndHeight = 1200;
        const newXPos = Math.max(
          Math.min(
            0,
            ((_f2 = (_e3 = (_d3 = transformComponentRef.current) == null ? void 0 : _d3.instance) == null ? void 0 : _e3.transformState) == null ? void 0 : _f2.positionX) - xScrollAmount
          ),
          -Math.max(minWidthAndHeight, canvasDimensions.width)
        );
        const newYPos = Math.max(
          Math.min(
            0,
            ((_i2 = (_h2 = (_g2 = transformComponentRef.current) == null ? void 0 : _g2.instance) == null ? void 0 : _h2.transformState) == null ? void 0 : _i2.positionY) - yScrollAmount
          ),
          -Math.max(minWidthAndHeight, canvasDimensions.height)
        );
        (_j2 = transformComponentRef.current) == null ? void 0 : _j2.setTransform(newXPos, newYPos, zoomScale, 0, "linear");
      }
      handleMouseOverCanvas(
        data.x + bookingWidth + dragOffset.current.x,
        data.y + bookingHeight + dragOffset.current.y
      );
    }
  };
  if (!loaded && loading) {
    return /* @__PURE__ */ React__default.createElement(
      Skeleton$1,
      {
        height: 800,
        style: {
          skeleton: {
            backgroundColor: theme2.colors.loadingShimmer
          }
        }
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageContent, onMouseMove: (e) => handleMouseOnCanvas(e) }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.hiddenFromPrint }, /* @__PURE__ */ React__default.createElement(
    BookingsSidebar$1,
    {
      selectedBooking,
      onStartDragging: onStartDraggingBooking,
      onStopDragging: onStopDraggingBooking,
      selectBooking: selectBookingFromList,
      hoveredTable: hoveredTableRef.current,
      setHighlightedTable,
      activeTab,
      setActiveTab,
      scrollToBooking,
      draggedBooking,
      loading: !loaded && loading,
      bookings: filteredBookings,
      messagesAnchor,
      setMessagesAnchor: (e) => {
        if (isVoid(e)) {
          setSelectedBooking(null);
        }
        setMessagesAnchor(e);
      },
      focusedArea: (focusedArea == null ? void 0 : focusedArea.id) ?? null,
      setFocusedArea: (newFocusedAreaId) => handleSetFocusedArea(findObjectByProperty(floorplanAreas, newFocusedAreaId, "id")),
      thinDraggedBookings: false
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.canvasWrapper, ref: canvasWrapperRef }, /* @__PURE__ */ React__default.createElement(
    TransformWrapper,
    {
      minScale: 0.5,
      maxScale: 2,
      initialPositionX: 0,
      initialPositionY: 0,
      minPositionX: 0,
      minPositionY: 0,
      maxPositionX: (_g = mousePosRef == null ? void 0 : mousePosRef.current) == null ? void 0 : _g.x,
      maxPositionY: (_h = mousePosRef == null ? void 0 : mousePosRef.current) == null ? void 0 : _h.y,
      pinch: { step: 1 },
      wheel: {
        touchPadDisabled: false,
        // To get pinch zoom working on trackpad
        disabled: false,
        activationKeys: ["Meta", "Ctrl", "Alt"]
      },
      panning: {
        velocityDisabled: true,
        // disabled: !!draggedTableBooking,
        excluded: ["booking-card", "react-draggable"]
      },
      doubleClick: { disabled: true },
      ref: transformComponentRef,
      onTransformed: (instance) => {
        var _a2;
        setZoomScale(((_a2 = instance == null ? void 0 : instance.state) == null ? void 0 : _a2.scale) ?? 1);
      }
    },
    ({ resetTransform: resetTransform2, instance }) => {
      var _a2, _b3, _c3, _d3;
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.hiddenFromPrint }, /* @__PURE__ */ React__default.createElement(
        Spacer,
        {
          gap: 10,
          className: classes.zoomToolbar,
          style: {
            opacity: draggedBooking || draggedTableBooking ? "0.5" : 1,
            pointerEvents: draggedBooking || draggedTableBooking ? "none" : "auto"
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
          RoundButton,
          {
            style: {
              button: {
                minWidth: "100px",
                borderRadius: "80px",
                height: "40px",
                padding: "0 12px"
              }
            },
            onClick: (e) => {
              setCanvasZoomAnchor(e.currentTarget);
              e.stopPropagation();
            }
          },
          /* @__PURE__ */ React__default.createElement(Spacer, { gap: 8, style: { width: "100%" } }, /* @__PURE__ */ React__default.createElement(ZoomSVG, { style: { width: "16px" } }), /* @__PURE__ */ React__default.createElement("span", null, Math.round(zoomScale * 100), "%"))
        ), /* @__PURE__ */ React__default.createElement(
          ListPopover,
          {
            items: [
              { value: 0.5, label: "50%" },
              { value: 0.6, label: "60%" },
              { value: 0.7, label: "70%" },
              { value: 0.8, label: "80%" },
              { value: 0.9, label: "90%" },
              { value: 1, label: "100% (default)" },
              { value: 1.1, label: "110%" },
              { value: 1.2, label: "120%" },
              { value: 1.3, label: "130%" },
              { value: 1.4, label: "140%" },
              { value: 1.5, label: "150%" },
              { value: 1.6, label: "160%" },
              { value: 1.7, label: "170%" },
              { value: 1.8, label: "180%" },
              { value: 1.9, label: "190%" },
              { value: 2, label: "200%" }
            ],
            selectedItems: [zoomScale],
            anchor: canvasZoomAnchor,
            isOpen: !!canvasZoomAnchor,
            onSelect: (newValue) => {
              var _a3, _b4;
              return setZoom(
                newValue,
                (_a3 = instance == null ? void 0 : instance.transformState) == null ? void 0 : _a3.positionX,
                (_b4 = instance == null ? void 0 : instance.transformState) == null ? void 0 : _b4.positionY
              );
            },
            onClose: () => setCanvasZoomAnchor(null),
            style: zoomPopoverStyles,
            anchorOrigin: {
              vertical: "top",
              horizontal: "left"
            },
            transformOrigin: {
              vertical: "bottom",
              horizontal: "left"
            }
          }
        )),
        /* @__PURE__ */ React__default.createElement(
          AreaSelector$1,
          {
            areas: floorplanAreas,
            setValue: (newFocusedAreaId) => {
              resetTransform2();
              if (newFocusedAreaId === null) {
                handleSetFocusedArea(null);
                return;
              }
              const chosenArea = findObjectByProperty(
                floorplanAreas,
                newFocusedAreaId,
                "id"
              );
              handleSetFocusedArea(chosenArea);
              setAreasOpen(false);
            },
            value: (focusedArea == null ? void 0 : focusedArea.id) ?? null,
            onOpen: (e) => {
              setAreasOpen(true);
              e.stopPropagation();
            },
            onClose: () => setAreasOpen(false)
          }
        )
      )), /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: `canvas-container-outer ${classes.canvasContainerOuter}`,
          onMouseDown: (e) => {
            if (e.button !== 1 && !(e == null ? void 0 : e.metaKey) && !(e == null ? void 0 : e.ctrlKey) && !(e == null ? void 0 : e.altKey)) {
              e.stopPropagation();
            }
          },
          onContextMenu: disableRightClickTest,
          onWheel,
          onTouchMove: (e) => {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        /* @__PURE__ */ React__default.createElement(
          TransformComponent,
          {
            wrapperStyle: {
              overflow: "visible",
              maxWidth: showPrintView ? canvasDimensions.width * zoomScale - 2 : "100%",
              // -2 is a magic number to prevent it overflowing to multiple pages
              maxHeight: showPrintView ? canvasDimensions.height * zoomScale - 2 : "100%",
              width: showPrintView ? canvasDimensions.width * zoomScale - 2 : "fit-content",
              height: showPrintView ? canvasDimensions.height * zoomScale - 2 : "fit-content"
            }
          },
          /* @__PURE__ */ React__default.createElement(Box, { className: `canvas-container ${classes.canvasContainer}` }, /* @__PURE__ */ React__default.createElement(
            Canvas,
            {
              className: classes.canvas,
              draw,
              canvasRef,
              width: canvasDimensions.width,
              height: canvasDimensions.height,
              onClick: () => {
                if (isEmpty(draggedTableBooking)) {
                  setSelectedBooking(null);
                }
              },
              onTouchStart: (e) => {
                if (isEmpty(draggedTableBooking)) {
                  setObeeShowAddBookingModal(false);
                  setObeeBookingDetailsModal(false);
                }
              },
              onTouchEnd: (e) => {
                var _a3;
                const focusNextArea = () => {
                  if (focusedArea === null) {
                    handleSetFocusedArea(floorplanAreas == null ? void 0 : floorplanAreas[0]);
                  } else {
                    const currentFocusedAreaIndex = findObjectIndexByProperty(
                      floorplanAreas,
                      focusedArea == null ? void 0 : focusedArea.id,
                      "id"
                    );
                    if (currentFocusedAreaIndex === floorplanAreas.length - 1) {
                      handleSetFocusedArea(null);
                    } else {
                      handleSetFocusedArea(floorplanAreas[currentFocusedAreaIndex + 1]);
                    }
                  }
                };
                const focusPreviousArea = () => {
                  if (focusedArea === null)
                    ;
                  else {
                    const currentFocusedAreaIndex = findObjectIndexByProperty(
                      floorplanAreas,
                      focusedArea == null ? void 0 : focusedArea.id,
                      "id"
                    );
                    if (currentFocusedAreaIndex === 0) {
                      handleSetFocusedArea(null);
                    } else {
                      handleSetFocusedArea(floorplanAreas[currentFocusedAreaIndex - 1]);
                    }
                  }
                };
                const edgeScrollDistance = instance.bounds.minPositionX - instance.transformState.positionX;
                if (floatsEqual(edgeScrollDistance, 100)) {
                  focusNextArea();
                  e.preventDefault();
                  e.stopPropagation();
                } else if (((_a3 = instance.transformState) == null ? void 0 : _a3.positionX) === 100) {
                  focusPreviousArea();
                  e.preventDefault();
                  e.stopPropagation();
                }
              }
            }
          ), /* @__PURE__ */ React__default.createElement(Box, { style: { position: "absolute", top: 0, left: 0 } }, /* @__PURE__ */ React__default.createElement(
            Box,
            {
              ref: scrollRef,
              className: classes.scrollRefBox,
              style: {
                width: (_a2 = scrollToTableBounds.current) == null ? void 0 : _a2.width,
                height: (_b3 = scrollToTableBounds.current) == null ? void 0 : _b3.height,
                top: ((_c3 = scrollToTableBounds.current) == null ? void 0 : _c3.topLeftY) - 40 - areaNegativeOffset.x || 0,
                left: ((_d3 = scrollToTableBounds.current) == null ? void 0 : _d3.topLeftX) - areaNegativeOffset.y || 0
              }
            }
          ), filteredAreas == null ? void 0 : filteredAreas.map((floorplanArea) => {
            var _a3, _b4;
            const tablesForArea = (_a3 = tables == null ? void 0 : tables.data) == null ? void 0 : _a3.filter(
              (table) => (table == null ? void 0 : table.areaId) === (floorplanArea == null ? void 0 : floorplanArea.id)
            );
            const areaIsInSession = activeSessions.some(
              (activeSession) => (activeSession == null ? void 0 : activeSession.areaId) === (floorplanArea == null ? void 0 : floorplanArea.id)
            );
            const fullyBookedAreaSessions = fullyBookedSessions.data.filter(
              (fullyBookedSession) => fullyBookedSession.areaId === floorplanArea.id && fullyBookedSession.fullyBooked && (sessionFilter === "all_sessions" || sessionFilter === fullyBookedSession.label)
            );
            const fullyBookedAreaSessionLabels = fullyBookedAreaSessions.map(
              (fullyBookedSession) => getSessionLabel(fullyBookedSession.label)
            );
            const inFullyBook = sessionFilter !== "all_sessions" || fullyBookedAreaSessions.some(
              (fullyBookedAreaSession) => isBetween(
                currentTimeAsInt,
                fullyBookedAreaSession.openingTime,
                fullyBookedAreaSession.closingTime
              )
            );
            const topLeftPoint = (_b4 = immutableSort(
              floorplanArea == null ? void 0 : floorplanArea.points,
              (a, b) => a.x - b.x
            )) == null ? void 0 : _b4[0];
            return /* @__PURE__ */ React__default.createElement(Fragment, { key: `area-label-${floorplanArea == null ? void 0 : floorplanArea.id}` }, /* @__PURE__ */ React__default.createElement(
              Box,
              {
                className: classes.areaLabelsContainer,
                style: {
                  left: floorplanArea.x + ((topLeftPoint == null ? void 0 : topLeftPoint.x) || 0) + 10 - areaNegativeOffset.x,
                  top: floorplanArea.y + ((topLeftPoint == null ? void 0 : topLeftPoint.y) || 0) + 10 - areaNegativeOffset.y
                }
              },
              /* @__PURE__ */ React__default.createElement(
                Label$1,
                {
                  className: classes.areaLabel,
                  label: floorplanArea.name,
                  onClick: () => {
                    if (focusedArea) {
                      handleSetFocusedArea(null);
                    } else {
                      handleSetFocusedArea(floorplanArea);
                    }
                  }
                }
              ),
              fullyBookedAreaSessions.length > 0 && /* @__PURE__ */ React__default.createElement(
                Label$1,
                {
                  className: classes.fullyBookedAreaLabel,
                  style: { opacity: inFullyBook ? 1 : 0.5 }
                },
                /* @__PURE__ */ React__default.createElement(
                  ClockSVG,
                  {
                    style: { flexShrink: 0, height: "15px", width: "15px" }
                  }
                ),
                /* @__PURE__ */ React__default.createElement(Box, null, `Fully booked${sessionFilter === "all_sessions" ? ` : ${fullyBookedAreaSessionLabels.join(", ")}` : ""}`)
              ),
              !areaIsInSession && /* @__PURE__ */ React__default.createElement(Label$1, { className: classes.fullyBookedAreaLabel }, /* @__PURE__ */ React__default.createElement(
                ClockSVG,
                {
                  style: { flexShrink: 0, height: "15px", width: "15px" }
                }
              ), /* @__PURE__ */ React__default.createElement(Box, null, sessionFilter === "all_sessions" && dateIsToday ? "Currently out of session" : "Out of session"))
            ), tablesForArea.filter((table) => !table.isJoin).map((table) => {
              var _a4, _b5;
              const floorplanTable = findObjectByProperty(
                floorplanTables,
                table == null ? void 0 : table.id,
                "id"
              );
              const bounds = {
                ...floorplanTable == null ? void 0 : floorplanTable.bounds,
                x: ((_a4 = floorplanTable == null ? void 0 : floorplanTable.bounds) == null ? void 0 : _a4.x) - areaNegativeOffset.x,
                y: ((_b5 = floorplanTable == null ? void 0 : floorplanTable.bounds) == null ? void 0 : _b5.y) - areaNegativeOffset.y
              };
              return /* @__PURE__ */ React__default.createElement(
                TableDetails$1,
                {
                  key: table == null ? void 0 : table.id,
                  table,
                  tables,
                  floorplanData,
                  obeeSettings: obeeSettings2,
                  areas,
                  bookings: filteredBookings,
                  onStartDraggingBooking: (booking) => onStartDraggingTableBooking(booking, table),
                  onStopDraggingBooking: onStopDraggingTableBooking,
                  onDragTableBooking,
                  setSelectedBooking: (booking) => {
                    if (!isEmpty(draggedTableBooking)) {
                      devLog(
                        "info",
                        "there is a dragged booking",
                        draggedTableBooking
                      );
                      return;
                    }
                    selectBookingFromTable(booking);
                  },
                  selectedBooking,
                  showAllBookings: (anchorEl) => {
                    setSelectedTable(table);
                    setBookingsForSelectedTable(
                      filteredBookings.filter(
                        (booking) => booking.tableNumbers.includes(table.tableNumber)
                      )
                    );
                    setBookingsForTableAnchor({ anchorEl, table });
                  },
                  draggedBooking,
                  dragRef,
                  draggedTableBooking,
                  setDraggedTableBooking: (booking) => {
                    if (!isEmpty(draggedTableBooking)) {
                      return;
                    }
                    setDraggedTableBooking({ ...booking, table });
                  },
                  hoveredTableRef,
                  tablePropertiesAnchor,
                  setTablePropertiesAnchor,
                  closingTime: closingTime.current,
                  inSession: areaIsInSession,
                  bounds,
                  dragScale: zoomScale
                }
              );
            }));
          })))
        )
      ));
    }
  ), /* @__PURE__ */ React__default.createElement(
    LiveTableProperties$1,
    {
      tableId: (_i = tablePropertiesAnchor == null ? void 0 : tablePropertiesAnchor.table) == null ? void 0 : _i.id,
      anchor: tablePropertiesAnchor == null ? void 0 : tablePropertiesAnchor.anchor,
      bookingId: (_j = tablePropertiesAnchor == null ? void 0 : tablePropertiesAnchor.booking) == null ? void 0 : _j.id,
      onClose: () => {
        setSelectedTable(null);
        setSelectedBooking(null);
        setTablePropertiesAnchor(null);
      },
      style: popoverStyles$3(theme2),
      closingTime: closingTime.current,
      todaySessions,
      isAvailable: tablePropertiesAnchor == null ? void 0 : tablePropertiesAnchor.available,
      inSession: tablePropertiesAnchor == null ? void 0 : tablePropertiesAnchor.inSession
    }
  ), /* @__PURE__ */ React__default.createElement(
    TableBookingsPopover$1,
    {
      isOpen: !!(bookingsForTableAnchor == null ? void 0 : bookingsForTableAnchor.anchorEl),
      anchor: bookingsForTableAnchor == null ? void 0 : bookingsForTableAnchor.anchorEl,
      onClose: () => setBookingsForTableAnchor(null),
      bookings: bookingsForSelectedTable,
      onStartDraggingBooking: (booking, offset) => onStartDraggingTableBooking(booking, selectedTable, offset),
      onStopDraggingBooking: () => {
        setBookingsForTableAnchor(null);
      },
      onStopPressing: () => {
        onStopDraggingTableBooking();
      },
      onDragBooking: onDragTableBooking,
      setSelectedBooking: (booking) => {
        if (!isEmpty(draggedTableBooking)) {
          return;
        }
        selectBookingFromTable(booking);
      },
      selectedBooking,
      dragRef,
      draggedTableBooking,
      setDraggedTableBooking: (booking) => {
        if (!isEmpty(draggedTableBooking)) {
          return;
        }
        setDraggedTableBooking({ ...booking, table: selectedTable });
      }
    }
  ))), /* @__PURE__ */ React__default.createElement(
    GeneralErrorModal$1,
    {
      isOpen: showGeneralErrorModal,
      onClose: () => setShowGeneralErrorModal(false),
      prompt: generalErrorPrompt,
      confirmLabel: "Okay, got it"
    }
  ), /* @__PURE__ */ React__default.createElement(
    TableCapacityModal$1,
    {
      isOpen: showTableCapacityModal,
      onClose: () => setShowTableCapacityModal(false),
      onConfirm: (bookingToUpdate) => updateBooking(bookingToUpdate),
      tableCapacityData
    }
  ), /* @__PURE__ */ React__default.createElement(
    ShortBookingTimeModal$1,
    {
      isOpen: showShortBookingTimeModal,
      onClose: () => setShowShortBookingTimeModal(false),
      onConfirm: (bookingToUpdate) => updateBooking(bookingToUpdate),
      shortBookingTimeData
    }
  ), /* @__PURE__ */ React__default.createElement(
    SwapBookingsModal$1,
    {
      isOpen: showSwapBookingsModal,
      onClose: () => setShowSwapBookingsModal(false),
      onConfirm: (bookingsToUpdate) => bookingsToUpdate.forEach((bookingToUpdate) => updateBooking(bookingToUpdate)),
      swapBookingsData
    }
  ), /* @__PURE__ */ React__default.createElement(
    SendMessagePopover$1,
    {
      anchor: messagesAnchor,
      onClose: () => setBookingsForTableAnchor(null),
      setAnchor: setMessagesAnchor,
      booking: selectedBooking
    }
  ));
};
ViewFloorplan.defaultProps = {
  date: null
};
ViewFloorplan.propTypes = {
  areas: areasPropTypes.isRequired,
  tables: tablesPropTypes.isRequired,
  obeeBookings: obeeBookingsPropTypes.isRequired,
  updateObeeBooking: PropTypes.func.isRequired,
  fetchFloorplan: PropTypes.func.isRequired,
  date: momentPropTypes.momentObj,
  floorplan: floorplanPropTypes.isRequired,
  obeeAvailability: obeeAvailabilityPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  updateBooking: PropTypes.func.isRequired,
  sessionFilter: PropTypes.string.isRequired,
  setSessionFilter: PropTypes.func.isRequired,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired
};
const mapStateToProps$1y = (state) => ({
  areas: state.areas,
  tables: state.tables,
  obeeBookings: state.obeeBookings,
  date: state.obeeScreen.date,
  sessionFilter: state.obeeScreen.sessionFilter,
  floorplan: state.floorplan,
  obeeAvailability: state.obeeAvailability,
  obeeSessions: state.obeeSessions,
  obeeSettings: state.obeeSettings,
  fullyBookedSessions: state.fullyBookedSessions
});
const mapDispatchToProps$1x = (dispatch) => bindActionCreators(
  {
    fetchFloorplan: fetchFloorplanAction,
    updateObeeBooking: updateObeeBookingAction,
    checkObeeAvailability: checkObeeAvailabilityAction,
    clearObeeAvailability: clearObeeAvailabilityAction,
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction,
    updateBooking: updateObeeBookingAction,
    setSessionFilter: setSessionFilterAction,
    setObeeShowAddBookingModal: setObeeShowAddBookingModalAction
  },
  dispatch
);
const ViewFloorplan$1 = connect(mapStateToProps$1y, mapDispatchToProps$1x)(ViewFloorplan);
const Floorplan$1 = () => {
  useFetchBookingsData();
  return /* @__PURE__ */ React__default.createElement(ViewFloorplan$1, null);
};
Floorplan$1.propTypes = {};
const mapStateToProps$1x = () => ({});
const mapDispatchToProps$1w = (dispatch) => bindActionCreators({}, dispatch);
const FloorplanScreen = connect(mapStateToProps$1x, mapDispatchToProps$1w)(Floorplan$1);
const tabBarStyles$2 = (theme2) => ({
  fontWeight: theme2.fontWeights.regular,
  containerInner: {
    gap: "12px"
  },
  tab: {
    padding: "0 13px",
    borderRadius: "100px",
    fontSize: "16px",
    lineHeight: "20px",
    transition: "background-color 0.1s",
    whiteSpace: "nowrap",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    border: "1px solid transparent"
  },
  tabActive: {
    fontWeight: theme2.fontWeights.regular,
    backgroundColor: "white",
    padding: "9px 13px",
    paddingBottom: "9px",
    color: theme2.colors.charcoal,
    border: `1px solid ${theme2.colors.charcoal}`,
    borderBottom: `1px solid ${theme2.colors.charcoal}`
    // defaults to red
  },
  tabHover: {
    backgroundColor: "white",
    border: `1px solid ${theme2.colors.white}`,
    color: theme2.colors.black,
    filter: "none"
  }
});
const TabBar = ({ ...props }) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(TabBar$2, { style: tabBarStyles$2(theme2), ...props });
};
TabBar.defaultProps = {
  tabs: [],
  activeTab: null,
  setActiveTab: (e) => e
};
TabBar.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func
};
const mapStateToProps$1w = () => ({});
const mapDispatchToProps$1v = (dispatch) => bindActionCreators({}, dispatch);
const TabBar$1 = connect(mapStateToProps$1w, mapDispatchToProps$1v)(TabBar);
const useStyles$M = createUseStyles((theme2) => ({
  container: {
    backgroundColor: theme2.colors.white,
    padding: "28px 88px",
    color: theme2.colors.charcoal,
    maxWidth: "1500px",
    fontSize: "15px",
    [theme2.breakpoints.down("md")]: {
      margin: 0,
      padding: "0"
    }
  },
  pageContent: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    marginLeft: 0,
    overflowY: theme2.overlay,
    // maxHeight: 'calc(100vh - 189px)',
    paddingBottom: "50px",
    paddingRight: "20px",
    marginRight: "-20px",
    fontSize: theme2.fontSizes.m2,
    // ...theme.typography.body.bodyText2,
    [theme2.breakpoints.down("md")]: {
      paddingLeft: "20px",
      paddingRight: "20px"
      // marginLeft: '20px',
      // margin: 0,
      // padding: '0',
    }
  },
  title: {
    ...theme2.typography.heading.H2
  },
  label: {
    ...theme2.typography.body.PS,
    fontWeight: theme2.fontWeights.medium,
    marginBottom: "10px"
  },
  bannerText: {},
  tableList: {
    marginBottom: "100px"
  }
}));
const DeleteAreaModal = ({ floorplanArea, onClose, deleteLocalAreas, isOpen, area }) => {
  const handleDelete = () => {
    deleteLocalAreas(floorplanArea == null ? void 0 : floorplanArea.id);
    onClose();
  };
  const [name2, setName] = useState(area == null ? void 0 : area.name);
  useEffect(() => {
    if (!isEmpty(area)) {
      setName(area == null ? void 0 : area.name);
    }
  }, [area]);
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      onClose,
      isOpen: isOpen && !isEmpty(area),
      onConfirm: handleDelete,
      heading: `Delete ${name2}`,
      confirmLabel: "Delete",
      prompt: `This will remove the area and all of its tables from your floor plan.
      Please confirm you want to proceed.`
    }
  );
};
DeleteAreaModal.defaultProps = {
  floorplanArea: null,
  area: null
};
DeleteAreaModal.propTypes = {
  deleteLocalAreas: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  floorplanArea: floorplanAreaPropTypes,
  isOpen: PropTypes.bool.isRequired,
  area: areaPropTypes
};
const mapStateToProps$1v = (state) => ({
  floorplan: state.floorplan
});
const mapDispatchToProps$1u = (dispatch) => bindActionCreators(
  {
    deleteLocalAreas: deleteLocalAreasAction
  },
  dispatch
);
const DeleteAreaModal$1 = connect(mapStateToProps$1v, mapDispatchToProps$1u)(DeleteAreaModal);
const CleanDropdown$1 = ({
  label,
  value,
  items,
  onSelect: onSelect2,
  onFocus: onFocus2,
  onBlur: onBlur2,
  style,
  multiSelect,
  disabled,
  ...other
}) => {
  const theme2 = useTheme$1();
  const styles2 = {
    ...style,
    outerContainer: {
      display: "flex",
      gap: "10px",
      alignItems: "center",
      height: "40px",
      ...style == null ? void 0 : style.outerContainer
    },
    disabled: {
      color: theme2.colors.nimbus,
      backgroundColor: theme2.colors.dateSelectBackground,
      ...style == null ? void 0 : style.disabled
    },
    label: {
      color: theme2.colors.smoke,
      marginBottom: "0",
      width: "100px",
      ...style == null ? void 0 : style.label
    },
    container: {
      // marginLeft: '-2px',
      // marginLeft: '-14px',
      ...style == null ? void 0 : style.container
    },
    dropdown: {
      // backgroundColor: '#EDEDED',
      // marginLeft: '-2px',
      border: "1px solid transparent",
      width: "100%",
      color: theme2.colors.charcoal,
      // padding: '10px',
      borderRadius: "6px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: "16px",
      paddingRight: "40px",
      minWidth: "250px",
      lineHeight: "18px",
      transition: "background-color 0.1s",
      ...style == null ? void 0 : style.dropdown
    },
    dropdownHover: {
      backgroundColor: theme2.colors.yetAnotherGray12,
      ...style == null ? void 0 : style.dropdownHover
    },
    dropdownOpen: {
      border: `1px solid ${theme2.colors.smoke}`,
      borderBottom: "1px solid transparent",
      backgroundColor: theme2.colors.yetAnotherGray12,
      borderRadius: "6px 6px 0 0",
      ...style == null ? void 0 : style.dropdownOpen
    },
    menu: {
      fontSize: "16px",
      top: "36px",
      ...style == null ? void 0 : style.menu
    },
    dropdownArrow: {
      display: "none"
    },
    dropdownContent: {
      // border: '1px solid transparent',
      maxWidth: "200px",
      ...style == null ? void 0 : style.dropdownContent
    },
    dropdownContentInner: {
      maxWidth: "100%",
      padding: "10px 14px",
      lineHeight: "18px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      ...style == null ? void 0 : style.dropdownContentInner
    },
    inputHover: {
      backgroundColor: theme2.colors.yetAnotherGray13,
      ...style == null ? void 0 : style.inputHover
    },
    placeholder: {
      color: theme2.colors.nimbus,
      ...style == null ? void 0 : style.placeholder
    },
    menuItem: {
      padding: "16px 14px"
    }
  };
  if (multiSelect) {
    return /* @__PURE__ */ React__default.createElement(
      MultiSelectDropdown,
      {
        label,
        selectedItems: value,
        items,
        type: "text",
        onSelect: onSelect2,
        placeholder: "Empty",
        onFocus: onFocus2,
        onBlur: onBlur2,
        style: styles2,
        disabled,
        ...other
      }
    );
  }
  return /* @__PURE__ */ React__default.createElement(
    Dropdown$2,
    {
      label,
      value,
      items,
      type: "text",
      onSelect: onSelect2,
      placeholder: "Empty",
      onFocus: onFocus2,
      onBlur: onBlur2,
      style: styles2,
      disabled,
      ...other
    }
  );
};
CleanDropdown$1.defaultProps = {
  label: "",
  value: "",
  onSelect: () => {
  },
  onFocus: () => {
  },
  onBlur: () => {
  },
  style: {},
  items: [],
  multiSelect: false,
  disabled: false
};
CleanDropdown$1.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  style: PropTypes.shape({}),
  items: PropTypes.arrayOf(PropTypes.shape({})),
  multiSelect: PropTypes.bool,
  disabled: PropTypes.bool
};
const mapStateToProps$1u = () => ({});
const mapDispatchToProps$1t = (dispatch) => bindActionCreators({}, dispatch);
const CleanDropdownComponent = connect(mapStateToProps$1u, mapDispatchToProps$1t)(CleanDropdown$1);
const useStyles$L = createUseStyles((theme2) => ({
  container: {},
  innerContainer: {
    color: theme2.colors.charcoal,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxWidth: "450px"
  },
  topSection: {
    padding: "24px",
    marginBottom: "20px"
  },
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  title: {
    ...theme2.typography.heading.H4,
    marginBottom: "20px"
  },
  subtitle: {
    ...theme2.typography.body.PL,
    color: theme2.colors.smoke,
    marginBottom: "20px"
  },
  bottomSection: {
    padding: "0 24px",
    borderTop: `1px solid ${theme2.colors.linkIconBackground}`
  },
  button: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    ...theme2.typography.body.PL
  },
  showField: {
    marginTop: "10px",
    fontSize: "14px",
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.olive3
  },
  sittingRowContainer: {
    padding: "20px 25px",
    display: "flex",
    flexDirection: "column",
    gap: "5px"
  },
  sittingsTitle: {
    padding: "0 25px",
    ...theme2.typography.body.PL,
    fontWeight: theme2.fontWeights.medium
  },
  sittingRow: {
    display: "flex",
    border: `1px solid ${theme2.colors.cloud}`,
    borderRadius: "4px",
    cursor: "pointer"
  },
  sittingRowNumber: {
    ...theme2.typography.body.PL,
    backgroundColor: theme2.colors.cloud,
    padding: "8px",
    width: "30px",
    height: "36px",
    textAlign: "center",
    verticalAlign: "center"
  },
  sittingRowDetails: {
    ...theme2.typography.body.PL,
    verticalAlign: "center",
    padding: "8px",
    height: "34px",
    width: "100%"
  }
}));
const buttonStyles$2 = (theme2) => ({
  container: { width: "auto" },
  button: {
    width: "100%",
    padding: "12px",
    borderRadius: "6px"
  },
  text: {
    justifyContent: "flex-start"
  },
  buttonHover: { backgroundColor: theme2.colors.notificationBackgroundGray },
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "-10px",
  marginRight: "-10px"
});
const AreaProperties = ({
  floorplanArea,
  areaData,
  anchor,
  onClose,
  updateLocalArea,
  floorplan,
  updateLocalFloorplan,
  showDeleteModal,
  tables
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$L();
  const [name2, setName] = useState("");
  const [type2, setType] = useState(null);
  const [areaTableType, setAreaTableType] = useState("tables");
  const [capacity, setCapacity] = useState(null);
  const [minGroup, setMinGroup] = useState(null);
  const [maxGroup, setMaxGroup] = useState(null);
  useEffect(() => {
    if (anchor) {
      unstable_batchedUpdates(() => {
        setName(areaData == null ? void 0 : areaData.name);
        setType(floorplanArea == null ? void 0 : floorplanArea.type);
        setAreaTableType(
          isAreaCapacityBased(areaData, tables) && (areaData == null ? void 0 : areaData.capacity) > 0 ? "capacity" : "tables"
        );
        setCapacity((areaData == null ? void 0 : areaData.capacity) || null);
        setMinGroup((areaData == null ? void 0 : areaData.minGroup) || 1);
        setMaxGroup((areaData == null ? void 0 : areaData.maxGroup) || 8);
      });
    }
  }, [anchor]);
  const sendUpdate = () => {
    const updatedArea = {
      ...areaData,
      name: name2 === "" ? "Untitled area" : name2,
      // areaTableType,
      capacity,
      minGroup,
      maxGroup
    };
    updateLocalArea(updatedArea);
  };
  const updateType = (newType) => {
    var _a;
    if (isEmpty(newType)) {
      return;
    }
    const newFloorplanArea = {
      ...floorplanArea,
      type: newType
    };
    const newFloorplan = {
      ...floorplan == null ? void 0 : floorplan.data,
      areas: updateObjectByProperty((_a = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a.areas, newFloorplanArea, "id")
    };
    updateLocalFloorplan(newFloorplan);
  };
  const updateAreaTableType = (newType) => {
    if (isEmpty(newType)) {
      return;
    }
    const newCapacity = isVoid(capacity) ? 50 : capacity;
    setAreaTableType(newType);
    setCapacity(newCapacity);
    const updatedArea = {
      ...areaData,
      areaType: newType,
      capacity: newCapacity
      // capacity will be calculated from tables
    };
    updateLocalArea(updatedArea);
  };
  const updateMinGroup = (newMinGroup) => {
    setMinGroup(newMinGroup);
  };
  const validateMaxGroup = () => {
  };
  const tablesForArea = tables.filter((table) => !(table == null ? void 0 : table.isJoin) && (table == null ? void 0 : table.areaId) === (areaData == null ? void 0 : areaData.id));
  const handleClose = () => {
    sendUpdate();
    onClose();
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchor,
      onClose: handleClose,
      anchorEl: anchor,
      innerStyle: { marginLeft: "20px", marginTop: "0", borderRadius: "6px", padding: "0" },
      anchorOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Area properties"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Name",
        value: name2,
        style: { label: { width: "120px" }, input: { minWidth: "250px" } },
        onChange: setName,
        onBlur: sendUpdate,
        onEnter: sendUpdate
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownComponent,
      {
        label: "Type",
        items: areaTypes,
        value: type2,
        style: {
          label: { width: "120px" },
          dropdown: { minWidth: "250px" }
        },
        onSelect: (newValue) => {
          setType(newValue);
          updateType(newValue);
        }
      }
    ), /* @__PURE__ */ React__default.createElement(Divider, { style: { marginTop: "16px", marginBottom: "16px" } }), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical" }, /* @__PURE__ */ React__default.createElement(Box, { style: { ...theme2.typography.heading.sectionHeading } }, "Group size limit"), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical" }, /* @__PURE__ */ React__default.createElement(
      NumberIncrement$1,
      {
        label: "Min party size",
        value: minGroup,
        onChange: updateMinGroup,
        inlineLabel: true,
        min: 1,
        max: 1e3,
        allowTyping: true
      }
    ), /* @__PURE__ */ React__default.createElement(
      NumberIncrement$1,
      {
        label: "Max party size",
        value: maxGroup,
        onChange: setMaxGroup,
        onBlur: validateMaxGroup,
        inlineLabel: true,
        min: minGroup,
        max: 1e3,
        allowTyping: true
      }
    ))), /* @__PURE__ */ React__default.createElement(Divider, { style: { marginTop: "16px", marginBottom: "16px" } }), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical" }, /* @__PURE__ */ React__default.createElement(Spacer, { style: { ...theme2.typography.heading.sectionHeading } }, /* @__PURE__ */ React__default.createElement(Box, null, "Area max capacity"), /* @__PURE__ */ React__default.createElement(
      Tooltip,
      {
        style: { message: { fontSize: "15px", padding: "16px" } },
        message: "The area max capacity limits how many guests are able to book into that area to ensure you remain within your specified capacity requirements.\n\nAs you add tables to the area, the area’s max capacity is automatically updated. However, If you set it manually, this maximum becomes fixed.\n\nSetting an area max capacity manually means that you cannot have tables added to that area. Bookings will be allocated to the area in general instead of individual tables. You will not have the ability to see which tables guests are sitting at and manage bookings on your floor plan."
      }
    )), isEmpty(tablesForArea) ? areaTableType === "capacity" ? /* @__PURE__ */ React__default.createElement(
      NumberIncrement$1,
      {
        label: "Area max",
        value: capacity,
        onChange: setCapacity,
        inlineLabel: true,
        min: 1,
        max: 1e3,
        allowTyping: true
      }
    ) : /* @__PURE__ */ React__default.createElement(Box, { style: { display: "inline-block", color: theme2.colors.smoke } }, "This is automatically updated as you add tables to the area. If you don't add tables, you can", " ", /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        style: {
          display: "inline-block",
          color: theme2.colors.brandPrimary,
          textDecoration: "underline"
        },
        onClick: () => {
          updateAreaTableType("capacity");
        }
      },
      "set it manually."
    )) : /* @__PURE__ */ React__default.createElement(Box, { style: { paddingTop: "10px" } }, tablesForArea.reduce((accum, table) => accum + table.maxSeats, 0), " guests")))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles$2(theme2),
        onClick: () => {
          onClose();
          showDeleteModal(true);
        },
        centered: false
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete"))
    )))
  );
};
AreaProperties.defaultProps = {
  floorplanArea: null,
  areaData: null,
  anchor: null,
  tables: []
};
AreaProperties.propTypes = {
  updateLocalArea: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  floorplanArea: floorplanAreaPropTypes,
  areaData: areaPropTypes,
  anchor: PropTypes.func,
  updateLocalFloorplan: PropTypes.func.isRequired,
  floorplan: floorplanPropTypes.isRequired,
  showDeleteModal: PropTypes.func.isRequired,
  tables: PropTypes.arrayOf(tablePropTypes)
};
const mapStateToProps$1t = (state) => ({
  floorplan: state.floorplan
});
const mapDispatchToProps$1s = (dispatch) => bindActionCreators(
  {
    updateLocalArea: updateLocalAreaAction,
    deleteLocalAreas: deleteLocalAreasAction,
    updateLocalFloorplan: updateLocalFloorplanAction
  },
  dispatch
);
const AreaProperties$1 = connect(mapStateToProps$1t, mapDispatchToProps$1s)(AreaProperties);
const useStyles$K = createUseStyles((theme2) => ({
  container: {},
  innerContainer: {
    color: theme2.colors.charcoal,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minWidth: "300px",
    fontSize: theme2.fontSizes.l
  },
  topSection: {
    padding: "12px 24px",
    display: "flex",
    flexDirection: "column"
  },
  bottomSection: {
    padding: "8px 24px",
    borderTop: `1px solid ${theme2.colors.linkIconBackground}`
  },
  button: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    width: "100%",
    ...theme2.typography.body.PL
  }
}));
const buttonStyles$1 = (theme2) => ({
  container: { width: "auto" },
  button: {
    width: "100%",
    padding: "7px 12px",
    borderRadius: "6px"
  },
  buttonHover: {
    backgroundColor: theme2.colors.notificationBackgroundGray
  },
  marginLeft: "-10px",
  marginRight: "-10px"
});
const popoverStyles$2 = {
  popoverInner: {
    marginLeft: "8px",
    marginTop: "20px",
    borderRadius: "6px",
    padding: "0",
    pointerEvents: "auto",
    minHeight: "10px"
  }
};
const AreaRowEdit = ({
  area,
  anchorEl,
  onClose,
  floorplanData,
  deleteLocalAreas,
  updateLocalFloorplan,
  tables
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$K();
  const floorplanArea = getFloorplanAreaFromAreaData(floorplanData == null ? void 0 : floorplanData.areas, area);
  const [showDeleteAreaModal, setShowDeleteAreaModal] = useState(false);
  const [propertiesAnchorEl, setPropertiesAnchorEl] = useState(null);
  useEffect(() => {
    setShowDeleteAreaModal(false);
    setPropertiesAnchorEl(null);
  }, [anchorEl, area == null ? void 0 : area.id]);
  const handleDelete = () => {
    setShowDeleteAreaModal(true);
  };
  const handleDeleteArea = () => {
    deleteLocalAreas([area == null ? void 0 : area.id]);
    const newFloorplan = {
      ...floorplanData,
      areas: filterByProperty(floorplanData == null ? void 0 : floorplanData.areas, area == null ? void 0 : area.id, "id", true)
    };
    updateLocalFloorplan(newFloorplan);
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchorEl,
      onClose,
      anchorEl,
      innerStyle: popoverStyles$2.popoverInner,
      anchorOrigin: {
        vertical: "center",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topSection }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles$1(theme2),
        onClick: (e) => setPropertiesAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { color: theme2.colors.gray3, height: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Edit properties"))
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles$1(theme2), onClick: handleDelete }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete")))))
  ), /* @__PURE__ */ React__default.createElement(
    DeleteAreaModal$1,
    {
      isOpen: showDeleteAreaModal,
      floorplanAreas: [floorplanArea],
      onClose: () => {
        setPropertiesAnchorEl(null);
        setShowDeleteAreaModal(false);
        onClose();
      },
      onDelete: handleDeleteArea,
      area
    }
  ), /* @__PURE__ */ React__default.createElement(
    AreaProperties$1,
    {
      floorplanArea,
      onClose: () => {
        setPropertiesAnchorEl(null);
        onClose();
      },
      floorplan: floorplanData,
      showDeleteModal: () => setShowDeleteAreaModal(true),
      anchor: propertiesAnchorEl,
      tables,
      areaData: area,
      anchorOrigin: {
        horizontal: "left"
      },
      transformOrigin: {
        horizontal: "right"
      }
    }
  ));
};
AreaRowEdit.defaultProps = {
  area: null,
  anchorEl: null,
  tables: []
};
AreaRowEdit.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.shape({}),
  area: areaPropTypes,
  floorplanData: floorplanDataPropTypes.isRequired,
  deleteLocalAreas: PropTypes.func.isRequired,
  updateLocalFloorplan: PropTypes.func.isRequired,
  tables: PropTypes.arrayOf(tablePropTypes)
};
const mapStateToProps$1s = () => ({});
const mapDispatchToProps$1r = (dispatch) => bindActionCreators(
  {
    deleteLocalAreas: deleteLocalAreasAction,
    updateLocalFloorplan: updateLocalFloorplanAction
  },
  dispatch
);
const AreaRowEdit$1 = connect(mapStateToProps$1s, mapDispatchToProps$1r)(AreaRowEdit);
const DeleteTableModal = ({ floorplanTables, onClose, onDelete: onDelete2, isOpen, table }) => {
  const handleDelete = () => {
    onDelete2();
    onClose();
  };
  const [tableNumber, setTableNumber] = useState("");
  const [tableAmount, setTableAmount] = useState(0);
  useEffect(() => {
    if (isOpen && !isEmpty(floorplanTables)) {
      setTableAmount(floorplanTables == null ? void 0 : floorplanTables.length);
      if (floorplanTables.length === 1) {
        setTableNumber(`table ${table == null ? void 0 : table.tableNumber}`);
      } else {
        setTableNumber(`${floorplanTables.length} tables`);
      }
    }
  }, [isOpen, floorplanTables, table == null ? void 0 : table.tableNumber]);
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      onClose,
      isOpen,
      onConfirm: handleDelete,
      heading: `Delete ${tableNumber}`,
      confirmLabel: "Delete",
      prompt: `This will remove the ${pluralise(
        "table",
        tableAmount
      )} from your floor plan. If there are any bookings on ${pluralise(
        "this table",
        tableAmount,
        "these tables"
      )}, they will no longer appear. Any table joins for ${pluralise(
        "this table",
        tableAmount,
        "these tables"
      )} will also be removed.
      Please confirm you want to proceed.`
    }
  );
};
DeleteTableModal.defaultProps = {
  floorplanTables: [],
  table: null
};
DeleteTableModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  floorplanTables: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  onDelete: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  table: tablePropTypes
};
const mapStateToProps$1r = (state) => ({
  floorplan: state.floorplan
});
const mapDispatchToProps$1q = (dispatch) => bindActionCreators({}, dispatch);
const DeleteTableModal$1 = connect(mapStateToProps$1r, mapDispatchToProps$1q)(DeleteTableModal);
const EnableJoin = ({
  selectedTableIds,
  anchor,
  onClose,
  tables,
  createLocalTable,
  createLocalTables
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$L();
  const [minCustomers, setMinCustomers] = useState(0);
  const [maxCustomers, setMaxCustomers] = useState(0);
  const [bookableBy, setBookableBy] = useState("public");
  const [notes, setNotes] = useState(null);
  const [showNotes, setShowNotes] = useState(false);
  const [createSubJoins, setCreateSubJoins] = useState(false);
  const [selectedTables, setSelectedTables] = useState([]);
  useEffect(() => {
    const newSelectedTables = tables.data.filter((table) => selectedTableIds.includes(table == null ? void 0 : table.id));
    setSelectedTables(newSelectedTables);
  }, [selectedTableIds]);
  const createJoin = (tablesToJoin) => {
    var _a;
    const joinTableId = flatten(tablesToJoin, "tableNumber").join(",");
    createLocalTable({
      minSeats: minCustomers,
      maxSeats: maxCustomers,
      isPublic: bookableBy === "public",
      areaId: (_a = tablesToJoin[0]) == null ? void 0 : _a.areaId,
      tableNumber: joinTableId
    });
  };
  const handleJoin = () => {
    var _a;
    devLog("info", "joining tables", selectedTables);
    if (createSubJoins) {
      const newJoinTables = (_a = getEverySideBySideCombination(selectedTables, 2)) == null ? void 0 : _a.map(
        (subJoinTables) => {
          var _a2;
          const joinTableId = flatten(subJoinTables, "tableNumber").join(",");
          const minSeats = subJoinTables.reduce((accum, table) => accum + table.minSeats, 0);
          const maxSeats = subJoinTables.reduce((accum, table) => accum + table.maxSeats, 0);
          return {
            minSeats,
            maxSeats,
            isPublic: bookableBy === "public",
            areaId: (_a2 = selectedTables[0]) == null ? void 0 : _a2.areaId,
            tableNumber: joinTableId
          };
        }
      );
      createLocalTables(newJoinTables);
    } else {
      createJoin(selectedTables);
    }
    onClose();
  };
  useEffect(() => {
    if (anchor) {
      let newMin = 0;
      let newMax = 0;
      selectedTables.forEach((table) => {
        newMin += table.minSeats;
        newMax += table.maxSeats;
      });
      unstable_batchedUpdates(() => {
        setMinCustomers(newMin);
        setMaxCustomers(newMax);
      });
    }
  }, [selectedTables, anchor]);
  const fieldStyles2 = {
    label: { fontSize: "18px", width: "160px" },
    input: { minWidth: "250px" },
    checkbox: { alignItems: "start" },
    checkboxBox: { marginTop: "2px" },
    container: { color: theme2.colors.black }
  };
  const styles2 = {
    button: {
      container: { width: "100%", padding: "20px" },
      button: {
        width: "100%"
      }
    },
    popoverInner: {
      marginLeft: "20px",
      marginTop: "0",
      borderRadius: "6px",
      padding: "0",
      pointerEvents: "auto"
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchor && selectedTables.length > 0,
      onClose,
      anchorEl: anchor,
      innerStyle: styles2.popoverInner,
      anchorOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer, style: { minHeight: "300px", minWidth: "400px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title, style: { marginBottom: "6px" } }, "Enable join"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.subtitle }, selectedTables.map((table) => table == null ? void 0 : table.tableNumber).join(", ")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Min guests",
        value: minCustomers,
        style: fieldStyles2,
        onChange: setMinCustomers
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Max guests",
        value: maxCustomers,
        style: fieldStyles2,
        onChange: setMaxCustomers
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownComponent,
      {
        label: "Bookable by",
        items: publicTypes,
        value: bookableBy,
        style: fieldStyles2,
        onSelect: setBookableBy
      }
    ), selectedTables.length > 2 && /* @__PURE__ */ React__default.createElement(
      Checkbox,
      {
        label: "Join all combinations of selected tables",
        selected: createSubJoins,
        onChange: setCreateSubJoins,
        style: checkboxStyles(theme2),
        color: theme2.colors.charcoal
      }
    ), showNotes ? /* @__PURE__ */ React__default.createElement(CleanTextFieldComponent, { label: "Notes", value: notes, style: fieldStyles2, onChange: setNotes }) : /* @__PURE__ */ React__default.createElement(Button, { type: "text", className: classes.showField, onClick: () => setShowNotes(true) }, "+ Add notes"))), /* @__PURE__ */ React__default.createElement(Button, { type: "primary", style: styles2.button, onClick: handleJoin }, "Confirm join rule"))
  );
};
EnableJoin.defaultProps = {
  anchor: null,
  selectedTableIds: []
};
EnableJoin.propTypes = {
  createLocalTable: PropTypes.func.isRequired,
  createLocalTables: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.func,
  selectedTableIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  tables: tablePropTypes.isRequired
};
const mapStateToProps$1q = (state) => ({
  tables: state.tables
});
const mapDispatchToProps$1p = (dispatch) => bindActionCreators(
  {
    createLocalTable: createLocalTableAction,
    createLocalTables: createLocalTablesAction
  },
  dispatch
);
const EnableJoin$1 = connect(mapStateToProps$1q, mapDispatchToProps$1p)(EnableJoin);
const MultiTableProperties = ({
  floorplanTables,
  // A list of the local floorplan table data
  tables,
  // A list of the local tables
  selectedTableIds,
  // A list of ids of tables being edited
  anchor,
  onClose,
  bulkUpdateLocalTables,
  updateLocalFloorplan,
  floorplan,
  showDeleteModal,
  anchorOrigin,
  transformOrigin
}) => {
  var _a, _b2, _c2, _d2, _e2;
  const theme2 = useTheme$1();
  const classes = useStyles$L();
  const [hasChanges, setHasChanges] = useState(false);
  const selectedFloorplanTables = useMemo(
    () => floorplanTables.filter((floorplanTable) => selectedTableIds.includes(floorplanTable.id)),
    [floorplanTables, selectedTableIds]
  );
  const selectedTableData = useMemo(
    () => tables.filter((table) => selectedTableIds.includes(table.id)),
    [tables, selectedTableIds]
  );
  const allTypes = unique(flatten(selectedFloorplanTables, "type"));
  const allMinSeats = unique(flatten(selectedTableData, "minSeats"));
  const allMaxSeats = unique(flatten(selectedTableData, "maxSeats"));
  const allBookableBy = unique(flatten(selectedTableData, "isPublic"));
  const allNotes = unique(flatten(selectedTableData, "notes"));
  const [type2, setType] = useState(
    allTypes.length <= 1 ? (_a = selectedFloorplanTables == null ? void 0 : selectedFloorplanTables[0]) == null ? void 0 : _a.type : null
  );
  const [minSeats, setMinSeats] = useState(
    allMinSeats.length <= 1 ? (_b2 = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _b2.minSeats : null
  );
  const [maxSeats, setMaxSeats] = useState(
    allMaxSeats.length <= 1 ? (_c2 = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _c2.maxSeats : null
  );
  const [bookableBy, setBookableBy] = useState(
    allBookableBy.length <= 1 ? (_d2 = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _d2.bookableBy : null
  );
  const [notes, setNotes] = useState(allNotes.length <= 1 ? (_e2 = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _e2.notes : null);
  const [showNotes, setShowNotes] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const styles2 = {
    popoverInner: {
      marginLeft: "20px",
      marginTop: "0",
      borderRadius: "6px",
      padding: "0",
      pointerEvents: "auto",
      overflow: "visible"
    }
  };
  useEffect(() => {
    if (!anchor)
      ;
    else {
      unstable_batchedUpdates(() => {
        var _a2, _b3, _c3, _d3, _e3, _f;
        setType(allTypes.length <= 1 ? (_a2 = selectedFloorplanTables == null ? void 0 : selectedFloorplanTables[0]) == null ? void 0 : _a2.type : null);
        setMaxSeats(allMaxSeats.length <= 1 ? (_b3 = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _b3.maxSeats : null);
        setMinSeats(allMinSeats.length <= 1 ? (_c3 = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _c3.minSeats : null);
        setBookableBy(
          allBookableBy.length <= 1 ? ((_d3 = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _d3.isPublic) ? "public" : "private" : null
        );
        setNotes(allNotes.length <= 1 ? (_e3 = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _e3.notes : null);
        setShowNotes(allNotes.length <= 1 ? !isEmpty((_f = selectedTableData == null ? void 0 : selectedTableData[0]) == null ? void 0 : _f.notes) : false);
        setHasChanges(false);
      });
    }
  }, [anchor, selectedTableIds]);
  const sendUpdate = () => {
    var _a2;
    const maxSeatsAsInt = parseInt(maxSeats, 10) || 1;
    const minSeatsAsInt = parseInt(minSeats, 10) || 1;
    const updatedTable = {
      notes,
      isPublic: bookableBy !== "private"
      // Since it should default to public
    };
    if (minSeats !== null) {
      updatedTable.minSeats = minSeatsAsInt;
    }
    if (maxSeats !== null) {
      updatedTable.maxSeats = maxSeatsAsInt;
    }
    if (!isEmpty(type2)) {
      const updatedFloorplanTables = selectedFloorplanTables.map((selectedFloorplanTable) => ({
        ...selectedFloorplanTable,
        type: type2
      }));
      const newFloorplan = {
        ...floorplan == null ? void 0 : floorplan.data,
        tables: updateObjectsByProperty((_a2 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a2.tables, updatedFloorplanTables, "id")
      };
      devLog("info", "updating tables from multi properties", updatedFloorplanTables);
      updateLocalFloorplan(newFloorplan);
    }
    const updatedTables = selectedTableData.map((selectedTable) => ({
      ...selectedTable,
      ...updatedTable
    }));
    bulkUpdateLocalTables(updatedTables);
  };
  const updateMinSeats = (newMin) => {
    const maxSeatsForTable = 20;
    const newMinAsInt = Math.min(maxSeatsForTable, parseInt(newMin, 10)) || 0;
    setMinSeats(`${newMinAsInt}`);
  };
  const updateMaxSeats = (newMax) => {
    const maxSeatsForTable = 20;
    const newMaxAsInt = Math.min(maxSeatsForTable, parseInt(newMax, 10)) || 0;
    setMaxSeats(`${newMaxAsInt}`);
  };
  const handleClose = () => {
    setShowConfirmationModal(false);
    onClose();
  };
  const handleConfirm = () => {
    sendUpdate();
    handleClose();
  };
  const onClickOutside = () => {
    if (hasChanges) {
      setShowConfirmationModal(true);
    } else {
      onClose();
    }
  };
  const updateType = (newType) => {
    setType(newType);
  };
  const updatePublic = (newValue) => {
    setBookableBy(newValue);
  };
  const handleDelete = () => {
    showDeleteModal();
  };
  const fieldStyles2 = {
    label: { fontSize: "18px", width: "140px" },
    input: { minWidth: "250px" },
    dropdown: { minWidth: "250px", fontSize: "18px" },
    errorText: { marginLeft: "150px" }
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchor,
      onClose: onClickOutside,
      anchorEl: anchor,
      innerStyle: styles2.popoverInner,
      anchorOrigin: {
        vertical: "center",
        horizontal: "right",
        ...anchorOrigin
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "left",
        ...transformOrigin
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer, style: { minHeight: "300px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Tables ", selectedTableData.map((table) => table.tableNumber).join(", ")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
      CleanDropdownComponent,
      {
        label: "Type",
        items: tableTypes,
        valueOverride: type2 === null ? "Multiple types" : getLabelForValue(type2, tableTypes),
        placeholder: allTypes.join(", "),
        style: fieldStyles2,
        onSelect: (value) => {
          if (value !== type2) {
            setHasChanges(true);
          }
          updateType(value);
        }
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Min guests",
        value: minSeats,
        placeholder: minSeats === null ? "Multiple values" : "Empty",
        style: fieldStyles2,
        onChange: (value) => {
          if (value !== minSeats) {
            setHasChanges(true);
          }
          setMinSeats(value);
        },
        onBlur: () => updateMinSeats(minSeats),
        onEnter: () => updateMinSeats(minSeats)
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Max guests",
        value: maxSeats,
        placeholder: maxSeats === null ? "Multiple values" : "Empty",
        style: fieldStyles2,
        onChange: (value) => {
          if (value !== maxSeats) {
            setHasChanges(true);
          }
          setMaxSeats(value);
        },
        onBlur: () => updateMaxSeats(maxSeats),
        onEnter: () => updateMaxSeats(maxSeats)
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownComponent,
      {
        label: "Bookable by",
        items: publicTypes,
        value: bookableBy,
        style: fieldStyles2,
        onSelect: (value) => {
          if (value !== bookableBy) {
            setHasChanges(true);
          }
          updatePublic(value);
        }
      }
    ), showNotes ? /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Notes",
        value: notes,
        style: fieldStyles2,
        onChange: (value) => {
          if (value !== notes) {
            setHasChanges(true);
          }
          setNotes(value);
        }
      }
    ) : /* @__PURE__ */ React__default.createElement(Button, { type: "text", className: classes.showField, onClick: () => setShowNotes(true) }, "+ Add notes"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles$2(theme2), onClick: handleDelete }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete"))))),
    /* @__PURE__ */ React__default.createElement(
      CommsModal$1,
      {
        isOpen: !!showConfirmationModal,
        onClose: handleClose,
        onConfirm: handleConfirm,
        heading: "Update multiple tables",
        prompt: `Confirm that you want to edit multiple tables ${joinList(
          selectedTableData.map((table) => table.tableNumber)
        )}`,
        confirmLabel: "Confirm"
      }
    )
  );
};
MultiTableProperties.defaultProps = {
  anchor: null,
  anchorOrigin: {},
  transformOrigin: {},
  floorplanTables: [],
  tables: []
};
MultiTableProperties.propTypes = {
  tables: PropTypes.arrayOf(tablePropTypes).isRequired,
  floorplanTables: PropTypes.arrayOf(PropTypes.shape({})),
  bulkUpdateLocalTables: PropTypes.func.isRequired,
  updateLocalFloorplan: PropTypes.func.isRequired,
  showDeleteModal: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.shape({}),
  floorplan: floorplanPropTypes.isRequired,
  anchorOrigin: PropTypes.shape({ horizontal: PropTypes.string, vertical: PropTypes.string }),
  transformOrigin: PropTypes.shape({ horizontal: PropTypes.string, vertical: PropTypes.string })
};
const mapStateToProps$1p = (state) => ({
  floorplan: state.floorplan
});
const mapDispatchToProps$1o = (dispatch) => bindActionCreators(
  {
    bulkUpdateLocalTables: bulkUpdateLocalTablesAction,
    updateLocalFloorplan: updateLocalFloorplanAction
  },
  dispatch
);
const MultiTableProperties$1 = connect(mapStateToProps$1p, mapDispatchToProps$1o)(MultiTableProperties);
const useStyles$J = createUseStyles((theme2) => ({
  container: {},
  innerContainer: {
    color: theme2.colors.charcoal,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minWidth: "300px",
    fontSize: theme2.fontSizes.l
  },
  topSection: {
    padding: "12px 24px",
    display: "flex",
    flexDirection: "column"
  },
  bottomSection: {
    padding: "8px 24px",
    borderTop: `1px solid ${theme2.colors.linkIconBackground}`
  },
  button: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    width: "100%",
    ...theme2.typography.body.PL
  },
  blockedTableContainer: {
    margin: "0px -10px 8px -10px",
    borderRadius: "8px",
    padding: "8px 9px",
    backgroundColor: `${theme2.colors.cloud}`,
    "&:hover": {
      background: theme2.colors.dateSelectBackground,
      cursor: "pointer"
    }
  },
  firstBlock: {
    marginTop: "8px"
  },
  editBlock: {
    paddingLeft: "34px"
  },
  blockInfoContainer: {
    display: "flex"
  },
  blockTimeWhiteBox: {
    fontSize: "12px",
    backgroundColor: `${theme2.colors.white}`,
    lineHeight: "22px",
    fontWeight: "500",
    marginLeft: "30px",
    minWidth: "134px",
    borderRadius: "6px",
    padding: "2px 0px 2px 0px"
  },
  rightCaret: {
    position: "absolute",
    right: "0",
    marginRight: "30px",
    width: "4px"
  }
}));
const buttonStyles = (theme2) => ({
  container: { width: "auto" },
  button: {
    width: "100%",
    padding: "7px 12px",
    borderRadius: "6px"
  },
  buttonHover: {
    backgroundColor: theme2.colors.notificationBackgroundGray
  },
  marginLeft: "-10px",
  marginRight: "-10px"
});
const bottomButtonStyles = (theme2) => ({
  container: { width: "auto" },
  button: {
    width: "100%",
    padding: "7px 0",
    borderRadius: "6px"
  },
  buttonHover: {
    backgroundColor: theme2.colors.notificationBackgroundGray
  }
});
const popoverStyles$1 = {
  popoverInner: {
    marginLeft: "8px",
    marginTop: "20px",
    borderRadius: "6px",
    padding: "0",
    pointerEvents: "auto",
    minHeight: "10px"
  }
};
const SvgJoin = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 20 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 2, cy: 2, r: 1.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 2, cy: 11, r: 1.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M3.26758 1.95331C4.74272 1.95331 7.11727 1.86324 8.97454 3.28094C11.6305 5.30832 13.1057 6.5127 15.2693 6.5127H17.7127", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M3.51855 11.1346C4.9937 11.1346 7.11506 11.2246 8.97233 9.80695C11.6283 7.77957 13.1035 6.5752 15.2671 6.5752H18.5456", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M15.8379 3.25L19.0879 6.71667L15.8379 9.75", stroke: "currentColor" }));
const JoinSVG = SvgJoin;
const MultiTableRowEdit = ({
  anchorEl,
  onClose,
  floorplanData,
  deleteLocalTables,
  updateLocalFloorplan,
  selectedTableIds,
  tables,
  onDelete: onDelete2
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$J();
  const [showDeleteTableModal, setShowDeleteTableModal] = useState(false);
  const [joinAnchorEl, setJoinAnchorEl] = useState(null);
  const [propertiesAnchorEl, setPropertiesAnchorEl] = useState(null);
  const selectedFloorplanTables = floorplanData == null ? void 0 : floorplanData.tables.filter(
    (tableFiltering) => selectedTableIds.includes(tableFiltering == null ? void 0 : tableFiltering.id)
  );
  const selectedTableData = tables.data.filter(
    (tableFiltering) => selectedTableIds.includes(tableFiltering == null ? void 0 : tableFiltering.id)
  );
  const actualIdsForSelectedTables = selectedTableData.map((table) => table.id);
  useEffect(() => {
    setShowDeleteTableModal(false);
    setJoinAnchorEl(null);
    setPropertiesAnchorEl(null);
  }, [anchorEl, selectedTableIds]);
  const handleDelete = () => {
    setShowDeleteTableModal(true);
  };
  const handleJoin = (e) => {
    setJoinAnchorEl(e.currentTarget);
  };
  const handleDeleteTables = () => {
    const actualIdsForTables = selectedTableData.map((table) => table.id);
    deleteLocalTables(actualIdsForTables);
    const newFloorplan = {
      ...floorplanData,
      tables: filterByProperty(floorplanData == null ? void 0 : floorplanData.tables, selectedTableIds, "id", true)
    };
    updateLocalFloorplan(newFloorplan);
    onDelete2();
  };
  const selectedTableNumbers = flatten(selectedTableData, "tableNumber");
  const includesJoin = selectedTableData.some((tableData) => tableData.isJoin);
  const tableJoin = useMemo(() => {
    var _a;
    if (includesJoin) {
      return null;
    }
    return (_a = tables.data.filter((tableFiltering) => tableFiltering == null ? void 0 : tableFiltering.isJoin).filter((tableFiltering) => {
      const joinedTables = tableFiltering.tableNumber.split(",");
      return arraysMatch(joinedTables, selectedTableNumbers);
    })) == null ? void 0 : _a[0];
  }, [selectedTableIds, tables.data]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchorEl,
      onClose,
      anchorEl,
      innerStyle: popoverStyles$1.popoverInner,
      anchorOrigin: {
        vertical: "center",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topSection }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles(theme2),
        onClick: (e) => setPropertiesAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(Box, { style: { width: "20px" } }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { color: theme2.colors.gray3, height: "15px" } })), /* @__PURE__ */ React__default.createElement(Box, null, "Edit properties for selected tables"))
    ), selectedTableIds.length > 1 && !includesJoin && !tableJoin && /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles(theme2), onClick: handleJoin }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(JoinSVG, { style: { color: theme2.colors.gray3, width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Join tables"))), tableJoin && /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles(theme2), onClick: handleDelete }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(JoinSVG, { style: { color: theme2.colors.gray3, width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Unjoin tables")))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles(theme2), onClick: handleDelete }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete tables")))))
  ), /* @__PURE__ */ React__default.createElement(
    DeleteTableModal$1,
    {
      isOpen: showDeleteTableModal,
      floorplanTables: selectedFloorplanTables,
      onClose: () => {
        setPropertiesAnchorEl(null);
        setShowDeleteTableModal(false);
        onClose();
      },
      onDelete: handleDeleteTables
    }
  ), /* @__PURE__ */ React__default.createElement(
    MultiTableProperties$1,
    {
      floorplanTables: floorplanData == null ? void 0 : floorplanData.tables,
      tables: tables.data,
      selectedTableIds,
      onClose: () => {
        setPropertiesAnchorEl(null);
        onClose();
      },
      floorplan: floorplanData,
      showDeleteModal: () => setShowDeleteTableModal(true),
      anchor: propertiesAnchorEl,
      anchorOrigin: {
        horizontal: "left"
      },
      transformOrigin: {
        horizontal: "right"
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    EnableJoin$1,
    {
      onClose: () => {
        setJoinAnchorEl(null);
        onClose();
      },
      anchor: joinAnchorEl,
      selectedTableIds: actualIdsForSelectedTables
    }
  ));
};
MultiTableRowEdit.defaultProps = {
  anchorEl: null,
  selectedTableIds: []
};
MultiTableRowEdit.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.shape({}),
  floorplanData: floorplanDataPropTypes.isRequired,
  deleteLocalTables: PropTypes.func.isRequired,
  updateLocalFloorplan: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  tables: tablesPropTypes.isRequired,
  selectedTableIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
};
const mapStateToProps$1o = (state) => ({
  tables: state.tables
});
const mapDispatchToProps$1n = (dispatch) => bindActionCreators(
  {
    deleteLocalTables: deleteLocalTablesAction,
    updateLocalFloorplan: updateLocalFloorplanAction
  },
  dispatch
);
const MultiTableRowEdit$1 = connect(mapStateToProps$1o, mapDispatchToProps$1n)(MultiTableRowEdit);
const TableProperties = ({
  floorplanTable,
  tableData,
  anchor,
  onClose,
  updateLocalTable,
  updateLocalFloorplan,
  floorplan,
  showDeleteModal,
  anchorOrigin,
  transformOrigin
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$L();
  const [number, setNumber] = useState("");
  const [type2, setType] = useState(null);
  const [minSeats, setMinSeats] = useState("");
  const [maxSeats, setMaxSeats] = useState("");
  const [bookableBy, setBookableBy] = useState(null);
  const [notes, setNotes] = useState(null);
  const [showNotes, setShowNotes] = useState(false);
  const [numberError, setNumberError] = useState(null);
  const styles2 = {
    popoverInner: {
      marginLeft: "20px",
      marginTop: "0",
      borderRadius: "6px",
      padding: "0",
      pointerEvents: "auto",
      overflow: "visible"
    }
  };
  useEffect(() => {
    if (!anchor)
      ;
    else {
      unstable_batchedUpdates(() => {
        setNumber(`${tableData == null ? void 0 : tableData.tableNumber}`);
        setType(floorplanTable == null ? void 0 : floorplanTable.type);
        setMaxSeats(`${tableData == null ? void 0 : tableData.maxSeats}`);
        setMinSeats(`${tableData == null ? void 0 : tableData.minSeats}`);
        setBookableBy((tableData == null ? void 0 : tableData.isPublic) ? "public" : "private");
        setShowNotes(!isEmpty(tableData == null ? void 0 : tableData.notes));
        setNotes(tableData == null ? void 0 : tableData.notes);
        setNumberError(null);
      });
    }
  }, [anchor, tableData, floorplanTable]);
  const updateMinSeats = (newMin) => {
    const maxSeatsForTable = 20;
    let maxSeatsAsInt = parseInt(maxSeats, 10) || 0;
    let newMinAsInt = Math.min(maxSeatsForTable, parseInt(newMin, 10)) || 0;
    if (newMinAsInt < 1) {
      newMinAsInt = 1;
    }
    if (newMinAsInt > maxSeatsAsInt) {
      maxSeatsAsInt = newMinAsInt;
    }
    setMinSeats(`${newMinAsInt}`);
    setMaxSeats(`${maxSeatsAsInt}`);
  };
  const updateMaxSeats = (newMax) => {
    const maxSeatsForTable = 20;
    let minSeatsAsInt = parseInt(minSeats, 10) || 0;
    let newMaxAsInt = Math.min(maxSeatsForTable, parseInt(newMax, 10)) || 0;
    if (newMaxAsInt < 1) {
      newMaxAsInt = 1;
      minSeatsAsInt = 1;
    }
    if (newMaxAsInt < minSeatsAsInt) {
      minSeatsAsInt = newMaxAsInt;
    }
    setMinSeats(`${minSeatsAsInt}`);
    setMaxSeats(`${newMaxAsInt}`);
  };
  const sendUpdate = () => {
    var _a;
    const maxSeatsAsInt = parseInt(maxSeats, 10) || 1;
    const minSeatsAsInt = parseInt(minSeats, 10) || 1;
    const newTableNumber = number === "" || number.match(/^0+$/) ? "T0" : number.replace("/[, -]/g", "");
    const updatedTable = {
      ...tableData,
      notes,
      tableNumber: newTableNumber,
      minSeats: minSeatsAsInt,
      maxSeats: maxSeatsAsInt,
      isPublic: bookableBy !== "private"
      // Since it should default to public
    };
    if (type2 !== (floorplanTable == null ? void 0 : floorplanTable.type)) {
      const newFloorplanTable = {
        ...floorplanTable,
        type: type2
      };
      const newFloorplan = {
        ...floorplan == null ? void 0 : floorplan.data,
        tables: updateObjectByProperty((_a = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a.tables, newFloorplanTable, "id")
      };
      devLog("info", "updating table from properties", newFloorplanTable);
      updateLocalFloorplan(newFloorplan);
    }
    updateLocalTable(updatedTable);
  };
  const handleClose = () => {
    sendUpdate();
    onClose();
  };
  const updateType = (newType) => {
    setType(newType);
  };
  const updatePublic = (newValue) => {
    const newValueAsBoolean = newValue !== "private";
    if (newValue !== (tableData == null ? void 0 : tableData.isPublic)) {
      const newTable = {
        ...tableData,
        isPublic: newValueAsBoolean
      };
      setBookableBy(newValue);
      updateLocalTable(newTable);
    }
  };
  const handleDelete = () => {
    showDeleteModal();
  };
  const fieldStyles2 = {
    label: { fontSize: "18px", width: "140px" },
    input: { minWidth: "250px" },
    dropdown: { minWidth: "250px", fontSize: "18px" },
    errorText: { marginLeft: "150px" }
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchor,
      onClose: handleClose,
      anchorEl: anchor,
      innerStyle: styles2.popoverInner,
      anchorOrigin: {
        vertical: "center",
        horizontal: "right",
        ...anchorOrigin
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "left",
        ...transformOrigin
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer, style: { minHeight: "300px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, "Table properties"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.fields }, /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Number",
        value: number,
        style: fieldStyles2,
        onChange: (value) => {
          const newNumber = alphaNumeric(value);
          setNumber(newNumber);
          if (newNumber.match(/^0+$/)) {
            setNumberError("Table number cannot be just 0");
          } else {
            setNumberError(null);
          }
        },
        onBlur: () => {
          sendUpdate();
        },
        error: numberError,
        onEnter: sendUpdate,
        disabled: tableData == null ? void 0 : tableData.isJoin
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownComponent,
      {
        label: "Type",
        items: tableTypes,
        value: type2,
        style: fieldStyles2,
        onSelect: updateType
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Min guests",
        value: minSeats,
        style: fieldStyles2,
        onChange: setMinSeats,
        onBlur: () => updateMinSeats(minSeats),
        onEnter: () => updateMinSeats(minSeats)
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Max guests",
        value: maxSeats,
        style: fieldStyles2,
        onChange: setMaxSeats,
        onBlur: () => updateMaxSeats(maxSeats),
        onEnter: () => updateMaxSeats(maxSeats)
      }
    ), /* @__PURE__ */ React__default.createElement(
      CleanDropdownComponent,
      {
        label: "Bookable by",
        items: publicTypes,
        value: bookableBy,
        style: fieldStyles2,
        onSelect: updatePublic
      }
    ), showNotes ? /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        label: "Notes",
        value: notes,
        style: fieldStyles2,
        onChange: setNotes
      }
    ) : /* @__PURE__ */ React__default.createElement(Button, { type: "text", className: classes.showField, onClick: () => setShowNotes(true) }, "+ Add notes"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles$2(theme2), onClick: handleDelete }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete")))))
  );
};
TableProperties.defaultProps = {
  tableData: null,
  floorplanTable: null,
  anchor: null,
  anchorOrigin: {},
  transformOrigin: {}
};
TableProperties.propTypes = {
  updateLocalTable: PropTypes.func.isRequired,
  updateLocalFloorplan: PropTypes.func.isRequired,
  showDeleteModal: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.shape({}),
  tableData: tablePropTypes,
  floorplanTable: floorplanTablePropTypes,
  floorplan: floorplanPropTypes.isRequired,
  anchorOrigin: PropTypes.shape({ horizontal: PropTypes.string, vertical: PropTypes.string }),
  transformOrigin: PropTypes.shape({ horizontal: PropTypes.string, vertical: PropTypes.string })
};
const mapStateToProps$1n = (state) => ({
  floorplan: state.floorplan
});
const mapDispatchToProps$1m = (dispatch) => bindActionCreators(
  {
    updateLocalTable: updateLocalTableAction,
    updateLocalFloorplan: updateLocalFloorplanAction
  },
  dispatch
);
const TableProperties$1 = connect(mapStateToProps$1n, mapDispatchToProps$1m)(TableProperties);
const SvgRightCaret = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 4 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M0.5 0.5L3 3L0.5 5.5", stroke: "black" }));
const RightCaret = SvgRightCaret;
const useStyles$I = createUseStyles((theme2) => ({
  label: {
    fontSize: "12px",
    fontWeight: theme2.fontWeights.medium,
    padding: "8px"
  },
  itemsContainer: {
    padding: "8px"
  },
  item: {
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "0"
  },
  itemInner: {
    alignItems: "center",
    display: "flex",
    gap: "8px"
  },
  editButton: {
    color: theme2.colors.olive3,
    marginLeft: "12px"
  },
  blockedDuration: {
    marginLeft: "29px"
  },
  blockTableContainer: {
    color: theme2.colors.labelText,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "370px",
    fontSize: theme2.fontSizes.l
  },
  blockTableSectionHeader: {
    backgroundColor: `${theme2.colors.linen}`,
    fontWeight: "700",
    fontSize: "18px",
    padding: "12px 24px",
    display: "flex",
    flexDirection: "column"
  },
  blockTableSectionBody: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "12px 24px"
  },
  blockTimeLabel: {
    width: "100px",
    color: `${theme2.colors.smoke}`
  },
  button: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    width: "100%",
    ...theme2.typography.body.PL
  },
  rightCaret: {
    position: "absolute",
    right: "0",
    marginRight: "30px"
  },
  unblockButtonContainer: {
    padding: "12px 24px 4px 24px",
    borderTop: `1px solid ${theme2.colors.shark}`,
    "&:hover": {
      background: theme2.colors.dateSelectBackground,
      cursor: "pointer"
    }
  }
}));
const TableBlockTimeDropdown = ({
  table,
  openingTime,
  closingTime,
  systemTimeInterval,
  todaySessions,
  selectedTimeBlockSlot,
  timeBlockType,
  selectedTimeSlot
}) => {
  const theme2 = useTheme$1();
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [timeBlockLabel, setTimeBlockLabel] = useState("");
  const [timeBlockValue, setTimeBlockValue] = useState("");
  const block = (timeSlot) => {
    selectedTimeBlockSlot(timeSlot, timeBlockType);
    setTimeBlockValue(timeSlot);
  };
  const checkIfIntervalIsInSession = (interval) => {
    return todaySessions.filter((session) => {
      return interval >= session.startTime && interval <= session.endTime;
    });
  };
  const getNextIntervals = (interval = 15) => {
    const now2 = nextNearestMinutes(moment$2(), interval);
    let timeIntervals2 = [];
    let nowInterval = null;
    let sessionCount = 1;
    do {
      nowInterval = moment$2(now2).add(sessionCount * interval, "minute");
      sessionCount += 1;
      const isValidInterval = checkIfIntervalIsInSession(formatIntFromTime(nowInterval));
      if (!isEmpty(isValidInterval)) {
        timeIntervals2 = [
          ...timeIntervals2,
          {
            label: formatDate(nowInterval, "h:mm a"),
            value: formatIntFromTime(nowInterval)
          }
        ];
      }
    } while (formatIntFromTime(nowInterval) < closingTime);
    return timeIntervals2;
  };
  const sessionsToUse = (todaySessions || []).filter((session) => session.areaId === (table == null ? void 0 : table.areaId));
  const nowAsInt = formatIntFromTime(moment$2());
  const sessionToUse = sessionsToUse.find(
    (session) => session.startTime <= nowAsInt && session.endTime > nowAsInt
  );
  const formatTimeslotToInt = () => {
    return formatIntFromTime(moment$2(selectedTimeSlot, "h:mm a"));
  };
  const addCurrentTimeSelection = () => {
    if (!selectedTimeSlot) {
      return null;
    }
    return {
      label: selectedTimeSlot,
      value: formatTimeslotToInt()
    };
  };
  const createTimeOptions = (sessionEndTime, sessionTime, sessionString, dayString) => {
    const timeOptions = [
      ...sessionToUse ? [
        {
          label: `${sessionString}: ${formatTimeFromInt(sessionEndTime)}`,
          value: sessionEndTime
        }
      ] : [],
      {
        label: dayString,
        value: sessionTime
      },
      addCurrentTimeSelection(),
      ...getNextIntervals(systemTimeInterval)
    ];
    return timeOptions.filter((options) => options);
  };
  useEffect(() => {
    if (timeBlockType === "startTime") {
      setTimeBlockLabel("Start Time");
      setDropdownOptions(
        createTimeOptions(sessionToUse == null ? void 0 : sessionToUse.startTime, openingTime, "Start of session", "Start of day")
      );
    }
    if (timeBlockType === "endTime") {
      setTimeBlockLabel("End Time");
      setDropdownOptions(
        createTimeOptions(sessionToUse == null ? void 0 : sessionToUse.endTime, closingTime, "End of session", "End of day")
      );
    }
  }, []);
  useEffect(() => {
    if (selectedTimeSlot) {
      setTimeBlockValue(formatTimeslotToInt());
    }
  }, [selectedTimeSlot]);
  const style = {
    container: { fontSize: "inherit", height: "unset", maxWidth: "100%" },
    errorText: { margin: "3px 0 0 0" },
    items: { display: "flex", flexDirection: "column", gap: "4px" },
    item: {
      fontSize: "15px",
      height: "auto",
      padding: "8px"
    },
    popover: {
      marginTop: "-6px",
      width: "228px"
    },
    label: {
      width: "100px",
      fontSize: "15px",
      color: theme2.colors.smoke,
      fontWeight: "400"
    },
    value: {
      width: "100%",
      height: "36px",
      padding: "0 12px",
      fontSize: "15px",
      "&:hover": {
        overflow: "visible",
        zIndex: "10"
      }
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: timeBlockLabel,
      items: dropdownOptions,
      value: timeBlockValue,
      onSelect: (value) => {
        block(value);
      },
      style,
      placeholder: "Empty",
      ...popoverAnchors
    }
  );
};
TableBlockTimeDropdown.defaultProps = {
  anchorEl: null,
  onClose: () => {
  },
  table: () => {
  }
};
TableBlockTimeDropdown.propTypes = {
  table: tablePropTypes,
  anchorEl: PropTypes.shape({}),
  onClose: PropTypes.func,
  openingTime: PropTypes.number.isRequired,
  closingTime: PropTypes.number.isRequired,
  systemTimeInterval: PropTypes.number.isRequired,
  todaySessions: PropTypes.arrayOf(sessionPropTypes).isRequired,
  selectedTimeBlockSlot: PropTypes.func.isRequired,
  timeBlockType: PropTypes.string.isRequired,
  selectedTimeSlot: PropTypes.string.isRequired
};
const mapStateToProps$1m = () => ({});
const mapDispatchToProps$1l = (dispatch) => bindActionCreators({}, dispatch);
const TableBlockTimeDropdown$1 = connect(mapStateToProps$1m, mapDispatchToProps$1l)(TableBlockTimeDropdown);
const TableBlockTimeRangePopover = ({
  table,
  anchorEl,
  onClose,
  openingTime,
  closingTime,
  systemTimeInterval,
  currentBlock,
  todaySessions,
  setUnsavedBlock,
  blockAction,
  removeBlockForTable
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$I();
  const [startTimeRangeAnchorEl, setStartTimeRangeAnchorEl] = useState(null);
  const [endTimeRangeAnchorEl, setEndTimeRangeAnchorEl] = useState(null);
  const [selectedStartTime, setSelectedStartTime] = useState("");
  const [selectedEndTime, setSelectedEndTime] = useState("");
  const [originalStartTime, setOriginalStartTime] = useState("");
  const [originalEndTime, setOriginalEndTime] = useState("");
  const [blockPopoverLabel, setBlockPopoverLabel] = useState("");
  const resetTimes = (st, et) => {
    let startTime = st;
    let endTime = et;
    if (startTime !== "") {
      startTime = formatTimeFromInt(startTime, "h:mm a");
    }
    if (endTime !== "") {
      endTime = formatTimeFromInt(endTime, "h:mm a");
    }
    setSelectedStartTime(startTime);
    setOriginalStartTime(startTime);
    setSelectedEndTime(endTime);
    setOriginalEndTime(endTime);
  };
  useEffect(() => {
    if (blockAction === "Add") {
      resetTimes("", "");
    }
  }, [anchorEl, table == null ? void 0 : table.id]);
  const selectedTimeBlockSlot = (timeSlot, timeSlotType) => {
    if (timeSlotType === "startTime") {
      setSelectedStartTime(formatTimeIfInt(timeSlot));
    }
    if (timeSlotType === "endTime") {
      setSelectedEndTime(formatTimeIfInt(timeSlot));
    }
  };
  const saveTableBlockTimes = () => {
    setUnsavedBlock(table, currentBlock, selectedStartTime, selectedEndTime);
  };
  const setTimeRangePopoverClosed = () => {
    if (selectedStartTime === "" || selectedEndTime === "") {
      devLog(
        "info",
        "blocks",
        "missing start time or end time",
        selectedStartTime,
        selectedEndTime
      );
      onClose();
      return;
    }
    if (selectedStartTime === originalStartTime && selectedEndTime === originalEndTime) {
      devLog("info", "blocks", "start or end time is wrong", selectedStartTime, selectedEndTime);
      onClose();
      return;
    }
    if ((selectedStartTime !== "" || selectedEndTime !== "") && blockAction === "Edit") {
      if (selectedStartTime === "") {
        setSelectedStartTime(originalStartTime);
      }
      if (selectedEndTime === "") {
        setSelectedEndTime(originalEndTime);
      }
    }
    saveTableBlockTimes();
    onClose();
  };
  useEffect(() => {
    setBlockPopoverLabel(blockAction === "Edit" ? "Edit Block" : "Create Block");
    if (blockAction === "Edit" && (currentBlock == null ? void 0 : currentBlock.startTime) && (currentBlock == null ? void 0 : currentBlock.endTime)) {
      resetTimes(currentBlock.startTime, currentBlock.endTime);
    }
  }, [blockAction]);
  const handleUnblock = () => {
    removeBlockForTable(table, currentBlock);
    onClose();
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      anchorEl,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      innerStyle: {
        borderRadius: "8px",
        marginLeft: "-4px",
        marginTop: "10px",
        padding: "0px",
        userSelect: "none"
      },
      isOpen: !!anchorEl,
      onClose: () => {
        onClose();
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockTableContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockTableSectionHeader }, blockPopoverLabel), /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockTableSectionBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.item }, /* @__PURE__ */ React__default.createElement(
      TableBlockTimeDropdown$1,
      {
        table,
        anchorEl: startTimeRangeAnchorEl,
        onClose: () => {
          setStartTimeRangeAnchorEl(null);
        },
        openingTime,
        closingTime,
        systemTimeInterval,
        currentBlock,
        todaySessions,
        selectedTimeBlockSlot,
        timeBlockType: "startTime",
        selectedTimeSlot: blockAction === "Add" ? selectedStartTime : selectedStartTime || originalStartTime
      }
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.item }, /* @__PURE__ */ React__default.createElement(
      TableBlockTimeDropdown$1,
      {
        table,
        anchorEl: endTimeRangeAnchorEl,
        onClose: () => {
          setEndTimeRangeAnchorEl(null);
        },
        openingTime,
        closingTime,
        systemTimeInterval,
        currentBlock,
        todaySessions,
        selectedTimeBlockSlot,
        timeBlockType: "endTime",
        selectedTimeSlot: blockAction === "Add" ? selectedEndTime : selectedEndTime || originalEndTime
      }
    )), /* @__PURE__ */ React__default.createElement(Button, { className: classes.button, onClick: setTimeRangePopoverClosed, fullWidth: true }, "Save block"))),
    blockAction === "Edit" && /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        className: classes.unblockButtonContainer,
        style: bottomButtonStyles(theme2),
        onClick: handleUnblock
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(IconBlockSVG, { style: { color: theme2.colors.gray3, height: "15px", width: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Unblock"))
    )
  );
};
TableBlockTimeRangePopover.defaultProps = {
  anchorEl: null,
  onClose: () => {
  },
  currentBlock: {},
  table: null
};
TableBlockTimeRangePopover.propTypes = {
  table: tablePropTypes,
  anchorEl: PropTypes.shape({}),
  onClose: PropTypes.func,
  openingTime: PropTypes.number.isRequired,
  closingTime: PropTypes.number.isRequired,
  systemTimeInterval: PropTypes.number.isRequired,
  currentBlock: PropTypes.instanceOf(Object),
  todaySessions: PropTypes.arrayOf(sessionPropTypes).isRequired,
  setUnsavedBlock: PropTypes.func.isRequired,
  blockAction: PropTypes.string.isRequired,
  removeBlockForTable: PropTypes.func.isRequired
};
const mapStateToProps$1l = () => ({});
const mapDispatchToProps$1k = (dispatch) => bindActionCreators({}, dispatch);
const TableBlockTimeRangePopover$1 = connect(mapStateToProps$1l, mapDispatchToProps$1k)(TableBlockTimeRangePopover);
const TableRowEdit = ({
  table,
  anchorEl,
  onClose,
  floorplanData,
  deleteLocalTables,
  updateLocalFloorplan,
  openingTime,
  closingTime,
  systemTimeInterval,
  todaySessions,
  setUnsavedBlockForTable,
  removeBlockForTable
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$J();
  const floorplanTable = getFloorplanTableFromTableData(floorplanData == null ? void 0 : floorplanData.tables, table);
  const [showDeleteTableModal, setShowDeleteTableModal] = useState(false);
  const [propertiesAnchorEl, setPropertiesAnchorEl] = useState(null);
  const [blockTimesAnchorEl, setBlockTimesAnchorEl] = useState(null);
  const [currentBlocks, setCurrentBlocks] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState({});
  const [blockAction, setBlockAction] = useState("Add");
  const getCurrentBlocks = () => {
    const apiBlockData = getTableBlocksForDate(table, moment().format("YYYY-MM-DD"));
    setCurrentBlocks(apiBlockData);
  };
  useEffect(() => {
    setShowDeleteTableModal(false);
    setPropertiesAnchorEl(null);
    getCurrentBlocks();
  }, [anchorEl, table == null ? void 0 : table.id]);
  const handleDelete = () => {
    setShowDeleteTableModal(true);
  };
  const handleDeleteTable = () => {
    deleteLocalTables([table == null ? void 0 : table.id]);
    const newFloorplan = {
      ...floorplanData,
      tables: filterByProperty(floorplanData == null ? void 0 : floorplanData.tables, table == null ? void 0 : table.id, "id", true)
    };
    updateLocalFloorplan(newFloorplan);
  };
  const setUnsavedBlock = (savedTable, newSelectedBlock, startTime, endTime) => {
    setUnsavedBlockForTable(savedTable, newSelectedBlock, startTime, endTime);
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: !!anchorEl,
      onClose,
      anchorEl,
      innerStyle: popoverStyles$1.popoverInner,
      anchorOrigin: {
        vertical: "center",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.topSection }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles(theme2),
        onClick: (e) => setPropertiesAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(EditSVG, { style: { color: theme2.colors.gray3, height: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Edit properties"))
    ), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "custom",
        style: buttonStyles(theme2),
        onClick: (e) => {
          setSelectedBlock({});
          setBlockAction("Add");
          setBlockTimesAnchorEl(e.currentTarget);
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(IconBlockSVG, { style: { color: theme2.colors.gray3, width: "17px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Block Table"), /* @__PURE__ */ React__default.createElement(RightCaret, { className: classes.rightCaret }))
    ), currentBlocks && currentBlocks.map((currentBlock, index) => {
      return (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ React__default.createElement(Box, { key: index }, currentBlock.startTime >= 0 && currentBlock.endTime >= 0 && currentBlock.removeFlag !== true && /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: `${classes.blockedTableContainer} ${index === 0 ? `${classes.firstBlock}` : ""}`,
            onClick: (e) => {
              setSelectedBlock(currentBlock);
              setBlockAction("Edit");
              setBlockTimesAnchorEl(e.currentTarget);
            }
          },
          /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles(theme2) }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(IconBlockSVG, { style: { color: theme2.colors.gray3 } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockInfoContainer }, "Blocked", /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockTimeWhiteBox }, formatTimeIfInt(currentBlock.startTime), " -", " ", formatTimeIfInt(currentBlock.endTime))))),
          /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles(theme2) }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.editBlock }, "Edit"), /* @__PURE__ */ React__default.createElement(RightCaret, { className: classes.rightCaret })))
        ))
      );
    }), (table == null ? void 0 : table.isJoin) && /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles(theme2), onClick: handleDelete }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(JoinSVG, { style: { color: theme2.colors.gray3, width: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Unjoin tables")))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bottomSection }, /* @__PURE__ */ React__default.createElement(Button, { type: "custom", style: buttonStyles(theme2), onClick: handleDelete }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.button }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { color: theme2.colors.gray3, width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete")))))
  ), /* @__PURE__ */ React__default.createElement(
    DeleteTableModal$1,
    {
      isOpen: showDeleteTableModal,
      floorplanTables: [floorplanTable],
      onClose: () => {
        setPropertiesAnchorEl(null);
        setShowDeleteTableModal(false);
        onClose();
      },
      onDelete: handleDeleteTable,
      table
    }
  ), /* @__PURE__ */ React__default.createElement(
    TableProperties$1,
    {
      floorplanTable,
      onClose: () => {
        setPropertiesAnchorEl(null);
        onClose();
      },
      floorplan: floorplanData,
      showDeleteModal: () => setShowDeleteTableModal(true),
      anchor: propertiesAnchorEl,
      tableData: table,
      anchorOrigin: {
        horizontal: "left"
      },
      transformOrigin: {
        horizontal: "right"
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    TableBlockTimeRangePopover$1,
    {
      table,
      anchorEl: blockTimesAnchorEl,
      onClose: () => {
        setBlockTimesAnchorEl(null);
        onClose();
      },
      openingTime,
      closingTime,
      systemTimeInterval,
      currentBlock: selectedBlock,
      todaySessions,
      setUnsavedBlock,
      blockAction,
      removeBlockForTable
    }
  ));
};
TableRowEdit.defaultProps = {
  table: null,
  anchorEl: null,
  selectedTableIds: []
};
TableRowEdit.propTypes = {
  onClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.shape({}),
  table: tablePropTypes,
  floorplanData: floorplanDataPropTypes.isRequired,
  deleteLocalTables: PropTypes.func.isRequired,
  updateLocalFloorplan: PropTypes.func.isRequired,
  openingTime: PropTypes.number.isRequired,
  closingTime: PropTypes.number.isRequired,
  systemTimeInterval: PropTypes.number.isRequired,
  todaySessions: PropTypes.arrayOf(sessionPropTypes).isRequired,
  setUnsavedBlockForTable: PropTypes.func.isRequired,
  removeBlockForTable: PropTypes.func.isRequired,
  tables: tablesPropTypes.isRequired
};
const mapStateToProps$1k = (state) => ({
  tables: state.tables
});
const mapDispatchToProps$1j = (dispatch) => bindActionCreators(
  {
    deleteLocalTables: deleteLocalTablesAction,
    updateLocalFloorplan: updateLocalFloorplanAction
  },
  dispatch
);
const TableRowEdit$1 = connect(mapStateToProps$1k, mapDispatchToProps$1j)(TableRowEdit);
const useStyles$H = createUseStyles((theme2) => ({
  container: {},
  iconButton: {
    color: theme2.colors.smoke,
    transition: "color 0.1s",
    "&:hover": {
      color: theme2.colors.charcoal,
      cursor: "pointer"
    }
  },
  table: (props) => ({
    borderCollapse: "collapse",
    textAlign: "left",
    borderRadius: "8px 8px 0 0",
    width: "max-content",
    minWidth: "100%",
    "& thead": {
      textAlign: "left",
      fontSize: "14px",
      backgroundColor: theme2.colors.tableMenuBackground,
      // position: 'sticky',
      // zIndex: '99',
      // top: '85px',
      "& tr": {
        "& th:first-child": {
          borderRadius: "8px 0 0 0"
        },
        "& th:last-child": {
          borderRadius: "0 8px 0 0"
        },
        "& th": {
          userSelect: "none",
          padding: "16px 16px",
          fontWeight: theme2.fontWeights.medium
          // '&:hover': {
          //   '& $iconArrow': {
          //     opacity: '0.4',
          //   },
          // },
        }
      }
    },
    "& tbody": {
      "& tr": {
        "& td": {
          padding: "12px 10px"
        }
      },
      "& tr:first-child": {
        "& td": {
          borderBottom: `1px solid ${(props == null ? void 0 : props.priorityView) ? theme2.colors.shark : theme2.colors.nimbus}`
        }
      },
      "& tr:not(:first-child):not(:last-child)": {
        "& td": {
          borderBottom: `1px solid ${theme2.colors.shark}`
        }
      }
    }
  }),
  priorityRow: (props) => ({
    // cursor: 'default',
    borderRadius: (props == null ? void 0 : props.isDragging) ? "20px" : "inherit",
    borderBottom: 0,
    boxShadow: (props == null ? void 0 : props.isDragging) ? "0px 4px 4px rgba(151, 151, 151, 0.25)" : "inherit",
    backgroundColor: (props == null ? void 0 : props.hovered) || (props == null ? void 0 : props.isDragging) || (props == null ? void 0 : props.isDraggingOther) ? theme2.colors.yetAnotherGray13 : (props == null ? void 0 : props.selected) ? theme2.colors.lightCloud : "white",
    "& td": {
      borderBottom: (props == null ? void 0 : props.isDragging) ? "1px solid transparent !important" : `inherit`
    }
  }),
  headerCellInner: {
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },
  iconArrow: {
    opacity: 0,
    width: "11px",
    overflow: "hidden",
    color: theme2.colors.charcoal,
    transition: "transform 0.1s, opacity 0.1s",
    marginTop: "2px"
  },
  tableControl: {
    userSelect: "none",
    borderRadius: "6px",
    width: "fit-content",
    padding: "8px 10px",
    border: "1px solid transparent",
    "&:hover": {
      cursor: "pointer",
      background: theme2.colors.backgroundLight
    }
  },
  tableGroupingHeader: {
    paddingTop: "30px",
    fontWeight: theme2.fontWeights.medium
  },
  tableCard: {
    padding: "6px 8px",
    border: "1px solid black",
    borderRadius: "4px",
    width: "fit-content"
    // backgroundColor: theme.colors.white,
  },
  popoverGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: "35px",
    rowGap: "15px",
    alignItems: "center"
  },
  tablePublicControl: {
    userSelect: "none",
    borderRadius: "6px",
    padding: "8px 10px",
    display: "flex",
    justifyContent: "space-between",
    width: "200px",
    margin: "-4px -5px",
    "&:hover": {
      cursor: "pointer",
      background: theme2.colors.backgroundLight
    }
  },
  banner: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    width: "100%",
    height: "56px",
    backgroundColor: theme2.colors.bannerBlue,
    borderRadius: "6px",
    padding: "12px 20px",
    alignItems: "center",
    marginBottom: "20px"
    // marginTop: '10px',
  },
  bannerLeft: {
    // width: '60%',
    lineHeight: "1.7"
  },
  bannerRight: {},
  tableNumberColumn: {
    width: "160px",
    [theme2.breakpoints.down("md")]: {
      width: "120px"
    }
  }
}));
const actionButtonStyles = (theme2, hidden) => ({
  container: {
    width: "20px",
    height: "40px",
    marginTop: "-12px",
    marginBottom: "-12px",
    borderRadius: "20px",
    opacity: hidden ? 0 : 1,
    pointerEvents: hidden ? "none" : "auto"
  },
  button: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 10px",
    // width: '40px',
    height: "40px",
    borderRadius: "20px",
    // backgroundColor: 'white',
    // color: 'black',
    // boxShadow: '0px 4px 4px rgba(176, 176, 176, 0.25)',
    // cursor: 'pointer',
    color: theme2.colors.smoke
  },
  text: {
    // TODO this should be on the button style in component library
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "20px"
  },
  bannerText: {}
});
const SvgArrowDown = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M1 1L5.5 5L10 1", stroke: "currentColor", strokeWidth: 1.5 }));
const AccordionDownArrowSVG = SvgArrowDown;
const SvgJoinCircle = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 10, cy: 10, r: 9.5, fill: "#313131", stroke: "black" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.55024 6.95394C5.55024 7.40168 5.16055 7.80779 4.62522 7.80779C4.08989 7.80779 3.7002 7.40168 3.7002 6.95394C3.7002 6.50621 4.08989 6.1001 4.62522 6.1001C5.16055 6.1001 5.55024 6.50621 5.55024 6.95394Z", stroke: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.55024 13.0462C5.55024 13.494 5.16055 13.9001 4.62522 13.9001C4.08989 13.9001 3.7002 13.494 3.7002 13.0462C3.7002 12.5985 4.08989 12.1924 4.62522 12.1924C5.16055 12.1924 5.55024 12.5985 5.55024 13.0462Z", stroke: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.52832 6.92219C6.57938 6.92219 8.27127 6.86122 9.5946 7.82089C11.487 9.19328 12.5381 10.0085 14.0797 10.0085H15.8206", stroke: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.70703 13.1374C6.75809 13.1374 8.26959 13.1983 9.59291 12.2387C11.4853 10.8663 12.5364 10.051 14.078 10.051H16.414", stroke: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M14.4844 7.80005L16.8 10.1467L14.4844 12.2", stroke: "white" }));
const JoinCircle = SvgJoinCircle;
const useStyles$G = createUseStyles((theme2) => ({
  circle: {
    width: "16px",
    height: "16px",
    lineHeight: "16px",
    borderRadius: "50%",
    border: `1px solid ${theme2.colors.shark}`,
    fontSize: "12px",
    textAlign: "center",
    position: "relative",
    left: "10px",
    top: "-32px",
    zIndex: "100",
    backgroundColor: "white"
  },
  iconContainer: {
    display: "flex"
  },
  blockList: {
    display: "flex",
    position: "relative"
  },
  blockListSummaryContainer: {
    paddingTop: "2px",
    paddingLeft: "5px",
    "&:first-child": {
      paddingTop: "4px"
    }
  },
  blockListDetails: {
    height: "auto",
    width: "auto",
    overflow: "visible",
    boxShadow: "0px 4.90909px 4.90909px rgba(128, 128, 128, 0.25)",
    position: "absolute",
    top: "-12px",
    "&:first-child": {
      paddingTop: "0px"
    }
  },
  blockIcon: (props) => ({
    flexShrink: 0,
    width: "15px",
    height: "15px",
    color: (props == null ? void 0 : props.isBlockedUnsaved) ? theme2.colors.nimbus : theme2.colors.charcoal
  }),
  blockListItems: {
    display: "inline-flex",
    overflow: "visible",
    alignItems: "center",
    zIndex: "100",
    paddingTop: "2px",
    "&:not(:last-child)": {
      borderBottom: "1px solid #DCDCDB"
    }
  },
  stateNormal: {
    visibility: "hidden"
  },
  stateHovered: {
    backgroundColor: "white",
    borderRadius: "8px",
    paddingLeft: "5px",
    paddingRight: "5px"
  },
  hoveredText: {
    marginLeft: "4px",
    marginTop: "-5px",
    padding: "6px 6px 4px 6px",
    fontSize: "14px",
    userSelect: "none"
  }
}));
const TableBlockIcon = ({ isBlocked, isBlockedUnsaved, tableBlocks }) => {
  const [blockCount, setBlockCount] = useState(0);
  const [hoverState, setHoverState] = useState(false);
  const [currentBlocks, setCurrentBlocks] = useState([]);
  const classes = useStyles$G({ isBlockedUnsaved });
  useEffect(() => {
    const activeBlocks = tableBlocks.filter((blockData) => {
      return (blockData == null ? void 0 : blockData.removeFlag) !== true && (blockData == null ? void 0 : blockData.date);
    });
    setBlockCount(activeBlocks.length);
    setCurrentBlocks(activeBlocks);
  }, [tableBlocks]);
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.iconContainer,
      onMouseOver: () => setHoverState(true),
      onMouseLeave: () => setHoverState(false),
      onFocus: () => setHoverState(true)
    },
    (isBlocked || isBlockedUnsaved) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockList }, hoverState === false && /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockListSummaryContainer }, /* @__PURE__ */ React__default.createElement(IconBlockSVG, { className: classes.blockIcon }), blockCount > 1 && /* @__PURE__ */ React__default.createElement(Box, { className: classes.circle }, blockCount)), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.blockListDetails} ${hoverState === true ? `${classes.stateHovered}` : `${classes.stateNormal}`}`
      },
      currentBlocks.length > 0 && currentBlocks.map((block) => {
        return /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockListItems }, /* @__PURE__ */ React__default.createElement(IconBlockSVG, { className: classes.blockIcon }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.hoveredText }, formatTimeFromInt(block.endTime)));
      })
    ))
  );
};
TableBlockIcon.defaultProps = {
  tableBlocks: [],
  isBlocked: false,
  isBlockedUnsaved: false
};
TableBlockIcon.propTypes = {
  isBlocked: PropTypes.bool,
  isBlockedUnsaved: PropTypes.bool,
  tableBlocks: PropTypes.arrayOf(tableBlockPropTypes)
};
const mapStateToProps$1j = () => ({});
const mapDispatchToProps$1i = (dispatch) => bindActionCreators({}, dispatch);
const TableBlockIcon$1 = connect(mapStateToProps$1j, mapDispatchToProps$1i)(TableBlockIcon);
const DefaultViewRow = ({ table, showTableMenu, areaName, obeeTables: obeeTables2 }) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$H();
  const [hovered, setHovered] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [isBlockedUnsaved, setIsBlockedUnsaved] = useState(false);
  const [tableBlocks, setTableBlocks] = useState([]);
  useEffect(() => {
    var _a2;
    (_a2 = obeeTables2 == null ? void 0 : obeeTables2.data) == null ? void 0 : _a2.forEach((activeTable) => {
      var _a3, _b2, _c2;
      if ((table == null ? void 0 : table.id) === activeTable.id) {
        setTableBlocks((activeTable == null ? void 0 : activeTable.blocks) || []);
        const isUnsavedBlock = (_a3 = activeTable == null ? void 0 : activeTable.blocks) == null ? void 0 : _a3.filter((blockStatus) => {
          return (blockStatus == null ? void 0 : blockStatus.updateFlag) === true && !(blockStatus == null ? void 0 : blockStatus.removeFlag);
        });
        const isUnsavedUnblock = (_b2 = activeTable == null ? void 0 : activeTable.blocks) == null ? void 0 : _b2.filter((blockStatus) => {
          return (blockStatus == null ? void 0 : blockStatus.removeFlag) === true;
        });
        const activeBlock = (_c2 = activeTable == null ? void 0 : activeTable.blocks) == null ? void 0 : _c2.filter((blockStatus) => {
          return (blockStatus == null ? void 0 : blockStatus.date) && !(blockStatus == null ? void 0 : blockStatus.updateFlag);
        });
        if (isEmpty(isUnsavedBlock) && isEmpty(isUnsavedUnblock) && !isEmpty(activeBlock)) {
          setIsBlockedUnsaved(false);
          setIsBlocked(true);
          return;
        }
        if (!isEmpty(isUnsavedBlock) && isEmpty(isUnsavedUnblock)) {
          setIsBlockedUnsaved(true);
          setIsBlocked(false);
          return;
        }
        if (isEmpty(isUnsavedBlock) && !isEmpty(isUnsavedUnblock) && !isEmpty(activeBlock)) {
          setIsBlockedUnsaved(true);
          setIsBlocked(false);
          return;
        }
        if (isEmpty(isUnsavedBlock) && !isEmpty(isUnsavedUnblock) && isEmpty(activeBlock)) {
          setIsBlockedUnsaved(false);
          setIsBlocked(false);
          return;
        }
        if (!isEmpty(isUnsavedBlock) && !isEmpty(isUnsavedUnblock) && isUnsavedBlock !== isUnsavedUnblock) {
          setIsBlockedUnsaved(true);
          setIsBlocked(false);
          return;
        }
        if (isEmpty(isUnsavedBlock) && isEmpty(isUnsavedUnblock)) {
          setIsBlockedUnsaved(false);
          setIsBlocked(false);
        }
      }
    });
  }, [obeeTables2 == null ? void 0 : obeeTables2.data]);
  const cellStyle = {
    width: "120px",
    paddingLeft: "18px"
  };
  return /* @__PURE__ */ React__default.createElement(
    "tr",
    {
      onMouseOver: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      onFocus: () => {
      },
      style: { backgroundColor: hovered ? theme2.colors.yetAnotherGray13 : "inherit" },
      key: table.id
    },
    /* @__PURE__ */ React__default.createElement("td", { className: classes.tableNumberColumn }, table.isJoin ? /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "3px", position: "relative" } }, /* @__PURE__ */ React__default.createElement(
      JoinCircle,
      {
        style: { position: "absolute", top: "-8px", left: "-8px", height: "20px" }
      }
    ), (_a = table.tableNumbers || []) == null ? void 0 : _a.map((num) => /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableCard, key: num }, num))) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableCard }, table.tableNumber)),
    /* @__PURE__ */ React__default.createElement("td", null, areaName),
    /* @__PURE__ */ React__default.createElement("td", { style: cellStyle }, table.minSeats),
    /* @__PURE__ */ React__default.createElement("td", { style: cellStyle }, table.maxSeats),
    /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(
      TableBlockIcon$1,
      {
        isBlocked,
        isBlockedUnsaved,
        tableBlocks
      }
    )),
    /* @__PURE__ */ React__default.createElement("td", { style: cellStyle }, table.isPublic ? "Public" : "Private"),
    /* @__PURE__ */ React__default.createElement("td", { style: { ...cellStyle, color: theme2.colors.nimbus, width: "200px" } }, "P", table == null ? void 0 : table.priority),
    /* @__PURE__ */ React__default.createElement("td", { style: { width: "20px" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "icon",
        style: actionButtonStyles(theme2),
        onClick: (e) => {
          showTableMenu(e);
          setHovered(false);
        }
      },
      /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG$1, { style: { height: "20px", width: "5px" } })
    ))
  );
};
DefaultViewRow.defaultProps = {
  areaName: ""
};
DefaultViewRow.propTypes = {
  showTableMenu: PropTypes.func.isRequired,
  table: tablePropTypes.isRequired,
  areaName: PropTypes.string,
  obeeTables: tablesPropTypes.isRequired
};
const mapStateToProps$1i = (state) => ({
  obeeTables: state.tables
});
const mapDispatchToProps$1h = (dispatch) => bindActionCreators({}, dispatch);
const DefaultViewRow$1 = connect(mapStateToProps$1i, mapDispatchToProps$1h)(DefaultViewRow);
const PrioritisationViewRow = ({
  table,
  areaName,
  provided,
  showTableMenu,
  isDragging,
  isDraggingOther,
  // Whether any rows have been dragged, to know if this one hasn't
  someSelected,
  // Whether any rows have been selected, to know if this one hasn't
  selected,
  onSelect: onSelect2
}) => {
  var _a, _b2, _c2;
  const theme2 = useTheme$1();
  const [hovered, setHovered] = useState(false);
  const selectedButNotDragged = isDraggingOther && selected && !isDragging;
  const classes = useStyles$H({
    isDragging,
    isDraggingOther: selectedButNotDragged,
    hovered,
    selected
  });
  const hasUnsavedBlock = (_a = table == null ? void 0 : table.blocks) == null ? void 0 : _a.some((blockStatus) => {
    return (blockStatus == null ? void 0 : blockStatus.removeFlag) === true || (blockStatus == null ? void 0 : blockStatus.updateFlag) === true;
  });
  const cellStyle = {
    width: "120px",
    paddingLeft: "18px"
  };
  return /* @__PURE__ */ React__default.createElement(
    "tr",
    {
      className: classes.priorityRow,
      ref: provided.innerRef,
      onMouseOver: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      onFocus: () => setHovered(true),
      ...provided.draggableProps,
      style: {
        ...(_b2 = provided.draggableProps) == null ? void 0 : _b2.style,
        opacity: selectedButNotDragged ? 0.4 : 1
      }
    },
    /* @__PURE__ */ React__default.createElement("td", { style: { width: `240px` } }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: {
          alignItems: "center",
          display: "flex",
          gap: "20px",
          maxWidth: "80px"
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { ...provided.dragHandleProps }, /* @__PURE__ */ React__default.createElement(
        DragHandleSVG,
        {
          style: { width: "10px", height: "16px", marginTop: "4px", color: "#808080" }
        }
      )),
      /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Checkbox, { onChange: onSelect2, selected, color: theme2.colors.charcoal })),
      /* @__PURE__ */ React__default.createElement(Box, null, table.isJoin ? /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "3px", position: "relative" } }, /* @__PURE__ */ React__default.createElement(
        JoinCircle,
        {
          style: { position: "absolute", top: "-8px", left: "-8px", height: "20px" }
        }
      ), table.tableNumber.split(",").map((num) => /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableCard }, num))) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableCard }, table.tableNumber))
    )),
    /* @__PURE__ */ React__default.createElement("td", null, areaName),
    /* @__PURE__ */ React__default.createElement("td", { style: cellStyle }, table.minSeats),
    /* @__PURE__ */ React__default.createElement("td", { style: cellStyle }, table.maxSeats),
    /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement(
      TableBlockIcon$1,
      {
        isBlocked: ((_c2 = table == null ? void 0 : table.blocks) == null ? void 0 : _c2.length) > 0,
        isBlockedUnsaved: hasUnsavedBlock,
        tableBlocks: table == null ? void 0 : table.blocks
      }
    )),
    /* @__PURE__ */ React__default.createElement("td", { style: { ...cellStyle, width: "15%" } }, table.isPublic ? "Public" : "Private"),
    /* @__PURE__ */ React__default.createElement("td", { style: { ...cellStyle, width: "200px" } }, "P", table == null ? void 0 : table.priority),
    /* @__PURE__ */ React__default.createElement("td", { style: { width: "20px" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "icon",
        style: actionButtonStyles(theme2, someSelected && !selected),
        onClick: showTableMenu
      },
      /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG$1, { style: { height: "20px", width: "5px" } })
    ))
  );
};
PrioritisationViewRow.defaultProps = {
  areaName: ""
};
PrioritisationViewRow.propTypes = {
  provided: PropTypes.shape({
    innerRef: PropTypes.func,
    draggableProps: PropTypes.shape({
      style: PropTypes.shape({})
    }),
    dragHandleProps: PropTypes.shape({})
  }).isRequired,
  tableRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]).isRequired,
  areaName: PropTypes.string,
  table: tablePropTypes.isRequired,
  showPrioritisationMenu: PropTypes.func.isRequired,
  showTableMenu: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  isDraggingOther: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  someSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
};
const mapStateToProps$1h = () => ({});
const mapDispatchToProps$1g = (dispatch) => bindActionCreators({}, dispatch);
const PrioritisationViewRow$1 = connect(mapStateToProps$1h, mapDispatchToProps$1g)(PrioritisationViewRow);
const TableTable = ({
  areas,
  tables,
  updateTable: updateTable2,
  updateTables: updateTables2,
  floorplanData,
  obeeSessions: obeeSessions2,
  obeeSettings: obeeSettings2,
  fetchSessions,
  fetchObeeSettings: fetchObeeSettings2,
  obeeTables: obeeTables2,
  priorityView
}) => {
  var _a, _b2, _c2;
  const theme2 = useTheme$1();
  const tableRef = useRef(null);
  const [tableEditing, setTableEditing] = useState({});
  const [areaAnchor, setAreaAnchor] = useState(null);
  const [areaEditing, setAreaEditing] = useState(null);
  const [tablesByPriority, setTablesByPriority] = useState([]);
  const [areasWithTables, setAreasWithTables] = useState([]);
  const [sortedAreasWithTables, setSortedAreasWithTables] = useState([]);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [updatedBlockForTables, setUpdatedBlockForTables] = useState({});
  const [showInfoBanner, setShowInfoBanner] = useState(true);
  const [selectedTables, setSelectedTables] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const classes = useStyles$H({ priorityView });
  const showEditTableMenu = (event, table) => {
    setTableEditing({
      anchor: event.currentTarget,
      table
    });
  };
  const sortByTableNumber = (tablesToSort, descending = false) => {
    return sortListNaturalByProperty(tablesToSort, "tableNumber", descending);
  };
  const getAreasWithTableData = (areasToUse) => {
    return areasToUse == null ? void 0 : areasToUse.map((area) => ({
      ...area,
      tables: sortByTableNumber(filterByProperty(tables, area.id, "areaId"))
    }));
  };
  const sort = (column) => {
    if (sortColumn === column) {
      switch (sortOrder) {
        case "ascending":
          setSortOrder("descending");
          setSortColumn(column);
          break;
        case "descending":
        default:
          setSortOrder("ascending");
          setSortColumn(column);
          break;
      }
    } else {
      setSortOrder("ascending");
      setSortColumn(column);
    }
  };
  useEffect(() => {
    setAreasWithTables(getAreasWithTableData(areas));
  }, [areas, tables]);
  const sortPriority = (tablesToSort) => {
    const tablesByNumber = sortByTableNumber(tablesToSort, sortOrder === "descending");
    setTablesByPriority(sortListByProperty(tablesByNumber, "priority", sortOrder === "descending"));
  };
  useEffect(() => {
    if (priorityView) {
      sortPriority(tables);
    }
  }, [areas, tables, sortColumn, sortOrder, priorityView]);
  useEffect(() => {
    if (priorityView) {
      setSortColumn("priority");
      setSortOrder("ascending");
    } else {
      setSortColumn("areas");
      setSortOrder("ascending");
    }
  }, [priorityView]);
  useEffect(() => {
    if (!priorityView) {
      const sortTables = (tablesToSort, descending = false) => {
        if (sortColumn === "tableNumber") {
          return sortByTableNumber(tablesToSort);
        }
        return sortListByProperty(tablesToSort, sortColumn, descending);
      };
      const sortAreaDescending = sortColumn === "tableNumber" && sortOrder === "descending";
      setSortedAreasWithTables(
        sortListNaturalByProperty(areasWithTables, "name", sortAreaDescending).map((area) => ({
          ...area,
          tables: sortTables(area.tables, sortOrder === "descending")
        }))
      );
    }
  }, [areasWithTables, sortColumn, sortOrder, priorityView]);
  const priorityHeaders = [
    { id: 0, label: "Table", colSpan: 1 },
    { id: 1, label: "Area" },
    { id: 2, label: "Seat Min" },
    { id: 3, label: "Seat Max" },
    { id: 4, label: "Blocks" },
    { id: 5, label: "Public/private" },
    { id: 6, label: "Prioritisation" },
    { id: 7, label: " " }
  ];
  const headers = priorityView ? priorityHeaders : [
    {
      id: 0,
      label: "Table & Area",
      sort: "tableNumber",
      colSpan: 2
    },
    { id: 2, label: "Seat Min", sort: "minSeats" },
    { id: 3, label: "Seat Max", sort: "maxSeats" },
    { id: 4, label: "Blocks", sort: "" },
    { id: 5, label: "Public/private", sort: "isPublic" },
    { id: 6, label: "Prioritisation", sort: "priority" },
    { id: 7, label: " " }
  ];
  const getDefaultView = () => sortedAreasWithTables.map((area) => /* @__PURE__ */ React__default.createElement("tbody", { key: `area_${area.id}` }, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { className: classes.tableGroupingHeader, style: { paddingTop: "40px" }, colSpan: 7 }, area.name), /* @__PURE__ */ React__default.createElement("td", { style: { width: "20px" } }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "icon",
      style: { ...actionButtonStyles(theme2), paddingTop: "10px" },
      onClick: (e) => {
        setAreaEditing(area);
        setAreaAnchor(e.currentTarget);
      }
    },
    /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG$1, { style: { height: "20px", width: "5px" } })
  ))), area.tables.length > 0 ? area.tables.map((table) => /* @__PURE__ */ React__default.createElement(
    DefaultViewRow$1,
    {
      key: `table_${table.id}`,
      table,
      showTableMenu: (e) => showEditTableMenu(e, table),
      areaName: area.name
    }
  )) : /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { style: { padding: "16px 20px" }, colSpan: 4 }, "There are no tables for area: ", area.name))));
  const onDragStart2 = useCallback(
    (e) => {
      const dragTableId = e.draggableId;
      if (selectedTables.length > 0) {
        if (selectedTables.map((tableId) => `${tableId}`).includes(dragTableId)) {
          setIsDragging(true);
        }
      }
    },
    [selectedTables]
  );
  const onDragEnd2 = (result) => {
    setIsDragging(false);
    if (result.source.index === result.destination.index) {
      return;
    }
    const sortedTables = sortListByProperty(
      tablesByPriority,
      "priority",
      sortOrder === "descending"
    );
    if (selectedTables && selectedTables.map((tableId) => `${tableId}`).includes(result.draggableId)) {
      const newInsertPriority = getNewPriorityIndex(
        result.source.index,
        result.destination.index,
        sortedTables,
        selectedTables,
        sortOrder === "descending"
      );
      const listWithNoSelections = tablesByPriority.filter(
        (table) => !selectedTables.includes(table == null ? void 0 : table.id)
      );
      const itemsToInsert = selectedTables.map(
        (tableId) => findObjectByProperty(tablesByPriority, tableId, "id")
      );
      const newList = sortListByProperty(
        listWithNoSelections,
        "priority",
        sortOrder === "descending"
      );
      const insertIndex = newInsertPriority <= 0 ? 0 : Math.ceil(newInsertPriority);
      newList.splice(insertIndex, 0, ...itemsToInsert);
      const newPriorities2 = newList.map((table, index) => ({
        ...table,
        priority: index + 1,
        priorityChanged: (table == null ? void 0 : table.priorityChanged) || index + 1 !== (table == null ? void 0 : table.priority)
      }));
      const changedTables2 = newPriorities2.filter((table) => table.priorityChanged);
      updateTables2(changedTables2);
      sortPriority(newPriorities2);
      return;
    }
    const tableToUpdate = sortedTables.find((table) => `${table.id}` === result.draggableId);
    const newPriorities = getNewTablePriorities(
      result.source.index,
      result.destination.index,
      sortedTables,
      tableToUpdate,
      sortOrder === "descending"
    );
    if (!newPriorities) {
      return;
    }
    const changedTables = newPriorities.filter((table) => table.priorityChanged);
    updateTables2(changedTables);
    sortPriority(newPriorities);
  };
  useEffect(() => {
    fetchObeeSettings2();
    fetchSessions();
  }, []);
  const date = formatIntFromTime(moment());
  const systemTimeInterval = (_a = obeeSettings2.data) == null ? void 0 : _a.systemTimeInterval;
  const currentDay = moment(date).format("ddd").toLowerCase();
  const todaySessions = (_b2 = obeeSessions2.data) == null ? void 0 : _b2.filter(
    (session) => (session == null ? void 0 : session.areaId) !== 0 && session.day === currentDay
  );
  const sessionsToCheck = todaySessions;
  const openingSession = sessionsToCheck == null ? void 0 : sessionsToCheck.reduce(
    (prev, curr) => prev.startTime < curr.startTime ? prev : curr,
    {}
  );
  const closingSession = sessionsToCheck == null ? void 0 : sessionsToCheck.reduce(
    (prev, curr) => prev.endTime > curr.endTime ? prev : curr,
    {}
  );
  const openingTime = (openingSession == null ? void 0 : openingSession.startTime) || 0;
  const closingTime = (closingSession == null ? void 0 : closingSession.endTime) || 1440;
  const getCurrentDate = () => {
    return moment().format("YYYY-MM-DD");
  };
  const getIntFromTimeString = (timeString) => {
    return formatIntFromTime(moment(timeString, "h:m A"));
  };
  const refreshBlockData = (joinedTable, newBlockData) => {
    let updatedBlocks = [];
    const filteredBlocks = joinedTable.blocks.filter((blockTime) => {
      if (Array.isArray(newBlockData)) {
        return !newBlockData.find((blockData) => {
          if (isVoid(newBlockData == null ? void 0 : newBlockData.id)) {
            return true;
          }
          return (blockData == null ? void 0 : blockData.id) === (blockTime == null ? void 0 : blockTime.id);
        });
      }
      if (isVoid(newBlockData == null ? void 0 : newBlockData.id)) {
        return true;
      }
      return (newBlockData == null ? void 0 : newBlockData.id) !== (blockTime == null ? void 0 : blockTime.id);
    });
    if (Array.isArray(newBlockData)) {
      updatedBlocks = [...filteredBlocks, ...newBlockData];
    } else {
      updatedBlocks = [...filteredBlocks, newBlockData];
    }
    return updateTable2({
      ...joinedTable,
      blocks: updatedBlocks
    });
  };
  const mapSingleToJoinedTable = (tableJoins, table) => {
    tableJoins.forEach((joinedTable) => {
      const currentTableBlocks = getTableBlocksForDate(joinedTable, getCurrentDate());
      let matchedJoins = [];
      currentTableBlocks.forEach((joinedBlock) => {
        const matchedBlock = table == null ? void 0 : table.blocks.find((singleTableBlock) => {
          return (singleTableBlock == null ? void 0 : singleTableBlock.startTime) === (joinedBlock == null ? void 0 : joinedBlock.startTime) && (singleTableBlock == null ? void 0 : singleTableBlock.endTime) === (joinedBlock == null ? void 0 : joinedBlock.endTime);
        });
        if (!isEmpty(matchedBlock)) {
          matchedJoins = [
            ...matchedJoins,
            {
              ...joinedBlock,
              singleBlockId: matchedBlock.id
            }
          ];
        }
      });
      refreshBlockData(joinedTable, matchedJoins);
    });
  };
  const mapJoinedToSingleTable = (tableNumbers, joinedTable) => {
    let matchedJoins = [];
    tableNumbers.forEach((singleTableId) => {
      const singleTable = obeeTables2 == null ? void 0 : obeeTables2.data.find((table) => {
        return table.tableNumber === singleTableId;
      });
      singleTable == null ? void 0 : singleTable.blocks.forEach((blockData) => {
        joinedTable == null ? void 0 : joinedTable.blocks.forEach((singleTableBlock) => {
          if ((singleTableBlock == null ? void 0 : singleTableBlock.startTime) === (blockData == null ? void 0 : blockData.startTime) && (singleTableBlock == null ? void 0 : singleTableBlock.endTime) === (blockData == null ? void 0 : blockData.endTime)) {
            matchedJoins = [
              ...matchedJoins,
              {
                ...singleTableBlock,
                singleBlockId: blockData == null ? void 0 : blockData.id
              }
            ];
          }
        });
      });
    });
    refreshBlockData(joinedTable, matchedJoins);
  };
  const mapBlocksForJoinedTable = (table) => {
    const tableJoins = getAllJoinsForTable(table, tables);
    if (!isEmpty(tableJoins)) {
      mapSingleToJoinedTable(tableJoins, table);
      return;
    }
    const tableNumbers = table == null ? void 0 : table.tableNumber.split(",");
    if (tableNumbers) {
      mapJoinedToSingleTable(tableNumbers, table);
    }
  };
  const updateBlocksForJoinedTables = (table, tableBlock) => {
    setUpdatedBlockForTables({});
    const tableJoins = getAllJoinsForTable(table, tables);
    tableJoins.forEach((joinedTable) => {
      const blockToUpdate = joinedTable == null ? void 0 : joinedTable.blocks.find((joinedBlock) => {
        return (joinedBlock == null ? void 0 : joinedBlock.singleBlockId) && table.id === tableBlock.tableId && (joinedBlock == null ? void 0 : joinedBlock.singleBlockId) === (tableBlock == null ? void 0 : tableBlock.id);
      });
      if (!isEmpty(blockToUpdate)) {
        refreshBlockData(joinedTable, {
          ...blockToUpdate,
          startTime: tableBlock.startTime,
          endTime: tableBlock.endTime,
          updateFlag: tableBlock == null ? void 0 : tableBlock.updateFlag,
          removeFlag: tableBlock == null ? void 0 : tableBlock.removeFlag,
          singleBlockId: tableBlock == null ? void 0 : tableBlock.singleBlockId
        });
        return;
      }
      if (tableBlock.updateFlag === true) {
        updateTable2({
          ...joinedTable,
          blocks: [...joinedTable.blocks, { ...tableBlock, tableId: joinedTable.id }]
        });
      }
    });
  };
  const updateBlocksForSingleTable = (table, tableBlock) => {
    setUpdatedBlockForTables({});
    refreshBlockData(table, tableBlock);
    const tableNumbers = table == null ? void 0 : table.tableNumber.split(",");
    tableNumbers.filter((tableNumber) => {
      let blockToUpdate = {};
      const singleTable = obeeTables2 == null ? void 0 : obeeTables2.data.find((tableToFind) => {
        return (tableToFind == null ? void 0 : tableToFind.id) === parseInt(tableNumber, 10);
      });
      const joinedTable = table.blocks.find((tableToFind) => {
        return (tableToFind == null ? void 0 : tableToFind.id) === (tableBlock == null ? void 0 : tableBlock.id);
      });
      if (joinedTable == null ? void 0 : joinedTable.singleBlockId) {
        blockToUpdate = singleTable == null ? void 0 : singleTable.blocks.find((blockToFind) => {
          return (blockToFind == null ? void 0 : blockToFind.id) === (joinedTable == null ? void 0 : joinedTable.singleBlockId);
        });
        if (!isEmpty(blockToUpdate)) {
          refreshBlockData(singleTable, {
            ...blockToUpdate,
            startTime: tableBlock.startTime,
            endTime: tableBlock.endTime,
            updateFlag: tableBlock == null ? void 0 : tableBlock.updateFlag,
            removeFlag: tableBlock == null ? void 0 : tableBlock.removeFlag
          });
          return true;
        }
      }
      if (singleTable && tableBlock) {
        refreshBlockData(singleTable, {
          ...tableBlock,
          tableId: singleTable.id
        });
      }
      return false;
    });
  };
  useEffect(() => {
    const updatedTable = obeeTables2.data.find((table) => {
      return table.id === updatedBlockForTables.tableId;
    });
    if (updatedTable && (updatedTable == null ? void 0 : updatedTable.isJoin) === false) {
      updateBlocksForJoinedTables(updatedTable, updatedBlockForTables);
    }
    if (updatedTable && (updatedTable == null ? void 0 : updatedTable.isJoin) === true) {
      updateBlocksForSingleTable(updatedTable, updatedBlockForTables);
    }
  }, [obeeTables2.data]);
  const setUnsavedBlockForTable = (table, selectedBlock, startTime, endTime) => {
    mapBlocksForJoinedTable(table);
    let updatedBlock = {};
    if (selectedBlock == null ? void 0 : selectedBlock.id) {
      updatedBlock = {
        ...selectedBlock,
        endTime: getIntFromTimeString(endTime),
        startTime: getIntFromTimeString(startTime),
        updateFlag: true
      };
    } else {
      updatedBlock = {
        ...selectedBlock,
        tableId: table == null ? void 0 : table.id,
        date: getCurrentDate(),
        endTime: getIntFromTimeString(endTime),
        startTime: getIntFromTimeString(startTime),
        updateFlag: true
      };
    }
    setUpdatedBlockForTables(updatedBlock);
    if ((table == null ? void 0 : table.isJoin) === false) {
      refreshBlockData(table, updatedBlock);
    }
  };
  const removeBlockForTable = (table, removedBlock) => {
    mapBlocksForJoinedTable(table);
    const updatedBlock = {
      ...removedBlock,
      removeFlag: true,
      updateFlag: true
    };
    setUpdatedBlockForTables(updatedBlock);
    if ((table == null ? void 0 : table.isJoin) === false) {
      refreshBlockData(table, updatedBlock);
    }
  };
  const getPrioritisationView = () => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(DragDropContext, { onDragStart: onDragStart2, onDragEnd: onDragEnd2, key: "priority" }, /* @__PURE__ */ React__default.createElement(
    Droppable,
    {
      droppableId: "priority",
      type: "table"
    },
    (dropProvided) => /* @__PURE__ */ React__default.createElement("tbody", { ...dropProvided.droppableProps, ref: dropProvided.innerRef }, tablesByPriority.length > 0 ? tablesByPriority.map((table, index) => /* @__PURE__ */ React__default.createElement(Draggable$2, { key: `${table.id}`, draggableId: `${table.id}`, index }, (dragProvided, snapshot) => {
      var _a2;
      return /* @__PURE__ */ React__default.createElement(
        PrioritisationViewRow$1,
        {
          provided: dragProvided,
          table,
          tableIndex: index,
          areaName: (_a2 = areas.find((area) => area.id === table.areaId)) == null ? void 0 : _a2.name,
          tableRef,
          showTableMenu: (e) => showEditTableMenu(e, table),
          isDragging: snapshot.isDragging,
          isDraggingOther: isDragging,
          someSelected: !isEmpty(selectedTables),
          selected: selectedTables.includes(table.id),
          onSelect: () => setSelectedTables(toggleListItem(selectedTables, table.id))
        }
      );
    })) : /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { style: { padding: "16px 20px" }, colSpan: 4 }, "There are no tables. Please create some tables first")), dropProvided.placeholder)
  )));
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, showInfoBanner && priorityView && /* @__PURE__ */ React__default.createElement(Box, { className: classes.banner }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bannerLeft }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bannerText }, "Drag", /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        backgroundColor: theme2.colors.white,
        display: "inline-flex",
        padding: "4px",
        marginLeft: "4px",
        marginRight: "4px",
        marginBottom: "-4px",
        borderRadius: "4px",
        boxShadow: "0px 4px 8px rgba(151, 151, 151, 0.25)",
        width: "20px",
        height: "26px"
      }
    },
    /* @__PURE__ */ React__default.createElement(DragHandleSVG, { style: { width: "12px", color: theme2.colors.charcoal } })
  ), " ", "up or down to reorder tables")), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "text",
      className: classes.bannerRight,
      style: { fontWeight: theme2.fontWeights.medium },
      onClick: () => setShowInfoBanner(false)
    },
    "Dismiss"
  )), /* @__PURE__ */ React__default.createElement("table", { className: classes.table, ref: tableRef }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, headers.map((header) => /* @__PURE__ */ React__default.createElement(
    "th",
    {
      key: header.id,
      colSpan: (header == null ? void 0 : header.colSpan) || 1,
      onClick: () => header.sort && sort(header.sort),
      style: {
        color: sortColumn === header.sort ? theme2.colors.brandPrimary : "inherit",
        cursor: header.sort ? "pointer" : "default"
      }
    },
    /* @__PURE__ */ React__default.createElement("div", { className: classes.headerCellInner }, header.label, header.sort && /* @__PURE__ */ React__default.createElement(
      AccordionDownArrowSVG,
      {
        className: classes.iconArrow,
        style: {
          opacity: sortColumn === header.sort && 1,
          transform: sortColumn === header.sort && sortOrder === "ascending" && "rotate(180deg)"
        }
      }
    ))
  )))), priorityView ? getPrioritisationView() : getDefaultView()), /* @__PURE__ */ React__default.createElement(
    MultiTableRowEdit$1,
    {
      anchorEl: selectedTables.length > 1 && (tableEditing == null ? void 0 : tableEditing.anchor),
      selectedTableIds: selectedTables,
      floorplanTable: getFloorplanTableFromTableData(floorplanData == null ? void 0 : floorplanData.tables, tableEditing),
      floorplanData,
      onClose: () => setTableEditing({}),
      onDelete: () => setSelectedTables([]),
      openingTime,
      closingTime,
      systemTimeInterval,
      todaySessions,
      setUnsavedBlockForTable,
      removeBlockForTable
    }
  ), /* @__PURE__ */ React__default.createElement(
    TableRowEdit$1,
    {
      anchorEl: selectedTables.length <= 1 && (tableEditing == null ? void 0 : tableEditing.anchor),
      table: findObjectByProperty(tables, (_c2 = tableEditing == null ? void 0 : tableEditing.table) == null ? void 0 : _c2.id, "id"),
      floorplanTable: getFloorplanTableFromTableData(floorplanData == null ? void 0 : floorplanData.tables, tableEditing),
      floorplanData,
      onClose: () => setTableEditing({}),
      showDeleteModal: false,
      openingTime,
      closingTime,
      systemTimeInterval,
      todaySessions,
      setUnsavedBlockForTable,
      removeBlockForTable
    }
  ), /* @__PURE__ */ React__default.createElement(
    AreaRowEdit$1,
    {
      anchorEl: areaAnchor,
      area: findObjectByProperty(areas, areaEditing == null ? void 0 : areaEditing.id, "id"),
      floorplanArea: getFloorplanAreaFromAreaData(floorplanData == null ? void 0 : floorplanData.areas, areaEditing),
      floorplanData,
      onClose: () => {
        setAreaAnchor(null);
      },
      showDeleteModal: false,
      tables
    }
  ));
};
TableTable.defaultProps = {};
TableTable.propTypes = {
  updateTable: PropTypes.func.isRequired,
  updateTables: PropTypes.func.isRequired,
  areas: PropTypes.arrayOf(areaPropTypes).isRequired,
  tables: PropTypes.arrayOf(tablePropTypes).isRequired,
  floorplanData: floorplanDataPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  fetchObeeSettings: PropTypes.func.isRequired,
  obeeTables: tablesPropTypes.isRequired
};
const mapStateToProps$1g = (state) => ({
  obeeSessions: state.obeeSessions,
  obeeSettings: state.obeeSettings,
  obeeTables: state.tables
});
const mapDispatchToProps$1f = (dispatch) => bindActionCreators(
  {
    fetchSessions: fetchSessionsAction,
    fetchObeeSettings: fetchSettingsAction
  },
  dispatch
);
const TableTable$1 = connect(mapStateToProps$1g, mapDispatchToProps$1f)(TableTable);
const EditFloorplanList = ({
  tables,
  areas,
  updateLocalTable,
  bulkUpdateLocalTables,
  floorplanData,
  fetchObeeSettings: fetchObeeSettings2,
  fetchSessions
}) => {
  const classes = useStyles$M();
  const [tab, setTab] = useState("tables");
  useEffect(() => {
    fetchObeeSettings2();
    fetchSessions();
  }, []);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageContent }, /* @__PURE__ */ React__default.createElement(Spacer, null, /* @__PURE__ */ React__default.createElement(SquareButton, { onClick: () => setTab("tables"), forceHoverState: tab === "tables" }, "All tables"), /* @__PURE__ */ React__default.createElement(SquareButton, { onClick: () => setTab("priority"), forceHoverState: tab === "priority" }, "Priority")), /* @__PURE__ */ React__default.createElement(
    TableTable$1,
    {
      tables: tables.data,
      areas: areas.data,
      updateTable: updateLocalTable,
      updateTables: bulkUpdateLocalTables,
      floorplanData,
      priorityView: tab === "priority",
      setPriorityView: (value) => {
        if (value) {
          setTab("priority");
        } else {
          setTab("tables");
        }
      }
    }
  )));
};
EditFloorplanList.propTypes = {
  tables: tablesPropTypes.isRequired,
  areas: areasPropTypes.isRequired,
  updateLocalTable: PropTypes.func.isRequired,
  bulkUpdateLocalTables: PropTypes.func.isRequired,
  floorplanData: floorplanPropTypes.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  fetchObeeSettings: PropTypes.func.isRequired
};
const mapStateToProps$1f = (state) => ({
  tables: state.tables,
  areas: state.areas
});
const mapDispatchToProps$1e = (dispatch) => bindActionCreators(
  {
    updateLocalTable: updateLocalTableAction,
    bulkUpdateLocalTables: bulkUpdateLocalTablesAction,
    fetchSessions: fetchSessionsAction,
    fetchObeeSettings: fetchSettingsAction
  },
  dispatch
);
const EditFloorplanList$1 = connect(mapStateToProps$1f, mapDispatchToProps$1e)(EditFloorplanList);
const SvgPlusRound = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 9 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("line", { x1: 4.59082, y1: 0.5, x2: 4.59082, y2: 8.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 8.5, y1: 4.59082, x2: 0.5, y2: 4.59082, stroke: "currentColor", strokeLinecap: "round" }));
const PlusRoundSVG = SvgPlusRound;
const SvgRotate = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M11.5 3C8.66667 3 3 4.7 3 11.5", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10 1L12 3L10 5", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5 10L3 12L1 10", stroke: "currentColor" }));
const RotateSVG = SvgRotate;
PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  areaId: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  rotation: PropTypes.number,
  points: PropTypes.arrayOf(PropTypes.shape({ x: PropTypes.number, y: PropTypes.number })),
  text: PropTypes.string
  // Only used for textbox
});
const getDefaultValuesForType = (type2) => {
  switch (type2) {
    case "rectangle":
      return { width: 75, height: 59 };
    case "circle":
      return { width: 79, height: 79 };
    case "island":
      return { width: 97, height: 57 };
    case "polygon":
      return { width: 74, height: 76 };
    case "door":
      return { width: 67, height: 38 };
    case "stairs_single":
      return { width: 87, height: 34 };
    case "stairs_landing":
      return { width: 91, height: 65 };
    case "kitchen":
      return { width: 38, height: 39 };
    case "register":
      return { width: 57, height: 54 };
    case "toilet":
      return { width: 38, height: 39 };
    case "text":
      return { width: 160, height: 40 };
    default:
      return { width: 50, height: 50 };
  }
};
const CanvasTextField = ({
  label,
  value,
  onChange,
  autofocus,
  onFocus: onFocus2,
  onBlur: onBlur2,
  style,
  ...others
}) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    TextField$2,
    {
      label,
      value,
      type: "text",
      onChange,
      placeholder: "Empty",
      autofocus,
      onFocus: onFocus2,
      onBlur: onBlur2,
      ...others,
      style: {
        ...style,
        container: {
          display: "flex",
          gap: "10px",
          alignItems: "center",
          flexGrow: "1",
          ...style == null ? void 0 : style.container
        },
        innerContainer: {
          width: "100%"
        },
        label: {
          color: theme2.colors.smoke,
          marginBottom: "0",
          width: "120px",
          ...style == null ? void 0 : style.label
        },
        textFieldInner: {
          ...style == null ? void 0 : style.textFieldInner
        },
        input: {
          // backgroundColor: '#EDEDED',
          border: "1px solid transparent",
          width: "100%",
          color: theme2.colors.charcoal,
          padding: "9px 14px",
          // borderRadius: '6px',
          borderRadius: "0",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "20px",
          backgroundColor: "transparent",
          fontSize: "18px",
          minWidth: "50px",
          ...style == null ? void 0 : style.input
        },
        inputActive: {
          outline: `1px solid ${theme2.colors.smoke}`,
          ...style == null ? void 0 : style.inputActive
        },
        inputHover: {
          ...style == null ? void 0 : style.inputHover
        },
        placeholder: {
          color: theme2.colors.nimbus,
          ...style == null ? void 0 : style.placeholder
        }
      }
    }
  );
};
CanvasTextField.defaultProps = {
  label: "",
  value: "",
  onChange: () => {
  },
  onFocus: () => {
  },
  onBlur: () => {
  },
  autofocus: false,
  style: {}
};
CanvasTextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  autofocus: PropTypes.bool,
  style: PropTypes.shape({
    container: PropTypes.shape({}),
    label: PropTypes.shape({}),
    textFieldInner: PropTypes.shape({}),
    input: PropTypes.shape({}),
    inputActive: PropTypes.shape({}),
    inputHover: PropTypes.shape({}),
    placeholder: PropTypes.shape({})
  })
};
const mapStateToProps$1e = () => ({});
const mapDispatchToProps$1d = (dispatch) => bindActionCreators({}, dispatch);
const CanvasTextField$1 = connect(mapStateToProps$1e, mapDispatchToProps$1d)(CanvasTextField);
const useStyles$F = createUseStyles((theme2) => ({
  container: {
    // height: '100px',
    // width: '400px',
    // marginTop: '-40px
  },
  innerContainer: {},
  toolbar: {
    fontSize: "8px",
    display: "inline-flex",
    gap: "4px"
    // padding: '4px',
  },
  buttonGroup: {
    display: "inline-flex",
    gap: "4px",
    padding: "4px"
  },
  buttonIcon: {
    width: "32px",
    height: "32px"
  },
  overflowItem: {
    display: "flex",
    gap: "12px",
    alignItems: "center"
  }
}));
const popoverStyles = (theme2) => ({
  button: {
    container: { width: "auto" },
    button: {
      width: "100%",
      padding: "12px",
      borderRadius: "6px"
    },
    // buttonHover: { backgroundColor: theme.colors.notificationBackgroundGray },
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "-10px",
    marginRight: "-10px"
  },
  popoverInner: {
    marginBottom: "20px",
    marginTop: "0",
    borderRadius: "6px",
    padding: "0",
    pointerEvents: "auto",
    border: `1px solid ${theme2.colors.shark}`
  }
});
const overflowStyles = () => ({
  popover: {
    marginTop: 0,
    marginLeft: "10px"
  },
  popoverInner: {
    right: "0"
  },
  listItem: {
    paddingLeft: "10px",
    paddingRight: "10px"
  }
});
const SvgAlignLeft = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { width: 28, height: 28, rx: 4, fill: "transparent" }), /* @__PURE__ */ React$7.createElement("line", { x1: 4.5, y1: 4.5, x2: 4.5, y2: 23.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("rect", { x: 7.99902, y: 7, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }), /* @__PURE__ */ React$7.createElement("rect", { x: 15.999, y: 7, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }));
const AlignLeftSVG = SvgAlignLeft;
const SvgAlignRight = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 28, y: 28, width: 28, height: 28, rx: 4, transform: "rotate(-180 28 28)", fill: "transparent" }), /* @__PURE__ */ React$7.createElement("line", { x1: 23.5, y1: 23.5, x2: 23.5, y2: 4.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("rect", { x: 19.999, y: 21, width: 6, height: 13, rx: 2, transform: "rotate(-180 19.999 21)", fill: "#DCDCDB" }), /* @__PURE__ */ React$7.createElement("rect", { x: 11.999, y: 21, width: 6, height: 13, rx: 2, transform: "rotate(-180 11.999 21)", fill: "#DCDCDB" }));
const AlignRightSVG = SvgAlignRight;
const SvgAlignTop = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { width: 28, height: 28, rx: 4, fill: "transparent" }), /* @__PURE__ */ React$7.createElement("line", { x1: 23.5, y1: 5.5, x2: 4.5, y2: 5.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("rect", { x: 7, y: 8, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }), /* @__PURE__ */ React$7.createElement("rect", { x: 15, y: 8, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }));
const AlignTopSVG = SvgAlignTop;
const SvgAlignBottom = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("line", { x1: 23.5, y1: 22.5, x2: 4.5, y2: 22.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("rect", { x: 7, y: 7, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }), /* @__PURE__ */ React$7.createElement("rect", { x: 15, y: 7, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }));
const AlignBottomSVG = SvgAlignBottom;
const SvgAlignHorizontalCenter = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { width: 28, height: 28, rx: 4, fill: "transparent" }), /* @__PURE__ */ React$7.createElement("rect", { x: 19.999, y: 8, width: 6, height: 13, rx: 2, transform: "rotate(90 19.999 8)", fill: "#DCDCDB" }), /* @__PURE__ */ React$7.createElement("rect", { x: 19.999, y: 16, width: 6, height: 13, rx: 2, transform: "rotate(90 19.999 16)", fill: "#DCDCDB" }), /* @__PURE__ */ React$7.createElement("line", { x1: 13.5, y1: 23.5, x2: 13.5, y2: 4.5, stroke: "currentColor", strokeLinecap: "round" }));
const AlignHorizontalCenter = SvgAlignHorizontalCenter;
const SvgAlignVerticalCenter = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { width: 28, height: 28, rx: 4, fill: "transparent" }), /* @__PURE__ */ React$7.createElement("line", { x1: 23.5, y1: 13.5, x2: 4.5, y2: 13.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("rect", { x: 7, y: 7, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }), /* @__PURE__ */ React$7.createElement("rect", { x: 15, y: 7, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }));
const AlignVerticalCenter = SvgAlignVerticalCenter;
const SvgAlignDistributeHorizontal = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 29 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("line", { x1: 8.5, y1: 6.5, x2: 8.5, y2: 20.5, stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 19.5, y1: 6.5, x2: 19.5, y2: 20.5, stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("rect", { x: 10.999, y: 7, width: 6, height: 13, rx: 2, fill: "#DCDCDB" }));
const DistributeHorizontalSVG = SvgAlignDistributeHorizontal;
const SvgAlignDistributeVertical = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 29 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: -976562e-9, width: 29, height: 29, rx: 4, fill: "transparent" }), /* @__PURE__ */ React$7.createElement("rect", { x: 20.999, y: 11, width: 6, height: 13, rx: 2, transform: "rotate(90 20.999 11)", fill: "#DCDCDB" }), /* @__PURE__ */ React$7.createElement("line", { x1: 21.499, y1: 8.5, x2: 7.49902, y2: 8.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 21.499, y1: 19.5, x2: 7.49902, y2: 19.5, stroke: "currentColor", strokeLinecap: "round" }));
const DistributeVerticalSVG = SvgAlignDistributeVertical;
const SmallButton = ({ onClick, children, style, ...props }) => {
  useStyles$F();
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    Button,
    {
      ...props,
      type: "custom",
      style: {
        button: {
          padding: "2px",
          width: "36px",
          height: "36px",
          borderRadius: "6px",
          color: theme2.colors.charcoal
        },
        buttonHover: {
          backgroundColor: theme2.colors.cloud,
          color: theme2.colors.jet
        }
      },
      onClick
    },
    children
  );
};
SmallButton.defaultProps = {
  onClick: () => {
  },
  children: null,
  style: {}
};
SmallButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  style: PropTypes.shape({})
};
const mapStateToProps$1d = () => ({});
const mapDispatchToProps$1c = (dispatch) => bindActionCreators({}, dispatch);
const SmallButton$1 = connect(mapStateToProps$1d, mapDispatchToProps$1c)(SmallButton);
const JoinButton = ({
  onClick,
  tables,
  selectedTableIds,
  deleteLocalTables,
  showEnableJoinModal,
  showDisableJoinModal,
  ...props
}) => {
  const classes = useStyles$F();
  const selectedTableData = tables.data.filter((table) => selectedTableIds.includes(table == null ? void 0 : table.id));
  const selectedTableNumbers = flatten(selectedTableData, "tableNumber");
  const tableJoin = useMemo(() => {
    var _a;
    return (_a = tables.data.filter((table) => table == null ? void 0 : table.isJoin).filter((table) => {
      const joinedTables = table.tableNumber.split(",");
      return arraysMatch(joinedTables, selectedTableNumbers);
    })) == null ? void 0 : _a[0];
  }, [selectedTableIds, tables.data]);
  const handleJoin = (e) => {
    showEnableJoinModal(e.currentTarget);
  };
  return /* @__PURE__ */ React__default.createElement(Box, null, tableJoin ? /* @__PURE__ */ React__default.createElement(SmallButton$1, { ...props, onClick: () => showDisableJoinModal(true) }, /* @__PURE__ */ React__default.createElement(JoinSVG, { className: classes.buttonIcon, style: { color: "red", width: "20px" } })) : /* @__PURE__ */ React__default.createElement(SmallButton$1, { ...props, onClick: handleJoin }, /* @__PURE__ */ React__default.createElement(JoinSVG, { className: classes.buttonIcon, style: { width: "20px" } })));
};
JoinButton.defaultProps = {
  onClick: () => {
  },
  selectedTableIds: []
};
JoinButton.propTypes = {
  onClick: PropTypes.func,
  tables: tablesPropTypes.isRequired,
  selectedTableIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  deleteLocalTables: PropTypes.func.isRequired
};
const mapStateToProps$1c = (state) => ({
  tables: state.tables
});
const mapDispatchToProps$1b = (dispatch) => bindActionCreators(
  {
    deleteLocalTables: deleteLocalTablesAction
  },
  dispatch
);
const JoinButton$1 = connect(mapStateToProps$1c, mapDispatchToProps$1b)(JoinButton);
const AlignmentToolbar = ({
  selectedTableIds,
  anchor,
  onClose,
  tables,
  floorplanTables,
  updateTables: updateTables2,
  deleteTables: deleteTables2,
  showEnableJoinModal,
  showDisableJoinModal
}) => {
  const classes = useStyles$F();
  const theme2 = useTheme$1();
  const [overflowAnchor, setOverflowAnchor] = useState(null);
  const joinButtonRef = useRef(null);
  const containerRef = useRef(null);
  const selectedTables = useMemo(() => {
    return tables.data.filter((table) => selectedTableIds.includes(table == null ? void 0 : table.id));
  }, [selectedTableIds, tables]);
  const selectedFloorplanTables = floorplanTables.filter(
    (table) => selectedTableIds.includes(table == null ? void 0 : table.id)
  );
  const alignTop = () => {
    var _a;
    const tablesWithBounds = selectedFloorplanTables.map((table) => {
      const tableData = getTableDataFromId(table.id, tables.data);
      const bounds = getBoundsOfTable(table, tableData == null ? void 0 : tableData.maxSeats, { originX: 0, originY: 0 });
      return { table, bounds };
    });
    const topPoint = (_a = tablesWithBounds.map((table) => table.bounds.actualTop).sort((a, b) => a - b)) == null ? void 0 : _a[0];
    const newTables = tablesWithBounds.map((table) => ({
      ...table.table,
      y: topPoint + table.bounds.yDistanceFromTop
    }));
    updateTables2(newTables);
  };
  const getTablesWithBounds = () => {
    return selectedFloorplanTables.map((table) => {
      const tableData = getTableDataFromId(table.id, tables.data);
      const bounds = getBoundsOfTable(table, tableData == null ? void 0 : tableData.maxSeats, { originX: 0, originY: 0 });
      return { table, bounds };
    });
  };
  const alignVerticalCenter = () => {
    var _a, _b2;
    const tablesWithBounds = getTablesWithBounds();
    const topPoint = (_a = tablesWithBounds.map((table) => table.bounds.actualTop).sort((a, b) => a - b)) == null ? void 0 : _a[0];
    const bottomPoint = (_b2 = tablesWithBounds.map((table) => table.bounds.actualBottom).sort((a, b) => b - a)) == null ? void 0 : _b2[0];
    const midpoint = (topPoint + bottomPoint) / 2;
    const newTables = tablesWithBounds.map((table) => ({
      ...table.table,
      y: midpoint - table.bounds.height / 2 + table.bounds.yDistanceFromTop
    }));
    updateTables2(newTables);
  };
  const alignBottom = () => {
    var _a;
    const tablesWithBounds = getTablesWithBounds();
    const bottomPoint = (_a = tablesWithBounds.map((table) => table.bounds.actualBottom).sort((a, b) => b - a)) == null ? void 0 : _a[0];
    const newTables = tablesWithBounds.map((table) => ({
      ...table.table,
      y: bottomPoint - (table.bounds.height - table.bounds.yDistanceFromTop)
      // y anchor is the center
    }));
    updateTables2(newTables);
  };
  const alignLeft = () => {
    var _a;
    const tablesWithBounds = getTablesWithBounds();
    const leftPoint = (_a = tablesWithBounds.map((table) => table.bounds.actualLeft).sort((a, b) => a - b)) == null ? void 0 : _a[0];
    const newTables = tablesWithBounds.map((table) => ({
      ...table.table,
      x: leftPoint + table.bounds.xDistanceFromLeft
    }));
    updateTables2(newTables);
  };
  const alignHorizontalCenter = () => {
    var _a, _b2;
    const tablesWithBounds = getTablesWithBounds();
    const leftPoint = (_a = tablesWithBounds.map((table) => table.bounds.actualLeft).sort((a, b) => a - b)) == null ? void 0 : _a[0];
    const rightPoint = (_b2 = tablesWithBounds.map((table) => table.bounds.actualRight).sort((a, b) => b - a)) == null ? void 0 : _b2[0];
    const midpoint = (leftPoint + rightPoint) / 2;
    const newTables = tablesWithBounds.map((table) => ({
      ...table.table,
      x: midpoint - table.bounds.width / 2 + table.bounds.xDistanceFromLeft
    }));
    updateTables2(newTables);
  };
  const alignRight = () => {
    var _a;
    const tablesWithBounds = getTablesWithBounds();
    const rightPoint = (_a = tablesWithBounds.map((table) => table.bounds.actualRight).sort((a, b) => b - a)) == null ? void 0 : _a[0];
    const newTables = tablesWithBounds.map((table) => ({
      ...table.table,
      x: rightPoint - (table.bounds.width - table.bounds.xDistanceFromLeft)
      // y anchor is the center
    }));
    updateTables2(newTables);
  };
  const distributeHorizontal = () => {
    const tablesWithBounds = getTablesWithBounds().sort(
      (a, b) => a.bounds.actualLeft - b.bounds.actualLeft
    );
    const leftPoint = Math.min(...tablesWithBounds.map((table) => table.bounds.actualLeft));
    const rightPoint = Math.max(...tablesWithBounds.map((table) => table.bounds.actualRight));
    const minGapSize = 5;
    const totalTableWidth = tablesWithBounds.reduce(
      (accum, table) => accum + table.bounds.width,
      0
    );
    const totalGapSize = rightPoint - leftPoint - totalTableWidth;
    const gapSize = Math.max(minGapSize, safeDivision(totalGapSize, tablesWithBounds.length - 1));
    let currentPos = leftPoint;
    const newTables = tablesWithBounds.map((table) => {
      const newPos = currentPos;
      currentPos += table.bounds.width + gapSize;
      return {
        ...table.table,
        x: newPos + table.bounds.xDistanceFromLeft
      };
    });
    updateTables2(newTables);
  };
  const distributeVertical = () => {
    const tablesWithBounds = getTablesWithBounds().sort(
      (a, b) => a.bounds.actualTop - b.bounds.actualTop
    );
    const topPoint = Math.min(...tablesWithBounds.map((table) => table.bounds.actualTop));
    const bottomPoint = Math.max(...tablesWithBounds.map((table) => table.bounds.actualBottom));
    const minGapSize = 5;
    const totalTableHeight = tablesWithBounds.reduce(
      (accum, table) => accum + table.bounds.height,
      0
    );
    const totalGapSize = bottomPoint - topPoint - totalTableHeight;
    const gapSize = Math.max(minGapSize, safeDivision(totalGapSize, tablesWithBounds.length - 1));
    let currentPos = topPoint;
    const newTables = tablesWithBounds.map((table) => {
      const newPos = currentPos;
      currentPos += table.bounds.height + gapSize;
      return {
        ...table.table,
        y: newPos + table.bounds.yDistanceFromTop
      };
    });
    updateTables2(newTables);
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      style: {
        // backgroundColor: 'white',
        pointerEvents: "none",
        marginTop: "-40px"
      },
      isOpen: !!anchor && selectedTables.length > 0,
      onClose,
      anchorEl: anchor,
      innerStyle: popoverStyles(theme2).popoverInner,
      anchorOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      disableEnforceFocus: true
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.container, ref: containerRef }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.toolbar }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonGroup }, /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: alignLeft }, /* @__PURE__ */ React__default.createElement(AlignLeftSVG, { className: classes.buttonIcon })), /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: alignHorizontalCenter }, /* @__PURE__ */ React__default.createElement(AlignHorizontalCenter, { className: classes.buttonIcon })), /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: alignRight }, /* @__PURE__ */ React__default.createElement(AlignRightSVG, { className: classes.buttonIcon }))), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.shark, direction: "vertical" }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonGroup }, /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: alignTop }, /* @__PURE__ */ React__default.createElement(AlignTopSVG, { className: classes.buttonIcon })), /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: alignVerticalCenter }, /* @__PURE__ */ React__default.createElement(AlignVerticalCenter, { className: classes.buttonIcon })), /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: alignBottom }, /* @__PURE__ */ React__default.createElement(AlignBottomSVG, { className: classes.buttonIcon, width: 32, height: 32 }))), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.shark, direction: "vertical" }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonGroup }, /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: distributeHorizontal }, /* @__PURE__ */ React__default.createElement(DistributeHorizontalSVG, { className: classes.buttonIcon })), /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: distributeVertical }, /* @__PURE__ */ React__default.createElement(DistributeVerticalSVG, { className: classes.buttonIcon }))), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.shark, direction: "vertical" }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonGroup, ref: joinButtonRef }, /* @__PURE__ */ React__default.createElement(
      JoinButton$1,
      {
        selectedTableIds,
        showEnableJoinModal,
        showDisableJoinModal
      }
    ), /* @__PURE__ */ React__default.createElement(SmallButton$1, { onClick: () => setOverflowAnchor(joinButtonRef.current) }, /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG, { className: classes.buttonIcon, style: { width: "20px" } }))))),
    /* @__PURE__ */ React__default.createElement(
      ListPopover,
      {
        items: [
          {
            key: "delete",
            label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.overflowItem }, /* @__PURE__ */ React__default.createElement(BinSVG, { style: { height: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Delete")),
            onClick: deleteTables2
          }
        ],
        anchor: overflowAnchor,
        isOpen: !isEmpty(overflowAnchor),
        onClose: () => setOverflowAnchor(null),
        style: overflowStyles(),
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }
    )
  );
};
AlignmentToolbar.defaultProps = {
  anchor: null,
  onClose: (e) => e,
  floorplanTables: [],
  updateTables: (e) => e,
  deleteTables: (e) => e,
  showEnableJoinModal: (e) => e,
  showDisableJoinModal: (e) => e
};
AlignmentToolbar.propTypes = {
  onClose: PropTypes.func,
  anchor: PropTypes.shape({}),
  tables: tablesPropTypes.isRequired,
  floorplanTables: PropTypes.arrayOf(PropTypes.shape({})),
  selectedTableIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
  updateTables: PropTypes.func,
  deleteTables: PropTypes.func,
  showEnableJoinModal: PropTypes.func,
  showDisableJoinModal: PropTypes.func
};
const mapStateToProps$1b = (state) => ({
  tables: state.tables
});
const mapDispatchToProps$1a = (dispatch) => bindActionCreators({}, dispatch);
const AlignmentToolbar$1 = connect(mapStateToProps$1b, mapDispatchToProps$1a)(AlignmentToolbar);
const UnjoinTablesModal = ({ onClose, isOpen, tableIds, tables, deleteLocalTables }) => {
  const tableData = tables.data.filter((table) => tableIds.includes(table == null ? void 0 : table.id));
  const tableNumbers = flatten(tableData, "tableNumber");
  const handleUnjoinTables = () => {
    tables.data.forEach((table) => {
      const joinedTables = table.tableNumber.split(",");
      if (arraysMatch(joinedTables, tableNumbers)) {
        deleteLocalTables([table == null ? void 0 : table.id]);
      }
    });
  };
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      onClose,
      isOpen,
      onConfirm: handleUnjoinTables,
      heading: "Unjoin tables",
      confirmLabel: "Remove join",
      prompt: `This will unjoin tables ${joinList(
        [...tableNumbers].sort(sortAlphaNumeric),
        ", ",
        " and "
      )} from your floor plan. If there are any bookings on the joined table, they will no longer appear.
      Please confirm you want to proceed.`
    }
  );
};
UnjoinTablesModal.defaultProps = {
  tableIds: [],
  onClose: () => {
  }
};
UnjoinTablesModal.propTypes = {
  onClose: PropTypes.func,
  deleteLocalTables: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  tableIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  tables: tablesPropTypes.isRequired
};
const mapStateToProps$1a = (state) => ({
  floorplan: state.floorplan,
  tables: state.tables
});
const mapDispatchToProps$19 = (dispatch) => bindActionCreators({ deleteLocalTables: deleteLocalTablesAction }, dispatch);
const UnjoinTablesModal$1 = connect(mapStateToProps$1a, mapDispatchToProps$19)(UnjoinTablesModal);
const sidebarWidth = 295;
const useStyles$E = createUseStyles((theme2) => ({
  container: {
    backgroundColor: "white",
    minHeight: "100svh",
    touchAction: "manipulation"
    // minHeight: '100vh',
  },
  headerContainer: {},
  pageContent: (props) => ({
    // position: 'relative',
    display: "flex",
    marginLeft: (props == null ? void 0 : props.sidebarOpen) ? `${sidebarWidth}px` : 0,
    transition: (props == null ? void 0 : props.sidebarOpen) ? "margin-left 0.25s " : "margin-left: 0.3s",
    width: (props == null ? void 0 : props.sidebarOpen) ? `calc(100% - ${sidebarWidth}px)` : "100%",
    maxHeight: "calc(100dvh - 134px)",
    overflow: "auto",
    touchAction: "manipulation pinch-zoom pan-x pan-y",
    backgroundColor: theme2.colors.linen,
    paddingBottom: "100px",
    paddingRight: "100px",
    [theme2.breakpoints.down("sm")]: {
      marginLeft: "20px"
    }
  }),
  sidebar: (props) => ({
    backgroundColor: theme2.colors.tableMenuBackground,
    // backgroundColor: 'red',
    width: "295px",
    // height: '2000px',
    // height: '100%',
    height: "calc(100dvh - 134px)",
    position: "absolute",
    zIndex: 100,
    // So it's drawn over the canvas
    left: (props == null ? void 0 : props.sidebarOpen) ? 0 : `-${sidebarWidth}px`,
    transition: (props == null ? void 0 : props.sidebarOpen) ? "left 0.25s" : "left: 0.3s",
    [theme2.breakpoints.down("sm")]: {
      marginLeft: "20px"
    }
  }),
  canvasContainer: {
    position: "relative",
    margin: "0 16px",
    width: "fit-content",
    height: "100%",
    borderRadius: "32px",
    // overflow: 'scroll',
    // width: '100%',
    // height: '100%',
    border: "4px solid #D9D9D9",
    // TODO get from theme
    backgroundColor: theme2.colors.canvasBackground
    // marginBottom: '200px',
  },
  canvas: {
    minWidth: "100px",
    minHeight: "100px",
    padding: "10px"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 20px",
    alignItems: "center",
    backgroundColor: theme2.colors.tableMenuBackground,
    // borderBottom: `1px solid ${theme.colors.shark}`,
    height: "65px"
  },
  title: {
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  headerButtons: {
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  plate: {
    color: theme2.colors.charcoal
  },
  logoContainer: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  headerText: {
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium
  },
  dropdownContent: {
    display: "flex",
    gap: "14px",
    alignItems: "center"
  },
  areaLabel: {
    position: "absolute",
    padding: "7px 10px",
    backgroundColor: "white",
    border: `1px solid ${theme2.colors.shark}`,
    borderRadius: "6px",
    fontSize: "12px",
    lineHeight: "12px",
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    alignItems: "center",
    userSelect: "none",
    fontWeight: theme2.fontWeights.medium,
    zIndex: 100
  },
  areaLabelText: {
    color: "black"
  },
  actionButton: {
    margin: "-7px -10px",
    padding: "7px 10px",
    cursor: "pointer"
  },
  actionIcon: {
    width: "19px",
    height: "8px",
    color: theme2.colors.charcoal
  },
  dragButton: {
    cursor: "pointer",
    position: "absolute",
    top: 0,
    left: 0,
    padding: "6px",
    backgroundColor: "white",
    borderRadius: "6px",
    boxShadow: "0px 4px 14px rgba(111, 111, 111, 0.25)",
    alignItems: "center",
    width: `40px`,
    height: `40px`
  },
  dragIcon: {
    width: "28px",
    height: "28px"
  },
  resizeIconContainer: {
    cursor: "pointer",
    position: "absolute",
    top: 0,
    left: 0
  },
  tableResizeIconContainer: {
    cursor: "pointer",
    position: "absolute",
    top: -6,
    left: -6
    // backgroundColor: 'red',
  },
  textElementInputContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    alignItems: "center",
    height: "40px",
    display: "flex",
    flexDirection: "column",
    flexGrow: "1"
  },
  resizeIcon: {
    width: `20px`,
    height: `20px`,
    borderRadius: "10px"
    // backgroundColor: theme.colors.OLIVE_3,
  },
  tableResizeIcon: {
    width: `20px`,
    height: `20px`,
    padding: "10px"
  },
  tableLabelContainer: {
    position: "absolute",
    // backgroundColor: 'orange',
    // backgroundColor: 'green',
    color: "black",
    padding: "10px",
    fontSize: "12px",
    lineHeight: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "8px",
    minHeight: "60px",
    alignItems: "center",
    // userSelect: 'none', // This was what was preventing the scrolling...
    fontWeight: theme2.fontWeights.medium,
    textAlign: "center",
    // background: 'rgba(1,0,0,0.2)',
    "&:hover": {
      // zIndex: 10,
    }
  },
  tableLabel: {
    touchAction: "none",
    userSelect: "none"
  },
  tableActionButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "25px",
    height: "25px",
    width: "47px",
    userSelect: "none",
    zIndex: 99,
    background: theme2.colors.white,
    borderRadius: "6px",
    border: "1px solid #E4E4E4",
    // TODO get from theme
    boxShadow: "0px 4px 4px rgba(176, 176, 176, 0.25)",
    "&:hover": {
      cursor: "pointer"
    }
  },
  rotateIconContainer: {
    cursor: "pointer ",
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: "white",
    borderRadius: "4px",
    boxSizing: "border-box",
    boxShadow: "0px 4px 8px rgba(151, 151, 151, 0.25)",
    width: "24px",
    height: "24px",
    border: `1px solid ${theme2.colors.cloud}`
  },
  tabLabel: {
    display: "inline-flex",
    gap: "10px",
    alignItems: "center"
  }
}));
const useStyles$D = createUseStyles((theme2) => ({
  container: {
    // padding: '40px',
    margin: "15px",
    color: theme2.colors.floorplanElementColour,
    display: "flex",
    gap: "5px",
    // maxWidth: '255px',
    justifyContent: "space-between",
    flexWrap: "wrap",
    flexBasis: "30%"
  },
  table: {
    width: "130px",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "8px",
    padding: "14px",
    border: "1px solid transparent",
    cursor: "pointer",
    userSelect: "none"
  },
  element: {
    width: "120px",
    // height: '100px',
    alignItems: "center",
    textAlign: "center",
    borderRadius: "8px",
    padding: "14px",
    border: "1px solid transparent",
    cursor: "pointer",
    userSelect: "none"
  },
  tableHover: {
    border: "1px solid black",
    backgroundColor: "white"
  },
  image: {
    // width: '100px',
    // maxHeight: '100px',
    display: "block"
  },
  label: {
    ...theme2.typography.heading.H5,
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.charcoal,
    textAlign: "center",
    marginTop: "16px"
  },
  categoryWrapper: {
    overflow: "auto",
    height: "100%",
    paddingBottom: "100px"
  },
  categoryContainer: {
    // padding: '40px',
    margin: "10px",
    marginTop: "30px"
  },
  categoryTitle: {
    ...theme2.typography.heading.H4,
    color: theme2.colors.charcoal,
    paddingLeft: "20px",
    marginBottom: "10px"
  },
  categoryItems: {
    color: theme2.colors.black,
    display: "flex",
    gap: "5px",
    // maxWidth: '255px',
    justifyContent: "space-between",
    flexWrap: "wrap",
    flexBasis: "30%"
  },
  imageContainerOuter: {
    height: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  imageContainer: {
    height: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "20px"
  }
}));
const SvgCircle = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 79 79", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 39.5, cy: 39.5, r: 39, stroke: "currentColor" }));
const ElementCircleSVG = SvgCircle;
const SvgDoor = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 67 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M17.2027 37C40.0189 37 50.25 13 52.5135 1H67M17.2027 37V1H15.5M17.2027 37H15.5V1M0 1H15.5", stroke: "black" }));
const ElementDoorSVG = SvgDoor;
const SvgIsland = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 97 57", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M2.5 0.5H69.5C84.4117 0.5 96.5 12.5883 96.5 27.5C96.5 42.4117 84.4117 54.5 69.5 54.5H2.5V0.5Z", stroke: "currentColor" }));
const ElementIslandSVG = SvgIsland;
const SvgKitchen = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 38 39", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 2.22852, y: 2.22852, width: 33.4286, height: 34.5813, rx: 4, fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("rect", { x: 1, y: 1, width: 35.8857, height: 37, rx: 3, stroke: "#6E6E6D", strokeWidth: 2 }), /* @__PURE__ */ React$7.createElement("path", { d: "M26.0495 26.7994V16.9802C27.4649 16.3484 29.9594 14.3514 28.6143 11.4181C27.2692 8.48475 24.0642 9.36723 22.6298 10.1751C22.2783 9.45009 21.1023 8 19.2101 8C16.8448 8 15.9729 10.1751 15.9729 10.1751C15.9729 10.1751 11.8293 7.4718 10.3188 11.4181C9.14132 14.4943 11.5062 16.4416 12.8551 16.9802V26.7994M26.0495 26.7994V26.7994C26.0495 28.5671 24.6166 30 22.849 30H16.0557C14.288 30 12.8551 28.5671 12.8551 26.7994V26.7994M26.0495 26.7994H12.8551", stroke: "#0E3AB9" }));
const ElementKitchenSVG = SvgKitchen;
const SvgLineSmall = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 88 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M2 3H86", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 0.5, width: 4, height: 4, fill: "white", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 83.5, y: 0.5, width: 4, height: 4, fill: "white", stroke: "currentColor" }));
const ElementLineSVG = SvgLineSmall;
const SvgRectangle = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 75 59", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 2.5, y: 2.5, width: 70, height: 54, stroke: "currentColor" }));
const ElementRectangleSVG = SvgRectangle;
const SvgRegister = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 57 54", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M5.1201 52.0968L7.38891 46.9468L13.1599 32.0918L52.0609 32.0918H53.9082C55.0128 32.0918 55.9082 32.9872 55.9082 34.0918L55.9082 52.5C55.9082 53.0523 55.4688 53.5 54.9165 53.5L12.5 53.5H6.03524C5.31298 53.5 4.82892 52.7578 5.1201 52.0968Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 1, y: 15.8857, width: 42.0308, height: 30.0613, rx: 2, fill: "white", stroke: "#6E6E6D", strokeWidth: 2 }), /* @__PURE__ */ React$7.createElement("rect", { x: 4.1582, y: 18.75, width: 35.5, height: 24.5, rx: 2.75, fill: "#F5F2ED", stroke: "#313131", strokeWidth: 0.5 }), /* @__PURE__ */ React$7.createElement("line", { x1: 49.5156, y1: 31.9849, x2: 49.5156, y2: 6.5496, stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 44.5, y: 0.5, width: 10, height: 4, rx: 0.5, fill: "#313131", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 48.5, y: 5.12622, width: 2, height: 1, rx: 0.5, stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M22 27.1818C22.477 27.1818 22.9343 27.3542 23.2716 27.661C23.6087 27.968 23.7982 28.3841 23.7982 28.8182C23.7982 29.0131 23.9124 29.1932 24.0979 29.2906C24.2833 29.388 24.5118 29.388 24.6973 29.2906C24.8827 29.1932 24.997 29.0131 24.997 28.8182C24.9971 28.1894 24.7586 27.5799 24.3216 27.0929C23.8847 26.6059 23.2764 26.2712 22.5994 26.1454V25.5454C22.5994 25.3505 22.4851 25.1705 22.2997 25.0731C22.1143 24.9756 21.8857 24.9756 21.7003 25.0731C21.5149 25.1705 21.4006 25.3505 21.4006 25.5454V26.1454C20.4207 26.3265 19.6045 26.9404 19.2247 27.7821C18.8449 28.6237 18.9512 29.5823 19.5084 30.3379C20.0656 31.0935 21.0002 31.5464 22 31.5455C22.477 31.5455 22.9343 31.7179 23.2716 32.0247C23.6087 32.3316 23.7982 32.7478 23.7982 33.1818C23.7982 33.6159 23.6087 34.032 23.2716 34.339C22.9343 34.6458 22.477 34.8182 22 34.8182C21.523 34.8182 21.0657 34.6458 20.7284 34.339C20.3913 34.032 20.2018 33.6159 20.2018 33.1818C20.2018 32.9869 20.0876 32.8068 19.9021 32.7094C19.7167 32.612 19.4882 32.612 19.3027 32.7094C19.1173 32.8068 19.003 32.9869 19.003 33.1818C19.0029 33.8106 19.2414 34.4201 19.6784 34.9071C20.1153 35.3941 20.7236 35.7288 21.4006 35.8546V36.4546C21.4006 36.6495 21.5149 36.8295 21.7003 36.9269C21.8857 37.0244 22.1143 37.0244 22.2997 36.9269C22.4851 36.8295 22.5994 36.6495 22.5994 36.4546V35.8546C23.5793 35.6735 24.3955 35.0596 24.7753 34.2179C25.1551 33.3763 25.0488 32.4177 24.4916 31.6621C23.9344 30.9065 22.9998 30.4536 22 30.4545C21.3575 30.4545 20.7639 30.1426 20.4428 29.6364C20.1215 29.1301 20.1215 28.5062 20.4428 28C20.7639 27.4938 21.3575 27.1818 22 27.1818Z", fill: "#0E3AB9" }));
const ElementRegisterSVG = SvgRegister;
const SvgStairsLanding = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 91 65", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 17.5078, y: 36.2192, width: 72.9907, height: 27.6415, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 31.3887, y1: 36.2339, x2: 31.3887, y2: 64.5082, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 45.7832, y1: 36.2339, x2: 45.7832, y2: 64.5082, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 60.1777, y1: 36.2339, x2: 60.1777, y2: 64.5082, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 74.5713, y1: 36.2339, x2: 74.5713, y2: 64.5082, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 88.9658, y1: 36.2339, x2: 88.9658, y2: 64.5082, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 17.5078, y: 0.5, width: 72.9907, height: 27.6415, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 31.3887, y1: 0.514404, x2: 31.3887, y2: 28.7887, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 45.7832, y1: 0.514404, x2: 45.7832, y2: 28.7887, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 60.1777, y1: 0.514404, x2: 60.1777, y2: 28.7887, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 74.5713, y1: 0.514404, x2: 74.5713, y2: 28.7887, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 88.9658, y1: 0.514404, x2: 88.9658, y2: 28.7887, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 0.5, width: 16.8598, height: 63.6355, stroke: "currentColor" }));
const ElementStairsLandingSVG = SvgStairsLanding;
const SvgStairsSingle = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 87 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 0.5, width: 86, height: 32.6774, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 16.8203, y1: 0.604736, x2: 16.8203, y2: 33.8504, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 33.7461, y1: 0.604736, x2: 33.7461, y2: 33.8504, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 50.6709, y1: 0.604736, x2: 50.6709, y2: 33.8504, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 67.5957, y1: 0.604736, x2: 67.5957, y2: 33.8504, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("line", { x1: 84.5205, y1: 0.604736, x2: 84.5205, y2: 33.8504, stroke: "currentColor" }));
const ElementStairsSingleSVG = SvgStairsSingle;
const SvgText = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 83 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 3.5, width: 80, height: 31, stroke: "#AEAEAE", strokeDasharray: "2 2" }), /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 3.5, width: 80, height: 31, stroke: "black", strokeOpacity: 0.2, strokeDasharray: "2 2" }), /* @__PURE__ */ React$7.createElement("path", { d: "M19.0625 25.6053V11", stroke: "black" }), /* @__PURE__ */ React$7.createElement("path", { d: "M25.2368 13.7928V12C25.2368 11.4477 24.7891 11 24.2368 11H14C13.4477 11 13 11.4477 13 12V13.7928", stroke: "black" }), /* @__PURE__ */ React$7.createElement("line", { x1: 16.6582, y1: 25.5, x2: 21.1845, y2: 25.5, stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 33.5, y1: 14.5, x2: 64.5, y2: 14.5, stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 33.5, y1: 18.5, x2: 51.5, y2: 18.5, stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 33.5, y1: 22.5, x2: 37.5, y2: 22.5, stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 39.5, y1: 22.5, x2: 43.5, y2: 22.5, stroke: "black", strokeLinecap: "round" }));
const ElementTextSVG = SvgText;
const SvgToilet = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 38 39", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 2.22852, y: 2.22852, width: 33.4286, height: 34.5813, rx: 4, fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("rect", { x: 1, y: 1, width: 35.8857, height: 37, rx: 3, stroke: "#6E6E6D", strokeWidth: 2 }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.41707 20.6072L9.41738 20.6044L9.8369 16.7438C9.83692 16.7437 9.83693 16.7436 9.83695 16.7434C9.95261 15.6981 10.7462 14.9856 11.6175 14.9856H12.2668H12.916C13.7834 14.9856 14.5797 15.7153 14.6964 16.7423L15.0958 20.6666L15.0957 20.6666L15.0968 20.6753C15.1263 20.9227 14.9518 21.054 14.834 21.054H14.1946H13.7181L13.6952 21.5299L13.3755 28.1619L13.3755 28.163C13.366 28.3689 13.2129 28.4713 13.1157 28.4713H11.3776C11.2802 28.4713 11.1273 28.3688 11.1179 28.1631L11.1178 28.1619L10.7981 21.5299L10.7752 21.054H10.2987H9.71938C9.59431 21.054 9.38443 20.8923 9.41707 20.6072Z", stroke: "#0E3AB9" }), /* @__PURE__ */ React$7.createElement("path", { d: "M28.4707 20.6522C28.4891 20.918 28.3185 21.0539 28.198 21.0651H27.9554H27.3126L27.4707 21.6881L28.1058 24.1899C28.2218 24.6767 27.8684 25.0513 27.558 25.0513H27.1804H26.7053L26.6811 25.5257L26.5419 28.2486L26.5419 28.249C26.5376 28.3345 26.506 28.3949 26.4743 28.4289C26.4447 28.4607 26.415 28.4713 26.3855 28.4713H24.8755C24.8609 28.4713 24.8282 28.4646 24.7906 28.4251C24.7535 28.3861 24.723 28.325 24.7191 28.2489L24.7191 28.2486L24.5799 25.5257L24.5557 25.0513H24.0806H23.703C23.3651 25.0513 23.0261 24.6712 23.1526 24.1997L23.1527 24.1997L23.1544 24.1931L23.7903 21.6881L23.9486 21.0646L23.3053 21.0651L23.0871 21.0652C23.087 21.0652 23.087 21.0652 23.0869 21.0652C22.9663 21.0651 22.7565 20.9062 22.7891 20.6197L22.7895 20.6166L23.2067 16.7404C23.2067 16.7402 23.2067 16.74 23.2067 16.7398C23.322 15.6949 24.1115 14.9856 24.9749 14.9856H26.2664C27.1265 14.9856 27.9194 15.7133 28.0347 16.7414L28.4707 20.6522Z", stroke: "#0E3AB9" }), /* @__PURE__ */ React$7.createElement("path", { d: "M13.9855 12.2571C13.9855 13.2117 13.2115 13.9857 12.2568 13.9857C11.3023 13.9857 10.5283 13.2118 10.5283 12.2571C10.5283 11.3024 11.3023 10.5286 12.2568 10.5286C13.2116 10.5286 13.9855 11.3024 13.9855 12.2571Z", stroke: "#0E3AB9" }), /* @__PURE__ */ React$7.createElement("path", { d: "M27.3575 12.2571C27.3575 13.2118 26.5836 13.9857 25.629 13.9857C24.6743 13.9857 23.9004 13.2117 23.9004 12.2571C23.9004 11.3024 24.6743 10.5286 25.629 10.5286C26.5836 10.5286 27.3575 11.3024 27.3575 12.2571Z", stroke: "#0E3AB9" }), /* @__PURE__ */ React$7.createElement("path", { d: "M19.8021 10H19.1979C19.0833 10 19 10.1836 19 10.3878V28.6122C19 28.8367 19.0937 29 19.1979 29H19.8021C19.9167 29 20 28.8164 20 28.6122V10.3878C20 10.1633 19.9063 10.0001 19.8021 10.0001V10Z", fill: "#0E3AB9" }));
const ElementToiletSVG = SvgToilet;
const ElementMenu = ({ onStopDraggingItem }) => {
  const classes = useStyles$D();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [draggedItem, setDraggedItem] = useState(null);
  const [hasDragged, setHasDragged] = useState(false);
  const dragging = draggedItem !== null;
  const dragOffset = useRef();
  const handleStartDragging = (element, e) => {
    var _a;
    const domElement = (_a = document.getElementById(`element-${element.id}`)) == null ? void 0 : _a.getBoundingClientRect();
    const mouseOffsetX = e.clientX - domElement.x;
    const mouseOffsetY = e.clientY - domElement.y;
    dragOffset.current = {
      id: element.id,
      x: mouseOffsetX,
      y: mouseOffsetY
    };
    setDraggedItem(element.id);
  };
  const handleStopDragging = (e, position) => {
    onStopDraggingItem(e, position, draggedItem, dragOffset.current);
    setDraggedItem(null);
    dragOffset.current = null;
    setHasDragged(false);
  };
  const elements = [
    {
      name: "Drawing",
      items: [
        {
          label: "Text",
          id: "text",
          icon: /* @__PURE__ */ React__default.createElement(ElementTextSVG, { style: { height: "35px" } })
        },
        {
          label: "Custom",
          id: "line",
          icon: /* @__PURE__ */ React__default.createElement(ElementLineSVG, { style: { height: "5px" } })
        }
      ]
    },
    {
      name: "Shapes",
      items: [
        {
          label: "Rectangle",
          id: "rectangle",
          icon: /* @__PURE__ */ React__default.createElement(ElementRectangleSVG, { style: { height: "59px" } })
        },
        {
          label: "Circle",
          id: "circle",
          icon: /* @__PURE__ */ React__default.createElement(ElementCircleSVG, { style: { height: "79px" } })
        },
        {
          label: "Island",
          id: "island",
          icon: /* @__PURE__ */ React__default.createElement(ElementIslandSVG, { style: { height: "57px" } })
        }
        // {
        //   label: 'Polygon',
        //   id: 'polygon',
        //   icon: <ElementDecagonSVG style={{ height: '76px' }} />,
        // },
      ]
    },
    {
      name: "Reference markers",
      items: [
        {
          label: "Door",
          id: "door",
          icon: /* @__PURE__ */ React__default.createElement(ElementDoorSVG, { style: { height: "38px" } })
        },
        {
          label: "Stairs: Single",
          id: "stairs_single",
          icon: /* @__PURE__ */ React__default.createElement(ElementStairsSingleSVG, { style: { height: "34px" } })
        },
        {
          label: "Stairs: Landing",
          id: "stairs_landing",
          icon: /* @__PURE__ */ React__default.createElement(ElementStairsLandingSVG, { style: { height: "65px" } })
        },
        {
          label: "Kitchen",
          id: "kitchen",
          icon: /* @__PURE__ */ React__default.createElement(ElementKitchenSVG, { style: { height: "39px" } })
        },
        {
          label: "Register",
          id: "register",
          icon: /* @__PURE__ */ React__default.createElement(ElementRegisterSVG, { style: { height: "54px" } })
        },
        {
          label: "Toilet",
          id: "toilet",
          icon: /* @__PURE__ */ React__default.createElement(ElementToiletSVG, { style: { height: "39px" } })
        }
      ]
    }
  ];
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.categoryWrapper }, elements.map((category) => /* @__PURE__ */ React__default.createElement(Box, { className: classes.categoryContainer, key: category.name }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.categoryTitle }, category.name), /* @__PURE__ */ React__default.createElement(Box, { className: classes.categoryItems }, category.items.map((element) => {
    var _a;
    return /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.element} ${hoveredItem === element.id && classes.tableHover}`,
        onMouseEnter: () => {
          if (!dragging) {
            setHoveredItem(element.id);
          }
        },
        onMouseLeave: () => {
          if (hoveredItem === element.id && !dragging) {
            setHoveredItem(null);
          }
        },
        key: element.id,
        style: {
          position: hasDragged && draggedItem === element.id && ((_a = dragOffset.current) == null ? void 0 : _a.id) === element.id ? "inherit" : "relative"
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.imageContainerOuter }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.imageContainer }, /* @__PURE__ */ React__default.createElement(
        ReactDraggable,
        {
          position: { x: 0, y: 0 },
          onStart: (e) => handleStartDragging(element, e),
          onDrag: () => setHasDragged(true),
          onStop: handleStopDragging
        },
        /* @__PURE__ */ React__default.createElement(Box, { id: `element-${element.id}`, className: classes.image }, element.icon)
      ))),
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, element.label)
    );
  })))));
};
ElementMenu.defaultProps = {
  onStopDraggingItem: () => {
  }
};
ElementMenu.propTypes = {
  onStopDraggingItem: PropTypes.func
};
const mapStateToProps$19 = () => ({});
const mapDispatchToProps$18 = (dispatch) => bindActionCreators({}, dispatch);
const ElementMenu$1 = connect(mapStateToProps$19, mapDispatchToProps$18)(ElementMenu);
const SvgTableRound = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 102 102", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M68.2406 10.4828V10.4828C68.2406 5.24558 63.995 1 58.7578 1H43.2406C38.0034 1 33.7578 5.24558 33.7578 10.4828V10.4828", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M33.7594 91.5172V91.5172C33.7594 96.7544 38.005 101 43.2422 101H58.7594C63.9966 101 68.2422 96.7544 68.2422 91.5172V91.5172", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M91.5172 68.2415V68.2415C96.7544 68.2415 101 63.996 101 58.7588L101 43.2415C101 38.0044 96.7544 33.7588 91.5172 33.7588V33.7588", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.4828 33.7589V33.7589C5.24558 33.7589 1 38.0045 1 43.2417L1 58.7589C1 63.9961 5.24558 68.2417 10.4828 68.2417V68.2417", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 50.8551, cy: 51.0953, r: 43.9342, fill: "currentColor", stroke: "#313131" }));
const TableRoundSVG = SvgTableRound;
const SvgTableSquare = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 101 103", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 7.26758, y: 95.5449, width: 88.7022, height: 86.8901, rx: 11.5, transform: "rotate(-90 7.26758 95.5449)", fill: "currentColor", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M61.1322 0.5C64.6912 0.5 67.6068 3.25497 67.8626 6.74867L33.5619 6.74866C33.8177 3.25497 36.7333 0.499999 40.2923 0.499999L61.1322 0.5Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M40.2916 101.887C36.7326 101.887 33.8171 99.1325 33.5612 95.6388L67.862 95.6388C67.6061 99.1325 64.6906 101.887 61.1315 101.887L40.2916 101.887Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M100.5 61.6136C100.5 65.1727 97.745 68.0882 94.2513 68.3441L94.2513 34.0433C97.745 34.2992 100.5 37.2147 100.5 40.7737L100.5 61.6136Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.924804 40.7738C0.924804 37.2148 3.67977 34.2992 7.17347 34.0434L7.17347 68.3441C3.67977 68.0883 0.924803 65.1727 0.924803 61.6137L0.924804 40.7738Z", fill: "white", stroke: "#313131" }));
const TableSquareSVG = SvgTableSquare;
const SvgTableLong = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 55 106", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M54.041 28.085C54.041 30.8756 51.9077 33.1679 49.1829 33.4201L49.1829 14.6949C51.9077 14.9471 54.041 17.2394 54.041 20.03L54.041 28.085Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.499999 75.4289C0.499999 72.6383 2.63336 70.346 5.35814 70.0938L5.35814 88.819C2.63335 88.5669 0.499997 86.2745 0.499998 83.4839L0.499999 75.4289Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M54.041 55.9827C54.041 58.7733 51.9077 61.0656 49.1829 61.3178L49.1829 42.5926C51.9077 42.8448 54.041 45.1371 54.041 47.9277L54.041 55.9827Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.499999 48.3738C0.499999 45.5831 2.63336 43.2908 5.35814 43.0386L5.35814 61.7638C2.63335 61.5117 0.499997 59.2193 0.499998 56.4287L0.499999 48.3738Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M54.041 83.4841C54.041 86.2748 51.9077 88.5671 49.1829 88.8193L49.1829 70.0941C51.9077 70.3462 54.041 72.6386 54.041 75.4292L54.041 83.4841Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.500976 20.03C0.500976 17.2394 2.63433 14.947 5.35912 14.6949L5.35912 33.4201C2.63433 33.1679 0.500974 30.8756 0.500974 28.085L0.500976 20.03Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 50.2031, y: 0.5, width: 104.447, height: 45.8651, rx: 5.5, transform: "rotate(90 50.2031 0.5)", fill: "currentColor", stroke: "#313131" }));
const TableLongSVG = SvgTableLong;
const SvgTableRectangle = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 84 105", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M0.5 24.231C0.5 20.7102 3.22403 17.8257 6.67949 17.5699V48.8408C3.22403 48.5851 0.5 45.7005 0.5 42.1797V24.231Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.5 64.6153C0.5 61.0945 3.22403 58.2099 6.67949 57.9542V89.2251C3.22403 88.9693 0.5 86.0848 0.5 82.564V64.6153Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M83.124 42.1799C83.124 45.7007 80.4 48.5852 76.9445 48.8409L76.9445 17.5701C80.4 17.8258 83.124 20.7104 83.124 24.2312L83.124 42.1799Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M83.124 82.5642C83.124 86.0849 80.4 88.9695 76.9445 89.2252L76.9445 57.9544C80.4 58.2101 83.124 61.0947 83.124 64.6154L83.124 82.5642Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 5.77051, y: 104.5, width: 104, height: 72.2886, rx: 7.5, transform: "rotate(-90 5.77051 104.5)", fill: "currentColor", stroke: "#313131" }));
const TableRectangleSVG = SvgTableRectangle;
const SvgTableBar = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 43 107", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 6.1084, y: 106.065, width: 105.565, height: 36.3913, rx: 7.5, transform: "rotate(-90 6.1084 106.065)", fill: "currentColor", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.5 23.6021C0.5 20.3043 3.04359 17.6006 6.27592 17.3458L6.27592 49.3392C3.04359 49.0844 0.499998 46.3807 0.499999 43.0829L0.5 23.6021Z", fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.5 64.7977C0.5 61.4999 3.04359 58.7961 6.27592 58.5414L6.27592 90.5347C3.04359 90.28 0.499998 87.5762 0.499999 84.2784L0.5 64.7977Z", fill: "white", stroke: "#313131" }));
const TableBarSVG = SvgTableBar;
const TableMenu = ({ onStopDraggingItem }) => {
  const classes = useStyles$D();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [draggedItem, setDraggedItem] = useState(null);
  const dragging = draggedItem !== null;
  const dragOffset = useRef();
  const handleStartDragging = (table, e) => {
    var _a;
    const domElement = (_a = document.getElementById(`table-${table.id}`)) == null ? void 0 : _a.getBoundingClientRect();
    const mouseOffsetX = e.clientX - domElement.x;
    const mouseOffsetY = e.clientY - domElement.y;
    dragOffset.current = {
      x: mouseOffsetX,
      y: mouseOffsetY
    };
    setDraggedItem(table.id);
  };
  const handleStopDragging = (e, position) => {
    onStopDraggingItem(e, position, draggedItem, dragOffset.current);
    setDraggedItem(null);
  };
  const tables = [
    {
      label: "Round",
      id: "round",
      icon: /* @__PURE__ */ React__default.createElement(TableRoundSVG, { style: { height: "102px" } })
    },
    {
      label: "Rectangle",
      id: "rectangle",
      icon: /* @__PURE__ */ React__default.createElement(TableRectangleSVG, { style: { height: "105px" } })
    },
    {
      label: "Square",
      id: "square",
      icon: /* @__PURE__ */ React__default.createElement(TableSquareSVG, { style: { height: "103px" } })
    },
    {
      label: "Long",
      id: "long",
      icon: /* @__PURE__ */ React__default.createElement(TableLongSVG, { style: { height: "106px" } })
    },
    {
      label: "Bar seats",
      id: "bar",
      icon: /* @__PURE__ */ React__default.createElement(TableBarSVG, { style: { height: "107px" } })
    }
  ];
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, tables.map((table) => /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.table} ${hoveredItem === table.id && classes.tableHover}`,
      onMouseEnter: () => {
        if (!dragging) {
          setHoveredItem(table.id);
        }
      },
      onMouseLeave: () => {
        if (hoveredItem === table.id && !dragging) {
          setHoveredItem(null);
        }
      },
      key: table.id,
      style: {
        ...draggedItem === table.id && { zIndex: 999 }
      }
    },
    /* @__PURE__ */ React__default.createElement(
      ReactDraggable,
      {
        position: { x: 0, y: 0 },
        onStart: (e) => handleStartDragging(table, e),
        onStop: handleStopDragging
      },
      /* @__PURE__ */ React__default.createElement(Box, { id: `table-${table.id}`, className: classes.image }, table.icon)
    ),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, table.label)
  )));
};
TableMenu.defaultProps = {
  onStopDraggingItem: () => {
  }
};
TableMenu.propTypes = {
  onStopDraggingItem: PropTypes.func
};
const mapStateToProps$18 = () => ({});
const mapDispatchToProps$17 = (dispatch) => bindActionCreators({}, dispatch);
const TableMenu$1 = connect(mapStateToProps$18, mapDispatchToProps$17)(TableMenu);
const EditFloorplanMap = ({
  areas,
  tables,
  createLocalTable,
  showSidebar,
  showTableMenu,
  showElementMenu,
  deleteLocalTables,
  floorplanData,
  updateLocalFloorplan,
  updateLocalTable,
  undoFloorplanUpdate,
  redoFloorplanUpdate
}) => {
  var _a;
  const theme2 = useTheme$1();
  const canvasRef = useRef(null);
  const canvasMargin = 5;
  const [hoveredArea, setHoveredArea] = useState(null);
  const [hoveredTable, setHoveredTable] = useState(null);
  const hoveredTableRef = useRef(null);
  const [activeTable, setActiveTable] = useState(null);
  const [addPoint, setAddPoint] = useState(null);
  const [addElementPoint, setAddElementPoint] = useState(null);
  const [selectedTables, setSelectedTables] = useState([]);
  const cancelClickRef = useRef(false);
  const [showDeleteAreaModal, setShowDeleteAreaModal] = useState(false);
  const [showDeleteTableModal, setShowDeleteTableModal] = useState(false);
  const [tablesToDelete, setTablesToDelete] = useState([]);
  const [hoveredElement, setHoveredElement] = useState(null);
  const [activeElement, setActiveElement] = useState(null);
  const [editingElement, setEditingElement] = useState(null);
  const [selectedElements, setSelectedElements] = useState([]);
  const dragOffsetRef = useRef(null);
  const resizeOffsetRef = useRef(null);
  const pointDragOffsetRef = useRef(null);
  const pointDragChangeRef = useRef(0);
  const isDrawingRef = useRef(null);
  const elementPointDragChangeRef = useRef(0);
  const elementPointDragOffsetRef = useRef(null);
  const tableDragOffsetRef = useRef(null);
  const tableResizeOffsetRef = useRef(null);
  const tableRotateOffsetRef = useRef(null);
  const elementDragOffsetRef = useRef(null);
  const elementResizeOffsetRef = useRef(null);
  const elementRotateOffsetRef = useRef(null);
  const mousePosRef = useRef(null);
  const tableCount = useRef(0);
  const isHoldingShift = useRef(false);
  const isHoldingControl = useRef(false);
  const copiedElements = useRef([]);
  const copiedTables = useRef([]);
  const scrollRef = useRef(null);
  const nodeRef = React__default.useRef(null);
  const requestRef = useRef(null);
  const previousTimeRef = useRef();
  const triggerRedrawRef = useRef(true);
  const classes = useStyles$E({ sidebarOpen: showSidebar });
  const floorplanElements = floorplanData == null ? void 0 : floorplanData.elements;
  const floorplanTables = floorplanData == null ? void 0 : floorplanData.tables;
  const floorplanAreas = floorplanData == null ? void 0 : floorplanData.areas;
  const [areaAnchor, setAreaAnchor] = useState(null);
  const [areaEditing, setAreaEditing] = useState(null);
  const [tableAnchor, setTableAnchor] = useState(null);
  const [tableEditing, setTableEditing] = useState(null);
  const [alignmentAnchor, setAlignmentAnchor] = useState(null);
  const [joinAnchor, setJoinAnchor] = useState(null);
  const [showUnjoinModal, setShowUnjoinModal] = useState(false);
  const [handleAnchor, setHandleAnchor] = useState({});
  const [dragDistance, setDragDistance] = useState({ x: 0, y: 0 });
  const getClosestPointOnLineSegment = (a, b, p) => {
    const ap = [p.x - a.x, p.y - a.y];
    const ab = [b.x - a.x, b.y - a.y];
    const magnitudeAB = lengthSquared(a, b);
    const ABAPProduct = dotProduct(ap, ab);
    const distance = ABAPProduct / magnitudeAB;
    if (distance < 0) {
      return a;
    }
    if (distance > 1) {
      return b;
    }
    return {
      x: a.x + ab[0] * distance,
      y: a.y + ab[1] * distance
    };
  };
  const drawArea = (ctx, floorplanArea, indoorPattern, outdoorPattern) => {
    var _a2, _b2;
    if (!floorplanArea) {
      return;
    }
    const areaData = findObjectByProperty(areas == null ? void 0 : areas.data, floorplanArea == null ? void 0 : floorplanArea.id, "id");
    const isCapacity = isAreaCapacityBased(areaData, tables == null ? void 0 : tables.data);
    const getFillStyle = () => {
      if (isCapacity) {
        return theme2.colors.gray7;
      }
      return floorplanArea.type === "outdoor" ? outdoorPattern : indoorPattern;
    };
    ctx.fillStyle = getFillStyle();
    const pointsWithOffset = (_a2 = floorplanArea == null ? void 0 : floorplanArea.points) == null ? void 0 : _a2.map((point) => ({
      x: (point == null ? void 0 : point.x) + (floorplanArea == null ? void 0 : floorplanArea.x),
      y: (point == null ? void 0 : point.y) + (floorplanArea == null ? void 0 : floorplanArea.y)
    }));
    drawShape(ctx, pointsWithOffset);
    if ((floorplanArea == null ? void 0 : floorplanArea.id) === (hoveredArea == null ? void 0 : hoveredArea.id)) {
      ctx.lineWidth = 2;
      ctx.strokeStyle = theme2.colors.olive3;
      ctx.setLineDash([]);
      ctx.stroke();
      ctx.fillStyle = theme2.colors.olive3;
      if (floorplanArea == null ? void 0 : floorplanArea.isRectangle) {
        drawCircle(
          ctx,
          floorplanArea.x + floorplanArea.points[2].x,
          floorplanArea.y + floorplanArea.points[2].y,
          5
        );
        ctx.fill();
      } else {
        ctx.fillStyle = theme2.colors.olive3;
        (_b2 = floorplanArea == null ? void 0 : floorplanArea.points) == null ? void 0 : _b2.forEach((point) => {
          drawCircle(ctx, floorplanArea.x + point.x, floorplanArea.y + point.y, 5);
          ctx.fill();
        });
      }
    } else if (floorplanArea.type === "outdoor") {
      ctx.lineWidth = 1;
      ctx.strokeStyle = theme2.colors.nimbus;
      ctx.setLineDash([5, 3]);
      ctx.stroke();
    }
  };
  const indoorGridPattern = createPatternCanvas(theme2);
  const outdoorGridPattern = createPatternCanvas(theme2, true);
  const draw = (ctx) => {
    var _a2, _b2;
    isDrawingRef.current = true;
    const indoorPattern = ctx.createPattern(indoorGridPattern, "repeat");
    const outdoorPattern = ctx.createPattern(outdoorGridPattern, "repeat");
    ctx.scale(1, 1);
    ctx.fillStyle = theme2.colors.floorplanTableFill;
    ctx.strokeStyle = theme2.colors.floorplanTableOutline;
    floorplanAreas.forEach((floorplanArea) => {
      if ((floorplanArea == null ? void 0 : floorplanArea.id) === (hoveredArea == null ? void 0 : hoveredArea.id)) {
        drawArea(ctx, hoveredArea, indoorPattern, outdoorPattern);
      } else {
        drawArea(ctx, floorplanArea, indoorPattern, outdoorPattern);
      }
    });
    floorplanAreas.forEach((floorplanArea) => {
      const areaToUse = (hoveredArea == null ? void 0 : hoveredArea.id) === (floorplanArea == null ? void 0 : floorplanArea.id) ? hoveredArea : floorplanArea;
      const elementsForArea = floorplanElements.filter(
        (element) => (element == null ? void 0 : element.areaId) === (floorplanArea == null ? void 0 : floorplanArea.id)
      );
      const areaBoundingBox = getBoundsOfShape(areaToUse == null ? void 0 : areaToUse.points, areaToUse.x, areaToUse.y);
      elementsForArea.forEach((element) => {
        const isActive = (activeElement == null ? void 0 : activeElement.id) === (element == null ? void 0 : element.id);
        const isHovered = (hoveredElement == null ? void 0 : hoveredElement.id) === (element == null ? void 0 : element.id);
        const isEditing = (editingElement == null ? void 0 : editingElement.id) === (element == null ? void 0 : element.id);
        const isSelected = selectedElements == null ? void 0 : selectedElements.includes(element == null ? void 0 : element.id);
        const elementToDraw = (hoveredElement == null ? void 0 : hoveredElement.id) === (element == null ? void 0 : element.id) ? hoveredElement : element;
        const elementBounds = getBoundsOfElement(elementToDraw, areaBoundingBox);
        drawElement(
          ctx,
          elementBounds.originX,
          elementBounds.originY,
          elementToDraw,
          elementBounds,
          element.rotation,
          isHovered || isActive || isSelected,
          isEditing,
          theme2
        );
        if (element.type !== "line" && (isHovered || isActive || isSelected)) {
          const resizable = element.type !== "text";
          drawBoundingBox(ctx, elementBounds, theme2, 10, resizable);
        }
      });
    });
    floorplanAreas.forEach((floorplanArea) => {
      const areaToUse = (hoveredArea == null ? void 0 : hoveredArea.id) === (floorplanArea == null ? void 0 : floorplanArea.id) ? hoveredArea : floorplanArea;
      const tableDataForArea = filterByProperty(tables == null ? void 0 : tables.data, floorplanArea == null ? void 0 : floorplanArea.id, "areaId");
      const areaBoundingBox = getBoundsOfShape(areaToUse == null ? void 0 : areaToUse.points, areaToUse.x, areaToUse.y);
      tableDataForArea.forEach((tableData) => {
        if (tableData.isJoin) {
          return;
        }
        const floorplanTable = getFloorplanTableFromTableData(floorplanTables, tableData);
        (activeTable == null ? void 0 : activeTable.id) === (floorplanTable == null ? void 0 : floorplanTable.id);
        const isHovered = (hoveredTable == null ? void 0 : hoveredTable.id) === (floorplanTable == null ? void 0 : floorplanTable.id);
        const isSelected = selectedTables == null ? void 0 : selectedTables.includes(floorplanTable == null ? void 0 : floorplanTable.id);
        const tableToDraw = (hoveredTable == null ? void 0 : hoveredTable.id) === (floorplanTable == null ? void 0 : floorplanTable.id) ? hoveredTable : floorplanTable;
        if (!tableToDraw || !tableData) {
          devLog("error", "NOT DRAWING TABLE, missing data for some reason", {
            tableToDraw,
            tableData
          });
          return;
        }
        const tableWithUpdatedPosition = {
          ...tableToDraw,
          x: floorplanTable.x + (isSelected ? dragDistance.x || 0 : 0),
          y: floorplanTable.y + (isSelected ? dragDistance.y || 0 : 0)
        };
        const tableBounds = getBoundsOfTable(
          tableWithUpdatedPosition,
          tableData.maxSeats,
          areaBoundingBox
        );
        drawTable(
          ctx,
          tableBounds.originX,
          tableBounds.originY,
          tableData,
          tableToDraw,
          tableBounds,
          theme2,
          false,
          isHovered ? theme2.colors.black : theme2.colors.charcoal
        );
      });
    });
    if (selectedTables.length > 1) {
      const selectedTableBounds = selectedTables.map((tableId) => {
        const { floorplanTable, tableData } = getAllTableData(
          tableId,
          floorplanTables,
          tables.data
        );
        const area = findObjectByProperty(floorplanAreas, tableData == null ? void 0 : tableData.areaId, "id");
        return getBoundsOfTable(floorplanTable, tableData == null ? void 0 : tableData.maxSeats, area.bounds);
      });
      const leftPoint = Math.min(...selectedTableBounds.map((table) => table.x));
      const rightPoint = Math.max(...selectedTableBounds.map((table) => table.right));
      const topPoint = Math.min(...selectedTableBounds.map((table) => table.y));
      const bottomPoint = Math.max(...selectedTableBounds.map((table) => table.bottom));
      const littleSquareOffsetRight = 0;
      const otherOffset = 10;
      const boundingBox = {
        topLeftX: leftPoint + dragDistance.x - otherOffset,
        topLeftY: topPoint + dragDistance.y - otherOffset,
        width: rightPoint - leftPoint + littleSquareOffsetRight,
        height: bottomPoint - topPoint + littleSquareOffsetRight
      };
      drawBoundingBox(ctx, boundingBox, theme2, 0, false);
    }
    (_b2 = (_a2 = tables == null ? void 0 : tables.data) == null ? void 0 : _a2.filter((tableData) => {
      const floorplanTable = getFloorplanTableFromTableData(floorplanTables, tableData);
      const isActive = (activeTable == null ? void 0 : activeTable.id) === (floorplanTable == null ? void 0 : floorplanTable.id);
      const isHovered = (hoveredTable == null ? void 0 : hoveredTable.id) === (floorplanTable == null ? void 0 : floorplanTable.id);
      const isSelected = selectedTables == null ? void 0 : selectedTables.includes(floorplanTable == null ? void 0 : floorplanTable.id);
      return isHovered || isActive || isSelected;
    })) == null ? void 0 : _b2.forEach((tableData) => {
      const floorplanTable = getFloorplanTableFromTableData(floorplanTables, tableData);
      const isSelected = selectedTables == null ? void 0 : selectedTables.includes(floorplanTable == null ? void 0 : floorplanTable.id);
      const isHovered = (hoveredTable == null ? void 0 : hoveredTable.id) === (floorplanTable == null ? void 0 : floorplanTable.id);
      if (!floorplanTable || !tableData) {
        devLog("info", "Not drawing table bounds", {
          floorplanTable,
          tableData
        });
      }
      const tableToDraw = isHovered ? hoveredTable : floorplanTable;
      const tableWithUpdatedPosition = {
        ...tableToDraw,
        x: (floorplanTable == null ? void 0 : floorplanTable.x) + (isSelected ? (dragDistance == null ? void 0 : dragDistance.x) || 0 : 0),
        // Position must not be the hovered table's
        y: (floorplanTable == null ? void 0 : floorplanTable.y) + (isSelected ? (dragDistance == null ? void 0 : dragDistance.y) || 0 : 0)
      };
      const area = getAreaById(floorplanAreas, tableData == null ? void 0 : tableData.areaId);
      const tableBounds = getBoundsOfTable(
        tableWithUpdatedPosition,
        tableData.maxSeats,
        area == null ? void 0 : area.bounds
      );
      drawBoundingBox(ctx, tableBounds, theme2);
    });
  };
  const redraw = () => {
    triggerRedrawRef.current = true;
  };
  const handleCreateElement = useCallback(
    (elementType, areaId, xPos = 0, yPos = 0, overrides) => {
      const defaultValues = getDefaultValuesForType(elementType);
      const createdElement = {
        id: generateRandomString(8),
        areaId,
        type: elementType,
        rotation: 0,
        width: defaultValues.width,
        height: defaultValues.height,
        x: xPos,
        y: yPos,
        points: [],
        text: null,
        ...overrides
      };
      devLog("info", "new element", { floorplanElements, createdElement });
      const newFloorplan = {
        ...floorplanData,
        elements: [...floorplanElements, createdElement]
      };
      updateLocalFloorplan(newFloorplan);
    },
    [floorplanData, floorplanElements, updateLocalFloorplan]
  );
  const handleDeleteElement = useCallback(
    (ids) => {
      const newFloorplan = {
        ...floorplanData,
        elements: filterByProperty(floorplanElements, ids, "id", true)
      };
      updateLocalFloorplan(newFloorplan);
    },
    [floorplanData, floorplanElements, updateLocalFloorplan]
  );
  const handleDeleteTables = (deletingTables) => {
    deleteLocalTables(deletingTables);
    setSelectedTables([]);
    setTablesToDelete([]);
  };
  const createTableNumber = useCallback(() => {
    var _a2;
    const newTableNumber = (((_a2 = tables.data.map((table) => {
      return parseInt(table == null ? void 0 : table.tableNumber, 10);
    }).filter((tableNumber) => tableNumber > 0).sort((a, b) => b - a)) == null ? void 0 : _a2[0]) || 0) + 1;
    return `${newTableNumber}`;
  }, [tables.data]);
  const handleUpdateArea = (updatedData) => {
    const newFloorplan = {
      ...floorplanData,
      areas: updateObjectByProperty(floorplanAreas, updatedData, "id")
    };
    updateLocalFloorplan(newFloorplan);
  };
  const updateTableData = (updatedData) => {
    const tableData = findObjectByProperty(tables == null ? void 0 : tables.data, updatedData.id, "id");
    updateLocalTable({ ...tableData, ...updatedData });
  };
  const handleUpdateTable = (updatedData) => {
    devLog("info", "updating table", updatedData);
    const newFloorplan = {
      ...floorplanData,
      tables: updateObjectByProperty(floorplanTables, updatedData, "id")
    };
    updateLocalFloorplan(newFloorplan);
  };
  const handleUpdateTables = (updatedData) => {
    devLog("info", "updating tables", updatedData);
    const newTables = updateObjectsByProperty(floorplanTables, updatedData, "id");
    updateLocalFloorplan({
      ...floorplanData,
      tables: newTables
    });
  };
  const handleUpdateElement = (updatedData) => {
    const newFloorplan = {
      ...floorplanData,
      elements: updateObjectByProperty(floorplanElements, updatedData, "id")
    };
    updateLocalFloorplan(newFloorplan);
  };
  const handleUpdateElements = (updatedData) => {
    devLog("info", "updating elements", updatedData);
    const newElements = updateObjectsByProperty(floorplanElements, updatedData, "id");
    updateLocalFloorplan({
      ...floorplanData,
      elements: newElements
    });
  };
  const handleCreateTable = useCallback(
    (tableType, areaId, xPos = 0, yPos = 0, notes = null, floorplanTableData = {}, tableData = {}) => {
      const tableId = generateRandomString(8);
      const tableNumber = createTableNumber();
      const floorplanTable = {
        type: tableType,
        rotation: 0,
        scale: 1,
        x: xPos,
        y: yPos,
        tableNumber,
        ...floorplanTableData,
        id: tableId,
        originalId: tableId
      };
      const newFloorplan = {
        ...floorplanData,
        tables: [...floorplanTables, floorplanTable]
      };
      updateLocalFloorplan(newFloorplan);
      createLocalTable(
        {
          minSeats: (tableData == null ? void 0 : tableData.minSeats) || 1,
          maxSeats: (tableData == null ? void 0 : tableData.maxSeats) || getDefaultSeatsForType(tableType),
          areaId,
          tableNumber,
          // must always be new
          notes: (tableData == null ? void 0 : tableData.notes) || notes
        },
        tableId
      );
    },
    [createLocalTable, createTableNumber, floorplanData, floorplanTables, updateLocalFloorplan]
  );
  const handleKeyPress = useCallback(
    (event) => {
      if (tableAnchor || joinAnchor || showUnjoinModal || !isEmpty(areaAnchor) || !isEmpty(editingElement)) {
        return;
      }
      if (!isHoldingShift.current && event.key === "Shift") {
        isHoldingShift.current = true;
      }
      if (!isHoldingControl.current && event.key === "Control" || event.key === "Meta") {
        isHoldingControl.current = true;
      }
      if (isHoldingControl.current && event.key.toLowerCase() === "z") {
        undoFloorplanUpdate();
      }
      if (isHoldingControl.current && isHoldingShift.current && event.key.toLowerCase() === "z") {
        redoFloorplanUpdate();
      }
      if (isHoldingControl.current && event.key.toLowerCase() === "c") {
        const elementsToCopy = filterByProperty(floorplanElements, selectedElements, "id");
        const tablesToCopy = filterByProperty(tables.data, selectedTables, "id");
        copiedElements.current = copyObjects(elementsToCopy);
        copiedTables.current = copyObjects(tablesToCopy);
      }
      if (isHoldingControl.current && event.key.toLowerCase() === "v") {
        if (copiedElements.current.length > 0) {
          copiedElements.current.forEach((element) => {
            const offset = 10;
            handleCreateElement(
              element.type,
              element.areaId,
              element.x + offset,
              element.y + offset,
              {
                rotation: element.rotation,
                width: element.width,
                height: element.height,
                points: element.points,
                text: element.text
              }
            );
          });
        }
        if (copiedTables.current.length > 0) {
          copiedTables.current.forEach((table) => {
            const floorplanTable = getFloorplanTableFromTableData(floorplanTables, table);
            const floorplanArea = getFloorplanAreaFromId(floorplanAreas, table == null ? void 0 : table.areaId);
            let offset = 10;
            if (floorplanArea) {
              const areaBoundingBox = getBoundsOfShape(
                floorplanArea == null ? void 0 : floorplanArea.points,
                floorplanArea.x,
                floorplanArea.y
              );
              const tableBounds = getBoundsOfTable(
                floorplanTable,
                table == null ? void 0 : table.maxSeats,
                areaBoundingBox
              );
              offset = tableBounds.width + 10;
            }
            tableCount.current += 1;
            handleCreateTable(
              floorplanTable.type,
              table.areaId,
              floorplanTable.x + offset,
              floorplanTable.y,
              table.notes,
              {
                rotation: floorplanTable.rotation,
                scale: floorplanTable.scale
              },
              {
                minSeats: table.minSeats,
                maxSeats: table.maxSeats,
                isPublic: table.isPublic
              }
            );
          });
        }
      }
      if (event.key === "Delete" || event.key === "Backspace") {
        if (selectedElements.length > 0) {
          handleDeleteElement(selectedElements);
          setSelectedElements([]);
          setEditingElement(null);
        }
        if (selectedTables.length > 0) {
          unstable_batchedUpdates(() => {
            setJoinAnchor(null);
            setAlignmentAnchor(null);
            setTablesToDelete([...selectedTables]);
            setShowDeleteTableModal(true);
          });
        }
      }
      const movementAmount = 4;
      const verticalMovement = event.key === "ArrowUp" ? -movementAmount : event.key === "ArrowDown" ? movementAmount : 0;
      const horizontalMovement = event.key === "ArrowLeft" ? -movementAmount : event.key === "ArrowRight" ? movementAmount : 0;
      const selectedElementData = filterByProperty(floorplanElements, selectedElements, "id");
      if (verticalMovement !== 0 || horizontalMovement !== 0) {
        if (selectedElementData.length > 0) {
          event.preventDefault();
          const updatedElements = selectedElementData.map((element) => {
            const nearestX = horizontalMovement !== 0 ? roundToNearest(element.x + horizontalMovement, movementAmount, "floor") : element.x;
            const nearestY = verticalMovement !== 0 ? roundToNearest(element.y + verticalMovement, movementAmount, "floor") : element.y;
            return {
              ...element,
              x: nearestX,
              y: nearestY
            };
          });
          handleUpdateElements(updatedElements);
        }
        const selectedTableData = filterByProperty(floorplanTables, selectedTables, "id");
        if (selectedTableData.length > 0) {
          event.preventDefault();
          const updatedTables = selectedTableData.map((table) => {
            const nearestX = horizontalMovement !== 0 ? roundToNearest(table.x + horizontalMovement, movementAmount, "floor") : table.x;
            const nearestY = verticalMovement !== 0 ? roundToNearest(table.y + verticalMovement, movementAmount, "floor") : table.y;
            return {
              ...table,
              x: nearestX,
              y: nearestY
            };
          });
          handleUpdateTables(updatedTables);
        }
      }
    },
    [
      editingElement,
      undoFloorplanUpdate,
      redoFloorplanUpdate,
      floorplanElements,
      selectedElements,
      tables.data,
      selectedTables,
      handleCreateElement,
      floorplanTables,
      floorplanAreas,
      handleCreateTable,
      tableAnchor,
      joinAnchor,
      showUnjoinModal,
      handleDeleteElement,
      areaAnchor
    ]
  );
  const handleKeyUp = useCallback(
    (event) => {
      if (isHoldingShift && event.key === "Shift") {
        isHoldingShift.current = false;
      }
      if (isHoldingControl && event.key === "Control") {
        isHoldingControl.current = false;
      }
    },
    [isHoldingShift]
  );
  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    document.addEventListener("keyup", handleKeyUp);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [selectedElements, selectedTables, floorplanData, handleKeyPress, handleKeyUp]);
  useEffect(() => {
    if (hoveredArea) {
      setHoveredArea(findObjectByProperty(floorplanAreas, hoveredArea == null ? void 0 : hoveredArea.id, "id"));
    }
  }, [floorplanAreas]);
  useEffect(() => {
    setDragDistance({ x: 0, y: 0 });
    redraw();
  }, [floorplanTables, tables == null ? void 0 : tables.data]);
  useEffect(() => {
    redraw();
  }, [
    floorplanElements,
    floorplanAreas,
    hoveredArea,
    hoveredTable,
    hoveredElement,
    selectedTables,
    selectedElements
  ]);
  useEffect(() => {
    if (tableCount.current === 0) {
      tableCount.current = tables.data.length;
    }
  }, [tables == null ? void 0 : tables.data]);
  const update = (time) => {
    if (triggerRedrawRef.current && (canvasRef == null ? void 0 : canvasRef.current)) {
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
      triggerRedrawRef.current = false;
      draw(context);
    }
    previousTimeRef.current = time;
    requestRef.current = requestAnimationFrame(update);
  };
  useEffect(() => {
    requestRef.current = requestAnimationFrame(update);
    return () => cancelAnimationFrame(requestRef.current);
  });
  const minCanvasWidth = 500;
  const minCanvasHeight = 500;
  let canvasWidth = minCanvasWidth;
  let canvasHeight = minCanvasHeight;
  (_a = [...floorplanAreas, hoveredArea]) == null ? void 0 : _a.forEach((floorplanArea) => {
    var _a2;
    (_a2 = floorplanArea == null ? void 0 : floorplanArea.points) == null ? void 0 : _a2.forEach((point) => {
      if (point.x + floorplanArea.x > canvasWidth) {
        canvasWidth = point.x + floorplanArea.x;
      }
      if (point.y + floorplanArea.y > canvasHeight) {
        canvasHeight = point.y + floorplanArea.y;
      }
    });
  });
  const increment = 1;
  canvasWidth = Math.ceil(canvasWidth / increment) * increment;
  canvasHeight = Math.ceil(canvasHeight / increment) * increment;
  canvasWidth += canvasMargin;
  canvasHeight += canvasMargin;
  useEffect(() => {
    if (tableEditing) {
      const updatedTable = getFloorplanTableFromTableData(floorplanTables, tableEditing);
      setTableEditing(updatedTable);
    }
  }, [floorplanTables]);
  const getClosestPointOnLine = (mouseX, mouseY, points = [], maxDistance = 25, minDistanceFromCorner = 25, enclosed = true) => {
    let closestPoint = null;
    let pointIndex = null;
    let closestDistance = null;
    const mousePos = {
      x: mouseX,
      y: mouseY
    };
    let tooClose = false;
    points.forEach((point) => {
      const distance = lengthSquared(point, mousePos);
      if (distance < minDistanceFromCorner * minDistanceFromCorner) {
        tooClose = true;
      }
    });
    if (tooClose) {
      return null;
    }
    let pointsToCheck = [...points];
    if (enclosed) {
      pointsToCheck = [...points, points[0]];
    }
    for (let i = 0; i < pointsToCheck.length - 1; i += 1) {
      const closestPointForLine = getClosestPointOnLineSegment(
        pointsToCheck[i],
        pointsToCheck[i + 1],
        mousePos
      );
      const distanceToClosestPoint = lengthSquared(mousePos, closestPointForLine);
      if (closestDistance === null || distanceToClosestPoint < closestDistance) {
        closestDistance = distanceToClosestPoint;
        closestPoint = closestPointForLine;
        pointIndex = i;
      }
    }
    if (closestDistance > maxDistance * maxDistance) {
      if (addPoint) {
        return null;
      }
    } else {
      return { point: closestPoint, index: pointIndex + 1, distance: closestDistance };
    }
    return null;
  };
  const recalculateClosestPointOnLine = (mouseX, mouseY, area) => {
    const marginFix = 10;
    const mousePosRelativeToShape = {
      x: mouseX - area.x - marginFix,
      y: mouseY - area.y - marginFix
    };
    setAddPoint(
      getClosestPointOnLine(mousePosRelativeToShape.x, mousePosRelativeToShape.y, area.points)
    );
  };
  const recalculateClosestPointOnElementLine = (mouseX, mouseY, area) => {
    const marginFix = 10;
    const lineElements = filterByProperty(floorplanElements, "line", "type");
    const elementsForArea = filterByProperty(lineElements, area == null ? void 0 : area.id, "areaId");
    const mousePosRelativeToShape = {
      x: mouseX - area.x - marginFix,
      y: mouseY - area.y - marginFix
    };
    let closestPoint = null;
    elementsForArea == null ? void 0 : elementsForArea.forEach((element) => {
      const closestPointForElement = getClosestPointOnLine(
        mousePosRelativeToShape.x - element.x,
        mousePosRelativeToShape.y - element.y,
        element == null ? void 0 : element.points,
        25,
        20,
        false
      );
      if (closestPointForElement !== null && closestPointForElement !== void 0 && (closestPoint === null || (closestPointForElement == null ? void 0 : closestPointForElement.distance) < closestPoint.distance)) {
        closestPoint = {
          ...closestPointForElement,
          elementId: element == null ? void 0 : element.id
        };
      }
    });
    if (closestPoint !== null) {
      const elementForPoint = findObjectByProperty(
        floorplanElements,
        closestPoint == null ? void 0 : closestPoint.elementId,
        "id"
      );
      setHoveredElement(elementForPoint);
    } else if ((hoveredElement == null ? void 0 : hoveredElement.type) === "line") {
      setHoveredElement(null);
    }
    setAddElementPoint(closestPoint);
  };
  const handleMouseOnCanvas = (event) => {
    if (dragOffsetRef.current || resizeOffsetRef.current || tableDragOffsetRef.current || tableResizeOffsetRef.current || pointDragOffsetRef.current || elementDragOffsetRef.current || elementResizeOffsetRef.current || elementPointDragOffsetRef.current) {
      devLog("info", "currently dragging or something", {
        dragOffsetRef: dragOffsetRef.current,
        resizeOffsetRef: resizeOffsetRef.current,
        tableDragOffsetRef: tableDragOffsetRef.current,
        tableResizeOffsetRef: tableResizeOffsetRef.current,
        pointDragOffsetRef: pointDragOffsetRef.current,
        elementDragOffsetRef: elementDragOffsetRef.current,
        elementResizeOffsetRef: elementResizeOffsetRef.current,
        elementPointDragOffsetRef: elementPointDragOffsetRef.current
      });
      return;
    }
    const rect = canvasRef.current.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;
    mousePosRef.current = { x: mouseX, y: mouseY };
    if (mouseX < 0 || mouseY < 0) {
      devLog("debug", "mouse is not on floorplan");
      hoveredTableRef.current = null;
      setHoveredTable(null);
      setHoveredArea(null);
      return;
    }
    const areaForPoint = getAreaForPoint(mousePosRef.current, floorplanAreas, canvasMargin);
    if (!areaForPoint) {
      if (hoveredArea !== null) {
        setHoveredArea(null);
      }
      return;
    }
    const newHoveredArea = areaForPoint;
    if ((hoveredArea == null ? void 0 : hoveredArea.id) !== (newHoveredArea == null ? void 0 : newHoveredArea.id)) {
      setHoveredArea(newHoveredArea);
    }
    recalculateClosestPointOnLine(mouseX, mouseY, newHoveredArea);
    recalculateClosestPointOnElementLine(mouseX, mouseY, newHoveredArea);
  };
  const renderAreaNames = () => {
    const innerPadding = 10;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, floorplanAreas.map((floorplanArea) => {
      var _a2;
      const areaToDrawOn = (floorplanArea == null ? void 0 : floorplanArea.id) === (hoveredArea == null ? void 0 : hoveredArea.id) ? hoveredArea : floorplanArea;
      const areaData = findObjectByProperty(areas == null ? void 0 : areas.data, floorplanArea == null ? void 0 : floorplanArea.id, "id");
      const topLeftPoint = (_a2 = immutableSort(floorplanArea == null ? void 0 : floorplanArea.points, (a, b) => a.x - b.x)) == null ? void 0 : _a2[0];
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: floorplanArea == null ? void 0 : floorplanArea.id,
          className: classes.areaLabel,
          style: {
            top: (areaToDrawOn == null ? void 0 : areaToDrawOn.y) + ((topLeftPoint == null ? void 0 : topLeftPoint.y) || 0) + canvasMargin + innerPadding,
            left: (areaToDrawOn == null ? void 0 : areaToDrawOn.x) + ((topLeftPoint == null ? void 0 : topLeftPoint.x) || 0) + canvasMargin + innerPadding,
            backgroundColor: theme2.colors.white
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaLabelText }, areaData == null ? void 0 : areaData.name),
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            type: "icon",
            className: classes.actionButton,
            onClick: (e) => {
              setAreaEditing(areaToDrawOn);
              setAreaAnchor(e.currentTarget);
            }
          },
          /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG, { className: classes.actionIcon })
        )
      );
    }));
  };
  const addPointToArea = (area, point, index) => {
    const points = insert(area.points, index, point);
    devLog("info", "adding point to area", { index, area, point });
    handleUpdateArea({
      ...area,
      points
    });
  };
  const addPointToElement = (element, point, index) => {
    const points = insert(element.points, index, point);
    devLog("info", "adding point to element", index);
    const newElement = {
      ...element,
      points
    };
    handleUpdateElement(newElement);
    setHoveredElement(newElement);
  };
  const removePointFromArea = (area, index) => {
    if (area.points.length <= 3) {
      return;
    }
    devLog("info", "removing point", index);
    const newPoints = area.points.filter((point, pointIndex) => pointIndex !== index);
    handleUpdateArea({
      ...area,
      points: newPoints
    });
  };
  const removePointFromElement = (element, index) => {
    if (element.points.length <= 2) {
      handleDeleteElement(element.id);
      return;
    }
    devLog("info", "removing point", index);
    const newPoints = element.points.filter((point, pointIndex) => pointIndex !== index);
    const newElement = {
      ...element,
      points: newPoints
    };
    handleUpdateElement(newElement);
    setHoveredElement(newElement);
  };
  const onStartDragging = () => {
    if (!hoveredArea) {
      return;
    }
    setAddPoint(null);
    setAddElementPoint(null);
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const areaBoundingBox = getBoundsOfShape(hoveredArea == null ? void 0 : hoveredArea.points, hoveredArea.x, hoveredArea.y);
    const offset = 45;
    const leftOffset = areaBoundingBox.width + canvasMargin - offset;
    const topOffset = areaBoundingBox.height + canvasMargin - offset;
    dragOffsetRef.current = {
      x: canvasRect.x + leftOffset,
      y: canvasRect.y + topOffset
    };
  };
  const onChangeDragPos = (newPos) => {
    if (!dragOffsetRef.current) {
      return;
    }
    const newHoveredArea = { ...hoveredArea };
    const offsetFix = 10;
    newHoveredArea.x = Math.max(canvasMargin, newPos.x - dragOffsetRef.current.x - offsetFix);
    newHoveredArea.y = Math.max(canvasMargin, newPos.y - dragOffsetRef.current.y - offsetFix);
    setHoveredArea(newHoveredArea);
  };
  const onStopDragging = () => {
    dragOffsetRef.current = null;
    if (hoveredArea) {
      handleUpdateArea(hoveredArea);
    }
  };
  const onStartResizing = () => {
    const canvasRect = canvasRef.current.getBoundingClientRect();
    setAddPoint(null);
    setAddElementPoint(null);
    resizeOffsetRef.current = {
      x: canvasRect.x,
      y: canvasRect.y
    };
  };
  const onChangeResizing = (newPos) => {
    if (!resizeOffsetRef.current) {
      return;
    }
    const minSize = 150;
    const offsetFix = 10;
    const mousePosRelativeToAreaX = Math.max(
      minSize,
      newPos.x - hoveredArea.x - resizeOffsetRef.current.x - offsetFix
    );
    const mousePosRelativeToAreaY = Math.max(
      minSize,
      newPos.y - hoveredArea.y - resizeOffsetRef.current.y - offsetFix
    );
    const newPoints = [...hoveredArea.points];
    newPoints[1].y = mousePosRelativeToAreaY;
    newPoints[2].x = mousePosRelativeToAreaX;
    newPoints[2].y = mousePosRelativeToAreaY;
    newPoints[3].x = mousePosRelativeToAreaX;
    setHoveredArea({
      ...hoveredArea,
      points: newPoints
    });
  };
  const onStopResizing = () => {
    resizeOffsetRef.current = null;
    devLog("info", "stopped resizing");
    handleUpdateArea(hoveredArea);
  };
  const onStartDraggingPoint = (pointIndex, e) => {
    const canvasRect = canvasRef.current.getBoundingClientRect();
    setAddPoint(null);
    setAddElementPoint(null);
    pointDragOffsetRef.current = {
      index: pointIndex,
      target: e.currentTarget,
      x: canvasRect.x,
      y: canvasRect.y
    };
  };
  const onChangeDraggingPoint = (newPos, ui) => {
    if (!pointDragOffsetRef.current || !hoveredArea) {
      return;
    }
    pointDragChangeRef.current += Math.abs(ui.deltaX) + Math.abs(ui.deltaY);
    const offsetFix = 10;
    const mousePosRelativeToAreaX = newPos.x - hoveredArea.x - pointDragOffsetRef.current.x - offsetFix;
    const mousePosRelativeToAreaY = newPos.y - hoveredArea.y - pointDragOffsetRef.current.y - offsetFix;
    const newPoints = [...hoveredArea.points];
    newPoints[pointDragOffsetRef.current.index].x = mousePosRelativeToAreaX;
    newPoints[pointDragOffsetRef.current.index].y = mousePosRelativeToAreaY;
    const updatedArea = {
      ...hoveredArea,
      points: newPoints
    };
    setHoveredArea(updatedArea);
  };
  const onStopDraggingPoint = (e) => {
    if (pointDragChangeRef.current <= 5) {
      setHandleAnchor({
        anchorEl: pointDragOffsetRef.current.target,
        index: pointDragOffsetRef.current.index,
        action: (index) => removePointFromArea(hoveredArea, index)
      });
      e.stopPropagation();
    } else {
      handleUpdateArea(hoveredArea);
    }
    pointDragChangeRef.current = 0;
    pointDragOffsetRef.current = null;
  };
  const onStartDraggingElementPoint = (element, pointIndex, e, position) => {
    setAddPoint(null);
    setAddElementPoint(null);
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const areaForElement = findObjectByProperty(floorplanAreas, hoveredElement == null ? void 0 : hoveredElement.areaId, "id");
    const mouseOffsetX = e.clientX - canvasRect.left - position.x + element.x + areaForElement.x;
    const mouseOffsetY = e.clientY - canvasRect.top - position.y + element.y + areaForElement.y;
    elementPointDragOffsetRef.current = {
      index: pointIndex,
      target: e.currentTarget,
      x: canvasRect.x + mouseOffsetX,
      y: canvasRect.y + mouseOffsetY
    };
  };
  const onChangeDraggingElementPoint = (newPos, ui) => {
    if (!elementPointDragOffsetRef.current || !hoveredElement) {
      devLog("info", "no element", hoveredElement);
      return;
    }
    elementPointDragChangeRef.current += Math.abs(ui.deltaX) + Math.abs(ui.deltaY);
    const newPoints = [...hoveredElement.points];
    newPoints[elementPointDragOffsetRef.current.index].x = newPos.x - elementPointDragOffsetRef.current.x;
    newPoints[elementPointDragOffsetRef.current.index].y = newPos.y - elementPointDragOffsetRef.current.y;
    setHoveredElement({
      ...hoveredElement,
      points: newPoints
    });
  };
  const onStopDraggingElementPoint = (e) => {
    if (!elementPointDragOffsetRef.current || !hoveredElement) {
      devLog("info", "no element", hoveredElement);
      return;
    }
    if (elementPointDragChangeRef.current <= 5) {
      setHandleAnchor({
        anchorEl: elementPointDragOffsetRef.current.target,
        index: elementPointDragOffsetRef.current.index,
        action: (index) => removePointFromElement(hoveredElement, index)
      });
      e.stopPropagation();
    } else {
      handleUpdateElement(hoveredElement);
    }
    elementPointDragChangeRef.current = 0;
    elementPointDragOffsetRef.current = null;
  };
  const onStartDraggingTable = (e, position, tableSelecting = null) => {
    let newHoveredTable = hoveredTable || hoveredTableRef.current;
    if (!isEmpty(tableSelecting)) {
      newHoveredTable = tableSelecting;
    }
    if (!newHoveredTable || !e || !canvasRef.current) {
      return;
    }
    setAddPoint(null);
    setAddElementPoint(null);
    const tableData = findObjectByProperty(tables == null ? void 0 : tables.data, newHoveredTable == null ? void 0 : newHoveredTable.id, "id");
    const areaForTable = findObjectByProperty(floorplanAreas, tableData == null ? void 0 : tableData.areaId, "id");
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const areaBoundingBox = getBoundsOfShape(
      areaForTable == null ? void 0 : areaForTable.points,
      areaForTable == null ? void 0 : areaForTable.x,
      areaForTable == null ? void 0 : areaForTable.y
    );
    const tableBoundingBox = getBoundsOfTable(
      newHoveredTable,
      tableData == null ? void 0 : tableData.maxSeats,
      areaBoundingBox
    );
    const mouseOffsetX = e.clientX - canvasRect.left - position.x;
    const mouseOffsetY = e.clientY - canvasRect.top - position.y;
    const hoveredTableData = findObjectByProperty(tables == null ? void 0 : tables.data, newHoveredTable == null ? void 0 : newHoveredTable.id, "id");
    const currentX = canvasRect.x + mouseOffsetX + (tableBoundingBox.topLeftX - tableBoundingBox.originX);
    const currentY = canvasRect.y + mouseOffsetY + (tableBoundingBox.topLeftY - tableBoundingBox.originY);
    tableDragOffsetRef.current = {
      x: currentX,
      y: currentY,
      x2: tableBoundingBox.x,
      y2: tableBoundingBox.y,
      initialScrollLeft: scrollRef.current.scrollLeft,
      initialScrollTop: scrollRef.current.scrollTop,
      originalX: currentX,
      // Used if resetting, e.g. dragged to invalid area
      originalY: currentY,
      originalPosition: position,
      table: newHoveredTable,
      tableData: hoveredTableData,
      canvasRect,
      area: findObjectByProperty(floorplanAreas, hoveredTableData == null ? void 0 : hoveredTableData.areaId, "id")
    };
  };
  const onChangeTableDragPos = (newPos, data) => {
    var _a2, _b2, _c2, _d2;
    if (isEmpty(tableDragOffsetRef.current) || isEmpty(selectedTables)) {
      tableDragOffsetRef.current = null;
      return;
    }
    const xDistance = data.x - ((_b2 = (_a2 = tableDragOffsetRef.current) == null ? void 0 : _a2.originalPosition) == null ? void 0 : _b2.x) || 0;
    const yDistance = data.y - ((_d2 = (_c2 = tableDragOffsetRef.current) == null ? void 0 : _c2.originalPosition) == null ? void 0 : _d2.y) || 0;
    tableDragOffsetRef.current.xDifference = xDistance;
    tableDragOffsetRef.current.yDifference = yDistance;
    setDragDistance({
      x: xDistance,
      y: yDistance
    });
    redraw();
  };
  const onStopDraggingTable = (result) => {
    var _a2;
    devLog("debug", "stopped dragging table", result);
    cancelClickRef.current = false;
    const updatedTables = (_a2 = selectedTables.map((tableId) => {
      const tableData = findObjectByProperty(tables == null ? void 0 : tables.data, tableId, "id");
      const floorplanTable = getFloorplanTableFromTableData(floorplanTables, tableData);
      const previousAreaForTable = findObjectByProperty(floorplanAreas, tableData == null ? void 0 : tableData.areaId, "id");
      if (!previousAreaForTable) {
        devLog("error", "Edit floorplan", "Dragged table has no previous area");
        return null;
      }
      let updatedTable = {
        ...floorplanTable,
        x: floorplanTable.x + (dragDistance == null ? void 0 : dragDistance.x) || 0,
        y: floorplanTable.y + (dragDistance == null ? void 0 : dragDistance.y) || 0
      };
      const areaBounds = getBoundsOfShape(
        previousAreaForTable.points,
        previousAreaForTable.x,
        previousAreaForTable.y
      );
      const bounds = getBoundsOfTable(updatedTable, tableData == null ? void 0 : tableData.maxSeats, areaBounds);
      if (!bounds) {
        return null;
      }
      const tablePoint = {
        x: bounds.x + bounds.width / 2,
        y: bounds.y + bounds.height / 2
      };
      const areaForPoint = getAreaForPoint(tablePoint, floorplanAreas, canvasMargin);
      if (areaForPoint === null) {
        devLog("info", "table was moved outside of an area");
        return null;
      }
      if ((areaForPoint == null ? void 0 : areaForPoint.id) !== null && (areaForPoint == null ? void 0 : areaForPoint.id) !== (tableData == null ? void 0 : tableData.areaId)) {
        devLog("info", "table was moved to a different area");
        updatedTable = {
          ...updatedTable,
          x: bounds.originX - areaForPoint.x,
          y: bounds.originY - areaForPoint.y
        };
        updateTableData({ id: updatedTable == null ? void 0 : updatedTable.id, areaId: areaForPoint == null ? void 0 : areaForPoint.id });
      }
      return {
        ...updatedTable,
        x: Math.floor(updatedTable.x),
        y: Math.floor(updatedTable.y)
      };
    })) == null ? void 0 : _a2.filter((table) => table !== null);
    handleUpdateTables(updatedTables);
    tableDragOffsetRef.current = null;
    setDragDistance({ x: 0, y: 0 });
  };
  const onStartResizingTable = (e) => {
    e.stopPropagation();
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const tableData = findObjectByProperty(tables == null ? void 0 : tables.data, hoveredTable == null ? void 0 : hoveredTable.id, "id");
    const areaForTable = findObjectByProperty(floorplanAreas, tableData == null ? void 0 : tableData.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(areaForTable == null ? void 0 : areaForTable.points, areaForTable.x, areaForTable.y);
    const tableBounds = getBoundsOfTable(hoveredTable, tableData == null ? void 0 : tableData.maxSeats, areaBoundingBox);
    setAddPoint(null);
    setAddElementPoint(null);
    tableResizeOffsetRef.current = {
      x: canvasRect.x + tableBounds.x + tableBounds.width,
      y: canvasRect.y,
      previousScale: hoveredTable == null ? void 0 : hoveredTable.scale
    };
  };
  const onChangeResizingTable = (e) => {
    e.stopPropagation();
    if (!tableResizeOffsetRef.current) {
      devLog("info", "Returning early: No resize ref");
      return;
    }
    const minScale = 0.6;
    const tableData = findObjectByProperty(tables == null ? void 0 : tables.data, hoveredTable == null ? void 0 : hoveredTable.id, "id");
    const areaForTable = findObjectByProperty(floorplanAreas, tableData == null ? void 0 : tableData.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(areaForTable == null ? void 0 : areaForTable.points, areaForTable.x, areaForTable.y);
    const tableBounds = getBoundsOfTable(hoveredTable, tableData == null ? void 0 : tableData.maxSeats, areaBoundingBox);
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const newWidth = e.x - tableBounds.x - canvasRect.x;
    const newHeight = e.y - tableBounds.y - canvasRect.y;
    const newWidthScale = Math.max(minScale, newWidth / tableBounds.defaultWidth);
    const newHeightScale = Math.max(minScale, newHeight / tableBounds.defaultHeight);
    const maxScale = 3;
    const newScale = Math.max(newWidthScale, newHeightScale);
    const newHoveredTable = { ...hoveredTable, scale: Math.min(newScale, maxScale) };
    setHoveredTable(newHoveredTable);
    hoveredTableRef.current = newHoveredTable;
  };
  const onStopResizingTable = (e) => {
    e.stopPropagation();
    tableResizeOffsetRef.current = null;
    devLog("info", "stopped resizing table");
    handleUpdateTable(hoveredTable);
  };
  const onStartRotatingTable = (e) => {
    e.stopPropagation();
    const tableData = findObjectByProperty(tables == null ? void 0 : tables.data, hoveredTable == null ? void 0 : hoveredTable.id, "id");
    const areaForTable = findObjectByProperty(floorplanAreas, tableData == null ? void 0 : tableData.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(areaForTable == null ? void 0 : areaForTable.points, areaForTable.x, areaForTable.y);
    const tableBounds = getBoundsOfTable(hoveredTable, tableData == null ? void 0 : tableData.maxSeats, areaBoundingBox);
    const clickPoint = { x: 0, y: 0 };
    const midPoint = { x: tableBounds.width / 2, y: tableBounds.height / 2 };
    const startingAngle = angleBetweenPoints(midPoint, clickPoint);
    setAddPoint(null);
    setAddElementPoint(null);
    tableRotateOffsetRef.current = {
      offsetAngle: startingAngle,
      previousRotation: hoveredTable == null ? void 0 : hoveredTable.rotation
    };
  };
  const onChangeRotatingTable = (e) => {
    e.stopPropagation();
    if (!tableRotateOffsetRef.current) {
      return;
    }
    const tableData = findObjectByProperty(tables == null ? void 0 : tables.data, hoveredTable == null ? void 0 : hoveredTable.id, "id");
    const areaForTable = findObjectByProperty(floorplanAreas, tableData == null ? void 0 : tableData.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(areaForTable == null ? void 0 : areaForTable.points, areaForTable.x, areaForTable.y);
    const tableBounds = getBoundsOfTable(hoveredTable, tableData == null ? void 0 : tableData.maxSeats, areaBoundingBox);
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const newPoint = { x: e.x, y: e.y };
    const midPoint = {
      x: canvasRect.x + tableBounds.x + tableBounds.width / 2,
      y: canvasRect.y + tableBounds.y + tableBounds.height / 2
    };
    const newAngle = angleBetweenPoints(midPoint, newPoint);
    const newRotation = newAngle - tableRotateOffsetRef.current.offsetAngle + tableRotateOffsetRef.current.previousRotation;
    const angleSnap = 15;
    const newHoveredTable = {
      ...hoveredTable,
      rotation: roundToNearest(newRotation, angleSnap)
    };
    setHoveredTable(newHoveredTable);
    hoveredTableRef.current = newHoveredTable;
  };
  const onStopRotatingTable = (e) => {
    e.stopPropagation();
    tableRotateOffsetRef.current = null;
    devLog("info", "stopped rotating table");
    handleUpdateTable({
      ...hoveredTable,
      rotation: parseInt(hoveredTable.rotation, 10)
    });
  };
  const onStartDraggingElement = (e, position) => {
    if (!hoveredElement) {
      return;
    }
    setAddPoint(null);
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const areaForElement = findObjectByProperty(floorplanAreas, hoveredElement == null ? void 0 : hoveredElement.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(
      areaForElement == null ? void 0 : areaForElement.points,
      areaForElement.x,
      areaForElement.y
    );
    const elementBoundingBox = getBoundsOfElement(hoveredElement, areaBoundingBox);
    const mouseOffsetX = e.clientX - canvasRect.left - position.x + (elementBoundingBox.topLeftX - elementBoundingBox.originX);
    const mouseOffsetY = e.clientY - canvasRect.top - position.y + (elementBoundingBox.topLeftY - elementBoundingBox.originY);
    elementDragOffsetRef.current = {
      x: canvasRect.x + mouseOffsetX,
      y: canvasRect.y + mouseOffsetY
    };
  };
  const onChangeElementDragPos = (newPos) => {
    if (!elementDragOffsetRef.current || !hoveredElement) {
      return;
    }
    const areaForElement = findObjectByProperty(floorplanAreas, hoveredElement == null ? void 0 : hoveredElement.areaId, "id");
    const newHoveredElement = { ...hoveredElement };
    newHoveredElement.x = newPos.x - areaForElement.x - elementDragOffsetRef.current.x;
    newHoveredElement.y = newPos.y - areaForElement.y - elementDragOffsetRef.current.y;
    setHoveredElement(newHoveredElement);
  };
  const onStopDraggingElement = () => {
    elementDragOffsetRef.current = null;
    if (!hoveredElement) {
      return;
    }
    const areaForElement = findObjectByProperty(floorplanAreas, hoveredElement == null ? void 0 : hoveredElement.areaId, "id");
    const elementPoint = {
      x: hoveredElement.x + areaForElement.x,
      y: hoveredElement.y + areaForElement.y
    };
    const areaForPoint = getAreaForPoint(elementPoint, floorplanAreas, canvasMargin);
    if (areaForPoint !== null && (areaForPoint == null ? void 0 : areaForPoint.id) !== (hoveredElement == null ? void 0 : hoveredElement.areaId)) {
      const newHoveredElement = {
        ...hoveredElement,
        areaId: areaForPoint.id,
        x: elementPoint.x - areaForPoint.x,
        y: elementPoint.y - areaForPoint.y
      };
      setHoveredElement(newHoveredElement);
      handleUpdateElement(newHoveredElement);
      return;
    }
    if (hoveredElement) {
      handleUpdateElement({
        ...hoveredElement,
        x: Math.floor(hoveredElement.x) + 0.5,
        // Offsetting by half a pixel makes it real crisp for some reason
        y: Math.floor(hoveredElement.y) + 0.5
      });
    }
  };
  const onStartResizingElement = (e) => {
    e.stopPropagation();
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const areaForElement = findObjectByProperty(floorplanAreas, hoveredElement == null ? void 0 : hoveredElement.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(
      areaForElement == null ? void 0 : areaForElement.points,
      areaForElement.x,
      areaForElement.y
    );
    const elementBounds = getBoundsOfElement(hoveredElement, areaBoundingBox);
    setAddPoint(null);
    setAddElementPoint(null);
    elementResizeOffsetRef.current = {
      x: canvasRect.x + elementBounds.x + elementBounds.width,
      y: canvasRect.y,
      previousXScale: 1,
      previousYScale: 1,
      previousBounds: elementBounds,
      previousWidth: elementBounds == null ? void 0 : elementBounds.width,
      previousHeight: elementBounds == null ? void 0 : elementBounds.height,
      previousPoints: elementBounds.points,
      previousX: elementBounds.x,
      previousOriginX: elementBounds.originX
    };
  };
  const onChangeResizingElement = (e) => {
    e.stopPropagation();
    if (!elementResizeOffsetRef.current) {
      return;
    }
    const areaForElement = findObjectByProperty(floorplanAreas, hoveredElement == null ? void 0 : hoveredElement.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(
      areaForElement == null ? void 0 : areaForElement.points,
      areaForElement.x,
      areaForElement.y
    );
    const elementBounds = getBoundsOfElement(hoveredElement, areaBoundingBox);
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const newWidth = e.x - elementBounds.x - canvasRect.x;
    const newHeight = e.y - elementBounds.y - canvasRect.y;
    const newWidthScale = Math.max(0.1, newWidth / elementResizeOffsetRef.current.previousWidth);
    const newHeightScale = Math.max(0.1, newHeight / elementResizeOffsetRef.current.previousHeight);
    const scaledPoints = elementResizeOffsetRef.current.previousPoints.map((point) => ({
      x: point.x * newWidthScale,
      y: point.y * newHeightScale
    }));
    const newImageWidth = distanceBetween(scaledPoints[0], scaledPoints[1]);
    const newImageHeight = distanceBetween(scaledPoints[0], scaledPoints[2]);
    const minSize = 25;
    const updatedElement = {
      ...hoveredElement,
      width: Math.max(minSize, newImageWidth),
      height: Math.max(minSize, newImageHeight)
    };
    const xMovement = elementResizeOffsetRef.current.previousBounds.topLeftX - elementBounds.topLeftX;
    const yMovement = elementResizeOffsetRef.current.previousBounds.topLeftY - elementBounds.topLeftY;
    setHoveredElement({
      ...updatedElement,
      x: hoveredElement.x + xMovement,
      y: hoveredElement.y + yMovement
    });
  };
  const onStopResizingElement = (e) => {
    e.stopPropagation();
    elementResizeOffsetRef.current = null;
    devLog("info", "stopped resizing element");
    handleUpdateElement(hoveredElement);
  };
  const onStartRotatingElement = (e) => {
    e.stopPropagation();
    const areaForElement = findObjectByProperty(floorplanAreas, hoveredElement == null ? void 0 : hoveredElement.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(
      areaForElement == null ? void 0 : areaForElement.points,
      areaForElement.x,
      areaForElement.y
    );
    const elementBounds = getBoundsOfElement(hoveredElement, areaBoundingBox);
    const clickPoint = { x: 0, y: 0 };
    const midPoint = { x: elementBounds.width / 2, y: elementBounds.height / 2 };
    const startingAngle = angleBetweenPoints(midPoint, clickPoint);
    devLog("info", "starting angle", { startingAngle, clickPoint, midPoint });
    setAddPoint(null);
    setAddElementPoint(null);
    elementRotateOffsetRef.current = {
      offsetAngle: startingAngle,
      previousRotation: hoveredElement == null ? void 0 : hoveredElement.rotation
    };
  };
  const onChangeRotatingElement = (e) => {
    e.stopPropagation();
    if (!elementRotateOffsetRef.current) {
      return;
    }
    const areaForElement = findObjectByProperty(floorplanAreas, hoveredElement == null ? void 0 : hoveredElement.areaId, "id");
    const areaBoundingBox = getBoundsOfShape(
      areaForElement == null ? void 0 : areaForElement.points,
      areaForElement.x,
      areaForElement.y
    );
    const elementBounds = getBoundsOfElement(hoveredElement, areaBoundingBox);
    const canvasRect = canvasRef.current.getBoundingClientRect();
    const newPoint = { x: e.x, y: e.y };
    const midPoint = {
      x: canvasRect.x + elementBounds.x + elementBounds.width / 2,
      y: canvasRect.y + elementBounds.y + elementBounds.height / 2
    };
    const newAngle = angleBetweenPoints(midPoint, newPoint);
    const newRotation = newAngle - elementRotateOffsetRef.current.offsetAngle + elementRotateOffsetRef.current.previousRotation;
    const angleSnap = 5;
    devLog("info", "new rotation", {
      newRotation,
      elementRotateOffsetRef: elementRotateOffsetRef.current
    });
    const updatedElement = {
      ...hoveredElement,
      rotation: roundToNearest(newRotation, angleSnap)
    };
    const newElementBounds = getBoundsOfElement(updatedElement, areaBoundingBox);
    devLog("info", "origin distance", newElementBounds);
    setHoveredElement({
      ...updatedElement
      // x: newElementBounds.originX,
      // y: newElementBounds.originY,
    });
  };
  const onStopRotatingElement = (e) => {
    e.stopPropagation();
    elementRotateOffsetRef.current = null;
    devLog("info", "stopped rotating element");
    handleUpdateElement({
      ...hoveredElement,
      rotation: parseInt(hoveredElement.rotation, 10)
    });
  };
  const onChangeElementText = (newValue) => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const textWidth = context.measureText(newValue || "Start typing...").width + 40;
    devLog("info", "text width", textWidth);
    setHoveredElement({
      ...hoveredElement,
      text: newValue,
      width: textWidth
    });
  };
  const renderAreaDraggables = () => {
    const offset = 50;
    const areasToShow = floorplanAreas.filter(
      (floorplanArea) => (floorplanArea == null ? void 0 : floorplanArea.id) === (hoveredArea == null ? void 0 : hoveredArea.id)
    );
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, areasToShow == null ? void 0 : areasToShow.map((floorplanArea) => {
      const areaBoundingBox = getBoundsOfShape(
        floorplanArea == null ? void 0 : floorplanArea.points,
        floorplanArea.x,
        floorplanArea.y
      );
      const bottomRightPointOfRectangle = {
        x: areaBoundingBox.width,
        y: areaBoundingBox.height
      };
      let bestDistance = 99999;
      const closestPointToBottomRight = floorplanArea.points.reduce(
        (accum, point) => {
          const distance = distanceBetween(point, bottomRightPointOfRectangle);
          if (distance < bestDistance) {
            bestDistance = distance;
            return point;
          }
          return accum;
        },
        floorplanArea.points[floorplanArea.points.length - 1]
      );
      const leftPos = floorplanArea.x + closestPointToBottomRight.x + canvasMargin - offset;
      const topPos = floorplanArea.y + closestPointToBottomRight.y + canvasMargin - offset;
      return /* @__PURE__ */ React__default.createElement(
        ReactDraggable,
        {
          key: floorplanArea.id,
          bounds: "parent",
          position: { x: leftPos, y: topPos },
          onDrag: onChangeDragPos,
          onStart: onStartDragging,
          onStop: onStopDragging
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.dragButton }, /* @__PURE__ */ React__default.createElement(DragIconSVG, { className: classes.dragIcon }))
      );
    }));
  };
  const renderResizeHandle = () => {
    const offset = 0;
    if (hoveredArea === null || !(hoveredArea == null ? void 0 : hoveredArea.isRectangle)) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
    }
    const floorplanArea = hoveredArea;
    const draggablePoint = floorplanArea == null ? void 0 : floorplanArea.points[2];
    const leftPos = floorplanArea.x + draggablePoint.x + canvasMargin - offset;
    const topPos = floorplanArea.y + draggablePoint.y + canvasMargin - offset;
    return /* @__PURE__ */ React__default.createElement(
      ReactDraggable,
      {
        bounds: "parent",
        position: { x: leftPos, y: topPos },
        onDrag: onChangeResizing,
        onStart: onStartResizing,
        onStop: onStopResizing,
        grid: isHoldingShift.current ? [25, 25] : null
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.resizeIconContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.resizeIcon }))
    );
  };
  const renderDraggableCornerHandles = () => {
    const offset = 0;
    if (hoveredArea === null || (hoveredArea == null ? void 0 : hoveredArea.isRectangle)) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
    }
    const floorplanArea = hoveredArea;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, floorplanArea.points.map((point, index) => {
      const leftPos = floorplanArea.x + point.x + canvasMargin - offset;
      const topPos = floorplanArea.y + point.y + canvasMargin - offset;
      return /* @__PURE__ */ React__default.createElement(
        ReactDraggable,
        {
          bounds: "parent",
          position: { x: leftPos, y: topPos },
          onStart: (e) => onStartDraggingPoint(index, e),
          onDrag: onChangeDraggingPoint,
          onStop: onStopDraggingPoint,
          grid: isHoldingShift.current ? [25, 25] : null
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.resizeIconContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.resizeIcon }))
      );
    }));
  };
  const onTableDragStop = (e, position, tableType, offset) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const droppedPositionOnCanvas = {
      x: e.x - rect.x - offset.x,
      y: e.y - rect.y - offset.y
    };
    const draggedArea = getAreaForPoint(droppedPositionOnCanvas, floorplanAreas, canvasMargin);
    if (!draggedArea) {
      return;
    }
    const droppedPositionOnArea = {
      x: droppedPositionOnCanvas.x - draggedArea.x,
      y: droppedPositionOnCanvas.y - draggedArea.y
    };
    if (tableType === "round") {
      droppedPositionOnArea.x += 44;
      droppedPositionOnArea.y += 44;
    }
    tableCount.current += 1;
    handleCreateTable(tableType, draggedArea.id, droppedPositionOnArea.x, droppedPositionOnArea.y);
  };
  const onElementDragStop = (e, position, type2, offset) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const droppedPositionOnCanvas = {
      x: e.x - rect.x - offset.x - 10,
      y: e.y - rect.y - offset.y - 10
    };
    const draggedArea = getAreaForPoint(droppedPositionOnCanvas, floorplanAreas, canvasMargin);
    if (!draggedArea) {
      return;
    }
    const droppedPositionOnArea = {
      x: droppedPositionOnCanvas.x - draggedArea.x,
      y: droppedPositionOnCanvas.y - draggedArea.y
    };
    let overrides = {};
    if (type2 === "line") {
      overrides = {
        points: [
          { x: 0, y: 0 },
          { x: 100, y: 0 }
        ]
      };
    }
    handleCreateElement(
      type2,
      draggedArea.id,
      droppedPositionOnArea.x,
      droppedPositionOnArea.y,
      overrides
    );
  };
  const selectTable = (tableId, e, replaceOthers = false) => {
    setEditingElement(null);
    const isSelected = selectedTables == null ? void 0 : selectedTables.includes(tableId);
    if ((replaceOthers || !isSelected) && !isHoldingShift.current) {
      devLog("info", "not holding shift");
      setSelectedElements([]);
      setSelectedTables([tableId]);
      setJoinAnchor(null);
      setShowUnjoinModal(false);
      setAlignmentAnchor(null);
      return;
    }
    if (selectedElements.length > 0) {
      devLog("info", "cant select table when elements are selected", selectedElements);
      return;
    }
    let newSelectedTables;
    if (!(selectedTables == null ? void 0 : selectedTables.includes(tableId))) {
      newSelectedTables = [...selectedTables, tableId];
    } else {
      newSelectedTables = selectedTables.filter((id) => id !== tableId);
    }
    setSelectedTables(newSelectedTables);
    if (newSelectedTables.length > 1) {
      setAlignmentAnchor(e == null ? void 0 : e.target);
    } else {
      setJoinAnchor(null);
      setShowUnjoinModal(false);
      setAlignmentAnchor(null);
    }
  };
  const selectElement = (elementId) => {
    if (!isHoldingShift.current) {
      unstable_batchedUpdates(() => {
        setSelectedTables([]);
        setSelectedElements([elementId]);
        setEditingElement(null);
      });
      return;
    }
    if (selectedTables.length > 0) {
      devLog("info", "cant select element when tables are selected", selectedTables);
      return;
    }
    let newSelectedElements = [];
    if (selectedElements == null ? void 0 : selectedElements.includes(elementId)) {
      newSelectedElements = selectedElements.filter((id) => id !== elementId);
    } else {
      newSelectedElements = [...selectedElements, elementId];
    }
    unstable_batchedUpdates(() => {
      setEditingElement(null);
      setSelectedElements(newSelectedElements);
      setEditingElement(null);
    });
  };
  const renderTableNames = () => {
    const offset = 5;
    const canMove = !(resizeOffsetRef.current || tableRotateOffsetRef.current || tableDragOffsetRef.current || tableRotateOffsetRef.current);
    const hasSelectedTable = isHoldingShift.current && activeTable;
    const canLeave = canMove && !tableAnchor;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, floorplanAreas == null ? void 0 : floorplanAreas.map((floorplanArea) => {
      const activeArea = (floorplanArea == null ? void 0 : floorplanArea.id) === (hoveredArea == null ? void 0 : hoveredArea.id) ? hoveredArea : floorplanArea;
      const tableDataForArea = tables == null ? void 0 : tables.data.filter((table) => !table.isJoin).filter((table) => (table == null ? void 0 : table.areaId) === (activeArea == null ? void 0 : activeArea.id));
      const areaBounds = getBoundsOfShape(activeArea.points, activeArea.x, activeArea.y);
      return tableDataForArea.map((tableData) => {
        const floorplanTable = getFloorplanTableFromTableData(floorplanTables, tableData);
        const isHovered = (hoveredTable == null ? void 0 : hoveredTable.id) === (floorplanTable == null ? void 0 : floorplanTable.id);
        const tableToUse = isHovered ? hoveredTable : floorplanTable;
        if (!tableToUse || !tableData) {
          devLog("warning", "table isn't in the floor plan for whatever reason", {
            floorplanTable,
            tableData
          });
          return /* @__PURE__ */ React__default.createElement("div", null);
        }
        const bounds = getBoundsOfTable(floorplanTable, tableData == null ? void 0 : tableData.maxSeats, areaBounds);
        const resizeBounds = isHovered ? getBoundsOfTable(hoveredTable, tableData == null ? void 0 : tableData.maxSeats, areaBounds) : bounds;
        const showActionMenu = !isHoldingShift.current && (floorplanTable == null ? void 0 : floorplanTable.id) === (hoveredTable == null ? void 0 : hoveredTable.id) && selectedTables.length < 2;
        const isSelected = selectedTables == null ? void 0 : selectedTables.includes(floorplanTable == null ? void 0 : floorplanTable.id);
        const position = isSelected ? {
          x: bounds.topLeftX + dragDistance.x,
          y: bounds.topLeftY + dragDistance.y
        } : { x: bounds.topLeftX, y: bounds.topLeftY };
        return /* @__PURE__ */ React__default.createElement(
          TouchDraggable$1,
          {
            key: floorplanTable.id,
            bounds: ".canvas-container",
            position,
            cancel: ".table-action-icon",
            onStart: (e, data) => {
              onStartDraggingTable(e, data);
            },
            onInitialPress: (e) => {
              if (!(selectedTables == null ? void 0 : selectedTables.includes(floorplanTable.id))) {
                cancelClickRef.current = true;
                selectTable(floorplanTable.id, e, true);
              }
              setHoveredArea(floorplanArea);
              setHoveredTable(floorplanTable);
              hoveredTableRef.current = floorplanTable;
            },
            onDrag: (e, data) => {
              onChangeTableDragPos(e, data);
            },
            onStopPressing: onStopDraggingTable,
            nodeRef,
            grid: isHoldingShift.current ? [25, 25] : null,
            holdTime: 200,
            onClick: (e) => {
              isHoldingShift.current = e.shiftKey;
              setHoveredTable(floorplanTable);
              hoveredTableRef.current = floorplanTable;
              if (!cancelClickRef.current) {
                selectTable(floorplanTable.id, e, true);
              }
            }
          },
          /* @__PURE__ */ React__default.createElement(
            Box,
            {
              ref: nodeRef,
              onMouseEnter: () => {
                if (canMove) {
                  devLog("info", "hovering table from mouse");
                  setHoveredTable(floorplanTable);
                  hoveredTableRef.current = floorplanTable;
                  if (!hasSelectedTable) {
                    setActiveTable(floorplanTable);
                  }
                }
              },
              onMouseLeave: () => {
                if (canLeave) {
                  setHoveredTable(null);
                  setActiveTable(null);
                  hoveredTableRef.current = null;
                }
              },
              className: classes.tableLabelContainer,
              style: {
                zIndex: isHovered ? 99 : 0,
                left: 0,
                top: 0,
                width: bounds.width || 100,
                height: bounds.height || 100
              }
            },
            /* @__PURE__ */ React__default.createElement(
              Box,
              {
                className: classes.tableLabel,
                style: { backgroundColor: theme2.colors.linen }
              },
              tableData == null ? void 0 : tableData.tableNumber
            ),
            /* @__PURE__ */ React__default.createElement(
              Box,
              {
                type: "icon",
                className: `table-action-icon ${classes.tableActionButton}`,
                style: {
                  opacity: showActionMenu ? 1 : 0,
                  pointerEvents: showActionMenu ? "auto" : "none"
                },
                onClick: (e) => {
                  isHoldingShift.current = e.shiftKey;
                  if (isHoldingShift.current) {
                    return;
                  }
                  setTableEditing(floorplanTable);
                  setTableAnchor(e.currentTarget);
                }
              },
              /* @__PURE__ */ React__default.createElement(ActionMenuIconSVG, { className: classes.actionIcon })
            ),
            (hoveredTable == null ? void 0 : hoveredTable.id) === (floorplanTable == null ? void 0 : floorplanTable.id) && /* @__PURE__ */ React__default.createElement(
              ReactDraggable,
              {
                position: {
                  x: resizeBounds.width - offset,
                  y: resizeBounds.height - offset
                },
                onStart: (e) => onStartResizingTable(e),
                onDrag: (e) => onChangeResizingTable(e),
                onStop: (e) => onStopResizingTable(e)
              },
              /* @__PURE__ */ React__default.createElement(
                Box,
                {
                  className: classes.tableResizeIconContainer
                },
                /* @__PURE__ */ React__default.createElement(
                  Box,
                  {
                    className: classes.tableResizeIcon,
                    style: { cursor: "nwse-resize" }
                  }
                )
              )
            ),
            isHovered && /* @__PURE__ */ React__default.createElement(
              ReactDraggable,
              {
                position: {
                  x: 0 - offset,
                  y: 0 - offset
                },
                onStart: (e) => onStartRotatingTable(e),
                onDrag: (e) => onChangeRotatingTable(e),
                onStop: (e) => onStopRotatingTable(e)
              },
              /* @__PURE__ */ React__default.createElement(Box, { className: classes.rotateIconContainer }, /* @__PURE__ */ React__default.createElement(RotateSVG, { style: { marginTop: "5px", width: "13px" } }))
            )
          )
        );
      });
    }));
  };
  const renderElementInteractables = () => {
    const offset = 5;
    const canMove = !(resizeOffsetRef.current || elementRotateOffsetRef.current || elementDragOffsetRef.current || elementResizeOffsetRef.current || elementPointDragOffsetRef.current || editingElement);
    const hasSelectedElement = isHoldingShift.current && activeElement;
    const canLeave = canMove;
    return /* @__PURE__ */ React__default.createElement(Box, null, floorplanAreas == null ? void 0 : floorplanAreas.map((floorplanArea) => {
      const activeArea = (floorplanArea == null ? void 0 : floorplanArea.id) === (hoveredArea == null ? void 0 : hoveredArea.id) ? hoveredArea : floorplanArea;
      const elementsForArea = floorplanElements == null ? void 0 : floorplanElements.filter(
        (element) => (element == null ? void 0 : element.areaId) === (activeArea == null ? void 0 : activeArea.id)
      );
      const areaBounds = getBoundsOfShape(activeArea.points, activeArea.x, activeArea.y);
      return elementsForArea.map((element) => {
        const elementToUse = (element == null ? void 0 : element.id) === (hoveredElement == null ? void 0 : hoveredElement.id) ? hoveredElement : element;
        if (!elementToUse) {
          return /* @__PURE__ */ React__default.createElement(Box, { key: element == null ? void 0 : element.id });
        }
        const bounds = getBoundsOfElement(elementToUse, areaBounds);
        const isText = (element == null ? void 0 : element.type) === "text";
        const isLine = (element == null ? void 0 : element.type) === "line";
        const canResize = (hoveredElement == null ? void 0 : hoveredElement.id) === (element == null ? void 0 : element.id) && !isText && !isLine;
        const canRotate = (hoveredElement == null ? void 0 : hoveredElement.id) === (element == null ? void 0 : element.id) && !isLine;
        const isEditing = (editingElement == null ? void 0 : editingElement.id) === (element == null ? void 0 : element.id);
        const canSelect = !isLine;
        const showTextEdit = () => {
          return isText && selectedElements.length === 1 && selectedElements[0] === (element == null ? void 0 : element.id);
        };
        if ((element == null ? void 0 : element.type) === "line") {
          return /* @__PURE__ */ React__default.createElement(Box, { key: element == null ? void 0 : element.id }, element.points.map((point, index) => {
            const leftPos = bounds.x + point.x;
            const topPos = bounds.y + point.y;
            return /* @__PURE__ */ React__default.createElement(
              TouchDraggable$1,
              {
                position: { x: leftPos, y: topPos },
                onStart: (e, position) => onStartDraggingElementPoint(element, index, e, position),
                onDrag: (e, ui) => onChangeDraggingElementPoint(e, ui),
                onStop: onStopDraggingElementPoint,
                onClick: onStopDraggingElementPoint
              },
              /* @__PURE__ */ React__default.createElement(
                Box,
                {
                  className: classes.resizeIconContainer,
                  onMouseEnter: () => {
                    if (canMove) {
                      setHoveredElement(element);
                    }
                  },
                  onMouseLeave: () => {
                    if (canLeave) {
                      setHoveredElement(null);
                    }
                  }
                },
                /* @__PURE__ */ React__default.createElement(Box, { className: classes.resizeIcon })
              )
            );
          }));
        }
        return /* @__PURE__ */ React__default.createElement(
          TouchDraggable$1,
          {
            key: element == null ? void 0 : element.id,
            bounds: ".canvas-container",
            position: { x: bounds.topLeftX, y: bounds.topLeftY },
            cancel: ".element-action-icon",
            onStart: (e, position) => !isEditing && onStartDraggingElement(e, position),
            onDrag: (e, position) => !isEditing && onChangeElementDragPos(e),
            onStopPressing: onStopDraggingElement
          },
          /* @__PURE__ */ React__default.createElement(
            Box,
            {
              onMouseOver: () => {
                if (canMove) {
                  setHoveredElement(element);
                  if (!hasSelectedElement) {
                    setActiveElement(element);
                  }
                }
              },
              onMouseLeave: () => {
                if (canLeave) {
                  setHoveredElement(null);
                  setActiveElement(null);
                }
              },
              className: classes.tableLabelContainer,
              style: {
                left: 0,
                top: 0,
                width: bounds.width,
                height: bounds.height,
                cursor: showTextEdit() ? "text" : "default"
              },
              onClick: (e) => {
                e.stopPropagation();
                if ((editingElement == null ? void 0 : editingElement.id) === (element == null ? void 0 : element.id)) {
                  return;
                }
                if (showTextEdit()) {
                  setEditingElement(element);
                } else if (canSelect) {
                  selectElement(element.id);
                }
              }
            },
            canResize && /* @__PURE__ */ React__default.createElement(
              ReactDraggable,
              {
                position: {
                  x: bounds.width - offset,
                  y: bounds.height - offset
                },
                onStart: (e) => !isEditing && onStartResizingElement(e),
                onDrag: (e) => !isEditing && onChangeResizingElement(e),
                onStop: (e) => onStopResizingElement(e),
                style: { zIndex: 50 }
              },
              /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableResizeIconContainer }, /* @__PURE__ */ React__default.createElement(
                Box,
                {
                  className: classes.tableResizeIcon,
                  style: { cursor: "nwse-resize" }
                }
              ))
            ),
            canRotate && /* @__PURE__ */ React__default.createElement(
              ReactDraggable,
              {
                position: {
                  x: 0 - offset,
                  y: 0 - offset
                },
                onStart: (e) => onStartRotatingElement(e),
                onDrag: (e) => onChangeRotatingElement(e),
                onStop: (e) => onStopRotatingElement(e),
                style: { zIndex: 50 }
              },
              /* @__PURE__ */ React__default.createElement(Box, { className: classes.rotateIconContainer }, /* @__PURE__ */ React__default.createElement(RotateSVG, { style: { marginTop: "5px", width: "13px" } }))
            ),
            (editingElement == null ? void 0 : editingElement.id) === element.id && /* @__PURE__ */ React__default.createElement(Box, { className: classes.textElementInputContainer }, /* @__PURE__ */ React__default.createElement(
              CanvasTextField$1,
              {
                value: elementToUse == null ? void 0 : elementToUse.text,
                style: { container: { width: hoveredElement == null ? void 0 : hoveredElement.width } },
                placeholder: "Start typing...",
                onChange: onChangeElementText,
                onBlur: () => handleUpdateElement(hoveredElement),
                autofocus: true
              }
            ))
          )
        );
      });
    }));
  };
  const renderAddPoint = () => {
    if (!hoveredArea || !addPoint) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
    }
    return /* @__PURE__ */ React__default.createElement(
      Box,
      {
        onClick: () => {
          addPointToArea(hoveredArea, addPoint.point, addPoint.index);
          setAddPoint(null);
          setAddElementPoint(null);
        },
        style: {
          cursor: "pointer",
          backgroundColor: theme2.colors.charcoal,
          position: "absolute",
          width: "18px",
          height: "18px",
          borderRadius: "20px",
          left: hoveredArea.x + addPoint.point.x,
          top: hoveredArea.y + addPoint.point.y,
          border: `2px solid ${theme2.colors.olive3}`,
          color: "white",
          alignItems: "center",
          textAlign: "center"
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { style: { marginTop: "-6px" } }, /* @__PURE__ */ React__default.createElement(PlusRoundSVG, { style: { width: "9px" } }))
    );
  };
  const renderAddElementPoint = () => {
    if (!hoveredArea || !addElementPoint) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
    }
    const element = findObjectByProperty(floorplanElements, addElementPoint.elementId, "id");
    const leftPos = hoveredArea.x + element.x + addElementPoint.point.x;
    const topPos = hoveredArea.y + element.y + addElementPoint.point.y;
    return /* @__PURE__ */ React__default.createElement(
      ReactDraggable,
      {
        position: { x: leftPos, y: topPos },
        onStart: (e, position) => onStartDraggingElement(e, position),
        onDrag: (e, position) => onChangeElementDragPos(e),
        onStop: onStopDraggingElement
      },
      /* @__PURE__ */ React__default.createElement(
        Box,
        {
          onClick: () => {
            addPointToElement(element, addElementPoint.point, addElementPoint.index);
            setAddElementPoint(null);
          },
          style: {
            cursor: "pointer",
            backgroundColor: theme2.colors.charcoal,
            position: "absolute",
            width: "18px",
            height: "18px",
            borderRadius: "20px",
            left: 0,
            top: 0,
            // left: leftPos,
            // top: topPos,
            border: `2px solid ${theme2.colors.olive3}`,
            color: "white",
            alignItems: "center",
            textAlign: "center"
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { style: { marginTop: "-3px" } }, /* @__PURE__ */ React__default.createElement(PlusRoundSVG, { style: { width: "9px" } }))
      )
    );
  };
  const getTableEditingData = () => {
    if (!tableEditing) {
      return null;
    }
    return findObjectByProperty(tables == null ? void 0 : tables.data, tableEditing == null ? void 0 : tableEditing.id, "id");
  };
  const getAreaEditingData = () => {
    if (!areaEditing) {
      return null;
    }
    return findObjectByProperty(areas == null ? void 0 : areas.data, areaEditing == null ? void 0 : areaEditing.id, "id");
  };
  const popoverStyles2 = {
    popover: {
      marginTop: "10px",
      padding: "10px",
      borderRadius: "8px",
      marginLeft: "20px"
    },
    item: {
      fontSize: "16px",
      color: theme2.colors.grayLight,
      padding: "10px",
      height: "auto"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, null, emptyObject(floorplanData) ? /* @__PURE__ */ React__default.createElement(Box, null, "Loading") : /* @__PURE__ */ React__default.createElement(Box, { ref: scrollRef, className: `floorplanPageContent ${classes.pageContent}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sidebar }, showTableMenu && /* @__PURE__ */ React__default.createElement(TableMenu$1, { onStopDraggingItem: onTableDragStop }), showElementMenu && /* @__PURE__ */ React__default.createElement(ElementMenu$1, { onStopDraggingItem: onElementDragStop })), /* @__PURE__ */ React__default.createElement(Box, { className: `canvas-container ${classes.canvasContainer}` }, /* @__PURE__ */ React__default.createElement(
    Canvas,
    {
      className: classes.canvas,
      draw,
      canvasRef,
      width: canvasWidth + 200,
      height: canvasHeight + 200,
      onMouseMove: handleMouseOnCanvas,
      onClick: (e) => {
        handleMouseOnCanvas(e);
        isHoldingShift.current = e.shiftKey;
        if (!isHoldingShift.current) {
          setSelectedTables([]);
          setSelectedElements([]);
          setEditingElement(null);
        }
      }
    }
  ), renderAreaNames(), renderAreaDraggables(), renderAddPoint(), renderAddElementPoint(), renderElementInteractables(), renderTableNames(), renderResizeHandle(), renderDraggableCornerHandles(), /* @__PURE__ */ React__default.createElement(
    AreaProperties$1,
    {
      areaData: getAreaEditingData(),
      floorplanArea: areaEditing,
      anchor: areaAnchor,
      onClose: () => {
        setAreaAnchor(null);
      },
      onDelete: () => {
        setHoveredArea(null);
      },
      showDeleteModal: () => setShowDeleteAreaModal(true),
      tables: tables.data
    }
  ), /* @__PURE__ */ React__default.createElement(
    TableProperties$1,
    {
      floorplanTable: tableEditing,
      tableData: getTableEditingData(),
      anchor: tableAnchor,
      showDeleteModal: () => {
        setTablesToDelete([tableEditing == null ? void 0 : tableEditing.id]);
        setShowDeleteTableModal(true);
        setTableAnchor(null);
      },
      onClose: () => {
        unstable_batchedUpdates(() => {
          setHoveredTable(null);
          setTableAnchor(null);
          setAreaAnchor(null);
          hoveredTableRef.current = null;
        });
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    EnableJoin$1,
    {
      onClose: () => setJoinAnchor(null),
      anchor: joinAnchor,
      selectedTableIds: selectedTables
    }
  ), /* @__PURE__ */ React__default.createElement(
    UnjoinTablesModal$1,
    {
      isOpen: showUnjoinModal,
      onClose: () => setShowUnjoinModal(false),
      tableIds: selectedTables
    }
  ), /* @__PURE__ */ React__default.createElement(
    AlignmentToolbar$1,
    {
      anchor: alignmentAnchor,
      selectedTableIds: selectedTables,
      floorplanTables,
      updateTables: handleUpdateTables,
      setJoinAnchor,
      showEnableJoinModal: setJoinAnchor,
      showDisableJoinModal: () => setShowUnjoinModal(true),
      deleteTables: () => {
        setTablesToDelete([...selectedTables]);
        setShowDeleteTableModal(true);
        setSelectedTables([]);
        setTableAnchor(null);
        setJoinAnchor(null);
        hoveredTableRef.current = null;
        setHoveredTable(null);
      },
      onClose: () => {
        unstable_batchedUpdates(() => {
          setHoveredTable(null);
          setTableAnchor(null);
          setAreaAnchor(null);
          setJoinAnchor(null);
          setSelectedTables([]);
          hoveredTableRef.current = null;
        });
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      isOpen: !!(handleAnchor == null ? void 0 : handleAnchor.anchorEl),
      onClose: () => setHandleAnchor(null),
      anchor: handleAnchor == null ? void 0 : handleAnchor.anchorEl,
      style: popoverStyles2,
      items: [
        {
          value: "remove",
          onClick: () => {
            handleAnchor == null ? void 0 : handleAnchor.action(handleAnchor == null ? void 0 : handleAnchor.index);
            setHandleAnchor(null);
          },
          label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.dropdownContent }, /* @__PURE__ */ React__default.createElement(Box, null, "Remove"))
        }
      ]
    }
  )), /* @__PURE__ */ React__default.createElement(
    DeleteTableModal$1,
    {
      isOpen: showDeleteTableModal,
      floorplanTables: tablesToDelete,
      onClose: () => setShowDeleteTableModal(false),
      onDelete: () => handleDeleteTables(tablesToDelete),
      table: getTableDataFromId(tablesToDelete == null ? void 0 : tablesToDelete[0], tables.data)
    }
  ), /* @__PURE__ */ React__default.createElement(
    DeleteAreaModal$1,
    {
      isOpen: showDeleteAreaModal,
      floorplanArea: areaEditing,
      area: getAreaDataFromFloorplanArea(areaEditing, areas.data),
      onClose: () => setShowDeleteAreaModal(false)
    }
  )));
};
EditFloorplanMap.defaultProps = {
  showSidebar: false,
  showTableMenu: false,
  showElementMenu: false
};
EditFloorplanMap.propTypes = {
  areas: areasPropTypes.isRequired,
  tables: tablesPropTypes.isRequired,
  createLocalTable: PropTypes.func.isRequired,
  deleteLocalTables: PropTypes.func.isRequired,
  showSidebar: PropTypes.bool,
  showTableMenu: PropTypes.bool,
  showElementMenu: PropTypes.bool,
  floorplanData: floorplanDataPropTypes.isRequired,
  updateLocalFloorplan: PropTypes.func.isRequired,
  updateLocalTable: PropTypes.func.isRequired,
  undoFloorplanUpdate: PropTypes.func.isRequired,
  redoFloorplanUpdate: PropTypes.func.isRequired
};
const mapStateToProps$17 = (state) => ({
  areas: state.areas,
  tables: state.tables
  // levels: state.levels,
});
const mapDispatchToProps$16 = (dispatch) => bindActionCreators(
  {
    updateLocalArea: updateLocalAreaAction,
    updateLocalTable: updateLocalTableAction,
    createLocalTable: createLocalTableAction,
    deleteLocalTables: deleteLocalTablesAction,
    updateLocalFloorplan: updateLocalFloorplanAction,
    undoFloorplanUpdate: undoFloorplanUpdateAction,
    redoFloorplanUpdate: redoFloorplanUpdateAction
  },
  dispatch
);
const EditFloorplanMap$1 = connect(mapStateToProps$17, mapDispatchToProps$16)(EditFloorplanMap);
const CleanSquareButton = ({ children, style, onClick, ...other }) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "standard",
      style: {
        ...style,
        button: {
          backgroundColor: "transparent",
          padding: "9px 14px",
          border: "1px solid transparent",
          borderRadius: "6px",
          fontWeight: "400",
          boxShadow: "none",
          color: theme2.colors.smoke,
          // eslint-disable-next-line react/prop-types
          ...style == null ? void 0 : style.button
        },
        buttonHover: {
          backgroundColor: "white",
          border: `1px solid ${theme2.colors.charcoal}`,
          color: theme2.colors.buttonText,
          filter: "none"
        },
        buttonActive: {
          backgroundColor: "white",
          border: `1px solid ${theme2.colors.charcoal}`,
          color: theme2.colors.buttonText,
          filter: "none"
        }
      },
      onClick,
      ...other
    },
    children
  );
};
CleanSquareButton.defaultProps = {
  children: null,
  style: {},
  onClick: () => {
  }
};
CleanSquareButton.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({}),
  onClick: PropTypes.func
};
const useStyles$C = createUseStyles((theme2) => ({
  toolbar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    padding: "0 32px 12px 32px",
    // borderBottom: `1px solid ${theme.colors.shark}`,
    height: "68px",
    backgroundColor: theme2.colors.linen
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    alignItems: "center"
  },
  buttonContent: {
    display: "flex",
    gap: "6px",
    alignItems: "center"
  },
  downArrow: {
    width: "11px",
    marginTop: "2px"
  },
  dropdownContent: {
    display: "flex",
    gap: "14px",
    alignItems: "center"
  }
}));
const SvgOutside = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 51 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 0.5, width: 50, height: 29, rx: 3.5, stroke: "currentColor", strokeDasharray: "2 2" }));
const OutsideIconSVG = SvgOutside;
const SvgInside = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 51 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 0.5, width: 50, height: 29, rx: 3.5, stroke: "currentColor" }));
const InsideIconSVG = SvgInside;
const Toolbar = ({
  createLocalArea,
  floorplan,
  onClickTable,
  onClickElement,
  setActiveTab,
  activeTab,
  updateLocalFloorplan,
  bookingsDuration,
  showTableMenu,
  showElementMenu
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$C();
  const [addAreaAnchor, setAddAreaAnchor] = useState(null);
  const getNewAreaPosition = () => {
    var _a, _b2;
    let lowestPoint = 0;
    const areaGap = 20;
    (_b2 = (_a = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a.areas) == null ? void 0 : _b2.forEach((area) => {
      var _a2;
      (_a2 = area == null ? void 0 : area.points) == null ? void 0 : _a2.forEach((point) => {
        if (point.y + area.y > lowestPoint) {
          lowestPoint = point.y + area.y;
        }
      });
    });
    return lowestPoint + areaGap;
  };
  const handleCreateArea = (type2) => {
    var _a;
    const yPosition = getNewAreaPosition();
    const areaId = generateRandomString(8);
    const screenWidth = document.documentElement.clientWidth;
    const sidebarWidth2 = 420;
    const floorplanArea = getAreaData(
      {
        id: areaId,
        originalId: areaId,
        type: type2,
        y: yPosition
      },
      Math.max(500, screenWidth - sidebarWidth2)
    );
    const newFloorplan = {
      ...floorplan == null ? void 0 : floorplan.data,
      areas: [...(_a = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a.areas, floorplanArea]
    };
    updateLocalFloorplan(newFloorplan);
    createLocalArea(type2, bookingsDuration, areaId);
  };
  const addAreaOptions = [
    {
      value: "add_inside",
      onClick: () => handleCreateArea("indoor"),
      label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.dropdownContent }, /* @__PURE__ */ React__default.createElement(InsideIconSVG, { style: { color: theme2.colors.floorplanAreaIcon, height: "30px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Add an inside area"))
    },
    {
      value: "add_outside",
      onClick: () => handleCreateArea("outdoor"),
      label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.dropdownContent }, /* @__PURE__ */ React__default.createElement(OutsideIconSVG, { style: { color: theme2.colors.floorplanAreaIcon, height: "30px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Add an outside area"))
    }
  ];
  const popoverStyles2 = {
    popover: {
      marginTop: "10px",
      padding: "10px",
      borderRadius: "8px",
      marginLeft: "20px"
    },
    item: {
      fontSize: "16px",
      color: theme2.colors.grayLight,
      padding: "10px",
      height: "auto"
    }
  };
  ({
    fontWeight: theme2.fontWeights.medium,
    containerInner: {
      gap: "10px"
    },
    tab: {
      padding: "9px",
      fontSize: "15px",
      lineHeight: "18px",
      transition: "background-color 0.1s",
      whiteSpace: "nowrap",
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      color: theme2.colors.nimbus,
      fontWeight: theme2.fontWeights.regular,
      paddingBottom: "9px"
    },
    tabActive: {
      fontWeight: theme2.fontWeights.regular,
      color: theme2.colors.buttonText,
      borderBottom: "none",
      paddingBottom: "9px"
    },
    tabHover: {
      color: theme2.colors.buttonText,
      filter: "none"
    }
  });
  return /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.toolbar }, activeTab === "map" ? /* @__PURE__ */ React__default.createElement(Box, { className: classes.row }, /* @__PURE__ */ React__default.createElement(
    CleanSquareButton,
    {
      onClick: (e) => setAddAreaAnchor(e.currentTarget),
      forceHoverState: addAreaAnchor
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonContent }, /* @__PURE__ */ React__default.createElement("span", null, "Add area"), /* @__PURE__ */ React__default.createElement(
      DownCaretSVG,
      {
        className: classes.downArrow,
        style: { transform: addAreaAnchor ? "rotate(180deg)" : "none" }
      }
    ))
  ), /* @__PURE__ */ React__default.createElement(CleanSquareButton, { onClick: onClickTable, forceHoverState: showTableMenu }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonContent }, /* @__PURE__ */ React__default.createElement("span", null, "Add table"), /* @__PURE__ */ React__default.createElement(
    DownCaretSVG,
    {
      className: classes.downArrow,
      style: { transform: showTableMenu ? "rotate(180deg)" : "none" }
    }
  ))), /* @__PURE__ */ React__default.createElement(CleanSquareButton, { onClick: onClickElement, forceHoverState: showElementMenu }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.buttonContent }, /* @__PURE__ */ React__default.createElement("span", null, "Add element"), /* @__PURE__ */ React__default.createElement(
    DownCaretSVG,
    {
      className: classes.downArrow,
      style: { transform: showElementMenu ? "rotate(180deg)" : "none" }
    }
  )))) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.row })), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: addAreaOptions,
      anchor: addAreaAnchor,
      isOpen: !!addAreaAnchor,
      onClose: () => setAddAreaAnchor(null),
      style: popoverStyles2
    }
  ));
};
Toolbar.propTypes = {
  createLocalArea: PropTypes.func.isRequired,
  updateLocalFloorplan: PropTypes.func.isRequired,
  areas: areasPropTypes.isRequired,
  floorplan: floorplanPropTypes.isRequired,
  onClickTable: PropTypes.func.isRequired,
  onClickElement: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  bookingsDuration: PropTypes.number.isRequired
};
const mapStateToProps$16 = (state) => {
  var _a, _b2;
  return {
    bookingsDuration: (_b2 = (_a = state.obeeSettings) == null ? void 0 : _a.data) == null ? void 0 : _b2.bookingsDuration,
    areas: state.areas,
    floorplan: state.floorplan
  };
};
const mapDispatchToProps$15 = (dispatch) => bindActionCreators(
  {
    createLocalArea: createLocalAreaAction,
    updateLocalFloorplan: updateLocalFloorplanAction
  },
  dispatch
);
const Toolbar$1 = connect(mapStateToProps$16, mapDispatchToProps$15)(Toolbar);
const SvgList = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 18 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("line", { x1: 5.5, y1: 1.5, x2: 17.5, y2: 1.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 5.5, y1: 6.5, x2: 17.5, y2: 6.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 5.5, y1: 11.5, x2: 17.5, y2: 11.5, stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 1.5, cy: 1.5, r: 1, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 1.5, cy: 6.5, r: 1, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 1.5, cy: 11.5, r: 1, stroke: "currentColor" }));
const ListSVG = SvgList;
const SvgFloorplanIcon = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M10.24 18.64H15.64C17.2969 18.64 18.64 17.2969 18.64 15.64V4C18.64 2.34315 17.2969 1 15.64 1H4C2.34315 1 1 2.34314 1 4V15.64C1 17.2969 2.34314 18.64 4 18.64H7.3C7.57228 17.2786 8.98311 14.5933 12.4594 14.4463C12.625 14.4393 12.76 14.5743 12.76 14.74V16.54", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.6588 1V7.42C10.6588 7.58569 10.5244 7.72 10.3588 7.72H7.71875", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M1 7.71997H4.36", stroke: "currentColor", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 18.1406, y1: 11.5801, x2: 14.9406, y2: 11.5801, stroke: "currentColor", strokeLinecap: "round" }));
const FloorplanSVG = SvgFloorplanIcon;
const EditFloorplan$1 = ({
  tables,
  areas,
  floorplan,
  fetchAreas,
  fetchTables,
  fetchFloorplan,
  saveFloorplan,
  restaurantActive,
  bulkUpdateLocalTables
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i;
  const theme2 = useTheme$1();
  const history = useHistory();
  const query = useQuery();
  const view = query.get("view");
  const [activeTab, setActiveTab] = useState(view || "map");
  const [showTableMenu, setShowTableMenu] = useState(false);
  const [showElementMenu, setShowElementMenu] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const tableCount = useRef(0);
  const hasFetchedFloorplan = useRef(false);
  const [invalidAreas, setInvalidAreas] = useState([]);
  const [previousRoute, setPreviousRoute] = useState(
    ((_b2 = (_a = history.location) == null ? void 0 : _a.state) == null ? void 0 : _b2.from) || `${(_c2 = window.bookingsConfig) == null ? void 0 : _c2.routePrefix}/runsheet`
  );
  const backLocation = hasBookingsPremium(restaurantActive) ? `${(_d2 = window.bookingsConfig) == null ? void 0 : _d2.routePrefix}/floorplan` : `${(_e2 = window.bookingsConfig) == null ? void 0 : _e2.routePrefix}/settings?tab=areas`;
  const hasLoaded = useRef(false);
  const classes = useStyles$E({ sidebarOpen: showSidebar });
  useEffect(() => {
    fetchAreas();
    fetchTables(moment$2().format("YYYY-MM-DD"));
  }, []);
  useEffect(() => {
    history.replace({
      search: `?view=${activeTab}`
    });
  }, [activeTab]);
  useEffect(() => {
    if (!hasFetchedFloorplan.current && areas.success && tables.success) {
      hasFetchedFloorplan.current = true;
      fetchFloorplan();
    }
  }, [areas.success, tables.success]);
  useEffect(() => {
    if (hasLoaded.current) {
      return;
    }
    if (!isEmpty(areas.data) && !isEmpty(tables.data) && !isEmpty(floorplan.data)) {
      hasLoaded.current = true;
      const firstAreaId = areas.data[0].id;
      const tablesWithMissingArea = tables == null ? void 0 : tables.data.filter((table) => {
        const areaForTable = findObjectByProperty(areas.data, table.areaId, "id");
        return isEmpty(areaForTable);
      });
      const updatedTables = tablesWithMissingArea.map((table) => ({
        ...table,
        areaId: firstAreaId
      }));
      bulkUpdateLocalTables(updatedTables);
    }
  }, [floorplan.data, areas.data, tables.data]);
  const floorplanData = useMemo(() => {
    var _a2, _b3, _c3, _d3, _e3, _f2, _g2;
    const floorplanAreas = (_b3 = (_a2 = areas == null ? void 0 : areas.data) == null ? void 0 : _a2.filter((area) => !isEmpty(area == null ? void 0 : area.id) || !isEmpty(area == null ? void 0 : area._tempId))) == null ? void 0 : _b3.map((area, index) => {
      var _a3, _b4;
      let areaInFloorplan = findObjectByProperty((_a3 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a3.areas, area == null ? void 0 : area.id, "id");
      const areaDefaultHeight = 400;
      const areaDefaultGap = 20;
      if (isEmpty(areaInFloorplan)) {
        areaInFloorplan = {
          ...getDefaultAreaValues(index * (areaDefaultHeight + areaDefaultGap)),
          ...getFloorplanAreaFromAreaData((_b4 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _b4.areas, area),
          id: area == null ? void 0 : area.id
        };
      }
      return { ...areaInFloorplan, bounds: getBoundsForArea(areaInFloorplan) };
    });
    const widthForDefault = 120;
    const heightForDefault = 120;
    const defaultTablesPerRow = 8;
    let floorplanTables = (_d3 = (_c3 = tables == null ? void 0 : tables.data) == null ? void 0 : _c3.filter((table) => !isEmpty(table == null ? void 0 : table.id) || !isEmpty(table == null ? void 0 : table._tempId))) == null ? void 0 : _d3.filter((table) => !table.isJoin);
    let newFloorplanTables = [];
    groupByProperty(floorplanTables, "areaId").map(
      (areaTables) => {
        var _a3;
        return (_a3 = areaTables == null ? void 0 : areaTables.items) == null ? void 0 : _a3.forEach((table, index) => {
          var _a4;
          newFloorplanTables = [
            ...newFloorplanTables,
            {
              type: "rectangle",
              rotation: 0,
              scale: 1,
              x: index % defaultTablesPerRow * widthForDefault + 20,
              // Place them horizontally
              y: Math.floor(index / defaultTablesPerRow) * heightForDefault + 40,
              ...getFloorplanTableFromTableData((_a4 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _a4.tables, table),
              id: table == null ? void 0 : table.id
              // Always override temporary ID with real ID from data
            }
          ];
        });
      }
    );
    floorplanTables = newFloorplanTables;
    const firstAreaId = ((_e3 = floorplanAreas == null ? void 0 : floorplanAreas[0]) == null ? void 0 : _e3.id) || 1;
    const floorplanElements = (((_f2 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _f2.elements) || []).map((element) => {
      const areaForElement = findObjectByProperty(floorplanAreas, element == null ? void 0 : element.areaId, "id");
      const areaId = !isEmpty(areaForElement == null ? void 0 : areaForElement.id) ? areaForElement == null ? void 0 : areaForElement.id : firstAreaId;
      return {
        ...element,
        areaId
      };
    });
    return {
      ...floorplan == null ? void 0 : floorplan.data,
      elements: floorplanElements,
      levels: ((_g2 = floorplan == null ? void 0 : floorplan.data) == null ? void 0 : _g2.levels) || [],
      areas: floorplanAreas,
      tables: floorplanTables
    };
  }, [floorplan.data, areas.data, tables.data]);
  useEffect(() => {
    var _a2;
    if (tableCount.current === 0) {
      tableCount.current = ((_a2 = tables.data) == null ? void 0 : _a2.length) || 0;
    }
  }, [tables == null ? void 0 : tables.data]);
  const toggleElementMenu = () => {
    if (!showElementMenu || !showSidebar) {
      unstable_batchedUpdates(() => {
        setShowSidebar(true);
        setShowTableMenu(false);
        setShowElementMenu(true);
      });
    } else {
      setShowSidebar(false);
    }
  };
  const toggleTableMenu = () => {
    if (!showTableMenu || !showSidebar) {
      unstable_batchedUpdates(() => {
        setShowSidebar(true);
        setShowTableMenu(true);
        setShowElementMenu(false);
      });
    } else {
      setShowSidebar(false);
    }
  };
  if (emptyObject(floorplan == null ? void 0 : floorplan.data)) {
    return /* @__PURE__ */ React__default.createElement(
      Box,
      {
        style: {
          marginTop: "400px",
          marginLeft: "auto",
          marginRight: "auto",
          width: "100%",
          textAlign: "center"
        }
      },
      "Loading..."
    );
  }
  const validateAndSaveFloorplan = (dataToSave) => {
    const newInvalidAreas = areas.data.map((area) => getAreaDataFromFloorplanArea(area, areas.data)).filter((areaData) => {
      const tablesForArea = tables.data.filter((table) => table.areaId === areaData.id);
      return isEmpty(tablesForArea) && areaData.capacity < 1;
    });
    if (!isEmpty(newInvalidAreas)) {
      setInvalidAreas(newInvalidAreas);
      return;
    }
    saveFloorplan(dataToSave);
  };
  const bookingButtonStyle = {
    marginLeft: "auto",
    button: {
      backgroundColor: theme2.colors.charcoal,
      fontWeight: theme2.fontWeights.medium,
      height: "40px",
      padding: "8px 20px",
      fontSize: "15px",
      display: "flex",
      alignItems: "center",
      ...(_g = (_f = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _f.Button) == null ? void 0 : _g.button
    }
  };
  const exitButtonStyle = {
    button: {
      backgroundColor: "transparent",
      fontWeight: theme2.fontWeights.medium,
      height: "40px",
      padding: "8px 20px",
      fontSize: "15px",
      display: "flex",
      alignItems: "center",
      color: theme2.colors.charcoal,
      ...(_i = (_h = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _h.Button) == null ? void 0 : _i.button
    },
    buttonHover: {
      backgroundColor: "white"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.logoContainer }, /* @__PURE__ */ React__default.createElement(Logo$1, { className: classes.plate })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerText }, "Edit floor plan")), /* @__PURE__ */ React__default.createElement(
    TabBar$1,
    {
      tabs: [
        {
          label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.tabLabel }, /* @__PURE__ */ React__default.createElement(FloorplanSVG, { style: { height: "20px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Map view")),
          value: "map"
        },
        {
          label: /* @__PURE__ */ React__default.createElement(Box, { className: classes.tabLabel }, /* @__PURE__ */ React__default.createElement(ListSVG, { style: { height: "13px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "List view")),
          value: "list"
        }
      ],
      value: activeTab,
      onSelect: setActiveTab
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerButtons }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      style: exitButtonStyle,
      type: "secondary",
      onClick: () => {
        devLog("info", "pushing history", { previousRoute, backLocation });
        fetchFloorplan();
        history.push(previousRoute);
      }
    },
    "Exit"
  ), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      onClick: () => {
        validateAndSaveFloorplan(floorplanData);
      },
      loading: floorplan == null ? void 0 : floorplan.pending,
      disabled: floorplan == null ? void 0 : floorplan.pending,
      style: bookingButtonStyle
    },
    "Save"
  ))), activeTab === "map" && /* @__PURE__ */ React__default.createElement(
    Toolbar$1,
    {
      onClickTable: toggleTableMenu,
      onClickElement: toggleElementMenu,
      activeTab,
      setActiveTab,
      showTableMenu: showSidebar && showTableMenu,
      showElementMenu: showSidebar && showElementMenu
    }
  )), activeTab === "map" && /* @__PURE__ */ React__default.createElement(
    EditFloorplanMap$1,
    {
      showSidebar,
      showTableMenu,
      showElementMenu,
      floorplanData
    }
  ), activeTab === "list" && /* @__PURE__ */ React__default.createElement(
    EditFloorplanList$1,
    {
      showSidebar,
      showTableMenu,
      showElementMenu,
      floorplanData
    }
  ), /* @__PURE__ */ React__default.createElement(
    GeneralErrorModal$1,
    {
      isOpen: !isEmpty(invalidAreas),
      onClose: () => setInvalidAreas([]),
      onConfirm: saveFloorplan,
      heading: "Invalid areas detected",
      confirmLabel: "Close"
    },
    /* @__PURE__ */ React__default.createElement("p", null, "The following areas have no tables, and no capacity set:"),
    /* @__PURE__ */ React__default.createElement("ul", null, invalidAreas.map((invalidArea) => /* @__PURE__ */ React__default.createElement("li", null, invalidArea.name))),
    /* @__PURE__ */ React__default.createElement("p", null, "Please add tables to each of these areas and then try saving again. If you wish to manage bookings for these areas without assigning them to tables, please edit the capacity on the area properties.")
  ));
};
EditFloorplan$1.propTypes = {
  areas: areasPropTypes.isRequired,
  tables: tablesPropTypes.isRequired,
  fetchAreas: PropTypes.func.isRequired,
  fetchTables: PropTypes.func.isRequired,
  fetchFloorplan: PropTypes.func.isRequired,
  saveFloorplan: PropTypes.func.isRequired,
  floorplan: floorplanPropTypes.isRequired,
  restaurantActive: restaurantActivePropTypes.isRequired,
  bulkUpdateLocalTables: PropTypes.func.isRequired
};
const mapStateToProps$15 = (state) => ({
  areas: state.areas,
  tables: state.tables,
  floorplan: state.floorplan,
  restaurantActive: state.restaurantActive.restaurant
});
const mapDispatchToProps$14 = (dispatch) => bindActionCreators(
  {
    fetchAreas: fetchAreasAction,
    updateLocalArea: updateLocalAreaAction,
    fetchTables: fetchTablesAction,
    fetchFloorplan: fetchFloorplanAction,
    updateFloorplan: updateFloorplanAction,
    saveFloorplan: saveFloorplanAction,
    bulkUpdateLocalTables: bulkUpdateLocalTablesAction
  },
  dispatch
);
const EditFloorplanScreen = connect(mapStateToProps$15, mapDispatchToProps$14)(EditFloorplan$1);
const useStyles$B = createUseStyles((theme2) => ({
  label: {
    fontSize: "12px",
    fontWeight: theme2.fontWeights.medium,
    padding: "8px"
  },
  itemsContainer: {
    padding: "8px"
  },
  item: {
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    margin: "0 -8px",
    padding: "8px",
    "&:hover": {
      background: theme2.colors.cloud,
      cursor: "pointer"
    }
  },
  itemInner: {
    alignItems: "center",
    display: "flex",
    gap: "8px"
  },
  editButton: {
    color: theme2.colors.olive3,
    marginLeft: "12px"
  },
  blockedDuration: {
    marginLeft: "29px"
  }
}));
const BlockTablePopover = ({
  anchorEl,
  onClose,
  table,
  unblockTable: unblockTable2,
  closingTime,
  systemTimeInterval,
  todaySessions
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$B();
  const [blockTimesAnchorEl, setBlockTimesAnchorEl] = useState(null);
  const now2 = formatIntFromTime(moment$2());
  const currentBlock = getTableBlockForTime(table, now2);
  const unblock = () => {
    unblockTable2(table, currentBlock.id);
  };
  return /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      anchorEl,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      innerStyle: {
        borderRadius: "8px",
        marginLeft: "-4px",
        marginTop: "10px",
        padding: "0 8px",
        userSelect: "none"
      },
      isOpen: !!anchorEl,
      onClose,
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, table == null ? void 0 : table.tableNumber), /* @__PURE__ */ React__default.createElement(Divider, { style: { margin: "0 -8px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemsContainer }, currentBlock ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.item,
        style: { background: !!blockTimesAnchorEl && theme2.colors.cloud },
        onClick: (e) => setBlockTimesAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemInner }, /* @__PURE__ */ React__default.createElement(IconBlockTable, { style: { width: "21px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Blocked"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.editButton }, "Edit"))),
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockedDuration }, /* @__PURE__ */ React__default.createElement(Box, null, "Until ", formatTimeFromInt(currentBlock.endTime)))
    ), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.item,
        onClick: () => {
          unblock();
          onClose();
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemInner }, /* @__PURE__ */ React__default.createElement(IconUnblockTable, { style: { width: "21px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Unblock table"))
    )) : /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.item,
        style: { background: !!blockTimesAnchorEl && theme2.colors.cloud },
        onClick: (e) => setBlockTimesAnchorEl(e.currentTarget)
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemInner }, /* @__PURE__ */ React__default.createElement(IconBlockTable, { style: { width: "21px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Block table"), /* @__PURE__ */ React__default.createElement(RightCaret, { style: { marginLeft: "12px", width: "4px" } }))
    )), /* @__PURE__ */ React__default.createElement(
      BlockTableTimePopover$1,
      {
        anchorEl: blockTimesAnchorEl,
        onClose: () => {
          setBlockTimesAnchorEl(null);
          onClose();
        },
        table,
        closingTime,
        systemTimeInterval,
        currentBlock,
        todaySessions
      }
    ))
  );
};
BlockTablePopover.defaultProps = {
  anchorEl: null,
  onClose: () => {
  },
  table: null
};
BlockTablePopover.propTypes = {
  anchorEl: PropTypes.shape({}),
  onClose: PropTypes.func,
  table: tablePropTypes,
  unblockTable: PropTypes.func.isRequired,
  closingTime: PropTypes.number.isRequired,
  systemTimeInterval: PropTypes.number.isRequired,
  todaySessions: PropTypes.arrayOf(sessionPropTypes).isRequired
};
const mapStateToProps$14 = (state) => ({
  obeeSessions: state.obeeSessions,
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$13 = (dispatch) => bindActionCreators(
  {
    unblockTable: unblockTableAction
  },
  dispatch
);
const BlockTablePopover$1 = connect(mapStateToProps$14, mapDispatchToProps$13)(BlockTablePopover);
const useStyles$A = createUseStyles((theme2) => ({
  blankRow: {
    background: theme2.colors.timelineEmptyRow,
    borderBottom: `1px solid ${theme2.colors.shark}`,
    position: "relative"
  },
  closedBar: {
    borderLeft: `4px solid ${theme2.colors.cloud}`,
    background: theme2.colors.timelineClosed,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    writingMode: "vertical-lr",
    width: "45px"
  },
  openedBar: {
    borderRight: `4px solid ${theme2.colors.cloud}`,
    background: theme2.colors.timelineClosed,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    writingMode: "vertical-lr",
    width: "45px"
  },
  barText: {
    transform: "rotate(180deg)",
    fontSize: "15px",
    color: theme2.colors.nimbus
  },
  areaGrid: {
    position: "relative",
    display: "flex"
  },
  privateTableContainer: {
    position: "absolute",
    height: "41px",
    right: 0,
    left: 0,
    alignItems: "center",
    display: "flex",
    pointerEvents: "none"
  },
  privateTableLabel: {
    padding: "4px 8px",
    fontWeight: theme2.fontWeights.medium,
    boxShadow: "rgba(151, 151, 151, 0.25) 0px 4px 4px",
    position: "sticky",
    left: `${theme2.components.timeline.sidebarWidth + 8}px`,
    marginLeft: "8px",
    zIndex: 50,
    opacity: 0.9
  },
  fullyBookContainer: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    position: "absolute"
  },
  fullBookLabel: {
    padding: "4px 8px",
    backgroundColor: theme2.colors.infoBlueLight,
    fontWeight: theme2.fontWeights.medium,
    boxShadow: "rgba(151, 151, 151, 0.25) 0px 4px 4px",
    position: "sticky",
    left: `${theme2.components.timeline.sidebarWidth + 8}px`
  }
}));
const useStyles$z = createUseStyles((theme2) => ({
  completedCheck: {
    alignItems: "center",
    color: theme2.colors.olive5,
    display: "flex",
    justifyContent: "center",
    paddingRight: "6px"
  },
  container: {
    alignItems: "center",
    backgroundColor: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.bookingBarFill;
    },
    border: (props) => {
      var _a;
      return `1px solid ${(_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.bookingBarOutline}`;
    },
    borderRadius: "4px",
    display: "flex",
    width: "100%",
    margin: "1px 0",
    transition: "transform 0.1s, box-shadow 0.1s, background-color 0.1s, border 0.1s",
    userSelect: "none"
  },
  containerActive: {
    border: "1px solid #000000 !important",
    boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.25)"
  },
  controlBox: {
    alignItems: "center",
    border: (props) => {
      var _a;
      return `1px solid ${(_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.bookingBarIconOutline}`;
    },
    color: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.color;
    },
    borderRadius: "8px",
    display: "flex",
    height: "28px",
    justifyContent: "center",
    width: "34px",
    transition: "opacity 0.1s, border 0.1s",
    cursor: "pointer",
    pointerEvents: "all",
    "&:hover": {
      opacity: "0.4"
    }
  },
  controlBoxContainer: {
    alignItems: "center",
    display: "flex",
    gap: "4px",
    marginLeft: "auto"
  },
  highlight: {
    flexShrink: 0,
    alignItems: "center",
    backgroundColor: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.bookingBarHighlight;
    },
    borderRadius: "2px 0 0 2px",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    width: "6px",
    transition: "width 0.1s, background-color 0.1s",
    "&:hover": {
      width: "12px",
      cursor: "pointer",
      "& > svg": {
        display: "block"
      }
    }
  },
  highlightDropdown: {
    display: "none",
    margin: "2px"
  },
  noShowLabel: {
    background: theme2.colors.rose,
    borderRadius: "4px",
    padding: "4px"
  },
  sittingContainer: {
    alignItems: "center",
    display: "flex",
    gap: "2px"
  },
  detailsContainer: {
    width: "100%",
    overflow: "hidden",
    pointerEvents: "none"
  },
  subText: {
    color: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.bookingBarDetails;
    },
    display: "flex",
    fontSize: "10px",
    gap: "12px",
    alignItems: "center",
    transition: "color 0.1s"
  },
  text: {
    color: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.color;
    },
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium,
    transition: "color 0.1s"
  },
  textOverflow: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  jointContainer: {
    color: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.color;
    },
    fontWeight: theme2.fontWeights.medium,
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "color 0.1s",
    whiteSpace: "nowrap",
    fontSize: "12px"
  },
  jointTablePill: {
    padding: "4px",
    backgroundColor: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.bookingBarJointPill;
    },
    color: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.bookingBarJointText;
    },
    borderRadius: "8px",
    transition: "background-color 0.1s"
  },
  guestAmount: {
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
    height: "28px",
    color: (props) => {
      var _a;
      return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.color;
    },
    width: "34px",
    border: `1px solid transparent`,
    justifyContent: "space-between"
  },
  bookingInfoContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    pointerEvents: "none",
    padding: "0 8px",
    maxWidth: "calc(100% - 6px)"
  }
}));
const defaultPosition = { x: 0, y: 0 };
const BookingBar = ({
  booking,
  bookingIdToView,
  bookingToDrag,
  top,
  left,
  setBookingToDrag,
  // TODO change to "onDrag"
  viewBooking,
  width,
  updateBooking,
  handleOnDrop,
  parentTableNumber,
  cellPxHeight,
  obeeSettings: obeeSettings2,
  timelineTableNumber,
  // used to determine which booking bar to use for dragging (joint table bookings)
  confirmWaitlist: confirmWaitlist2,
  confirmWaitlistAsBooked: confirmWaitlistAsBooked2,
  isHovered
}) => {
  const theme2 = useTheme$1();
  const bookingStatus = getStatus(booking);
  const [statusListAnchorEl, setStatusListAnchorEl] = useState(null);
  const [commentAnchorEl, setCommentAnchorEl] = useState(null);
  const [pressed, setPressed] = useState(false);
  const cancelDragRef = useRef(false);
  cancelDragRef.current = false;
  const isMobile = useHasMobile();
  const classes = useStyles$z({ bookingStatus });
  const isDragging = (bookingToDrag == null ? void 0 : bookingToDrag.id) === booking.id;
  const getComments = () => {
    if ((booking == null ? void 0 : booking.customerComments) || (booking == null ? void 0 : booking.restaurantComments)) {
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          style: { pointerEvents: isDragging && "none" },
          className: classes.controlBox,
          onTouchStart: (e) => {
            e.stopPropagation();
            cancelDragRef.current = true;
          },
          onTouchEnd: (e) => setCommentAnchorEl(e.currentTarget),
          onMouseDown: (e) => e.stopPropagation(),
          onClick: (e) => setCommentAnchorEl(e.currentTarget)
        },
        /* @__PURE__ */ React__default.createElement(CommentSVG, { style: { height: "15px", width: "15px" } })
      );
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  };
  const onStatusSave = (newStatus) => {
    var _a;
    if (newStatus !== booking.status) {
      let newDuration = booking.duration;
      if (newStatus === STATUS_TYPES.FINISHED) {
        const nowAsInt = formatIntFromTime(moment$2());
        if (nowAsInt >= booking.startTime && nowAsInt < booking.endTime) {
          const timeInterval = (_a = obeeSettings2.data) == null ? void 0 : _a.systemTimeInterval;
          newDuration = roundToNearest(nowAsInt, timeInterval, "floor") - booking.startTime;
          newDuration = Math.max(newDuration, timeInterval);
        }
      }
      if (booking.status === STATUS_TYPES.WAITING && newStatus === STATUS_TYPES.CONFIRMED) {
        confirmWaitlist2(booking.id);
        return;
      }
      if (booking.status === STATUS_TYPES.WAITING && newStatus === STATUS_TYPES.BOOKED) {
        confirmWaitlistAsBooked2(booking.id);
        return;
      }
      if (newStatus === STATUS_TYPES.WAITING) {
        updateBooking({
          ...booking,
          tableNumber: null,
          areaId: 0,
          tableId: -1,
          status: newStatus
        });
        return;
      }
      updateBooking({
        ...booking,
        duration: newDuration,
        status: newStatus
      });
    }
    setStatusListAnchorEl(null);
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    TouchDraggable$1,
    {
      holdTime: 250,
      onStart: () => setBookingToDrag({ ...booking, timelineTableNumber }),
      onInitialPress: () => setPressed(true),
      onStop: handleOnDrop,
      onStopPressing: () => {
        unstable_batchedUpdates(() => {
          setPressed(false);
          setBookingToDrag(null);
        });
      },
      position: defaultPosition,
      onClick: () => viewBooking(booking.id),
      cancelRef: cancelDragRef
    },
    /* @__PURE__ */ React__default.createElement(
      Box,
      {
        key: `booking-${booking.id}`,
        style: {
          top: `${top}px`,
          left: `${left}px`,
          zIndex: isDragging ? 99 : getSeatableStatuses().includes(bookingStatus == null ? void 0 : bookingStatus.id) ? 41 : 40,
          width: `${width}px`,
          position: "absolute",
          cursor: "pointer",
          pointerEvents: bookingToDrag && bookingToDrag.id !== booking.id && "none"
        }
      },
      /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: `${classes.container} ${bookingIdToView === booking.id ? classes.containerActive : ""}`,
          style: {
            opacity: bookingIdToView && bookingIdToView !== booking.id && "0.4",
            boxShadow: isDragging && "0px 4px 4px rgba(151, 151, 151, 0.25)",
            height: `${cellPxHeight - 3}px`,
            // minus margins and borders
            transform: !isDragging && pressed ? "scale(0.95)" : "scale(1)"
          },
          "data-booking": `${booking.id}-${timelineTableNumber}`
        },
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.highlight,
            style: {
              width: isMobile ? "20px" : statusListAnchorEl && "12px",
              pointerEvents: isDragging && "none"
              // Allow the dragging position to fall through to the cells while dragging
            },
            onTouchStart: (e) => {
              e.stopPropagation();
              cancelDragRef.current = true;
            },
            onTouchEnd: (e) => setStatusListAnchorEl(e.currentTarget),
            onMouseDown: (e) => e.stopPropagation(),
            onClick: (e) => setStatusListAnchorEl(e.currentTarget)
          },
          /* @__PURE__ */ React__default.createElement(
            DownCaretSVG,
            {
              className: classes.highlightDropdown,
              style: {
                width: "8px",
                height: "8px",
                display: (isMobile || statusListAnchorEl) && "block",
                color: [STATUS_TYPES.BOOKED, STATUS_TYPES.CONFIRMED, STATUS_TYPES.FINISHED].includes(
                  booking.status
                ) && theme2.colors.white
              }
            }
          )
        ),
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.bookingInfoContainer,
            style: {
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
              pointerEvents: "none",
              padding: "0 8px",
              maxWidth: "calc(100% - 6px)"
            }
          },
          /* @__PURE__ */ React__default.createElement(Box, { className: classes.detailsContainer }, parentTableNumber ? /* @__PURE__ */ React__default.createElement(Box, { className: classes.jointContainer }, /* @__PURE__ */ React__default.createElement(
            TableJoinedSVG,
            {
              style: {
                flexShrink: 0,
                height: "20px",
                width: "20px",
                color: theme2.colors.charcoal
              }
            }
          ), /* @__PURE__ */ React__default.createElement(Box, null, "Joined with"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.jointTablePill }, parentTableNumber)) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.text} ${classes.textOverflow}` }, getBookingName(booking)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.subText }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.textOverflow }, `${formatTimeFromInt(booking.time, "h:mma")}-${formatTimeFromInt(
            booking.time + booking.duration,
            "h:mma"
          )}`), booking.status === STATUS_TYPES.CONFIRMED && /* @__PURE__ */ React__default.createElement(ConfirmedCheckIcon, { style: { width: "14px", height: "14px" } })))),
          /* @__PURE__ */ React__default.createElement(Box, { className: classes.controlBoxContainer }, (booking == null ? void 0 : booking.isBirthday) && /* @__PURE__ */ React__default.createElement(Cake, null), getComments(), /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestAmount }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { flexShrink: 0, height: "15px", width: "15px" } }), booking == null ? void 0 : booking.size))
        )
      )
    )
  ), /* @__PURE__ */ React__default.createElement(
    StatusPopover$1,
    {
      setStatusListAnchorEl,
      statusListAnchorEl,
      onSave: onStatusSave,
      isWaitlist: (booking == null ? void 0 : booking.status) === "waitlist"
    }
  ), /* @__PURE__ */ React__default.createElement(
    CommentsPopover$1,
    {
      booking,
      anchor: commentAnchorEl,
      setAnchor: setCommentAnchorEl,
      innerStyle: {
        marginBottom: "10px",
        marginTop: "-10px"
      }
    }
  ));
};
BookingBar.defaultProps = {
  bookingToDrag: null,
  bookingIdToView: null,
  parentTableNumber: null,
  timelineTableNumber: null
};
BookingBar.propTypes = {
  booking: obeeBookingPropTypes.isRequired,
  bookingToDrag: obeeBookingPropTypes,
  bookingIdToView: PropTypes.number,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  setBookingToDrag: PropTypes.func.isRequired,
  viewBooking: PropTypes.func.isRequired,
  updateBooking: PropTypes.func.isRequired,
  handleOnDrop: PropTypes.func.isRequired,
  parentTableNumber: PropTypes.string,
  cellPxHeight: PropTypes.number.isRequired,
  timelineTableNumber: PropTypes.string,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  confirmWaitlist: PropTypes.func.isRequired,
  confirmWaitlistAsBooked: PropTypes.func.isRequired
};
const mapStateToProps$13 = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$12 = (dispatch) => bindActionCreators(
  {
    updateBooking: updateObeeBookingAction,
    confirmWaitlist: confirmWaitlistAction,
    confirmWaitlistAsBooked: confirmWaitlistAsBookedAction
  },
  dispatch
);
const BookingBar$1 = connect(mapStateToProps$13, mapDispatchToProps$12)(BookingBar);
const DragListener = forwardRef(({ bookingToDrag, handleOnDrop }, ref) => {
  const theme2 = useTheme$1();
  const [cellToDrop, setCellToDrop] = useState(null);
  const [bookingToDragEl, setBookingToDragEl] = useState(null);
  const handleMove = useCallback(() => {
    if (!bookingToDragEl) {
      return;
    }
    let { x, y } = bookingToDragEl.getBoundingClientRect();
    x += 10;
    y += 20;
    const cell = document.elementsFromPoint(x, y).find((element) => element.getAttribute("data-cell") !== null);
    if (cell !== cellToDrop) {
      if (cell) {
        cell.style.background = theme2.colors.cloud;
      }
      if (cellToDrop) {
        cellToDrop.style.background = cellToDrop.getAttribute("data-background");
      }
    }
    setCellToDrop(cell);
  }, [theme2.colors.cloud, cellToDrop, bookingToDragEl]);
  useEffect(() => {
    if (bookingToDrag) {
      window.addEventListener("mousemove", handleMove);
      window.addEventListener("touchmove", handleMove);
    } else {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("touchmove", handleMove);
    }
    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("touchmove", handleMove);
    };
  }, [bookingToDrag, handleMove]);
  useEffect(() => {
    setBookingToDragEl(
      document.querySelector(
        `[data-booking="${bookingToDrag == null ? void 0 : bookingToDrag.id}-${bookingToDrag == null ? void 0 : bookingToDrag.timelineTableNumber}"]`
      )
    );
  }, [bookingToDrag]);
  useImperativeHandle(ref, () => ({
    handleOnDrop: () => handleOnDrop(cellToDrop, setCellToDrop, bookingToDrag)
  }));
  return null;
});
DragListener.defaultProps = {
  bookingToDrag: null
};
DragListener.propTypes = {
  bookingToDrag: obeeBookingPropTypes,
  handleOnDrop: PropTypes.func.isRequired
};
const DragListener$1 = DragListener;
const useStyles$y = createUseStyles((theme2) => ({
  cell: (props) => ({
    alignItems: "center",
    borderBottom: `1px solid ${theme2.colors.cloud}`,
    borderLeft: `1px solid ${theme2.colors.cloud}`,
    display: "flex",
    justifyContent: "center",
    position: "relative",
    transition: "background 0.1s",
    "&:hover": {
      background: (props == null ? void 0 : props.isInSession) ? `${theme2.colors.cloud} !important` : theme2.colors.cloud,
      cursor: "pointer"
    }
  })
}));
const SchedulerCell = ({
  key,
  style,
  setObeeShowAddBookingModal,
  time,
  table,
  area,
  isInSession
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$y({ isInSession });
  const cellData = {
    tableNumber: table == null ? void 0 : table.tableNumber,
    tableId: table == null ? void 0 : table.id,
    areaId: (table == null ? void 0 : table.areaId) || (area == null ? void 0 : area.id),
    time,
    isInSession
  };
  const addBooking = (quickBooking) => {
    setObeeShowAddBookingModal(true, quickBooking, true);
  };
  const dataCell = JSON.stringify(cellData);
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      "data-cell": dataCell,
      "data-background": !isInSession ? theme2.colors.timelineClosed : "inherit",
      key,
      style: {
        ...style,
        background: !isInSession ? theme2.colors.timelineClosed : "inherit",
        cursor: !isInSession && "default"
      },
      className: classes.cell,
      onClick: () => isInSession && addBooking(cellData)
    }
  );
};
SchedulerCell.defaultProps = {
  key: "",
  table: null,
  area: null
};
SchedulerCell.propTypes = {
  key: PropTypes.string,
  style: PropTypes.shape({}).isRequired,
  setObeeShowAddBookingModal: PropTypes.func.isRequired,
  time: PropTypes.number.isRequired,
  table: tablePropTypes,
  area: areaPropTypes,
  isInSession: PropTypes.bool.isRequired
};
const mapStateToProps$12 = () => ({});
const mapDispatchToProps$11 = (dispatch) => bindActionCreators(
  {
    setObeeShowAddBookingModal: setObeeShowAddBookingModalAction
  },
  dispatch
);
const SchedulerCell$1 = connect(mapStateToProps$12, mapDispatchToProps$11)(SchedulerCell);
const useStyles$x = createUseStyles((theme2) => ({
  container: {
    position: "absolute",
    zIndex: 50,
    userSelect: "none",
    margin: "1px 0",
    padding: "0 8px",
    border: "1px dashed #000000",
    background: addAlphaToHex(theme2.colors.cloud, 0.7),
    borderRadius: "4px",
    display: "flex",
    alignItems: "center"
  },
  innerContainer: {
    alignItems: "center",
    display: "flex",
    gap: "8px",
    width: "100%",
    whiteSpace: "nowrap"
  },
  blockedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium
  },
  untilText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "10px",
    color: theme2.colors.smoke
  }
}));
const BlockedBar = ({ blockedUntil, left, top, width, isDragging, cellPxHeight }) => {
  const classes = useStyles$x();
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      title: `Blocked ${blockedUntil}`,
      className: classes.container,
      style: {
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        pointerEvents: isDragging && "none",
        height: `${cellPxHeight - 3}px`,
        // minus margins and borders
        zIndex: 1
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(IconBlockSVG, { style: { flexShrink: 0, height: "15px", width: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, { style: { overflow: "hidden" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.blockedText }, "Blocked"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.untilText }, blockedUntil)))
  );
};
BlockedBar.propTypes = {
  blockedUntil: PropTypes.string.isRequired,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  cellPxHeight: PropTypes.number.isRequired
};
const BlockedBar$1 = BlockedBar;
const useStyles$w = createUseStyles((theme2) => ({
  container: {
    position: "absolute",
    zIndex: 50,
    userSelect: "none",
    margin: "1px 0",
    padding: "0 8px",
    border: "1px dashed #000000",
    background: addAlphaToHex(theme2.colors.cloud, 0.7),
    borderRadius: "4px",
    display: "flex",
    alignItems: "center"
  },
  innerContainer: {
    alignItems: "center",
    display: "flex",
    gap: "8px",
    width: "100%",
    whiteSpace: "nowrap"
  },
  fullyBookText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium
  },
  untilText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "10px",
    color: theme2.colors.smoke
  }
}));
const FullyBookBar = ({ bookedUntil, left, top, width, isDragging, cellPxHeight }) => {
  const classes = useStyles$w();
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      title: `Fully booked ${bookedUntil}`,
      className: classes.container,
      style: {
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        pointerEvents: isDragging && "none",
        height: `${cellPxHeight - 3}px`,
        // minus margins and borders
        zIndex: 1
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, /* @__PURE__ */ React__default.createElement(Box, { style: { overflow: "hidden" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.fullyBookText }, "Fully booked")))
  );
};
FullyBookBar.propTypes = {
  bookedUntil: PropTypes.string.isRequired,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  cellPxHeight: PropTypes.number.isRequired
};
const FullyBookBar$1 = FullyBookBar;
const SchedulerGrid = ({
  areasToHide,
  bookingsOnly,
  setObeeBookingDetailsModal,
  obeeBookingDetailsModal,
  bookings,
  cellPxWidth,
  cellPxHeight,
  minutePxWidth,
  todayInTimeIntervals,
  // Start and end time of day/session after filter is applied
  obeeAreas: obeeAreas2,
  todaySessions,
  systemTimeInterval,
  sessionFilter,
  fullyBookedSessions,
  tableRowsByArea,
  bookingRefs,
  highlightedBooking,
  placeBookingOnTable
}) => {
  var _a;
  const classes = useStyles$A({ isInSession: false });
  const dragListenerRef = useRef(null);
  const handleOnDropCallback = () => {
    var _a2;
    (_a2 = dragListenerRef.current) == null ? void 0 : _a2.handleOnDrop();
  };
  const [bookingToDrag, setBookingToDrag] = useState(null);
  const hiddenTimelineStatuses = getHiddenTimelineStatuses();
  const timelineStart = todayInTimeIntervals == null ? void 0 : todayInTimeIntervals[0];
  const timelineEnd = todayInTimeIntervals == null ? void 0 : todayInTimeIntervals[(todayInTimeIntervals == null ? void 0 : todayInTimeIntervals.length) - 1];
  const timelineBookings = bookings == null ? void 0 : bookings.filter(
    (booking) => !hiddenTimelineStatuses.includes(booking.status)
  );
  useEffect(() => {
    bookings == null ? void 0 : bookings.forEach((timelineBooking) => {
      var _a2;
      if (isEmpty((_a2 = bookingRefs == null ? void 0 : bookingRefs.current) == null ? void 0 : _a2[timelineBooking == null ? void 0 : timelineBooking.id])) {
        bookingRefs.current[timelineBooking == null ? void 0 : timelineBooking.id] = createRef();
      }
    });
  }, [bookings]);
  const viewBooking = (bookingId) => {
    setObeeBookingDetailsModal(bookingId);
  };
  const handleOnDrop = (cellToDrop, setCellToDrop) => {
    const bookingToUse = bookingToDrag;
    setBookingToDrag(null);
    if (!bookingToUse) {
      return;
    }
    const cellToUse = cellToDrop;
    setCellToDrop(null);
    if (!cellToUse) {
      return;
    }
    cellToUse.style.background = "inherit";
    let cellDataParsed = null;
    try {
      cellDataParsed = JSON.parse(cellToUse.getAttribute("data-cell"));
    } catch {
      return;
    }
    const { tableNumber, areaId, time, isInSession } = cellDataParsed;
    placeBookingOnTable(bookingToUse, tableNumber, areaId, time, isInSession);
  };
  const gridWidth = Math.max(0, (todayInTimeIntervals == null ? void 0 : todayInTimeIntervals.length) - 1) * cellPxWidth;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (_a = obeeAreas2.data) == null ? void 0 : _a.map((area) => {
    const sessionsToUse = todaySessions.filter((session) => session.areaId === area.id);
    const areaRows = tableRowsByArea[area.id];
    const bookedAreaRows = areaRows.filter((row) => !isEmpty(row.tableBookings));
    timelineBookings == null ? void 0 : timelineBookings.filter((booking) => booking.areaId === area.id);
    const areaBlocks = areaRows.reduce((allAreaBlocks, areaRow) => {
      var _a2, _b2;
      if ((_a2 = areaRow == null ? void 0 : areaRow.table) == null ? void 0 : _a2.blocks) {
        return allAreaBlocks.concat((_b2 = areaRow == null ? void 0 : areaRow.table) == null ? void 0 : _b2.blocks);
      }
      return [...allAreaBlocks];
    }, []).filter((block) => block.endTime > timelineStart && block.startTime < timelineEnd);
    const fullyBookedAreaSessions = fullyBookedSessions.data.filter(
      (fullyBookedAreaSession) => fullyBookedAreaSession.fullyBooked && fullyBookedAreaSession.areaId === area.id && (sessionFilter === "all_sessions" || sessionFilter === fullyBookedAreaSession.label)
    );
    const visibleRows = bookingsOnly ? bookedAreaRows : areaRows;
    visibleRows.filter((tableRow) => !tableRow.isPublic);
    const cellRenderer = ({ columnIndex, key, rowIndex, style }) => {
      var _a2, _b2;
      const time = todayInTimeIntervals[columnIndex];
      const isInSession = sessionsToUse.some(
        (session) => time >= session.startTime && time + systemTimeInterval <= session.endTime
      );
      return /* @__PURE__ */ React__default.createElement(
        SchedulerCell$1,
        {
          key,
          style,
          time,
          table: (_a2 = visibleRows[rowIndex]) == null ? void 0 : _a2.table,
          area: (_b2 = visibleRows[rowIndex]) == null ? void 0 : _b2.area,
          isInSession
        }
      );
    };
    return /* @__PURE__ */ React__default.createElement(Box, { key: `scheduler-grid-area-${area.id}` }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.blankRow,
        style: {
          height: `${cellPxHeight}px`
        }
      },
      fullyBookedAreaSessions.map((fullyBookedAreaSession) => {
        return /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.fullyBookContainer,
            style: {
              width: `${(fullyBookedAreaSession.closingTime - fullyBookedAreaSession.openingTime) * minutePxWidth}px`,
              left: `${45 + (fullyBookedAreaSession.openingTime - todayInTimeIntervals[0]) * minutePxWidth}px`
            }
          },
          /* @__PURE__ */ React__default.createElement(Label$1, { className: classes.fullBookLabel, label: "Fully booked" })
        );
      })
    ), !areasToHide.includes(area == null ? void 0 : area.id) && /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.openedBar }, visibleRows.length > 2 && sessionFilter === "all_sessions" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.barText }, "Closed")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaGrid, tabIndex: -1 }, /* @__PURE__ */ React__default.createElement(
      Grid,
      {
        tabIndex: -1,
        cellRenderer,
        columnCount: (todayInTimeIntervals == null ? void 0 : todayInTimeIntervals.length) - 1,
        columnWidth: cellPxWidth,
        width: ((todayInTimeIntervals == null ? void 0 : todayInTimeIntervals.length) - 1) * cellPxWidth,
        rowCount: visibleRows == null ? void 0 : visibleRows.length,
        rowHeight: cellPxHeight,
        height: (visibleRows == null ? void 0 : visibleRows.length) * cellPxHeight,
        style: { outline: "none" }
      }
    ), areaBlocks == null ? void 0 : areaBlocks.map((block) => {
      const tableToBlockIndex = visibleRows == null ? void 0 : visibleRows.findIndex(
        (row) => {
          var _a2;
          return ((_a2 = row == null ? void 0 : row.table) == null ? void 0 : _a2.id) === block.tableId;
        }
      );
      if (tableToBlockIndex > -1) {
        const leftOffset = Math.max(
          0,
          (block.startTime - todayInTimeIntervals[0]) * minutePxWidth
        );
        const maxWidth = gridWidth - leftOffset;
        return /* @__PURE__ */ React__default.createElement(
          BlockedBar$1,
          {
            key: `${block == null ? void 0 : block.id}-${block == null ? void 0 : block.startTime}-${block == null ? void 0 : block.endTime}`,
            top: tableToBlockIndex * cellPxHeight,
            left: leftOffset,
            width: Math.min(
              (block.endTime - block.startTime) * minutePxWidth,
              maxWidth
            ),
            blockedUntil: `${minutesToTimeString(
              block.startTime,
              "h:mma"
            )}-${minutesToTimeString(block.endTime, "h:mma")}`,
            isDragging: !!bookingToDrag,
            cellPxHeight
          }
        );
      }
      return null;
    }), fullyBookedAreaSessions.map((fullyBookedAreaSession) => {
      return visibleRows.map((row, index) => /* @__PURE__ */ React__default.createElement(
        FullyBookBar$1,
        {
          key: `${fullyBookedAreaSession == null ? void 0 : fullyBookedAreaSession.id}_${row == null ? void 0 : row.id}`,
          top: index * cellPxHeight,
          left: (fullyBookedAreaSession.openingTime - todayInTimeIntervals[0]) * minutePxWidth,
          width: (fullyBookedAreaSession.closingTime - fullyBookedAreaSession.openingTime) * minutePxWidth,
          isDragging: !!bookingToDrag,
          cellPxHeight,
          bookedUntil: `${minutesToTimeString(
            fullyBookedAreaSession.openingTime,
            "h:mma"
          )}-${minutesToTimeString(fullyBookedAreaSession.closingTime, "h:mma")}`
        }
      ));
    }), visibleRows.map((areaRow, index) => {
      var _a2;
      return (_a2 = areaRow == null ? void 0 : areaRow.tableBookings) == null ? void 0 : _a2.map((booking) => /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: `scrollRef-${booking == null ? void 0 : booking.id}`,
          ref: bookingRefs.current[booking.id],
          style: {
            position: "absolute",
            top: index * cellPxHeight - 100,
            left: (booking.time - todayInTimeIntervals[0]) * minutePxWidth,
            height: "200px",
            width: booking.duration * minutePxWidth,
            pointerEvents: "none",
            zIndex: 50
            // outline: '2px solid blue',
          }
        },
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            style: {
              marginTop: "100px",
              padding: "2px",
              height: "40px",
              width: booking.duration * minutePxWidth + 4,
              marginLeft: "-2px",
              outline: highlightedBooking && (highlightedBooking == null ? void 0 : highlightedBooking.id) === (booking == null ? void 0 : booking.id) ? "3px solid black" : "none"
            }
          }
        )
      ));
    }), visibleRows.map((areaRow, index) => {
      var _a2;
      return (_a2 = areaRow == null ? void 0 : areaRow.tableBookings) == null ? void 0 : _a2.map((booking) => {
        var _a3, _b2, _c2, _d2, _e2;
        if (((_a3 = booking.tableNumbers) == null ? void 0 : _a3.length) > 1) {
          const parentTableNumber = booking.tableNumbers[0];
          if (parentTableNumber === ((_b2 = areaRow == null ? void 0 : areaRow.table) == null ? void 0 : _b2.tableNumber)) {
            return /* @__PURE__ */ React__default.createElement(
              BookingBar$1,
              {
                key: `${parentTableNumber}_parent_${booking == null ? void 0 : booking.id}`,
                booking,
                bookingToDrag,
                bookingIdToView: obeeBookingDetailsModal.bookingId,
                top: index * cellPxHeight,
                left: (booking.time - todayInTimeIntervals[0]) * minutePxWidth,
                setBookingToDrag,
                viewBooking,
                width: booking.duration * minutePxWidth,
                handleOnDrop: handleOnDropCallback,
                cellPxHeight,
                timelineTableNumber: parentTableNumber
              }
            );
          }
          return /* @__PURE__ */ React__default.createElement(
            BookingBar$1,
            {
              key: `${parentTableNumber}_child_${(_c2 = areaRow == null ? void 0 : areaRow.table) == null ? void 0 : _c2.tableNumber}_${booking.id}`,
              parentTableNumber,
              booking,
              bookingToDrag,
              bookingIdToView: obeeBookingDetailsModal.bookingId,
              top: index * cellPxHeight,
              left: (booking.time - todayInTimeIntervals[0]) * minutePxWidth,
              setBookingToDrag,
              viewBooking,
              width: booking.duration * minutePxWidth,
              handleOnDrop: handleOnDropCallback,
              cellPxHeight,
              timelineTableNumber: (_d2 = areaRow == null ? void 0 : areaRow.table) == null ? void 0 : _d2.tableNumber
            }
          );
        }
        if (((_e2 = booking == null ? void 0 : booking.tableNumbers) == null ? void 0 : _e2.length) === 0) {
          return /* @__PURE__ */ React__default.createElement(
            BookingBar$1,
            {
              key: booking.id,
              booking,
              bookingToDrag,
              bookingIdToView: obeeBookingDetailsModal.bookingId,
              top: index * cellPxHeight,
              left: (booking.time - todayInTimeIntervals[0]) * minutePxWidth,
              setBookingToDrag,
              viewBooking,
              width: booking.duration * minutePxWidth,
              handleOnDrop: handleOnDropCallback,
              cellPxHeight,
              timelineTableNumber: booking.tableNumber
            }
          );
        }
        return /* @__PURE__ */ React__default.createElement(
          BookingBar$1,
          {
            key: booking.id,
            booking,
            bookingToDrag,
            bookingIdToView: obeeBookingDetailsModal.bookingId,
            top: index * cellPxHeight,
            left: (booking.time - todayInTimeIntervals[0]) * minutePxWidth,
            setBookingToDrag,
            viewBooking,
            width: booking.duration * minutePxWidth,
            handleOnDrop: handleOnDropCallback,
            cellPxHeight,
            timelineTableNumber: booking.tableNumber
          }
        );
      });
    })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.closedBar }, visibleRows.length > 2 && sessionFilter === "all_sessions" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.barText }, "Closed"))));
  }), /* @__PURE__ */ React__default.createElement(
    DragListener$1,
    {
      bookingToDrag,
      handleOnDrop,
      ref: dragListenerRef
    }
  ));
};
SchedulerGrid.defaultProps = {
  highlightedBooking: null
};
SchedulerGrid.propTypes = {
  obeeBookingDetailsModal: PropTypes.shape({
    bookingId: PropTypes.number,
    defaultTab: PropTypes.string
  }).isRequired,
  setObeeBookingDetailsModal: PropTypes.func.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  bookings: PropTypes.arrayOf(obeeBookingPropTypes).isRequired,
  areasToHide: PropTypes.arrayOf(PropTypes.number).isRequired,
  bookingsOnly: PropTypes.bool.isRequired,
  todayInTimeIntervals: PropTypes.arrayOf(PropTypes.number).isRequired,
  cellPxWidth: PropTypes.number.isRequired,
  cellPxHeight: PropTypes.number.isRequired,
  minutePxWidth: PropTypes.number.isRequired,
  todaySessions: PropTypes.arrayOf(sessionPropTypes).isRequired,
  systemTimeInterval: PropTypes.number.isRequired,
  sessionFilter: PropTypes.string.isRequired,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired,
  tableRowsByArea: PropTypes.shape({}).isRequired,
  highlightedBooking: obeeBookingPropTypes,
  placeBookingOnTable: PropTypes.func.isRequired
};
const mapStateToProps$11 = (state) => ({
  obeeBookingDetailsModal: state.obeeScreen.bookingDetailsModal,
  obeeAreas: state.areas,
  sessionFilter: state.obeeScreen.sessionFilter,
  fullyBookedSessions: state.fullyBookedSessions
});
const mapDispatchToProps$10 = (dispatch) => bindActionCreators(
  {
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction,
    updateBooking: updateObeeBookingAction
  },
  dispatch
);
const SchedulerGrid$1 = connect(mapStateToProps$11, mapDispatchToProps$10)(SchedulerGrid);
const useStyles$v = createUseStyles((theme2) => ({
  container: {
    alignItems: "center",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    pointerEvents: "none",
    transition: "left 0.5s",
    top: 0,
    bottom: 0
  },
  timeLabel: {
    alignItems: "center",
    background: theme2.colors.labelBackground,
    borderRadius: "6px",
    color: theme2.colors.timelineGreen,
    display: "flex",
    fontWeight: theme2.fontWeights.medium,
    justifyContent: "center",
    width: "78px",
    height: "28px",
    position: "sticky",
    top: "25px",
    zIndex: 60
  },
  timeLine: {
    background: theme2.colors.timelineGreen,
    width: "1px",
    position: "sticky"
  }
}));
const TimeMarker = ({ startTime, endTime, minutePxWidth, date, sessionFilter }) => {
  const classes = useStyles$v();
  const ref = useRef(null);
  const isToday = date == null ? void 0 : date.isSame(moment$2(), "day");
  const [currentTime, setCurrentTime] = useState(formatIntFromTime(moment$2()));
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(formatIntFromTime(moment$2()));
    }, 1e3);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (ref.current && isToday) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center"
      });
    }
  }, [isToday, sessionFilter]);
  if (!isToday) {
    return null;
  }
  if (currentTime < startTime || currentTime > endTime) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.container,
      style: { left: `${(currentTime - startTime) * minutePxWidth - 40 + 45}px` },
      ref
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeLabel }, moment$2().format("h:mma")),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.timeLine, style: { height: "12px", top: "52px", zIndex: 60 } }),
    /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.timeLine,
        style: { height: "calc(100dvh - 128px)", top: "64px", zIndex: 30 }
      }
    )
  );
};
TimeMarker.defaultProps = {
  date: null
};
TimeMarker.propTypes = {
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  minutePxWidth: PropTypes.number.isRequired,
  date: momentPropTypes.momentObj,
  sessionFilter: PropTypes.string.isRequired
};
const mapStateToProps$10 = (state) => ({
  date: state.obeeScreen.date,
  sessionFilter: state.obeeScreen.sessionFilter
});
const mapDispatchToProps$$ = (dispatch) => bindActionCreators({}, dispatch);
const TimeMarker$1 = connect(mapStateToProps$10, mapDispatchToProps$$)(TimeMarker);
const useStyles$u = createUseStyles((theme2) => ({
  invertedLip: {
    position: "absolute",
    top: "0",
    right: "-25px",
    height: "25px",
    width: "25px",
    background: theme2.colors.linen,
    // flexShrink: 0,
    "&::before": {
      content: '""',
      position: "absolute",
      backgroundColor: "transparent",
      bottom: "-25px",
      height: "25px",
      width: "25px",
      borderTopLeftRadius: "25px",
      boxShadow: `1px -25px 0 0 ${theme2.colors.white}`
    }
  },
  areaContainer: {
    alignItems: "flex-end",
    display: "flex",
    fontWeight: theme2.fontWeights.medium,
    height: "64px",
    padding: "10px 20px",
    position: "sticky",
    top: 0,
    background: theme2.colors.linen,
    borderBottom: `1px solid ${theme2.colors.cloud}`,
    zIndex: 80
  },
  areaList: {
    backgroundColor: theme2.colors.linen,
    borderLeft: `1px solid ${theme2.colors.grayBorder}`,
    borderRight: `1px solid ${theme2.colors.grayBorder}`,
    borderTopLeftRadius: "24px",
    display: "flex",
    flexDirection: "column",
    left: 0,
    position: "sticky",
    width: `${theme2.components.timeline.sidebarWidth}px`,
    zIndex: 70,
    flexShrink: 0
  },
  areaDetails: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    width: "100%"
  },
  caretContainer: {
    alignItems: "center",
    borderRadius: "100%",
    display: "flex",
    height: "19px",
    justifyContent: "center",
    transition: "background 0.1s, transform 0.1s",
    width: "19px",
    "&:hover": {
      background: theme2.colors.linen,
      cursor: "pointer"
    }
  },
  scrollContainer: {
    overflow: "auto",
    height: `calc(100dvh - ${headerHeight$4}px)`,
    userSelect: "none",
    position: "relative",
    [`@media (max-width: ${mobileHeaderBreakpoint}px)`]: {
      height: `calc(100dvh - ${mobileHeaderHeight}px)`
    }
  },
  container: {
    background: theme2.colors.white,
    display: "flex",
    width: "fit-content",
    minHeight: "100%",
    fontSize: "15px",
    position: "relative"
  },
  halfHourContainer: {
    alignItems: "center",
    color: theme2.colors.smoke,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    justifyContent: "center"
  },
  headerCell: {
    alignItems: "flex-end",
    background: theme2.colors.white,
    display: "flex",
    fontWeight: theme2.fontWeights.medium,
    justifyContent: "space-between",
    padding: "4px 4px 4px 20px",
    position: "relative",
    borderBottom: `1px solid ${theme2.colors.shark}`,
    borderRadius: "24px 0 0",
    userSelect: "none"
  },
  hourContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    justifyContent: "center"
  },
  hourNotch: {
    backgroundColor: theme2.colors.charcoal,
    height: "6px",
    width: "1px"
  },
  pageContainer: {
    height: `calc(100dvh - ${headerHeight$4}px)`,
    display: "flex",
    flexDirection: "row",
    left: 0,
    [`@media (max-width: ${mobileHeaderBreakpoint}px)`]: {
      height: `calc(100dvh - ${mobileHeaderHeight}px)`
    }
  },
  leftPanel: {
    backgroundColor: theme2.colors.linen,
    // borderRight: `1px solid ${theme.colors.grayBorder}`,
    display: "flex",
    flexDirection: "column",
    left: 0,
    position: "sticky",
    width: `${theme2.components.timeline.sidebarWidth}px`,
    zIndex: 70,
    flexShrink: 0
  },
  sidebarContainer: {
    position: "sticky",
    top: 0,
    backgroundColor: theme2.colors.linen,
    // borderRight: `1px solid ${theme.colors.cloud}`,
    // height: '100%',
    // width: `${theme.components.floorplan.sidebarWidth}px`,
    // overflowY: 'hidden',
    zIndex: 100,
    flexShrink: 0
  },
  tableCellOuter: {
    padding: "8px 4px",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    width: "100%",
    borderBottom: `1px solid ${theme2.colors.cloud}`
  },
  tableCellInner: {
    borderRadius: "8px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    padding: "6px 0 6px 6px",
    transition: "background 0.1s",
    gap: "4px",
    width: "100%",
    "&:hover": {
      background: theme2.colors.alabaster,
      cursor: "pointer"
    }
  },
  tableCellSegmentOuter: {
    position: "relative",
    gap: "4px",
    display: "flex",
    alignItems: "center",
    overflow: "hidden"
  },
  tableCellSegmentInner: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flexGrow: 1
  },
  tableCellOverflow: {
    color: theme2.colors.smoke,
    cursor: "pointer",
    marginLeft: "auto",
    display: "flex",
    transition: "visibility 0.1s",
    visibility: "hidden",
    padding: "4px"
  },
  tableColumns: {
    display: "grid",
    position: "relative"
  },
  tableContainer: {
    position: "relative",
    paddingRight: "400px"
  },
  tableRows: {
    background: theme2.colors.white,
    display: "grid"
  },
  areaRowCellInner: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    padding: "6px 12px",
    gap: "4px",
    width: "100%"
  },
  timeBarContainer: {
    display: "grid",
    height: "64px",
    position: "sticky",
    top: "0",
    background: theme2.colors.white,
    borderBottom: `1px solid ${theme2.colors.cloud}`,
    zIndex: 60
  },
  timeGroupingText: {
    fontWeight: theme2.fontWeights.medium,
    width: "max-content",
    marginTop: "50px",
    marginBottom: "auto"
  },
  timeSegment: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column"
  },
  areasFilter: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    padding: "4px 8px",
    marginLeft: "-8px",
    borderRadius: "6px",
    transition: "background 0.1s",
    "&:hover": {
      cursor: "pointer",
      background: theme2.colors.alabaster
    }
  },
  noSessionsOverlay: {
    alignItems: "center",
    background: "rgba(255, 255, 255, 0.75)",
    // TODO get from theme
    bottom: 0,
    color: theme2.colors.smoke,
    display: "flex",
    fontSize: theme2.fontSizes.h4,
    fontWeight: theme2.fontWeights.medium,
    justifyContent: "center",
    left: 0,
    paddingBottom: "128px",
    position: "fixed",
    right: 0,
    top: `${headerHeight$4}px`,
    zIndex: 200
  }
}));
const Scheduler = ({
  date,
  obeeAreas: obeeAreas2,
  obeeBookings: obeeBookings2,
  obeeSessions: obeeSessions2,
  obeeSettings: obeeSettings2,
  obeeTables: obeeTables2,
  sessionFilter,
  restaurant,
  updateBooking
}) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$u();
  const [bookingsOnly, setBookingsOnly] = useState(false);
  const [bookingsOnlyAnchorEl, setBookingsOnlyAnchorEl] = useState(null);
  const [tableToBlock, setTableToBlock] = useState(null);
  const [tableToBlockAnchorEl, setTableToBlockAnchorEl] = useState(null);
  const [focusedArea, setFocusedArea] = useState(null);
  const [activeTab, setActiveTab] = useState("bookings");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const scrollToTable = useRef(false);
  const [messagesAnchor, setMessagesAnchor] = useState(null);
  const [highlightedBooking, setHighlightedBooking] = useState(null);
  const [draggedBooking, setDraggedBooking] = useState(null);
  const draggedBookingElementRef = useRef(null);
  const cellToDropRef = useRef(null);
  const [showGeneralErrorModal, setShowGeneralErrorModal] = useState(false);
  const [generalErrorPrompt, setGeneralErrorPrompt] = useState("Table has conflicting bookings.");
  const [showShortBookingTimeModal, setShowShortBookingTimeModal] = useState(false);
  const [shortBookingTimeData, setShortBookingTimeData] = useState(null);
  const [showTableCapacityModal, setShowTableCapacityModal] = useState(false);
  const [tableCapacityData, setTableCapacityData] = useState(null);
  const [showSwapBookingsModal, setShowSwapBookingsModal] = useState(false);
  const [swapBookingsData, setSwapBookingsData] = useState(null);
  const systemTimeInterval = (_a = obeeSettings2.data) == null ? void 0 : _a.systemTimeInterval;
  const cellPxWidth = 57;
  const cellPxHeight = 41;
  const minutePxWidth = cellPxWidth / systemTimeInterval;
  const [areasToHide, setAreasToHide] = useState([]);
  const bookingRefs = useRef({});
  const loadingSessions = obeeSessions2 == null ? void 0 : obeeSessions2.pending;
  const todaySessions = useMemo(() => {
    return getTodaySessions(date, obeeSessions2, sessionFilter);
  }, [obeeSessions2.data, date, sessionFilter]);
  const filteredBookings = useMemo(() => {
    return getBookingsForSessions(
      obeeBookings2.data,
      todaySessions,
      true,
      sessionFilter === "all_sessions"
    ).filter((booking) => isEmpty(focusedArea) || (booking == null ? void 0 : booking.areaId) === focusedArea).filter((booking) => (booking == null ? void 0 : booking.date) === formatDate(date, "YYYY-MM-DD"));
  }, [todaySessions, obeeBookings2.data]);
  const openingSession = todaySessions == null ? void 0 : todaySessions.reduce(
    (prev, curr) => prev.startTime < curr.startTime ? prev : curr,
    {}
  );
  const closingSession = todaySessions == null ? void 0 : todaySessions.reduce(
    (prev, curr) => prev.endTime > curr.endTime ? prev : curr,
    {}
  );
  const openingTime = (openingSession == null ? void 0 : openingSession.startTime) || 0;
  const closingTime = (closingSession == null ? void 0 : closingSession.endTime) || 1440;
  const todayInTimeIntervals = numberRange(openingTime, closingTime, systemTimeInterval, true);
  const isClosed = closedEarlyToday(restaurant, date) || !isEmpty(todaySessions) && (openingSession == null ? void 0 : openingSession.startTime) === (closingSession == null ? void 0 : closingSession.endTime);
  const noSessions = !loadingSessions && isEmpty(todaySessions);
  const toggleHide = (id) => {
    if (areasToHide.includes(id)) {
      setAreasToHide(areasToHide.filter((areaToHide) => areaToHide !== id));
    } else {
      setAreasToHide([...areasToHide, id]);
    }
  };
  const hiddenTimelineStatuses = getHiddenTimelineStatuses();
  const now2 = formatIntFromTime(moment$2());
  useEffect(() => {
    var _a2, _b3, _c2, _d2, _e2;
    if (selectedBooking && scrollToTable.current) {
      if ((_b3 = (_a2 = bookingRefs.current) == null ? void 0 : _a2[selectedBooking == null ? void 0 : selectedBooking.id]) == null ? void 0 : _b3.current) {
        (_e2 = (_d2 = (_c2 = bookingRefs.current) == null ? void 0 : _c2[selectedBooking == null ? void 0 : selectedBooking.id]) == null ? void 0 : _d2.current) == null ? void 0 : _e2.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
      scrollToTable.current = false;
    }
  }, [selectedBooking, scrollToTable.current, bookingRefs == null ? void 0 : bookingRefs.current]);
  const selectBookingFromList = useCallback(
    (booking) => {
      setSelectedBooking(booking);
      scrollToTable.current = true;
    },
    [filteredBookings]
  );
  const tableRowsByArea = useMemo(() => {
    const getTableRowsForArea = (area) => {
      var _a2, _b3;
      const isNoTableArea = isAreaCapacityBased(area, obeeTables2.data);
      if (isNoTableArea) {
        const areaBookings = filteredBookings.filter((booking) => (booking == null ? void 0 : booking.areaId) === (area == null ? void 0 : area.id));
        const bookingRows = fitIntoRows(areaBookings, "startTime", "endTime");
        const getEmptyRowData = (index = -1, bookingRow = []) => ({
          name: `${index}`,
          id: index,
          area,
          tableBookings: bookingRow,
          type: "capacity",
          isPublic: true
          // TODO allow areas to be private
        });
        if (isEmpty(areaBookings)) {
          return [getEmptyRowData()];
        }
        return [
          ...bookingRows.map((bookingRow, index) => getEmptyRowData(index, bookingRow)),
          getEmptyRowData()
          // Add an extra row so it's easy to add bookings at the same time as other bookings
        ];
      }
      return (_b3 = (_a2 = obeeTables2.data) == null ? void 0 : _a2.filter((table) => table.areaId === area.id && !table.isJoin)) == null ? void 0 : _b3.sort((a, b) => sortAlphaNumericByProperty(a, b, "tableNumber")).map((table) => {
        const tableBookings = filteredBookings == null ? void 0 : filteredBookings.filter((booking) => {
          if (hiddenTimelineStatuses.includes(booking.status)) {
            return false;
          }
          return isTableForBooking(table, booking);
        });
        return {
          type: "table",
          id: table == null ? void 0 : table.id,
          table,
          tableBookings,
          isPublic: table == null ? void 0 : table.isPublic
        };
      });
    };
    return obeeAreas2.data.reduce((accum, area) => {
      return { ...accum, [area.id]: getTableRowsForArea(area) };
    }, {});
  }, [obeeAreas2.data, obeeTables2.data, filteredBookings, hiddenTimelineStatuses]);
  const attemptSwap = (bookingToCheck, tableBookings, table, time) => {
    const seatableStatuses = getSeatableStatuses();
    const bookingToSwap = tableBookings == null ? void 0 : tableBookings.find(
      (booking) => time === booking.time && booking.id !== bookingToCheck.id && seatableStatuses.includes(booking.status)
    );
    if (bookingToSwap) {
      const bookingToCheckConflict = getSwapConflict(
        bookingToCheck,
        bookingToSwap,
        obeeTables2,
        filteredBookings
      );
      const bookingToSwapConflict = getSwapConflict(
        bookingToSwap,
        bookingToCheck,
        obeeTables2,
        filteredBookings
      );
      const isValidSwap = !bookingToCheckConflict && !bookingToSwapConflict;
      if (isValidSwap) {
        setShowSwapBookingsModal(true);
        setSwapBookingsData({ booking: bookingToCheck, bookingToSwap });
      } else {
        setShowGeneralErrorModal(true);
        setGeneralErrorPrompt("One or more bookings breach multiple conflicting rules.");
      }
      return true;
    }
    return false;
  };
  const attemptPlaceBookingOnNewTable = (bookingToUse, tableNumber, areaId, time, isInSession) => {
    const table = findObjectByProperty(obeeTables2.data, `${tableNumber}`, "tableNumber");
    const area = findObjectByProperty(obeeAreas2.data, areaId, "id");
    if (time === bookingToUse.time && isTableForBooking(table, bookingToUse)) {
      return;
    }
    if (!isInSession) {
      setShowGeneralErrorModal(true);
      setGeneralErrorPrompt(
        `There is no session for table ${table == null ? void 0 : table.tableNumber} at ${formatTimeFromInt(time)}.`
      );
      return;
    }
    const block = getTableBlockForTime(table, time);
    if (block) {
      setShowGeneralErrorModal(true);
      setGeneralErrorPrompt(`Table is blocked till ${formatTimeFromInt(block.endTime)}.`);
      return;
    }
    if (isEmpty(table)) {
      const exceedsAreaCapacityConflict = exceedsAreaCapacity(bookingToUse, area);
      if (exceedsAreaCapacityConflict) {
        setShowTableCapacityModal(true);
        setTableCapacityData({
          booking: bookingToUse,
          conflict: area,
          over: { areaId: area.id, tableNumber: null, time }
        });
        return;
      }
      updateBooking({
        ...bookingToUse,
        areaId: area.id,
        tableNumber: null,
        time
      });
      return;
    }
    const tableBookings = filteredBookings == null ? void 0 : filteredBookings.filter(
      (booking) => booking.tableNumbers.includes(table == null ? void 0 : table.tableNumber)
    );
    if (isTableInUse(bookingToUse, tableBookings, time)) {
      setShowGeneralErrorModal(true);
      setGeneralErrorPrompt("Table has conflicting bookings.");
      return;
    }
    if (attemptSwap(bookingToUse, tableBookings, table, time)) {
      return;
    }
    const exceedsTableCapacityConflict = exceedsTableCapacity(bookingToUse, table);
    if (exceedsTableCapacityConflict) {
      setShowTableCapacityModal(true);
      setTableCapacityData({
        booking: bookingToUse,
        conflict: table,
        over: { areaId: table.areaId, tableNumber: table.tableNumber, time }
      });
      return;
    }
    todaySessions.filter((session) => session.areaId === table.areaId);
    const shortBookingConflict = getShortBookingConflict(
      bookingToUse,
      tableBookings,
      table,
      time
    );
    if (shortBookingConflict) {
      setShowShortBookingTimeModal(true);
      setShortBookingTimeData({
        booking: bookingToUse,
        conflict: shortBookingConflict,
        over: { areaId: table.areaId, tableNumber: table.tableNumber, time }
      });
      return;
    }
    updateBooking({
      ...bookingToUse,
      status: (bookingToUse == null ? void 0 : bookingToUse.status) === STATUS_TYPES.WAITING ? STATUS_TYPES.BOOKED : bookingToUse == null ? void 0 : bookingToUse.status,
      areaId: table == null ? void 0 : table.areaId,
      tableNumber: table == null ? void 0 : table.tableNumber,
      time
    });
  };
  const onStartDraggingBooking = (booking, e) => {
    setDraggedBooking(booking);
    const bookingToDragEl = e.target.closest("[data-booking]") || draggedBookingElementRef.current;
    if (bookingToDragEl) {
      draggedBookingElementRef.current = bookingToDragEl;
    }
    if (!bookingToDragEl) {
      return;
    }
    let { x, y } = bookingToDragEl.getBoundingClientRect();
    x += 10;
    y += 20;
    const cell = document.elementsFromPoint(x, y).find((element) => element.getAttribute("data-cell") !== null);
    if (cell !== cellToDropRef.current) {
      if (cell) {
        cell.style.background = theme2.colors.cloud;
      }
      if (cellToDropRef.current) {
        cellToDropRef.current.style.background = cellToDropRef.current.getAttribute("data-background");
      }
    }
    cellToDropRef.current = cell;
  };
  const onStopDraggingBooking = (booking, e) => {
    setDraggedBooking(null);
    draggedBookingElementRef.current = null;
    if (cellToDropRef.current) {
      cellToDropRef.current.style.background = cellToDropRef.current.getAttribute("data-background");
    }
    let cellDataParsed = null;
    try {
      cellDataParsed = JSON.parse(cellToDropRef.current.getAttribute("data-cell"));
    } catch {
      return;
    }
    const { tableNumber, areaId, time, isInSession } = cellDataParsed;
    if (!isEmpty(booking) && !isEmpty(cellToDropRef.current)) {
      attemptPlaceBookingOnNewTable(booking, tableNumber, areaId, time, isInSession);
    }
    cellToDropRef.current = null;
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sidebarContainer }, /* @__PURE__ */ React__default.createElement(
    BookingsSidebar$1,
    {
      selectedBooking,
      onStartDragging: onStartDraggingBooking,
      onStopDragging: onStopDraggingBooking,
      selectBooking: selectBookingFromList,
      setHighlightedTable: setHighlightedBooking,
      activeTab,
      setActiveTab,
      loading: false,
      draggedBooking,
      bookings: filteredBookings,
      messagesAnchor,
      setMessagesAnchor: (e) => {
        if (isVoid(e)) {
          setSelectedBooking(null);
        }
        setMessagesAnchor(e);
      },
      focusedArea: (focusedArea == null ? void 0 : focusedArea.id) ?? null,
      setFocusedArea: (newFocusedAreaId) => setFocusedArea(findObjectByProperty(obeeAreas2.data, newFocusedAreaId, "id")),
      thinDraggedBookings: true
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.scrollContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.leftPanel }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.invertedLip }), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.areasFilter,
      onClick: (e) => setBookingsOnlyAnchorEl(e.currentTarget)
    },
    /* @__PURE__ */ React__default.createElement(Box, null, bookingsOnly ? "Filtered" : "Filter"),
    /* @__PURE__ */ React__default.createElement(
      DownCaretSVG,
      {
        style: {
          width: "10px",
          height: "10px",
          transform: bookingsOnlyAnchorEl && "rotate(180deg)",
          transition: "transform 0.1s"
        }
      }
    )
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaList }, (_b2 = obeeAreas2.data) == null ? void 0 : _b2.map((area) => {
    const areaHide = areasToHide.includes(area == null ? void 0 : area.id);
    const areaTables = tableRowsByArea[area == null ? void 0 : area.id];
    return /* @__PURE__ */ React__default.createElement(Box, { key: `freeze-pane-area-${area.id}` }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.headerCell,
        style: {
          height: `${cellPxHeight}px`
        }
      },
      /* @__PURE__ */ React__default.createElement(
        Box,
        {
          style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          title: area.name
        },
        area.name
      ),
      /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.caretContainer,
          onClick: () => toggleHide(area.id),
          style: {
            transform: areasToHide.includes(area.id) && "rotate(180deg)"
          }
        },
        /* @__PURE__ */ React__default.createElement(DownCaretSVG, { style: { width: "10px", height: "10px" } })
      )
    ), !areaHide && (areaTables == null ? void 0 : areaTables.map((row) => {
      const { tableBookings } = row;
      if (bookingsOnly && (tableBookings == null ? void 0 : tableBookings.length) === 0) {
        return null;
      }
      const table = row == null ? void 0 : row.table;
      if (!table) {
        return /* @__PURE__ */ React__default.createElement(
          Box,
          {
            key: `freeze-pane-table-area-${area.id}-${row == null ? void 0 : row.id}`,
            className: classes.tableCellOuter,
            style: { height: `${cellPxHeight}px` }
          },
          /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaRowCellInner }, /* @__PURE__ */ React__default.createElement(
            Box,
            {
              className: classes.tableCellSegmentOuter,
              style: { overflow: "visible" }
            },
            /* @__PURE__ */ React__default.createElement(
              GuestSVG,
              {
                style: { flexShrink: 0, height: "15px", width: "15px" }
              }
            ),
            /* @__PURE__ */ React__default.createElement(Box, { style: { whiteSpace: "nowrap" } }, "Max ", area.capacity)
          ))
        );
      }
      const isBlocked = getTableBlockForTime(row == null ? void 0 : row.table, now2);
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: `freeze-pane-table-${table.id}`,
          className: classes.tableCellOuter,
          style: { height: `${cellPxHeight}px` }
        },
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.tableCellInner,
            onClick: (e) => {
              setTableToBlock(table);
              setTableToBlockAnchorEl(e.currentTarget);
            },
            style: {
              background: tableToBlock === table && tableToBlockAnchorEl && theme2.colors.alabaster
            }
          },
          /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableCellSegmentOuter }, /* @__PURE__ */ React__default.createElement(
            Box,
            {
              className: classes.tableCellSegmentInner,
              title: table.tableNumber
            },
            table.tableNumber
          ), isBlocked && /* @__PURE__ */ React__default.createElement(
            IconBlockSVG,
            {
              style: { flexShrink: 0, height: "15px", width: "15px" }
            }
          )),
          /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableCellSegmentOuter }, /* @__PURE__ */ React__default.createElement(
            GuestSVG,
            {
              style: { flexShrink: 0, height: "15px", width: "15px" }
            }
          ), /* @__PURE__ */ React__default.createElement(Box, { style: { whiteSpace: "nowrap" } }, table.minSeats, "-", table.maxSeats))
        )
      );
    })));
  }))), isClosed || noSessions ? /* @__PURE__ */ React__default.createElement(Box, { className: classes.noSessionsOverlay }, `You ${noSessions ? "have no sessions" : "are closed"}  ${isCurrentDate(date) ? "today" : "for this date"}`) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableContainer }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.timeBarContainer,
      style: {
        gridTemplateColumns: `repeat(${todayInTimeIntervals.length}, ${cellPxWidth}px)`,
        marginLeft: `${45 - cellPxWidth}px`
      }
    },
    todayInTimeIntervals == null ? void 0 : todayInTimeIntervals.map((time) => {
      const isHour = time % 60 === 0;
      return /* @__PURE__ */ React__default.createElement(Box, { key: `time-segment-${time}`, className: classes.timeSegment }, /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: isHour ? classes.hourContainer : classes.halfHourContainer,
          style: { transform: `translateX(${cellPxWidth / 2}px)` }
        },
        /* @__PURE__ */ React__default.createElement(Box, null, isHour ? minutesToTimeString(time, "ha") : time % 60),
        /* @__PURE__ */ React__default.createElement(Box, { className: isHour ? classes.hourNotch : null })
      ));
    })
  ), todayInTimeIntervals.length > 0 && /* @__PURE__ */ React__default.createElement(
    TimeMarker$1,
    {
      startTime: todayInTimeIntervals[0],
      endTime: todayInTimeIntervals[todayInTimeIntervals.length - 1],
      minutePxWidth
    }
  ), /* @__PURE__ */ React__default.createElement(
    SchedulerGrid$1,
    {
      areasToHide,
      bookingsOnly,
      systemTimeInterval,
      cellPxWidth,
      cellPxHeight,
      minutePxWidth,
      todayInTimeIntervals,
      todaySessions,
      bookings: filteredBookings,
      tableRowsByArea,
      bookingRefs,
      highlightedBooking,
      draggedWaitlistBooking: draggedBooking,
      placeBookingOnTable: attemptPlaceBookingOnNewTable
    }
  )), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      isOpen: !!bookingsOnlyAnchorEl,
      onClose: () => setBookingsOnlyAnchorEl(null),
      anchor: bookingsOnlyAnchorEl,
      items: [
        {
          onClick: () => setBookingsOnly(false),
          label: "All areas and tables"
        },
        {
          onClick: () => setBookingsOnly(true),
          label: "Tables with bookings only"
        }
      ],
      style: { item: { fontSize: "16px" } }
    }
  ), /* @__PURE__ */ React__default.createElement(
    BlockTablePopover$1,
    {
      anchorEl: tableToBlockAnchorEl,
      onClose: () => setTableToBlockAnchorEl(null),
      table: tableToBlock,
      closingTime,
      systemTimeInterval,
      todaySessions
    }
  ), /* @__PURE__ */ React__default.createElement(
    SendMessagePopover$1,
    {
      anchor: messagesAnchor,
      setAnchor: setMessagesAnchor,
      booking: selectedBooking
    }
  ), /* @__PURE__ */ React__default.createElement(
    GeneralErrorModal$1,
    {
      isOpen: showGeneralErrorModal,
      onClose: () => setShowGeneralErrorModal(false),
      prompt: generalErrorPrompt,
      confirmLabel: "Okay, got it"
    }
  ), /* @__PURE__ */ React__default.createElement(
    TableCapacityModal$1,
    {
      isOpen: showTableCapacityModal,
      onClose: () => setShowTableCapacityModal(false),
      onConfirm: (bookingToUpdate) => updateBooking(bookingToUpdate),
      tableCapacityData
    }
  ), /* @__PURE__ */ React__default.createElement(
    ShortBookingTimeModal$1,
    {
      isOpen: showShortBookingTimeModal,
      onClose: () => setShowShortBookingTimeModal(false),
      onConfirm: (bookingToUpdate) => updateBooking(bookingToUpdate),
      shortBookingTimeData
    }
  ), /* @__PURE__ */ React__default.createElement(
    SwapBookingsModal$1,
    {
      isOpen: showSwapBookingsModal,
      onClose: () => setShowSwapBookingsModal(false),
      onConfirm: (bookingsToUpdate) => bookingsToUpdate.forEach((bookingToUpdate) => updateBooking(bookingToUpdate)),
      swapBookingsData
    }
  ))));
};
Scheduler.propTypes = {
  date: momentPropTypes.momentObj.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  obeeBookings: obeeBookingsPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  obeeTables: tablesPropTypes.isRequired,
  sessionFilter: PropTypes.string.isRequired,
  restaurant: restaurantPropTypes.isRequired
};
const mapStateToProps$$ = (state) => ({
  obeeAreas: state.areas,
  obeeBookings: state.obeeBookings,
  obeeSessions: state.obeeSessions,
  obeeSettings: state.obeeSettings,
  obeeTables: state.tables,
  sessionFilter: state.obeeScreen.sessionFilter,
  restaurant: state.restaurantActive.restaurant
});
const mapDispatchToProps$_ = (dispatch) => bindActionCreators(
  {
    updateBooking: updateObeeBookingAction
  },
  dispatch
);
const Scheduler$1 = connect(mapStateToProps$$, mapDispatchToProps$_)(Scheduler);
const Timeline$1 = ({ date }) => {
  const loading = useFetchBookingsData();
  if (loading || isEmpty(date)) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(Scheduler$1, { date });
};
Timeline$1.defaultProps = {
  date: null
};
Timeline$1.propTypes = {
  date: momentPropTypes.momentObj
};
const mapStateToProps$_ = (state) => ({
  date: state.obeeScreen.date
});
const mapDispatchToProps$Z = (dispatch) => bindActionCreators({}, dispatch);
const TimelineScreen = connect(mapStateToProps$_, mapDispatchToProps$Z)(Timeline$1);
const fetchMonthlyViewAction = (date = null) => (dispatch) => {
  const action = "FETCH_OBEE_MONTHLY_VIEW";
  const data = {
    date: date ? formatDate(date, "YYYY-MM") : null
  };
  const request = () => fetchMonthlyView(data);
  dispatch(makeApiAction(action, request, {}, "monthlyView"));
};
const Skeleton = ({ children, style, onClick, height, ...other }) => {
  const theme2 = useTheme$1();
  return /* @__PURE__ */ React__default.createElement(
    Skeleton$1,
    {
      height,
      style: {
        skeleton: {
          backgroundColor: theme2.colors.loadingShimmer
        }
      },
      ...other
    }
  );
};
Skeleton.defaultProps = {
  children: null,
  style: {},
  onClick: () => {
  },
  height: 200
};
Skeleton.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
  height: PropTypes.number
};
const useStyles$t = createUseStyles(
  (theme2) => ({
    container: {
      minHeight: "200px",
      maxHeight: "280px"
    },
    calendarDay: {
      position: "relative",
      zIndex: 1,
      [theme2.breakpoints.down("md")]: {
        color: `${theme2.colors.charcoal} !important`,
        fontSize: "15px !important",
        lineHeight: "normal !important"
      }
    },
    calendarCell: {
      display: "flex",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      padding: "30px 16px",
      border: `1px solid ${theme2.colors.yetAnotherGray24}`,
      height: "100%",
      overflow: "hidden",
      borderRadius: "24px",
      backgroundColor: theme2.colors.white,
      color: theme2.colors.smoke,
      fontSize: "12px",
      lineHeight: "18px",
      gap: 0,
      "&:hover": {
        filter: "brightness(98%)"
      },
      cursor: "pointer"
    },
    today: {
      border: `1px solid ${theme2.colors.nimbus}`
    },
    selected: {
      border: `1px solid ${theme2.colors.charcoal}`
    },
    calendarContent: {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      flexGrow: 1,
      flexShrink: 1,
      minWidth: "120px",
      marginLeft: "auto"
    },
    calendarSessionContainer: {
      padding: "0 0 0 8px"
    },
    calendarStats: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      [theme2.breakpoints.down("md")]: {
        gap: "20px"
      }
    },
    summaryCell: {
      display: "flex",
      alignItems: "center",
      border: `1px solid ${theme2.colors.yetAnotherGray24}`,
      borderRadius: "50px",
      backgroundColor: theme2.colors.linen,
      padding: "2px 4px 2px 8px",
      color: theme2.colors.black,
      fontSize: "12px",
      lineHeight: "18px"
    },
    summaryText: {
      width: "100%",
      overflow: "hidden",
      position: "relative",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      lineClamp: 1,
      WebkitLineClamp: 1
    },
    summaryNumber: {
      borderRadius: theme2.borderRadius.xxxl,
      padding: "2px 4px",
      fontSize: "12px",
      backgroundColor: theme2.colors.calendarStatsTotalBackground,
      minWidth: "25px",
      textAlign: "center",
      lineHeight: "normal"
    },
    mobileContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "30px",
      color: `${theme2.colors.charcoal}`,
      fontSize: "15px",
      lineHeight: "normal",
      flex: 1,
      overflow: "hidden",
      height: "100%",
      gridAutoRows: "1fr",
      [theme2.breakpoints.down("sm")]: {
        gap: "26px"
      },
      [theme2.breakpoints.down("xs")]: {
        gap: "24px"
      }
    },
    mobileCalendarDay: {
      fontWeight: theme2.fontWeights.medium
    },
    mobileCalendarContent: {
      display: "flex",
      flexDirection: "column",
      gap: "20px"
    },
    mobileSummary: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "white"
    },
    mobileSummaryNumber: {
      display: "inline-flex",
      whiteSpace: "nowrap",
      padding: "0px 8px",
      borderBottom: "none",
      background: `radial-gradient(farthest-side,${theme2.colors.totalUnderlineColor} 98%,#0000) bottom left, linear-gradient(${theme2.colors.totalUnderlineColor} 0 0) bottom, radial-gradient(farthest-side,${theme2.colors.totalUnderlineColor} 98%,#0000) bottom right`,
      backgroundSize: "15px 17px, calc(100% - 15px) 17px",
      backgroundPositionY: 0,
      backgroundRepeat: "no-repeat",
      minWidth: "50px",
      justifyContent: "flex-end"
    },
    mobileSummaryNumberInner: {
      position: "relative",
      top: "-7px"
    },
    summaryNoBookingText: {
      color: theme2.colors.yetAnotherGray25
    }
  }),
  { name: "CalendarCard" }
);
const CalendarCard = ({
  calendarDay,
  sessionStats,
  showModal,
  isSelected,
  sessionFilter,
  obeeSessions: obeeSessions2,
  hasMultipleSessions
}) => {
  const classes = useStyles$t();
  const isToday = useMemo(() => isCurrentDate(moment$2(calendarDay.date)), [calendarDay]);
  const displayDay = useMemo(
    () => `${moment$2(calendarDay.date).format("dddd Do")} ${isToday ? " - Today" : ""}`,
    [calendarDay, isToday]
  );
  const sessionsForDay = useMemo(() => {
    return getTodaySessions(calendarDay.date, obeeSessions2, sessionFilter);
  }, [obeeSessions2.data, calendarDay.date, sessionFilter]);
  const openingSession = sessionsForDay == null ? void 0 : sessionsForDay.reduce(
    (prev, curr) => prev.startTime < curr.startTime ? prev : curr,
    {}
  );
  const closingSession = sessionsForDay == null ? void 0 : sessionsForDay.reduce(
    (prev, curr) => prev.endTime > curr.endTime ? prev : curr,
    {}
  );
  const isClosed = (isEmpty(sessionsForDay) || (openingSession == null ? void 0 : openingSession.startTime) === (closingSession == null ? void 0 : closingSession.endTime)) && sessionFilter === "all_sessions";
  const filteredSessionBreakdowns = useMemo(() => {
    const sessionBookings = calendarDay.totalCovers > 0 || calendarDay.waitlistCovers > 0 ? Object.values(calendarDay.sessionGroups) : [];
    const mergedData = sessionStats.map((sessionData) => {
      const sessionGroup = findObjectByProperty(sessionBookings, sessionData.label, "label");
      return {
        ...sessionGroup,
        sessionData
      };
    });
    return {
      confirmed: mergedData.filter(
        (sessionGroup) => {
          var _a, _b2;
          return ((_b2 = (_a = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _a.confirmed) == null ? void 0 : _b2.total_bookings) > 0;
        }
      ),
      waitlist: mergedData.filter(
        (sessionGroup) => {
          var _a, _b2;
          return ((_b2 = (_a = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _a.waitlist) == null ? void 0 : _b2.total_bookings) > 0;
        }
      )
    };
  }, [calendarDay, sessionStats]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.calendarCell} 
        ${isClosed ? classes.closed : ""} 
        ${isToday ? classes.today : ""} 
        ${isSelected ? classes.selected : ""}`,
      onClick: showModal
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileCalendarDay }, displayDay), /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileCalendarContent }, filteredSessionBreakdowns.confirmed.length > 0 || filteredSessionBreakdowns.waitlist.length > 0 ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, hasMultipleSessions && sessionFilter === "all_sessions" && /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummary }, /* @__PURE__ */ React__default.createElement(Box, null, "Guests"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummaryNumber }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummaryNumberInner }, calendarDay.totalCovers))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarStats }, filteredSessionBreakdowns.confirmed.map((sessionGroup) => {
      var _a, _b2, _c2, _d2, _e2;
      return /* @__PURE__ */ React__default.createElement(Box, { key: sessionGroup.label, className: `${classes.mobileSummary}` }, /* @__PURE__ */ React__default.createElement(Box, null, getSessionLabel(sessionGroup.label)), /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.mobileSummaryNumber,
          style: {
            background: `radial-gradient(farthest-side,${(_a = sessionGroup.sessionData.themeColors) == null ? void 0 : _a.backgroundColor} 98%,#0000) bottom left, linear-gradient(${(_b2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _b2.backgroundColor} 0 0) bottom, radial-gradient(farthest-side,${(_c2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _c2.backgroundColor} 98%,#0000) bottom right`,
            // These need to be in here too or it loses its shape
            backgroundSize: "15px 17px, calc(100% - 15px) 17px",
            backgroundPositionY: 0,
            backgroundRepeat: "no-repeat"
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummaryNumberInner }, (_e2 = (_d2 = sessionGroup.statuses) == null ? void 0 : _d2.confirmed) == null ? void 0 : _e2.total_covers)
      ));
    }), sessionFilter !== "all_sessions" && filteredSessionBreakdowns.waitlist.map((sessionGroup) => {
      var _a, _b2, _c2, _d2, _e2;
      return /* @__PURE__ */ React__default.createElement(Box, { key: sessionGroup.label, className: `${classes.mobileSummary}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, "Waitlist"), /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.mobileSummaryNumber,
          style: {
            background: `radial-gradient(farthest-side,${(_a = sessionGroup.sessionData.themeColors) == null ? void 0 : _a.backgroundColor} 98%,#0000) bottom left, linear-gradient(${(_b2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _b2.backgroundColor} 0 0) bottom, radial-gradient(farthest-side,${(_c2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _c2.backgroundColor} 98%,#0000) bottom right`,
            // These need to be in here too or it loses its shape
            backgroundSize: "15px 17px, calc(100% - 15px) 17px",
            backgroundPositionY: 0,
            backgroundRepeat: "no-repeat"
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummaryNumberInner }, (_e2 = (_d2 = sessionGroup.statuses) == null ? void 0 : _d2.waitlist) == null ? void 0 : _e2.total_covers)
      ));
    }), calendarDay.waitlistCovers > 0 && sessionFilter === "all_sessions" && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.mobileSummary}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummaryText }, "Waitlist"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummaryNumber }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummaryNumberInner }, calendarDay.waitlistCovers))))) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileSummary }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryNoBookingText }, isClosed ? "Closed" : "No bookings"))))
  ));
};
CalendarCard.defaultProps = {
  sessionStats: [],
  isSelected: false
};
CalendarCard.propTypes = {
  calendarDay: monthlyViewPropTypes.isRequired,
  sessionStats: PropTypes.arrayOf(PropTypes.shape({})),
  showModal: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  sessionFilter: PropTypes.string.isRequired,
  obeeSessions: sessionsPropTypes.isRequired
};
const mapStateToProps$Z = (state) => ({
  sessionFilter: state.obeeScreen.sessionFilter,
  obeeSessions: state.obeeSessions
});
const mapDispatchToProps$Y = (dispatch) => bindActionCreators({}, dispatch);
const CalendarCard$1 = connect(mapStateToProps$Z, mapDispatchToProps$Y)(CalendarCard);
const useStyles$s = createUseStyles(
  (theme2) => ({
    pageContent: {
      minHeight: "calc(100dvh - 65px)",
      backgroundColor: theme2.colors.linen,
      padding: "12px 8px 40px 16px",
      // Bottom padding so calendar doesn't touch bottom edge
      overflowY: "scroll",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100%",
      flexGrow: 1,
      [theme2.breakpoints.down("sm")]: {
        height: "auto",
        padding: "0 16px 40px 16px"
      },
      "@media print": {
        padding: 0,
        // To remove side padding when printed
        minHeight: "auto",
        // To avoid stretching content
        overflowY: "visible",
        // To remove scrollbar padding
        backgroundColor: theme2.colors.white
      }
    },
    calendar: {
      maxWidth: "1920px",
      backgroundColor: theme2.colors.white,
      borderRadius: "24px",
      fontSize: "15px",
      color: theme2.colors.charcoal,
      padding: "12px 36px 18px",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      flexGrow: 1,
      // The point where it starts cutting content
      [theme2.breakpoints.down("md")]: {
        padding: "12px 12px"
      },
      "@media print": {
        padding: "6px"
        // Less padding when printed
      }
    },
    calendarHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px"
    },
    calendarRowHeader: {
      display: "grid",
      gridTemplateColumns: "repeat(7, minmax(130px, 1fr))",
      gap: "4px"
    },
    calendarRow: {
      display: "grid",
      gridTemplateColumns: "repeat(7, minmax(130px, 1fr))",
      gridAutoRows: "1fr",
      gap: "4px",
      flexGrow: 1,
      // height: '516px',
      maxHeight: "1250px"
    },
    calendarCards: {
      display: "grid",
      gridAutoRows: "1fr",
      gap: "4px",
      flexGrow: 1,
      width: "100%",
      gridTemplateColumns: "repeat(3, minmax(300px, 1fr))",
      rowGap: "20px",
      columnGap: "20px",
      maxHeight: "100%",
      height: "100%",
      [theme2.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(2, minmax(280px, 1fr))",
        rowGap: "20px",
        columnGap: "20px"
      },
      [theme2.breakpoints.down("xs")]: {
        gridTemplateColumns: "repeat(1, minmax(300px, 1fr))",
        rowGap: "16px",
        columnGap: 0
      }
    },
    headerCell: {
      backgroundColor: "transparent",
      fontWeight: theme2.fontWeights.medium,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "auto",
      padding: "12px 6px",
      textTransform: "capitalize"
    },
    calendarSummary: {
      marginTop: "30px"
    },
    calendarSummaryRow: {
      display: "inline-flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "10px"
    },
    summaryCell: {
      display: "flex",
      alignItems: "center",
      gap: "18px",
      border: `1px solid ${theme2.colors.calendarStatsBorder}`,
      borderRadius: theme2.borderRadius.xxxl,
      padding: "5px 8px 5px 14px",
      color: theme2.colors.black,
      backgroundColor: "white"
    },
    summaryText: {
      fontSize: "12px"
    },
    summaryNumber: {
      fontSize: "15px",
      borderRadius: theme2.borderRadius.xxxl,
      padding: "8px 14px",
      minWidth: "40px",
      textAlign: "center",
      backgroundColor: (props) => {
        var _a;
        return (_a = props == null ? void 0 : props.themeColors) == null ? void 0 : _a.numberBackgroundColor;
      },
      outline: (props) => {
        var _a;
        return `1px solid ${(_a = props == null ? void 0 : props.themeColors) == null ? void 0 : _a.numberOutlineColor}`;
      }
    },
    totalCell: {
      "& $summaryNumber": {
        backgroundColor: theme2.colors.calendarTotalBackground,
        color: theme2.colors.white
      }
    }
  }),
  { name: "CalendarView" }
);
const CalendarSummaryItem = ({ label, value, themeColors }) => {
  const classes = useStyles$s({ themeColors });
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.summaryCell}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, getSessionLabel(label)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryNumber }, value));
};
CalendarSummaryItem.defaultProps = {
  label: null,
  value: null,
  themeColors: {
    backgroundColor: "white",
    numberBackgroundColor: "white",
    numberOutlineColor: "black"
  }
};
CalendarSummaryItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number,
  themeColors: PropTypes.shape({})
};
const mapStateToProps$Y = () => ({});
const mapDispatchToProps$X = (dispatch) => bindActionCreators({}, dispatch);
const CalendarSummaryItem$1 = connect(mapStateToProps$Y, mapDispatchToProps$X)(CalendarSummaryItem);
const CalendarSummary = ({ sessionStats, monthlyView }) => {
  var _a, _b2, _c2, _d2, _e2, _f;
  const classes = useStyles$s();
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", className: classes.calendarSummary }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarSummaryRow }, /* @__PURE__ */ React__default.createElement(
    CalendarSummaryItem$1,
    {
      label: "Total bookings",
      value: (_b2 = (_a = monthlyView.data) == null ? void 0 : _a.totals) == null ? void 0 : _b2.totalBookings
    }
  ), /* @__PURE__ */ React__default.createElement(CalendarSummaryItem$1, { label: "Total guests", value: (_d2 = (_c2 = monthlyView.data) == null ? void 0 : _c2.totals) == null ? void 0 : _d2.totalCovers }), /* @__PURE__ */ React__default.createElement(
    CalendarSummaryItem$1,
    {
      label: "Total waitlist guests",
      value: (_f = (_e2 = monthlyView.data) == null ? void 0 : _e2.totals) == null ? void 0 : _f.totalWaitlistCovers
    }
  ), sessionStats.map((session) => {
    return /* @__PURE__ */ React__default.createElement(
      CalendarSummaryItem$1,
      {
        key: session.label,
        themeColors: session.themeColors,
        label: `${getSessionLabel(session.label)} bookings`,
        value: session.totalBookings
      }
    );
  })));
};
CalendarSummary.defaultProps = {};
CalendarSummary.propTypes = {
  sessionStats: PropTypes.arrayOf(
    PropTypes.shape({
      themeColors: PropTypes.shape({
        backgroundColor: PropTypes.string,
        numberBackgroundColor: PropTypes.string
      })
    })
  ).isRequired,
  monthlyView: monthlyViewPropTypes.isRequired
};
const mapStateToProps$X = () => ({});
const mapDispatchToProps$W = (dispatch) => bindActionCreators({}, dispatch);
const CalendarSummary$1 = connect(mapStateToProps$X, mapDispatchToProps$W)(CalendarSummary);
const CalendarCardList = ({
  sessionStats,
  monthlyView,
  groupedSessionLabels,
  modalDate,
  showModal,
  hasMultipleSessions
}) => {
  const classes = useStyles$s();
  const calendarDays = useMemo(() => {
    var _a, _b2;
    if (isEmpty((_a = monthlyView.data) == null ? void 0 : _a.monthlyViewData)) {
      return [];
    }
    return (_b2 = monthlyView == null ? void 0 : monthlyView.data) == null ? void 0 : _b2.monthlyViewData.filter((dayViewData) => dayViewData == null ? void 0 : dayViewData.currentMonth);
  }, [groupedSessionLabels, monthlyView.data]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarCards }, calendarDays.map((calendarDay) => /* @__PURE__ */ React__default.createElement(
    CalendarCard$1,
    {
      key: `calendar-card-${calendarDay.date}`,
      calendarDay,
      sessionStats,
      showModal: () => showModal(calendarDay.date),
      isSelected: !isEmpty(modalDate) && modalDate === calendarDay.date,
      hasMultipleSessions
    }
  ))), /* @__PURE__ */ React__default.createElement(CalendarSummary$1, { monthlyView, sessionStats }));
};
CalendarCardList.defaultProps = {
  sessionStats: [],
  groupedSessionLabels: [],
  monthlyView: {}
};
CalendarCardList.propTypes = {
  sessionStats: PropTypes.arrayOf(PropTypes.shape({})),
  groupedSessionLabels: PropTypes.arrayOf(PropTypes.shape({})),
  monthlyView: monthlyViewPropTypes,
  showModal: PropTypes.func.isRequired,
  modalDate: PropTypes.string.isRequired,
  hasMultipleSessions: PropTypes.bool.isRequired
};
const mapStateToProps$W = (state) => ({
  date: state.obeeScreen.date,
  monthlyView: state.monthlyView
});
const mapDispatchToProps$V = (dispatch) => bindActionCreators({}, dispatch);
const CalendarCardList$1 = connect(mapStateToProps$W, mapDispatchToProps$V)(CalendarCardList);
const createDailyNoteAction = (dailyNote) => (dispatch) => {
  const action = "CREATE_DAILY_NOTE";
  const data = {
    dailyNote: { ...removeNullFields(dailyNote) }
  };
  const entityName = "dailyNote";
  const successMessage = "Daily note created";
  const errorMessage = `Unable to create Daily note`;
  const request = () => createDailyNote(data);
  dispatch(
    makeApiAction(action, request, dailyNote, entityName, successMessage, {}, false, errorMessage)
  );
};
const updateDailyNoteAction = (dailyNoteId, dailyNote) => (dispatch) => {
  const action = "UPDATE_DAILY_NOTE";
  const data = {
    id: dailyNoteId,
    dailyNote: { ...removeNullFields(dailyNote) }
  };
  const entityName = "updateDailyNote";
  const successMessage = "Daily note updated";
  const errorMessage = `Unable to update daily note`;
  const request = () => updateDailyNote(data);
  dispatch(makeApiAction(action, request, {}, entityName, successMessage, {}, false, errorMessage));
};
const deleteDailyNoteAction = (dailyNoteId) => (dispatch) => {
  const action = "DELETE_DAILY_NOTE";
  const data = {
    id: dailyNoteId,
    dailyNoteId
  };
  const entityName = "deleteDailyNote";
  const successMessage = "Daily note deleted";
  const errorMessage = `Unable to delete daily note`;
  const request = () => deleteDailyNote(data);
  dispatch(
    makeApiAction(action, request, data, entityName, successMessage, data, false, errorMessage)
  );
};
const fetchDailyNotesAction = (date) => (dispatch) => {
  const action = "FETCH_DAILY_NOTES";
  const entityName = "obeeDailyNotes";
  const errorMessage = "Unable to retrieve daily notes";
  const data = { date };
  const request = () => fetchDailyNotes(data);
  dispatch(makeApiAction(action, request, {}, entityName, null, {}, true, errorMessage));
};
const useStyles$r = createUseStyles(
  (theme2) => ({
    root: {
      backgroundColor: theme2.colors.white,
      borderRadius: "24px",
      overflow: "hidden",
      boxShadow: "0px 4px 4px 0px rgba(218, 218, 218, 0.25)"
    },
    grid: {
      backgroundColor: theme2.colors.borderLight,
      height: "100%",
      display: "flex",
      flexWrap: "wrap",
      borderRadius: "24px",
      overflow: "hidden",
      containerType: "inline-size"
    },
    gridBlock: {
      flexBasis: "33.3%",
      maxWidth: "33.3%"
      // // Wow this is cool. if shrunk down, reposition
      // '@container (max-width: 900px)': {
      //   flexBasis: '50%',
      //   maxWidth: '50%',
      // },
    },
    gridItem: {
      position: "relative",
      padding: "12px 20px",
      backgroundColor: "white",
      height: "100%",
      alignItems: "flex-start",
      gap: "12px"
    },
    details: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      alignItems: "flex-start",
      containerType: "inline-size",
      width: "100%"
    },
    title: {
      color: theme2.colors.grayLight,
      display: "flex",
      fontSize: "15px"
    },
    loading: {
      display: "flex",
      fontSize: "15px"
    },
    insightData: {
      fontSize: "22px",
      minHeight: "24px",
      opacity: (props) => props.loading ? 0 : 1,
      transition: (props) => props.loading ? "none" : "opacity 0.5s"
    }
  }),
  { name: "BookingDaySummary" }
);
const InsightItem = ({ title, dataFormatted, loading }) => {
  const classes = useStyles$r({ loading });
  return /* @__PURE__ */ React__default.createElement(Spacer, { className: classes.gridItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.details }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.title }, title), /* @__PURE__ */ React__default.createElement(Box, { className: classes.insightData }, dataFormatted))));
};
const BookingDaySummary = ({ data, loading }) => {
  const classes = useStyles$r({ loading });
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.root }, /* @__PURE__ */ React__default.createElement(Grid$1, { container: true, wrap: "wrap", spacing: "1px", className: classes.grid }, /* @__PURE__ */ React__default.createElement(Grid$1, { item: true, className: classes.gridBlock }, /* @__PURE__ */ React__default.createElement(
    InsightItem,
    {
      title: "Guests",
      dataFormatted: formatNumber(data.guests, ""),
      loading
    }
  )), /* @__PURE__ */ React__default.createElement(Grid$1, { item: true, className: classes.gridBlock }, /* @__PURE__ */ React__default.createElement(
    InsightItem,
    {
      title: "Bookings",
      dataFormatted: formatNumber(data.bookings, ""),
      loading
    }
  )), /* @__PURE__ */ React__default.createElement(Grid$1, { item: true, className: classes.gridBlock }, /* @__PURE__ */ React__default.createElement(
    InsightItem,
    {
      title: "Waitlist",
      dataFormatted: formatNumber(data.waitlist, ""),
      loading
    }
  )), /* @__PURE__ */ React__default.createElement(Grid$1, { item: true, className: classes.gridBlock }, /* @__PURE__ */ React__default.createElement(
    InsightItem,
    {
      title: "Walk-ins",
      dataFormatted: formatNumber(data.walkIns, ""),
      loading
    }
  )), /* @__PURE__ */ React__default.createElement(Grid$1, { item: true, className: classes.gridBlock }, /* @__PURE__ */ React__default.createElement(
    InsightItem,
    {
      title: "Cancelled",
      dataFormatted: formatNumber(data.cancelled, ""),
      loading
    }
  )), /* @__PURE__ */ React__default.createElement(Grid$1, { item: true, className: classes.gridBlock }, /* @__PURE__ */ React__default.createElement(
    InsightItem,
    {
      title: "No show",
      dataFormatted: formatNumber(data.noShow, ""),
      loading
    }
  ))));
};
BookingDaySummary.defaultProps = {
  data: {
    bookings: null,
    waitlist: null,
    walkIns: null,
    guests: null,
    cancelled: null,
    noShow: null,
    specialBookings: []
  },
  loading: false
};
BookingDaySummary.propTypes = {
  data: PropTypes.shape({
    bookings: PropTypes.number,
    waitlist: PropTypes.number,
    walkIns: PropTypes.number,
    guests: PropTypes.number,
    cancelled: PropTypes.number,
    noShow: PropTypes.number,
    specialBookings: PropTypes.arrayOf(obeeBookingPropTypes)
  }),
  loading: PropTypes.bool
};
const mapStateToProps$V = () => ({});
const mapDispatchToProps$U = (dispatch) => bindActionCreators({}, dispatch);
const BookingDaySummary$1 = connect(mapStateToProps$V, mapDispatchToProps$U)(BookingDaySummary);
const Tag = ({ type: type2, label, content, active, printStyles, onClick }) => {
  const classes = useStyles$1K({ printStyles });
  const smallTagStyles = {
    padding: "4px 8px"
  };
  switch (type2) {
    case "blacklist":
      return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.blacklistTag}`, style: smallTagStyles }, "Blacklisted");
    case "vip":
      return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.vipTag}`, style: smallTagStyles }, "VIP");
    case "dietaries":
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: `${classes.tag} ${classes.dietaryTag} ${active ? classes.activeTag : ""}`,
          onClick,
          style: smallTagStyles
        },
        "Dietaries"
      );
    case "celebration":
      return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.birthdayTag}`, style: smallTagStyles }, label);
    case "favorites":
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: `${classes.tag} ${classes.favouriteTag} ${active ? classes.activeTag : ""}`,
          onClick,
          style: smallTagStyles
        },
        /* @__PURE__ */ React__default.createElement(StarIcon, { width: "17", height: "17" }),
        /* @__PURE__ */ React__default.createElement(Box, null, "Food & drinks")
      );
    default:
      return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tag} ${classes.tagContainer}`, style: smallTagStyles }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tagLabel}` }, label), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tagContent}` }, content));
  }
};
Tag.defaultProps = {
  printStyles: {},
  label: "",
  content: "",
  active: false,
  onClick: (e) => e
};
Tag.propTypes = {
  printStyles: PropTypes.shape({}),
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
  content: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func
};
const mapStateToProps$U = () => ({});
const mapDispatchToProps$T = (dispatch) => bindActionCreators({}, dispatch);
const Tag$1 = connect(mapStateToProps$U, mapDispatchToProps$T)(Tag);
const fetchDailyNoteCategoriesAction = () => (dispatch) => {
  const action = "FETCH_DAILY_NOTE_CATEGORIES";
  const entityName = "obeeDailyNoteCategories";
  const errorMessage = "Unable to retrieve daily note categories";
  const data = {};
  const request = () => fetchDailyNoteCategories(data);
  dispatch(makeApiAction(action, request, {}, entityName, null, {}, true, errorMessage));
};
const useStyles$q = createUseStyles(
  (theme2) => ({
    stripeTextField: {
      padding: 0,
      borderRadius: "6px",
      transition: "background-color 0.1s, outline 0.1s",
      "&:hover": {
        background: theme2.colors.yetAnotherGray12
      },
      "&.Mui-focused": {
        outline: "1px solid"
      }
    },
    stripeTextFieldInput: {
      padding: "11px 10px 6px 15px"
      // weird magic number but lines up with other field heights
    },
    stripeTextFieldError: {
      border: `1px solid ${theme2.colors.red}`
    },
    stripeTextFieldErrorText: {
      fontSize: "10px",
      color: theme2.colors.red,
      margin: "4px 0 0 110px"
    },
    interactiveItem: {
      display: "flex",
      gap: "16px",
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "6px",
      padding: "5px 10px",
      border: `1px solid transparent`,
      alignItems: "center",
      transition: "background-color 0.1s",
      height: "36px",
      "&:hover": {
        backgroundColor: theme2.colors.notificationBackgroundGray
      }
    },
    disabledItem: {
      cursor: "default",
      "&:hover": {
        backgroundColor: "inherit"
      }
    },
    activeItem: {
      backgroundColor: theme2.colors.notificationBackgroundGray,
      border: `1px solid ${theme2.colors.smoke}`
    },
    error: {
      fontSize: "10px",
      lineHeight: "10px",
      color: theme2.colors.red,
      marginTop: "3px"
    },
    label: {
      width: "90px",
      color: theme2.colors.smoke,
      alignSelf: "center",
      flexShrink: 0
    },
    container: {
      display: "flex",
      gap: "10px",
      fontSize: "inherit"
    },
    itemContainer: {
      width: "100%"
    }
  }),
  { name: "FormFields" }
);
const CleanInteractiveItem = ({
  label,
  value,
  onClick,
  isActive,
  error,
  placeholder,
  required,
  formatValue,
  disabled
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$q();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label, required && "*"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemContainer }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.interactiveItem} ${isActive && classes.activeItem} ${disabled && classes.disabledItem}`,
      style: {
        color: isEmpty(value) && theme2.colors.nimbus,
        border: !isEmpty(error) && `1px solid ${theme2.colors.red}`
      },
      onClick
    },
    isEmpty(value) ? placeholder : formatValue(value)
  ), !isEmpty(error) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.error }, error)));
};
CleanInteractiveItem.defaultProps = {
  value: "",
  onClick: () => {
  },
  isActive: false,
  error: "",
  placeholder: "Empty",
  required: false,
  formatValue: (value) => value,
  disabled: false
};
CleanInteractiveItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  formatValue: PropTypes.func,
  disabled: PropTypes.bool
};
const CleanInteractiveItem$1 = CleanInteractiveItem;
const useStyles$p = createUseStyles(
  (theme2) => ({
    note: {
      position: "relative",
      maxWidth: "100%",
      border: `1px solid ${theme2.colors.grayBorder}`,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: `0px 4px 4px 0px rgba(151, 151, 151, 0.25)`
    },
    noteContent: {
      padding: "14px 16px 16px 24px",
      display: "flex",
      flexDirection: "column",
      gap: "6px"
    },
    noteColorBar: {
      position: "absolute",
      width: "8px",
      height: "100%",
      backgroundColor: (props) => (props == null ? void 0 : props.noteColor) || theme2.colors.grayBorder,
      left: 0,
      top: 0
    },
    saveButtonsContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "12px"
    }
  }),
  { name: "Note" }
);
const editableTextStyles = (theme2) => ({
  padding: 0,
  input: {
    padding: 0,
    paddingLeft: 0,
    color: theme2.colors.charcoal,
    fontWeight: theme2.fontWeights.medium,
    "& input": {
      "&::placeholder": {
        color: theme2.colors.nimbus,
        fontWeight: theme2.fontWeights.medium
      }
    }
  },
  inputActive: {
    outline: 0,
    color: "black",
    fontWeight: theme2.fontWeights.medium
  },
  inputHover: {
    backgroundColor: "transparent",
    color: "black"
  }
});
const textAreaStyles = (theme2) => ({
  container: {
    cursor: "text",
    marginBottom: "8px"
  },
  textAreaInner: {
    borderRadius: "6px",
    display: "flex",
    position: "relative",
    lineHeight: "24px",
    alignItems: "center"
  },
  disabled: {},
  input: {
    // border: '1px solid transparent',
    backgroundColor: "transparent",
    outline: "none",
    alignItems: "center",
    width: "100%"
  },
  textField: {
    border: `1px solid ${theme2.colors.grayBorder}`,
    lineHeight: "1.5",
    fontSize: "inherit",
    fontFamily: "inherit",
    padding: "0",
    "&:active": {
      border: `1px solid ${theme2.colors.charcoal}`
    }
  },
  inputProps: {
    padding: "12px 8px",
    width: "calc(100% + 8px)",
    marginLeft: "-8px",
    marginRight: "-8px"
    // TODO figure out how to change placeholder colour in text area
    // '&::placeholder': {
    //   color: 'red !important',
    //   opacity: 1 /* Firefox */,
    // },
  }
});
const CreateNote = ({
  onCancel,
  createDailyNote: createDailyNote2,
  onSave,
  date,
  dailyNoteCategories,
  obeeStaff,
  createNoteRef
  // A ref passed from the parent to backup the entered values
}) => {
  var _a, _b2, _c2, _d2, _e2;
  const theme2 = useTheme$1();
  const [title, setTitle] = useState(((_a = createNoteRef == null ? void 0 : createNoteRef.current) == null ? void 0 : _a.title) || "");
  const [note, setNote] = useState(((_b2 = createNoteRef == null ? void 0 : createNoteRef.current) == null ? void 0 : _b2.note) || "");
  const [insertedBy, setInsertedBy] = useState(((_c2 = createNoteRef == null ? void 0 : createNoteRef.current) == null ? void 0 : _c2.insertedBy) || "");
  const [category, setCategory] = useState(((_d2 = createNoteRef == null ? void 0 : createNoteRef.current) == null ? void 0 : _d2.category) ?? 1);
  const [pinned, setPinned] = useState(((_e2 = createNoteRef == null ? void 0 : createNoteRef.current) == null ? void 0 : _e2.pinned) ?? false);
  const [error, setError] = useState(null);
  const [staffAnchorEl, setStaffAnchorEl] = useState(null);
  const color = getDailyNoteColor(
    findObjectByProperty(dailyNoteCategories == null ? void 0 : dailyNoteCategories.data, category, "id"),
    theme2
  );
  const classes = useStyles$p({ noteColor: color });
  const dropdownStyles = {
    label: { width: "90px" },
    container: { fontSize: "inherit", width: "100%" },
    // value: { border: `1px solid ${theme.colors.grayBorder}` },
    popover: { padding: "8px", marginTop: 0 },
    item: { fontSize: "15px", padding: "8px 12px" },
    items: { fontSize: "15px", minWidth: "150px" }
  };
  const toggleStyles = {
    inputContainer: { marginLeft: "12px" },
    textLabel: { width: "90px", fontSize: "15px" }
  };
  const validate = () => {
    if (isEmpty(note)) {
      setError("Note cannot be empty");
      return false;
    }
    return true;
  };
  const validateAndSubmit = () => {
    const isValid = validate();
    if (!isValid) {
      return;
    }
    createDailyNote2({
      title,
      note,
      insertedBy,
      category: `${category}`,
      pinned,
      date
      // createdDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    onSave();
  };
  const categoriesList = useMemo(() => {
    var _a2;
    return (_a2 = dailyNoteCategories == null ? void 0 : dailyNoteCategories.data) == null ? void 0 : _a2.map((dailyNoteCategory) => ({
      label: dailyNoteCategory == null ? void 0 : dailyNoteCategory.category,
      value: dailyNoteCategory == null ? void 0 : dailyNoteCategory.id
    }));
  }, [dailyNoteCategories.data]);
  const staffItems = useMemo(
    () => {
      var _a2, _b3;
      return (_b3 = (_a2 = obeeStaff.data) == null ? void 0 : _a2.map((obeeStaffMember) => (obeeStaffMember == null ? void 0 : obeeStaffMember.appearAs) || (obeeStaffMember == null ? void 0 : obeeStaffMember.fullName))) == null ? void 0 : _b3.sort(sortValues).map((staffName) => ({ label: staffName, value: staffName }));
    },
    []
  );
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.note }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.noteColorBar }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.noteContent }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      value: title,
      onChange: (newValue) => {
        setTitle(newValue);
        createNoteRef.current.title = newValue;
      },
      placeholder: "Write title here",
      style: editableTextStyles(theme2)
    }
  ), /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      resizable: true,
      placeholder: "Write note here",
      value: note,
      onChange: (newValue) => {
        setNote(newValue);
        createNoteRef.current.note = newValue;
      },
      style: textAreaStyles(theme2),
      error
    }
  ), error && /* @__PURE__ */ React__default.createElement(Box, { style: { color: "red" } }, error), /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: "Category",
      items: categoriesList,
      value: category,
      onSelect: (newValue) => {
        setCategory(newValue);
        createNoteRef.current.category = newValue;
      },
      style: dropdownStyles
    }
  ), isObee() ? /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Created by",
      value: insertedBy,
      onChange: (newValue) => {
        setInsertedBy(newValue);
        createNoteRef.current.insertedBy = newValue;
      },
      style: { label: { width: "90px" } }
    }
  ) : !isEmpty(staffItems) && /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Staff name",
      value: insertedBy,
      onClick: (e) => {
        setStaffAnchorEl(e.currentTarget);
      },
      isActive: !!staffAnchorEl
    }
  ), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      label: "Pinned",
      checked: pinned,
      onChange: (newValue) => {
        setPinned(newValue);
        createNoteRef.current.pinned = newValue;
      },
      style: toggleStyles,
      color: theme2.colors.toggleBackground
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.saveButtonsContainer }, /* @__PURE__ */ React__default.createElement(RoundButton, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React__default.createElement(SecondaryButton, { onClick: validateAndSubmit }, "Save"))), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: staffItems,
      onSelect: (newValue) => {
        setInsertedBy(newValue);
        createNoteRef.current.insertedBy = newValue;
      },
      anchor: staffAnchorEl,
      isOpen: !!staffAnchorEl,
      onClose: () => setStaffAnchorEl(null),
      style: listPopoverStyles$2,
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    }
  ));
};
CreateNote.defaultProps = {};
CreateNote.propTypes = {
  createDailyNote: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  date: PropTypes.string.isRequired,
  dailyNoteCategories: dailyNoteCategoriesPropTypes.isRequired,
  obeeStaff: obeeStaffPropTypes.isRequired
};
const mapStateToProps$T = (state) => ({
  dailyNoteCategories: state.dailyNoteCategories,
  obeeStaff: state.obeeStaff
});
const mapDispatchToProps$S = (dispatch) => bindActionCreators(
  {
    createDailyNote: createDailyNoteAction
  },
  dispatch
);
const CreateNote$1 = connect(mapStateToProps$T, mapDispatchToProps$S)(CreateNote);
const useStyles$o = createUseStyles(
  (theme2) => ({
    note: {
      position: "relative",
      color: theme2.colors.smoke,
      // maxWidth: '324px',
      maxWidth: "100%",
      border: `1px solid ${theme2.colors.grayBorder}`,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: `0px 4px 4px 0px rgba(151, 151, 151, 0.25)`,
      whiteSpace: "pre-wrap"
    },
    noteContent: {
      padding: "16px 16px 16px 24px",
      display: "flex",
      flexDirection: "column",
      gap: "16px"
    },
    noteColorBar: {
      position: "absolute",
      width: "8px",
      height: "100%",
      backgroundColor: (props) => (props == null ? void 0 : props.noteColor) || theme2.colors.grayBorder,
      left: 0,
      top: 0
    },
    displayTitle: {
      color: theme2.colors.charcoal,
      fontWeight: theme2.fontWeights.medium
    },
    displayNote: {
      fontSize: "14px",
      color: theme2.colors.smoke,
      lineHeight: "22px"
    },
    displayFooter: {
      fontSize: "12px",
      color: theme2.colors.yetAnotherGray7,
      display: "inline-flex",
      gap: "4px"
    }
  }),
  { name: "Note" }
);
const DailyNote = ({ note, deleteDailyNote: deleteDailyNote2, setNoteEditing, dailyNoteCategories }) => {
  const theme2 = useTheme$1();
  const color = getDailyNoteColor(
    findObjectByProperty(dailyNoteCategories == null ? void 0 : dailyNoteCategories.data, note == null ? void 0 : note.category, "id"),
    theme2
  );
  const classes = useStyles$o({ noteColor: color });
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.note }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.noteColorBar }), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "custom",
      style: {
        position: "absolute",
        top: "0",
        right: "0",
        button: {
          padding: "12px 14px"
        },
        text: {
          height: "20px"
        }
      },
      onClick: (e) => setMenuAnchor(e.currentTarget)
    },
    /* @__PURE__ */ React__default.createElement(KebabSvg, { style: { height: "14px" } })
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.noteContent }, !isEmpty(note.title) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.displayTitle }, note.title), !isEmpty(note.note) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.displayNote }, note.note), !isEmpty(note.insertedBy) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.displayFooter }, /* @__PURE__ */ React__default.createElement(Box, null, "Created by"), /* @__PURE__ */ React__default.createElement(Box, null, note.insertedBy))), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: [
        {
          key: "edit",
          label: "Edit",
          onClick: setNoteEditing
        },
        {
          key: "delete",
          label: "Delete note",
          onClick: () => setShowDeleteConfirmation(true)
        }
      ],
      anchor: menuAnchor,
      isOpen: !isEmpty(menuAnchor),
      onClose: () => setMenuAnchor(null),
      style: {
        popover: { minWidth: "fit-content", maxHeight: "550px", padding: "8px", marginTop: 0 },
        item: { fontSize: "15px" }
      },
      popoverProps: { innerProps: { disableScrollLock: true } },
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      onClose: () => setShowDeleteConfirmation(false),
      isOpen: showDeleteConfirmation,
      onConfirm: () => {
        deleteDailyNote2(note.id);
        setShowDeleteConfirmation(false);
      },
      heading: "Delete daily note",
      confirmLabel: "Confirm",
      prompt: "Are you sure you want to delete this daily note?"
    }
  ));
};
DailyNote.defaultProps = {};
DailyNote.propTypes = {
  note: dailyNotePropTypes.isRequired
};
const mapStateToProps$S = (state) => ({
  dailyNoteCategories: state.dailyNoteCategories
});
const mapDispatchToProps$R = (dispatch) => bindActionCreators(
  {
    deleteDailyNote: deleteDailyNoteAction
  },
  dispatch
);
const DailyNote$1 = connect(mapStateToProps$S, mapDispatchToProps$R)(DailyNote);
const useStyles$n = createUseStyles((theme2) => ({
  container: {},
  iconContainer: {
    position: "relative"
  },
  icon: {
    color: theme2.colors.linen,
    width: "23px",
    height: "24px"
  },
  notificationIcon: {
    position: "absolute",
    backgroundColor: theme2.colors.notification,
    border: `1px solid ${theme2.colors.white}`,
    borderRadius: "12px",
    width: "12px",
    height: "12px",
    top: "-2px",
    right: 0
  },
  itemsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: `1px solid ${theme2.colors.cloud}`,
    height: "56px",
    cursor: "pointer",
    fontSize: "15px",
    lineHeight: "28px",
    gap: "20px",
    transition: "0.1s",
    padding: "0 40px",
    "&:hover": {
      backgroundColor: theme2.colors.cloud,
      cursor: "pointer"
    }
  },
  modal: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "20px",
    minWidth: "324px"
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  modalTitle: {
    fontSize: "18px",
    fontWeight: theme2.fontWeights.medium
  }
}));
const EditNote = ({ onCancel, updateDailyNote: updateDailyNote2, onSave, note, dailyNoteCategories }) => {
  const theme2 = useTheme$1();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [insertedBy, setInsertedBy] = useState("");
  const [category, setCategory] = useState(1);
  const [pinned, setPinned] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    setTitle(note == null ? void 0 : note.title);
    setMessage(note == null ? void 0 : note.note);
    setInsertedBy(note == null ? void 0 : note.insertedBy);
    setCategory(note == null ? void 0 : note.category);
    setPinned(note == null ? void 0 : note.pinned);
  }, [note == null ? void 0 : note.id]);
  const color = getDailyNoteColor(
    findObjectByProperty(dailyNoteCategories == null ? void 0 : dailyNoteCategories.data, category, "id"),
    theme2
  );
  const classes = useStyles$p({ noteColor: color });
  const dropdownStyles = {
    label: { width: "90px" },
    container: { fontSize: "inherit", width: "100%" },
    popover: { padding: "8px", marginTop: 0 },
    item: { fontSize: "15px", padding: "8px 12px" },
    items: { fontSize: "15px", minWidth: "150px" }
  };
  const toggleStyles = {
    inputContainer: { marginLeft: "12px" },
    textLabel: { width: "90px", fontSize: "15px" }
  };
  const validate = () => {
    if (isEmpty(message)) {
      setError("Note cannot be empty");
      return false;
    }
    return true;
  };
  const validateAndSubmit = () => {
    const isValid = validate();
    if (!isValid) {
      return;
    }
    updateDailyNote2(note.id, {
      // id: note.id,
      title,
      note: message,
      // insertedBy,
      category: `${category}`,
      pinned
    });
    onSave();
  };
  const categoriesList = useMemo(() => {
    var _a;
    return (_a = dailyNoteCategories == null ? void 0 : dailyNoteCategories.data) == null ? void 0 : _a.map((dailyNoteCategory) => ({
      label: dailyNoteCategory == null ? void 0 : dailyNoteCategory.category,
      value: dailyNoteCategory == null ? void 0 : dailyNoteCategory.id
    }));
  }, [dailyNoteCategories.data]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.note }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.noteColorBar }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.noteContent }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      value: title,
      onChange: setTitle,
      placeholder: "Write title here",
      style: editableTextStyles(theme2)
    }
  ), /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      resizable: true,
      placeholder: "Write note here",
      value: message,
      onChange: (value) => {
        setMessage(value);
        setError(null);
      },
      style: textAreaStyles(theme2)
    }
  ), error && /* @__PURE__ */ React__default.createElement(Box, { style: { color: "red" } }, error), /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: "Category",
      items: categoriesList,
      value: category,
      onSelect: setCategory,
      style: dropdownStyles
    }
  ), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      label: "Pinned",
      checked: pinned,
      onChange: setPinned,
      style: toggleStyles,
      color: theme2.colors.toggleBackground
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.saveButtonsContainer }, /* @__PURE__ */ React__default.createElement(RoundButton, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React__default.createElement(SecondaryButton, { onClick: validateAndSubmit }, "Save"))));
};
EditNote.defaultProps = {
  note: null
};
EditNote.propTypes = {
  updateDailyNote: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  note: dailyNotePropTypes,
  dailyNoteCategories: dailyNoteCategoriesPropTypes.isRequired
};
const mapStateToProps$R = (state) => ({
  dailyNoteCategories: state.dailyNoteCategories
});
const mapDispatchToProps$Q = (dispatch) => bindActionCreators(
  {
    updateDailyNote: updateDailyNoteAction
  },
  dispatch
);
const EditNote$1 = connect(mapStateToProps$R, mapDispatchToProps$Q)(EditNote);
const DailyNotesList = ({
  dailyNotes,
  date,
  dailyNoteCategories,
  fetchDailyNoteCategories: fetchDailyNoteCategories2,
  createNoteRef,
  fetchObeeStaffList,
  obeeStaff
}) => {
  const theme2 = useTheme$1();
  const [showAddNote, setShowAddNote] = useState(!isEmpty(createNoteRef.current));
  const [noteEditing, setNoteEditing] = useState(null);
  const classes = useStyles$n();
  useFetchOnFirstRender([fetchDailyNoteCategories2], [dailyNoteCategories], [], false, true);
  useEffect(() => {
    if (!isObee() && isEmpty(obeeStaff.apiData) && !obeeStaff.pending) {
      fetchObeeStaffList();
    }
  }, []);
  const notesForDay = useMemo(
    () => dailyNotes.data.filter((note) => note.date === date).sort((a, b) => sortByDate(a.createdDate, b.createdDate, "YYYY-MM-DD HH:mm:ss", true)),
    [dailyNotes.data, date]
  );
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.modal }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalTitle }, "Notes"), /* @__PURE__ */ React__default.createElement(
    RoundButton,
    {
      onClick: () => {
        setNoteEditing(null);
        setShowAddNote(true);
      },
      style: { button: { fontWeight: theme2.fontWeights.medium } }
    },
    "Add"
  )), !showAddNote && isEmpty(notesForDay) && /* @__PURE__ */ React__default.createElement(Box, null, "There are no daily notes for this day"), showAddNote && /* @__PURE__ */ React__default.createElement(
    CreateNote$1,
    {
      createNoteRef,
      onCancel: () => {
        createNoteRef.current = {};
        setShowAddNote(false);
      },
      onSave: () => {
        createNoteRef.current = {};
        setShowAddNote(false);
      },
      date
    }
  ), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 16 }, notesForDay.map(
    (note) => (
      // Show or edit note
      !isEmpty(noteEditing) && (note == null ? void 0 : note.id) === (noteEditing == null ? void 0 : noteEditing.id) ? /* @__PURE__ */ React__default.createElement(
        EditNote$1,
        {
          note,
          onCancel: () => setNoteEditing(null),
          onSave: () => setNoteEditing(null)
        }
      ) : /* @__PURE__ */ React__default.createElement(
        DailyNote$1,
        {
          note,
          key: note == null ? void 0 : note.id,
          setNoteEditing: () => {
            setNoteEditing(note);
            createNoteRef.current = {};
            setShowAddNote(false);
          }
        }
      )
    )
  )));
};
DailyNotesList.defaultProps = {
  date: null
};
DailyNotesList.propTypes = {
  dailyNotes: dailyNotesPropTypes.isRequired,
  fetchObeeStaffList: PropTypes.func.isRequired,
  date: PropTypes.string,
  obeeStaff: obeeStaffPropTypes.isRequired,
  createNoteRef: PropTypes.shape({}).isRequired,
  dailyNoteCategories: dailyNoteCategoriesPropTypes.isRequired,
  fetchDailyNoteCategories: PropTypes.func.isRequired
};
const mapStateToProps$Q = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  dailyNotes: state.dailyNotes,
  dailyNoteCategories: state.dailyNoteCategories,
  obeeStaff: state.obeeStaff
});
const mapDispatchToProps$P = (dispatch) => bindActionCreators(
  {
    fetchDailyNoteCategories: fetchDailyNoteCategoriesAction,
    fetchObeeStaffList: fetchObeeStaffListAction
  },
  dispatch
);
const DailyNotesList$1 = connect(mapStateToProps$Q, mapDispatchToProps$P)(DailyNotesList);
const useStyles$m = createUseStyles((theme2) => ({
  buttonContainer: {
    width: "100%",
    gap: "15px",
    justifyContent: "space-between",
    display: "flex",
    [theme2.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center"
    }
  },
  modalHeader: {
    ...theme2.typography.heading.H2,
    color: theme2.colors.charcoal,
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  modalBody: {
    ...theme2.typography.body.textLarge,
    color: theme2.colors.smoke
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "32px"
  }
}));
const FullyBookModal = ({
  isOpen,
  onClose,
  areas,
  obeeSessions: obeeSessions2,
  date,
  fetchSessions,
  fetchAreas,
  fetchFullyBookedSessions: fetchFullyBookedSessions2,
  fullyBookedSessions,
  bulkUpdateFullyBookedSessions
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$m();
  const [tooltipAnchorEl, setTooltipAnchorEl] = useState(null);
  const [localFullyBookedSessions, setLocalFullyBookedSessions] = useState(
    sortListByProperty(fullyBookedSessions.data, "openingTime")
  );
  const [updating, setUpdating] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setLocalFullyBookedSessions(sortListByProperty(fullyBookedSessions.data, "openingTime"));
    }
  }, [isOpen, fullyBookedSessions.data]);
  useEffect(() => {
    if (updating && fullyBookedSessions.success) {
      setUpdating(false);
      onClose();
    }
  }, [fullyBookedSessions.success, onClose, updating]);
  useEffect(() => {
    if (updating && fullyBookedSessions.error) {
      setUpdating(false);
    }
  }, [fullyBookedSessions.error, updating]);
  const loading = useFetchOnFirstRender(
    [fetchAreas, fetchSessions, () => fetchFullyBookedSessions2(date)],
    [areas, obeeSessions2, fullyBookedSessions]
  );
  useEffect(() => {
    fetchFullyBookedSessions2(date);
  }, [fetchFullyBookedSessions2, date]);
  const fullyBookedSessionsToAdd = localFullyBookedSessions.filter((fullyBookedSession) => {
    return fullyBookedSession.fullyBooked && fullyBookedSession.fullyBookedBId === 0;
  });
  const fullyBookedSessionsToRemove = localFullyBookedSessions.filter((fullyBookedSession) => {
    return !fullyBookedSession.fullyBooked && fullyBookedSession.fullyBookedBId !== 0;
  });
  const update = () => {
    setUpdating(true);
    bulkUpdateFullyBookedSessions(date, fullyBookedSessionsToAdd, fullyBookedSessionsToRemove);
  };
  const updateLocalFullyBookedSession = (sessionId, areaId, fullyBooked) => {
    const updatedSessions = localFullyBookedSessions.map((session) => {
      if (session.sessionId === sessionId && session.areaId === areaId) {
        return {
          ...session,
          fullyBooked
        };
      }
      return session;
    });
    setLocalFullyBookedSessions(updatedSessions);
  };
  const bulkUpdateLocalFullyBookedSession = (sessionLabel, fullyBooked) => setLocalFullyBookedSessions(
    localFullyBookedSessions.map((session) => {
      if (session.label === sessionLabel) {
        return {
          ...session,
          fullyBooked
        };
      }
      return session;
    })
  );
  const hasFullyBookedSessions = fullyBookedSessions.data.some(
    (fullyBookedSession) => fullyBookedSession.fullyBooked
  );
  return /* @__PURE__ */ React__default.createElement(
    PromptModal$1,
    {
      isOpen,
      onClose,
      onConfirm: update,
      inputStyle: { maxWidth: "680px", maxHeight: "535px" },
      heading: /* @__PURE__ */ React__default.createElement(Spacer, { gap: "m", style: { width: "100%" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalHeader }, hasFullyBookedSessions ? "Update Fully Book" : "Fully Book", " for", " ", formatDate(date, "Do MMM")), /* @__PURE__ */ React__default.createElement(
        HeaderButton$1,
        {
          type: "round",
          onClick: (e) => setTooltipAnchorEl(e.currentTarget),
          style: { button: { height: "28px", width: "28px", lineHeight: "15px" } }
        },
        "?"
      ), /* @__PURE__ */ React__default.createElement(Box, { style: { marginLeft: "auto" } }, /* @__PURE__ */ React__default.createElement(
        HeaderButton$1,
        {
          onClick: () => setLocalFullyBookedSessions(
            localFullyBookedSessions.map((session) => ({
              ...session,
              fullyBooked: true
            }))
          )
        },
        "Select all"
      ))),
      confirmLabel: hasFullyBookedSessions ? "Update fully book" : "Fully Book",
      loadingConfirm: updating,
      disableConfirm: [...fullyBookedSessionsToAdd, ...fullyBookedSessionsToRemove].length === 0
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: "m" }, loading && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Skeleton$1, { width: 600, height: 48, style: { skeleton: { borderRadius: "12px" } } }), /* @__PURE__ */ React__default.createElement(Skeleton$1, { width: 600, height: 48, style: { skeleton: { borderRadius: "12px" } } }), /* @__PURE__ */ React__default.createElement(Skeleton$1, { width: 600, height: 48, style: { skeleton: { borderRadius: "12px" } } })), !loading && localFullyBookedSessions.length === 0 && /* @__PURE__ */ React__default.createElement(Box, null, "There are no sessions to fully book for ", formatDate(date, "dddd Do MMM")), !loading && localFullyBookedSessions.length > 0 && groupByProperty(localFullyBookedSessions, "label", "label").map((sessionByLabel) => {
      const fullyBooked = sessionByLabel.items.every((item) => item.fullyBooked);
      return /* @__PURE__ */ React__default.createElement(Spacer, { key: sessionByLabel.id, direction: "vertical", gap: 0 }, /* @__PURE__ */ React__default.createElement(
        Checkbox,
        {
          color: theme2.colors.charcoal,
          label: getSessionLabel(sessionByLabel.label),
          onChange: () => bulkUpdateLocalFullyBookedSession(sessionByLabel.label, !fullyBooked),
          selected: fullyBooked,
          style: {
            container: {
              background: theme2.colors.dune,
              borderRadius: "12px",
              margin: "0 -12px",
              padding: "8px 12px",
              width: "100%"
            },
            label: {
              color: theme2.colors.charcoal,
              fontSize: "15px",
              fontWeight: theme2.fontWeights.bold,
              lineHeight: 0
            },
            checkboxBox: { height: "24px", width: "24px" }
          }
        }
      ), immutableSort(
        sessionByLabel.items,
        (a, b) => sortAlphaNumericByProperty(a, b, "name")
      ).map((item) => /* @__PURE__ */ React__default.createElement(
        Checkbox,
        {
          key: item.name,
          color: theme2.colors.charcoal,
          label: item.name,
          onChange: () => updateLocalFullyBookedSession(item.sessionId, item.areaId, !item.fullyBooked),
          selected: item.fullyBooked,
          style: {
            container: {
              borderRadius: "12px",
              margin: "0 -12px",
              padding: "8px 12px",
              width: "100%"
            },
            label: { color: theme2.colors.smoke, fontSize: "15px", lineHeight: 0 },
            checkboxBox: { height: "24px", width: "24px" }
          }
        }
      )));
    })),
    /* @__PURE__ */ React__default.createElement(
      Popover$3,
      {
        anchorEl: tooltipAnchorEl,
        isOpen: !!tooltipAnchorEl,
        onClose: () => setTooltipAnchorEl(null),
        innerStyle: {
          borderRadius: "8px",
          padding: "12px 20px",
          maxWidth: "484px",
          boxShadow: "0px 4px 8px rgba(151, 151, 151, 0.25)",
          border: "1px solid rgb(231, 225, 215)",
          marginBottom: "24px",
          marginTop: 0
        },
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "center"
        }
      },
      /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "15px" } }, "Fully Book will quickly stop any new bookings from being made. But don't worry, you can always unselect it if you change your mind and want to allow more bookings.")
    )
  );
};
FullyBookModal.defaultProps = {
  date: null
};
FullyBookModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  areas: areasPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  fetchAreas: PropTypes.func.isRequired,
  date: momentPropTypes.momentObj,
  fetchFullyBookedSessions: PropTypes.func.isRequired,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired,
  bulkUpdateFullyBookedSessions: PropTypes.func.isRequired
};
const mapStateToProps$P = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  areas: state.areas,
  obeeSessions: state.obeeSessions,
  fullyBookedSessions: state.fullyBookedSessions
});
const mapDispatchToProps$O = (dispatch) => bindActionCreators(
  {
    fetchSessions: fetchSessionsAction,
    fetchFullyBookedSessions: fetchFullyBookedSessionsAction,
    fetchAreas: fetchAreasAction,
    bulkUpdateFullyBookedSessions: bulkUpdateFullyBookedSessionsAction
  },
  dispatch
);
const FullyBookModal$1 = connect(mapStateToProps$P, mapDispatchToProps$O)(FullyBookModal);
const useStyles$l = createUseStyles(
  (theme2) => ({
    container: {
      width: "435px",
      [theme2.breakpoints.down("sm")]: {
        maxWidth: "332px"
      }
    },
    headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      position: "sticky",
      top: "0",
      zIndex: "99",
      gap: "16px",
      flexDirection: "column",
      backgroundColor: theme2.colors.linen
    },
    headerContent: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "22px",
      color: theme2.colors.charcoal,
      fontWeight: theme2.fontWeights.medium,
      padding: "0 22px"
    },
    headerLeft: {
      display: "flex",
      flexDirection: "column"
    },
    headerRight: {
      display: "flex",
      gap: "6px",
      alignItems: "flex-end",
      paddingBottom: "4px"
    },
    separator: {
      borderBottom: `1px solid ${theme2.colors.headerButtonOutline}`
    },
    detailsContainer: {
      padding: "16px 12px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      marginBottom: "14px"
    },
    navigationSection: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      padding: "0"
    },
    actionsContainer: {
      padding: "0 22px",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },
    // For padding
    navigationContainerOuter: {
      padding: "0 14px"
      // 22px minus 8px padding to sit flush on left side
    },
    navigationContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },
    sessionBreakdownContainer: {
      display: "grid",
      gridTemplateColumns: "1fr 65px 75px",
      gridTemplateRows: "24px",
      flexDirection: "column",
      gap: "10px 8px",
      alignItems: "center",
      alignContent: "center",
      justifyItems: "end",
      backgroundColor: theme2.colors.white,
      borderRadius: "24px",
      padding: "16px 20px",
      fontSize: "15px",
      color: theme2.colors.charcoal,
      "& :first-child": {
        gap: "16px"
        // paddingBottom: '12px',
      }
    },
    sessionBreakdownHeader: {
      justifySelf: "start",
      fontSize: "18px",
      fontWeight: theme2.fontWeights.medium
    },
    sessionBreakdownLabel: {
      justifySelf: "start",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },
    circle: {
      width: "12px",
      height: "12px",
      minWidth: "12px",
      minHeight: "12px",
      borderRadius: "50%"
    },
    sessionTotals: {
      display: "inline-flex",
      whiteSpace: "nowrap",
      width: "fit-content",
      padding: "0px 6px",
      // borderBottom: 'none',
      minWidth: "40px",
      justifyContent: "center",
      borderRadius: "40px"
    },
    specialBookingsContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "2px",
      backgroundColor: theme2.colors.white,
      borderRadius: "24px",
      padding: "16px 20px",
      color: theme2.colors.charcoal
    },
    tableNumber: {
      height: "24px",
      border: `1px solid ${theme2.colors.shark}`,
      borderRadius: "4px",
      padding: "0 8px",
      display: "flex",
      // alignItems: 'center',
      textAlign: "center",
      userSelect: "none",
      maxWidth: "100px",
      flexGrow: 1,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    bookingRow: {
      display: "flex",
      gap: "8px",
      justifyContent: "space-between",
      alignItems: "center",
      textAlign: "left",
      borderTop: `1px solid ${theme2.colors.grayBorder}`,
      height: "48px",
      marginLeft: "-12px",
      marginRight: "-12px",
      paddingLeft: "6px",
      paddingRight: "6px"
    },
    bookingRowLeft: {
      display: "flex",
      gap: "8px",
      justifyContent: "flex-start",
      alignItems: "center",
      textAlign: "left"
    },
    bookingRowRight: {
      display: "flex",
      gap: "8px",
      justifyContent: "flex-start",
      alignItems: "center"
    },
    specialBookingSummary: {
      color: theme2.colors.smoke,
      textAlign: "right"
    },
    bookingRowItem: {},
    bookingRowTags: {
      display: "flex",
      gap: "2px",
      overflow: "hidden",
      width: "90px",
      minWidth: "90px",
      maxWidth: "90px",
      justifyContent: "flex-end"
      // overflow: 'scroll',
    },
    bookingRowTagsInner: {
      overflowX: "auto",
      maxWidth: "100%",
      display: "flex",
      gap: "2px",
      // justifyContent: 'flex-end',
      alignItems: "center"
    }
  }),
  { name: "CalendarDayReportModal" }
);
const SvgPageRunsheet = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M4.68359 0.5H24.3566C24.6327 0.5 24.8566 0.723858 24.8566 1V12.4165C24.8566 12.6926 24.6327 12.9165 24.3566 12.9165H4.68359C4.40745 12.9165 4.18359 12.6926 4.18359 12.4165V0.999999C4.18359 0.723857 4.40745 0.5 4.68359 0.5Z", fill: "currentColor", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M25.1071 9H26C27.1046 9 28 9.89543 28 11V11C28 12.1046 27.1046 13 26 13H3C1.89543 13 1 12.1046 1 11V11C1 9.89543 1.89543 9 3 9L3.68421 9", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M1 11V26C1 26.5523 1.44772 27 2 27H27C27.5523 27 28 26.5523 28 26V11", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 4.5, y: 18.5, width: 3, height: 3, rx: 0.5, stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 9.5, y: 18.5, width: 3, height: 3, rx: 0.5, stroke: "#313131" }));
const PrinterIconSVG = SvgPageRunsheet;
const SvgPageTimeline = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 27 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M14 29L14 1", stroke: "black", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 12.5, width: 21, height: 5, rx: 2.5, fill: "currentColor", stroke: "black" }), /* @__PURE__ */ React$7.createElement("rect", { x: 5.5, y: 4.5, width: 21, height: 5, rx: 2.5, fill: "currentColor", stroke: "black" }), /* @__PURE__ */ React$7.createElement("rect", { x: 4.5, y: 20.5, width: 21, height: 5, rx: 2.5, fill: "currentColor", stroke: "black" }));
const TimelineIconSVG = SvgPageTimeline;
const SvgPageFloorplan = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 15.0011, cy: 15.0001, r: 11.9444, fill: "currentColor", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M20.375 4.584V4.584C20.375 2.60461 18.7704 1 16.7911 1H13.207C11.2277 1 9.62305 2.60461 9.62305 4.584V4.584", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.62495 25.416V25.416C9.62495 27.3954 11.2296 29 13.2089 29L16.793 29C18.7723 29 20.377 27.3954 20.377 25.416V25.416", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M4.584 9.62398V9.62398C2.60461 9.62398 1 11.2286 1 13.208L1 16.792C1 18.7714 2.60461 20.376 4.584 20.376V20.376", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M25.416 20.376V20.376C27.3954 20.376 29 18.7714 29 16.792L29 13.208C29 11.2286 27.3954 9.62402 25.416 9.62402V9.62402", stroke: "#313131" }));
const FloorplanIconSVG = SvgPageFloorplan;
const CalendarDayReportModal = ({
  date,
  // Date being looked at in the modal
  setDate,
  // Set the modal date
  sessionStats,
  // Calendar data
  monthlyView,
  // Data
  setObeeDate,
  // Set the date for the app. e.g. if looking at the run sheet this is the date it uses
  onClose,
  isOpen,
  areasData,
  // TODO would prefer not to use these just to get the table display number
  tablesData,
  restaurantActive,
  setShowAddBookingModal,
  fetchDailyNotes: fetchDailyNotes2
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$l();
  const history = useHistory();
  const refetchBookings = useRefetchBookings();
  const createNoteRef = useRef({});
  const [fetchingBookingData, setFetchingBookingData] = useState(false);
  const [dataForDay, setDataForDay] = useState({
    bookings: null,
    waitlist: null,
    walkIns: null,
    guests: null,
    cancelled: null,
    noShow: null,
    initialSpecialBookings: [],
    specialBookings: []
  });
  const [showAllSpecialBookings, setShowAllSpecialBookings] = useState(false);
  const [showFullyBookModal, setShowFullyBookModal] = useState(false);
  const style = {
    content: {
      backgroundColor: theme2.colors.linen
    }
  };
  useEffect(() => {
    if (isOpen) {
      setShowAddBookingModal(false);
    }
  }, [date, isOpen]);
  useEffect(() => {
    if (date) {
      fetchDailyNotes2(formatDate(date, "YYYY-MM-DD"));
    }
  }, [date]);
  useEffect(() => {
    const data = {
      date: formatDate(date, "YYYY-MM-DD")
    };
    const fetchBookings = async () => {
      setFetchingBookingData(true);
      setShowAllSpecialBookings(false);
      setDataForDay({
        bookings: null,
        waitlist: null,
        walkIns: null,
        guests: null,
        cancelled: null,
        noShow: null,
        initialSpecialBookings: [],
        specialBookings: []
      });
      const response = await fetchObeeBookings(data);
      if (response.data) {
        setDataForDay(response.data);
        const fetchedBookings = response.data.map(getData$i);
        let walkInBookings = [];
        let regularBookings = [];
        let waitlistBookings = [];
        let cancelledBookings = [];
        let noShowBookings = [];
        setFetchingBookingData(false);
        fetchedBookings == null ? void 0 : fetchedBookings.forEach((booking) => {
          if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.WAITING) {
            waitlistBookings = [...waitlistBookings, booking];
            return;
          }
          if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.CANCELLED) {
            cancelledBookings = [...cancelledBookings, booking];
            return;
          }
          if ((booking == null ? void 0 : booking.status) === STATUS_TYPES.NO_SHOW) {
            noShowBookings = [...noShowBookings, booking];
          }
          if ((booking == null ? void 0 : booking.source) === "walkin") {
            walkInBookings = [...walkInBookings, booking];
          }
          regularBookings = [...regularBookings, booking];
        });
        const newSpecialBookings = regularBookings.filter(
          (booking) => (booking == null ? void 0 : booking.isBirthday) || (booking == null ? void 0 : booking.isCelebration) || (booking == null ? void 0 : booking.isAnniversary) || getVIPstatus(booking)
        ).map((booking) => ({
          ...booking,
          displayTableNumber: getDisplayTableNumberForBooking(areasData, tablesData, booking)
        }));
        const bookingsData = {
          totalBookings: fetchedBookings.length,
          bookings: regularBookings.length,
          // TODO should this be ALL bookings or the ones that aren't cancelled, walk-ins, etc?
          waitlist: waitlistBookings.length,
          walkIns: walkInBookings.length,
          guests: regularBookings.reduce((accum, booking) => accum + booking.size, 0),
          cancelled: cancelledBookings.length,
          noShow: noShowBookings.length,
          initialSpecialBookings: newSpecialBookings.slice(0, 5),
          // Only show first 5
          specialBookings: newSpecialBookings
          // All of them when "show more" is clicked
        };
        setFetchingBookingData(false);
        setDataForDay(bookingsData);
        return bookingsData;
      }
    };
    if (date && isOpen) {
      fetchBookings();
    }
  }, [date, isOpen]);
  const displayMonth = useMemo(() => moment$2(date).format("MMMM"), [date]);
  const displayDay = useMemo(() => moment$2(date).format("dddd Do"), [date]);
  const setNextDay = useCallback(() => {
    setDate(moment$2(date).add(1, "day").format("YYYY-MM-DD"));
  }, [date]);
  const setPrevDay = useCallback(() => {
    setDate(moment$2(date).subtract(1, "day").format("YYYY-MM-DD"));
  }, [monthlyView.data, date]);
  const reportModalData = useMemo(() => {
    var _a, _b2;
    const calendarDay = (_b2 = (_a = monthlyView.data) == null ? void 0 : _a.monthlyViewData) == null ? void 0 : _b2.find((day) => day.date === date);
    return calendarDay;
  }, [date, monthlyView.data]);
  const navButtonStyle = {
    button: {
      padding: "8px 20px",
      fontWeight: theme2.fontWeights.medium,
      border: `1px solid ${theme2.colors.charcoal}`,
      height: "auto",
      backgroundColor: theme2.colors.linen,
      lineHeight: "normal"
    }
  };
  const textButtonStyle = {
    button: {
      padding: "8px 14px 8px 10px",
      fontWeight: theme2.fontWeights.medium,
      borderRadius: "12px",
      height: "auto",
      backgroundColor: theme2.colors.linen,
      lineHeight: "20px"
    }
  };
  const dateChangeButtonStyle = {
    button: {
      padding: "14px 12px",
      border: `1px solid ${theme2.colors.yetAnotherGray27}`,
      borderRadius: "12px",
      height: "auto",
      backgroundColor: theme2.colors.linen,
      color: theme2.colors.charcoal
    }
  };
  const navAction = (location) => {
    var _a;
    const from = history.location.pathname;
    const dateTo = moment$2(date);
    refetchBookings(dateTo);
    if (dateTo !== moment$2(date)) {
      setObeeDate(dateTo);
    }
    history.push(`${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/${location}`, {
      from
    });
  };
  const quickNavActions = [
    {
      label: "Run sheet",
      icon: /* @__PURE__ */ React__default.createElement(PrinterIconSVG, { height: "20px" }),
      action: () => navAction("runsheet")
    },
    ...hasBookingsPremium(restaurantActive) ? [
      {
        label: "Floor plan",
        icon: /* @__PURE__ */ React__default.createElement(FloorplanIconSVG, { height: "20px" }),
        action: () => navAction("floorplan")
      },
      {
        label: "Timeline",
        icon: /* @__PURE__ */ React__default.createElement(TimelineIconSVG, { height: "20px" }),
        action: () => navAction("timeline")
      }
    ] : []
  ];
  const confirmedSessionGroups = useMemo(() => {
    if (isEmpty(reportModalData == null ? void 0 : reportModalData.sessionGroups)) {
      return [];
    }
    const sessionBookings = Object.values(reportModalData == null ? void 0 : reportModalData.sessionGroups);
    return sessionStats.map((sessionData) => {
      const sessionGroup = findObjectByProperty(sessionBookings, sessionData.label, "label");
      return {
        ...sessionGroup,
        sessionData
      };
    }).filter((sessionGroup) => {
      var _a;
      return (_a = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _a.confirmed;
    });
  }, [reportModalData == null ? void 0 : reportModalData.sessionGroups]);
  return /* @__PURE__ */ React__default.createElement(
    LiveBookingModal$1,
    {
      isOpen,
      onClose: () => {
        setShowAddBookingModal(false);
        onClose();
      },
      headerHeight: 32,
      style
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerLeft }, /* @__PURE__ */ React__default.createElement(Box, null, displayMonth), /* @__PURE__ */ React__default.createElement(Box, null, displayDay)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerRight }, /* @__PURE__ */ React__default.createElement(RoundButton, { style: dateChangeButtonStyle, onClick: setPrevDay }, /* @__PURE__ */ React__default.createElement(LeftArrowSVG, { style: { width: "6px", height: "10px", color: "black" } })), /* @__PURE__ */ React__default.createElement(RoundButton, { style: dateChangeButtonStyle, onClick: setNextDay }, /* @__PURE__ */ React__default.createElement(RightArrowSVG, { style: { width: "6px", height: "10px", color: "black" } })))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.actionsContainer }, /* @__PURE__ */ React__default.createElement(
      RoundButton,
      {
        style: navButtonStyle,
        onClick: () => {
          setShowAddBookingModal(true, null, false, date);
          onClose();
        }
      },
      "Add booking"
    ), /* @__PURE__ */ React__default.createElement(RoundButton, { style: navButtonStyle, onClick: () => setShowFullyBookModal(true) }, "Fully book")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.navigationSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.separator }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.navigationContainerOuter }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.navigationContainer }, quickNavActions.map((quickAction) => /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "text",
        key: quickAction.label,
        style: textButtonStyle,
        onClick: quickAction.action
      },
      /* @__PURE__ */ React__default.createElement(Spacer, null, /* @__PURE__ */ React__default.createElement(Box, { style: { color: "white", height: "20px" } }, quickAction.icon), /* @__PURE__ */ React__default.createElement(Box, null, quickAction.label))
    )))), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.separator }), /* @__PURE__ */ React__default.createElement(Box, { style: { height: "2px" } }, fetchingBookingData && /* @__PURE__ */ React__default.createElement(LinearProgress, null))))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.detailsContainer }, /* @__PURE__ */ React__default.createElement(BookingDaySummary$1, { data: dataForDay, loading: fetchingBookingData }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionBreakdownContainer }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionBreakdownHeader }, "By session"), !isEmpty(confirmedSessionGroups) ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, null, "Guests"), /* @__PURE__ */ React__default.createElement(Box, null, "Bookings")) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, null), /* @__PURE__ */ React__default.createElement(Box, null))), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, isEmpty(confirmedSessionGroups) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionBreakdownLabel, style: { fontSize: "15px" } }, "No bookings for this day"), confirmedSessionGroups.map((sessionGroup) => {
      var _a, _b2, _c2, _d2, _e2, _f, _g;
      return /* @__PURE__ */ React__default.createElement(Fragment, { key: sessionGroup == null ? void 0 : sessionGroup.label }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionBreakdownLabel }, /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.circle,
          style: {
            backgroundColor: (_a = sessionGroup.sessionData.themeColors) == null ? void 0 : _a.numberBackgroundColor
          }
        }
      ), /* @__PURE__ */ React__default.createElement(Box, null, getSessionLabel(sessionGroup.label))), /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.sessionTotals,
          style: {
            backgroundColor: (_b2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _b2.backgroundColor
          }
        },
        (_d2 = (_c2 = sessionGroup.statuses) == null ? void 0 : _c2.confirmed) == null ? void 0 : _d2.total_covers
      ), /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: classes.sessionTotals,
          style: {
            backgroundColor: (_e2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _e2.backgroundColor
          }
        },
        (_g = (_f = sessionGroup.statuses) == null ? void 0 : _f.confirmed) == null ? void 0 : _g.total_bookings
      ));
    }))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.specialBookingsContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionBreakdownHeader }, "VIP & occasions"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionBreakdownBody }, fetchingBookingData ? /* @__PURE__ */ React__default.createElement(Box, { style: { paddingTop: "10px", minHeight: "34px" } }) : !fetchingBookingData && isEmpty(dataForDay.specialBookings) ? /* @__PURE__ */ React__default.createElement(Box, { style: { paddingTop: "10px", minHeight: "34px" } }, "No VIP or occasion bookings for this day") : /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.specialBookingSummary }, "Total ", dataForDay.specialBookings.length), (showAllSpecialBookings ? dataForDay.specialBookings : dataForDay.initialSpecialBookings).map((booking) => /* @__PURE__ */ React__default.createElement(Box, { key: booking.id, className: `${classes.bookingRow}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingRowLeft }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingRowItem }, formatTimeFromInt(booking.startTime, "h:mma")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingRowItem }, getSessionLabel(booking.name))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingRowRight }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableNumber, title: booking == null ? void 0 : booking.displayTableNumber }, booking == null ? void 0 : booking.displayTableNumber), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingRowTags }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingRowTagsInner }, getVIPstatus(booking) && /* @__PURE__ */ React__default.createElement(Tag$1, { type: "vip" }), (booking == null ? void 0 : booking.isBirthday) && /* @__PURE__ */ React__default.createElement(Tag$1, { type: "celebration", label: "Birthday" }), (booking == null ? void 0 : booking.isAnniversary) && /* @__PURE__ */ React__default.createElement(Tag$1, { type: "celebration", label: "Anniversary" }), (booking == null ? void 0 : booking.isCelebration) && /* @__PURE__ */ React__default.createElement(Tag$1, { type: "celebration", label: "Celebration" })))))))), dataForDay.specialBookings.length > 5 && /* @__PURE__ */ React__default.createElement(RoundButton, { onClick: () => setShowAllSpecialBookings(!showAllSpecialBookings) }, showAllSpecialBookings ? "Show less" : "Show more")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.specialBookingsContainer }, /* @__PURE__ */ React__default.createElement(DailyNotesList$1, { createNoteRef, date })))),
    /* @__PURE__ */ React__default.createElement(DeferRender$1, { isShowing: showFullyBookModal }, /* @__PURE__ */ React__default.createElement(
      FullyBookModal$1,
      {
        isOpen: showFullyBookModal,
        onClose: () => setShowFullyBookModal(false),
        date
      }
    ))
  );
};
CalendarDayReportModal.defaultProps = {
  date: moment$2(),
  sessionStats: []
};
CalendarDayReportModal.propTypes = {
  date: PropTypes.oneOfType([momentPropTypes.momentObj, PropTypes.string]),
  sessionStats: PropTypes.arrayOf(PropTypes.shape({})),
  monthlyView: monthlyViewPropTypes.isRequired,
  setObeeDate: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  areasData: PropTypes.arrayOf(areaPropTypes).isRequired,
  tablesData: PropTypes.arrayOf(tablePropTypes).isRequired,
  restaurantActive: restaurantPropTypes.isRequired,
  setShowAddBookingModal: PropTypes.func.isRequired,
  fetchDailyNotes: PropTypes.func.isRequired
};
const mapStateToProps$O = (state) => ({
  monthlyView: state.monthlyView,
  areasData: state.areas.data,
  tablesData: state.tables.data,
  restaurantActive: state.restaurantActive.restaurant
});
const mapDispatchToProps$N = (dispatch) => bindActionCreators(
  {
    setObeeDate: setObeeDateAction,
    setShowAddBookingModal: setObeeShowAddBookingModalAction,
    fetchDailyNotes: fetchDailyNotesAction
  },
  dispatch
);
const CalendarDayReportModal$1 = connect(mapStateToProps$O, mapDispatchToProps$N)(CalendarDayReportModal);
const useStyles$k = createUseStyles(
  (theme2) => ({
    container: {
      position: "relative",
      minHeight: "130px",
      maxHeight: "250px",
      // overflow: 'hidden',
      "&:hover": {
        "& $calendarLink": {
          opacity: 1
        }
      }
    },
    calendarDay: {
      position: "relative",
      zIndex: 1,
      userSelect: "none"
    },
    calendarCell: {
      position: "relative",
      display: "flex",
      alignItems: "flex-start",
      flexWrap: "nowrap",
      gap: "12px",
      padding: "10px 6px 4px 12px",
      border: `1px solid ${theme2.colors.yetAnotherGray24}`,
      borderRadius: "2px",
      height: "100%",
      cursor: "pointer",
      backgroundColor: theme2.colors.white,
      fontSize: "15px",
      "& $calendarDay": {
        color: theme2.colors.smoke,
        lineHeight: "18px"
      },
      "&:hover": {
        filter: "brightness(99%)",
        color: theme2.colors.black,
        border: `1px solid ${theme2.colors.nimbus}`
      }
    },
    closed: {
      backgroundColor: "#FCFCFC",
      color: theme2.colors.nimbus,
      textAlign: "right",
      "&:hover": {
        color: theme2.colors.smoke
      }
    },
    emptyCell: {
      backgroundColor: theme2.colors.yetAnotherGray12,
      border: `1px solid ${theme2.colors.white}`,
      cursor: "auto",
      "& $calendarDay": {
        color: theme2.colors.yetAnotherGray20
      },
      "&:hover": {
        filter: "none",
        border: `1px solid ${theme2.colors.white}`,
        "& $calendarLink": {
          opacity: 0
        }
      }
    },
    today: {
      border: `1px solid ${theme2.colors.nimbus}`,
      "& $calendarDay": {
        "&:after": {
          position: "absolute",
          left: "-7px",
          top: "-6px",
          margin: "auto",
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          color: theme2.colors.black,
          content: '""',
          zIndex: -1
        }
      }
    },
    selected: {
      border: `1px solid ${theme2.colors.charcoal}`,
      "& $calendarDay": {
        "&:after": {
          position: "absolute",
          left: "-7px",
          top: "-6px",
          margin: "auto",
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          backgroundColor: theme2.colors.linen,
          content: '""',
          zIndex: -1
        }
      }
    },
    calendarContent: {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      flexGrow: 1,
      flexShrink: 1,
      // minWidth: '120px',
      marginLeft: "auto",
      overflow: "hidden"
    },
    calendarLink: {
      position: "absolute",
      opacity: 0,
      bottom: 1,
      left: 1,
      width: "32px",
      height: "37px",
      borderRadius: "0 16px 0 0",
      color: theme2.colors.smoke,
      borderRight: `1px solid  ${theme2.colors.yetAnotherGray24}`,
      borderTop: `1px solid  ${theme2.colors.yetAnotherGray24}`,
      padding: "12px 8px",
      backgroundColor: "white",
      cursor: "pointer",
      zIndex: 1,
      "&:hover": {
        opacity: 1,
        filter: "brightness(99%)",
        color: theme2.colors.black
      }
    },
    calendarSessionContainer: {
      position: "relative",
      padding: "0 0 0 8px"
    },
    calendarStats: {
      display: "flex",
      flexDirection: "column",
      gap: "4px"
    },
    summaryCell: {
      display: "flex",
      alignItems: "center",
      border: `1px solid ${theme2.colors.yetAnotherGray24}`,
      borderRadius: "50px",
      backgroundColor: theme2.colors.white,
      color: theme2.colors.black,
      fontSize: "12px",
      lineHeight: "18px",
      height: "25px",
      overflow: "hidden"
    },
    summaryText: {
      width: "100%",
      overflow: "hidden",
      position: "relative",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      lineClamp: 1,
      WebkitLineClamp: 1,
      padding: "2px 4px 2px 8px",
      userSelect: "none",
      textAlign: "left"
    },
    summaryNumber: {
      borderRadius: theme2.borderRadius.xxxl,
      padding: "2px 4px",
      fontSize: "12px",
      backgroundColor: theme2.colors.calendarStatsTotalBackground,
      border: `1px solid ${theme2.colors.black}`,
      minWidth: "30px",
      textAlign: "center",
      lineHeight: "normal",
      height: "100%",
      userSelect: "none"
    },
    summaryNoBookingText: {
      color: theme2.colors.yetAnotherGray25
    },
    closedMessage: {
      width: "100%",
      paddingRight: "8px",
      textAlign: "right"
    },
    activeDayLabel: {
      position: "absolute",
      fontSize: "12px",
      border: `1px solid ${theme2.colors.smoke}`,
      borderRadius: "20px",
      top: "2px",
      color: "white",
      fontWeight: theme2.fontWeights.medium,
      backgroundColor: theme2.colors.smoke,
      zIndex: 1,
      padding: "2px 8px",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },
    icon: {
      color: theme2.colors.white,
      marginTop: "8px",
      width: "16px",
      height: "16px"
    }
  }),
  { name: "CalendarDay" }
);
const SvgCurveArrow = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M1 1C4.66667 1.16667 10.5 6.4 10.5 14M10.5 14L14 9M10.5 14L5 11", stroke: "currentColor" }));
const CurveArrowSVG = SvgCurveArrow;
const CalendarDay = ({
  calendarDay,
  sessionStats,
  showModal,
  isSelected,
  setObeeDate,
  sessionFilter,
  obeeSessions: obeeSessions2,
  eventSessions,
  hasMultipleSessions,
  defaultLandingPage
}) => {
  var _a;
  const classes = useStyles$k();
  const history = useHistory();
  const refetchBookings = useRefetchBookings();
  const isToday = useMemo(() => isCurrentDate(moment$2(calendarDay.date)), [calendarDay]);
  const closeEvent = (_a = eventSessions.filter(
    (sessionStat) => (sessionStat == null ? void 0 : sessionStat.isClosed) && (sessionStat == null ? void 0 : sessionStat.date) === calendarDay.date
  )) == null ? void 0 : _a[0];
  const sessionsForDay = useMemo(() => {
    return getTodaySessions(calendarDay.date, obeeSessions2, sessionFilter);
  }, [obeeSessions2.data, calendarDay.date, sessionFilter]);
  const openingSession = sessionsForDay == null ? void 0 : sessionsForDay.reduce(
    (prev, curr) => prev.startTime < curr.startTime ? prev : curr,
    {}
  );
  const closingSession = sessionsForDay == null ? void 0 : sessionsForDay.reduce(
    (prev, curr) => prev.endTime > curr.endTime ? prev : curr,
    {}
  );
  const isClosed = isEmpty(sessionsForDay) || (openingSession == null ? void 0 : openingSession.startTime) === (closingSession == null ? void 0 : closingSession.endTime) || !isEmpty(closeEvent);
  const filteredSessionBreakdowns = useMemo(() => {
    const sessionBookings = calendarDay.totalCovers > 0 || calendarDay.waitlistCovers > 0 ? Object.values(calendarDay.sessionGroups) : [];
    const mergedData = sessionStats.map((sessionData) => {
      const sessionGroup = findObjectByProperty(sessionBookings, sessionData.label, "label");
      return {
        ...sessionGroup,
        sessionData
      };
    });
    return {
      confirmed: mergedData.filter(
        (sessionGroup) => {
          var _a2, _b2;
          return ((_b2 = (_a2 = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _a2.confirmed) == null ? void 0 : _b2.total_bookings) > 0;
        }
      ),
      waitlist: mergedData.filter(
        (sessionGroup) => {
          var _a2, _b2;
          return ((_b2 = (_a2 = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _a2.waitlist) == null ? void 0 : _b2.total_bookings) > 0;
        }
      )
    };
  }, [calendarDay, sessionStats]);
  const changeDateAndScreen = (location) => {
    var _a2;
    const from = history.location.pathname;
    const dateTo = moment$2(calendarDay.date);
    refetchBookings(dateTo);
    if (dateTo !== moment$2(calendarDay.date)) {
      setObeeDate(dateTo);
    }
    history.push(`${(_a2 = window.bookingsConfig) == null ? void 0 : _a2.routePrefix}/${location}`, {
      from
    });
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, calendarDay.currentMonth && /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.calendarLink,
      onMouseOver: (e) => e.stopPropagation(),
      onMouseEnter: (e) => e.stopPropagation(),
      onClick: () => changeDateAndScreen(defaultLandingPage || "runsheet")
    },
    /* @__PURE__ */ React__default.createElement(CurveArrowSVG, null)
  ), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `
        ${classes.calendarCell} 
        ${isClosed ? classes.closed : ""} 
        ${calendarDay.currentMonth ? "" : classes.emptyCell} 
        ${isToday ? classes.today : ""} 
        ${isSelected ? classes.selected : ""}
        `,
      onClick: () => calendarDay.currentMonth && showModal()
    },
    isToday && /* @__PURE__ */ React__default.createElement(Box, { className: classes.activeDayLabel }, "Today"),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarDay }, /* @__PURE__ */ React__default.createElement(Box, null, calendarDay.dateNo), calendarDay.hasNotes && /* @__PURE__ */ React__default.createElement(NotesSVG, { className: classes.icon })),
    calendarDay.currentMonth && isClosed && (!filteredSessionBreakdowns.confirmed.length > 0 || filteredSessionBreakdowns.waitlist.length > 0) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.closedMessage }, sessionFilter === "all_sessions" && /* @__PURE__ */ React__default.createElement(Box, null, "Closed"), closeEvent && (closeEvent == null ? void 0 : closeEvent.label) !== "Closed" && /* @__PURE__ */ React__default.createElement(Box, null, closeEvent.label)),
    calendarDay.currentMonth && (filteredSessionBreakdowns.confirmed.length > 0 || filteredSessionBreakdowns.waitlist.length > 0) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarContent }, hasMultipleSessions && sessionFilter === "all_sessions" && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.summaryCell}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, "Guests"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryNumber }, calendarDay.totalCovers)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarSessionContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarStats }, filteredSessionBreakdowns.confirmed.map((sessionGroup) => {
      var _a2, _b2, _c2, _d2, _e2;
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: sessionGroup.label,
          className: `${classes.summaryCell}`,
          style: {
            backgroundColor: (_a2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _a2.backgroundColor
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, getSessionLabel(sessionGroup.label)),
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.summaryNumber,
            style: {
              backgroundColor: (_b2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _b2.numberBackgroundColor,
              border: `1px solid ${(_c2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _c2.numberOutlineColor}`
            }
          },
          (_e2 = (_d2 = sessionGroup.statuses) == null ? void 0 : _d2.confirmed) == null ? void 0 : _e2.total_covers
        )
      );
    }), sessionFilter !== "all_sessions" && filteredSessionBreakdowns.waitlist.map((sessionGroup) => {
      var _a2, _b2, _c2, _d2, _e2;
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: sessionGroup.label,
          className: `${classes.summaryCell}`,
          style: {
            backgroundColor: (_a2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _a2.backgroundColor
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, "Waitlist"),
        /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.summaryNumber,
            style: {
              backgroundColor: (_b2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _b2.numberBackgroundColor,
              border: `1px solid ${(_c2 = sessionGroup.sessionData.themeColors) == null ? void 0 : _c2.numberOutlineColor}`
            }
          },
          (_e2 = (_d2 = sessionGroup.statuses) == null ? void 0 : _d2.waitlist) == null ? void 0 : _e2.total_covers
        )
      );
    }), calendarDay.waitlistCovers > 0 && sessionFilter === "all_sessions" && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.summaryCell}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryText }, "Waitlist"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.summaryNumber }, calendarDay.waitlistCovers)))))
  ));
};
CalendarDay.defaultProps = {
  sessionStats: [],
  eventSessions: [],
  calendarDay: {},
  isSelected: false,
  hasMultipleSessions: false
};
CalendarDay.propTypes = {
  sessionStats: PropTypes.arrayOf(PropTypes.shape({})),
  eventSessions: PropTypes.arrayOf(PropTypes.shape({})),
  showModal: PropTypes.func.isRequired,
  calendarDay: monthlyViewDayPropTypes,
  isSelected: PropTypes.bool,
  hasMultipleSessions: PropTypes.bool,
  setObeeDate: PropTypes.func.isRequired,
  sessionFilter: PropTypes.string.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  defaultLandingPage: PropTypes.string.isRequired
};
const mapStateToProps$N = (state) => {
  var _a, _b2;
  return {
    sessionFilter: state.obeeScreen.sessionFilter,
    obeeSessions: state.obeeSessions,
    defaultLandingPage: (_b2 = (_a = state.obeeSettings) == null ? void 0 : _a.data) == null ? void 0 : _b2.defaultLandingPage
  };
};
const mapDispatchToProps$M = (dispatch) => bindActionCreators(
  {
    setObeeDate: setObeeDateAction
  },
  dispatch
);
const CalendarDay$1 = connect(mapStateToProps$N, mapDispatchToProps$M)(CalendarDay);
const CalendarView = ({
  obeeSessions: obeeSessions2,
  monthlyView,
  calendarMonth,
  setCalendarMonth,
  sessionFilter
}) => {
  const classes = useStyles$s();
  const showCardView = useBreakpointDown(1036);
  const [calendarDays, setCalendarDays] = useState([]);
  const [sessionStats, setSessionStats] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalDate, setModalDate] = useState(null);
  const loadingSessions = obeeSessions2.pending;
  useEffect(() => {
    if (showModal) {
      const modalMonth = moment$2(modalDate, "YYYY-MM-DD").format("MMMM YYYY");
      if (modalMonth !== calendarMonth) {
        setModalDate(moment$2(calendarMonth, "MMMM YYYY").format("YYYY-MM-DD"));
      }
    }
  }, [calendarMonth]);
  const eventSessions = useMemo(() => {
    return obeeSessions2.data.filter((session) => session.date);
  }, [obeeSessions2.data]);
  const groupedSessionLabels = useMemo(() => {
    var _a, _b2;
    if (isEmpty(obeeSessions2.data)) {
      return [];
    }
    const sessionColors = getSessionColorMap(obeeSessions2.data);
    const sessionsWithOrderIndex = getMonthSessions(
      calendarMonth,
      obeeSessions2.data,
      sessionFilter
    ).map((session) => ({
      ...session,
      themeColors: getColorForSession(session, sessionColors),
      totalBookings: 0,
      totalCovers: 0,
      totalWaitlistBookings: 0,
      totalWaitlistCovers: 0
    }));
    const groupedSessions = groupAsObjectByProperty(
      getMonthSessions(calendarMonth, sessionsWithOrderIndex, sessionFilter),
      "label"
    );
    const filteredMonthlyViewData = (_b2 = (_a = monthlyView.data) == null ? void 0 : _a.monthlyViewData) == null ? void 0 : _b2.filter(
      (dayViewData) => dayViewData == null ? void 0 : dayViewData.currentMonth
    );
    filteredMonthlyViewData == null ? void 0 : filteredMonthlyViewData.forEach((dayViewData) => {
      var _a2;
      const sessionGroups = (dayViewData == null ? void 0 : dayViewData.sessionGroups) || {};
      (_a2 = Object.values(sessionGroups)) == null ? void 0 : _a2.filter(
        (sessionGroup) => sessionFilter === "all_sessions" || (sessionGroup == null ? void 0 : sessionGroup.label) === sessionFilter
      ).forEach((sessionGroup) => {
        var _a3, _b3, _c2, _d2, _e2, _f, _g, _h;
        const sessionLabel = sessionGroup == null ? void 0 : sessionGroup.label;
        const sessionCount = (_b3 = (_a3 = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _a3.confirmed) == null ? void 0 : _b3.total_bookings;
        const guestCount = (_d2 = (_c2 = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _c2.confirmed) == null ? void 0 : _d2.total_covers;
        const waitlistCount = (_f = (_e2 = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _e2.waitlist) == null ? void 0 : _f.total_bookings;
        const waitlistGuestCount = (_h = (_g = sessionGroup == null ? void 0 : sessionGroup.statuses) == null ? void 0 : _g.waitlist) == null ? void 0 : _h.total_covers;
        let existingSession = groupedSessions == null ? void 0 : groupedSessions[sessionLabel];
        if (isVoid(existingSession)) {
          existingSession = {
            // themeColors: getColorForSession(null, sessionColors),
            label: sessionLabel,
            noSession: true,
            totalBookings: 0,
            totalCovers: 0,
            totalWaitlistBookings: 0,
            totalWaitlistCovers: 0
          };
        }
        groupedSessions[sessionLabel] = {
          ...existingSession,
          totalBookings: existingSession.totalBookings += sessionCount || 0,
          totalCovers: existingSession.totalCovers += guestCount || 0,
          totalWaitlistBookings: existingSession.totalWaitlistBookings += waitlistCount || 0,
          totalWaitlistCovers: existingSession.totalWaitlistCovers += waitlistGuestCount || 0
        };
      });
    });
    return groupedSessions;
  }, [calendarMonth, monthlyView.data, obeeSessions2.data, sessionFilter]);
  useEffect(() => {
    var _a, _b2;
    if (isEmpty((_a = monthlyView.data) == null ? void 0 : _a.monthlyViewData)) {
      return;
    }
    const calendarData = (_b2 = monthlyView.data) == null ? void 0 : _b2.monthlyViewData.filter(
      (dayViewData) => showCardView ? dayViewData == null ? void 0 : dayViewData.currentMonth : true
    );
    const newSessionStats = Object.values(groupedSessionLabels).filter((session) => (session == null ? void 0 : session.totalBookings) > 0).filter((session) => sessionFilter === "all_sessions" || (session == null ? void 0 : session.label) === sessionFilter);
    setSessionStats(newSessionStats);
    setCalendarDays(calendarData);
  }, [groupedSessionLabels, monthlyView.data, showCardView, sessionFilter]);
  const hasMultipleSessions = useMemo(() => {
    return groupByProperty(
      obeeSessions2.data.filter((session) => !session.isClosed),
      "label"
    ).length > 1;
  }, [obeeSessions2.data]);
  const handleChangeModalDate = (newDate) => {
    if (showModal && newDate !== null) {
      const oldMonth = moment$2(modalDate, "YYYY-MM-DD").format("MMMM YYYY");
      const newMonth = moment$2(newDate, "YYYY-MM-DD").format("MMMM YYYY");
      if (newMonth !== oldMonth) {
        setCalendarMonth(newMonth);
      }
    }
    setModalDate(newDate);
  };
  if (loadingSessions) {
    return /* @__PURE__ */ React__default.createElement(Skeleton, { height: 600 });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, showCardView ? /* @__PURE__ */ React__default.createElement(
    CalendarCardList$1,
    {
      sessionStats,
      groupedSessionLabels,
      modalDate: showModal ? modalDate : null,
      showModal: (newModalDate) => {
        handleChangeModalDate(newModalDate);
        setShowModal(true);
      },
      eventSessions,
      hasMultipleSessions
    }
  ) : /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendar }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarRowHeader }, weekdays().map((weekday) => /* @__PURE__ */ React__default.createElement("div", { key: weekday.label, className: `${classes.headerCell}` }, weekday.value))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.calendarRow }, calendarDays.map((calendarDay) => /* @__PURE__ */ React__default.createElement(
    CalendarDay$1,
    {
      key: `calendar-day-${calendarDay.date}`,
      calendarDay,
      sessionStats,
      isSelected: showModal && modalDate === calendarDay.date,
      showModal: () => {
        handleChangeModalDate(calendarDay.date);
        setShowModal(true);
      },
      eventSessions,
      hasMultipleSessions
    }
  ))), /* @__PURE__ */ React__default.createElement(CalendarSummary$1, { monthlyView, sessionStats }))), /* @__PURE__ */ React__default.createElement(DeferRender$1, { isShowing: showModal }, /* @__PURE__ */ React__default.createElement(
    CalendarDayReportModal$1,
    {
      setDate: handleChangeModalDate,
      sessionStats,
      onClose: () => {
        setShowModal(false);
        handleChangeModalDate(null);
      },
      isOpen: showModal,
      date: modalDate
    }
  )));
};
CalendarView.defaultProps = {};
CalendarView.propTypes = {
  obeeSessions: sessionsPropTypes.isRequired,
  monthlyView: monthlyViewPropTypes.isRequired,
  setCalendarMonth: PropTypes.func.isRequired,
  calendarMonth: PropTypes.string.isRequired,
  sessionFilter: PropTypes.string.isRequired
};
const mapStateToProps$M = (state) => ({
  obeeSessions: state.obeeSessions,
  monthlyView: state.monthlyView,
  sessionFilter: state.obeeScreen.sessionFilter,
  calendarMonth: state.obeeScreen.calendarMonth
});
const mapDispatchToProps$L = (dispatch) => bindActionCreators(
  {
    fetchMonthlyView: fetchMonthlyViewAction,
    setCalendarMonth: setCalendarMonthAction
  },
  dispatch
);
const CalendarView$1 = connect(mapStateToProps$M, mapDispatchToProps$L)(CalendarView);
const Calendar$1 = ({
  fetchMonthlyView: fetchMonthlyView2,
  calendarMonth,
  bookingsData,
  fetchAreas,
  fetchTables,
  areas,
  tables
}) => {
  useEffect(() => {
    fetchMonthlyView2(formatDate(moment$2(calendarMonth, "MMMM YYYY"), "YYYY-MM-DD"));
  }, [calendarMonth, fetchMonthlyView2, bookingsData]);
  useFetchOnFirstRender([fetchAreas, fetchTables], [areas, tables]);
  return /* @__PURE__ */ React__default.createElement(CalendarView$1, null);
};
Calendar$1.propTypes = {
  calendarMonth: PropTypes.string.isRequired,
  fetchMonthlyView: PropTypes.func.isRequired,
  bookingsData: PropTypes.arrayOf(obeeBookingPropTypes).isRequired,
  fetchAreas: PropTypes.func.isRequired,
  fetchTables: PropTypes.func.isRequired,
  areas: areasPropTypes.isRequired,
  tables: tablesPropTypes.isRequired
};
const mapStateToProps$L = (state) => ({
  calendarMonth: state.obeeScreen.calendarMonth,
  bookingsData: state.obeeBookings.data,
  areas: state.areas,
  tables: state.tables
});
const mapDispatchToProps$K = (dispatch) => bindActionCreators(
  {
    fetchMonthlyView: fetchMonthlyViewAction,
    fetchAreas: fetchAreasAction,
    fetchTables: fetchTablesAction
  },
  dispatch
);
const CalendarScreen = connect(mapStateToProps$L, mapDispatchToProps$K)(Calendar$1);
const completeMetaCallbackAction = (state, accessToken) => (dispatch) => {
  const action = "COMPLETE_META_CALLBACK";
  const data = { state, accessToken };
  const request = () => completeMetaCallback(data);
  dispatch(makeApiAction(action, request, data, "metaCallback"));
};
const getFacebookRedirectUrlAction = (queryString) => (dispatch) => {
  const action = "GET_FACEBOOK_REDIRECT_URL";
  const data = { queryString };
  const request = () => getFacebookRedirectUrl(data);
  dispatch(makeApiAction(action, request, data, "getFBRedirectUrl"));
};
const metaCallbackApiPropTypes = PropTypes.shape({
  data: PropTypes.shape({}),
  apiData: PropTypes.shape({}),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const useStyles$j = createUseStyles({
  container: {
    padding: "50px",
    textAlign: "center"
  }
});
const Integrations$1 = ({ metaCallback: metaCallback2, completeMetaCallback: completeMetaCallback2 }) => {
  const classes = useStyles$j();
  const history = useHistory();
  const hashParams = useHashQuery();
  const params = useQuery();
  useEffect(() => {
    var _a;
    const state = (params == null ? void 0 : params.state) || (hashParams == null ? void 0 : hashParams.state);
    const accessToken = (params == null ? void 0 : params.access_token) || (hashParams == null ? void 0 : hashParams.access_token);
    if (isEmpty(state) && isEmpty(accessToken)) {
      history.replace({
        pathname: `${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/settings`,
        search: `tab=integrations`
      });
      return;
    }
    completeMetaCallback2(state, accessToken);
  }, []);
  useEffect(() => {
    var _a;
    if (metaCallback2.success) {
      history.replace(
        `${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/settings?tab=integrations&integration=meta&status=success`
      );
    }
  }, [metaCallback2.success]);
  useEffect(() => {
    var _a, _b2, _c2;
    if ((_a = metaCallback2 == null ? void 0 : metaCallback2.error) == null ? void 0 : _a.includes("already installed")) {
      history.replace(
        `${(_b2 = window.bookingsConfig) == null ? void 0 : _b2.routePrefix}/settings?tab=integrations&integration=meta&status=success`
      );
    }
    if (metaCallback2.error) {
      devLog("error", "metaCallback", metaCallback2);
      history.replace(
        `${(_c2 = window.bookingsConfig) == null ? void 0 : _c2.routePrefix}/settings?tab=integrations&integration=meta&status=failure&error=${metaCallback2.error}`
      );
    }
  }, [metaCallback2.error]);
  const isLoading = metaCallback2.success === false && isEmpty(metaCallback2.error);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, null, isLoading && "Completing facebook authentication..."), /* @__PURE__ */ React__default.createElement(Box, null, metaCallback2.error));
};
Integrations$1.propTypes = {
  completeMetaCallback: PropTypes.func.isRequired,
  metaCallback: metaCallbackApiPropTypes.isRequired
};
const mapStateToProps$K = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  metaCallback: state.metaCallback
});
const mapDispatchToProps$J = (dispatch) => bindActionCreators(
  {
    fetchIntegrations: fetchIntegrationsAction,
    completeMetaCallback: completeMetaCallbackAction
  },
  dispatch
);
const IntegrationsScreen = connect(mapStateToProps$K, mapDispatchToProps$J)(Integrations$1);
const MarketPlaceIntegrations$1 = ({ getFacebookRedirectUrl: getFacebookRedirectUrl2, facebookRedirectUrl }) => {
  const classes = useStyles$j();
  const history = useHistory();
  const params = useQuery();
  devLog("info", "", { params });
  useEffect(() => {
    const query = params.get("redirect_uri");
    getFacebookRedirectUrl2(`redirect_uri=${query}`);
  }, []);
  useEffect(() => {
    var _a;
    devLog("info", "", { facebookRedirectUrl });
    const debugging = params.get("debug");
    if (debugging) {
      debugger;
    }
    if (facebookRedirectUrl.success && ((_a = facebookRedirectUrl.data) == null ? void 0 : _a.redirectUrl)) {
      window.location.href = facebookRedirectUrl.data.redirectUrl;
    }
  }, [facebookRedirectUrl.success]);
  useEffect(() => {
    var _a;
    if (facebookRedirectUrl.error) {
      devLog("error", "facebook redirect url", facebookRedirectUrl);
      history.replace(
        `${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/settings?tab=integrations&integration=meta&status=failure&error=${facebookRedirectUrl.error}`
      );
    }
  }, [facebookRedirectUrl.error]);
  const isLoading = facebookRedirectUrl.success === false && isEmpty(facebookRedirectUrl.error);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, null, isLoading && "Completing Facebook connection..."), /* @__PURE__ */ React__default.createElement(Box, null, facebookRedirectUrl.error));
};
MarketPlaceIntegrations$1.propTypes = {
  getFacebookRedirectUrl: PropTypes.func.isRequired,
  facebookRedirectUrl: metaCallbackApiPropTypes.isRequired
};
const mapStateToProps$J = (state) => ({
  facebookRedirectUrl: state.facebookRedirectUrl
});
const mapDispatchToProps$I = (dispatch) => bindActionCreators(
  {
    getFacebookRedirectUrl: getFacebookRedirectUrlAction
  },
  dispatch
);
const MarketPlaceIntegrationsScreen = connect(mapStateToProps$J, mapDispatchToProps$I)(MarketPlaceIntegrations$1);
const useStyles$i = createUseStyles((theme2) => ({
  // TODO remove global style changes
  "@global": {
    body: {
      overflow: "hidden"
    }
  },
  guestGridContainer: {
    fontSize: "15px",
    display: "flex",
    background: `${theme2.colors.linen}`,
    boxSizing: "border-box"
  },
  guestBookLeftContainer: {
    minWidth: "362px",
    maxWidth: "362px"
  },
  guestBookRightContainer: {
    width: "calc(100vw - 363px)",
    // To perfectly fill width of screen after sidebar
    height: "calc(100dvh - 64px)"
    // To perfectly fill height
  },
  guestBookPhoneNumber: {},
  guestLeftPane: {
    paddingLeft: "24px",
    paddingTop: "32px"
  },
  guestRightPane: {
    background: "#FFFFFF",
    border: "1px solid #EEEEEE",
    boxShadow: "0px 4px 8px rgba(104, 104, 104, 0.25)",
    borderRadius: "25px 0 0 0",
    width: "100%",
    height: "100%",
    padding: "46px 40px 0 40px"
  },
  guestRightPaneContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%"
  },
  guestSummaryPanel: {
    background: `${theme2.colors.summaryPanelBackground}`,
    height: "120px",
    minHeight: "120px",
    borderRadius: "20px",
    boxSizing: "border-box",
    paddingBottom: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  guestDetailPreview: {
    minHeight: "100dvh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    "& svg": {
      height: "133px"
    }
  },
  grayscale: {
    filter: "grayscale(100%)"
  },
  guestDetailContainer: {
    position: "relative",
    flexGrow: 1,
    // overflowX: 'hidden',
    overflowY: theme2.overlay,
    width: "100%"
  },
  guestDetailPanel: {
    paddingTop: "40px",
    paddingBottom: "40px",
    paddingLeft: "6px",
    maxWidth: "1100px"
    // To prevent stretching on wide monitors
  },
  guestSummaryStatsContainer: {
    lineHeight: "26px",
    maxWidth: "500px",
    display: "flex",
    gap: "16px"
  },
  guestRightPanePadding: {
    padding: "0 6px",
    width: "auto",
    maxWidth: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%"
  },
  guestFullName: {
    ...theme2.typography.heading.H2
  },
  guestGrid: {
    display: "grid",
    padding: "15px 20px 15px 20px",
    // marginBottom: '5px',
    border: "1px solid transparent",
    minWidth: "313px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme2.colors.white,
      borderRadius: "6px",
      boxSizing: "border-box"
    },
    "&:active": {
      border: `1px solid ${theme2.colors.bodyText}`
    }
  },
  guestNameContainer: {
    fontWeight: theme2.fontWeights.medium,
    fontSize: "18px",
    lineHeight: "22px"
  },
  guestListingContainer: {
    margin: "15px 0px 0px 0px",
    paddingRight: "24px",
    overflowY: "scroll",
    overflowX: "hidden",
    // maxHeight: '100%',
    maxHeight: "calc(100dvh - 196px)",
    // header plus search section TODO there must be a better way
    paddingBottom: "40px"
  },
  guestDetailSection: {
    maxWidth: "100%",
    paddingBottom: "40px",
    borderBottom: `1px solid ${theme2.colors.yetAnotherGray11}`
  },
  guestDetailHeader: {
    ...theme2.typography.heading.H4,
    paddingBottom: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  guestDetailContent: {
    fontSize: "15px"
  },
  guestContactDetails: {
    marginTop: "8px",
    display: "flex",
    maxWidth: "280px",
    overflow: "hidden"
  },
  guestSearchBoxContainer: {
    paddingRight: "24px"
  },
  guestBookSearchBox: {
    background: `${theme2.colors.white}`,
    border: `1px solid ${theme2.colors.unicornSilver}`,
    boxShadow: `0px 4px 7px rgba(222, 222, 222, 0.25)`,
    borderRadius: "25px",
    width: "100%",
    // // TODO change these
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: "22px"
    },
    "& label.Mui-focused": {
      color: "white"
    },
    "& .MuiInput-underline:after": {
      border: "none"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none"
      },
      "&:hover fieldset": {
        borderRadius: "25px",
        border: `1px solid white`
      },
      "&:focus": {
        border: "none"
      },
      "&.Mui-focused fieldset": {
        border: "none"
      }
    }
  },
  guestBookSearchStats: {
    marginTop: "25px",
    marginLeft: "20px"
  },
  guestListRowActive: {
    backgroundColor: theme2.colors.activeGuestRowBackground,
    border: `1px solid ${theme2.colors.activeGuestRowBorder}`,
    borderRadius: "6px",
    boxSizing: "border-box"
  },
  tabContainer: {
    display: "flex",
    gap: "12px"
  },
  customerDetailsContainer: {},
  bookingHistoryItems: {
    display: "flex",
    flexDirection: "column",
    gap: "10px"
    // Because the circle has a 6px margin top
  },
  bookingHistory: {
    minHeight: "140px",
    // width: '65vw',
    display: "inline-flex"
  },
  bookingHistoryDate: {
    fontSize: "18px",
    fontWeight: theme2.fontWeights.medium,
    lineHeight: "24px"
  },
  bookingHistorySize: {
    fontSize: "18px",
    lineHeight: "24px",
    marginTop: "10px"
  },
  bookingHistoryComments: {
    fontSize: "15px",
    lineHeight: "26px",
    marginTop: "20px"
  },
  bookingHistoryContents: {
    paddingLeft: "20px"
  },
  circleContainer: {
    width: "14px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "center"
  },
  circle: {
    width: "14px",
    height: "14px",
    marginTop: "6px"
  },
  dashline: {
    flexGrow: 1,
    width: "1px",
    minHeight: "95px",
    backgroundColor: "transparent",
    borderLeft: `1px dashed ${theme2.colors.shark}`
  }
}));
const tabBarStyles$1 = (theme2) => ({
  fontWeight: theme2.fontWeights.medium,
  marginLeft: "-6px",
  // So the text sits flush with the heading
  containerInner: {
    gap: "12px"
  },
  tab: {
    boxSizing: "border-box",
    padding: "0 11px",
    borderRadius: "100px",
    fontSize: "15px",
    lineHeight: "15px",
    minWidth: "50px",
    transition: "background-color 0.1s",
    whiteSpace: "nowrap",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    border: "1px solid transparent",
    overflowX: theme2.overlay,
    fontWeight: theme2.fontWeights.medium,
    color: theme2.colors.smoke
  },
  tabActive: {
    fontWeight: theme2.fontWeights.medium,
    backgroundColor: "transparent",
    padding: "9px 11px",
    paddingBottom: "9px",
    color: "black",
    border: "1px solid black",
    borderBottom: `1px solid ${theme2.colors.charcoal}`
    // defaults to red
  },
  tabHover: {
    backgroundColor: "transparent",
    color: theme2.colors.black,
    filter: "none"
  }
});
var FUNC_ERROR_TEXT = "Expected a function";
var NAN = 0 / 0;
var symbolTag = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var nativeMax = Math.max, nativeMin = Math.min;
var now = function() {
  return root.Date.now();
};
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
    return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
function isObject(value) {
  var type2 = typeof value;
  return !!value && (type2 == "object" || type2 == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, "");
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var lodash_debounce = debounce;
const debounce$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_debounce);
const fetchGuestBookListing = (page = 1, data = {}, skipLoading = false) => (dispatch) => {
  const action = "FETCH_OBEE_GUESTS";
  const request = () => fetchGuests(data, { page });
  dispatch(makeApiAction(action, request, {}, "obeeGuest", null, {}, skipLoading));
};
const filterGuestBookListing = (searchValue) => (dispatch) => {
  dispatch(fetchGuestBookListing(1, { search: searchValue }));
};
const updateGuestAction = (guest, guestId, skipLoading = false) => (dispatch) => {
  const action = "UPDATE_OBEE_GUEST";
  const successMessage = "Guest has been updated.";
  const updatedItem = only(convertDataForAPI(guest), OBGuestUpdateInput);
  const data = {
    guestId,
    guest: updatedItem
  };
  const request = () => updateGuest(data);
  dispatch(
    makeApiAction(action, request, guest, "obeeGuestBook", successMessage, {}, skipLoading)
  );
};
const GuestBookSearchBox = ({
  obeeGuestBook,
  filterGuestBook,
  searchBoxText,
  viewGuestData,
  setSearchCompleted,
  searchCompleted
}) => {
  var _a, _b2;
  const classes = useStyles$i();
  const theme2 = useTheme$1();
  const [searchResults, setSearchResults] = useState(null);
  const [searchString, setSearchString] = useState(null);
  const doSearch = useMemo(
    () => debounce$1((searchText) => {
      filterGuestBook(searchText);
    }, 500),
    []
  );
  const searchGuest = (value) => {
    setSearchString(value);
    doSearch(value);
  };
  useEffect(() => {
    var _a2, _b3, _c2, _d2;
    setSearchCompleted((_a2 = obeeGuestBook == null ? void 0 : obeeGuestBook.data) == null ? void 0 : _a2.length);
    if (((_b3 = obeeGuestBook == null ? void 0 : obeeGuestBook.data) == null ? void 0 : _b3.length) === 0) {
      setSearchResults(0);
      viewGuestData(null);
      return;
    }
    if (((_c2 = obeeGuestBook.data) == null ? void 0 : _c2.length) > 0) {
      setSearchResults(obeeGuestBook.pagination.totalResults || ((_d2 = obeeGuestBook == null ? void 0 : obeeGuestBook.data) == null ? void 0 : _d2.length));
      return;
    }
    setSearchResults(null);
  }, [obeeGuestBook.data]);
  const styles2 = {
    container: {
      display: "flex",
      gap: "10px",
      alignItems: "center"
    },
    innerContainer: {
      width: "100%"
    },
    label: {
      color: theme2.colors.nimbus,
      marginBottom: "0",
      width: "120px"
    },
    textField: {
      flexGrow: 1
    },
    textFieldInner: {
      width: "100%"
    },
    input: {
      backgroundColor: theme2.colors.white,
      border: `1px solid ${theme2.colors.grayBorder}`,
      width: "100%",
      color: theme2.colors.labelText,
      padding: "9px 14px 9px 45px",
      borderRadius: "12px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      lineHeight: "20px",
      paddingLeft: "45px",
      transition: "box-shadow 0.1s",
      ...(_b2 = (_a = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _a.SearchBar) == null ? void 0 : _b2.input
    },
    inputActive: {
      outline: "none",
      boxShadow: "0 4px 8px rgba(220, 220, 219, 0.25)"
    },
    inputHover: {
      backgroundColor: theme2.colors.white
    },
    placeholder: {
      color: theme2.colors.nimbus
    }
  };
  const getSearchText = () => {
    if (isVoid(searchResults) || searchResults < 0 || !searchCompleted) {
      return "";
    }
    if (!isEmpty(searchString)) {
      return `${searchResults} ${pluralise("guest", searchResults)} matching search`;
    }
    return `${searchResults} total ${pluralise("guest", searchResults)}`;
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestSearchBoxContainer}` }, /* @__PURE__ */ React__default.createElement(
    TextField$2,
    {
      id: "guest-search",
      placeholder: searchBoxText,
      onChange: searchGuest,
      value: searchString,
      style: styles2,
      inputPrefix: /* @__PURE__ */ React__default.createElement(
        MagnifyingGlassSVG,
        {
          style: {
            marginLeft: "10px",
            marginTop: "4px",
            color: theme2.colors.yetAnotherGray16,
            width: "15px"
          }
        }
      )
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestBookSearchStats}` }, getSearchText()));
};
GuestBookSearchBox.defaultProps = {
  searchBoxText: "Search guest name",
  searchCompleted: true
};
GuestBookSearchBox.propTypes = {
  filterGuestBook: PropTypes.func.isRequired,
  obeeGuestBook: obeeGuestPropTypes.isRequired,
  searchBoxText: PropTypes.string,
  viewGuestData: PropTypes.func.isRequired,
  setSearchCompleted: PropTypes.func.isRequired,
  searchCompleted: PropTypes.bool
};
const mapStateToProps$I = (state) => ({
  obeeGuestBook: state.obeeGuests
});
const mapDispatchToProps$H = (dispatch) => bindActionCreators(
  {
    filterGuestBook: filterGuestBookListing
  },
  dispatch
);
const GuestBookSearchBox$1 = connect(mapStateToProps$I, mapDispatchToProps$H)(GuestBookSearchBox);
function createObserverCache() {
  var cachesByRoot = /* @__PURE__ */ new Map();
  function getObserver(_ref) {
    var root2 = _ref.root, rootMargin = _ref.rootMargin, threshold = _ref.threshold;
    var cacheByRoot = cachesByRoot.get(root2);
    if (!cacheByRoot) {
      cacheByRoot = /* @__PURE__ */ new Map();
      cachesByRoot.set(root2, cacheByRoot);
    }
    var cacheKey = JSON.stringify({
      rootMargin,
      threshold
    });
    var cachedObserver = cacheByRoot.get(cacheKey);
    if (!cachedObserver) {
      var entryCallbacks = /* @__PURE__ */ new Map();
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var callback = entryCallbacks.get(entry.target);
          callback == null ? void 0 : callback(entry);
        });
      }, {
        root: root2,
        rootMargin,
        threshold
      });
      cachedObserver = {
        observer,
        entryCallbacks
      };
      cacheByRoot.set(cacheKey, cachedObserver);
    }
    return {
      observe: function observe(node, callback) {
        var _cachedObserver, _cachedObserver2;
        (_cachedObserver = cachedObserver) == null ? void 0 : _cachedObserver.entryCallbacks.set(node, callback);
        (_cachedObserver2 = cachedObserver) == null ? void 0 : _cachedObserver2.observer.observe(node);
      },
      unobserve: function unobserve(node) {
        var _cachedObserver3, _cachedObserver4;
        (_cachedObserver3 = cachedObserver) == null ? void 0 : _cachedObserver3.entryCallbacks["delete"](node);
        (_cachedObserver4 = cachedObserver) == null ? void 0 : _cachedObserver4.observer.unobserve(node);
      }
    };
  }
  return {
    getObserver
  };
}
var DEFAULT_ROOT_MARGIN = "0px";
var DEFAULT_THRESHOLD = [0];
var observerCache = /* @__PURE__ */ createObserverCache();
function useIntersectionObserver(args) {
  var _args$rootMargin, _args$threshold;
  var rootMargin = (_args$rootMargin = args == null ? void 0 : args.rootMargin) != null ? _args$rootMargin : DEFAULT_ROOT_MARGIN;
  var threshold = (_args$threshold = args == null ? void 0 : args.threshold) != null ? _args$threshold : DEFAULT_THRESHOLD;
  var nodeRef = useRef(null);
  var rootRef = useRef(null);
  var observerRef = useRef(null);
  var _useState = useState(), entry = _useState[0], setEntry = _useState[1];
  var observe = useCallback(function() {
    var node = nodeRef.current;
    if (!node) {
      setEntry(void 0);
      return;
    }
    var observer = observerCache.getObserver({
      root: rootRef.current,
      rootMargin,
      threshold
    });
    observer.observe(node, function(observedEntry) {
      setEntry(observedEntry);
    });
    observerRef.current = observer;
  }, [rootMargin, threshold]);
  var unobserve = useCallback(function() {
    var currentObserver = observerRef.current;
    var node = nodeRef.current;
    if (node) {
      currentObserver == null ? void 0 : currentObserver.unobserve(node);
    }
    observerRef.current = null;
  }, []);
  var refCallback = useCallback(function(node) {
    unobserve();
    nodeRef.current = node;
    observe();
  }, [observe, unobserve]);
  var rootRefCallback = useCallback(function(rootNode) {
    unobserve();
    rootRef.current = rootNode;
    observe();
  }, [observe, unobserve]);
  return [refCallback, {
    entry,
    rootRef: rootRefCallback
  }];
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function useTrackVisibility(args) {
  var _result$entry;
  var _useIntersectionObser = useIntersectionObserver(args), ref = _useIntersectionObser[0], result = _useIntersectionObser[1];
  var isVisible = Boolean((_result$entry = result.entry) == null ? void 0 : _result$entry.isIntersecting);
  var _useState = useState(isVisible), wasEverVisible = _useState[0], setWasEverVisible = _useState[1];
  if (isVisible && !wasEverVisible) {
    setWasEverVisible(true);
  }
  return [ref, _extends({}, result, {
    isVisible,
    wasEverVisible
  })];
}
var DEFAULT_DELAY_IN_MS = 100;
function useInfiniteScroll(_ref) {
  var loading = _ref.loading, hasNextPage = _ref.hasNextPage, onLoadMore = _ref.onLoadMore, rootMargin = _ref.rootMargin, disabled = _ref.disabled, _ref$delayInMs = _ref.delayInMs, delayInMs = _ref$delayInMs === void 0 ? DEFAULT_DELAY_IN_MS : _ref$delayInMs;
  var _useTrackVisibility = useTrackVisibility({
    rootMargin
  }), ref = _useTrackVisibility[0], _useTrackVisibility$ = _useTrackVisibility[1], rootRef = _useTrackVisibility$.rootRef, isVisible = _useTrackVisibility$.isVisible;
  var shouldLoadMore = !disabled && !loading && isVisible && hasNextPage;
  useEffect(function() {
    if (shouldLoadMore) {
      var timer = setTimeout(function() {
        onLoadMore();
      }, delayInMs);
      return function() {
        clearTimeout(timer);
      };
    }
  }, [onLoadMore, shouldLoadMore, delayInMs]);
  return [ref, {
    rootRef
  }];
}
const fetchObeeGuestsAction = (search, searchType = "all", pagination) => (dispatch) => {
  const action = "FETCH_OBEE_GUESTS";
  const entityName = "obeeGuests";
  const data = {
    search,
    searchType
  };
  const request = () => fetchGuests(data, pagination);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const updateObeeGuestAction = (guestId, guest) => (dispatch) => {
  const action = "UPDATE_OBEE_GUEST";
  const entityName = "updateGuest";
  const successMessage = "Customer details successfully updated.";
  const errorMessage = "Unable to update customer details";
  const updatedItem = only(convertDataForAPI(guest), OBGuestUpdateInput);
  const data = {
    guestId,
    guest: updatedItem
  };
  const request = () => updateGuest(data);
  dispatch(
    makeApiAction(action, request, guest, entityName, successMessage, {}, false, errorMessage)
  );
};
const GuestBookListRow = ({ guest }) => {
  const classes = useStyles$i();
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestNameContainer}` }, guest == null ? void 0 : guest.firstName, " ", guest == null ? void 0 : guest.lastName), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestContactDetails}` }, (guest == null ? void 0 : guest.mobile) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestBookPhoneNumber }, guest.mobile)));
};
GuestBookListRow.propTypes = {
  guest: obeeGuestPropTypes.isRequired
};
const mapStateToProps$H = () => ({});
const mapDispatchToProps$G = (dispatch) => bindActionCreators({}, dispatch);
const GuestBookListRow$1 = connect(mapStateToProps$H, mapDispatchToProps$G)(GuestBookListRow);
const GuestBookListing = ({ obeeGuestBook, viewGuestData, activeGuest, fetchObeeGuests }) => {
  var _a;
  const classes = useStyles$i();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    fetchObeeGuests("", "all", { page: 1 });
  }, []);
  const hasNextPage = () => {
    var _a2, _b2, _c2, _d2;
    if (((_a2 = obeeGuestBook == null ? void 0 : obeeGuestBook.pagination) == null ? void 0 : _a2.currentPage) && ((_b2 = obeeGuestBook == null ? void 0 : obeeGuestBook.pagination) == null ? void 0 : _b2.totalPages)) {
      return ((_c2 = obeeGuestBook == null ? void 0 : obeeGuestBook.pagination) == null ? void 0 : _c2.currentPage) < ((_d2 = obeeGuestBook == null ? void 0 : obeeGuestBook.pagination) == null ? void 0 : _d2.totalPages);
    }
    return false;
  };
  const loadMore = async () => {
    var _a2;
    try {
      if (!loading && hasNextPage() && obeeGuestBook.pending === false) {
        setLoading(true);
        fetchObeeGuests("", "all", { page: ((_a2 = obeeGuestBook == null ? void 0 : obeeGuestBook.pagination) == null ? void 0 : _a2.currentPage) + 1 });
      }
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };
  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore: loadMore,
    disabled: !!error,
    rootMargin: "0px 0px 50px 0px"
  });
  return /* @__PURE__ */ React__default.createElement(Spacer, { gap: 4, direction: "vertical" }, (_a = obeeGuestBook.data) == null ? void 0 : _a.map((guest) => /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.guestGrid} ${(activeGuest == null ? void 0 : activeGuest.id) === guest.id ? ` + ${classes.guestListRowActive} + ` : ""}`,
      key: guest.id,
      onClick: () => {
        viewGuestData(guest);
      }
    },
    /* @__PURE__ */ React__default.createElement(GuestBookListRow$1, { key: guest == null ? void 0 : guest.id, guest })
  )), (loading || hasNextPage()) && /* @__PURE__ */ React__default.createElement(LinearProgress, { ref: sentryRef }));
};
GuestBookListing.defaultProps = {
  activeGuest: null
};
GuestBookListing.propTypes = {
  obeeGuestBook: PropTypes.instanceOf(Object).isRequired,
  viewGuestData: PropTypes.func.isRequired,
  activeGuest: PropTypes.instanceOf(Object),
  fetchObeeGuests: PropTypes.func.isRequired
};
const mapStateToProps$G = (state) => ({
  obeeGuestBook: state.obeeGuests
});
const mapDispatchToProps$F = (dispatch) => bindActionCreators(
  {
    fetchObeeGuests: fetchObeeGuestsAction
  },
  dispatch
);
const GuestBookListing$1 = connect(mapStateToProps$G, mapDispatchToProps$F)(GuestBookListing);
const Fade = ({ children, isShowing, style, fadeInOnly }) => {
  const hasFadedIn = useRef(false);
  useEffect(() => {
    if (isShowing) {
      hasFadedIn.current = true;
    }
  }, [isShowing]);
  const styles2 = {
    opacity: isShowing ? 1 : 0,
    transition: !fadeInOnly || isShowing ? "opacity 0.5s" : "opacity 0s",
    ...style
  };
  return /* @__PURE__ */ React__default.createElement(Box, { style: styles2 }, children);
};
Fade.defaultProps = {
  isShowing: false,
  fadeInOnly: false,
  // If not showing, don't fade out
  children: null,
  style: {}
};
Fade.propTypes = {
  isShowing: PropTypes.bool,
  fadeInOnly: PropTypes.bool,
  style: PropTypes.shape({}),
  children: PropTypes.node
};
const SvgGuestbookSearch = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 158 133", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M31.5856 34.443C42.8278 18.8048 62.1876 12.4627 79.7796 17.0061C73.7553 9.17533 64.2887 4.12024 53.6435 4.12024C35.4467 4.12024 20.6924 18.8746 20.6924 37.0714C20.6924 42.266 21.8941 47.1738 24.034 51.5389C24.4759 49.4533 25.0652 47.3831 25.8095 45.3518C27.2051 41.5527 29.1124 37.8855 31.5856 34.443Z", fill: "#F7D2D2" }), /* @__PURE__ */ React$7.createElement("path", { d: "M94.8905 24.0925C92.1226 22.1077 89.2074 20.4873 86.1992 19.2003C88.4321 23.6428 89.6959 28.6592 89.6959 33.9701C89.6959 43.8555 85.3308 52.7251 78.4382 58.7649C72.6388 63.8355 65.0562 66.9213 56.7447 66.9213C42.5486 66.9213 30.4459 57.943 25.8172 45.3518C25.0729 47.3832 24.4836 49.4533 24.0417 51.5389C21.8553 61.9282 23.3904 72.7904 28.337 82.1486C36.1677 76.0158 46.0221 72.3485 56.7447 72.3485C74.0887 72.3485 89.1919 81.9237 97.0692 96.0733C100.093 93.6078 102.853 90.7081 105.241 87.3897C119.864 67.0531 115.227 38.7073 94.8905 24.0925Z", fill: "#F7D2D2" }), /* @__PURE__ */ React$7.createElement("path", { d: "M41.936 97.748C36.2684 93.6776 31.8258 88.5372 28.6702 82.7998C15.9472 91.0105 7.51172 105.307 7.51172 121.581H99.7749C99.7749 113.216 97.5342 105.377 93.6421 98.6163C78.3683 108.835 57.737 109.106 41.936 97.748Z", fill: "#F7D2D2" }), /* @__PURE__ */ React$7.createElement("path", { d: "M86.1994 19.2002C84.0983 18.3009 81.9506 17.5721 79.7797 17.0138C62.1877 12.4627 42.8357 18.8048 31.5858 34.4508C29.1125 37.8932 27.2052 41.5683 25.8174 45.3596C30.446 57.943 42.5488 66.9212 56.7449 66.9212C65.0564 66.9212 72.639 63.8355 78.4384 58.7649C85.3388 52.7251 89.6961 43.8632 89.6961 33.9701C89.6961 28.6592 88.4323 23.6428 86.1994 19.2002Z", fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("path", { d: "M56.7446 72.3485C46.0219 72.3485 36.1676 76.0158 28.3291 82.1486C28.4454 82.3657 28.5539 82.5827 28.6702 82.7998C31.8258 88.5372 36.2684 93.6698 41.936 97.748C57.737 109.106 78.3683 108.835 93.6421 98.6164C94.8206 97.8333 95.9603 96.9805 97.0691 96.0811C89.1918 81.9237 74.0885 72.3485 56.7446 72.3485Z", fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.6912 45.1582C14.3804 32.9004 17.8616 19.1074 27.5997 10.4936C36.764 2.38377 50.3398 0.267149 61.52 5.29898C68.0016 8.21419 73.3203 13.215 76.693 19.4641C77.4063 20.7821 79.4144 19.6114 78.7011 18.2934C72.1806 6.18285 58.6823 -1.0664 44.9669 0.437719C32.3912 1.81779 21.4746 10.1757 16.8227 21.9296C13.83 29.5045 13.7447 38.1028 16.4428 45.7707C16.9468 47.1741 19.1952 46.5693 18.6912 45.1582Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M87.7723 97.0737C91.3233 103.664 93.1531 110.998 93.1841 118.473C93.5717 118.085 93.9594 117.697 94.3471 117.31C91.2845 117.31 88.222 117.31 85.1595 117.31C77.8017 117.31 70.4517 117.31 63.0939 117.31C54.232 117.31 45.37 117.31 36.5081 117.31C28.8169 117.31 21.1258 117.31 13.4423 117.31C10.9148 117.31 8.38724 117.31 5.85969 117.31C4.68896 117.31 3.40193 117.154 2.23894 117.31C2.19242 117.317 2.13815 117.31 2.08388 117.31C2.47154 117.697 2.8592 118.085 3.24686 118.473C3.28563 107.595 7.22426 96.9651 14.427 88.7933C16.3885 86.5681 18.5672 84.5212 20.9242 82.7147C22.0949 81.8154 20.9397 79.7995 19.7534 80.7067C10.7752 87.5682 4.34006 97.4226 1.97533 108.51C1.27755 111.782 0.936405 115.131 0.920898 118.473C0.920898 119.101 1.45587 119.636 2.08388 119.636C5.1464 119.636 8.20892 119.636 11.2714 119.636C18.6292 119.636 25.9793 119.636 33.3371 119.636C42.199 119.636 51.0609 119.636 59.9228 119.636C67.614 119.636 75.3052 119.636 82.9886 119.636C86.7102 119.636 90.4705 119.783 94.192 119.636C94.2463 119.636 94.2928 119.636 94.3471 119.636C94.9751 119.636 95.51 119.101 95.51 118.473C95.479 110.588 93.5252 102.842 89.7804 95.8952C89.0749 94.5849 87.0668 95.7556 87.7723 97.0737Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M86.5483 25.0928C93.9294 30.4347 99.5737 38.0174 102.489 46.6467C105.342 55.0667 105.621 64.262 103.225 72.8293C100.721 81.7765 95.356 89.7933 88.099 95.5772C81.1288 101.136 72.3832 104.462 63.4903 105.021C54.45 105.594 45.3788 103.369 37.6411 98.6475C29.8026 93.856 23.5457 86.6532 19.9638 78.1945C16.5136 70.0536 15.5599 60.8661 17.3199 52.1902C19.1652 43.0957 23.8791 34.73 30.6865 28.4266C37.2612 22.3404 45.6734 18.394 54.5353 17.138C63.436 15.8742 72.7011 17.4248 80.7024 21.5185C82.7415 22.5652 84.6876 23.767 86.5483 25.0928C87.7656 25.9611 88.9286 23.9453 87.7191 23.0847C79.8883 17.4946 70.4216 14.4166 60.7922 14.3933C51.4651 14.3701 42.1612 17.2 34.4623 22.4644C26.3757 27.9925 20.1731 36.0325 16.8547 45.2433C13.6837 54.051 13.3038 63.7968 15.6917 72.837C18.1263 82.0478 23.4294 90.4368 30.7407 96.5386C38.1761 102.741 47.3714 106.532 57.0319 107.3C66.359 108.037 75.8722 105.866 83.9743 101.19C92.3632 96.3447 99.155 88.8086 103.109 79.9622C106.978 71.2941 108.11 61.6026 106.366 52.2755C104.637 43.0182 100.016 34.3578 93.2936 27.7599C91.5569 26.0619 89.6884 24.5113 87.7191 23.0847C86.5096 22.2086 85.3466 24.2244 86.5483 25.0928Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M48.9922 66.9212C67.1906 66.9212 81.9433 52.1685 81.9433 33.9701C81.9433 15.7716 67.1906 1.01892 48.9922 1.01892C30.7937 1.01892 16.041 15.7716 16.041 33.9701C16.041 52.1685 30.7937 66.9212 48.9922 66.9212Z", stroke: "#313131", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeDasharray: "3.03 3.03" }), /* @__PURE__ */ React$7.createElement("path", { d: "M4.02236 118.48H2.85938C2.85938 118.092 2.86713 117.705 2.87488 117.317", stroke: "#313131", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M3.13867 113.386C5.67397 90.3049 25.2353 72.3484 48.9911 72.3484C73.4215 72.3484 93.4093 91.3361 95.022 115.356", stroke: "#313131", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeDasharray: "3.05 3.05" }), /* @__PURE__ */ React$7.createElement("path", { d: "M95.1074 117.317C95.1152 117.705 95.1229 118.092 95.1229 118.48H93.96", stroke: "#313131", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M90.1141 118.48H5.94531", stroke: "#313131", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeDasharray: "2.97 2.97" }), /* @__PURE__ */ React$7.createElement("path", { d: "M94.3242 92.7239C96.1152 94.011 97.914 95.3058 99.7049 96.5928C104.016 99.6941 108.327 102.788 112.637 105.889C117.855 109.641 123.073 113.394 128.291 117.147C132.827 120.411 137.362 123.667 141.898 126.931C144.084 128.505 146.232 130.172 148.48 131.661C148.511 131.684 148.542 131.707 148.573 131.73C149.729 132.56 151.737 132.684 153.055 132.32C154.404 131.947 155.861 130.908 156.528 129.645C157.242 128.296 157.598 126.66 157.117 125.163C156.629 123.644 155.737 122.62 154.443 121.69C152.652 120.403 150.853 119.108 149.062 117.821C144.751 114.72 140.44 111.626 136.13 108.525C130.912 104.772 125.694 101.02 120.476 97.2673C115.94 94.0032 111.405 90.7469 106.869 87.4828C104.682 85.9089 102.535 84.2419 100.286 82.7533C100.255 82.73 100.224 82.7068 100.193 82.6835L94.3242 92.7239Z", fill: "#313131" }));
const GuestBookSearchSVG = SvgGuestbookSearch;
const useStyles$h = createUseStyles((theme2) => ({
  container: {
    borderBottom: `1px solid ${theme2.colors.yetAnotherGray11}`
  },
  guestDetailHeader: {
    ...theme2.typography.heading.H4,
    maxWidth: "100%",
    paddingRight: "24px",
    padding: "24px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    userSelect: "none"
  },
  content: {
    paddingBottom: "40px"
  }
}));
const ExpandSection = ({ title, children }) => {
  const classes = useStyles$h();
  const [showing, setShowing] = useState(false);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestDetailHeader, onClick: () => setShowing(!showing) }, title, /* @__PURE__ */ React__default.createElement(
    AccordionDownArrowSVG,
    {
      style: {
        transform: showing ? "rotate(180deg)" : "none",
        width: "11px",
        marginRight: "17px"
      }
    }
  )), showing && /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, children));
};
ExpandSection.defaultProps = {
  title: "",
  children: null
};
ExpandSection.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number]),
  children: PropTypes.node
};
const ExpandSection$1 = ExpandSection;
const useStyles$g = createUseStyles((theme2) => ({
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    maxWidth: "400px"
  },
  spinnerContainer: {
    position: "absolute",
    right: 0,
    width: "30px",
    pointerEvents: "none"
  },
  spinner: {
    color: theme2.colors.charcoal
  }
}));
const multiSelectStyles = {
  // label: { maxWidth: '180px' },
  value: { height: "36px", padding: "0 15px" },
  container: {
    fontSize: "15px",
    height: "unset",
    maxWidth: "100%"
  },
  errorText: { margin: "3px 0 0 150px" },
  item: { fontSize: "15px", padding: "0 16px", height: "36px" },
  popover: { padding: "8px" },
  items: { display: "flex", flexDirection: "column", gap: "4px" }
};
const GuestBookDropdown = ({
  label,
  items,
  selectedItems,
  onChange,
  onClose,
  loading,
  placeholder,
  ...props
}) => {
  const classes = useStyles$g();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label,
      items,
      value: selectedItems,
      selectedItems,
      onSelect: (selectedItem) => onChange(toggleListItem(selectedItems, selectedItem)),
      placeholder,
      onClose,
      style: multiSelectStyles,
      multiselect: true
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.spinnerContainer }, loading && /* @__PURE__ */ React__default.createElement(CircularProgress, { size: 20, className: classes.spinner })));
};
GuestBookDropdown.defaultProps = {
  label: "",
  items: [],
  selectedItems: [],
  placeholder: "Empty",
  onChange: (e) => e,
  onClose: (e) => e,
  loading: false
};
GuestBookDropdown.propTypes = {
  label: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })),
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  loading: PropTypes.bool
};
const useStyles$f = createUseStyles((theme2) => ({
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    maxWidth: "400px"
  },
  spinnerContainer: {
    position: "absolute",
    right: 0,
    width: "30px",
    pointerEvents: "none"
  },
  spinner: {
    color: theme2.colors.charcoal
  }
}));
const GuestBookTextField = ({
  label,
  value,
  onChange,
  onBlur: onBlur2,
  loading,
  placeholder,
  ...props
}) => {
  const classes = useStyles$f();
  const inputTextStyles = {
    fontSize: "15px",
    textFieldInner: {
      padding: "0",
      margin: "0"
    },
    label: {
      width: "140px"
    },
    input: {
      fontSize: "15px",
      textOverflow: "unset",
      resize: "none",
      height: "36px",
      maxWidth: "300px",
      width: "250px",
      // width: 'calc(100vw / 2)',
      padding: "0px 14px 0px 5px"
    },
    container: {},
    errorText: {
      margin: "4px 0 0 150px"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label,
      value,
      onChange,
      onBlur: () => onBlur2(trim(value)),
      onEnter: () => onBlur2(trim(value)),
      placeholder,
      style: inputTextStyles,
      ...props
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.spinnerContainer }, loading && /* @__PURE__ */ React__default.createElement(CircularProgress, { size: 20, className: classes.spinner })));
};
GuestBookTextField.defaultProps = {
  label: "",
  value: "",
  placeholder: "Empty",
  onChange: (e) => e,
  onBlur: (e) => e,
  loading: false
};
GuestBookTextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  loading: PropTypes.bool
};
const useStyles$e = createUseStyles((theme2) => ({
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    gap: "16px",
    maxWidth: "500px"
  },
  spinnerContainer: {
    position: "absolute",
    right: 0,
    width: "30px",
    top: "10px",
    pointerEvents: "none"
  },
  spinner: {
    color: theme2.colors.charcoal
  }
}));
const GuestBookTextArea = ({
  label,
  value,
  onChange,
  onBlur: onBlur2,
  loading,
  placeholder,
  ...props
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$e();
  const inputTextStyles = {
    fontSize: "15px",
    textFieldInner: {
      margin: "0",
      borderRadius: "8px",
      backgroundColor: theme2.colors.yetAnotherGray4,
      padding: "14px",
      width: "400px",
      height: "212px"
    },
    label: {
      width: "0"
    },
    input: {
      fontSize: "15px",
      textOverflow: "unset",
      resize: "none",
      maxWidth: "422px",
      // Because 14px padding on each side
      width: "422px",
      height: "100%",
      // width: 'calc(100vw / 2)',
      padding: "0px 14px 0px 5px"
    },
    container: {}
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        color: theme2.colors.smoke,
        userSelect: "none",
        whiteSpace: "nowrap",
        width: "80px",
        height: "100%",
        paddingTop: "10px"
      }
    },
    label
  ), /* @__PURE__ */ React__default.createElement(
    InlineTextArea,
    {
      value,
      onChange,
      onBlur: () => onBlur2(trim(value)),
      placeholder,
      resizable: false,
      minRows: 3,
      loading,
      style: inputTextStyles,
      autoChangeHeight: true
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.spinnerContainer }, loading && /* @__PURE__ */ React__default.createElement(CircularProgress, { size: 20, className: classes.spinner })));
};
GuestBookTextArea.defaultProps = {
  label: "",
  value: "",
  placeholder: "Empty",
  onChange: (e) => e,
  onBlur: (e) => e,
  loading: false
};
GuestBookTextArea.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  loading: PropTypes.bool
};
const GuestBookToggle = ({ label, value, onChange, loading, styles: styles2, ...props }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$f();
  const style = {
    labelRow: { width: "140px", ...styles2 == null ? void 0 : styles2.labelRow },
    textLabel: { color: theme2.colors.smoke, fontSize: "15px" },
    inputContainer: { marginLeft: "15px" }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Toggle, { label, checked: value, onChange, style, ...props })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.spinnerContainer }, loading && /* @__PURE__ */ React__default.createElement(CircularProgress, { size: 20, className: classes.spinner })));
};
GuestBookToggle.defaultProps = {
  label: "",
  value: false,
  onChange: () => {
  },
  loading: false,
  styles: {}
};
GuestBookToggle.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  styles: PropTypes.shape({})
};
const GuestBookCustomerDetailsTab = ({ guestData, updateGuest: updateGuest2, obeeGuests: obeeGuests2 }) => {
  const classes = useStyles$i();
  const [onSaving, setSaving] = useState("");
  const [error, setError] = useState({});
  const [updatedGuestData, setUpdatedGuestData] = useState(guestData);
  useEffect(() => {
    setSaving("");
    setUpdatedGuestData(guestData);
  }, [guestData]);
  useEffect(() => {
    if (!isEmpty(obeeGuests2 == null ? void 0 : obeeGuests2.error)) {
      setError({ field: onSaving, error: obeeGuests2 == null ? void 0 : obeeGuests2.error });
    }
    if (!(obeeGuests2 == null ? void 0 : obeeGuests2.pending)) {
      setSaving("");
    }
  }, [obeeGuests2 == null ? void 0 : obeeGuests2.pending]);
  const handleOnChange = (fieldName, value) => {
    setUpdatedGuestData({ ...guestData, [fieldName]: value });
  };
  const handleOnToggle = (fieldName, value) => {
    setUpdatedGuestData({ ...guestData, [fieldName]: value });
    setSaving(fieldName);
    const updatedValues = {
      [fieldName]: value
    };
    updateGuest2(updatedValues, guestData.id);
  };
  useEffect(() => {
    setUpdatedGuestData(guestData);
  }, [guestData == null ? void 0 : guestData.id]);
  const changeDate = (inputValue, oldValue) => {
    let newValue = inputValue;
    if ((oldValue == null ? void 0 : oldValue.length) < (newValue == null ? void 0 : newValue.length) && ((newValue == null ? void 0 : newValue.length) === 2 || (newValue == null ? void 0 : newValue.length) === 5)) {
      newValue += "/";
    }
    return newValue;
  };
  const handleOnBlur = (fieldName) => {
    if (isEmpty(guestData == null ? void 0 : guestData[fieldName]) && isEmpty(updatedGuestData == null ? void 0 : updatedGuestData[fieldName])) {
      return;
    }
    if ((guestData == null ? void 0 : guestData[fieldName]) === (updatedGuestData == null ? void 0 : updatedGuestData[fieldName])) {
      return;
    }
    const trimmedValue = trim(updatedGuestData == null ? void 0 : updatedGuestData[fieldName]);
    setUpdatedGuestData({ ...updatedGuestData, [fieldName]: trimmedValue });
    if ((guestData == null ? void 0 : guestData[fieldName]) !== trimmedValue) {
      setSaving(fieldName);
      const updatedValues = {
        [fieldName]: trimmedValue
      };
      updateGuest2(updatedValues, guestData.id);
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestDetailPanel }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.customerDetailsContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestDetailSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestDetailHeader }, "Contact Details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestDetailContent }, /* @__PURE__ */ React__default.createElement(
    Spacer,
    {
      gap: 16,
      style: {
        alignItems: "flex-start",
        flexWrap: "wrap",
        justifyContent: "space-between"
      }
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { gap: 4, direction: "vertical" }, /* @__PURE__ */ React__default.createElement(
      GuestBookTextField,
      {
        label: "First name",
        value: updatedGuestData == null ? void 0 : updatedGuestData.firstName,
        onChange: (value) => handleOnChange("firstName", value),
        onBlur: () => handleOnBlur("firstName"),
        loading: onSaving === "firstName"
      }
    ), /* @__PURE__ */ React__default.createElement(
      GuestBookTextField,
      {
        label: "Last name",
        value: updatedGuestData == null ? void 0 : updatedGuestData.lastName,
        onChange: (value) => handleOnChange("lastName", value),
        onBlur: () => handleOnBlur("lastName"),
        loading: onSaving === "lastName"
      }
    ), /* @__PURE__ */ React__default.createElement(
      GuestBookTextField,
      {
        label: "Phone",
        value: updatedGuestData == null ? void 0 : updatedGuestData.mobile,
        onChange: (value) => handleOnChange("mobile", value),
        onBlur: () => {
          if (!isEmpty(updatedGuestData == null ? void 0 : updatedGuestData.mobile)) {
            handleOnBlur("mobile");
          } else {
            handleOnChange("mobile", guestData == null ? void 0 : guestData.mobile);
          }
        },
        loading: onSaving === "mobile",
        clearError: () => setError({}),
        error: (error == null ? void 0 : error.field) === "mobile" && (error == null ? void 0 : error.error)
      }
    ), /* @__PURE__ */ React__default.createElement(
      GuestBookTextField,
      {
        label: "Email",
        value: updatedGuestData == null ? void 0 : updatedGuestData.email,
        onChange: (value) => handleOnChange("email", value),
        onBlur: () => handleOnBlur("email"),
        loading: onSaving === "email"
      }
    ), /* @__PURE__ */ React__default.createElement(
      GuestBookDropdown,
      {
        label: "Marketing",
        items: marketingPreferenceOptions(),
        selectedItems: updatedGuestData == null ? void 0 : updatedGuestData.marketingPreferences,
        onChange: (newValues) => {
          handleOnChange("marketingPreferences", newValues);
        },
        onClose: () => handleOnBlur("marketingPreferences"),
        loading: onSaving === "marketingPreferences"
      }
    )),
    /* @__PURE__ */ React__default.createElement(
      GuestBookTextArea,
      {
        label: "Notes",
        value: updatedGuestData == null ? void 0 : updatedGuestData.notes,
        onChange: (value) => handleOnChange("notes", value),
        onBlur: () => handleOnBlur("notes"),
        loading: onSaving === "notes"
      }
    )
  ))), /* @__PURE__ */ React__default.createElement(ExpandSection$1, { title: "Additional Details" }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestDetailContent}` }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 4, direction: "vertical" }, /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Birthday",
      value: updatedGuestData == null ? void 0 : updatedGuestData.birthday,
      onBlur: () => handleOnBlur("birthday"),
      onChange: (value) => {
        const newValue = changeDate(value, updatedGuestData == null ? void 0 : updatedGuestData.birthday);
        handleOnChange("birthday", newValue);
      },
      loading: onSaving === "birthday",
      placeholder: "DD/MM/YYYY",
      maxCharacters: 10
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Address",
      value: updatedGuestData == null ? void 0 : updatedGuestData.address,
      onChange: (value) => handleOnChange("address", value),
      onBlur: () => handleOnBlur("address"),
      loading: onSaving === "address"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Interests",
      value: updatedGuestData == null ? void 0 : updatedGuestData.interests,
      onChange: (value) => handleOnChange("interests", value),
      onBlur: () => handleOnBlur("interests"),
      loading: onSaving === "interests"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Work",
      value: updatedGuestData == null ? void 0 : updatedGuestData.jobCompany,
      onChange: (value) => handleOnChange("jobCompany", value),
      onBlur: () => handleOnBlur("jobCompany"),
      loading: onSaving === "jobCompany"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "PA/Concierge",
      value: updatedGuestData == null ? void 0 : updatedGuestData.secretary,
      onChange: (value) => handleOnChange("secretary", value),
      onBlur: () => handleOnBlur("secretary"),
      loading: onSaving === "secretary"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Description",
      value: updatedGuestData == null ? void 0 : updatedGuestData.description,
      onChange: (value) => handleOnChange("description", value),
      onBlur: () => handleOnBlur("description"),
      loading: onSaving === "description"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookToggle,
    {
      label: "VIP",
      value: updatedGuestData == null ? void 0 : updatedGuestData.vip,
      onChange: (value) => handleOnToggle("vip", value),
      loading: onSaving === "vip"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookToggle,
    {
      label: "Blacklisted",
      value: updatedGuestData == null ? void 0 : updatedGuestData.blacklisted,
      onChange: (value) => handleOnToggle("blacklisted", value),
      loading: onSaving === "blacklisted"
    }
  )))), /* @__PURE__ */ React__default.createElement(ExpandSection$1, { title: "Preferences" }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestDetailContent }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 4, direction: "vertical" }, /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Dietary",
      value: updatedGuestData == null ? void 0 : updatedGuestData.allergies,
      onChange: (value) => handleOnChange("allergies", value),
      onBlur: () => handleOnBlur("allergies"),
      loading: onSaving === "allergies"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Table",
      value: updatedGuestData == null ? void 0 : updatedGuestData.preferredTableArea,
      onChange: (value) => handleOnChange("preferredTableArea", value),
      onBlur: () => handleOnBlur("preferredTableArea"),
      loading: onSaving === "preferredTableArea"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Meals",
      value: updatedGuestData == null ? void 0 : updatedGuestData.favouriteMeals,
      onChange: (value) => handleOnChange("favouriteMeals", value),
      onBlur: () => handleOnBlur("favouriteMeals"),
      loading: onSaving === "favouriteMeals"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Drinks",
      value: updatedGuestData == null ? void 0 : updatedGuestData.favouriteDrinks,
      onChange: (value) => handleOnChange("favouriteDrinks", value),
      onBlur: () => handleOnBlur("favouriteDrinks"),
      loading: onSaving === "favouriteDrinks"
    }
  )))), /* @__PURE__ */ React__default.createElement(ExpandSection$1, { title: "Website & socials" }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestDetailContent }, /* @__PURE__ */ React__default.createElement(Spacer, { gap: 4, direction: "vertical" }, /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Website",
      value: updatedGuestData == null ? void 0 : updatedGuestData.website,
      onChange: (value) => handleOnChange("website", value),
      onBlur: () => handleOnBlur("website"),
      loading: onSaving === "website"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Blog",
      value: updatedGuestData == null ? void 0 : updatedGuestData.blog,
      onChange: (value) => handleOnChange("blog", value),
      onBlur: () => handleOnBlur("blog"),
      loading: onSaving === "blog"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Facebook",
      value: updatedGuestData == null ? void 0 : updatedGuestData.facebook,
      onChange: (value) => handleOnChange("facebook", value),
      onBlur: () => handleOnBlur("facebook"),
      loading: onSaving === "facebook"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Twitter",
      value: updatedGuestData == null ? void 0 : updatedGuestData.twitter,
      onChange: (value) => handleOnChange("twitter", value),
      onBlur: () => handleOnBlur("twitter"),
      loading: onSaving === "twitter"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Instagram",
      value: updatedGuestData == null ? void 0 : updatedGuestData.instagram,
      onChange: (value) => handleOnChange("instagram", value),
      onBlur: () => handleOnBlur("instagram"),
      loading: onSaving === "instagram"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "Pinterest",
      value: updatedGuestData == null ? void 0 : updatedGuestData.pinterest,
      onChange: (value) => handleOnChange("pinterest", value),
      onBlur: () => handleOnBlur("pinterest"),
      loading: onSaving === "pinterest"
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookTextField,
    {
      label: "LinkedIn",
      value: updatedGuestData == null ? void 0 : updatedGuestData.linkedIn,
      onChange: (value) => handleOnChange("linkedIn", value),
      onBlur: () => handleOnBlur("linkedIn"),
      loading: onSaving === "linkedIn"
    }
  ))))));
};
GuestBookCustomerDetailsTab.propTypes = {
  guestData: obeeGuestPropTypes.isRequired,
  updateGuest: PropTypes.func.isRequired,
  obeeGuests: obeeGuestsPropTypes.isRequired
};
const mapStateToProps$F = (state) => ({
  obeeGuests: state.obeeGuests
});
const mapDispatchToProps$E = (dispatch) => bindActionCreators(
  {
    updateGuest: updateGuestAction
  },
  dispatch
);
const GuestBookCustomerDetailsTab$1 = connect(mapStateToProps$F, mapDispatchToProps$E)(GuestBookCustomerDetailsTab);
const SvgEclipse = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 6.61711, cy: 6.62474, r: 6.11711, stroke: "#AEAEAE" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 6.61711, cy: 6.62474, r: 6.11711, stroke: "black", strokeOpacity: 0.2 }));
const EclipseSVG = SvgEclipse;
const GuestBookHistoryTab = ({ obeeGuestBookings }) => {
  const classes = useStyles$i();
  const getDateString = (date, bookingTime) => {
    const bookingDateTime = momentFromInt(bookingTime, date);
    return getRelativeDate(bookingDateTime);
  };
  const sortedBookings = useMemo(() => {
    return obeeGuestBookings == null ? void 0 : obeeGuestBookings.map((booking) => ({
      ...booking,
      displayDate: getDateString(booking.date, booking.time),
      displaySize: `${booking.size} ${pluralise("guest", booking.size)}`,
      displayStatus: `Status: ${getStatusLabel(booking)}`
    })).sort((a, b) => {
      return b.momentStartTime.valueOf() - a.momentStartTime.valueOf();
    });
  }, [obeeGuestBookings]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestDetailPanel }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistoryItems }, sortedBookings.map((booking, index) => /* @__PURE__ */ React__default.createElement(Box, { key: booking == null ? void 0 : booking.id, className: classes.bookingHistory }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.circleContainer }, /* @__PURE__ */ React__default.createElement(EclipseSVG, { className: classes.circle }), index !== (sortedBookings == null ? void 0 : sortedBookings.length) - 1 && /* @__PURE__ */ React__default.createElement(Box, { className: classes.dashline })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistoryContents }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistoryDate }, booking.displayDate), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistorySize }, booking.displaySize), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistorySize }, booking.displayStatus), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistoryComments }, getFullComments(booking)))))));
};
GuestBookHistoryTab.defaultProps = {
  obeeGuestBookings: []
};
GuestBookHistoryTab.propTypes = {
  obeeGuestBookings: PropTypes.arrayOf(obeeBookingPropTypes)
};
const mapStateToProps$E = () => ({});
const mapDispatchToProps$D = (dispatch) => bindActionCreators({}, dispatch);
const GuestBookHistoryTab$1 = connect(mapStateToProps$E, mapDispatchToProps$D)(GuestBookHistoryTab);
const useStyles$d = createUseStyles((theme2) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid ${theme2.colors.shark}`,
    borderRadius: "8px",
    padding: "0 10px",
    height: "45px",
    width: "206px"
  },
  label: {
    fontSize: "13px",
    fontWeight: theme2.fontWeights.medium,
    whiteSpace: "nowrap",
    userSelect: "none",
    color: theme2.colors.smoke
    // TODO what colour for obee?
  },
  value: {
    ...theme2.typography.body.bodyText,
    whiteSpace: "nowrap",
    userSelect: "none",
    color: theme2.colors.charcoal
    // TODO what colour for obee?
  }
}));
const InfoCard = ({ label, value }) => {
  const classes = useStyles$d();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label), /* @__PURE__ */ React__default.createElement(Box, { className: classes.value }, value));
};
InfoCard.defaultProps = {
  label: "",
  value: ""
};
InfoCard.propTypes = {
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number])
};
const InfoCard$1 = InfoCard;
const GuestBookDetailView = ({
  guestData,
  obeeGuestBookings,
  fetchBookingsForUser,
  searchCompleted
}) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$i();
  const [activeTab, setActiveTab] = useState("customer");
  useEffect(() => {
    setActiveTab("customer");
    if (guestData == null ? void 0 : guestData.id) {
      fetchBookingsForUser(guestData == null ? void 0 : guestData.id, true);
    }
  }, [guestData == null ? void 0 : guestData.id]);
  const totalVisits = guestData == null ? void 0 : guestData.numVisits;
  const totalLastMonth = useMemo(() => {
    var _a2, _b2;
    if (!(guestData == null ? void 0 : guestData.id)) {
      return 0;
    }
    const today = moment$2().startOf("day");
    const recentBookings = (_b2 = (_a2 = obeeGuestBookings.data) == null ? void 0 : _a2[guestData == null ? void 0 : guestData.id]) == null ? void 0 : _b2.filter((booking) => {
      return getVisitedStatuses().includes(booking == null ? void 0 : booking.status) && today.diff(moment$2(booking.date), "month") === 0;
    });
    return (recentBookings == null ? void 0 : recentBookings.length) || 0;
  }, [obeeGuestBookings == null ? void 0 : obeeGuestBookings.data, guestData == null ? void 0 : guestData.id]);
  const renderGuestDetailPreview = (message, isGrayscale) => /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestDetailPreview} ${isGrayscale ? classes.grayscale : ""}` }, /* @__PURE__ */ React__default.createElement(GuestBookSearchSVG, null), /* @__PURE__ */ React__default.createElement(Box, null, message));
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestRightPane}` }, !isEmpty(guestData) ? /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestRightPaneContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestSummaryPanel }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestRightPanePadding }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestFullName }, guestData == null ? void 0 : guestData.firstName, " ", guestData == null ? void 0 : guestData.lastName), /* @__PURE__ */ React__default.createElement(
    TabBar$2,
    {
      tabs: [
        { value: "customer", label: "Customer details" },
        { value: "history", label: "History" }
      ],
      value: activeTab,
      onSelect: setActiveTab,
      style: tabBarStyles$1(theme2)
    }
  )), /* @__PURE__ */ React__default.createElement(Fade, { isShowing: totalVisits > 0, fadeInOnly: true }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestSummaryStatsContainer }, /* @__PURE__ */ React__default.createElement(InfoCard$1, { label: "Total visits", value: totalVisits }), /* @__PURE__ */ React__default.createElement(
    InfoCard$1,
    {
      label: "Last month",
      value: `${totalLastMonth} ${pluralise("time", totalLastMonth)}`
    }
  )))), /* @__PURE__ */ React__default.createElement(Divider, { color: theme2.colors.charcoal }), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestDetailContainer}` }, activeTab === "customer" && /* @__PURE__ */ React__default.createElement(GuestBookCustomerDetailsTab$1, { guestData }), activeTab === "history" && /* @__PURE__ */ React__default.createElement(
    GuestBookHistoryTab$1,
    {
      obeeGuestBookings: ((_a = obeeGuestBookings == null ? void 0 : obeeGuestBookings.data) == null ? void 0 : _a[guestData == null ? void 0 : guestData.id]) || []
    }
  ))) : renderGuestDetailPreview(
    searchCompleted === 0 ? "Sorry, no results were found." : "Click on a guest name from the list on the left to view their details",
    searchCompleted === 0
  ));
};
GuestBookDetailView.defaultProps = {
  obeeGuestBookings: {},
  guestData: null
};
GuestBookDetailView.propTypes = {
  guestData: obeeGuestPropTypes,
  obeeGuestBookings: obeeBookingsPropTypes,
  fetchBookingsForUser: PropTypes.func.isRequired,
  searchCompleted: PropTypes.number.isRequired
};
const mapStateToProps$D = (state) => ({
  obeeGuestBookings: state.obeeBookingsForUser
});
const mapDispatchToProps$C = (dispatch) => bindActionCreators(
  {
    fetchBookingsForUser: fetchObeeBookingsForUserAction
  },
  dispatch
);
const GuestBookDetailView$1 = connect(mapStateToProps$D, mapDispatchToProps$C)(GuestBookDetailView);
const GuestBook = ({ guests }) => {
  const classes = useStyles$i();
  const [guestData, setGuestData] = useState(null);
  const [searchCompleted, setSearchCompleted] = useState(0);
  const viewGuestData = (guest) => {
    setGuestData(guest);
  };
  useEffect(() => {
    viewGuestData(findObjectByProperty(guests, guestData == null ? void 0 : guestData.id, "id"));
    setSearchCompleted(guests == null ? void 0 : guests.length);
  }, [guests]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestGridContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestBookLeftContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestLeftPane }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, /* @__PURE__ */ React__default.createElement(
    GuestBookSearchBox$1,
    {
      viewGuestData,
      setSearchCompleted,
      searchCompleted: searchCompleted !== 0
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestListingContainer }, /* @__PURE__ */ React__default.createElement(
    GuestBookListing$1,
    {
      obeeGuestBook: guests,
      viewGuestData,
      activeGuest: guestData
    }
  )))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestBookRightContainer }, /* @__PURE__ */ React__default.createElement(
    GuestBookDetailView$1,
    {
      guestData,
      updateLocalGuestData: setGuestData,
      searchCompleted
    }
  )));
};
GuestBook.defaultProps = {
  guests: []
};
GuestBook.propTypes = {
  guests: PropTypes.instanceOf(Object)
};
const mapStateToProps$C = (state) => ({
  guests: state.obeeGuests.data,
  restId: state.restaurantActive.restaurant.objectId,
  restaurant: state.restaurantActive
});
const mapDispatchToProps$B = (dispatch) => bindActionCreators({}, dispatch);
const GuestbookScreen = connect(mapStateToProps$C, mapDispatchToProps$B)(GuestBook);
const useStyles$c = createUseStyles((theme2) => ({
  voucherGridContainer: {
    fontSize: "15px",
    display: "flex",
    background: `${theme2.colors.linen}`
  },
  voucherLeftContainer: {
    minWidth: "362px",
    maxWidth: "362px"
  },
  voucherRightContainer: {
    width: "calc(100% - 32px)",
    height: "calc(100dvh - 65px)"
  },
  tabContainer: {
    width: "240px",
    display: "flex",
    marginTop: "5px"
  },
  voucherLeftPane: {
    marginLeft: "24px",
    marginTop: "32px"
    // maxHeight: 'calc(95vh - 50px)',
  },
  voucherRightPane: {
    background: "#FFFFFF",
    border: "1px solid #EEEEEE",
    boxShadow: "0px 4px 8px rgba(104, 104, 104, 0.25)",
    borderRadius: "25px 0 0 0",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    display: "flex"
    // width: 'calc(100% + 100px)',
  },
  voucherDetailContainer: {
    position: "relative",
    flexGrow: 1,
    // overflowX: 'hidden',
    overflowY: theme2.overlay,
    width: "100%"
    // height: 'calc(80vh - 8rem)',
  },
  voucherSummaryPanel: {
    background: `${theme2.colors.summaryPanelBackground}`,
    margin: "9px 0px 40px 9px",
    height: "auto",
    maxHeight: "150px",
    borderRadius: "20px",
    boxSizing: "border-box",
    width: "calc(100% - 32px)",
    display: "flex",
    position: "relative",
    flexGrow: 1,
    "&::after": {
      content: '""',
      position: "absolute",
      top: "190px",
      left: "50px",
      width: "calc(100% - 50px)",
      height: "1px",
      backgroundColor: `${theme2.colors.yetAnotherGray15}`
    }
  },
  voucherDetailPreview: {
    padding: "15px 25px 20px 15px",
    // height: '100vh',
    // minHeight: '100vh',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    flexGrow: 1,
    "& svg": {
      height: "142px"
    }
  },
  grayscale: {
    filter: "grayscale(100%)"
  },
  voucherDetailPanel: {
    margin: "0px 25px 20px 15px",
    paddingTop: "31px",
    // overflowY: 'auto',
    overflowX: "hidden",
    // width: '100%',
    // height: 'calc(100vh - 79px)', // To fill screen (64px header and 40px bottom padding)
    display: "inline-block",
    paddingLeft: "55px",
    paddingRight: "55px",
    flexGrow: "1",
    overflowY: theme2.overlay
  },
  voucherDetailPanelRow: {
    display: "inline-flex",
    width: "100%",
    height: "36px",
    marginBottom: "20px"
    // marginTop: '24px',
  },
  voucherDetailPanelRowLabel: {
    color: theme2.colors.smoke,
    lineHeight: "24px",
    minWidth: "150px"
  },
  voucherDetailPanelRowData: {
    width: "100%",
    marginLeft: "50px"
  },
  voucherBalanceContainer: {},
  voucherBalanceHeaderText: {
    fontSize: "18px",
    lineHeight: "24px",
    fontWeight: "700"
  },
  voucherBalanceAmountContainer: {
    display: "inline-flex",
    marginTop: "32px"
  },
  voucherBalanceAmountText: {
    fontSize: "32px",
    lineHeight: "43px",
    marginRight: "32px",
    fontWeight: "900"
  },
  voucherLeftHeaderContent: {
    paddingLeft: "50px",
    width: "370px"
  },
  voucherRightHeaderContent: {
    maxWidth: "570px",
    display: "inline-flex",
    width: "100%",
    justifyContent: "end",
    marginTop: "42px"
  },
  // guestLeftMargin: {
  //   marginLeft: '70px',
  // },
  voucherReferenceContainer: {
    display: "inline-flex"
  },
  voucherReference: {
    fontSize: "32px",
    fontWeight: "900",
    lineHeight: "43px",
    paddingTop: "40px"
  },
  voucherDetailStatus: {
    marginLeft: "40px",
    marginTop: "45px",
    color: "#FFFFFF",
    height: "25px",
    display: "inline-block",
    padding: "4px 12px",
    borderRadius: "100px",
    backgroundColor: theme2.colors.activeVoucher
  },
  voucherNumber: {
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "28px"
  },
  voucherGrid: {
    display: "grid",
    padding: "15px 20px 15px 20px",
    marginBottom: "5px",
    border: "1px solid transparent",
    minWidth: "313px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme2.colors.white,
      borderRadius: "6px",
      boxSizing: "border-box"
    },
    "&:active": {
      border: `1px solid ${theme2.colors.bodyText}`
    }
  },
  recipientNameContainer: {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "22px"
  },
  voucherListingContainer: {
    margin: "15px 0px 0px 0px",
    paddingRight: "24px",
    overflowY: "scroll",
    overflowX: "hidden",
    maxHeight: "calc(100dvh - 196px)",
    // header plus search section
    userSelect: "none"
  },
  voucherSearchBoxContainer: {
    paddingRight: "24px"
  },
  voucherSearchBox: {
    background: `${theme2.colors.white}`,
    border: `1px solid ${theme2.colors.unicornSilver}`,
    boxShadow: `0px 4px 7px rgba(222, 222, 222, 0.25)`,
    borderRadius: "25px",
    width: "100%",
    // TODO change these
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: "22px"
    },
    "& label.Mui-focused": {
      color: "white"
    },
    "& .MuiInput-underline:after": {
      border: "none"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none"
      },
      "&:hover fieldset": {
        borderRadius: "25px",
        border: `1px solid white`
      },
      "&:focus": {
        border: "none"
      },
      "&.Mui-focused fieldset": {
        border: "none"
      }
    }
  },
  voucherSearchStats: {
    marginTop: "25px",
    marginLeft: "20px",
    width: "100%",
    fontSize: "15px"
  },
  guestContactDetailsDivider: {
    marginRight: "15px",
    marginLeft: "15px",
    color: theme2.colors.gray9
  },
  voucherListRowActive: {
    backgroundColor: theme2.colors.activeGuestRowBackground,
    border: `1px solid ${theme2.colors.activeGuestRowBorder}`,
    borderRadius: "6px",
    boxSizing: "border-box"
  },
  saveProgress: {
    marginLeft: "10px"
  },
  activeTab: {
    borderRadius: "100px",
    textAlign: "center",
    width: "100%",
    height: "35px",
    lineHeight: "23px",
    fontSize: "16px",
    cursor: "pointer",
    paddingTop: "5px",
    border: "1px solid #313131"
  },
  inactiveTab: {
    textAlign: "center",
    width: "100%",
    height: "35px",
    lineHeight: "35px",
    fontSize: "16px",
    cursor: "pointer"
  },
  customerDetailsContainer: {
    width: "881.5px",
    "&:last-of-type": {
      marginBottom: "200px"
    }
  },
  bookingHistoryContainer: {
    minHeight: "140px",
    // width: '65vw',
    display: "inline-flex"
  },
  leftBorder: {
    paddingLeft: "5px"
  },
  bookingHistoryComments: {
    fontSize: "15px",
    lineHeight: "26px",
    marginTop: "20px"
  },
  bookingHistoryContents: {
    marginLeft: "20px"
  },
  voucherResultsContainer: {
    display: "inline-flex",
    width: "100%"
  },
  voucherStatusSelectContainer: {
    marginTop: "20px",
    textAlign: "end"
  },
  voucherListRowContainer: {
    display: "inline-flex",
    height: "80px",
    width: "100%",
    marginBottom: "6px"
  },
  voucherListRowDetail: {
    width: "100%"
  },
  voucherListRowBalanceContainer: {
    textAlign: "end",
    lineHeight: "28px"
  },
  voucherListRowBalanceLabel: {
    fontSize: "12px",
    letterSpacing: "1.5px",
    lineHeight: "16px",
    fontWeight: "500"
  },
  voucherRefContainer: {
    display: "inline-flex"
  },
  voucherStatusSelectFormControl: {
    width: "130px",
    border: "1px solid #DCDCDB",
    "& .MuiInput-underline:before": {
      border: "none"
    },
    "& .MuiInput-underline:after": {
      border: "none"
    }
  },
  voucherStatusSelectDropdown: {
    textAlign: "center",
    padding: "0"
  },
  voucherStatusSelectDropdownItems: {
    "& .MuiList-padding": {
      paddingRight: "12px",
      paddingLeft: "12px"
    },
    "& .MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover": {
      backgroundColor: "#F0F0F0",
      borderRadius: "6px"
    }
  },
  voucherStatusHeaderBox: {
    backgroundColor: theme2.colors.activeVoucher,
    // TODO need colours for other statuses
    color: "#FFFFFF",
    height: "25px",
    borderRadius: "100px",
    padding: "4px 12px",
    display: "inline-block",
    marginTop: "30px"
  },
  voucherStatusHeaderText: {
    color: theme2.colors.labelText,
    fontSize: "15px",
    lineHeight: "15px",
    fontWeight: "500",
    textAlign: "center",
    width: "100%",
    textTransform: "capitalize"
  },
  voucherRedeemContainer: {
    alignItems: "center",
    minHeight: "77px",
    height: "77px",
    display: "inline-flex",
    justifyContent: "end",
    width: "100%",
    position: "relative",
    paddingRight: "20px",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "0px",
      left: "56px",
      width: "calc(100% - 75px)",
      height: "1px",
      backgroundColor: `${theme2.colors.yetAnotherGray15}`
    }
  },
  redeemVoucherHeader: {
    ...theme2.typography.heading.H4,
    paddingBottom: "12px",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "32px",
    fontWeight: "900",
    lineHeight: "43px"
    // paddingBottom: '34px',
  },
  redeemVoucherOptionContainer: {
    display: "flex",
    marginBottom: "50px"
  },
  redeemVoucherOption: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px",
    gap: "32px",
    width: "261px",
    height: "48px",
    background: theme2.colors.white,
    border: "1px solid #15221C",
    borderRadius: "12px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: "500",
    "&:nth-child(n+2)": {
      marginLeft: "20px"
    }
  },
  redeemVoucherOptionText: {
    flexGrow: "1",
    textAlign: "center"
  },
  redeemVoucherTakenByLabel: {
    fontSize: "18px",
    fontWeight: "700",
    lineHeight: "22px",
    paddingBottom: "18px"
  },
  redeemVoucherNotesRow: {
    extend: "voucherDetailPanelRow",
    height: "72px"
  },
  redeemVoucherNotesRowLabel: {
    extend: "voucherDetailPanelRowLabel",
    marginTop: "16px",
    width: "180px",
    color: theme2.colors.smoke
  },
  optionCircleContainer: {
    position: "relative",
    marginLeft: "20px",
    svg: {
      position: "absolute",
      top: "50%",
      right: "0",
      transform: "translateY(-50%)"
    }
  },
  redeemVoucherButtonsContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "24px"
  },
  redeemVoucherConfirmButton: {
    borderRadius: "12px"
  },
  bookingHistoryDate: {
    fontSize: "18px",
    fontWeight: theme2.fontWeights.medium,
    lineHeight: "24px"
  },
  bookingHistorySize: {
    fontSize: "18px",
    lineHeight: "24px",
    marginTop: "10px"
  },
  circleContainer: {
    position: "relative"
  },
  dashlineContainer: {
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      left: "45%",
      bottom: "5px",
      top: "35px",
      width: "1px",
      height: "95px",
      borderLeft: `1px solid ${theme2.colors.shark}`
    }
  },
  voucherHistoryPanel: {
    margin: "0 25px 20px 15px",
    paddingTop: "40px",
    overflowX: "hidden",
    paddingLeft: "55px",
    paddingRight: "55px",
    flexGrow: "1",
    overflowY: theme2.overlay,
    display: "flex",
    flexDirection: "column"
  },
  errorText: {
    color: theme2.colors.errorRed
  }
}));
const fetchVoucherRedemptionListingAction = (page = 1, data = {}, skipLoading = false) => (dispatch) => {
  const action = "FETCH_OBEE_VOUCHER_REDEMPTION_LIST";
  const request = () => fetchVoucherRedemptions(data, page);
  dispatch(makeApiAction(action, request, {}, "voucherRedemption", null, {}, skipLoading));
};
const resetSearchDataAction = (filterValues = "") => (dispatch) => {
  dispatch({
    type: "RESET_OBEE_SEARCH_FILTER",
    filterValue: filterValues
  });
};
const filterVoucherRedemptionsAction = (searchValue) => (dispatch) => {
  dispatch(resetSearchDataAction(searchValue));
  dispatch(fetchVoucherRedemptionListingAction(1, { search: searchValue }));
};
const createNewRedemption = (data, skipLoading = false) => (dispatch) => {
  const action = "CREATE_OBEE_VOUCHER_REDEMPTION";
  const request = () => createVoucherRedemption(data);
  dispatch(makeApiAction(action, request, {}, "obeeVoucherRedemption", null, {}, skipLoading));
};
const VoucherRedemptionListRow = ({ voucher }) => {
  const classes = useStyles$c();
  return /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.recipientNameContainer}` }, voucher == null ? void 0 : voucher.recipientName)), /* @__PURE__ */ React__default.createElement(Box, { style: { display: "inline-flex", gap: "16px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestNameContainer}` }, voucher == null ? void 0 : voucher.voucherRef), (voucher == null ? void 0 : voucher.voucherNumber) && /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestNameContainer}` }, "#", voucher == null ? void 0 : voucher.voucherNumber))), /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", justifyContent: "space-between", flexDirection: "column" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "12px" } }, "BALANCE"), /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "18px" } }, formatCurrency(voucher == null ? void 0 : voucher.balance))));
};
VoucherRedemptionListRow.propTypes = {
  voucher: voucherRedemptionPropTypes.isRequired
};
const mapStateToProps$B = () => ({});
const mapDispatchToProps$A = (dispatch) => bindActionCreators({}, dispatch);
const VoucherRedemptionListRow$1 = connect(mapStateToProps$B, mapDispatchToProps$A)(VoucherRedemptionListRow);
const VoucherRedemptionListing = ({
  voucherRedemptions,
  fetchVoucherRedemptions: fetchVoucherRedemptions2,
  viewVoucherDetails,
  activeVoucher
}) => {
  var _a;
  const classes = useStyles$c();
  useEffect(() => {
    fetchVoucherRedemptions2();
  }, []);
  return /* @__PURE__ */ React__default.createElement(Box, null, (_a = voucherRedemptions.data) == null ? void 0 : _a.map((voucher) => /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.voucherGrid} ${(activeVoucher == null ? void 0 : activeVoucher.id) === voucher.id ? ` + ${classes.voucherListRowActive} + ` : ""}`,
      key: voucher.id,
      onClick: () => {
        viewVoucherDetails(voucher);
      }
    },
    /* @__PURE__ */ React__default.createElement(VoucherRedemptionListRow$1, { voucher })
  )));
};
VoucherRedemptionListing.propTypes = {
  voucherRedemptions: voucherRedemptionPropTypes.isRequired,
  fetchVoucherRedemptions: PropTypes.func.isRequired,
  viewVoucherDetails: PropTypes.func.isRequired,
  activeVoucher: PropTypes.instanceOf(Object).isRequired
};
const mapStateToProps$A = (state) => ({
  voucherRedemptions: state.voucherRedemptions
});
const mapDispatchToProps$z = (dispatch) => bindActionCreators(
  {
    fetchVoucherRedemptions: fetchVoucherRedemptionListingAction
  },
  dispatch
);
const VoucherRedemptionListing$1 = connect(mapStateToProps$A, mapDispatchToProps$z)(VoucherRedemptionListing);
const VoucherRedemptionSearchBox = ({
  voucherRedemptions,
  filterVoucherRedemptions,
  searchBoxText
}) => {
  var _a, _b2, _c2;
  const classes = useStyles$c();
  const theme2 = useTheme$1();
  const searchResults = ((_a = voucherRedemptions == null ? void 0 : voucherRedemptions.pagination) == null ? void 0 : _a.totalResults) || 0;
  const [searchString, setSearchString] = useState(null);
  const doSearch = useCallback(
    debounce$1((searchText) => {
      filterVoucherRedemptions(searchText);
    }, 1e3),
    []
  );
  const searchVoucherRedemptions = (value) => {
    setSearchString(value);
    doSearch(value);
  };
  const getSearchText = () => {
    if (isEmpty(searchString) || searchResults < 0) {
      return "";
    }
    if (!isEmpty(searchString)) {
      return `${searchResults} ${pluralise("voucher", searchResults)} matching search`;
    }
    return `${searchResults} total ${pluralise("voucher", searchResults)}`;
  };
  const styles2 = {
    container: {
      display: "flex",
      gap: "10px",
      alignItems: "center"
    },
    innerContainer: {
      width: "100%"
    },
    label: {
      color: theme2.colors.nimbus,
      marginBottom: "0",
      width: "120px"
    },
    textField: {
      flexGrow: 1
    },
    textFieldInner: {
      width: "100%"
    },
    input: {
      backgroundColor: theme2.colors.white,
      border: `1px solid ${theme2.colors.grayBorder}`,
      width: "100%",
      color: theme2.colors.labelText,
      padding: "9px 14px 9px 45px",
      borderRadius: "20px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      lineHeight: "20px",
      paddingLeft: "45px",
      transition: "box-shadow 0.1s",
      ...(_c2 = (_b2 = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _b2.SearchBar) == null ? void 0 : _c2.input
    },
    inputActive: {
      outline: "none",
      boxShadow: "0 4px 8px rgba(220, 220, 219, 0.25)"
    },
    inputHover: {
      backgroundColor: theme2.colors.white
    },
    placeholder: {
      color: theme2.colors.nimbus
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.voucherSearchBoxContainer}` }, /* @__PURE__ */ React__default.createElement(
    TextField$2,
    {
      id: "voucher-search",
      placeholder: searchBoxText,
      onChange: searchVoucherRedemptions,
      value: searchString,
      style: styles2,
      inputPrefix: /* @__PURE__ */ React__default.createElement(
        MagnifyingGlassSVG,
        {
          style: {
            marginLeft: "10px",
            marginTop: "4px",
            color: theme2.colors.yetAnotherGray16,
            width: "15px"
          }
        }
      )
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.voucherSearchStats}` }, getSearchText()));
};
VoucherRedemptionSearchBox.defaultProps = {
  searchBoxText: "Search voucher code or number"
};
VoucherRedemptionSearchBox.propTypes = {
  filterVoucherRedemptions: PropTypes.func.isRequired,
  // resetSearch: PropTypes.func.isRequired,
  voucherRedemptions: voucherRedemptionsPropTypes.isRequired,
  searchBoxText: PropTypes.string
};
const mapStateToProps$z = (state) => ({
  voucherRedemptions: state.voucherRedemptions
});
const mapDispatchToProps$y = (dispatch) => bindActionCreators(
  {
    filterVoucherRedemptions: filterVoucherRedemptionsAction,
    fetchVoucherRedemptions: fetchVoucherRedemptionListingAction
    // resetSearch: resetSearchData,
  },
  dispatch
);
const VoucherRedemptionSearchBox$1 = connect(mapStateToProps$z, mapDispatchToProps$y)(VoucherRedemptionSearchBox);
const VoucherRedemptionHistoryTab = ({ voucherHistory }) => {
  const classes = useStyles$c();
  const voucherRedemptions = useMemo(() => {
    var _a, _b2;
    return (_b2 = ((_a = voucherHistory.data) == null ? void 0 : _a.history) || []) == null ? void 0 : _b2.map((voucher) => {
      const voucherDate = moment$2(voucher.redemptionDate);
      return { ...voucher, displayDate: getRelativeDate(voucherDate) };
    }).sort((a, b) => sortByDate(a.redemptionDate, b.redemptionDate, "YYYY-MM-DD HH:mm:ss"));
  }, [voucherHistory]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherHistoryPanel }, voucherRedemptions.length === 0 && /* @__PURE__ */ React__default.createElement(Box, null, "This voucher has no redemptions yet"), voucherRedemptions.length > 0 && voucherRedemptions.map((voucher) => /* @__PURE__ */ React__default.createElement(Box, { key: voucher == null ? void 0 : voucher.id, className: classes.bookingHistoryContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.circleContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.dashlineContainer }, /* @__PURE__ */ React__default.createElement(EclipseSVG, { style: { width: "14px", height: "14px", marginTop: "5px" } }))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistoryContents }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistoryDate }, voucher.displayDate), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistorySize }, "Redeemed ", formatCurrency(voucher.redemptionAmount)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingHistoryComments }, "Taken by ", voucher.redemptionTakenBy)))));
};
VoucherRedemptionHistoryTab.defaultProps = {};
VoucherRedemptionHistoryTab.propTypes = {
  voucherHistory: voucherRedemptionsPropTypes.isRequired
};
const mapStateToProps$y = () => ({});
const mapDispatchToProps$x = (dispatch) => bindActionCreators({}, dispatch);
const VoucherRedemptionHistoryTab$1 = connect(mapStateToProps$y, mapDispatchToProps$x)(VoucherRedemptionHistoryTab);
const SvgVoucherRedemptionSearch = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 214, height: 142, viewBox: "0 0 214 142", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.773926, y: 0.0136719, width: 140.403, height: 100.763, rx: 13.1266, fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("rect", { x: 0.773926, y: 0.0136719, width: 140.403, height: 100.763, rx: 13.1266, fill: "#F5F2ED" }), /* @__PURE__ */ React$7.createElement("g", { opacity: 0.7 }, /* @__PURE__ */ React$7.createElement("path", { d: "M118.791 114.813C144.394 114.813 165.149 94.0583 165.149 68.4555C165.149 42.8528 144.394 22.0977 118.791 22.0977C93.1887 22.0977 72.4336 42.8528 72.4336 68.4555C72.4336 94.0583 93.1887 114.813 118.791 114.813Z", fill: "#86AEA6" })), /* @__PURE__ */ React$7.createElement("path", { d: "M213.348 134.338C212.848 132.79 211.935 131.737 210.618 130.785C208.786 129.468 206.949 128.151 205.117 126.828C200.713 123.66 196.304 120.492 191.9 117.328C186.568 113.491 181.232 109.659 175.9 105.823C171.265 102.491 166.63 99.1589 161.99 95.8222L155.932 91.5047C156.586 90.3316 157.192 89.1296 157.74 87.9036C161.639 79.1724 162.784 69.3739 161.029 59.9745C159.279 50.5798 154.605 41.8054 147.788 35.108C146.047 33.3963 144.167 31.8338 142.187 30.4058C134.268 24.7325 124.676 21.617 114.935 21.5881C105.473 21.5593 96.0499 24.4248 88.237 29.7664C80.0588 35.3532 73.77 43.5122 70.4237 52.8299C67.2168 61.763 66.8418 71.6336 69.2794 80.8023C71.7507 90.1008 77.1115 98.5531 84.4965 104.722C92.0208 111.01 101.372 114.857 111.152 115.612C120.57 116.338 130.162 114.155 138.34 109.433C142.288 107.154 145.879 104.284 148.999 100.972C150.778 102.26 152.951 103.89 154.682 105.135C159.086 108.304 163.495 111.472 167.899 114.636C173.231 118.472 178.568 122.304 183.9 126.141C188.535 129.473 193.174 132.805 197.809 136.141C200.045 137.747 202.237 139.454 204.536 140.973C204.569 140.993 204.598 141.021 204.632 141.041C205.814 141.892 207.863 142.012 209.214 141.642C210.594 141.262 212.084 140.194 212.767 138.911C213.478 137.536 213.844 135.867 213.348 134.338ZM143.052 104.505C135.85 110.217 126.878 113.631 117.714 114.222C108.401 114.823 99.0356 112.535 91.0641 107.683C82.9243 102.726 76.4336 95.2597 72.7267 86.4709C69.1785 78.0618 68.2121 68.6095 70.015 59.6619C71.9093 50.2721 76.8038 41.6131 83.8378 35.108C90.641 28.8192 99.3337 24.7517 108.502 23.468C117.647 22.1891 127.143 23.7661 135.374 27.9538C137.494 29.0308 139.528 30.276 141.461 31.6607C149.124 37.1898 154.966 45.0603 157.985 54.0175C160.913 62.7054 161.187 72.1866 158.716 81.0187C156.12 90.2451 150.562 98.5435 143.052 104.505Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M138.907 4.41909C136.874 1.8084 133.739 0.308328 130.436 0.279481C130.143 0.274673 129.844 0.279481 129.551 0.279481C127.705 0.279481 125.859 0.279481 124.008 0.279481C120.767 0.279481 117.527 0.279481 114.281 0.279481C109.93 0.279481 105.584 0.279481 101.233 0.279481C96.1313 0.279481 91.0253 0.279481 85.9241 0.279481C80.3374 0.279481 74.7506 0.279481 69.1638 0.279481C63.4568 0.279481 57.7546 0.279481 52.0476 0.279481C46.4945 0.279481 40.9365 0.279481 35.3786 0.279481C30.3303 0.279481 25.282 0.279481 20.2337 0.279481C15.9691 0.279481 21.3155 0.279481 17.0508 0.279481C13.9065 0.279481 20.3827 0.279481 17.2383 0.279481C15.5412 0.279481 13.844 0.279481 12.1468 0.279481C11.7862 0.279481 11.4208 0.274673 11.0602 0.289096C7.27155 0.452565 3.74254 2.6642 1.99246 6.03936C0.708752 8.52024 0.776063 11.0636 0.776063 13.732C0.776063 17.1312 0.776063 20.5304 0.776063 23.9296C0.776063 28.925 0.776063 33.9204 0.776063 38.9158C0.776063 44.5988 0.776063 50.2817 0.776063 55.9647C0.776063 61.3351 0.776063 66.7056 0.776063 72.076C0.776063 76.23 0.776063 80.3841 0.776063 84.5381C0.776063 86.4901 0.771255 88.4469 0.776063 90.3989C0.795294 96.3367 5.55513 101.198 11.5217 101.246C12.5747 101.255 13.6276 101.246 14.6805 101.246C17.2864 101.246 10.2717 101.246 12.8776 101.246C16.7383 101.246 10.9833 101.246 14.844 101.246C19.6135 101.246 24.3829 101.246 29.1523 101.246C34.5564 101.246 39.9605 101.246 45.3646 101.246C51.038 101.246 56.7161 101.246 62.3894 101.246C68.0724 101.246 73.7505 101.246 79.4335 101.246C81.6451 101.246 83.8616 101.246 86.0732 101.246C85.5972 100.774 85.1357 100.294 84.6837 99.8032C83.0346 99.8032 81.3903 99.8032 79.7412 99.8032C74.14 99.8032 68.5436 99.8032 62.9423 99.8032C57.3171 99.8032 51.687 99.8032 46.0618 99.8032C44.2828 99.8032 42.5039 99.8032 40.725 99.8032C40.725 99.1541 40.725 98.5051 40.725 97.8512C40.725 95.4424 40.725 93.0337 40.725 90.6201C40.725 87.043 40.725 83.4659 40.725 79.884C40.725 75.5377 40.725 71.1913 40.725 66.8402C40.725 62.0804 40.725 57.3205 40.725 52.5559C40.725 49.7481 40.725 46.9402 40.725 44.1324C41.0087 44.118 41.2875 44.1084 41.5712 44.0843C44.0232 44.6901 46.1387 46.3152 47.8118 48.2576C50.211 51.0414 51.8841 54.4598 53.2256 57.859C54.6872 61.5515 55.7882 65.3882 56.6873 69.2538C57.4421 72.4895 58.0575 75.754 58.5479 79.0378C58.7835 80.6197 58.947 81.9611 59.1345 83.615C59.1393 83.639 59.1393 83.6631 59.1393 83.6871C59.2258 84.6054 60.6682 84.6102 60.5817 83.6871C60.4518 82.312 60.2643 80.9418 60.072 79.5715C59.6153 76.3646 59.0383 73.1674 58.3364 70.0038C57.4517 66.0373 56.3699 62.0996 54.9324 58.2965C53.5525 54.6473 51.8601 51.0558 49.4321 47.9739C48.0907 46.2671 46.4368 44.7094 44.5088 43.6757C44.5665 43.6661 44.6194 43.6516 44.6771 43.642C49.2879 43.642 53.9035 43.642 58.5143 43.642C65.5578 43.642 72.6014 43.642 79.645 43.642C79.9527 43.1564 80.2701 42.6756 80.597 42.1996C75.1352 42.1996 69.6734 42.1996 64.2068 42.1996C59.3797 42.1996 54.5477 42.1996 49.7206 42.1996C53.3746 40.8198 56.8074 38.8005 59.7307 36.3773C63.7212 33.0694 68.2214 27.2855 65.1251 21.9583C63.2693 18.7611 59.4903 17.1841 55.8843 17.5831C53.4371 17.8572 51.2447 18.963 49.4081 20.5737C45.6002 23.9104 43.403 28.9106 41.8404 33.6175C41.4318 34.8532 41.0567 36.1032 40.7202 37.3677C40.7202 33.1031 40.7202 28.8385 40.7202 24.5738C40.7202 20.7852 40.7202 17.0014 40.7202 13.2128C40.7202 10.4867 40.7202 7.7654 40.7202 5.03931C40.7202 3.92868 40.7346 2.81806 40.725 1.70262C44.3742 1.70262 48.0186 1.70262 51.6678 1.70262C57.3219 1.70262 62.9712 1.70262 68.6253 1.70262C74.1448 1.70262 79.6691 1.70262 85.1885 1.70262C90.2753 1.70262 95.3621 1.70262 100.449 1.70262C104.795 1.70262 109.142 1.70262 113.488 1.70262C116.801 1.70262 120.118 1.70262 123.431 1.70262C125.378 1.70262 127.32 1.70262 129.267 1.70262C129.638 1.70262 130.008 1.70262 130.378 1.70262C132.979 1.71705 135.441 2.73632 137.229 4.64025C138.903 6.41918 139.725 8.7414 139.734 11.1598C139.734 11.8233 139.734 12.4868 139.734 13.1503C139.734 16.3042 139.734 19.463 139.734 22.617C139.734 24.0882 139.734 25.5643 139.734 27.0355C140.22 27.2807 140.701 27.5355 141.177 27.8C141.177 26.1316 141.177 24.4585 141.177 22.7901C141.177 19.5784 141.177 16.3619 141.177 13.1503C141.177 12.482 141.177 11.8137 141.177 11.1454C141.162 8.71736 140.417 6.36149 138.907 4.41909ZM29.9312 99.8032C25.1666 99.8032 20.3971 99.8032 15.6325 99.8032C11.7525 99.8032 17.4884 99.8032 13.6084 99.8032C10.9208 99.8032 17.849 99.8032 15.1613 99.8032C13.969 99.8032 12.7766 99.8128 11.5842 99.8032C6.36285 99.7696 2.23286 95.5867 2.21844 90.3797C2.21363 88.4469 2.21844 86.5141 2.21844 84.5766C2.21844 80.4995 2.21844 76.4223 2.21844 72.3452C2.21844 67.0421 2.21844 61.739 2.21844 56.4359C2.21844 52.1761 2.21844 47.9163 2.21844 43.6564C3.39637 43.6564 4.57912 43.6564 5.75706 43.6564C9.58896 43.6564 13.4161 43.6564 17.248 43.6564C22.9261 43.6564 9.37261 43.6564 15.0507 43.6564C21.9789 43.6564 28.9023 43.6564 35.8305 43.6564C35.8402 43.6564 35.8546 43.6564 35.8642 43.6564C35.8979 43.6613 35.9315 43.6709 35.9652 43.6757C34.4026 44.493 33.0035 45.6469 31.8063 46.9883C29.2485 49.8586 27.4744 53.354 26.032 56.8878C24.4839 60.6764 23.3348 64.6237 22.3924 68.6047C21.6087 71.9173 20.9789 75.2636 20.4693 78.6244C20.301 79.759 20.1423 80.8985 20.0029 82.038C19.9404 82.5572 19.8346 83.1005 19.825 83.6246C19.825 83.6486 19.8202 83.6727 19.8202 83.6967C19.7337 84.6198 21.176 84.615 21.2626 83.6967C21.2962 83.3554 21.3347 83.014 21.3731 82.6726C21.4212 82.2736 21.4693 81.8697 21.5174 81.4706C21.5943 80.8697 21.6232 80.6389 21.7145 79.9994C22.1616 76.8695 22.7194 73.754 23.3973 70.6625C24.2435 66.8161 25.2772 62.9987 26.6378 59.2966C27.9359 55.758 29.537 52.2386 31.8255 49.2192C33.6093 46.8633 35.9555 44.7911 38.8547 44.0843C38.9941 44.0988 39.1384 44.1036 39.2778 44.1132C39.2778 45.7287 39.2778 47.3393 39.2778 48.9548C39.2778 53.7819 39.2778 58.609 39.2778 63.4314C39.2778 67.9316 39.2778 72.4318 39.2778 76.9272C39.2778 80.7158 39.2778 84.4996 39.2778 88.2883C39.2778 91.0144 39.2778 93.7356 39.2778 96.4617C39.2778 97.5723 39.2634 98.683 39.273 99.7984C36.1575 99.8032 33.0468 99.8032 29.9312 99.8032ZM35.8546 42.2141C30.7342 41.1852 25.7772 38.7043 21.8251 35.4686C18.2769 32.5598 13.6565 27.2422 16.6902 22.4536C18.4836 19.6169 22.0943 18.4918 25.2868 19.1698C27.4119 19.6217 29.2533 20.8141 30.7678 22.343C34.0853 25.6893 36.0132 30.3097 37.4171 34.733C38.0181 36.6225 38.523 38.5408 38.9364 40.4784C39.0615 41.0554 39.1624 41.6323 39.2634 42.2093C38.1335 42.2141 36.994 42.2141 35.8546 42.2141ZM42.5135 36.3292C43.7876 31.8771 45.5281 27.2759 48.4801 23.6459C49.86 21.9487 51.5668 20.4102 53.6294 19.6121C56.3699 18.5543 59.6297 18.7851 62.0144 20.5929C64.0914 22.1699 65.1059 24.6989 64.5338 27.247C63.952 29.8385 62.2212 32.0598 60.3605 33.882C57.9854 36.209 55.1631 38.0648 52.187 39.5264C49.7494 40.7236 47.1435 41.6612 44.4752 42.2093C43.3693 42.2093 42.2635 42.2093 41.1529 42.2093C41.1433 42.2093 41.1289 42.2093 41.1192 42.2093C41.475 40.2284 41.9606 38.262 42.5135 36.3292ZM39.2778 3.67386C39.2778 6.08263 39.2778 8.49139 39.2778 10.905C39.2778 14.482 39.2778 18.0591 39.2778 21.641C39.2778 25.9874 39.2778 30.3337 39.2778 34.6849C39.2778 35.0936 39.2778 35.5022 39.2778 35.9061C39.2153 35.6945 39.1576 35.4782 39.0951 35.2618C37.6672 30.4876 35.6767 25.5691 32.2775 21.8381C30.6765 20.0833 28.686 18.6313 26.383 17.963C23.1088 17.0062 19.3538 17.6841 16.8297 20.0496C14.7575 21.9872 13.8824 24.7662 14.469 27.5307C15.0652 30.3481 16.9258 32.8194 18.9307 34.8099C21.3876 37.2475 24.33 39.2139 27.4263 40.7429C28.5369 41.291 29.6764 41.7814 30.8351 42.2189C27.1571 42.2189 23.4838 42.2189 19.8058 42.2189C13.7718 42.2189 17.3537 42.2189 11.3198 42.2189C6.98307 42.2189 12.2574 42.2189 7.92062 42.2189C6.02149 42.2189 4.11756 42.19 2.22324 42.2141C2.22324 41.3198 2.22324 40.4255 2.22324 39.5313C2.22324 34.5358 2.22324 29.5404 2.22324 24.545C2.22324 21.0833 2.22324 17.6216 2.22324 14.1599C2.22324 11.905 2.04054 9.57798 2.9252 7.44807C4.35315 3.99119 7.786 1.75551 11.4977 1.72185C11.7381 1.72185 11.9785 1.72185 12.2189 1.72185C13.9497 1.72185 15.6806 1.72185 17.4114 1.72185C20.5318 1.72185 14.0363 1.72185 17.1566 1.72185C21.3683 1.72185 15.9594 1.72185 20.1712 1.72185C25.1666 1.72185 30.162 1.72185 35.1574 1.72185C36.5325 1.72185 37.9027 1.72185 39.2778 1.72185C39.2778 2.37092 39.2778 3.0248 39.2778 3.67386Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M116.084 99.7539H114.166C113.767 99.7539 113.445 100.076 113.445 100.475C113.445 100.874 113.767 101.196 114.166 101.196H116.084C116.483 101.196 116.805 100.874 116.805 100.475C116.805 100.076 116.483 99.7539 116.084 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 81.4746C140.056 81.4746 139.734 81.7967 139.734 82.1958V84.1141C139.734 84.5132 140.056 84.8353 140.455 84.8353C140.854 84.8353 141.177 84.5132 141.177 84.1141V82.1958C141.177 81.7967 140.854 81.4746 140.455 81.4746Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M125.666 99.7539H123.748C123.349 99.7539 123.027 100.076 123.027 100.475C123.027 100.874 123.349 101.196 123.748 101.196H125.666C126.065 101.196 126.388 100.874 126.388 100.475C126.388 100.076 126.065 99.7539 125.666 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 67.1055C140.056 67.1055 139.734 67.4276 139.734 67.8267V69.745C139.734 70.1441 140.056 70.4662 140.455 70.4662C140.854 70.4662 141.177 70.1441 141.177 69.745V67.8267C141.177 67.4276 140.854 67.1055 140.455 67.1055Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 57.5195C140.056 57.5195 139.734 57.8417 139.734 58.2407V60.1591C139.734 60.5581 140.056 60.8803 140.455 60.8803C140.854 60.8803 141.177 60.5581 141.177 60.1591V58.2407C141.177 57.8417 140.854 57.5195 140.455 57.5195Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M120.877 99.7539H118.959C118.56 99.7539 118.238 100.076 118.238 100.475C118.238 100.874 118.56 101.196 118.959 101.196H120.877C121.276 101.196 121.599 100.874 121.599 100.475C121.599 100.076 121.276 99.7539 120.877 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M130.46 99.7539H128.541C128.142 99.7539 127.82 100.076 127.82 100.475C127.82 100.874 128.142 101.196 128.541 101.196H130.498C130.897 101.196 131.2 100.874 131.2 100.475C131.2 100.076 130.859 99.7539 130.46 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M134.767 98.6949C134.243 98.969 133.69 99.195 133.123 99.3632C132.743 99.4786 132.527 99.8777 132.638 100.262C132.729 100.575 133.017 100.777 133.33 100.777C133.397 100.777 133.469 100.767 133.537 100.748C134.19 100.551 134.83 100.291 135.436 99.9738C135.787 99.7863 135.921 99.3536 135.739 98.9978C135.556 98.6469 135.118 98.5074 134.767 98.6949Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.465 91.0572C140.071 91.0043 139.71 91.2832 139.657 91.6822C139.58 92.2688 139.451 92.8506 139.263 93.4131C139.138 93.7929 139.34 94.2016 139.72 94.3266C139.797 94.3506 139.874 94.3651 139.946 94.3651C140.249 94.3651 140.528 94.1727 140.628 93.8698C140.845 93.2208 140.999 92.5477 141.085 91.8698C141.138 91.4707 140.859 91.1101 140.465 91.0572Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M139.076 95.6059C138.749 95.3799 138.301 95.4568 138.071 95.7838C137.734 96.2694 137.345 96.7213 136.922 97.1348C136.638 97.4137 136.628 97.8704 136.907 98.1541C137.047 98.2983 137.239 98.3752 137.426 98.3752C137.609 98.3752 137.787 98.3079 137.926 98.1733C138.417 97.6973 138.864 97.1685 139.253 96.6107C139.479 96.2838 139.402 95.8319 139.076 95.6059Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 86.2637C140.056 86.2637 139.734 86.5858 139.734 86.9849V88.9032C139.734 89.3023 140.056 89.6244 140.455 89.6244C140.854 89.6244 141.177 89.3023 141.177 88.9032V86.9849C141.177 86.5906 140.854 86.2637 140.455 86.2637Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 71.8926C140.056 71.8926 139.734 72.2147 139.734 72.6138V74.5321C139.734 74.9312 140.056 75.2533 140.455 75.2533C140.854 75.2533 141.177 74.9312 141.177 74.5321V72.6138C141.177 72.2147 140.854 71.8926 140.455 71.8926Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 52.7324C140.056 52.7324 139.734 53.0546 139.734 53.4536V55.372C139.734 55.771 140.056 56.0931 140.455 56.0931C140.854 56.0931 141.177 55.771 141.177 55.372V53.4536C141.177 53.0546 140.854 52.7324 140.455 52.7324Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 76.6855C140.056 76.6855 139.734 77.0077 139.734 77.4067V79.3251C139.734 79.7241 140.056 80.0463 140.455 80.0463C140.854 80.0463 141.177 79.7241 141.177 79.3251V77.4067C141.177 77.0077 140.854 76.6855 140.455 76.6855Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 62.3105C140.056 62.3105 139.734 62.6327 139.734 63.0317V64.9501C139.734 65.3491 140.056 65.6713 140.455 65.6713C140.854 65.6713 141.177 65.3491 141.177 64.9501V63.0317C141.177 62.6327 140.854 62.3105 140.455 62.3105Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M96.9247 99.7539H95.0063C94.6073 99.7539 94.2852 100.076 94.2852 100.475C94.2852 100.874 94.6073 101.196 95.0063 101.196H96.9247C97.3238 101.196 97.6459 100.874 97.6459 100.475C97.6459 100.076 97.3238 99.7539 96.9247 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 33.5703C140.056 33.5703 139.734 33.8924 139.734 34.2915V36.2099C139.734 36.6089 140.056 36.931 140.455 36.931C140.854 36.931 141.177 36.6089 141.177 36.2099V34.2915C141.177 33.8924 140.854 33.5703 140.455 33.5703Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M111.296 99.7539H109.377C108.978 99.7539 108.656 100.076 108.656 100.475C108.656 100.874 108.978 101.196 109.377 101.196H111.296C111.695 101.196 112.017 100.874 112.017 100.475C112.017 100.076 111.695 99.7539 111.296 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M92.131 99.7539H90.2126C89.8136 99.7539 89.4915 100.076 89.4915 100.475C89.4915 100.874 89.8136 101.196 90.2126 101.196H92.131C92.53 101.196 92.8522 100.874 92.8522 100.475C92.8522 100.076 92.53 99.7539 92.131 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 28.7793C140.056 28.7793 139.734 29.1014 139.734 29.5005V31.4188C139.734 31.8179 140.056 32.14 140.455 32.14C140.854 32.14 141.177 31.8179 141.177 31.4188V29.5005C141.177 29.1014 140.854 28.7793 140.455 28.7793Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M87.3424 99.7539H85.4241C85.2029 99.7539 85.0106 99.8549 84.876 100.009C85.251 100.408 85.6356 100.807 86.0251 101.196H87.3424C87.7415 101.196 88.0636 100.874 88.0636 100.475C88.0636 100.076 87.7415 99.7539 87.3424 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 38.3574C140.056 38.3574 139.734 38.6796 139.734 39.0786V40.997C139.734 41.396 140.056 41.7182 140.455 41.7182C140.854 41.7182 141.177 41.396 141.177 40.997V39.0786C141.177 38.6796 140.854 38.3574 140.455 38.3574Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M106.506 99.7539H104.588C104.189 99.7539 103.867 100.076 103.867 100.475C103.867 100.874 104.189 101.196 104.588 101.196H106.506C106.906 101.196 107.228 100.874 107.228 100.475C107.228 100.076 106.901 99.7539 106.506 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M139.994 27.1738C140.071 27.2411 140.167 27.2892 140.268 27.3181C140.177 27.27 140.085 27.2219 139.994 27.1738Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M101.713 99.7539H99.7949C99.3959 99.7539 99.0737 100.076 99.0737 100.475C99.0737 100.874 99.3959 101.196 99.7949 101.196H101.713C102.112 101.196 102.434 100.874 102.434 100.475C102.434 100.076 102.112 99.7539 101.713 99.7539Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M140.455 47.9375C140.056 47.9375 139.734 48.2596 139.734 48.6587V50.577C139.734 50.9761 140.056 51.2982 140.455 51.2982C140.854 51.2982 141.177 50.9761 141.177 50.577V48.6587C141.177 48.2596 140.854 47.9375 140.455 47.9375Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M107.858 42.166H105.939C105.54 42.166 105.218 42.4881 105.218 42.8872C105.218 43.2863 105.54 43.6084 105.939 43.6084H107.858C108.257 43.6084 108.579 43.2863 108.579 42.8872C108.579 42.4881 108.257 42.166 107.858 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M103.069 42.166H101.151C100.752 42.166 100.43 42.4881 100.43 42.8872C100.43 43.2863 100.752 43.6084 101.151 43.6084H103.069C103.468 43.6084 103.79 43.2863 103.79 42.8872C103.79 42.4881 103.463 42.166 103.069 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M93.4823 42.166H91.564C91.1649 42.166 90.8428 42.4881 90.8428 42.8872C90.8428 43.2863 91.1649 43.6084 91.564 43.6084H93.4823C93.8814 43.6084 94.2035 43.2863 94.2035 42.8872C94.2035 42.4881 93.8766 42.166 93.4823 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M98.2755 42.166H96.3572C95.9581 42.166 95.636 42.4881 95.636 42.8872C95.636 43.2863 95.9581 43.6084 96.3572 43.6084H98.2755C98.6746 43.6084 98.9967 43.2863 98.9967 42.8872C98.9967 42.4881 98.6698 42.166 98.2755 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M88.6889 42.166H86.7705C86.3714 42.166 86.0493 42.4881 86.0493 42.8872C86.0493 43.2863 86.3714 43.6084 86.7705 43.6084H88.6889C89.0879 43.6084 89.41 43.2863 89.41 42.8872C89.41 42.4881 89.0879 42.166 88.6889 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M83.8952 42.166H81.9768C81.5777 42.166 81.2556 42.4881 81.2556 42.8872C81.2556 43.2863 81.5777 43.6084 81.9768 43.6084H83.8952C84.2942 43.6084 84.6163 43.2863 84.6163 42.8872C84.6163 42.4881 84.2942 42.166 83.8952 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M137.34 42.8872C137.34 42.4881 137.018 42.166 136.619 42.166H134.701C134.302 42.166 133.979 42.4881 133.979 42.8872C133.979 43.2863 134.302 43.6084 134.701 43.6084H136.619C137.018 43.6084 137.34 43.2863 137.34 42.8872Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M131.825 42.166H129.907C129.508 42.166 129.186 42.4881 129.186 42.8872C129.186 43.2863 129.508 43.6084 129.907 43.6084H131.825C132.224 43.6084 132.546 43.2863 132.546 42.8872C132.546 42.4881 132.224 42.166 131.825 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M127.032 42.166H125.114C124.714 42.166 124.392 42.4881 124.392 42.8872C124.392 43.2863 124.714 43.6084 125.114 43.6084H127.032C127.431 43.6084 127.753 43.2863 127.753 42.8872C127.753 42.4881 127.431 42.166 127.032 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M122.238 42.166H120.32C119.921 42.166 119.599 42.4881 119.599 42.8872C119.599 43.2863 119.921 43.6084 120.32 43.6084H122.238C122.637 43.6084 122.959 43.2863 122.959 42.8872C122.959 42.4881 122.637 42.166 122.238 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M117.445 42.166H115.526C115.127 42.166 114.805 42.4881 114.805 42.8872C114.805 43.2863 115.127 43.6084 115.526 43.6084H117.445C117.844 43.6084 118.166 43.2863 118.166 42.8872C118.166 42.4881 117.844 42.166 117.445 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M112.651 42.166H110.733C110.334 42.166 110.011 42.4881 110.011 42.8872C110.011 43.2863 110.334 43.6084 110.733 43.6084H112.651C113.05 43.6084 113.372 43.2863 113.372 42.8872C113.372 42.4881 113.05 42.166 112.651 42.166Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M141.177 42.8872C141.177 42.4881 140.855 42.166 140.455 42.166H139.494C139.095 42.166 138.773 42.4881 138.773 42.8872C138.773 43.2863 139.095 43.6084 139.494 43.6084H139.787C139.754 43.6901 139.734 43.7767 139.734 43.8728V45.7912C139.734 46.1902 140.056 46.5124 140.455 46.5124C140.855 46.5124 141.177 46.1902 141.177 45.7912V43.8728V42.8872Z", fill: "#313131" }));
const VoucherRedemptionSearchSVG = SvgVoucherRedemptionSearch;
const SvgGiftBox = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 51, height: 38, viewBox: "0 0 51 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.926285, y: 0.939957, width: 48.8466, height: 35.846, rx: 4.19904, fill: "#F2EFEE", stroke: "#313131", strokeWidth: 0.989289 }), /* @__PURE__ */ React$7.createElement("rect", { x: 0.926285, y: 0.939957, width: 48.8466, height: 35.846, rx: 4.19904, fill: "#F2EFEE", stroke: "#313131", strokeWidth: 0.989289 }), /* @__PURE__ */ React$7.createElement("path", { d: "M1.11035 16.7363L50.2679 16.7363", stroke: "#313131", strokeWidth: 1.0125 }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.3184 1.125L18.3184 36.5742", stroke: "#313131", strokeWidth: 0.989289 }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.4755 16.7385C17.5339 13.4901 13.2503 7.69974 10.7074 9.95911C7.24852 13.0324 17.2044 16.7385 18.4755 16.7385Z", fill: "#F2EFEE", stroke: "#313131", strokeWidth: 0.989289 }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.336 16.7385C19.2776 13.4901 23.5612 7.69974 26.1041 9.95911C29.563 13.0324 19.6071 16.7385 18.336 16.7385Z", fill: "#F2EFEE", stroke: "#313131", strokeWidth: 0.989289 }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.3358 16.7363C17.0371 17.117 13.7082 19.0931 10.7822 23.952", stroke: "#313131", strokeWidth: 0.989289, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.3361 16.7363C19.6348 17.117 22.9636 19.0931 25.8896 23.952", stroke: "#313131", strokeWidth: 0.989289, strokeLinecap: "round" }));
const GiftBoxSVG = SvgGiftBox;
const VoucherDetailTab = ({ voucherData }) => {
  const classes = useStyles$c();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanel }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowLabel }, "Issue date"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowData }, formatDate(voucherData == null ? void 0 : voucherData.issueDate, "DD/MM/YYYY"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowLabel }, "Expiry"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowData }, formatDate(voucherData == null ? void 0 : voucherData.expiryDate, "DD/MM/YYYY"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowLabel }, "Original amount"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowData }, formatCurrency(voucherData == null ? void 0 : voucherData.originalValue))), (voucherData == null ? void 0 : voucherData.menu) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowLabel }, "Menu"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowData }, voucherData == null ? void 0 : voucherData.menu)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowLabel }, "Purchaser"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowData }, combineNames([voucherData == null ? void 0 : voucherData.purchaserFirstName, voucherData == null ? void 0 : voucherData.purchaserLastName]))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowLabel }, "Recipient"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowData }, voucherData == null ? void 0 : voucherData.recipientName)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowLabel }, "Notes"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowData }, voucherData == null ? void 0 : voucherData.notes)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowLabel }, "Voucher type"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRowData }, capitaliseFirstLetter(voucherData == null ? void 0 : voucherData.voucherType))));
};
VoucherDetailTab.propTypes = {
  voucherData: PropTypes.instanceOf(Object).isRequired
};
const mapStateToProps$x = () => ({});
const mapDispatchToProps$w = (dispatch) => bindActionCreators({}, dispatch);
const VoucherDetailTab$1 = connect(mapStateToProps$x, mapDispatchToProps$w)(VoucherDetailTab);
const SvgCircleCheck = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 11.5, cy: 11.5, r: 11.5, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M7 12.2778L9.8 15L17 8", stroke: "white" }));
const CircleCheck = SvgCircleCheck;
const RedeemVoucherModal = ({
  isOpen,
  onClose,
  voucher,
  createRedemption,
  voucherRedemptions,
  onSuccess
}) => {
  const classes = useStyles$c();
  const theme2 = useTheme$1();
  const [redemptionType, setRedemptionType] = useState("full");
  const [takenBy, setTakenBy] = useState(null);
  const [amountToDeduct, setAmountToDeduct] = useState(null);
  const [notes, setNotes] = useState(null);
  const [error, setError] = useState(null);
  const [pending, setPending2] = useState(false);
  const currentBalance = voucher == null ? void 0 : voucher.balance;
  useEffect(() => {
    if (isOpen) {
      setAmountToDeduct(null);
      setRedemptionType("full");
      setNotes(null);
      setPending2(false);
      setTakenBy(null);
      setError(null);
    }
  }, [isOpen]);
  useEffect(() => {
    if (isOpen && pending && voucherRedemptions.success) {
      setPending2(false);
      onSuccess();
      onClose();
    }
  }, [voucherRedemptions.success]);
  useEffect(() => {
    if (pending && voucherRedemptions.error) {
      setPending2(false);
      setError(voucherRedemptions.error);
    }
  }, [voucherRedemptions.error]);
  const isValid = () => {
    if (redemptionType === "partial") {
      const amountToDeductAsFloat = roundToDecimals(amountToDeduct);
      const currentBalanceAsFloat = roundToDecimals(currentBalance);
      if (amountToDeductAsFloat > currentBalanceAsFloat || amountToDeductAsFloat <= 0) {
        return false;
      }
    }
    if (isEmpty(takenBy)) {
      return false;
    }
    return true;
  };
  const inputTextStyles = {
    textFieldInner: {
      padding: "0",
      margin: "0",
      backgroundColor: theme2.colors.white
    },
    label: {
      width: "180px"
    },
    input: {
      fontSize: "16px",
      textOverflow: "unset",
      resize: "none",
      height: "40px",
      maxWidth: "300px",
      width: "352px",
      padding: `0px 14px 0px 5px`
    }
  };
  const redeemVoucher = () => {
    if (isValid()) {
      setError(null);
      setPending2(true);
      const amountToDeductAsFloat = roundToDecimals(amountToDeduct);
      const currentBalanceAsFloat = roundToDecimals(currentBalance);
      const redemptionAmount = redemptionType === "full" ? currentBalanceAsFloat : amountToDeductAsFloat;
      const redemption = {
        gv_redeem_id: voucher == null ? void 0 : voucher.id,
        redemption_amount: redemptionAmount,
        redemption_taken_by: takenBy,
        redemption_notes: notes,
        gv_balance: currentBalanceAsFloat
        // voucherId: voucher?.id,
        // redemptionAmount,
        // balance: currentBalanceAsFloat,
        // redemptionTakenBy: takenBy,
        // redemptionNotes: notes,
      };
      createRedemption(redemption);
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    PromptModal$1,
    {
      onClose,
      isOpen,
      heading: "Redeem voucher",
      inputStyle: { maxWidth: "660px", maxHeight: "90dvh", minHeight: "min(350px, 90dvh)" },
      allowCancel: true,
      disableConfirm: !isValid(),
      loadingConfirm: (voucherRedemptions == null ? void 0 : voucherRedemptions.pending) || pending,
      onConfirm: () => {
        redeemVoucher();
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      ToggleGroup$2,
      {
        items: [
          { label: "Fully redeem", value: "full" },
          { label: "Partially redeem", value: "partial" }
        ],
        style: {
          groupContainer: {
            gap: "20px"
          },
          option: {
            width: "261px",
            height: "48px",
            background: theme2.colors.white,
            border: "1px solid #15221C",
            borderRadius: "12px",
            cursor: "pointer",
            fontSize: "15px",
            fontWeight: theme2.fontWeights.medium,
            textAlign: "center",
            justifyContent: "center"
          }
        },
        value: redemptionType,
        showCheckmark: true,
        icon: /* @__PURE__ */ React__default.createElement(CircleCheck, { style: { width: "21px", height: "21px" } }),
        onSelect: (value) => {
          setRedemptionType(value || "full");
        }
      }
    ), /* @__PURE__ */ React__default.createElement(Box, { style: { marginTop: "24px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        placeholder: "Empty",
        label: "Current balance",
        value: currentBalance,
        inputPrefix: "$",
        editable: false,
        style: {
          ...inputTextStyles,
          input: {
            ...inputTextStyles.input,
            paddingLeft: "25px"
          }
        }
      }
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        placeholder: "Enter amount to deduct",
        label: "Amount to deduct",
        value: redemptionType === "full" ? currentBalance : amountToDeduct,
        editable: redemptionType === "partial",
        inputPrefix: "$",
        type: "currency",
        onChange: setAmountToDeduct,
        validation: "numbers_only",
        style: {
          ...inputTextStyles,
          input: {
            ...inputTextStyles.input,
            paddingLeft: "25px"
          }
        }
      }
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.redeemVoucherNotesRow }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.redeemVoucherNotesRowLabel }, "Notes"), /* @__PURE__ */ React__default.createElement(
      InlineTextArea,
      {
        placeholder: "Empty",
        resizable: false,
        minRows: 2,
        style: {
          textFieldInner: {
            marginLeft: "15px",
            paddingLeft: "14px",
            paddingRight: "14px",
            width: "352px",
            minHeight: "72px",
            height: "72px"
            // maxHeight: '150px',
          },
          input: {
            height: "100%",
            resize: "none"
          }
        },
        onChange: setNotes,
        value: notes
      }
    ))), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.redeemVoucherTakenByLabel }, "Taken by"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailPanelRow }, /* @__PURE__ */ React__default.createElement(
      CleanTextFieldComponent,
      {
        placeholder: "Empty",
        style: inputTextStyles,
        label: "Staff name",
        value: takenBy,
        required: true,
        onChange: setTakenBy
      }
    )))),
    error && /* @__PURE__ */ React__default.createElement(Box, { className: classes.errorText }, error)
  );
};
RedeemVoucherModal.defaultProps = {
  onSuccess: () => {
  }
};
RedeemVoucherModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  voucher: PropTypes.instanceOf(Object).isRequired,
  createRedemption: PropTypes.func.isRequired,
  voucherRedemptions: voucherRedemptionsPropTypes.isRequired,
  onSuccess: PropTypes.func
};
const mapStateToProps$w = (state) => ({
  voucherRedemptions: state.voucherRedemptions
});
const mapDispatchToProps$v = (dispatch) => bindActionCreators(
  {
    createRedemption: createNewRedemption
  },
  dispatch
);
const RedeemVoucherModal$1 = connect(mapStateToProps$w, mapDispatchToProps$v)(RedeemVoucherModal);
const VoucherRedemptionDetailView = ({ voucherData, fetchVoucherRedemptions: fetchVoucherRedemptions2 }) => {
  const classes = useStyles$c();
  const [activeTab, setActiveTab] = useState("details");
  const [isShowRedeemVoucherModal, setShowRedeemVoucherModal] = useState(false);
  const [voucherHistory, setVoucherHistory] = useState({});
  const toggleActiveTab = (newTab) => {
    setActiveTab(newTab);
  };
  const getHistory = (id) => {
    fetchVoucherHistory(id).then((response) => {
      setVoucherHistory(response);
    });
  };
  useEffect(() => {
    if (!isEmpty(voucherData)) {
      setActiveTab("details");
      getHistory(voucherData == null ? void 0 : voucherData.id);
    }
  }, [voucherData == null ? void 0 : voucherData.id]);
  const toggleRedeemVoucher = () => {
    setShowRedeemVoucherModal(true);
  };
  const renderVoucherDetailPreview = (message, isGrayscale) => /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.voucherDetailPreview} ${isGrayscale ? classes.grayscale : ""}` }, /* @__PURE__ */ React__default.createElement(VoucherRedemptionSearchSVG, null), /* @__PURE__ */ React__default.createElement(Box, null, message));
  return /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.voucherRightPane}` }, !isEmpty(voucherData) ? /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", flexDirection: "column", width: "100%" } }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.voucherSummaryPanel}` }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.voucherLeftHeaderContent}` }, /* @__PURE__ */ React__default.createElement(Box, { item: true, xs: 12 }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherReferenceContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.voucherReference}` }, voucherData == null ? void 0 : voucherData.voucherRef), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailStatus }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherStatusHeaderText }, (voucherData == null ? void 0 : voucherData.voucherStatus) || "Active"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherNumber }, "#", voucherData == null ? void 0 : voucherData.voucherNumber)), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tabContainer}` }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: activeTab === "details" ? classes.activeTab : classes.inactiveTab,
      onClick: () => {
        toggleActiveTab("details");
      }
    },
    "Details"
  ), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: activeTab === "details" ? classes.inactiveTab : classes.activeTab,
      onClick: () => {
        toggleActiveTab("history");
      }
    },
    "History"
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherRightHeaderContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherBalanceContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherBalanceHeaderText }, "Balance"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherBalanceAmountContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherBalanceAmountText }, formatCurrency(voucherData == null ? void 0 : voucherData.balance)), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(GiftBoxSVG, null)))))), !isEmpty(voucherData) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherDetailContainer }, activeTab === "details" && /* @__PURE__ */ React__default.createElement(VoucherDetailTab$1, { voucherData }), activeTab === "history" && /* @__PURE__ */ React__default.createElement(VoucherRedemptionHistoryTab$1, { voucherHistory })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherRedeemContainer }, /* @__PURE__ */ React__default.createElement(Button, { className: classes.redeemButton, onClick: toggleRedeemVoucher }, "Redeem")), /* @__PURE__ */ React__default.createElement(
    RedeemVoucherModal$1,
    {
      onClose: () => setShowRedeemVoucherModal(false),
      isOpen: isShowRedeemVoucherModal,
      voucher: voucherData,
      onSuccess: () => {
        fetchVoucherRedemptions2();
        getHistory(voucherData == null ? void 0 : voucherData.id);
      }
    }
  )) : renderVoucherDetailPreview("Type voucher code or number", 0));
};
VoucherRedemptionDetailView.propTypes = {
  voucherData: PropTypes.instanceOf(Object).isRequired,
  fetchVoucherRedemptions: PropTypes.func.isRequired
};
const mapStateToProps$v = () => ({});
const mapDispatchToProps$u = (dispatch) => bindActionCreators(
  {
    fetchVoucherRedemptions: fetchVoucherRedemptionListingAction
  },
  dispatch
);
const VoucherRedemptionDetailView$1 = connect(mapStateToProps$v, mapDispatchToProps$u)(VoucherRedemptionDetailView);
const VoucherRedemption = ({ voucherRedemptions }) => {
  const classes = useStyles$c();
  const [voucherData, setVoucherData] = useState({});
  const viewVoucherDetails = (voucher) => {
    setVoucherData(voucher);
  };
  useEffect(() => {
    if (!isEmpty(voucherData == null ? void 0 : voucherData.id)) {
      const newVoucherData = findObjectByProperty(voucherRedemptions.data, voucherData == null ? void 0 : voucherData.id, "id");
      setVoucherData(newVoucherData);
    }
  }, [voucherRedemptions.data]);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherGridContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherLeftContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherLeftPane }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, /* @__PURE__ */ React__default.createElement(VoucherRedemptionSearchBox$1, null)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherListingContainer }, /* @__PURE__ */ React__default.createElement(
    VoucherRedemptionListing$1,
    {
      voucherRedemptions,
      viewVoucherDetails,
      activeVoucher: voucherData
    }
  )))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.voucherRightContainer }, /* @__PURE__ */ React__default.createElement(VoucherRedemptionDetailView$1, { voucherData })));
};
VoucherRedemption.propTypes = {
  voucherRedemptions: voucherRedemptionsPropTypes.isRequired
};
const mapStateToProps$u = (state) => ({
  voucherRedemptions: state.voucherRedemptions
});
const mapDispatchToProps$t = (dispatch) => bindActionCreators({}, dispatch);
const VoucherRedemptionScreen = connect(mapStateToProps$u, mapDispatchToProps$t)(VoucherRedemption);
const Loading = ({ loading }) => {
  const { loadingIds } = loading;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, loadingIds.length > 0 && /* @__PURE__ */ React__default.createElement(Box, { style: { marginTop: "-4px" } }, /* @__PURE__ */ React__default.createElement(LinearProgress, null)));
};
Loading.propTypes = {
  loading: PropTypes.shape({
    loadingIds: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};
const mapStateToProps$t = (state) => ({
  loading: state.loading
});
const Loading$1 = connect(mapStateToProps$t, null)(Loading);
const fetchPaymentSettingsAction = (data) => (dispatch) => {
  const action = "FETCH_PAYMENT_SETTINGS";
  const entityName = "fetchPaymentSettings";
  const request = () => fetchPaymentSettings(data);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const isSameDay = (date1, date2) => {
  return formatDate(date1, "YYYY-MM-DD") === formatDate(date2, "YYYY-MM-DD");
};
const useStyles$b = createUseStyles(
  (theme2) => ({
    modalBody: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      "@media print": {
        display: "none"
      }
    },
    heading: {
      ...theme2.typography.heading.H3
    },
    modalBodyInner: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      overflowY: "scroll"
    },
    subheading: {},
    content: {
      // padding: '20px',
      display: "flex",
      flexDirection: "column",
      maxWidth: "332px",
      // 350px - 4px borders - 10px scrollbar
      gap: "16px",
      overflowY: "auto",
      overflowX: "hidden",
      flex: 1,
      padding: "12px 6px 12px 16px"
    },
    contentTop: {
      display: "flex",
      flexDirection: "column",
      gap: "20px"
    },
    sectionHeading: {
      fontWeight: theme2.fontWeights.medium,
      color: theme2.colors.charcoal
    },
    interactiveItem: {
      height: "36px",
      maxWidth: "310px",
      display: "flex",
      gap: "16px",
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "6px",
      padding: "5px 10px",
      marginLeft: "-10px",
      marginRight: "-10px",
      border: `1px solid transparent`,
      alignItems: "center",
      transition: "background-color 0.1s",
      "&:hover": {
        backgroundColor: theme2.colors.notificationBackgroundGray
      }
    },
    activeItem: {
      backgroundColor: theme2.colors.notificationBackgroundGray,
      border: `1px solid ${theme2.colors.smoke}`
    },
    disabledItem: {
      backgroundColor: theme2.colors.white,
      color: theme2.colors.nimbus,
      "&:hover": {
        backgroundColor: theme2.colors.white,
        cursor: "default"
      }
    },
    itemIcon: {
      width: "28px",
      height: "28px",
      borderRadius: "100%",
      border: `1px solid ${theme2.colors.shark}`,
      backgroundColor: "white",
      alignItems: "center",
      justifyContent: "center",
      color: "black",
      display: "flex"
    },
    subSection: {
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    section: {
      display: "flex",
      flexDirection: "column",
      gap: "4px"
    },
    formSection: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      // padding: '20px 6px 20px 16px',
      // TODO this style class should pretty much match the booking details styles
      // padding: '20px 0 20px 0',
      paddingBottom: "20px",
      "&:not(:last-child)": {
        borderBottom: `1px solid ${theme2.colors.cloud}`
      }
    },
    description: {
      color: theme2.colors.smoke
    },
    availabilityCardContainer: {
      position: "relative",
      backgroundColor: theme2.colors.availableBackground,
      borderRadius: "8px"
      // cursor: 'pointer',
    },
    leftBar: {
      position: "absolute",
      backgroundColor: theme2.colors.pillAvailable,
      height: "100%",
      width: "7px",
      borderRadius: "8px"
    },
    availabilityCardContent: {
      height: "36px",
      padding: "6px 20px",
      display: "flex",
      gap: "8px",
      justifyContent: "space-between",
      color: theme2.colors.bodyText,
      alignItems: "center"
    },
    availabilityCardTableInfo: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      fontSize: theme2.typography.body.PL,
      lineHeight: "16px"
    },
    tableNumber: {
      border: `1px solid ${theme2.colors.smoke}`,
      borderRadius: "6px",
      padding: "2px 8px",
      alignItems: "center",
      height: "fit-content",
      color: theme2.colors.smoke,
      background: theme2.colors.white
    },
    editIcon: {
      cursor: "pointer"
    },
    unavailableCardContainer: {
      borderBottom: "1px solid #EBEBEB",
      // TODO use theme
      display: "flex",
      gap: "10px",
      justifyContent: "space-between",
      padding: "13px 0",
      cursor: "pointer"
    },
    nextAvailable: {
      fontWeight: "bold",
      fontSize: "14px",
      lineHeight: "22px",
      paddingBottom: "6px",
      borderBottom: `1px solid ${theme2.colors.nimbus}`
    },
    footer: {
      borderTop: `1px solid ${theme2.colors.shark}`,
      padding: "8px 16px",
      position: "sticky",
      bottom: 0,
      background: theme2.colors.white,
      zIndex: 1,
      borderRadius: "0 0 8px 8px"
    },
    footerButtons: {
      display: "flex",
      gap: "8px"
    },
    footerHeading: {
      fontWeight: theme2.fontWeights.medium,
      marginBottom: "10px"
    },
    addPlaceholderText: {
      color: theme2.colors.smoke,
      cursor: "pointer",
      userSelect: "none",
      height: "36px",
      // To prevent jank when changing to text field
      lineHeight: "36px",
      alignItems: "center",
      transition: "color 0.1s",
      width: "fit-content",
      "&:hover": {
        color: theme2.colors.charcoal
      }
    },
    selectDate: {
      fontWeight: theme2.fontWeights.medium,
      display: "flex",
      gap: "8px",
      padding: "10px 20px",
      cursor: "pointer",
      userSelect: "none",
      alignItems: "center",
      borderRadius: "8px",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: theme2.colors.notificationBackgroundGray
      }
    },
    incrementButton: {
      cursor: "pointer",
      userSelect: "none",
      width: "26px",
      height: "26px",
      backgroundColor: "white",
      outline: "1px solid #E8E8E8",
      // TODO
      borderRadius: "6px",
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      transition: "background-color 0.01s, outline 0.01s"
    },
    guestsLabel: {
      display: "flex",
      gap: "8px",
      alignItems: "center"
    },
    guestsText: {
      width: "80px"
    },
    guestsForPhone: {
      position: "absolute",
      maxHeight: "500px",
      width: "310px",
      backgroundColor: theme2.colors.white,
      borderRadius: "6px",
      zIndex: 1,
      marginTop: "10px",
      boxShadow: "0 4px 14px 0 rgba(202,202,202,0.5)",
      padding: "10px"
    },
    guestForPhone: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      width: "100%",
      cursor: "pointer",
      userSelect: "none",
      padding: "10px",
      borderRadius: "6px",
      transition: "background-color 0.1s",
      "&:hover": {
        backgroundColor: theme2.colors.notificationBackgroundGray
      }
    },
    guestNameAndPhone: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      flexWrap: "wrap"
    },
    guestTags: {
      display: "flex",
      flexWrap: "wrap",
      "& > div": {
        marginRight: "5px"
      }
    },
    guestCustomerName: {
      fontWeight: theme2.fontWeights.medium,
      maxWidth: "250px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      padding: "5px 0"
    },
    guestPhoneNumber: {
      // TODO highlight selected text
      textAlign: "right",
      maxWidth: "150px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      padding: "5px 0"
    },
    // guestPastVisits: {
    //   ...theme.typography.body.PS,
    //   color: theme.colors.nimbus,
    //   paddingTop: '8px',
    // },
    addDetailsHeader: {
      padding: "8px 16px 8px 12px",
      display: "flex",
      justifyContent: "space-between",
      borderBottom: `1px solid ${theme2.colors.shark}`,
      position: "sticky",
      top: "0",
      background: theme2.colors.white,
      zIndex: 1,
      alignItems: "center",
      height: "36px"
    },
    headerDetail: {
      display: "flex",
      gap: "4px",
      alignItems: "center",
      fontSize: "12px"
    },
    editButton: {
      fontWeight: theme2.fontWeights.regular,
      color: theme2.colors.olive3,
      "&:hover": {
        cursor: "pointer"
      }
    },
    backButton: {
      flexShrink: 0,
      height: "24px",
      color: theme2.colors.cloud,
      transition: "color 0.1s",
      "&:hover": {
        color: theme2.colors.shark,
        cursor: "pointer"
      }
    }
  }),
  { name: "AddBookingModal" }
);
const iconButtonStyles = (theme2) => ({
  button: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px"
  },
  buttonHover: {
    backgroundColor: theme2.colors.notificationBackgroundGray,
    outline: "1px solid black"
  },
  text: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
const AddBookingFooter = ({
  isAvailableTable,
  isCreatedTable,
  showAddDetails,
  showAddWaitlist,
  showForceBooking,
  addWalkin,
  obeeSettings: obeeSettings2
}) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$b();
  const largeButtonStyle = largeButtonStyles(theme2);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.footer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.footerButtons }, !isAvailableTable && !isCreatedTable ? /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "tertiary",
      style: largeButtonStyle,
      onClick: () => showForceBooking("phone")
    },
    "Force booking"
  ) : /* @__PURE__ */ React__default.createElement(Button, { type: "tertiary", style: largeButtonStyle, onClick: addWalkin }, "Add walk-in"), !isAvailableTable && !isCreatedTable ? ((_a = obeeSettings2.data) == null ? void 0 : _a.waitlist) && /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "primary",
      style: largeButtonStyle,
      onClick: () => showAddWaitlist("phone")
    },
    "Add to waitlist"
  ) : /* @__PURE__ */ React__default.createElement(Button, { type: "primary", style: largeButtonStyle, onClick: () => showAddDetails("phone") }, "Add details")));
};
AddBookingFooter.propTypes = {
  isAvailableTable: PropTypes.bool.isRequired,
  isCreatedTable: PropTypes.bool.isRequired,
  showAddDetails: PropTypes.func.isRequired,
  showAddWaitlist: PropTypes.func.isRequired,
  showForceBooking: PropTypes.func.isRequired,
  addWalkin: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$s = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$s = (dispatch) => bindActionCreators({}, dispatch);
const AddBookingFooter$1 = connect(mapStateToProps$s, mapDispatchToProps$s)(AddBookingFooter);
const SvgDate = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M0.5 4.05554H15.5V13.1111C15.5 13.9395 14.8284 14.6111 14 14.6111H2C1.17157 14.6111 0.5 13.9395 0.5 13.1111V4.05554Z", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M0.5 3.94446H15.5V2.00001C15.5 1.17159 14.8284 0.500013 14 0.500013H2C1.17157 0.500013 0.5 1.17159 0.5 2.00001V3.94446Z", stroke: "currentColor" }));
const DateIconSVG = SvgDate;
const SvgAreas = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 0.5, width: 6, height: 6, rx: 0.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 9.5, y: 0.5, width: 6, height: 6, rx: 0.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 9.5, width: 6, height: 6, rx: 0.5, stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 9.5, y: 9.5, width: 6, height: 6, rx: 0.5, stroke: "currentColor" }));
const AreaIconSVG = SvgAreas;
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function assertString(input) {
  var isString = typeof input === "string" || input instanceof String;
  if (!isString) {
    var invalidType = _typeof$1(input);
    if (input === null)
      invalidType = "null";
    else if (invalidType === "object")
      invalidType = input.constructor.name;
    throw new TypeError("Expected a string but received a ".concat(invalidType));
  }
}
var phones = {
  "am-AM": /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
  "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
  "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
  "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
  "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
  "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
  "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
  "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
  "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
  "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
  "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
  "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
  "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
  "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
  "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
  "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
  "ar-TN": /^(\+?216)?[2459]\d{7}$/,
  "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
  "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
  "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
  "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
  "ca-AD": /^(\+376)?[346]\d{5}$/,
  "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
  "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
  "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
  "de-LU": /^(\+352)?((6\d1)\d{6})$/,
  "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
  "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
  "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
  "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
  "en-AU": /^(\+?61|0)4\d{8}$/,
  "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
  "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
  "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
  "en-GB": /^(\+?44|0)7\d{9}$/,
  "en-GG": /^(\+?44|0)1481\d{6}$/,
  "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
  "en-GY": /^(\+592|0)6\d{6}$/,
  "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
  "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
  "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
  "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
  "en-JM": /^(\+?876)?\d{7}$/,
  "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
  "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
  "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
  "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
  "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
  "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
  "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
  "en-MU": /^(\+?230|0)?\d{8}$/,
  "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
  "en-NG": /^(\+?234|0)?[789]\d{9}$/,
  "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
  "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
  "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
  "en-PH": /^(09|\+639)\d{9}$/,
  "en-RW": /^(\+?250|0)?[7]\d{8}$/,
  "en-SG": /^(\+65)?[3689]\d{7}$/,
  "en-SL": /^(\+?232|0)\d{8}$/,
  "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
  "en-UG": /^(\+?256|0)?[7]\d{8}$/,
  "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  "en-ZA": /^(\+?27|0)\d{9}$/,
  "en-ZM": /^(\+?26)?09[567]\d{7}$/,
  "en-ZW": /^(\+263)[0-9]{9}$/,
  "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
  "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
  "es-BO": /^(\+?591)?(6|7)\d{7}$/,
  "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
  "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
  "es-CR": /^(\+506)?[2-8]\d{7}$/,
  "es-CU": /^(\+53|0053)?5\d{7}$/,
  "es-DO": /^(\+?1)?8[024]9\d{7}$/,
  "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
  "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
  "es-ES": /^(\+?34)?[6|7]\d{8}$/,
  "es-PE": /^(\+?51)?9\d{8}$/,
  "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
  "es-NI": /^(\+?505)\d{7,8}$/,
  "es-PA": /^(\+?507)\d{7,8}$/,
  "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
  "es-SV": /^(\+?503)?[67]\d{7}$/,
  "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
  "es-VE": /^(\+?58)?(2|4)\d{9}$/,
  "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
  "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
  "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "fr-BF": /^(\+226|0)[67]\d{7}$/,
  "fr-BJ": /^(\+229)\d{8}$/,
  "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
  "fr-CM": /^(\+?237)6[0-9]{8}$/,
  "fr-FR": /^(\+?33|0)[67]\d{8}$/,
  "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
  "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
  "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
  "fr-PF": /^(\+?689)?8[789]\d{6}$/,
  "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
  "fr-WF": /^(\+681)?\d{6}$/,
  "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
  "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  "ir-IR": /^(\+98|0)?9\d{9}$/,
  "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
  "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
  "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
  "kk-KZ": /^(\+?7|8)?7\d{9}$/,
  "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  "ky-KG": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
  "lt-LT": /^(\+370|8)\d{8}$/,
  "lv-LV": /^(\+?371)2\d{7}$/,
  "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
  "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
  "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
  "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
  "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
  "nb-NO": /^(\+?47)?[49]\d{7}$/,
  "ne-NP": /^(\+?977)?9[78]\d{8}$/,
  "nl-BE": /^(\+?32|0)4\d{8}$/,
  "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
  "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
  "nn-NO": /^(\+?47)?[49]\d{7}$/,
  "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
  "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
  "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
  "pt-AO": /^(\+244)\d{9}$/,
  "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
  "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
  "ru-RU": /^(\+?7|8)?9\d{9}$/,
  "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
  "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
  "sq-AL": /^(\+355|0)6[789]\d{6}$/,
  "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
  "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
  "th-TH": /^(\+66|66|0)\d{9}$/,
  "tr-TR": /^(\+?90|0)?5\d{9}$/,
  "tk-TM": /^(\+993|993|8)\d{8}$/,
  "uk-UA": /^(\+?38|8)?0\d{9}$/,
  "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
  "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
  "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
  "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
  "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
  "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
  "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
  "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
phones["en-CA"] = phones["en-US"];
phones["fr-CA"] = phones["en-CA"];
phones["fr-BE"] = phones["nl-BE"];
phones["zh-HK"] = phones["en-HK"];
phones["zh-MO"] = phones["en-MO"];
phones["ga-IE"] = phones["en-IE"];
phones["fr-CH"] = phones["de-CH"];
phones["it-CH"] = phones["fr-CH"];
function isMobilePhone(str, locale, options) {
  assertString(str);
  if (options && options.strictMode && !str.startsWith("+")) {
    return false;
  }
  if (Array.isArray(locale)) {
    return locale.some(function(key2) {
      if (phones.hasOwnProperty(key2)) {
        var phone2 = phones[key2];
        if (phone2.test(str)) {
          return true;
        }
      }
      return false;
    });
  } else if (locale in phones) {
    return phones[locale].test(str);
  } else if (!locale || locale === "any") {
    for (var key in phones) {
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];
        if (phone.test(str)) {
          return true;
        }
      }
    }
    return false;
  }
  throw new Error("Invalid locale '".concat(locale, "'"));
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function isByteLength(str, options) {
  assertString(str);
  var min;
  var max;
  if (_typeof(options) === "object") {
    min = options.min || 0;
    max = options.max;
  } else {
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === "undefined" || len <= max);
}
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : void 0;
  for (var key in defaults) {
    if (typeof obj[key] === "undefined") {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_numeric_tld: false,
  allow_wildcard: false,
  ignore_max_length: false
};
function isFQDN(str, options) {
  assertString(str);
  options = merge(options, default_fqdn_options);
  if (options.allow_trailing_dot && str[str.length - 1] === ".") {
    str = str.substring(0, str.length - 1);
  }
  if (options.allow_wildcard === true && str.indexOf("*.") === 0) {
    str = str.substring(2);
  }
  var parts = str.split(".");
  var tld = parts[parts.length - 1];
  if (options.require_tld) {
    if (parts.length < 2) {
      return false;
    }
    if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    if (/\s/.test(tld)) {
      return false;
    }
  }
  if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
    return false;
  }
  return parts.every(function(part) {
    if (part.length > 63 && !options.ignore_max_length) {
      return false;
    }
    if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (/^-|-$/.test(part)) {
      return false;
    }
    if (!options.allow_underscores && /_/.test(part)) {
      return false;
    }
    return true;
  });
}
var IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
var IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
var IPv6AddressRegExp = new RegExp("^(" + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
function isIP(str) {
  var version2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  assertString(str);
  version2 = String(version2);
  if (!version2) {
    return isIP(str, 4) || isIP(str, 6);
  }
  if (version2 === "4") {
    return IPv4AddressRegExp.test(str);
  }
  if (version2 === "6") {
    return IPv6AddressRegExp.test(str);
  }
  return false;
}
var default_email_options = {
  allow_display_name: false,
  allow_underscores: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true,
  blacklisted_chars: "",
  ignore_max_length: false,
  host_blacklist: [],
  host_whitelist: []
};
var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var defaultMaxEmailLength = 254;
function validateDisplayName(display_name) {
  var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1");
  if (!display_name_without_quotes.trim()) {
    return false;
  }
  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
  if (contains_illegal) {
    if (display_name_without_quotes === display_name) {
      return false;
    }
    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
    if (!all_start_with_back_slash) {
      return false;
    }
  }
  return true;
}
function isEmail(str, options) {
  assertString(str);
  options = merge(options, default_email_options);
  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(splitNameAddress);
    if (display_email) {
      var display_name = display_email[1];
      str = str.replace(display_name, "").replace(/(^<|>$)/g, "");
      if (display_name.endsWith(" ")) {
        display_name = display_name.slice(0, -1);
      }
      if (!validateDisplayName(display_name)) {
        return false;
      }
    } else if (options.require_display_name) {
      return false;
    }
  }
  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
    return false;
  }
  var parts = str.split("@");
  var domain = parts.pop();
  var lower_domain = domain.toLowerCase();
  if (options.host_blacklist.includes(lower_domain)) {
    return false;
  }
  if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) {
    return false;
  }
  var user = parts.join("@");
  if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
    user = user.toLowerCase();
    var username = user.split("+")[0];
    if (!isByteLength(username.replace(/\./g, ""), {
      min: 6,
      max: 30
    })) {
      return false;
    }
    var _user_parts = username.split(".");
    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }
  if (options.ignore_max_length === false && (!isByteLength(user, {
    max: 64
  }) || !isByteLength(domain, {
    max: 254
  }))) {
    return false;
  }
  if (!isFQDN(domain, {
    require_tld: options.require_tld,
    ignore_max_length: options.ignore_max_length,
    allow_underscores: options.allow_underscores
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }
    if (!isIP(domain)) {
      if (!domain.startsWith("[") || !domain.endsWith("]")) {
        return false;
      }
      var noBracketdomain = domain.slice(1, -1);
      if (noBracketdomain.length === 0 || !isIP(noBracketdomain)) {
        return false;
      }
    }
  }
  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }
  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split(".");
  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }
  if (options.blacklisted_chars) {
    if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1)
      return false;
  }
  return true;
}
const useStyles$a = createUseStyles((theme2) => ({
  interactiveItem: {
    display: "flex",
    cursor: "pointer",
    userSelect: "none",
    // borderRadius: '8px',
    // border: `1px solid ${theme.colors.smoke}`,
    transition: "background-color 0.1s",
    width: "100%",
    // justifyContent: 'stretch',
    // alignItems: 'stretch',
    flexGrow: 1,
    height: "36px",
    maxWidth: "230px",
    overflow: "hidden",
    gap: "16px",
    borderRadius: "6px",
    padding: "8px 10px",
    border: `1px solid transparent`,
    "&:hover": {
      backgroundColor: theme2.colors.notificationBackgroundGray
    }
  },
  buttonContent: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "8px",
    padding: "0 8px",
    whiteSpace: "nowrap",
    flexGrow: 1,
    width: "100%",
    overflow: "hidden"
  },
  tableNumber: {
    height: "24px",
    border: `1px solid ${theme2.colors.shark}`,
    borderRadius: "8px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    userSelect: "none",
    maxWidth: "100px",
    // flexGrow: 1,
    flexShrink: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  areaName: {
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}));
const TableSelector = ({
  value,
  onSelectTable,
  onSelectArea,
  error,
  required,
  clearError,
  time,
  date,
  guestAmount,
  fromForceBooking
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$a();
  const [anchor, setAnchor] = useState(null);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "10px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { width: "100px", flexShrink: 0, color: theme2.colors.smoke } }, "Table", required && "*"), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.interactiveItem,
      style: {
        border: error && `1px solid ${theme2.colors.red}` || !isEmpty(anchor) && `1px solid ${theme2.colors.smoke}`,
        color: isEmpty(value) && theme2.colors.nimbus,
        backgroundColor: !isEmpty(anchor) && theme2.colors.notificationBackgroundGray
      },
      onClick: (e) => setAnchor(e.currentTarget)
    },
    !isEmpty(value) ? value : "Empty"
  )), error && /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "10px", color: theme2.colors.red, margin: "4px 0 0 110px" } }, error)), /* @__PURE__ */ React__default.createElement(
    TableSelectorPopover$1,
    {
      anchorEl: anchor,
      setAnchorEl: setAnchor,
      areaId: "all",
      setTable: (table) => onSelectTable(table),
      clearError,
      time,
      setAreaId: (areaId) => onSelectArea(areaId),
      date,
      guestAmount,
      fromForceBooking
    }
  ));
};
TableSelector.defaultProps = {
  value: null,
  onSelectTable: () => {
  },
  onSelectArea: () => {
  },
  style: {},
  error: null,
  required: false,
  clearError: () => {
  },
  fromForceBooking: false
};
TableSelector.propTypes = {
  value: PropTypes.string,
  onSelectTable: PropTypes.func,
  onSelectArea: PropTypes.func,
  style: PropTypes.shape({}),
  error: PropTypes.string,
  required: PropTypes.bool,
  clearError: PropTypes.func,
  time: PropTypes.number.isRequired,
  fromForceBooking: PropTypes.bool
};
const mapStateToProps$r = () => ({});
const mapDispatchToProps$r = (dispatch) => bindActionCreators({}, dispatch);
const TableSelector$1 = connect(mapStateToProps$r, mapDispatchToProps$r)(TableSelector);
const SvgLeftArrowInCircle = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 12.625, cy: 12, r: 12, fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.375 18L5.375 12L11.375 6", stroke: "#6E6E6D", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M5.625 12.0278H19.875", stroke: "#6E6E6D", strokeLinecap: "round" }));
const IconBackButton = SvgLeftArrowInCircle;
const ForceConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      onClose,
      isOpen,
      onConfirm: () => {
        onConfirm();
        onClose();
      },
      heading: "Force booking confirmation",
      confirmLabel: "Confirm",
      prompt: "Are you sure you want to force this booking?"
    }
  );
};
ForceConfirmationModal.defaultProps = {
  onConfirm: () => {
  }
};
ForceConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func
};
const ForceConfirmationModal$1 = ForceConfirmationModal;
const usePinPayments = (pinMode) => {
  const [pinPaymentFields, setPinPaymentFields] = useState(null);
  const onLoad = () => {
    setPinPaymentFields(
      window.HostedFields.create({
        // Set this to true when testing. Set it to false in production.
        sandbox: pinMode === "test",
        // Optional: set autocomplete to true to allow web browsers to suggest saved credit cards.
        autocomplete: false,
        // These are the CSS styles for the input elements inside the iframes. Inside each iframe is a single input with its id set to name, number, cvc or expiry.
        // When the input has a valid value, it will have the 'hosted-fields-valid' class. When the input has an invalid value, it will have the 'hosted-fields-invalid' class.
        styles: {
          input: {
            "font-size": "15px",
            "font-family": "Inter, 'Open Sans', 'Helvetica', 'sans-serif' !important",
            height: "36px",
            color: "#3a3a3a"
          },
          "input:focus": {
            outline: `1px solid #6E6E6D`
          },
          ".hosted-fields-invalid:not(:focus)": {
            "font-family": "Inter, 'Open Sans', 'Helvetica', 'sans-serif' !important",
            color: "red"
          },
          ".pin-form-field": {
            height: "36px",
            border: "1px solid black"
          }
        },
        // The fields object defines the fields to be created. All four fields are required (name, number, cvc, expiry).
        // Each field requires a selector for the element in which to create an iframe. Optionally, you can define placeholder text and a label selector (the CSS selector of the label element for that particular field).
        fields: {
          name: {
            selector: "#name",
            placeholder: "Empty"
          },
          number: {
            selector: "#number",
            // placeholder: '4200 0000 0000 0000',
            placeholder: "Empty"
          },
          cvc: {
            selector: "#cvc",
            // placeholder: '123',
            placeholder: "000"
          },
          expiry: {
            selector: "#expiry",
            placeholder: "MM/YYYY"
            // placeholder: 'Empty',
          }
        }
      })
    );
  };
  useEffect(() => {
    var _a;
    if (pinPaymentFields || !isObee()) {
      return;
    }
    const injectScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", resolve);
        script.addEventListener("error", (e) => reject(e.error));
        document.head.appendChild(script);
      });
    };
    injectScript((_a = window.bookingsConfig) == null ? void 0 : _a.pinPaymentsUrl).then(() => {
      onLoad();
    });
  }, [pinMode]);
  return pinPaymentFields;
};
const useStyles$9 = createUseStyles((theme2) => ({
  container: {},
  innerContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center"
  },
  label: {
    color: theme2.colors.smoke,
    width: "100px",
    flexShrink: 0,
    marginBottom: 0
  },
  placeholder: {
    color: theme2.colors.nimbus
  },
  // Displayed at the bottom
  error: {
    fontSize: "10px",
    color: theme2.colors.red
  },
  errorText: {
    fontSize: "10px",
    color: theme2.colors.red,
    margin: "4px 0 0 110px"
  },
  valueField: (props) => ({
    width: "100%",
    // padding: '0 12px',
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    border: "1px solid transparent",
    color: (props == null ? void 0 : props.disabled) ? theme2.colors.nimbus : theme2.colors.charcoal,
    padding: "0px 12px",
    borderRadius: "6px",
    transition: "background-color 0.1s",
    height: "36px",
    "&:hover": {
      backgroundColor: theme2.colors.yetAnotherGray12
    },
    "&:has(> a.active)": {
      outline: `1px solid ${theme2.colors.smoke}`
    }
  })
}));
const PinField = ({ label, id, error }) => {
  const classes = useStyles$9();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.innerContainer }, label && /* @__PURE__ */ React__default.createElement(Box, { className: classes.label }, label), /* @__PURE__ */ React__default.createElement(Box, { className: classes.valueField }, /* @__PURE__ */ React__default.createElement("div", { id }))), error && /* @__PURE__ */ React__default.createElement(Box, { className: classes.errorText }, error));
};
PinField.defaultProps = {
  label: "",
  id: ""
};
PinField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string
};
const PinPaymentsFields = ({ paymentRef, paymentSettings }) => {
  const classes = useStyles$9();
  const [errorMessages, setErrorMessages] = useState([]);
  const [cardNameError, setCardNameError] = useState(null);
  const [cardNumberError, setCardNumberError] = useState(null);
  const [cardCVVError, setCardCVVError] = useState(null);
  const [cardExpiryError, setCardExpiryError] = useState(null);
  const [visible, setVisible] = useState(false);
  const pinPaymentFields = usePinPayments(paymentSettings.data.pinMode);
  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 1e3);
  }, []);
  const handlePaymentError = (errorResponse) => {
    var _a;
    if (errorResponse.error === "unauthenticated") {
      setErrorMessages(["Cannot process payment. API key is missing or not valid."]);
    } else {
      const messages = [];
      let numberError = null;
      let nameError = null;
      let cvvError = null;
      let expiryError = null;
      (_a = errorResponse == null ? void 0 : errorResponse.messages) == null ? void 0 : _a.forEach((message) => {
        if (message.code.includes("number")) {
          numberError = message.message;
        } else if (message.code.includes("name")) {
          nameError = message.message;
        } else if (message.code.includes("cvc")) {
          cvvError = message.message;
        } else if (message.code.includes("expiry")) {
          expiryError = message.message;
        } else {
          messages.push(message.message);
        }
      });
      setCardNumberError(numberError);
      setCardNameError(nameError);
      setCardCVVError(cvvError);
      setCardExpiryError(expiryError);
      setErrorMessages(messages);
    }
  };
  const handlePaymentClicked = async (pinFields) => {
    if (!pinFields) {
      handlePaymentError({
        messages: [{ code: "", message: "Credit card details are not valid" }]
      });
      return {
        valid: false
      };
    }
    setErrorMessages([]);
    setCardCVVError(null);
    setCardNameError(null);
    setCardNumberError(null);
    setCardExpiryError(null);
    const pinResponse = await new Promise((resolve) => {
      var _a;
      pinFields == null ? void 0 : pinFields.tokenize(
        { publishable_api_key: (_a = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _a.publishableKey },
        (error, response) => {
          let valid = true;
          devLog("debug", "pin payments response", error, response);
          if (error) {
            handlePaymentError(error);
            valid = false;
          }
          resolve({
            valid,
            response,
            token: response == null ? void 0 : response.token,
            // This was the result of the intent in stripe
            cardNumber: response == null ? void 0 : response.display_number
            // card number
          });
        }
      );
    });
    return pinResponse;
  };
  useImperativeHandle(
    paymentRef,
    () => ({
      submit: async () => handlePaymentClicked(pinPaymentFields)
    }),
    [handlePaymentClicked, pinPaymentFields]
  );
  return /* @__PURE__ */ React__default.createElement(Box, { style: { position: "relative" } }, !visible && /* @__PURE__ */ React__default.createElement(
    Spinner,
    {
      style: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    Spacer,
    {
      direction: "vertical",
      gap: 4,
      style: { opacity: visible ? "100" : "0", transition: "opacity 0.5s" }
    },
    /* @__PURE__ */ React__default.createElement(PinField, { id: "name", label: "Card name", error: cardNameError }),
    /* @__PURE__ */ React__default.createElement(PinField, { id: "number", label: "Card no", error: cardNumberError }),
    /* @__PURE__ */ React__default.createElement(PinField, { id: "expiry", label: "Expiry", error: cardExpiryError }),
    /* @__PURE__ */ React__default.createElement(PinField, { id: "cvc", label: "CVC", error: cardCVVError }),
    /* @__PURE__ */ React__default.createElement(Box, null, errorMessages.map((message) => /* @__PURE__ */ React__default.createElement(Box, { key: message, className: classes.errorText }, message)))
  ));
};
PinPaymentsFields.defaultProps = {
  paymentRef: null
};
PinPaymentsFields.propTypes = {
  paymentRef: PropTypes.shape({}),
  paymentSettings: paymentSettingPropTypes.isRequired
};
const mapStateToProps$q = (state) => ({
  paymentSettings: state.paymentSettings
});
const mapDispatchToProps$q = (dispatch) => bindActionCreators({}, dispatch);
const PinPaymentsFields$1 = connect(mapStateToProps$q, mapDispatchToProps$q)(PinPaymentsFields);
const createPaymentSetupIntentAction = async (name2, phone, email, userId, stripeId, stripe2, card) => {
  var _a, _b2;
  const response = await createPaymentSetupIntent({
    name: name2,
    phone,
    email,
    userId,
    stripeId
  });
  if (response.error) {
    throw new Error((response == null ? void 0 : response.error) || ((_a = response == null ? void 0 : response.error) == null ? void 0 : _a.message));
  }
  devLog("success", "createPaymentSetupIntent", response, response.data);
  const parsedResponse = JSON.parse(response.data);
  const { secret, setupIntentId } = parsedResponse;
  const result = await stripe2.confirmCardSetup(secret, {
    payment_method: {
      card,
      billing_details: {
        name: name2
      }
    }
  });
  if (result.error) {
    throw new Error((_b2 = result == null ? void 0 : result.error) == null ? void 0 : _b2.message);
  }
  return { paymentMethodId: result.setupIntent.payment_method, setupIntentId };
};
const lookupPaymentMethodNameAction = async (paymentMethodId) => {
  const response = await lookupPaymentMethodName({ paymentMethodId });
  devLog("success", "lookupPaymentMethodName", response.data);
  const parsedResponse = JSON.parse(response.data);
  const { paymentMethodName } = parsedResponse;
  return paymentMethodName;
};
const createPaymentMethodAction = async (name2, phone, email, userId, stripeId, stripe2, card) => {
  try {
    const { paymentMethodId, setupIntentId } = await createPaymentSetupIntentAction(
      name2,
      phone,
      email,
      userId,
      stripeId,
      stripe2,
      card
    );
    const paymentMethodName = await lookupPaymentMethodNameAction(paymentMethodId);
    return [paymentMethodId, paymentMethodName, setupIntentId];
  } catch (error) {
    throw new Error(error);
  }
};
const StripeInput = forwardRef(({ component: Component, ...props }, ref) => {
  const theme2 = useTheme$1();
  const elementRef = useRef();
  useImperativeHandle(ref, () => ({
    focus: () => {
      var _a;
      return (_a = elementRef.current) == null ? void 0 : _a.focus;
    }
  }));
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      onReady: (element) => elementRef.current = element,
      options: {
        placeholder: "Empty",
        disableLink: true,
        style: {
          base: {
            fontSize: "15px",
            fontFamily,
            color: theme2.colors.charcoal,
            "::placeholder": {
              color: theme2.colors.nimbus
            }
          }
        }
      },
      ...props
    }
  );
});
const StripeTextField = ({ label, component, onChange, error, required }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$q();
  const inputRef = useRef(null);
  return /* @__PURE__ */ React__default.createElement(Box$1, null, /* @__PURE__ */ React__default.createElement(Box$1, { style: { alignItems: "center", display: "flex", gap: "10px" } }, /* @__PURE__ */ React__default.createElement(
    Box$1,
    {
      style: {
        color: theme2.colors.smoke,
        flexShrink: 0,
        width: "100px",
        whiteSpace: "nowrap"
      }
    },
    label,
    required ? "*" : ""
  ), /* @__PURE__ */ React__default.createElement(
    TextField$3,
    {
      fullWidth: true,
      variant: "standard",
      error,
      InputProps: {
        disableUnderline: true,
        inputComponent: StripeInput,
        inputProps: {
          component,
          inputRef,
          onChange
        },
        classes: { input: classes.stripeTextFieldInput },
        className: `${classes.stripeTextField} ${error && classes.stripeTextFieldError}`
      }
    }
  )), error && /* @__PURE__ */ React__default.createElement(Box$1, { className: classes.stripeTextFieldErrorText }, error));
};
const mapStateToProps$p = () => ({});
const mapDispatchToProps$p = (dispatch) => bindActionCreators({}, dispatch);
const StripeTextField$1 = connect(mapStateToProps$p, mapDispatchToProps$p)(StripeTextField);
const StripeFields = ({ paymentRef, phone, email }) => {
  const stripe2 = useStripe();
  const elements = useElements();
  const EMPTY_FIELD = "EMPTY_FIELD";
  const [cardName, setCardName] = useState(null);
  const [cardNameError, setCardNameError] = useState(null);
  const [cardNumberError, setCardNumberError] = useState(EMPTY_FIELD);
  const [cardCVVError, setCardCVVError] = useState(EMPTY_FIELD);
  const [cardExpiryError, setCardExpiryError] = useState(EMPTY_FIELD);
  const classes = useStyles$b();
  const requiredErrorMessage = "This field is required.";
  const handlePaymentClicked = async () => {
    let valid = true;
    if (!stripe2 || !elements) {
      throw new Error("stripe is undefined");
    }
    if (isEmpty(cardName)) {
      setCardNameError(requiredErrorMessage);
      valid = false;
    }
    const stripeFields = [
      { error: cardNumberError, setError: setCardNumberError },
      { error: cardExpiryError, setError: setCardExpiryError },
      { error: cardCVVError, setError: setCardCVVError }
    ];
    stripeFields.forEach((stripeField) => {
      if (!isEmpty(stripeField.error)) {
        valid = false;
      }
      if (stripeField.error === EMPTY_FIELD) {
        stripeField.setError(requiredErrorMessage);
        valid = false;
      }
    });
    if (!valid) {
      return { valid: false };
    }
    const [paymentMethodId, paymentMethodName, setupIntentId] = await createPaymentMethodAction(
      cardName,
      phone,
      email,
      null,
      null,
      stripe2,
      elements.getElement(CardNumberElement)
    );
    return { valid, token: paymentMethodId, cardNumber: paymentMethodName, setupIntentId };
  };
  useImperativeHandle(paymentRef, () => ({
    submit: async () => handlePaymentClicked()
  }));
  const textFieldStyles2 = {
    input: { fontSize: "inherit", padding: "8px 10px", paddingLeft: "10px" }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Card name",
      value: cardName,
      onChange: setCardName,
      error: cardNameError,
      clearError: () => setCardNameError(""),
      required: true,
      style: textFieldStyles2
    }
  ), /* @__PURE__ */ React__default.createElement(
    StripeTextField$1,
    {
      label: "Card no.",
      component: CardNumberElement,
      onChange: (e) => {
        var _a;
        return setCardNumberError(((_a = e.error) == null ? void 0 : _a.message) || "");
      },
      error: cardNumberError === EMPTY_FIELD ? "" : cardNumberError,
      required: true
    }
  ), /* @__PURE__ */ React__default.createElement(
    StripeTextField$1,
    {
      label: "MM/YY",
      component: CardExpiryElement,
      onChange: (e) => {
        var _a;
        return setCardExpiryError(((_a = e.error) == null ? void 0 : _a.message) || "");
      },
      error: cardExpiryError === EMPTY_FIELD ? "" : cardExpiryError,
      required: true
    }
  ), /* @__PURE__ */ React__default.createElement(
    StripeTextField$1,
    {
      label: "CVV",
      component: CardCvcElement,
      onChange: (e) => {
        var _a;
        return setCardCVVError(((_a = e.error) == null ? void 0 : _a.message) || "");
      },
      error: cardCVVError === EMPTY_FIELD ? "" : cardCVVError,
      required: true
    }
  ));
};
StripeFields.defaultProps = {
  paymentRef: null,
  phone: null,
  email: null
};
StripeFields.propTypes = {
  paymentRef: PropTypes.shape({}),
  phone: PropTypes.string,
  email: PropTypes.string
};
const mapStateToProps$o = () => ({});
const mapDispatchToProps$o = (dispatch) => bindActionCreators({}, dispatch);
const StripeFields$1 = connect(mapStateToProps$o, mapDispatchToProps$o)(StripeFields);
const CardFields = ({ paymentRef, showCardFields, setShowCardFields, phone, email }) => {
  const classes = useStyles$b();
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, showCardFields ? /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, isObee() ? /* @__PURE__ */ React__default.createElement(PinPaymentsFields$1, { paymentRef }) : /* @__PURE__ */ React__default.createElement(StripeFields$1, { paymentRef, phone, email })) : /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "text",
      className: classes.addPlaceholderText,
      onClick: () => setShowCardFields(true)
    },
    "+ Add credit card details"
  ));
};
CardFields.defaultProps = {
  paymentRef: null,
  showCardFields: null,
  setShowCardFields: (e) => e,
  phone: null,
  email: null
};
CardFields.propTypes = {
  paymentRef: PropTypes.shape({}),
  showCardFields: PropTypes.bool,
  setShowCardFields: PropTypes.func,
  phone: PropTypes.string,
  email: PropTypes.string
};
const mapStateToProps$n = () => ({});
const mapDispatchToProps$n = (dispatch) => bindActionCreators({}, dispatch);
const CardFields$1 = connect(mapStateToProps$n, mapDispatchToProps$n)(CardFields);
const GuestsSearchBox = ({
  guestsLoading,
  guestsSearch,
  property,
  selectPastGuest,
  setFieldFocused
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$b();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestsForPhone }, guestsLoading && /* @__PURE__ */ React__default.createElement(Box, { style: { padding: "10px" } }, "Searching..."), !guestsLoading && (guestsSearch == null ? void 0 : guestsSearch.length) === 0 && /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestForPhone }, /* @__PURE__ */ React__default.createElement(Box, null, "Create new for ", /* @__PURE__ */ React__default.createElement("span", { style: { fontWeight: theme2.fontWeights.medium } }, property))), !guestsLoading && (guestsSearch == null ? void 0 : guestsSearch.map((guest, index) => /* @__PURE__ */ React__default.createElement(Fragment, { key: guest == null ? void 0 : guest.id }, index > 0 && /* @__PURE__ */ React__default.createElement(Divider, { style: { margin: "4px 0" } }), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      onMouseDown: (e) => e.preventDefault(),
      key: guest.phone,
      className: classes.guestForPhone,
      onClick: () => {
        selectPastGuest(guest);
        setFieldFocused(false);
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestNameAndPhone }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestCustomerName }, guest.firstName, " ", guest.lastName)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestPhoneNumber }, guest.mobile)),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestTags }, guest.blacklisted && /* @__PURE__ */ React__default.createElement(Tag$1, { type: "blacklist" }), guest.vip && /* @__PURE__ */ React__default.createElement(Tag$1, { type: "vip" }))
  )))));
};
const AddDetails = ({
  date,
  time,
  areaId,
  guestAmount,
  obeeSettings: obeeSettings2,
  source,
  createObeeBooking: createObeeBooking2,
  isWaitlist,
  isForced,
  onBack,
  creating,
  setCreating,
  table,
  setTable,
  setAreaId,
  duration,
  obeeStaff,
  paymentSettings,
  obeeBookings: obeeBookings2,
  resubmitBooking: resubmitBooking2,
  obeeAreas: obeeAreas2,
  obeeTables: obeeTables2,
  fetchPaymentSettings: fetchPaymentSettings2
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
  const theme2 = useTheme$1();
  const classes = useStyles$b();
  const [guestsSearch, setGuestsSearch] = useState([]);
  const [guestsLoading, setGuestsLoading] = useState(false);
  const [phoneFocused, setPhoneFocused] = useState(false);
  const [nameFocused, setNameFocused] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [phone, setPhone] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [email, setEmail] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [marketingPreferences, setMarketingPreferences] = useState([]);
  const [guest, setGuest] = useState(null);
  const [highchairs, setHighchairs] = useState(null);
  const [showChildrenField, setShowChildrenField] = useState(false);
  const [children, setChildren] = useState(null);
  const [staff, setStaff] = useState(null);
  const [staffError, setStaffError] = useState(null);
  const [bookingSource, setBookingSource] = useState(source);
  const [restaurantComments, setRestaurantComments] = useState(null);
  const [customerComments, setCustomerComments] = useState(null);
  const [showComments, setShowComments] = useState(null);
  const [forceWaitlist, setForceWaitlist] = useState(isWaitlist);
  const [quotedMins, setQuotedMins] = useState(null);
  const [forceTableError, setForceTableError] = useState(null);
  const [sendConfirmationEmail, setSendConfirmationEmail] = useState(
    (_b2 = (_a = obeeSettings2.data) == null ? void 0 : _a.addBookingSettings) == null ? void 0 : _b2.showConfirmationEmailOptionDefault
  );
  const [sendConfirmationSms, setSendConfirmationSms] = useState(
    (_d2 = (_c2 = obeeSettings2.data) == null ? void 0 : _c2.addBookingSettings) == null ? void 0 : _d2.showConfirmationSmsOptionDefault
  );
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [sourceAnchorEl, setSourceAnchorEl] = useState(null);
  const [staffAnchorEl, setStaffAnchorEl] = useState(null);
  const [waitlistAnchorEl, setWaitlistAnchorEl] = useState(null);
  const [quotedMinsAnchorEl, setQuotedMinsAnchorEl] = useState(null);
  const [chargeError, setChargeError] = useState(null);
  const [failedBookingId, setFailedBookingId] = useState(null);
  const paymentRef = useRef(null);
  const requireGuestDetails = bookingSource !== "walkin";
  const allowChildren = ((_e2 = obeeSettings2.data) == null ? void 0 : _e2.abKids) || ((_g = (_f = obeeSettings2.data) == null ? void 0 : _f.addBookingSettings) == null ? void 0 : _g.showChildren);
  const allowHighchairs = ((_h = obeeSettings2.data) == null ? void 0 : _h.abHighchairs) || ((_j = (_i = obeeSettings2.data) == null ? void 0 : _i.addBookingSettings) == null ? void 0 : _j.showHighChairs);
  const highchairCap = 4;
  useEffectAfterFirstRender(() => {
    var _a2;
    const getAreaIdToUse = () => {
      var _a3, _b3;
      if (!isVoid(table == null ? void 0 : table.areaId)) {
        return table == null ? void 0 : table.areaId;
      }
      if (!isVoid(areaId)) {
        return areaId;
      }
      return (_b3 = (_a3 = obeeAreas2 == null ? void 0 : obeeAreas2.data) == null ? void 0 : _a3[0]) == null ? void 0 : _b3.id;
    };
    if ((_a2 = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _a2.hasPaymentSettings) {
      fetchPaymentSettings2({
        date: formatDate(date, "YYYY-MM-DD"),
        time,
        size: guestAmount,
        public: 0,
        areaId: getAreaIdToUse()
      });
    }
  }, [
    guestAmount,
    time,
    areaId,
    table == null ? void 0 : table.areaId,
    obeeAreas2 == null ? void 0 : obeeAreas2.data,
    date,
    (_k = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _k.hasPaymentSettings
  ]);
  const isWaitlistBooking = forceWaitlist || isWaitlist;
  const requireCardCapture = () => {
    var _a2, _b3, _c3, _d3, _e3, _f2;
    if (!requireGuestDetails) {
      return false;
    }
    if (!isObee() && ((_a2 = obeeSettings2.data) == null ? void 0 : _a2.ccCapture) === false) {
      return false;
    }
    if (isWaitlistBooking && !isObee() && ((_b3 = obeeSettings2.data) == null ? void 0 : _b3.ccAddBookings) !== "off") {
      return obeeSettings2.data.ccWaitlistShow === "mandatory";
    }
    const payRequired = isObee() ? (_c3 = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _c3.staffPayRequired : ((_d3 = obeeSettings2.data) == null ? void 0 : _d3.ccAddBookings) === "mandatory";
    if (isWaitlistBooking || !requireGuestDetails || !payRequired) {
      return false;
    }
    if (isObee()) {
      return (_e3 = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _e3.publishableKey;
    }
    return (_f2 = obeeSettings2.data) == null ? void 0 : _f2.ccCapture;
  };
  const showCardCapture = () => {
    var _a2, _b3, _c3, _d3;
    if (!requireGuestDetails) {
      return false;
    }
    if (!isObee() && ((_a2 = obeeSettings2.data) == null ? void 0 : _a2.ccCapture) === false) {
      return false;
    }
    if (isWaitlistBooking && !isObee() && ((_b3 = obeeSettings2.data) == null ? void 0 : _b3.ccAddBookings) !== "off") {
      return obeeSettings2.data.ccWaitlistShow !== "off";
    }
    if (isObee()) {
      return (_c3 = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _c3.publishableKey;
    }
    return (_d3 = obeeSettings2.data) == null ? void 0 : _d3.ccCapture;
  };
  const [showCardFields, setShowCardFields] = useState(requireCardCapture());
  const emailRequired = isObee() && showCardFields;
  const showGuestsSearchPhone = phoneFocused && !isEmpty(phone);
  const showGuestsSearchName = nameFocused && !isEmpty(firstName);
  useEffect(() => {
    if (requireCardCapture()) {
      setShowCardFields(true);
    }
  }, [
    (_l = paymentSettings.data) == null ? void 0 : _l.publishableKey,
    (_m = obeeSettings2.data) == null ? void 0 : _m.ccCapture,
    (_n = obeeSettings2.data) == null ? void 0 : _n.ccAddBookings,
    requireGuestDetails
  ]);
  useEffect(() => {
    if (forceWaitlist) {
      setShowCardFields(requireCardCapture());
    }
  }, [forceWaitlist]);
  const minCharactersForSearch = 3;
  const debouncedFetchObeeGuests = useMemo(
    () => debounce$2((searchValue) => {
      if (!isEmpty(searchValue) && searchValue.length >= minCharactersForSearch) {
        fetchGuests({ search: `${searchValue}`, searchType: "all" }, { pageSize: "5" }).then(
          (response) => {
            if (response == null ? void 0 : response.error) {
              setPhoneError(`Server error: ${response.error}`);
              return;
            }
            setGuestsLoading(false);
            setGuestsSearch(response.data.slice(0, 5));
          }
        );
      } else {
        setGuestsSearch([]);
        setGuestsLoading(false);
      }
    }, 500),
    []
  );
  const clearErrors = () => {
    setChargeError(null);
  };
  useEffect(() => {
    if (showGuestsSearchPhone || showGuestsSearchName) {
      setGuestsLoading(true);
      debouncedFetchObeeGuests(showGuestsSearchPhone ? phone : firstName);
    }
  }, [phone, firstName, showGuestsSearchName, showGuestsSearchPhone]);
  const showChildren = () => {
    unstable_batchedUpdates(() => {
      setShowChildrenField(true);
      if (!children) {
        setChildren(1);
      }
      if (!highchairs) {
        if (highchairs > children) {
          setHighchairs(children);
        } else {
          setHighchairs(0);
        }
      }
    });
  };
  useEffect(() => {
    setStaffError(null);
  }, [staff]);
  useEffect(() => {
    setFirstNameError(null);
  }, [firstName]);
  useEffect(() => {
    var _a2, _b3, _c3, _d3;
    if (obeeBookings2 == null ? void 0 : obeeBookings2.error) {
      setChargeError((_b3 = (_a2 = obeeBookings2 == null ? void 0 : obeeBookings2.errorData) == null ? void 0 : _a2.errors) == null ? void 0 : _b3.charge_error);
      if (!failedBookingId) {
        setFailedBookingId((_d3 = (_c3 = obeeBookings2 == null ? void 0 : obeeBookings2.errorData) == null ? void 0 : _c3.extras) == null ? void 0 : _d3.booking_id);
      }
    }
  }, [obeeBookings2 == null ? void 0 : obeeBookings2.error]);
  useEffect(() => {
    setEmailError(null);
  }, [email]);
  useEffect(() => {
    clearErrors();
  }, [email, phone]);
  const area = findObjectByProperty(obeeAreas2.data, areaId, "id");
  const isCapacityArea = isAreaCapacityBased(area, obeeTables2.data);
  const getStaffItems = () => {
    var _a2, _b3;
    return (_b3 = (_a2 = obeeStaff.data) == null ? void 0 : _a2.map((obeeStaffMember) => (obeeStaffMember == null ? void 0 : obeeStaffMember.appearAs) || (obeeStaffMember == null ? void 0 : obeeStaffMember.fullName))) == null ? void 0 : _b3.sort(sortValues).map((staffName) => ({ label: staffName, value: staffName }));
  };
  const requiredErrorMsg = "This field is required.";
  const handleCreditCardCapture = () => {
    var _a2, _b3, _c3, _d3, _e3, _f2, _g2;
    if (isObee()) {
      return ((_a2 = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _a2.publishableKey) && showCardFields;
    }
    if ((_b3 = obeeSettings2.data) == null ? void 0 : _b3.ccCapture) {
      if ((isWaitlist || forceWaitlist) && showField((_c3 = obeeSettings2.data) == null ? void 0 : _c3.ccWaitlistShow)) {
        return ((_d3 = obeeSettings2.data) == null ? void 0 : _d3.ccWaitlistShow) === "optional" && showCardFields || ((_e3 = obeeSettings2.data) == null ? void 0 : _e3.ccWaitlistShow) === "mandatory";
      }
      return ((_f2 = obeeSettings2.data) == null ? void 0 : _f2.ccAddBookings) === "optional" && showCardFields || ((_g2 = obeeSettings2.data) == null ? void 0 : _g2.ccAddBookings) === "mandatory";
    }
    return false;
  };
  const createBooking = async () => {
    var _a2, _b3, _c3, _d3, _e3;
    setCreating(true);
    clearErrors();
    let valid = true;
    const hasStaff2 = isObee() || !isEmpty(obeeStaff.data);
    try {
      let fieldsRequired = [
        ...isForced && !isCapacityArea ? [{ field: table == null ? void 0 : table.tableNumber, fieldLabel: "tableNumber", setError: setForceTableError }] : [],
        ...((_a2 = obeeSettings2.data) == null ? void 0 : _a2.abTakenBy) === "mandatory" && hasStaff2 ? [
          {
            fieldLabel: "staff",
            field: staff,
            setError: setStaffError
          }
        ] : []
      ];
      if (requireGuestDetails) {
        fieldsRequired = [
          ...fieldsRequired,
          { field: phone, fieldLabel: "phone", setError: setPhoneError },
          { field: firstName, fieldLabel: "firstName", setError: setFirstNameError }
        ];
      }
      fieldsRequired.forEach((fieldRequired) => {
        if (isEmpty(fieldRequired.field)) {
          devLog(
            "debug",
            `Booking failed validation due missing required field ${fieldRequired.fieldLabel}`,
            fieldRequired
          );
          fieldRequired.setError(requiredErrorMsg);
          valid = false;
        }
      });
      if (requireGuestDetails && (isEmpty(phone) || !isMobilePhone(phone))) {
        devLog("debug", "Booking failed validation due to the phone number");
        setPhoneError("A valid phone number is required.");
        valid = false;
      }
      if (emailRequired && isEmpty(email)) {
        devLog(
          "debug",
          "Booking failed validation due to the email address missing for payment provider"
        );
        setEmailError("Our payment provider requires an email when using credit cards.");
        valid = false;
      }
      if (!isEmpty(email) && !isEmail(email)) {
        devLog("debug", "Booking failed validation due to the email address being invalid");
        setEmailError("Email address is not valid");
        valid = false;
      }
      let cardResponse = null;
      if (paymentRef.current && handleCreditCardCapture()) {
        cardResponse = await paymentRef.current.submit();
        if (!(cardResponse == null ? void 0 : cardResponse.valid)) {
          devLog("warning", "card response not valid", cardResponse);
          valid = false;
        }
      }
      const getFirstName = () => {
        if (isEmpty(firstName) && !requireGuestDetails) {
          return "Walk-in guest";
        }
        return trim(firstName);
      };
      if (valid) {
        let booking = {
          areaId: !forceWaitlist && areaId !== "all" ? areaId : null,
          date: formatDate(date, "YYYY-MM-DD"),
          time,
          size: guestAmount,
          name: combineNames([getFirstName(), lastName]),
          source: bookingSource,
          status: forceWaitlist || isWaitlist ? STATUS_TYPES.WAITING : STATUS_TYPES.BOOKED,
          // Would prefer seated but it's not a real status
          tableNumber: !forceWaitlist ? table == null ? void 0 : table.tableNumber : null,
          duration,
          highchairs,
          kids: children,
          staff,
          restaurantComments,
          customerComments,
          // force: isForced, // TODO get allen to add this to API
          sendConfirmationEmail: sendConfirmationEmail && !isEmpty(email),
          sendConfirmationSMS: sendConfirmationSms && !isEmpty(phone),
          quotedMins: forceWaitlist || isWaitlist ? quotedMins : null
        };
        devLog("info", "card response", cardResponse, paymentSettings);
        const sendPaymentMode = !!(cardResponse == null ? void 0 : cardResponse.token) || !!(cardResponse == null ? void 0 : cardResponse.setupIntentId);
        if (bookingSource !== "walkin") {
          const convertedGuest = convertDataForAPI({
            firstName: nullToEmpty(firstName),
            lastName: nullToEmpty(lastName),
            email: nullToEmpty(email),
            mobile: phone,
            marketingPreferences
          });
          booking = {
            ...booking,
            guests: [convertedGuest],
            ccMode: sendPaymentMode ? ((_b3 = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _b3.mode) || null : null,
            paymentSettingId: ((_c3 = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _c3.id) || null,
            cardToken: (cardResponse == null ? void 0 : cardResponse.token) || null,
            cardNumber: (cardResponse == null ? void 0 : cardResponse.cardNumber) || null,
            setupIntentId: (cardResponse == null ? void 0 : cardResponse.setupIntentId) || null,
            paymentMethodId: (cardResponse == null ? void 0 : cardResponse.paymentMethodId) || null,
            // TODO remove
            paymentMethodName: (cardResponse == null ? void 0 : cardResponse.paymentMethodName) || null,
            // TODO remove
            amount: !Number.isNaN((_d3 = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _d3.amount) ? ((_e3 = paymentSettings == null ? void 0 : paymentSettings.data) == null ? void 0 : _e3.amount) * 100 : null
          };
        }
        if (!isObee() || isEmpty(failedBookingId)) {
          createObeeBooking2(booking);
        } else {
          devLog("resubmitting ", booking, failedBookingId);
          resubmitBooking2(booking, failedBookingId);
        }
      } else {
        setCreating(false);
      }
    } catch (error) {
      devLog("error", "create booking", error);
      setCreating(false);
    }
  };
  const selectPastGuest = useCallback((guest2) => {
    unstable_batchedUpdates(() => {
      setPhone(guest2.mobile);
      setFirstName(guest2.firstName);
      setLastName(guest2.lastName);
      setEmail(guest2.email);
      setMarketingPreferences(guest2.marketingPreferences);
      setPhoneFocused(false);
      setNameFocused(false);
      setGuest(guest2);
    });
    document.activeElement.blur();
  }, []);
  const hasStaff = !isEmpty(obeeStaff.data);
  const textFieldStyles2 = {
    input: { fontSize: "inherit", padding: "8px 10px", paddingLeft: "10px", maxWidth: "310px" },
    label: { width: "90px" },
    innerContainer: { gap: "8px" }
  };
  const textAreaStyles2 = {
    ...textFieldStyles2,
    textArea: {
      borderColor: theme2.colors.smoke
    },
    textField: {
      borderColor: theme2.colors.smoke,
      maxWidth: "100%"
    },
    label: { width: "100%" }
  };
  const marketingPreferencesStyles = {
    ...multiSelectStyles,
    label: {
      width: "90px"
    }
  };
  const showConfirmationSmsOption = !isWaitlistBooking && ((_p = (_o = obeeSettings2.data) == null ? void 0 : _o.addBookingSettings) == null ? void 0 : _p.showConfirmationSmsOption) && ((_s = (_r = (_q = obeeSettings2.data) == null ? void 0 : _q.messaging) == null ? void 0 : _r.sms_confirmation) == null ? void 0 : _s.sms_confirmation_toggle);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.addDetailsHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerDetail }, /* @__PURE__ */ React__default.createElement(IconBackButton, { className: classes.backButton, onClick: onBack })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerDetail }, /* @__PURE__ */ React__default.createElement(DateIconSVG, { style: { width: "16px" } }), /* @__PURE__ */ React__default.createElement(Box, null, formatDate(date, "ddd, Do"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerDetail }, /* @__PURE__ */ React__default.createElement(TimeIconSVG, { style: { width: "18px" } }), /* @__PURE__ */ React__default.createElement(Box, null, formatTimeFromInt(time, "h:mma"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerDetail }, /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { width: "14px" } }), /* @__PURE__ */ React__default.createElement(Box, null, guestAmount + pluralise(" guest", guestAmount)))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, isForced ? "Force booking" : "Add details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.contentTop }, isForced && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.sectionHeading,
      style: { fontWeight: theme2.fontWeights.regular }
    },
    "Override rules and submit a booking"
  ), /* @__PURE__ */ React__default.createElement(
    TableSelector$1,
    {
      value: isCapacityArea && (area == null ? void 0 : area.name) || (table == null ? void 0 : table.tableNumber),
      onSelectTable: setTable,
      onSelectArea: setAreaId,
      error: forceTableError,
      required: true,
      clearError: () => setForceTableError(null),
      time,
      date,
      guestAmount,
      fromForceBooking: true
    }
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "Customer details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Phone",
      value: phone,
      onChange: setPhone,
      onFocus: () => setPhoneFocused(true),
      onBlur: () => setPhoneFocused(false),
      required: requireGuestDetails,
      error: phoneError,
      style: textFieldStyles2,
      clearError: () => setPhoneError(null),
      type: "tel"
    }
  ), showGuestsSearchPhone && /* @__PURE__ */ React__default.createElement(
    GuestsSearchBox,
    {
      guestsLoading,
      guestsSearch,
      property: phone,
      selectPastGuest,
      setFieldFocused: setPhoneFocused
    }
  )), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "First name",
      value: firstName,
      onChange: setFirstName,
      onFocus: () => setNameFocused(true),
      onBlur: () => setNameFocused(false),
      required: requireGuestDetails,
      error: firstNameError,
      style: textFieldStyles2,
      clearError: () => setFirstNameError(null)
    }
  ), isEmpty(phone) && showGuestsSearchName && /* @__PURE__ */ React__default.createElement(
    GuestsSearchBox,
    {
      guestsLoading,
      guestsSearch,
      property: firstName,
      selectPastGuest,
      setFieldFocused: setNameFocused
    }
  )), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Last name",
      value: lastName,
      onChange: setLastName,
      onBlur: () => {
        setLastName(trim(lastName));
      },
      style: textFieldStyles2
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Email",
      value: email,
      onChange: setEmail,
      onBlur: () => {
        setEmail(trim(email));
      },
      required: emailRequired,
      error: emailError,
      clearError: () => setEmailError(null),
      style: textFieldStyles2
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: "Marketing",
      items: marketingPreferenceOptions(),
      value: marketingPreferences,
      selectedItems: marketingPreferences,
      onSelect: (selectedItem) => setMarketingPreferences(toggleListItem(marketingPreferences, selectedItem)),
      style: marketingPreferencesStyles,
      multiselect: true
    }
  ))), ((guest == null ? void 0 : guest.vip) || (guest == null ? void 0 : guest.blacklisted)) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestTags }, (guest == null ? void 0 : guest.blacklisted) && /* @__PURE__ */ React__default.createElement(Tag$1, { type: "blacklist" }), (guest == null ? void 0 : guest.vip) && /* @__PURE__ */ React__default.createElement(Tag$1, { type: "vip" }))), (allowChildren || allowHighchairs) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.sectionHeading,
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline"
      }
    },
    "Kids & high chairs",
    showChildrenField && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.editButton,
        onClick: () => {
          unstable_batchedUpdates(() => {
            setChildren(null);
            setShowChildrenField(false);
            setHighchairs(null);
          });
        }
      },
      "Remove"
    )
  ), showChildrenField ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.description }, guestAmount, " total guests on the booking"), allowChildren && /* @__PURE__ */ React__default.createElement(
    NumberIncrement$1,
    {
      label: "Children",
      value: children,
      onChange: (newValue) => {
        setChildren(newValue);
        if (highchairs > newValue) {
          setHighchairs(newValue);
        }
      },
      min: 0,
      max: guestAmount,
      allowTyping: true,
      textIfNone: "None"
    }
  ), allowHighchairs && children > 0 && /* @__PURE__ */ React__default.createElement(
    NumberIncrement$1,
    {
      label: "High chairs",
      value: highchairs,
      onChange: setHighchairs,
      min: 0,
      max: Math.min(highchairCap, children || 0),
      allowTyping: true,
      textIfNone: "None"
    }
  )) : /* @__PURE__ */ React__default.createElement(Button, { type: "text", className: classes.addPlaceholderText, onClick: showChildren }, "+ Indicate number of children")), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.sectionHeading,
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline"
      }
    },
    "Comments",
    showComments && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.editButton,
        onClick: () => {
          unstable_batchedUpdates(() => {
            setRestaurantComments(null);
            setCustomerComments(null);
            setShowComments(false);
          });
        }
      },
      "Remove"
    )
  ), showComments ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Guest comments",
      value: customerComments,
      onChange: setCustomerComments,
      style: textAreaStyles2,
      resizable: true,
      placeholder: "Guest comments are shown to the guest in the confirmation email"
    }
  ), /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Restaurant comments",
      value: restaurantComments,
      onChange: setRestaurantComments,
      style: textAreaStyles2,
      resizable: true
    }
  )) : /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "text",
      className: classes.addPlaceholderText,
      style: { color: theme2.colors.smoke },
      onClick: () => setShowComments(true)
    },
    "+ Add comments"
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "Booking type"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Source",
      value: bookingSource,
      formatValue: resolveSource,
      onClick: (e) => {
        setSourceAnchorEl(e.currentTarget);
      },
      isActive: !!sourceAnchorEl
    }
  ), ((_t = obeeSettings2.data) == null ? void 0 : _t.waitlist) && /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Waitlist",
      value: forceWaitlist,
      onClick: (e) => {
        setWaitlistAnchorEl(e.currentTarget);
      },
      formatValue: (value) => value ? "Yes" : "No",
      isActive: !!waitlistAnchorEl
    }
  ), forceWaitlist && /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Quoted time",
      value: quotedMins,
      onClick: (e) => {
        setQuotedMinsAnchorEl(e.currentTarget);
      },
      formatValue: (value) => `${value} mins`,
      isActive: !!quotedMinsAnchorEl
    }
  ))), showCardCapture() && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.sectionHeading,
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline"
      }
    },
    "Credit card details",
    requireCardCapture() ? "*" : "",
    !requireCardCapture() && showCardFields && /* @__PURE__ */ React__default.createElement(Box, { className: classes.editButton, onClick: () => setShowCardFields(false) }, "Remove")
  ), /* @__PURE__ */ React__default.createElement(
    CardFields$1,
    {
      paymentRef,
      showCardFields: showCardFields || requireCardCapture(),
      setShowCardFields,
      phone,
      email
    }
  )), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (!!((_v = (_u = obeeSettings2.data) == null ? void 0 : _u.addBookingSettings) == null ? void 0 : _v.showConfirmationEmailOption) || !!showConfirmationSmsOption) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.sectionHeading }, "Confirmation"), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        display: "flex",
        gap: "6px",
        flexDirection: "column"
      }
    },
    !!((_x = (_w = obeeSettings2.data) == null ? void 0 : _w.addBookingSettings) == null ? void 0 : _x.showConfirmationEmailOption) && /* @__PURE__ */ React__default.createElement(
      Checkbox,
      {
        color: theme2.colors.charcoal,
        label: "Send confirmation email",
        onChange: setSendConfirmationEmail,
        selected: sendConfirmationEmail,
        style: {
          label: { color: theme2.colors.smoke, lineHeight: 0 },
          checkboxBox: { height: "24px", width: "24px" }
        }
      }
    ),
    !!showConfirmationSmsOption && /* @__PURE__ */ React__default.createElement(
      Checkbox,
      {
        color: theme2.colors.charcoal,
        label: "Send confirmation SMS",
        onChange: setSendConfirmationSms,
        selected: sendConfirmationSms,
        style: {
          label: { color: theme2.colors.smoke, lineHeight: 0 },
          checkboxBox: { height: "24px", width: "24px" }
        }
      }
    )
  )))), !isEmpty(chargeError) && chargeError.map((error) => /* @__PURE__ */ React__default.createElement(Box, { style: { color: "red" } }, error))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.footer }, /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 12 }, showField((_y = obeeSettings2.data) == null ? void 0 : _y.abTakenBy) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, isObee() ? /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Staff name",
      value: staff,
      onChange: setStaff,
      error: staffError,
      required: ((_z = obeeSettings2.data) == null ? void 0 : _z.abTakenBy) === "mandatory"
    }
  ) : hasStaff && /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Staff name",
      value: staff,
      onClick: (e) => {
        setStaffAnchorEl(e.currentTarget);
      },
      isActive: !!staffAnchorEl,
      error: staffError,
      required: ((_A = obeeSettings2.data) == null ? void 0 : _A.abTakenBy) === "mandatory"
    }
  )), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "primary",
      style: largeButtonStyles(theme2),
      color: theme2.colors.submitButton,
      disabled: creating,
      loading: creating,
      onClick: () => {
        if (isForced) {
          setOpenConfirmation(true);
        } else {
          createBooking();
        }
      }
    },
    forceWaitlist || isWaitlist ? "Add to waitlist" : "Submit booking"
  ))), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: getStaffItems(),
      onSelect: setStaff,
      anchor: staffAnchorEl,
      isOpen: !!staffAnchorEl,
      onClose: () => setStaffAnchorEl(null),
      style: listPopoverStyles$2,
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: [
        { label: "Walk-in", value: "walkin" },
        { label: "Phone", value: "phone" },
        { label: "Email", value: "email" }
      ],
      onSelect: (newValue) => {
        setBookingSource(newValue);
        if (newValue === "walkin") {
          setShowCardFields(false);
        }
      },
      anchor: sourceAnchorEl,
      isOpen: !!sourceAnchorEl,
      onClose: () => setSourceAnchorEl(null),
      style: listPopoverStyles$2,
      ...popoverAnchors$3
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: [
        { label: "Yes", value: true },
        { label: "No", value: false }
      ],
      onSelect: (newValue) => {
        setForceWaitlist(newValue);
      },
      anchor: waitlistAnchorEl,
      isOpen: !!waitlistAnchorEl,
      onClose: () => setWaitlistAnchorEl(null),
      style: listPopoverStyles$2,
      ...popoverAnchors$3
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: [
        { label: "-", value: null },
        ...numberRange(5, 120, 5, true).map((minutes) => ({
          label: `${minutes} mins`,
          value: minutes
        }))
      ],
      onSelect: (newValue) => {
        setQuotedMins(newValue);
      },
      anchor: quotedMinsAnchorEl,
      isOpen: !!quotedMinsAnchorEl,
      onClose: () => setQuotedMinsAnchorEl(null),
      style: listPopoverStyles$2,
      ...popoverAnchors$3
    }
  ), /* @__PURE__ */ React__default.createElement(
    ForceConfirmationModal$1,
    {
      isOpen: openConfirmation,
      onClose: () => setOpenConfirmation(false),
      onConfirm: () => createBooking()
    }
  ));
};
GuestsSearchBox.defaultProps = {
  guestsLoading: false,
  guestsSearch: [],
  property: null,
  selectPastGuest: null,
  setFieldFocused: null
};
GuestsSearchBox.propTypes = {
  guestsLoading: PropTypes.bool,
  guestsSearch: PropTypes.arrayOf(PropTypes.shape({})),
  property: PropTypes.string,
  selectPastGuest: PropTypes.func,
  setFieldFocused: PropTypes.func
};
AddDetails.defaultProps = {
  time: null,
  areaId: null,
  date: null,
  guestAmount: 2,
  source: null,
  table: null
};
AddDetails.propTypes = {
  time: PropTypes.number,
  date: PropTypes.shape({}),
  guestAmount: PropTypes.number,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  createObeeBooking: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  areaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  source: PropTypes.string,
  isWaitlist: PropTypes.bool.isRequired,
  isForced: PropTypes.bool.isRequired,
  creating: PropTypes.bool.isRequired,
  setCreating: PropTypes.func.isRequired,
  table: PropTypes.shape({
    tableNumber: PropTypes.string
  }),
  setTable: PropTypes.func.isRequired,
  setAreaId: PropTypes.func.isRequired,
  duration: PropTypes.number.isRequired,
  obeeStaff: obeeStaffPropTypes.isRequired,
  obeeGuests: obeeGuestsPropTypes.isRequired,
  paymentSettings: paymentSettingsPropTypes.isRequired,
  obeeBookings: obeeBookingsPropTypes.isRequired
};
const mapStateToProps$m = (state) => ({
  obeeSettings: state.obeeSettings,
  obeeStaff: state.obeeStaff,
  obeeGuests: state.obeeGuests,
  paymentSettings: state.paymentSettings,
  obeeBookings: state.obeeBookings,
  obeeAreas: state.areas,
  obeeTables: state.tables
});
const mapDispatchToProps$m = (dispatch) => bindActionCreators(
  {
    createObeeBooking: createObeeBookingAction,
    resubmitBooking: resubmitBookingAction,
    fetchPaymentSettings: fetchPaymentSettingsAction
  },
  dispatch
);
const AddDetails$1 = connect(mapStateToProps$m, mapDispatchToProps$m)(AddDetails);
const SvgComms = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M13.8789 27.751C21.3348 27.751 27.3789 21.7068 27.3789 14.251C27.3789 6.79513 21.3348 0.750977 13.8789 0.750977C6.42306 0.750977 0.378906 6.79513 0.378906 14.251C0.378906 21.7068 6.42306 27.751 13.8789 27.751Z", fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M15.1234 16.186L15.3484 10.876V8.50598H12.7684V10.876L12.9934 16.186H15.1234ZM12.6334 18.976C12.6334 18.166 13.2934 17.506 14.0734 17.506C14.8834 17.506 15.5434 18.166 15.5434 18.976C15.5434 19.771 14.8834 20.416 14.0734 20.416C13.2934 20.416 12.6334 19.771 12.6334 18.976Z", fill: "white" }));
const IconComms = SvgComms;
const AvailabilityCard = ({ table, hasConflicts, areaId, areas }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$b();
  const areaForTable = findObjectByProperty(areas == null ? void 0 : areas.data, table == null ? void 0 : table.areaId, "id");
  const areaForArea = findObjectByProperty(areas == null ? void 0 : areas.data, areaId, "id");
  const hasTable = (table == null ? void 0 : table.id) > -1;
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.availabilityCardContainer,
      style: {
        backgroundColor: hasConflicts && theme2.colors.white,
        outline: hasConflicts && `1px solid ${theme2.colors.nimbus}`
      }
    },
    /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.leftBar,
        style: { backgroundColor: hasConflicts && theme2.colors.apricot }
      }
    ),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.availabilityCardContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.availabilityCardTableInfo }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableNumber }, (table == null ? void 0 : table.tableNumber) || !hasTable && ((areaForArea == null ? void 0 : areaForArea.name) || (areaForTable == null ? void 0 : areaForTable.name))), /* @__PURE__ */ React__default.createElement(Box, null, hasTable && (areaForTable == null ? void 0 : areaForTable.name))), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, hasTable && !isEmpty(table) && !(table == null ? void 0 : table.isPublic) && /* @__PURE__ */ React__default.createElement(Label$1, null, "Private")))
  );
};
AvailabilityCard.defaultProps = {
  hasConflicts: false,
  areaId: null,
  table: null
};
AvailabilityCard.propTypes = {
  table: tablePropTypes,
  areaId: PropTypes.number,
  areas: areasPropTypes.isRequired,
  hasConflicts: PropTypes.bool
};
const mapStateToProps$l = (state) => ({
  areas: state.areas
});
const mapDispatchToProps$l = (dispatch) => bindActionCreators({}, dispatch);
const AvailabilityCard$1 = connect(mapStateToProps$l, mapDispatchToProps$l)(AvailabilityCard);
const useStyles$8 = createUseStyles((theme2) => ({
  conflictMessageBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: "16px",
    padding: "12px",
    borderRadius: "8px",
    background: theme2.colors.apricotLight
  }
}));
const Availability = ({
  context,
  obeeSettings: obeeSettings2,
  table,
  setTable,
  setAreaId,
  guestAmount,
  time,
  filteredAreaId,
  // The area ID chosen from the filter
  areaId,
  // The area ID when a table or area is chosen for the booking
  isAvailableTable,
  setIsAvailableTable,
  setIsCreatedTable,
  conflict,
  date
}) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$8();
  const [availTablesAnchorEl, setAvailTablesAnchorEl] = useState(null);
  const getBackgroundColor = () => {
    switch (context) {
      case BOOKING_AVAILABILITY_STATE.AVAILABLE:
        return theme2.colors.pillAvailable;
      case BOOKING_AVAILABILITY_STATE.CONFLICTED:
        return theme2.colors.apricot;
      case BOOKING_AVAILABILITY_STATE.UNAVAILABLE:
      default:
        return theme2.colors.unavailableBackground;
    }
  };
  const getColor2 = () => {
    switch (context) {
      case BOOKING_AVAILABILITY_STATE.AVAILABLE:
      case BOOKING_AVAILABILITY_STATE.CONFLICTED:
        return theme2.colors.bodyText;
      case BOOKING_AVAILABILITY_STATE.UNAVAILABLE:
      default:
        return theme2.colors.errorRed;
    }
  };
  const getHeading = () => {
    switch (context) {
      case BOOKING_AVAILABILITY_STATE.AVAILABLE:
        return "Available";
      case BOOKING_AVAILABILITY_STATE.CONFLICTED:
        return conflict && isAvailableTable ? "Short duration" : "Unavailable";
      case BOOKING_AVAILABILITY_STATE.UNAVAILABLE:
      default:
        return "No availability";
    }
  };
  const getPrompt = (type2) => {
    switch (type2) {
      case BOOKING_CONFLICT_TYPE.BLOCK: {
        return "The table is blocked at";
      }
      case BOOKING_CONFLICT_TYPE.SESSION: {
        return "The session ends at";
      }
      case BOOKING_CONFLICT_TYPE.BOOKING:
      default: {
        return "The next booking starts at";
      }
    }
  };
  const backgroundColor = getBackgroundColor();
  const color = getColor2();
  if (context !== BOOKING_AVAILABILITY_STATE.AVAILABLE) {
    devLog("debug", "Table was unavailable", {
      context,
      table,
      guestAmount,
      time,
      areaId,
      conflict
    });
  }
  return /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical" }, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline" } }, /* @__PURE__ */ React__default.createElement(
    Pill,
    {
      backgroundColor,
      color,
      style: {
        container: {
          borderRadius: "8px",
          fontSize: "inherit",
          height: "24px",
          display: "flex",
          padding: "0 20px"
        }
      }
    },
    getHeading()
  ), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "text",
      onClick: (e) => setAvailTablesAnchorEl(e.currentTarget),
      style: { fontWeight: theme2.fontWeights.medium }
    },
    "Change table"
  )), context !== BOOKING_AVAILABILITY_STATE.UNAVAILABLE && /* @__PURE__ */ React__default.createElement(
    AvailabilityCard$1,
    {
      table,
      areaId,
      hasConflicts: context === BOOKING_AVAILABILITY_STATE.CONFLICTED
    }
  ), context === BOOKING_AVAILABILITY_STATE.CONFLICTED && /* @__PURE__ */ React__default.createElement(Box, { className: classes.conflictMessageBox }, /* @__PURE__ */ React__default.createElement(IconComms, { style: { flexShrink: 0, width: "28px", color: backgroundColor } }), /* @__PURE__ */ React__default.createElement(Box, null, conflict && isAvailableTable ? `${getPrompt(conflict.type)} ${formatTimeFromInt(
    conflict.startTime
  )}. It means you can
            only book for ${conflict.startTime - time} mins.` : "Table is unavailable, this may cause conflicts.")), context === BOOKING_AVAILABILITY_STATE.UNAVAILABLE && ((_a = obeeSettings2.data) == null ? void 0 : _a.waitlist) && /* @__PURE__ */ React__default.createElement(Box, null, `Add the ${pluralise("guest", guestAmount)} to the ${formatTimeFromInt(
    time,
    "h:mma"
  )} waitlist.`), /* @__PURE__ */ React__default.createElement(
    TableSelectorPopover$1,
    {
      anchorEl: availTablesAnchorEl,
      setAnchorEl: setAvailTablesAnchorEl,
      areaId: filteredAreaId,
      setTable,
      setIsAvailableTable,
      setIsCreatedTable,
      time,
      setAreaId,
      date,
      guestAmount
    }
  ));
};
Availability.defaultProps = {
  conflict: null,
  filteredAreaId: null,
  areaId: null,
  table: null
};
Availability.propTypes = {
  obeeSettings: obeeSettingsPropTypes.isRequired,
  context: PropTypes.oneOf([
    BOOKING_AVAILABILITY_STATE.AVAILABLE,
    BOOKING_AVAILABILITY_STATE.CONFLICTED,
    BOOKING_AVAILABILITY_STATE.UNAVAILABLE
  ]).isRequired,
  table: tablePropTypes,
  conflict: PropTypes.shape({
    type: PropTypes.oneOf([
      BOOKING_CONFLICT_TYPE.BLOCK,
      BOOKING_CONFLICT_TYPE.SESSION,
      BOOKING_CONFLICT_TYPE.BOOKING
    ]),
    startTime: PropTypes.number
  }),
  setTable: PropTypes.func.isRequired,
  setAreaId: PropTypes.func.isRequired,
  guestAmount: PropTypes.number.isRequired,
  time: PropTypes.number.isRequired,
  filteredAreaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // Since it can be 'all'
  areaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // Since it can be 'all'
  isAvailableTable: PropTypes.bool.isRequired,
  setIsAvailableTable: PropTypes.func.isRequired,
  setIsCreatedTable: PropTypes.func.isRequired
};
const mapStateToProps$k = (state) => ({
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$k = (dispatch) => bindActionCreators({}, dispatch);
const Availability$1 = connect(mapStateToProps$k, mapDispatchToProps$k)(Availability);
const stripe$1 = loadStripe((_c = window.bookingsConfig) == null ? void 0 : _c.stripeApiKey);
const durationTimes = [
  { label: "Default duration", value: "default" },
  { label: "30 minutes", value: 30 },
  { label: "60 minutes", value: 60 },
  { label: "90 minutes", value: 90 },
  { label: "120 minutes", value: 120 },
  { label: "150 minutes", value: 150 },
  { label: "180 minutes", value: 180 }
];
const AddBookingModal = ({
  isOpen,
  onClose,
  fetchObeeSettings: fetchObeeSettings2,
  obeeSettings: obeeSettings2,
  checkObeeAvailability: checkObeeAvailability2,
  clearObeeAvailability,
  obeeAvailability,
  obeeAreas: obeeAreas2,
  obeeSessions: obeeSessions2,
  fetchAreas,
  quickBooking,
  // Clicked a table on fp or timeline to quickly add a booking
  obeeBookings: obeeBookings2,
  createObeeBooking: createObeeBooking2,
  obeeScreenDate,
  fetchObeeStaffList,
  obeeStaff,
  checkObeeAvailabilityAllAreas: checkObeeAvailabilityAllAreas2,
  obeeTables: obeeTables2,
  fetchObeeTables: fetchObeeTables2,
  fetchSessions,
  preventChanges,
  fetchPaymentSettings: fetchPaymentSettings2,
  paymentSettings,
  defaultDate
  // If provided, overrides the system date being used
}) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const classes = useStyles$b();
  const isQuickBooking = !isEmpty(quickBooking);
  const skipAvailabilityCheck = !((_a = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _a.hasCustomDuration) && isQuickBooking;
  const autoFetchAvailability = ((_b2 = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _b2.hasCustomDuration) && isQuickBooking;
  const isLoading = (obeeSettings2 == null ? void 0 : obeeSettings2.pending) || (obeeAreas2 == null ? void 0 : obeeAreas2.pending) || (obeeSessions2 == null ? void 0 : obeeSessions2.pending) || (obeeBookings2 == null ? void 0 : obeeBookings2.pending) || (obeeStaff == null ? void 0 : obeeStaff.pending) || (obeeTables2 == null ? void 0 : obeeTables2.pending) || (paymentSettings == null ? void 0 : paymentSettings.pending);
  const [check, setCheck] = useState(autoFetchAvailability);
  const [creating, setCreating] = useState(false);
  const [step, setStep] = useState(0);
  const [time, setTime] = useState(0);
  const [selectedSession, setSelectedSession] = useState(null);
  const [duration, setDuration] = useState("default");
  const [date, setDate] = useState(moment$2(defaultDate ?? obeeScreenDate));
  const [guestAmount, setGuestAmount] = useState(2);
  const [areaId, setAreaId] = useState("all");
  const [source, setSource] = useState(null);
  const [table, setTable] = useState(null);
  const [isWaitlist, setIsWaitlist] = useState(false);
  const [isForced, setIsForced] = useState(false);
  const [selectedAreaId, setSelectedAreaId] = useState(null);
  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [dateListAnchorEl, setDateListAnchorEl] = useState(null);
  const [timeAnchorEl, setTimeAnchorEl] = useState(null);
  const [durationAnchorEl, setDurationAnchorEl] = useState(null);
  const [guestsAnchorEl, setGuestsAnchorEl] = useState(null);
  const [areasAnchorEl, setAreasAnchorEl] = useState(null);
  const [isAvailableTable, setIsAvailableTable] = useState(false);
  const [isCreatedTable, setIsCreatedTable] = useState(false);
  const dateRef = useRef(null);
  const sessionsForDay = useMemo(
    () => getTodaySessions(date, obeeSessions2, "all_sessions", areaId || "all"),
    [obeeSessions2.data, date, areaId]
  );
  const handleUpdateTime = (newTime, newSession) => {
    setTime(newTime);
    setSelectedSession(newSession);
  };
  const availableTimes = useMemo(() => {
    var _a2;
    const bookingInterval = (_a2 = obeeSettings2.data) == null ? void 0 : _a2.systemTimeInterval;
    return getTimeDropdownList(sessionsForDay, handleUpdateTime, bookingInterval);
  }, [sessionsForDay, date, areaId]);
  useEffect(() => {
    if (isOpen) {
      if (isEmpty(obeeSettings2.apiData) && !obeeSettings2.pending) {
        fetchObeeSettings2();
      }
      if (isEmpty(obeeTables2.apiData) && !obeeTables2.pending) {
        fetchObeeTables2(date);
      }
      if (isEmpty(obeeAreas2.apiData) && !obeeAreas2.pending) {
        fetchAreas();
      }
      if (isEmpty(obeeSessions2.apiData) && !obeeSessions2.pending) {
        fetchSessions();
      }
      if (!isObee() && isEmpty(obeeStaff.apiData) && !obeeStaff.pending) {
        fetchObeeStaffList();
      }
    }
  }, [isOpen]);
  const [minMaxGroupSize, setMinMaxGroupSize] = useState({ min: 1, max: 20 });
  useEffect(() => {
    const newMinMaxGroupSize = getMinMaxGroupSize(obeeAreas2.data, areaId);
    setMinMaxGroupSize({
      min: newMinMaxGroupSize.minGroup,
      max: newMinMaxGroupSize.maxGroup
    });
    if (guestAmount < newMinMaxGroupSize.minGroup) {
      setGuestAmount(newMinMaxGroupSize.minGroup);
    }
    if (guestAmount > newMinMaxGroupSize.maxGroup) {
      setGuestAmount(newMinMaxGroupSize.maxGroup);
    }
  }, [obeeAreas2.data, areaId]);
  const openDateModal = (event) => {
    setDateListAnchorEl(event.currentTarget);
  };
  const closeDateModal = () => {
    setDateListAnchorEl(null);
  };
  const setCalendarDate = (newDate) => {
    setDate(moment$2(newDate));
    closeDateModal();
  };
  const resetEverything = () => {
    devLog("info", "resetting add booking modal");
    unstable_batchedUpdates(() => {
      setStep(0);
      setTime(getNextTime(availableTimes));
      setDate(moment$2(obeeScreenDate));
      setGuestAmount(Math.max(minMaxGroupSize.min, 2));
      setAreaId("all");
      setSource(null);
      setTable(null);
      setCheck(false);
      setIsWaitlist(false);
      setIsForced(false);
      setIsAvailableTable(false);
      setIsCreatedTable(false);
      setSelectedAreaId(null);
    });
  };
  const updateEverything = () => {
    if (isQuickBooking) {
      devLog("debug", "adding quick booking", quickBooking);
      const tableForQuickBooking = getTableForBooking(
        quickBooking,
        obeeTables2.data,
        obeeAreas2.data
      );
      const getDefaultGuestAmount = () => {
        const defaultGuestAmount = 2;
        const tableMaxSeats = (tableForQuickBooking == null ? void 0 : tableForQuickBooking.maxSeats) ?? 999;
        const tableMinSeats = (tableForQuickBooking == null ? void 0 : tableForQuickBooking.minSeats) ?? 0;
        const maxGuests = Math.min(tableMaxSeats, minMaxGroupSize.max, defaultGuestAmount);
        return Math.max(maxGuests, tableMinSeats, minMaxGroupSize.min);
      };
      unstable_batchedUpdates(() => {
        setTime(quickBooking.time || 0);
        setDate(moment$2(defaultDate ?? obeeScreenDate));
        setGuestAmount(getDefaultGuestAmount());
        setAreaId((tableForQuickBooking == null ? void 0 : tableForQuickBooking.areaId) || (quickBooking == null ? void 0 : quickBooking.areaId));
        setSelectedAreaId((tableForQuickBooking == null ? void 0 : tableForQuickBooking.areaId) || (quickBooking == null ? void 0 : quickBooking.areaId));
        setTable(tableForQuickBooking);
        setIsAvailableTable(true);
        setIsCreatedTable(false);
        setDuration("default");
      });
    } else {
      setTime(getNextTime(availableTimes));
      setDate(moment$2(defaultDate ?? obeeScreenDate));
      setAreaId("all");
      setSelectedAreaId(null);
      setTable(null);
      setDuration("default");
    }
  };
  useEffect(() => {
    if (!isOpen) {
      resetEverything();
    } else {
      updateEverything();
    }
  }, [isOpen, quickBooking]);
  const checkAvailability = useCallback(() => {
    devLog("info", "checking availability", areaId, date, time, guestAmount);
    clearObeeAvailability();
    setCheck(true);
    if (areaId === "all") {
      if (!quickBooking) {
        checkObeeAvailabilityAllAreas2(date, time, guestAmount, false, true);
      }
    } else {
      const areaIdAsInt = parseInt(`${areaId}`, 10);
      if (date && !isEmpty(areaIdAsInt) && !isEmpty(time)) {
        checkObeeAvailability2(date, areaIdAsInt, time, guestAmount, false, true);
      }
    }
  }, [areaId, date, time, guestAmount, quickBooking]);
  useEffect(() => {
    if (isOpen && autoFetchAvailability && date && !isEmpty(areaId) && !isEmpty(time)) {
      checkAvailability();
    }
  }, [isOpen, date, areaId, time]);
  useEffect(() => {
    if (!skipAvailabilityCheck && !quickBooking) {
      devLog("info", "clearing availability");
      clearObeeAvailability();
      setCheck(false);
    }
  }, [date, areaId, time, guestAmount]);
  useEffect(() => {
    if (isQuickBooking && !isEmpty(quickBooking.time)) {
      return;
    }
    const availableTimesValues = availableTimes == null ? void 0 : availableTimes.flatMap(
      (availableTime) => {
        var _a2;
        return (_a2 = availableTime.items) == null ? void 0 : _a2.flatMap((item) => item.value);
      }
    );
    if (!isEmpty(availableTimesValues) && !availableTimesValues.includes(time)) {
      setTime(getNextTime(availableTimes));
    }
  }, [availableTimes]);
  useEffect(() => {
    if (!isEmpty(obeeAvailability.data)) {
      unstable_batchedUpdates(() => {
        setIsAvailableTable(true);
        if (isQuickBooking) {
          const isNoTableArea = isAreaCapacityBased(quickBookingArea, obeeTables2.data);
          if (isNoTableArea) {
            setIsAvailableTable(true);
          } else {
            const availableQuickBookingTable = obeeAvailability.data.find(
              (availability) => availability.tableNumber === quickBooking.tableNumber
            );
            if (availableQuickBookingTable)
              ;
            else {
              devLog("debug", "Quick booking Table unavailable", obeeAvailability, quickBooking);
              setIsAvailableTable(false);
            }
          }
        } else {
          setTable(obeeAvailability.data[0]);
        }
      });
    } else {
      if (!isQuickBooking) {
        devLog("debug", "Booking Table unavailable", obeeAvailability);
        setIsAvailableTable(false);
        setTable(null);
      }
    }
  }, [obeeAvailability.data]);
  useEffect(() => {
    if (obeeAvailability == null ? void 0 : obeeAvailability.success) {
      setCheck(false);
    }
  }, [obeeAvailability.success]);
  useEffect(() => {
    if (obeeAvailability == null ? void 0 : obeeAvailability.error) {
      setCheck(false);
    }
  }, [obeeAvailability.error]);
  const quickBookingTable = getTableForBooking(
    quickBooking,
    obeeTables2.data,
    obeeAreas2.data
  );
  const quickBookingArea = findObjectByProperty(obeeAreas2.data, quickBooking == null ? void 0 : quickBooking.areaId, "id");
  const getAreas = () => {
    var _a2;
    return [
      {
        label: "All Areas",
        value: "all",
        onClick: () => {
          setAreaId("all");
        }
      },
      ...(_a2 = obeeAreas2.data) == null ? void 0 : _a2.map((area) => ({
        label: area.name,
        value: area.id,
        onClick: () => {
          setAreaId(area.id);
          setSelectedAreaId(area.id);
          if ((table == null ? void 0 : table.areaId) !== area.id) {
            setTable(null);
          }
        }
      }))
    ];
  };
  const getGuestAmounts = () => {
    const getMinAndMax = () => {
      var _a2, _b3;
      if (quickBookingTable) {
        return {
          min: (quickBookingTable == null ? void 0 : quickBookingTable.minSeats) || 1,
          max: (quickBookingTable == null ? void 0 : quickBookingTable.maxSeats) || 20
        };
      }
      const maxCapacity = ((_b3 = (_a2 = sortListByProperty(obeeAreas2.data, "capacity", true)) == null ? void 0 : _a2[0]) == null ? void 0 : _b3.capacity) || 20;
      return { min: 1, max: maxCapacity };
    };
    const { min, max } = getMinAndMax();
    return numberRange(min, max, 1, true).map((amount) => {
      return {
        label: amount,
        value: amount,
        onClick: () => setGuestAmount(amount)
      };
    });
  };
  const getInteractiveItem = (icon, value, onClick, isActive = false, disabled = false) => {
    return /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.interactiveItem} ${isActive && classes.activeItem} ${disabled && classes.disabledItem}`,
        onClick: disabled ? () => {
        } : (e) => onClick(e)
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemIcon }, icon),
      /* @__PURE__ */ React__default.createElement(Box, null, value)
    );
  };
  const getNextWeekAsDays = (amountOfDays = 8) => {
    return [...Array.from({ length: amountOfDays })].map((_, i) => {
      const newDay = moment$2().startOf("day").add(i, "days");
      return {
        label: formatDate(newDay, "dddd D/M"),
        value: newDay,
        onClick: () => setDate(newDay)
      };
    });
  };
  const removeGuest = (e) => {
    e == null ? void 0 : e.stopPropagation();
    setGuestAmount(Math.max((quickBookingTable == null ? void 0 : quickBookingTable.minSeats) || 1, guestAmount - 1));
  };
  const addGuest = (e) => {
    var _a2, _b3;
    e == null ? void 0 : e.stopPropagation();
    const maxCapacity = ((_b3 = (_a2 = sortListByProperty(obeeAreas2.data, "capacity", true)) == null ? void 0 : _a2[0]) == null ? void 0 : _b3.capacity) || 20;
    setGuestAmount(Math.min((quickBookingTable == null ? void 0 : quickBookingTable.maxSeats) || maxCapacity, guestAmount + 1));
  };
  const days = getNextWeekAsDays();
  const getConflict = () => {
    var _a2;
    if (isEmpty(table)) {
      return null;
    }
    const startTime = time;
    const bookingDuration = table.duration > 0 ? table.duration : (_a2 = obeeSettings2.data) == null ? void 0 : _a2.bookingsDuration;
    const endTime = startTime + bookingDuration;
    if (!isSameDay(date, obeeScreenDate)) {
      return null;
    }
    const blockAhead = getTableBlockAhead(table.blocks, startTime, endTime);
    if (blockAhead) {
      devLog("info", "CONFLICT - Block ahead");
      return { type: BOOKING_CONFLICT_TYPE.BLOCK, startTime: blockAhead.startTime };
    }
    const tableBookings = getAllTableBookings(table, obeeBookings2.data);
    const bookingAhead = getTableBookingAhead(tableBookings, startTime, endTime);
    if (bookingAhead) {
      devLog("info", "CONFLICT - bookingAhead");
      return { type: BOOKING_CONFLICT_TYPE.BOOKING, startTime: bookingAhead.startTime };
    }
    return null;
  };
  const getSessionEndTime = (areaForTable) => {
    let sessionForTime = null;
    const areaIdToUse = (areaForTable == null ? void 0 : areaForTable.id) || (table == null ? void 0 : table.areaId) || areaId;
    if (isVoid(sessionForTime)) {
      sessionForTime = getSessionForBooking(
        { startTime: time, areaId: areaIdToUse },
        sessionsForDay,
        true
      );
    } else {
      sessionForTime = selectedSession.items.find(
        (areaSession) => areaSession.areaId === areaIdToUse || isVoid(areaSession.areaId)
      );
    }
    return sessionForTime == null ? void 0 : sessionForTime.endTime;
  };
  const getBookingDuration = () => {
    var _a2, _b3;
    if (isEmpty(table) && isEmpty(areaId)) {
      return (_a2 = obeeSettings2.data) == null ? void 0 : _a2.bookingsDuration;
    }
    const conflict = getConflict();
    if (conflict) {
      return conflict.startTime - time;
    }
    const areaForTable = getAreaById(obeeAreas2.data, areaId ?? (table == null ? void 0 : table.areaId));
    const durationForTable = (table == null ? void 0 : table.duration) ?? (areaForTable == null ? void 0 : areaForTable.duration) ?? ((_b3 = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _b3.bookingsDuration);
    if (durationForTable === 0) {
      return Math.max(15, getSessionEndTime() - time);
    }
    return durationForTable;
  };
  const createWalkin = async () => {
    setCreating(true);
    try {
      const booking = {
        areaId: (table == null ? void 0 : table.areaId) || selectedAreaId,
        date: formatDate(date, "YYYY-MM-DD"),
        time,
        size: guestAmount,
        name: "Walk-in guest",
        source: "walkin",
        status: STATUS_TYPES.ARRIVED,
        tableNumber: table == null ? void 0 : table.tableNumber,
        duration: getBookingDuration()
      };
      createObeeBooking2(booking);
    } catch (error) {
      setCreating(false);
    }
  };
  useEffect(() => {
    if (creating && !obeeBookings2.pending && obeeBookings2.success) {
      setCreating(false);
      onClose();
    }
  }, [obeeBookings2.success]);
  useEffect(() => {
    if (creating && !obeeBookings2.pending && obeeBookings2.error) {
      setCreating(false);
    }
  }, [obeeBookings2.error]);
  const getAreaIdToUse = () => {
    var _a2, _b3;
    if (!isVoid(table == null ? void 0 : table.areaId)) {
      return table == null ? void 0 : table.areaId;
    }
    if (!isVoid(selectedAreaId)) {
      return selectedAreaId;
    }
    return (_b3 = (_a2 = obeeAreas2 == null ? void 0 : obeeAreas2.data) == null ? void 0 : _a2[0]) == null ? void 0 : _b3.id;
  };
  const getAvailability = () => {
    var _a2;
    if (((_a2 = obeeAvailability.data) == null ? void 0 : _a2.length) > 0 || skipAvailabilityCheck || isCreatedTable) {
      const conflict = getConflict();
      const tableIsAvailable = skipAvailabilityCheck || isAvailableTable;
      return /* @__PURE__ */ React__default.createElement(
        Availability$1,
        {
          context: !tableIsAvailable || conflict ? "conflicted" : "available",
          conflict,
          table,
          setTable,
          guestAmount,
          time,
          date,
          filteredAreaId: areaId,
          areaId: selectedAreaId,
          setAreaId: setSelectedAreaId,
          isAvailableTable: tableIsAvailable,
          setIsAvailableTable,
          setIsCreatedTable
        }
      );
    }
    return /* @__PURE__ */ React__default.createElement(
      Availability$1,
      {
        context: "unavailable",
        table,
        setTable,
        guestAmount,
        time,
        date,
        filteredAreaId: areaId,
        areaId: selectedAreaId,
        setAreaId: setSelectedAreaId,
        isAvailableTable,
        setIsAvailableTable,
        setIsCreatedTable
      }
    );
  };
  const getAddBookingView = () => {
    var _a2;
    return /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBody }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Add booking"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.contentTop, ref: dateRef }, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", flexDirection: "column", gap: "8px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, getInteractiveItem(
      /* @__PURE__ */ React__default.createElement(DateIconSVG, { style: { width: "16px" } }),
      formatDate(date, "ddd Do of MMM"),
      openDateModal,
      dateAnchorEl || dateListAnchorEl,
      preventChanges
    ), getInteractiveItem(
      /* @__PURE__ */ React__default.createElement(TimeIconSVG, { style: { width: "18px" } }),
      isEmpty(time) ? "You have no sessions for the day" : formatTimeFromInt(time, "h:mma"),
      (e) => !isEmpty(availableTimes) && setTimeAnchorEl(e.currentTarget),
      timeAnchorEl,
      preventChanges
    ), getInteractiveItem(
      /* @__PURE__ */ React__default.createElement(GuestSVG, { style: { width: "14px" } }),
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestsLabel }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestsText }, `${guestAmount} ${pluralise("guest", guestAmount)}`), /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "custom",
          className: classes.incrementButton,
          style: iconButtonStyles(theme2),
          onClick: removeGuest,
          disabled: guestAmount <= ((quickBookingTable == null ? void 0 : quickBookingTable.minSeats) || 1)
        },
        /* @__PURE__ */ React__default.createElement(MinusIconSVG, { style: { height: "2px" } })
      ), /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "custom",
          className: classes.incrementButton,
          style: iconButtonStyles(theme2),
          onClick: addGuest,
          disabled: guestAmount >= ((quickBookingTable == null ? void 0 : quickBookingTable.maxSeats) || (quickBookingArea == null ? void 0 : quickBookingArea.capacity))
        },
        /* @__PURE__ */ React__default.createElement(PlusIconSVG, { style: { height: "13px" } })
      )),
      (e) => {
        setGuestsAnchorEl(e.currentTarget);
      },
      guestsAnchorEl
    ), getInteractiveItem(
      /* @__PURE__ */ React__default.createElement(AreaIconSVG, { style: { width: "16px" } }),
      (_a2 = findObjectByProperty(getAreas(), areaId, "value")) == null ? void 0 : _a2.label,
      (e) => {
        setAreasAnchorEl(e.currentTarget);
      },
      areasAnchorEl,
      preventChanges
    ))), /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "tertiary",
        style: smallButtonStyles$1(theme2),
        onClick: checkAvailability,
        disabled: check || skipAvailabilityCheck || isEmpty(time),
        loading: check || isLoading,
        centered: true
      },
      "Check"
    ), /* @__PURE__ */ React__default.createElement(Divider, { color: "#CFCFCF" }), obeeAvailability.pending && /* @__PURE__ */ React__default.createElement(
      Skeleton$1,
      {
        height: 80,
        style: { skeleton: { backgroundColor: theme2.colors.loadingShimmer } }
      }
    ), (skipAvailabilityCheck || !check && (obeeAvailability.success || !isEmpty(obeeAvailability.error))) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.section, style: { gap: "10px" } }, getAvailability()))), (skipAvailabilityCheck || !check && (obeeAvailability.success || !isEmpty(obeeAvailability.error))) && /* @__PURE__ */ React__default.createElement(
      AddBookingFooter$1,
      {
        isAvailableTable: skipAvailabilityCheck || isAvailableTable,
        isCreatedTable,
        showAddDetails: (type2 = null) => {
          var _a3;
          setIsForced(false);
          setIsWaitlist(false);
          setStep(1);
          setSource(type2);
          if ((_a3 = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _a3.hasPaymentSettings) {
            fetchPaymentSettings2({
              date: formatDate(date, "YYYY-MM-DD"),
              time,
              size: guestAmount,
              public: 0,
              areaId: getAreaIdToUse()
            });
          }
        },
        showAddWaitlist: (type2 = null) => {
          setIsWaitlist(true);
          setIsForced(false);
          setStep(1);
          setSource(type2);
        },
        showForceBooking: (type2 = null) => {
          var _a3;
          setIsWaitlist(false);
          setIsForced(true);
          setStep(1);
          setSource(type2);
          if ((_a3 = obeeSettings2 == null ? void 0 : obeeSettings2.data) == null ? void 0 : _a3.hasPaymentSettings) {
            fetchPaymentSettings2({
              date: formatDate(date, "YYYY-MM-DD"),
              time,
              size: guestAmount,
              public: 0,
              areaId: getAreaIdToUse()
            });
          }
        },
        addWalkin: createWalkin
      }
    ), /* @__PURE__ */ React__default.createElement(
      DatePopover$1,
      {
        value: date,
        anchor: dateAnchorEl,
        isOpen: !!dateAnchorEl,
        onClose: () => setDateAnchorEl(null),
        onSetDate: setCalendarDate
      }
    ), /* @__PURE__ */ React__default.createElement(
      ListPopover,
      {
        items: days,
        anchor: dateListAnchorEl,
        isOpen: !!dateListAnchorEl,
        onClose: closeDateModal,
        style: listPopoverStyles$2,
        footer: /* @__PURE__ */ React__default.createElement(Box, { className: classes.selectDate, onClick: () => setDateAnchorEl(dateListAnchorEl) }, /* @__PURE__ */ React__default.createElement(Box, null, "Select date"), /* @__PURE__ */ React__default.createElement(ChevronRight, { style: { width: "8px" } })),
        popoverProps: { innerProps: { disableScrollLock: true } },
        ...popoverAnchors$3
      }
    ), !isEmpty(timeAnchorEl) && /* @__PURE__ */ React__default.createElement(
      ListPopover,
      {
        items: availableTimes,
        selectedItems: [time],
        anchor: timeAnchorEl,
        isOpen: !isEmpty(timeAnchorEl),
        onClose: () => setTimeAnchorEl(null),
        style: listPopoverStyles$2,
        container: timeAnchorEl.parentNode,
        disableScrollLock: true,
        popoverProps: { innerProps: { disableScrollLock: true } },
        ...popoverAnchors$3
      }
    ), !isEmpty(durationAnchorEl) && /* @__PURE__ */ React__default.createElement(
      ListPopover,
      {
        items: durationTimes,
        selectedItems: [duration],
        anchor: durationAnchorEl,
        onSelect: setDuration,
        isOpen: !isEmpty(durationAnchorEl),
        onClose: () => setDurationAnchorEl(null),
        style: listPopoverStyles$2,
        popoverProps: { innerProps: { disableScrollLock: true } },
        ...popoverAnchors$3
      }
    ), /* @__PURE__ */ React__default.createElement(
      ListPopover,
      {
        items: getGuestAmounts(),
        anchor: guestsAnchorEl,
        isOpen: !!guestsAnchorEl,
        onClose: () => setGuestsAnchorEl(null),
        style: listPopoverStyles$2,
        popoverProps: { innerProps: { disableScrollLock: true } },
        ...popoverAnchors$3
      }
    ), /* @__PURE__ */ React__default.createElement(
      ListPopover,
      {
        items: getAreas(),
        anchor: areasAnchorEl,
        isOpen: !!areasAnchorEl,
        onClose: () => setAreasAnchorEl(null),
        style: listPopoverStyles$2,
        popoverProps: { innerProps: { disableScrollLock: true } },
        ...popoverAnchors$3
      }
    ));
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(LiveBookingModal$1, { isOpen, onClose, headerHeight: 32 }, step === 0 && getAddBookingView(), step === 1 && /* @__PURE__ */ React__default.createElement(Elements, { stripe: stripe$1 }, /* @__PURE__ */ React__default.createElement(
    AddDetails$1,
    {
      isWaitlist,
      isForced,
      areaId: !isEmpty(table) ? table.areaId : selectedAreaId,
      setAreaId: setSelectedAreaId,
      date,
      guestAmount,
      time,
      source,
      creating,
      setCreating,
      onBack: () => setStep(0),
      setTable,
      table,
      duration: getBookingDuration()
    }
  ))));
};
AddBookingModal.defaultProps = {
  onClose: () => {
  },
  obeeSettings: {},
  quickBooking: null,
  preventChanges: false,
  defaultDate: null,
  obeeBookings: {},
  obeeScreenDate: null
};
AddBookingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  fetchObeeSettings: PropTypes.func.isRequired,
  fetchAreas: PropTypes.func.isRequired,
  checkObeeAvailability: PropTypes.func.isRequired,
  clearObeeAvailability: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes,
  obeeAvailability: obeeAvailabilityPropTypes.isRequired,
  obeeAreas: areasPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  quickBooking: PropTypes.shape({
    areaId: PropTypes.number,
    table: tablePropTypes,
    area: areaPropTypes,
    time: PropTypes.number
  }),
  obeeBookings: obeeBookingsPropTypes,
  createObeeBooking: PropTypes.func.isRequired,
  obeeScreenDate: momentPropTypes.momentObj,
  obeeStaff: obeeStaffPropTypes.isRequired,
  fetchObeeStaffList: PropTypes.func.isRequired,
  checkObeeAvailabilityAllAreas: PropTypes.func.isRequired,
  obeeTables: tablesPropTypes.isRequired,
  fetchObeeTables: PropTypes.func.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  preventChanges: PropTypes.bool,
  defaultDate: momentPropTypes.momentObj,
  // moment date
  fetchPaymentSettings: PropTypes.func.isRequired,
  paymentSettings: paymentSettingsPropTypes.isRequired
};
const mapStateToProps$j = (state) => ({
  obeeSettings: state.obeeSettings,
  obeeAvailability: state.obeeAvailability,
  obeeAreas: state.areas,
  obeeSessions: state.obeeSessions,
  obeeBookings: state.obeeBookings,
  obeeScreenDate: state.obeeScreen.date,
  obeeStaff: state.obeeStaff,
  obeeTables: state.tables,
  paymentSettings: state.paymentSettings
});
const mapDispatchToProps$j = (dispatch) => bindActionCreators(
  {
    fetchObeeSettings: fetchSettingsAction,
    fetchSessions: fetchSessionsAction,
    checkObeeAvailability: checkObeeAvailabilityAction,
    checkObeeAvailabilityAllAreas: checkObeeAvailabilityAllAreasAction,
    clearObeeAvailability: clearObeeAvailabilityAction,
    fetchAreas: fetchAreasAction,
    createObeeBooking: createObeeBookingAction,
    fetchObeeStaffList: fetchObeeStaffListAction,
    fetchObeeTables: fetchTablesAction,
    fetchPaymentSettings: fetchPaymentSettingsAction
  },
  dispatch
);
const AddBookingModal$1 = connect(mapStateToProps$j, mapDispatchToProps$j)(AddBookingModal);
const SvgPageSettings = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.1283 30C13.1283 30.5523 13.5761 31 14.1283 31H18.5638C18.7315 31 18.8675 30.8641 18.8675 30.6964V27.5694C18.8675 26.8342 19.3696 26.1994 20.0502 25.9214V25.9214C20.7235 25.6463 21.5056 25.7495 22.02 26.2639L23.7775 28.0214C24.168 28.4119 24.8012 28.4119 25.1917 28.0214L28.0202 25.193C28.4107 24.8025 28.4107 24.1693 28.0202 23.7788L26.2208 21.9794C25.7315 21.4902 25.633 20.7456 25.8984 20.1065V20.1065C26.1637 19.4678 26.7633 19.0008 27.4549 19.0008H30C30.5523 19.0008 31 18.5531 31 18.0008V14.0008C31 13.4485 30.5523 13.0008 30 13.0008H27.4541C26.7629 13.0008 26.1636 12.5341 25.8985 11.8957V11.8957C25.6333 11.257 25.7318 10.5129 26.2208 10.0239L28.0228 8.22189C28.4133 7.83137 28.4133 7.1982 28.0228 6.80768L25.1944 3.97925C24.8038 3.58873 24.1707 3.58873 23.7802 3.97925L22.0212 5.73824C21.5066 6.2528 20.7242 6.35604 20.0506 6.0808V6.0808C19.3698 5.80264 18.8675 5.16766 18.8675 4.43225V2C18.8675 1.44771 18.4198 1 17.8675 1H14.1283C13.5761 1 13.1283 1.44772 13.1283 2V4.43762C13.1283 5.1711 12.6276 5.80455 11.9487 6.08222V6.08222C11.2765 6.35717 10.4956 6.25417 9.98199 5.74061L8.22117 3.97978C7.83064 3.58925 7.19748 3.58925 6.80695 3.97978L3.97853 6.8082C3.588 7.19873 3.588 7.83189 3.97853 8.22242L5.78189 10.0258C6.27055 10.5144 6.36905 11.2581 6.10405 11.8963V11.8963C5.83913 12.5344 5.24018 13.0008 4.5493 13.0008H2C1.44772 13.0008 1 13.4485 1 14.0008V18.0008C1 18.5531 1.44772 19.0008 2 19.0008H4.54849C5.23977 19.0008 5.83905 19.4675 6.10413 20.1059V20.1059C6.36931 20.7446 6.27078 21.4886 5.78182 21.9776L3.98117 23.7782C3.59065 24.1688 3.59065 24.8019 3.98117 25.1925L6.8096 28.0209C7.20012 28.4114 7.83329 28.4114 8.22381 28.0209L9.98318 26.2615C10.4965 25.7482 11.2772 25.6452 11.9491 25.92V25.92C12.6278 26.1975 13.1283 26.8308 13.1283 27.564V30Z", fill: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M28.0228 8.22189L28.3992 8.59828L28.3992 8.59828L28.0228 8.22189ZM28.0228 6.80768L28.3992 6.4313L28.3992 6.4313L28.0228 6.80768ZM25.1944 3.97925L25.5708 3.60287L25.5708 3.60287L25.1944 3.97925ZM23.7802 3.97925L24.1565 4.35564L24.1565 4.35564L23.7802 3.97925ZM8.22117 3.97978L8.59755 3.60339L8.59755 3.60339L8.22117 3.97978ZM3.97853 6.8082L3.60214 6.43182L3.60214 6.43182L3.97853 6.8082ZM3.97853 8.22242L3.60214 8.5988L3.60214 8.5988L3.97853 8.22242ZM3.98117 23.7782L3.60479 23.4019L3.60479 23.4019L3.98117 23.7782ZM3.98117 25.1925L3.60479 25.5688L3.60479 25.5688L3.98117 25.1925ZM6.8096 28.0209L6.43321 28.3973L6.43321 28.3973L6.8096 28.0209ZM8.22381 28.0209L7.84743 27.6445L7.84743 27.6445L8.22381 28.0209ZM5.78182 21.9776L5.40544 21.6012L5.78182 21.9776ZM9.98199 5.74061L10.3584 5.36422L9.98199 5.74061ZM9.98318 26.2615L10.3596 26.6379L9.98318 26.2615ZM22.0212 5.73824L21.6448 5.36186L22.0212 5.73824ZM14.1283 30.4677C13.87 30.4677 13.6606 30.2583 13.6606 30H12.5961C12.5961 30.8463 13.2821 31.5323 14.1283 31.5323V30.4677ZM18.5638 30.4677H14.1283V31.5323H18.5638V30.4677ZM18.3352 30.6964C18.3352 30.5701 18.4376 30.4677 18.5638 30.4677V31.5323C19.0255 31.5323 19.3998 31.158 19.3998 30.6964H18.3352ZM18.3352 27.5694V30.6964H19.3998V27.5694H18.3352ZM24.1539 27.645L22.3964 25.8875L21.6436 26.6403L23.4011 28.3978L24.1539 27.645ZM24.8153 27.645C24.6327 27.8277 24.3366 27.8277 24.1539 27.645L23.4011 28.3978C23.9995 28.9962 24.9697 28.9962 25.5681 28.3978L24.8153 27.645ZM27.6438 24.8166L24.8153 27.645L25.5681 28.3978L28.3965 25.5694L27.6438 24.8166ZM27.6438 24.1552C27.8264 24.3378 27.8264 24.6339 27.6438 24.8166L28.3965 25.5694C28.9949 24.971 28.9949 24.0008 28.3965 23.4024L27.6438 24.1552ZM25.8445 22.3558L27.6438 24.1552L28.3965 23.4024L26.5972 21.6031L25.8445 22.3558ZM30 18.4685H27.4549V19.5331H30V18.4685ZM30.4677 18.0008C30.4677 18.2591 30.2583 18.4685 30 18.4685V19.5331C30.8463 19.5331 31.5323 18.8471 31.5323 18.0008H30.4677ZM30.4677 14.0008V18.0008H31.5323V14.0008H30.4677ZM30 13.5331C30.2583 13.5331 30.4677 13.7425 30.4677 14.0008H31.5323C31.5323 13.1545 30.8463 12.4685 30 12.4685V13.5331ZM27.4541 13.5331H30V12.4685H27.4541V13.5331ZM27.6464 7.84551L25.8444 9.64754L26.5972 10.4003L28.3992 8.59828L27.6464 7.84551ZM27.6464 7.18406C27.8291 7.36672 27.8291 7.66286 27.6464 7.84551L28.3992 8.59828C28.9976 7.99988 28.9976 7.02969 28.3992 6.4313L27.6464 7.18406ZM24.818 4.35564L27.6464 7.18406L28.3992 6.4313L25.5708 3.60287L24.818 4.35564ZM24.1565 4.35564C24.3392 4.17298 24.6353 4.17298 24.818 4.35564L25.5708 3.60287C24.9724 3.00448 24.0022 3.00448 23.4038 3.60287L24.1565 4.35564ZM22.3976 6.11462L24.1565 4.35564L23.4038 3.60287L21.6448 5.36186L22.3976 6.11462ZM18.3352 2V4.43225H19.3998V2H18.3352ZM17.8675 1.53229C18.1258 1.53229 18.3352 1.74169 18.3352 2H19.3998C19.3998 1.15374 18.7137 0.467713 17.8675 0.467713V1.53229ZM14.1283 1.53229H17.8675V0.467713H14.1283V1.53229ZM13.6606 2C13.6606 1.74169 13.87 1.53229 14.1283 1.53229V0.467713C13.2821 0.467713 12.5961 1.15374 12.5961 2H13.6606ZM13.6606 4.43762V2H12.5961V4.43762H13.6606ZM7.84478 4.35616L9.60561 6.11699L10.3584 5.36422L8.59755 3.60339L7.84478 4.35616ZM7.18334 4.35616C7.36599 4.17351 7.66213 4.17351 7.84478 4.35616L8.59755 3.60339C7.99916 3.005 7.02897 3.005 6.43057 3.60339L7.18334 4.35616ZM4.35491 7.18459L7.18334 4.35616L6.43057 3.60339L3.60214 6.43182L4.35491 7.18459ZM4.35491 7.84604C4.17226 7.66338 4.17226 7.36724 4.35491 7.18459L3.60214 6.43182C3.00375 7.03022 3.00375 8.00041 3.60214 8.5988L4.35491 7.84604ZM6.15827 9.6494L4.35491 7.84604L3.60214 8.5988L5.40551 10.4022L6.15827 9.6494ZM2 13.5331H4.5493V12.4685H2V13.5331ZM1.53229 14.0008C1.53229 13.7425 1.74169 13.5331 2 13.5331V12.4685C1.15374 12.4685 0.467713 13.1545 0.467713 14.0008H1.53229ZM1.53229 18.0008V14.0008H0.467713V18.0008H1.53229ZM2 18.4685C1.74169 18.4685 1.53229 18.2591 1.53229 18.0008H0.467713C0.467713 18.8471 1.15374 19.5331 2 19.5331V18.4685ZM4.54849 18.4685H2V19.5331H4.54849V18.4685ZM4.35755 24.1546L6.15821 22.354L5.40544 21.6012L3.60479 23.4019L4.35755 24.1546ZM4.35755 24.8161C4.1749 24.6334 4.1749 24.3373 4.35755 24.1546L3.60479 23.4019C3.00639 24.0003 3.00639 24.9704 3.60479 25.5688L4.35755 24.8161ZM7.18598 27.6445L4.35755 24.8161L3.60479 25.5688L6.43321 28.3973L7.18598 27.6445ZM7.84743 27.6445C7.66477 27.8272 7.36863 27.8272 7.18598 27.6445L6.43321 28.3973C7.03161 28.9957 8.0018 28.9957 8.6002 28.3973L7.84743 27.6445ZM9.60679 25.8851L7.84743 27.6445L8.60019 28.3973L10.3596 26.6379L9.60679 25.8851ZM13.6606 30V27.564H12.5961V30H13.6606ZM11.7476 26.4127C12.2624 26.6232 12.5961 27.0835 12.5961 27.564H13.6606C13.6606 26.5781 12.9932 25.7719 12.1506 25.4273L11.7476 26.4127ZM5.61254 20.31C5.80733 20.7792 5.72067 21.286 5.40544 21.6012L6.15821 22.354C6.82089 21.6913 6.93128 20.7099 6.59573 19.9018L5.61254 20.31ZM5.61246 11.6922C5.41601 12.1653 4.99071 12.4685 4.5493 12.4685V13.5331C5.48965 13.5331 6.26225 12.9034 6.59565 12.1004L5.61246 11.6922ZM11.7472 5.58955C11.2425 5.79598 10.698 5.70383 10.3584 5.36422L9.60561 6.11699C10.2931 6.8045 11.3105 6.91836 12.1502 6.57489L11.7472 5.58955ZM26.39 20.3107C26.5868 19.8368 27.0128 19.5331 27.4549 19.5331V18.4685C26.5138 18.4685 25.7406 19.0988 25.4068 19.9024L26.39 20.3107ZM5.40551 10.4022C5.72046 10.7171 5.80707 11.2235 5.61246 11.6922L6.59565 12.1004C6.93104 11.2926 6.82064 10.3118 6.15827 9.6494L5.40551 10.4022ZM10.3596 26.6379C10.699 26.2985 11.2432 26.2064 11.7476 26.4127L12.1506 25.4273C11.3111 25.084 10.2941 25.1978 9.60679 25.8851L10.3596 26.6379ZM20.2519 5.58805C19.735 5.37686 19.3998 4.91477 19.3998 4.43225H18.3352C18.3352 5.42055 19.0046 6.22841 19.8492 6.57354L20.2519 5.58805ZM20.2515 26.4142C20.7574 26.2075 21.3032 26.2998 21.6436 26.6403L22.3964 25.8875C21.7081 25.1992 20.6897 25.0851 19.8489 25.4287L20.2515 26.4142ZM12.5961 4.43762C12.5961 4.91838 12.2622 5.37892 11.7472 5.58955L12.1502 6.57489C12.9931 6.23018 13.6606 5.42382 13.6606 4.43762H12.5961ZM4.54849 19.5331C4.99028 19.5331 5.41592 19.8365 5.61254 20.31L6.59573 19.9018C6.26217 19.0985 5.48926 18.4685 4.54849 18.4685V19.5331ZM26.3901 11.6916C26.1952 11.2224 26.2819 10.7156 26.5972 10.4003L25.8444 9.64754C25.1817 10.3103 25.0713 11.2917 25.4069 12.0998L26.3901 11.6916ZM27.4541 12.4685C27.0123 12.4685 26.5867 12.1651 26.3901 11.6916L25.4069 12.0998C25.7405 12.9031 26.5134 13.5331 27.4541 13.5331V12.4685ZM21.6448 5.36186C21.3042 5.70248 20.7581 5.79489 20.2519 5.58805L19.8492 6.57354C20.6903 6.91719 21.7091 6.80312 22.3976 6.11462L21.6448 5.36186ZM26.5972 21.6031C26.2817 21.2875 26.195 20.7802 26.39 20.3107L25.4068 19.9024C25.071 20.7109 25.1814 21.6928 25.8445 22.3558L26.5972 21.6031ZM19.3998 27.5694C19.3998 27.0871 19.7348 26.6252 20.2515 26.4142L19.8489 25.4287C19.0044 25.7737 18.3352 26.5813 18.3352 27.5694H19.3998Z", fill: "#313131" }), /* @__PURE__ */ React$7.createElement("ellipse", { cx: 15.9984, cy: 16.0003, rx: 4.69565, ry: 4.69565, fill: "#F5F2ED", stroke: "#313131", strokeWidth: 1.06457 }));
const SettingsIconSVG = SvgPageSettings;
const SvgPageGuestbook = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 10.5, cy: 10.5, r: 9.5, stroke: "#313131", strokeWidth: 0.75, strokeLinecap: "round", strokeDasharray: "1.2 1.2" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.45461 7.24559C8.45461 8.39004 9.37398 9.31101 10.4998 9.31101C11.6255 9.31101 12.5449 8.39004 12.5449 7.24559C12.5449 6.10115 11.6255 5.18018 10.4998 5.18018C9.37398 5.18018 8.45461 6.10115 8.45461 7.24559Z", fill: "currentColor", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M14.6216 13.4353V14.3412C14.6216 15.2534 13.884 15.9929 12.9719 15.9929H8.03055C7.1184 15.9929 6.37924 15.2537 6.37924 14.3415V13.2455C6.37924 11.9091 7.80758 10.725 8.86201 10.5271C9.05292 10.4912 9.24288 10.548 9.3969 10.6663C9.64834 10.8595 10.0106 11.1298 10.5232 11.1298C11.1014 11.1298 11.6167 10.786 11.8422 10.5967C11.9128 10.5375 12.001 10.4967 12.0929 10.5029C13.7683 10.6157 14.6216 12.6651 14.6216 13.4353Z", fill: "currentColor", stroke: "#313131" }));
const GuestBookIconSVG = SvgPageGuestbook;
const SvgPageVoucher = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 22 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M1 2.81782V12.9362C1 13.9305 1.79896 14.7404 2.79324 14.7538L19.1574 14.9751C20.1709 14.9888 20.9998 14.171 20.9998 13.1574V2.81787C20.9998 1.81392 20.186 1.00005 19.182 1.00005L2.81782 1.00001C1.81387 1 1 1.81387 1 2.81782Z", stroke: "#313131", strokeWidth: 0.95 }), /* @__PURE__ */ React$7.createElement("line", { x1: 1.475, y1: 7.10557, x2: 9.79554, y2: 7.10557, stroke: "black", strokeWidth: 0.95, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 19.2355, y1: 7.10557, x2: 20.5249, y2: 7.10557, stroke: "black", strokeWidth: 0.95, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 15.0302, y1: 1.475, x2: 15.0302, y2: 2.39437, stroke: "black", strokeWidth: 0.95, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 15.0299, y1: 11.6386, x2: 15.0299, y2: 14.2729, stroke: "black", strokeWidth: 0.95, strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M13.5107 3.8848C13.8211 4.21872 14.2361 4.92284 14.4776 5.63792C14.5973 5.99233 14.6635 6.3182 14.6651 6.57902C14.6667 6.84457 14.6029 6.97364 14.542 7.03366C14.4774 7.09733 14.3366 7.16302 14.0609 7.15848C13.7929 7.15407 13.4629 7.083 13.1101 6.95805C12.3937 6.7043 11.7111 6.27554 11.4121 5.95394C10.8568 5.35643 10.8774 4.40922 11.4565 3.83824C12.0356 3.26726 12.9553 3.28728 13.5107 3.8848Z", fill: "currentColor", stroke: "#313131", strokeWidth: 0.95 }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.2252 10.7976C15.913 10.4655 15.4941 9.76391 15.2486 9.05028C15.1269 8.69659 15.059 8.37113 15.0559 8.11033C15.0528 7.84482 15.1159 7.71531 15.1765 7.65486C15.2408 7.59075 15.3813 7.52424 15.657 7.52716C15.925 7.52999 16.2555 7.59911 16.6089 7.72197C17.3267 7.97149 18.0116 8.39621 18.3123 8.716C18.8709 9.31009 18.8557 10.2574 18.2796 10.8319C17.7036 11.4064 16.7838 11.3917 16.2252 10.7976Z", fill: "currentColor", stroke: "#313131", strokeWidth: 0.95 }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.5912 8.70243C11.9009 8.36784 12.5649 7.9087 13.2475 7.62757C13.5857 7.48824 13.8988 7.40533 14.1517 7.39176C14.4092 7.37795 14.5373 7.43774 14.5982 7.49761C14.6629 7.56112 14.7331 7.703 14.7412 7.98683C14.7492 8.26276 14.6953 8.60562 14.5902 8.97427C14.3768 9.72296 13.9921 10.4448 13.6938 10.7671C13.1396 11.3658 12.2199 11.3877 11.6397 10.818C11.0595 10.2483 11.0369 9.30117 11.5912 8.70243Z", fill: "currentColor", stroke: "#313131", strokeWidth: 0.95 }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.2157 5.69321C17.9078 6.02966 17.2463 6.49272 16.5653 6.77788C16.2278 6.91921 15.9152 7.00396 15.6624 7.01902C15.4049 7.03435 15.2766 6.9753 15.2154 6.91586C15.1504 6.8528 15.0795 6.71138 15.0697 6.42759C15.0602 6.15171 15.1122 5.80853 15.2152 5.43925C15.4245 4.68931 15.8052 3.96515 16.1017 3.64111C16.6528 3.03897 17.5723 3.0118 18.1555 3.57793C18.7387 4.14406 18.7667 5.09107 18.2157 5.69321Z", fill: "currentColor", stroke: "#313131", strokeWidth: 0.95 }));
const VoucherRedemptionSVG = SvgPageVoucher;
const SvgPageCalendar = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("rect", { x: 0.5, y: 2.56909, width: 18.9999, height: 16.931, rx: 1.5, stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("line", { x1: 0.666748, y1: 5.71533, x2: 20, y2: 5.71533, stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 2.56897, y: 0.5, width: 1.75861, height: 3.13793, rx: 0.879304, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 6.8598, y: 0.5, width: 1.75861, height: 3.13793, rx: 0.879304, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 11.1505, y: 0.5, width: 1.75861, height: 3.13793, rx: 0.879304, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 15.441, y: 0.5, width: 1.75861, height: 3.13793, rx: 0.879304, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 3.25861, y: 9.08008, width: 2.44826, height: 2.44828, rx: 1.22413, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 3.25861, y: 13.9077, width: 2.44826, height: 2.44828, rx: 1.22413, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 8.77582, y: 9.08008, width: 2.44826, height: 2.44828, rx: 1.22413, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 8.77582, y: 13.9077, width: 2.44826, height: 2.44828, rx: 1.22413, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 14.293, y: 9.08008, width: 2.44826, height: 2.44828, rx: 1.22413, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }), /* @__PURE__ */ React$7.createElement("rect", { x: 14.293, y: 13.9077, width: 2.44826, height: 2.44828, rx: 1.22413, fill: "currentColor", stroke: "#313131", strokeWidth: 0.8 }));
const CalendarIconSVG = SvgPageCalendar;
const SvgViewMulti = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 25 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M16.6374 4.42999V3.79887V3.79887C16.6374 2.2531 15.3843 1 13.8385 1H11.1563C9.61052 1 8.35742 2.2531 8.35742 3.79887V3.79887V4.42999", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.6426 22.9997L16.6426 23.6308V23.6308C16.6426 25.1766 15.3895 26.4297 13.8437 26.4297L11.1615 26.4297C9.61568 26.4297 8.36258 25.1766 8.36258 23.6308V23.6308L8.36258 22.9997", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M4.38235 9.46178L3.76 9.46178V9.46178C2.23569 9.46178 1 10.6975 1 12.2218L1 15.0984C1 16.6227 2.23569 17.8584 3.76 17.8584V17.8584L4.38235 17.8584", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M20.6176 9.46582L21.24 9.46582V9.46582C22.7643 9.46582 24 10.7015 24 12.2258L24 15.1024C24 16.6267 22.7643 17.8624 21.24 17.8624V17.8624L20.6176 17.8624", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 6.5, y: 5.5, width: 12, height: 4, rx: 1.5, fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 6.5, y: 11.5, width: 12, height: 4, rx: 1.5, fill: "white", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("rect", { x: 6.5, y: 17.5, width: 12, height: 4, rx: 1.5, fill: "white", stroke: "#313131" }));
const IconMulti = SvgViewMulti;
const SvgViewSingle = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M16.6374 4.26788V3.63676V3.63676C16.6374 2.09099 15.3843 0.837891 13.8385 0.837891H11.1563C9.61052 0.837891 8.35742 2.09099 8.35742 3.63676V3.63676V4.26788", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.6426 20.7321L16.6426 21.3632V21.3632C16.6426 22.909 15.3895 24.1621 13.8437 24.1621L11.1615 24.1621C9.61568 24.1621 8.36258 22.909 8.36258 21.3632V21.3632L8.36258 20.7321", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M4.38235 8.29967L3.76 8.29967V8.29967C2.23569 8.29967 1 9.53536 1 11.0597L1 13.9363C1 15.4606 2.23569 16.6963 3.76 16.6963V16.6963L4.38235 16.6963", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("path", { d: "M20.6176 8.30371L21.24 8.30371V8.30371C22.7643 8.30371 24 9.53941 24 11.0637L24 13.9403C24 15.4646 22.7643 16.7003 21.24 16.7003V16.7003L20.6176 16.7003", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("rect", { x: 4.5, y: 4.33789, width: 16, height: 16, rx: 1.5, fill: "white", stroke: "#313131" }));
const IconSingle = SvgViewSingle;
const FloorplanHeaderButtons = ({ floorplanView, setFloorplanView }) => {
  const theme2 = useTheme$1();
  const breakpointMdDown = useMediaQuery$1(theme2.breakpoints.down("md"));
  const floorplanViews = [
    {
      label: "Single",
      value: "single",
      icon: /* @__PURE__ */ React__default.createElement(IconSingle, { style: { height: "27px", width: "25px", color: theme2.colors.headerIcon } })
    },
    {
      label: "Multi",
      value: "multi",
      icon: /* @__PURE__ */ React__default.createElement(IconMulti, { style: { height: "25px", width: "25px", color: theme2.colors.headerIcon } })
    }
  ];
  const selectedView = findObjectByProperty(floorplanViews, floorplanView, "value");
  const handleClick = () => {
    if (floorplanView === "single") {
      setFloorplanView("multi");
    } else {
      setFloorplanView("single");
    }
  };
  if (breakpointMdDown) {
    return /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", alignItems: "center", gap: "8px" } }, /* @__PURE__ */ React__default.createElement(HeaderButton$1, { onClick: handleClick, type: "round" }, /* @__PURE__ */ React__default.createElement(Box, { style: { width: "25px", height: "27px", color: theme2.colors.headerButtonOutline } }, selectedView == null ? void 0 : selectedView.icon)));
  }
  return /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", alignItems: "center", gap: "8px" } }, /* @__PURE__ */ React__default.createElement(HeaderButton$1, { onClick: handleClick, style: { button: { width: "105px" } } }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        display: "flex",
        gap: "8px",
        alignItems: "center"
      }
    },
    selectedView == null ? void 0 : selectedView.icon,
    /* @__PURE__ */ React__default.createElement(Box, null, getLabelForValue(floorplanView, floorplanViews))
  )));
};
FloorplanHeaderButtons.defaultProps = {};
FloorplanHeaderButtons.propTypes = {
  floorplanView: PropTypes.string.isRequired,
  setFloorplanView: PropTypes.func.isRequired
};
const mapStateToProps$i = (state) => ({
  floorplanView: state.obeeScreen.floorplanView
});
const mapDispatchToProps$i = (dispatch) => bindActionCreators(
  {
    setFloorplanView: setFloorplanViewAction
  },
  dispatch
);
const FloorplanHeaderButtons$1 = connect(mapStateToProps$i, mapDispatchToProps$i)(FloorplanHeaderButtons);
const GuestBookHeaderButtons = ({ addMessage: addMessage2, guests }) => {
  const handleClick = () => {
    exportGuestBook().then((response) => {
      const guestBookResponseData = safeParse(response == null ? void 0 : response.data);
      if (guestBookResponseData == null ? void 0 : guestBookResponseData.url) {
        window.location = guestBookResponseData.url;
        addMessage2("Guestbook export", "Guestbook data has been downloaded");
      }
    });
  };
  if (!guests.data.find((guest) => !isEmpty(guest == null ? void 0 : guest.marketingPreferences))) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  return /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", alignItems: "center", gap: "8px" } }, /* @__PURE__ */ React__default.createElement(HeaderButton$1, { onClick: handleClick }, "Export marketing list"));
};
GuestBookHeaderButtons.defaultProps = {};
GuestBookHeaderButtons.propTypes = {
  addMessage: PropTypes.func.isRequired,
  guests: obeeGuestsPropTypes.isRequired
};
const mapStateToProps$h = (state) => ({
  guests: state.obeeGuests
});
const mapDispatchToProps$h = (dispatch) => bindActionCreators(
  {
    // exportGuestBook: exportGuestBookAction,
    addMessage: addMessageAction
  },
  dispatch
);
const GuestBookHeaderButtons$1 = connect(mapStateToProps$h, mapDispatchToProps$h)(GuestBookHeaderButtons);
const pages = [
  {
    id: "runsheet",
    name: "Run Sheet",
    pageName: "Run sheet",
    headerIcon: /* @__PURE__ */ React__default.createElement(PrinterIconSVG, { style: { height: "20px" } }),
    menuIcon: /* @__PURE__ */ React__default.createElement(PrinterIconSVG, { style: { height: "30px" } }),
    slug: "/runsheet",
    showDateSelector: true,
    showMonthSelector: false
  },
  {
    id: "floorplan",
    name: "Floor Plan",
    pageName: "Floor plan",
    headerIcon: /* @__PURE__ */ React__default.createElement(FloorplanIconSVG, { style: { height: "20px" } }),
    menuIcon: /* @__PURE__ */ React__default.createElement(FloorplanIconSVG, { style: { height: "30px" } }),
    slug: "/floorplan",
    headerButtons: /* @__PURE__ */ React__default.createElement(FloorplanHeaderButtons$1, null),
    showDateSelector: true,
    showMonthSelector: false
  },
  {
    id: "timeline",
    name: "Timeline",
    pageName: "Timeline",
    headerIcon: /* @__PURE__ */ React__default.createElement(TimelineIconSVG, { style: { height: "20px" } }),
    menuIcon: /* @__PURE__ */ React__default.createElement(TimelineIconSVG, { style: { height: "30px" } }),
    slug: "/timeline",
    showDateSelector: true,
    showMonthSelector: false
  },
  {
    id: "monthly",
    name: "Monthly",
    pageName: "Monthly",
    headerIcon: /* @__PURE__ */ React__default.createElement(CalendarIconSVG, { style: { height: "20px", width: "20px" } }),
    // TODO replace this placeholder
    menuIcon: /* @__PURE__ */ React__default.createElement(CalendarIconSVG, { style: { height: "30px", width: "30px" } }),
    slug: "/monthly",
    showDateSelector: false,
    showMonthSelector: true,
    ignoreSessionDate: true
    // so the session list shows all for month rather than for day
  },
  {
    id: "guestbook",
    name: "Guest Book",
    pageName: "Guest book",
    headerIcon: /* @__PURE__ */ React__default.createElement(GuestBookIconSVG, { style: { height: "19px" } }),
    menuIcon: /* @__PURE__ */ React__default.createElement(GuestBookIconSVG, { style: { height: "30px", width: "30px" } }),
    slug: "/guestbook",
    headerButtons: /* @__PURE__ */ React__default.createElement(GuestBookHeaderButtons$1, null),
    showDateSelector: true,
    showMonthSelector: false
  },
  isObee() && {
    id: "voucherRedemptions",
    name: "Voucher Redemptions",
    pageName: "Voucher redemptions",
    headerIcon: /* @__PURE__ */ React__default.createElement(VoucherRedemptionSVG, { style: { height: "19px" } }),
    menuIcon: /* @__PURE__ */ React__default.createElement(VoucherRedemptionSVG, { style: { width: "30px" } }),
    slug: "/voucher-redemptions",
    showDateSelector: true,
    showMonthSelector: false
  },
  {
    id: "settings",
    name: "Settings",
    pageName: "Settings",
    menuIcon: /* @__PURE__ */ React__default.createElement(SettingsIconSVG, { style: { height: "30px" } }),
    slug: "/settings",
    hiddenInObee: true,
    // flag to show modal for obee settings
    showDateSelector: false,
    showMonthSelector: false
  }
].filter((page) => page);
const DailyNotes = ({
  dailyNotes,
  date,
  fetchDailyNotes: fetchDailyNotes2,
  fetchDailyNoteCategories: fetchDailyNoteCategories2,
  showDailyNotesModal,
  setShowDailyNotesModal
}) => {
  const anchorRef = useRef(null);
  const classes = useStyles$n();
  const createNoteRef = useRef({});
  useEffect(() => {
    fetchDailyNoteCategories2();
  }, []);
  useEffect(() => {
    if (!isEmpty(date)) {
      fetchDailyNotes2(formatDate(date, "YYYY-MM-DD"));
    }
  }, [date, fetchDailyNotes2]);
  const handleOpenDailyNotes = () => {
    setShowDailyNotesModal(true);
  };
  const handleCloseDailyNotes = () => {
    setShowDailyNotesModal(false);
  };
  const notesForDay = useMemo(
    () => dailyNotes.data.filter((note) => note.date === formatDate(date, "YYYY-MM-DD")).sort((a, b) => sortByDate(a.createdDate, b.createdDate, "YYYY-MM-DD HH:mm:ss", true)),
    [dailyNotes.data, date]
  );
  const unreadNotifications = !isEmpty(notesForDay);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container, ref: anchorRef }, /* @__PURE__ */ React__default.createElement(
    HeaderButton$1,
    {
      onClick: handleOpenDailyNotes,
      type: "round",
      style: { button: { position: "relative" } }
    },
    /* @__PURE__ */ React__default.createElement(NotesSVG, { className: classes.icon }),
    unreadNotifications && /* @__PURE__ */ React__default.createElement(Box, { className: classes.notificationIcon })
  ), /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: showDailyNotesModal,
      onClose: handleCloseDailyNotes,
      anchorEl: () => anchorRef == null ? void 0 : anchorRef.current,
      style: {
        padding: "20px"
      },
      innerStyle: {
        padding: "20px",
        marginTop: "8px",
        borderRadius: "16px",
        overflow: "auto",
        bottom: "16px",
        height: "fit-content",
        maxWidth: "375px"
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.modal }, /* @__PURE__ */ React__default.createElement(DailyNotesList$1, { createNoteRef, date: formatDate(date, "YYYY-MM-DD") }))
  ));
};
DailyNotes.defaultProps = {};
DailyNotes.propTypes = {
  dailyNotes: dailyNotesPropTypes.isRequired,
  fetchDailyNotes: PropTypes.func.isRequired,
  fetchDailyNoteCategories: PropTypes.func.isRequired,
  setShowDailyNotesModal: PropTypes.func.isRequired
};
const mapStateToProps$g = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  dailyNotes: state.dailyNotes,
  dailyNoteCategories: state.dailyNoteCategories,
  date: state.obeeScreen.date,
  showDailyNotesModal: state.obeeScreen.showDailyNotesModal
});
const mapDispatchToProps$g = (dispatch) => bindActionCreators(
  {
    fetchDailyNotes: fetchDailyNotesAction,
    fetchDailyNoteCategories: fetchDailyNoteCategoriesAction,
    setShowDailyNotesModal: setShowDailyNotesModalAction
  },
  dispatch
);
const DailyNotes$1 = connect(mapStateToProps$g, mapDispatchToProps$g)(DailyNotes);
const DateSelector = ({ date, setObeeDate }) => {
  const theme2 = useTheme$1();
  const breakpointMdDown = useMediaQuery$1(theme2.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = !!anchorEl;
  useEffect(() => {
    if (!date) {
      setObeeDate(moment$2());
    }
  }, [date]);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const switchToNextDay = () => {
    setObeeDate(date.clone().add(1, "day"));
  };
  const switchToPreviousDay = () => {
    setObeeDate(date.clone().subtract(1, "day"));
  };
  const changeDay = (newDay) => {
    setObeeDate(moment$2(newDay));
    handleCloseMenu();
  };
  const isOpen = !!anchorEl;
  const getDate = () => {
    if (breakpointMdDown) {
      return isCurrentDate(date) ? `Today` : formatDate(date, "ddd Do MMM");
    }
    return isCurrentDate(date) ? `Today, ${formatDate(date, "Do MMM")}` : formatDate(date, "ddd Do MMM");
  };
  return /* @__PURE__ */ React__default.createElement(Box, { style: { position: "relative" } }, /* @__PURE__ */ React__default.createElement(
    SelectToggle$1,
    {
      value: getDate(),
      onClickValue: handleOpenMenu,
      onNext: switchToNextDay,
      onPrevious: switchToPreviousDay,
      isSelected: isOpen,
      canClickValue: true,
      style: {
        value: breakpointMdDown ? { width: "115px", maxWidth: "115px" } : {}
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: openMenu,
      onClose: () => handleCloseMenu(),
      anchorEl,
      innerStyle: { marginTop: "10px", padding: "12px", borderRadius: "6px" },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      disableScrollLock: true
    },
    /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
      ObeeDatePicker,
      {
        inputProps: { inline: true },
        onSelect: changeDay,
        value: date,
        showTodayButton: true,
        style: { header: { backgroundColor: theme2.colors.menuHighlightBackground } }
      }
    ))
  ));
};
DateSelector.defaultProps = {
  date: null
};
DateSelector.propTypes = {
  date: momentPropTypes.momentObj,
  setObeeDate: PropTypes.func.isRequired
};
const mapStateToProps$f = (state) => ({
  user: state.user,
  date: state.obeeScreen.date
});
const mapDispatchToProps$f = (dispatch) => bindActionCreators(
  {
    setObeeDate: setObeeDateAction
  },
  dispatch
);
const DateSelector$1 = connect(mapStateToProps$f, mapDispatchToProps$f)(DateSelector);
const SettingsRedirectModal = ({ slug, onClose, isOpen }) => {
  return /* @__PURE__ */ React__default.createElement(
    CommsModal$1,
    {
      onClose,
      isOpen,
      onConfirm: () => {
        var _a;
        return (_a = window.open(`https://obee.com.au/${slug}/admin/settings.php`, "_blank")) == null ? void 0 : _a.focus();
      },
      heading: "Access settings",
      confirmLabel: "Continue, take me to Obee 2.0",
      prompt: "Click continue to open a new tab and access all of your settings from Obee 2.0. These will be accessible within your Obee 3.0 experience soon."
    }
  );
};
SettingsRedirectModal.defaultProps = {
  slug: "",
  isOpen: false
};
SettingsRedirectModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  slug: PropTypes.string,
  isOpen: PropTypes.bool
};
const mapStateToProps$e = (state) => {
  var _a, _b2;
  return {
    slug: (_b2 = (_a = state.restaurantActive) == null ? void 0 : _a.restaurant) == null ? void 0 : _b2.slug
  };
};
const mapDispatchToProps$e = (dispatch) => bindActionCreators({}, dispatch);
const SettingsRedirectModal$1 = connect(mapStateToProps$e, mapDispatchToProps$e)(SettingsRedirectModal);
const useStyles$7 = createUseStyles((theme2) => ({
  expandArrow: {
    marginTop: "3px",
    color: theme2.colors.black,
    transitionDuration: "0.1s"
  },
  pageSelectContainer: {
    display: "flex",
    height: "51px",
    alignItems: "center",
    padding: "10px",
    color: theme2.colors.charcoal,
    gap: "16px",
    userSelect: "none",
    position: "relative",
    marginLeft: "-10px",
    fontSize: "15px",
    // TODO get from theme
    [theme2.breakpoints.down("sm")]: {
      gap: "8px",
      padding: "0",
      marginLeft: "0"
    }
  },
  pageContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "12px"
  },
  row: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "8px"
  },
  menuText: {
    color: theme2.colors.menuText
  },
  pageIcon: {
    height: "20px",
    color: theme2.colors.linen
    // '&:child': {
    //   height: '16px',
    //   maxHeight: '16px',
    // },
  },
  pageText: {
    fontWeight: theme2.fontWeights.medium,
    cursor: "pointer",
    whiteSpace: "nowrap"
  },
  restaurantDropdownArrow: {
    color: theme2.colors.black,
    marginTop: "2px",
    width: "7px",
    transitionDuration: "0.1s"
  },
  menuItems: {
    alignItems: "center",
    padding: "16px"
  },
  menuItemContainer: {
    paddingBottom: "3px",
    borderBottom: `1px solid ${theme2.colors.cloud}`
  },
  menuItem: {
    display: "flex",
    cursor: "pointer",
    // margin: '8px',
    borderRadius: "8px",
    minWidth: "260px",
    // minHeight: '50px',
    marginTop: "3px",
    alignItems: "center",
    gap: "16px",
    "&:hover": {
      backgroundColor: theme2.colors.linen
    },
    [theme2.breakpoints.down("sm")]: {
      minWidth: "100px"
    }
  },
  itemIconContainer: {
    width: "47px",
    height: "47px",
    borderRadius: "7px",
    backgroundColor: theme2.colors.linen,
    color: "white",
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  },
  itemIcon: {
    alignItems: "center",
    marginLeft: "auto",
    marginRight: "auto",
    width: "fit-content",
    marginTop: "10px"
  },
  menuItemsContainer: {
    display: "flex"
  },
  menuItemContent: {
    display: "flex",
    gap: "10px",
    marginLeft: "-10px",
    ...theme2.typography.body.PL,
    lineHeight: "32px"
  },
  quickActionContent: {
    backgroundColor: theme2.colors.menuHighlightBackground,
    width: "240px",
    borderTopRightRadius: "18px",
    borderBottomRightRadius: "18px",
    padding: "20px",
    fontSize: "15px"
  },
  quickActionTitle: {
    fontWeight: theme2.fontWeights.medium,
    lineHeight: "20px",
    marginBottom: "8px"
  },
  quickActionListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  quickActionIcon: {
    color: theme2.colors.charcoal,
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  },
  quickActionItem: {
    display: "flex",
    cursor: "pointer",
    height: "40px",
    borderRadius: "8px",
    alignItems: "center",
    gap: "8px",
    padding: "8px",
    margin: "0 -8px",
    "&:hover": {
      backgroundColor: theme2.colors.white
    }
  },
  quickActionItemText: {
    fontSize: "15px"
    // marginLeft: '-20px',
  },
  logoContainer: {
    border: `1px solid ${theme2.colors.linenDark}`,
    borderRadius: "50px",
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));
const Navigation = ({ showNavigation, pageId, slug, obeeSettings: obeeSettings2, date }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$7();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [showSettingsRedirectModal, setShowSettingsRedirectModal] = useState(false);
  const openMenu = Boolean(anchorEl);
  const [openFullyBookModal, setOpenFullyBookModal] = useState(false);
  const getCurrentPage = (id) => pages.find((page) => (page == null ? void 0 : page.id) === id);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleOpenFullyBookModal = () => {
    setOpenFullyBookModal(true);
  };
  const handleCloseFullyBookModal = () => {
    setOpenFullyBookModal(false);
  };
  const handleClickOption = (action) => {
    action();
    handleOpenMenu(false);
  };
  const currentPage = getCurrentPage(pageId);
  const quickActions = [
    {
      action: () => {
        handleCloseMenu();
        handleOpenFullyBookModal();
      },
      label: "Fully book"
    },
    !isObee() && {
      action: () => {
        var _a;
        return history.push(`${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/floorplan/edit?view=list`, {
          from: history.location.pathname
        });
      },
      // icon: <IconBlockTable style={{ color: theme.colors.charcoal, height: '18px' }} />,
      label: "Block table"
    },
    {
      label: "Edit floor plan",
      action: () => {
        var _a;
        return history.push(`${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/floorplan/edit?view=map`, {
          from: history.location.pathname
        });
      }
    },
    {
      label: "Edit booking widget",
      action: () => {
        var _a;
        return history.push(`${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/settings?tab=bookingWidget`, {
          from: history.location.pathname
        });
      },
      hidden: !isObee() || !hasNewWidget(obeeSettings2.data)
    },
    {
      label: "Edit messaging settings",
      action: () => {
        var _a;
        return history.push(`${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/settings?tab=messages`, {
          from: history.location.pathname
        });
      },
      hidden: !isObee() || !hasNewWidget(obeeSettings2.data)
    }
  ].filter((item) => item && !(item == null ? void 0 : item.hidden));
  return /* @__PURE__ */ React__default.createElement(Box, { style: { position: "relative" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageSelectContainer }, /* @__PURE__ */ React__default.createElement(
    HeaderButton$1,
    {
      onClick: showNavigation,
      type: "round",
      style: { button: { position: "relative" } }
    },
    /* @__PURE__ */ React__default.createElement(Logo$1, { style: { color: theme2.colors.charcoal, width: "26px", height: "26px" } })
  ), /* @__PURE__ */ React__default.createElement(HeaderButton$1, { onClick: (e) => handleOpenMenu(e) }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: classes.row,
      style: { marginLeft: "-5px", gap: "5px", paddingRight: "5px" }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageIcon }, currentPage == null ? void 0 : currentPage.headerIcon),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.pageText }, currentPage == null ? void 0 : currentPage.pageName)
  ))), /* @__PURE__ */ React__default.createElement(
    SettingsRedirectModal$1,
    {
      slug: `https://obee.com.au/${slug}/admin`,
      onClose: () => setShowSettingsRedirectModal(false),
      isOpen: showSettingsRedirectModal
    }
  ), /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: openMenu,
      onClose: () => handleCloseMenu(),
      anchorEl,
      style: { marginTop: "-8px" },
      innerStyle: { padding: "0" }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.menuItemsContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.menuItems }, pages.map((page, index) => {
      const isActivePage = (page == null ? void 0 : page.id) === pageId;
      return /* @__PURE__ */ React__default.createElement(
        Box,
        {
          key: page.id,
          onClick: () => handleClickOption(() => {
            var _a;
            if (isObee() && (page == null ? void 0 : page.hiddenInObee)) {
              setShowSettingsRedirectModal(true);
              return;
            }
            history.push(`${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}${page == null ? void 0 : page.slug}`, {
              from: history.location.pathname
            });
          }),
          style: {
            ...index !== (pages == null ? void 0 : pages.length) - 1 ? {
              borderBottom: `1px solid ${theme2.colors.cloud}`,
              paddingBottom: "3px"
            } : {}
          }
        },
        /* @__PURE__ */ React__default.createElement(Box, { className: classes.menuItem }, /* @__PURE__ */ React__default.createElement(
          Box,
          {
            className: classes.itemIconContainer,
            style: {
              border: isActivePage && `1px solid ${theme2.colors.charcoal}`
            }
          },
          page == null ? void 0 : page.menuIcon
        ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.menuItemContent }, /* @__PURE__ */ React__default.createElement(Box, null, page == null ? void 0 : page.name)))
      );
    })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.quickActionContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.quickActionTitle }, "Quick actions"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.quickActionListContainer }, quickActions.map((quickAction) => /* @__PURE__ */ React__default.createElement(
      Box,
      {
        key: quickAction.label,
        className: classes.quickActionItem,
        onClick: quickAction.action
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: classes.quickActionItemText }, quickAction.label)
    )))))
  ), /* @__PURE__ */ React__default.createElement(DeferRender$1, { isShowing: openFullyBookModal }, /* @__PURE__ */ React__default.createElement(
    FullyBookModal$1,
    {
      isOpen: openFullyBookModal,
      onClose: handleCloseFullyBookModal,
      date
    }
  )));
};
Navigation.defaultProps = {
  pageId: "",
  slug: ""
};
Navigation.propTypes = {
  showNavigation: PropTypes.func.isRequired,
  pageId: PropTypes.string,
  slug: PropTypes.string
};
const mapStateToProps$d = (state) => {
  var _a, _b2, _c2, _d2;
  return {
    slug: ((_b2 = (_a = state.restaurantActive) == null ? void 0 : _a.restaurant) == null ? void 0 : _b2.slug) || ((_d2 = (_c2 = state == null ? void 0 : state.obeeSettings) == null ? void 0 : _c2.data) == null ? void 0 : _d2.slug),
    obeeSettings: state.obeeSettings,
    date: state.obeeScreen.date
  };
};
const mapDispatchToProps$d = (dispatch) => bindActionCreators({}, dispatch);
const Navigation$1 = connect(mapStateToProps$d, mapDispatchToProps$d)(Navigation);
const useStyles$6 = createUseStyles(
  (theme2) => ({
    modalBody: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      "@media print": {
        display: "none"
      }
    },
    modalBodyInner: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      overflowY: "scroll"
    },
    heading: {
      ...theme2.typography.heading.H3
    },
    content: {
      // padding: '10px 0',
      display: "flex",
      flexDirection: "column",
      fontSize: "15px",
      maxWidth: "332px",
      // 350px - 4px borders - 10px scrollbar
      gap: "8px",
      flex: 1
    },
    contentTop: {
      display: "flex",
      flexDirection: "column",
      gap: "0"
    },
    formSection: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      padding: "20px 6px 20px 16px",
      "&:not(:last-child)": {
        borderBottom: `1px solid ${theme2.colors.cloud}`
      }
    },
    interactiveFormSection: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      backgroundColor: "white",
      padding: "12px 6px 12px 12px",
      margin: "-12px -6px -12px -12px",
      borderRadius: "12px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme2.colors.touchSectionHover
      }
    },
    interactiveFormSectionActive: {
      backgroundColor: theme2.colors.touchSectionHover
    },
    subHeading: {
      fontWeight: theme2.fontWeights.medium,
      color: theme2.colors.charcoal,
      alignItems: "baseline",
      display: "flex",
      justifyContent: "space-between"
    },
    subHeadingHeading: {
      fontWeight: theme2.fontWeights.medium,
      maxWidth: "200px"
    },
    description: {
      color: theme2.colors.smoke
    },
    subSection: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      marginBottom: "8px"
    },
    section: {
      display: "flex",
      flexDirection: "column",
      gap: "4px"
    },
    footer: {
      borderTop: `1px solid ${theme2.colors.shark}`,
      padding: "8px 6px 8px 16px",
      position: "sticky",
      bottom: 0,
      background: theme2.colors.white,
      zIndex: 1,
      borderRadius: "0 0 8px 8px",
      maxWidth: "331px"
    },
    addPlaceholderText: {
      color: theme2.colors.smoke,
      cursor: "pointer",
      userSelect: "none",
      height: "36px",
      // To prevent jank when changing to text field
      lineHeight: "36px",
      alignItems: "center",
      transition: "color 0.1s",
      width: "fit-content",
      "&:hover": {
        color: theme2.colors.charcoal
      }
    },
    bookingStatus: {
      ...theme2.typography.heading.SUBHEAD,
      position: "relative",
      borderRadius: theme2.borderRadius.s,
      padding: "4px 10px",
      textTransform: "uppercase",
      backgroundColor: (props) => {
        var _a;
        return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.backgroundColor;
      },
      border: (props) => {
        var _a;
        return `1px solid ${(_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.outline}`;
      },
      color: (props) => {
        var _a;
        return (_a = props == null ? void 0 : props.bookingStatus) == null ? void 0 : _a.color;
      },
      display: "flex",
      alignItems: "center",
      gap: "8px",
      letterSpacing: "1.2px",
      "&:hover": {
        cursor: "pointer"
      }
    },
    outBy: {
      gap: "8px",
      display: "flex",
      alignItems: "center"
    },
    tab: {
      ...theme2.typography.body.P,
      fontWeight: theme2.fontWeights.medium,
      borderRadius: "100px",
      padding: "8px 10px",
      cursor: "pointer",
      color: theme2.colors.smoke,
      transition: "background 0.1s",
      "&:hover": {
        background: "#F9DAD860"
      }
    },
    bookingName: {
      // TODO make style out of this
      fontSize: "24px",
      fontWeight: theme2.fontWeights.medium,
      maxWidth: "250px",
      lineHeight: "28px"
    },
    tabContainer: {
      // margin: '0 -10px',
    },
    tabSelected: {
      background: "#F9DAD8",
      color: theme2.colors.brandPrimary
    },
    detailsContainer: {
      background: theme2.colors.linen,
      padding: "8px 16px",
      display: "flex",
      flexDirection: "column",
      gap: "12px"
    },
    headerContainer: {
      background: theme2.colors.linen,
      borderRadius: "20px 20px 0 0",
      // marginTop: '-10px',
      display: "flex",
      justifyContent: "space-between",
      // padding: '0 16px',
      padding: "18px 16px 0 16px",
      position: "sticky",
      top: "0",
      zIndex: "99",
      // width: '350px',
      // maxWidth: '350px',
      gap: "8px",
      flexDirection: "column"
    },
    availableContainer: {
      flexWrap: "wrap",
      padding: "8px",
      borderRadius: "4px",
      background: theme2.colors.yetAnotherGray17,
      display: "flex",
      rowGap: "8px",
      columnGap: "12px",
      alignItems: "baseline",
      maxWidth: "310px"
    },
    unavailableContainer: {
      flexWrap: "wrap",
      padding: "8px",
      borderRadius: "4px",
      background: theme2.colors.unavailableBackground,
      display: "flex",
      rowGap: "8px",
      columnGap: "12px",
      alignItems: "baseline",
      maxWidth: "310px"
    },
    availableRoomContainer: {
      display: "flex",
      gap: "8px",
      alignItems: "baseline"
    },
    availableRoom: {
      border: `1px solid ${theme2.colors.smoke}`,
      color: theme2.colors.smoke,
      borderRadius: "6px",
      padding: "0 8px"
    },
    interactiveItem: {
      display: "flex",
      gap: "16px",
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "6px",
      padding: "5px 10px",
      marginLeft: "-10px",
      marginRight: "-10px",
      border: `1px solid transparent`,
      alignItems: "center",
      transition: "background-color 0.1s",
      "&:hover": {
        backgroundColor: theme2.colors.notificationBackgroundGray
      }
    },
    activeItem: {
      backgroundColor: theme2.colors.notificationBackgroundGray,
      border: `1px solid ${theme2.colors.smoke}`
    },
    selectDate: {
      fontWeight: theme2.fontWeights.medium,
      fontSize: "15px",
      display: "flex",
      gap: "8px",
      padding: "10px 20px",
      cursor: "pointer",
      userSelect: "none",
      alignItems: "center",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: theme2.colors.notificationBackgroundGray
      }
    },
    incrementButton: {
      cursor: "pointer",
      userSelect: "none",
      width: "26px",
      height: "26px",
      backgroundColor: "white",
      outline: "1px solid #E8E8E8",
      borderRadius: "6px",
      alignItems: "center",
      "&:hover": {
        backgroundColor: theme2.colors.notificationBackgroundGray,
        outline: "1px solid black"
      }
    },
    guestsLabel: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      height: "18px"
    },
    guestsText: {
      width: "80px"
    },
    editButton: {
      fontWeight: theme2.fontWeights.regular,
      color: theme2.colors.olive3,
      "&:hover": {
        cursor: "pointer"
      }
    },
    historyContent: {
      padding: "12px 20px 20px 20px",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      fontSize: "15px",
      maxWidth: "342px",
      flex: 1,
      overflowY: "scroll"
    },
    itemContainer: {
      display: "flex",
      gap: "20px"
    },
    itemHeading: {
      fontWeight: theme2.fontWeights.bold,
      marginBottom: "4px"
    },
    itemHeadingContainer: {
      alignItems: "center",
      display: "flex",
      gap: "13px"
    },
    itemTimeCircle: {
      border: `1px solid ${theme2.colors.nimbus}`,
      borderRadius: "100%",
      display: "flex",
      height: "12px",
      position: "relative",
      width: "12px"
    },
    itemTimeLine: {
      borderRight: `1px dotted ${theme2.colors.shark}`,
      height: "calc(100% - 20px)",
      margin: "6px auto 0 auto",
      width: "0px"
    },
    itemSubHeading: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      flexShrink: 0
    },
    itemNote: {
      marginBottom: "2px"
    },
    itemsContainer: {
      width: "100%",
      maxWidth: "380px"
    },
    historyHeader: {
      fontSize: theme2.fontSizes.m2,
      color: theme2.colors.smoke,
      marginBottom: "4px"
    },
    historySubHeader: {
      fontSize: theme2.fontSizes.h4
    },
    bookingWarningContainer: {
      background: theme2.colors.apricotLight,
      margin: "-12px -12px 0 -12px"
    },
    bookingWarningHeader: {
      padding: "8px 12px",
      display: "flex",
      justifyContent: "space-between",
      fontSize: "15px",
      // TODO
      fontWeight: "500",
      alignItems: "center"
    },
    bookingWarningType: {
      color: "#C46E2A",
      // TODO
      display: "flex",
      gap: "8px",
      alignItems: "center"
    },
    bookingWarningButton: {
      cursor: "pointer"
    },
    bookingWarningInfo: {
      padding: "12px",
      fontSize: "15px",
      color: theme2.colors.smoke
    },
    errorMessage: {
      ...theme2.typography.body.P,
      padding: "20px",
      textAlign: "center"
    },
    historyDetailsContainer: {
      fontSize: "15px",
      margin: "-4px 0 40px 0",
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      width: "100%"
    },
    visitsContainer: {
      display: "flex"
    },
    visitItem: {
      flexBasis: "50%"
    },
    visitDivider: {
      margin: "0 28px",
      borderLeft: `1px solid ${theme2.colors.cloud}`
    },
    footerButtons: {
      display: "flex",
      gap: "8px"
    },
    chargeNoShowInfo: {
      padding: "12px",
      fontSize: "15px",
      color: theme2.colors.smoke,
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    chargeNoShowHeader: {
      padding: "8px 12px",
      display: "flex",
      fontSize: "15px",
      fontWeight: theme2.fontWeights.medium,
      alignItems: "center",
      gap: "8px",
      color: (props) => (props == null ? void 0 : props.charged) ? "#4E804D" : "#C46E2A"
      // TODO refactor to theme
    },
    chargeNoShowContainer: {
      background: (props) => (props == null ? void 0 : props.charged) ? "#E3ECE2" : theme2.colors.apricotLight
      // TODO refactor
    },
    chargeNoShowItem: {
      display: "flex",
      justifyContent: "space-between",
      gap: "16px",
      overflow: "hidden"
    },
    chargeNoShowAmountCharged: {
      color: theme2.colors.charcoal,
      fontWeight: theme2.fontWeights.bold
    },
    chargeNoShowDetail: {
      color: theme2.colors.charcoal,
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    buttonContainer: {
      width: "100%",
      gap: "12px",
      justifyContent: "space-between",
      display: "flex",
      [theme2.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems: "center"
      }
    },
    commentContainer: {
      display: "flex",
      fontSize: "12px",
      lineHeight: "18px",
      maxWidth: "342px",
      flexDirection: "column",
      whiteSpace: "pre-wrap",
      gap: "8px",
      color: theme2.colors.smoke,
      boarderRadius: `1px solid ${theme2.colors.smoke}`
    }
  }),
  { name: "BookingDetailsModal" }
);
const tabBarStyles = (theme2) => ({
  fontWeight: theme2.fontWeights.medium,
  containerInner: {
    gap: "12px",
    padding: "0"
  },
  tab: {
    // padding: '2px 10px',
    padding: "10px 6px 10px 6px",
    marginLeft: 0,
    // margin: '0 8px 0 0',
    // borderRadius: '100px',
    fontSize: "15px",
    whiteSpace: "nowrap",
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
    // border: '1px solid transparent',
    // paddingBottom: '2px',
    color: theme2.colors.smoke
  },
  tabActive: {
    // color: theme.colors.charcoal,
    // border: `1px solid ${theme.colors.charcoal}`,
    // borderBottom: `1px solid ${theme.colors.charcoal}`,
    // paddingBottom: '2px',
    backgroundSize: "8px 14px, calc(100% - 8px) 14px",
    backgroundPositionY: "20px"
  },
  tabHover: {
    color: theme2.colors.black
  }
});
const CustomerDetails = ({
  booking,
  updateObeeGuest,
  obeeGuests: obeeGuests2,
  updateObeeBooking: updateObeeBooking2,
  obeeBookings: obeeBookings2
}) => {
  var _a;
  const theme2 = useTheme$1();
  const classes = useStyles$6();
  const [updating, setUpdating] = useState(false);
  const guest = (_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a[0];
  const [firstName, setFirstName] = useState(guest == null ? void 0 : guest.firstName);
  const [firstNameErrors, setFirstNameErrors] = useState("");
  const [lastName, setLastName] = useState(guest == null ? void 0 : guest.lastName);
  const [mobile, setMobile] = useState(guest == null ? void 0 : guest.mobile);
  const [mobileErrors, setMobileErrors] = useState("");
  const [landline, setLandline] = useState(guest == null ? void 0 : guest.landline);
  useState("");
  const [email, setEmail] = useState(guest == null ? void 0 : guest.email);
  const [emailErrors, setEmailErrors] = useState("");
  const [marketingPreferences, setMarketingPreferences] = useState(guest == null ? void 0 : guest.marketingPreferences);
  const [description2, setDescription] = useState(guest == null ? void 0 : guest.description);
  const [notes, setNotes] = useState(guest == null ? void 0 : guest.notes);
  const [birthday, setBirthday] = useState(guest == null ? void 0 : guest.birthday);
  const [address, setAddress] = useState(guest == null ? void 0 : guest.address);
  const [interests, setInterests] = useState(guest == null ? void 0 : guest.interests);
  const [jobCompany, setJobCompany] = useState(guest == null ? void 0 : guest.jobCompany);
  const [vip, setVip] = useState(guest == null ? void 0 : guest.vip);
  const [blacklisted, setBlacklisted] = useState(guest == null ? void 0 : guest.blacklisted);
  const [allergies, setAllergies] = useState(guest == null ? void 0 : guest.allergies);
  const [preferredTableArea, setPreferredTableArea] = useState(guest == null ? void 0 : guest.preferredTableArea);
  const [favouriteMeals, setFavouriteMeals] = useState(guest == null ? void 0 : guest.favouriteMeals);
  const [favouriteDrinks, setFavouriteDrinks] = useState(guest == null ? void 0 : guest.favouriteDrinks);
  const [website, setWebsite] = useState(guest == null ? void 0 : guest.website);
  const [blog, setBlog] = useState(guest == null ? void 0 : guest.blog);
  const [facebook, setFacebook] = useState(guest == null ? void 0 : guest.facebook);
  const [twitter, setTwitter] = useState(guest == null ? void 0 : guest.twitter);
  const [instagram, setInstagram] = useState(guest == null ? void 0 : guest.instagram);
  const [pinterest, setPinterest] = useState(guest == null ? void 0 : guest.pinterest);
  const [linkedIn, setLinkedIn] = useState(guest == null ? void 0 : guest.linkedIn);
  const requiredErrorMsg = "This field is required.";
  const validPhoneErrorMsg = "A valid phone number is required.";
  const validEmailErrorMsg = "A valid email is required.";
  useEffect(() => {
    unstable_batchedUpdates(() => {
      setFirstName(guest == null ? void 0 : guest.firstName);
      setLastName(guest == null ? void 0 : guest.lastName);
      setMobile(guest == null ? void 0 : guest.mobile);
      setEmail(guest == null ? void 0 : guest.email);
      setMarketingPreferences(guest == null ? void 0 : guest.marketingPreferences);
      setDescription(guest == null ? void 0 : guest.description);
      setNotes(guest == null ? void 0 : guest.notes);
      setBirthday(guest == null ? void 0 : guest.birthday);
      setAddress(guest == null ? void 0 : guest.address);
      setInterests(guest == null ? void 0 : guest.interests);
      setJobCompany(guest == null ? void 0 : guest.jobCompany);
      setVip(guest == null ? void 0 : guest.vip);
      setBlacklisted(guest == null ? void 0 : guest.blacklisted);
      setAllergies(guest == null ? void 0 : guest.allergies);
      setPreferredTableArea(guest == null ? void 0 : guest.preferredTableArea);
      setFavouriteMeals(guest == null ? void 0 : guest.favouriteMeals);
      setFavouriteDrinks(guest == null ? void 0 : guest.favouriteDrinks);
      setWebsite(guest == null ? void 0 : guest.website);
      setBlog(guest == null ? void 0 : guest.blog);
      setFacebook(guest == null ? void 0 : guest.facebook);
      setTwitter(guest == null ? void 0 : guest.twitter);
      setInstagram(guest == null ? void 0 : guest.instagram);
      setPinterest(guest == null ? void 0 : guest.pinterest);
      setLinkedIn(guest == null ? void 0 : guest.linkedIn);
    });
  }, [booking == null ? void 0 : booking.id]);
  const handleSaveChanges = () => {
    let isValid = true;
    if (isEmpty(firstName)) {
      setFirstNameErrors(requiredErrorMsg);
      isValid = false;
    }
    if (isEmpty(mobile)) {
      setMobileErrors(requiredErrorMsg);
      isValid = false;
    } else if (!isMobilePhone(mobile)) {
      setMobileErrors(validPhoneErrorMsg);
      isValid = false;
    }
    if (!isEmpty(email) && !isEmail(email)) {
      setEmailErrors(validEmailErrorMsg);
      isValid = false;
    }
    if (!isValid) {
      return;
    }
    setUpdating(true);
    const newGuest = {
      ...guest,
      address,
      birthday,
      blacklisted,
      blog,
      description: description2,
      email,
      marketingPreferences,
      facebook,
      favouriteDrinks,
      favouriteMeals,
      firstName,
      instagram,
      interests,
      jobCompany,
      vip,
      landline,
      lastName,
      linkedIn,
      mobile,
      notes,
      pinterest,
      allergies,
      preferredTableArea,
      twitter,
      website
    };
    if (guest) {
      updateObeeGuest(guest.id, newGuest);
    } else {
      updateObeeBooking2({
        ...booking,
        name: [firstName, lastName].join(" ").trim(),
        guests: [newGuest]
      });
    }
  };
  useEffect(() => {
    if (updating && (obeeGuests2.success || obeeGuests2.error)) {
      setUpdating(false);
    }
  }, [obeeGuests2.success, obeeGuests2.error]);
  useEffect(() => {
    if (updating && (obeeBookings2.success || obeeBookings2.error)) {
      setUpdating(false);
    }
  }, [obeeBookings2.success, obeeBookings2.error]);
  const textFieldStyles2 = {
    input: { fontSize: "inherit", padding: "8px 10px", paddingLeft: "10px" }
  };
  const toggleStyles = {
    labelRow: { width: "100px" }
  };
  const marketingPreferencesStyles = {
    ...multiSelectStyles,
    label: {
      width: "100px"
    }
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBodyInner }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.contentTop }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Contact details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "First name",
      value: firstName,
      onChange: setFirstName,
      error: firstNameErrors,
      clearError: () => setFirstNameErrors(""),
      required: true,
      style: textFieldStyles2
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Last name",
      value: lastName,
      onChange: setLastName,
      style: textFieldStyles2
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Phone",
      value: mobile,
      onChange: setMobile,
      error: mobileErrors,
      clearError: () => setMobileErrors(""),
      required: true,
      style: textFieldStyles2,
      type: "tel"
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Email",
      value: email,
      onChange: setEmail,
      error: emailErrors,
      style: textFieldStyles2,
      clearError: () => setEmailErrors("")
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanDropdownPopover$1,
    {
      label: "Marketing",
      items: marketingPreferenceOptions(),
      value: marketingPreferences,
      selectedItems: marketingPreferences,
      onSelect: (selectedItem) => setMarketingPreferences(toggleListItem(marketingPreferences, selectedItem)),
      style: marketingPreferencesStyles,
      multiselect: true,
      popoverProps: { innerProps: { disableScrollLock: true } }
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Additional details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Description",
      value: description2,
      style: textFieldStyles2,
      onChange: setDescription
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Notes",
      value: notes,
      style: textFieldStyles2,
      onChange: setNotes
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Birthday",
      value: birthday,
      style: textFieldStyles2,
      onChange: setBirthday,
      placeholder: "DD/MM/YYYY",
      format: (inputValue) => {
        if ((birthday == null ? void 0 : birthday.length) > (inputValue == null ? void 0 : inputValue.length)) {
          return inputValue;
        }
        let newValue = inputValue;
        if ((newValue == null ? void 0 : newValue.length) === 2 || (newValue == null ? void 0 : newValue.length) === 5) {
          newValue += "/";
        }
        return newValue;
      },
      maxCharacters: 10
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Address",
      value: address,
      style: textFieldStyles2,
      onChange: setAddress
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Interests",
      value: interests,
      style: textFieldStyles2,
      onChange: setInterests
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Work",
      value: jobCompany,
      style: textFieldStyles2,
      onChange: setJobCompany
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookToggle,
    {
      label: "VIP",
      value: vip,
      onChange: (value) => setVip(value),
      loading: false,
      styles: toggleStyles
    }
  ), /* @__PURE__ */ React__default.createElement(
    GuestBookToggle,
    {
      label: "Blacklisted",
      value: blacklisted,
      onChange: (value) => setBlacklisted(value),
      loading: false,
      styles: toggleStyles
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Preferences"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Dietary",
      value: allergies,
      onChange: setAllergies,
      style: textFieldStyles2
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Table",
      value: preferredTableArea,
      onChange: setPreferredTableArea,
      style: textFieldStyles2
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Meals",
      value: favouriteMeals,
      style: textFieldStyles2,
      onChange: setFavouriteMeals
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Drinks",
      value: favouriteDrinks,
      style: textFieldStyles2,
      onChange: setFavouriteDrinks
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Website and socials"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      style: textFieldStyles2,
      label: "Website",
      value: website,
      onChange: setWebsite
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      style: textFieldStyles2,
      label: "Blog",
      value: blog,
      onChange: setBlog
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      style: textFieldStyles2,
      label: "Facebook",
      value: facebook,
      onChange: setFacebook
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      style: textFieldStyles2,
      label: "Twitter",
      value: twitter,
      onChange: setTwitter
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      style: textFieldStyles2,
      label: "Instagram",
      value: instagram,
      onChange: setInstagram
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      style: textFieldStyles2,
      label: "Pinterest",
      value: pinterest,
      onChange: setPinterest
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      style: textFieldStyles2,
      label: "LinkedIn",
      value: linkedIn,
      onChange: setLinkedIn
    }
  ))))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.footer }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "primary",
      style: largeButtonStyles(theme2),
      onClick: handleSaveChanges,
      loading: updating,
      text: "Save changes"
    }
  )));
};
CustomerDetails.defaultProps = {
  booking: null
};
CustomerDetails.propTypes = {
  booking: obeeBookingsPropTypes,
  updateObeeGuest: PropTypes.func.isRequired,
  obeeGuests: obeeGuestsPropTypes.isRequired,
  updateObeeBooking: PropTypes.func.isRequired,
  obeeBookings: obeeBookingsPropTypes.isRequired
};
const mapStateToProps$c = (state) => ({
  obeeGuests: state.obeeGuests,
  obeeBookings: state.obeeBookings
});
const mapDispatchToProps$c = (dispatch) => bindActionCreators(
  {
    updateObeeGuest: updateObeeGuestAction,
    updateObeeBooking: updateObeeBookingAction
  },
  dispatch
);
const CustomerDetails$1 = connect(mapStateToProps$c, mapDispatchToProps$c)(CustomerDetails);
const BookingFooter = ({
  handleSaveChanges,
  handleForce,
  handleAddToWaitlist,
  updating,
  tableNumber,
  requiresUpdateCheck,
  allowSaving,
  areaName,
  checking,
  obeeUpdateCheck,
  obeeSettings: obeeSettings2,
  obeeStaff,
  takenByError
}) => {
  var _a, _b2, _c2, _d2, _e2, _f;
  const theme2 = useTheme$1();
  const classes = useStyles$6();
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [takenBy, setTakenBy] = useState(null);
  const [staffAnchorEl, setStaffAnchorEl] = useState(null);
  const staffItems = useMemo(
    () => {
      var _a2, _b3;
      return (_b3 = (_a2 = obeeStaff.data) == null ? void 0 : _a2.map((obeeStaffMember) => (obeeStaffMember == null ? void 0 : obeeStaffMember.appearAs) || (obeeStaffMember == null ? void 0 : obeeStaffMember.fullName))) == null ? void 0 : _b3.sort(sortValues).map((staffName) => ({ label: staffName, value: staffName }));
    },
    [obeeStaff.data]
  );
  if (!requiresUpdateCheck && !allowSaving) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  const isAvailable = requiresUpdateCheck && !checking && ((_a = obeeUpdateCheck.data) == null ? void 0 : _a.available) === true;
  const isUnavailable = requiresUpdateCheck && !checking && ((_b2 = obeeUpdateCheck.data) == null ? void 0 : _b2.available) === false;
  const hasStaff = !isEmpty(staffItems);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.footer }, /* @__PURE__ */ React__default.createElement(Box, null, checking && /* @__PURE__ */ React__default.createElement(Box, { className: classes.subSection }, /* @__PURE__ */ React__default.createElement(Skeleton$1, { height: 46, width: 310, style: { skeleton: { borderRadius: "4px" } } })), isAvailable && /* @__PURE__ */ React__default.createElement(Box, { className: classes.subSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.availableContainer }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(
    Pill,
    {
      backgroundColor: theme2.colors.pillAvailable,
      color: theme2.colors.bodyText,
      style: { container: { borderRadius: "6px", fontSize: "inherit" } }
    },
    "Available"
  )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.availableRoomContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.availableRoom }, tableNumber), /* @__PURE__ */ React__default.createElement(Box, null, areaName)))), isUnavailable && /* @__PURE__ */ React__default.createElement(Box, { className: classes.subSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.unavailableContainer }, /* @__PURE__ */ React__default.createElement(
    Pill,
    {
      backgroundColor: theme2.colors.rose,
      color: theme2.colors.errorRed,
      style: { container: { borderRadius: "6px", fontSize: "inherit" } }
    },
    "No availability"
  ))), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 12 }, showField((_c2 = obeeSettings2.data) == null ? void 0 : _c2.abTakenBy) && /* @__PURE__ */ React__default.createElement(Box, null, isObee() ? /* @__PURE__ */ React__default.createElement(
    CleanTextFieldComponent,
    {
      label: "Staff name",
      value: takenBy,
      onChange: setTakenBy,
      error: takenByError,
      required: ((_d2 = obeeSettings2.data) == null ? void 0 : _d2.abTakenBy) === "mandatory"
    }
  ) : hasStaff && /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Staff name",
      value: takenBy,
      onClick: (e) => {
        setStaffAnchorEl(e.currentTarget);
      },
      isActive: !!staffAnchorEl,
      error: takenByError,
      required: ((_e2 = obeeSettings2.data) == null ? void 0 : _e2.abTakenBy) === "mandatory"
    }
  )), isUnavailable && /* @__PURE__ */ React__default.createElement(Box, { className: classes.footerButtons }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "tertiary",
      style: largeButtonStyles(theme2),
      onClick: () => setOpenConfirmation(true),
      loading: updating,
      text: "Force"
    }
  ), ((_f = obeeSettings2.data) == null ? void 0 : _f.waitlist) && /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "primary",
      style: largeButtonStyles(theme2),
      onClick: () => handleAddToWaitlist(takenBy),
      loading: updating,
      text: "Add to waitlist"
    }
  )), !isUnavailable && allowSaving && /* @__PURE__ */ React__default.createElement(Box, { className: classes.footerButtons }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "primary",
      style: largeButtonStyles(theme2),
      onClick: () => handleSaveChanges(takenBy),
      disabled: updating || checking,
      loading: updating || checking,
      text: "Save changes"
    }
  )))), /* @__PURE__ */ React__default.createElement(
    ForceConfirmationModal$1,
    {
      isOpen: openConfirmation,
      onClose: () => setOpenConfirmation(false),
      onConfirm: () => handleForce(takenBy)
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: staffItems,
      onSelect: setTakenBy,
      anchor: staffAnchorEl,
      isOpen: !!staffAnchorEl,
      onClose: () => setStaffAnchorEl(null),
      style: listPopoverStyles$2,
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    }
  ));
};
BookingFooter.defaultProps = {
  takenByError: null,
  areaName: null,
  tableNumber: null
};
BookingFooter.propTypes = {
  handleSaveChanges: PropTypes.func.isRequired,
  handleForce: PropTypes.func.isRequired,
  handleAddToWaitlist: PropTypes.func.isRequired,
  updating: PropTypes.bool.isRequired,
  tableNumber: PropTypes.string,
  requiresUpdateCheck: PropTypes.bool.isRequired,
  allowSaving: PropTypes.bool.isRequired,
  areaName: PropTypes.string,
  checking: PropTypes.bool.isRequired,
  obeeUpdateCheck: obeeUpdateCheckPropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  obeeStaff: obeeStaffPropTypes.isRequired,
  takenByError: PropTypes.string
};
const mapStateToProps$b = (state) => ({
  obeeUpdateCheck: state.obeeUpdateCheck,
  obeeSettings: state.obeeSettings,
  obeeStaff: state.obeeStaff
});
const mapDispatchToProps$b = (dispatch) => bindActionCreators({}, dispatch);
const BookingFooter$1 = connect(mapStateToProps$b, mapDispatchToProps$b)(BookingFooter);
const SvgBookingWarning = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 35 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M32.6696 20.7301C31.012 21.5403 29.6149 21.3133 28.2812 20.0518C28.2597 20.0316 28.2312 20.0213 28.2019 20.0241C27.0352 20.137 24.6556 19.9949 23.5779 19.1356C22.5743 18.3355 21.6184 17.634 21.3895 15.9035C21.2064 14.5191 20.6686 14.0033 20.4226 13.9184C19.9306 13.7487 18.8423 12.9951 18.425 11.338C18.0208 9.73311 19.2671 7.61274 20.0031 6.66654C20.0462 6.61116 20.0582 6.53745 20.0354 6.47109C19.5262 4.98479 19.7996 3.7315 20.9975 2.80754C21.5384 2.39044 21.7519 1.96104 21.8724 1.34296C21.9806 0.7715 21.7594 0.656392 21.2717 0.561912C19.3731 0.188761 17.4241 0.129067 15.5051 0.385291C5.73456 1.70871 -0.85609 10.9119 1.29907 20.3132C2.87174 27.1642 9.22995 34.5308 19.8187 33.5378C26.4608 32.9127 32.495 27.9223 34.2533 21.6155C34.2984 21.4545 34.3089 21.2854 34.3526 21.0231C33.7569 20.9048 33.0672 20.5345 32.6696 20.7301Z", fill: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M17.5938 30.4297C25.0496 30.4297 31.0938 24.3855 31.0938 16.9297C31.0938 9.47384 25.0496 3.42969 17.5938 3.42969C10.1379 3.42969 4.09375 9.47384 4.09375 16.9297C4.09375 24.3855 10.1379 30.4297 17.5938 30.4297Z", fill: "#E09A63" }), /* @__PURE__ */ React$7.createElement("path", { d: "M18.9802 19.122L19.2502 12.75V9.906H16.1542V12.75L16.4242 19.122H18.9802ZM15.9922 22.47C15.9922 21.498 16.7842 20.706 17.7202 20.706C18.6922 20.706 19.4842 21.498 19.4842 22.47C19.4842 23.424 18.6922 24.198 17.7202 24.198C16.7842 24.198 15.9922 23.424 15.9922 22.47Z", fill: "white" }));
const IconBookingWarning = SvgBookingWarning;
const BookingWarning = ({ booking, updateBooking, obeeBookings: obeeBookings2, obeeSettings: obeeSettings2 }) => {
  const classes = useStyles$6();
  const [canExtend, setCanExtend] = useState(false);
  useEffect(() => {
    var _a, _b2;
    setCanExtend(false);
    if (booking && booking.duration < ((_a = obeeSettings2.data) == null ? void 0 : _a.bookingsDuration)) {
      const conflict = (_b2 = obeeBookings2.data) == null ? void 0 : _b2.find(
        (bookingToCheck) => {
          var _a2;
          return bookingsOnSameTable(booking, bookingToCheck) && booking.startTime < bookingToCheck.startTime && booking.startTime + ((_a2 = obeeSettings2.data) == null ? void 0 : _a2.bookingsDuration) > bookingToCheck.startTime;
        }
      );
      setCanExtend(!conflict);
    }
  }, [booking == null ? void 0 : booking.startTime, booking == null ? void 0 : booking.tableNumber]);
  const extend = () => {
    var _a;
    updateBooking({ ...booking, duration: (_a = obeeSettings2.data) == null ? void 0 : _a.bookingsDuration });
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingWarningContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingWarningHeader }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingWarningType }, /* @__PURE__ */ React__default.createElement(IconBookingWarning, { style: { height: "28px", flexShrink: 0 } }), "Short booking time"), canExtend && /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingWarningButton, onClick: extend }, "Extend")), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingWarningInfo }, "This booking has a shorter duration of ", booking == null ? void 0 : booking.duration, " minutes."));
};
BookingWarning.defaultProps = {
  booking: null
};
BookingWarning.propTypes = {
  booking: obeeBookingPropTypes,
  updateBooking: PropTypes.func.isRequired,
  obeeBookings: obeeBookingsPropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired
};
const mapStateToProps$a = (state) => ({
  obeeBookings: state.obeeBookings,
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps$a = (dispatch) => bindActionCreators(
  {
    updateBooking: updateObeeBookingAction
  },
  dispatch
);
const BookingWarning$1 = connect(mapStateToProps$a, mapDispatchToProps$a)(BookingWarning);
const SvgBookingSuccess = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 35 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M32.1579 21.5896C30.5002 22.3999 29.1032 22.1729 27.7694 20.9114C27.748 20.8912 27.7195 20.8808 27.6901 20.8837C26.5234 20.9965 24.1439 20.8545 23.0661 19.9952C22.0625 19.195 21.1067 18.4936 20.8778 16.7631C20.6947 15.3786 20.1569 14.8628 19.9109 14.778C19.4189 14.6083 18.3306 13.8546 17.9133 12.1975C17.5091 10.5927 18.7553 8.47232 19.4914 7.52612C19.5344 7.47074 19.5465 7.39704 19.5237 7.33067C19.0145 5.84437 19.2879 4.59108 20.4858 3.66713C21.0267 3.25002 21.2402 2.82062 21.3607 2.20254C21.4689 1.63108 21.2477 1.51597 20.76 1.42149C18.8613 1.04834 16.9124 0.988648 14.9934 1.24487C5.22284 2.56829 -1.36781 11.7714 0.78735 21.1728C2.36002 28.0238 8.71823 35.3903 19.307 34.3974C25.9491 33.7723 31.9833 28.7818 33.7416 22.4751C33.7867 22.314 33.7972 22.145 33.8409 21.8827C33.2452 21.7644 32.5555 21.3941 32.1579 21.5896Z", fill: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M16.741 31.0944C24.1968 31.0944 30.241 25.0502 30.241 17.5944C30.241 10.1385 24.1968 4.09436 16.741 4.09436C9.28512 4.09436 3.24097 10.1385 3.24097 17.5944C3.24097 25.0502 9.28512 31.0944 16.741 31.0944Z", fill: "#4E804D" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.241 19.0944L14.241 22.0944L23.241 13.0944", stroke: "white" }));
const IconBookingSuccess = SvgBookingSuccess;
const useStyles$5 = createUseStyles((theme2) => ({
  buttonContainer: {
    width: "100%",
    gap: "15px",
    justifyContent: "space-between",
    display: "flex",
    [theme2.breakpoints.down("md")]: {
      flexDirection: "column-reverse",
      alignItems: "center"
    }
  },
  modalHeading: {
    fontSize: "28px",
    fontWeight: theme2.fontWeights.black
  },
  modalHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  modalInfo: {
    color: theme2.colors.smoke
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    fontSize: "15px",
    color: theme2.colors.charcoal
  },
  modalItems: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  modalItem: {
    display: "flex",
    gap: "12px"
  },
  modalItemLabel: {
    width: "120px",
    color: theme2.colors.smoke
  },
  modalFeeContainer: (props) => ({
    background: !(props == null ? void 0 : props.processed) ? theme2.colors.dune : (props == null ? void 0 : props.success) ? theme2.colors.successGreenLight : theme2.colors.errorRedLight,
    display: "flex",
    padding: "12px",
    borderRadius: "8px",
    flexDirection: "column",
    gap: "12px"
  }),
  feeItem: {
    display: "flex",
    justifyContent: "space-between"
  },
  feeLabel: {
    fontWeight: theme2.fontWeights.medium
  },
  feeValue: {
    fontWeight: theme2.fontWeights.black
  },
  processResult: {
    display: "flex",
    gap: "8px"
  },
  processResultHeading: {
    fontWeight: theme2.fontWeights.bold,
    lineHeight: "28px"
  },
  processResultDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  item: {
    display: "flex",
    gap: "8px",
    alignItems: "center"
  }
}));
const SvgChargeSucceeded = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M14.21 27.1885C21.6658 27.1885 27.71 21.1444 27.71 13.6885C27.71 6.23266 21.6658 0.188507 14.21 0.188507C6.75412 0.188507 0.709961 6.23266 0.709961 13.6885C0.709961 21.1444 6.75412 27.1885 14.21 27.1885Z", fill: "#4E804D" }), /* @__PURE__ */ React$7.createElement("path", { d: "M8.70996 15.1885L11.71 18.1885L20.71 9.18851", stroke: "white" }));
const IconChargeSuccess = SvgChargeSucceeded;
const SvgChargeFailed = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M13.7775 27.1885C21.116 27.1885 27.065 21.1444 27.065 13.6885C27.065 6.23266 21.116 0.188507 13.7775 0.188507C6.43901 0.188507 0.48999 6.23266 0.48999 13.6885C0.48999 21.1444 6.43901 27.1885 13.7775 27.1885Z", fill: "#DA5A5A" }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.34839 18.2771C10.8242 16.8229 16.1126 11.6121 18.5723 9.18851", stroke: "white", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M9.34839 9.18851C9.96332 9.79441 15.4977 15.2475 18.5723 18.2771", stroke: "white", strokeLinecap: "round" }));
const IconChargeFailed = SvgChargeFailed;
const PROCESSED_TYPES = {
  IDLE: "idle",
  SUCCESS: "success",
  ERROR: "error"
};
const ChargeNoShowModal = ({
  isOpen,
  onClose,
  booking,
  chargeNoShow: chargeNoShow2,
  obeeChargeNoShow,
  clearChargeNoShow
}) => {
  var _a;
  const [processed, setProcessed] = useState(PROCESSED_TYPES.IDLE);
  const classes = useStyles$5({
    success: processed === PROCESSED_TYPES.SUCCESS,
    processed: processed !== PROCESSED_TYPES.IDLE
  });
  const onConfirm = () => chargeNoShow2(booking);
  useEffect(() => {
    if (isOpen) {
      setProcessed(PROCESSED_TYPES.IDLE);
      clearChargeNoShow();
    }
  }, [isOpen]);
  useEffect(() => {
    if (obeeChargeNoShow.success) {
      setProcessed(
        (booking == null ? void 0 : booking.ccNoShowChargeStatus) === "succeeded" ? PROCESSED_TYPES.SUCCESS : PROCESSED_TYPES.ERROR
      );
    }
  }, [obeeChargeNoShow.success]);
  useEffect(() => {
    if (obeeChargeNoShow.error) {
      setProcessed(PROCESSED_TYPES.ERROR);
    }
  }, [obeeChargeNoShow.error]);
  const noShowFee = getNoShowFee(booking);
  const cardNumber = isObee() ? booking == null ? void 0 : booking.ccNoShowChargeDisplayNumber : booking == null ? void 0 : booking.paymentMethodId;
  return /* @__PURE__ */ React__default.createElement(
    PromptModal$1,
    {
      isOpen,
      onClose,
      heading: "Charge no-show fee",
      confirmLabel: processed === PROCESSED_TYPES.SUCCESS && "Exit" || processed === PROCESSED_TYPES.ERROR && "Charge again" || "Process charge",
      loadingConfirm: obeeChargeNoShow.pending,
      closeLabel: processed === PROCESSED_TYPES.ERROR ? "Exit" : "Cancel",
      allowCancel: processed !== PROCESSED_TYPES.SUCCESS,
      onConfirm: processed === PROCESSED_TYPES.SUCCESS ? onClose : onConfirm
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalInfo }, "Total amount will be charged to the customer’s credit card."), /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItems }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItemLabel }, "Guest name"), /* @__PURE__ */ React__default.createElement(Box, null, getBookingName(booking))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItemLabel }, "Total guests"), /* @__PURE__ */ React__default.createElement(Box, null, `${booking == null ? void 0 : booking.size} ${pluralise("guest", booking == null ? void 0 : booking.size)}`)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItemLabel }, "Fee per ", booking == null ? void 0 : booking.ccNoShowChargeType), /* @__PURE__ */ React__default.createElement(Box, null, `${formatCurrency(booking == null ? void 0 : booking.ccNoShowFee, true, "$0", true)} per ${booking == null ? void 0 : booking.ccNoShowChargeType}`)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalItemLabel }, "Credit Card"), /* @__PURE__ */ React__default.createElement(Box, null, cardNumber))), /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", flexDirection: "column", gap: "8px" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalFeeContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.feeItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.feeLabel }, "Total"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.feeValue }, formatCurrency(noShowFee, true, "Invalid amount", true))), processed === PROCESSED_TYPES.SUCCESS && /* @__PURE__ */ React__default.createElement(Box, { className: classes.processResult }, /* @__PURE__ */ React__default.createElement(IconChargeSuccess, { style: { height: "28px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.processResultDetails }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.item }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.processResultHeading }, "Success:"), /* @__PURE__ */ React__default.createElement(Box, null, `Customer charged on ${formatDate(
      moment$3(booking == null ? void 0 : booking.ccNoShowChargeTime),
      "DD/MM/YYYY"
    )}`)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.item }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.processResultHeading }, "Transaction ID:"), /* @__PURE__ */ React__default.createElement(Box, null, (_a = booking == null ? void 0 : booking.ccNoShowPaymentIntentId) == null ? void 0 : _a.slice(-8))))), processed === PROCESSED_TYPES.ERROR && /* @__PURE__ */ React__default.createElement(Box, { className: classes.processResult }, /* @__PURE__ */ React__default.createElement(IconChargeFailed, { style: { height: "28px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.processResultDetails }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.processResultHeading }, "Charge request failed"), /* @__PURE__ */ React__default.createElement(Box, null, "Unable to charge the credit card on file"))))))
  );
};
ChargeNoShowModal.defaultProps = {
  booking: null
};
ChargeNoShowModal.propTypes = {
  booking: obeeBookingPropTypes,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  chargeNoShow: PropTypes.func.isRequired,
  clearChargeNoShow: PropTypes.func.isRequired,
  obeeChargeNoShow: obeeChargeNoShowPropTypes.isRequired
};
const mapStateToProps$9 = (state) => ({
  obeeChargeNoShow: state.chargeNoShow
});
const mapDispatchToProps$9 = (dispatch) => bindActionCreators(
  {
    chargeNoShow: chargeNoShowAction,
    clearChargeNoShow: clearChargeNoShowAction
  },
  dispatch
);
const ChargeNoShowModal$1 = connect(mapStateToProps$9, mapDispatchToProps$9)(ChargeNoShowModal);
const ChargeNoShow = ({ booking }) => {
  var _a;
  const theme2 = useTheme$1();
  const charged = (booking == null ? void 0 : booking.ccNoShowChargeStatus) === "succeeded";
  const classes = useStyles$6({ charged });
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => {
    setIsOpen(false);
  };
  const smallButtonStyle = smallButtonStyles$1(theme2);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.chargeNoShowContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.chargeNoShowHeader }, charged ? /* @__PURE__ */ React__default.createElement(IconBookingSuccess, { style: { width: "35px" } }) : /* @__PURE__ */ React__default.createElement(IconBookingWarning, { style: { width: "35px" } }), charged ? "No-Show fee charged" : "Charge no-show fee"), /* @__PURE__ */ React__default.createElement(Divider, null), /* @__PURE__ */ React__default.createElement(Box, { className: classes.chargeNoShowInfo }, charged ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.chargeNoShowItem }, /* @__PURE__ */ React__default.createElement(Box, null, "Total amount charged"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.chargeNoShowAmountCharged }, formatCurrency(getNoShowFee(booking), true, "Invalid amount", true))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.chargeNoShowItem }, /* @__PURE__ */ React__default.createElement(Box, null, "Transaction date"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.chargeNoShowDetail }, formatDate(booking == null ? void 0 : booking.ccNoShowChargeTime, "DD/MM/YYYY"))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.chargeNoShowItem }, /* @__PURE__ */ React__default.createElement(Box, null, "ID"), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      title: booking == null ? void 0 : booking.ccNoShowPaymentIntentId,
      className: classes.chargeNoShowDetail
    },
    (_a = booking == null ? void 0 : booking.ccNoShowPaymentIntentId) == null ? void 0 : _a.slice(-8)
  ))) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, null, "Charge the customer’s credit card for your no show policy fee."), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "secondary",
      style: {
        ...smallButtonStyle,
        container: {
          ...smallButtonStyle == null ? void 0 : smallButtonStyle.container,
          width: "fit-content"
        },
        button: {
          ...smallButtonStyle == null ? void 0 : smallButtonStyle.button,
          background: "transparent"
        }
      },
      onClick: () => setIsOpen(true)
    },
    "Charge no-show fee"
  )))), /* @__PURE__ */ React__default.createElement(ChargeNoShowModal$1, { booking, isOpen, onClose }));
};
ChargeNoShow.defaultProps = {
  booking: null
};
ChargeNoShow.propTypes = {
  booking: obeeBookingPropTypes
};
const ChargeNoShow$1 = ChargeNoShow;
const TableAndAreaSelector = ({ tableNumber, error, required, area, anchor, setAnchor }) => {
  const theme2 = useTheme$1();
  const classes = useStyles$a();
  const buttonStyles2 = {
    border: error && `1px solid ${theme2.colors.red}` || (!isEmpty(anchor) ? `1px solid ${theme2.colors.smoke}` : `1px solid ${theme2.colors.nimbus}`),
    color: isEmpty(tableNumber) && isEmpty(area) && theme2.colors.nimbus,
    // backgroundColor: !isEmpty(anchor) && theme.colors.notificationBackgroundGray,
    backgroundColor: "white",
    button: {
      width: "100%",
      padding: 0,
      maxWidth: "230px",
      overflow: "hidden"
    }
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "10px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(Box, { style: { width: "70px", flexShrink: 0, color: theme2.colors.smoke } }, isEmpty(tableNumber) && !isEmpty(area) ? "Area" : "Table", required && "*"), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "custom",
      centered: false,
      className: classes.interactiveItem,
      style: buttonStyles2,
      onClick: (e) => setAnchor(e.currentTarget),
      title: `${tableNumber} - ${area == null ? void 0 : area.name}`
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { gap: 8, className: classes.buttonContent }, !isEmpty(tableNumber) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableNumber }, tableNumber), !isEmpty(area == null ? void 0 : area.name) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaName }, area == null ? void 0 : area.name), isEmpty(tableNumber) && isEmpty(area == null ? void 0 : area.name) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.areaName }, "No table"))
  )), error && /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "10px", color: theme2.colors.red, margin: "4px 0 0 100px" } }, error)));
};
TableAndAreaSelector.defaultProps = {
  tableNumber: null,
  error: null,
  required: false,
  area: null,
  anchor: null,
  setAnchor: () => {
  }
};
TableAndAreaSelector.propTypes = {
  tableNumber: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  area: areaPropTypes,
  anchor: PropTypes.shape({}),
  setAnchor: PropTypes.func
};
const mapStateToProps$8 = () => ({});
const mapDispatchToProps$8 = (dispatch) => bindActionCreators({}, dispatch);
const TableAndAreaSelector$1 = connect(mapStateToProps$8, mapDispatchToProps$8)(TableAndAreaSelector);
const TableSection = ({
  onSelect: onSelect2,
  hasAreaChanges,
  hasTableChanges,
  setSeatingDefaults,
  tableNumber,
  error,
  required,
  clearError,
  time,
  date,
  guestAmount,
  area,
  bookingId,
  setAreaId
}) => {
  const classes = useStyles$6();
  const [anchor, setAnchor] = useState(null);
  const getSectionSubHeading = (heading, hasChanged = false, onDiscard) => /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeadingHeading }, heading), hasChanged && onDiscard && /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "text",
      className: classes.editButton,
      onClick: (e) => {
        onDiscard(e);
        e.stopPropagation();
      }
    },
    "Discard changes"
  ));
  const ref = useRef();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `${classes.interactiveFormSection} ${anchor ? classes.interactiveFormSectionActive : ""}`,
      onClick: (e) => setAnchor(e.currentTarget),
      ref
    },
    getSectionSubHeading("Seating", hasAreaChanges || hasTableChanges, setSeatingDefaults),
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
      TableAndAreaSelector$1,
      {
        area,
        tableNumber,
        required,
        error,
        anchor,
        setAnchor: () => setAnchor(ref == null ? void 0 : ref.current)
      }
    ))
  ), /* @__PURE__ */ React__default.createElement(
    TableSelectorPopover$1,
    {
      anchorEl: anchor,
      setAnchorEl: setAnchor,
      areaId: area == null ? void 0 : area.id,
      setTable: onSelect2,
      clearError,
      time,
      bookingId,
      setAreaId,
      date,
      guestAmount,
      popoverProps: { innerProps: { disableScrollLock: true } },
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      popoverStyle: {
        marginTop: 0,
        // marginRight: '100px',
        marginLeft: "-8px",
        maxHeight: "calc(100dvh - 100px)"
      }
    }
  ));
};
TableSection.defaultProps = {
  tableNumber: null,
  style: {},
  error: null,
  required: false,
  clearError: () => {
  },
  area: null,
  date: null,
  guestAmount: null,
  bookingId: null,
  setAreaId: () => {
  },
  onSelect: () => {
  }
};
TableSection.propTypes = {
  onSelect: PropTypes.func,
  hasAreaChanges: PropTypes.bool.isRequired,
  hasTableChanges: PropTypes.bool.isRequired,
  setSeatingDefaults: PropTypes.func.isRequired,
  tableNumber: PropTypes.string,
  style: PropTypes.shape({}),
  error: PropTypes.string,
  required: PropTypes.bool,
  clearError: PropTypes.func,
  time: PropTypes.number.isRequired,
  area: areaPropTypes,
  date: PropTypes.string,
  guestAmount: PropTypes.number,
  bookingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setAreaId: PropTypes.func
};
const mapStateToProps$7 = () => ({});
const mapDispatchToProps$7 = (dispatch) => bindActionCreators({}, dispatch);
const TableSection$1 = connect(mapStateToProps$7, mapDispatchToProps$7)(TableSection);
const Booking = ({
  booking,
  areas,
  tables,
  obeeSettings: obeeSettings2,
  obeeSessions: obeeSessions2,
  updateBooking,
  status,
  updateCheck,
  clearUpdateCheck,
  obeeStaff,
  obeeUpdateCheck,
  obeeBookings: obeeBookings2,
  setObeeShowAddBookingModal,
  restaurant
}) => {
  var _a, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  const dispatch = useDispatch();
  const theme2 = useTheme$1();
  const classes = useStyles$6();
  const debouncedUpdateCheck = useMemo(
    () => debounce$2(
      (id, areaId2, date2, time2, size2, tableNumber2, duration2, isPublic) => updateCheck(id, areaId2, date2, time2, size2, tableNumber2, duration2, isPublic),
      500
    ),
    [updateCheck]
  );
  const [checking, setChecking] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [requiresUpdateCheck, setRequiresUpdateCheck] = useState(false);
  const [allowSaving, setAllowSaving] = useState(false);
  const [bookingId, setBookingId] = useState(booking == null ? void 0 : booking.id);
  const isBookingToCheckAgainst = (booking == null ? void 0 : booking.id) === bookingId;
  const [date, setDate] = useState(booking == null ? void 0 : booking.date);
  const [time, setTime] = useState(booking == null ? void 0 : booking.time);
  const [duration, setDuration] = useState(booking == null ? void 0 : booking.duration);
  const [size, setSize] = useState(booking == null ? void 0 : booking.size);
  const [areaId, setAreaId] = useState(booking == null ? void 0 : booking.areaId);
  const [tableNumber, setTableNumber] = useState(booking == null ? void 0 : booking.tableNumber);
  const [tableError, setTableError] = useState(null);
  const [customerComments, setCustomerComments] = useState(booking == null ? void 0 : booking.customerComments);
  const [restaurantComments, setRestaurantComments] = useState(booking == null ? void 0 : booking.restaurantComments);
  const [hasBookingDetailsChanges, setHasBookingDetailsChanges] = useState(false);
  const [showHighChairField, setShowHighChairField] = useState((booking == null ? void 0 : booking.highchairs) > 0);
  const [highchairs, setHighchairs] = useState(booking == null ? void 0 : booking.highchairs);
  const [children, setChildren] = useState(booking == null ? void 0 : booking.kids);
  const allowChildren = ((_a = obeeSettings2.data) == null ? void 0 : _a.abKids) || ((_c2 = (_b2 = obeeSettings2.data) == null ? void 0 : _b2.addBookingSettings) == null ? void 0 : _c2.showChildren);
  const allowHighchairs = ((_d2 = obeeSettings2.data) == null ? void 0 : _d2.abHighchairs) || ((_f = (_e2 = obeeSettings2.data) == null ? void 0 : _e2.addBookingSettings) == null ? void 0 : _f.showHighChairs);
  const highchairCap = 4;
  const [staff, setStaff] = useState(null);
  const [staffError, setStaffError] = useState(null);
  const [quotedMins, setQuotedMins] = useState(booking == null ? void 0 : booking.quotedMins);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [sendingSms, setSendingSms] = useState(false);
  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [dateListAnchorEl, setDateListAnchorEl] = useState(null);
  const [timeAnchorEl, setTimeAnchorEl] = useState(null);
  const [endTimeAnchorEl, setEndTimeAnchorEl] = useState(null);
  const [guestsAnchorEl, setGuestsAnchorEl] = useState(null);
  const [quotedMinsAnchorEl, setQuotedMinsAnchorEl] = useState(null);
  const setBookingDetailDefaults = useCallback(() => {
    unstable_batchedUpdates(() => {
      setDate(booking == null ? void 0 : booking.date);
      setTime(booking == null ? void 0 : booking.time);
      setSize(booking == null ? void 0 : booking.size);
      setDuration(booking == null ? void 0 : booking.duration);
      setCustomerComments(booking == null ? void 0 : booking.customerComments);
      setQuotedMins(booking == null ? void 0 : booking.quotedMins);
    });
  }, [
    setDate,
    setTime,
    setSize,
    setDuration,
    setCustomerComments,
    booking == null ? void 0 : booking.date,
    booking == null ? void 0 : booking.time,
    booking == null ? void 0 : booking.size,
    booking == null ? void 0 : booking.duration,
    booking == null ? void 0 : booking.customerComments,
    booking == null ? void 0 : booking.quotedMins
  ]);
  const setSeatingDefaults = useCallback(() => {
    unstable_batchedUpdates(() => {
      setAreaId(booking == null ? void 0 : booking.areaId);
      setTableNumber(booking == null ? void 0 : booking.tableNumber);
    });
  }, [setAreaId, setTableNumber, booking == null ? void 0 : booking.areaId, booking == null ? void 0 : booking.tableNumber]);
  const setBookingHighchairDefaults = useCallback(() => {
    unstable_batchedUpdates(() => {
      setShowHighChairField((booking == null ? void 0 : booking.highchairs) > 0);
      setHighchairs(booking == null ? void 0 : booking.highchairs);
      setChildren(booking == null ? void 0 : booking.kids);
    });
  }, [setShowHighChairField, setHighchairs, booking == null ? void 0 : booking.highchairs]);
  const setBookingStaffDefaults = useCallback(() => {
    setStaff(booking == null ? void 0 : booking.staff);
  }, [setStaff, booking == null ? void 0 : booking.staff]);
  const setBookingDefaults = useCallback(() => {
    unstable_batchedUpdates(() => {
      setBookingDetailDefaults();
      setBookingHighchairDefaults();
      setBookingStaffDefaults();
    });
  }, [setBookingDetailDefaults, setBookingHighchairDefaults, setBookingStaffDefaults]);
  useEffect(() => {
    setBookingId(booking == null ? void 0 : booking.id);
    setBookingDefaults();
  }, [booking == null ? void 0 : booking.id, setBookingDefaults]);
  const hasDateChanges = isBookingToCheckAgainst && date !== (booking == null ? void 0 : booking.date);
  const hasStartTimeChanges = isBookingToCheckAgainst && time !== (booking == null ? void 0 : booking.time);
  const hasEndTimeChanges = isBookingToCheckAgainst && duration !== (booking == null ? void 0 : booking.duration);
  const hasSizeChanges = isBookingToCheckAgainst && size !== (booking == null ? void 0 : booking.size);
  const hasAreaChanges = isBookingToCheckAgainst && areaId !== (booking == null ? void 0 : booking.areaId);
  const hasTableChanges = isBookingToCheckAgainst && tableNumber !== (booking == null ? void 0 : booking.tableNumber);
  const hasCustomerCommentsChanges = isBookingToCheckAgainst && customerComments !== (booking == null ? void 0 : booking.customerComments);
  const hasRestaurantCommentsChanges = isBookingToCheckAgainst && restaurantComments !== (booking == null ? void 0 : booking.restaurantComments);
  const hasHighchairChanges = isBookingToCheckAgainst && (highchairs !== (booking == null ? void 0 : booking.highchairs) || children !== (booking == null ? void 0 : booking.kids));
  const hasStaffChanges = isBookingToCheckAgainst && staff !== (booking == null ? void 0 : booking.staff);
  const hasQuotedMinsChanges = isBookingToCheckAgainst && quotedMins !== (booking == null ? void 0 : booking.quotedMins);
  useEffect(() => {
    setRequiresUpdateCheck(
      isBookingToCheckAgainst && (hasDateChanges || hasStartTimeChanges || hasEndTimeChanges || hasSizeChanges || hasAreaChanges || hasTableChanges)
    );
  }, [
    setRequiresUpdateCheck,
    isBookingToCheckAgainst,
    hasDateChanges,
    hasStartTimeChanges,
    hasEndTimeChanges,
    hasSizeChanges,
    hasAreaChanges,
    hasTableChanges
  ]);
  useEffect(() => {
    setHasBookingDetailsChanges(
      isBookingToCheckAgainst && (hasDateChanges || hasStartTimeChanges || hasEndTimeChanges || hasSizeChanges || hasCustomerCommentsChanges)
    );
  }, [
    setHasBookingDetailsChanges,
    isBookingToCheckAgainst,
    hasDateChanges,
    hasStartTimeChanges,
    hasEndTimeChanges,
    hasSizeChanges,
    hasCustomerCommentsChanges
  ]);
  useEffect(() => {
    if ((booking == null ? void 0 : booking.tableNumber) !== tableNumber || (booking == null ? void 0 : booking.areaId) !== areaId) {
      setTableNumber(booking == null ? void 0 : booking.tableNumber);
      setAreaId(booking == null ? void 0 : booking.areaId);
    }
  }, [booking == null ? void 0 : booking.status]);
  useEffect(() => {
    setAllowSaving(
      isBookingToCheckAgainst && (hasBookingDetailsChanges || hasAreaChanges || hasTableChanges || hasRestaurantCommentsChanges || hasHighchairChanges || hasStaffChanges || hasQuotedMinsChanges)
    );
  }, [
    setAllowSaving,
    isBookingToCheckAgainst,
    hasBookingDetailsChanges,
    hasHighchairChanges,
    hasStaffChanges,
    hasQuotedMinsChanges,
    hasAreaChanges,
    hasTableChanges,
    hasRestaurantCommentsChanges
  ]);
  useEffect(() => {
    if (!requiresUpdateCheck) {
      clearUpdateCheck();
    }
    if (requiresUpdateCheck) {
      setChecking(true);
      debouncedUpdateCheck(booking.id, areaId, date, time, size, tableNumber, duration, false);
    }
  }, [
    requiresUpdateCheck,
    booking == null ? void 0 : booking.id,
    areaId,
    date,
    time,
    size,
    tableNumber,
    duration,
    clearUpdateCheck,
    setChecking,
    debouncedUpdateCheck
  ]);
  useEffect(() => {
    if (obeeUpdateCheck.success || obeeUpdateCheck.error) {
      setChecking(false);
    }
  }, [obeeUpdateCheck.success, obeeUpdateCheck.error]);
  useEffect(() => {
    var _a2;
    const selectedTable = findObjectByProperty(tables == null ? void 0 : tables.data, tableNumber, "tableNumber");
    if (isEmpty(selectedTable) || areaId === (selectedTable == null ? void 0 : selectedTable.areaId)) {
      return;
    }
    if (areaId === (booking == null ? void 0 : booking.areaId)) {
      setTableNumber(booking == null ? void 0 : booking.tableNumber);
    } else {
      const areaTables = (_a2 = tables == null ? void 0 : tables.data) == null ? void 0 : _a2.filter((table) => table.areaId === areaId);
      if (areaTables.length === 0) {
        setTableNumber(null);
      } else {
        setTableNumber(areaTables[0].tableNumber);
      }
    }
  }, [areaId, booking == null ? void 0 : booking.areaId, booking == null ? void 0 : booking.tableNumber]);
  const area = findObjectByProperty(areas.data, areaId, "id");
  const capacityArea = isAreaCapacityBased(area, tables == null ? void 0 : tables.data);
  const isMissingTable = !capacityArea && getSeatableStatuses().includes(status) && isEmpty(tableNumber);
  useEffect(() => {
    if (isMissingTable) {
      setTableError("Please add an area and table for the booking");
    } else {
      setTableError(null);
    }
  }, [isMissingTable]);
  const dateFormatted = moment$2(date).format("ddd").toLowerCase();
  const availableTimes = useMemo(() => {
    var _a2;
    const bookingInterval = (_a2 = obeeSettings2.data) == null ? void 0 : _a2.systemTimeInterval;
    const sessionsForDay = getTodaySessions(date, obeeSessions2, "all_sessions", areaId || "all");
    return getTimeDropdownList(sessionsForDay, setTime, bookingInterval);
  }, [obeeSessions2.data, dateFormatted, areaId, date, (_g = obeeSettings2.data) == null ? void 0 : _g.systemTimeInterval]);
  const availableEndTimes = useMemo(() => {
    var _a2, _b3;
    const bookingInterval = (_a2 = obeeSettings2.data) == null ? void 0 : _a2.systemTimeInterval;
    const sessionsForDay = getTodaySessions(date, obeeSessions2, "all_sessions", areaId || "all");
    const lastSession = getLastSession(sessionsForDay);
    const isLastSession = (session) => {
      return (session == null ? void 0 : session.endTime) === (lastSession == null ? void 0 : lastSession.endTime);
    };
    return (_b3 = sessionsForDay.map((session) => {
      const sessionTimes = [];
      const bonusTimePastEndOfDay = isLastSession(session) ? 90 : 0;
      for (let i = time + bookingInterval; i <= session.endTime + bonusTimePastEndOfDay; i += bookingInterval) {
        sessionTimes.push(i);
      }
      if (isEmpty(sessionTimes)) {
        return null;
      }
      return {
        label: getSessionLabel(session.label),
        items: sessionTimes == null ? void 0 : sessionTimes.map((sessionTime) => ({
          label: /* @__PURE__ */ React__default.createElement(
            Spacer,
            {
              style: {
                alignItems: "baseline"
              }
            },
            formatTimeFromInt(sessionTime, "h:mma"),
            /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "12px", color: theme2.colors.smoke } }, sessionTime - ((booking == null ? void 0 : booking.time) ?? 0), "mins")
          ),
          value: sessionTime,
          onClick: () => setDuration(sessionTime - time)
        }))
      };
    })) == null ? void 0 : _b3.filter((session) => !!session);
  }, [obeeSessions2.data, dateFormatted, areaId, time, date, (_h = obeeSettings2.data) == null ? void 0 : _h.systemTimeInterval]);
  const textFieldStyles2 = {
    label: {
      color: theme2.colors.smoke
    },
    inputProps: {
      fontSize: "inherit",
      padding: "8px",
      paddingLeft: "10px",
      width: "100%",
      maxWidth: "310px",
      border: "none",
      minHeight: "80px",
      borderRadius: "6px",
      backgroundColor: theme2.colors.textAreaBackground
    },
    hovered: {
      backgroundColor: theme2.colors.nimbus
    },
    hoveredBorder: {
      backgroundColor: theme2.colors.nimbus
    }
  };
  const handleSaveChanges = async (isWaitlist, takenBy) => {
    var _a2;
    let valid = true;
    const hasNoStaff = !isObee() && isEmpty(obeeStaff.data);
    if (!hasNoStaff && ((_a2 = obeeSettings2.data) == null ? void 0 : _a2.abTakenBy) === "mandatory" && isEmpty(takenBy)) {
      setStaffError("This field is required.");
      valid = false;
    } else {
      setStaffError(null);
    }
    if (valid) {
      setUpdating(true);
      updateBooking({
        ...booking,
        areaId,
        date: formatDate(date, "YYYY-MM-DD"),
        time,
        size,
        tableNumber,
        highchairs,
        kids: children,
        children,
        staff: takenBy,
        status: isWaitlist ? STATUS_TYPES.WAITING : status,
        duration,
        customerComments,
        restaurantComments,
        quotedMins
      });
    }
  };
  useEffect(() => {
    if (updating && (obeeBookings2.success || obeeBookings2.error)) {
      setUpdating(false);
      setObeeShowAddBookingModal(false);
    }
  }, [obeeBookings2.success, obeeBookings2.error]);
  const closeDateModal = () => {
    setDateListAnchorEl(null);
  };
  const setCalendarDate = (newDate) => {
    setDate(moment$2(newDate));
    closeDateModal();
  };
  const getNextWeekAsDays = (amountOfDays = 8) => [...Array.from({ length: amountOfDays })].map((_, i) => {
    const newDay = moment$2().startOf("day").add(i, "days");
    return { label: formatDate(newDay, "dddd D/M"), value: newDay };
  });
  const days = getNextWeekAsDays();
  useEffect(() => {
    setStaffError(null);
  }, [staff]);
  const openDateModal = (event) => {
    setDateListAnchorEl(event.currentTarget);
  };
  const getGuestAmounts = () => {
    var _a2, _b3;
    const maxCapacity = ((_b3 = (_a2 = sortListByProperty(areas.data, "capacity", true)) == null ? void 0 : _a2[0]) == null ? void 0 : _b3.capacity) || 20;
    return [...Array.from({ length: maxCapacity })].map((_, i) => ({
      label: `${i + 1} ${pluralise("guest", i + 1)}`,
      value: i + 1
    }));
  };
  const removeGuest = (e) => {
    e == null ? void 0 : e.stopPropagation();
    setSize(Math.max(1, size - 1));
  };
  const addGuest = (e) => {
    e == null ? void 0 : e.stopPropagation();
    setSize(size + 1);
  };
  const getSectionSubHeading = (heading, hasChanged = false, onDiscard = null) => /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeadingHeading }, heading), hasChanged && onDiscard && /* @__PURE__ */ React__default.createElement(Box, { className: classes.editButton, onClick: onDiscard }, "Discard changes"));
  const cardNumber = isObee() ? booking == null ? void 0 : booking.ccNoShowChargeDisplayNumber : booking == null ? void 0 : booking.paymentMethodId;
  const hasNoShowFee = (booking == null ? void 0 : booking.ccNoShowFee) > 0 && (booking == null ? void 0 : booking.source) !== "walkin" && !isEmpty(cardNumber);
  const getBookingDefaultDuration = () => {
    var _a2;
    const bookingTable = getTableForBooking(booking, tables == null ? void 0 : tables.data, areas.data);
    if (bookingTable && bookingTable.duration > 0) {
      return bookingTable.duration;
    }
    const areaForTable = getAreaById(areas.data, bookingTable == null ? void 0 : bookingTable.areaId);
    if (areaForTable && areaForTable.duration) {
      return areaForTable.duration;
    }
    return (_a2 = obeeSettings2.data) == null ? void 0 : _a2.bookingsDuration;
  };
  const isWaitlistBooking = (booking == null ? void 0 : booking.status) === STATUS_TYPES.WAITING;
  const showConfirmationSmsOption = !isWaitlistBooking && ((_j = (_i = booking == null ? void 0 : booking.guests) == null ? void 0 : _i[0]) == null ? void 0 : _j.mobile) && ((_l = (_k = obeeSettings2.data) == null ? void 0 : _k.addBookingSettings) == null ? void 0 : _l.showConfirmationSmsOption) && ((_o = (_n = (_m = obeeSettings2.data) == null ? void 0 : _m.messaging) == null ? void 0 : _n.sms_confirmation) == null ? void 0 : _o.sms_confirmation_toggle);
  const showConfirmationEmailOption = !isWaitlistBooking && ((_q = (_p = booking == null ? void 0 : booking.guests) == null ? void 0 : _p[0]) == null ? void 0 : _q.email) && ((_s = (_r = obeeSettings2.data) == null ? void 0 : _r.addBookingSettings) == null ? void 0 : _s.showConfirmationEmailOption);
  const emailHistory = ((booking == null ? void 0 : booking.emailHistory) ?? []).filter(
    (email) => isWaitlistBooking ? email.type === "waiting_list" : "confirmation"
  );
  const canBeSeated = isBooked(booking) && !isFutureDate(booking);
  const isSeated = (booking == null ? void 0 : booking.status) === STATUS_TYPES.ARRIVED;
  const quickActions = [
    ...canBeSeated ? [
      {
        id: "seatGuest",
        label: "Seat guests",
        onClick: () => {
          updateBooking({
            ...booking,
            status: STATUS_TYPES.ARRIVED
          });
        }
      }
    ] : [],
    ...isSeated ? [
      {
        id: "finishBooking",
        label: "Set as finished",
        onClick: () => {
          updateBooking({
            ...booking,
            status: STATUS_TYPES.FINISHED
          });
        }
      }
    ] : []
  ];
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.modalBodyInner }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.content }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.contentTop }, isWaitlistBooking && (booking == null ? void 0 : booking.duration) < getBookingDefaultDuration() && /* @__PURE__ */ React__default.createElement(BookingWarning$1, { booking }), quickActions.length > 0 && /* @__PURE__ */ React__default.createElement(Spacer, { style: { padding: "20px 12px 0 12px" } }, quickActions.map((quickAction) => /* @__PURE__ */ React__default.createElement(Box, { key: quickAction.id }, /* @__PURE__ */ React__default.createElement(
    RoundButton,
    {
      onClick: (e) => {
        quickAction.onClick(e);
        setObeeShowAddBookingModal(false);
      },
      style: {
        button: {
          backgroundColor: theme2.colors.linen,
          border: "none",
          padding: "0 16px",
          color: theme2.colors.jet
        }
      }
    },
    quickAction.label
  )))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, getSectionSubHeading(
    "Booking details",
    hasBookingDetailsChanges,
    setBookingDetailDefaults
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Date",
      value: formatDate(date, "ddd Do of MMM"),
      onClick: openDateModal,
      isActive: !!(dateAnchorEl || dateListAnchorEl)
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Start time",
      value: formatTimeFromInt(time, "h:mma"),
      onClick: (e) => {
        setTimeAnchorEl(e.currentTarget);
      },
      isActive: !!timeAnchorEl
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "End time",
      value: `${formatTimeFromInt(time + duration, "h:mma")} (${duration}mins)`,
      onClick: (e) => {
        setEndTimeAnchorEl(e.currentTarget);
      },
      isActive: !!endTimeAnchorEl
    }
  ), /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Party size",
      value: /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestsLabel }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.guestsText }, `${size} ${pluralise(
        "guest",
        size
      )}`), /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "custom",
          className: classes.incrementButton,
          style: iconButtonStyles(theme2),
          onClick: removeGuest
        },
        /* @__PURE__ */ React__default.createElement(MinusIconSVG, { style: { height: "2px" } })
      ), /* @__PURE__ */ React__default.createElement(
        Button,
        {
          type: "custom",
          className: classes.incrementButton,
          style: iconButtonStyles(theme2),
          onClick: addGuest
        },
        /* @__PURE__ */ React__default.createElement(PlusIconSVG, { style: { height: "13px" } })
      )),
      onClick: (e) => {
        setGuestsAnchorEl(e.currentTarget);
      },
      isActive: !!guestsAnchorEl
    }
  ), /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      label: "Guest comments",
      value: customerComments,
      onChange: setCustomerComments,
      style: textFieldStyles2,
      resizable: true,
      placeholder: "Comments left by the guest and shown in their confirmation email"
    }
  ))), /* @__PURE__ */ React__default.createElement(
    TableSection$1,
    {
      hasAreaChanges,
      hasTableChanges,
      setSeatingDefaults,
      area,
      tableNumber,
      onSelect: (table) => {
        setTableNumber((table == null ? void 0 : table.tableNumber) || null);
        setAreaId(table == null ? void 0 : table.areaId);
      },
      time,
      bookingId: booking == null ? void 0 : booking.id,
      setAreaId,
      date,
      guestAmount: size,
      error: tableError,
      areaId,
      innerProps: { disableScrollLock: true }
    }
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, getSectionSubHeading("Restaurant Comments", hasRestaurantCommentsChanges, () => {
    setRestaurantComments(booking == null ? void 0 : booking.restaurantComments);
  }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(
    TextArea,
    {
      value: restaurantComments,
      onChange: setRestaurantComments,
      style: textFieldStyles2,
      resizable: true
    }
  ))), (allowChildren || (allowHighchairs || highchairs > 0) && children > 0 || children > 0) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, getSectionSubHeading(
    `Kids & high chairs`,
    hasHighchairChanges,
    setBookingHighchairDefaults
  ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.description }, size, " total guests on the booking"), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (allowChildren || children > 0) && /* @__PURE__ */ React__default.createElement(
    NumberIncrement$1,
    {
      label: "Children",
      value: children,
      onChange: setChildren,
      min: 0,
      max: size,
      allowTyping: true,
      textIfNone: "None",
      gap: "4px"
    }
  ), (allowHighchairs || highchairs > 0) && children > 0 && /* @__PURE__ */ React__default.createElement(
    NumberIncrement$1,
    {
      label: "High chairs",
      value: highchairs,
      onChange: setHighchairs,
      min: 0,
      max: Math.min(highchairCap, children || 0),
      allowTyping: true,
      textIfNone: "None",
      gap: "4px"
    }
  ))), showField((_t = obeeSettings2.data) == null ? void 0 : _t.abTakenBy) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, getSectionSubHeading("Taken by", hasStaffChanges, setBookingStaffDefaults), isObee() ? /* @__PURE__ */ React__default.createElement(CleanTextFieldComponent, { label: "Staff name", value: booking == null ? void 0 : booking.staff, editable: false }) : /* @__PURE__ */ React__default.createElement(CleanInteractiveItem$1, { label: "Staff name", value: booking == null ? void 0 : booking.staff, disabled: true })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, getSectionSubHeading("Booking type"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(ValueField$1, { label: "Source", value: resolveSource(booking == null ? void 0 : booking.source) }), booking.status === STATUS_TYPES.WAITING && /* @__PURE__ */ React__default.createElement(
    CleanInteractiveItem$1,
    {
      label: "Quoted time",
      value: quotedMins,
      onClick: (e) => {
        setQuotedMinsAnchorEl(e.currentTarget);
      },
      formatValue: (value) => `${value} mins`,
      isActive: !!quotedMinsAnchorEl
    }
  ))), (!!showConfirmationEmailOption || !!showConfirmationSmsOption) && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.subHeading }, "Confirmation"), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        display: "flex",
        gap: "6px",
        flexDirection: "column"
      }
    },
    showConfirmationEmailOption && /* @__PURE__ */ React__default.createElement(Spacer, { style: { alignItems: "center", justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { fontWeight: theme2.fontWeights.medium } }, "Email"), emailHistory.length > 0 && /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "13px", color: theme2.colors.smoke } }, "Last sent", " ", moment$2(emailHistory[0].dateTimeSent, "YYYY-MM-DD hh:mm:ss").format(
      "DD/MM/YYYY h:mma"
    ))), /* @__PURE__ */ React__default.createElement(
      SquareButton,
      {
        style: {
          button: { fontWeight: theme2.fontWeights.medium, padding: "4px 14px" }
        },
        loading: sendingEmail,
        onClick: () => {
          setSendingEmail(true);
          dispatch(
            sendGuestEmailAction(
              booking == null ? void 0 : booking.id,
              isWaitlistBooking ? "waiting_list" : "confirmation"
            )
          ).finally(() => setSendingEmail(false));
        }
      },
      emailHistory.length > 0 ? "Resend" : "Send"
    )),
    showConfirmationSmsOption && /* @__PURE__ */ React__default.createElement(Spacer, { style: { alignItems: "center", justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { style: { fontWeight: theme2.fontWeights.medium } }, "SMS"), (booking == null ? void 0 : booking.smsHistory.length) > 0 && /* @__PURE__ */ React__default.createElement(Box, { style: { fontSize: "13px", color: theme2.colors.smoke } }, "Last sent", " ", moment$2(
      booking == null ? void 0 : booking.smsHistory[0].dateTimeSent,
      "YYYY-MM-DD hh:mm:ss"
    ).format("DD/MM/YYYY h:mma"))), /* @__PURE__ */ React__default.createElement(
      SquareButton,
      {
        style: {
          button: { fontWeight: theme2.fontWeights.medium, padding: "4px 14px" }
        },
        loading: sendingSms,
        onClick: () => {
          setSendingSms(true);
          dispatch(sendGuestSMSAction(booking == null ? void 0 : booking.id, "confirmation")).finally(
            () => setSendingSms(false)
          );
        }
      },
      (booking == null ? void 0 : booking.smsHistory.length) > 0 ? "Resend" : "Send"
    ))
  )), /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, hasNoShowFee && /* @__PURE__ */ React__default.createElement(Box, { className: classes.formSection }, getSectionSubHeading("Credit card details"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.section }, /* @__PURE__ */ React__default.createElement(ValueField$1, { label: "Card name", value: "****" }), /* @__PURE__ */ React__default.createElement(ValueField$1, { label: "Card no.", value: cardNumber }), /* @__PURE__ */ React__default.createElement(ValueField$1, { label: "MM/YY", value: "**/**" }), /* @__PURE__ */ React__default.createElement(ValueField$1, { label: "CVV", value: "***" })), ((booking == null ? void 0 : booking.status) === STATUS_TYPES.NO_SHOW && (booking == null ? void 0 : booking.ccNoShowFee) > 0 || (booking == null ? void 0 : booking.ccNoShowChargeStatus) === "succeeded") && /* @__PURE__ */ React__default.createElement(ChargeNoShow$1, { booking }))))), /* @__PURE__ */ React__default.createElement(
    BookingFooter$1,
    {
      handleSaveChanges: (takenBy) => handleSaveChanges(false, takenBy),
      handleForce: (takenBy) => handleSaveChanges(false, takenBy),
      handleAddToWaitlist: (takenBy) => handleSaveChanges(true, takenBy),
      updating,
      tableNumber,
      areaName: (_v = (_u = areas.data) == null ? void 0 : _u.find((areaToFind) => areaToFind.id === areaId)) == null ? void 0 : _v.name,
      requiresUpdateCheck,
      allowSaving,
      checking,
      takenByError: staffError
    }
  ), /* @__PURE__ */ React__default.createElement(
    DatePopover$1,
    {
      value: date,
      anchor: dateAnchorEl,
      isOpen: !!dateAnchorEl,
      onClose: () => setDateAnchorEl(null),
      onSetDate: setCalendarDate,
      popoverProps: { innerProps: { disableScrollLock: true } },
      ...popoverAnchors$3
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: days,
      onSelect: setDate,
      value: date,
      anchor: dateListAnchorEl,
      isOpen: !!dateListAnchorEl,
      onClose: closeDateModal,
      style: listPopoverStyles$2,
      popoverProps: { innerProps: { disableScrollLock: true } },
      footer: /* @__PURE__ */ React__default.createElement(Box, { className: classes.selectDate, onClick: () => setDateAnchorEl(dateListAnchorEl) }, /* @__PURE__ */ React__default.createElement(Box, null, "Select date"), /* @__PURE__ */ React__default.createElement(ChevronRight, { style: { width: "8px", height: "13px" } })),
      ...popoverAnchors$3
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: availableTimes,
      anchor: timeAnchorEl,
      isOpen: !!timeAnchorEl,
      onClose: () => setTimeAnchorEl(null),
      value: time,
      style: listPopoverStyles$2,
      popoverProps: { innerProps: { disableScrollLock: true } },
      ...popoverAnchors$3
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: availableEndTimes,
      anchor: endTimeAnchorEl,
      isOpen: !!endTimeAnchorEl,
      onClose: () => setEndTimeAnchorEl(null),
      value: time + duration,
      style: listPopoverStyles$2,
      popoverProps: { innerProps: { disableScrollLock: true } },
      ...popoverAnchors$3
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: getGuestAmounts(),
      onSelect: setSize,
      anchor: guestsAnchorEl,
      isOpen: !!guestsAnchorEl,
      onClose: () => setGuestsAnchorEl(null),
      value: size,
      style: {
        ...listPopoverStyles$2,
        popover: { ...listPopoverStyles$2.popover, minWidth: "fit-content" }
      },
      popoverProps: { innerProps: { disableScrollLock: true } },
      ...popoverAnchors$3
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: [
        ...numberRange(5, 120, 5, true).map((minutes) => ({
          label: `${minutes} mins`,
          value: minutes
        }))
      ],
      onSelect: (newValue) => {
        setQuotedMins(newValue);
      },
      anchor: quotedMinsAnchorEl,
      isOpen: !!quotedMinsAnchorEl,
      onClose: () => setQuotedMinsAnchorEl(null),
      style: listPopoverStyles$2,
      value: quotedMins,
      popoverProps: { innerProps: { disableScrollLock: true } },
      ...popoverAnchors$3
    }
  ));
};
Booking.defaultProps = {
  booking: null,
  status: null
};
Booking.propTypes = {
  booking: obeeBookingPropTypes,
  areas: areasPropTypes.isRequired,
  tables: tablesPropTypes.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  obeeSessions: sessionsPropTypes.isRequired,
  updateBooking: PropTypes.func.isRequired,
  status: PropTypes.string,
  updateCheck: PropTypes.func.isRequired,
  clearUpdateCheck: PropTypes.func.isRequired,
  obeeStaff: obeeStaffPropTypes.isRequired,
  obeeUpdateCheck: obeeUpdateCheckPropTypes.isRequired,
  obeeBookings: obeeBookingsPropTypes.isRequired
};
const mapStateToProps$6 = (state) => ({
  areas: state.areas,
  tables: state.tables,
  obeeSettings: state.obeeSettings,
  obeeStaff: state.obeeStaff,
  obeeSessions: state.obeeSessions,
  obeeUpdateCheck: state.obeeUpdateCheck,
  obeeBookings: state.obeeBookings
});
const mapDispatchToProps$6 = (dispatch) => bindActionCreators(
  {
    updateBooking: updateObeeBookingAction,
    updateCheck: updateCheckAction,
    clearUpdateCheck: clearUpdateCheckAction,
    setObeeShowAddBookingModal: setObeeShowAddBookingModalAction
  },
  dispatch
);
const Booking$1 = connect(mapStateToProps$6, mapDispatchToProps$6)(Booking);
const SvgHistory = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 23, height: 21, viewBox: "0 0 23 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 12.3072, cy: 10.6923, r: 5.96154, stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.375 1C17.6907 1 22 5.33939 22 10.6923C22 16.0452 17.6907 20.3846 12.375 20.3846C7.50441 20.3846 3.39015 16.7417 2.75001 12.014M2.75001 12.014L1 14.6573M2.75001 12.014L5.37502 13.7762", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("path", { d: "M12.0781 12.0767L12.0781 7.10255", stroke: "#313131" }), /* @__PURE__ */ React$7.createElement("line", { x1: 12.3086, y1: 11.5767, x2: 15.0778, y2: 11.5767, stroke: "#313131" }));
const HistorySVG = SvgHistory;
const History = ({ guestId, fetchObeeBookingsForUser, obeeBookingsForUser: obeeBookingsForUser2 }) => {
  var _a, _b2, _c2, _d2, _e2;
  const classes = useStyles$6();
  const [history, setHistory] = useState({ anchor: null, booking: null });
  useEffect(() => {
    if (guestId) {
      fetchObeeBookingsForUser(guestId);
    }
  }, [guestId]);
  const getDateString = (date, bookingTime) => {
    const dateFromNow = momentFromInt(bookingTime, date).fromNow();
    if (dateFromNow === "a day ago") {
      return "Yesterday,";
    }
    return `${capitaliseFirstLetter(dateFromNow)},`;
  };
  const bookings = useMemo(
    () => {
      var _a2;
      return immutableSort(
        ((_a2 = obeeBookingsForUser2.data) == null ? void 0 : _a2[guestId]) || [],
        (a, b) => sortByDate(a.date, b.date, "YYYY-MM-DD", true)
      );
    },
    [guestId, (_a = obeeBookingsForUser2.data) == null ? void 0 : _a[guestId]]
  );
  const numTotalVisits = ((_d2 = (_c2 = (_b2 = bookings == null ? void 0 : bookings[0]) == null ? void 0 : _b2.guests) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.numVisits) || 0;
  const totalLastMonth = useMemo(() => {
    var _a2;
    const today = moment$2().startOf("day");
    return ((_a2 = bookings.filter((booking) => {
      return getVisitedStatuses().includes(booking == null ? void 0 : booking.status) && today.diff(moment$2(booking.date), "month") === 0;
    })) == null ? void 0 : _a2.length) || 0;
  }, [bookings]);
  if (obeeBookingsForUser2.error) {
    return /* @__PURE__ */ React__default.createElement(Box, { className: classes.errorMessage }, "Something went wrong, please try again later");
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.historyContent }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.visitsContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.visitItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.historyHeader }, obeeBookingsForUser2.pending ? /* @__PURE__ */ React__default.createElement(Skeleton$2, { width: 72 }) : "Total visits"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.historySubHeader }, obeeBookingsForUser2.pending ? /* @__PURE__ */ React__default.createElement(Skeleton$2, { width: 24 }) : numTotalVisits)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.visitDivider }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.visitItem }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.historyHeader }, obeeBookingsForUser2.pending ? /* @__PURE__ */ React__default.createElement(Skeleton$2, { width: 72 }) : "Last month"), /* @__PURE__ */ React__default.createElement(Box, { className: classes.historySubHeader }, obeeBookingsForUser2.pending ? /* @__PURE__ */ React__default.createElement(Skeleton$2, { width: 24 }) : totalLastMonth))), /* @__PURE__ */ React__default.createElement(Divider, { style: { margin: "10px -10px 20px -10px" } }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemsContainer }, obeeBookingsForUser2.pending && /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemContainer }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Skeleton$2, { variant: "circular", height: 12, width: 12 })), /* @__PURE__ */ React__default.createElement(Box, { className: classes.historyDetailsContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemHeading }, /* @__PURE__ */ React__default.createElement(Skeleton$2, { width: 200 })), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "row", gap: 10, style: { justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemSubHeading }, /* @__PURE__ */ React__default.createElement(Skeleton$2, { width: 90 }))), /* @__PURE__ */ React__default.createElement(Skeleton$2, { width: 90 }))), obeeBookingsForUser2.success && bookings.map((booking, index) => {
    var _a2;
    const noShowFee = formatCurrency(getNoShowFee(booking), true, "$0", true);
    return /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemContainer, key: booking.id }, /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemTimeCircle }), /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.itemTimeLine,
        style: { borderRight: index === bookings.length - 1 && "none" }
      }
    )), /* @__PURE__ */ React__default.createElement(Box, { className: classes.historyDetailsContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemHeading }, `${getDateString(booking.date, booking.time)} ${moment$2(booking.date).format(
      "ddd, Do MMM YYYY"
    )}`), /* @__PURE__ */ React__default.createElement(Spacer, { direction: "row", gap: 10, style: { justifyContent: "space-between" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemSubHeading }, /* @__PURE__ */ React__default.createElement(GuestSVG, { width: "11" }), /* @__PURE__ */ React__default.createElement(Box, { style: { flexShrink: 0 } }, `${booking.size} ${pluralise(
      "guest",
      booking.size
    )}`)), /* @__PURE__ */ React__default.createElement(
      SquareButton,
      {
        onClick: (e) => setHistory({ anchor: e.currentTarget, booking }),
        forceHoverState: ((_a2 = history == null ? void 0 : history.booking) == null ? void 0 : _a2.id) === (booking == null ? void 0 : booking.id),
        style: { button: { padding: "4px 8px" } }
      },
      /* @__PURE__ */ React__default.createElement(Spacer, { gap: 8 }, /* @__PURE__ */ React__default.createElement(HistorySVG, null), "Activity")
    )), booking.ccNoShowChargeStatus === "succeeded" && noShowFee !== "$0" && /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: classes.itemNote
      },
      `No-show fee of ${noShowFee} charged to the card ending ${booking.paymentMethodName}.`
    ), booking.customerComments && /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemNote }, `"${booking.customerComments}"`), booking.restaurantComments && /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemNote }, `${booking.restaurantComments}`), /* @__PURE__ */ React__default.createElement(Box, { className: classes.itemNote }, "Status: ", getStatusLabel(booking))));
  })), /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      anchorEl: history.anchor,
      innerStyle: {
        borderRadius: "8px",
        marginTop: "8px",
        padding: "16px"
      },
      isOpen: !!history.anchor,
      onClose: () => setHistory({ anchor: null, booking: null }),
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      innerProps: { disableScrollLock: true },
      popoverProps: { innerProps: { disableScrollLock: true } }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.commentContainer }, (_e2 = history == null ? void 0 : history.booking) == null ? void 0 : _e2.history)
  ));
};
History.propTypes = {
  guestId: PropTypes.number.isRequired,
  fetchObeeBookingsForUser: PropTypes.func.isRequired,
  obeeBookingsForUser: PropTypes.shape({
    error: PropTypes.string,
    pending: PropTypes.bool,
    success: PropTypes.bool,
    data: PropTypes.shape({ obeeBookingPropTypes })
  }).isRequired
};
const mapStateToProps$5 = (state) => ({
  obeeBookingsForUser: state.obeeBookingsForUser
});
const mapDispatchToProps$5 = (dispatch) => bindActionCreators(
  {
    fetchObeeBookingsForUser: fetchObeeBookingsForUserAction
  },
  dispatch
);
const History$1 = connect(mapStateToProps$5, mapDispatchToProps$5)(History);
const stripe = loadStripe((_d = window.bookingsConfig) == null ? void 0 : _d.stripeApiKey);
const BookingDetailsModal = ({
  onClose,
  booking,
  defaultTab,
  areas,
  fetchAreas,
  newBookingStatus,
  fetchObeeStaffList,
  obeeStaff
}) => {
  var _a, _b2;
  const theme2 = useTheme$1();
  const bookingStatus = getStatus(booking);
  const classes = useStyles$6({ bookingStatus });
  const [activeTab, setActiveTab] = useState(0);
  const [status, setStatus] = useState(null);
  useEffect(() => {
    setStatus(newBookingStatus || (booking == null ? void 0 : booking.status));
  }, [newBookingStatus, booking == null ? void 0 : booking.status]);
  const setToDefaultTab = () => {
    switch (defaultTab) {
      case "booking":
        setActiveTab(0);
        return;
      case "customer":
        setActiveTab(1);
        return;
      case "history":
        setActiveTab(2);
        return;
      default:
        setActiveTab(0);
    }
  };
  const resetEverything = () => {
    setActiveTab(0);
  };
  useEffect(() => {
    if (!booking) {
      resetEverything();
    } else {
      if (!areas.success) {
        fetchAreas();
      }
      if (!isObee() && !obeeStaff.success) {
        fetchObeeStaffList();
      }
      setToDefaultTab();
    }
  }, [booking == null ? void 0 : booking.id]);
  useEffect(() => {
    setToDefaultTab();
  }, [defaultTab]);
  const guestId = (_b2 = (_a = booking == null ? void 0 : booking.guests) == null ? void 0 : _a[0]) == null ? void 0 : _b2.id;
  return /* @__PURE__ */ React__default.createElement(LiveBookingModal$1, { isOpen: !!booking, onClose, headerHeight: 0 }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingName }, getBookingName(booking)), /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", justifyContent: "space-between", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.outBy }, /* @__PURE__ */ React__default.createElement(IconExit, { style: { height: "15px" } }), /* @__PURE__ */ React__default.createElement(Box, null, "Out by ", minutesToTimeString((booking == null ? void 0 : booking.time) + (booking == null ? void 0 : booking.duration), "h:mma"))), !isEmpty(status) && !isEmpty(booking) && /* @__PURE__ */ React__default.createElement(
    StatusSelector$1,
    {
      status,
      booking,
      onChange: setStatus,
      style: { nextButtonDisplay: "none" }
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.detailsContainer }, /* @__PURE__ */ React__default.createElement(
    UnderlinedTabBar$1,
    {
      tabs: [
        { label: "Booking", value: 0 },
        { label: "Customer", value: 1 },
        ...!isEmpty(guestId) ? [{ label: "History", value: 2 }] : []
      ],
      value: activeTab,
      onSelect: setActiveTab,
      style: tabBarStyles(theme2)
    }
  )), activeTab === 0 && /* @__PURE__ */ React__default.createElement(Elements, { stripe }, /* @__PURE__ */ React__default.createElement(Booking$1, { booking, status })), activeTab === 1 && /* @__PURE__ */ React__default.createElement(CustomerDetails$1, { booking }), activeTab === 2 && /* @__PURE__ */ React__default.createElement(History$1, { guestId }));
};
BookingDetailsModal.defaultProps = {
  onClose: () => {
  },
  booking: null,
  defaultTab: null,
  newBookingStatus: null
};
BookingDetailsModal.propTypes = {
  onClose: PropTypes.func,
  booking: obeeBookingPropTypes,
  defaultTab: PropTypes.string,
  fetchAreas: PropTypes.func.isRequired,
  areas: areasPropTypes.isRequired,
  newBookingStatus: PropTypes.string,
  fetchObeeStaffList: PropTypes.func.isRequired,
  obeeStaff: obeeStaffPropTypes.isRequired
};
const mapStateToProps$4 = (state) => ({
  areas: state.areas,
  obeeStaff: state.obeeStaff
});
const mapDispatchToProps$4 = (dispatch) => bindActionCreators(
  {
    updateBooking: updateObeeBookingAction,
    fetchAreas: fetchAreasAction,
    fetchObeeStaffList: fetchObeeStaffListAction
  },
  dispatch
);
const BookingDetailsModal$1 = connect(mapStateToProps$4, mapDispatchToProps$4)(BookingDetailsModal);
const SvgClosed = (props) => /* @__PURE__ */ React$7.createElement("svg", { viewBox: "0 0 29 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("circle", { cx: 14.8799, cy: 14.343, r: 14, fill: "white" }), /* @__PURE__ */ React$7.createElement("rect", { x: 8.62988, y: 6.34302, width: 12.5, height: 16, fill: "#C4C4C4", stroke: "currentColor", strokeLinejoin: "round" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.8477 24.6555V4.06177L15.0351 5.21802C15.013 11.1972 14.9819 23.1868 15.0351 23.3118C15.0883 23.4368 12.2656 24.2597 10.8477 24.6555Z", fill: "#D9D9D9", stroke: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M11.8291 4.40552L21.2539 6.31177L21.1914 22.4055L11.8291 24.1555V4.40552Z", fill: "currentColor", stroke: "currentColor" }), /* @__PURE__ */ React$7.createElement("ellipse", { cx: 14.0044, cy: 14.593, rx: 0.655762, ry: 0.8125, fill: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M25.0908 4.72437L5.33623 24.5678", stroke: "white" }), /* @__PURE__ */ React$7.createElement("path", { d: "M24.8604 4.21216L5.02422 23.974", stroke: "currentColor" }));
const ClosedIconSVG = SvgClosed;
const useStyles$4 = createUseStyles({
  heading: {
    fontSize: "16px"
  },
  monthButtonContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "1px"
  }
});
const months = [
  { index: 0, label: "Jan" },
  { index: 1, label: "Feb" },
  { index: 2, label: "Mar" },
  { index: 3, label: "Apr" },
  { index: 4, label: "May" },
  { index: 5, label: "Jun" },
  { index: 6, label: "Jul" },
  { index: 7, label: "Aug" },
  { index: 8, label: "Sep" },
  { index: 9, label: "Oct" },
  { index: 10, label: "Nov" },
  { index: 11, label: "Dec" }
];
const MonthSelector = ({ calendarMonth, setCalendarMonth }) => {
  const theme2 = useTheme$1();
  const breakpointMdDown = useMediaQuery$1(theme2.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles$4();
  const [year, setYear] = useState(moment$2(calendarMonth, "MMMM YYYY").format("MMMM YYYY"));
  useEffect(() => {
    setYear(moment$2(calendarMonth, "MMMM YYYY").format("YYYY"));
  }, [calendarMonth]);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const calendarMonthAsMoment = moment$2(calendarMonth, "MMMM YYYY");
  const switchToNextMonth = () => {
    setCalendarMonth(calendarMonthAsMoment.add(1, "month").format("MMMM YYYY"));
  };
  const switchToPreviousMonth = () => {
    setCalendarMonth(calendarMonthAsMoment.subtract(1, "month").format("MMMM YYYY"));
  };
  const changeMonth = (newMonthIndex) => {
    const newMonth = moment$2(year, "YYYY").add(newMonthIndex, "months").format("MMMM YYYY");
    setCalendarMonth(newMonth);
    handleCloseMenu();
  };
  const getDate = () => {
    const isCurrentYear = moment$2().format("YYYY") === calendarMonthAsMoment.format("YYYY");
    if (!isCurrentYear) {
      return calendarMonth;
    }
    return formatDate(moment$2(calendarMonth, "MMMM YYYY"), "MMMM");
  };
  const yearList = useMemo(() => {
    const pastYearsToShow = 3;
    const futureYearsToShow = 3;
    return [...Array.from({ length: pastYearsToShow + futureYearsToShow + 1 })].map((_, i) => {
      const newYear = moment$2().startOf("year").add(i - pastYearsToShow, "years");
      const formattedYear = formatDate(newYear, "YYYY");
      return {
        label: formattedYear,
        value: formattedYear,
        onClick: () => {
          setYear(newYear);
        }
      };
    });
  }, [calendarMonth]);
  const currentMonth = moment$2().month();
  const isOpen = !!anchorEl;
  return /* @__PURE__ */ React__default.createElement(Box, { style: { position: "relative" } }, /* @__PURE__ */ React__default.createElement(
    SelectToggle$1,
    {
      value: getDate(),
      onClickValue: handleOpenMenu,
      onNext: switchToNextMonth,
      onPrevious: switchToPreviousMonth,
      isSelected: isOpen,
      canClickValue: true,
      style: {
        value: breakpointMdDown ? { width: "115px", maxWidth: "115px" } : {}
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen,
      onClose: () => handleCloseMenu(),
      anchorEl,
      style: { container: { minWidth: "150px", maxWidth: "300px" } },
      innerStyle: { marginTop: "40px", padding: "12px", borderRadius: "6px" },
      anchorOrigin: {
        vertical: "center",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "center"
      }
    },
    /* @__PURE__ */ React__default.createElement(Spacer, { direction: "vertical", gap: 8 }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.heading }, "Select month"), /* @__PURE__ */ React__default.createElement(
      CleanDropdownPopover$1,
      {
        items: yearList,
        value: year,
        onSelect: setYear,
        style: {
          container: {
            maxWidth: "100%",
            borderRadius: "8px"
          },
          value: {
            border: `1px solid ${theme2.colors.shark}`
          },
          items: { width: "100%" }
        }
      }
    ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.monthButtonContainer }, months.map((month) => /* @__PURE__ */ React__default.createElement(Box, { key: month.index }, /* @__PURE__ */ React__default.createElement(
      SquareButton,
      {
        onClick: () => {
          changeMonth(month == null ? void 0 : month.index);
        },
        style: {
          button: {
            width: "100%",
            height: "100%",
            borderRadius: "2px",
            padding: "8px 4px",
            fontWeight: currentMonth === (month == null ? void 0 : month.index) ? theme2.fontWeights.bold : theme2.fontWeights.regular
          }
        }
      },
      month == null ? void 0 : month.label
    )))))
  ));
};
MonthSelector.propTypes = {
  calendarMonth: PropTypes.string.isRequired,
  setCalendarMonth: PropTypes.func.isRequired
};
const mapStateToProps$3 = (state) => ({
  calendarMonth: state.obeeScreen.calendarMonth
});
const mapDispatchToProps$3 = (dispatch) => bindActionCreators(
  {
    setCalendarMonth: setCalendarMonthAction
  },
  dispatch
);
const MonthSelector$1 = connect(mapStateToProps$3, mapDispatchToProps$3)(MonthSelector);
const useStyles$3 = createUseStyles({
  sessionSelector: {
    display: "block"
    // Hide session selector to fit header on mobile phone
    // '@media only screen and (max-width: 700px)': {
    //   display: 'none',
    // },
  }
});
const sessionList = [{ label: "All sessions", value: "all_sessions" }, ...getSessionList()];
const SessionSelector = ({
  obeeSessions: obeeSessions2,
  fetchSessions,
  date,
  setSessionFilter,
  sessionFilter,
  ignoreDate
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const loading = useFetchOnFirstRender([fetchSessions], [obeeSessions2]);
  const classes = useStyles$3();
  const sessionsForDay = useMemo(() => {
    const allSessions = ignoreDate ? getMonthSessions(null, obeeSessions2.data) : getTodaySessions(date, obeeSessions2);
    const sessionsForList = sortListByProperty(allSessions, "startTime").map((session) => session == null ? void 0 : session.label).filter(filterUnique).map((sessionLabel) => ({
      label: getSessionLabel(sessionLabel),
      value: sessionLabel
      // regret calling it this
    }));
    return [{ label: "All sessions", value: "all_sessions" }, ...sessionsForList];
  }, [date, obeeSessions2.data, ignoreDate]);
  useEffect(() => {
    var _a;
    if (isEmpty(sessionsForDay)) {
      return;
    }
    setSessionFilter((_a = sessionsForDay == null ? void 0 : sessionsForDay[0]) == null ? void 0 : _a.value);
  }, [sessionsForDay]);
  const indexOfCurrent = sessionsForDay.findIndex((sessionToCheck) => (sessionToCheck == null ? void 0 : sessionToCheck.value) === sessionFilter) || 0;
  const handleNext = () => {
    var _a;
    setSessionFilter((_a = sessionsForDay[mod(indexOfCurrent + 1, sessionsForDay.length)]) == null ? void 0 : _a.value);
  };
  const handlePrevious = () => {
    var _a;
    setSessionFilter((_a = sessionsForDay[mod(indexOfCurrent - 1, sessionsForDay.length)]) == null ? void 0 : _a.value);
  };
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.sessionSelector }, /* @__PURE__ */ React__default.createElement(
    SelectToggle$1,
    {
      loading,
      canClickValue: sessionsForDay.length > 1,
      onClickValue: handleOpenMenu,
      value: loading ? "" : sessionsForDay.length === 0 ? "No sessions" : getLabelForValue(sessionFilter, sessionList),
      onNext: handleNext,
      onPrevious: handlePrevious,
      disabled: sessionsForDay.length <= 1
    }
  ), /* @__PURE__ */ React__default.createElement(
    ListPopover,
    {
      items: sessionsForDay,
      anchor: anchorEl,
      isOpen: !!anchorEl,
      onSelect: setSessionFilter,
      onClose: () => setAnchorEl(null),
      style: listPopoverStyles$2,
      popoverProps: { innerProps: { disableScrollLock: true } },
      ...popoverAnchors$3
    }
  ));
};
SessionSelector.defaultProps = {
  ignoreDate: false
};
SessionSelector.propTypes = {
  obeeSessions: sessionsPropTypes.isRequired,
  date: momentPropTypes.momentObj.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  setSessionFilter: PropTypes.func.isRequired,
  sessionFilter: PropTypes.string.isRequired,
  ignoreDate: PropTypes.bool
};
const mapStateToProps$2 = (state) => ({
  obeeSessions: state.obeeSessions,
  date: state.obeeScreen.date,
  sessionFilter: state.obeeScreen.sessionFilter
});
const mapDispatchToProps$2 = (dispatch) => bindActionCreators(
  {
    fetchSessions: fetchSessionsAction,
    setSessionFilter: setSessionFilterAction
  },
  dispatch
);
const SessionSelector$1 = connect(mapStateToProps$2, mapDispatchToProps$2)(SessionSelector);
const SvgNotifications = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 20, height: 25, viewBox: "0 0 20 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("path", { d: "M9.78969 3.50111C3.84059 3.50111 3.62426 9.87582 3.84059 13.0098C3.71237 16.1081 1.13648 17.1765 0.920147 17.7107C0.814555 17.9714 0.79754 18.5105 0.800322 19.0612C0.803112 19.6134 1.25968 20.0611 1.81196 20.0611H18.2C18.7523 20.0611 19.2044 19.6126 19.1571 19.0624C19.1124 18.5432 19.0272 18.0102 18.8756 17.7107C18.5511 17.0696 16.3878 16.0012 16.3878 13.0098C16.3878 10.0183 16.1714 3.50111 9.78969 3.50111Z", fill: "currentColor", stroke: "#1A1919" }), /* @__PURE__ */ React$7.createElement("path", { d: "M10.9201 1.66112H9.08008C9.08008 1.35445 9.25672 0.741119 9.96328 0.741119C10.6698 0.741119 10.8955 1.35445 10.9201 1.66112Z", stroke: "#1A1919" }), /* @__PURE__ */ React$7.createElement("path", { d: "M7.24001 21.9011L12.76 21.9011C12.76 22.5145 12.2301 23.7411 10.1104 23.7411C7.99073 23.7411 7.31361 22.5145 7.24001 21.9011Z", stroke: "#1A1919" }));
const BellSVG = SvgNotifications;
const SvgFilter = (props) => /* @__PURE__ */ React$7.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React$7.createElement("line", { x1: 5.5, y1: 7.5, x2: 14.5, y2: 7.5, stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 7.5, y1: 10.5, x2: 12.5, y2: 10.5, stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("line", { x1: 8.5, y1: 13.5, x2: 11.5, y2: 13.5, stroke: "#313131", strokeLinecap: "round" }), /* @__PURE__ */ React$7.createElement("circle", { cx: 10, cy: 10, r: 9.5, stroke: "currentColor" }));
const FilterSVG = SvgFilter;
const useStyles$2 = createUseStyles((theme2) => ({
  container: {},
  iconContainer: {
    position: "relative"
  },
  bellIcon: {
    color: theme2.colors.linen
  },
  notificationIcon: {
    position: "absolute",
    backgroundColor: theme2.colors.notification,
    border: `1px solid ${theme2.colors.white}`,
    borderRadius: "12px",
    width: "12px",
    height: "12px",
    top: "-2px",
    right: 0
  },
  notificationsHeader: {
    display: "flex",
    height: "55px",
    fontSize: "15px",
    fontWeight: theme2.fontWeights.medium,
    lineHeight: "20px",
    borderBottom: `1px solid ${theme2.colors.yetAnotherGray3}`,
    alignItems: "center",
    justifyContent: "center",
    position: "sticky",
    top: 0,
    background: theme2.colors.white,
    padding: "0 40px",
    gap: "20px"
  },
  notificationsHeaderColumns: {
    display: "flex"
  },
  itemsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: `1px solid ${theme2.colors.cloud}`,
    height: "56px",
    cursor: "pointer",
    fontSize: "15px",
    lineHeight: "28px",
    gap: "20px",
    transition: "0.1s",
    padding: "0 40px",
    "&:hover": {
      backgroundColor: theme2.colors.cloud,
      cursor: "pointer"
    }
  },
  tableBox: {
    display: "flex",
    padding: "8px",
    border: `1px solid ${theme2.colors.yetAnotherGray8}`,
    borderRadius: "4px",
    width: "52px",
    height: "28px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit"
  },
  rowUnread: {
    fontWeight: theme2.fontWeights.medium
  },
  rowBar: {
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    height: "48px",
    width: "1%"
  },
  rowBarRead: {
    borderLeft: `5px solid ${theme2.colors.yetAnotherGray3}`
  },
  rowBarUnread: {
    borderLeft: `5px solid ${theme2.colors.turmeric}`
  },
  filterIcon: {
    marginLeft: "12px",
    width: "fit-content",
    cursor: "pointer",
    color: theme2.colors.yetAnotherGray8,
    transition: "color 0.1s",
    "&:hover": {
      color: theme2.colors.charcoal
    }
  },
  bookingSize: {
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "20%"
  },
  guestColumn: {
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  bookingName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "79%"
  },
  headerColumn: {
    width: "100%",
    minWidth: "160px"
  },
  rowColumn: {
    width: "100%",
    minWidth: "160px"
  },
  notificationColumn: {
    width: "133px",
    minWidth: "133px"
  },
  dateColumn: {
    width: "80px",
    minWidth: "80px"
  },
  timeColumn: {
    width: "95px",
    minWidth: "95px"
  },
  sourceColumn: {
    width: "100px",
    minWidth: "100px"
  },
  commentColumn: {
    width: "140px",
    minWidth: "140px"
  },
  receivedColumn: {
    width: "16px",
    minWidth: "160px"
  }
}));
const useStyles$1 = createUseStyles((theme2) => ({
  filterOptions: {
    padding: "12px",
    border: `1px solid ${theme2.colors.cloud}`,
    borderRadius: "6px"
  },
  filterOption: {
    padding: "6px 12px",
    fontSize: "15px",
    lineHeight: "24px",
    boxSizing: "border-box",
    alignItems: "center",
    display: "flex",
    borderRadius: "6px",
    transition: "background-color 0.1s",
    gap: "8px",
    "&:hover": {
      backgroundColor: theme2.colors.cloud,
      cursor: "pointer"
    }
  }
}));
const NotificationFilterModal = ({
  anchorEl,
  onClose,
  handleFilterOptionToggle,
  selectedFilterOptions
}) => {
  const theme2 = useTheme$1();
  const classes = useStyles$1();
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      innerStyle: {
        borderRadius: "8px",
        marginTop: "10px",
        padding: "8px",
        userSelect: "none"
      },
      isOpen: !!anchorEl,
      onClose,
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.items }, filterOptions.map((option) => /* @__PURE__ */ React__default.createElement(
      Box,
      {
        key: option.value,
        className: classes.filterOption,
        onClick: () => handleFilterOptionToggle(option.value)
      },
      /* @__PURE__ */ React__default.createElement(
        Checkbox,
        {
          style: { display: "flex" },
          selected: selectedFilterOptions.includes(option.value),
          onChange: () => handleFilterOptionToggle(option.value),
          color: theme2.colors.charcoal
        }
      ),
      /* @__PURE__ */ React__default.createElement(Box, null, option.label)
    )))
  );
};
NotificationFilterModal.defaultProps = {
  anchorEl: null,
  onClose: () => {
  },
  selectedFilterOptions: []
};
NotificationFilterModal.propTypes = {
  anchorEl: PropTypes.shape({}),
  onClose: PropTypes.func,
  handleFilterOptionToggle: PropTypes.func.isRequired,
  selectedFilterOptions: PropTypes.arrayOf(PropTypes.string)
};
const NotificationsFilterModal = NotificationFilterModal;
const restoreNotificationsAction = (restId) => (dispatch) => {
  dispatch({
    type: RESTORE_NOTIFICATIONS,
    payload: { restId }
  });
};
const fetchNotificationCountAction = (lastChecked) => (dispatch) => {
  const action = "FETCH_NOTIFICATIONS_COUNT";
  const entityName = "obeeNotificationCount";
  const errorMessage = "Unable to retrieve notifications";
  const data = { lastChecked };
  const request = () => fetchNotificationCount(data);
  dispatch(makeApiAction(action, request, {}, entityName, null, null, false, errorMessage));
};
const fetchNotificationsAction = (restId, lastChecked) => (dispatch) => {
  const action = "FETCH_NOTIFICATIONS";
  const entityName = "obeeNotifications";
  const errorMessage = "Unable to retrieve notifications";
  const data = { lastChecked };
  const lastCheckedAt = getDateTimeNow();
  const request = () => fetchNotifications(data);
  dispatch(
    makeApiAction(
      action,
      request,
      { restId },
      // required to have access to the restId in the reducer success response
      entityName,
      null,
      { lastCheckedAt },
      false,
      errorMessage
    )
  );
};
const markAllNotificationsAsReadAction = (restId) => (dispatch) => {
  dispatch({
    type: MARK_ALL_NOTIFICATIONS_AS_READ,
    payload: { restId }
  });
};
const subscribeToNotificationEventsAction = () => (dispatch) => {
  const action = "SUBSCRIBE_TO_NOTIFICATION_EVENTS";
  const entityName = "subscribeToNotificationEvents";
  const data = {};
  const onEvent = (restId, lastCheckedAt) => dispatch(fetchNotificationsAction(restId, lastCheckedAt));
  const request = () => subscribeToNotificationEvents(data, onEvent);
  dispatch(makeApiAction(action, request, {}, entityName));
};
const useStyles = createUseStyles((theme2) => ({
  iconContainer: (props) => ({
    width: "fit-content",
    padding: "8px 12px",
    height: "28px",
    display: "flex",
    borderRadius: "8px",
    alignItems: "center",
    transition: "border 0.1s, box-shadow 0.1s",
    boxShadow: (props == null ? void 0 : props.active) && "0px 4px 8px rgba(151, 151, 151, 0.25)",
    "&:hover": {
      cursor: "pointer",
      boxShadow: "0px 4px 8px rgba(151, 151, 151, 0.25)"
    }
  }),
  commentContainer: {
    display: "flex",
    fontSize: "12px",
    lineHeight: "18px",
    padding: "8px 20px",
    maxWidth: "300px",
    flexDirection: "column",
    gap: "8px"
  },
  commentHeading: {
    fontWeight: theme2.fontWeights.medium
  }
}));
const NotificationsComment = ({ comment }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles({ active: !!anchorEl });
  const handlePopoverOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const onClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(null);
  };
  if (!comment) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.iconContainer, onClick: handlePopoverOpen }, /* @__PURE__ */ React__default.createElement(CommentSVG, { height: 16 })), /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl,
      innerStyle: {
        borderRadius: "8px",
        marginTop: "8px",
        padding: "0px"
      },
      isOpen: !!anchorEl,
      onClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { className: classes.commentContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.commentHeading }, "Special request"), /* @__PURE__ */ React__default.createElement(Box, null, comment))
  ));
};
NotificationsComment.defaultProps = {
  anchorEl: null,
  comment: null
};
NotificationsComment.propTypes = {
  anchorEl: PropTypes.shape({}),
  comment: PropTypes.string
};
const NotificationsComment$1 = NotificationsComment;
const notificationEventsPropTypes = PropTypes.shape({
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool
});
const Notifications = ({
  restId,
  setObeeDate,
  notifications,
  subscribeToNotificationEvents: subscribeToNotificationEvents2,
  fetchNotifications: fetchNotifications2,
  fetchNotificationCount: fetchNotificationCount2,
  notificationEvents,
  markAllNotificationsAsRead,
  restoreNotifications
}) => {
  const theme2 = useTheme$1();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const openNotifications = Boolean(anchorEl);
  const classes = useStyles$2();
  const history = useHistory();
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([]);
  const handleOpenNotifications = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseNotifications = () => {
    setAnchorEl(null);
    markAllNotificationsAsRead(restId);
  };
  const handleClickThrough = (notification) => {
    var _a, _b2;
    handleCloseNotifications();
    setObeeDate(moment$2(notification.date));
    if (notification.status === "waitlist") {
      history.push(`${(_a = window.bookingsConfig) == null ? void 0 : _a.routePrefix}/runsheet?type=waitlist`);
      return;
    }
    history.push(`${(_b2 = window.bookingsConfig) == null ? void 0 : _b2.routePrefix}/runsheet`);
  };
  const handleFilterModalClose = () => {
    setFilterAnchorEl(null);
  };
  const handleFilterOptionToggle = (value) => {
    if (selectedFilterOptions.includes(value)) {
      setSelectedFilterOptions(selectedFilterOptions.filter((option) => option !== value));
    } else {
      setSelectedFilterOptions([...selectedFilterOptions, value]);
    }
  };
  useEffect(() => {
    if (restId) {
      restoreNotifications(restId);
    }
  }, [restId, restoreNotifications]);
  useEffect(() => {
    if (restId && !notificationEvents.success) {
      subscribeToNotificationEvents2();
    }
  }, [restId, subscribeToNotificationEvents2, notificationEvents.success]);
  useEffect(() => {
    if (notifications.restored) {
      fetchNotificationCount2(notifications.lastCheckedAt);
    }
  }, [notifications.restored, fetchNotificationCount2]);
  useEffect(() => {
    if (restId && openNotifications) {
      fetchNotifications2(restId, notifications.lastCheckedAt);
    }
  }, [restId, openNotifications, fetchNotifications2]);
  const handleFilterClick = (e) => {
    setFilterAnchorEl(e.currentTarget);
  };
  const tableHeaderColumns = (columnProperties) => {
    const { columnName, onClick, columnClass, extraContent } = columnProperties;
    const columnClassName = `${classes.notificationsHeaderColumns} ${classes.rowColumn} ${(classes == null ? void 0 : classes[columnClass]) || ""}`;
    return /* @__PURE__ */ React__default.createElement(Box, { className: columnClassName, onClick }, columnName, extraContent);
  };
  const filteredNotifications = immutableSort(
    notifications.data,
    (a, b) => sortByDate(a.orderByDate, b.orderByDate, "YYYY-MM-DD HH:mm:ss", true)
  ).filter((notification) => {
    if (selectedFilterOptions.length > 0) {
      return selectedFilterOptions.includes(notification.whichNotification);
    }
    return true;
  });
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(
    HeaderButton$1,
    {
      onClick: handleOpenNotifications,
      type: "round",
      style: { button: { position: "relative" } }
    },
    /* @__PURE__ */ React__default.createElement(BellSVG, { className: classes.bellIcon }),
    notifications.unreadNotifications && /* @__PURE__ */ React__default.createElement(Box, { className: classes.notificationIcon })
  ), /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      isOpen: openNotifications,
      onClose: () => handleCloseNotifications(),
      anchorEl,
      style: {
        padding: "24px"
      },
      innerStyle: {
        padding: 0,
        marginTop: "16px",
        borderRadius: "6px",
        width: "100%",
        overflow: "auto",
        bottom: "16px"
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      }
    },
    /* @__PURE__ */ React__default.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.notificationsHeader }, tableHeaderColumns({ columnName: "Guest" }), tableHeaderColumns({
      columnName: "Notification",
      columnClass: "notificationColumn",
      extraContent: /* @__PURE__ */ React__default.createElement(
        FilterSVG,
        {
          className: classes.filterIcon,
          onClick: handleFilterClick,
          style: {
            color: (filterAnchorEl || selectedFilterOptions.length > 0) && theme2.colors.charcoal
          }
        }
      )
    }), tableHeaderColumns({ columnName: "Date", columnClass: "dateColumn" }), tableHeaderColumns({ columnName: "Time", columnClass: "timeColumn" }), tableHeaderColumns({ columnName: "Table", columnClass: "tableColumn" }), tableHeaderColumns({ columnName: "Source", columnClass: "sourceColumn" }), tableHeaderColumns({ columnName: "Comment", columnClass: "commentColumn" }), tableHeaderColumns({ columnName: "Received", columnClass: "receivedColumn" })), /* @__PURE__ */ React__default.createElement(Box, null, filteredNotifications.map((notification) => /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `${classes.itemsContainer} ${notification.unread ? classes.rowUnread : ""}`,
        key: `${notification == null ? void 0 : notification.id}_${notification == null ? void 0 : notification.time}_${notification == null ? void 0 : notification.time}`,
        onClick: () => handleClickThrough(notification)
      },
      /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.guestColumn}  ${classes.rowColumn}` }, /* @__PURE__ */ React__default.createElement(
        Box,
        {
          className: `${classes.rowBar} ${notification.unread ? classes.rowBarUnread : classes.rowBarRead}`
        }
      ), /* @__PURE__ */ React__default.createElement(Box, { className: classes.bookingName }, notification.bName), /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.bookingSize}` }, /* @__PURE__ */ React__default.createElement(GuestSVG, { height: 16 }), /* @__PURE__ */ React__default.createElement(Box, null, notification.bSize))),
      /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.notificationColumn}  ${classes.rowColumn}` }, getNotificationTypeLabel(notification.whichNotification)),
      /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.dateColumn}  ${classes.rowColumn}` }, notification.readableDate),
      /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.timeColumn}  ${classes.rowColumn}` }, notification.readableTime),
      /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.tableColumn}  ${classes.rowColumn}` }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.tableBox }, notification.tableNumber ?? "-")),
      /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.sourceColumn}  ${classes.rowColumn}` }, getNotificationSource(notification)),
      /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.commentColumn}  ${classes.rowColumn}` }, /* @__PURE__ */ React__default.createElement(NotificationsComment$1, { comment: notification.customerComments })),
      /* @__PURE__ */ React__default.createElement(Box, { className: `${classes.receivedColumn}  ${classes.rowColumn}` }, notification.readableReceived)
    )), notifications.success && filteredNotifications.length === 0 && /* @__PURE__ */ React__default.createElement(Box, { style: { padding: "24px 40px" } }, "No new notifications."), notifications.error && /* @__PURE__ */ React__default.createElement(Box, { style: { padding: "24px 40px" } }, notifications.error)))
  ), /* @__PURE__ */ React__default.createElement(
    NotificationsFilterModal,
    {
      anchorEl: filterAnchorEl,
      onClose: handleFilterModalClose,
      handleFilterOptionToggle,
      selectedFilterOptions
    }
  ));
};
Notifications.defaultProps = {};
Notifications.propTypes = {
  restId: PropTypes.string.isRequired,
  setObeeDate: PropTypes.func.isRequired,
  notifications: notificationsPropTypes.isRequired,
  subscribeToNotificationEvents: PropTypes.func.isRequired,
  fetchNotifications: PropTypes.func.isRequired,
  notificationEvents: notificationEventsPropTypes.isRequired,
  fetchNotificationCount: PropTypes.func.isRequired,
  markAllNotificationsAsRead: PropTypes.func.isRequired,
  restoreNotifications: PropTypes.func.isRequired
};
const mapStateToProps$1 = (state) => ({
  restId: state.restaurantActive.restaurant.objectId,
  notifications: state.notifications,
  notificationEvents: state.notificationEvents
});
const mapDispatchToProps$1 = (dispatch) => bindActionCreators(
  {
    setObeeDate: setObeeDateAction,
    subscribeToNotificationEvents: subscribeToNotificationEventsAction,
    fetchNotifications: fetchNotificationsAction,
    fetchNotificationCount: fetchNotificationCountAction,
    markAllNotificationsAsRead: markAllNotificationsAsReadAction,
    restoreNotifications: restoreNotificationsAction
  },
  dispatch
);
const Notifications$1 = connect(mapStateToProps$1, mapDispatchToProps$1)(Notifications);
const LiveBookingsHeader$1 = ({
  children,
  showNavigation,
  navigationOpen,
  obeeAddBookingModal,
  obeeBookingDetailsModal,
  setObeeShowAddBookingModal,
  setObeeBookingDetailsModal,
  obeeBookings: obeeBookings2,
  closedEarlyToday: closedEarlyToday2,
  reopenRestaurant,
  pageId,
  // e.g. 'runsheet'
  hideFilters,
  // Whether to show sessions and date selector
  fetchObeeSettings: fetchObeeSettings2,
  obeeSettings: obeeSettings2,
  fullyBookedSessions
}) => {
  var _a, _b2, _c2;
  const classes = useStyles$1W({ navigationOpen });
  const theme2 = useTheme$1();
  const ref = useRef(null);
  const [closedAnchorEl, setClosedAnchorEl] = useState(null);
  const isMobile = useHasMobile();
  const isSmallScreen = useMediaQuery(`(max-width:${mobileHeaderBreakpoint}px)`);
  const route = findObjectByProperty(pages, pageId, "id");
  useFetchOnFirstRender([fetchObeeSettings2], [obeeSettings2]);
  const bookingButtonStyle = {
    button: {
      backgroundColor: theme2.colors.charcoal,
      fontWeight: theme2.fontWeights.medium,
      height: "40px",
      padding: "8px 20px",
      fontSize: "15px",
      display: "flex",
      alignItems: "center",
      borderRadius: "100px",
      lineHeight: "normal",
      ...(_b2 = (_a = theme2 == null ? void 0 : theme2.components) == null ? void 0 : _a.Button) == null ? void 0 : _b2.button
    }
  };
  const closedButtonStyle = {
    button: {
      alignItems: "center",
      backgroundColor: theme2.colors.infoBlueLight,
      // border: closedAnchorEl ? `1px solid ${theme.colors.INFO_BLUE}` : '1px solid transparent',
      border: `1px solid ${theme2.colors.linenButtonOutline}`,
      borderRadius: "8px",
      // boxShadow: '0px 4px 4px rgba(200, 199, 199, 0.25)',
      color: theme2.colors.infoBlue,
      display: "flex",
      fontSize: "15px",
      fontWeight: theme2.fontWeights.medium,
      height: "40px",
      padding: isMobile ? "8px" : "8px 20px"
    },
    text: { display: "flex" }
  };
  const reopenButtonStyle = {
    button: {
      alignItems: "center",
      backgroundColor: theme2.colors.white,
      border: `1px solid ${theme2.colors.cloud}`,
      borderRadius: "8px",
      boxShadow: "0px 4px 4px rgba(200, 199, 199, 0.25)",
      color: theme2.colors.infoBlue,
      display: "flex",
      fontSize: "15px",
      fontWeight: theme2.fontWeights.medium,
      height: "36px",
      padding: "8px 20px"
    }
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.containerInner }, /* @__PURE__ */ React__default.createElement(AppBar, { ref, position: "static", className: classes.appBar, enableColorOnDark: true }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.header }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.leftRow }, /* @__PURE__ */ React__default.createElement(Navigation$1, { pageId, showNavigation }), closedEarlyToday2 && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      type: "standard",
      style: closedButtonStyle,
      onClick: (e) => setClosedAnchorEl(e.currentTarget)
    },
    isMobile ? /* @__PURE__ */ React__default.createElement(ClosedIconSVG, { style: { width: "29px", height: "29px" } }) : "Closed"
  ), /* @__PURE__ */ React__default.createElement(
    Popover$3,
    {
      anchorEl: closedAnchorEl,
      isOpen: !!closedAnchorEl,
      onClose: () => setClosedAnchorEl(null),
      innerStyle: { padding: 0, marginTop: "8px", borderRadius: "8px" }
    },
    /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "standard",
        style: reopenButtonStyle,
        onClick: () => reopenRestaurant(fullyBookedSessions.data)
      },
      "Re-open"
    )
  ))), !isSmallScreen && /* @__PURE__ */ React__default.createElement(Box, { className: classes.middle }, !hideFilters && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (route == null ? void 0 : route.showMonthSelector) && /* @__PURE__ */ React__default.createElement(MonthSelector$1, null), (route == null ? void 0 : route.showDateSelector) && /* @__PURE__ */ React__default.createElement(DateSelector$1, null), /* @__PURE__ */ React__default.createElement(
    SessionSelector$1,
    {
      key: "session-selector-1",
      ignoreDate: (route == null ? void 0 : route.ignoreSessionDate) ?? false
    }
  ))), /* @__PURE__ */ React__default.createElement(Box, { className: classes.headerRight }, route == null ? void 0 : route.headerButtons, !(route == null ? void 0 : route.showMonthSelector) && /* @__PURE__ */ React__default.createElement(DailyNotes$1, null), /* @__PURE__ */ React__default.createElement(Notifications$1, null), /* @__PURE__ */ React__default.createElement(
    Button,
    {
      style: bookingButtonStyle,
      onClick: () => {
        setObeeBookingDetailsModal(null);
        setObeeShowAddBookingModal(!(obeeAddBookingModal == null ? void 0 : obeeAddBookingModal.show));
      }
    },
    /* @__PURE__ */ React__default.createElement(Box, { style: { display: "flex", gap: "6px", alignItems: "center" } }, /* @__PURE__ */ React__default.createElement(PlusIconSVG, { style: { height: "13px" } }), "Booking")
  ))), isSmallScreen && !hideFilters && /* @__PURE__ */ React__default.createElement(Box, { className: classes.mobileRow }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, (route == null ? void 0 : route.showMonthSelector) && /* @__PURE__ */ React__default.createElement(MonthSelector$1, null), (route == null ? void 0 : route.showDateSelector) && /* @__PURE__ */ React__default.createElement(DateSelector$1, null), /* @__PURE__ */ React__default.createElement(SessionSelector$1, { key: "session-selector-2" }))), /* @__PURE__ */ React__default.createElement(Loading$1, null)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.liveBookingsContent }, children))), /* @__PURE__ */ React__default.createElement(DeferRender$1, { isShowing: obeeAddBookingModal.show }, /* @__PURE__ */ React__default.createElement(
    AddBookingModal$1,
    {
      isOpen: obeeAddBookingModal.show,
      quickBooking: obeeAddBookingModal.quickBooking,
      preventChanges: obeeAddBookingModal.preventChanges,
      defaultDate: obeeAddBookingModal.defaultDate,
      onClose: () => setObeeShowAddBookingModal(false)
    }
  )), /* @__PURE__ */ React__default.createElement(DeferRender$1, { isShowing: !isEmpty(obeeBookingDetailsModal == null ? void 0 : obeeBookingDetailsModal.bookingId) }, /* @__PURE__ */ React__default.createElement(
    BookingDetailsModal$1,
    {
      booking: (_c2 = obeeBookings2.data) == null ? void 0 : _c2.find(
        (booking) => booking.id === (obeeBookingDetailsModal == null ? void 0 : obeeBookingDetailsModal.bookingId)
      ),
      defaultTab: obeeBookingDetailsModal.defaultTab,
      newBookingStatus: obeeBookingDetailsModal.newBookingStatus,
      onClose: () => setObeeBookingDetailsModal(null)
    }
  )));
};
LiveBookingsHeader$1.defaultProps = {
  navigationOpen: false,
  closedEarlyToday: false,
  pageId: "runsheet",
  hideFilters: false
};
LiveBookingsHeader$1.propTypes = {
  showNavigation: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  navigationOpen: PropTypes.bool,
  obeeAddBookingModal: PropTypes.shape({
    show: PropTypes.bool.isRequired,
    preventChanges: PropTypes.bool.isRequired,
    defaultDate: momentPropTypes.momentObj,
    quickBooking: PropTypes.shape({
      areaId: PropTypes.number,
      table: tablePropTypes,
      time: PropTypes.number
    })
  }).isRequired,
  obeeBookingDetailsModal: PropTypes.shape({
    bookingId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    defaultTab: PropTypes.string,
    newBookingStatus: PropTypes.string
  }).isRequired,
  setObeeShowAddBookingModal: PropTypes.func.isRequired,
  setObeeBookingDetailsModal: PropTypes.func.isRequired,
  obeeBookings: obeeBookingsPropTypes.isRequired,
  reopenRestaurant: PropTypes.func.isRequired,
  closedEarlyToday: PropTypes.bool,
  pageId: PropTypes.string,
  hideFilters: PropTypes.bool,
  fetchObeeSettings: PropTypes.func.isRequired,
  obeeSettings: obeeSettingsPropTypes.isRequired,
  fullyBookedSessions: fullyBookedSessionsPropTypes.isRequired
};
const mapStateToProps = (state) => ({
  breadcrumbs: state.breadcrumbs,
  obeeAddBookingModal: state.obeeScreen.addBookingModal,
  obeeBookingDetailsModal: state.obeeScreen.bookingDetailsModal,
  obeeBookings: state.obeeBookings,
  closedEarlyToday: state.restaurantActive.restaurant.closedEarlyToday,
  fullyBookedSessions: state.fullyBookedSessions,
  obeeSettings: state.obeeSettings
});
const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    setObeeShowAddBookingModal: setObeeShowAddBookingModalAction,
    setObeeBookingDetailsModal: setObeeBookingDetailsModalAction,
    reopenRestaurant: reopenRestaurantAction,
    fetchObeeSettings: fetchSettingsAction
  },
  dispatch
);
const HeaderComponent = connect(mapStateToProps, mapDispatchToProps)(LiveBookingsHeader$1);
devLog(
  "info",
  "running bookings library for:",
  window == null ? void 0 : window.bookingsConfig,
  (_e = window == null ? void 0 : window.bookingsConfig) == null ? void 0 : _e.bookingsBranding
);
const withProviders = (children) => /* @__PURE__ */ React__default.createElement(ThemeProvider, { theme: theme$1 }, /* @__PURE__ */ React__default.createElement(Provider, { store: store$1 }, children));
const CleanTextField = (props) => withProviders(/* @__PURE__ */ React__default.createElement(CleanTextFieldComponent, { ...props }));
const CleanDropdown = (props) => withProviders(/* @__PURE__ */ React__default.createElement(CleanDropdownComponent, { ...props }));
const LiveBookingsHeader = (props) => withProviders(/* @__PURE__ */ React__default.createElement(HeaderComponent, { ...props }));
const RunSheet = (props) => withProviders(/* @__PURE__ */ React__default.createElement(RunSheetScreen, { ...props }));
const Settings = (props) => withProviders(/* @__PURE__ */ React__default.createElement(SettingsScreen, { ...props }));
const Floorplan = (props) => withProviders(/* @__PURE__ */ React__default.createElement(FloorplanScreen, { ...props }));
const EditFloorplan = (props) => withProviders(/* @__PURE__ */ React__default.createElement(EditFloorplanScreen, { ...props }));
const Timeline = (props) => withProviders(/* @__PURE__ */ React__default.createElement(TimelineScreen, { ...props }));
const Calendar = (props) => withProviders(/* @__PURE__ */ React__default.createElement(CalendarScreen, { ...props }));
const Integrations = (props) => withProviders(/* @__PURE__ */ React__default.createElement(IntegrationsScreen, { ...props }));
const MarketPlaceIntegrations = (props) => withProviders(/* @__PURE__ */ React__default.createElement(MarketPlaceIntegrationsScreen, { ...props }));
const Guestbook = (props) => withProviders(/* @__PURE__ */ React__default.createElement(GuestbookScreen, { ...props }));
const VoucherRedemptions = (props) => withProviders(/* @__PURE__ */ React__default.createElement(VoucherRedemptionScreen, { ...props }));
const getVersion = () => packageInfo.version;
export {
  Calendar,
  CleanDropdown,
  CleanTextField,
  EditFloorplan,
  Floorplan,
  Guestbook,
  Integrations,
  LiveBookingsHeader,
  MarketPlaceIntegrations,
  RunSheet,
  Settings,
  Timeline,
  VoucherRedemptions,
  getVersion
};
//# sourceMappingURL=ec-bookings-library.js.map
